webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactApollo = __webpack_require__(467);
	
	var _reactRouter = __webpack_require__(497);
	
	var _Config = __webpack_require__(551);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _Startup = __webpack_require__(552);
	
	var _zopimListener = __webpack_require__(1080);
	
	var zopim = _interopRequireWildcard(_zopimListener);
	
	var _AppActions = __webpack_require__(1083);
	
	var _AppActions2 = _interopRequireDefault(_AppActions);
	
	var _userBootData = __webpack_require__(975);
	
	var _routes = __webpack_require__(1086);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _reduxStore = __webpack_require__(3276);
	
	var _reduxStore2 = _interopRequireDefault(_reduxStore);
	
	var _xhrInterceptors = __webpack_require__(575);
	
	var _ResponseInterceptors = __webpack_require__(2527);
	
	__webpack_require__(3302);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (false) {
	  require('utils/setupPerfUtils');
	}
	// first because it patches runtime env
	
	
	if (window.trackJs) {
	  // https://trackjs.com/blog/unhandled-promises/
	  window.addEventListener('unhandledrejection', function (event) {
	    var info = 'reason' in event ? event.reason : event;
	    window.trackJs.track(info);
	  });
	}
	
	zopim.listenForStatusChange(_reduxStore2.default.dispatch);
	
	__webpack_require__.p = _Config2.default.Environment.PUBLIC_PATH; // eslint-disable-line
	
	(0, _xhrInterceptors.registerInterceptor)('503-interceptor', _ResponseInterceptors.serviceUnavailableInterceptor);
	
	(0, _userBootData.promiseDataIfSignedIn)().then(function () {
	  _AppActions2.default.observeConnection();
	
	  var container = document.getElementById('app');
	
	  _reactDom2.default.render(_react2.default.createElement(
	    _reactApollo.ApolloProvider,
	    { store: _reduxStore2.default, client: _reduxStore.apolloClient },
	    _react2.default.createElement(_reactRouter.Router, {
	      routes: _routes2.default,
	      history: _reactRouter.browserHistory,
	      render: _Startup.routeRenderer
	    })
	  ), container);
	}).catch(function (error) {
	  console.error('Application failed to load:', error.stack ? error.stack : error);
	  // TODO: Pretty failure
	  throw error;
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ApolloProvider_1 = __webpack_require__(468);
	exports.ApolloProvider = ApolloProvider_1.default;
	var graphql_1 = __webpack_require__(470);
	exports.graphql = graphql_1.default;
	exports.withApollo = graphql_1.withApollo;
	var redux_1 = __webpack_require__(476);
	exports.compose = redux_1.compose;
	//# sourceMappingURL=browser.js.map

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(299);
	var react_1 = __webpack_require__(299);
	var invariant = __webpack_require__(469);
	var ApolloProvider = (function (_super) {
	    __extends(ApolloProvider, _super);
	    function ApolloProvider(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        invariant(props.client, 'ApolloClient was not passed a client instance. Make ' +
	            'sure you pass in your client via the "client" prop.');
	        _this.client = props.client;
	        if (props.store) {
	            _this.store = props.store;
	            if (props.immutable)
	                props.client.initStore();
	            return _this;
	        }
	        props.client.initStore();
	        _this.store = props.client.store;
	        return _this;
	    }
	    ApolloProvider.prototype.getChildContext = function () {
	        return {
	            store: this.store,
	            client: this.client,
	        };
	    };
	    ApolloProvider.prototype.render = function () {
	        return React.Children.only(this.props.children);
	    };
	    return ApolloProvider;
	}(react_1.Component));
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = ApolloProvider;
	ApolloProvider.propTypes = {
	    store: react_1.PropTypes.shape({
	        subscribe: react_1.PropTypes.func.isRequired,
	        dispatch: react_1.PropTypes.func.isRequired,
	        getState: react_1.PropTypes.func.isRequired,
	    }),
	    client: react_1.PropTypes.object.isRequired,
	    immutable: react_1.PropTypes.bool,
	    children: react_1.PropTypes.element.isRequired,
	};
	ApolloProvider.childContextTypes = {
	    store: react_1.PropTypes.object.isRequired,
	    client: react_1.PropTypes.object.isRequired,
	};
	;
	//# sourceMappingURL=ApolloProvider.js.map

/***/ },
/* 469 */,
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var react_1 = __webpack_require__(299);
	var pick = __webpack_require__(471);
	var flatten = __webpack_require__(472);
	var shallowEqual_1 = __webpack_require__(473);
	var invariant = __webpack_require__(469);
	var assign = __webpack_require__(301);
	var hoistNonReactStatics = __webpack_require__(474);
	var parser_1 = __webpack_require__(475);
	var defaultMapPropsToOptions = function (props) { return ({}); };
	var defaultMapResultToProps = function (props) { return props; };
	var defaultMapPropsToSkip = function (props) { return false; };
	function observableQueryFields(observable) {
	    var fields = pick(observable, 'variables', 'refetch', 'fetchMore', 'updateQuery', 'startPolling', 'stopPolling', 'subscribeToMore');
	    Object.keys(fields).forEach(function (key) {
	        if (typeof fields[key] === 'function') {
	            fields[key] = fields[key].bind(observable);
	        }
	    });
	    return fields;
	}
	function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	var nextVersion = 0;
	function withApollo(WrappedComponent) {
	    var withDisplayName = "withApollo(" + getDisplayName(WrappedComponent) + ")";
	    var WithApollo = (function (_super) {
	        __extends(WithApollo, _super);
	        function WithApollo(props, context) {
	            var _this = _super.call(this, props, context) || this;
	            _this.client = context.client;
	            invariant(!!_this.client, "Could not find \"client\" in the context of " +
	                ("\"" + withDisplayName + "\". ") +
	                "Wrap the root component in an <ApolloProvider>");
	            return _this;
	        }
	        WithApollo.prototype.render = function () {
	            var props = assign({}, this.props);
	            props.client = this.client;
	            return react_1.createElement(WrappedComponent, props);
	        };
	        return WithApollo;
	    }(react_1.Component));
	    WithApollo.displayName = withDisplayName;
	    WithApollo.WrappedComponent = WrappedComponent;
	    WithApollo.contextTypes = { client: react_1.PropTypes.object.isRequired };
	    return hoistNonReactStatics(WithApollo, WrappedComponent, {});
	}
	exports.withApollo = withApollo;
	;
	function graphql(document, operationOptions) {
	    if (operationOptions === void 0) { operationOptions = {}; }
	    var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b;
	    var mapPropsToOptions = options;
	    if (typeof mapPropsToOptions !== 'function')
	        mapPropsToOptions = function () { return options; };
	    var mapPropsToSkip = skip;
	    if (typeof mapPropsToSkip !== 'function')
	        mapPropsToSkip = (function () { return skip; });
	    var mapResultToProps = operationOptions.props;
	    var operation = parser_1.parser(document);
	    var version = nextVersion++;
	    return function wrapWithApolloComponent(WrappedComponent) {
	        var graphQLDisplayName = "Apollo(" + getDisplayName(WrappedComponent) + ")";
	        var GraphQL = (function (_super) {
	            __extends(GraphQL, _super);
	            function GraphQL(props, context) {
	                var _this = _super.call(this, props, context) || this;
	                _this.previousData = {};
	                _this.version = version;
	                _this.client = context.client;
	                invariant(!!_this.client, "Could not find \"client\" in the context of " +
	                    ("\"" + graphQLDisplayName + "\". ") +
	                    "Wrap the root component in an <ApolloProvider>");
	                _this.store = _this.client.store;
	                _this.type = operation.type;
	                if (_this.shouldSkip(props))
	                    return _this;
	                _this.setInitialProps();
	                return _this;
	            }
	            GraphQL.prototype.componentDidMount = function () {
	                this.hasMounted = true;
	                if (this.type === parser_1.DocumentType.Mutation)
	                    return;
	                if (!this.shouldSkip(this.props)) {
	                    this.subscribeToQuery();
	                }
	            };
	            GraphQL.prototype.componentWillReceiveProps = function (nextProps) {
	                if (shallowEqual_1.default(this.props, nextProps))
	                    return;
	                this.shouldRerender = true;
	                if (this.type === parser_1.DocumentType.Mutation) {
	                    return;
	                }
	                ;
	                if (this.shouldSkip(nextProps)) {
	                    if (!this.shouldSkip(this.props)) {
	                        this.unsubscribeFromQuery();
	                    }
	                    return;
	                }
	                this.updateQuery(nextProps);
	                this.subscribeToQuery();
	            };
	            GraphQL.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
	                return !!nextContext || this.shouldRerender;
	            };
	            GraphQL.prototype.componentWillUnmount = function () {
	                if (this.type === parser_1.DocumentType.Query)
	                    this.unsubscribeFromQuery();
	                if (this.type === parser_1.DocumentType.Subscription)
	                    this.unsubscribeFromQuery();
	                this.hasMounted = false;
	            };
	            GraphQL.prototype.calculateOptions = function (props, newOpts) {
	                if (props === void 0) { props = this.props; }
	                var opts = mapPropsToOptions(props);
	                if (newOpts && newOpts.variables) {
	                    newOpts.variables = assign({}, opts.variables, newOpts.variables);
	                }
	                if (newOpts)
	                    opts = assign({}, opts, newOpts);
	                if (opts.fragments) {
	                    opts.fragments = flatten(opts.fragments);
	                }
	                if (opts.variables || !operation.variables.length)
	                    return opts;
	                var variables = {};
	                for (var _i = 0, _a = operation.variables; _i < _a.length; _i++) {
	                    var _b = _a[_i], variable = _b.variable, type = _b.type;
	                    if (!variable.name || !variable.name.value)
	                        continue;
	                    if (typeof props[variable.name.value] !== 'undefined') {
	                        variables[variable.name.value] = props[variable.name.value];
	                        continue;
	                    }
	                    if (type.kind !== 'NonNullType') {
	                        variables[variable.name.value] = null;
	                        continue;
	                    }
	                    invariant(typeof props[variable.name.value] !== 'undefined', "The operation '" + operation.name + "' wrapping '" + getDisplayName(WrappedComponent) + "' " +
	                        ("is expecting a variable: '" + variable.name.value + "' but it was not found in the props ") +
	                        ("passed to '" + graphQLDisplayName + "'"));
	                }
	                opts.variables = variables;
	                return opts;
	            };
	            ;
	            GraphQL.prototype.calculateResultProps = function (result) {
	                var name = this.type === parser_1.DocumentType.Mutation ? 'mutate' : 'data';
	                if (operationOptions.name)
	                    name = operationOptions.name;
	                var newResult = (_a = {}, _a[name] = result, _a.ownProps = this.props, _a);
	                if (mapResultToProps)
	                    return mapResultToProps(newResult);
	                return _b = {}, _b[name] = defaultMapResultToProps(result), _b;
	                var _a, _b;
	            };
	            GraphQL.prototype.setInitialProps = function () {
	                if (this.type === parser_1.DocumentType.Mutation) {
	                    return;
	                }
	                var opts = this.calculateOptions(this.props);
	                this.createQuery(opts);
	            };
	            GraphQL.prototype.createQuery = function (opts) {
	                if (this.type === parser_1.DocumentType.Subscription) {
	                    this.queryObservable = this.client.subscribe(assign({
	                        query: document,
	                    }, opts));
	                }
	                else {
	                    this.queryObservable = this.client.watchQuery(assign({
	                        query: document,
	                        metadata: {
	                            reactComponent: {
	                                displayName: graphQLDisplayName,
	                            },
	                        },
	                    }, opts));
	                }
	            };
	            GraphQL.prototype.updateQuery = function (props) {
	                var opts = this.calculateOptions(props);
	                if (!this.queryObservable) {
	                    this.createQuery(opts);
	                }
	                if (this.queryObservable._setOptionsNoResult) {
	                    this.queryObservable._setOptionsNoResult(opts);
	                }
	                else {
	                    this.queryObservable.setOptions(opts);
	                }
	            };
	            GraphQL.prototype.fetchData = function () {
	                if (this.shouldSkip())
	                    return false;
	                if (operation.type === parser_1.DocumentType.Mutation || operation.type === parser_1.DocumentType.Subscription)
	                    return false;
	                var opts = this.calculateOptions();
	                if (opts.ssr === false)
	                    return false;
	                if (opts.forceFetch)
	                    delete opts.forceFetch;
	                var observable = this.client.watchQuery(assign({ query: document }, opts));
	                var result = observable.currentResult();
	                if (result.loading) {
	                    return observable.result();
	                }
	                else {
	                    return false;
	                }
	            };
	            GraphQL.prototype.subscribeToQuery = function () {
	                var _this = this;
	                if (this.querySubscription) {
	                    return;
	                }
	                var next = function (results) {
	                    if (_this.type === parser_1.DocumentType.Subscription) {
	                        _this.lastSubscriptionData = results;
	                        results = { data: results };
	                    }
	                    var clashingKeys = Object.keys(observableQueryFields(results.data));
	                    invariant(clashingKeys.length === 0, "the result of the '" + graphQLDisplayName + "' operation contains keys that " +
	                        "conflict with the return object." +
	                        clashingKeys.map(function (k) { return "'" + k + "'"; }).join(', ') + " not allowed.");
	                    _this.forceRenderChildren();
	                };
	                var handleError = function (error) {
	                    if (error.hasOwnProperty('graphQLErrors'))
	                        return next({ error: error });
	                    throw error;
	                };
	                this.querySubscription = this.queryObservable.subscribe({ next: next, error: handleError });
	            };
	            GraphQL.prototype.unsubscribeFromQuery = function () {
	                if (this.querySubscription) {
	                    this.querySubscription.unsubscribe();
	                    delete this.querySubscription;
	                }
	            };
	            GraphQL.prototype.shouldSkip = function (props) {
	                if (props === void 0) { props = this.props; }
	                return mapPropsToSkip(props) ||
	                    mapPropsToOptions(props).skip;
	            };
	            GraphQL.prototype.forceRenderChildren = function () {
	                this.shouldRerender = true;
	                if (this.hasMounted)
	                    this.setState({});
	            };
	            GraphQL.prototype.getWrappedInstance = function () {
	                invariant(operationOptions.withRef, "To access the wrapped instance, you need to specify " +
	                    "{ withRef: true } in the options");
	                return this.refs.wrappedInstance;
	            };
	            GraphQL.prototype.dataForChild = function () {
	                var _this = this;
	                if (this.type === parser_1.DocumentType.Mutation) {
	                    return function (mutationOpts) {
	                        var opts = _this.calculateOptions(_this.props, mutationOpts);
	                        if (typeof opts.variables === 'undefined')
	                            delete opts.variables;
	                        opts.mutation = document;
	                        return _this.client.mutate(opts);
	                    };
	                }
	                var opts = this.calculateOptions(this.props);
	                var data = {};
	                assign(data, observableQueryFields(this.queryObservable));
	                if (this.type === parser_1.DocumentType.Subscription) {
	                    assign(data, {
	                        loading: !this.lastSubscriptionData,
	                        variables: opts.variables,
	                    }, this.lastSubscriptionData);
	                }
	                else {
	                    var currentResult = this.queryObservable.currentResult();
	                    var loading = currentResult.loading, error = currentResult.error, networkStatus = currentResult.networkStatus;
	                    assign(data, { loading: loading, error: error, networkStatus: networkStatus });
	                    if (loading) {
	                        assign(data, this.previousData, currentResult.data);
	                    }
	                    else {
	                        assign(data, currentResult.data);
	                        this.previousData = currentResult.data;
	                    }
	                }
	                return data;
	            };
	            GraphQL.prototype.render = function () {
	                if (this.shouldSkip()) {
	                    return react_1.createElement(WrappedComponent, this.props);
	                }
	                var _a = this, shouldRerender = _a.shouldRerender, renderedElement = _a.renderedElement, props = _a.props;
	                this.shouldRerender = false;
	                var data = this.dataForChild();
	                var clientProps = this.calculateResultProps(data);
	                var mergedPropsAndData = assign({}, props, clientProps);
	                if (!shouldRerender && renderedElement) {
	                    return renderedElement;
	                }
	                if (operationOptions.withRef)
	                    mergedPropsAndData.ref = 'wrappedInstance';
	                this.renderedElement = react_1.createElement(WrappedComponent, mergedPropsAndData);
	                return this.renderedElement;
	            };
	            return GraphQL;
	        }(react_1.Component));
	        GraphQL.displayName = graphQLDisplayName;
	        GraphQL.WrappedComponent = WrappedComponent;
	        GraphQL.contextTypes = {
	            store: react_1.PropTypes.object.isRequired,
	            client: react_1.PropTypes.object.isRequired,
	        };
	        return hoistNonReactStatics(GraphQL, WrappedComponent, {});
	    };
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = graphql;
	;
	//# sourceMappingURL=graphql.js.map

/***/ },
/* 471 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = baseRest(function(object, props) {
	  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	});
	
	module.exports = pick;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 472 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = flatten;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 473 */
/***/ function(module, exports) {

	"use strict";
	function shallowEqual(objA, objB) {
	    if (!objA || !objB)
	        return true;
	    if (objA === objB)
	        return true;
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	    if (keysA.length !== keysB.length)
	        return false;
	    var hasOwn = Object.prototype.hasOwnProperty;
	    for (var i = 0; i < keysA.length; i++) {
	        if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	            return false;
	        }
	    }
	    return true;
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = shallowEqual;
	//# sourceMappingURL=shallowEqual.js.map

/***/ },
/* 474 */,
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var invariant = __webpack_require__(469);
	(function (DocumentType) {
	    DocumentType[DocumentType["Query"] = 0] = "Query";
	    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
	    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
	})(exports.DocumentType || (exports.DocumentType = {}));
	var DocumentType = exports.DocumentType;
	function parser(document) {
	    var variables, type, name;
	    invariant((!!document || !!document.kind), "Argument of " + document + " passed to parser was not a valid GraphQL Document. You may need to use 'graphql-tag' or another method to convert your operation into a document");
	    var fragments = document.definitions.filter(function (x) { return x.kind === 'FragmentDefinition'; });
	    var queries = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'query'; });
	    var mutations = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'mutation'; });
	    var subscriptions = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'subscription'; });
	    if (fragments.length && (!queries.length || !mutations.length || !subscriptions.length)) {
	        invariant(true, "Passing only a fragment to 'graphql' is not yet supported. You must include a query, subscription or mutation as well");
	    }
	    if (queries.length && mutations.length && mutations.length) {
	        invariant(((queries.length + mutations.length + mutations.length) > 1), "react-apollo only supports a query, subscription, or a mutation per HOC. " + document + " had " + queries.length + " queries, " + subscriptions.length + " subscriptions and " + mutations.length + " muations. You can use 'compose' to join multiple operation types to a component");
	    }
	    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
	    if (!queries.length && !mutations.length)
	        type = DocumentType.Subscription;
	    var definitions = queries.length ? queries :
	        (mutations.length ? mutations : subscriptions);
	    if (definitions.length !== 1) {
	        invariant((definitions.length !== 1), "react-apollo only supports one defintion per HOC. " + document + " had " + definitions.length + " definitions. You can use 'compose' to join multiple operation types to a component");
	    }
	    var definition = definitions[0];
	    variables = definition.variableDefinitions || [];
	    var hasName = definition.name && definition.name.kind === 'Name';
	    name = hasName ? definition.name.value : 'data';
	    return { name: name, type: type, variables: variables };
	}
	exports.parser = parser;
	//# sourceMappingURL=parser.js.map

/***/ },
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listenForStatusChange = listenForStatusChange;
	
	var _Zopim = __webpack_require__(1081);
	
	var _Zopim2 = _interopRequireDefault(_Zopim);
	
	var _zopim = __webpack_require__(1082);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function listenForStatusChange(dispatch) {
	  _Zopim2.default.addStatusListener(function (status) {
	    if (status === 'online') {
	      dispatch((0, _zopim.changeStatus)('online'));
	    } else {
	      dispatch((0, _zopim.changeStatus)('offline'));
	    }
	  });
	}

/***/ },
/* 1081 */,
/* 1082 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.changeStatus = changeStatus;
	var initialState = exports.initialState = {
	  status: 'offline'
	};
	
	// typecheck: ignore statement
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'zopim/CHANGE_STATUS':
	      return _extends({}, state, { status: action.status });
	    default:
	      return state;
	  }
	}
	
	function changeStatus(status) {
	  return {
	    type: 'zopim/CHANGE_STATUS',
	    status: status
	  };
	}

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dispatcher = __webpack_require__(590);
	
	var _Offline = __webpack_require__(1084);
	
	var _Offline2 = _interopRequireDefault(_Offline);
	
	var _AppConstants = __webpack_require__(989);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _observingConnection = false;
	
	
	var AppActions = {
	  observeConnection: function observeConnection() {
	    if (_observingConnection) {
	      return;
	    }
	
	    var previous = 'connected';
	    var onStateChange = function onStateChange(current) {
	      if (false) {
	        console.log('Connection state changed:', current);
	      }
	      _Dispatcher.dispatcher.dispatch({
	        type: _AppConstants.ActionTypes.CONNECTION_STATE_CHANGED,
	        previous: previous,
	        current: current
	      });
	      previous = current;
	    };
	
	    if (false) {
	      window.offline = function () {
	        return onStateChange('unavailable');
	      };
	      window.online = function () {
	        return onStateChange('connected');
	      };
	    }
	
	    _Offline2.default.on('down', function () {
	      return onStateChange('unavailable');
	    });
	    _Offline2.default.on('reconnect:connecting', function () {
	      return onStateChange('connecting');
	    });
	    _Offline2.default.on('up', function () {
	      return onStateChange('connected');
	    });
	
	    _observingConnection = true;
	  }
	};
	
	exports.default = AppActions;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _offline = __webpack_require__(1085);
	
	var _offline2 = _interopRequireDefault(_offline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_offline2.default.options = {
	  // TODO: We should test an endpoint on API. If using CORS, make sure IE8/9 works. May need to
	  // switch to using the image method, but possible to update `offline-js` to use XDomainRequest.
	  checks: {
	    xhr: { url: '/' }
	  }
	}; /*  weak */
	exports.default = _offline2.default;

/***/ },
/* 1085 */
/***/ function(module, exports) {

	(function() {
	  var Offline, checkXHR, defaultOptions, extendNative, grab, handlers, init;
	
	  extendNative = function(to, from) {
	    var e, key, results, val;
	    results = [];
	    for (key in from.prototype) {
	      try {
	        val = from.prototype[key];
	        if ((to[key] == null) && typeof val !== 'function') {
	          results.push(to[key] = val);
	        } else {
	          results.push(void 0);
	        }
	      } catch (_error) {
	        e = _error;
	      }
	    }
	    return results;
	  };
	
	  Offline = {};
	
	  Offline.options = window.Offline ? window.Offline.options || {} : {};
	
	  defaultOptions = {
	    checks: {
	      xhr: {
	        url: function() {
	          return "/favicon.ico?_=" + ((new Date()).getTime());
	        },
	        timeout: 5000,
	        type: 'HEAD'
	      },
	      image: {
	        url: function() {
	          return "/favicon.ico?_=" + ((new Date()).getTime());
	        }
	      },
	      active: 'xhr'
	    },
	    checkOnLoad: false,
	    interceptRequests: true,
	    reconnect: true,
	    deDupBody: false
	  };
	
	  grab = function(obj, key) {
	    var cur, i, j, len, part, parts;
	    cur = obj;
	    parts = key.split('.');
	    for (i = j = 0, len = parts.length; j < len; i = ++j) {
	      part = parts[i];
	      cur = cur[part];
	      if (typeof cur !== 'object') {
	        break;
	      }
	    }
	    if (i === parts.length - 1) {
	      return cur;
	    } else {
	      return void 0;
	    }
	  };
	
	  Offline.getOption = function(key) {
	    var ref, val;
	    val = (ref = grab(Offline.options, key)) != null ? ref : grab(defaultOptions, key);
	    if (typeof val === 'function') {
	      return val();
	    } else {
	      return val;
	    }
	  };
	
	  if (typeof window.addEventListener === "function") {
	    window.addEventListener('online', function() {
	      return setTimeout(Offline.confirmUp, 100);
	    }, false);
	  }
	
	  if (typeof window.addEventListener === "function") {
	    window.addEventListener('offline', function() {
	      return Offline.confirmDown();
	    }, false);
	  }
	
	  Offline.state = 'up';
	
	  Offline.markUp = function() {
	    Offline.trigger('confirmed-up');
	    if (Offline.state === 'up') {
	      return;
	    }
	    Offline.state = 'up';
	    return Offline.trigger('up');
	  };
	
	  Offline.markDown = function() {
	    Offline.trigger('confirmed-down');
	    if (Offline.state === 'down') {
	      return;
	    }
	    Offline.state = 'down';
	    return Offline.trigger('down');
	  };
	
	  handlers = {};
	
	  Offline.on = function(event, handler, ctx) {
	    var e, events, j, len, results;
	    events = event.split(' ');
	    if (events.length > 1) {
	      results = [];
	      for (j = 0, len = events.length; j < len; j++) {
	        e = events[j];
	        results.push(Offline.on(e, handler, ctx));
	      }
	      return results;
	    } else {
	      if (handlers[event] == null) {
	        handlers[event] = [];
	      }
	      return handlers[event].push([ctx, handler]);
	    }
	  };
	
	  Offline.off = function(event, handler) {
	    var _handler, ctx, i, ref, results;
	    if (handlers[event] == null) {
	      return;
	    }
	    if (!handler) {
	      return handlers[event] = [];
	    } else {
	      i = 0;
	      results = [];
	      while (i < handlers[event].length) {
	        ref = handlers[event][i], ctx = ref[0], _handler = ref[1];
	        if (_handler === handler) {
	          results.push(handlers[event].splice(i, 1));
	        } else {
	          results.push(i++);
	        }
	      }
	      return results;
	    }
	  };
	
	  Offline.trigger = function(event) {
	    var ctx, handler, j, len, ref, ref1, results;
	    if (handlers[event] != null) {
	      ref = handlers[event].slice(0);
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        ref1 = ref[j], ctx = ref1[0], handler = ref1[1];
	        results.push(handler.call(ctx));
	      }
	      return results;
	    }
	  };
	
	  checkXHR = function(xhr, onUp, onDown) {
	    var _onerror, _onload, _onreadystatechange, _ontimeout, checkStatus;
	    checkStatus = function() {
	      if (xhr.status && xhr.status < 12000) {
	        return onUp();
	      } else {
	        return onDown();
	      }
	    };
	    if (xhr.onprogress === null) {
	      _onerror = xhr.onerror;
	      xhr.onerror = function() {
	        onDown();
	        return typeof _onerror === "function" ? _onerror.apply(null, arguments) : void 0;
	      };
	      _ontimeout = xhr.ontimeout;
	      xhr.ontimeout = function() {
	        onDown();
	        return typeof _ontimeout === "function" ? _ontimeout.apply(null, arguments) : void 0;
	      };
	      _onload = xhr.onload;
	      return xhr.onload = function() {
	        checkStatus();
	        return typeof _onload === "function" ? _onload.apply(null, arguments) : void 0;
	      };
	    } else {
	      _onreadystatechange = xhr.onreadystatechange;
	      return xhr.onreadystatechange = function() {
	        if (xhr.readyState === 4) {
	          checkStatus();
	        } else if (xhr.readyState === 0) {
	          onDown();
	        }
	        return typeof _onreadystatechange === "function" ? _onreadystatechange.apply(null, arguments) : void 0;
	      };
	    }
	  };
	
	  Offline.checks = {};
	
	  Offline.checks.xhr = function() {
	    var e, xhr;
	    xhr = new XMLHttpRequest;
	    xhr.offline = false;
	    xhr.open(Offline.getOption('checks.xhr.type'), Offline.getOption('checks.xhr.url'), true);
	    if (xhr.timeout != null) {
	      xhr.timeout = Offline.getOption('checks.xhr.timeout');
	    }
	    checkXHR(xhr, Offline.markUp, Offline.markDown);
	    try {
	      xhr.send();
	    } catch (_error) {
	      e = _error;
	      Offline.markDown();
	    }
	    return xhr;
	  };
	
	  Offline.checks.image = function() {
	    var img;
	    img = document.createElement('img');
	    img.onerror = Offline.markDown;
	    img.onload = Offline.markUp;
	    img.src = Offline.getOption('checks.image.url');
	    return void 0;
	  };
	
	  Offline.checks.down = Offline.markDown;
	
	  Offline.checks.up = Offline.markUp;
	
	  Offline.check = function() {
	    Offline.trigger('checking');
	    return Offline.checks[Offline.getOption('checks.active')]();
	  };
	
	  Offline.confirmUp = Offline.confirmDown = Offline.check;
	
	  Offline.onXHR = function(cb) {
	    var _XDomainRequest, _XMLHttpRequest, monitorXHR;
	    monitorXHR = function(req, flags) {
	      var _open;
	      _open = req.open;
	      return req.open = function(type, url, async, user, password) {
	        cb({
	          type: type,
	          url: url,
	          async: async,
	          flags: flags,
	          user: user,
	          password: password,
	          xhr: req
	        });
	        return _open.apply(req, arguments);
	      };
	    };
	    _XMLHttpRequest = window.XMLHttpRequest;
	    window.XMLHttpRequest = function(flags) {
	      var _overrideMimeType, _setRequestHeader, req;
	      req = new _XMLHttpRequest(flags);
	      monitorXHR(req, flags);
	      _setRequestHeader = req.setRequestHeader;
	      req.headers = {};
	      req.setRequestHeader = function(name, value) {
	        req.headers[name] = value;
	        return _setRequestHeader.call(req, name, value);
	      };
	      _overrideMimeType = req.overrideMimeType;
	      req.overrideMimeType = function(type) {
	        req.mimeType = type;
	        return _overrideMimeType.call(req, type);
	      };
	      return req;
	    };
	    extendNative(window.XMLHttpRequest, _XMLHttpRequest);
	    if (window.XDomainRequest != null) {
	      _XDomainRequest = window.XDomainRequest;
	      window.XDomainRequest = function() {
	        var req;
	        req = new _XDomainRequest;
	        monitorXHR(req);
	        return req;
	      };
	      return extendNative(window.XDomainRequest, _XDomainRequest);
	    }
	  };
	
	  init = function() {
	    if (Offline.getOption('interceptRequests')) {
	      Offline.onXHR(function(arg) {
	        var xhr;
	        xhr = arg.xhr;
	        if (xhr.offline !== false) {
	          return checkXHR(xhr, Offline.markUp, Offline.confirmDown);
	        }
	      });
	    }
	    if (Offline.getOption('checkOnLoad')) {
	      return Offline.check();
	    }
	  };
	
	  setTimeout(init, 0);
	
	  window.Offline = Offline;
	
	}).call(this);
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = window.Offline;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(497);
	
	var _AdminDesktopUpsellPage = __webpack_require__(1087);
	
	var _AdminDesktopUpsellPage2 = _interopRequireDefault(_AdminDesktopUpsellPage);
	
	var _AdminSignupRedirect = __webpack_require__(1101);
	
	var _AdminSignupRedirect2 = _interopRequireDefault(_AdminSignupRedirect);
	
	var _App = __webpack_require__(1103);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _AppLayoutContainer = __webpack_require__(2142);
	
	var _AppLayoutContainer2 = _interopRequireDefault(_AppLayoutContainer);
	
	var _AppUpsellPageContainer = __webpack_require__(2530);
	
	var _AppUpsellPageContainer2 = _interopRequireDefault(_AppUpsellPageContainer);
	
	var _ConfirmEmailPage = __webpack_require__(2543);
	
	var _ConfirmEmailPage2 = _interopRequireDefault(_ConfirmEmailPage);
	
	var _DebugInfoView = __webpack_require__(2546);
	
	var _DebugInfoView2 = _interopRequireDefault(_DebugInfoView);
	
	var _DeleteAccountPage = __webpack_require__(2549);
	
	var _DeleteAccountPage2 = _interopRequireDefault(_DeleteAccountPage);
	
	var _DepositSetupView = __webpack_require__(2550);
	
	var _DepositSetupView2 = _interopRequireDefault(_DepositSetupView);
	
	var _EmailUnsubscribeView = __webpack_require__(2610);
	
	var _EmailUnsubscribeView2 = _interopRequireDefault(_EmailUnsubscribeView);
	
	var _ErrorView = __webpack_require__(2612);
	
	var _ErrorView2 = _interopRequireDefault(_ErrorView);
	
	var _ForgotPasswordPage = __webpack_require__(2616);
	
	var _ForgotPasswordPage2 = _interopRequireDefault(_ForgotPasswordPage);
	
	var _GetBirthdateForChat = __webpack_require__(2623);
	
	var _GetBirthdateForChat2 = _interopRequireDefault(_GetBirthdateForChat);
	
	var _routes = __webpack_require__(2634);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _JoinPageTymkView = __webpack_require__(2762);
	
	var _JoinPageTymkView2 = _interopRequireDefault(_JoinPageTymkView);
	
	var _routes3 = __webpack_require__(2765);
	
	var _routes4 = _interopRequireDefault(_routes3);
	
	var _LeaveChatView = __webpack_require__(2811);
	
	var _LeaveChatView2 = _interopRequireDefault(_LeaveChatView);
	
	var _MarketingEmailUnsubscribeView = __webpack_require__(2812);
	
	var _MarketingEmailUnsubscribeView2 = _interopRequireDefault(_MarketingEmailUnsubscribeView);
	
	var _MarketingLayout = __webpack_require__(2815);
	
	var _MarketingLayout2 = _interopRequireDefault(_MarketingLayout);
	
	var _MessageView = __webpack_require__(2834);
	
	var _MessageView2 = _interopRequireDefault(_MessageView);
	
	var _NotFoundPage = __webpack_require__(2837);
	
	var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);
	
	var _routes5 = __webpack_require__(2840);
	
	var _routes6 = _interopRequireDefault(_routes5);
	
	var _ParentalConsentPage = __webpack_require__(2848);
	
	var _ParentalConsentPage2 = _interopRequireDefault(_ParentalConsentPage);
	
	var _QuickLinkView = __webpack_require__(2859);
	
	var _QuickLinkView2 = _interopRequireDefault(_QuickLinkView);
	
	var _ReportChatView = __webpack_require__(2860);
	
	var _ReportChatView2 = _interopRequireDefault(_ReportChatView);
	
	var _ResetPasswordPage = __webpack_require__(2867);
	
	var _ResetPasswordPage2 = _interopRequireDefault(_ResetPasswordPage);
	
	var _SchoolView = __webpack_require__(2870);
	
	var _SchoolView2 = _interopRequireDefault(_SchoolView);
	
	var _SessionExpiredPage = __webpack_require__(2893);
	
	var _SessionExpiredPage2 = _interopRequireDefault(_SessionExpiredPage);
	
	var _SessionSyncPage = __webpack_require__(2894);
	
	var _SessionSyncPage2 = _interopRequireDefault(_SessionSyncPage);
	
	var _routes7 = __webpack_require__(2897);
	
	var _routes8 = _interopRequireDefault(_routes7);
	
	var _routes9 = __webpack_require__(3077);
	
	var _routes10 = _interopRequireDefault(_routes9);
	
	var _SignInPage = __webpack_require__(1689);
	
	var _SignInPage2 = _interopRequireDefault(_SignInPage);
	
	var _SignOutPage = __webpack_require__(3113);
	
	var _SignOutPage2 = _interopRequireDefault(_SignOutPage);
	
	var _ShareRemindPage = __webpack_require__(3114);
	
	var _ShareRemindPage2 = _interopRequireDefault(_ShareRemindPage);
	
	var _TextAppLinkPage = __webpack_require__(3115);
	
	var _TextAppLinkPage2 = _interopRequireDefault(_TextAppLinkPage);
	
	var _TranscriptRequestApproveView = __webpack_require__(3116);
	
	var _TranscriptRequestApproveView2 = _interopRequireDefault(_TranscriptRequestApproveView);
	
	var _TreasurerSignUp = __webpack_require__(3119);
	
	var _TreasurerSignUp2 = _interopRequireDefault(_TreasurerSignUp);
	
	var _TreasurerAddBankAccountRouteHandler = __webpack_require__(3123);
	
	var _TreasurerAddBankAccountRouteHandler2 = _interopRequireDefault(_TreasurerAddBankAccountRouteHandler);
	
	var _TreasurerLandingPage = __webpack_require__(3130);
	
	var _TreasurerLandingPage2 = _interopRequireDefault(_TreasurerLandingPage);
	
	var _TymkThanksView = __webpack_require__(3131);
	
	var _TymkThanksView2 = _interopRequireDefault(_TymkThanksView);
	
	var _ActivityDetailView = __webpack_require__(3135);
	
	var _ActivityDetailView2 = _interopRequireDefault(_ActivityDetailView);
	
	var _routes11 = __webpack_require__(3186);
	
	var _routes12 = _interopRequireDefault(_routes11);
	
	var _RouteLogic = __webpack_require__(1033);
	
	var _AuthConstants = __webpack_require__(1040);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Dynamically load routes
	
	//
	// NOTICE: can't conflict with src/createSsrRoutes
	//
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { component: _App2.default, onEnter: _App2.default.onEnter, onChange: _App2.default.onChange },
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/', to: '/landing' }),
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/classes/all', to: '/classes/' }),
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/get_our_app', to: '/get_the_app(/)' }),
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/profile', to: '/settings/profile' }),
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/profile/widgets', to: '/settings/widgets' }),
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/profile/exports', to: '/settings/export' }),
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/sign_in', to: '/log_in' }),
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/sign_out', to: '/log_out' }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/transactions/deposit/setup',
	    component: _DepositSetupView2.default,
	    onEnter: _DepositSetupView2.default.onEnter
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/landing',
	    onEnter: _RouteLogic.goFromLanding
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/activities/treasurer/add_bank_account(/)',
	    component: _TreasurerAddBankAccountRouteHandler2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/activities/treasurer/join(/)',
	    component: _TreasurerLandingPage2.default
	  }),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { component: _MarketingLayout2.default },
	    _react2.default.createElement(_reactRouter.Route, { path: '/chat/enroll/:token', component: _GetBirthdateForChat2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/chat/report/:token',
	      component: _ReportChatView2.default,
	      onEnter: _ReportChatView2.default.onEnter
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/chat/leave/:token',
	      component: _LeaveChatView2.default,
	      onEnter: _LeaveChatView2.default.onEnter
	    })
	  ),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/activities/:id',
	    component: _ActivityDetailView2.default,
	    onEnter: _ActivityDetailView2.default.onEnter
	  }),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { component: _AppLayoutContainer2.default },
	    _react2.default.createElement(_reactRouter.Redirect, { from: '/chat(/)', to: '/classes/r/messages' }),
	    _react2.default.createElement(_reactRouter.Redirect, { from: '/inbox(/)', to: '/classes/r/messages' }),
	    _react2.default.createElement(_reactRouter.Redirect, { from: '/chat/:chatId', to: '/classes/r/messages/:chatId' }),
	    _routes2.default,
	    _routes8.default,
	    _routes6.default,
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/messages/:messageUuid',
	      component: _MessageView2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/activities/:id',
	      component: _ActivityDetailView2.default,
	      onEnter: _ActivityDetailView2.default.onEnter
	    }),
	    _react2.default.createElement(_reactRouter.Redirect, { from: '/transactions(/)', to: '/classes/r/activities' }),
	    _react2.default.createElement(_reactRouter.Redirect, { from: '/campaigns(/)', to: '/classes/r/activities' }),
	    _react2.default.createElement(_reactRouter.Redirect, { from: '/activities/new(/)', to: '/classes/r/activities/new' })
	  ),
	  _routes12.default,
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { component: _MarketingLayout2.default },
	    _routes10.default,
	    _routes4.default,
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/activities/treasurer/sign_up(/)',
	      component: _TreasurerSignUp2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/school/sign_up',
	      component: _AdminSignupRedirect2.default,
	      onEnter: _AdminSignupRedirect2.default.onEnter
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/log_in', component: _SignInPage2.default, onEnter: _RouteLogic.goLandingIfAuthed }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/session/expired', component: _SessionExpiredPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/log_out', component: _SignOutPage2.default, onEnter: _SignOutPage2.default.onEnter }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/confirm_email/:token', component: _ConfirmEmailPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: _AuthConstants.RESET_PASSWORD_PATH, component: _ResetPasswordPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/forgot_password', component: _ForgotPasswordPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/user_changed', component: _SessionSyncPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/delete_account/:token', component: _DeleteAccountPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/quicklink/:token',
	      component: _QuickLinkView2.default,
	      onEnter: _QuickLinkView2.default.onEnter
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/email/unsubscribe/:token',
	      component: _EmailUnsubscribeView2.default,
	      onEnter: _EmailUnsubscribeView2.default.onEnter
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/invite',
	      component: _JoinPageTymkView2.default,
	      onEnter: _JoinPageTymkView2.default.onEnter
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/invite/thanks', component: _TymkThanksView2.default }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/unsubscribe/:token',
	      component: _MarketingEmailUnsubscribeView2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/transcript/:token',
	      component: _TranscriptRequestApproveView2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/get_the_app',
	      component: _AppUpsellPageContainer2.default,
	      onEnter: _AppUpsellPageContainer2.default.onEnter
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/schools_desktop',
	      component: _AdminDesktopUpsellPage2.default,
	      onEnter: _AdminDesktopUpsellPage2.default.onEnter
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/school/:organizationId',
	      component: _SchoolView2.default,
	      onEnter: _SchoolView2.default.onEnter
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/send_the_app',
	      component: _TextAppLinkPage2.default
	    }),
	    _react2.default.createElement(_reactRouter.Route, {
	      path: '/parental_consent',
	      component: _ParentalConsentPage2.default,
	      onEnter: _ParentalConsentPage2.default.onEnter
	    }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/share_remind', component: _ShareRemindPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/error', component: _ErrorView2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/debug', component: _DebugInfoView2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '/not_found', component: _NotFoundPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _NotFoundPage2.default })
	  )
	);

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AffiliationStatus = __webpack_require__(1088);
	
	var _AffiliationStatus2 = _interopRequireDefault(_AffiliationStatus);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1099);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminDesktopUpsellPage = function (_React$Component) {
	  _inherits(AdminDesktopUpsellPage, _React$Component);
	
	  function AdminDesktopUpsellPage() {
	    _classCallCheck(this, AdminDesktopUpsellPage);
	
	    return _possibleConstructorReturn(this, (AdminDesktopUpsellPage.__proto__ || Object.getPrototypeOf(AdminDesktopUpsellPage)).apply(this, arguments));
	  }
	
	  _createClass(AdminDesktopUpsellPage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'SchoolAdminPending' },
	        _react2.default.createElement(
	          _AffiliationStatus2.default,
	          {
	            title: 'We\'re verifying your status',
	            subtext: 'Verifying administrators usually takes 1 to 3 business days, and you\'ll get an email as soon as we\'re done!' },
	          _react2.default.createElement(
	            'div',
	            { className: 'AffiliationStatus-Subtext' },
	            'Please log in on your computer to use Remind for Schools.'
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'onEnter',
	
	    // This has to be here in order to get a CurrentUser
	    value: function onEnter(nextState, replaceWith, callback) {
	      _AuthActions2.default.checkLoggedIn().then(function () {
	        return callback();
	      }, function () {
	        return callback();
	      });
	    }
	  }]);
	
	  return AdminDesktopUpsellPage;
	}(_react2.default.Component);
	
	AdminDesktopUpsellPage.displayName = 'AdminDesktopUpsellPage';
	exports.default = AdminDesktopUpsellPage;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	__webpack_require__(1096);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AffiliationStatus = _react2.default.createClass({
	  displayName: 'AffiliationStatus',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('AffiliationStatus', this.props.className) },
	      _react2.default.createElement(_Image2.default, {
	        className: 'AffiliationStatus-Bell',
	        src: __webpack_require__(1098)
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'AffiliationStatus-Title' },
	        this.props.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'AffiliationStatus-Subtext' },
	        this.props.subtext
	      ),
	      this.props.children
	    );
	  }
	});
	
	exports.default = AffiliationStatus;

/***/ },
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */
1136,
/* 1097 */,
/* 1098 */,
/* 1099 */
1136,
/* 1100 */,
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminSignupRedirect = _react2.default.createClass({
	  displayName: 'AdminSignupRedirect',
	
	  statics: {
	    onEnter: function onEnter(nextState, replaceWith, callback) {
	      var loggedIn = function loggedIn() {
	        replaceWith('/setup/admin_role');
	        callback();
	      };
	      var notLoggedIn = function notLoggedIn() {
	        window.location = _LinkConstants2.default.SIGN_UP;
	        callback();
	      };
	
	      _AuthActions2.default.checkLoggedIn().then(loggedIn, notLoggedIn);
	    }
	  },
	
	  render: function render() {
	    return null;
	  }
	});
	exports.default = AdminSignupRedirect;

/***/ },
/* 1102 */,
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Electron = __webpack_require__(1104);
	
	var _Electron2 = _interopRequireDefault(_Electron);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _PusherActions = __webpack_require__(953);
	
	var _PusherActions2 = _interopRequireDefault(_PusherActions);
	
	var _ScrollContext = __webpack_require__(1105);
	
	var _ScrollContext2 = _interopRequireDefault(_ScrollContext);
	
	var _ToastsContainerNode = __webpack_require__(1111);
	
	var _ToastsContainerNode2 = _interopRequireDefault(_ToastsContainerNode);
	
	var _currentUserAgent = __webpack_require__(1160);
	
	var _currentUserAgent2 = _interopRequireDefault(_currentUserAgent);
	
	var _WebNotificationClient = __webpack_require__(2138);
	
	var _WebNotificationClient2 = _interopRequireDefault(_WebNotificationClient);
	
	var _Timer = __webpack_require__(1239);
	
	var _refreshAssets = __webpack_require__(2139);
	
	var _xhrInterceptors = __webpack_require__(575);
	
	var _App = __webpack_require__(2140);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, App);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.onUserSignIn = function () {
	      if (_CurrentUser2.default.isSignedIn()) {
	        var user = _CurrentUser2.default.getUser();
	        if (user && user.getPusherChannel()) {
	          _PusherActions2.default.subscribeToChannel(user.getPusherChannel());
	        }
	      }
	    }, _this.isOutOfSync = function (response) {
	      // TODO FIXME IE cache headers, resulting in this showing too much.
	      if (_currentUserAgent2.default.ie()) {
	        return false;
	      }
	
	      var status = response.headers['status'];
	      if (status && status.toLowerCase() === '304 not modified') {
	        return false;
	      }
	
	      if (!_CurrentUser2.default.isSignedIn() || !response.headers['x-userid']) {
	        return false;
	      }
	
	      return response.headers['x-userid'] !== _CurrentUser2.default.getUserId().toString();
	    }, _this.userChangeInterceptor = function (response) {
	      var isOutOfSync = _this.isOutOfSync(response);
	      if (!_this.context.router.isActive('/user_changed') && isOutOfSync) {
	        _this.context.router.push('/user_changed');
	        return true;
	      }
	
	      return false;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // XXX all of these are available on context.router now
	  // TODO delete here and update all dependents
	
	
	  _createClass(App, [{
	    key: 'getChildContext',
	
	
	    // XXX all of these are available on context.router now
	    // TODO delete here and update all dependents
	    value: function getChildContext() {
	      return {
	        routes: this.props.routes,
	        location: this.props.location,
	        params: this.props.params
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _Timer.markAppMounted)();
	      (0, _xhrInterceptors.registerInterceptor)('userchange-interceptor', this.userChangeInterceptor);
	
	      this.onUserSignIn();
	      _CurrentUser2.default.addSignInListener(this.onUserSignIn);
	      _CurrentUser2.default.addSignInNoRoleListener(this.onUserSignIn);
	      _Electron2.default.bindIfAvailable(this.context.router);
	      _WebNotificationClient2.default.handleNotifications(this.context.router);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _xhrInterceptors.unregisterInterceptor)('userchange-interceptor');
	      // leave 503-interceptor, probably should move elsewhere but another PR
	
	      _CurrentUser2.default.removeSignInListener(this.onUserSignIn);
	    }
	
	    // @returns whether the response was intercepted
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ScrollContext2.default,
	        { className: _App2.default.this },
	        _react2.default.createElement(_ToastsContainerNode2.default, null),
	        this.props.children
	      );
	    }
	  }], [{
	    key: 'onEnter',
	
	
	    // typecheck: ignore statement
	    value: function onEnter(nextState) {
	      // Refresh the app if it's more than a day old when the user is navigating.
	      (0, _refreshAssets.refreshAppIfOld)();
	
	      (0, _Timer.markNewTransition)(nextState.location.pathname);
	
	      _EventTracking2.default.view((0, _EventTracking.getEventScreenName)(null, nextState), nextState.params);
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(prevState, nextState) {
	      window.prevLocation = prevState.location;
	      App.onEnter(nextState);
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	App.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	App.childContextTypes = {
	  routes: _react2.default.PropTypes.array.isRequired,
	  location: _react2.default.PropTypes.object.isRequired,
	  params: _react2.default.PropTypes.object.isRequired
	};
	App.displayName = 'App';
	exports.default = App;

/***/ },
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ToastsContainer = __webpack_require__(1112);
	
	var _ToastsContainer2 = _interopRequireDefault(_ToastsContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line camelcase
	
	
	var ToastsContainerNode = function (_React$Component) {
	  _inherits(ToastsContainerNode, _React$Component);
	
	  function ToastsContainerNode() {
	    _classCallCheck(this, ToastsContainerNode);
	
	    return _possibleConstructorReturn(this, (ToastsContainerNode.__proto__ || Object.getPrototypeOf(ToastsContainerNode)).apply(this, arguments));
	  }
	
	  _createClass(ToastsContainerNode, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.build();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cleanup();
	    }
	  }, {
	    key: 'cleanup',
	    value: function cleanup() {
	      _reactDom2.default.unmountComponentAtNode(this.node);
	    }
	  }, {
	    key: 'build',
	    value: function build() {
	      this.node = document.createElement('div');
	      document.body.appendChild(this.node);
	
	      (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, _react2.default.createElement(_ToastsContainer2.default, null), this.node);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ToastsContainerNode;
	}(_react2.default.Component);
	
	ToastsContainerNode.displayName = 'ToastsContainerNode';
	exports.default = ToastsContainerNode;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _SuccessToast = __webpack_require__(1128);
	
	var _SuccessToast2 = _interopRequireDefault(_SuccessToast);
	
	var _ErrorToast = __webpack_require__(2125);
	
	var _ErrorToast2 = _interopRequireDefault(_ErrorToast);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(2126);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _redux = __webpack_require__(476);
	
	var _toasts = __webpack_require__(948);
	
	var _immutable = __webpack_require__(949);
	
	__webpack_require__(2136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var MINIMUM_TIMEOUT = 1000;
	var TIME_PER_CHARACTER = 100;
	
	function calculateTimeout(toast) {
	  return MINIMUM_TIMEOUT + toast.text.length * TIME_PER_CHARACTER;
	}
	
	var ToastsContainer = function (_React$Component) {
	  _inherits(ToastsContainer, _React$Component);
	
	  function ToastsContainer() {
	    _classCallCheck(this, ToastsContainer);
	
	    return _possibleConstructorReturn(this, (ToastsContainer.__proto__ || Object.getPrototypeOf(ToastsContainer)).apply(this, arguments));
	  }
	
	  _createClass(ToastsContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var newToast = nextProps.toasts.last();
	      var toasts = nextProps.toasts.slice(0, -1);
	
	      // Because we are going to clear all but the new toast
	      // we can clear this timeout, no problemo.
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	      }
	
	      // Clear all the toasts but the new one.
	      toasts.forEach(function (toast) {
	        return _this2.props.remove(toast);
	      });
	
	      // clear the new toast after a little time.
	      if (newToast) {
	        this.timeout = setTimeout(function () {
	          return _this2.props.remove(newToast);
	        }, calculateTimeout(newToast));
	      }
	    }
	  }, {
	    key: 'renderToast',
	    value: function renderToast(toast) {
	      var Component = toast.kind === 'success' ? _SuccessToast2.default : _ErrorToast2.default;
	
	      return _react2.default.createElement(
	        Component,
	        { key: toast.uuid },
	        toast.text
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ToastsContainer' },
	        _react2.default.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          {
	            transitionAppear: true,
	            transitionName: 'toasts',
	            transitionEnterTimeout: 500,
	            transitionAppearTimeout: 500,
	            transitionLeaveTimeout: 500 },
	          this.props.toasts.toArray().map(function (toast) {
	            return _this3.renderToast(toast);
	          })
	        )
	      );
	    }
	  }]);
	
	  return ToastsContainer;
	}(_react2.default.Component);
	
	ToastsContainer.displayName = 'ToastsContainer';
	
	
	function mapStateToProps(state) {
	  return {
	    toasts: state.toasts
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ remove: _toasts.remove }, dispatch);
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ToastsContainer);

/***/ },
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Toast = __webpack_require__(1129);
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	var _Notice = __webpack_require__(1132);
	
	var _Notice2 = _interopRequireDefault(_Notice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SuccessToast = function SuccessToast(props) {
	  return _react2.default.createElement(
	    _Toast2.default,
	    null,
	    _react2.default.createElement(
	      _Notice2.default,
	      { color: 'shamrock', glyph: 'check' },
	      props.children
	    )
	  );
	};
	// typecheck: ignore file
	exports.default = SuccessToast;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toast = function (_React$Component) {
	  _inherits(Toast, _React$Component);
	
	  function Toast() {
	    _classCallCheck(this, Toast);
	
	    return _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).apply(this, arguments));
	  }
	
	  _createClass(Toast, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Toast' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Toast-contents' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return Toast;
	}(_react2.default.Component);
	
	Toast.displayName = 'Toast';
	exports.default = Toast;

/***/ },
/* 1130 */
1136,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Toast = __webpack_require__(1129);
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	var _Notice = __webpack_require__(1132);
	
	var _Notice2 = _interopRequireDefault(_Notice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ErrorToast = function ErrorToast(props) {
	  return _react2.default.createElement(
	    _Toast2.default,
	    null,
	    _react2.default.createElement(
	      _Notice2.default,
	      { color: 'lava', glyph: 'close' },
	      props.children
	    )
	  );
	};
	// typecheck: ignore file
	exports.default = ErrorToast;

/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2127);

/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(300);
	
	var ReactTransitionGroup = __webpack_require__(2128);
	var ReactCSSTransitionGroupChild = __webpack_require__(2132);
	
	function createTransitionTimeoutPropValidator(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to ReactCSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	  };
	}
	
	/**
	 * An easy way to perform CSS transitions and animations when a React component
	 * enters or leaves the DOM.
	 * See https://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup
	 */
	
	var ReactCSSTransitionGroup = function (_React$Component) {
	  _inherits(ReactCSSTransitionGroup, _React$Component);
	
	  function ReactCSSTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactCSSTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
	      // We need to provide this childFactory so that
	      // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	      // leave while it is leaving.
	      return React.createElement(ReactCSSTransitionGroupChild, {
	        name: _this.props.transitionName,
	        appear: _this.props.transitionAppear,
	        enter: _this.props.transitionEnter,
	        leave: _this.props.transitionLeave,
	        appearTimeout: _this.props.transitionAppearTimeout,
	        enterTimeout: _this.props.transitionEnterTimeout,
	        leaveTimeout: _this.props.transitionLeaveTimeout
	      }, child);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactCSSTransitionGroup.prototype.render = function render() {
	    return React.createElement(ReactTransitionGroup, _assign({}, this.props, { childFactory: this._wrapChild }));
	  };
	
	  return ReactCSSTransitionGroup;
	}(React.Component);
	
	ReactCSSTransitionGroup.displayName = 'ReactCSSTransitionGroup';
	ReactCSSTransitionGroup.propTypes = {
	  transitionName: ReactCSSTransitionGroupChild.propTypes.name,
	
	  transitionAppear: React.PropTypes.bool,
	  transitionEnter: React.PropTypes.bool,
	  transitionLeave: React.PropTypes.bool,
	  transitionAppearTimeout: createTransitionTimeoutPropValidator('Appear'),
	  transitionEnterTimeout: createTransitionTimeoutPropValidator('Enter'),
	  transitionLeaveTimeout: createTransitionTimeoutPropValidator('Leave')
	};
	ReactCSSTransitionGroup.defaultProps = {
	  transitionAppear: false,
	  transitionEnter: true,
	  transitionLeave: true
	};
	
	
	module.exports = ReactCSSTransitionGroup;

/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(301);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(300);
	var ReactAddonsDOMDependencies = __webpack_require__(2129);
	var ReactTransitionChildMapping = __webpack_require__(2130);
	
	var emptyFunction = __webpack_require__(309);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	
	var ReactTransitionGroup = function (_React$Component) {
	  _inherits(ReactTransitionGroup, _React$Component);
	
	  function ReactTransitionGroup() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactTransitionGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(_this.props.children)
	    }, _this.performAppear = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key));
	      } else {
	        _this._handleDoneAppearing(key);
	      }
	    }, _this._handleDoneAppearing = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performEnter = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key));
	      } else {
	        _this._handleDoneEntering(key);
	      }
	    }, _this._handleDoneEntering = function (key) {
	      var component = _this.refs[key];
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key);
	      }
	    }, _this.performLeave = function (key) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      var component = _this.refs[key];
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key);
	      }
	    }, _this._handleDoneLeaving = function (key) {
	      var component = _this.refs[key];
	
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping;
	      if (false) {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(_this)._debugID);
	      } else {
	        currentChildMapping = ReactTransitionChildMapping.getChildMapping(_this.props.children);
	      }
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.performEnter(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _assign({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ReactTransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  ReactTransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  };
	
	  ReactTransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping;
	    if (false) {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children, ReactAddonsDOMDependencies.getReactInstanceMap().get(this)._debugID);
	    } else {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    }
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  ReactTransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  };
	
	  ReactTransitionGroup.prototype.render = function render() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return ReactTransitionGroup;
	}(React.Component);
	
	ReactTransitionGroup.displayName = 'ReactTransitionGroup';
	ReactTransitionGroup.propTypes = {
	  component: React.PropTypes.any,
	  childFactory: React.PropTypes.func
	};
	ReactTransitionGroup.defaultProps = {
	  component: 'span',
	  childFactory: emptyFunction.thatReturnsArgument
	};
	
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(327);
	var ReactInstanceMap = __webpack_require__(408);
	
	exports.getReactDOM = function () {
	  return ReactDOM;
	};
	
	exports.getReactInstanceMap = function () {
	  return ReactInstanceMap;
	};
	
	if (false) {
	  var ReactPerf = require('react-dom/lib/ReactPerf');
	  var ReactTestUtils = require('react-dom/lib/ReactTestUtils');
	
	  exports.getReactPerf = function () {
	    return ReactPerf;
	  };
	
	  exports.getReactTestUtils = function () {
	    return ReactTestUtils;
	  };
	}

/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(2131);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(314);
	var traverseAllChildren = __webpack_require__(312);
	var warning = __webpack_require__(308);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(423);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(300);
	var ReactAddonsDOMDependencies = __webpack_require__(2129);
	
	var CSSCore = __webpack_require__(2133);
	var ReactTransitionEvents = __webpack_require__(2134);
	
	var onlyChild = __webpack_require__(325);
	
	var TICK = 17;
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  propTypes: {
	    name: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      active: React.PropTypes.string
	    }), React.PropTypes.shape({
	      enter: React.PropTypes.string,
	      enterActive: React.PropTypes.string,
	      leave: React.PropTypes.string,
	      leaveActive: React.PropTypes.string,
	      appear: React.PropTypes.string,
	      appearActive: React.PropTypes.string
	    })]).isRequired,
	
	    // Once we require timeouts to be specified, we can remove the
	    // boolean flags (appear etc.) and just accept a number
	    // or a bool for the timeout flags (appearTimeout etc.)
	    appear: React.PropTypes.bool,
	    enter: React.PropTypes.bool,
	    leave: React.PropTypes.bool,
	    appearTimeout: React.PropTypes.number,
	    enterTimeout: React.PropTypes.number,
	    leaveTimeout: React.PropTypes.number
	  },
	
	  transition: function (animationType, finishCallback, userSpecifiedDelay) {
	    var node = ReactAddonsDOMDependencies.getReactDOM().findDOMNode(this);
	
	    if (!node) {
	      if (finishCallback) {
	        finishCallback();
	      }
	      return;
	    }
	
	    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
	    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
	    var timeout = null;
	
	    var endListener = function (e) {
	      if (e && e.target !== node) {
	        return;
	      }
	
	      clearTimeout(timeout);
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClassAndNode(activeClassName, node);
	
	    // If the user specified a timeout delay.
	    if (userSpecifiedDelay) {
	      // Clean-up the animation after the specified delay
	      timeout = setTimeout(endListener, userSpecifiedDelay);
	      this.transitionTimeouts.push(timeout);
	    } else {
	      // DEPRECATED: this listener will be removed in a future version of react
	      ReactTransitionEvents.addEndEventListener(node, endListener);
	    }
	  },
	
	  queueClassAndNode: function (className, node) {
	    this.classNameAndNodeQueue.push({
	      className: className,
	      node: node
	    });
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameAndNodeQueue, TICK);
	    }
	  },
	
	  flushClassNameAndNodeQueue: function () {
	    if (this.isMounted()) {
	      this.classNameAndNodeQueue.forEach(function (obj) {
	        CSSCore.addClass(obj.node, obj.className);
	      });
	    }
	    this.classNameAndNodeQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function () {
	    this.classNameAndNodeQueue = [];
	    this.transitionTimeouts = [];
	  },
	
	  componentWillUnmount: function () {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	    this.transitionTimeouts.forEach(function (timeout) {
	      clearTimeout(timeout);
	    });
	
	    this.classNameAndNodeQueue.length = 0;
	  },
	
	  componentWillAppear: function (done) {
	    if (this.props.appear) {
	      this.transition('appear', done, this.props.appearTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function (done) {
	    if (this.props.enter) {
	      this.transition('enter', done, this.props.enterTimeout);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function (done) {
	    if (this.props.leave) {
	      this.transition('leave', done, this.props.leaveTimeout);
	    } else {
	      done();
	    }
	  },
	
	  render: function () {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;

/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(305);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	/* Slow implementation for browsers that don't natively support .matches() */
	function matchesSelector_SLOW(element, selector) {
	  var root = element;
	  while (root.parentNode) {
	    root = root.parentNode;
	  }
	
	  var all = root.querySelectorAll(selector);
	  return Array.prototype.indexOf.call(all, element) !== -1;
	}
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function addClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.addClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function removeClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSSCore.removeClass takes only a single class name. "%s" contains ' + 'multiple classes.', className) : invariant(false) : void 0;
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ') // multiple spaces to one
	        .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function conditionClass(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to check the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function hasClass(element, className) {
	    !!/\s/.test(className) ?  false ? invariant(false, 'CSS.hasClass takes only a single class name.') : invariant(false) : void 0;
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  },
	
	  /**
	   * Tests whether the element matches the selector specified
	   *
	   * @param {DOMNode|DOMWindow} element the element that we are querying
	   * @param {string} selector the CSS selector
	   * @return {boolean} true if the element matches the selector, false if not
	   */
	  matchesSelector: function matchesSelector(element, selector) {
	    var matchesImpl = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector || function (s) {
	      return matchesSelector_SLOW(element, s);
	    };
	    return matchesImpl.call(element, selector);
	  }
	
	};
	
	module.exports = CSSCore;

/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(2135);
	
	var getVendorPrefixedEventName = __webpack_require__(399);
	
	var endEvents = [];
	
	function detectEvents() {
	  var animEnd = getVendorPrefixedEventName('animationend');
	  var transEnd = getVendorPrefixedEventName('transitionend');
	
	  if (animEnd) {
	    endEvents.push(animEnd);
	  }
	
	  if (transEnd) {
	    endEvents.push(transEnd);
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function (node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;

/***/ },
/* 2135 */
345,
/* 2136 */
1136,
/* 2137 */,
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Electron = __webpack_require__(1104);
	
	var _Electron2 = _interopRequireDefault(_Electron);
	
	var _WebNotificationStore = __webpack_require__(2096);
	
	var _WebNotificationStore2 = _interopRequireDefault(_WebNotificationStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function focusWindow() {
	  if (_Electron2.default.isAvailable()) {
	    _Electron2.default.showCurrentWindow();
	  }
	  window.focus();
	}
	
	var WebNotificationClient = function () {
	  function WebNotificationClient() {
	    _classCallCheck(this, WebNotificationClient);
	  }
	
	  _createClass(WebNotificationClient, [{
	    key: 'handleNotifications',
	
	    // $FlowFixMe where can we get this type?
	    value: function handleNotifications(router) {
	      _WebNotificationStore2.default.addChangeListener(function () {
	        _WebNotificationStore2.default.getPendingNotifications().forEach(function (notif) {
	          var url = notif._options.url;
	
	          if (url) {
	            // Don't show the notification if the user is in Chat, and is a chat notification
	            if (url.startsWith('/chat') && router.isActive('/chat') && document.hasFocus()) {
	              notif.dismissNotification();
	            } else {
	              var redirect = function redirect() {
	                return router.push(url);
	              };
	              notif.setOnClick((0, _createChainedFunction2.default)(focusWindow, redirect));
	              notif.dispatch();
	            }
	          } else {
	            notif.setOnClick(focusWindow);
	            notif.dispatch();
	          }
	        });
	      });
	    }
	  }]);
	
	  return WebNotificationClient;
	}();
	
	WebNotificationClient.displayName = 'WebNotificationClient';
	exports.default = new WebNotificationClient();

/***/ },
/* 2139 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var appStartupTime = Date.now();
	var ONE_DAY = 24 * 60 * 60 * 1000;
	
	var refreshAppIfOld = exports.refreshAppIfOld = function refreshAppIfOld() {
	  if (typeof window === 'undefined') {
	    return;
	  }
	
	  // Tests that fake time to be in the future and then perform a route change
	  // may fail due to the refresh caused by refreshAppIfOld.
	  if (window.DO_NOT_REFRESH) {
	    return;
	  }
	
	  if (appStartupTime + ONE_DAY < Date.now()) {
	    window.location.reload();
	  }
	};

/***/ },
/* 2140 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"App__this___2Pt6u"};

/***/ },
/* 2141 */,
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppLayoutContainer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _AppLayout = __webpack_require__(2143);
	
	var _AppLayout2 = _interopRequireDefault(_AppLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var AppLayoutContainer = function (_Component) {
	  _inherits(AppLayoutContainer, _Component);
	
	  function AppLayoutContainer() {
	    _classCallCheck(this, AppLayoutContainer);
	
	    return _possibleConstructorReturn(this, (AppLayoutContainer.__proto__ || Object.getPrototypeOf(AppLayoutContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppLayoutContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_AppLayout2.default, _extends({ user: this.state.user }, this.props));
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        user: _CurrentUser2.default.getUser()
	      };
	    }
	  }]);
	
	  return AppLayoutContainer;
	}(_react.Component);
	
	AppLayoutContainer.displayName = 'AppLayoutContainer';
	exports.AppLayoutContainer = AppLayoutContainer;
	exports.default = _utils.Container.create(AppLayoutContainer, { withProps: true });

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AdminVerificationModals = __webpack_require__(2144);
	
	var _AdminVerificationModals2 = _interopRequireDefault(_AdminVerificationModals);
	
	var _AppTopBarContainer = __webpack_require__(2154);
	
	var _AppTopBarContainer2 = _interopRequireDefault(_AppTopBarContainer);
	
	var _ClassNavigation = __webpack_require__(2391);
	
	var _ClassNavigation2 = _interopRequireDefault(_ClassNavigation);
	
	var _QuickPromotionAppOpenedModals = __webpack_require__(2495);
	
	var _QuickPromotionAppOpenedModals2 = _interopRequireDefault(_QuickPromotionAppOpenedModals);
	
	var _BannersContainer = __webpack_require__(2499);
	
	var _BannersContainer2 = _interopRequireDefault(_BannersContainer);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TymkRegistrationModals = __webpack_require__(2507);
	
	var _TymkRegistrationModals2 = _interopRequireDefault(_TymkRegistrationModals);
	
	var _ProfileCompletenessModals = __webpack_require__(2508);
	
	var _ProfileCompletenessModals2 = _interopRequireDefault(_ProfileCompletenessModals);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _accountCompletionTracker = __webpack_require__(2526);
	
	var _ResponseInterceptors = __webpack_require__(2527);
	
	var _xhrInterceptors = __webpack_require__(575);
	
	var _AppLayout = __webpack_require__(2528);
	
	var _AppLayout2 = _interopRequireDefault(_AppLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var AppLayout = function (_React$Component) {
	  _inherits(AppLayout, _React$Component);
	
	  function AppLayout() {
	    _classCallCheck(this, AppLayout);
	
	    return _possibleConstructorReturn(this, (AppLayout.__proto__ || Object.getPrototypeOf(AppLayout)).apply(this, arguments));
	  }
	
	  _createClass(AppLayout, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _xhrInterceptors.registerInterceptor)('401-interceptor', _ResponseInterceptors.unauthorizedInterceptor);
	      (0, _accountCompletionTracker.markSeenClasses)(this.props.user);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      (0, _xhrInterceptors.unregisterInterceptor)('401-interceptor');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var shouldShowBanner = this.props.user && !this.context.router.isActive('/setup');
	
	      return _react2.default.createElement(
	        'div',
	        { className: _AppLayout2.default.this },
	        shouldShowBanner && _react2.default.createElement(_BannersContainer2.default, { 'data-test': 'banners-container' }),
	        _react2.default.createElement(
	          'div',
	          { className: _AppLayout2.default.bodyPadding },
	          _react2.default.createElement(_AppTopBarContainer2.default, null),
	          _react2.default.createElement(
	            'div',
	            { className: _AppLayout2.default.heightSetter },
	            _react2.default.createElement(
	              'div',
	              { className: _AppLayout2.default.contentWrap },
	              _react2.default.createElement(
	                'div',
	                { className: _AppLayout2.default.sidebar },
	                _react2.default.createElement(_ClassNavigation2.default, null)
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: _AppLayout2.default.content },
	                this.props.children
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_AdminVerificationModals2.default, { location: this.props.location }),
	        _react2.default.createElement(_QuickPromotionAppOpenedModals2.default, null),
	        _react2.default.createElement(_TymkRegistrationModals2.default, null),
	        _react2.default.createElement(_ProfileCompletenessModals2.default, null)
	      );
	    }
	  }]);
	
	  return AppLayout;
	}(_react2.default.Component);
	
	AppLayout.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	AppLayout.displayName = 'AppLayout';
	exports.default = AppLayout;

/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AdminNeedsOptInModal = __webpack_require__(2145);
	
	var _AdminNeedsOptInModal2 = _interopRequireDefault(_AdminNeedsOptInModal);
	
	var _AdminNeedsEmailConfModal = __webpack_require__(2151);
	
	var _AdminNeedsEmailConfModal2 = _interopRequireDefault(_AdminNeedsEmailConfModal);
	
	var _AdminRejectedModal = __webpack_require__(2152);
	
	var _AdminRejectedModal2 = _interopRequireDefault(_AdminRejectedModal);
	
	var _AdminVerifiedModal = __webpack_require__(2146);
	
	var _AdminVerifiedModal2 = _interopRequireDefault(_AdminVerifiedModal);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _Prompt = __webpack_require__(1049);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminVerificationModals = _react2.default.createClass({
	  displayName: 'AdminVerificationModals',
	
	
	  mixins: [(0, _linkStateWithStores2.default)([_PromptStore2.default, _AffiliationStore2.default])],
	
	  getInitialState: function getInitialState() {
	    // XXX this should be handled by real state
	    this.hasShownAny = false;
	    return this.getStateFromStores();
	  },
	  componentDidMount: function componentDidMount() {
	    this.checkForPrompts();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.checkForPrompts();
	  },
	  onRequestHide: function onRequestHide(prompt) {
	    // Check that this is a Prompt rather than an event
	    if (prompt instanceof _Prompt2.default) {
	      _PromptActions2.default.recordDismissExistingPrompt(prompt);
	    }
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      verifiedModalPrompt: _PromptStore2.default.getAvailable(_PromptConstants.PromptNames.ADMIN_VERIFIED_MODAL),
	      rejectedModalPrompt: _PromptStore2.default.getAvailable(_PromptConstants.PromptNames.ADMIN_REJECTED_MODAL),
	      recentlyDismissedPreverified: _PromptStore2.default.hasDismissedWithin(_PromptConstants.PromptNames.ADMIN_PREVERIFIED_MODAL, 7),
	      affiliations: _AffiliationStore2.default.getAffiliations()
	    };
	  },
	  checkForPrompts: function checkForPrompts() {
	    var query = this.props.location.query;
	    var path = this.props.location.pathname;
	    var hasAdminConsole = _CurrentUser2.default.getUser().hasFeature('web_admin_console');
	    if (hasAdminConsole || query.admin || !path.includes('/classes')) {
	      // Don't show if they just came through AFO or aren't on the classes page, or have the admin console
	      return;
	    }
	
	    var _state = this.state,
	        affiliations = _state.affiliations,
	        verifiedModalPrompt = _state.verifiedModalPrompt,
	        rejectedModalPrompt = _state.rejectedModalPrompt,
	        recentlyDismissedPreverified = _state.recentlyDismissedPreverified;
	
	
	    if (!this.hasShownAny) {
	      if (verifiedModalPrompt) {
	        var orgId = verifiedModalPrompt.getMessageId();
	        (0, _modal.mountModal)(_react2.default.createElement(_AdminVerifiedModal2.default, {
	          orgId: orgId,
	          onRequestHide: this.onRequestHide.bind(this, verifiedModalPrompt)
	        }), this);
	        this.hasShownAny = true;
	      } else if (rejectedModalPrompt) {
	        var _orgId = rejectedModalPrompt.getMessageId();
	        (0, _modal.mountModal)(_react2.default.createElement(_AdminRejectedModal2.default, {
	          orgId: _orgId,
	          onRequestHide: this.onRequestHide.bind(this, rejectedModalPrompt)
	        }), this);
	        this.hasShownAny = true;
	      } else if (affiliations && affiliations.length) {
	        var affWithPendingRole = affiliations.find(_Affiliation.hasPendingRole);
	        if (affWithPendingRole) {
	          if ((0, _Affiliation.needsOptIn)(affWithPendingRole) && !recentlyDismissedPreverified) {
	            var org = _OrganizationStore2.default.getOrganization(affWithPendingRole.organization_id);
	            var prompt = _PromptStore2.default.getPrompt(_PromptConstants.PromptNames.ADMIN_PREVERIFIED_MODAL);
	            if (!prompt || prompt.isLessThanDaysOld(30)) {
	              (0, _modal.mountModal)(_react2.default.createElement(_AdminNeedsOptInModal2.default, {
	                affiliation: affWithPendingRole,
	                orgName: org.getName(),
	                onRequestHide: this.onRequestHide
	              }), this);
	              this.hasShownAny = true;
	            }
	          } else if ((0, _Affiliation.needsEmailConf)(affWithPendingRole)) {
	            var _org = _OrganizationStore2.default.getOrganization(affWithPendingRole.organization_id);
	            (0, _modal.mountModal)(_react2.default.createElement(_AdminNeedsEmailConfModal2.default, {
	              affiliation: affWithPendingRole,
	              orgName: _org.getName(),
	              onRequestHide: this.onRequestHide
	            }), this);
	            this.hasShownAny = true;
	          }
	        }
	      }
	    }
	  },
	  render: function render() {
	    return null;
	  }
	});
	
	exports.default = AdminVerificationModals;

/***/ },
/* 2145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _OrgRoleActions = __webpack_require__(1583);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _Affiliation2 = _interopRequireDefault(_Affiliation);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _AdminVerifiedModal = __webpack_require__(2146);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _YouTubeEmbed = __webpack_require__(2147);
	
	var _YouTubeEmbed2 = _interopRequireDefault(_YouTubeEmbed);
	
	var _AdminRoles = __webpack_require__(2148);
	
	__webpack_require__(2149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminNeedsOptInModal = function (_React$Component) {
	  _inherits(AdminNeedsOptInModal, _React$Component);
	
	  function AdminNeedsOptInModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AdminNeedsOptInModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminNeedsOptInModal.__proto__ || Object.getPrototypeOf(AdminNeedsOptInModal)).call.apply(_ref, [this].concat(args))), _this), _this.acceptAdminship = function () {
	      var aff = _this.props.affiliation;
	      (0, _OrgRoleActions.adminOptIn)(aff.organization_id, _this.props.orgName, aff);
	      // Need to allow the modal to be removed before transitioning
	      setTimeout(function () {
	        _this.context.router.push('/organizations/' + aff.organization_id);
	      }, 0);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AdminNeedsOptInModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _AlertDialog2.default,
	        {
	          eventScreenName: 'AdminNeedsOptInModal',
	          ref: 'dialog',
	          size: 'small',
	          className: 'AdminVerificationModal',
	          headerImageComponent: _react2.default.createElement(_AdminVerifiedModal.SchoolCrownBadge, null),
	          title: 'Introducing Remind for Schools',
	          subtext: 'Reach your school instantly with direct, reliable messaging. Get started and\n we\'ll notify the teachers who use Remind that ' + this.props.orgName + ' has a verified administrator.',
	          buttonText: 'Get Remind for Schools',
	          closeLinkText: 'Not right now',
	          onOkay: this.acceptAdminship,
	          onRequestHide: this.props.onRequestHide },
	        _react2.default.createElement(_YouTubeEmbed2.default, {
	          className: 'AdminVerificationModal-video',
	          width: 392,
	          height: 220,
	          src: _AdminRoles.VIDEO_URL
	        })
	      );
	    }
	  }]);
	
	  return AdminNeedsOptInModal;
	}(_react2.default.Component);
	
	AdminNeedsOptInModal.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	AdminNeedsOptInModal.displayName = 'AdminNeedsOptInModal';
	exports.default = AdminNeedsOptInModal;

/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SchoolCrownBadge = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _Coin = __webpack_require__(1671);
	
	var _Coin2 = _interopRequireDefault(_Coin);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupInviteModal = __webpack_require__(1435);
	
	var _GroupInviteModal2 = _interopRequireDefault(_GroupInviteModal);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _schoolCircle = __webpack_require__(1000);
	
	var _schoolCircle2 = _interopRequireDefault(_schoolCircle);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _YouTubeEmbed = __webpack_require__(2147);
	
	var _YouTubeEmbed2 = _interopRequireDefault(_YouTubeEmbed);
	
	var _modal = __webpack_require__(1188);
	
	var _AdminRoles = __webpack_require__(2148);
	
	__webpack_require__(2149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchoolCrownBadge = exports.SchoolCrownBadge = function SchoolCrownBadge() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'AdminVerificationModal-school-image' },
	    _react2.default.createElement(_Image2.default, { height: '64', width: '64', src: _schoolCircle2.default }),
	    _react2.default.createElement(
	      _Coin2.default,
	      { className: 'AdminVerificationModal-badge', color: 'midnight', size: 'xlarge' },
	      _react2.default.createElement(_Glyph2.default, { name: 'crown', color: 'white', size: 'xxsmall', solo: true })
	    )
	  );
	};
	
	var AdminVerifiedModal = function (_React$Component) {
	  _inherits(AdminVerifiedModal, _React$Component);
	
	  function AdminVerifiedModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AdminVerifiedModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminVerifiedModal.__proto__ || Object.getPrototypeOf(AdminVerifiedModal)).call.apply(_ref, [this].concat(args))), _this), _this.showInviteDialog = function () {
	      _this.props.onRequestHide();
	      if (_this.state.schoolClass) {
	        (0, _modal.mountModal)(_react2.default.createElement(_GroupInviteModal2.default, { group: _this.state.schoolClass }), _this);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AdminVerifiedModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _OrganizationActions2.default.getOrLoadOrganization(this.props.orgId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.org) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _AlertDialog2.default,
	        {
	          eventScreenName: 'AdminVerifiedModal',
	          ref: 'dialog',
	          size: 'small',
	          className: 'AdminVerificationModal',
	          hideCloseButton: true,
	          hideOnBlur: false,
	          headerImageComponent: _react2.default.createElement(SchoolCrownBadge, null),
	          title: 'Welcome to ' + this.state.org.getName() + ' on Remind!',
	          subtext: 'Watch the video to see what you can do as a verified administrator of your school.',
	          buttonText: 'Add teachers to your school',
	          onRequestHide: this.showInviteDialog },
	        _react2.default.createElement(_YouTubeEmbed2.default, {
	          className: 'AdminVerificationModal-video',
	          width: 392,
	          height: 220,
	          src: _AdminRoles.VIDEO_URL
	        })
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_GroupStore2.default, _OrganizationStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var org = _OrganizationStore2.default.getOrganization(props.orgId);
	      if (!org) {
	        return {};
	      }
	      var schoolClass = _GroupStore2.default.getStaffClassForOrg(org.id);
	      return { org: org, schoolClass: schoolClass };
	    }
	  }]);
	
	  return AdminVerifiedModal;
	}(_react2.default.Component);
	
	AdminVerifiedModal.displayName = 'AdminVerifiedModal';
	exports.default = _utils.Container.create(AdminVerifiedModal, {
	  withProps: true,
	  pure: false
	});

/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YouTubeEmbed = function (_React$Component) {
	  _inherits(YouTubeEmbed, _React$Component);
	
	  function YouTubeEmbed() {
	    _classCallCheck(this, YouTubeEmbed);
	
	    return _possibleConstructorReturn(this, (YouTubeEmbed.__proto__ || Object.getPrototypeOf(YouTubeEmbed)).apply(this, arguments));
	  }
	
	  _createClass(YouTubeEmbed, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          width = _props.width,
	          height = _props.height,
	          src = _props.src;
	
	      return _react2.default.createElement('iframe', {
	        className: className,
	        width: width,
	        height: height,
	        src: src + '?rel=0&wmode=transparent' // Fix for z-index in IE
	        , frameBorder: '0',
	        allowFullScreen: true
	      });
	    }
	  }]);
	
	  return YouTubeEmbed;
	}(_react2.default.Component);
	
	YouTubeEmbed.displayName = 'YouTubeEmbed';
	exports.default = YouTubeEmbed;

/***/ },
/* 2148 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var AdminRoles = exports.AdminRoles = {
	  superintendent: 'Superintendent',
	  principal: 'Principal',
	  vicePrincipal: 'Vice Principal',
	  techCoordinator: 'Technical Coordinator',
	  ITDirector: 'IT Director',
	  other: 'Other'
	};
	
	var AdminRoleOptions = exports.AdminRoleOptions = Object.keys(AdminRoles).map(function (key) {
	  return { label: AdminRoles[key], value: key };
	});
	
	var VIDEO_URL = exports.VIDEO_URL = 'https://www.youtube.com/embed/1V9ADCGhuo4';

/***/ },
/* 2149 */
1136,
/* 2150 */,
/* 2151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Affiliation = __webpack_require__(1039);
	
	var _Affiliation2 = _interopRequireDefault(_Affiliation);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _AdminVerifiedModal = __webpack_require__(2146);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _YouTubeEmbed = __webpack_require__(2147);
	
	var _YouTubeEmbed2 = _interopRequireDefault(_YouTubeEmbed);
	
	var _AdminRoles = __webpack_require__(2148);
	
	__webpack_require__(2149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminNeedsEmailConfModal = function (_React$Component) {
	  _inherits(AdminNeedsEmailConfModal, _React$Component);
	
	  function AdminNeedsEmailConfModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AdminNeedsEmailConfModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminNeedsEmailConfModal.__proto__ || Object.getPrototypeOf(AdminNeedsEmailConfModal)).call.apply(_ref, [this].concat(args))), _this), _this.resendConf = function () {
	      var email = (0, _Affiliation.getNeedsEmailConf)(_this.props.affiliation).official_email;
	      _DeviceActions2.default.resendConfirmationEmail(email).then(function () {
	        return _ToastActions2.default.showSuccessToast('Sent! Please check your email in a few minutes');
	      }, function (error) {
	        return _ToastActions2.default.showAPIError(error);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AdminNeedsEmailConfModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _AlertDialog2.default,
	        {
	          eventScreenName: 'AdminNeedsEmailConfModal',
	          ref: 'dialog',
	          size: 'small',
	          className: 'AdminVerificationModal',
	          headerImageComponent: _react2.default.createElement(_AdminVerifiedModal.SchoolCrownBadge, null),
	          title: 'Get the new Remind for Schools',
	          subtext: 'Confirm your email address to access features that support better communication at ' + this.props.orgName + '.',
	          buttonText: 'Resend confirmation email',
	          closeLinkText: 'Not right now',
	          onOkay: this.resendConf,
	          onRequestHide: this.props.onRequestHide },
	        _react2.default.createElement(_YouTubeEmbed2.default, {
	          className: 'AdminVerificationModal-video',
	          width: 392,
	          height: 220,
	          src: _AdminRoles.VIDEO_URL
	        })
	      );
	    }
	  }]);
	
	  return AdminNeedsEmailConfModal;
	}(_react2.default.Component);
	
	AdminNeedsEmailConfModal.displayName = 'AdminNeedsEmailConfModal';
	exports.default = AdminNeedsEmailConfModal;

/***/ },
/* 2152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _Coin = __webpack_require__(1671);
	
	var _Coin2 = _interopRequireDefault(_Coin);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _GroupCreateModal = __webpack_require__(1326);
	
	var _GroupCreateModal2 = _interopRequireDefault(_GroupCreateModal);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _schoolCircle = __webpack_require__(1000);
	
	var _schoolCircle2 = _interopRequireDefault(_schoolCircle);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(1188);
	
	var _getRedirectLocationAfterGroupCreation = __webpack_require__(2153);
	
	var _getRedirectLocationAfterGroupCreation2 = _interopRequireDefault(_getRedirectLocationAfterGroupCreation);
	
	__webpack_require__(2149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdminRejectedModal = _react2.default.createClass({
	  displayName: 'AdminRejectedModal',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_OrganizationStore2.default])],
	
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  componentWillMount: function componentWillMount() {
	    _OrganizationActions2.default.getOrLoadOrganization(this.props.orgId);
	  },
	  getStateFromStores: function getStateFromStores() {
	    var org = _OrganizationStore2.default.getOrganization(this.props.orgId);
	    return {
	      orgName: org ? org.getName() : null
	    };
	  },
	  handleGroupCreated: function handleGroupCreated(group) {
	    this.context.router.push((0, _getRedirectLocationAfterGroupCreation2.default)(group));
	  },
	  showCreateClassDialog: function showCreateClassDialog() {
	    (0, _modal.mountModal)(_react2.default.createElement(_GroupCreateModal2.default, { onCreate: this.handleGroupCreated }), this);
	  },
	  render: function render() {
	    if (!this.state.orgName) {
	      return false;
	    }
	
	    var badgedSchoolImage = _react2.default.createElement(
	      'div',
	      { className: 'AdminVerificationModal-school-image' },
	      _react2.default.createElement(_Image2.default, {
	        className: 'AdminVerificationModal-school-rejected',
	        height: '64', width: '64', src: _schoolCircle2.default
	      }),
	      _react2.default.createElement(
	        _Coin2.default,
	        { className: 'AdminVerificationModal-badge', size: 'xlarge', color: 'lava' },
	        _react2.default.createElement(_Glyph2.default, { name: 'close', color: 'white', size: 'xxsmall', solo: true })
	      ),
	      _react2.default.createElement('div', { className: 'AdminVerificationModal-badge-border' })
	    );
	
	    return _react2.default.createElement(_AlertDialog2.default, {
	      eventScreenName: 'AdminRejectedModal',
	      className: 'AdminVerificationModal',
	      headerImageComponent: badgedSchoolImage,
	      title: 'We couldn\'t verify you as an admin at ' + this.state.orgName,
	      subtext: 'You\'ll receive an email from us with more information.',
	      buttonText: 'Create a class',
	      onOkay: this.showCreateClassDialog,
	      onRequestHide: this.props.onRequestHide
	    });
	  }
	}); /*  weak */
	exports.default = AdminRejectedModal;

/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getRedirectLocationAfterGroupCreation;
	
	var _roleHelpers = __webpack_require__(1230);
	
	function getRedirectLocationAfterGroupCreation(group) {
	  return '/classes/' + group.getCode() + '/messages/announcements/' + _roleHelpers.EVERYONE + '?invite=true';
	} /*  weak */

/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.container = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _AppTopBar = __webpack_require__(2155);
	
	var _AppTopBar2 = _interopRequireDefault(_AppTopBar);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RootGroup = __webpack_require__(943);
	
	var _UnreadStore = __webpack_require__(1030);
	
	var _UnreadStore2 = _interopRequireDefault(_UnreadStore);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _recentMessagesModal = __webpack_require__(1570);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppTopBarContainer = function (_React$Component) {
	  _inherits(AppTopBarContainer, _React$Component);
	
	  function AppTopBarContainer() {
	    _classCallCheck(this, AppTopBarContainer);
	
	    return _possibleConstructorReturn(this, (AppTopBarContainer.__proto__ || Object.getPrototypeOf(AppTopBarContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppTopBarContainer, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          unreadCount = _state.unreadCount,
	          displayUnreadIcon = _state.displayUnreadIcon,
	          showRCE = _state.showRCE,
	          showZopim = _state.showZopim,
	          userName = _state.userName;
	
	
	      return _react2.default.createElement(_AppTopBar2.default, {
	        showRCE: showRCE,
	        showZopim: showZopim,
	        userName: userName,
	        unreadCount: unreadCount,
	        displayUnreadIcon: displayUnreadIcon,
	        showingRecent: this.props.showingRecent,
	        showRecent: this.props.showRecent,
	        hideRecent: this.props.hideRecent
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default, _UnreadStore2.default, _ChatStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var unreadCount = _UnreadStore2.default.getTotalUnread();
	      var user = _CurrentUser2.default.getUser();
	
	      return {
	        unreadCount: unreadCount,
	        showRCE: user.isRCE(),
	        showZopim: !user.isUnderage(),
	        userName: user.getFullName(),
	        displayUnreadIcon: _ChatStore2.default.getChats(_RootGroup.rootGroup).length > 0
	      };
	    }
	  }]);
	
	  return AppTopBarContainer;
	}(_react2.default.Component);
	
	AppTopBarContainer.displayName = 'AppTopBarContainer';
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    showingRecent: state.recentMessagesModal.showingRecent
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    showRecent: _recentMessagesModal.showRecent,
	    hideRecent: _recentMessagesModal.hideRecent
	  }, dispatch);
	};
	
	var container = exports.container = _utils.Container.create(AppTopBarContainer); // expose for testing
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(container);

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(2126);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _HeartShare = __webpack_require__(2156);
	
	var _HeartShare2 = _interopRequireDefault(_HeartShare);
	
	var _Hovercard = __webpack_require__(1548);
	
	var _Hovercard2 = _interopRequireDefault(_Hovercard);
	
	var _HovercardBody = __webpack_require__(1554);
	
	var _HovercardBody2 = _interopRequireDefault(_HovercardBody);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _UserNavigationMenu = __webpack_require__(2159);
	
	var _UserNavigationMenu2 = _interopRequireDefault(_UserNavigationMenu);
	
	var _RecentView = __webpack_require__(2182);
	
	var _RecentView2 = _interopRequireDefault(_RecentView);
	
	var _SupportDialog = __webpack_require__(2363);
	
	var _SupportDialog2 = _interopRequireDefault(_SupportDialog);
	
	var _ZopimLink = __webpack_require__(2381);
	
	var _ZopimLink2 = _interopRequireDefault(_ZopimLink);
	
	var _ZopimChevronBox = __webpack_require__(2382);
	
	var _ZopimChevronBox2 = _interopRequireDefault(_ZopimChevronBox);
	
	var _AdminConsoleAccess = __webpack_require__(2388);
	
	var _AdminConsoleAccess2 = _interopRequireDefault(_AdminConsoleAccess);
	
	var _AppTopBar = __webpack_require__(2389);
	
	var _AppTopBar2 = _interopRequireDefault(_AppTopBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NOTIFICATION_VISIBILITY_TIME = 6000;
	
	var AppTopBar = function (_React$Component) {
	  _inherits(AppTopBar, _React$Component);
	
	  function AppTopBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AppTopBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppTopBar.__proto__ || Object.getPrototypeOf(AppTopBar)).call.apply(_ref, [this].concat(args))), _this), _this.showUnreadNotification = false, _this.hideRecentView = function () {
	      _this.props.hideRecent();
	      if (_this.refs.recentView) {
	        _this.refs.recentView.hideLayer();
	      }
	    }, _this.showRecentView = function () {
	      _this.props.showRecent();
	      if (_this.refs.recentView) {
	        _this.refs.recentView.showLayer();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AppTopBar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.unreadCount > 0) {
	        this.showUnreadNotification = true;
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.unreadCount < nextProps.unreadCount) {
	        this.showUnreadNotification = true;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.showingRecent) {
	        this.showRecentView();
	      } else {
	        this.hideRecentView();
	      }
	    }
	  }, {
	    key: 'renderUnreadIcon',
	    value: function renderUnreadIcon(unreadCount) {
	      var _this2 = this;
	
	      var classBadgingEnabled = _CurrentUser2.default.inExpVariant('CLASS_BADGES');
	
	      var trigger = _react2.default.createElement(
	        _Link2.default,
	        { 'data-test-selector': 'recent-view-unread-icon', onClick: this.showRecentView },
	        _react2.default.createElement(_Glyph2.default, { name: 'clock', className: _AppTopBar2.default.unreadGlyph, solo: true }),
	        unreadCount > 0 && !classBadgingEnabled && _react2.default.createElement(
	          'div',
	          { className: _AppTopBar2.default.unreadCountContainer },
	          _react2.default.createElement(
	            'span',
	            { 'data-test-selector': 'unread-count', className: _AppTopBar2.default.unreadCount },
	            unreadCount
	          )
	        )
	      );
	
	      if (classBadgingEnabled) {
	        return trigger;
	      }
	
	      var notification = _react2.default.createElement(
	        _Hovercard2.default,
	        {
	          className: _AppTopBar2.default.unreadNotification,
	          hideOnEscape: false,
	          hideOnBlur: false },
	        _react2.default.createElement(
	          _reactAddonsCssTransitionGroup2.default,
	          {
	            transitionAppear: true,
	            transitionEnterTimeout: 1000,
	            transitionAppearTimeout: 1000,
	            transitionLeaveTimeout: 1000,
	            transitionName: _AppTopBar2.default },
	          _react2.default.createElement(
	            _HovercardBody2.default,
	            { onClick: this.showRecentView, className: _AppTopBar2.default.unreadNotificationBody },
	            unreadCount + ' unread message' + (unreadCount === 1 ? '' : 's')
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          ref: function ref(layer) {
	            if (layer && _this2.showUnreadNotification && unreadCount > 0) {
	              setTimeout(layer.showLayer, 0);
	              setTimeout(layer.hideLayer, NOTIFICATION_VISIBILITY_TIME);
	              _this2.showUnreadNotification = false;
	            }
	          },
	          layer: notification,
	          trigger: 'manual',
	          alignment: 'right',
	          placement: 'bottom' },
	        trigger
	      );
	    }
	  }, {
	    key: 'renderUnreadIndicator',
	    value: function renderUnreadIndicator() {
	      var unreadCount = this.props.unreadCount;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _AppTopBar2.default.unreadIndicator },
	        _react2.default.createElement(
	          _LayerTrigger2.default,
	          {
	            'data-test-selector': 'recent-view-trigger',
	            ref: 'recentView',
	            layer: _react2.default.createElement(_RecentView2.default, { hide: this.hideRecentView }),
	            trigger: 'manual' },
	          this.props.showingRecent ? _react2.default.createElement('div', null) : this.renderUnreadIcon(unreadCount)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: _AppTopBar2.default.this },
	        _react2.default.createElement(
	          'div',
	          { className: _AppTopBar2.default.left },
	          _react2.default.createElement(
	            _UserNavigationMenu2.default,
	            { showSettings: true, showGetTheApp: true, showLogout: true, showRCE: this.props.showRCE },
	            _react2.default.createElement(
	              _Link2.default,
	              { color: 'inherit', className: _AppTopBar2.default.userLink },
	              _react2.default.createElement(
	                _Text2.default,
	                { truncate: true, size: 'medium' },
	                this.props.userName
	              ),
	              _react2.default.createElement(_Glyph2.default, { name: 'chevron-down', size: 'xxsmall' })
	            )
	          ),
	          this.props.displayUnreadIcon && this.renderUnreadIndicator()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _AppTopBar2.default.actions },
	          _react2.default.createElement(
	            _AdminConsoleAccess2.default,
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              { className: _AppTopBar2.default.adminConsoleLink, to: '/admin', color: 'inherit', target: '_blank' },
	              _react2.default.createElement(
	                _Button2.default,
	                { size: 'xxsmall', level: 'secondary', color: 'pitch' },
	                'Go to Admin Console'
	              )
	            )
	          ),
	          this.props.showZopim && _react2.default.createElement(
	            _ZopimLink2.default,
	            null,
	            _react2.default.createElement(_ZopimChevronBox2.default, null)
	          ),
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { 'data-test-selector': 'support-dialog-trigger', modal: _react2.default.createElement(_SupportDialog2.default, null) },
	            _react2.default.createElement(
	              _Link2.default,
	              { eventElementName: 'Navigation-help', color: 'pitch' },
	              _react2.default.createElement(_Glyph2.default, { className: _AppTopBar2.default.help, name: 'help', size: 'large', solo: true })
	            )
	          ),
	          _react2.default.createElement(_HeartShare2.default, { className: _AppTopBar2.default.share, color: 'pitch', size: 'large' })
	        )
	      );
	    }
	  }]);
	
	  return AppTopBar;
	}(_react2.default.Component);
	
	AppTopBar.displayName = 'AppTopBar';
	exports.default = AppTopBar;

/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _LeadStore = __webpack_require__(1024);
	
	var _LeadStore2 = _interopRequireDefault(_LeadStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _InviteModal = __webpack_require__(1687);
	
	var _InviteModal2 = _interopRequireDefault(_InviteModal);
	
	var _getPropClasses = __webpack_require__(1135);
	
	__webpack_require__(2157);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeartShare = function (_React$Component) {
	  _inherits(HeartShare, _React$Component);
	
	  function HeartShare() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HeartShare);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeartShare.__proto__ || Object.getPrototypeOf(HeartShare)).call.apply(_ref, [this].concat(args))), _this), _this.dismissHeartBadge = function () {
	      _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.TYMK_MODAL);
	      _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.TYMK_BADGE);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(HeartShare, [{
	    key: 'renderIcon',
	    value: function renderIcon() {
	      var showingBadgingHeart = this.state.showingBadgingHeart;
	
	      var className = (0, _classnames2.default)({
	        'HeartShare-badging': showingBadgingHeart
	      }, 'HeartShare', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className);
	
	      if (showingBadgingHeart) {
	        return _react2.default.createElement('div', { className: className });
	      } else {
	        return _react2.default.createElement(_Glyph2.default, {
	          className: className,
	          name: 'heart',
	          size: this.props.size,
	          solo: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { 'data-test-selector': 'share-remind-trigger', modal: _react2.default.createElement(_InviteModal2.default, null) },
	        _react2.default.createElement(
	          _Link2.default,
	          { eventElementName: 'Navigation-share', color: this.props.color, onClick: this.dismissHeartBadge },
	          this.renderIcon()
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_PromptStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        showingBadgingHeart: this.shouldBadgeHeart()
	      };
	    }
	  }, {
	    key: 'shouldBadgeHeart',
	    value: function shouldBadgeHeart() {
	      return !_LeadStore2.default.getLeads().isEmpty() && _CurrentUser2.default.isSignedIn() && _CurrentUser2.default.getUser().hasItemInPromptsInventory(_PromptConstants.PromptNames.TYMK_BADGE) && !_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.TYMK_BADGE);
	    }
	  }]);
	
	  return HeartShare;
	}(_react2.default.Component);
	
	HeartShare.propClasses = {
	  size: {
	    large: 'HeartShare-large',
	    xlarge: 'HeartShare-xlarge'
	  },
	  color: {
	    thunder: 'HeartShare-thunder',
	    pitch: 'HeartShare-pitch'
	  }
	};
	HeartShare.defaultProps = {
	  size: 'large',
	  color: 'pitch'
	};
	HeartShare.displayName = 'HeartShare';
	exports.default = _utils.Container.create(HeartShare, { withProps: true, pure: false });

/***/ },
/* 2157 */
1136,
/* 2158 */,
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _reactIntl = __webpack_require__(1058);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _NavigationMenu = __webpack_require__(2160);
	
	var _NavigationMenu2 = _interopRequireDefault(_NavigationMenu);
	
	var _TextAppLinkDialog = __webpack_require__(2163);
	
	var _TextAppLinkDialog2 = _interopRequireDefault(_TextAppLinkDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var UserNavigationMenu = function (_React$Component) {
	  _inherits(UserNavigationMenu, _React$Component);
	
	  function UserNavigationMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserNavigationMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserNavigationMenu.__proto__ || Object.getPrototypeOf(UserNavigationMenu)).call.apply(_ref, [this].concat(args))), _this), _this.signOut = function () {
	      _AuthActions2.default.signOut();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserNavigationMenu, [{
	    key: 'renderMenu',
	    value: function renderMenu() {
	      var _props = this.props,
	          showRCE = _props.showRCE,
	          showSettings = _props.showSettings,
	          showGetTheApp = _props.showGetTheApp,
	          showLogout = _props.showLogout;
	
	
	      return _react2.default.createElement(
	        _NavigationMenu2.default,
	        null,
	        showSettings && _react2.default.createElement(
	          _Link2.default,
	          { to: '/settings', eventElementName: 'Navigation-account', color: 'thunder' },
	          _react2.default.createElement(_Glyph2.default, { name: 'avatar', size: 'large' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'navigation.settings',
	            defaultMessage: 'Account'
	          })
	        ),
	        showGetTheApp && _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: _react2.default.createElement(_TextAppLinkDialog2.default, null) },
	          _react2.default.createElement(
	            _Link2.default,
	            { eventElementName: 'Navigation-getTheApp', color: 'thunder' },
	            _react2.default.createElement(_Glyph2.default, { name: 'mobile', size: 'large' }),
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'navigation.getTheApp',
	              defaultMessage: 'Get the Remind app'
	            })
	          )
	        ),
	        showRCE && _react2.default.createElement(
	          _Link2.default,
	          {
	            href: _LinkConstants2.default.RCE,
	            target: '_blank',
	            eventElementName: 'Navigation-rce',
	            color: 'thunder' },
	          _react2.default.createElement(_Glyph2.default, { name: 'apple', size: 'large' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'navigation.rce',
	            defaultMessage: 'Connected Educator'
	          })
	        ),
	        showLogout && _react2.default.createElement(
	          _Link2.default,
	          { onClick: this.signOut, eventElementName: 'Navigation-logOut', color: 'thunder' },
	          _react2.default.createElement(_Glyph2.default, { name: 'sign-out', size: 'large' }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'navigation.logout',
	            defaultMessage: 'Log out'
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        { layer: this.renderMenu(), trigger: 'click', placement: 'bottom' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return UserNavigationMenu;
	}(_react2.default.Component);
	
	UserNavigationMenu.displayName = 'UserNavigationMenu';
	exports.default = UserNavigationMenu;

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Hovercard = __webpack_require__(1548);
	
	var _Hovercard2 = _interopRequireDefault(_Hovercard);
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _NavigationMenu = __webpack_require__(2161);
	
	var _NavigationMenu2 = _interopRequireDefault(_NavigationMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavigationMenu = function (_React$Component) {
	  _inherits(NavigationMenu, _React$Component);
	
	  function NavigationMenu() {
	    _classCallCheck(this, NavigationMenu);
	
	    return _possibleConstructorReturn(this, (NavigationMenu.__proto__ || Object.getPrototypeOf(NavigationMenu)).apply(this, arguments));
	  }
	
	  _createClass(NavigationMenu, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Hovercard2.default,
	        _extends({}, this.props, { className: (0, _classnames2.default)(_NavigationMenu2.default.this, this.props.className) }),
	        _react2.default.createElement(
	          _List2.default,
	          null,
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return NavigationMenu;
	}(_react2.default.Component);
	
	NavigationMenu.displayName = 'NavigationMenu';
	exports.default = NavigationMenu;

/***/ },
/* 2161 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spacing-medium":"8px","spacing-large":"16px","this":"NavigationMenu__this___2_j66"};

/***/ },
/* 2162 */,
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextAppLink = __webpack_require__(2164);
	
	var _TextAppLink2 = _interopRequireDefault(_TextAppLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    _classCallCheck(this, _class);
	
	    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	  }
	
	  _createClass(_class, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        { eventScreenName: 'TextAppLinkDialog', className: 'TextAppLinkDialog', size: 'large', onRequestHide: this.props.onRequestHide },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(_TextAppLink2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	_class.displayName = '_class';
	exports.default = _class;

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TextAppLinkForm = __webpack_require__(2168);
	
	var _TextAppLinkForm2 = _interopRequireDefault(_TextAppLinkForm);
	
	__webpack_require__(2178);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    _classCallCheck(this, _class);
	
	    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	  }
	
	  _createClass(_class, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'TextAppLink' },
	        _react2.default.createElement(
	          _Columns2.default,
	          { reset: 'tablet', flex: true },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'TextAppLink-title' },
	              'Get the Remind app'
	            ),
	            _react2.default.createElement(
	              _Text2.default,
	              { color: 'thunder', element: 'p', size: 'small' },
	              'Send and receive messages instantly on your phone.'
	            ),
	            _react2.default.createElement(_TextAppLinkForm2.default, null)
	          ),
	          _react2.default.createElement(_Image2.default, {
	            src: __webpack_require__(2180),
	            srcSet: __webpack_require__(2181) + ' 2x',
	            alt: 'Remind mobile apps'
	          })
	        )
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	_class.displayName = '_class';
	exports.default = _class;

/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var Columns2 = function (_React$Component) {
	  _inherits(Columns2, _React$Component);
	
	  function Columns2() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Columns2);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Columns2.__proto__ || Object.getPrototypeOf(Columns2)).call.apply(_ref, [this].concat(args))), _this), _this.wrap = function (node) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Columns2-column Columns2-column1-2' },
	        node
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Columns2, [{
	    key: 'render',
	    value: function render() {
	      var children = _react2.default.Children.map(this.props.children, function (child, index) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'Columns2-column Columns2-column1-2', key: index },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('Columns2', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        children
	      );
	    }
	  }]);
	
	  return Columns2;
	}(_react2.default.Component);
	
	Columns2.propClasses = {
	  direction: {
	    left: 'Columns2--rev'
	  },
	  gutter: {
	    xlarge: 'Columns2--xloose',
	    small: 'Columns2--tight',
	    xsmall: 'Columns2--xtight',
	    xxsmall: 'Columns2--xxtight'
	  },
	  reset: {
	    tablet: 'Columns2--reset--tablet'
	  },
	  flex: 'Columns2--flex'
	};
	Columns2.defaultProps = {
	  direction: 'right',
	  gutter: 'medium'
	};
	Columns2.displayName = 'Columns2';
	exports.default = Columns2;

/***/ },
/* 2166 */
1136,
/* 2167 */,
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AppLinkActions = __webpack_require__(2169);
	
	var _AppLinkActions2 = _interopRequireDefault(_AppLinkActions);
	
	var _AppDownloadImageLinks = __webpack_require__(2170);
	
	var _AppDownloadImageLinks2 = _interopRequireDefault(_AppDownloadImageLinks);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _FormSingle = __webpack_require__(1716);
	
	var _FormSingle2 = _interopRequireDefault(_FormSingle);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(2176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, _class);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      error: '',
	      phoneNumber: '',
	      submitting: false,
	      valid: false
	    }, _this.handlePhoneNumberChange = function (event) {
	      _this.setState({
	        error: '',
	        // $FlowFixMe
	        phoneNumber: event.target.value,
	        // $FlowFixMe
	        valid: event.target.checkValidity()
	      });
	    }, _this.handlePhoneNumberBlur = function (event) {
	      // $FlowFixMe
	      if (event.target.value !== '') {
	        // $FlowFixMe
	        var valid = event.target.checkValidity();
	
	        _this.setState({ valid: valid });
	
	        if (!valid) {
	          _this.setState({ error: 'Invalid phone number' });
	        }
	      }
	    }, _this.onSubmit = function (event) {
	      event.preventDefault();
	
	      var onSuccess = function onSuccess() {
	        _ToastActions2.default.showSuccessToast('Download link sent to ' + _this.state.phoneNumber);
	        _this.setState({
	          phoneNumber: '',
	          submitting: false,
	          valid: false
	        });
	      };
	
	      var onError = function onError() {
	        _ToastActions2.default.showErrorToast('Download link not sent. Please try again later.');
	        _this.setState({ submitting: false });
	      };
	
	      _this.setState({ submitting: true });
	
	      _AppLinkActions2.default.sendLink(_this.state.phoneNumber).then(onSuccess, onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(_class, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'TextAppLinkForm' },
	        _react2.default.createElement(
	          'form',
	          { className: 'TextAppLinkForm-form', onSubmit: this.onSubmit },
	          _react2.default.createElement(
	            _Field2.default,
	            { error: this.state.error },
	            _react2.default.createElement(
	              _Label2.default,
	              { hidden: true },
	              'Phone number'
	            ),
	            _react2.default.createElement(
	              _FormSingle2.default,
	              { reset: 'mobile' },
	              _react2.default.createElement(_Input2.default, {
	                type: 'tel',
	                pattern: '\\+?1?[- .]?\\(?\\d{3}\\)?[- .]?\\d{3}[- .]?\\d{4}',
	                placeholder: '(555) 555-5555',
	                value: this.state.phoneNumber,
	                onBlur: this.handlePhoneNumberBlur,
	                onChange: this.handlePhoneNumberChange,
	                autoFocus: true,
	                required: true
	              }),
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  type: 'submit',
	                  level: 'primary',
	                  size: 'small',
	                  disabled: !this.state.valid || this.state.submitting },
	                'Text me a link'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_AppDownloadImageLinks2.default, { align: 'left', className: 'TextAppLinkForm-appStores' })
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	_class.displayName = '_class';
	exports.default = _class;

/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppLinkActions = {
	  sendLink: function sendLink(phoneNumber) {
	    return (0, _apiRequest2.default)('/devices/sms/send_app_link', 'POST', {
	      endpoint: phoneNumber
	    });
	  }
	};
	exports.default = AppLinkActions;

/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _getGooglePlayLink = __webpack_require__(2171);
	
	var _getGooglePlayLink2 = _interopRequireDefault(_getGooglePlayLink);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserAgent = __webpack_require__(1161);
	
	var _UserAgent2 = _interopRequireDefault(_UserAgent);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppDownloadImageLinks = function (_React$Component) {
	  _inherits(AppDownloadImageLinks, _React$Component);
	
	  function AppDownloadImageLinks() {
	    _classCallCheck(this, AppDownloadImageLinks);
	
	    return _possibleConstructorReturn(this, (AppDownloadImageLinks.__proto__ || Object.getPrototypeOf(AppDownloadImageLinks)).apply(this, arguments));
	  }
	
	  _createClass(AppDownloadImageLinks, [{
	    key: 'renderLinks',
	    value: function renderLinks() {
	      var iosDownloadLink = _react2.default.createElement(
	        _Link2.default,
	        {
	          href: _LinkConstants2.default.APP_STORE,
	          target: '_blank',
	          className: 'AppDownloadImageLinks-item',
	          eventElementName: 'AppDownloadImageLinks-item' },
	        _react2.default.createElement(_Image2.default, {
	          src: __webpack_require__(2174),
	          alt: 'Download on the App Store',
	          className: 'AppDownloadImageLinks-item-img'
	        })
	      );
	
	      // TODO(turadg) make this (or something like it) always available at the root app context
	      var provided = this.context.provided || {};
	      var authToken = provided.cookies ? provided.cookies['auth_token'] || null : undefined;
	
	      var androidDownloadLink = _react2.default.createElement(
	        _Link2.default,
	        {
	          href: (0, _getGooglePlayLink2.default)(authToken),
	          target: '_blank',
	          className: 'AppDownloadImageLinks-item',
	          eventElementName: 'AppDownloadImageLinks-item' },
	        _react2.default.createElement(_Image2.default, {
	          src: __webpack_require__(2175),
	          alt: 'Get it on Google Play',
	          className: 'AppDownloadImageLinks-item-img'
	        })
	      );
	
	      var userAgent = new _UserAgent2.default(provided.userAgentStr || window.navigator.userAgent);
	
	      if (userAgent.ios()) {
	        return iosDownloadLink;
	      }
	      if (userAgent.android()) {
	        return androidDownloadLink;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'AppDownloadImageLinks-links' },
	        iosDownloadLink,
	        androidDownloadLink
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('AppDownloadImageLinks', {
	            'AppDownloadImageLinks--left': this.props.align === 'left'
	          }, this.props.className),
	          size: 'small' },
	        this.props.showText && _react2.default.createElement(
	          'h3',
	          { className: 'AppDownloadImageLinks-title' },
	          'Download the app'
	        ),
	        this.renderLinks()
	      );
	    }
	  }]);
	
	  return AppDownloadImageLinks;
	}(_react2.default.Component);
	
	AppDownloadImageLinks.contextTypes = {
	  provided: _react2.default.PropTypes.object
	};
	AppDownloadImageLinks.defaultProps = {
	  align: 'center'
	};
	AppDownloadImageLinks.displayName = 'AppDownloadImageLinks';
	exports.default = AppDownloadImageLinks;

/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGooglePlayShortLink = getGooglePlayShortLink;
	exports.default = getGooglePlayLink;
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getGooglePlayShortLink() {
	  var authToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _AuthActions2.default.getAuthTokenFromCookies();
	
	  var url = _LinkConstants2.default.APP_DOWNLOAD;
	
	  if (authToken) {
	    url += _LinkConstants2.default.GOOGLE_PLAY_SHORT_LINK_REFERRER_AUTOLOGIN_PARAM + authToken;
	  }
	
	  return url;
	}
	
	function getGooglePlayLink() {
	  var authToken = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _AuthActions2.default.getAuthTokenFromCookies();
	
	  var url = _LinkConstants2.default.GOOGLE_PLAY;
	
	  if (authToken) {
	    // Google Play Store forces the url to be terrible and follow a format
	    // where only half the query string is encoded. Since everything except
	    // for the authToken is constant for this url, we append the auth
	    // token at the end via. string concatenation.
	    url += _LinkConstants2.default.GOOGLE_PLAY_AUTOLOGIN_PARAM + authToken;
	  }
	
	  return url;
	}

/***/ },
/* 2172 */
1136,
/* 2173 */,
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "baa72870d73744ebc1541ae8da10814d.svg";

/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d13dbdcd42a10ec2f76aff10d3554bc9.svg";

/***/ },
/* 2176 */
1136,
/* 2177 */,
/* 2178 */
1136,
/* 2179 */,
/* 2180 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "70afdbefaf8d768e9371b60b243667e4.png";

/***/ },
/* 2181 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "901daeaa8c640f4cc2dbadec0c2362a7.png";

/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(2126);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _RecentMessages = __webpack_require__(2183);
	
	var _RecentMessages2 = _interopRequireDefault(_RecentMessages);
	
	var _RecentView = __webpack_require__(2361);
	
	var _RecentView2 = _interopRequireDefault(_RecentView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecentView = function (_React$Component) {
	  _inherits(RecentView, _React$Component);
	
	  function RecentView() {
	    _classCallCheck(this, RecentView);
	
	    return _possibleConstructorReturn(this, (RecentView.__proto__ || Object.getPrototypeOf(RecentView)).apply(this, arguments));
	  }
	
	  _createClass(RecentView, [{
	    key: 'render',
	    value: function render() {
	      var hide = this.props.hide;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('div', { className: _RecentView2.default.recentViewMask, onClick: hide }),
	        _react2.default.createElement(
	          _Link2.default,
	          { className: _RecentView2.default.closeRecent, onClick: hide },
	          _react2.default.createElement(_Glyph2.default, { name: 'close-btn' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _RecentView2.default.recentView },
	          _react2.default.createElement(
	            _reactAddonsCssTransitionGroup2.default,
	            {
	              className: _RecentView2.default.recentViewInner,
	              transitionAppear: true,
	              transitionEnterTimeout: 1000,
	              transitionAppearTimeout: 1000,
	              transitionLeaveTimeout: 1000,
	              transitionName: _RecentView2.default },
	            _react2.default.createElement(_RecentMessages2.default, { key: 'recent' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return RecentView;
	}(_react2.default.Component);
	
	RecentView.displayName = 'RecentView';
	exports.default = RecentView;

/***/ },
/* 2183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _ChatList = __webpack_require__(2184);
	
	var _ChatList2 = _interopRequireDefault(_ChatList);
	
	var _ConversationView = __webpack_require__(2228);
	
	var _ConversationView2 = _interopRequireDefault(_ConversationView);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _View = __webpack_require__(2356);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _RootGroup = __webpack_require__(943);
	
	var _RecentMessages = __webpack_require__(2359);
	
	var _RecentMessages2 = _interopRequireDefault(_RecentMessages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecentMessages = function (_React$Component) {
	  _inherits(RecentMessages, _React$Component);
	
	  function RecentMessages() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RecentMessages);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RecentMessages.__proto__ || Object.getPrototypeOf(RecentMessages)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedChat: RecentMessages.getSelectedChat()
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RecentMessages, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        chatSelectionAction: 'store',
	        group: _RootGroup.rootGroup
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.selectedChat) {
	        return _react2.default.createElement(_LoadingIndicator2.default, null);
	      }
	
	      var chatId = this.state.selectedChat.id;
	      return _react2.default.createElement(
	        _View2.default,
	        {
	          full: true,
	          'data-test-selector': 'recent-chatlist',
	          className: _RecentMessages2.default.this },
	        _react2.default.createElement(_ChatList2.default, {
	          className: _RecentMessages2.default.sidebar,
	          selectedChatId: chatId,
	          group: _RootGroup.rootGroup,
	          unifiedView: true,
	          headerText: 'Recent'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _RecentMessages2.default.wrap },
	          _react2.default.createElement(
	            'div',
	            { className: _RecentMessages2.default.content },
	            _react2.default.createElement(_ConversationView2.default, { params: { chatId: chatId } })
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getSelectedChat',
	    value: function getSelectedChat() {
	      return _ChatStore2.default.getCurrentChat() || _ChatStore2.default.getChats(_RootGroup.rootGroup).first();
	    }
	  }, {
	    key: 'getStores',
	    value: function getStores() {
	      return [_ChatStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        selectedChat: RecentMessages.getSelectedChat()
	      };
	    }
	  }]);
	
	  return RecentMessages;
	}(_react2.default.Component);
	
	RecentMessages.childContextTypes = {
	  chatSelectionAction: _react2.default.PropTypes.string,
	  group: _react2.default.PropTypes.instanceOf(_Group2.default)
	};
	RecentMessages.displayName = 'RecentMessages';
	exports.default = _utils.Container.create(RecentMessages);

/***/ },
/* 2184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChatList = undefined;
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _modal = __webpack_require__(1188);
	
	var _ChatRouteHelper = __webpack_require__(1568);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _recentMessagesModal = __webpack_require__(1570);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _AnnouncementThreadListItem = __webpack_require__(2185);
	
	var _AnnouncementThreadListItem2 = _interopRequireDefault(_AnnouncementThreadListItem);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _ChatConstants2 = _interopRequireDefault(_ChatConstants);
	
	var _ChatListActivitiesContainer = __webpack_require__(2188);
	
	var _ChatListActivitiesContainer2 = _interopRequireDefault(_ChatListActivitiesContainer);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _Chats = __webpack_require__(942);
	
	var _Chats2 = _interopRequireDefault(_Chats);
	
	var _ChatSearchBlock = __webpack_require__(2197);
	
	var _ChatSearchBlock2 = _interopRequireDefault(_ChatSearchBlock);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ChatSearch = __webpack_require__(2200);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _PotentialChatMembers = __webpack_require__(946);
	
	var _PotentialChatMembers2 = _interopRequireDefault(_PotentialChatMembers);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _QuickActionsBarContainer = __webpack_require__(2201);
	
	var _QuickActionsBarContainer2 = _interopRequireDefault(_QuickActionsBarContainer);
	
	var _ScrollContainer = __webpack_require__(2210);
	
	var _ScrollContainer2 = _interopRequireDefault(_ScrollContainer);
	
	var _ScrollWatch = __webpack_require__(1238);
	
	var _ScrollWatch2 = _interopRequireDefault(_ScrollWatch);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _UniversalComposeButtonContainer = __webpack_require__(1723);
	
	var _UniversalComposeButtonContainer2 = _interopRequireDefault(_UniversalComposeButtonContainer);
	
	var _UnreadStore = __webpack_require__(1030);
	
	var _UnreadStore2 = _interopRequireDefault(_UnreadStore);
	
	var _isElementInViewport = __webpack_require__(2213);
	
	var _isElementInViewport2 = _interopRequireDefault(_isElementInViewport);
	
	var _RootGroup = __webpack_require__(943);
	
	var _ChatListItem = __webpack_require__(2214);
	
	var _ChatListItem2 = _interopRequireDefault(_ChatListItem);
	
	var _ChatListSearchItem = __webpack_require__(2223);
	
	var _ChatListSearchItem2 = _interopRequireDefault(_ChatListSearchItem);
	
	var _roleHelpers = __webpack_require__(1230);
	
	__webpack_require__(2226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RECENT_SECTION_SIZE = 3;
	// typecheck: ignore file
	var ChatList = exports.ChatList = _react2.default.createClass({
	  displayName: 'ChatList',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired,
	    chatSelectionAction: _react2.default.PropTypes.string
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_ChatStore2.default, _UnreadStore2.default, _ActivityStore2.default, _PromptStore2.default])],
	
	  statics: {
	    loadData: function loadData() {
	      _ChatActions2.default.loadPotentialChatMembers();
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    var canSubscribersInitiateChats = this.state ? this.state.canSubscribersInitiateChats : false;
	    if (!canSubscribersInitiateChats) {
	      var groups = _GroupStore2.default.getOwnedGroups();
	      canSubscribersInitiateChats = groups.some(function (group) {
	        return group.canSubscribersInitiateChats();
	      });
	    }
	
	    var group = this.props.group;
	
	    var chats = _ChatStore2.default.getChats(group);
	    var chatsAndSearchedChats = _ChatStore2.default.getChatsAndSearchedChats(group);
	    var allChatsLoadedForGroup = _ChatStore2.default.areAllChatsLoadedForGroup(group);
	
	    // todo rm this filter when we feel confident that all activity have a group chat.
	    var hasUpcomingActivities = _ActivityStore2.default.getUpcomingActivityForGroup(group).filter(function (activity) {
	      return !!activity.getChatUuid();
	    }).length > 0;
	
	    var showQuickActions = _CurrentUser2.default.inExpVariant('QUICK_ACTIONS', 'quick_actions');
	
	    return {
	      allChatsLoaded: allChatsLoadedForGroup,
	      canSubscribersInitiateChats: canSubscribersInitiateChats,
	      chats: chats,
	      chatsAndSearchedChats: chatsAndSearchedChats,
	      conversationResults: chats,
	      hasUpcomingActivities: hasUpcomingActivities,
	      lastMessage: null,
	      peopleResults: _ChatStore2.default.getMembers(group),
	      potentialRecipients: _ChatStore2.default.getMembers(_RootGroup.rootGroup),
	      query: '',
	      tooltip: false,
	      updating: false,
	      showQuickActions: showQuickActions
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    ChatList.loadData();
	
	    // can't be defined in main property list because `this` is missing
	    this.handleQueryChange = _lodash2.default.debounce(this.performSearch, _ChatConstants2.default.SEARCH_UI_LIMIT_MS,
	    // lead so user gets immediate feedback when they start typing
	    { leading: true, trailing: true });
	  },
	
	
	  // $FlowFixMe
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    var group = nextProps.group;
	
	    if (group !== this.props.group) {
	      this._searchBlock.handleClose();
	      var _chats = _ChatStore2.default.getChats(group);
	      var _chatsAndSearchedChats = _ChatStore2.default.getChatsAndSearchedChats(group);
	      var allChatsLoadedForGroup = _ChatStore2.default.areAllChatsLoadedForGroup(group);
	      var _hasUpcomingActivities = _ActivityStore2.default.getUpcomingActivityForGroup(group).filter(function (activity) {
	        return !!activity.getChatUuid();
	      }).length > 0;
	
	      this.setState({
	        chats: _chats,
	        conversationResults: _chats,
	        chatsAndSearchedChats: _chatsAndSearchedChats,
	        allChatsLoaded: allChatsLoadedForGroup,
	        hasUpcomingActivities: _hasUpcomingActivities,
	        potentialRecipients: _ChatStore2.default.getMembers(_RootGroup.rootGroup)
	      });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (this.state.query) {
	      return;
	    }
	
	    var prevLastMessage = prevState.lastMessage;
	    var lastMessage = this.state.lastMessage;
	
	    // Scroll to the top when you send a chat message so that the current
	    // thread is displayed at the top of the chat list
	
	    if (prevLastMessage && lastMessage && prevLastMessage !== lastMessage && prevLastMessage.getChatId() !== lastMessage.getChatId() && lastMessage.getSender().id === _CurrentUser2.default.getUser().id) {
	      this.scrollToTop();
	    }
	
	    this.loadMoreIfLoadingVisible();
	  },
	
	
	  // TODO move to an open-source scroll loader component.
	  // spike in https://github.com/remind101/r101-frontend/pull/4140
	  loadMoreIfLoadingVisible: function loadMoreIfLoadingVisible() {
	    if (this._loadingIndicator) {
	      var el = _reactDom2.default.findDOMNode(this._loadingIndicator);
	      if ((0, _isElementInViewport2.default)(el)) {
	        this.loadMoreChats();
	      }
	    }
	  },
	  getConversationResults: function getConversationResults(query) {
	    if (!query) {
	      return this.state.chats;
	    }
	
	    var f = (0, _ChatSearch.makeConversationFilter)(query);
	
	    var matchingChats = this.state.chatsAndSearchedChats.filter(f);
	
	    return new _Chats2.default(matchingChats);
	  },
	  getPeopleResults: function getPeopleResults() {
	    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    var f = (0, _ChatSearch.makePeopleFilter)(query);
	
	    return this.state.potentialRecipients.filter(f);
	  },
	  getStateFromStores: function getStateFromStores() {
	    var group = this.props.group;
	
	    var chats = _ChatStore2.default.getChats(group);
	    return {
	      chats: chats,
	      chat: _ChatStore2.default.getLocal(),
	      newChatAvailable: chats.first() && !chats.first().getTitle(),
	      lastMessage: chats.getLastMessage(),
	      allChatsLoaded: _ChatStore2.default.areAllChatsLoaded(),
	      conversationResults: this.state.query ? this.getConversationResults(this.state.query) : chats,
	      potentialRecipients: _ChatStore2.default.getMembers(_RootGroup.rootGroup),
	      peopleResults: this.getPeopleResults(this.state.query)
	    };
	  },
	
	
	  // Satisfy Flow
	  handleQueryChange: function handleQueryChange() {
	    return null;
	  },
	  _searchBlock: { handleClose: function handleClose() {} },
	
	  // Fired upon clicking a chat thread
	  handleChatClick: function handleChatClick() {
	    _ChatActions2.default.setFocusView(_ChatConstants2.default.FocusableViews.COMPOSER);
	
	    var leavingLocalChat = this.state.chats.first().isNew();
	    if (leavingLocalChat) {
	      _ChatActions2.default.destroyLocal();
	    }
	  },
	  clearSearchQuery: function clearSearchQuery() {
	    this.performSearch('');
	  },
	
	
	  // $FlowFixMe
	  handlePersonSelection: function handlePersonSelection(member) {
	    if (!member.isEligible()) {
	      this.memberNotEligible(member);
	      return;
	    }
	
	    (0, _ChatRouteHelper.pushRouterToChatWithMember)(this.context.router, this.props.showRecent, this.props.hideRecent, member, this.props.group, function () {
	      _ChatActions2.default.setFocusView(_ChatConstants2.default.FocusableViews.HEADER);
	    });
	    // Clear query after selection
	    this.clearSearchQuery();
	    this._searchBlock.handleClose();
	  },
	
	
	  // $FlowFixMe
	  memberNotEligible: function memberNotEligible(member) {
	    var modal = void 0;
	    if (member.isAgeUnknown() || member.isPending()) {
	      if (member.isAgeUnknown()) {
	        _ChatActions2.default.requestMemberAge(member);
	      }
	
	      modal = _react2.default.createElement(_AlertDialog2.default, {
	        eventScreenName: 'ChatList',
	        title: 'We need to collect more information from the participant',
	        subtext: 'We\'ll notify you as soon as they\'re available for two-way messaging.'
	      });
	    } else if (member.isUnder13()) {
	      modal = _react2.default.createElement(_AlertDialog2.default, {
	        title: 'Two-way messaging is only available for students 13 and older.',
	        subtext: 'Don\'t worry\u2014they can still receive announcements.'
	      });
	    } else if (member.isUnavailable()) {
	      modal = _react2.default.createElement(_AlertDialog2.default, {
	        title: 'Sorry! ' + member.getName() + ' isn\'t accepting messages on Remind.'
	      });
	    }
	
	    if (modal) {
	      (0, _modal.mountModal)(modal, this);
	    }
	  },
	  performSearch: function performSearch() {
	    var _this = this;
	
	    var rawQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    var query = rawQuery.trim();
	
	    this.setState({
	      query: query,
	      conversationResults: this.getConversationResults(query),
	      peopleResults: this.getPeopleResults(query)
	    }, function () {
	      // TODO cache search queries for some amount of time
	      // https://app.asana.com/0/42965143452863/116236888105435
	      if (query.length > 0) {
	        _ChatActions2.default.loadPotentialChatMembers(_this.state.query);
	        _ChatActions2.default.searchChats(_this.state.query);
	      }
	    });
	  },
	  scrollToTop: function scrollToTop() {
	    this.refs.scrollArea.scrollToTop();
	  },
	  renderConversations: function renderConversations(chats) {
	    var _this2 = this;
	
	    return chats.map(function (chat) {
	      return _this2.props.hideLocalChat && chat.isNew() ? null : _this2.renderConversationResult(chat);
	    });
	  },
	  renderConversationResult: function renderConversationResult(chat) {
	    var _props = this.props,
	        selectedChatId = _props.selectedChatId,
	        group = _props.group;
	
	
	    return _react2.default.createElement(_ChatListItem2.default, {
	      key: chat.id || 'new',
	      chatUuid: chat.id,
	      selected: chat.id === selectedChatId,
	      group: group,
	      query: this.state.query,
	      onClick: this.handleChatClick
	    });
	  },
	  loadMoreChats: function loadMoreChats() {
	    _ChatActions2.default.loadMoreChats(this.props.group);
	  },
	
	
	  _loadingIndicator: null,
	
	  renderBody: function renderBody() {
	    var _this3 = this;
	
	    var loadingIndicator = null;
	    var group = this.props.group;
	    var _state = this.state,
	        conversationResults = _state.conversationResults,
	        chats = _state.chats,
	        peopleResults = _state.peopleResults;
	
	    var hasChats = conversationResults.length > 0;
	    var hasPeople = peopleResults.length > 0;
	    var hasResults = hasChats || hasPeople;
	    var canSendAnnouncements = !!group.getPostableRoles().length;
	
	    var allChatsLoaded = _ChatStore2.default.areAllChatsLoadedForGroup(group);
	
	    if (!this.state.query && !allChatsLoaded) {
	      loadingIndicator = _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _ScrollWatch2.default,
	          { onEnter: this.loadMoreChats, threshold: 0.2 },
	          _react2.default.createElement(
	            'div',
	            { className: 'ChatList-loading' },
	            _react2.default.createElement(_LoadingIndicator2.default, { size: 'small', ref: function ref(r) {
	                _this3._loadingIndicator = r;
	              } })
	          )
	        )
	      );
	    }
	
	    if (this.state.query && !hasResults) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ChatList-noResults' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ChatList-noResultsTitle' },
	          'No results for "' + this.state.query + '"'
	        )
	      );
	    }
	
	    var body = void 0;
	
	    var shouldSeeSplitView = !this.props.unifiedView && conversationResults.length > 0 && this.state.hasUpcomingActivities;
	
	    var classHasChats = chats.length > 0;
	
	    if (!canSendAnnouncements && !classHasChats) {
	      body = _react2.default.createElement(
	        'ul',
	        { className: 'ChatList-list' },
	        this.renderEmpty()
	      );
	    } else if (shouldSeeSplitView) {
	      (function () {
	        var recentChats = conversationResults.slice(0, RECENT_SECTION_SIZE);
	        var olderChats = conversationResults.slice(RECENT_SECTION_SIZE, conversationResults.length);
	
	        body = _react2.default.createElement(
	          'ul',
	          { className: 'ChatList-list' },
	          !_this3.state.query && canSendAnnouncements && _this3.renderAnnouncementsConversationResults(),
	          !_this3.state.query && _this3.renderQuickActions(),
	          !_this3.state.query && recentChats.length > 0 && _this3.renderRecentConversationsHeader(),
	          _react2.default.createElement(
	            'div',
	            null,
	            ' ',
	            !_this3.state.query && recentChats.length > 0 && _this3.renderConversations(recentChats)
	          ),
	          function () {
	            if (!_this3.state.query && recentChats.length > 0) {
	              return _this3.renderUpcomingActivitiesSection();
	            } else {
	              return null;
	            }
	          }(),
	          !_this3.state.query && olderChats.length > 0 && _this3.renderMoreConversationsHeader(),
	          !_this3.state.query && olderChats.length > 0 && _this3.renderConversations(olderChats),
	          _this3.state.query && _this3.renderConversationsHeader(),
	          _this3.state.query && _this3.renderConversations(conversationResults.models),
	          _this3.state.query && _this3.renderPeopleHeader(),
	          _this3.state.query && _this3.state.peopleResults.map(_this3.renderPersonResult),
	          loadingIndicator
	        );
	      })();
	    } else {
	      body = _react2.default.createElement(
	        'ul',
	        { className: 'ChatList-list' },
	        !this.state.query && canSendAnnouncements && this.renderAnnouncementsConversationResults(),
	        !this.state.query && this.renderQuickActions(),
	        conversationResults.length > 0 && this.renderConversationsHeader(),
	        conversationResults.length > 0 && this.renderConversations(conversationResults.models),
	        this.state.query && conversationResults.length > 0 && this.renderPeopleHeader(),
	        this.state.peopleResults.map(this.renderPersonResult),
	        loadingIndicator
	      );
	    }
	
	    return _react2.default.createElement(
	      _ScrollContainer2.default,
	      {
	        ref: 'scrollArea' },
	      body
	    );
	  },
	  renderUpcomingActivitiesSection: function renderUpcomingActivitiesSection() {
	    var _props2 = this.props,
	        group = _props2.group,
	        selectedChatId = _props2.selectedChatId;
	
	    if (this.state.showQuickActions) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'ChatList-list-header ChatList-list-header-activities' },
	        _react2.default.createElement(
	          'div',
	          null,
	          'Activities'
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Link2.default,
	            { color: 'eclipse', to: '/classes/' + group.getCode() + '/activities' },
	            'View All'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_ChatListActivitiesContainer2.default, {
	          selectedChatId: selectedChatId,
	          group: group
	        })
	      )
	    );
	  },
	  renderAnnouncementsConversationResults: function renderAnnouncementsConversationResults() {
	    var _this4 = this;
	
	    var group = this.props.group;
	
	
	    var threads = group.getPostableThreads();
	    var postableRoles = group.getPostableRoles();
	
	    // Always display Teachers thread for staff classes to promote RBM
	    if (group.isStaffClass() && !threads.some(function (t) {
	      return t.role === _roleHelpers.TEACHER;
	    }) && postableRoles.includes(_roleHelpers.TEACHER)) {
	      threads.push({ role: _roleHelpers.TEACHER, group_id: group.id });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.renderAnnouncementsHeader(),
	      threads.map(function (thread, i) {
	        return _react2.default.createElement(_AnnouncementThreadListItem2.default, {
	          key: i,
	          thread: thread,
	          group: group,
	          onClick: _this4.handleChatClick,
	          isAnnouncementsThread: true
	        });
	      })
	    );
	  },
	  renderEmpty: function renderEmpty() {
	    var group = this.props.group;
	
	    var isDistrict = group.getType() === 'district';
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'ChatList-list-header' },
	        'Announcements'
	      ),
	      _react2.default.createElement(_UniversalComposeButtonContainer2.default, {
	        label: 'Start a conversation',
	        hideAnnouncements: isDistrict,
	        hideActivities: isDistrict,
	        level: 'secondary',
	        full: true
	      })
	    );
	  },
	  renderAnnouncementsHeader: function renderAnnouncementsHeader() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'ChatList-list-header' },
	      'Announcements'
	    );
	  },
	  renderQuickActions: function renderQuickActions() {
	    if (!this.state.showQuickActions || this.props.group.isRoot()) {
	      return null;
	    }
	    return _react2.default.createElement(_QuickActionsBarContainer2.default, { group: this.props.group });
	  },
	  renderHeader: function renderHeader() {
	    var _this5 = this;
	
	    var group = this.props.group;
	
	    var isDistrict = group.getType() === 'district';
	    return _react2.default.createElement(
	      'div',
	      { ref: 'header', className: 'ChatList-header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ChatList-header-title' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            _Text2.default,
	            { size: 'large' },
	            this.props.headerText || 'Messages'
	          )
	        ),
	        _react2.default.createElement(_UniversalComposeButtonContainer2.default, {
	          label: _react2.default.createElement(_Glyph2.default, { name: 'pencil-compose-stroke', size: 'xlarge', solo: true }),
	          hideAnnouncements: isDistrict,
	          hideActivities: isDistrict
	        })
	      ),
	      _react2.default.createElement(_ChatSearchBlock2.default, {
	        ref: function ref(_ref) {
	          return _this5._searchBlock = _ref;
	        },
	        className: 'ChatList-searchBlock',
	        onDismiss: this.clearSearchQuery,
	        onQueryChange: this.handleQueryChange
	      })
	    );
	  },
	  renderMoreConversationsHeader: function renderMoreConversationsHeader() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'ChatList-list-header' },
	      'More conversations'
	    );
	  },
	  renderConversationsHeader: function renderConversationsHeader() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'ChatList-list-header' },
	      'Conversations'
	    );
	  },
	  renderRecentConversationsHeader: function renderRecentConversationsHeader() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'ChatList-list-header' },
	      'Recent'
	    );
	  },
	  renderPeopleHeader: function renderPeopleHeader() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'ChatList-list-header' },
	      'People'
	    );
	  },
	  renderPersonResult: function renderPersonResult(member) {
	    if (this.state.query) {
	      return _react2.default.createElement(_ChatListSearchItem2.default, {
	        key: member.id,
	        member: member,
	        query: this.state.query,
	        onSelect: this.handlePersonSelection
	      });
	    }
	    return undefined;
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)('ChatList', this.props.className) },
	      this.renderHeader(),
	      this.renderBody()
	    );
	  }
	});
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    showRecent: _recentMessagesModal.showRecent,
	    hideRecent: _recentMessagesModal.hideRecent
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ChatList);

/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Timestamp = __webpack_require__(1683);
	
	var _Timestamp2 = _interopRequireDefault(_Timestamp);
	
	var _roleHelpers = __webpack_require__(1230);
	
	__webpack_require__(2186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnnouncementThreadListItem = function (_React$Component) {
	  _inherits(AnnouncementThreadListItem, _React$Component);
	
	  function AnnouncementThreadListItem() {
	    _classCallCheck(this, AnnouncementThreadListItem);
	
	    return _possibleConstructorReturn(this, (AnnouncementThreadListItem.__proto__ || Object.getPrototypeOf(AnnouncementThreadListItem)).apply(this, arguments));
	  }
	
	  _createClass(AnnouncementThreadListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          thread = _props.thread,
	          group = _props.group;
	      var preview = thread.preview;
	
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'ChatListItem' },
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            to: '/classes/' + group.getCode() + '/messages/announcements/' + thread.role,
	            activeClassName: 'ChatListItem-selected',
	            className: 'ChatListItem-link ChatListItem-link-experiment',
	            eventElementName: 'ChatListItem-link ChatListItem-link-experiment' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'ChatListItem-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ChatListItem-content-droplet' },
	              _react2.default.createElement(_GroupAvatar2.default, { group: group, className: 'ChatListItem-announcementBadge' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ChatListItem-content-body' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ChatListItem-content-body-inner' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'ChatListItem-name' },
	                  _roleHelpers.subgroupName[thread.role]
	                ),
	                preview && _react2.default.createElement(_Timestamp2.default, {
	                  className: 'ChatListItem-date',
	                  date: new Date(this.props.thread.preview.sent_at),
	                  format: 'short'
	                })
	              ),
	              _react2.default.createElement(
	                _Text2.default,
	                { className: 'ChatListItem-snippet', truncate: true },
	                preview ? preview.preview : 'Send your first announcement'
	              ),
	              _react2.default.createElement('hr', { className: 'ChatListItem-content-body-divider' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AnnouncementThreadListItem;
	}(_react2.default.Component);
	
	AnnouncementThreadListItem.displayName = 'AnnouncementThreadListItem';
	exports.default = AnnouncementThreadListItem;

/***/ },
/* 2186 */
1136,
/* 2187 */,
/* 2188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _ChatListActivities = __webpack_require__(2189);
	
	var _ChatListActivities2 = _interopRequireDefault(_ChatListActivities);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatListActivitiesContainer = function (_React$Component) {
	  _inherits(ChatListActivitiesContainer, _React$Component);
	
	  function ChatListActivitiesContainer() {
	    _classCallCheck(this, ChatListActivitiesContainer);
	
	    return _possibleConstructorReturn(this, (ChatListActivitiesContainer.__proto__ || Object.getPrototypeOf(ChatListActivitiesContainer)).apply(this, arguments));
	  }
	
	  _createClass(ChatListActivitiesContainer, [{
	    key: 'render',
	    value: function render() {
	      var props = {
	        canCreateActivity: this.state.currentUser.canCreateActivity(),
	        upcomingActivities: this.state.upcomingActivities
	      };
	
	      return _react2.default.createElement(_ChatListActivities2.default, _extends({}, props, this.props));
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ActivityStore2.default, _CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var upcomingActivities = _ActivityStore2.default.getUpcomingActivityForGroup(props.group);
	      upcomingActivities = upcomingActivities.filter(function (activity) {
	        return !!activity.getChatUuid();
	      });
	      return {
	        upcomingActivities: upcomingActivities,
	        currentUser: _CurrentUser2.default.getUser()
	      };
	    }
	  }]);
	
	  return ChatListActivitiesContainer;
	}(_react2.default.Component);
	
	ChatListActivitiesContainer.displayName = 'ChatListActivitiesContainer';
	exports.default = _utils.Container.create(ChatListActivitiesContainer, { withProps: true });

/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityCreateDialogContainer = __webpack_require__(1726);
	
	var _ActivityCreateDialogContainer2 = _interopRequireDefault(_ActivityCreateDialogContainer);
	
	var _ChatListActivityItem = __webpack_require__(2190);
	
	var _ChatListActivityItem2 = _interopRequireDefault(_ChatListActivityItem);
	
	var _ChatListNewActivityItemContainer = __webpack_require__(2191);
	
	var _ChatListNewActivityItemContainer2 = _interopRequireDefault(_ChatListNewActivityItemContainer);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	__webpack_require__(2195);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_NUMBER_ACTIVITY_ITEM = 2;
	
	var ChatListActivities = function (_React$Component) {
	  _inherits(ChatListActivities, _React$Component);
	
	  function ChatListActivities() {
	    _classCallCheck(this, ChatListActivities);
	
	    return _possibleConstructorReturn(this, (ChatListActivities.__proto__ || Object.getPrototypeOf(ChatListActivities)).apply(this, arguments));
	  }
	
	  _createClass(ChatListActivities, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var activities = this.props.upcomingActivities.sort(function (a, b) {
	        return a.getStartAt() - b.getStartAt();
	      }).slice(0, MAX_NUMBER_ACTIVITY_ITEM);
	
	      var chatListActivityItems = activities.map(function (activity) {
	        var chatUuid = activity.getChatUuid();
	        var linkTo = '/classes/' + _this2.props.group.getCode() + '/messages/' + chatUuid;
	        var selected = _this2.props.selectedChatId && _this2.props.selectedChatId === chatUuid;
	
	        return _react2.default.createElement(
	          _Link2.default,
	          { key: activity.id, to: linkTo },
	          _react2.default.createElement(_ChatListActivityItem2.default, {
	            className: (0, _classnames2.default)({ 'ChatListActivities-item-selected': selected }),
	            activity: activity
	          })
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        chatListActivityItems,
	        this.props.canCreateActivity && _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: _react2.default.createElement(_ActivityCreateDialogContainer2.default, null) },
	          _react2.default.createElement(_ChatListNewActivityItemContainer2.default, { 'data-test': 'new-activity-item' })
	        )
	      );
	    }
	  }]);
	
	  return ChatListActivities;
	}(_react2.default.Component);
	
	ChatListActivities.displayName = 'ChatListActivities';
	exports.default = ChatListActivities;

/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatListActivityItem = function (_React$Component) {
	  _inherits(ChatListActivityItem, _React$Component);
	
	  function ChatListActivityItem() {
	    _classCallCheck(this, ChatListActivityItem);
	
	    return _possibleConstructorReturn(this, (ChatListActivityItem.__proto__ || Object.getPrototypeOf(ChatListActivityItem)).apply(this, arguments));
	  }
	
	  _createClass(ChatListActivityItem, [{
	    key: 'render',
	    value: function render() {
	      var activity = this.props.activity;
	
	      var summary = activity.getRecipientSummary();
	      var startAtDate = activity.getStartAt();
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ChatListActivities-item', this.props.className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'ChatListActivities-item-droplet' },
	          _react2.default.createElement(_Avatar2.default, { colorHex: 'c4c6c9', date: startAtDate, size: 'medium' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ChatListActivities-item-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ChatListActivities-item-body-header' },
	            _react2.default.createElement(
	              _Text2.default,
	              { truncate: true, className: 'ChatListActivities-item-body-header-title' },
	              activity.getTitle()
	            ),
	            startAtDate && _react2.default.createElement(
	              'div',
	              { className: 'ChatListActivities-item-body-header-date' },
	              _react2.default.createElement(_Time2.default, {
	                date: startAtDate,
	                month: 'short',
	                day: '2-digit'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ChatListActivities-item-body-subtext' },
	            summary.getAttendingCount(),
	            ' participants'
	          ),
	          _react2.default.createElement('hr', { className: 'ChatListActivities-item-divider' })
	        )
	      );
	    }
	  }]);
	
	  return ChatListActivityItem;
	}(_react2.default.Component);
	
	ChatListActivityItem.displayName = 'ChatListActivityItem';
	exports.default = ChatListActivityItem;

/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ChatListNewActivityItem = __webpack_require__(2192);
	
	var _ChatListNewActivityItem2 = _interopRequireDefault(_ChatListNewActivityItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ChatListNewActivityItemContainer = function (_React$Component) {
	  _inherits(ChatListNewActivityItemContainer, _React$Component);
	
	  function ChatListNewActivityItemContainer() {
	    _classCallCheck(this, ChatListNewActivityItemContainer);
	
	    return _possibleConstructorReturn(this, (ChatListNewActivityItemContainer.__proto__ || Object.getPrototypeOf(ChatListNewActivityItemContainer)).apply(this, arguments));
	  }
	
	  _createClass(ChatListNewActivityItemContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ChatListNewActivityItem2.default, {
	        onClick: this.props.onClick,
	        canCollectMoney: this.state.canCollectMoney
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var user = _CurrentUser2.default.isSignedIn() && _CurrentUser2.default.getUser();
	
	      return {
	        canCollectMoney: user && user.canCollectMoney()
	      };
	    }
	  }]);
	
	  return ChatListNewActivityItemContainer;
	}(_react2.default.Component);
	
	ChatListNewActivityItemContainer.displayName = 'ChatListNewActivityItemContainer';
	exports.default = _utils.Container.create(ChatListNewActivityItemContainer, { withProps: true });

/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(2193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChatListNewActivityItem(props) {
	  return _react2.default.createElement(
	    'div',
	    { onClick: props.onClick, className: 'ChatListActivities-item ChatListNewActivityItem' },
	    _react2.default.createElement(
	      'div',
	      { className: 'ChatListActivities-item-droplet' },
	      _react2.default.createElement(_Avatar2.default, { color: 'brand', glyphName: 'calendar-stroke', size: 'medium' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'ChatListActivities-item-body' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'ChatListNewActivityItem-header',
	            eventElementName: 'ChatListNewActivityItem-header' },
	          'Create an activity'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'ChatListActivities-item-body-subtext' },
	        _react2.default.createElement(
	          'span',
	          null,
	          props.canCollectMoney ? 'Manage invitations and collect funds' : 'Send invitations and track RSVPs'
	        )
	      ),
	      _react2.default.createElement('hr', { style: { border: 'none' }, className: 'ChatListActivities-item-divider' })
	    )
	  );
	}
	
	exports.default = ChatListNewActivityItem;

/***/ },
/* 2193 */
1136,
/* 2194 */,
/* 2195 */
1136,
/* 2196 */,
/* 2197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _ChatSearchBlock = __webpack_require__(2198);
	
	var _ChatSearchBlock2 = _interopRequireDefault(_ChatSearchBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ChatSearchBlock = function (_Component) {
	  _inherits(ChatSearchBlock, _Component);
	
	  function ChatSearchBlock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChatSearchBlock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatSearchBlock.__proto__ || Object.getPrototypeOf(ChatSearchBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      value: ''
	    }, _this.handleClose = function () {
	      var _this$props = _this.props,
	          onDismiss = _this$props.onDismiss,
	          onQueryChange = _this$props.onQueryChange;
	
	
	      var value = '';
	
	      _this.setState({ value: value });
	
	      // REVISIT should the caller have the freedom to preserve the last value?
	      onQueryChange(value);
	
	      if (onDismiss) {
	        onDismiss();
	      }
	    }, _this.handleInputBlur = function () {
	      var isEmpty = _this.state.value.length === 0;
	
	      if (isEmpty) {
	        _this.handleClose();
	      }
	    }, _this.handleInputChange = function (event) {
	      // $FlowFixMe
	      var value = event.target.value;
	
	
	      _this.setState({ value: value });
	
	      _this.props.onQueryChange(value);
	    }, _this.handleInputKeyDown = function (event) {
	      var keyCode = event.keyCode;
	
	      switch (keyCode) {
	        case _KeyConstants2.default.ESCAPE:
	          _this.handleClose();
	          break;
	        default:
	          return;
	      }
	      event.preventDefault();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChatSearchBlock, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    // typecheck: ignore statement
	
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var value = this.state.value;
	      var className = this.props.className;
	
	
	      var showClose = value && value.length > 0;
	      var placeholder = 'Search for messages or people';
	
	      return _react2.default.createElement(
	        _FlexibleBlock2.default,
	        {
	          flex: 'left',
	          className: className },
	        _react2.default.createElement(
	          'div',
	          { className: _ChatSearchBlock2.default.inputWrapper },
	          _react2.default.createElement(_Input2.default, {
	            'data-test-selector': 'chatlist_search_input',
	            className: _ChatSearchBlock2.default.input,
	            type: 'text',
	            value: value || '',
	            size: 'medium',
	            placeholder: placeholder,
	            onBlur: this.handleInputBlur,
	            onChange: this.handleInputChange,
	            onKeyDown: this.handleInputKeyDown
	          }),
	          _react2.default.createElement(_Glyph2.default, { className: _ChatSearchBlock2.default.inputGlyph, name: 'search', size: 'medium' })
	        ),
	        showClose && _react2.default.createElement(
	          _Button2.default,
	          {
	            className: _ChatSearchBlock2.default.closeButton,
	            level: 'icon',
	            onClick: this.handleClose },
	          _react2.default.createElement(_Glyph2.default, {
	            className: _ChatSearchBlock2.default.closeGlyph,
	            name: 'close',
	            size: 'small',
	            solo: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return ChatSearchBlock;
	}(_react.Component);
	
	ChatSearchBlock.displayName = 'ChatSearchBlock';
	exports.default = ChatSearchBlock;

/***/ },
/* 2198 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"eclipse":"#9e9fa5","inputWrapper":"ChatSearchBlock__inputWrapper___msdXH","closeButton":"ChatSearchBlock__closeButton___3Ww6U","closeGlyph":"ChatSearchBlock__closeGlyph___2fOlg","input":"ChatSearchBlock__input___27qUi","inputGlyph":"ChatSearchBlock__inputGlyph___3_tnl"};

/***/ },
/* 2199 */,
/* 2200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makePeopleFilter = exports.makeConversationFilter = undefined;
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _getMatcher = __webpack_require__(1890);
	
	var _getMatcher2 = _interopRequireDefault(_getMatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeConversationFilter = exports.makeConversationFilter = function makeConversationFilter(query) {
	  var isMatch = (0, _getMatcher2.default)(query);
	  return function (chat) {
	    return !chat.isNew() && isMatch([chat.getQueryKey()]);
	  };
	};
	var makePeopleFilter = exports.makePeopleFilter = function makePeopleFilter(query) {
	  var isMatch = (0, _getMatcher2.default)(query);
	  return function (pcm) {
	    return isMatch([pcm.getQueryKey()]);
	  };
	};

/***/ },
/* 2201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _QuickActionsBar = __webpack_require__(2202);
	
	var _QuickActionsBar2 = _interopRequireDefault(_QuickActionsBar);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _quickActions = __webpack_require__(2209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuickActionsBarContainer = function (_React$Component) {
	  _inherits(QuickActionsBarContainer, _React$Component);
	
	  function QuickActionsBarContainer() {
	    _classCallCheck(this, QuickActionsBarContainer);
	
	    return _possibleConstructorReturn(this, (QuickActionsBarContainer.__proto__ || Object.getPrototypeOf(QuickActionsBarContainer)).apply(this, arguments));
	  }
	
	  _createClass(QuickActionsBarContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.actions) {
	        this.props.loadQuickActions(this.props.group.id);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.group !== this.props.group && !newProps.actions) {
	        newProps.loadQuickActions(newProps.group.id);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.actions && this.props.actions.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'ChatList-list-header' },
	            'Quick Actions'
	          ),
	          _react2.default.createElement(_QuickActionsBar2.default, {
	            actions: this.props.actions,
	            group: this.props.group
	          })
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return QuickActionsBarContainer;
	}(_react2.default.Component);
	
	QuickActionsBarContainer.displayName = 'QuickActionsBarContainer';
	
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var quickActions = state.quickActions.get(props.group.id);
	  if (!quickActions) {
	    return {};
	  }
	
	  return { actions: quickActions.actions };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    loadQuickActions: _quickActions.loadQuickActions
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QuickActionsBarContainer);

/***/ },
/* 2202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _QuickActions = __webpack_require__(2203);
	
	var _QuickActionsBarItem = __webpack_require__(2204);
	
	var _QuickActionsBarItem2 = _interopRequireDefault(_QuickActionsBarItem);
	
	var _lodash = __webpack_require__(555);
	
	__webpack_require__(2207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var quickActionsBarItemMargin = 0;
	var arrowWidth = 30;
	var edgeOffset = 1.5 * arrowWidth;
	
	var QuickActionsBar = function (_React$Component) {
	  _inherits(QuickActionsBar, _React$Component);
	
	  function QuickActionsBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, QuickActionsBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuickActionsBar.__proto__ || Object.getPrototypeOf(QuickActionsBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      scrollIndex: 0,
	      scrollOffset: 0,
	      numVisible: 0
	    }, _this.maxScrollIndex = 0, _this.barWidth = 0, _this.contentWidth = 0, _this.cycleForward = function () {
	      var amount = _this.state.numVisible;
	      var nextIndex = (0, _lodash.range)(_this.state.scrollIndex + amount, _this.props.actions.length).find(function (index) {
	        return index <= _this.maxScrollIndex && _this.props.actions[index].uid !== _QuickActions.QuickActionUIDs.DIVIDER;
	      });
	      if (nextIndex || nextIndex === 0) {
	        _this.scrollToIndex(nextIndex);
	      } else {
	        _this.scrollToIndex(_this.maxScrollIndex);
	      }
	    }, _this.cycleBack = function () {
	      var amount = _this.state.numVisible;
	      var nextIndex = (0, _lodash.range)(_this.state.scrollIndex - amount, -1, -1).find(function (index) {
	        return index >= 0 && _this.props.actions[index].uid !== _QuickActions.QuickActionUIDs.DIVIDER;
	      });
	      if (nextIndex || nextIndex === 0) {
	        _this.scrollToIndex(nextIndex);
	      } else {
	        _this.scrollToIndex(0);
	      }
	    }, _this.offsetForIndex = (0, _lodash.memoize)(function (index) {
	      if (index === 0) {
	        return 0;
	      } else {
	        return _this.offsetForIndex(index - 1) + (0, _QuickActionsBarItem.widthForAction)(_this.props.actions[index - 1]) + quickActionsBarItemMargin;
	      }
	    }), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(QuickActionsBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.resetSize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // Will be a new Array when actions change
	      if (this.props.actions !== prevProps.actions) {
	        this.resetSize();
	      }
	    }
	  }, {
	    key: 'resetSize',
	    value: function resetSize() {
	      var _this2 = this;
	
	      this.barWidth = _reactDom2.default.findDOMNode(this).offsetWidth;
	      this.contentWidth = this.offsetForIndex(this.props.actions.length) - quickActionsBarItemMargin;
	
	      var maxScrollIndex = (0, _lodash.range)(this.props.actions.length).find(function (index) {
	        return _this2.contentWidth - _this2.offsetForIndex(index) - quickActionsBarItemMargin <= _this2.barWidth;
	      });
	      if (maxScrollIndex || maxScrollIndex === 0) {
	        this.maxScrollIndex = maxScrollIndex;
	      } else {
	        this.maxScrollIndex = this.props.actions.length - 1;
	      }
	
	      this.scrollToIndex(0);
	    }
	  }, {
	    key: 'canCycleForwardFrom',
	    value: function canCycleForwardFrom(index) {
	      return index < this.maxScrollIndex;
	    }
	  }, {
	    key: 'canCycleBackFrom',
	    value: function canCycleBackFrom(index) {
	      return index > 0;
	    }
	  }, {
	    key: 'numVisibleForIndex',
	    value: function numVisibleForIndex(index) {
	      var _this3 = this;
	
	      var lastVisible = (0, _lodash.rangeRight)(index, this.props.actions.length).find(function (i) {
	        return _this3.alignedOffsetForIndex(i) - _this3.alignedOffsetForIndex(index) + (0, _QuickActionsBarItem.widthForAction)(_this3.props.actions[index]) + (index === _this3.maxScrollIndex ? 0 : edgeOffset) <= _this3.barWidth;
	      });
	      if (lastVisible || lastVisible === 0) {
	        return lastVisible - index + 1;
	      } else {
	        return 0;
	      }
	    }
	  }, {
	    key: 'scrollToIndex',
	    value: function scrollToIndex(index) {
	      this.setState({
	        scrollIndex: index,
	        scrollOffset: this.alignedOffsetForIndex(index),
	        numVisible: this.numVisibleForIndex(index)
	      });
	    }
	  }, {
	    key: 'alignedOffsetForIndex',
	    value: function alignedOffsetForIndex(index) {
	      if (index === 0) {
	        return this.offsetForIndex(index);
	
	        // Includes greater than in case we skip past a divider
	      } else if (index >= this.maxScrollIndex) {
	        return this.contentWidth - this.barWidth;
	
	        // Show a bit of the previous item from under the chevron
	      } else {
	        return this.offsetForIndex(index) - edgeOffset;
	      }
	    }
	  }, {
	    key: 'carouselOffset',
	    value: function carouselOffset() {
	      return { marginLeft: -this.state.scrollOffset + 'px' };
	    }
	  }, {
	    key: 'leftArrowClass',
	    value: function leftArrowClass() {
	      return (0, _classnames2.default)('QuickActionsBar-arrow', 'QuickActionsBar-arrow-left', { 'QuickActionsBar-arrow-hidden': !this.canCycleBackFrom(this.state.scrollIndex) });
	    }
	  }, {
	    key: 'rightArrowClass',
	    value: function rightArrowClass() {
	      return (0, _classnames2.default)('QuickActionsBar-arrow', 'QuickActionsBar-arrow-right', { 'QuickActionsBar-arrow-hidden': !this.canCycleForwardFrom(this.state.scrollIndex) });
	    }
	  }, {
	    key: 'isIndexVisible',
	    value: function isIndexVisible(index) {
	      return index >= this.state.scrollIndex && index <= this.state.scrollIndex + this.state.numVisible;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'QuickActionsBar' },
	        _react2.default.createElement(
	          'a',
	          {
	            className: this.leftArrowClass(),
	            onClick: this.cycleBack },
	          _react2.default.createElement(_Glyph2.default, { name: 'chevron-left', color: 'brand', size: 'medium' })
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: this.rightArrowClass(),
	            onClick: this.cycleForward },
	          _react2.default.createElement(_Glyph2.default, { name: 'chevron-right', color: 'brand', size: 'medium' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'QuickActionsBar-carousel' },
	          _react2.default.createElement(
	            'div',
	            { className: 'QuickActionsBar-carousel-content', style: this.carouselOffset() },
	            this.props.actions.map(function (a, index) {
	              return _react2.default.createElement(_QuickActionsBarItem2.default, {
	                action: a,
	                group: _this4.props.group,
	                visible: _this4.isIndexVisible(index),
	                key: index
	              });
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return QuickActionsBar;
	}(_react2.default.Component);
	
	QuickActionsBar.displayName = 'QuickActionsBar';
	exports.default = QuickActionsBar;

/***/ },
/* 2203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuickActionUIDs = undefined;
	exports.loadQuickActionsForGroup = loadQuickActionsForGroup;
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuickActionUIDs = exports.QuickActionUIDs = {
	  ADD_PEOPLE: 'add_people',
	  CREATE_GROUP_CHAT: 'create_group_chat',
	  SHOW_HISTORY: 'show_history',
	  CREATE_ACTIVITY: 'create_activity',
	  DIVIDER: 'vertical_divider',
	  PERSON: 'person'
	};
	function loadQuickActionsForGroup(groupId) {
	  return (0, _apiRequest2.default)('/classes/' + groupId + '/quick_actions', 'GET').then(function (response) {
	    return response.actions;
	  });
	}

/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.widthForAction = widthForAction;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GroupInviteModal = __webpack_require__(1435);
	
	var _GroupInviteModal2 = _interopRequireDefault(_GroupInviteModal);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _modal = __webpack_require__(1188);
	
	var _ActivityCreateDialogContainer = __webpack_require__(1726);
	
	var _ActivityCreateDialogContainer2 = _interopRequireDefault(_ActivityCreateDialogContainer);
	
	var _GroupMessageListModal = __webpack_require__(1227);
	
	var _GroupMessageListModal2 = _interopRequireDefault(_GroupMessageListModal);
	
	var _UniversalComposer = __webpack_require__(2032);
	
	var _UniversalComposer2 = _interopRequireDefault(_UniversalComposer);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _reactRouter = __webpack_require__(497);
	
	var _RelationshipActions = __webpack_require__(1006);
	
	var _RelationshipActions2 = _interopRequireDefault(_RelationshipActions);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _RelationshipStore = __webpack_require__(1310);
	
	var _RelationshipStore2 = _interopRequireDefault(_RelationshipStore);
	
	var _QuickActions = __webpack_require__(2203);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _utils = __webpack_require__(956);
	
	__webpack_require__(2205);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuickActionsBarItem = function (_React$Component) {
	  _inherits(QuickActionsBarItem, _React$Component);
	
	  function QuickActionsBarItem() {
	    var _ref, _this$actionDetails;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, QuickActionsBarItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuickActionsBarItem.__proto__ || Object.getPrototypeOf(QuickActionsBarItem)).call.apply(_ref, [this].concat(args))), _this), _this.actionDetails = (_this$actionDetails = {}, _defineProperty(_this$actionDetails, _QuickActions.QuickActionUIDs.ADD_PEOPLE, {
	      title: 'Add people',
	      glyph: 'avatar-add',
	      action: _this.withTracking(_QuickActions.QuickActionUIDs.ADD_PEOPLE, function () {
	        (0, _modal.mountModal)(_react2.default.createElement(_GroupInviteModal2.default, { group: _this.props.group }), _this);
	      })
	    }), _defineProperty(_this$actionDetails, _QuickActions.QuickActionUIDs.CREATE_GROUP_CHAT, {
	      title: 'Group message',
	      glyph: 'message-group',
	      action: _this.withTracking(_QuickActions.QuickActionUIDs.CREATE_GROUP_CHAT, function () {
	        (0, _modal.mountModal)(_react2.default.createElement(_UniversalComposer2.default, {
	          canAnnounce: _CurrentUser2.default.getUser().canComposeAnnouncements(),
	          panel: _UniversalComposer.PANELS.GROUP_CONVERSATION
	        }), _this);
	      })
	    }), _defineProperty(_this$actionDetails, _QuickActions.QuickActionUIDs.SHOW_HISTORY, {
	      title: 'Announcements',
	      glyph: 'megaphone',
	      action: _this.withTracking(_QuickActions.QuickActionUIDs.SHOW_HISTORY, function () {
	        (0, _modal.mountModal)(_react2.default.createElement(_GroupMessageListModal2.default, { groupCode: _this.props.group.getCode() }), _this);
	      })
	    }), _defineProperty(_this$actionDetails, _QuickActions.QuickActionUIDs.CREATE_ACTIVITY, {
	      title: 'Activity',
	      glyph: 'calendar-stroke',
	      action: _this.withTracking(_QuickActions.QuickActionUIDs.CREATE_ACTIVITY, function () {
	        (0, _modal.mountModal)(_react2.default.createElement(_ActivityCreateDialogContainer2.default, null), _this);
	      })
	    }), _this$actionDetails), _this.navigateToMember = _this.withTracking(_QuickActions.QuickActionUIDs.PERSON, function () {
	      var data = _this.props.action.data;
	      var uuid = data && data.chat_uuid;
	      if (uuid) {
	        _reactRouter.browserHistory.push('/classes/' + _this.props.group.getCode() + '/messages/' + uuid);
	      } else {
	        var _relationship = _this.state.relationship;
	
	        if (_relationship) {
	          _reactRouter.browserHistory.push('/classes/' + _this.props.group.getCode() + '/messages/new/' + _relationship.id);
	        }
	      }
	    }), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(QuickActionsBarItem, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (!props.visible || this.props.visible || this.state.relationship || this.props.action.uid !== _QuickActions.QuickActionUIDs.PERSON) {
	        return;
	      }
	      if (this.props.action.data && this.props.action.data.chat_uuid) {
	        return;
	      }
	
	      var id = this.props.action.data && this.props.action.data.user.id;
	      if (id && !_RelationshipStore2.default.getRelationshipWithUser(id)) {
	        _RelationshipActions2.default.loadRelationship(id);
	      }
	    }
	  }, {
	    key: 'withTracking',
	    value: function withTracking(type, fn) {
	      var _this2 = this;
	
	      return function () {
	        _EventTracking2.default.tap(_this2.context.eventScreenName, 'QuickActionsBarItem-' + type, null, {});
	        fn();
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      switch (this.props.action.uid) {
	        case _QuickActions.QuickActionUIDs.DIVIDER:
	          {
	            return _react2.default.createElement('div', { className: 'QuickActionsBarItem QuickActionsBarItem-divider' });
	          }
	        case _QuickActions.QuickActionUIDs.PERSON:
	          {
	            if (!this.props.action.data) {
	              return _react2.default.createElement('div', null);
	            }
	            return _react2.default.createElement(
	              'div',
	              {
	                className: 'QuickActionsBarItem QuickActionsBarItem-person',
	                onClick: this.navigateToMember },
	              _react2.default.createElement(_Avatar2.default, {
	                colorHex: this.props.action.data.user.color,
	                text: this.props.action.data.user.initials,
	                size: 'medium'
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'QuickActionsBarItem-title' },
	                this.props.action.data.user.name
	              )
	            );
	          }
	        default:
	          {
	            var details = this.actionDetails[this.props.action.uid];
	            if (!details) {
	              return _react2.default.createElement('div', null);
	            }
	            return _react2.default.createElement(
	              'div',
	              {
	                className: 'QuickActionsBarItem QuickActionsBarItem-action',
	                onClick: details.action },
	              _react2.default.createElement(_Avatar2.default, {
	                color: 'brand',
	                glyphName: details.glyph,
	                size: 'medium'
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'QuickActionsBarItem-title' },
	                details.title
	              )
	            );
	          }
	      }
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_RelationshipStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var relationship = null;
	      if (props.action.uid === _QuickActions.QuickActionUIDs.PERSON && props.action.data && !props.action.data.chat_uuid) {
	        var id = props.action.data.user.id;
	
	        if (id) {
	          relationship = _RelationshipStore2.default.getRelationshipWithUser(id);
	        }
	      }
	      return { relationship: relationship };
	    }
	  }]);
	
	  return QuickActionsBarItem;
	}(_react2.default.Component);
	
	QuickActionsBarItem.contextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	QuickActionsBarItem.displayName = 'QuickActionsBarItem';
	exports.default = _utils.Container.create(QuickActionsBarItem, { withProps: true });
	function widthForAction(action) {
	  switch (action.uid) {
	    case _QuickActions.QuickActionUIDs.DIVIDER:
	      return 11;
	    case _QuickActions.QuickActionUIDs.PERSON:
	      return 98;
	    default:
	      return 98;
	  }
	}

/***/ },
/* 2205 */
1136,
/* 2206 */,
/* 2207 */
1136,
/* 2208 */,
/* 2209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = reducer;
	exports.loadQuickActions = loadQuickActions;
	exports.loadQuickActionsSuccess = loadQuickActionsSuccess;
	
	var _immutable = __webpack_require__(949);
	
	var initialState = exports.initialState = new _immutable.Map();
	
	// typecheck: ignore statement
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'quickActions/LOAD_QUICK_ACTIONS_SUCCESS':
	      return state.set(action.groupId, { actions: action.quickActions });
	    default:
	      return state;
	  }
	}
	
	function loadQuickActions(groupId) {
	  return {
	    type: 'quickActions/LOAD_QUICK_ACTIONS',
	    groupId: groupId
	  };
	}
	
	function loadQuickActionsSuccess(groupId, quickActions) {
	  return {
	    type: 'quickActions/LOAD_QUICK_ACTIONS_SUCCESS',
	    groupId: groupId,
	    quickActions: quickActions
	  };
	}

/***/ },
/* 2210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	__webpack_require__(2211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ScrollContainer = function (_React$Component) {
	  _inherits(ScrollContainer, _React$Component);
	
	  function ScrollContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScrollContainer.__proto__ || Object.getPrototypeOf(ScrollContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      scrollBottom: 0
	    }, _this._container = null, _this.handleScroll = function () {
	      if (_this._container) {
	        var scrollBottom = _this._container.scrollTop + _this._container.offsetHeight - _this._container.scrollHeight;
	        _this.setState({ scrollBottom: scrollBottom }, _this.props.onScroll);
	      }
	    }, _this.handleWheel = function (event) {
	      var node = _this._container;
	      if (!node) {
	        return;
	      }
	
	      if (event.deltaX && !event.deltaY) {
	        return;
	      }
	
	      var scrollHeight = node.scrollHeight;
	      var clientHeight = node.clientHeight;
	      if (scrollHeight > clientHeight) {
	        var scrollTop = node.scrollTop;
	        var delta = -event.deltaY;
	        if (delta > 0 && scrollTop === 0 || delta < 0 && scrollTop >= scrollHeight - clientHeight - 1) {
	          event.preventDefault();
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScrollContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleScroll = (0, _lodash.throttle)(this.handleScroll, 100);
	      if (this.props.scrollToBottom) {
	        this.scrollToBottom();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.scrollBottom === 0) {
	        if (this._container && this.props.scrollToBottom) {
	          this._container.scrollTop = this._container.scrollHeight;
	        }
	      }
	    }
	  }, {
	    key: 'isScrolledToBottom',
	    value: function isScrolledToBottom() {
	      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      if (this._container) {
	        var scrollTop = this._container.scrollTop;
	        var scrollBottom = scrollTop + this._container.offsetHeight - this._container.scrollHeight;
	        return scrollBottom + offset >= 0;
	      }
	      return false;
	    }
	  }, {
	    key: 'scrollToBottom',
	    value: function scrollToBottom() {
	      this.setState({ scrollBottom: 0 }, this.props.onScroll);
	    }
	  }, {
	    key: 'scrollToTop',
	    value: function scrollToTop() {
	      if (this._container) {
	        this._container.scrollTop = 0;
	      }
	    }
	
	    // This prevents mousewheel events on ScrollableArea instances from transferring to mousewheel
	    // on the document's main scroll area.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'ScrollContainer',
	          ref: function ref(container) {
	            return _this2._container = container;
	          },
	          onScroll: this.handleScroll,
	          onWheel: this.handleWheel },
	        this.props.children
	      );
	    }
	  }]);
	
	  return ScrollContainer;
	}(_react2.default.Component);
	
	ScrollContainer.displayName = 'ScrollContainer';
	exports.default = ScrollContainer;

/***/ },
/* 2211 */
1136,
/* 2212 */,
/* 2213 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isElementInViewport;
	
	
	// http://stackoverflow.com/a/16270434/46040
	function isElementInViewport(el) {
	  var rect = el.getBoundingClientRect();
	
	  return rect.bottom > 0 && rect.right > 0 && rect.left < (window.innerWidth || document.documentElement.clientWidth) && rect.top < (window.innerHeight || document.documentElement.clientHeight);
	}

/***/ },
/* 2214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChatListItem = undefined;
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _getParticipantNames = __webpack_require__(2215);
	
	var _getParticipantNames2 = _interopRequireDefault(_getParticipantNames);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _MessageStore = __webpack_require__(1232);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _UnreadStore = __webpack_require__(1030);
	
	var _UnreadStore2 = _interopRequireDefault(_UnreadStore);
	
	var _ChatListItemAvatar = __webpack_require__(2216);
	
	var _ChatListItemAvatar2 = _interopRequireDefault(_ChatListItemAvatar);
	
	var _ChatListItemContentConversation = __webpack_require__(2217);
	
	var _ChatListItemContentConversation2 = _interopRequireDefault(_ChatListItemContentConversation);
	
	var _ChatListItemContentNew = __webpack_require__(2221);
	
	var _ChatListItemContentNew2 = _interopRequireDefault(_ChatListItemContentNew);
	
	__webpack_require__(2186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// typecheck: ignore file
	var ChatListItem = exports.ChatListItem = _react2.default.createClass({
	  displayName: 'ChatListItem',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired,
	    chatSelectionAction: _react2.default.PropTypes.string
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_ChatStore2.default, _UnreadStore2.default, _MessageStore2.default])],
	
	  // typecheck: ignore statement
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    var chatUuid = nextProps.chatUuid;
	
	
	    var chat = chatUuid ? _ChatStore2.default.getChat(chatUuid) : _ChatStore2.default.getLocal();
	    if (!chat) {
	      return false;
	    }
	
	    // props
	    if (this.props.chatUuid !== nextProps.chatUuid || this.props.selected !== nextProps.selected || this.props.query !== nextProps.query || this.props.withinGroupId !== nextProps.withinGroupId || this.props.group !== nextProps.group) {
	      return true;
	    }
	
	    // shallow state
	    var shallowKeys = ['isDisabled', 'inactive', 'isNew', 'chatColor', 'chatType', 'otherMemberInitials', 'otherMemberColor', 'unreadCount'];
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = shallowKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var key = _step.value;
	
	        if (this.state[key] !== nextState[key]) {
	          return true;
	        }
	      }
	
	      // state that can't be compared shallow, because our Chat entity
	      // is Backbone
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    if (!this.state.lastMessage && nextState.lastMessage) {
	      return true;
	    }
	
	    if (this.state.lastMessage && nextState.lastMessage && this.state.lastMessage.id !== nextState.lastMessage.id) {
	      return true;
	    }
	
	    if (!_lodash2.default.isEqual(this.state.groupSummaries, nextState.groupSummaries)) {
	      return true;
	    }
	
	    if (!_lodash2.default.isEqual(this.state.participantNames, nextState.participantNames)) {
	      return true;
	    }
	
	    return false;
	  },
	  getStateFromStores: function getStateFromStores() {
	    var chatUuid = this.props.chatUuid;
	
	    // For new chat threads, the chatUuid parameter is not present in the url.
	    // In this case, We invoke ChatStore.getLocal to get the Chat representing a new thread.
	    // The new, local-only, Chat must exist in ChatStore prior to this invocation.
	
	    var chat = chatUuid ? _ChatStore2.default.getChat(chatUuid) : _ChatStore2.default.getLocal();
	
	    // XXX There must be a better way to do this
	    // For removing a new chat thread... getStateFromStores is invoked after Chat is deleted
	    if (!chat) {
	      return {
	        isDisabled: true,
	        groupSummaries: [],
	        inactive: true,
	        chatType: null,
	        isNew: true,
	        title: '',
	        lastMessage: null,
	        chatColor: '',
	        otherMemberInitials: '',
	        otherMemberColor: '',
	        participantNames: [],
	        unreadCount: 0,
	        activityStartAt: null,
	        timestamp: new Date()
	      };
	    }
	
	    var activityStartAt = chat.getActivity() ? chat.getActivity().getStartAt() : undefined;
	
	    var otherMember = chat.getOtherMember();
	
	    return {
	      isDisabled: chat.isDisabled(),
	      groupSummaries: chat.get('group_summaries'),
	      inactive: chat.isInactive(),
	      chatType: chat.getType(),
	      isNew: chat.isNew(), // this state value causes render to call renderNewChatListItem
	      title: chat.getTitle(),
	      lastMessage: chat.getLastMessage(),
	      chatColor: chat && chat.getColor() || '',
	      otherMemberInitials: otherMember ? otherMember.initials : '',
	      otherMemberColor: otherMember ? otherMember.color : '',
	      participantNames: (0, _getParticipantNames2.default)(chat),
	      unreadCount: chatUuid ? _UnreadStore2.default.getUnreadCount(chatUuid) : 0,
	      activityStartAt: activityStartAt,
	      timestamp: chat.getSortKeyTimestamp()
	    };
	  },
	  resetUnreadCount: function resetUnreadCount() {
	    this.setState({ unreadCount: 0 });
	  },
	  selectChat: function selectChat() {
	    var chatUuid = this.props.chatUuid;
	
	    if (chatUuid) {
	      _ChatActions2.default.selectChat(chatUuid);
	    }
	  },
	
	
	  // Upon clicking the 'x' icon to dismiss a new chat. Destroys the local chat thread
	  // and redirects to the default message thread in the focused group.
	  closeNewChat: function closeNewChat() {
	    var groupCode = this.props.group.getCode();
	    this.context.router.replace('/classes/' + groupCode + '/messages/');
	    _ChatActions2.default.destroyLocal();
	  },
	  buildAvatar: function buildAvatar() {
	    var _state = this.state,
	        chatColor = _state.chatColor,
	        otherMemberInitials = _state.otherMemberInitials,
	        otherMemberColor = _state.otherMemberColor,
	        inactive = _state.inactive,
	        chatType = _state.chatType,
	        activityStartAt = _state.activityStartAt;
	
	
	    return _react2.default.createElement(_ChatListItemAvatar2.default, {
	      chatColor: chatColor,
	      otherMemberInitials: otherMemberInitials,
	      otherMemberColor: otherMemberColor,
	      inactive: inactive,
	      chatType: chatType,
	      activityStartAt: activityStartAt
	    });
	  },
	  renderNewChatListItem: function renderNewChatListItem() {
	    return _react2.default.createElement(
	      'li',
	      { className: 'ChatListItem' },
	      _react2.default.createElement(
	        _Link2.default,
	        {
	          className: (0, _classnames2.default)({
	            'ChatListItem-link': true,
	            'ChatListItem-newChat': true,
	            'ChatListItem-selected': this.props.selected
	          }),
	          params: {} },
	        _react2.default.createElement(_ChatListItemContentNew2.default, {
	          avatar: this.buildAvatar(),
	          participantNames: this.state.participantNames,
	          closeNewChat: this.closeNewChat
	        })
	      )
	    );
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        chatUuid = _props.chatUuid,
	        query = _props.query,
	        group = _props.group;
	
	    // XXX these should be different components
	
	    if (this.state.isNew || !chatUuid) {
	      return this.renderNewChatListItem();
	    }
	
	    var linkTo = '/classes/' + group.getCode() + '/messages/' + chatUuid;
	    var onClick = this.resetUnreadCount;
	
	    if (this.context.chatSelectionAction === 'store') {
	      linkTo = null;
	      onClick = function onClick() {
	        _this.resetUnreadCount();
	        _this.selectChat();
	        if (_this.props.onClick) {
	          _this.props.onClick();
	        }
	      };
	    }
	
	    return _react2.default.createElement(
	      'li',
	      { className: 'ChatListItem' },
	      _react2.default.createElement(
	        _Link2.default,
	        {
	          to: linkTo,
	          onClick: onClick,
	          className: (0, _classnames2.default)({
	            'ChatListItem-link': true,
	            'ChatListItem-hasUnread': this.state.unreadCount > 0,
	            'ChatListItem-inactive': this.state.inactive,
	            'ChatListItem-selected': this.props.selected
	          }) },
	        _react2.default.createElement(_ChatListItemContentConversation2.default, {
	          avatar: this.buildAvatar(),
	          isDisabled: this.state.isDisabled,
	          query: query,
	          title: this.state.title,
	          lastMessage: this.state.lastMessage,
	          timestamp: this.state.timestamp
	        })
	      )
	    );
	  }
	});
	
	exports.default = ChatListItem;

/***/ },
/* 2215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getParticipantNames;
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NOTE: This function will likely go away after awhile since we should pass Membership or User
	// objects to components that render names. I am just keeping it around for now since it's a
	// quick way to output names in a chat conversation.
	function getParticipantNames(chat) {
	  var currentUserId = _CurrentUser2.default.getUser().id;
	  return chat.getMemberships().filter(function (membership) {
	    return membership.getMember().id !== currentUserId;
	  }).map(function (membership) {
	    return membership.getMember().getName();
	  });
	} /*  weak */

/***/ },
/* 2216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TYPE_TO_GLYPH;
	
	exports.default = function (_ref) {
	  var chatColor = _ref.chatColor,
	      otherMemberInitials = _ref.otherMemberInitials,
	      otherMemberColor = _ref.otherMemberColor,
	      inactive = _ref.inactive,
	      chatType = _ref.chatType,
	      activityStartAt = _ref.activityStartAt;
	  // eslint-disable-line object-curly-spacing
	  var text = void 0;
	
	  var colorHex = chatColor || otherMemberColor;
	
	  if (inactive || !colorHex) {
	    colorHex = 'ADADAD'; // Eclipse
	  }
	
	  if (chatType === _Chat.TYPES.ACTIVITY && activityStartAt) {
	    return _react2.default.createElement(_Avatar2.default, { colorHex: colorHex, date: activityStartAt, size: 'medium' });
	  }
	
	  if (chatType === _Chat.TYPES.INDIVIDUAL) {
	    text = otherMemberInitials;
	  }
	
	  var glyph = TYPE_TO_GLYPH[chatType];
	
	  return _react2.default.createElement(_Avatar2.default, {
	    glyphName: glyph,
	    colorHex: colorHex,
	    text: text || undefined,
	    size: 'medium'
	  });
	};
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Chat = __webpack_require__(906);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// This has to be 'any' because something about Flow
	var TYPE_TO_GLYPH = (_TYPE_TO_GLYPH = {}, _defineProperty(_TYPE_TO_GLYPH, _Chat.TYPES.ACTIVITY, 'message-activity'), _defineProperty(_TYPE_TO_GLYPH, _Chat.TYPES.GROUP, 'message-group'), _defineProperty(_TYPE_TO_GLYPH, _Chat.TYPES.INDIVIDUAL, undefined), _TYPE_TO_GLYPH);

/***/ },
/* 2217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChatListItemContentConversation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _ChatMessageSnippet = __webpack_require__(2218);
	
	var _ChatMessageSnippet2 = _interopRequireDefault(_ChatMessageSnippet);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ChatMessageTimestamp = __webpack_require__(2219);
	
	var _ChatMessageTimestamp2 = _interopRequireDefault(_ChatMessageTimestamp);
	
	var _ChatTitle = __webpack_require__(2220);
	
	var _ChatTitle2 = _interopRequireDefault(_ChatTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var chatDisabledGlyph = _react2.default.createElement(_Glyph2.default, {
	  className: 'ChatListItem-disabledGlyph',
	  name: 'chat-mute',
	  size: 'xsmall',
	  color: 'eclipse'
	});
	
	var ChatListItemContentConversation = exports.ChatListItemContentConversation = function (_React$Component) {
	  _inherits(ChatListItemContentConversation, _React$Component);
	
	  function ChatListItemContentConversation() {
	    _classCallCheck(this, ChatListItemContentConversation);
	
	    return _possibleConstructorReturn(this, (ChatListItemContentConversation.__proto__ || Object.getPrototypeOf(ChatListItemContentConversation)).apply(this, arguments));
	  }
	
	  _createClass(ChatListItemContentConversation, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          avatar = _props.avatar,
	          isDisabled = _props.isDisabled,
	          lastMessage = _props.lastMessage,
	          title = _props.title,
	          query = _props.query,
	          timestamp = _props.timestamp;
	
	
	      var snippet = lastMessage ? _react2.default.createElement(_ChatMessageSnippet2.default, { message: lastMessage }) : _react2.default.createElement('br', null);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ChatListItem-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ChatListItem-content-droplet' },
	          avatar
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ChatListItem-content-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ChatListItem-content-body-inner' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ChatListItem-content-body-inner-title' },
	              _react2.default.createElement(
	                _Text2.default,
	                { color: 'pitch' },
	                _react2.default.createElement(_ChatTitle2.default, { title: title, query: query })
	              ),
	              isDisabled && chatDisabledGlyph
	            ),
	            _react2.default.createElement(_ChatMessageTimestamp2.default, { timestamp: timestamp, className: 'ChatListItem-date' })
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            { className: 'ChatListItem-snippet', truncate: true },
	            snippet
	          ),
	          _react2.default.createElement('hr', { className: 'ChatListItem-content-body-divider' })
	        )
	      );
	    }
	  }]);
	
	  return ChatListItemContentConversation;
	}(_react2.default.Component);
	
	ChatListItemContentConversation.displayName = 'ChatListItemContentConversation';
	exports.default = ChatListItemContentConversation;

/***/ },
/* 2218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChatMessageSnippet = function ChatMessageSnippet(_ref) {
	  var message = _ref.message;
	
	  var preview = message.getPreview();
	  if (preview) {
	    var entities = _TextEntities2.default.parseEmoji(preview);
	    return _react2.default.createElement(_TextWithEntities2.default, { text: preview, entities: entities });
	  }
	  // UNTIL 0.15 https://github.com/facebook/react/issues/5355
	  return _react2.default.createElement('noscript', null);
	};
	exports.default = ChatMessageSnippet;

/***/ },
/* 2219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Timestamp = __webpack_require__(1683);
	
	var _Timestamp2 = _interopRequireDefault(_Timestamp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChatMessageTimestamp = function ChatMessageTimestamp(_ref) {
	  var timestamp = _ref.timestamp,
	      className = _ref.className;
	  // eslint-disable-line
	  return _react2.default.createElement(_Timestamp2.default, {
	    className: className,
	    date: timestamp,
	    format: 'short'
	  });
	};
	
	exports.default = ChatMessageTimestamp;

/***/ },
/* 2220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var ChatTitle = function ChatTitle(_ref) {
	  var title = _ref.title,
	      query = _ref.query;
	
	  var text = title;
	
	  if (query !== '') {
	    var parser = _TextEntities2.default.createTextMatchingParser(query);
	    text = _react2.default.createElement(_TextWithEntities2.default, { text: text, entities: parser(text) });
	  }
	
	  return _react2.default.createElement(
	    _Text2.default,
	    { truncate: true, className: 'ChatListItem-name' },
	    text
	  );
	};
	
	exports.default = ChatTitle;

/***/ },
/* 2221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var participantNames = _ref.participantNames,
	      avatar = _ref.avatar,
	      closeNewChat = _ref.closeNewChat;
	  // eslint-disable-line object-curly-spacing
	  return _react2.default.createElement(
	    'div',
	    { className: 'ChatListItem-content' },
	    _react2.default.createElement(
	      'div',
	      { className: 'ChatListItem-content-droplet' },
	      avatar
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'ChatListItem-content-body' },
	      _react2.default.createElement(
	        _Text2.default,
	        { className: 'ChatListItem-name', truncate: true },
	        _react2.default.createElement(_HumanArray2.default, { sample: participantNames, total: participantNames.length })
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        { className: 'ChatListItem-snippet', truncate: true },
	        'Send your first message'
	      ),
	      _react2.default.createElement('hr', { className: 'ChatListItem-content-body-divider' })
	    ),
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'ChatListItem-closeButton',
	        level: 'text',
	        onClick: closeNewChat,
	        eventElementName: 'ChatListItem-closeButton' },
	      _react2.default.createElement(_Glyph2.default, { name: 'close', size: 'xsmall', solo: true })
	    )
	  );
	};
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _HumanArray = __webpack_require__(2222);
	
	var _HumanArray2 = _interopRequireDefault(_HumanArray);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* humanize an array:
	 *
	 * <HumanArray sample={['Sam', 'John', 'Smith']} total={100} />
	 *    => Sam, John, Smith and 97 more
	 *
	 * const array = ['Sam', 'John', 'Smith', 'Doc'];
	 * <HumanArray sample={array} total={array.length} />
	 *    => Sam, John, Smith and 1 more
	 */
	var HumanArray = function (_React$Component) {
	  _inherits(HumanArray, _React$Component);
	
	  function HumanArray() {
	    _classCallCheck(this, HumanArray);
	
	    return _possibleConstructorReturn(this, (HumanArray.__proto__ || Object.getPrototypeOf(HumanArray)).apply(this, arguments));
	  }
	
	  _createClass(HumanArray, [{
	    key: 'render',
	    value: function render() {
	      var objs = this.props.sample;
	
	      if (objs.length === 0) {
	        return _react2.default.createElement('span', null);
	      }
	
	      if (objs.length === 1) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          objs[0]
	        );
	      }
	
	      if (objs.length === 2) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          objs[0],
	          ' & ',
	          objs[1]
	        );
	      }
	
	      if (objs.length > 2) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          objs[0],
	          ', ',
	          objs[1],
	          ' & ',
	          this.props.total - 2,
	          ' more'
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return HumanArray;
	}(_react2.default.Component);
	
	HumanArray.displayName = 'HumanArray';
	exports.default = HumanArray;

/***/ },
/* 2223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _LeadActions = __webpack_require__(1021);
	
	var _LeadActions2 = _interopRequireDefault(_LeadActions);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _NameAndSignatureQuery = __webpack_require__(2036);
	
	var _NameAndSignatureQuery2 = _interopRequireDefault(_NameAndSignatureQuery);
	
	var _PotentialChatMember = __webpack_require__(945);
	
	var _PotentialChatMember2 = _interopRequireDefault(_PotentialChatMember);
	
	var _StatusLabel = __webpack_require__(1571);
	
	var _StatusLabel2 = _interopRequireDefault(_StatusLabel);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	__webpack_require__(2224);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var screenName = 'invite_teacher_leads_chat_search_item';
	
	var ChatListSearchItem = function (_React$Component) {
	  _inherits(ChatListSearchItem, _React$Component);
	
	  function ChatListSearchItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChatListSearchItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatListSearchItem.__proto__ || Object.getPrototypeOf(ChatListSearchItem)).call.apply(_ref, [this].concat(args))), _this), _this.click = function () {
	      var link = _reactDom2.default.findDOMNode(_this.refs.link);
	      link.click();
	    }, _this.handleClick = function (event) {
	      event.preventDefault();
	      _this.props.onSelect(_this.props.member);
	    }, _this.inviteMember = function () {
	      var onSuccess = function onSuccess() {
	        _ToastActions2.default.showSuccessToast('Thank you! ' + _this.props.member.getName() + ' has been sent an invitation.');
	      };
	
	      _LeadActions2.default.sendInvitations([_this.props.member.id], 'chat').then(onSuccess, _ToastActions2.default.showDefaultErrorToast);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChatListSearchItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var member = this.props.member;
	
	      if (member.isTeacherLead()) {
	        if (member.isInvited()) {
	          _EventTracking2.default.view(screenName, {
	            state: 'invited'
	          });
	        } else if (member.isInvitable()) {
	          _EventTracking2.default.view(screenName, {
	            state: 'invitable'
	          });
	        }
	      }
	    }
	
	    // Avoid redrawing like crazy when the highlight
	    // props is changed when hovered on element.
	
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.highlight !== this.props.highlight || nextProps.query !== this.props.query || nextProps.onSelect !== this.props.onSelect || nextProps.selected !== this.props.selected || nextProps.added !== this.props.added || !!nextProps.member.changed.state;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var member = this.props.member;
	
	      var fullName = member.getRole() === 'teacher' ? member.getUser().getFullName() : '';
	
	      var subText = member.getConnectionDescription();
	      var privateNote = member.getNote();
	
	      if (this.props.query !== '') {
	        var parser = _TextEntities2.default.createTextMatchingParser(this.props.query);
	        subText = _react2.default.createElement(_TextWithEntities2.default, { text: subText, entities: parser(subText) });
	
	        if (privateNote) {
	          var privateNoteMatches = parser(privateNote);
	          privateNote = _react2.default.createElement(_TextWithEntities2.default, { text: privateNote, entities: privateNoteMatches });
	        }
	      }
	
	      if (privateNote) {
	        privateNote = _react2.default.createElement(
	          _Text2.default,
	          { className: 'ChatListSearchItem-privateNote', truncate: true },
	          privateNote
	        );
	      }
	
	      var user = member.getUser();
	
	      var item = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'right' },
	          _react2.default.createElement(_Avatar2.default, {
	            className: 'ChatListSearchItem-glyph',
	            text: user.getInitials(),
	            colorHex: user.getColor() || 'ADADAD',
	            size: 'medium'
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'ChatListSearchItem-bodyText' },
	            _react2.default.createElement(
	              _Text2.default,
	              { className: 'ChatListSearchItem-name', truncate: true },
	              _react2.default.createElement(_NameAndSignatureQuery2.default, {
	                displayName: member.getName(),
	                fullName: fullName,
	                query: this.props.query
	              })
	            ),
	            privateNote,
	            _react2.default.createElement(
	              _Text2.default,
	              { className: 'ChatListSearchItem-subText', truncate: true },
	              subText
	            ),
	            _react2.default.createElement('hr', { className: 'ChatListSearchItem-divider' })
	          )
	        )
	      );
	
	      var state = void 0;
	      if (this.props.added) {
	        state = 'Added';
	      } else if (member.isPending()) {
	        state = 'Pending';
	      } else if (member.isUnder13()) {
	        state = 'Under 13';
	      }
	
	      if (member.isTeacherLead()) {
	        if (member.isInvited()) {
	          item = _react2.default.createElement(
	            _FlexibleBlock2.default,
	            { flex: 'left' },
	            item,
	            _react2.default.createElement(
	              _StatusLabel2.default,
	              { className: 'ChatListSearchItem-status' },
	              'Invited'
	            )
	          );
	        } else if (member.isInvitable()) {
	          item = _react2.default.createElement(
	            _FlexibleBlock2.default,
	            { flex: 'left' },
	            item,
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: 'ChatListSearchItem-inviteButton',
	                size: 'xsmall',
	                level: 'secondary',
	                onClick: this.inviteMember,
	                eventProperties: {
	                  teacher_lead_id: member.id
	                },
	                eventElementName: 'ChatListSearchItem-inviteButton' },
	              'Invite'
	            )
	          );
	        } else {
	          return null; // if a teacher lead is neither invited nor invitable, don't display them
	        }
	      }
	
	      if (this.props.selected) {
	        item = _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'left' },
	          item,
	          _react2.default.createElement(_Glyph2.default, {
	            className: 'ChatListSearchItem-selectedGlyph',
	            name: 'stamp-check',
	            size: 'medium',
	            color: 'brand'
	          })
	        );
	      } else if (state) {
	        item = _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'left' },
	          item,
	          _react2.default.createElement(
	            _StatusLabel2.default,
	            { className: 'ChatListSearchItem-status' },
	            state
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'li',
	        {
	          className: (0, _classnames2.default)({
	            ChatListSearchItem: true,
	            'ChatListSearchItem-highlight': this.props.highlight,
	            'ChatListSearchItem-under13': member.isUnder13(),
	            'ChatListSearchItem-unavailable': member.isUnavailable(),
	            'ChatListSearchItem-selected': this.props.selected,
	            'ChatListSearchItem-added': this.props.added,
	            'ChatListSearchItem-invite': member.isInvitable() || member.isInvited()
	          }) },
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'ChatListSearchItem-link',
	            ref: 'link',
	            color: 'pitch',
	            onClick: this.handleClick,
	            eventElementName: 'ChatListSearchItem-link' },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'ChatListSearchItem-linkContent' },
	            item
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChatListSearchItem;
	}(_react2.default.Component);
	
	ChatListSearchItem.defaultProps = {
	  highlight: false,
	  selected: false
	};
	ChatListSearchItem.displayName = 'ChatListSearchItem';
	exports.default = ChatListSearchItem;

/***/ },
/* 2224 */
1136,
/* 2225 */,
/* 2226 */
1136,
/* 2227 */,
/* 2228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConversationView = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _ActivityConversationHeader = __webpack_require__(2229);
	
	var _ActivityConversationHeader2 = _interopRequireDefault(_ActivityConversationHeader);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _Timer = __webpack_require__(1239);
	
	var _modal = __webpack_require__(1188);
	
	var _ChatPromises = __webpack_require__(1569);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _ChatConstants2 = _interopRequireDefault(_ChatConstants);
	
	var _ChatMembers = __webpack_require__(987);
	
	var _ChatMembers2 = _interopRequireDefault(_ChatMembers);
	
	var _ChatMemberships = __webpack_require__(926);
	
	var _ChatMemberships2 = _interopRequireDefault(_ChatMemberships);
	
	var _ChatMessageActions = __webpack_require__(939);
	
	var _ChatMessageActions2 = _interopRequireDefault(_ChatMessageActions);
	
	var _ChatMessageStore = __webpack_require__(988);
	
	var _ChatMessageStore2 = _interopRequireDefault(_ChatMessageStore);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _ConnectionState = __webpack_require__(2251);
	
	var _ConnectionState2 = _interopRequireDefault(_ConnectionState);
	
	var _ConversationHeader = __webpack_require__(2252);
	
	var _ConversationHeader2 = _interopRequireDefault(_ConversationHeader);
	
	var _ConversationHeaderSidebarButton = __webpack_require__(2255);
	
	var _ConversationHeaderSidebarButton2 = _interopRequireDefault(_ConversationHeaderSidebarButton);
	
	var _ConversationSidebar = __webpack_require__(2256);
	
	var _ConversationSidebar2 = _interopRequireDefault(_ConversationSidebar);
	
	var _ConversationViewComposer = __webpack_require__(2286);
	
	var _ConversationViewComposer2 = _interopRequireDefault(_ConversationViewComposer);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getRoleDescriptionForChat = __webpack_require__(2302);
	
	var _getRoleDescriptionForChat2 = _interopRequireDefault(_getRoleDescriptionForChat);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _MessageList = __webpack_require__(2303);
	
	var _MessageList2 = _interopRequireDefault(_MessageList);
	
	var _ActivityShareModal = __webpack_require__(2261);
	
	var _ActivityShareModal2 = _interopRequireDefault(_ActivityShareModal);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _promptDialog = __webpack_require__(2086);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StudentsParentsDialog = __webpack_require__(2353);
	
	var _StudentsParentsDialog2 = _interopRequireDefault(_StudentsParentsDialog);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _UnreadStore = __webpack_require__(1030);
	
	var _UnreadStore2 = _interopRequireDefault(_UnreadStore);
	
	var _mountTymkPrompt = __webpack_require__(1464);
	
	var _mountTymkPrompt2 = _interopRequireDefault(_mountTymkPrompt);
	
	__webpack_require__(2354);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function checkLoadChats(chatId) {
	  var messages = _ChatMessageStore2.default.getChatMessages(chatId);
	  if (messages.isEmpty() && chatId) {
	    _ChatMessageActions2.default.loadChatMessages(chatId);
	  }
	}
	
	var ConversationView = exports.ConversationView = _react2.default.createClass({
	  displayName: 'ConversationView',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired,
	    group: _react2.default.PropTypes.instanceOf(_Group2.default).isRequired
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_ChatMessageStore2.default, _ChatStore2.default, _UnreadStore2.default])],
	
	  statics: {
	    onLeaveNewChat: function onLeaveNewChat() {
	      // Called when leaving the /new route, destroys the local chat
	      _ChatActions2.default.destroyLocal();
	    },
	    onEnter: function onEnter(nextState, replaceWith, callback) {
	      var params = nextState.params,
	          location = nextState.location;
	      var query = location.query;
	      var memberId = params.memberId,
	          chatId = params.chatId,
	          groupCode = params.groupCode;
	
	      // FIXME I think all we need use to put the 'announcements' route before the 'chatId' route
	      // We must perform this redirect here because we can't distinguish between 'announcements'
	      // and any other chatId -- even if there is an explicit route for /announcements(/), this
	      // onEnter will fire with chatId === 'announcements'
	
	      if (chatId === 'announcements') {
	        replaceWith({ pathname: '/classes/' + groupCode + '/messages/announcements/everyone', query: query });
	        callback();
	        return;
	      }
	
	      if (memberId) {
	        ConversationView.createLocalChat(memberId).then(callback);
	      } else if (chatId) {
	        var _chat = _ChatStore2.default.getChat(chatId);
	        if (_chat) {
	          callback();
	        } else {
	          _ChatActions2.default.loadChat(chatId).then(callback);
	        }
	      } else {
	        // this includes group chats, for which the local is already created
	        callback();
	      }
	    },
	    createLocalChat: function createLocalChat(memberIdStr) {
	      var memberId = parseInt(memberIdStr, 10);
	      var currentMember = _ChatMembers2.default.buildChatMember(_CurrentUser2.default.getUser());
	      return (0, _ChatPromises.promiseRelationship)(memberId).then(function (relationship) {
	        var member = _ChatMembers2.default.buildChatMember(relationship.getRelatedUser());
	        return _ChatActions2.default.loadLocal([member, currentMember], member.getName());
	      });
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    var chatId = this.props.params.chatId;
	
	    var chat = chatId ? _ChatStore2.default.getChat(chatId) : null;
	    var chatOrLocalChat = chat || _ChatStore2.default.getLocal();
	    var messages = chatId ? _ChatMessageStore2.default.getChatMessages(chatId).models.slice(0) : [];
	
	    return Object.assign(this.getChatState(chatOrLocalChat, messages), {
	      sidebar: false
	    });
	  },
	  componentWillMount: function componentWillMount() {
	    var chatId = this.props.params.chatId;
	
	    if (chatId) {
	      checkLoadChats(chatId);
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    (0, _Timer.markChange)('chat_open', 'chat_shown');
	
	    if (this.context.router.location.query.show === _ActivityShareModal.SHARE_MODAL) {
	      (0, _modal.mountModal)(_react2.default.createElement(_ActivityShareModal2.default, { activity: this.state.chat.getActivity() }), this);
	    }
	
	    if (this.shouldShowStudentParentCreateGroupModal()) {
	      (0, _modal.mountModal)(_react2.default.createElement(_StudentsParentsDialog2.default, { onOkay: this.onStudentsParentsDialogOkay }), this);
	      _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.SP_CREATE_GROUP_MODAL);
	    } else {
	      this.focusComposer();
	    }
	    _ConnectionState2.default.on('reconnect', this.handleReconnect);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState(this.getStateFromStores(nextProps)); // why?
	
	    var chatId = nextProps.params.chatId;
	
	    if (!chatId) {
	      return;
	    }
	
	    if (_ChatMessageStore2.default.shouldReloadMessages(chatId)) {
	      _ChatMessageActions2.default.loadChatMessages(chatId);
	    }
	    checkLoadChats(chatId);
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    // shallow state
	    var shallowKeys = ['chat', 'sidebar', 'unreadCount'];
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = shallowKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var key = _step.value;
	
	        if (this.state[key] !== nextState[key]) {
	          return true;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    if (!(0, _lodash.isEqual)(this.props.params, nextProps.params)) {
	      return true;
	    }
	
	    if (this.state.messages.length !== nextState.messages.length) {
	      return true;
	    }
	
	    var oldChatMemberships = this.state.chatMemberships;
	    var newChatMemberships = nextState.chatMemberships;
	    var membershipsHaveChanged = oldChatMemberships !== newChatMemberships || oldChatMemberships.length !== newChatMemberships.length || !!oldChatMemberships && !!newChatMemberships && oldChatMemberships.some(function (o, i) {
	      return !(0, _lodash.isEqual)(o.attributes, newChatMemberships.at(i).attributes);
	    });
	    if (membershipsHaveChanged) {
	      return true;
	    }
	
	    return false;
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    var _this = this;
	
	    if (prevProps.params.chatId === this.props.params.chatId) {
	      var currentLastMessage = this.state.messages[this.state.messages.length - 1];
	      var prevLastMessage = prevState.messages[prevState.messages.length - 1];
	      if (currentLastMessage !== prevLastMessage) {
	        (0, _Timer.markChange)('chat_open', 'last_message_shown');
	      }
	    } else {
	      // focusComposer() does not work without setTimeout(,1) after DOM update
	      setTimeout(function () {
	        _this.focusComposer();
	      }, 1);
	
	      // chatId changed
	      (0, _Timer.markChange)('chat_open', 'chat_shown');
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _ConnectionState2.default.removeListener('reconnect', this.handleReconnect);
	
	    // Clear local chat if we have not already before unmounting
	    if (_ChatStore2.default.hasLocal()) {
	      _ChatActions2.default.destroyLocal();
	    }
	  },
	  toggleSidebar: function toggleSidebar() {
	    this.setState(function (_ref) {
	      var sidebar = _ref.sidebar;
	      return { sidebar: !sidebar };
	    });
	  },
	  onStudentsParentsDialogOkay: function onStudentsParentsDialogOkay() {
	    this.context.router.push('/classes'); // almost certainly incorrect
	  },
	  getChatState: function getChatState(chat, messages) {
	    return {
	      chat: chat,
	      chatMemberships: chat.getMemberships(),
	      messages: messages,
	      unreadCount: chat.isNew() ? 0 : _UnreadStore2.default.getUnreadCount(chat.id)
	    };
	  },
	
	
	  // $FlowIssue default value
	  getStateFromStores: function getStateFromStores() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	    var chatId = props.params.chatId;
	
	
	    var chat = chatId ? _ChatStore2.default.getChat(chatId) : null;
	    var chatOrLocalChat = chat || _ChatStore2.default.getLocal();
	    var nextMessages = chatId ? _ChatMessageStore2.default.getChatMessages(chatId).models.slice(0) : [];
	
	    // Do not change state for null chat
	
	    var _ref2 = chatOrLocalChat ? [chatOrLocalChat, nextMessages] : [this.state.chat, this.state.messages],
	        _ref3 = _slicedToArray(_ref2, 2),
	        stateChat = _ref3[0],
	        stateMessages = _ref3[1];
	
	    return this.getChatState(stateChat, stateMessages);
	  },
	
	
	  // Invoked upon message send in a new chat thread, this creates the chat thread
	  // on the server, and destroys the local chat
	  initialize: function initialize(text, files) {
	    var _this2 = this;
	
	    var sender = _CurrentUser2.default.getUser();
	    var group = this.context.group;
	
	    var originGroupId = group.id > 0 ? group.id : null;
	    var message = _ChatMessage.ChatMessage.create(text, files, this.state.chat, sender, 0, 'text', null, originGroupId);
	    return _ChatActions2.default.createChat(this.state.chat, message).then(function (chat) {
	      _this2.context.router.replace('/classes/' + group.getCode() + '/messages/' + chat.id);
	      _ChatActions2.default.destroyLocal();
	      (0, _mountTymkPrompt2.default)(_this2, 'send_chat');
	    }).catch(function (error) {
	      if (error && ['no_solo_chats', 'max_memberships'].indexOf(error.code) > -1) {
	        _ToastActions2.default.showErrorToast(error.message);
	      } else {
	        throw error;
	      }
	    });
	  },
	
	
	  // If no chatId is passed in the url, this must be a new chat thread
	  isNewConversation: function isNewConversation() {
	    var params = this.props.params;
	
	    return !params || !params.chatId;
	  },
	  loadMoreMessages: function loadMoreMessages(message) {
	    _ChatMessageActions2.default.fillGap(message);
	  },
	  focusComposer: function focusComposer() {
	    // Check for truthy refs.composer is defensive, focusComposer is used in a setTimeout()
	    if (_ChatStore2.default.getFocusView() === _ChatConstants2.default.FocusableViews.COMPOSER && this.refs.composer) {
	      this.refs.composer.getWrappedInstance().focus();
	    }
	  },
	  handleReconnect: function handleReconnect() {
	    var chatId = this.props.params.chatId;
	
	    _ChatMessageActions2.default.loadChatMessages(chatId);
	  },
	  openSideBar: function openSideBar() {
	    if (!this.state.sidebar) {
	      this.toggleSidebar();
	    }
	  },
	  sendMessage: function sendMessage(text, files) {
	    var _this3 = this;
	
	    var sender = _CurrentUser2.default.getUser();
	    var lastMessage = _ChatMessageStore2.default.getChatMessages(this.state.chat.id).last();
	    var seq = lastMessage ? lastMessage.getSeq() + 1 : 1;
	    var group = this.context.group;
	
	    var originGroupId = group.id > 0 ? group.id : null;
	    var message = _ChatMessage.ChatMessage.create(text, files, this.state.chat, sender, seq, 'text', null, originGroupId);
	
	    _ChatMessageActions2.default.sendMessage(message).then(function () {
	      (0, _promptDialog.showPromptDialog)(_PromptConstants.PromptNames.DESKTOP_NOTIFICATION_MODAL, 'sent_chat', _this3);
	    });
	
	    (0, _mountTymkPrompt2.default)(this, 'send_chat');
	    this.refs.messageList.scrollToBottom();
	  },
	  shouldShowStudentParentCreateGroupModal: function shouldShowStudentParentCreateGroupModal() {
	    return _CurrentUser2.default.getUser().getPromptsInventory().find(function (i) {
	      return i.get('action') === _PromptConstants.PromptNames.SP_CREATE_GROUP_MODAL;
	    }) && !_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.SP_CREATE_GROUP_MODAL);
	  },
	  chatHasSidebar: function chatHasSidebar() {
	    return !this.state.chat.isNew();
	  },
	  updateUnread: function updateUnread() {
	    var chat = this.state.chat;
	
	    if (this.state.unreadCount > 0) {
	      var lastMessage = this.state.messages[this.state.messages.length - 1];
	      if (lastMessage) {
	        chat.markAsReadForAssociatedGroups(_UnreadStore2.default);
	        // $FlowIssue
	        _ChatActions2.default.markReadUpto(chat.id, lastMessage.getSeq());
	      }
	    }
	  },
	  renderSideBar: function renderSideBar() {
	    if (!this.state.sidebar) {
	      return null;
	    }
	
	    var chat = this.state.chat;
	
	
	    return _react2.default.createElement(_ConversationSidebar2.default, {
	      className: 'ConversationView-body-sidebar',
	      chat: chat
	    });
	  },
	  renderHeaderButtons: function renderHeaderButtons() {
	    var chat = this.state.chat;
	
	    return this.chatHasSidebar() && _react2.default.createElement(_ConversationHeaderSidebarButton2.default, {
	      chat: chat,
	      className: 'ConversationView-header-sidebarButton',
	      sidebar: this.state.sidebar,
	      onSideBarToggle: this.toggleSidebar
	    });
	  },
	  render: function render() {
	    var chat = this.state.chat;
	
	    if (!chat) {
	      return null;
	    }
	
	    var header = void 0;
	    var isActivity = chat.isActivityType();
	
	    if (isActivity) {
	      header = _react2.default.createElement(_ActivityConversationHeader2.default, {
	        ref: 'header',
	        chat: chat,
	        sidebar: this.state.sidebar,
	        activity: chat.getActivity(),
	        className: 'ConversationView-header-activity-sender',
	        onSideBarToggle: this.toggleSidebar
	      });
	    } else {
	      header = _react2.default.createElement(
	        'div',
	        { ref: 'header' },
	        _react2.default.createElement(
	          _ConversationHeader2.default,
	          {
	            chat: chat,
	            sidebar: this.state.sidebar,
	            subtitle: (0, _getRoleDescriptionForChat2.default)(chat),
	            onTitleClicked: this.chatHasSidebar() ? this.toggleSidebar : null },
	          this.renderHeaderButtons()
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('ConversationView', this.props.className) },
	      header,
	      _react2.default.createElement(
	        'div',
	        { className: 'ConversationView-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ConversationView-body-wrap' },
	          _react2.default.createElement(_MessageList2.default, {
	            ref: 'messageList',
	            className: 'ConversationView-body-messageList',
	            chat: chat,
	            unreadCount: this.state.unreadCount,
	            messages: this.state.messages,
	            loadMoreMessages: this.loadMoreMessages,
	            onScrollToBottom: this.updateUnread
	          }),
	          _react2.default.createElement(_ConversationViewComposer2.default, {
	            ref: 'composer',
	            className: 'ConversationView-body-composer',
	            chat: chat,
	            onMessageSend: this.isNewConversation() ? this.initialize : this.sendMessage,
	            openSideBar: this.openSideBar
	          })
	        ),
	        this.renderSideBar()
	      )
	    );
	  }
	});
	
	exports.default = ConversationView;

/***/ },
/* 2229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActivityConversationHeader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SimpleDateIcon = __webpack_require__(2230);
	
	var _SimpleDateIcon2 = _interopRequireDefault(_SimpleDateIcon);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _ActivityConversationHeaderManageButton = __webpack_require__(2233);
	
	var _ActivityConversationHeaderManageButton2 = _interopRequireDefault(_ActivityConversationHeaderManageButton);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _RSVPDialogContainer = __webpack_require__(2234);
	
	var _RSVPDialogContainer2 = _interopRequireDefault(_RSVPDialogContainer);
	
	var _RSVPDropdownContainer = __webpack_require__(2245);
	
	var _RSVPDropdownContainer2 = _interopRequireDefault(_RSVPDropdownContainer);
	
	var _modal = __webpack_require__(1188);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _TimeRange = __webpack_require__(1937);
	
	var _TimeRange2 = _interopRequireDefault(_TimeRange);
	
	__webpack_require__(2249);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line
	
	
	var ActivityConversationHeader = exports.ActivityConversationHeader = function (_React$Component) {
	  _inherits(ActivityConversationHeader, _React$Component);
	
	  function ActivityConversationHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityConversationHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityConversationHeader.__proto__ || Object.getPrototypeOf(ActivityConversationHeader)).call.apply(_ref, [this].concat(args))), _this), _this.onRSVP = function (rsvp) {
	      (0, _modal.mountModal)(_react2.default.createElement(_RSVPDialogContainer2.default, {
	        initialRSVP: rsvp,
	        activityId: _this.props.activity.id
	      }), _this);
	    }, _this.getResponseURL = function (sort) {
	      return 'activities/' + _this.props.activity.id + '?sort=' + sort;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityConversationHeader, [{
	    key: 'renderRsvpSelector',
	    value: function renderRsvpSelector() {
	      var activity = this.props.activity;
	
	
	      if (activity.isClosed()) {
	        return _react2.default.createElement('span', null);
	      }
	
	      return _react2.default.createElement(_RSVPDropdownContainer2.default, { activity: activity, onRSVPChange: this.onRSVP, 'data-test': 'rsvp-dropdown-container' });
	    }
	  }, {
	    key: 'renderHeroImageSection',
	    value: function renderHeroImageSection() {
	      var activity = this.props.activity;
	
	      var cover = activity.getCover();
	
	      var style = {
	        backgroundImage: 'url(' + cover.image + ')',
	        backgroundSize: 'auto 100px',
	        backgroundPosition: 'top center'
	      };
	
	      return _react2.default.createElement('div', { className: 'ActivityConversationHeader-hero', style: style });
	    }
	  }, {
	    key: 'renderSenderSubtitle',
	    value: function renderSenderSubtitle() {
	      var activity = this.props.activity;
	
	      var summary = activity.getRecipientSummary();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityConversationHeader-rsvpInformation' },
	        _react2.default.createElement(
	          _Link2.default,
	          { to: this.getResponseURL('yes'), color: 'eclipse' },
	          _react2.default.createElement(
	            'span',
	            null,
	            summary.getAttendingCount(),
	            ' Yes'
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'ActivityConversationHeader-separator' },
	          '|'
	        ),
	        _react2.default.createElement(
	          _Link2.default,
	          { to: this.getResponseURL('maybe'), color: 'eclipse' },
	          _react2.default.createElement(
	            'span',
	            null,
	            summary.getMaybeCount(),
	            ' Maybe'
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'ActivityConversationHeader-separator' },
	          '|'
	        ),
	        _react2.default.createElement(
	          _Link2.default,
	          { to: this.getResponseURL('no'), color: 'eclipse' },
	          _react2.default.createElement(
	            'span',
	            null,
	            summary.getNotAttendingCount(),
	            ' No'
	          )
	        ),
	        !activity.isClosed() && activity.isOrHasCollectedMoneyOnline() && _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'ActivityConversationHeader-separator' },
	            '|'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'ActivityConversationHeader-subSection-header-moneyCollected' },
	            _react2.default.createElement(_Money2.default, { cents: activity.getTotalCollected() }),
	            ' Collected'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderParticipantSubtitle',
	    value: function renderParticipantSubtitle() {
	      var activity = this.props.activity;
	
	      var text = activity.isClosed() ? 'Activity is closed' : 'Organized by ' + activity.getRequester().getDisplayName();
	      return _react2.default.createElement(
	        'div',
	        null,
	        text
	      );
	    }
	  }, {
	    key: 'renderRespondedSection',
	    value: function renderRespondedSection() {
	      var activity = this.props.activity;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityConversationHeader-subSection-infos' },
	        !activity.isSender() && this.renderRsvpSelector(),
	        _react2.default.createElement(_ActivityConversationHeaderManageButton2.default, {
	          activity: activity,
	          size: 'xsmall',
	          level: 'secondary'
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            size: 'xsmall',
	            level: 'secondary',
	            onClick: this.props.onSideBarToggle },
	          _react2.default.createElement(_Glyph2.default, { name: 'ellipses', solo: true })
	        )
	      );
	    }
	  }, {
	    key: 'renderUnRespondedSection',
	    value: function renderUnRespondedSection() {
	      var activity = this.props.activity;
	
	      var startAt = activity.getStartAt();
	      var cost = activity.isFree() ? _react2.default.createElement(
	        'span',
	        null,
	        ' Free '
	      ) : _react2.default.createElement(_Money2.default, { cents: activity.getAmountPerPerson() });
	      var location = activity.getLocation();
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityConversationHeader-summaryContainer', 'data-test': 'rsvp-unresponded-section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityConversationHeader-summary' },
	          startAt && _react2.default.createElement(
	            _MediaObject2.default,
	            { className: 'ActivityConversationHeader-summary-time', gutter: 'small' },
	            _react2.default.createElement(_Glyph2.default, { color: 'thunder', name: 'calendar' }),
	            _react2.default.createElement(
	              _Text2.default,
	              { color: 'thunder' },
	              _react2.default.createElement(_TimeRange2.default, {
	                start: startAt,
	                end: activity.getEndAt(),
	                month: 'long',
	                year: 'numeric',
	                day: 'numeric',
	                hour: 'numeric',
	                minute: 'numeric'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _MediaObject2.default,
	            { className: 'ActivityConversationHeader-summary-cost', gutter: 'small' },
	            _react2.default.createElement(_Glyph2.default, { name: 'dollar-circle', color: 'thunder' }),
	            _react2.default.createElement(
	              _Text2.default,
	              { element: 'span', color: 'thunder' },
	              cost
	            )
	          )
	        ),
	        location && _react2.default.createElement(
	          _MediaObject2.default,
	          { gutter: 'small' },
	          _react2.default.createElement(_Glyph2.default, { color: 'thunder', name: 'location-pin' }),
	          _react2.default.createElement(
	            _Text2.default,
	            { className: 'ActivityConversationHeader-summary-location', color: 'thunder', truncate: true },
	            activity.getLocation()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSubSection',
	    value: function renderSubSection() {
	      var _props = this.props,
	          activity = _props.activity,
	          activityRecipient = _props.activityRecipient;
	
	      var startAt = activity.getStartAt();
	      var infoSection = void 0;
	      if (activityRecipient) {
	        infoSection = activityRecipient.getAttendance() === 'pending' ? this.renderUnRespondedSection() : this.renderRespondedSection();
	      } else if (activity.isSender()) {
	        infoSection = this.renderRespondedSection();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityConversationHeader-subSection' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityConversationHeader-subSection-dateAndTitle' },
	          startAt && _react2.default.createElement(_SimpleDateIcon2.default, {
	            className: 'ActivityConversationHeader-date',
	            date: startAt
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'ActivityConversationHeader-subSection-header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ActivityConversationHeader-subSection-header-title' },
	              activity.getTitle()
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'ActivityConversationHeader-subSection-header-subtitle' },
	              activity.isSender() ? this.renderSenderSubtitle() : this.renderParticipantSubtitle()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          infoSection
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ActivityConversationHeader', this.props.className) },
	        this.renderHeroImageSection(),
	        this.renderSubSection()
	      );
	    }
	  }]);
	
	  return ActivityConversationHeader;
	}(_react2.default.Component);
	
	ActivityConversationHeader.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ActivityConversationHeader.displayName = 'ActivityConversationHeader';
	
	
	function mapStateToProps(state, props) {
	  var activity = props.chat.getActivity();
	  if (activity && activity.id) {
	    var activityObj = state.activityRecipients.activities[activity.id] || {};
	    return {
	      activityRecipient: activityObj.currentUserRecipient
	    };
	  }
	  return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ActivityConversationHeader);

/***/ },
/* 2230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleDateIcon = function (_React$Component) {
	  _inherits(SimpleDateIcon, _React$Component);
	
	  function SimpleDateIcon() {
	    _classCallCheck(this, SimpleDateIcon);
	
	    return _possibleConstructorReturn(this, (SimpleDateIcon.__proto__ || Object.getPrototypeOf(SimpleDateIcon)).apply(this, arguments));
	  }
	
	  _createClass(SimpleDateIcon, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('SimpleDateIcon', this.props.className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'SimpleDateIcon-month' },
	          _react2.default.createElement(
	            _Text2.default,
	            this.props.monthTextProps,
	            _react2.default.createElement(_Time2.default, { date: this.props.date, month: 'short' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'SimpleDateIcon-day' },
	          _react2.default.createElement(
	            _Text2.default,
	            this.props.dayTextProps,
	            _react2.default.createElement(_Time2.default, { date: this.props.date, day: 'numeric' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SimpleDateIcon;
	}(_react2.default.Component);
	
	SimpleDateIcon.displayName = 'SimpleDateIcon';
	exports.default = SimpleDateIcon;

/***/ },
/* 2231 */
1136,
/* 2232 */,
/* 2233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _RSVPDialogContainer = __webpack_require__(2234);
	
	var _RSVPDialogContainer2 = _interopRequireDefault(_RSVPDialogContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityConversationHeaderManageButton = function (_React$Component) {
	  _inherits(ActivityConversationHeaderManageButton, _React$Component);
	
	  function ActivityConversationHeaderManageButton() {
	    _classCallCheck(this, ActivityConversationHeaderManageButton);
	
	    return _possibleConstructorReturn(this, (ActivityConversationHeaderManageButton.__proto__ || Object.getPrototypeOf(ActivityConversationHeaderManageButton)).apply(this, arguments));
	  }
	
	  _createClass(ActivityConversationHeaderManageButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activity = _props.activity,
	          rest = _objectWithoutProperties(_props, ['activity']);
	
	      if (activity.isSender()) {
	        return _react2.default.createElement(
	          _Button2.default,
	          _extends({}, rest, { to: '/activities/' + activity.id }),
	          'Details'
	        );
	      } else {
	        return _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: _react2.default.createElement(_RSVPDialogContainer2.default, { activityId: this.props.activity.id }) },
	          _react2.default.createElement(
	            _Button2.default,
	            rest,
	            'Details'
	          )
	        );
	      }
	    }
	  }]);
	
	  return ActivityConversationHeaderManageButton;
	}(_react2.default.Component);
	
	ActivityConversationHeaderManageButton.displayName = 'ActivityConversationHeaderManageButton';
	exports.default = ActivityConversationHeaderManageButton;

/***/ },
/* 2234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RSVPDialog = __webpack_require__(2235);
	
	var _RSVPDialog2 = _interopRequireDefault(_RSVPDialog);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _activityRecipients = __webpack_require__(2238);
	
	var actions = _interopRequireWildcard(_activityRecipients);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line
	// eslint-disable-line
	
	
	var RSVPDialogContainer = function (_React$Component) {
	  _inherits(RSVPDialogContainer, _React$Component);
	
	  function RSVPDialogContainer() {
	    _classCallCheck(this, RSVPDialogContainer);
	
	    return _possibleConstructorReturn(this, (RSVPDialogContainer.__proto__ || Object.getPrototypeOf(RSVPDialogContainer)).apply(this, arguments));
	  }
	
	  _createClass(RSVPDialogContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.state.activity) {
	        _ActivityActions2.default.loadByUuid(this.props.activityId);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.activity) {
	        return _react2.default.createElement(_CenteredLoadingIndicator2.default, null);
	      }
	
	      return _react2.default.createElement(_RSVPDialog2.default, {
	        isUnderage: this.state.isUnderage,
	        activity: this.state.activity,
	        initialRSVP: this.props.initialRSVP,
	        onRequestHide: this.props.onRequestHide,
	        activityRecipient: this.props.activityRecipient,
	        updateLocalActivityRecipient: this.props.updateLocalActivityRecipient
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ActivityStore2.default, _CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      return {
	        activity: _ActivityStore2.default.getActivityById(props.activityId),
	        isUnderage: !!(_CurrentUser2.default.isSignedIn() && _CurrentUser2.default.getUser().isUnderage())
	      };
	    }
	  }]);
	
	  return RSVPDialogContainer;
	}(_react2.default.Component);
	
	RSVPDialogContainer.displayName = 'RSVPDialogContainer';
	
	
	function mapStateToProps(state, props) {
	  var activity = state.activityRecipients.activities[props.activityId] || {};
	
	  return {
	    activityRecipient: activity.currentUserRecipient
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    updateLocalActivityRecipient: actions.updateLocalCurrentUserActivityResponse
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_utils.Container.create(RSVPDialogContainer, { withProps: true }));

/***/ },
/* 2235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _RSVPFlow = __webpack_require__(1940);
	
	var _RSVPFlow2 = _interopRequireDefault(_RSVPFlow);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _PaymentViewSideInformation = __webpack_require__(1935);
	
	var _PaymentViewSideInformation2 = _interopRequireDefault(_PaymentViewSideInformation);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	__webpack_require__(2236);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	// eslint-disable-line
	// eslint-disable-line
	
	var RSVPDialog = function (_React$Component) {
	  _inherits(RSVPDialog, _React$Component);
	
	  function RSVPDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RSVPDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RSVPDialog.__proto__ || Object.getPrototypeOf(RSVPDialog)).call.apply(_ref, [this].concat(args))), _this), _this.onActivityRecipientUpdated = function (recipient) {
	      _this.props.updateLocalActivityRecipient(_this.props.activity.id, recipient);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RSVPDialog, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        isModal: true,
	        onRequestHide: this.props.onRequestHide
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activity = _props.activity,
	          isUnderage = _props.isUnderage,
	          initialRSVP = _props.initialRSVP,
	          onRequestHide = _props.onRequestHide,
	          activityRecipient = _props.activityRecipient,
	          rest = _objectWithoutProperties(_props, ['activity', 'isUnderage', 'initialRSVP', 'onRequestHide', 'activityRecipient']);
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'RSVPDialog'
	        }, rest, {
	          size: 'xlarge',
	          onRequestHide: onRequestHide,
	          className: 'RSVPDialog' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'RSVPDialog-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'RSVPDialog-content-rsvp' },
	            _react2.default.createElement(_RSVPFlow2.default, {
	              activity: activity,
	              isUnderage: isUnderage,
	              initialRSVP: initialRSVP,
	              initialActivityRecipient: activityRecipient,
	              onActivityRecipientUpdated: this.onActivityRecipientUpdated
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'RSVPDialog-content-info' },
	            _react2.default.createElement(_PaymentViewSideInformation2.default, { activity: activity })
	          )
	        )
	      );
	    }
	  }]);
	
	  return RSVPDialog;
	}(_react2.default.Component);
	
	RSVPDialog.childContextTypes = {
	  isModal: _react2.default.PropTypes.bool,
	  onRequestHide: _react2.default.PropTypes.func
	};
	RSVPDialog.displayName = 'RSVPDialog';
	exports.default = RSVPDialog;

/***/ },
/* 2236 */
1136,
/* 2237 */,
/* 2238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.loadActivityRecipients = loadActivityRecipients;
	exports.loadActivityRecipientsSuccess = loadActivityRecipientsSuccess;
	exports.loadCurrentUserActivityResponse = loadCurrentUserActivityResponse;
	exports.updateLocalCurrentUserActivityResponse = updateLocalCurrentUserActivityResponse;
	exports.loadCurrentUserActivityResponseSuccess = loadCurrentUserActivityResponseSuccess;
	exports.patchActivityRecipient = patchActivityRecipient;
	exports.patchActivityRecipientSuccess = patchActivityRecipientSuccess;
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _ActivityRecipients = __webpack_require__(910);
	
	var _ActivityRecipients2 = _interopRequireDefault(_ActivityRecipients);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = exports.initialState = {
	  activities: {}
	};
	
	function updateActivity(state, activityId, values) {
	  return {
	    activities: _extends({}, state.activities, _defineProperty({}, activityId, _extends({}, state.activities[activityId], values)))
	  };
	}
	
	function updateActivityRecipient(state, activityId, activityRecipient) {
	  var activity = state.activities[activityId] || {};
	  var recipients = activity.recipients || new _ActivityRecipients2.default();
	
	  recipients.add(activityRecipient);
	  return updateActivity(state, activityId, { recipients: recipients });
	}
	
	// typecheck: ignore statement
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'activityRecipients/CURRENT_USER_ACTIVITY_SUCCESS':
	    case 'activityRecipients/UPDATE_LOCAL_CURRENT_USER_ACTIVITY':
	      return updateActivity(state, action.activityId, {
	        currentUserRecipient: action.activityRecipient,
	        loadingCurrentUserRecipient: false
	      });
	    case 'activities/LOAD_ACTIVITIES_SUCCESS':
	      return action.activities.models.reduce(function (newState, activity) {
	        return updateActivity(newState, activity.id, {
	          currentUserRecipient: activity.get('viewing_user_response'),
	          loadingCurrentUserRecipient: false
	        });
	      }, state);
	    case 'activityRecipients/ACTIVITY_RECIPIENTS_SUCCESS':
	      return updateActivity(state, action.activityId, {
	        recipients: action.activityRecipients,
	        loadingRecipients: false
	      });
	    case 'activityRecipients/CURRENT_USER_ACTIVITY_RESPONSE_REQUEST':
	      return updateActivity(state, action.activityId, {
	        loadingCurrentUserRecipient: true
	      });
	    case 'activityRecipients/ACTIVITY_RECIPIENTS_REQUEST':
	      return updateActivity(state, action.activityId, {
	        loadingRecipients: true
	      });
	    case 'activityRecipients/PATCH_ACTIVITY_RECIPIENT_REQUEST_SUCCESS':
	      return updateActivityRecipient(state, action.activityId, action.activityRecipient);
	    case 'chats/LOAD_CHAT':
	    case 'chats/APPEND_CHATS':
	    case 'chats/LIST_CHATS':
	      var chats = action.chats || [action.chat];
	      var activityChats = chats.filter(function (chat) {
	        return chat.isActivityType();
	      });
	
	      if (activityChats.length === 0) {
	        return state;
	      }
	      return activityChats.reduce(function (newState, chat) {
	        var chatActivity = chat.getActivity();
	        return updateActivity(newState, chatActivity.id, {
	          currentUserRecipient: chatActivity.get('viewing_user_response'),
	          loadingCurrentUserRecipient: false
	        });
	      }, state);
	    default:
	      return state;
	  }
	}
	
	function loadActivityRecipients(activityId) {
	  return {
	    type: 'activityRecipients/ACTIVITY_RECIPIENTS_REQUEST',
	    activityId: activityId
	  };
	}
	
	function loadActivityRecipientsSuccess(activityId, activityRecipients) {
	  return {
	    type: 'activityRecipients/ACTIVITY_RECIPIENTS_SUCCESS',
	    activityRecipients: activityRecipients,
	    activityId: activityId
	  };
	}
	
	function loadCurrentUserActivityResponse(activityId) {
	  return {
	    type: 'activityRecipients/CURRENT_USER_ACTIVITY_RESPONSE_REQUEST',
	    activityId: activityId
	  };
	}
	
	function updateLocalCurrentUserActivityResponse(activityId, activityRecipient) {
	  return {
	    type: 'activityRecipients/UPDATE_LOCAL_CURRENT_USER_ACTIVITY',
	    activityRecipient: activityRecipient,
	    activityId: activityId
	  };
	}
	
	function loadCurrentUserActivityResponseSuccess(activityRecipient, activityId) {
	  return {
	    type: 'activityRecipients/CURRENT_USER_ACTIVITY_SUCCESS',
	    activityRecipient: activityRecipient,
	    activityId: activityId
	  };
	}
	
	function patchActivityRecipient(activityId, recipientId, data) {
	  return {
	    type: 'activityRecipients/PATCH_ACTIVITY_RECIPIENT_REQUEST',
	    activityId: activityId,
	    recipientId: recipientId,
	    data: data
	  };
	}
	
	function patchActivityRecipientSuccess(activityId, activityRecipient) {
	  return {
	    type: 'activityRecipients/PATCH_ACTIVITY_RECIPIENT_REQUEST_SUCCESS',
	    activityRecipient: activityRecipient,
	    activityId: activityId
	  };
	}

/***/ },
/* 2239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CenteredContainer = __webpack_require__(2240);
	
	var _CenteredContainer2 = _interopRequireDefault(_CenteredContainer);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// A loading indicator that's centered vertically and horizontally.
	
	
	var CenteredLoadingIndicator = function (_React$Component) {
	  _inherits(CenteredLoadingIndicator, _React$Component);
	
	  function CenteredLoadingIndicator() {
	    _classCallCheck(this, CenteredLoadingIndicator);
	
	    return _possibleConstructorReturn(this, (CenteredLoadingIndicator.__proto__ || Object.getPrototypeOf(CenteredLoadingIndicator)).apply(this, arguments));
	  }
	
	  _createClass(CenteredLoadingIndicator, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _CenteredContainer2.default,
	        { className: 'CenteredLoadingIndicator-container' },
	        _react2.default.createElement(_LoadingIndicator2.default, null)
	      );
	    }
	  }]);
	
	  return CenteredLoadingIndicator;
	}(_react2.default.Component);
	
	CenteredLoadingIndicator.displayName = 'CenteredLoadingIndicator';
	exports.default = CenteredLoadingIndicator;

/***/ },
/* 2240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CenteredContainer = function (_React$Component) {
	  _inherits(CenteredContainer, _React$Component);
	
	  function CenteredContainer() {
	    _classCallCheck(this, CenteredContainer);
	
	    return _possibleConstructorReturn(this, (CenteredContainer.__proto__ || Object.getPrototypeOf(CenteredContainer)).apply(this, arguments));
	  }
	
	  _createClass(CenteredContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('CenteredContainer', this.props.className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'CenteredContainer-wrap' },
	          _react2.default.createElement(
	            _Container2.default,
	            this.props,
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return CenteredContainer;
	}(_react2.default.Component);
	
	CenteredContainer.displayName = 'CenteredContainer';
	exports.default = CenteredContainer;

/***/ },
/* 2241 */
1136,
/* 2242 */,
/* 2243 */
1136,
/* 2244 */,
/* 2245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _activityRecipients = __webpack_require__(2238);
	
	var actions = _interopRequireWildcard(_activityRecipients);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RSVPDropdown = __webpack_require__(2246);
	
	var _RSVPDropdown2 = _interopRequireDefault(_RSVPDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RSVPDropdownContainer = function (_React$Component) {
	  _inherits(RSVPDropdownContainer, _React$Component);
	
	  function RSVPDropdownContainer() {
	    _classCallCheck(this, RSVPDropdownContainer);
	
	    return _possibleConstructorReturn(this, (RSVPDropdownContainer.__proto__ || Object.getPrototypeOf(RSVPDropdownContainer)).apply(this, arguments));
	  }
	
	  _createClass(RSVPDropdownContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.activityRecipient && this.props.loadCurrentUserActivityResponse) {
	        this.props.loadCurrentUserActivityResponse(this.props.activity.id);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RSVPDropdown2.default, this.props);
	    }
	  }]);
	
	  return RSVPDropdownContainer;
	}(_react2.default.Component);
	
	RSVPDropdownContainer.displayName = 'RSVPDropdownContainer';
	
	
	function mapStateToProps(state, props) {
	  var activity = state.activityRecipients.activities[props.activity.id] || {};
	  return {
	    activityRecipient: activity.currentUserRecipient
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch
	// $FlowIssue
	) {
	  return (0, _redux.bindActionCreators)({
	    loadCurrentUserActivityResponse: actions.loadCurrentUserActivityResponse
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RSVPDropdownContainer);

/***/ },
/* 2246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	__webpack_require__(2247);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RSVPDropdown = function (_React$Component) {
	  _inherits(RSVPDropdown, _React$Component);
	
	  function RSVPDropdown() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RSVPDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RSVPDropdown.__proto__ || Object.getPrototypeOf(RSVPDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.onRSVPYes = function () {
	      _this.props.onRSVPChange('yes');
	    }, _this.onRSVPNo = function () {
	      _this.props.onRSVPChange('no');
	    }, _this.onRSVPMaybe = function () {
	      _this.props.onRSVPChange('maybe');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RSVPDropdown, [{
	    key: 'renderMenu',
	    value: function renderMenu() {
	      return _react2.default.createElement(
	        _Menu2.default,
	        null,
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: this.onRSVPYes },
	          'Yes'
	        ),
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: this.onRSVPMaybe },
	          'Maybe'
	        ),
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: this.onRSVPNo },
	          'No'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var activityRecipient = this.props.activityRecipient;
	
	      var attendance = activityRecipient ? activityRecipient.getAttendance() : 'pending';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'RSVPDropdown' },
	        _react2.default.createElement(
	          _LayerTrigger2.default,
	          {
	            layer: this.renderMenu(),
	            trigger: 'click',
	            alignment: 'right',
	            placement: 'bottom' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              size: 'xsmall',
	              level: 'secondary' },
	            _react2.default.createElement(
	              'span',
	              null,
	              attendance === 'pending' ? 'RSVP' : (0, _lodash.capitalize)(attendance)
	            ),
	            _react2.default.createElement(_Glyph2.default, { name: 'chevron-down' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return RSVPDropdown;
	}(_react2.default.Component);
	
	RSVPDropdown.displayName = 'RSVPDropdown';
	exports.default = RSVPDropdown;

/***/ },
/* 2247 */
1136,
/* 2248 */,
/* 2249 */
1136,
/* 2250 */,
/* 2251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AppConstants = __webpack_require__(989);
	
	var _PusherConstants = __webpack_require__(954);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConnectionState = function (_Store) {
	  _inherits(ConnectionState, _Store);
	
	  function ConnectionState() {
	    _classCallCheck(this, ConnectionState);
	
	    return _possibleConstructorReturn(this, (ConnectionState.__proto__ || Object.getPrototypeOf(ConnectionState)).apply(this, arguments));
	  }
	
	  _createClass(ConnectionState, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        connectionState: 'connected',
	        pusherState: 'connected',
	        hasRetriedConn: false
	      };
	    }
	  }, {
	    key: 'isConnected',
	    value: function isConnected() {
	      return this.state.connectionState === 'connected' && this.state.pusherState === 'connected';
	    }
	  }, {
	    key: 'isConnecting',
	    value: function isConnecting() {
	      return this.state.connectionState === 'connecting' || this.state.pusherState === 'connecting';
	    }
	  }, {
	    key: 'getPusherState',
	    value: function getPusherState() {
	      return this.state.pusherState;
	    }
	  }, {
	    key: 'hasRetriedConnection',
	    value: function hasRetriedConnection() {
	      return this.state.hasRetriedConn;
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _AppConstants.ActionTypes.CONNECTION_STATE_CHANGED:
	          this.handleConnectionStateChanged(action.previous, action.current);
	          break;
	        case _PusherConstants.PushEvents.CONNECTION_STATE_CHANGED:
	          this.handlePusherStateChanged(action.previous, action.current);
	          break;
	        case _PusherConstants.PushEvents.RETRY_CONNECTION:
	          this.handleRetryConnection();
	          break;
	        case _PusherConstants.PushEvents.RESET_STORE:
	          this.state = this.getInitialState();
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handleConnectionStateChanged',
	    value: function handleConnectionStateChanged(previous, current) {
	      this.state.connectionState = current;
	      if (current === 'connected') {
	        this.emit('reconnect');
	        this.state.hasRetriedConn = false;
	      }
	      this.emitChange();
	    }
	  }, {
	    key: 'handlePusherStateChanged',
	    value: function handlePusherStateChanged(previous, current) {
	      this.state.pusherState = current;
	      if (current === 'connected') {
	        this.emit('reconnect');
	        this.state.hasRetriedConn = false;
	      }
	      this.emitChange();
	    }
	  }, {
	    key: 'handleRetryConnection',
	    value: function handleRetryConnection() {
	      this.state.hasRetriedConn = true;
	      this.emitChange();
	    }
	  }]);
	
	  return ConnectionState;
	}(_Store3.default);
	
	ConnectionState.displayName = 'ConnectionState';
	exports.default = new ConnectionState();

/***/ },
/* 2252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _HumanArray = __webpack_require__(2222);
	
	var _HumanArray2 = _interopRequireDefault(_HumanArray);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(2253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConversationHeader = _react2.default.createClass({
	  displayName: 'ConversationHeader',
	  getInitialState: function getInitialState() {
	    return {
	      partner: this.props.chat && this.props.chat.getOtherChatMembers()[0]
	    };
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    if (this.props.chat && nextProps.chat && this.props.chat.id !== nextProps.chat.id) {
	      this.setState(this.getInitialState());
	    }
	  },
	  shouldHideToastsFn: function shouldHideToastsFn() {
	    return !_Modal2.default.getCurrent();
	  },
	  renderParticipantNames: function renderParticipantNames() {
	    var names = this.props.chat.getDisplayNames();
	    return _react2.default.createElement(
	      _Text2.default,
	      { size: 'large', truncate: true },
	      _react2.default.createElement(_HumanArray2.default, { sample: names, total: names.length })
	    );
	  },
	  render: function render() {
	    var _props = this.props,
	        chat = _props.chat,
	        title = _props.title,
	        subtitle = _props.subtitle;
	
	    var partnerLeft = chat && chat.isPresent() && !!this.props.chat.getLeftMemberships()[0];
	    var participantNames = null;
	    var titleTextSize = subtitle ? 'medium' : 'large';
	
	    if (this.props.chat && !title) {
	      participantNames = _react2.default.createElement(
	        _Text2.default,
	        { size: titleTextSize, truncate: true },
	        this.props.chat.hasTitle() ? this.props.chat.getTitle() : this.renderParticipantNames()
	      );
	    }
	    var titleText = _react2.default.createElement(
	      _Text2.default,
	      { size: titleTextSize, truncate: true },
	      title
	    );
	
	    var linkedTitle = title ? titleText : participantNames;
	    if (this.props.onTitleClicked) {
	      linkedTitle = _react2.default.createElement(
	        _Link2.default,
	        { color: 'pitch', onClick: this.props.onTitleClicked },
	        linkedTitle
	      );
	    }
	
	    var subtitleText = _react2.default.createElement(
	      _Text2.default,
	      {
	        className: 'ConversationHeader-subtitle',
	        size: 'xsmall',
	        truncate: true },
	      subtitle
	    );
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)({
	          ConversationHeader: true,
	          'ConversationHeader-disabled': chat && chat.isUnsubscribed() || partnerLeft
	        }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'ConversationHeader-titles' },
	        _react2.default.createElement(
	          'h1',
	          {
	            className: (0, _classnames2.default)('ConversationHeader-title', {
	              'ConversationHeader-title-shiftUp': subtitle
	            }) },
	          linkedTitle
	        ),
	        subtitle && subtitleText
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'ConversationHeader-buttons' },
	        this.props.children
	      )
	    );
	  }
	});
	
	exports.default = ConversationHeader;

/***/ },
/* 2253 */
1136,
/* 2254 */,
/* 2255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _UserConstants = __webpack_require__(1015);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationHeaderSidebarButton = function (_React$Component) {
	  _inherits(ConversationHeaderSidebarButton, _React$Component);
	
	  function ConversationHeaderSidebarButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConversationHeaderSidebarButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConversationHeaderSidebarButton.__proto__ || Object.getPrototypeOf(ConversationHeaderSidebarButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleSideBarToggle = function () {
	      if (_this.shouldShowNuxMoreSidebarTooltip()) {
	        _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.NUX_MORE_SIDEBAR_TOOLTIP);
	      }
	
	      if (_this.props.onSideBarToggle) {
	        _this.props.onSideBarToggle();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ConversationHeaderSidebarButton, [{
	    key: 'shouldShowNuxMoreSidebarTooltip',
	    value: function shouldShowNuxMoreSidebarTooltip() {
	      return _CurrentUser2.default.getUser().getRole() === _UserConstants.Roles.teacher && this.state.hasDismissedNuxStartNewChatTooltip && !_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.NUX_MORE_SIDEBAR_TOOLTIP);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var button = _react2.default.createElement(
	        _Button2.default,
	        {
	          size: 'xsmall',
	          className: this.props.className,
	          level: this.props.sidebar ? 'primary' : 'secondary',
	          onClick: this.handleSideBarToggle },
	        _react2.default.createElement(_Glyph2.default, { name: 'ellipses', solo: true })
	      );
	
	      if (this.props.chat && this.shouldShowNuxMoreSidebarTooltip()) {
	        var text = this.props.chat.canManageReplies() ? 'Click here to disable replies, access chat history, and view user information' : 'Click here to access chat history and view user information';
	
	        var tooltip = _react2.default.createElement(
	          _Tooltip2.default,
	          {
	            position: 'left',
	            placement: 'left',
	            alignment: 'middle',
	            fixed: 'true',
	            color: 'violet',
	            type: 'nux',
	            hideOnEscape: false,
	            hideOnBlur: false },
	          text
	        );
	
	        button = _react2.default.createElement(
	          _LayerTrigger2.default,
	          {
	            layer: tooltip,
	            trigger: 'manual',
	            placement: 'bottom',
	            defaultLayerShown: true },
	          button
	        );
	      }
	
	      return button;
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_PromptStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        hasDismissedNuxStartNewChatTooltip: _PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.NUX_START_NEW_CHAT_TOOLTIP)
	      };
	    }
	  }]);
	
	  return ConversationHeaderSidebarButton;
	}(_react2.default.Component);
	
	ConversationHeaderSidebarButton.displayName = 'ConversationHeaderSidebarButton';
	exports.default = _utils.Container.create(ConversationHeaderSidebarButton);

/***/ },
/* 2256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatForm = __webpack_require__(2257);
	
	var _ChatForm2 = _interopRequireDefault(_ChatForm);
	
	var _ConversationSidebarParticipants = __webpack_require__(2260);
	
	var _ConversationSidebarParticipants2 = _interopRequireDefault(_ConversationSidebarParticipants);
	
	var _EmailChatHistoryButton = __webpack_require__(2282);
	
	var _EmailChatHistoryButton2 = _interopRequireDefault(_EmailChatHistoryButton);
	
	var _LeaveChatButton = __webpack_require__(2283);
	
	var _LeaveChatButton2 = _interopRequireDefault(_LeaveChatButton);
	
	var _ManageChatButton = __webpack_require__(2284);
	
	var _ManageChatButton2 = _interopRequireDefault(_ManageChatButton);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2280);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationSidebar = function (_React$Component) {
	  _inherits(ConversationSidebar, _React$Component);
	
	  function ConversationSidebar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConversationSidebar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConversationSidebar.__proto__ || Object.getPrototypeOf(ConversationSidebar)).call.apply(_ref, [this].concat(args))), _this), _this.updateChatTitle = function (title) {
	      _ChatActions2.default.updateChatTitle(_this.props.chat, title);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ConversationSidebar, [{
	    key: 'renderParticipantsHeader',
	    value: function renderParticipantsHeader() {
	      var chat = this.props.chat;
	
	      var text = null;
	
	      if (chat.isGroupType()) {
	        var number = chat.getOtherChatMembershipsWithState('present').length + 1;
	        text = number === 1 ? '1 person' : number + ' people';
	      } else {
	        text = 'People';
	      }
	
	      return _react2.default.createElement(
	        'h2',
	        { className: 'ConversationSidebar-participants-title' },
	        text
	      );
	    }
	  }, {
	    key: 'renderParticipantNames',
	    value: function renderParticipantNames() {
	      var names = this.props.chat.getDisplayNames();
	      return names.join(', ');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var chat = this.props.chat;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ConversationSidebar', this.props.className), style: this.props.style },
	        chat.isGroupType() && _react2.default.createElement(_ChatForm2.default, {
	          chatName: chat.getTitle(),
	          updateTitle: this.updateChatTitle
	        }),
	        _react2.default.createElement(_ManageChatButton2.default, {
	          buttonClassName: 'ConversationSidebar-item-button',
	          chat: chat
	        }),
	        _react2.default.createElement(_LeaveChatButton2.default, {
	          buttonClassName: 'ConversationSidebar-item-button',
	          chat: chat
	        }),
	        _react2.default.createElement(_EmailChatHistoryButton2.default, {
	          buttonClassName: 'ConversationSidebar-item-button',
	          chat: chat
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ConversationSidebar-participants' },
	          this.renderParticipantsHeader(),
	          _react2.default.createElement(_ConversationSidebarParticipants2.default, { chat: chat })
	        )
	      );
	    }
	  }]);
	
	  return ConversationSidebar;
	}(_react2.default.Component);
	
	ConversationSidebar.displayName = 'ConversationSidebar';
	exports.default = ConversationSidebar;

/***/ },
/* 2257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Textarea = __webpack_require__(1598);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	__webpack_require__(2258);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ChatForm = function (_Component) {
	  _inherits(ChatForm, _Component);
	
	  function ChatForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChatForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatForm.__proto__ || Object.getPrototypeOf(ChatForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isEditing: false,
	      chatName: _this.props.chatName
	    }, _this.onChange = function (event) {
	      _this.setState({
	        // $FlowFixMe
	        chatName: event.target.value
	      });
	    }, _this.onSave = function () {
	      _this.setState({
	        isEditing: false
	      });
	      var isEmpty = _this.state.chatName.trim() === '';
	      var wasChanged = _this.state.chatName !== _this.props.chatName;
	
	      if (isEmpty) {
	        _this.setState({
	          chatName: _this.props.chatName
	        });
	      } else if (wasChanged) {
	        _this.props.updateTitle(_this.state.chatName);
	      }
	    }, _this.onEdit = function () {
	      _this.setState({
	        isEditing: true
	      });
	    }, _this.renderChatFormHeader = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ChatForm-header' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'ChatForm-header-title' },
	          'Group Name'
	        ),
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'ChatForm-header-toggle',
	            weight: 'semibold',
	            onClick: _this.state.isEditing ? _this.onSave : _this.onEdit,
	            eventElementName: 'ChatForm-header-toggle' },
	          _this.state.isEditing ? _react2.default.createElement(
	            'span',
	            null,
	            'Save'
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            'Rename'
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChatForm, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        isEditing: false,
	        chatName: nextProps.chatName
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.isEditing && this.refs.textarea) {
	        this.refs.textarea.select();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var chatNameDisplay = this.state.isEditing ? _react2.default.createElement(_Textarea2.default, {
	        className: 'ChatForm-name',
	        autoselect: true,
	        rows: 2,
	        value: this.state.chatName,
	        onChange: this.onChange
	      }) : _react2.default.createElement(
	        'h2',
	        {
	          className: 'ChatForm-name' },
	        this.state.chatName
	      );
	      return _react2.default.createElement(
	        'div',
	        { className: 'ChatForm' },
	        this.renderChatFormHeader(),
	        chatNameDisplay
	      );
	    }
	  }]);
	
	  return ChatForm;
	}(_react.Component);
	
	ChatForm.displayName = 'ChatForm';
	exports.default = ChatForm;

/***/ },
/* 2258 */
1136,
/* 2259 */,
/* 2260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BlockMemberMenuItem = __webpack_require__(1594);
	
	var _BlockMemberMenuItem2 = _interopRequireDefault(_BlockMemberMenuItem);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatMember = __webpack_require__(921);
	
	var _ChatMember2 = _interopRequireDefault(_ChatMember);
	
	var _ChatMembership = __webpack_require__(920);
	
	var _ChatMembership2 = _interopRequireDefault(_ChatMembership);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuButton = __webpack_require__(1604);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _ModalMenuItem = __webpack_require__(1595);
	
	var _ModalMenuItem2 = _interopRequireDefault(_ModalMenuItem);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ActivityShareModal = __webpack_require__(2261);
	
	var _ActivityShareModal2 = _interopRequireDefault(_ActivityShareModal);
	
	var _RelationshipModal = __webpack_require__(1309);
	
	var _RelationshipModal2 = _interopRequireDefault(_RelationshipModal);
	
	var _StatusLabel = __webpack_require__(1571);
	
	var _StatusLabel2 = _interopRequireDefault(_StatusLabel);
	
	var _StartChatButton = __webpack_require__(1567);
	
	var _StartChatButton2 = _interopRequireDefault(_StartChatButton);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserLink = __webpack_require__(1640);
	
	var _UserLink2 = _interopRequireDefault(_UserLink);
	
	var _ChatAddParticipantContainer = __webpack_require__(2273);
	
	var _ChatAddParticipantContainer2 = _interopRequireDefault(_ChatAddParticipantContainer);
	
	var _ReportChatSelectModal = __webpack_require__(2279);
	
	var _ReportChatSelectModal2 = _interopRequireDefault(_ReportChatSelectModal);
	
	__webpack_require__(2280);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// May be omitted if the chat was loaded by v2/chats page
	function hasMemberships(chat) {
	  return chat.getMemberships().length > 0;
	}
	
	var ConversationSidebarParticipants = function (_React$Component) {
	  _inherits(ConversationSidebarParticipants, _React$Component);
	
	  function ConversationSidebarParticipants() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConversationSidebarParticipants);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConversationSidebarParticipants.__proto__ || Object.getPrototypeOf(ConversationSidebarParticipants)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      showLeftMembers: false,
	      hoverOwner: false,
	      loading: [],
	      missingMemberships: !hasMemberships(_this.props.chat)
	    }, _this.toggleShowLeftMembers = function () {
	      _this.setState(function (_ref2) {
	        var showLeftMembers = _ref2.showLeftMembers;
	        return { showLeftMembers: !showLeftMembers };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ConversationSidebarParticipants, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.missingMemberships) {
	        // triggers a props update
	        _ChatActions2.default.loadChat(this.props.chat.id);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextMissingMemberships = !hasMemberships(nextProps.chat);
	      if (nextMissingMemberships) {
	        this.setState({ missingMemberships: true });
	        // triggers a props update
	        _ChatActions2.default.loadChat(this.props.chat.id);
	      } else {
	        this.setState({ missingMemberships: false });
	      }
	    }
	  }, {
	    key: 'getChatTypeName',
	    value: function getChatTypeName() {
	      return this.props.chat.isActivityType() ? 'activity' : 'conversation';
	    }
	  }, {
	    key: 'setHoverOwnerTo',
	    value: function setHoverOwnerTo(value) {
	      this.setState({ hoverOwner: value });
	    }
	  }, {
	    key: 'addMemberToChat',
	    value: function addMemberToChat(member) {
	      var _this2 = this;
	
	      this.showLoadingIndicatorFor(member);
	
	      _ChatActions2.default.addMembersToChat(this.props.chat, [member.id]).then(function () {
	        _this2.hideLoadingIndicatorFor(member);
	        _ToastActions2.default.showSuccessToast(member.getName() + ' has been added back to the ' + _this2.getChatTypeName());
	      });
	    }
	  }, {
	    key: 'hideLoadingIndicatorFor',
	    value: function hideLoadingIndicatorFor(member) {
	      var index = this.state.loading.indexOf(member.id);
	      if (index > -1) {
	        delete this.state.loading[index];
	        this.forceUpdate();
	      }
	    }
	  }, {
	    key: 'memberHasLoaded',
	    value: function memberHasLoaded(member) {
	      return this.state.loading.indexOf(member.id) > -1;
	    }
	  }, {
	    key: 'removeMembershipFromChat',
	    value: function removeMembershipFromChat(member) {
	      var _this3 = this;
	
	      this.showLoadingIndicatorFor(member);
	
	      _ChatActions2.default.changeMemberStatus(this.props.chat, member.id, 'removed').then(function () {
	        _this3.hideLoadingIndicatorFor(member);
	        _ToastActions2.default.showSuccessToast(member.getName() + ' has been removed from the ' + _this3.getChatTypeName());
	      });
	    }
	  }, {
	    key: 'showLoadingIndicatorFor',
	    value: function showLoadingIndicatorFor(member) {
	      this.state.loading.push(member.id);
	      this.forceUpdate();
	    }
	  }, {
	    key: 'renderActiveParticipants',
	    value: function renderActiveParticipants() {
	      var _this4 = this;
	
	      var chat = this.props.chat;
	
	
	      return chat.getOtherChatMembershipsWithState('present').sort(function (membership) {
	        return !membership.isCreator(chat);
	      }).map(function (membership) {
	        return _this4.renderParticipant(chat, membership);
	      });
	    }
	  }, {
	    key: 'renderShareActivity',
	    value: function renderShareActivity() {
	      var chat = this.props.chat;
	
	      if (chat.isActivityType()) {
	        var modal = _react2.default.createElement(_ActivityShareModal2.default, { activity: chat.getActivity() });
	        var button = _react2.default.createElement(
	          'div',
	          { className: 'ConversationSidebar-item' },
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: modal },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: 'ConversationSidebar-item-button',
	                level: 'text',
	                weight: 'semibold',
	                eventElementName: 'ConversationSidebar-item-button' },
	              _react2.default.createElement(_Glyph2.default, { name: 'plus-circle-fill', size: 'large' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Share activity'
	              )
	            )
	          )
	        );
	        return button;
	      }
	      return null;
	    }
	  }, {
	    key: 'renderAddParticipants',
	    value: function renderAddParticipants() {
	      var chat = this.props.chat;
	
	
	      return _react2.default.createElement(
	        _ChatAddParticipantContainer2.default,
	        { chatUuid: chat.id, 'data-test': 'chat-add-participant-container' },
	        function (disabled) {
	          return _react2.default.createElement(
	            _Button2.default,
	            {
	              level: 'text',
	              className: 'ConversationSidebar-item-button',
	              disabled: disabled,
	              weight: 'semibold',
	              eventElementName: 'ConversationSidebar-item-button' },
	            _react2.default.createElement(_Glyph2.default, { name: 'plus-circle-fill', size: 'large' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Add people'
	            )
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderGroupOwner',
	    value: function renderGroupOwner(menu, member) {
	      var _this5 = this;
	
	      var button = this.renderGroupOwnerButton(menu);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: member.id,
	          className: (0, _classnames2.default)('ConversationSidebar-participant', 'ConversationSidebar-participant-present'),
	          onMouseLeave: function onMouseLeave() {
	            return _this5.setHoverOwnerTo(false);
	          },
	          onMouseEnter: function onMouseEnter() {
	            return _this5.setHoverOwnerTo(true);
	          } },
	        this.renderParticipantNameTag(member),
	        button
	      );
	    }
	  }, {
	    key: 'renderGroupOwnerButton',
	    value: function renderGroupOwnerButton(menu) {
	      var body = _react2.default.createElement(
	        _StatusLabel2.default,
	        { className: 'ConversationSidebar-participant-label' },
	        'Owner'
	      );
	
	      if (this.state.hoverOwner) {
	        body = _react2.default.createElement(
	          _Button2.default,
	          {
	            level: 'secondary',
	            size: 'xsmall',
	            className: 'ConversationSidebar-participant-menuButton',
	            eventElementName: 'ConversationSidebar-participant-menuButton' },
	          _react2.default.createElement(_Glyph2.default, { size: 'large', name: 'ellipses', solo: true })
	        );
	      }
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        { layer: menu, alignment: 'right', placement: 'bottom', trigger: 'click' },
	        body
	      );
	    }
	  }, {
	    key: 'renderLeftParticipants',
	    value: function renderLeftParticipants() {
	      var _this6 = this;
	
	      var chat = this.props.chat;
	
	      var leftMembership = chat.getOtherChatMembershipsWithState('left');
	      var removedMembership = chat.getOtherChatMembershipsWithState('removed');
	      var total = leftMembership.length + removedMembership.length;
	
	      if (total > 0) {
	        var glyph = void 0;
	
	        var leftList = void 0;
	        var removedList = void 0;
	
	        if (this.state.showLeftMembers) {
	          leftList = leftMembership.map(function (membership) {
	            return _this6.renderParticipant(chat, membership);
	          });
	
	          removedList = removedMembership.map(function (membership) {
	            return _this6.renderParticipant(chat, membership);
	          });
	
	          glyph = _react2.default.createElement(_Glyph2.default, { name: 'chevron-up', size: 'xsmall' });
	        } else {
	          glyph = _react2.default.createElement(_Glyph2.default, { name: 'chevron-down', size: 'xsmall' });
	        }
	
	        var header = total === 1 ? '1 person left this ' + this.getChatTypeName() : total + ' people left this ' + this.getChatTypeName();
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'ConversationSidebar-participantsleft' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ConversationSidebar-participantsleft-header' },
	            _react2.default.createElement(
	              _Link2.default,
	              { onClick: this.toggleShowLeftMembers },
	              _react2.default.createElement(
	                'span',
	                null,
	                header
	              ),
	              glyph
	            )
	          ),
	          leftList,
	          removedList
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderMeParticipant',
	    value: function renderMeParticipant() {
	      var chat = this.props.chat;
	
	
	      if (chat.isIndividualType()) {
	        return null;
	      }
	
	      var owner = void 0;
	      if (chat.getCreatorId() === _CurrentUser2.default.getUserId()) {
	        owner = _react2.default.createElement(
	          _StatusLabel2.default,
	          { className: 'ConversationSidebar-tag-me' },
	          'Owner'
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ConversationSidebar-participant ConversationSidebar-participant-present' },
	        'You',
	        owner
	      );
	    }
	  }, {
	    key: 'renderMenuForParticipant',
	    value: function renderMenuForParticipant(chat, membership) {
	      var _this7 = this;
	
	      var member = membership.getMember();
	      var ownedGroups = _GroupStore2.default.getOwnedGroups();
	
	      var reportModal = _react2.default.createElement(_ReportChatSelectModal2.default, {
	        chat: chat,
	        partner: member
	      });
	
	      var addToChat = void 0;
	      if (chat.canAdd() && (membership.hasLeft() || membership.hasBeenRemoved())) {
	        addToChat = _react2.default.createElement(
	          _MenuItem2.default,
	          {
	            menuKey: member.id,
	            disabled: chat.hasReachedParticipantNumberLimit(),
	            onClick: function onClick() {
	              return _this7.addMemberToChat(member);
	            } },
	          _react2.default.createElement(_Glyph2.default, { name: 'plus-circle-fill', size: 'medium', className: 'mrm' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Add back to this ',
	            this.getChatTypeName()
	          )
	        );
	      }
	
	      var removeFromChat = void 0;
	      if (membership.canRemove()) {
	        removeFromChat = _react2.default.createElement(
	          _ModalMenuItem2.default,
	          {
	            modal: this.renderRemoveFromChatConfirmModal(member),
	            className: 'ConversationSidebar-participant-menuItem-negative' },
	          _react2.default.createElement(_Glyph2.default, { name: 'close', size: 'medium', className: 'mrm' }),
	          _react2.default.createElement(
	            'span',
	            { 'data-test-remove-participant': true },
	            'Remove from this ',
	            this.getChatTypeName()
	          )
	        );
	      }
	
	      var removeFromClass = void 0;
	      if (ownedGroups.some(function (group) {
	        return chat.isInGroup(group.id);
	      })) {
	        removeFromClass = _react2.default.createElement(
	          _ModalMenuItem2.default,
	          {
	            modal: this.renderRelationshipModal(member.id),
	            disabled: chat.isUnsubscribed() },
	          _react2.default.createElement(_Glyph2.default, { name: 'close', size: 'medium', className: 'mrm' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Remove from class\u2026'
	          )
	        );
	      }
	
	      var individualMessageStarter = void 0;
	      if (member.isEligibleForChat()) {
	        individualMessageStarter = _react2.default.createElement(
	          _MenuItem2.default,
	          { menuKey: member.id },
	          _react2.default.createElement(
	            _StartChatButton2.default,
	            { subscriber: member },
	            _react2.default.createElement(_Glyph2.default, { name: 'chat-add-bubble', size: 'medium', className: 'mrm' }),
	            _react2.default.createElement(
	              'span',
	              null,
	              'Send message'
	            )
	          )
	        );
	      }
	
	      // FIXME: Remove spans required for React 15 upgrade
	      return _react2.default.createElement(
	        _Menu2.default,
	        null,
	        _react2.default.createElement(
	          _ModalMenuItem2.default,
	          {
	            modal: this.renderRelationshipModal(member.id),
	            disabled: chat.isUnsubscribed() },
	          _react2.default.createElement(_Glyph2.default, { name: 'avatar', size: 'medium', className: 'mrm' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'View profile'
	          )
	        ),
	        addToChat,
	        removeFromChat,
	        removeFromClass,
	        individualMessageStarter,
	        _react2.default.createElement(_BlockMemberMenuItem2.default, {
	          blocked: member.isBlocked(),
	          memberId: member.getUserId(),
	          memberName: member.getName()
	        }),
	        _react2.default.createElement(
	          _ModalMenuItem2.default,
	          {
	            modal: reportModal,
	            className: 'ConversationSidebar-participant-menuItem-negative' },
	          _react2.default.createElement(_Glyph2.default, { name: 'flag', size: 'medium', className: 'mrm' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Report to Remind'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderParticipant',
	    value: function renderParticipant(chat, membership) {
	      var member = membership.getMember();
	      var menu = this.renderMenuForParticipant(chat, membership);
	
	      // if this is the owner, render the special "owner" tag.
	      if (chat.getCreatorId() === member.id) {
	        return this.renderGroupOwner(menu, member);
	      }
	
	      var text = _react2.default.createElement(_Glyph2.default, { size: 'large', name: 'ellipses', solo: true });
	      if (this.memberHasLoaded(member)) {
	        text = _react2.default.createElement(_LoadingIndicator2.default, { size: 'xsmall' });
	      }
	
	      // to apply diff styling if you are present or not
	      // (owner is always present).
	      var presentClass = membership.isPresent() ? 'ConversationSidebar-participant-present' : 'ConversationSidebar-participant-notpresent';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: member.id,
	          className: (0, _classnames2.default)('ConversationSidebar-participant', presentClass) },
	        this.renderParticipantNameTag(member),
	        _react2.default.createElement(
	          _MenuButton2.default,
	          {
	            menu: menu,
	            className: 'ConversationSidebar-participant-menuButton',
	            activeClassName: 'ConversationSidebar-participant-menuButton--active',
	            level: 'icon',
	            size: 'xsmall',
	            alignment: 'right' },
	          text
	        )
	      );
	    }
	  }, {
	    key: 'renderParticipantNameTag',
	    value: function renderParticipantNameTag(member) {
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        {
	          key: member.id,
	          modal: this.renderRelationshipModal(member.id) },
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            className: 'ConversationSidebar-participant-info',
	            truncate: true },
	          _react2.default.createElement(
	            _UserLink2.default,
	            {
	              className: 'ConversationSidebar-participant-name',
	              userId: member.id,
	              placement: 'left',
	              alignment: 'top' },
	            _react2.default.createElement(_Avatar2.default, {
	              className: 'ConversationSidebar-droplet',
	              colorHex: member.getColor(),
	              text: member.getInitials(),
	              size: 'small'
	            }),
	            member.getName()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderRelationshipModal',
	    value: function renderRelationshipModal(userId) {
	      return _react2.default.createElement(_RelationshipModal2.default, { userId: userId });
	    }
	  }, {
	    key: 'renderRemoveFromChatConfirmModal',
	    value: function renderRemoveFromChatConfirmModal(member) {
	      var _this8 = this;
	
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'ConversationSidebarParticipants',
	        title: 'Remove ' + member.getName() + ' from the conversation?',
	        actionButtonText: 'Remove',
	        cancelButtonText: 'Cancel',
	        onConfirm: function onConfirm() {
	          return _this8.removeMembershipFromChat(member);
	        },
	        subtext: member.getName() + ' won\u2019t be able to view\n          or send messages to this ' + this.getChatTypeName() + '.'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.missingMemberships) {
	        return _react2.default.createElement(_LoadingIndicator2.default, { size: 'xsmall', className: 'ConversationSidebar-participants-loading' });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderAddParticipants(),
	        this.renderShareActivity(),
	        this.renderMeParticipant(),
	        this.renderActiveParticipants(),
	        this.renderLeftParticipants()
	      );
	    }
	  }]);
	
	  return ConversationSidebarParticipants;
	}(_react2.default.Component);
	
	ConversationSidebarParticipants.displayName = 'ConversationSidebarParticipants';
	exports.default = ConversationSidebarParticipants;

/***/ },
/* 2261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHARE_MODAL = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityModalLink = __webpack_require__(2262);
	
	var _ActivityModalLink2 = _interopRequireDefault(_ActivityModalLink);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ShareCopy = __webpack_require__(2265);
	
	var _ShareCopy2 = _interopRequireDefault(_ShareCopy);
	
	var _ShareFacebook = __webpack_require__(2268);
	
	var _ShareFacebook2 = _interopRequireDefault(_ShareFacebook);
	
	var _ShareTwitter = __webpack_require__(2269);
	
	var _ShareTwitter2 = _interopRequireDefault(_ShareTwitter);
	
	var _UniversalComposer = __webpack_require__(2032);
	
	var _UniversalComposer2 = _interopRequireDefault(_UniversalComposer);
	
	__webpack_require__(2270);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SHARE_MODAL = exports.SHARE_MODAL = 'share_modal';
	
	exports.default = _react2.default.createClass({
	  displayName: 'ActivityShareModal',
	  render: function render() {
	    var link = this.props.activity.getPayUrl();
	    var title = this.props.activity.isSender() ? 'Share this activity with your class' : 'Share this activity';
	
	    return _react2.default.createElement(
	      _Dialog2.default,
	      _extends({}, this.props, {
	        size: 'small',
	        imageSize: 'medium',
	        image: __webpack_require__(2272),
	        title: title,
	        subtext: 'Anyone can participate by visiting the website below:',
	        className: (0, _classnames2.default)('ActivityShareModal', this.props.className) }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { className: 'ActivityShareModal-boxBody' },
	        _react2.default.createElement(_ActivityModalLink2.default, { link: link }),
	        this.props.activity.isSender() && _react2.default.createElement(
	          _ModalTrigger2.default,
	          {
	            modal: _react2.default.createElement(_UniversalComposer2.default, { canAnnounce: true, activity: this.props.activity }) },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'ActivityShareModal-MessageClass',
	              onClick: this.sendMessage,
	              eventElementName: 'ActivityShareModal-MessageClass' },
	            'Message your class'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityShareModal-shares' },
	          _react2.default.createElement(_ShareTwitter2.default, { text: link }),
	          _react2.default.createElement(_ShareFacebook2.default, { link: link }),
	          _react2.default.createElement(_ShareCopy2.default, { text: link })
	        )
	      )
	    );
	  }
	});

/***/ },
/* 2262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ClipboardTrigger = __webpack_require__(1492);
	
	var _ClipboardTrigger2 = _interopRequireDefault(_ClipboardTrigger);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ClickEventTrigger = __webpack_require__(1181);
	
	var _ClickEventTrigger2 = _interopRequireDefault(_ClickEventTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(2263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivityModalLink = _react2.default.createClass({
	  displayName: 'ActivityModalLink',
	  showCopyToast: function showCopyToast() {
	    _ToastActions2.default.showSuccessToast('URL has been copied to your clipboard');
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _ClickEventTrigger2.default,
	      { eventElementName: 'ActivityModalLink' },
	      _react2.default.createElement(
	        _ClipboardTrigger2.default,
	        {
	          text: this.props.link,
	          onCopy: this.showCopyToast },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('ActivityModalLink-link', this.props.className) },
	          _react2.default.createElement(
	            _Text2.default,
	            { size: 'large', weight: 'light' },
	            this.props.link
	          )
	        )
	      )
	    );
	  }
	});
	exports.default = ActivityModalLink;

/***/ },
/* 2263 */
1136,
/* 2264 */,
/* 2265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ClipboardTrigger = __webpack_require__(1492);
	
	var _ClipboardTrigger2 = _interopRequireDefault(_ClipboardTrigger);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(2266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, _class);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.showCopyToast = function () {
	      _ToastActions2.default.showSuccessToast('URL has been copied to your clipboard');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(_class, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ClipboardTrigger2.default,
	        {
	          text: this.props.text,
	          onCopy: this.showCopyToast },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('Share', 'ShareCopy', this.props.className) },
	          _react2.default.createElement(_Glyph2.default, {
	            className: 'Share-glyph ShareCopy-glyph',
	            size: 'large',
	            name: 'link'
	          }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Copy'
	          )
	        )
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	_class.displayName = '_class';
	exports.default = _class;

/***/ },
/* 2266 */
1136,
/* 2267 */,
/* 2268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, _class);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.getLink = function () {
	      return 'https://www.facebook.com/sharer/sharer.php?u=' + _this.props.link;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(_class, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Link2.default,
	        {
	          target: '_blank',
	          href: this.getLink(),
	          className: (0, _classnames2.default)('Share', 'ShareFacebook', this.props.className) },
	        _react2.default.createElement(_Glyph2.default, {
	          className: 'Share-glyph ShareFacebook-glyph',
	          size: 'large',
	          name: 'facebook'
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Share'
	        )
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	_class.displayName = '_class';
	exports.default = _class;

/***/ },
/* 2269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	  _inherits(_class, _React$Component);
	
	  function _class() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, _class);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.getLink = function () {
	      return 'https://www.twitter.com/home?status=' + _this.props.text;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(_class, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Link2.default,
	        {
	          target: '_blank',
	          href: this.getLink(),
	          className: (0, _classnames2.default)('Share', 'ShareTwitter', this.props.className) },
	        _react2.default.createElement(_Glyph2.default, {
	          className: 'Share-glyph ShareTwitter-glyph',
	          size: 'large',
	          name: 'twitter'
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Tweet'
	        )
	      );
	    }
	  }]);
	
	  return _class;
	}(_react2.default.Component);
	
	_class.displayName = '_class';
	exports.default = _class;

/***/ },
/* 2270 */
1136,
/* 2271 */,
/* 2272 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "00a7d7e01f17fc5e53d6b6e643b54bde.svg";

/***/ },
/* 2273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatAddParticipant = __webpack_require__(2274);
	
	var _ChatAddParticipant2 = _interopRequireDefault(_ChatAddParticipant);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatAddParticipantContainer = function (_React$Component) {
	  _inherits(ChatAddParticipantContainer, _React$Component);
	
	  function ChatAddParticipantContainer() {
	    _classCallCheck(this, ChatAddParticipantContainer);
	
	    return _possibleConstructorReturn(this, (ChatAddParticipantContainer.__proto__ || Object.getPrototypeOf(ChatAddParticipantContainer)).apply(this, arguments));
	  }
	
	  _createClass(ChatAddParticipantContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.state.chat) {
	        _ChatActions2.default.loadChat(this.props.chatUuid);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.chat) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _ChatAddParticipant2.default,
	        {
	          onAddParticipants: this.props.onAddParticipants,
	          chat: this.state.chat },
	        this.props.children
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ChatStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      return {
	        chat: _ChatStore2.default.getChat(props.chatUuid)
	      };
	    }
	  }]);
	
	  return ChatAddParticipantContainer;
	}(_react2.default.Component);
	
	ChatAddParticipantContainer.displayName = 'ChatAddParticipantContainer';
	exports.default = _utils.Container.create(ChatAddParticipantContainer, { withProps: true });

/***/ },
/* 2274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _AddParticipantModal = __webpack_require__(2275);
	
	var _AddParticipantModal2 = _interopRequireDefault(_AddParticipantModal);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatAddParticipant = function (_React$Component) {
	  _inherits(ChatAddParticipant, _React$Component);
	
	  function ChatAddParticipant() {
	    _classCallCheck(this, ChatAddParticipant);
	
	    return _possibleConstructorReturn(this, (ChatAddParticipant.__proto__ || Object.getPrototypeOf(ChatAddParticipant)).apply(this, arguments));
	  }
	
	  _createClass(ChatAddParticipant, [{
	    key: 'getAddParticipantModal',
	    value: function getAddParticipantModal() {
	      return _react2.default.createElement(_AddParticipantModal2.default, {
	        chat: this.props.chat,
	        onAddParticipants: this.props.onAddParticipants
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var chat = this.props.chat;
	
	
	      if (!chat.canAdd()) {
	        return null;
	      }
	
	      var disabled = chat.hasReachedParticipantNumberLimit();
	      var wrapper = _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: this.getAddParticipantModal() },
	        this.props.children && this.props.children(disabled)
	      );
	
	      if (!disabled) {
	        return wrapper;
	      }
	
	      var chatMembersLimit = _SettingsStore2.default.getChatMembersLimit();
	      var tooltip = _react2.default.createElement(
	        _Tooltip2.default,
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          'Only ',
	          chatMembersLimit,
	          ' people can participate in a conversation.'
	        )
	      );
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          ref: 'tooltipTrigger',
	          layer: tooltip,
	          placement: 'left' },
	        wrapper
	      );
	    }
	  }]);
	
	  return ChatAddParticipant;
	}(_react2.default.Component);
	
	ChatAddParticipant.displayName = 'ChatAddParticipant';
	exports.default = ChatAddParticipant;

/***/ },
/* 2275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _AutosizeInput = __webpack_require__(2276);
	
	var _AutosizeInput2 = _interopRequireDefault(_AutosizeInput);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatParticipantSearchMixin = __webpack_require__(2034);
	
	var _ChatParticipantSearchMixin2 = _interopRequireDefault(_ChatParticipantSearchMixin);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _GroupInviteModal = __webpack_require__(1435);
	
	var _GroupInviteModal2 = _interopRequireDefault(_GroupInviteModal);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _PotentialChatMembers = __webpack_require__(946);
	
	var _PotentialChatMembers2 = _interopRequireDefault(_PotentialChatMembers);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Token = __webpack_require__(1878);
	
	var _Token2 = _interopRequireDefault(_Token);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _modal = __webpack_require__(1188);
	
	var _ChatListSearchItem = __webpack_require__(2223);
	
	var _ChatListSearchItem2 = _interopRequireDefault(_ChatListSearchItem);
	
	__webpack_require__(2277);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddParticipantModal = _react2.default.createClass({
	  displayName: 'AddParticipantModal',
	
	
	  mixins: [_ChatParticipantSearchMixin2.default],
	
	  statics: {
	    prefetch: [function () {
	      return _ChatActions2.default.promisePotentialChatMembers();
	    }]
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      pickedMembers: new _PotentialChatMembers2.default(),
	      max: this.props.chat.getMaximumMembers() - this.props.chat.getPresentMemberships().length
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.focusInput();
	  },
	  onSubmit: function onSubmit() {
	    var _this = this;
	
	    var pickedMembers = this.state.pickedMembers;
	
	
	    _ChatActions2.default.addMembersToChat(this.props.chat, pickedMembers.map(function (p) {
	      return p.id;
	    })).then(function () {
	      var message = pickedMembers.length === 1 ? pickedMembers.first().getName() + ' has been added to the ' + _this.getChatTypeName() : pickedMembers.length + ' people have been added to the ' + _this.getChatTypeName();
	
	      _ToastActions2.default.showSuccessToast(message);
	      _this.props.onRequestHide();
	      if (_this.props.onAddParticipants) {
	        _this.props.onAddParticipants();
	      }
	    });
	  },
	  getChatTypeName: function getChatTypeName() {
	    return this.props.chat.isActivityType() ? 'activity' : 'conversation';
	  },
	  clearInput: function clearInput() {
	    _reactDom2.default.findDOMNode(this.refs.memberSearch).value = '';
	    this.refs.memberSearch.onChange();
	    this.handleInputChange();
	  },
	  handleGroupSelect: function handleGroupSelect(group) {
	    this.refs.groupSelectionDialog.hide();
	    (0, _modal.mountModal)(_react2.default.createElement(_GroupInviteModal2.default, { group: group }), this);
	  },
	  handleInputKeyDown: function handleInputKeyDown(event) {
	    var code = event.keyCode;
	    switch (code) {
	      case _KeyConstants2.default.ENTER:
	        {
	          var searchItem = this.refs['searchItem-' + this.state.highlight];
	          if (searchItem) {
	            searchItem.click();
	          }
	          break;
	        }
	      case _KeyConstants2.default.UP:
	      case _KeyConstants2.default.DOWN:
	        {
	          var highlight = this.state.highlight;
	
	          if (code === _KeyConstants2.default.UP) {
	            if (highlight >= 0) {
	              highlight -= 1;
	            } else {
	              highlight = this.state.results.length - 1;
	            }
	          } else {
	            if (highlight < this.state.results.length) {
	              highlight += 1;
	            } else {
	              highlight = 0;
	            }
	          }
	          this.setState({ highlight: highlight });
	
	          if (highlight >= 0 && highlight < this.state.results.length) {
	            var searchItemNode = _reactDom2.default.findDOMNode(this.refs['searchItem-' + highlight]);
	            this.refs.scrollArea.scrollIntoView(searchItemNode);
	            this._blockResultMouseOverWhileScrolling = true;
	          }
	          break;
	        }
	      case _KeyConstants2.default.BACKSPACE:
	        {
	          var memberSearch = _reactDom2.default.findDOMNode(this.refs.memberSearch);
	          if (memberSearch.value.length !== 0) {
	            return;
	          }
	
	          this.state.pickedMembers.pop();
	          this.forceUpdate();
	          break;
	        }
	      default:
	        {
	          return;
	        }
	    }
	    event.preventDefault();
	  },
	  handleOnSelectItem: function handleOnSelectItem(member) {
	    if (!member.isEligible()) {
	      this.memberNotEligible(member);
	      return;
	    } else if (this.hasBeenInitialySelected(member)) {
	      return;
	    }
	
	    if (this.hasBeenPicked(member)) {
	      this.unpickMember(member);
	    } else {
	      this.pickMember(member);
	    }
	  },
	  hasBeenInitialySelected: function hasBeenInitialySelected(member) {
	    return this.props.chat.isPresentMember(member);
	  },
	  hasBeenPicked: function hasBeenPicked(member) {
	    return !!this.state.pickedMembers.get(member.id);
	  },
	  pickMember: function pickMember(member) {
	    this.state.pickedMembers.add(member);
	    this.clearInput();
	    this.focusInput();
	    this.forceUpdate();
	  },
	  unpickMember: function unpickMember(member) {
	    this.state.pickedMembers.remove(member);
	    this.forceUpdate();
	  },
	  renderCancel: function renderCancel() {
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'AddParticipantModal-footer-button',
	        onClick: this.props.onRequestHide,
	        level: 'secondary',
	        eventElementName: 'AddParticipantModal-footer-button' },
	      'Cancel'
	    );
	  },
	  renderConfirmModal: function renderConfirmModal(members) {
	    var text = members.length === 1 ? 'Add 1 person to this ' + this.getChatTypeName() + '?' : 'Add ' + members.length + ' people to this ' + this.getChatTypeName() + '?';
	
	    return _react2.default.createElement(_ConfirmDialog2.default, {
	      eventScreenName: 'AddParticipantModal',
	      title: text,
	      actionButtonText: 'Add',
	      cancelButtonText: 'Cancel',
	      onConfirm: this.onSubmit,
	      subtext: 'New participants can see all the messages in this ' + this.getChatTypeName() + '.'
	    });
	  },
	  renderInput: function renderInput() {
	    var placeholder = this.state.pickedMembers.length > 0 ? '' : 'Who do you want to add?';
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'AddParticipantModal-input', onClick: this.focusInput },
	      _react2.default.createElement(
	        'span',
	        { className: 'AddParticipantModal-input-to' },
	        'Add:'
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        this.renderPickerMemberTokens()
	      ),
	      _react2.default.createElement(_AutosizeInput2.default, {
	        ref: 'memberSearch',
	        className: 'AddParticipantModal-input-text AddParticipantModal-autoSizeInput',
	        placeholder: placeholder,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus,
	        onKeyDown: this.handleInputKeyDown
	      })
	    );
	  },
	  renderMember: function renderMember(member, index) {
	    var _this2 = this;
	
	    return _react2.default.createElement(_ChatListSearchItem2.default, {
	      ref: 'searchItem-' + index,
	      key: member.id,
	      member: member,
	      query: this.state.query,
	      highlight: member.id === this.state.highlight,
	      onSelect: this.handleOnSelectItem,
	      selected: this.hasBeenPicked(member),
	      added: this.hasBeenInitialySelected(member),
	      onMouseOver: function onMouseOver() {
	        return _this2.handleResultMouseOver(member.id);
	      }
	    });
	  },
	  renderMembers: function renderMembers() {
	    if (this.state.pickedMembers.length > this.state.max) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'AddParticipantModal-limitReached' },
	        _react2.default.createElement(_Glyph2.default, {
	          className: 'AddParticipantModal-limitGlyph',
	          name: 'chat-close-bubble-fill',
	          size: 'xxxlarge'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'AddParticipantModal-limitTitle' },
	          'Only ',
	          this.props.chat.getMaximumMembers(),
	          ' people can participate in a conversation.'
	        )
	      );
	    }
	
	    if (this.state.results.length === 0) {
	      var button = void 0;
	      if (_CurrentUser2.default.getUser().getRole() === _UserConstants.Roles.teacher) {
	        button = _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.renderGroupSelectionDialog() },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'AddParticipantModal-inviteButton',
	              level: 'secondary',
	              color: 'shamrock',
	              size: 'small',
	              eventElementName: 'AddParticipantModal-inviteButton' },
	            'Add students and parents'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AddParticipantModal-noResults' },
	        _react2.default.createElement(
	          'div',
	          null,
	          '0 people found'
	        ),
	        button
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'AddParticipantModal-list' },
	      _react2.default.createElement(
	        _ScrollableArea2.default,
	        {
	          ref: 'scrollArea',
	          className: 'AddParticipantModal-list-scrollArea',
	          onScroll: this.handleScroll,
	          showShadows: true },
	        this.state.results.map(this.renderMember)
	      )
	    );
	  },
	  renderPickerMemberTokens: function renderPickerMemberTokens() {
	    var _this3 = this;
	
	    return this.state.pickedMembers.map(function (member) {
	      return _react2.default.createElement(
	        _Token2.default,
	        {
	          onRemove: function onRemove() {
	            return _this3.unpickMember(member);
	          },
	          key: member.id },
	        member.getName()
	      );
	    });
	  },
	  renderSubmit: function renderSubmit() {
	    var disabled = this.state.pickedMembers.length < 1 || this.state.pickedMembers.length > this.state.max;
	
	    var modal = this.renderConfirmModal(this.state.pickedMembers);
	
	    return _react2.default.createElement(
	      _ModalTrigger2.default,
	      { modal: modal },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'AddParticipantModal-footer-button',
	          disabled: disabled,
	          eventElementName: 'AddParticipantModal-footer-button' },
	        'Add'
	      )
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _Dialog2.default,
	      _extends({}, this.props, { size: 'small', className: 'AddParticipantModal' }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { full: true },
	        _react2.default.createElement(
	          _BoxHeader2.default,
	          { className: 'AddParticipantModal-header' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Add people to the ',
	            this.getChatTypeName()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'AddParticipantModal-members' },
	          this.renderInput(),
	          this.renderMembers()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'AddParticipantModal-footer' },
	          this.renderCancel(),
	          this.renderSubmit()
	        )
	      )
	    );
	  }
	});
	
	exports.default = AddParticipantModal;

/***/ },
/* 2276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _pickInputElementProps = __webpack_require__(1106);
	
	var _pickInputElementProps2 = _interopRequireDefault(_pickInputElementProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AutosizeInput = _react2.default.createClass({
	  displayName: 'AutosizeInput',
	  getDefaultProps: function getDefaultProps() {
	    return {
	      placeholder: ''
	    };
	  },
	  getInitialState: function getInitialState() {
	    return { size: this.props.placeholder.length + 1 };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (this.props.placeholder !== newProps.placeholder) {
	      this.setState({ size: newProps.placeholder.length + 1 });
	    }
	  },
	  onChange: function onChange() {
	    var value = this.refs.input.value;
	    if (value.length === 0) {
	      this.setState(this.getInitialState());
	    } else {
	      this.setState({ size: value.length + 1 });
	    }
	  },
	  render: function render() {
	    var _props = this.props,
	        onChange = _props.onChange,
	        others = _objectWithoutProperties(_props, ['onChange']);
	
	    var props = (0, _pickInputElementProps2.default)(others);
	
	    return _react2.default.createElement('input', _extends({
	      ref: 'input'
	    }, props, {
	      size: this.state.size,
	      onChange: (0, _createChainedFunction2.default)(this.onChange, onChange)
	    }));
	  }
	});
	
	exports.default = AutosizeInput;

/***/ },
/* 2277 */
1136,
/* 2278 */,
/* 2279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatMember = __webpack_require__(921);
	
	var _ChatMember2 = _interopRequireDefault(_ChatMember);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReportToRemindSelectModal = __webpack_require__(1608);
	
	var _ReportToRemindSelectModal2 = _interopRequireDefault(_ReportToRemindSelectModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportChatSelectModal = function (_React$Component) {
	  _inherits(ReportChatSelectModal, _React$Component);
	
	  function ReportChatSelectModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReportChatSelectModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReportChatSelectModal.__proto__ || Object.getPrototypeOf(ReportChatSelectModal)).call.apply(_ref, [this].concat(args))), _this), _this.reportChat = function (reason, notes) {
	      var _this$props = _this.props,
	          chat = _this$props.chat,
	          partner = _this$props.partner;
	
	      _ChatActions2.default.reportChat(chat.id, partner.getUuid(), reason, notes);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReportChatSelectModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ReportToRemindSelectModal2.default, _extends({}, this.props, {
	        reportee: this.props.partner.getName(),
	        notesPlaceholder: 'Why are you reporting ' + this.props.partner.getName() + '?',
	        onReport: this.reportChat
	      }));
	    }
	  }]);
	
	  return ReportChatSelectModal;
	}(_react2.default.Component);
	
	ReportChatSelectModal.displayName = 'ReportChatSelectModal';
	exports.default = ReportChatSelectModal;

/***/ },
/* 2280 */
1136,
/* 2281 */,
/* 2282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _SetUserEmailModal = __webpack_require__(1402);
	
	var _SetUserEmailModal2 = _interopRequireDefault(_SetUserEmailModal);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailChatHistoryButton = function (_React$Component) {
	  _inherits(EmailChatHistoryButton, _React$Component);
	
	  function EmailChatHistoryButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EmailChatHistoryButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = EmailChatHistoryButton.__proto__ || Object.getPrototypeOf(EmailChatHistoryButton)).call.apply(_ref, [this].concat(args))), _this), _this.emailTranscript = function () {
	      if (!_CurrentUser2.default.hasEmail()) {
	        (0, _modal.mountModal)(_react2.default.createElement(_SetUserEmailModal2.default, { onSave: _this.emailTranscript }), _this);
	        return;
	      }
	
	      _ChatActions2.default.emailTranscript(_this.props.chat.id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EmailChatHistoryButton, [{
	    key: 'renderEmailChatHistory',
	    value: function renderEmailChatHistory() {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: this.props.buttonClassName,
	          level: 'text',
	          weight: 'semibold',
	          onClick: this.emailTranscript },
	        _react2.default.createElement(_Glyph2.default, { name: 'email-transcript', size: 'large' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Email message history'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.renderEmailChatHistory()
	      );
	    }
	  }]);
	
	  return EmailChatHistoryButton;
	}(_react2.default.Component);
	
	EmailChatHistoryButton.displayName = 'EmailChatHistoryButton';
	exports.default = EmailChatHistoryButton;

/***/ },
/* 2283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LeaveChatButton = function (_React$Component) {
	  _inherits(LeaveChatButton, _React$Component);
	
	  function LeaveChatButton() {
	    _classCallCheck(this, LeaveChatButton);
	
	    return _possibleConstructorReturn(this, (LeaveChatButton.__proto__ || Object.getPrototypeOf(LeaveChatButton)).apply(this, arguments));
	  }
	
	  _createClass(LeaveChatButton, [{
	    key: 'renderLeaveButton',
	    value: function renderLeaveButton() {
	      var chat = this.props.chat;
	
	
	      var pauseModal = _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'LeaveChatButton',
	        glyph: 'caution',
	        glyphColor: 'lava',
	        title: 'Leave this conversation?',
	        subtext: 'You won\u2019t receive new messages in this conversation.',
	        onConfirm: function onConfirm() {
	          return _ChatActions2.default.leaveChat(chat);
	        }
	      });
	
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: pauseModal },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: this.props.buttonClassName,
	            level: 'text',
	            color: 'lava' },
	          _react2.default.createElement(_Glyph2.default, { name: 'close' }),
	          'Leave this conversation'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var chat = this.props.chat;
	
	
	      if (!chat.canLeave()) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'LeaveChatButton' },
	        this.renderLeaveButton()
	      );
	    }
	  }]);
	
	  return LeaveChatButton;
	}(_react2.default.Component);
	
	LeaveChatButton.displayName = 'LeaveChatButton';
	exports.default = LeaveChatButton;

/***/ },
/* 2284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _DisableRepliesConfirmationDialog = __webpack_require__(2285);
	
	var _DisableRepliesConfirmationDialog2 = _interopRequireDefault(_DisableRepliesConfirmationDialog);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ManageChatButton = function (_React$Component) {
	  _inherits(ManageChatButton, _React$Component);
	
	  function ManageChatButton() {
	    _classCallCheck(this, ManageChatButton);
	
	    return _possibleConstructorReturn(this, (ManageChatButton.__proto__ || Object.getPrototypeOf(ManageChatButton)).apply(this, arguments));
	  }
	
	  _createClass(ManageChatButton, [{
	    key: 'renderDisabledRepliesButton',
	    value: function renderDisabledRepliesButton() {
	      var chat = this.props.chat;
	
	      // FIXME: Remove spans required for React 15 upgrade
	
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: _react2.default.createElement(_DisableRepliesConfirmationDialog2.default, { chat: chat }) },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            level: 'text',
	            weight: 'semibold',
	            className: this.props.buttonClassName },
	          _react2.default.createElement(_Glyph2.default, { name: 'chat-close-bubble-fill', size: 'large' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Turn off replies'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderEnabledRepliesButton',
	    value: function renderEnabledRepliesButton() {
	      var chat = this.props.chat;
	
	
	      var buttonProps = {};
	      if (chat.canOpen()) {
	        buttonProps.onClick = function () {
	          return _ChatActions2.default.enableReplies(chat);
	        };
	      } else {
	        buttonProps.disabled = true;
	        // If can_send is false, we assume this thread has an under13 user.
	        if (!chat.canSend()) {
	          Object.assign(buttonProps, {
	            // There is a bug in Chrome where disabled form elements don't properly fire mouseleave
	            // events. This was breaking tooltip behavior. To fix, just make the button a link.
	            href: '#',
	            tooltip: 'Two-way messaging is not permitted with students under the age of 13.',
	            tooltipPlacement: 'bottom'
	          });
	        }
	      }
	
	      // FIXME: Remove spans required for React 15 upgrade
	      return _react2.default.createElement(
	        _Button2.default,
	        _extends({
	          className: this.props.buttonClassName,
	          level: 'text',
	          weight: 'semibold'
	        }, buttonProps),
	        _react2.default.createElement(_Glyph2.default, { name: 'chat-check-bubble-fill', size: 'large' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          'Turn on replies'
	        )
	      );
	    }
	  }, {
	    key: 'renderManagedButton',
	    value: function renderManagedButton() {
	      var chat = this.props.chat;
	
	      // The chat be open with can_send false (for under 13 users)
	
	      if (chat.isOpen() && chat.canSend()) {
	        return this.renderDisabledRepliesButton();
	      } else {
	        return this.renderEnabledRepliesButton();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var chat = this.props.chat;
	
	
	      if (!chat.canManageReplies()) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ManageChatButton' },
	        this.renderManagedButton()
	      );
	    }
	  }]);
	
	  return ManageChatButton;
	}(_react2.default.Component);
	
	ManageChatButton.displayName = 'ManageChatButton';
	exports.default = ManageChatButton;

/***/ },
/* 2285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	function otherMemberName(chat) {
	  var otherMember = chat.getOtherMember();
	  if (otherMember) {
	    return otherMember.name;
	  }
	  var otherChatMembers = chat.getOtherChatMembers();
	  var firstMember = otherChatMembers && otherChatMembers[0];
	  if (firstMember) {
	    return firstMember.getName();
	  }
	
	  return null;
	}
	
	var DisableRepliesConfirmationDialog = function (_React$Component) {
	  _inherits(DisableRepliesConfirmationDialog, _React$Component);
	
	  function DisableRepliesConfirmationDialog() {
	    _classCallCheck(this, DisableRepliesConfirmationDialog);
	
	    return _possibleConstructorReturn(this, (DisableRepliesConfirmationDialog.__proto__ || Object.getPrototypeOf(DisableRepliesConfirmationDialog)).apply(this, arguments));
	  }
	
	  _createClass(DisableRepliesConfirmationDialog, [{
	    key: 'render',
	    value: function render() {
	      var chat = this.props.chat;
	
	
	      var subject = function () {
	        if (chat.isGroupChat()) {
	          return 'Participants';
	        }
	        var name = otherMemberName(chat);
	        if (name) {
	          return name;
	        }
	        return 'Participant';
	      }();
	
	      var subtext = subject + ' won\u2019t be able to reply to any messages in this conversation.';
	
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'DisableRepliesConfirmationDialog',
	        title: 'Turn off replies?',
	        subtext: subtext,
	        actionButtonText: 'Turn off',
	        cancelButtonText: 'Cancel',
	        onConfirm: function onConfirm() {
	          return _ChatActions2.default.disableReplies(chat);
	        },
	        onRequestHide: this.props.onRequestHide
	      });
	    }
	  }]);
	
	  return DisableRepliesConfirmationDialog;
	}(_react2.default.Component);
	
	DisableRepliesConfirmationDialog.displayName = 'DisableRepliesConfirmationDialog';
	exports.default = DisableRepliesConfirmationDialog;

/***/ },
/* 2286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConversationViewComposer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MessageComposer = __webpack_require__(2287);
	
	var _MessageComposer2 = _interopRequireDefault(_MessageComposer);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _ComposerEventRSVP = __webpack_require__(2299);
	
	var _ComposerEventRSVP2 = _interopRequireDefault(_ComposerEventRSVP);
	
	var _RSVPDialogContainer = __webpack_require__(2234);
	
	var _RSVPDialogContainer2 = _interopRequireDefault(_RSVPDialogContainer);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationViewComposer = exports.ConversationViewComposer = function (_React$Component) {
	  _inherits(ConversationViewComposer, _React$Component);
	
	  function ConversationViewComposer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConversationViewComposer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConversationViewComposer.__proto__ || Object.getPrototypeOf(ConversationViewComposer)).call.apply(_ref, [this].concat(args))), _this), _this.onRSVPChange = function (rsvp) {
	      (0, _modal.mountModal)(_react2.default.createElement(_RSVPDialogContainer2.default, {
	        initialRSVP: rsvp,
	        activityId: _this.props.chat.getActivity().id
	      }), _this);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ConversationViewComposer, [{
	    key: 'focus',
	    value: function focus() {
	      if (this.refs.composer) {
	        this.refs.composer.focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activityRecipient = _props.activityRecipient,
	          className = _props.className,
	          chat = _props.chat,
	          onMessageSend = _props.onMessageSend,
	          rest = _objectWithoutProperties(_props, ['activityRecipient', 'className', 'chat', 'onMessageSend']);
	
	      if (chat.isActivityType() && activityRecipient && activityRecipient.getAttendance() === 'pending' && !chat.getActivity().isSender()) {
	        return _react2.default.createElement(_ComposerEventRSVP2.default, { onChange: this.onRSVPChange });
	      }
	
	      return _react2.default.createElement(_MessageComposer2.default, _extends({}, rest, {
	        chat: chat,
	        ref: 'composer',
	        className: className,
	        onMessageSend: onMessageSend
	      }));
	    }
	  }]);
	
	  return ConversationViewComposer;
	}(_react2.default.Component);
	
	ConversationViewComposer.displayName = 'ConversationViewComposer';
	
	
	function mapStateToProps(state, props) {
	  var activity = props.chat.getActivity();
	  if (activity && activity.id) {
	    var activityObj = state.activityRecipients.activities[activity.id] || {};
	    return {
	      activityRecipient: activityObj.currentUserRecipient
	    };
	  }
	  return {};
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, undefined, undefined, { withRef: true, pure: false })(ConversationViewComposer);

/***/ },
/* 2287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// typecheck: ignore file
	
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _i18n = __webpack_require__(1018);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _reactAddonsLinkedStateMixin = __webpack_require__(2288);
	
	var _reactAddonsLinkedStateMixin2 = _interopRequireDefault(_reactAddonsLinkedStateMixin);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ButtonGroup = __webpack_require__(1432);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _Composer = __webpack_require__(2050);
	
	var _Composer2 = _interopRequireDefault(_Composer);
	
	var _ComposerFilePreview = __webpack_require__(2079);
	
	var _ComposerFilePreview2 = _interopRequireDefault(_ComposerFilePreview);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _DateConstants = __webpack_require__(1751);
	
	var _DateConstants2 = _interopRequireDefault(_DateConstants);
	
	var _DropZoneModal = __webpack_require__(1501);
	
	var _DropZoneModal2 = _interopRequireDefault(_DropZoneModal);
	
	var _FileUploaderMixin = __webpack_require__(2082);
	
	var _FileUploaderMixin2 = _interopRequireDefault(_FileUploaderMixin);
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _LanguageHoverCard = __webpack_require__(2083);
	
	var _LanguageHoverCard2 = _interopRequireDefault(_LanguageHoverCard);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _MessageComposerActions = __webpack_require__(2292);
	
	var _MessageComposerActions2 = _interopRequireDefault(_MessageComposerActions);
	
	var _MessageComposerStore = __webpack_require__(2294);
	
	var _MessageComposerStore2 = _interopRequireDefault(_MessageComposerStore);
	
	var _ResponsiveMixin = __webpack_require__(1260);
	
	var _ResponsiveMixin2 = _interopRequireDefault(_ResponsiveMixin);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _Timing = __webpack_require__(2295);
	
	var _Timing2 = _interopRequireDefault(_Timing);
	
	var _TranslationActions = __webpack_require__(1301);
	
	var _TranslationActions2 = _interopRequireDefault(_TranslationActions);
	
	var _modal = __webpack_require__(1188);
	
	var _ComposerAlert = __webpack_require__(2053);
	
	var _ComposerAlert2 = _interopRequireDefault(_ComposerAlert);
	
	__webpack_require__(2296);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OFFICE_HOURS_NOTICE_TIMEOUT = 60 * 60 * 1000;
	var AFTER_HOURS_NOTICE_TIMEOUT = 60 * 60 * 1000;
	var CHARACTER_LIMIT = 1500;
	var UI_CONTEXT = 'chat_composer';
	
	var MessageComposer = _react2.default.createClass({
	  displayName: 'MessageComposer',
	
	
	  mixins: [_reactAddonsLinkedStateMixin2.default, _FileUploaderMixin2.default, _ResponsiveMixin2.default],
	
	  statics: {
	    MEDIUM: 750,
	    SMALL: 650,
	    XSMALL: 550,
	    XXSMALL: 450
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      composerError: false,
	      latestTranslation: '',
	      text: '',
	      translationBoxOpened: false,
	      uploadedFile: null
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.chat.id) {
	      var state = _MessageComposerStore2.default.getComposerStates(this.props.chat.id);
	      if (state) {
	        this.setState(_extends({}, state));
	      }
	    }
	  },
	  componentWillUpdate: function componentWillUpdate(nextProps) {
	    var _this = this;
	
	    var currentChatId = this.props.chat.id;
	    var nextChatId = nextProps.chat.id;
	    var chatChanged = nextChatId !== currentChatId;
	
	    if (chatChanged) {
	      this.destroyDropzone();
	
	      // When switching chats, we save the composer state for persisted chats to be restored if we come back to this chat.
	      if (!this.props.chat.isNew()) {
	        (function () {
	          var stateBeforeTimeout = _this.state;
	          // Timeout to place action at end of dispatch stack
	          setTimeout(function () {
	            _MessageComposerActions2.default.saveState(currentChatId, stateBeforeTimeout);
	          }, 0);
	        })();
	      }
	
	      if (this.refs.composer) {
	        this.refs.composer.clear();
	      }
	
	      if (nextChatId) {
	        var state = _MessageComposerStore2.default.getComposerStates(nextChatId) || this.getInitialState();
	        this.setState(_extends({}, state));
	      }
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (this.props.width !== prevProps.width) {
	      this.hasResized(); // ResponsiveMixin
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _this2 = this;
	
	    if (!this.props.chat.isNew()) {
	      setTimeout(function () {
	        _MessageComposerActions2.default.saveState(_this2.props.chat.id, _this2.state);
	      }, 0);
	    }
	    this.destroyDropzone();
	  },
	  onUploadFailed: function onUploadFailed(file) {
	    if (file.getSize() > this.getMaxFilesize()) {
	      this.resetDropzone();
	      (0, _modal.mountModal)(_react2.default.createElement(_AlertDialog2.default, {
	        glyph: 'caution',
	        glyphColor: 'lava',
	        title: 'File "' + file.getName() + '" is too large.',
	        subtext: 'Files must be less than 10MB'
	      }), this);
	    }
	  },
	  getDropzoneId: function getDropzoneId() {
	    if (this.props.isNewChat) {
	      return 'newChat';
	    } else {
	      return this.props.chat.id;
	    }
	  },
	  getTranslationBox: function getTranslationBox() {
	    var _this3 = this;
	
	    var languages = _SettingsStore2.default.getLanguages().primary;
	
	    if (!languages) {
	      return null;
	    }
	
	    var buttons = [];
	
	    var displayedMax = (0, _lodash.keys)(languages).length;
	    var displayed = 0;
	
	    if (this.isComponentSize(MessageComposer.MEDIUM)) {
	      displayedMax -= 1;
	    } else if (this.isComponentSize(MessageComposer.SMALL)) {
	      displayedMax -= 2;
	    } else if (this.isComponentSize(MessageComposer.XSMALL)) {
	      displayedMax -= 3;
	    } else if (this.isComponentSize(MessageComposer.XXSMALL)) {
	      displayedMax -= 5;
	    }
	
	    var _loop = function _loop(lang) {
	      displayed += 1;
	      if (displayed <= displayedMax) {
	        buttons.push(_react2.default.createElement(
	          _Button2.default,
	          {
	            key: 'translate-' + lang,
	            eventContextName: UI_CONTEXT,
	            eventElementName: 'translate_button',
	            eventProperties: {
	              language_code: lang
	            },
	            onClick: function onClick() {
	              return _this3.translateTo(lang);
	            } },
	          languages[lang]
	        ));
	      }
	    };
	
	    for (var lang in languages) {
	      _loop(lang);
	    }
	
	    buttons.push(_react2.default.createElement(
	      _LayerTrigger2.default,
	      {
	        key: 'show-more',
	        layer: _react2.default.createElement(_LanguageHoverCard2.default, {
	          eventContextName: UI_CONTEXT,
	          onLanguagePicked: function onLanguagePicked(lang) {
	            return _this3.translateTo(lang);
	          }
	        }),
	        placement: 'top',
	        trigger: 'click',
	        alignment: 'middle' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          eventContextName: UI_CONTEXT,
	          eventElementName: 'show_more_languages_button',
	          level: 'secondary',
	          color: 'thunder',
	          size: 'xsmall' },
	        _react2.default.createElement(_Glyph2.default, { name: 'ellipses', solo: true })
	      )
	    ));
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)('MessageComposer-translationBox', {
	          'MessageComposer-translationBox-opened': this.state.translationBoxOpened,
	          'MessageComposer-translationBox-closed': !this.state.translationBoxOpened
	        }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'MessageComposer-translationBox-buttons' },
	        _react2.default.createElement(
	          _ButtonGroup2.default,
	          { level: 'secondary', color: 'thunder', size: 'xsmall' },
	          buttons
	        )
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'MessageComposer-translationBox-closeButton',
	          eventContextName: UI_CONTEXT,
	          eventElementName: 'close_translation_box',
	          onClick: this.toggleTranslationBoxOpened,
	          level: 'text' },
	        _react2.default.createElement(_Glyph2.default, { name: 'close-circle', color: 'brand', size: 'xlarge', solo: true })
	      )
	    );
	  },
	  toggleTranslationBoxOpened: function toggleTranslationBoxOpened() {
	    this.setState(function (_ref) {
	      var translationBoxOpened = _ref.translationBoxOpened;
	      return { translationBoxOpened: !translationBoxOpened };
	    });
	  },
	
	
	  allowSendAfterHours: null,
	
	  allowSendOutsideOfficeHours: {},
	
	  chatState: {},
	
	  handleTextChange: function handleTextChange(event) {
	    // $FlowIssue
	    var text = event.target.value;
	
	    if (text === this.state.text) {
	      return;
	    }
	
	    this.setState({
	      text: text,
	      composerError: text.trim().length > CHARACTER_LIMIT
	    });
	  },
	  confirmSendMessageAfterHours: function confirmSendMessageAfterHours() {
	    var _this4 = this;
	
	    var timeWarning = _Timing2.default.isEarly() ? 'It’s pretty early.' : 'It’s pretty late.';
	    var question = 'Send this message anyway?';
	
	    var title = _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Image2.default, {
	        className: 'MessageComposer-confirmImage',
	        src: __webpack_require__(2298)
	      }),
	      _react2.default.createElement(
	        'p',
	        null,
	        timeWarning,
	        ' ',
	        question
	      )
	    );
	
	    (0, _modal.mountModal)(_react2.default.createElement(_ConfirmDialog2.default, {
	      title: title,
	      eventContext: 'ChatMessageComposer',
	      size: 'xsmall',
	      onConfirm: function onConfirm() {
	        // $FlowFixMe
	        _this4.allowSendAfterHours = setTimeout(function () {
	          _this4.allowSendAfterHours = null;
	        }, AFTER_HOURS_NOTICE_TIMEOUT);
	        _this4.sendMessage();
	      }
	    }), this);
	  },
	  confirmSendMessageOutsideOfOfficeHours: function confirmSendMessageOutsideOfOfficeHours() {
	    var _this5 = this;
	
	    var chat = this.props.chat;
	
	    var otherChatMember = null;
	    var nextAvailability = null;
	    // XXX weird use of some() since the return value isn't used
	    chat.getOtherChatMembers().some(function (member) {
	      var officeHours = member.getOfficeHours();
	      if (officeHours && !officeHours.isAvailableNow()) {
	        otherChatMember = member;
	        nextAvailability = officeHours.getNextAvailability();
	        return true;
	      }
	      return false;
	    });
	
	    (0, _invariant2.default)(nextAvailability, 'unable to determine nextAvailability');
	
	    var startTime = nextAvailability.getStartTime();
	    var date = new Date();
	    var diff = (nextAvailability.getDay() + 7 - date.getDay()) % 7;
	    date.setHours(Math.floor(startTime / 3600));
	    date.setMinutes(startTime % 3600 / 60);
	
	    var day = diff === 1 ? _i18n2.default.getText('tomorrow') : _DateConstants2.default.WEEKDAYS[nextAvailability.getDay()];
	    var time = _i18n2.default.getTime(date, { hour: 'numeric', minute: '2-digit' });
	
	    var otherChatMemberName = otherChatMember ? otherChatMember.getName() : '???';
	
	    (0, _modal.mountModal)(_react2.default.createElement(_ConfirmDialog2.default, {
	      size: 'xsmall',
	      glyph: 'clock-bubble',
	      glyphColor: 'violet',
	      title: 'Uh-oh! ' + otherChatMemberName + ' won\u2019t be back until ' + day + ' at ' + time + '.',
	      subtext: 'Office hours for ' + otherChatMemberName + ' won\u2019t start until ' + day + ' at ' + time + ',\n          so they may not receive your message right now. Send anyway?',
	      onConfirm: function onConfirm() {
	        _this5.allowSendOutsideOfficeHours[chat.id] = setTimeout(function () {
	          delete _this5.allowSendOutsideOfficeHours[chat.id];
	        }, OFFICE_HOURS_NOTICE_TIMEOUT);
	        _this5.sendMessage();
	      }
	    }), this);
	  },
	  destroyDropzone: function destroyDropzone() {
	    if (this.props.chat.isNew()) {
	      var files = this.getFiles();
	      if (files.length > 0) {
	        this.removeFile(files[0]);
	      }
	      this.destroyDropzoneIfEmpty();
	    } else {
	      this.destroyDropzoneIfEmpty();
	    }
	  },
	  focus: function focus() {
	    if (this.refs.composer) {
	      this.refs.composer.focus();
	    }
	  },
	  handleEnableRepliesButtonClick: function handleEnableRepliesButtonClick(event) {
	    event.preventDefault();
	    _ChatActions2.default.enableReplies(this.props.chat);
	  },
	  isAttachEnabled: function isAttachEnabled() {
	    return !this.state.translationBoxOpened && (this.isChatEnabled() || this.props.chat.isNew()) && !this.getFiles()[0];
	  },
	  isAttachWithDragEnabled: function isAttachWithDragEnabled() {
	    return this.isChatEnabled();
	  },
	  isChatEnabled: function isChatEnabled() {
	    return this.props.chat.isPresent() && !this.props.chat.isUnsubscribed();
	  },
	  isValidMessage: function isValidMessage() {
	    var fileData = this.getFileData(this.getFiles()[0]);
	    if (fileData) {
	      var fileEntity = this.getFileEntities()[0];
	      return fileData.progress === 100 && fileEntity.hasUrls();
	    }
	    return this.state.text.trim() !== '';
	  },
	  getPlaceholder: function getPlaceholder() {
	    var chatTitle = this.props.chat.getTitle();
	    if (chatTitle) {
	      return 'Message ' + chatTitle;
	    } else {
	      return 'Type a message';
	    }
	  },
	  sendMessage: function sendMessage() {
	    var chat = this.props.chat;
	
	
	    if (chat.isOutsideOfOtherOfficeHours() && !this.allowSendOutsideOfficeHours[chat.id]) {
	      this.confirmSendMessageOutsideOfOfficeHours();
	    } else if ((_Timing2.default.isLate() || _Timing2.default.isEarly()) && !this.allowSendAfterHours) {
	      this.confirmSendMessageAfterHours();
	    } else {
	      this.props.onMessageSend(this.state.text, this.getFileEntities());
	      this.refs.composer.clear();
	      this.setState({ text: '' });
	      this.removeAllFiles();
	    }
	  },
	
	
	  // typecheck: ignore statement
	  handleReturn: function handleReturn(event) {
	    if (event.keyCode === _KeyConstants2.default.ENTER && !event.shiftKey) {
	      this.handleSubmit(event);
	      return true;
	    }
	    return false;
	  },
	
	
	  // typecheck: ignore statement
	  handleSubmit: function handleSubmit(event) {
	    event.preventDefault();
	    this.submitComposer();
	  },
	  submitComposer: function submitComposer() {
	    if (!this.submitDisabled()) {
	      this.sendMessage();
	    }
	  },
	  submitDisabled: function submitDisabled() {
	    return this.state.translationBoxOpened || this.state.composerError || !this.isChatEnabled() || !this.isValidMessage();
	  },
	  translateTo: function translateTo(lang) {
	    var _this6 = this;
	
	    _TranslationActions2.default.translate(this.state.text, lang).then(function (response) {
	      _this6.setState({
	        text: response.translation,
	        latestTranslation: lang,
	        translationBoxOpened: false
	      });
	    });
	  },
	  renderMessageComposer: function renderMessageComposer() {
	    var _this7 = this;
	
	    var _state = this.state,
	        composerError = _state.composerError,
	        isDraggingFile = _state.isDraggingFile,
	        isDraggingFileInner = _state.isDraggingFileInner,
	        translationBoxOpened = _state.translationBoxOpened,
	        latestTranslation = _state.latestTranslation;
	
	
	    if (!this.props.chat.canSend()) {
	      return null;
	    }
	
	    var chat = this.props.chat;
	
	
	    var errorMessage = null;
	    if (composerError) {
	      errorMessage = _react2.default.createElement(
	        'div',
	        { className: 'MessageComposer-error' },
	        'Sorry, you can\u2019t send more than ',
	        _i18n2.default.getNumber(CHARACTER_LIMIT),
	        ' characters'
	      );
	    }
	
	    var file = this.getFiles()[0];
	    var fileData = this.getFileData(file);
	
	    var dropZoneModal = void 0;
	    if (isDraggingFile && this.isAttachWithDragEnabled()) {
	      dropZoneModal = _react2.default.createElement(_DropZoneModal2.default, {
	        isHovering: isDraggingFileInner,
	        isFileUploaded: !!file
	      });
	    }
	
	    var attachButton = _react2.default.createElement(
	      'div',
	      { className: 'MessageComposer-attach', ref: 'dropzone', key: chat.id },
	      _react2.default.createElement(
	        'div',
	        { ref: 'dropzone_attach' },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'addFileButton_' + this.getDropzoneId(),
	            onClick: function onClick() {
	              return (0, _focusNode2.default)(_this7.refs.composer);
	            },
	            disabled: !this.isAttachEnabled(),
	            level: 'text' },
	          _react2.default.createElement(_Glyph2.default, { name: 'paperclip', className: 'MessageComposer-actionGlyph' }),
	          'Attach'
	        )
	      ),
	      dropZoneModal
	    );
	
	    var translateButton = _react2.default.createElement(
	      _Button2.default,
	      {
	        className: 'MessageComposer-translate',
	        disabled: this.state.text.length < 1,
	        eventContextName: UI_CONTEXT,
	        eventElementName: translationBoxOpened ? 'hide_translation_box' : 'show_translation_box',
	        onClick: function onClick() {
	          return _this7.setState({ translationBoxOpened: !translationBoxOpened });
	        },
	        level: 'text' },
	      _react2.default.createElement(_Glyph2.default, { name: 'globe', className: 'MessageComposer-actionGlyph' }),
	      'Translate'
	    );
	
	    if (isDraggingFile && !fileData) {
	      // use a fake file when hovering so that the composer is the correct size
	      fileData = {};
	    }
	    var filePreview = null;
	    if (fileData || isDraggingFile) {
	      filePreview = _react2.default.createElement(
	        'div',
	        { className: 'MessageComposer-preview' },
	        _react2.default.createElement(_ComposerFilePreview2.default, {
	          className: (0, _classnames2.default)({
	            draggingFile: isDraggingFile
	          }),
	          progress: fileData.progress,
	          thumbnail: fileData.thumbnail,
	          type: fileData.type,
	          error: fileData.error,
	          onDelete: function onDelete() {
	            return _this7.removeFile(file);
	          },
	          onRetry: function onRetry() {
	            return _this7.retryUpload(file);
	          },
	          file: this.state.uploadedFile
	        })
	      );
	    }
	
	    var eventProperties = {};
	
	    if (latestTranslation) {
	      eventProperties.language_code = latestTranslation;
	    }
	
	    var otherMembersPlaceholderText = this.getPlaceholder();
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'MessageComposer-composerContainer' },
	      _react2.default.createElement(
	        _FlexibleBlock2.default,
	        { flex: 'left' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Composer2.default,
	            {
	              ref: 'composer',
	              className: 'MessageComposer-composer',
	              onChange: this.handleTextChange,
	              onReturnKeyPress: this.handleReturn,
	              error: composerError,
	              onUpdate: this.checkLimit,
	              value: this.state.text,
	              placeholder: otherMembersPlaceholderText,
	              disabled: !this.isChatEnabled() },
	            filePreview,
	            this.getTranslationBox()
	          ),
	          errorMessage,
	          _react2.default.createElement(
	            'div',
	            { className: 'MessageComposer-actions' },
	            attachButton,
	            translateButton
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'MessageComposer-sendButton',
	            eventContextName: UI_CONTEXT,
	            eventElementName: 'send_button',
	            eventProperties: eventProperties,
	            level: 'primary',
	            size: 'small',
	            onClick: this.handleSubmit,
	            disabled: this.submitDisabled() },
	          'Send'
	        )
	      )
	    );
	  },
	  render: function render() {
	    var composerAlert = _react2.default.createElement(_ComposerAlert2.default, {
	      chat: this.props.chat,
	      openSideBar: this.props.openSideBar
	    });
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)('MessageComposer', this.props.className),
	        style: { width: this.props.width } },
	      !this.props.hideComposerAlert && composerAlert,
	      this.renderMessageComposer()
	    );
	  }
	});
	
	exports.default = MessageComposer;

/***/ },
/* 2288 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2289);

/***/ },
/* 2289 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactLink = __webpack_require__(2290);
	var ReactStateSetters = __webpack_require__(2291);
	
	/**
	 * A simple mixin around ReactLink.forState().
	 * See https://facebook.github.io/react/docs/two-way-binding-helpers.html
	 */
	var LinkedStateMixin = {
	  /**
	   * Create a ReactLink that's linked to part of this component's state. The
	   * ReactLink will have the current value of this.state[key] and will call
	   * setState() when a change is requested.
	   *
	   * @param {string} key state key to update.
	   * @return {ReactLink} ReactLink instance linking to the state.
	   */
	  linkState: function (key) {
	    return new ReactLink(this.state[key], ReactStateSetters.createStateKeySetter(this, key));
	  }
	};
	
	module.exports = LinkedStateMixin;

/***/ },
/* 2290 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * ReactLink encapsulates a common pattern in which a component wants to modify
	 * a prop received from its parent. ReactLink allows the parent to pass down a
	 * value coupled with a callback that, when invoked, expresses an intent to
	 * modify that value. For example:
	 *
	 * React.createClass({
	 *   getInitialState: function() {
	 *     return {value: ''};
	 *   },
	 *   render: function() {
	 *     var valueLink = new ReactLink(this.state.value, this._handleValueChange);
	 *     return <input valueLink={valueLink} />;
	 *   },
	 *   _handleValueChange: function(newValue) {
	 *     this.setState({value: newValue});
	 *   }
	 * });
	 *
	 * We have provided some sugary mixins to make the creation and
	 * consumption of ReactLink easier; see LinkedValueUtils and LinkedStateMixin.
	 */
	
	var React = __webpack_require__(300);
	
	/**
	 * Deprecated: An an easy way to express two-way binding with React. 
	 * See https://facebook.github.io/react/docs/two-way-binding-helpers.html
	 *
	 * @param {*} value current value of the link
	 * @param {function} requestChange callback to request a change
	 */
	function ReactLink(value, requestChange) {
	  this.value = value;
	  this.requestChange = requestChange;
	}
	
	/**
	 * Creates a PropType that enforces the ReactLink API and optionally checks the
	 * type of the value being passed inside the link. Example:
	 *
	 * MyComponent.propTypes = {
	 *   tabIndexLink: ReactLink.PropTypes.link(React.PropTypes.number)
	 * }
	 */
	function createLinkTypeChecker(linkType) {
	  var shapes = {
	    value: linkType === undefined ? React.PropTypes.any.isRequired : linkType.isRequired,
	    requestChange: React.PropTypes.func.isRequired
	  };
	  return React.PropTypes.shape(shapes);
	}
	
	ReactLink.PropTypes = {
	  link: createLinkTypeChecker
	};
	
	module.exports = ReactLink;

/***/ },
/* 2291 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactStateSetters = {
	  /**
	   * Returns a function that calls the provided function, and uses the result
	   * of that to set the component's state.
	   *
	   * @param {ReactCompositeComponent} component
	   * @param {function} funcReturningState Returned callback uses this to
	   *                                      determine how to update state.
	   * @return {function} callback that when invoked uses funcReturningState to
	   *                    determined the object literal to setState.
	   */
	  createStateSetter: function (component, funcReturningState) {
	    return function (a, b, c, d, e, f) {
	      var partialState = funcReturningState.call(component, a, b, c, d, e, f);
	      if (partialState) {
	        component.setState(partialState);
	      }
	    };
	  },
	
	  /**
	   * Returns a single-argument callback that can be used to update a single
	   * key in the component's state.
	   *
	   * Note: this is memoized function, which makes it inexpensive to call.
	   *
	   * @param {ReactCompositeComponent} component
	   * @param {string} key The key in the state that you should update.
	   * @return {function} callback of 1 argument which calls setState() with
	   *                    the provided keyName and callback argument.
	   */
	  createStateKeySetter: function (component, key) {
	    // Memoize the setters.
	    var cache = component.__keySetters || (component.__keySetters = {});
	    return cache[key] || (cache[key] = createStateKeySetter(component, key));
	  }
	};
	
	function createStateKeySetter(component, key) {
	  // Partial state is allocated outside of the function closure so it can be
	  // reused with every call, avoiding memory allocation when this function
	  // is called.
	  var partialState = {};
	  return function stateKeySetter(value) {
	    partialState[key] = value;
	    component.setState(partialState);
	  };
	}
	
	ReactStateSetters.Mixin = {
	  /**
	   * Returns a function that calls the provided function, and uses the result
	   * of that to set the component's state.
	   *
	   * For example, these statements are equivalent:
	   *
	   *   this.setState({x: 1});
	   *   this.createStateSetter(function(xValue) {
	   *     return {x: xValue};
	   *   })(1);
	   *
	   * @param {function} funcReturningState Returned callback uses this to
	   *                                      determine how to update state.
	   * @return {function} callback that when invoked uses funcReturningState to
	   *                    determined the object literal to setState.
	   */
	  createStateSetter: function (funcReturningState) {
	    return ReactStateSetters.createStateSetter(this, funcReturningState);
	  },
	
	  /**
	   * Returns a single-argument callback that can be used to update a single
	   * key in the component's state.
	   *
	   * For example, these statements are equivalent:
	   *
	   *   this.setState({x: 1});
	   *   this.createStateKeySetter('x')(1);
	   *
	   * Note: this is memoized function, which makes it inexpensive to call.
	   *
	   * @param {string} key The key in the state that you should update.
	   * @return {function} callback of 1 argument which calls setState() with
	   *                    the provided keyName and callback argument.
	   */
	  createStateKeySetter: function (key) {
	    return ReactStateSetters.createStateKeySetter(this, key);
	  }
	};
	
	module.exports = ReactStateSetters;

/***/ },
/* 2292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MessageComposerConstants = __webpack_require__(2293);
	
	var _Dispatcher = __webpack_require__(590);
	
	var MessageComposerActions = {
	  saveState: function saveState(chatId, state) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _MessageComposerConstants.ActionTypes.SAVE_STATE,
	      chatId: chatId,
	      state: state
	    });
	  }
	};
	
	exports.default = MessageComposerActions;

/***/ },
/* 2293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['SAVE_STATE']); /*  weak */

/***/ },
/* 2294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _MessageComposerConstants = __webpack_require__(2293);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageComposerStore = function (_Store) {
	  _inherits(MessageComposerStore, _Store);
	
	  function MessageComposerStore() {
	    _classCallCheck(this, MessageComposerStore);
	
	    return _possibleConstructorReturn(this, (MessageComposerStore.__proto__ || Object.getPrototypeOf(MessageComposerStore)).apply(this, arguments));
	  }
	
	  _createClass(MessageComposerStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        composerStates: {}
	      };
	    }
	  }, {
	    key: 'getComposerStates',
	    value: function getComposerStates(chatId) {
	      return this.state.composerStates[chatId];
	    }
	  }, {
	    key: 'setComposerStates',
	    value: function setComposerStates(chatId, state) {
	      this.state.composerStates[chatId] = state;
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _MessageComposerConstants.ActionTypes.SAVE_STATE:
	          this.setComposerStates(action.chatId, action.state);
	          this.emitChange();
	          break;
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return MessageComposerStore;
	}(_Store3.default);
	
	MessageComposerStore.displayName = 'MessageComposerStore';
	exports.default = new MessageComposerStore();

/***/ },
/* 2295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var settings = {
	  weekday: { early: 7, late: 21 },
	  weekend: { early: 9, late: 21 }
	};
	
	
	_SettingsStore2.default.addListener(function () {
	  Object.assign(settings, _SettingsStore2.default.getMessagesTiming());
	});
	
	exports.default = {
	  isWeekend: function isWeekend() {
	    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	
	    return date.getDay() === 0 || date.getDay() === 6;
	  },
	  isWeekday: function isWeekday() {
	    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	
	    return !this.isWeekend(date);
	  },
	  isLate: function isLate() {
	    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	
	    var hour = date.getHours();
	    return this.isWeekend() && hour >= settings.weekend.late || this.isWeekday() && hour >= settings.weekday.late;
	  },
	  isEarly: function isEarly() {
	    var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	
	    var hour = date.getHours();
	    return this.isWeekend() && hour < settings.weekend.early || this.isWeekday() && hour < settings.weekday.early;
	  }
	};

/***/ },
/* 2296 */
1136,
/* 2297 */,
/* 2298 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _EventRSVPForm = __webpack_require__(1952);
	
	var _EventRSVPForm2 = _interopRequireDefault(_EventRSVPForm);
	
	__webpack_require__(2300);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComposerEventRSVP = function (_React$Component) {
	  _inherits(ComposerEventRSVP, _React$Component);
	
	  function ComposerEventRSVP() {
	    _classCallCheck(this, ComposerEventRSVP);
	
	    return _possibleConstructorReturn(this, (ComposerEventRSVP.__proto__ || Object.getPrototypeOf(ComposerEventRSVP)).apply(this, arguments));
	  }
	
	  _createClass(ComposerEventRSVP, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ComposerEventRSVP' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ComposerEventRSVP-container' },
	          _react2.default.createElement(
	            _Text2.default,
	            { element: 'div', className: 'ComposerEventRSVP-label', weight: 'bold' },
	            'RSVP to join this conversation!'
	          ),
	          _react2.default.createElement(_EventRSVPForm2.default, {
	            buttonSize: 'medium',
	            onChange: this.props.onChange,
	            disableSelectionChange: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return ComposerEventRSVP;
	}(_react2.default.Component);
	
	ComposerEventRSVP.displayName = 'ComposerEventRSVP';
	exports.default = ComposerEventRSVP;

/***/ },
/* 2300 */
1136,
/* 2301 */,
/* 2302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (chat) {
	  var memberships = chat.getOtherPresentMemberships(_CurrentUser2.default.getUserId());
	
	  if (chat.getType() !== 'assistant') {
	    if (memberships.length > 1) {
	      return memberships.length + 1 + ' people in this conversation';
	    } else if (memberships.length === 1) {
	      var firstUserRole = memberships[0].getMember().getRole();
	      return firstUserRole ? (0, _lodash.capitalize)(firstUserRole) : 'No Role';
	    }
	  }
	
	  return '';
	};
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 2303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _lodash = __webpack_require__(555);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _Message = __webpack_require__(930);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _AnnouncementMessageListItem = __webpack_require__(2304);
	
	var _AnnouncementMessageListItem2 = _interopRequireDefault(_AnnouncementMessageListItem);
	
	var _MessageListWelcome = __webpack_require__(2325);
	
	var _MessageListWelcome2 = _interopRequireDefault(_MessageListWelcome);
	
	var _MessageListItem = __webpack_require__(2330);
	
	var _MessageListItem2 = _interopRequireDefault(_MessageListItem);
	
	var _MessageListSystemItem = __webpack_require__(2340);
	
	var _MessageListSystemItem2 = _interopRequireDefault(_MessageListSystemItem);
	
	var _MessageListTimeItem = __webpack_require__(2346);
	
	var _MessageListTimeItem2 = _interopRequireDefault(_MessageListTimeItem);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _GapMessageItem = __webpack_require__(2349);
	
	var _GapMessageItem2 = _interopRequireDefault(_GapMessageItem);
	
	var _MessageHistory = __webpack_require__(2350);
	
	__webpack_require__(2351);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	function allChatMessages(messages) {
	  var chatMessages = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = messages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var m = _step.value;
	
	      if (m instanceof _ChatMessage2.default) {
	        chatMessages.push(m);
	      } else {
	        console.error('unexpected not ChatMessage', m);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return chatMessages;
	}
	
	var MessageList = function (_React$Component) {
	  _inherits(MessageList, _React$Component);
	
	  function MessageList(props) {
	    _classCallCheck(this, MessageList);
	
	    var _this = _possibleConstructorReturn(this, (MessageList.__proto__ || Object.getPrototypeOf(MessageList)).call(this, props));
	
	    _this.detectScrolledToBottom = (0, _lodash.debounce)(function () {
	      if (_this.isScrolledToBottom()) {
	        if (_this.props.onScrollToBottom) {
	          _this.props.onScrollToBottom();
	        }
	        _this.setState({ tooltip: false });
	        _this.refs.trigger.handleDelayedHide();
	      }
	    }, 200);
	
	    _this.isScrolledToBottom = function () {
	      return _this.refs.scrollable && _this.refs.scrollable.isScrolledToBottom(50);
	    };
	
	    _this.scrollToBottom = function () {
	      if (_this.refs.scrollable) {
	        _this.refs.scrollable.scrollToBottom();
	        _this.detectScrolledToBottom();
	      }
	    };
	
	    _this._itemRenderer = function (_ref) {
	      var index = _ref.index;
	
	      var item = _this.state.items[index];
	
	      if (item.messageType) {
	        // $FlowFixMe not sure how to cast this
	        var bunch = item;
	        return _this.renderBunch(bunch);
	      } else if (item instanceof _ChatMessage.ChatGapMessage || item instanceof _Message.GapMessage) {
	        return _react2.default.createElement(_GapMessageItem2.default, {
	          key: item.getUuid(),
	          message: item,
	          onVisible: _this.props.loadMoreMessages
	        });
	      } else if (item instanceof Date) {
	        return _react2.default.createElement(_MessageListTimeItem2.default, { key: item.toString(), date: item });
	      } else {
	        if (!_this._hasErroredOnItemType) {
	          console.warn('Unknown item type at index', index, item);
	          console.error('DEBUG MessageList returning null for item');
	          _this._hasErroredOnItemType = true;
	        }
	        return null;
	      }
	    };
	
	    _this.state = {
	      tooltip: false,
	      items: (0, _MessageHistory.extractListItems)(props.messages)
	    };
	    return _this;
	  }
	
	  _createClass(MessageList, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.messages !== this.props.messages) {
	        this.setState({
	          items: (0, _MessageHistory.extractListItems)(nextProps.messages)
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
	    }
	
	    // TODO refactor this to avoid setState
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var unreads = this.props.unreadCount || 0;
	
	      if (unreads > 0 && !this.isScrolledToBottom() && !this.state.tooltip) {
	        this.refs.trigger.showLayer();
	        this.setState({ tooltip: true }); // eslint-disable-line react/no-did-update-set-state
	      }
	
	      if (this.props.chat !== prevProps.chat) {
	        this.scrollToBottom();
	      }
	
	      if (prevProps.messages.length === this.props.messages.length - 1) {
	        this.onReceiveNewMessage();
	      }
	    }
	
	    // debounce (not throttle) because we only need to carry out this logic if
	    // the user is at the bottom once their scrolling settles
	
	  }, {
	    key: 'onReceiveNewMessage',
	    value: function onReceiveNewMessage() {
	      if (this.isScrolledToBottom()) {
	        this.scrollToBottom();
	      }
	    }
	  }, {
	    key: 'renderBunch',
	    value: function renderBunch(bunch) {
	      var messages = bunch.messages;
	      var _props = this.props,
	          chat = _props.chat,
	          group = _props.group;
	
	      var isUnsubscribed = chat ? chat.isUnsubscribed() : false;
	      var isGroupChat = chat ? chat.isGroupChat() : false;
	      var itemKey = messages[0].getUuid();
	
	      switch (bunch.messageType) {
	        case 'broadcast':
	        case 'message':
	          return _react2.default.createElement(_AnnouncementMessageListItem2.default, {
	            key: itemKey,
	            group: group,
	            messages: messages,
	            isGroupChat: isGroupChat
	          });
	        case 'attachment':
	        case 'text':
	          return _react2.default.createElement(_MessageListItem2.default, {
	            key: itemKey,
	            messages: allChatMessages(messages),
	            isGroupChat: isGroupChat,
	            disabled: isUnsubscribed
	          });
	        case 'system':
	          return _react2.default.createElement(_MessageListSystemItem2.default, {
	            key: itemKey,
	            messages: messages
	          });
	        case 'gap':
	          console.error('renderBunch received gap message');
	          return undefined;
	        default:
	          console.error('Unknown Message Type: ' + bunch.messageType);
	          return undefined;
	      }
	    }
	  }, {
	    key: 'renderMessages',
	    value: function renderMessages() {
	      var _this2 = this;
	
	      var items = this.state.items;
	
	
	      var result = (0, _lodash.range)(items.length).map(function (index) {
	        return _this2._itemRenderer({ index: index });
	      });
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'MessageList-messages' },
	        result
	      );
	    }
	  }, {
	    key: 'renderTooltipLauncher',
	    value: function renderTooltipLauncher() {
	      var unreads = this.props.unreadCount || 0;
	
	      var messageText = unreads === 1 ? 'You have 1 unread message' : 'You have ' + unreads + ' unread messages';
	
	      var tooltip = _react2.default.createElement(
	        _Tooltip2.default,
	        {
	          onClick: this.scrollToBottom,
	          className: (0, _classnames2.default)({
	            'MessageList-tooltip': true,
	            'MessageList-unread': this.state.tooltip,
	            'MessageList-unreadFade': !this.state.tooltip
	          }),
	          hideOnEscape: false,
	          hideOnBlur: false },
	        messageText
	      );
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          ref: 'trigger',
	          layer: tooltip,
	          trigger: 'manual',
	          placement: 'top',
	          alignment: 'middle' },
	        _react2.default.createElement('div', null)
	      );
	    }
	  }, {
	    key: 'renderWelcome',
	    value: function renderWelcome() {
	      var _props2 = this.props,
	          chat = _props2.chat,
	          group = _props2.group,
	          subgroupRole = _props2.subgroupRole;
	
	
	      return _react2.default.createElement(_MessageListWelcome2.default, { chat: chat, group: group, subgroupRole: subgroupRole });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('MessageList', this.props.className) },
	        _react2.default.createElement(
	          _ScrollableArea2.default,
	          {
	            useBodyChildrenHeight: true,
	            scrollToBottom: true,
	            ref: 'scrollable',
	            onScroll: this.detectScrolledToBottom },
	          this.renderWelcome(),
	          this.renderMessages()
	        ),
	        this.renderTooltipLauncher()
	      );
	    }
	  }]);
	
	  return MessageList;
	}(_react2.default.Component);
	
	MessageList.displayName = 'MessageList';
	exports.default = MessageList;

/***/ },
/* 2304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _AnnouncementMessageItem = __webpack_require__(2305);
	
	var _AnnouncementMessageItem2 = _interopRequireDefault(_AnnouncementMessageItem);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _RelationshipModal = __webpack_require__(1309);
	
	var _RelationshipModal2 = _interopRequireDefault(_RelationshipModal);
	
	var _UserLink = __webpack_require__(1640);
	
	var _UserLink2 = _interopRequireDefault(_UserLink);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	__webpack_require__(2323);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnnouncementMessageListItem = function (_React$Component) {
	  _inherits(AnnouncementMessageListItem, _React$Component);
	
	  function AnnouncementMessageListItem() {
	    _classCallCheck(this, AnnouncementMessageListItem);
	
	    return _possibleConstructorReturn(this, (AnnouncementMessageListItem.__proto__ || Object.getPrototypeOf(AnnouncementMessageListItem)).apply(this, arguments));
	  }
	
	  _createClass(AnnouncementMessageListItem, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, null);
	    }
	  }, {
	    key: 'getSender',
	    value: function getSender() {
	      var messages = this.props.messages;
	
	      var firstMessage = messages[0];
	      return firstMessage.getSender();
	    }
	  }, {
	    key: 'sentByCurrentUser',
	    value: function sentByCurrentUser() {
	      return _CurrentUser2.default.getUserId() === this.getSender().id;
	    }
	  }, {
	    key: 'renderName',
	    value: function renderName() {
	      var sender = this.getSender();
	      var modal = _react2.default.createElement(_RelationshipModal2.default, { userId: sender.id });
	
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: modal },
	        _react2.default.createElement(
	          _UserLink2.default,
	          {
	            userId: sender.id,
	            neverShowStartChat: !this.props.isGroupChat,
	            placement: 'right',
	            color: 'inherit',
	            alignment: 'top' },
	          _react2.default.createElement(
	            'span',
	            { className: 'AnnouncementMessageListItem-name' },
	            sender.getName()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderMessage',
	    value: function renderMessage(message, isCurrentUser, lastOfGroup) {
	      var sender = this.getSender();
	      return _react2.default.createElement(_AnnouncementMessageItem2.default, {
	        key: message.getUuid(),
	        message: message,
	        group: this.props.group || message.getGroupSummary(),
	        sentBySelf: isCurrentUser,
	        senderColor: sender.getColor(),
	        senderInitials: sender.getInitials(),
	        lastOfGroup: lastOfGroup
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var messages = this.props.messages;
	
	      var sentByCurrentUser = this.sentByCurrentUser();
	      var messageItems = messages.map(function (message) {
	        var lastOfGroup = message === messages[messages.length - 1];
	        return _this2.renderMessage(message, sentByCurrentUser, lastOfGroup);
	      });
	
	      if (sentByCurrentUser) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'AnnouncementMessageListItem-content' },
	          messageItems
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AnnouncementMessageListItem-messageGroup' },
	        _react2.default.createElement(
	          'div',
	          { className: 'AnnouncementMessageListItem-contentWrap' },
	          this.renderName(),
	          _react2.default.createElement(
	            'span',
	            { className: 'AnnouncementMessageListItem-content' },
	            messageItems
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var sentByCurrentUser = this.sentByCurrentUser();
	
	      return _react2.default.createElement(
	        'li',
	        {
	          className: (0, _classnames2.default)('AnnouncementMessageListItem', {
	            'AnnouncementMessageListItem-self': sentByCurrentUser,
	            'AnnouncementMessageListItem-other': !sentByCurrentUser
	          }) },
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return AnnouncementMessageListItem;
	}(_react2.default.Component);
	
	AnnouncementMessageListItem.displayName = 'AnnouncementMessageListItem';
	exports.default = AnnouncementMessageListItem;

/***/ },
/* 2305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _ChatMessageStore = __webpack_require__(988);
	
	var _ChatMessageStore2 = _interopRequireDefault(_ChatMessageStore);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DeliveryStore = __webpack_require__(1678);
	
	var _DeliveryStore2 = _interopRequireDefault(_DeliveryStore);
	
	var _DeliverySummaryStore = __webpack_require__(2306);
	
	var _DeliverySummaryStore2 = _interopRequireDefault(_DeliverySummaryStore);
	
	var _DeliveryModal = __webpack_require__(1647);
	
	var _DeliveryModal2 = _interopRequireDefault(_DeliveryModal);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _FeatureStore = __webpack_require__(588);
	
	var _FeatureStore2 = _interopRequireDefault(_FeatureStore);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _MessageActions = __webpack_require__(1228);
	
	var _MessageActions2 = _interopRequireDefault(_MessageActions);
	
	var _MessageDelivery = __webpack_require__(1680);
	
	var _MessageDelivery2 = _interopRequireDefault(_MessageDelivery);
	
	var _MessageDeliverySummary = __webpack_require__(1658);
	
	var _MessageDeliverySummary2 = _interopRequireDefault(_MessageDeliverySummary);
	
	var _MessageItemContent = __webpack_require__(2057);
	
	var _MessageItemContent2 = _interopRequireDefault(_MessageItemContent);
	
	var _modal = __webpack_require__(1188);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TooltippedReactionButton = __webpack_require__(2308);
	
	var _TooltippedReactionButton2 = _interopRequireDefault(_TooltippedReactionButton);
	
	var _ReactionDisplay = __webpack_require__(2315);
	
	var _ReactionDisplay2 = _interopRequireDefault(_ReactionDisplay);
	
	var _ReactionSummary = __webpack_require__(936);
	
	var _ReactionSummary2 = _interopRequireDefault(_ReactionSummary);
	
	__webpack_require__(2321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getDeliverySummary(message) {
	  var announcement = message instanceof _Message2.default ? message : message.getMessage();
	  return _DeliverySummaryStore2.default.getByMessageId(announcement.getUuid());
	}
	
	var AnnouncementMessageItem = function (_React$Component) {
	  _inherits(AnnouncementMessageItem, _React$Component);
	
	  function AnnouncementMessageItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnnouncementMessageItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnnouncementMessageItem.__proto__ || Object.getPrototypeOf(AnnouncementMessageItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      reactionSummary: null,
	      readReceipt: _DeliveryStore2.default.getDeliveryByMessageId(_this.props.message.getUuid()),
	      deliverySummary: getDeliverySummary(_this.props.message),
	      reactionPickerVisible: false,
	      hovered: false
	    }, _this.onHoverReactionPickerShow = function () {
	      _this.setState({ reactionPickerVisible: true });
	    }, _this.onHoverReactionPickerHide = function () {
	      _this.setState({ reactionPickerVisible: false });
	    }, _this.onEnterHover = function () {
	      _this.setState({ hovered: true });
	    }, _this.onLeaveHover = function () {
	      _this.setState({ hovered: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AnnouncementMessageItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _MessageActions2.default.loadDeliverySummary(this.getAnnouncement());
	    }
	  }, {
	    key: 'getAnnouncement',
	    value: function getAnnouncement() {
	      var message = this.props.message;
	
	      return message instanceof _Message2.default ? message : message.getMessage();
	    }
	  }, {
	    key: 'isAnnouncementToOwnedGroup',
	    value: function isAnnouncementToOwnedGroup(message) {
	      var threadGroupIds = message.getThreads().map(function (thread) {
	        return thread.group_id;
	      }) || [];
	      var messageGroupIds = message.getGroupIds() || [];
	      return threadGroupIds.concat(messageGroupIds).map(function (id) {
	        return _GroupStore2.default.getGroup(id);
	      }).map(function (group) {
	        return group && group.isOwnedByUser(_CurrentUser2.default.getUser().id);
	      }).includes(true);
	    }
	  }, {
	    key: 'memberCountForRoles',
	    value: function memberCountForRoles(messageRoles) {
	      var groupRoles = this.props.group.getRoles();
	      // Add the number of people in group for each role message was sent to
	      return _lodash2.default.sumBy(groupRoles, function (r) {
	        return messageRoles.includes(r.role) ? r.count : 0;
	      });
	    }
	  }, {
	    key: 'renderDeliveryInfo',
	    value: function renderDeliveryInfo() {
	      var _this2 = this;
	
	      var group = this.props.group;
	      var deliverySummary = this.state.deliverySummary;
	
	      var openReadReceiptModal = function openReadReceiptModal() {
	        (0, _modal.mountModal)(_react2.default.createElement(_DeliveryModal2.default, { summary: deliverySummary, loaded: true, tooSoon: true }), _this2);
	      };
	
	      var sentCount = void 0;
	      var readCount = void 0;
	
	      if (deliverySummary) {
	        sentCount = deliverySummary.getTotalSent();
	        readCount = deliverySummary.getReadCount();
	      } else {
	        var roles = this.getAnnouncement().getRoles();
	        var defaultRecipients = roles.includes(_roleHelpers.EVERYONE) ? group.getMembershipsCount() : this.memberCountForRoles(roles);
	        sentCount = defaultRecipients;
	        readCount = 0;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AnnouncementMessageItem-head-deliveryInfo' },
	        _react2.default.createElement(
	          'span',
	          null,
	          ' Sent to ',
	          sentCount,
	          ' '
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          ' ',
	          ' • ',
	          ' '
	        ),
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            onClick: openReadReceiptModal },
	          'Seen by ',
	          readCount
	        )
	      );
	    }
	  }, {
	    key: 'renderAnnouncementHeader',
	    value: function renderAnnouncementHeader() {
	      var group = this.props.group;
	
	      var isAnnouncementToOwnedGroup = this.isAnnouncementToOwnedGroup(this.getAnnouncement());
	
	      var groupName = group.getName();
	      var roles = this.getAnnouncement().getRoles();
	      var groupHeading = roles.includes(_roleHelpers.EVERYONE) ? groupName : groupName + ' ' + roles.map(function (role) {
	        return _roleHelpers.subgroupName[role];
	      }).join(' & ');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AnnouncementMessageItem-head' },
	        _react2.default.createElement(_GroupAvatar2.default, {
	          className: 'AnnouncementMessageItem-announcementBadge',
	          group: group
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'AnnouncementMessageItem-head-classInfo' },
	          _react2.default.createElement(
	            _Text2.default,
	            { className: 'AnnouncementMessageItem-groupName', weight: 'semibold', truncate: true },
	            groupHeading
	          ),
	          isAnnouncementToOwnedGroup && this.renderDeliveryInfo()
	        )
	      );
	    }
	  }, {
	    key: 'renderReactions',
	    value: function renderReactions() {
	      var _props = this.props,
	          message = _props.message,
	          sentBySelf = _props.sentBySelf;
	
	      return _react2.default.createElement(_ReactionDisplay2.default, {
	        message: message,
	        reactionSummary: this.state.reactionSummary,
	        sentBySelf: sentBySelf
	      });
	    }
	  }, {
	    key: 'renderHover',
	    value: function renderHover() {
	      var message = this.props.message;
	
	      var reactionsEnabled = _FeatureStore2.default.hasFeature('web.reactions') && message instanceof _ChatMessage2.default;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AnnouncementMessageItem-hover' },
	        _react2.default.createElement(
	          'div',
	          { className: 'MessageItem-hover-receipt' },
	          _react2.default.createElement(_Time2.default, {
	            date: message.getSentAt(),
	            hour: 'numeric',
	            minute: '2-digit'
	          })
	        ),
	        reactionsEnabled && !message.hasReactions() && _react2.default.createElement(_TooltippedReactionButton2.default, {
	          message: message,
	          onShow: this.onHoverReactionPickerShow,
	          onHide: this.onHoverReactionPickerHide,
	          reactionPickerVisible: this.state.reactionPickerVisible
	        })
	      );
	    }
	  }, {
	    key: 'renderDroplet',
	    value: function renderDroplet() {
	      var _props2 = this.props,
	          senderColor = _props2.senderColor,
	          senderInitials = _props2.senderInitials,
	          lastOfGroup = _props2.lastOfGroup,
	          sentBySelf = _props2.sentBySelf;
	
	      return lastOfGroup && !sentBySelf ? _react2.default.createElement(
	        'span',
	        { className: 'AnnouncementMessageItem-droplet' },
	        _react2.default.createElement(_Avatar2.default, {
	          colorHex: senderColor,
	          size: 'small',
	          text: senderInitials
	        })
	      ) : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          sentBySelf = _props3.sentBySelf,
	          message = _props3.message;
	      var _state = this.state,
	          hovered = _state.hovered,
	          reactionPickerVisible = _state.reactionPickerVisible;
	
	      var reactionsEnabled = _FeatureStore2.default.hasFeature('web.reactions') && message instanceof _ChatMessage2.default;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('AnnouncementMessageItem', {
	            'AnnouncementMessageItem-self': sentBySelf,
	            'AnnouncementMessageItem-other': !sentBySelf,
	            'AnnouncementMessageItem-hovered': hovered || reactionPickerVisible
	          }) },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'AnnouncementMessageItem-row',
	            onMouseEnter: this.onEnterHover,
	            onMouseLeave: this.onLeaveHover },
	          this.renderHover(),
	          _react2.default.createElement(
	            'div',
	            { className: 'AnnouncementMessageItem-container' },
	            this.renderAnnouncementHeader(),
	            _react2.default.createElement(_MessageItemContent2.default, {
	              className: 'AnnouncementMessageItem-content',
	              sentBySelf: sentBySelf,
	              message: message,
	              failed: false
	            })
	          ),
	          this.renderDroplet()
	        ),
	        reactionsEnabled && this.renderReactions()
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_DeliveryStore2.default, _DeliverySummaryStore2.default, _ChatMessageStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var message = props.message;
	
	
	      var reactionSummary = void 0;
	      if (message instanceof _ChatMessage2.default) {
	        var chatMessages = _ChatMessageStore2.default.getChatMessages(props.message.getChatId());
	        var chatMessage = chatMessages.find(function (m) {
	          return m.id === props.message.id;
	        });
	        reactionSummary = chatMessage.getReactionSummary();
	      }
	
	      return {
	        reactionPickerVisible: false,
	        hovered: false,
	        readReceipt: _DeliveryStore2.default.getDeliveryByMessageId(message.getUuid()),
	        deliverySummary: getDeliverySummary(message),
	        reactionSummary: reactionSummary
	      };
	    }
	  }]);
	
	  return AnnouncementMessageItem;
	}(_react2.default.Component);
	
	AnnouncementMessageItem.displayName = 'AnnouncementMessageItem';
	exports.default = _utils.Container.create(AnnouncementMessageItem, { withProps: true });

/***/ },
/* 2306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _GroupConstants = __webpack_require__(991);
	
	var _MessageDeliverySummaries = __webpack_require__(2307);
	
	var _MessageDeliverySummaries2 = _interopRequireDefault(_MessageDeliverySummaries);
	
	var _PusherConstants = __webpack_require__(954);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DeliverySummaryStore = function (_Store) {
	  _inherits(DeliverySummaryStore, _Store);
	
	  function DeliverySummaryStore() {
	    _classCallCheck(this, DeliverySummaryStore);
	
	    return _possibleConstructorReturn(this, (DeliverySummaryStore.__proto__ || Object.getPrototypeOf(DeliverySummaryStore)).apply(this, arguments));
	  }
	
	  _createClass(DeliverySummaryStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        loadedSummaries: {},
	        summaries: new _MessageDeliverySummaries2.default()
	      };
	    }
	  }, {
	    key: 'isDeliverySummaryLoaded',
	    value: function isDeliverySummaryLoaded(messageId) {
	      return !!this.state.loadedSummaries[messageId];
	    }
	  }, {
	    key: 'getByMessageId',
	    value: function getByMessageId(id) {
	      return this.state.summaries.get(id);
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      var _this2 = this;
	
	      switch (action.type) {
	        case _GroupConstants.ActionTypes.LOAD_DELIVERY_SUMMARY:
	          this.state.loadedSummaries[action.messageId] = true;
	          this.state.summaries.add(action.summary);
	          this.emitChange();
	          break;
	        case _PusherConstants.PushEvents.CHANGESET_UPDATE_DELIVERY_UPDATES:
	          {
	            var messageUUIDS = action.changes.map(function (change) {
	              return change.content.message_uuid;
	            });
	            messageUUIDS.forEach(function (messageUUID) {
	              return _this2.state.summaries.remove(messageUUID);
	            });
	            break;
	          }
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return DeliverySummaryStore;
	}(_Store3.default);
	
	DeliverySummaryStore.displayName = 'DeliverySummaryStore';
	exports.default = new DeliverySummaryStore();

/***/ },
/* 2307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MessageDeliverySummary = __webpack_require__(1658);
	
	var _MessageDeliverySummary2 = _interopRequireDefault(_MessageDeliverySummary);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageDeliverySummaries = function (_Collection) {
	  _inherits(MessageDeliverySummaries, _Collection);
	
	  function MessageDeliverySummaries() {
	    _classCallCheck(this, MessageDeliverySummaries);
	
	    return _possibleConstructorReturn(this, (MessageDeliverySummaries.__proto__ || Object.getPrototypeOf(MessageDeliverySummaries)).apply(this, arguments));
	  }
	
	  _createClass(MessageDeliverySummaries, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _MessageDeliverySummary2.default;
	    }
	  }, {
	    key: 'findWhereMessageId',
	    value: function findWhereMessageId(messageId) {
	      // This findWhere is provided by backbone-collection, NOT proxied to lodash
	      // which is nice because findWhere has been removed in lodash 4
	      return this.findWhere({ message_uuid: messageId });
	    }
	  }]);
	
	  return MessageDeliverySummaries;
	}(_Collection3.default);
	
	MessageDeliverySummaries.displayName = 'MessageDeliverySummaries';
	exports.default = MessageDeliverySummaries;

/***/ },
/* 2308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactionButton = __webpack_require__(2309);
	
	var _ReactionButton2 = _interopRequireDefault(_ReactionButton);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TooltippedReactionButton = function TooltippedReactionButton(_ref) {
	  var message = _ref.message,
	      onShow = _ref.onShow,
	      onHide = _ref.onHide,
	      reactionPickerVisible = _ref.reactionPickerVisible;
	
	  var addReactionTooltip = _react2.default.createElement(
	    _Tooltip2.default,
	    null,
	    _react2.default.createElement(
	      'span',
	      null,
	      'Add reaction'
	    )
	  );
	
	  return _react2.default.createElement(
	    _LayerTrigger2.default,
	    {
	      trigger: ['hover', 'focus'],
	      layer: reactionPickerVisible ? _react2.default.createElement('div', null) : addReactionTooltip,
	      placement: 'top' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_ReactionButton2.default, {
	        message: message,
	        onShow: onShow,
	        onHide: onHide
	      })
	    )
	  );
	};
	exports.default = TooltippedReactionButton;

/***/ },
/* 2309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactionButton = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _Hovercard = __webpack_require__(1548);
	
	var _Hovercard2 = _interopRequireDefault(_Hovercard);
	
	var _HovercardBody = __webpack_require__(1554);
	
	var _HovercardBody2 = _interopRequireDefault(_HovercardBody);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactionEmojis = __webpack_require__(2310);
	
	var _ReactionEmojis2 = _interopRequireDefault(_ReactionEmojis);
	
	var _ShortcodeEmoji = __webpack_require__(1151);
	
	var _ShortcodeEmoji2 = _interopRequireDefault(_ShortcodeEmoji);
	
	__webpack_require__(2312);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactionButton = exports.ReactionButton = function (_React$Component) {
	  _inherits(ReactionButton, _React$Component);
	
	  function ReactionButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactionButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactionButton.__proto__ || Object.getPrototypeOf(ReactionButton)).call.apply(_ref, [this].concat(args))), _this), _this._layerPicker = null, _this.onShow = function () {
	      if (_this.props.onShow) {
	        _this.props.onShow();
	      }
	    }, _this.onHide = function () {
	      if (_this.props.onHide) {
	        _this.props.onHide();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactionButton, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          message = _props.message,
	          reactions = _props.reactions;
	
	
	      if (!reactions) {
	        return null;
	      }
	
	      var reactionPicker = _react2.default.createElement(
	        _Hovercard2.default,
	        {
	          className: 'ReactionButton-picker',
	          hideOnEscape: true,
	          hideOnBlur: true },
	        _react2.default.createElement(
	          _HovercardBody2.default,
	          { className: 'ReactionButton-picker-body' },
	          reactions && reactions.map(function (reaction) {
	            return _react2.default.createElement(
	              _Link2.default,
	              {
	                key: reaction.getName(),
	                className: 'ReactionButton-picker-body-emoji',
	                onClick: function onClick() {
	                  if (_this2._layerPicker) {
	                    _this2._layerPicker.hideLayer();
	                  }
	                  message.addReaction(reaction.getName());
	                },
	                eventElementName: 'ReactionButton-picker-body-emoji' },
	              _react2.default.createElement(_ShortcodeEmoji2.default, { text: reaction.getEmojiCode() })
	            );
	          })
	        )
	      );
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          className: (0, _classnames2.default)('ReactionButton', this.props.className),
	          layer: reactionPicker,
	          ref: function ref(layerPicker) {
	            return _this2._layerPicker = layerPicker;
	          },
	          trigger: 'click',
	          alignment: 'right',
	          placement: 'top',
	          onShow: this.onShow,
	          onHide: this.onHide,
	          hideLayerOnScroll: true },
	        _react2.default.createElement(
	          _Link2.default,
	          null,
	          _react2.default.createElement(_Image2.default, { src: __webpack_require__(2314) })
	        )
	      );
	    }
	  }]);
	
	  return ReactionButton;
	}(_react2.default.Component);
	
	ReactionButton.displayName = 'ReactionButton';
	
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    reactions: state.availableReactions.availableReactions
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReactionButton);

/***/ },
/* 2310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _ReactionEmoji = __webpack_require__(2311);
	
	var _ReactionEmoji2 = _interopRequireDefault(_ReactionEmoji);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactionEmojis = function (_Collection) {
	  _inherits(ReactionEmojis, _Collection);
	
	  function ReactionEmojis() {
	    _classCallCheck(this, ReactionEmojis);
	
	    return _possibleConstructorReturn(this, (ReactionEmojis.__proto__ || Object.getPrototypeOf(ReactionEmojis)).apply(this, arguments));
	  }
	
	  _createClass(ReactionEmojis, [{
	    key: 'parse',
	    value: function parse(response) {
	      return response.map(function (reaction) {
	        return _ReactionEmoji2.default.fromJSON(reaction);
	      });
	    }
	
	    // $FlowFixMe
	
	  }], [{
	    key: 'fetch',
	    value: function fetch() {
	      return (0, _apiRequest2.default)('/messages/reactions', 'GET').then(function (response) {
	        return ReactionEmojis.fromJSON(response);
	      });
	    }
	  }]);
	
	  return ReactionEmojis;
	}(_Collection3.default);
	
	ReactionEmojis.displayName = 'ReactionEmojis';
	exports.default = ReactionEmojis;

/***/ },
/* 2311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactionEmoji = function (_Entity) {
	  _inherits(ReactionEmoji, _Entity);
	
	  function ReactionEmoji() {
	    _classCallCheck(this, ReactionEmoji);
	
	    return _possibleConstructorReturn(this, (ReactionEmoji.__proto__ || Object.getPrototypeOf(ReactionEmoji)).apply(this, arguments));
	  }
	
	  _createClass(ReactionEmoji, [{
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getEmojiCode',
	    value: function getEmojiCode() {
	      return ':' + this.get('name') + ':'; // API returns Emoji shortcodes with no colons
	    }
	  }]);
	
	  return ReactionEmoji;
	}(_Entity3.default);
	
	ReactionEmoji.displayName = 'ReactionEmoji';
	exports.default = ReactionEmoji;

/***/ },
/* 2312 */
1136,
/* 2313 */,
/* 2314 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _MessageReaction = __webpack_require__(2316);
	
	var _MessageReaction2 = _interopRequireDefault(_MessageReaction);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Reaction = __webpack_require__(938);
	
	var _Reaction2 = _interopRequireDefault(_Reaction);
	
	var _ReactionButton = __webpack_require__(2309);
	
	var _ReactionButton2 = _interopRequireDefault(_ReactionButton);
	
	var _ReactionSummary = __webpack_require__(936);
	
	var _ReactionSummary2 = _interopRequireDefault(_ReactionSummary);
	
	__webpack_require__(2319);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactionDisplay = function (_React$Component) {
	  _inherits(ReactionDisplay, _React$Component);
	
	  function ReactionDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactionDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactionDisplay.__proto__ || Object.getPrototypeOf(ReactionDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.renderReaction = function (reaction) {
	      return _react2.default.createElement(_MessageReaction2.default, {
	        message: _this.props.message,
	        key: reaction.getName(),
	        reaction: reaction
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactionDisplay, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          message = _props.message,
	          reactionSummary = _props.reactionSummary,
	          sentBySelf = _props.sentBySelf;
	
	      var reactions = reactionSummary ? reactionSummary.getReactions() : null;
	
	      if (!reactions || reactions.isEmpty()) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('ReactionDisplay', {
	            'ReactionDisplay-self': sentBySelf,
	            'ReactionDisplay-other': !sentBySelf
	          }) },
	        reactions.map(this.renderReaction),
	        _react2.default.createElement(_ReactionButton2.default, {
	          className: 'ReactionDisplay-addButton',
	          message: message
	        })
	      );
	    }
	  }]);
	
	  return ReactionDisplay;
	}(_react2.default.Component);
	
	ReactionDisplay.displayName = 'ReactionDisplay';
	exports.default = ReactionDisplay;

/***/ },
/* 2316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _HumanArray = __webpack_require__(2222);
	
	var _HumanArray2 = _interopRequireDefault(_HumanArray);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Reaction = __webpack_require__(938);
	
	var _Reaction2 = _interopRequireDefault(_Reaction);
	
	var _ShortcodeEmoji = __webpack_require__(1151);
	
	var _ShortcodeEmoji2 = _interopRequireDefault(_ShortcodeEmoji);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2317);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var replaceYourNameWithTheWordYouIn = function replaceYourNameWithTheWordYouIn(names) {
	  return names.map(function (name) {
	    return name === _CurrentUser2.default.getUser().getName() ? 'You' : name;
	  });
	};
	
	var MessageReaction = function (_React$Component) {
	  _inherits(MessageReaction, _React$Component);
	
	  function MessageReaction() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MessageReaction);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessageReaction.__proto__ || Object.getPrototypeOf(MessageReaction)).call.apply(_ref, [this].concat(args))), _this), _this.toggleReaction = function () {
	      var _this$props = _this.props,
	          reaction = _this$props.reaction,
	          message = _this$props.message;
	
	      if (_this.hasBeenSelectedByCurrentUser()) {
	        message.removeReaction(reaction.getName());
	      } else {
	        message.addReaction(reaction.getName());
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MessageReaction, [{
	    key: 'hasBeenSelectedByCurrentUser',
	    value: function hasBeenSelectedByCurrentUser() {
	      return this.props.reaction.getUserUuids().includes(_CurrentUser2.default.getUserUuid());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var reaction = this.props.reaction;
	
	
	      var tooltip = _react2.default.createElement(
	        _Tooltip2.default,
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(_HumanArray2.default, {
	            sample: replaceYourNameWithTheWordYouIn(reaction.getUserNames()),
	            total: reaction.getCount()
	          })
	        )
	      );
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          trigger: ['hover', 'focus'],
	          layer: tooltip,
	          placement: 'bottom' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('MessageReaction', {
	              'MessageReaction-selfReacted': this.hasBeenSelectedByCurrentUser()
	            }),
	            onClick: this.toggleReaction },
	          _react2.default.createElement(_ShortcodeEmoji2.default, { text: reaction.getEmojiCode() }),
	          _react2.default.createElement(
	            'div',
	            { className: 'MessageReaction-count' },
	            reaction.getCount()
	          )
	        )
	      );
	    }
	  }]);
	
	  return MessageReaction;
	}(_react2.default.Component);
	
	MessageReaction.displayName = 'MessageReaction';
	exports.default = MessageReaction;

/***/ },
/* 2317 */
1136,
/* 2318 */,
/* 2319 */
1136,
/* 2320 */,
/* 2321 */
1136,
/* 2322 */,
/* 2323 */
1136,
/* 2324 */,
/* 2325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MessageListWelcome = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatWelcomeMessage = __webpack_require__(2326);
	
	var _ChatWelcomeMessage2 = _interopRequireDefault(_ChatWelcomeMessage);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _roleHelpers = __webpack_require__(1230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageListWelcome = exports.MessageListWelcome = function (_React$PureComponent) {
	  _inherits(MessageListWelcome, _React$PureComponent);
	
	  function MessageListWelcome() {
	    _classCallCheck(this, MessageListWelcome);
	
	    return _possibleConstructorReturn(this, (MessageListWelcome.__proto__ || Object.getPrototypeOf(MessageListWelcome)).apply(this, arguments));
	  }
	
	  _createClass(MessageListWelcome, [{
	    key: 'makeHeaders',
	    value: function makeHeaders() {
	      var _props = this.props,
	          chat = _props.chat,
	          group = _props.group,
	          subgroupRole = _props.subgroupRole;
	
	      if (group) {
	        var messageSettingsLink = _react2.default.createElement(
	          _Link2.default,
	          { to: '/settings/chat' },
	          'message settings'
	        );
	        var subgrouped = subgroupRole && subgroupRole !== _roleHelpers.EVERYONE;
	        // $FlowIssue can't infer that role is defined
	        var target = subgrouped ? subgroupRole + 's in ' + group.getName() : group.getName();
	        // $FlowIssue can't infer that role is defined
	        var membershipDescription = subgrouped ? 'Participants' : _roleHelpers.subgroupName[subgroupRole];
	
	        return {
	          firstHeader: 'This is the beginning of your announcement history for ' + target + '.',
	          secondHeader: _react2.default.createElement(
	            'div',
	            null,
	            membershipDescription,
	            ' in your class can receive announcements by text, app, web, and email. They can also reply directly to you depending on your ',
	            messageSettingsLink,
	            '.'
	          )
	        };
	      } else if (chat) {
	        var otherMember = chat.getOtherMember();
	        var subject = otherMember && otherMember.id !== -1 ? otherMember.name : 'Participants';
	        var title = chat.hasTitle() ? chat.getTitle() : chat.getDisplayNames().join(', ');
	
	        return {
	          firstHeader: _react2.default.createElement(
	            'div',
	            null,
	            'This is the beginning of your message history with ',
	            title,
	            '.'
	          ),
	          secondHeader: subject + ' can send and receive messages by text, app, web, and email.'
	        };
	      } else {
	        return { firstHeader: null, secondHeader: null };
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var chat = this.props.chat;
	
	      var heroImage = __webpack_require__(2329);
	
	      if (chat && chat.isActivityType()) {
	        return null;
	      }
	
	      var _makeHeaders = this.makeHeaders(),
	          firstHeader = _makeHeaders.firstHeader,
	          secondHeader = _makeHeaders.secondHeader;
	
	      return _react2.default.createElement(_ChatWelcomeMessage2.default, {
	        chat: chat,
	        firstHeader: firstHeader,
	        secondHeader: secondHeader,
	        heroImage: heroImage,
	        className: 'MessageList-welcomeMessage'
	      });
	    }
	  }]);
	
	  return MessageListWelcome;
	}(_react2.default.PureComponent);
	
	MessageListWelcome.displayName = 'MessageListWelcome';
	exports.default = MessageListWelcome;

/***/ },
/* 2326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatWelcomeMessage = function (_React$Component) {
	  _inherits(ChatWelcomeMessage, _React$Component);
	
	  function ChatWelcomeMessage() {
	    _classCallCheck(this, ChatWelcomeMessage);
	
	    return _possibleConstructorReturn(this, (ChatWelcomeMessage.__proto__ || Object.getPrototypeOf(ChatWelcomeMessage)).apply(this, arguments));
	  }
	
	  _createClass(ChatWelcomeMessage, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          firstHeader = _props.firstHeader,
	          secondHeader = _props.secondHeader,
	          heroImage = _props.heroImage;
	
	      if (!firstHeader || !secondHeader) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ChatWelcomeMessage', this.props.className) },
	        _react2.default.createElement(_Image2.default, {
	          className: 'ChatWelcomeMessage-hero',
	          src: heroImage
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ChatWelcomeMessage-nuxH1' },
	          'Welcome!'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ChatWelcomeMessage-nuxH2' },
	          firstHeader
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ChatWelcomeMessage-nuxH3' },
	          secondHeader
	        )
	      );
	    }
	  }]);
	
	  return ChatWelcomeMessage;
	}(_react2.default.Component);
	
	ChatWelcomeMessage.displayName = 'ChatWelcomeMessage';
	exports.default = ChatWelcomeMessage;

/***/ },
/* 2327 */
1136,
/* 2328 */,
/* 2329 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "96a1ab1fd6e0e8f252eef63b727e5403.png";

/***/ },
/* 2330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _ChatMessageStore = __webpack_require__(988);
	
	var _ChatMessageStore2 = _interopRequireDefault(_ChatMessageStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _MessageItem = __webpack_require__(2331);
	
	var _MessageItem2 = _interopRequireDefault(_MessageItem);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _RelationshipModal = __webpack_require__(1309);
	
	var _RelationshipModal2 = _interopRequireDefault(_RelationshipModal);
	
	var _UserLink = __webpack_require__(1640);
	
	var _UserLink2 = _interopRequireDefault(_UserLink);
	
	__webpack_require__(2338);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageListItem = function (_React$Component) {
	  _inherits(MessageListItem, _React$Component);
	
	  function MessageListItem() {
	    _classCallCheck(this, MessageListItem);
	
	    return _possibleConstructorReturn(this, (MessageListItem.__proto__ || Object.getPrototypeOf(MessageListItem)).apply(this, arguments));
	  }
	
	  _createClass(MessageListItem, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, null);
	    }
	  }, {
	    key: 'getSender',
	    value: function getSender() {
	      var messages = this.props.messages;
	
	      var firstMessage = messages[0];
	      return firstMessage.getSender();
	    }
	  }, {
	    key: 'sentByCurrentUser',
	    value: function sentByCurrentUser() {
	      return _CurrentUser2.default.getUserId() === this.getSender().id;
	    }
	  }, {
	    key: 'renderName',
	    value: function renderName() {
	      var sender = this.getSender();
	      var modal = _react2.default.createElement(_RelationshipModal2.default, { userId: sender.id });
	
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: modal },
	        _react2.default.createElement(
	          _UserLink2.default,
	          {
	            userId: sender.id,
	            neverShowStartChat: !this.props.isGroupChat,
	            placement: 'right',
	            color: 'inherit',
	            alignment: 'top' },
	          _react2.default.createElement(
	            'span',
	            {
	              className: (0, _classnames2.default)('MessageListItem-name', {
	                'MessageListItem-disabled': this.props.disabled
	              }),
	              disabled: this.props.disabled },
	            sender.getName()
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderMessage',
	    value: function renderMessage(message, isCurrentUser, lastOfGroup) {
	      var sender = this.getSender();
	      return _react2.default.createElement(_MessageItem2.default, {
	        key: message.getUuid(),
	        failed: _ChatMessageStore2.default.hasMessageFailed(message),
	        message: message,
	        sentBySelf: isCurrentUser,
	        senderColor: sender.getColor(),
	        senderInitials: sender.getInitials(),
	        lastOfGroup: lastOfGroup
	      });
	    }
	  }, {
	    key: 'renderContent',
	    value: function renderContent() {
	      var _this2 = this;
	
	      var messages = this.props.messages;
	
	      var sentByCurrentUser = this.sentByCurrentUser();
	      var messageItems = messages.map(function (message) {
	        var lastOfGroup = message === messages[messages.length - 1];
	        return _this2.renderMessage(message, sentByCurrentUser, lastOfGroup);
	      });
	
	      if (sentByCurrentUser) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'MessageListItem-content' },
	          messageItems
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MessageListItem-messageGroup' },
	        _react2.default.createElement(
	          'div',
	          { className: 'MessageListItem-contentWrap' },
	          this.renderName(),
	          _react2.default.createElement(
	            'div',
	            { className: 'MessageListItem-content' },
	            messageItems
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var sentByCurrentUser = this.sentByCurrentUser();
	
	      return _react2.default.createElement(
	        'li',
	        {
	          className: (0, _classnames2.default)('MessageListItem', {
	            'MessageListItem-self': sentByCurrentUser,
	            'MessageListItem-other': !sentByCurrentUser
	          }) },
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return MessageListItem;
	}(_react2.default.Component);
	
	MessageListItem.defaultProps = {
	  disabled: false,
	  isGroupChat: false
	};
	MessageListItem.displayName = 'MessageListItem';
	exports.default = MessageListItem;

/***/ },
/* 2331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Audio = __webpack_require__(1258);
	
	var _Audio2 = _interopRequireDefault(_Audio);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _ChatMessageStore = __webpack_require__(988);
	
	var _ChatMessageStore2 = _interopRequireDefault(_ChatMessageStore);
	
	var _ChatMessageActions = __webpack_require__(939);
	
	var _ChatMessageActions2 = _interopRequireDefault(_ChatMessageActions);
	
	var _ChatReadReceipt = __webpack_require__(2332);
	
	var _ChatReadReceipt2 = _interopRequireDefault(_ChatReadReceipt);
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _FeatureStore = __webpack_require__(588);
	
	var _FeatureStore2 = _interopRequireDefault(_FeatureStore);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _MessageItemContent = __webpack_require__(2057);
	
	var _MessageItemContent2 = _interopRequireDefault(_MessageItemContent);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TooltippedReactionButton = __webpack_require__(2308);
	
	var _TooltippedReactionButton2 = _interopRequireDefault(_TooltippedReactionButton);
	
	var _ReactionDisplay = __webpack_require__(2315);
	
	var _ReactionDisplay2 = _interopRequireDefault(_ReactionDisplay);
	
	var _ReactionSummary = __webpack_require__(936);
	
	var _ReactionSummary2 = _interopRequireDefault(_ReactionSummary);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	__webpack_require__(2336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var MessageItem = function (_React$Component) {
	  _inherits(MessageItem, _React$Component);
	
	  function MessageItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MessageItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessageItem.__proto__ || Object.getPrototypeOf(MessageItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      reactionSummary: null,
	      hovered: false,
	      reactionPickerVisible: false
	    }, _this.handleCancel = function () {
	      _ChatMessageActions2.default.removeMessage(_this.props.message);
	    }, _this.handleRetry = function () {
	      _ChatMessageActions2.default.sendMessage(_this.props.message);
	    }, _this.onHoverReactionPickerShow = function () {
	      _this.setState({ reactionPickerVisible: true });
	    }, _this.onHoverReactionPickerHide = function () {
	      _this.setState({ reactionPickerVisible: false });
	    }, _this.onEnterHover = function () {
	      _this.setState({ hovered: true });
	    }, _this.onLeaveHover = function () {
	      _this.setState({ hovered: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MessageItem, [{
	    key: 'showReadReceipt',
	    value: function showReadReceipt(message) {
	      return message.getSender().id === _CurrentUser2.default.getUser().id;
	    }
	  }, {
	    key: 'renderReadReceipt',
	    value: function renderReadReceipt(message) {
	      return message.hasReactions() ? null : _react2.default.createElement(
	        'div',
	        { className: 'MessageItem-readIcon' },
	        this.showReadReceipt(message) && _react2.default.createElement(_ChatReadReceipt2.default, { hovered: true, labelDisplay: true, glyphDisplay: true, message: message })
	      );
	    }
	  }, {
	    key: 'renderReactions',
	    value: function renderReactions() {
	      var _props = this.props,
	          message = _props.message,
	          sentBySelf = _props.sentBySelf;
	
	      return _react2.default.createElement(_ReactionDisplay2.default, {
	        message: message,
	        reactionSummary: this.state.reactionSummary,
	        sentBySelf: sentBySelf
	      });
	    }
	  }, {
	    key: 'renderRetry',
	    value: function renderRetry() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'MessageItem-retry' },
	        _react2.default.createElement(_Glyph2.default, { name: 'caution', className: 'MessageItem-retryGlyph' }),
	        'Message failed to send.',
	        ' ',
	        _react2.default.createElement(
	          _Link2.default,
	          { weight: 'semibold', onClick: this.handleRetry },
	          'Retry'
	        ),
	        ' ',
	        'or',
	        ' ',
	        _react2.default.createElement(
	          _Link2.default,
	          { weight: 'semibold', onClick: this.handleCancel },
	          'Cancel'
	        )
	      );
	    }
	  }, {
	    key: 'renderHover',
	    value: function renderHover() {
	      var _props2 = this.props,
	          message = _props2.message,
	          sentBySelf = _props2.sentBySelf;
	
	      var reactionsEnabled = _FeatureStore2.default.hasFeature('web.reactions');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'MessageItem-hover' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)({
	              'MessageItem-hover-receipt': !message.hasReactions()
	            }) },
	          _react2.default.createElement(_Time2.default, {
	            date: message.getSentAt(),
	            hour: 'numeric',
	            minute: '2-digit'
	          }),
	          sentBySelf && _react2.default.createElement(_ChatReadReceipt2.default, { hovered: true, labelDisplay: false, glyphDisplay: true, message: message })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'MessageItem-hover-reactionButton' },
	          reactionsEnabled && !message.hasReactions() && _react2.default.createElement(_TooltippedReactionButton2.default, {
	            message: message,
	            onShow: this.onHoverReactionPickerShow,
	            onHide: this.onHoverReactionPickerHide,
	            reactionPickerVisible: this.state.reactionPickerVisible
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderDroplet',
	    value: function renderDroplet() {
	      var _props3 = this.props,
	          senderColor = _props3.senderColor,
	          senderInitials = _props3.senderInitials,
	          lastOfGroup = _props3.lastOfGroup,
	          sentBySelf = _props3.sentBySelf;
	
	      return lastOfGroup && !sentBySelf ? _react2.default.createElement(
	        'span',
	        { className: 'MessageItem-droplet' },
	        _react2.default.createElement(_Avatar2.default, {
	          colorHex: senderColor,
	          size: 'small',
	          text: senderInitials
	        })
	      ) : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          message = _props4.message,
	          failed = _props4.failed,
	          sentBySelf = _props4.sentBySelf;
	      var _state = this.state,
	          hovered = _state.hovered,
	          reactionPickerVisible = _state.reactionPickerVisible;
	
	      var reactionsEnabled = _FeatureStore2.default.hasFeature('web.reactions');
	
	      var hasBody = !!message.getBody();
	      var file = message.getFile();
	      var isSoloAudioFile = !hasBody && file && _Audio2.default.isSupportedType(file.getContentType());
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('MessageItem', {
	            'MessageItem-self': sentBySelf,
	            'MessageItem-other': !sentBySelf,
	            'MessageItem-noRoundedCorners': isSoloAudioFile,
	            'MessageItem-hovered': hovered || reactionPickerVisible
	          }) },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'MessageItem-row',
	            onMouseEnter: this.onEnterHover,
	            onMouseLeave: this.onLeaveHover },
	          this.renderHover(),
	          _react2.default.createElement(
	            'div',
	            { className: 'MessageItem-container' },
	            _react2.default.createElement(_MessageItemContent2.default, { message: message, failed: failed, sentBySelf: sentBySelf }),
	            failed && this.renderRetry()
	          ),
	          this.renderDroplet()
	        ),
	        reactionsEnabled && this.renderReactions(),
	        this.renderReadReceipt(message)
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ChatMessageStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var chatMessages = _ChatMessageStore2.default.getChatMessages(props.message.getChatId());
	      var chatMessage = chatMessages.find(function (m) {
	        return m.id === props.message.id;
	      });
	      var reactionSummary = chatMessage.getReactionSummary();
	      return _extends({}, prevState, {
	        reactionSummary: reactionSummary
	      });
	    }
	  }]);
	
	  return MessageItem;
	}(_react2.default.Component);
	
	MessageItem.displayName = 'MessageItem';
	exports.default = _utils.Container.create(MessageItem, { withProps: true });

/***/ },
/* 2332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ChatMessageStore = __webpack_require__(988);
	
	var _ChatMessageStore2 = _interopRequireDefault(_ChatMessageStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DeliveryModalContainer = __webpack_require__(2333);
	
	var _DeliveryModalContainer2 = _interopRequireDefault(_DeliveryModalContainer);
	
	var _DeliveryStore = __webpack_require__(1678);
	
	var _DeliveryStore2 = _interopRequireDefault(_DeliveryStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReadReceipt = __webpack_require__(1670);
	
	var _ReadReceipt2 = _interopRequireDefault(_ReadReceipt);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _DeliveryConstants = __webpack_require__(1648);
	
	var _modal = __webpack_require__(1188);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	__webpack_require__(2334);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChatReadReceipt = _react2.default.createClass({
	  displayName: 'ChatReadReceipt',
	
	
	  mixins: [(0, _linkStateWithStores2.default)([_DeliveryStore2.default, _ChatMessageStore2.default])],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      labelDisplay: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  getLastMessageReceivedSequence: function getLastMessageReceivedSequence() {
	    var chatMessages = this.state.messages.filter(function (message) {
	      return message instanceof _ChatMessage.ChatMessage && message.getSender().id !== _CurrentUser2.default.getUser().id;
	    }).sort(function (a, b) {
	      return b.getSeq() - a.getSeq();
	    });
	
	    if (chatMessages && chatMessages[0]) {
	      return chatMessages[0].getSeq();
	    }
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      delivery: _DeliveryStore2.default.getDeliveryByMessageId(this.props.message.id),
	      marker: _DeliveryStore2.default.getMarkerForStream(this.props.message.getChatId()),
	      messages: _ChatMessageStore2.default.getChatMessages(this.props.message.getChatId())
	    };
	  },
	  showDeliveryModal: function showDeliveryModal() {
	    (0, _modal.mountModal)(_react2.default.createElement(_DeliveryModalContainer2.default, { message: this.props.message }), this);
	  },
	  render: function render() {
	    if (!this.state.delivery) {
	      return null;
	    }
	
	    if (!this.state.delivery.getReadSummary()) {
	      return null;
	    }
	
	    // we only display a read receipt before the
	    // last received message when item is hovered.
	    var shouldHide = !this.props.hovered &&
	    // $FlowFixMe
	    this.getLastMessageReceivedSequence() > this.props.message.getSeq();
	
	    if (shouldHide) {
	      return null;
	    }
	
	    /* If we received a marker for that stream about the readSeq
	     * then we show all previous message as read. The "read" status
	     * will show up in the read summary otherwise!
	     */
	    var shouldBeMarkAsRead = this.state.marker && this.state.marker.readSeq >= this.props.message.getSeq();
	
	    var status = shouldBeMarkAsRead ? _DeliveryConstants.DeliveryStatus.READ : this.state.delivery.getReadSummary().getState();
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'ChatReadReceipt' },
	      status && _react2.default.createElement(
	        'span',
	        null,
	        this.props.labelDisplay && _react2.default.createElement(
	          'span',
	          { className: 'ChatReadReceipt-spacer' },
	          ' • '
	        ),
	        _react2.default.createElement(_ReadReceipt2.default, {
	          labelDisplay: this.props.labelDisplay,
	          glyphDisplay: this.props.glyphDisplay,
	          errorCount: this.state.delivery.getReadSummary().getFailedCount(),
	          status: status,
	          onClick: status === _DeliveryConstants.DeliveryStatus.DELIVERY_ERROR ? this.showDeliveryModal : null
	        })
	      )
	    );
	  }
	});
	exports.default = ChatReadReceipt;

/***/ },
/* 2333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DeliveryModal = __webpack_require__(1647);
	
	var _DeliveryModal2 = _interopRequireDefault(_DeliveryModal);
	
	var _DeliveryStore = __webpack_require__(1678);
	
	var _DeliveryStore2 = _interopRequireDefault(_DeliveryStore);
	
	var _DeliverySummaryStore = __webpack_require__(2306);
	
	var _DeliverySummaryStore2 = _interopRequireDefault(_DeliverySummaryStore);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _ChatMessage2 = _interopRequireDefault(_ChatMessage);
	
	var _MessageDeliverySummary = __webpack_require__(1658);
	
	var _MessageDeliverySummary2 = _interopRequireDefault(_MessageDeliverySummary);
	
	var _MessageActions = __webpack_require__(1228);
	
	var _MessageActions2 = _interopRequireDefault(_MessageActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DELIVERY_SUMMARY_UNAVAILABLE_THRESHOLD = 24 * 60 * 60 * 1000; // 1 day
	
	var DeliveryModalContainer = function (_React$Component) {
	  _inherits(DeliveryModalContainer, _React$Component);
	
	  function DeliveryModalContainer() {
	    _classCallCheck(this, DeliveryModalContainer);
	
	    return _possibleConstructorReturn(this, (DeliveryModalContainer.__proto__ || Object.getPrototypeOf(DeliveryModalContainer)).apply(this, arguments));
	  }
	
	  _createClass(DeliveryModalContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var message = this.props.message;
	
	
	      if (message instanceof _Message2.default) {
	        _MessageActions2.default.loadDeliverySummary(message);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_DeliveryModal2.default, _extends({}, this.props, this.state));
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_DeliveryStore2.default, _DeliverySummaryStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var summary = void 0;
	      var loaded = void 0;
	      var tooSoon = false;
	
	      if (props.message instanceof _Message2.default) {
	        summary = _DeliverySummaryStore2.default.getByMessageId(props.message.getUuid());
	        loaded = _DeliverySummaryStore2.default.isDeliverySummaryLoaded(props.message.id);
	        if (loaded && !summary) {
	          tooSoon = Date.now() - props.message.getSentAt() < DELIVERY_SUMMARY_UNAVAILABLE_THRESHOLD;
	        }
	      } else if (props.message instanceof _ChatMessage2.default) {
	        summary = _DeliveryStore2.default.getDeliveryByMessageId(props.message.id).getReadSummary();
	        loaded = true; /* we can't load chat msg summary, they already are in the message object! */
	      }
	
	      return {
	        summary: summary,
	        loaded: loaded,
	        tooSoon: tooSoon
	      };
	    }
	  }]);
	
	  return DeliveryModalContainer;
	}(_react2.default.Component);
	
	DeliveryModalContainer.displayName = 'DeliveryModalContainer';
	exports.default = _utils.Container.create(DeliveryModalContainer, { withProps: true });

/***/ },
/* 2334 */
1136,
/* 2335 */,
/* 2336 */
1136,
/* 2337 */,
/* 2338 */
1136,
/* 2339 */,
/* 2340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _MessageSystemItem = __webpack_require__(2341);
	
	var _MessageSystemItem2 = _interopRequireDefault(_MessageSystemItem);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChatMessage = __webpack_require__(927);
	
	__webpack_require__(2344);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageListSystemItem = function (_React$Component) {
	  _inherits(MessageListSystemItem, _React$Component);
	
	  function MessageListSystemItem() {
	    _classCallCheck(this, MessageListSystemItem);
	
	    return _possibleConstructorReturn(this, (MessageListSystemItem.__proto__ || Object.getPrototypeOf(MessageListSystemItem)).apply(this, arguments));
	  }
	
	  _createClass(MessageListSystemItem, [{
	    key: 'render',
	    value: function render() {
	      var messages = this.props.messages;
	
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'MessageListSystemItem' },
	        messages.map(function (m) {
	          return _react2.default.createElement(_MessageSystemItem2.default, { key: m.id, message: m });
	        })
	      );
	    }
	  }]);
	
	  return MessageListSystemItem;
	}(_react2.default.Component);
	
	MessageListSystemItem.displayName = 'MessageListSystemItem';
	exports.default = MessageListSystemItem;

/***/ },
/* 2341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2342);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageSystemItem = function (_React$Component) {
	  _inherits(MessageSystemItem, _React$Component);
	
	  function MessageSystemItem() {
	    _classCallCheck(this, MessageSystemItem);
	
	    return _possibleConstructorReturn(this, (MessageSystemItem.__proto__ || Object.getPrototypeOf(MessageSystemItem)).apply(this, arguments));
	  }
	
	  _createClass(MessageSystemItem, [{
	    key: 'renderMessageBody',
	    value: function renderMessageBody() {
	      var message = this.props.message;
	
	      var body = message.getBody();
	      if (!body) {
	        return null;
	      }
	
	      var entities = [].concat(_TextEntities2.default.parseEmoji(body), _TextEntities2.default.parseNewlines(body), _TextEntities2.default.parseLeadingWhitespace(body), _TextEntities2.default.parseUrls(body), _TextEntities2.default.parseAttributes(message.getBodyAttributes()));
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)({ 'MessageSystemItem-body': true }) },
	        _react2.default.createElement(_TextWithEntities2.default, { text: body, entities: entities })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'MessageSystemItem' },
	        this.renderMessageBody()
	      );
	    }
	  }]);
	
	  return MessageSystemItem;
	}(_react2.default.Component);
	
	MessageSystemItem.displayName = 'MessageSystemItem';
	exports.default = MessageSystemItem;

/***/ },
/* 2342 */
1136,
/* 2343 */,
/* 2344 */
1136,
/* 2345 */,
/* 2346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Timestamp = __webpack_require__(1683);
	
	var _Timestamp2 = _interopRequireDefault(_Timestamp);
	
	__webpack_require__(2347);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MessageListTimeItem = function (_React$PureComponent) {
	  _inherits(MessageListTimeItem, _React$PureComponent);
	
	  function MessageListTimeItem() {
	    _classCallCheck(this, MessageListTimeItem);
	
	    return _possibleConstructorReturn(this, (MessageListTimeItem.__proto__ || Object.getPrototypeOf(MessageListTimeItem)).apply(this, arguments));
	  }
	
	  _createClass(MessageListTimeItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'li',
	        { className: 'MessageListTimeItem' },
	        _react2.default.createElement(_Timestamp2.default, { className: 'MessageListTimeItem-date', date: this.props.date, format: 'long' })
	      );
	    }
	  }]);
	
	  return MessageListTimeItem;
	}(_react2.default.PureComponent);
	
	MessageListTimeItem.displayName = 'MessageListTimeItem';
	exports.default = MessageListTimeItem;

/***/ },
/* 2347 */
1136,
/* 2348 */,
/* 2349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GapMessageItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _ScrollWatch = __webpack_require__(1238);
	
	var _ScrollWatch2 = _interopRequireDefault(_ScrollWatch);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _ChatMessage = __webpack_require__(927);
	
	var _Message = __webpack_require__(930);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GapMessageItem = exports.GapMessageItem = function (_React$Component) {
	  _inherits(GapMessageItem, _React$Component);
	
	  function GapMessageItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GapMessageItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GapMessageItem.__proto__ || Object.getPrototypeOf(GapMessageItem)).call.apply(_ref, [this].concat(args))), _this), _this.detectVisible = function () {
	      var alreadyVisible = _this.refs.gapWatch && _this.refs.gapWatch.isVisible();
	      if (alreadyVisible) {
	        _this.handleVisible();
	      }
	    }, _this.handleVisible = function () {
	      var _this$props = _this.props,
	          message = _this$props.message,
	          onVisible = _this$props.onVisible;
	
	      // temporary debugging in prod
	
	      var validType = message instanceof _ChatMessage.ChatGapMessage || message instanceof _Message.GapMessage;
	      if (!validType) {
	        console.error('message prop not a gap', message.getType());
	        return;
	      }
	
	      onVisible(message);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GapMessageItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // let MessageList scroll to the bottom first
	      setTimeout(this.detectVisible, 0);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, null);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // see if it's still visible after DOM updates
	      setTimeout(this.detectVisible, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _ScrollWatch2.default,
	          {
	            onEnter: this.handleVisible,
	            ref: 'gapWatch' },
	          _react2.default.createElement(
	            'div',
	            { className: 'MessageList-loading' },
	            _react2.default.createElement(_LoadingIndicator2.default, { size: 'small' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return GapMessageItem;
	}(_react2.default.Component);
	
	GapMessageItem.displayName = 'GapMessageItem';
	exports.default = GapMessageItem;

/***/ },
/* 2350 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extractGapAndBunches = extractGapAndBunches;
	exports.extractListItems = extractListItems;
	var sameDay = exports.sameDay = function sameDay(a, b) {
	  return !!b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
	};
	
	function makeBunch(message) {
	  var date = message.getSentAt();
	  var sender = message.getSender();
	  return {
	    date: date,
	    senderId: sender ? sender.id : undefined,
	    messageType: message.getType(),
	    messages: [message]
	  };
	}
	
	var MESSAGE_BUNCH_TIME_WINDOW = 1000 * 60 * 5; // 5 min
	
	/**
	 * A bunch is of the same type, on same day, from same sender, within MESSAGE_BUNCH_TIME_WINDOW.
	 */
	function messageFits(message, bunch) {
	  if (message.getType() !== bunch.messageType) {
	    return false;
	  }
	  if (!sameDay(message.getSentAt(), bunch.date)) {
	    return false;
	  }
	  if (message.getSender().id !== bunch.senderId) {
	    return false;
	  }
	  if (message.getType() !== 'system' && message.getSentAt() - bunch.date > MESSAGE_BUNCH_TIME_WINDOW) {
	    return false;
	  }
	  return true;
	}
	
	function bunchMessages(messages) {
	  if (messages.length === 0) {
	    return [];
	  }
	
	  var messageStack = Array.from(messages).reverse();
	
	  var bunches = [makeBunch(messageStack.pop())];
	
	  while (messageStack.length > 0) {
	    var currBunch = bunches[bunches.length - 1];
	    var currMessage = messageStack.pop();
	
	    if (messageFits(currMessage, currBunch)) {
	      currBunch.messages.push(currMessage);
	    } else {
	      bunches.push(makeBunch(currMessage));
	    }
	  }
	
	  return bunches;
	}
	
	function extractGapAndBunches(messages) {
	  var gapMessage = messages.length > 0 && messages[0].getType() === 'gap' ? messages[0] : null;
	  var fullMessages = gapMessage ? messages.slice(1) : messages;
	  var bunches = bunchMessages(fullMessages);
	  return { gapMessage: gapMessage, bunches: bunches };
	}
	
	function extractListItems(messages) {
	  var _extractGapAndBunches = extractGapAndBunches(messages),
	      gapMessage = _extractGapAndBunches.gapMessage,
	      bunches = _extractGapAndBunches.bunches;
	
	  var items = [];
	
	  if (gapMessage) {
	    // no date to render before gap because we don't know what date the message
	    // represented by the gap was on until we fetch it.
	    items.push(gapMessage);
	  }
	
	  var bunchDate = null;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = bunches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var bunch = _step.value;
	
	      if (!sameDay(bunch.date, bunchDate)) {
	        bunchDate = bunch.date;
	        items.push(bunchDate);
	      }
	      items.push(bunch);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return items;
	}

/***/ },
/* 2351 */
1136,
/* 2352 */,
/* 2353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StudentsParentsDialog = function (_React$Component) {
	  _inherits(StudentsParentsDialog, _React$Component);
	
	  function StudentsParentsDialog() {
	    _classCallCheck(this, StudentsParentsDialog);
	
	    return _possibleConstructorReturn(this, (StudentsParentsDialog.__proto__ || Object.getPrototypeOf(StudentsParentsDialog)).apply(this, arguments));
	  }
	
	  _createClass(StudentsParentsDialog, [{
	    key: 'render',
	    value: function render() {
	      var subtextText = 'Create a class to stay connected with your clubs, teams, organizations, and\n      more! \uD83C\uDF89';
	
	      var subtext = _react2.default.createElement(_TextWithEntities2.default, {
	        text: subtextText,
	        entities: _TextEntities2.default.parseEmoji(subtextText)
	      });
	
	      return _react2.default.createElement(_AlertDialog2.default, {
	        eventScreenName: 'StudentsParentsDialog',
	        title: 'Want to reach a group with Remind?',
	        subtext: subtext,
	        buttonText: 'Create a class',
	        onOkay: this.props.onOkay,
	        onRequestHide: this.props.onRequestHide
	      });
	    }
	  }]);
	
	  return StudentsParentsDialog;
	}(_react2.default.Component);
	
	StudentsParentsDialog.displayName = 'StudentsParentsDialog';
	exports.default = StudentsParentsDialog;

/***/ },
/* 2354 */
1136,
/* 2355 */,
/* 2356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2357);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var View = function (_React$Component) {
	  _inherits(View, _React$Component);
	
	  function View() {
	    _classCallCheck(this, View);
	
	    return _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).apply(this, arguments));
	  }
	
	  _createClass(View, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          full = _props.full,
	          children = _props.children,
	          className = _props.className,
	          otherProps = _objectWithoutProperties(_props, ['full', 'children', 'className']);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: (0, _classnames2.default)({
	            View: true,
	            'View-full': full
	          }, className)
	        }, otherProps),
	        children
	      );
	    }
	  }]);
	
	  return View;
	}(_react2.default.Component);
	
	View.defaultProps = {
	  full: false
	};
	View.displayName = 'View';
	exports.default = View;

/***/ },
/* 2357 */
1136,
/* 2358 */,
/* 2359 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pitch":"#282c31","this":"RecentMessages__this___3OVeG","sidebar":"RecentMessages__sidebar___1UHI-","wrap":"RecentMessages__wrap___1mQgA","content":"RecentMessages__content___2k9OL"};

/***/ },
/* 2360 */,
/* 2361 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pitch":"#282c31","brand":"#2f75c1","recentViewMask":"RecentView__recentViewMask___3r133","recentView":"RecentView__recentView___15_hx","recentViewInner":"RecentView__recentViewInner___Z45CZ","closeRecent":"RecentView__closeRecent___10m6q","appear":"RecentView__appear___2D2sl","appearActive":"RecentView__appearActive___150JP"};

/***/ },
/* 2362 */,
/* 2363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SupportDialog = undefined;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxButton = __webpack_require__(2364);
	
	var _BoxButton2 = _interopRequireDefault(_BoxButton);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Zopim = __webpack_require__(1081);
	
	var _Zopim2 = _interopRequireDefault(_Zopim);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _DefaultArticles = __webpack_require__(2367);
	
	var _DefaultArticles2 = _interopRequireDefault(_DefaultArticles);
	
	var _FaqActions = __webpack_require__(2368);
	
	var _FaqActions2 = _interopRequireDefault(_FaqActions);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _AsyncSelect = __webpack_require__(2374);
	
	var _AsyncSelect2 = _interopRequireDefault(_AsyncSelect);
	
	var _AsyncSelectItem = __webpack_require__(2377);
	
	var _AsyncSelectItem2 = _interopRequireDefault(_AsyncSelectItem);
	
	var _reactRedux = __webpack_require__(1113);
	
	__webpack_require__(2378);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var SupportDialog = function (_React$Component) {
	  _inherits(SupportDialog, _React$Component);
	
	  function SupportDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SupportDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SupportDialog.__proto__ || Object.getPrototypeOf(SupportDialog)).call.apply(_ref, [this].concat(args))), _this), _this.handleResultSelected = function (item) {
	      if (!item.props || !item.props.url) {
	        return;
	      }
	
	      var link = item.props.url;
	      window.open(link, '_blank');
	    }, _this.highlightMatches = function (text, searchString) {
	      var lowerText = text.toLowerCase();
	      var searchWords = searchString.split(' ').filter(function (word) {
	        return word.length >= 3;
	      });
	
	      var matches = [];
	
	      searchWords.forEach(function (word) {
	        var index = lowerText.indexOf(word.toLowerCase());
	        if (index >= 0) {
	          matches.push([index, word]);
	        }
	      });
	
	      if (matches.length > 0) {
	        matches.sort(function (a, b) {
	          if (a[0] < b[0]) {
	            return -1;
	          } else if (b[0] < a[0]) {
	            return 1;
	          } else {
	            if (a[1].length > b[1].length) {
	              return -1;
	            } else {
	              return 1;
	            }
	          }
	        });
	
	        var match = matches[0];
	
	        var list = [_react2.default.createElement(
	          'span',
	          null,
	          text.slice(0, match[0])
	        ), _react2.default.createElement(
	          'span',
	          { className: 'highlighted' },
	          match[1]
	        )];
	
	        return list.concat(_this.highlightMatches(text.slice(match[0] + match[1].length), searchString));
	      }
	
	      return [_react2.default.createElement(
	        'span',
	        null,
	        text
	      )];
	    }, _this.openZopim = function () {
	      if (_this.props.onRequestHide) {
	        _this.props.onRequestHide();
	      }
	
	      _Zopim2.default.show();
	    }, _this.searchAnswers = function (query, callback) {
	      if (query.length === 0) {
	        _this.setState({ searchString: query });
	        return;
	      }
	
	      _this.setState({ searchString: query, articles: [] });
	      callback(_FaqActions2.default.loadFaqs(query).then(function (faqs) {
	        return faqs.slice(0, 4).map(function (article) {
	          return _this.renderSearchResult(article, query);
	        });
	      }));
	    }, _this.renderNoResults = function () {
	      var body = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Link2.default,
	          null,
	          'Contact us'
	        ),
	        ' ',
	        'with your question'
	      );
	      var resultTemplate = _this.renderSearchResultTemplate(_LinkConstants2.default.CONTACT_FORM, 'We don’t have any FAQs about this topic yet.', body, 'SupportDialog-faqSearchResults-item--noResult');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'SupportDialog-noResults' },
	        resultTemplate
	      );
	    }, _this.renderDefaultArticles = function () {
	      return _DefaultArticles2.default.map(function (article, idx) {
	        return _this.renderSearchResultTemplate(article.url, article.title, article.body, '', idx);
	      });
	    }, _this.renderSearchResult = function (article, searchString) {
	      var e = document.createElement('html');
	      e.innerHTML = article.getBody();
	      var text = e.innerText || e.textContent;
	      // trim off extra spaces/NBSPs from the text
	      text = text.replace(/^[ \u00a0]*/, '');
	      return _this.renderSearchResultTemplate(article.getUrl(), _this.highlightMatches(article.getTitle(), searchString), _this.highlightMatches(text, searchString), '', article.id);
	    }, _this.renderSearchResultTemplate = function (url, name, body) {
	      var className = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	      var id = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : -1;
	
	      return _react2.default.createElement(
	        _AsyncSelectItem2.default,
	        { id: id, title: '', url: url },
	        _react2.default.createElement(
	          _Link2.default,
	          { href: url, target: '_blank', className: 'SupportDialog-faqSearchResults-item ' + className },
	          _react2.default.createElement(
	            'h3',
	            { className: 'SupportDialog-faqSearchResults-item-title' },
	            name
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            { truncate: true, className: 'SupportDialog-faqSearchResults-item-body' },
	            body
	          )
	        )
	      );
	    }, _this.renderTitle = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Image2.default, { className: 'SupportDialog-titleImage', src: __webpack_require__(2380) }),
	        _react2.default.createElement(
	          'div',
	          null,
	          'We\u2019re here to help!'
	        )
	      );
	    }, _this.render = function () {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          eventScreenName: 'SupportDialog',
	          title: _this.renderTitle(),
	          className: 'SupportDialog',
	          onRequestHide: _this.props.onRequestHide,
	          size: 'small' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(_AsyncSelect2.default, {
	            layerClassName: 'SupportDialog-faqSearch',
	            searchCallback: _this.searchAnswers,
	            onSelect: _this.handleResultSelected,
	            initialItems: _this.renderDefaultArticles(),
	            noResults: _this.renderNoResults(),
	            placeholder: 'Search our FAQs using keywords like \u201Cattach\u201D',
	            clearOnInputChange: true,
	            inputDelay: 500,
	            noQuery: ' '
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'SupportDialog-actions' },
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              href: _LinkConstants2.default.ZENDESK,
	              target: '_blank',
	              color: 'thunder',
	              className: 'SupportDialog-actions-link',
	              eventElementName: 'SupportDialog-actions-link' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Glyph2.default, { name: 'lightbulb', size: 'xlarge', solo: true, className: 'SupportDialog-actions-link-glyph' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Frequently asked questions'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              href: _LinkConstants2.default.TEACHER_RESOURCES,
	              target: '_blank',
	              color: 'thunder',
	              className: 'SupportDialog-actions-link',
	              eventElementName: 'SupportDialog-actions-link' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Glyph2.default, { name: 'apple', size: 'xlarge', solo: true, className: 'SupportDialog-actions-link-glyph' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Resources'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              href: _LinkConstants2.default.YOUTUBE_TUTORIAL_VIDEOS,
	              target: '_blank',
	              color: 'thunder',
	              className: 'SupportDialog-actions-link',
	              eventElementName: 'SupportDialog-actions-link' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Glyph2.default, { name: 'play', size: 'xlarge', solo: true, className: 'SupportDialog-actions-link-glyph' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Tutorial videos'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              href: _LinkConstants2.default.CONTACT_FORM,
	              target: '_blank',
	              color: 'thunder',
	              className: 'SupportDialog-actions-link',
	              eventElementName: 'SupportDialog-actions-link' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_Glyph2.default, { name: 'email', size: 'xlarge', solo: true, className: 'SupportDialog-actions-link-glyph' }),
	              _react2.default.createElement(
	                'div',
	                null,
	                'Contact Remind'
	              )
	            )
	          )
	        ),
	        !(_CurrentUser2.default.isSignedIn() && _CurrentUser2.default.getUser().isUnderage()) && _this.props.zopimStatus !== 'offline' && _react2.default.createElement(
	          _BoxButton2.default,
	          { className: 'SupportDialog-liveChat', onClick: _this.openZopim },
	          _react2.default.createElement(_Glyph2.default, { name: 'remind-icon', size: 'large' }),
	          'Get live help from our team!'
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return SupportDialog;
	}(_react2.default.Component);
	
	SupportDialog.displayName = 'SupportDialog';
	
	
	function mapStateToProps(state) {
	  return {
	    zopimStatus: state.zopim.status
	  };
	}
	
	exports.SupportDialog = SupportDialog;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, undefined)(SupportDialog);

/***/ },
/* 2364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(2365);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxButton = function (_React$Component) {
	  _inherits(BoxButton, _React$Component);
	
	  function BoxButton() {
	    _classCallCheck(this, BoxButton);
	
	    return _possibleConstructorReturn(this, (BoxButton.__proto__ || Object.getPrototypeOf(BoxButton)).apply(this, arguments));
	  }
	
	  _createClass(BoxButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          text = _props.text,
	          rest = _objectWithoutProperties(_props, ['children', 'text']);
	
	      return _react2.default.createElement(
	        _Button2.default,
	        _extends({}, rest, { className: 'BoxButton', full: true, eventElementName: 'BoxButton' }),
	        text,
	        children
	      );
	    }
	  }]);
	
	  return BoxButton;
	}(_react2.default.Component);
	
	BoxButton.displayName = 'BoxButton';
	exports.default = BoxButton;

/***/ },
/* 2365 */
1136,
/* 2366 */,
/* 2367 */
/***/ function(module, exports) {

	module.exports = [
		{
			"url": "https://help.remind.com/hc/en-us/articles/203179827",
			"title": "Can I add an owner to my class?",
			"body": "Yes you can add an owner to your classes in your account. Here's how you will promote them to owner:"
		},
		{
			"url": "https://help.remind.com/hc/en-us/articles/203179817",
			"title": "How do I remove participants?",
			"body": "If a student/parent is no longer in your class and you want to remove him/her from your Remind messages, you can easily do that within your account."
		},
		{
			"url": "https://help.remind.com/hc/en-us/articles/202171035",
			"title": "Can I update my account details?",
			"body": "As a teacher/organizer, the easiest way to update or change your account information is to log into your Remind account online and go to Settings in the lower left."
		},
		{
			"url": "https://help.remind.com/hc/en-us/articles/202004015",
			"title": "I can't access my account!",
			"body": "Try clicking \"Forgot password?\" underneath where you sign in. You'll receive an email with a password reset link to access your account again."
		},
		{
			"url": "https://help.remind.com/hc/en-us/articles/203179887-How-do-I-join-a-class",
			"title": "How do I join a class?",
			"body": "There are 3 ways to receive messages on Remind. You can receive messages via text, email, or push notification (or any combination of these)."
		},
		{
			"url": "https://help.remind.com/hc/en-us/articles/202547989",
			"title": "How do I get participants?",
			"body": "New participants need to use your unique class @code and then follow all prompts (e.g. - reply with full name if first time joining a class)."
		}
	];

/***/ },
/* 2368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Faqs = __webpack_require__(2369);
	
	var _Faqs2 = _interopRequireDefault(_Faqs);
	
	var _FaqSections = __webpack_require__(2371);
	
	var _FaqSections2 = _interopRequireDefault(_FaqSections);
	
	var _FaqConstants = __webpack_require__(2373);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SECTIONS_PAGE_SIZE = 30;
	
	var FaqActions = {
	  loadFaqSections: function loadFaqSections() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SECTIONS_PAGE_SIZE;
	
	    return _FaqSections2.default.fetch({
	      page: page,
	      per_page: perPage
	    }).then(function (response) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _FaqConstants.ActionTypes.LOAD_FAQ_SECTIONS,
	        requested: perPage,
	        sections: response
	      });
	    });
	  },
	  loadFaqs: function loadFaqs(query) {
	    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	
	    return _Faqs2.default.fetch(query, locale).then(function (response) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _FaqConstants.ActionTypes.LOAD_FAQS,
	        faqs: response
	      });
	      return response;
	    });
	  }
	};
	
	exports.default = FaqActions;

/***/ },
/* 2369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Faq = __webpack_require__(2370);
	
	var _Faq2 = _interopRequireDefault(_Faq);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Faqs = function (_Collection) {
	  _inherits(Faqs, _Collection);
	
	  function Faqs() {
	    _classCallCheck(this, Faqs);
	
	    return _possibleConstructorReturn(this, (Faqs.__proto__ || Object.getPrototypeOf(Faqs)).apply(this, arguments));
	  }
	
	  _createClass(Faqs, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _Faq2.default;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      return response.map(function (article) {
	        return _Faq2.default.fromJSON(article);
	      });
	    }
	
	    // $FlowFixMe
	
	  }], [{
	    key: 'fetch',
	    value: function fetch(query) {
	      var _this2 = this;
	
	      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	
	      return _Faq2.default.searchFaqs(query, locale).then(function (response) {
	        return _this2.fromJSON(response);
	      });
	    }
	  }]);
	
	  return Faqs;
	}(_Collection3.default);
	
	Faqs.displayName = 'Faqs';
	exports.default = Faqs;

/***/ },
/* 2370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Config = __webpack_require__(551);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _qs = __webpack_require__(557);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _xhr = __webpack_require__(562);
	
	var _xhr2 = _interopRequireDefault(_xhr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var URL = _Config2.default.Environment.R101_ZENDESK_URL;
	
	var Faq = function (_Entity) {
	  _inherits(Faq, _Entity);
	
	  function Faq() {
	    _classCallCheck(this, Faq);
	
	    return _possibleConstructorReturn(this, (Faq.__proto__ || Object.getPrototypeOf(Faq)).apply(this, arguments));
	  }
	
	  _createClass(Faq, [{
	    key: 'getUrl',
	    value: function getUrl() {
	      return this.get('html_url');
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      return this.get('title');
	    }
	  }, {
	    key: 'getBody',
	    value: function getBody() {
	      return this.get('body');
	    }
	  }], [{
	    key: 'searchFaqs',
	    value: function searchFaqs(query) {
	      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
	
	      return new Promise(function (resolve, reject) {
	        (0, _xhr2.default)({
	          url: URL + '/api/v2/help_center/articles/search?' + _qs2.default.stringify({
	            query: query,
	            locale: locale
	          }),
	          method: 'GET'
	        }, function (err, response, body) {
	          if (err || response.statusCode >= 400) {
	            // TODO: Wrap the error response into something easier to use.
	            reject(err || body);
	          } else {
	            resolve(JSON.parse(body).results);
	          }
	        });
	      });
	    }
	  }]);
	
	  return Faq;
	}(_Entity3.default);
	
	Faq.displayName = 'Faq';
	exports.default = Faq;

/***/ },
/* 2371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _qs = __webpack_require__(557);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _xhr = __webpack_require__(562);
	
	var _xhr2 = _interopRequireDefault(_xhr);
	
	var _Config = __webpack_require__(551);
	
	var _Config2 = _interopRequireDefault(_Config);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _FaqSection = __webpack_require__(2372);
	
	var _FaqSection2 = _interopRequireDefault(_FaqSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var URL = _Config2.default.Environment.R101_ZENDESK_URL;
	
	var FaqSections = function (_Collection) {
	  _inherits(FaqSections, _Collection);
	
	  function FaqSections() {
	    _classCallCheck(this, FaqSections);
	
	    return _possibleConstructorReturn(this, (FaqSections.__proto__ || Object.getPrototypeOf(FaqSections)).apply(this, arguments));
	  }
	
	  _createClass(FaqSections, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _FaqSection2.default;
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      return response.map(function (section) {
	        return _FaqSection2.default.fromJSON(section);
	      });
	    }
	  }], [{
	    key: 'fetch',
	    value: function fetch() {
	      var _this2 = this;
	
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return new Promise(function (resolve, reject) {
	        (0, _xhr2.default)({
	          url: URL + '/api/v2/help_center/sections?' + _qs2.default.stringify(options),
	          method: 'GET'
	        }, function (err, response, body) {
	          var possiblyParsedBody = body;
	          try {
	            possiblyParsedBody = JSON.parse(body);
	          } catch (e) {
	            // Do nothing.
	          }
	
	          if (err || response.statusCode >= 400) {
	            // TODO: Wrap the error response into something easier to use.
	            reject(err || possiblyParsedBody || body);
	          } else {
	            resolve(_this2.fromJSON(possiblyParsedBody.sections));
	          }
	        });
	      });
	    }
	  }]);
	
	  return FaqSections;
	}(_Collection3.default);
	
	FaqSections.displayName = 'FaqSections';
	exports.default = FaqSections;

/***/ },
/* 2372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FaqSection = function (_Entity) {
	  _inherits(FaqSection, _Entity);
	
	  function FaqSection() {
	    _classCallCheck(this, FaqSection);
	
	    return _possibleConstructorReturn(this, (FaqSection.__proto__ || Object.getPrototypeOf(FaqSection)).apply(this, arguments));
	  }
	
	  _createClass(FaqSection, [{
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }]);
	
	  return FaqSection;
	}(_Entity3.default);
	
	FaqSection.displayName = 'FaqSection';
	exports.default = FaqSection;

/***/ },
/* 2373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['LOAD_FAQS', 'LOAD_FAQ_SECTIONS']); /*  weak */

/***/ },
/* 2374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(555);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	__webpack_require__(2375);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	/*
	 * Component to perform async searches.
	 * To do so you must register a callback to the component
	 * that will be called when a search is need. This registered
	 * callback will have two parameters, the search query and a
	 * callback. The callback must be called with a promise that
	 * returns the search results as AsyncSelectItem.
	 *
	 * renderSomething(something) {
	 *   return (
	 *     <AsyncSelectItem id={something.id} title={something.getName()}>
	 *       <span>{something.getFirstname()}</span>
	 *     </AsyncSelectItem>
	 *   );
	 * },
	 *
	 * onSearchCallback(input, callback) {
	 *   callback(Something.search(input).then((somethings) => {
	 *     return somethings.map(this.renderSomething);
	 *   }));
	 * },
	 *
	 * onSelect(id) {
	 *   console.log('item selected', id);
	 * }
	 *
	 * render: function() {
	 *   return (
	 *     <AsyncSelect
	 *       searchCallback={this.onSearchCallback}
	 *       onSelect={this.onSelect} />
	 *   );
	 * }
	 *
	 */
	var AsyncSelect = function (_React$Component) {
	  _inherits(AsyncSelect, _React$Component);
	
	  function AsyncSelect() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AsyncSelect);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AsyncSelect.__proto__ || Object.getPrototypeOf(AsyncSelect)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      searchString: '',
	      items: [],
	      hasSelected: false,
	      highlight: 0,
	      pendingQueries: 0,
	      userTyping: false,
	      lastSelectedItem: null,
	      showResults: false
	    }, _this._width = null, _this._isMouseScrolling = false, _this.onBlur = function () {
	      var newSearchString = '';
	      if (_this.state.lastSelectedItem) {
	        newSearchString = _this.state.lastSelectedItem.props.title;
	      }
	      _this.clearResults();
	      _this.setState({
	        searchString: newSearchString,
	        showResults: false
	      });
	    }, _this.onFocus = function () {
	      _this.setState({ showResults: true });
	    }, _this.onInputChange = function () {
	      var value = _reactDom2.default.findDOMNode(_this.refs.myInput).value;
	
	      _this.setState({ searchString: value });
	
	      if (value.length >= _this.props.queryMinSize) {
	        _this.setState({
	          showResults: true,
	          userTyping: true
	        });
	        _this.callSearchCallback(value);
	      } else if (value.length === 0) {
	        _this.clearResults();
	      }
	
	      if (_this.props.clearOnInputChange) {
	        if (_this.props.onClear) {
	          _this.props.onClear();
	        }
	
	        _this.clearResults();
	      }
	    }, _this.onInputFocus = function () {
	      if (_this.state.lastSelectedItem && _this.state.searchString === _this.state.lastSelectedItem.props.title) {
	        _this.clearInput();
	        _this.clearResults();
	      }
	    }, _this.onResultClick = function (item) {
	      _this.onResultSelected(item);
	    }, _this.onResultSelected = function (item) {
	      if (!_this.isItemPermanent(item)) {
	        _this.setState({
	          searchString: item.props.title,
	          lastSelectedItem: item,
	          hasSelected: true
	        });
	      }
	
	      if (_this.props.onSelect) {
	        _this.props.onSelect(item);
	      }
	
	      _this.clearResults();
	      _this.setState({
	        showResults: false
	      });
	    }, _this.getSearchString = function () {
	      return _this.state.searchString;
	    }, _this.setSelectedItem = function (item) {
	      var input = _reactDom2.default.findDOMNode(_this.refs.myInput);
	      input.value = item.props.title;
	      _this.setState({
	        searchString: item.props.title,
	        lastSelectedItem: item,
	        hasSelected: true
	      });
	    }, _this.callSearchCallback = function (value) {
	      var searchAndDisplay = function searchAndDisplay(query) {
	        return _this.props.searchCallback(query, _this.displayAsyncResults);
	      };
	      var debouncedSearchCallback = (0, _lodash.debounce)(searchAndDisplay, _this.props.inputDelay);
	      debouncedSearchCallback(value);
	    }, _this.clearInput = function () {
	      _this.setState({
	        searchString: ''
	      });
	    }, _this.clearResults = function () {
	      _this.setState({
	        highlight: 0,
	        items: []
	      });
	    }, _this.displayAsyncResults = function (promise) {
	      _this.setState({
	        userTyping: false,
	        pendingQueries: _this.state.pendingQueries + 1
	      });
	      promise.then(function (items) {
	        _this.setState({
	          pendingQueries: _this.state.pendingQueries - 1,
	          items: items
	        });
	      });
	    }, _this.handleInputKeyDown = function (event) {
	      var code = event.keyCode;
	      switch (code) {
	        case _KeyConstants2.default.ENTER:
	          {
	            var item = _this.state.items[_this.state.highlight];
	            if (item) {
	              _this.onResultSelected(item);
	            }
	            break;
	          }
	        case _KeyConstants2.default.UP:
	        case _KeyConstants2.default.DOWN:
	          {
	            var _ret2 = function () {
	              var highlight = _this.state.highlight;
	
	              if (code === _KeyConstants2.default.UP) {
	                highlight = highlight === 0 ? _this.state.items.length - 1 : highlight - 1;
	              } else {
	                highlight = highlight === _this.state.items.length - 1 ? 0 : highlight + 1;
	              }
	              _this.setState({ highlight: highlight }, function () {
	                var searchItemNode = _reactDom2.default.findDOMNode(_this.refs['item-' + highlight]);
	                _this.refs.scrollArea.scrollIntoView(searchItemNode);
	              });
	
	              return 'break';
	            }();
	
	            if (_ret2 === 'break') break;
	          }
	        default:
	          return;
	      }
	      event.preventDefault();
	    }, _this.handleResultMouseOver = function (index) {
	      if (_this._isMouseScrolling) {
	        _this._isMouseScrolling = false;
	        return;
	      }
	      _this.setState({ highlight: index });
	      if (_this.props.infiniteLoad && _this.isScrolledToBottom() &&
	      // $FlowIssue defaultProps
	      _this.state.searchString.length >= _this.props.queryMinSize) {
	        _this.callSearchCallback(_this.state.searchString);
	      }
	    }, _this.hasItems = function () {
	      return _this.state.items && _this.state.items.length > 0;
	    }, _this.isItemPermanent = function (item) {
	      var permanentItems = _this.props.permanentItems;
	      // $FlowFixMe defaultProps
	
	      return permanentItems.find(function (result) {
	        return result.props.id === item.props.id;
	      });
	    }, _this.isScrolledToBottom = function () {
	      return _this.refs.scrollArea.isScrolledToBottom(150);
	    }, _this.focus = function () {
	      _this.refs.myInput.focus();
	    }, _this.waitingOnQueries = function () {
	      return _this.state.userTyping === true || _this.state.pendingQueries > 0;
	    }, _this.renderPermanent = function (item, index) {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('AsyncSelect-searchResult-permanent'),
	          key: item.props.id || 'permanent-' + index,
	          onMouseDown: function onMouseDown() {
	            return _this.onResultClick(item);
	          } },
	        item
	      );
	    }, _this.renderResult = function (item, index) {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('AsyncSelect-searchResult', {
	            highlight: index === _this.state.highlight
	          }),
	          ref: 'item-' + index,
	          key: item.props.id || 'item-' + index,
	          onMouseOver: function onMouseOver() {
	            return _this.handleResultMouseOver(index);
	          },
	          onMouseDown: function onMouseDown() {
	            return _this.onResultClick(item);
	          } },
	        item
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AsyncSelect, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._width = _reactDom2.default.findDOMNode(this.refs.select).offsetWidth;
	      if (this.props.defaultItem) {
	        this.setSelectedItem(this.props.defaultItem);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.defaultItem) {
	        this.setSelectedItem(nextProps.defaultItem);
	      }
	    }
	  }, {
	    key: 'renderLoadingIndicator',
	    value: function renderLoadingIndicator() {
	      if (this.waitingOnQueries()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'AsyncSelect-searchLoading' },
	          _react2.default.createElement(_LoadingIndicator2.default, { size: 'small' })
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderNoResultsOrQuery',
	    value: function renderNoResultsOrQuery() {
	      var query = this.state.searchString;
	
	      if (this.state.items.length === 0 && !this.waitingOnQueries()) {
	        if (query === '') {
	          return this.props.noQuery && _react2.default.createElement(
	            'div',
	            { className: 'AsyncSelect-noQuery' },
	            this.props.noQuery
	          );
	        } else if (query.length < this.props.queryMinSize && this.props.queryTooShort) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'AsyncSelect-noQuery' },
	            this.props.queryTooShort
	          );
	        } else {
	          return this.props.noResults;
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults(layerClassName) {
	      if (!this.state.showResults) {
	        return null;
	      }
	
	      if (!this.props.noQuery && !this.props.initialItems && this.state.searchString === '') {
	        return null;
	      }
	
	      var permanentItems = void 0;
	      if (this.props.permanentItems) {
	        permanentItems = _react2.default.createElement(
	          'div',
	          null,
	          this.props.permanentItems.map(this.renderPermanent)
	        );
	      }
	
	      var resultingItems = void 0;
	      if (this.hasItems() || this.waitingOnQueries()) {
	        resultingItems = _react2.default.createElement(
	          _ScrollableArea2.default,
	          {
	            className: 'AsyncSelect-list',
	            ref: 'scrollArea',
	            useBodyChildrenHeight: true },
	          this.state.items.map(this.renderResult),
	          this.renderLoadingIndicator()
	        );
	      } else if (this.props.initialItems && !this.state.searchString) {
	        resultingItems = _react2.default.createElement(
	          _ScrollableArea2.default,
	          {
	            className: 'AsyncSelect-list',
	            ref: 'scrollArea',
	            useBodyChildrenHeight: true },
	          this.props.initialItems.map(this.renderResult)
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AsyncSelect-resultsWrapper' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('AsyncSelect-searchResults', layerClassName),
	            style: {
	              width: this._width
	            } },
	          this.renderNoResultsOrQuery(),
	          resultingItems,
	          _react2.default.createElement(
	            'div',
	            { className: 'AsyncSelect-searchResults-permanent' },
	            permanentItems
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          layerClassName = _props.layerClassName,
	          others = _objectWithoutProperties(_props, ['className', 'layerClassName']);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'select',
	          className: (0, _classnames2.default)('AsyncSelect', className),
	          onFocus: this.onFocus,
	          onBlur: this.onBlur },
	        _react2.default.createElement(_Input2.default, _extends({}, others, {
	          ref: 'myInput',
	          className: 'AsyncSelect-input',
	          placeholder: this.props.placeholder,
	          onKeyDown: this.handleInputKeyDown,
	          onChange: this.onInputChange,
	          onFocus: this.onInputFocus,
	          value: this.state.searchString || ''
	        })),
	        _react2.default.createElement(_Glyph2.default, { className: 'AsyncSelect-glyph search', name: 'search', size: 'medium' }),
	        this.renderResults(layerClassName)
	      );
	    }
	  }]);
	
	  return AsyncSelect;
	}(_react2.default.Component);
	
	AsyncSelect.defaultProps = {
	  queryMinSize: 1,
	  inputDelay: 0,
	  permanentItems: [],
	  noResults: _react2.default.createElement(
	    'div',
	    { className: 'AsyncSelect-searchResults-none' },
	    'No results'
	  ),
	  placeholder: '',
	  infiniteLoad: false
	};
	AsyncSelect.displayName = 'AsyncSelect';
	exports.default = AsyncSelect;

/***/ },
/* 2375 */
1136,
/* 2376 */,
/* 2377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* Simple component to describe to structure
	 * of a AsyncSelectItem, thoses are the thing that
	 * must be passed back in AsyncSelect#searchCallback.
	 */
	var AsyncSelectItem = function (_React$Component) {
	  _inherits(AsyncSelectItem, _React$Component);
	
	  function AsyncSelectItem() {
	    _classCallCheck(this, AsyncSelectItem);
	
	    return _possibleConstructorReturn(this, (AsyncSelectItem.__proto__ || Object.getPrototypeOf(AsyncSelectItem)).apply(this, arguments));
	  }
	
	  _createClass(AsyncSelectItem, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	    /*
	     * title - The string showed in the input afters selecting a results
	     * id - The unique identifier of the object (REACTJS keys)
	     * childrens are The DOM elements of the result box.
	     */
	
	  }]);
	
	  return AsyncSelectItem;
	}(_react2.default.Component);
	
	AsyncSelectItem.displayName = 'AsyncSelectItem';
	exports.default = AsyncSelectItem;

/***/ },
/* 2378 */
1136,
/* 2379 */,
/* 2380 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ZopimLink = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _Zopim = __webpack_require__(1081);
	
	var _Zopim2 = _interopRequireDefault(_Zopim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ZopimLink = function (_React$Component) {
	  _inherits(ZopimLink, _React$Component);
	
	  function ZopimLink() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ZopimLink);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ZopimLink.__proto__ || Object.getPrototypeOf(ZopimLink)).call.apply(_ref, [this].concat(args))), _this), _this.showZopim = function (event) {
	      event.preventDefault();
	      event.stopPropagation();
	      _Zopim2.default.show();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ZopimLink, [{
	    key: 'render',
	    value: function render() {
	      // We can't let underage children use live chat.
	      var underaged = _CurrentUser2.default.isSignedIn() && _CurrentUser2.default.getUser().isUnderage();
	
	      if (this.props.zopimStatus !== 'online' || underaged) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Link2.default,
	        { onClick: this.showZopim },
	        this.props.children
	      );
	    }
	  }]);
	
	  return ZopimLink;
	}(_react2.default.Component);
	
	ZopimLink.displayName = 'ZopimLink';
	
	
	function mapStateToProps(state) {
	  return {
	    zopimStatus: state.zopim.status
	  };
	}
	
	exports.ZopimLink = ZopimLink;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, undefined)(ZopimLink);

/***/ },
/* 2382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ZopimChevronBox;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChevronBox = __webpack_require__(2383);
	
	var _ChevronBox2 = _interopRequireDefault(_ChevronBox);
	
	__webpack_require__(2386);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ZopimChevronBox() {
	  return _react2.default.createElement(
	    _ChevronBox2.default,
	    { className: 'ZopimChevronBox', direction: 'right' },
	    'Chat with Remind'
	  );
	}
	// typecheck: ignore file

/***/ },
/* 2383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ChevronBox = __webpack_require__(2384);
	
	var _ChevronBox2 = _interopRequireDefault(_ChevronBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	// typecheck: ignore file
	
	
	// UNTIL prop-types lint can detect Flow annotation
	/* eslint-disable react/prop-types */
	var ChevronBox = function ChevronBox(_ref) {
	  var _cx;
	
	  var className = _ref.className,
	      children = _ref.children,
	      direction = _ref.direction,
	      props = _objectWithoutProperties(_ref, ['className', 'children', 'direction']);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({}, props, {
	      className: (0, _classnames2.default)(_ChevronBox2.default.this, className, (_cx = {}, _defineProperty(_cx, _ChevronBox2.default.right, direction === 'right'), _defineProperty(_cx, _ChevronBox2.default.left, direction !== 'right'), _cx)) }),
	    children
	  );
	};
	
	exports.default = ChevronBox;

/***/ },
/* 2384 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"eclipse":"#9e9fa5","wolf":"#dcdee2","small":"4px","medium":"8px","borderRadiusSmall":"3px","this":"ChevronBox__this___u454D","left":"ChevronBox__left___3CDjA","right":"ChevronBox__right___2O4Wh"};

/***/ },
/* 2385 */,
/* 2386 */
1136,
/* 2387 */,
/* 2388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdminConsoleAccess = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  query {\n    user: me {\n      id\n      featureFlags {\n        web_admin_console\n      }\n      organizations: organizations(first: 1, affiliation_status: [admin pending_admin]) {\n        id\n      }\n    }\n  }'], ['\n  query {\n    user: me {\n      id\n      featureFlags {\n        web_admin_console\n      }\n      organizations: organizations(first: 1, affiliation_status: [admin pending_admin]) {\n        id\n      }\n    }\n  }']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactApollo = __webpack_require__(467);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var AdminConsoleAccess = function (_React$Component) {
	  _inherits(AdminConsoleAccess, _React$Component);
	
	  function AdminConsoleAccess() {
	    _classCallCheck(this, AdminConsoleAccess);
	
	    return _possibleConstructorReturn(this, (AdminConsoleAccess.__proto__ || Object.getPrototypeOf(AdminConsoleAccess)).apply(this, arguments));
	  }
	
	  _createClass(AdminConsoleAccess, [{
	    key: 'render',
	    value: function render() {
	      var user = this.props.user;
	
	
	      var access = user && user.featureFlags['web_admin_console'] && user.organizations.length > 0;
	
	      if (!access) {
	        return null;
	      }
	
	      return this.props.children;
	    }
	  }]);
	
	  return AdminConsoleAccess;
	}(_react2.default.Component);
	
	AdminConsoleAccess.displayName = 'AdminConsoleAccess';
	
	
	var withUser = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  props: function props(_ref) {
	    var data = _ref.data;
	    return { user: data.user };
	  }
	});
	
	exports.AdminConsoleAccess = AdminConsoleAccess;
	exports.default = withUser(AdminConsoleAccess);

/***/ },
/* 2389 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pitch":"#282c31","thunder":"#6b6e72","lava":"#c63442","polarBear":"#f2f3f5","brand":"#2f75c1","midnight":"#182947","medium":"8px","this":"AppTopBar__this___jWnki","left":"AppTopBar__left___-lMTX","userLink":"AppTopBar__userLink___ozT5n","unreadIndicator":"AppTopBar__unreadIndicator___1sd8f","unreadNotification":"AppTopBar__unreadNotification___s6C92","unreadNotificationBody":"AppTopBar__unreadNotificationBody___3fM-I","unreadCountContainer":"AppTopBar__unreadCountContainer___nOUgv","unreadCount":"AppTopBar__unreadCount___3ryvk","actions":"AppTopBar__actions___1dDrq","help":"AppTopBar__help___3CBX5","unreadGlyph":"AppTopBar__unreadGlyph___3fcyL","share":"AppTopBar__share___1B96c","adminConsoleLink":"AppTopBar__adminConsoleLink___1D9yZ","appear":"AppTopBar__appear___LAKjs","appearActive":"AppTopBar__appearActive___N3T4l"};

/***/ },
/* 2390 */,
/* 2391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(956);
	
	var _lodash = __webpack_require__(555);
	
	var _ClassNavigationPromotionContainer = __webpack_require__(2392);
	
	var _ClassNavigationPromotionContainer2 = _interopRequireDefault(_ClassNavigationPromotionContainer);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _ClassNavigationHeader = __webpack_require__(2399);
	
	var _ClassNavigationHeader2 = _interopRequireDefault(_ClassNavigationHeader);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _GroupsNav = __webpack_require__(2434);
	
	var _GroupsNav2 = _interopRequireDefault(_GroupsNav);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _groupNavigation = __webpack_require__(2489);
	
	var _ClassNavigation = __webpack_require__(2493);
	
	var _ClassNavigation2 = _interopRequireDefault(_ClassNavigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassNavigation = function (_React$Component) {
	  _inherits(ClassNavigation, _React$Component);
	
	  function ClassNavigation() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClassNavigation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClassNavigation.__proto__ || Object.getPrototypeOf(ClassNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.handleScroll = function () {
	      var scrollTop = _reactDom2.default.findDOMNode(_this.refs.nav).scrollTop;
	      if (_this.state.showDivider && scrollTop === 0) {
	        _this.setState({ showDivider: false });
	      } else if (!_this.state.showDivider && scrollTop > 0) {
	        _this.setState({ showDivider: true });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClassNavigation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleScroll = (0, _lodash.throttle)(this.handleScroll, 100);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_ClassNavigation2.default.this, this.props.className) },
	        _react2.default.createElement(_ClassNavigationHeader2.default, { ref: 'header' }),
	        _react2.default.createElement(_ClassNavigationPromotionContainer2.default, null),
	        this.state.showDivider && _react2.default.createElement(_Divider2.default, { className: _ClassNavigation2.default.divider, size: 'small' }),
	        _react2.default.createElement(_GroupsNav2.default, _extends({
	          ref: 'nav',
	          className: _ClassNavigation2.default.classList,
	          onScroll: this.handleScroll
	        }, this.state))
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default, _GroupStore2.default, _SettingsStore2.default, _AffiliationStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var user = _CurrentUser2.default.getUser();
	      var settings = _SettingsStore2.default.getSettings();
	      var hasAdminConsole = user.hasFeature('web_admin_console');
	
	      var ownedGroups = _GroupStore2.default.getOwnedGroups();
	      var subscribedGroups = _GroupStore2.default.getSubscribedGroups();
	      var districtGroups = _GroupStore2.default.getDistrictGroups();
	      var schoolGroups = _GroupStore2.default.getSchoolGroups();
	      var organizations = _AffiliationStore2.default.getAffiliatedOrganizations();
	      var userCanOwnGroups = user.canOwnGroups();
	      var maxGroups = settings.groups && settings.groups.limit || Number.POSITIVE_INFINITY;
	      var canAddGroup = user.canCreateGroups() && _GroupStore2.default.getOwnedGroups().length < maxGroups;
	      var isMuted = user.isMuted();
	      var mutedUntil = user.getMutedUntil();
	
	      var sections = (0, _groupNavigation.getOrderedSectionInfo)({
	        organizations: organizations,
	        districtGroups: districtGroups,
	        schoolGroups: schoolGroups,
	        ownedGroups: ownedGroups,
	        subscribedGroups: subscribedGroups,
	        userCanOwnGroups: userCanOwnGroups,
	        options: {
	          ignoreDistrictSection: !hasAdminConsole,
	          ignoreDistrictOrganizationSection: hasAdminConsole
	        }
	      });
	
	      return {
	        sections: sections,
	        canAddGroup: canAddGroup,
	        isMuted: isMuted,
	        mutedUntil: mutedUntil
	      };
	    }
	  }]);
	
	  return ClassNavigation;
	}(_react2.default.Component);
	
	ClassNavigation.displayName = 'ClassNavigation';
	exports.default = _utils.Container.create(ClassNavigation);

/***/ },
/* 2392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _QuickPromotion = __webpack_require__(1042);
	
	var _QuickPromotion2 = _interopRequireDefault(_QuickPromotion);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ClassNavigationPromotion = __webpack_require__(2393);
	
	var _ClassNavigationPromotion2 = _interopRequireDefault(_ClassNavigationPromotion);
	
	var _QuickPromotionActionHandler = __webpack_require__(2396);
	
	var _QuickPromotionConstants = __webpack_require__(1043);
	
	var _QuickPromotionActions = __webpack_require__(2397);
	
	var _QuickPromotionActions2 = _interopRequireDefault(_QuickPromotionActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassNavigationPromotionContainer = function (_Component) {
	  _inherits(ClassNavigationPromotionContainer, _Component);
	
	  function ClassNavigationPromotionContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClassNavigationPromotionContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClassNavigationPromotionContainer.__proto__ || Object.getPrototypeOf(ClassNavigationPromotionContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onConfirm = function () {
	      var promotion = _this.state.promotion;
	
	      if (promotion) {
	        (0, _QuickPromotionActionHandler.handleResponse)(_this.context.router, promotion, _QuickPromotionConstants.ResponseTypes.PRIMARY_ACTION);
	      }
	    }, _this.onCancel = function () {
	      var promotion = _this.state.promotion;
	
	      if (promotion) {
	        _QuickPromotionActions2.default.recordDismissal(promotion, _QuickPromotionConstants.ResponseTypes.SECONDARY_ACTION);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClassNavigationPromotionContainer, [{
	    key: 'render',
	    value: function render() {
	      var promotion = this.state.promotion;
	
	      return promotion ? _react2.default.createElement(_ClassNavigationPromotion2.default, {
	        promotion: promotion,
	        onConfirm: this.onConfirm,
	        onCancel: this.onCancel
	      }) : null;
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        promotion: _CurrentUser2.default.getQuickPromotionsForTrigger(_QuickPromotionConstants.TriggerTypes.CLASSES_LIST_TOP).find(function (p) {
	          return p.isShowable();
	        })
	      };
	    }
	  }]);
	
	  return ClassNavigationPromotionContainer;
	}(_react.Component);
	
	ClassNavigationPromotionContainer.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ClassNavigationPromotionContainer.displayName = 'ClassNavigationPromotionContainer';
	exports.default = _utils.Container.create(ClassNavigationPromotionContainer);

/***/ },
/* 2393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _QuickPromotion = __webpack_require__(1042);
	
	var _QuickPromotion2 = _interopRequireDefault(_QuickPromotion);
	
	var _QuickPromotionConstants = __webpack_require__(1043);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2394);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassNavigationPromotion = function (_React$Component) {
	  _inherits(ClassNavigationPromotion, _React$Component);
	
	  function ClassNavigationPromotion() {
	    _classCallCheck(this, ClassNavigationPromotion);
	
	    return _possibleConstructorReturn(this, (ClassNavigationPromotion.__proto__ || Object.getPrototypeOf(ClassNavigationPromotion)).apply(this, arguments));
	  }
	
	  _createClass(ClassNavigationPromotion, [{
	    key: 'renderImage',
	    value: function renderImage() {
	      var _ImageTypes$RIGHT_ICO;
	
	      var promotion = this.props.promotion;
	      // const imageType = promotion.getImageType();
	
	      var imageType = _QuickPromotionConstants.ImageTypes.RIGHT_ICON;
	
	      if (![_QuickPromotionConstants.ImageTypes.RIGHT_ICON, _QuickPromotionConstants.ImageTypes.LEFT_ICON].includes(imageType)) {
	        return null;
	      }
	
	      var className = (_ImageTypes$RIGHT_ICO = {}, _defineProperty(_ImageTypes$RIGHT_ICO, _QuickPromotionConstants.ImageTypes.RIGHT_ICON, 'ClassNavigationPromotion-image-right'), _defineProperty(_ImageTypes$RIGHT_ICO, _QuickPromotionConstants.ImageTypes.LEFT_ICON, 'ClassNavigationPromotion-image-left'), _ImageTypes$RIGHT_ICO)[imageType];
	
	      return _react2.default.createElement(_Image2.default, {
	        className: (0, _classnames2.default)('ClassNavigationPromotion-image', className),
	        src: promotion.getImageUrl()
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var promotion = this.props.promotion;
	
	      var imageType = promotion.getImageType();
	      return _react2.default.createElement(
	        'div',
	        { className: 'ClassNavigationPromotion' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ClassNavigationPromotion-header' },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _Text2.default,
	              { size: 'xxxsmall', color: 'pitch' },
	              promotion.getHeader()
	            ),
	            imageType === _QuickPromotionConstants.ImageTypes.RIGHT_ICON ? this.renderImage() : this.renderImage(),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                color: 'koala',
	                level: 'text',
	                className: 'ClassNavigationPromotion-close',
	                onClick: this.props.onCancel,
	                eventElementName: 'ClassNavigationPromotion-close' },
	              _react2.default.createElement(_Glyph2.default, { name: 'close', size: 'xsmall' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          { element: 'div', color: 'thunder', size: 'xxxsmall' },
	          promotion.getBody(),
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: this.props.onConfirm },
	            ' ',
	            ' ',
	            promotion.getPrimaryAction().getLabel()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ClassNavigationPromotion;
	}(_react2.default.Component);
	
	ClassNavigationPromotion.displayName = 'ClassNavigationPromotion';
	exports.default = ClassNavigationPromotion;

/***/ },
/* 2394 */
1136,
/* 2395 */,
/* 2396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.actionHandlers = undefined;
	exports.handleAction = handleAction;
	exports.handleResponse = handleResponse;
	
	var _QuickPromotionConstants = __webpack_require__(1043);
	
	var _QuickPromotion = __webpack_require__(1042);
	
	var _QuickPromotion2 = _interopRequireDefault(_QuickPromotion);
	
	var _QuickPromotionAction = __webpack_require__(1044);
	
	var _QuickPromotionAction2 = _interopRequireDefault(_QuickPromotionAction);
	
	var _QuickPromotionActions = __webpack_require__(2397);
	
	var _QuickPromotionActions2 = _interopRequireDefault(_QuickPromotionActions);
	
	var _resolveDeeplinkRedirects = __webpack_require__(2398);
	
	var _resolveDeeplinkRedirects2 = _interopRequireDefault(_resolveDeeplinkRedirects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionHandlers = exports.actionHandlers = {
	  handleActionLink: function handleActionLink(action) {
	    window.location = action.getActionData();
	  },
	  handleActionDeeplink: function handleActionDeeplink(router, action) {
	    router.push((0, _resolveDeeplinkRedirects2.default)(action.getActionData()));
	  }
	};
	function handleAction(router, promotion, action) {
	  switch (action.getActionType()) {
	    case _QuickPromotionConstants.ButtonActionTypes.NONE:
	      // do nothing
	      break;
	    case _QuickPromotionConstants.ButtonActionTypes.LINK:
	      actionHandlers.handleActionLink(action);
	      break;
	    case _QuickPromotionConstants.ButtonActionTypes.DEEPLINK:
	      actionHandlers.handleActionDeeplink(router, action);
	      break;
	    default:
	      console.error('Don\'t know how to handle this QP action. The QP shouldn\'t have been shown.' + ' action: ' + action.toString() + ' offending QP ' + promotion.toString());
	      break;
	  }
	}
	
	function handleResponse(router, promotion, responseType) {
	  _QuickPromotionActions2.default.recordDismissal(promotion, responseType);
	
	  switch (responseType) {
	    case _QuickPromotionConstants.ResponseTypes.PRIMARY_ACTION:
	      handleAction(router, promotion, promotion.getPrimaryAction());
	      break;
	    case _QuickPromotionConstants.ResponseTypes.SECONDARY_ACTION:
	      var secondaryAction = promotion.getSecondaryAction();
	      if (secondaryAction != null) {
	        handleAction(router, promotion, secondaryAction);
	      } else {
	        console.error('QP has no secondary action. This QP should not have been shown.' + ' offending QP: ' + promotion.toString());
	      }
	      break;
	    default:
	      console.error('Unknown QP response type. This should never happen.' + ' responseType: ' + responseType + ' offending QP: ' + promotion.toString());
	      break;
	  }
	}

/***/ },
/* 2397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _QuickPromotionConstants = __webpack_require__(1043);
	
	var _Dispatcher = __webpack_require__(590);
	
	var QuickPromotionActions = {
	  recordDismissal: function recordDismissal(promotion, response) {
	    promotion.recordDismissal(response).then(function () {
	      _Dispatcher.dispatcher.dispatch({
	        promotion: promotion,
	        type: _QuickPromotionConstants.ActionTypes.PROMOTION_DISMISSED
	      });
	    }).catch(function (e) {
	      return console.error('QuickPromotionActions recordDismissal failed', e);
	    });
	  }
	};
	
	exports.default = QuickPromotionActions;

/***/ },
/* 2398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NEW_MESSAGE_PATHS = undefined;
	
	var _qs = __webpack_require__(557);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var NEW_MESSAGE_PATHS = exports.NEW_MESSAGE_PATHS = ['/messages/new', '/classes/[^/]*/messages/new', '/chat/new', '/inbox/new'];
	
	function extractQueryString(url) {
	  var match = url.match(/[^?]*\?(.*)/);
	  return match ? match[1] : '';
	}
	
	/* Some deeplinks conflict with one-off apps, so we fix certain urls
	 *   before sending them to the router. If they don't conflict, we just
	 *   pass them through.
	 */
	
	exports.default = function (url) {
	  var matchedNewMessagePath = NEW_MESSAGE_PATHS.find(function (p) {
	    return url.match(p);
	  });
	  if (matchedNewMessagePath) {
	    // Rename attachment
	    var _QueryString$parse = _qs2.default.parse(extractQueryString(url)),
	        attachment = _QueryString$parse.attachment,
	        queryDict = _objectWithoutProperties(_QueryString$parse, ['attachment']);
	
	    queryDict.attachmentId = attachment;
	
	    return '/classes?' + _qs2.default.stringify({ queryParams: queryDict, action: 'new-message' });
	  } else {
	    return url;
	  }
	};

/***/ },
/* 2399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClassNavigationHeader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(497);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _GroupSettingsModal = __webpack_require__(2400);
	
	var _GroupSettingsModal2 = _interopRequireDefault(_GroupSettingsModal);
	
	var _GroupSubscribedSettingModal = __webpack_require__(2415);
	
	var _GroupSubscribedSettingModal2 = _interopRequireDefault(_GroupSubscribedSettingModal);
	
	var _SchoolSettingsModal = __webpack_require__(2419);
	
	var _SchoolSettingsModal2 = _interopRequireDefault(_SchoolSettingsModal);
	
	var _GroupAspectTabs = __webpack_require__(2425);
	
	var _GroupAspectTabs2 = _interopRequireDefault(_GroupAspectTabs);
	
	var _OrgAspectTabs = __webpack_require__(2431);
	
	var _OrgAspectTabs2 = _interopRequireDefault(_OrgAspectTabs);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _RootGroup = __webpack_require__(943);
	
	var _RootGroup2 = _interopRequireDefault(_RootGroup);
	
	var _ClassNavigationHeader = __webpack_require__(2432);
	
	var _ClassNavigationHeader2 = _interopRequireDefault(_ClassNavigationHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassNavigationHeader = exports.ClassNavigationHeader = function (_React$Component) {
	  _inherits(ClassNavigationHeader, _React$Component);
	
	  function ClassNavigationHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClassNavigationHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClassNavigationHeader.__proto__ || Object.getPrototypeOf(ClassNavigationHeader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.handleGroupChanged = function (groupCode) {
	      _this.props.router.push('/classes/' + groupCode);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClassNavigationHeader, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setGroupOrOrg(this.props.params);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setGroupOrOrg(nextProps.params);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var nextGroup = this.getGroupOrOrg(nextProps.params);
	      var groupHasChanged = nextGroup !== this.state.groupOrOrg;
	      var tabHasChanged = nextProps.router.location.pathname !== window.prevLocation;
	
	      return nextGroup && (groupHasChanged || tabHasChanged);
	    }
	  }, {
	    key: 'getGroupOrOrg',
	    value: function getGroupOrOrg(params) {
	      var groupCode = params.groupCode;
	
	      var organizationId = void 0;
	      if (params.organizationId) {
	        organizationId = parseInt(params.organizationId, 10);
	      }
	
	      var result = void 0;
	      if (organizationId) {
	        result = _OrganizationStore2.default.getOrganization(organizationId);
	      } else if (groupCode) {
	        result = _GroupStore2.default.getGroupForCode(groupCode);
	      }
	
	      return result || _RootGroup.rootGroup;
	    }
	  }, {
	    key: 'setGroupOrOrg',
	    value: function setGroupOrOrg(params) {
	      var groupOrOrg = this.getGroupOrOrg(params);
	      this.setState({ groupOrOrg: groupOrOrg });
	    }
	
	    // Upon changing the group code, we must redirect to the new group code
	
	  }, {
	    key: 'shouldLinkHeader',
	    value: function shouldLinkHeader() {
	      var groupOrOrg = this.state.groupOrOrg;
	
	      return this.isGroup() && groupOrOrg.getType() !== 'root';
	    }
	  }, {
	    key: 'shouldShowCode',
	    value: function shouldShowCode() {
	      var groupOrOrg = this.state.groupOrOrg;
	
	      return this.isGroup() && groupOrOrg.getType() !== 'root';
	    }
	  }, {
	    key: 'isGroup',
	    value: function isGroup() {
	      var groupOrOrg = this.state.groupOrOrg;
	
	      return groupOrOrg instanceof _Group2.default || groupOrOrg instanceof _RootGroup2.default;
	    }
	  }, {
	    key: 'renderSettingsIcon',
	    value: function renderSettingsIcon() {
	      if (this.shouldLinkHeader()) {
	        return _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.renderGroupSettingsModal() },
	          _react2.default.createElement(_Glyph2.default, { className: _ClassNavigationHeader2.default.settingsIcon, name: 'gear', size: 'large', solo: true })
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderAvatar',
	    value: function renderAvatar() {
	      var avatar = _react2.default.createElement(_GroupAvatar2.default, { group: this.state.groupOrOrg, className: _ClassNavigationHeader2.default.avatar });
	
	      if (this.shouldLinkHeader()) {
	        return _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.renderGroupSettingsModal() },
	          _react2.default.createElement(
	            _Link2.default,
	            null,
	            avatar
	          )
	        );
	      } else {
	        return avatar;
	      }
	    }
	  }, {
	    key: 'renderName',
	    value: function renderName() {
	      var groupName = _react2.default.createElement(
	        'div',
	        { className: _ClassNavigationHeader2.default.groupName },
	        _react2.default.createElement(_GroupName2.default, { group: this.state.groupOrOrg })
	      );
	      if (this.shouldLinkHeader()) {
	        groupName = _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.renderGroupSettingsModal() },
	          groupName
	        );
	      }
	      return groupName;
	    }
	  }, {
	    key: 'renderCode',
	    value: function renderCode() {
	      if (!this.shouldShowCode()) {
	        return null;
	      }
	
	      var groupOrOrg = this.state.groupOrOrg;
	
	      var codeText = '@' + groupOrOrg.getCode();
	      var canJoinText = groupOrOrg.isStaffClass() ? 'Staff, students, and parents can join your school by ' : 'Students and parents can join your class by ';
	
	      var smsNumber = groupOrOrg.getSMSNumber();
	      var actionText = smsNumber ? 'texting ' + codeText + ' to ' + smsNumber : 'entering ' + codeText + ' in the app';
	      var codeTooltip = canJoinText + actionText;
	
	      var link = _react2.default.createElement(
	        _Link2.default,
	        {
	          color: 'white',
	          className: _ClassNavigationHeader2.default.groupCode,
	          tooltip: codeTooltip,
	          tooltipPlacement: 'bottom' },
	        codeText
	      );
	
	      if (this.shouldLinkHeader()) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { checkForUnsavedChanges: true, modal: this.renderGroupSettingsModal() },
	            link
	          )
	        );
	      } else {
	        return link;
	      }
	    }
	  }, {
	    key: 'renderGroupSettingsModal',
	    value: function renderGroupSettingsModal() {
	      var groupOrOrg = this.state.groupOrOrg;
	
	      if (this.isGroup() && groupOrOrg.isStaffClass()) {
	        return _react2.default.createElement(_SchoolSettingsModal2.default, { group: groupOrOrg });
	      } else if (groupOrOrg.canEdit()) {
	        return _react2.default.createElement(_GroupSettingsModal2.default, {
	          group: groupOrOrg,
	          onCodeChange: this.handleGroupChanged,
	          userIsTeacher: _CurrentUser2.default.getUser().isTeacher()
	        });
	      } else {
	        return _react2.default.createElement(_GroupSubscribedSettingModal2.default, { group: groupOrOrg });
	      }
	    }
	  }, {
	    key: 'renderAspectTabs',
	    value: function renderAspectTabs(isGroup) {
	      var groupOrOrg = this.state.groupOrOrg;
	
	
	      if (isGroup) {
	        return _react2.default.createElement(_GroupAspectTabs2.default, { group: groupOrOrg });
	      }
	
	      return _OrgAspectTabs2.default.shouldMount() ? _react2.default.createElement(_OrgAspectTabs2.default, { org: groupOrOrg }) : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var groupOrOrg = this.state.groupOrOrg;
	
	      var isGroup = this.isGroup();
	
	      var aspectTabs = this.renderAspectTabs(isGroup);
	
	      return _react2.default.createElement(
	        'div',
	        { className: _ClassNavigationHeader2.default.this },
	        isGroup && this.renderSettingsIcon(),
	        _react2.default.createElement(
	          'div',
	          {
	            className: _ClassNavigationHeader2.default.top,
	            style: { background: groupOrOrg.getAccentColor() } },
	          this.renderAvatar(),
	          this.renderName(),
	          isGroup && this.renderCode()
	        ),
	        aspectTabs && _react2.default.createElement(
	          'div',
	          { className: _ClassNavigationHeader2.default.bottom },
	          aspectTabs
	        )
	      );
	    }
	  }]);
	
	  return ClassNavigationHeader;
	}(_react2.default.Component);
	
	ClassNavigationHeader.displayName = 'ClassNavigationHeader';
	exports.default = (0, _reactRouter.withRouter)(ClassNavigationHeader);

/***/ },
/* 2400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupEditPanel = __webpack_require__(2401);
	
	var _GroupEditPanel2 = _interopRequireDefault(_GroupEditPanel);
	
	var _GroupMemberList = __webpack_require__(2406);
	
	var _GroupMemberList2 = _interopRequireDefault(_GroupMemberList);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	var _Tabs = __webpack_require__(1539);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupSettingsModal = function (_React$Component) {
	  _inherits(GroupSettingsModal, _React$Component);
	
	  function GroupSettingsModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupSettingsModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupSettingsModal.__proto__ || Object.getPrototypeOf(GroupSettingsModal)).call.apply(_ref, [this].concat(args))), _this), _this.renderGroupInformationPanel = function () {
	      return _react2.default.createElement(_GroupEditPanel2.default, _this.props);
	    }, _this.renderGroupOwnerManagerPanel = function () {
	      return _react2.default.createElement(_GroupMemberList2.default, _extends({}, _this.props, {
	        className: 'GroupMemberList',
	        group: _this.props.group
	      }));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupSettingsModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'GroupSettingsModal'
	        }, this.props, {
	          className: 'GroupSettingsModal',
	          title: 'Class settings',
	          size: 'small' }),
	        _react2.default.createElement(
	          _Tabs2.default,
	          { tabAlign: 'center' },
	          _react2.default.createElement(
	            _TabPanel2.default,
	            { title: _react2.default.createElement(
	                'span',
	                null,
	                'Information'
	              ) },
	            this.renderGroupInformationPanel()
	          ),
	          _react2.default.createElement(
	            _TabPanel2.default,
	            { title: _react2.default.createElement(
	                'span',
	                null,
	                'Owners'
	              ) },
	            this.renderGroupOwnerManagerPanel()
	          )
	        )
	      );
	    }
	  }]);
	
	  return GroupSettingsModal;
	}(_react2.default.Component);
	
	GroupSettingsModal.displayName = 'GroupSettingsModal';
	exports.default = GroupSettingsModal;

/***/ },
/* 2401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Avatar = __webpack_require__(933);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _modal = __webpack_require__(1188);
	
	var _GroupAvatarSelector = __webpack_require__(1333);
	
	var _GroupAvatarSelector2 = _interopRequireDefault(_GroupAvatarSelector);
	
	var _GroupForm = __webpack_require__(1343);
	
	var _GroupForm2 = _interopRequireDefault(_GroupForm);
	
	var _GroupOptionsForm = __webpack_require__(1387);
	
	var _GroupOptionsForm2 = _interopRequireDefault(_GroupOptionsForm);
	
	var _ReuseClassConfirmDialog = __webpack_require__(2402);
	
	var _ReuseClassConfirmDialog2 = _interopRequireDefault(_ReuseClassConfirmDialog);
	
	var _RemoveClassConfirmDialog = __webpack_require__(2403);
	
	var _RemoveClassConfirmDialog2 = _interopRequireDefault(_RemoveClassConfirmDialog);
	
	__webpack_require__(2404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupEditPanel = function (_React$Component) {
	  _inherits(GroupEditPanel, _React$Component);
	
	  function GroupEditPanel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupEditPanel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupEditPanel.__proto__ || Object.getPrototypeOf(GroupEditPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      name: null,
	      code: null,
	      canSubmit: false,
	      group: _this.props.group
	    }, _this.onAvatarSelected = function (avatar) {
	      _GroupActions2.default.patch(_this.props.group, {
	        group_avatar_id: avatar.id
	      }, 'Icon saved');
	    }, _this.onInvalidChange = function () {
	      _this.setState({ name: null, code: null, canSubmit: false });
	    }, _this.onValidChange = function (name, code, organizationId) {
	      _this.setState({ name: name, code: code, organizationId: organizationId, canSubmit: true });
	    }, _this.onOptionsChange = function (name, value) {
	      var underscored = name.replace(/([A-Z])/g, function (a) {
	        return '_' + a.toLowerCase();
	      });
	      _GroupActions2.default.patch(_this.props.group, _defineProperty({}, underscored, value)).then(function (group) {
	        return _this.setState(group);
	      }, function (_ref2) {
	        var message = _ref2.message;
	
	        _this.setState({ group: _this.props.group });
	        _ToastActions2.default.showErrorToast(message);
	      });
	    }, _this.onSubmit = function () {
	      var _this$state = _this.state,
	          code = _this$state.code,
	          name = _this$state.name,
	          organizationId = _this$state.organizationId;
	
	
	      var attributes = {
	        name: code,
	        class_name: name,
	        group_avatar_id: _this.refs.avatarSelector.getSelectedAvatarId(),
	        organization_id: organizationId
	      };
	
	      var update = function update() {
	        _GroupActions2.default.patch(_this.props.group, attributes).then(function () {
	          _this.props.onRequestHide();
	          if (_this.state.initialCode !== code) {
	            _this.props.onCodeChange(code);
	          }
	        }, function (error) {
	          return _ToastActions2.default.showAPIError(error);
	        });
	      };
	
	      if (attributes.name === _this.props.group.getCode()) {
	        update();
	      } else {
	        (0, _modal.mountModal)(_this.renderConfirmDialog('Are you sure you want to change your class code to @' + attributes.name, 'Current participants won’t be affected, but new participants ' + 'must use this code to join your class.', 'No', 'Yes', update), _this);
	      }
	    }, _this.handleRemoveCompletion = function () {
	      _this.context.router.push('/classes');
	    }, _this.handleReuseCompletion = function (newGroup) {
	      _this.context.router.push('/classes/' + newGroup.getCode());
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupEditPanel, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var group = this.props.group;
	
	      this.setState({ initialCode: group.getCode() });
	    }
	
	    /* eslint-disable flowtype/space-before-type-colon*/
	
	  }, {
	    key: 'renderConfirmDialog',
	    value: function renderConfirmDialog(title, note, cancelButtonText, actionButtonText, onConfirm) {
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'GroupEditPanel',
	        glyph: 'caution',
	        glyphColor: 'lava',
	        title: title,
	        actionButtonText: actionButtonText,
	        cancelButtonText: cancelButtonText,
	        onConfirm: onConfirm,
	        subtext: note
	      });
	    }
	  }, {
	    key: 'renderRemoveDialog',
	    value: function renderRemoveDialog() {
	      var _this2 = this;
	
	      return _react2.default.createElement(_RemoveClassConfirmDialog2.default, {
	        group: this.props.group,
	        onSubmit: function onSubmit() {
	          return _this2.props.onRequestHide();
	        },
	        onActionCompletion: function onActionCompletion() {
	          return _this2.handleRemoveCompletion();
	        }
	      });
	    }
	  }, {
	    key: 'renderRemoveClassButton',
	    value: function renderRemoveClassButton() {
	      if (this.props.group.canEdit()) {
	        return _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.renderRemoveDialog() },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              { color: 'lava', block: true },
	              'Remove from class list'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'GroupEditPanel-subtext' },
	              'This class will be archived and will no longer appear in your class list.'
	            )
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'renderReuseDialog',
	    value: function renderReuseDialog() {
	      var _this3 = this;
	
	      var subText = 'A new class will be created with the code @' + this.props.group.getCode() + '. You can always view and restore archived classes from your settings.';
	      return _react2.default.createElement(_ReuseClassConfirmDialog2.default, {
	        group: this.props.group,
	        onSubmit: function onSubmit() {
	          return _this3.props.onRequestHide();
	        },
	        onActionCompletion: function onActionCompletion(newGroup) {
	          return _this3.handleReuseCompletion(newGroup);
	        },
	        subText: subText,
	        archiveFirst: true
	      });
	    }
	  }, {
	    key: 'renderReuseClassButton',
	    value: function renderReuseClassButton() {
	      if (this.props.group.canEdit()) {
	        return _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.renderReuseDialog() },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              { color: 'lava', block: true },
	              'Reuse class code'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'GroupEditPanel-subtext' },
	              'This class will be archived, and a new class will be created with this code.'
	            )
	          )
	        );
	      }
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var reuseClassButton = this.renderReuseClassButton();
	      var removeClassButton = this.renderRemoveClassButton();
	      var archiveSection = (removeClassButton || reuseClassButton) && _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Divider2.default, { size: 'medium' }),
	        _react2.default.createElement(
	          _List2.default,
	          { size: 'small', className: 'archiveSection' },
	          reuseClassButton,
	          removeClassButton
	        )
	      );
	
	      return _react2.default.createElement(
	        _BoxBody2.default,
	        { className: 'GroupEditPanel' },
	        _react2.default.createElement(
	          _MediaObject2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'GroupEditPanel-avatar' },
	            _react2.default.createElement(_GroupAvatarSelector2.default, {
	              ref: 'avatarSelector',
	              onSelect: this.onAvatarSelected,
	              initialAvatar: this.props.group.getAvatar()
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_GroupForm2.default, {
	              group: this.state.group,
	              name: this.props.group.getName(),
	              code: this.props.group.getCode(),
	              currentOrganization: this.props.group.getOrganization(),
	              onFormValid: this.onValidChange,
	              onFormInvalid: this.onInvalidChange
	            }),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: 'GroupEditPanel-submit',
	                disabled: !this.state.canSubmit,
	                onClick: this.onSubmit,
	                eventElementName: 'GroupEditPanel-submit' },
	              'Save'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Divider2.default, { size: 'medium' }),
	          _react2.default.createElement(_GroupOptionsForm2.default, {
	            hasChildren: this.props.group.hasChildren(),
	            hideUnderageNote: !this.props.group.getOrganization(),
	            searchable: this.props.group.isSearchable(),
	            showSearchable: !this.props.group.hasStudentOrParentOwner(),
	            subscriberInitiatedChats: this.props.group.canSubscribersInitiateChats(),
	            userIsTeacher: this.props.userIsTeacher,
	            onChange: this.onOptionsChange
	          })
	        ),
	        archiveSection
	      );
	    }
	  }]);
	
	  return GroupEditPanel;
	}(_react2.default.Component);
	
	GroupEditPanel.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	GroupEditPanel.displayName = 'GroupEditPanel';
	exports.default = GroupEditPanel;

/***/ },
/* 2402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ReuseClassConfirmDialog = function (_React$Component) {
	  _inherits(ReuseClassConfirmDialog, _React$Component);
	
	  function ReuseClassConfirmDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReuseClassConfirmDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReuseClassConfirmDialog.__proto__ || Object.getPrototypeOf(ReuseClassConfirmDialog)).call.apply(_ref, [this].concat(args))), _this), _this.onSuccess = function (group) {
	      _ToastActions2.default.showSuccessToast('New class created with code @' + group.getCode());
	      _this.props.onActionCompletion(group);
	    }, _this.onError = function (error) {
	      _ToastActions2.default.showErrorToast(error.message);
	    }, _this.handleReuse = function () {
	      var group = _this.props.group;
	
	      var orgId = group.getOriginalOrganizationId() || null;
	
	      if (_this.props.onSubmit) {
	        _this.props.onSubmit();
	      }
	
	      return _GroupActions2.default.reuseGroup(group, orgId).then(_this.onSuccess, _this.onError);
	    }, _this.handleArchiveAndReuse = function () {
	      var group = _this.props.group;
	
	      var orgId = group.getOrganization() ? group.getOrganization().id : null;
	
	      if (_this.props.onSubmit) {
	        _this.props.onSubmit();
	      }
	
	      return _GroupActions2.default.archiveAndReuseGroup(group, orgId).then(_this.onSuccess, _this.onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReuseClassConfirmDialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'ReuseClassConfirmDialog',
	        group: this.props.group,
	        title: 'Reuse this class code?',
	        subtext: this.props.subText,
	        actionButtonText: 'Reuse',
	        cancelButtonText: 'Cancel',
	        preConfirmPromise: this.props.archiveFirst ? this.handleArchiveAndReuse : this.handleReuse,
	        onRequestHide: this.props.onRequestHide
	      });
	    }
	  }]);
	
	  return ReuseClassConfirmDialog;
	}(_react2.default.Component);
	
	ReuseClassConfirmDialog.displayName = 'ReuseClassConfirmDialog';
	exports.default = ReuseClassConfirmDialog;

/***/ },
/* 2403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var RemoveClassConfirmDialog = function (_React$Component) {
	  _inherits(RemoveClassConfirmDialog, _React$Component);
	
	  function RemoveClassConfirmDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RemoveClassConfirmDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RemoveClassConfirmDialog.__proto__ || Object.getPrototypeOf(RemoveClassConfirmDialog)).call.apply(_ref, [this].concat(args))), _this), _this.onSuccess = function (group) {
	      _ToastActions2.default.showSuccessToast('Class archived');
	      _this.props.onActionCompletion(group);
	    }, _this.onError = function (error) {
	      _ToastActions2.default.showErrorToast(error.message);
	    }, _this.handleRemove = function () {
	      var group = _this.props.group;
	
	
	      return _GroupActions2.default.archiveGroup(group).then(_this.onSuccess, _this.onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RemoveClassConfirmDialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'RemoveClassConfirmDialog',
	        group: this.props.group,
	        title: 'Remove this class from your list?',
	        subtext: 'This class will be archived, but you can always view and restore it from your settings.',
	        actionButtonText: 'Remove',
	        cancelButtonText: 'Cancel',
	        onRequestHide: this.props.onRequestHide,
	        preConfirmPromise: this.handleRemove
	      });
	    }
	  }]);
	
	  return RemoveClassConfirmDialog;
	}(_react2.default.Component);
	
	RemoveClassConfirmDialog.displayName = 'RemoveClassConfirmDialog';
	exports.default = RemoveClassConfirmDialog;

/***/ },
/* 2404 */
1136,
/* 2405 */,
/* 2406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AddGroupOwnerModal = __webpack_require__(2407);
	
	var _AddGroupOwnerModal2 = _interopRequireDefault(_AddGroupOwnerModal);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupMemberListItem = __webpack_require__(2410);
	
	var _GroupMemberListItem2 = _interopRequireDefault(_GroupMemberListItem);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _GroupMembershipStore = __webpack_require__(1900);
	
	var _GroupMembershipStore2 = _interopRequireDefault(_GroupMembershipStore);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	__webpack_require__(2413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupMemberList = _react2.default.createClass({
	  displayName: 'GroupMemberList',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [
	  // XXX refresh whenever GroupMembershipStore dispatches
	  (0, _linkStateWithStores2.default)([_GroupMembershipStore2.default])],
	
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  getStateFromStores: function getStateFromStores() {
	    var group = this.props.group;
	
	    return {
	      owners: group.getOwners()
	    };
	  },
	  getAddOwnerModal: function getAddOwnerModal() {
	    return _react2.default.createElement(_AddGroupOwnerModal2.default, { group: this.props.group });
	  },
	  renderClassOwner: function renderClassOwner(member) {
	    return _react2.default.createElement(_GroupMemberListItem2.default, {
	      key: member.id,
	      className: 'GroupMemberList-listItem',
	      classMember: member,
	      owner: member.isOwner()
	    });
	  },
	  renderConfirmResignationDialog: function renderConfirmResignationDialog() {
	    var _this = this;
	
	    var onConfirm = function onConfirm() {
	      _this.props.onRequestHide();
	      _GroupActions2.default.resignOwnership(_this.props.group).then(function () {
	        _ToastActions2.default.showSuccessToast('Removed as class owner.');
	        _this.context.router.push('/classes');
	      }, function () {
	        _ToastActions2.default.showDefaultErrorToast();
	      });
	    };
	
	    return _react2.default.createElement(_ConfirmDialog2.default, {
	      eventScreenName: 'GroupMemberList',
	      title: 'Are you sure you want to remove yourself as class owner?',
	      subtext: 'Once you remove yourself as class owner, another owner will need to add you again.',
	      actionButtonText: 'Remove',
	      cancelButtonText: 'Cancel',
	      onConfirm: onConfirm
	    });
	  },
	  renderAddOwnerLink: function renderAddOwnerLink() {
	    return _react2.default.createElement(
	      'li',
	      { className: 'GroupMemberListItem' },
	      _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: this.getAddOwnerModal() },
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'GroupMemberListItem-addOwnerLink',
	            eventElementName: 'GroupMemberListItem-addOwnerLink' },
	          _react2.default.createElement(
	            _Text2.default,
	            { weight: 'semibold' },
	            'Add class owner'
	          )
	        )
	      )
	    );
	  },
	  renderFooter: function renderFooter() {
	    var userId = _CurrentUser2.default.getUser().id;
	    var group = this.props.group;
	
	    var isOwner = group.isOwnedByUser(userId);
	
	    return isOwner && this.state.owners.length > 1 && _react2.default.createElement(
	      'div',
	      { className: 'GroupMemberList-footer' },
	      _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: this.renderConfirmResignationDialog() },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'GroupMemberList-resignButton',
	            level: 'secondary',
	            color: 'lava',
	            size: 'small',
	            eventElementName: 'GroupMemberList-resignButton' },
	          'Remove me as class owner'
	        )
	      )
	    );
	  },
	  renderClassOwners: function renderClassOwners() {
	    return _react2.default.createElement(
	      _ScrollableArea2.default,
	      null,
	      _react2.default.createElement(
	        'ul',
	        { className: 'GroupMemberList-list' },
	        this.state.owners.map(this.renderClassOwner),
	        this.renderAddOwnerLink()
	      )
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'GroupMemberList' },
	      this.renderClassOwners(),
	      this.renderFooter()
	    );
	  }
	});
	exports.default = GroupMemberList;

/***/ },
/* 2407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckboxList = __webpack_require__(1467);
	
	var _CheckboxList2 = _interopRequireDefault(_CheckboxList);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _ScrollWatch = __webpack_require__(1238);
	
	var _ScrollWatch2 = _interopRequireDefault(_ScrollWatch);
	
	var _AddGroupOwnerModalConfirm = __webpack_require__(1576);
	
	var _AddGroupOwnerModalConfirm2 = _interopRequireDefault(_AddGroupOwnerModalConfirm);
	
	__webpack_require__(2408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PER_PAGE = 10;
	
	var AddGroupOwnerModal = function (_React$Component) {
	  _inherits(AddGroupOwnerModal, _React$Component);
	
	  function AddGroupOwnerModal(props) {
	    _classCallCheck(this, AddGroupOwnerModal);
	
	    var _this = _possibleConstructorReturn(this, (AddGroupOwnerModal.__proto__ || Object.getPrototypeOf(AddGroupOwnerModal)).call(this, props));
	
	    _this.getPotentialOwnerOptions = function () {
	      var results = new Map();
	
	      _this.state.potentialOwners.forEach(function (potentialOwner) {
	        results.set(potentialOwner.getUserId(), _react2.default.createElement(
	          'div',
	          { className: 'AddGroupOwnerModal-potentialOwner' },
	          potentialOwner.getName()
	        ));
	      });
	
	      return results;
	    };
	
	    _this.loadNextPage = function () {
	      var page = _this.state.page + 1;
	      var group = _this.props.group;
	
	
	      return _GroupActions2.default.loadPotentialOwners(group, page, PER_PAGE).then(function (potentialOwners) {
	        // not already an owner.
	        var potentialOwnersThatAreNotOwners = potentialOwners.filter(function (potentialOwner) {
	          return !group.isOwnedByUser(potentialOwner.id);
	        });
	
	        _this.setState({
	          page: page,
	          initLoadDone: true,
	          allPotentialOwnersLoaded: potentialOwners.length < PER_PAGE,
	          potentialOwners: _this.state.potentialOwners.concat(potentialOwnersThatAreNotOwners)
	        });
	      });
	    };
	
	    _this.canSubmit = function () {
	      return _this.state.checkedIds.length > 0;
	    };
	
	    _this.handlePotentialOwnerChange = function (checkedIds) {
	      _this.setState({ checkedIds: checkedIds });
	    };
	
	    _this.renderAddOwnersButton = function () {
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: _this.renderConfirmDialog() },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            disabled: !_this.canSubmit(),
	            className: 'AddGroupOwnerModal-addButton',
	            eventElementName: 'AddGroupOwnerModal-addButton' },
	          'Add'
	        )
	      );
	    };
	
	    _this.renderConfirmDialog = function () {
	      return _react2.default.createElement(_AddGroupOwnerModalConfirm2.default, {
	        group: _this.props.group,
	        checkedIds: _this.state.checkedIds,
	        onFinish: function onFinish() {
	          return _this.props.onRequestHide();
	        }
	      });
	    };
	
	    _this.renderPotentialOwners = function () {
	      return _react2.default.createElement(_CheckboxList2.default, {
	        ref: 'potential-owners',
	        className: 'AddGroupOwnerModal-list',
	        options: _this.getPotentialOwnerOptions(),
	        onChange: _this.handlePotentialOwnerChange
	      });
	    };
	
	    _this.renderTitle = function (title) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          title
	        )
	      );
	    };
	
	    _this.renderLoadingIndicator = function () {
	      if (!_this.state.allPotentialOwnersLoaded) {
	        return _react2.default.createElement(
	          _ScrollWatch2.default,
	          { onEnter: _this.loadNextPage },
	          _react2.default.createElement(_LoadingIndicator2.default, { size: 'large' })
	        );
	      }
	    };
	
	    _this.state = {
	      allPotentialOwnersLoaded: false,
	      checkedIds: [],
	      initLoadDone: false,
	      page: 0,
	      potentialOwners: []
	    };
	    return _this;
	  }
	
	  _createClass(AddGroupOwnerModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadNextPage();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var body = null;
	
	      if (!this.state.initLoadDone) {
	        body = _react2.default.createElement(_LoadingIndicator2.default, null);
	      } else {
	        if (this.state.potentialOwners.length === 0) {
	          body = _react2.default.createElement(
	            'div',
	            { className: 'AddGroupOwnerModal-info' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'To be promoted to class owner, participants must be 13 or older with a Remind account created online or in the app.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Nobody is currently eligible to become a co-owner.'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                href: _LinkConstants2.default.MOG_FAQ,
	                target: '_blank',
	                onClick: this.props.onRequestHide },
	              'Learn more'
	            )
	          );
	        } else {
	          body = _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'AddGroupOwnerModal-info' },
	              'Not seeing the person you\u2019d like to add?',
	              ' ',
	              _react2.default.createElement(
	                _Link2.default,
	                {
	                  href: _LinkConstants2.default.MOG_FAQ,
	                  target: '_blank',
	                  onClick: this.props.onRequestHide },
	                'Add them'
	              )
	            ),
	            _react2.default.createElement(
	              _ScrollableArea2.default,
	              { className: 'AddGroupOwnerModal-scrollArea' },
	              this.renderPotentialOwners(),
	              this.renderLoadingIndicator()
	            ),
	            this.renderAddOwnersButton()
	          );
	        }
	      }
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'AddGroupOwnerModal'
	        }, this.props, {
	          className: 'AddGroupOwnerModal',
	          title: 'Add class owners',
	          size: 'small' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { className: 'AddGroupOwnerModal-body', divided: true, full: true },
	          body
	        )
	      );
	    }
	  }]);
	
	  return AddGroupOwnerModal;
	}(_react2.default.Component);
	
	AddGroupOwnerModal.displayName = 'AddGroupOwnerModal';
	exports.default = AddGroupOwnerModal;

/***/ },
/* 2408 */
1136,
/* 2409 */,
/* 2410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RelationshipModal = __webpack_require__(1309);
	
	var _RelationshipModal2 = _interopRequireDefault(_RelationshipModal);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _UserLink = __webpack_require__(1640);
	
	var _UserLink2 = _interopRequireDefault(_UserLink);
	
	__webpack_require__(2411);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupMembershipListItem = function (_React$Component) {
	  _inherits(GroupMembershipListItem, _React$Component);
	
	  function GroupMembershipListItem() {
	    _classCallCheck(this, GroupMembershipListItem);
	
	    return _possibleConstructorReturn(this, (GroupMembershipListItem.__proto__ || Object.getPrototypeOf(GroupMembershipListItem)).apply(this, arguments));
	  }
	
	  _createClass(GroupMembershipListItem, [{
	    key: 'render',
	    value: function render() {
	      var name = this.props.classMember.getName();
	      var member = this.props.classMember;
	      var user = this.props.classMember.getUser();
	
	      return _react2.default.createElement(
	        'li',
	        {
	          className: (0, _classnames2.default)({
	            GroupMemberListItem: true,
	            'GroupMemberListItem-highlight': this.props.highlight
	          }, this.props.className) },
	        _react2.default.createElement(
	          _UserLink2.default,
	          {
	            className: 'GroupMemberListItem-link',
	            userId: member.getUserId(),
	            placement: 'left',
	            alignment: 'top' },
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_RelationshipModal2.default, { userId: member.getUserId() }) },
	            _react2.default.createElement(
	              'span',
	              { className: 'GroupMemberListItem-link-trigger' },
	              _react2.default.createElement(_Avatar2.default, {
	                className: 'GroupMemberListItem-droplet',
	                size: 'medium',
	                colorHex: user.getColor(),
	                text: user.getInitials()
	              }),
	              _react2.default.createElement(
	                _Text2.default,
	                { className: 'GroupMemberListItem-name' },
	                name
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GroupMembershipListItem;
	}(_react2.default.Component);
	
	GroupMembershipListItem.displayName = 'GroupMembershipListItem';
	exports.default = GroupMembershipListItem;

/***/ },
/* 2411 */
1136,
/* 2412 */,
/* 2413 */
1136,
/* 2414 */,
/* 2415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _GroupLeaveConfirmDialog = __webpack_require__(2416);
	
	var _GroupLeaveConfirmDialog2 = _interopRequireDefault(_GroupLeaveConfirmDialog);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _reactIntl = __webpack_require__(1058);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	__webpack_require__(2417);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupSubscribedSettingModal = function (_React$Component) {
	  _inherits(GroupSubscribedSettingModal, _React$Component);
	
	  function GroupSubscribedSettingModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupSubscribedSettingModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupSubscribedSettingModal.__proto__ || Object.getPrototypeOf(GroupSubscribedSettingModal)).call.apply(_ref, [this].concat(args))), _this), _this.renderConfirmModal = function () {
	      return _react2.default.createElement(_GroupLeaveConfirmDialog2.default, {
	        group: _this.props.group,
	        onLeave: function onLeave() {
	          return _this.props.onRequestHide();
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupSubscribedSettingModal, [{
	    key: 'render',
	    value: function render() {
	      var group = this.props.group;
	
	      var ownerNames = group.getOwners().map(function (o) {
	        return o.getUser().getName();
	      });
	      var groupName = _react2.default.createElement(_GroupName2.default, { group: group });
	
	      var leaveButtonOpt = group.canLeave() && _react2.default.createElement(
	        'div',
	        { className: 'GroupSubscribedSettingModal-actionBox' },
	        _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.renderConfirmModal() },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              'data-test-selector': 'leave_class_button',
	              size: 'small',
	              level: 'text',
	              color: 'lava' },
	            'Leave this class'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'You will no longer receive announcements from ',
	          groupName,
	          '.'
	        )
	      );
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'GroupSubscribedSettingModal'
	        }, this.props, {
	          size: 'small',
	          title: 'Class settings',
	          className: 'GroupSubscribedSettingModal' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'GroupSubscribedSettingModal-info-header' },
	                'Class name'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'GroupSubscribedSettingModal-info-content' },
	                groupName
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'GroupSubscribedSettingModal-info-header' },
	                'Class code'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'GroupSubscribedSettingModal-info-content' },
	                '@',
	                group.getCode()
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'GroupSubscribedSettingModal-info-header' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                  className: 'GroupSubscribedSettingModal-info-header',
	                  id: 'groupSchoolDialog.title',
	                  defaultMessage: '{ownerNum, plural, one {Owner} other {Owners}}',
	                  values: { ownerNum: ownerNames.length }
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'GroupSubscribedSettingModal-info-content' },
	                ownerNames.join(', ')
	              )
	            )
	          ),
	          leaveButtonOpt
	        )
	      );
	    }
	  }]);
	
	  return GroupSubscribedSettingModal;
	}(_react2.default.Component);
	
	GroupSubscribedSettingModal.displayName = 'GroupSubscribedSettingModal';
	exports.default = GroupSubscribedSettingModal;

/***/ },
/* 2416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupMembershipStore = __webpack_require__(1900);
	
	var _GroupMembershipStore2 = _interopRequireDefault(_GroupMembershipStore);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupLeaveConfirmDialog = function (_React$Component) {
	  _inherits(GroupLeaveConfirmDialog, _React$Component);
	
	  function GroupLeaveConfirmDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupLeaveConfirmDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupLeaveConfirmDialog.__proto__ || Object.getPrototypeOf(GroupLeaveConfirmDialog)).call.apply(_ref, [this].concat(args))), _this), _this.unsubscribe = function () {
	      var group = _this.props.group;
	
	
	      if (_this.props.onLeave) {
	        _this.props.onLeave();
	      }
	
	      _GroupActions2.default.unsubscribeFromGroup(group).then(function () {
	        _GroupMembershipStore2.default.removeGroupMembershipsForGroup(group.id);
	        _this.context.router.push('/classes');
	        _ToastActions2.default.showSuccessToast('You have left ' + group.getName());
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupLeaveConfirmDialog, [{
	    key: 'render',
	    value: function render() {
	      var group = this.props.group;
	
	
	      var subtext = _react2.default.createElement(
	        'span',
	        null,
	        'Once you leave, you will no longer receive messages from',
	        ' ',
	        _react2.default.createElement(_GroupName2.default, { group: group })
	      );
	
	      return _react2.default.createElement(_ConfirmDialog2.default, _extends({
	        eventScreenName: 'GroupLeaveConfirmDialog'
	      }, this.props, {
	        actionButtonText: 'Leave',
	        cancelButtonText: 'Cancel',
	        size: 'xsmall',
	        onConfirm: this.unsubscribe,
	        title: 'Leave this class?',
	        subtext: subtext
	      }));
	    }
	  }]);
	
	  return GroupLeaveConfirmDialog;
	}(_react2.default.Component);
	
	GroupLeaveConfirmDialog.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	GroupLeaveConfirmDialog.displayName = 'GroupLeaveConfirmDialog';
	exports.default = GroupLeaveConfirmDialog;

/***/ },
/* 2417 */
1136,
/* 2418 */,
/* 2419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _reactIntl = __webpack_require__(1058);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _SettingsRemoveSchoolModal = __webpack_require__(2420);
	
	var _SettingsRemoveSchoolModal2 = _interopRequireDefault(_SettingsRemoveSchoolModal);
	
	__webpack_require__(2423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var SchoolSettingsModal = function (_React$Component) {
	  _inherits(SchoolSettingsModal, _React$Component);
	
	  function SchoolSettingsModal() {
	    _classCallCheck(this, SchoolSettingsModal);
	
	    return _possibleConstructorReturn(this, (SchoolSettingsModal.__proto__ || Object.getPrototypeOf(SchoolSettingsModal)).apply(this, arguments));
	  }
	
	  _createClass(SchoolSettingsModal, [{
	    key: 'renderConfirmModal',
	    value: function renderConfirmModal() {
	      var _this2 = this;
	
	      var group = this.props.group;
	
	      var orgId = group.getStaffClassOrgId();
	      var orgGroups = _GroupStore2.default.getGroupsAtOrganization(orgId).models;
	      var groupsByOwned = (0, _lodash.partition)(orgGroups, function (g) {
	        return g.isOwnedByUser(_CurrentUser2.default.getUserId());
	      });
	      var affiliation = _AffiliationStore2.default.getAffiliation(orgId);
	      var org = _OrganizationStore2.default.getOrganization(orgId);
	      return _react2.default.createElement(_SettingsRemoveSchoolModal2.default, {
	        affiliation: affiliation,
	        ownedGroups: groupsByOwned[0],
	        subscribedGroups: groupsByOwned[1],
	        school: org,
	        onConfirm: function onConfirm() {
	          return _this2.props.onRequestHide && _this2.props.onRequestHide();
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var group = this.props.group;
	
	      var isGroupOwner = group.isOwnedByUser(_CurrentUser2.default.getUserId());
	
	      var ownerNames = group.getOwners().map(function (o) {
	        return o.getUser().getName();
	      });
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'SchoolSettingsModal'
	        }, this.props, {
	          size: 'small',
	          title: 'School settings',
	          className: 'SchoolSettingsModal' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'SchoolSettingsModal-info-header' },
	                'School name'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'SchoolSettingsModal-info-content' },
	                _react2.default.createElement(_GroupName2.default, { group: group })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'SchoolSettingsModal-info-header' },
	                'School code'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'SchoolSettingsModal-info-content' },
	                '@',
	                group.getCode()
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'SchoolSettingsModal-info-header' },
	                _react2.default.createElement(_reactIntl.FormattedMessage, {
	                  id: 'groupSchoolDialog.title',
	                  defaultMessage: '{adminNum, plural, one {Admin} other {Admins}}',
	                  values: { adminNum: ownerNames.length }
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'SchoolSettingsModal-info-content' },
	                ownerNames.join(', ')
	              )
	            )
	          ),
	          isGroupOwner && _react2.default.createElement(
	            'div',
	            { className: 'SchoolSettingsModal-searchable' },
	            _react2.default.createElement(
	              'div',
	              { className: 'SchoolSettingsModal-searchable-explanation' },
	              'As a verified administrator, you can see and message everyone at your school. Everyone else can only see the teachers.'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'SchoolSettingsModal-searchable-explanation' },
	              'Teachers can decide whether students and parents can message them and whether people in their classes can message each other.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'SchoolSettingsModal-actionBox' },
	            _react2.default.createElement(
	              _ModalTrigger2.default,
	              { modal: this.renderConfirmModal() },
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  'data-test-selector': 'leave_class_button',
	                  size: 'small',
	                  level: 'text',
	                  color: 'lava' },
	                'Leave this school'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'You will no longer receive announcements from this school.'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SchoolSettingsModal;
	}(_react2.default.Component);
	
	SchoolSettingsModal.displayName = 'SchoolSettingsModal';
	exports.default = SchoolSettingsModal;

/***/ },
/* 2420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _OrgRoleActions = __webpack_require__(1583);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _Affiliation2 = _interopRequireDefault(_Affiliation);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _reactIntl = __webpack_require__(1058);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _HumanArray = __webpack_require__(2222);
	
	var _HumanArray2 = _interopRequireDefault(_HumanArray);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _SettingsRemoveSchoolModal = __webpack_require__(2421);
	
	var _SettingsRemoveSchoolModal2 = _interopRequireDefault(_SettingsRemoveSchoolModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var RemoveAction = function RemoveAction(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _classnames2.default)(props.className, _SettingsRemoveSchoolModal2.default.removeContainer),
	      style: props.style },
	    _react2.default.createElement(_Checkbox2.default, { type: 'checkbox', checked: props.checked, onChange: props.onCheck }),
	    _react2.default.createElement(
	      'div',
	      null,
	      props.children
	    )
	  );
	};
	
	var SettingsRemoveSchoolModal = _react2.default.createClass({
	  displayName: 'SettingsRemoveSchoolModal',
	  getInitialState: function getInitialState() {
	    return _extends({}, this.getNeeds(this.props, {}), {
	      subscribedGroupsChecked: {}
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState(_extends({}, this.state, this.getNeeds(nextProps, this.props)));
	  },
	  getNeeds: function getNeeds(props, prevProps) {
	    // We don't want a change in props to remove your need to have done something
	    return {
	      needsAdmin: this.isAdmin(prevProps) || this.isAdmin(props),
	      needsOwnedGroups: this.isGroupOwner(prevProps) || this.isGroupOwner(props)
	    };
	  },
	  preConfirmPromises: function preConfirmPromises() {
	    var _this = this;
	
	    var promises = [];
	    if (this.isAdmin()) {
	      promises.push((0, _OrgRoleActions.resignAdminship)(this.props.school.id, _CurrentUser2.default.getUserId()));
	    }
	
	    if (this.isGroupOwner()) {
	      this.props.ownedGroups.forEach(function (g) {
	        // Don't show the toast when patching the group
	        promises.push(_GroupActions2.default.patch(g, { organization_id: null }, null, false));
	      });
	    }
	
	    if (this.isGroupSubscriber()) {
	      this.props.subscribedGroups.forEach(function (g) {
	        return promises.push(_GroupActions2.default.unsubscribeFromGroup(g));
	      });
	    }
	    return Promise.all(promises).then(function () {
	      return _UserActions2.default.leaveOrg(_this.props.school.id);
	    });
	  },
	  isAdmin: function isAdmin() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	    return !!props.affiliation && (0, _Affiliation.isAdmin)(props.affiliation);
	  },
	  isGroupOwner: function isGroupOwner() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	    return !!props.ownedGroups && !!props.ownedGroups.length;
	  },
	  isGroupSubscriber: function isGroupSubscriber() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	    return !!props.subscribedGroups && !!props.subscribedGroups.length;
	  },
	  isUnblocked: function isUnblocked() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	    return !this.isAdmin(props) && !this.isGroupSubscriber(props) && !this.isGroupOwner(props);
	  },
	  renderAdmin: function renderAdmin() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      RemoveAction,
	      {
	        className: 'RemoveAction-admin',
	        onCheck: function onCheck() {
	          return _this2.setState({ needsAdmin: !_this2.state.needsAdmin });
	        },
	        checked: !this.state.needsAdmin },
	      _react2.default.createElement(
	        'div',
	        { className: _SettingsRemoveSchoolModal2.default.actionLabel },
	        'Remove yourself as administrator.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _SettingsRemoveSchoolModal2.default.actionText },
	        'Once you do, you won\u2019t have access to your school\u2019s staff list, staff messaging,',
	        ' ',
	        'and other features for verified administrators.'
	      )
	    );
	  },
	  renderOwnedGroups: function renderOwnedGroups() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      RemoveAction,
	      {
	        className: 'RemoveAction-unlinkGroups',
	        onCheck: function onCheck() {
	          return _this3.setState({ needsOwnedGroups: !_this3.state.needsOwnedGroups });
	        },
	        checked: !this.state.needsOwnedGroups },
	      _react2.default.createElement(
	        'div',
	        { className: _SettingsRemoveSchoolModal2.default.actionLabel },
	        'Disconnect your classes.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('description', _SettingsRemoveSchoolModal2.default.actionText) },
	        _react2.default.createElement(_reactIntl.FormattedMessage, {
	          className: 'description',
	          id: 'settings.removeSchool',
	          defaultMessage: 'The {ownedGroupsCount, plural, one {# class} other {# classes}} you own won\u2019t appear when members of {schoolName} search for classes. They\u2019ll be labeled \u201Cnot affiliated\u201D unless you join a new school.',
	          values: {
	            ownedGroupsCount: this.props.ownedGroups.length,
	            schoolName: this.props.school.getName()
	          }
	        })
	      )
	    );
	  },
	  renderSubscribedGroups: function renderSubscribedGroups() {
	    var _this4 = this;
	
	    var onGroupCheck = function onGroupCheck(groupId) {
	      var subscribedGroupsChecked = _extends({}, _this4.state.subscribedGroupsChecked, _defineProperty({}, groupId, !_this4.state.subscribedGroupsChecked[groupId]));
	      _this4.setState({ subscribedGroupsChecked: subscribedGroupsChecked });
	    };
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _SettingsRemoveSchoolModal2.default.subscriptionHeader },
	        _react2.default.createElement(
	          'div',
	          { className: _SettingsRemoveSchoolModal2.default.actionLabel },
	          'Leave classes at ' + this.props.school.getName()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('description', _SettingsRemoveSchoolModal2.default.actionText) },
	          'Classes affiliated with a school can only include participants from that school.'
	        )
	      ),
	      this.props.subscribedGroups.map(function (group) {
	        var ownerNames = group.getOwners().map(function (o) {
	          return o.getUser().getName();
	        });
	        return _react2.default.createElement(
	          RemoveAction,
	          {
	            key: group.id,
	            style: { alignItems: 'center', margin: '12px 0', paddingBottom: '12px' },
	            className: (0, _classnames2.default)('RemoveAction-leave-' + group.id, _SettingsRemoveSchoolModal2.default.leaveGroupAction),
	            onCheck: onGroupCheck.bind(_this4, group.id),
	            checked: _this4.state.subscribedGroupsChecked[group.id] || false },
	          _react2.default.createElement(
	            'div',
	            { className: _SettingsRemoveSchoolModal2.default.subscription },
	            _react2.default.createElement(_GroupAvatar2.default, {
	              group: group,
	              size: 'small'
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: _SettingsRemoveSchoolModal2.default.subscriptionName },
	              _react2.default.createElement(_GroupName2.default, { group: group }),
	              _react2.default.createElement(
	                'div',
	                { className: _SettingsRemoveSchoolModal2.default.leaveGroupNames },
	                _react2.default.createElement(_HumanArray2.default, { sample: ownerNames, total: ownerNames.length })
	              )
	            )
	          )
	        );
	      })
	    );
	  },
	  renderTitle: function renderTitle() {
	    return _react2.default.createElement(
	      'span',
	      null,
	      'Leave ' + this.props.school.getName() + '?'
	    );
	  },
	  renderSubtext: function renderSubtext() {
	    if (this.isUnblocked()) {
	      return _react2.default.createElement(
	        'span',
	        null,
	        'Once you do, you won\u2019t be affiliated with ' + this.props.school.getName() + '.'
	      );
	    } else {
	      return _react2.default.createElement(
	        'span',
	        null,
	        'To leave this school, take a minute to complete this checklist'
	      );
	    }
	  },
	  render: function render() {
	    var _state = this.state,
	        needsAdmin = _state.needsAdmin,
	        needsOwnedGroups = _state.needsOwnedGroups,
	        subscribedGroupsChecked = _state.subscribedGroupsChecked;
	
	    var needsSubscribedGroups = this.props.subscribedGroups.some(function (g) {
	      return !subscribedGroupsChecked[g.id];
	    });
	    return _react2.default.createElement(
	      _ConfirmDialog2.default,
	      _extends({
	        eventScreenName: 'SettingsRemoveSchoolModal'
	      }, this.props, {
	        size: 'small',
	        title: this.renderTitle(),
	        subtext: this.renderSubtext(),
	        hideCancel: true,
	        actionButtonText: 'Leave',
	        preConfirmPromise: this.preConfirmPromises,
	        divided: true,
	        onConfirm: this.props.onConfirm,
	        confirmDisabled: needsAdmin || needsOwnedGroups || needsSubscribedGroups }),
	      this.isAdmin() && this.renderAdmin(),
	      this.isGroupOwner() && this.renderOwnedGroups(),
	      this.isGroupSubscriber() && this.renderSubscribedGroups()
	    );
	  }
	});
	
	exports.default = SettingsRemoveSchoolModal;

/***/ },
/* 2421 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"thunder":"#6b6e72","wolf":"#dcdee2","eclipse":"#9e9fa5","spacing-medium":"8px","removeContainer":"SettingsRemoveSchoolModal__removeContainer___38kJ0","actionLabel":"SettingsRemoveSchoolModal__actionLabel___27M1J","actionText":"SettingsRemoveSchoolModal__actionText___i7Z9J","subscriptionHeader":"SettingsRemoveSchoolModal__subscriptionHeader___1JLsE","subscription":"SettingsRemoveSchoolModal__subscription___pPhty","subscriptionName":"SettingsRemoveSchoolModal__subscriptionName___hqdMv","leaveGroupNames":"SettingsRemoveSchoolModal__leaveGroupNames___1m4hy"};

/***/ },
/* 2422 */,
/* 2423 */
1136,
/* 2424 */,
/* 2425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GroupAspectTabs = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _InviteButton = __webpack_require__(2426);
	
	var _InviteButton2 = _interopRequireDefault(_InviteButton);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UnreadStore = __webpack_require__(1030);
	
	var _UnreadStore2 = _interopRequireDefault(_UnreadStore);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _GroupInviteModal = __webpack_require__(1435);
	
	var _GroupInviteModal2 = _interopRequireDefault(_GroupInviteModal);
	
	var _modal = __webpack_require__(1188);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _GroupAspectTabs = __webpack_require__(2429);
	
	var _GroupAspectTabs2 = _interopRequireDefault(_GroupAspectTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var tabGlyph = {
	  people: 'avatar-group-stroke',
	  messages: 'message-bubble-stroke',
	  activities: 'calendar-stroke',
	  statistics: 'bar-graph-stroke',
	  verify: 'bell-stroke'
	};
	
	var activeTabGlyph = {
	  people: 'avatar-group-fill',
	  messages: 'message-bubble-fill',
	  activities: 'calendar-fill',
	  statistics: 'bar-graph-fill',
	  verify: 'bell-fill'
	};
	
	var GroupAspectTabs = exports.GroupAspectTabs = function (_Component) {
	  _inherits(GroupAspectTabs, _Component);
	
	  function GroupAspectTabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupAspectTabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupAspectTabs.__proto__ || Object.getPrototypeOf(GroupAspectTabs)).call.apply(_ref, [this].concat(args))), _this), _this.showVerifyTab = function () {
	      if (_this.canAccessAdminConsoleForGroup()) {
	        return false;
	      }
	
	      var organization = _this.props.group.getOrganization();
	
	      if (organization) {
	        var affiliation = _AffiliationStore2.default.getAffiliation(organization.id);
	        if (affiliation && (0, _Affiliation.isPendingAdmin)(affiliation)) {
	          return true;
	        }
	      }
	
	      return false;
	    }, _this.openInviteModal = function (e) {
	      var group = _this.props.group;
	
	      e.preventDefault();
	      _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.PDF_CALLOUT);
	      (0, _modal.mountModal)(_react2.default.createElement(_GroupInviteModal2.default, { group: group, hideOnBlur: true }), _this);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupAspectTabs, [{
	    key: 'getGlyphName',
	    value: function getGlyphName(basepath, subpath) {
	      return this.context.router.isActive(basepath + '/' + subpath) ? activeTabGlyph[subpath] : tabGlyph[subpath];
	    }
	  }, {
	    key: 'canAccessAdminConsoleForGroup',
	    value: function canAccessAdminConsoleForGroup() {
	      return _CurrentUser2.default.getUser().hasFeature('web_admin_console') && (this.props.group.getType() === 'district' || this.props.group.isStaffClass());
	    }
	  }, {
	    key: 'showActivityTab',
	    value: function showActivityTab() {
	      return this.props.group.getType() === 'owned' || this.props.group.getType() === 'subscribed' || this.props.group.isRoot();
	    }
	  }, {
	    key: 'showStatisticsTab',
	    value: function showStatisticsTab() {
	      if (this.canAccessAdminConsoleForGroup()) {
	        return false;
	      }
	
	      return this.props.group.getStaffClassOrgId() && this.props.group.isOwnedByUser(_CurrentUser2.default.getUserId());
	    }
	  }, {
	    key: 'renderInviteButton',
	    value: function renderInviteButton() {
	      var group = this.props.group;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _GroupAspectTabs2.default.inviteButton },
	        _react2.default.createElement(_InviteButton2.default, { group: group, forceType: 'glyph' })
	      );
	    }
	  }, {
	    key: 'renderPdfCallout',
	    value: function renderPdfCallout() {
	      var group = this.props.group;
	
	      var showCallout = !group.isRoot() && group.isOwnedByUser(_CurrentUser2.default.getUserId()) && !_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.PDF_CALLOUT);
	
	      if (!showCallout) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: _GroupAspectTabs2.default.pdfDrawer,
	          onClick: this.openInviteModal },
	        _react2.default.createElement(
	          'span',
	          { className: _GroupAspectTabs2.default.pdfDrawerContent },
	          'Get PDF instructions, add participants, or share a link to your class from here.'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _cx, _cx2, _cx3;
	
	      var group = this.props.group;
	      var unreadCount = this.state.unreadCount;
	
	      var basepath = '/classes/' + group.getCode();
	      var activeColor = group.getAccentColor();
	      var isActive = this.context.router.isActive;
	
	
	      return _react2.default.createElement(
	        'nav',
	        { className: _GroupAspectTabs2.default.this },
	        _react2.default.createElement(
	          'ul',
	          { className: _GroupAspectTabs2.default.tabList },
	          this.showVerifyTab() && _react2.default.createElement(
	            'li',
	            { className: _GroupAspectTabs2.default.tab },
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: basepath + '/verify',
	                activeClassName: _GroupAspectTabs2.default.activeLink,
	                className: _GroupAspectTabs2.default.link },
	              _react2.default.createElement(_Glyph2.default, {
	                style: {
	                  color: isActive(basepath + '/verify') ? activeColor : null
	                },
	                size: 'large',
	                name: this.getGlyphName(basepath, 'verify'),
	                className: _GroupAspectTabs2.default.glyph
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Verify'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _GroupAspectTabs2.default.tab },
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: basepath + '/messages',
	                className: (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _GroupAspectTabs2.default.link, true), _defineProperty(_cx, _GroupAspectTabs2.default.activeLink, isActive(basepath + '/messages')), _cx)) },
	              _react2.default.createElement(_Glyph2.default, {
	                style: {
	                  color: isActive(basepath + '/messages') ? activeColor : null
	                },
	                size: 'large',
	                name: this.getGlyphName(basepath, 'messages'),
	                className: _GroupAspectTabs2.default.glyph
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Messages' + (unreadCount > 0 ? ' (' + unreadCount + ')' : '')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _GroupAspectTabs2.default.tab },
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: basepath + '/people',
	                className: (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, _GroupAspectTabs2.default.link, true), _defineProperty(_cx2, _GroupAspectTabs2.default.activeLink, isActive(basepath + '/people')), _cx2)) },
	              _react2.default.createElement(_Glyph2.default, {
	                style: {
	                  color: isActive(basepath + '/people') ? activeColor : null
	                },
	                size: 'large',
	                name: this.getGlyphName(basepath, 'people'),
	                className: _GroupAspectTabs2.default.glyph
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'People'
	              ),
	              !group.isRoot() && this.renderInviteButton()
	            ),
	            this.renderPdfCallout()
	          ),
	          this.showActivityTab() && _react2.default.createElement(
	            'li',
	            { className: _GroupAspectTabs2.default.tab },
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: basepath + '/activities',
	                className: (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, _GroupAspectTabs2.default.link, true), _defineProperty(_cx3, _GroupAspectTabs2.default.activeLink, isActive(basepath + '/activities')), _cx3)) },
	              _react2.default.createElement(_Glyph2.default, {
	                style: {
	                  color: isActive(basepath + '/activities') ? activeColor : null
	                },
	                size: 'large',
	                name: this.getGlyphName(basepath, 'activities'),
	                className: _GroupAspectTabs2.default.glyph
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Activities'
	              )
	            )
	          ),
	          this.showStatisticsTab() && _react2.default.createElement(
	            'li',
	            { className: _GroupAspectTabs2.default.tab },
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: basepath + '/statistics',
	                activeClassName: _GroupAspectTabs2.default.activeLink,
	                className: _GroupAspectTabs2.default.link },
	              _react2.default.createElement(_Glyph2.default, {
	                style: {
	                  color: isActive(basepath + '/statistics') ? activeColor : null
	                },
	                size: 'large',
	                name: this.getGlyphName(basepath, 'statistics'),
	                className: _GroupAspectTabs2.default.glyph
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Statistics'
	              )
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_UnreadStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(state, props) {
	      return {
	        unreadCount: _UnreadStore2.default.getUnreadCount(props.group.getUuid())
	      };
	    }
	  }]);
	
	  return GroupAspectTabs;
	}(_react.Component);
	
	GroupAspectTabs.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	GroupAspectTabs.displayName = 'GroupAspectTabs';
	exports.default = _utils.Container.create(GroupAspectTabs, { withProps: true, pure: false });

/***/ },
/* 2426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ChatParticipantSearchMixin = __webpack_require__(2034);
	
	var _ChatParticipantSearchMixin2 = _interopRequireDefault(_ChatParticipantSearchMixin);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupInviteModal = __webpack_require__(1435);
	
	var _GroupInviteModal2 = _interopRequireDefault(_GroupInviteModal);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _modal = __webpack_require__(1188);
	
	var _TooltipTrigger = __webpack_require__(1171);
	
	var _TooltipTrigger2 = _interopRequireDefault(_TooltipTrigger);
	
	__webpack_require__(2427);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteButton = _react2.default.createClass({
	  displayName: 'InviteButton',
	
	
	  mixins: [_ChatParticipantSearchMixin2.default],
	
	  handleGroupSelect: function handleGroupSelect(group) {
	    this.refs.groupSelectionDialog.hide();
	    var modal = _react2.default.createElement(_GroupInviteModal2.default, { group: group });
	    (0, _modal.mountModal)(modal, this);
	  },
	  canInvite: function canInvite() {
	    var group = this.props.group;
	
	    return group.isRoot() || group.canAddPeople();
	  },
	  renderModal: function renderModal() {
	    var group = this.props.group;
	
	
	    if (group.isRoot()) {
	      return this.renderGroupSelectionDialog();
	    }
	    return _react2.default.createElement(_GroupInviteModal2.default, { group: group });
	  },
	  renderButton: function renderButton(className, text) {
	    return _react2.default.createElement(
	      _Button2.default,
	      _extends({
	        size: 'small'
	      }, this.props, {
	        className: (0, _classnames2.default)(this.props.className, className) }),
	      text
	    );
	  },
	  renderGlyph: function renderGlyph(className, text) {
	    return _react2.default.createElement(
	      _TooltipTrigger2.default,
	      { tooltip: text, placement: 'bottom' },
	      _react2.default.createElement(
	        _Button2.default,
	        _extends({}, this.props, {
	          full: false,
	          size: 'small',
	          level: 'icon',
	          className: className,
	          'data-test-selector': 'invite_button' }),
	        _react2.default.createElement(_Glyph2.default, { name: 'avatar-add', size: 'large', color: 'brand', solo: true })
	      )
	    );
	  },
	  render: function render() {
	    if (!this.canInvite()) {
	      return null;
	    }
	
	    var text = 'Add people';
	    var trigger = void 0;
	
	    if (this.props.forceType === 'button') {
	      trigger = _react2.default.createElement(
	        'div',
	        { style: { display: 'inline' } },
	        this.renderButton('InviteButton-alwaysButton', text)
	      );
	    } else if (this.props.forceType === 'glyph') {
	      trigger = _react2.default.createElement(
	        'div',
	        { style: { display: 'inline' } },
	        this.renderGlyph('InviteButton-alwaysGlyph', text)
	      );
	    } else {
	      trigger = _react2.default.createElement(
	        'div',
	        { style: { display: 'inline' } },
	        this.renderGlyph('InviteButton-small', text),
	        this.renderButton('InviteButton-big', text)
	      );
	    }
	
	    return _react2.default.createElement(
	      _ModalTrigger2.default,
	      { modal: this.renderModal() },
	      trigger
	    );
	  }
	});
	
	exports.default = InviteButton;

/***/ },
/* 2427 */
1136,
/* 2428 */,
/* 2429 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pitch":"#282c31","thunder":"#6b6e72","snow":"#fafbfc","eclipse":"#9e9fa5","polarBear":"#f2f3f5","link":"GroupAspectTabs__link___34IIb","activeLink":"GroupAspectTabs__activeLink___3-eWL","inviteButton":"GroupAspectTabs__inviteButton___3syVq","pdfDrawer":"GroupAspectTabs__pdfDrawer___2Dsvf","pdfDrawerContent":"GroupAspectTabs__pdfDrawerContent___2aLsb"};

/***/ },
/* 2430 */,
/* 2431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _GroupAspectTabs = __webpack_require__(2429);
	
	var _GroupAspectTabs2 = _interopRequireDefault(_GroupAspectTabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrgAspectTabs = function (_Component) {
	  _inherits(OrgAspectTabs, _Component);
	
	  function OrgAspectTabs() {
	    _classCallCheck(this, OrgAspectTabs);
	
	    return _possibleConstructorReturn(this, (OrgAspectTabs.__proto__ || Object.getPrototypeOf(OrgAspectTabs)).apply(this, arguments));
	  }
	
	  _createClass(OrgAspectTabs, [{
	    key: 'render',
	    value: function render() {
	      var org = this.props.org;
	
	
	      var basepath = '/organizations/' + org.id;
	      var activeColor = org.getAccentColor();
	
	      return _react2.default.createElement(
	        'nav',
	        { className: _GroupAspectTabs2.default.this },
	        _react2.default.createElement(
	          'ul',
	          { className: _GroupAspectTabs2.default.tabList },
	          _react2.default.createElement(
	            'li',
	            { className: _GroupAspectTabs2.default.tab },
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                to: basepath,
	                className: (0, _classnames2.default)(_GroupAspectTabs2.default.link, _GroupAspectTabs2.default.activeLink) },
	              _react2.default.createElement(_Glyph2.default, {
	                style: {
	                  color: activeColor
	                },
	                size: 'large',
	                name: 'bell-fill',
	                className: _GroupAspectTabs2.default.glyph
	              }),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Verify'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrgAspectTabs;
	}(_react.Component);
	
	OrgAspectTabs.shouldMount = function () {
	  return !_CurrentUser2.default.getUser().hasFeature('web_admin_console');
	};
	
	OrgAspectTabs.displayName = 'OrgAspectTabs';
	exports.default = OrgAspectTabs;

/***/ },
/* 2432 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"brand":"#2f75c1","polarBear":"#f2f3f5","wolf":"#dcdee2","this":"ClassNavigationHeader__this___f2X4E","top":"ClassNavigationHeader__top___1BpxZ","bottom":"ClassNavigationHeader__bottom___3-Chn","settingsIcon":"ClassNavigationHeader__settingsIcon___17tL2","avatar":"ClassNavigationHeader__avatar___DtHeb","groupName":"ClassNavigationHeader__groupName___EY-EL","groupCode":"ClassNavigationHeader__groupCode___2gF94"};

/***/ },
/* 2433 */,
/* 2434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AddButton = __webpack_require__(1894);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupCreateModal = __webpack_require__(1326);
	
	var _GroupCreateModal2 = _interopRequireDefault(_GroupCreateModal);
	
	var _GroupOrgList = __webpack_require__(2435);
	
	var _GroupOrgList2 = _interopRequireDefault(_GroupOrgList);
	
	var _JoinGroupModal = __webpack_require__(2450);
	
	var _JoinGroupModal2 = _interopRequireDefault(_JoinGroupModal);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _GroupsNavSection = __webpack_require__(2485);
	
	var _GroupsNavSection2 = _interopRequireDefault(_GroupsNavSection);
	
	var _Timestamp = __webpack_require__(1683);
	
	var _Timestamp2 = _interopRequireDefault(_Timestamp);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _groupDisplay = __webpack_require__(1322);
	
	var _groupNavigation = __webpack_require__(2489);
	
	var _getRedirectLocationAfterGroupCreation = __webpack_require__(2153);
	
	var _getRedirectLocationAfterGroupCreation2 = _interopRequireDefault(_getRedirectLocationAfterGroupCreation);
	
	var _getRedirectLocationAfterGroupJoin = __webpack_require__(2490);
	
	var _getRedirectLocationAfterGroupJoin2 = _interopRequireDefault(_getRedirectLocationAfterGroupJoin);
	
	__webpack_require__(2491);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GroupsNav = _react2.default.createClass({
	  displayName: 'GroupsNav',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      showingModal: !!_Modal2.default.getCurrent()
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    _Modal2.default.on('show', this.onModalOpened);
	    _Modal2.default.on('hide', this.onModalClosed);
	  },
	
	
	  // typecheck: ignore statement
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    // XXX move check for sections up to ClassNavigation once that wins,
	    // so we can assume that props are only updated if they've changed
	    // props
	    if (!_lodash2.default.isEqual(this.props.sections, nextProps.sections)) {
	      return true;
	    }
	    // state
	    var stateKeys = ['showingModal'];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = stateKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var stateKey = _step.value;
	
	        if (this.state[stateKey] !== nextState[stateKey]) {
	          return true;
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return false;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _Modal2.default.removeListener('show', this.onModalOpened);
	    _Modal2.default.removeListener('hide', this.onModalClosed);
	  },
	  onModalClosed: function onModalClosed() {
	    this.setState({ showingModal: !!_Modal2.default.getCurrent() });
	  },
	  onModalOpened: function onModalOpened() {
	    this.setState({ showingModal: true });
	  },
	  handleGroupCreated: function handleGroupCreated(group) {
	    this.context.router.push((0, _getRedirectLocationAfterGroupCreation2.default)(group));
	  },
	  handleGroupJoined: function handleGroupJoined(group) {
	    this.context.router.push((0, _getRedirectLocationAfterGroupJoin2.default)(group));
	  },
	  renderDescribedSection: function renderDescribedSection(_ref) {
	    var key = _ref.key,
	        scope = _ref.scope,
	        items = _ref.items;
	
	    if (scope === 'district') {
	      return this.renderDistrictsSection(items);
	    } else if (scope === 'district_organization') {
	      return this.renderDistrictOrganizationsSection(items);
	    } else if (scope === 'school') {
	      return this.renderSchoolsSection(items);
	    } else if (scope === 'class') {
	      if (key === 'classes-owned') {
	        return this.renderOwnedClassesSection(items);
	      } else {
	        return this.renderSubscribedClassesSection(items);
	      }
	    } else if (scope === 'root') {
	      return this.renderRootGroupSection(items);
	    } else {
	      console.error('Unsupported section scope \'' + scope + '\'');
	      return null;
	    }
	  },
	  renderRootGroupSection: function renderRootGroupSection(items) {
	    return _react2.default.createElement(
	      _GroupsNavSection2.default,
	      { key: 'root' },
	      _react2.default.createElement(_GroupOrgList2.default, { items: items })
	    );
	  },
	  renderDistrictsSection: function renderDistrictsSection(items) {
	    return _react2.default.createElement(
	      _GroupsNavSection2.default,
	      {
	        key: 'districts',
	        title: (0, _groupDisplay.titleForSection)('districts', items.length) },
	      _react2.default.createElement(_GroupOrgList2.default, { items: items })
	    );
	  },
	  renderDistrictOrganizationsSection: function renderDistrictOrganizationsSection(items) {
	    return _react2.default.createElement(
	      _GroupsNavSection2.default,
	      {
	        key: 'district_organizations',
	        title: (0, _groupDisplay.titleForSection)('districts', items.length) },
	      _react2.default.createElement(_GroupOrgList2.default, { items: items })
	    );
	  },
	  renderSchoolsSection: function renderSchoolsSection(items) {
	    return _react2.default.createElement(
	      _GroupsNavSection2.default,
	      {
	        key: 'schools',
	        title: (0, _groupDisplay.titleForSection)('schools', items.length) },
	      _react2.default.createElement(_GroupOrgList2.default, { items: items })
	    );
	  },
	
	
	  // XXX this should be in a separate component but I've already
	  // refactored this so much I'll save it for later.
	  renderCreateGroupButton: function renderCreateGroupButton() {
	    // TODO add a tooltip about why it's disabled
	    // `You can only have ${this.state.ownedGroupsLimit} classes` :
	    // 'Create a class'
	
	    var _props = this.props,
	        canAddGroup = _props.canAddGroup,
	        isMuted = _props.isMuted,
	        mutedUntil = _props.mutedUntil;
	
	
	    var button = _react2.default.createElement(
	      _AddButton2.default,
	      {
	        'data-test-selector': 'create_class_nav_link',
	        size: 'normal',
	        className: 'GroupsNav-section-header',
	        disabled: !canAddGroup,
	        linkId: 'GroupsNav-add-class' },
	      'Create a class'
	    );
	
	    if (canAddGroup) {
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        {
	          modal: _react2.default.createElement(_GroupCreateModal2.default, { onCreate: this.handleGroupCreated }),
	          checkForUnsavedChanges: true },
	        button
	      );
	    } else if (isMuted) {
	      var timestamp = _react2.default.createElement(_Timestamp2.default, { date: mutedUntil, format: 'long' });
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          layer: _react2.default.createElement(
	            _Tooltip2.default,
	            null,
	            'Your messaging privileges have been temporarily suspended until ',
	            timestamp,
	            '.'
	          ),
	          placement: 'bottom' },
	        button
	      );
	    } else {
	      return button;
	    }
	  },
	  renderOwnedClassesSection: function renderOwnedClassesSection(items) {
	    var title = (0, _groupDisplay.titleForSection)('classes-owned', items.length);
	
	    return _react2.default.createElement(
	      _GroupsNavSection2.default,
	      {
	        key: 'classes-owned',
	        title: title },
	      this.renderCreateGroupButton(),
	      _react2.default.createElement(_GroupOrgList2.default, { items: items })
	    );
	  },
	
	
	  // XXX this should be in a separate component but I've already
	  // refactored this so much I'll save it for later.
	  renderJoinGroupButton: function renderJoinGroupButton() {
	    var button = _react2.default.createElement(
	      _AddButton2.default,
	      {
	        className: 'GroupsNav-section-header',
	        'data-test-selector': 'join_class_nav_link',
	        linkId: 'GroupsNav-join-class' },
	      'Join a class'
	    );
	
	    return _react2.default.createElement(
	      _ModalTrigger2.default,
	      { modal: _react2.default.createElement(_JoinGroupModal2.default, { onJoin: this.handleGroupJoined }) },
	      button
	    );
	  },
	  renderSubscribedClassesSection: function renderSubscribedClassesSection(items) {
	    var title = (0, _groupDisplay.titleForSection)('classes-subscribed', items.length);
	
	    return _react2.default.createElement(
	      _GroupsNavSection2.default,
	      {
	        key: 'classes-subscribed',
	        title: title },
	      this.renderJoinGroupButton(),
	      _react2.default.createElement(_GroupOrgList2.default, { items: items })
	    );
	  },
	  render: function render() {
	    var _props2 = this.props,
	        className = _props2.className,
	        sections = _props2.sections;
	
	    return _react2.default.createElement(
	      'nav',
	      { className: (0, _classnames2.default)('GroupsNav', className) },
	      sections.map(this.renderDescribedSection)
	    );
	  }
	});
	
	exports.default = GroupsNav;

/***/ },
/* 2435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupOrgListGroupItem = __webpack_require__(2436);
	
	var _GroupOrgListGroupItem2 = _interopRequireDefault(_GroupOrgListGroupItem);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _GroupOrgListOrganizationItem = __webpack_require__(2444);
	
	var _GroupOrgListOrganizationItem2 = _interopRequireDefault(_GroupOrgListOrganizationItem);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(1241);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	__webpack_require__(2448);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Displays a list of mixed organizations and groups in the GroupNav
	 */
	var GroupOrgList = function (_React$Component) {
	  _inherits(GroupOrgList, _React$Component);
	
	  function GroupOrgList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupOrgList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupOrgList.__proto__ || Object.getPrototypeOf(GroupOrgList)).call.apply(_ref, [this].concat(args))), _this), _this.renderItem = function (item) {
	      if (item instanceof _Organization2.default) {
	        return _react2.default.createElement(_GroupOrgListOrganizationItem2.default, { organization: item, key: 'org-' + item.id });
	      } else if (item instanceof _Group2.default) {
	        return _react2.default.createElement(_GroupOrgListGroupItem2.default, {
	          group: item,
	          key: 'group-' + item.id
	        });
	      } else {
	        console.error('Unsupported list item', item);
	        return null;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupOrgList, [{
	    key: 'shouldComponentUpdate',
	
	
	    // typecheck: ignore statement
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _reactAddonsShallowCompare2.default)(this, nextProps);
	    }
	
	    // typecheck: ignore statement
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          items = _props.items,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'ul',
	        {
	          className: (0, _classnames2.default)('GroupOrgList', className) },
	        items.map(this.renderItem)
	      );
	    }
	  }]);
	
	  return GroupOrgList;
	}(_react2.default.Component);
	
	GroupOrgList.displayName = 'GroupOrgList';
	exports.default = GroupOrgList;

/***/ },
/* 2436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Badge = __webpack_require__(2437);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _GroupLink = __webpack_require__(1430);
	
	var _GroupLink2 = _interopRequireDefault(_GroupLink);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _UnreadStore = __webpack_require__(1030);
	
	var _UnreadStore2 = _interopRequireDefault(_UnreadStore);
	
	var _UX = __webpack_require__(2440);
	
	var _UX2 = _interopRequireDefault(_UX);
	
	var _GroupOrgListGroupItem = __webpack_require__(2442);
	
	var _GroupOrgListGroupItem2 = _interopRequireDefault(_GroupOrgListGroupItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupItem = function (_React$Component) {
	  _inherits(GroupItem, _React$Component);
	
	  function GroupItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupItem.__proto__ || Object.getPrototypeOf(GroupItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      unreadCount: 0
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupItem, [{
	    key: 'hasUnreads',
	    value: function hasUnreads() {
	      return _CurrentUser2.default.inExpVariant('CLASS_BADGES') && this.state.unreadCount > 0;
	    }
	  }, {
	    key: 'renderBadge',
	    value: function renderBadge() {
	      return this.hasUnreads() && _react2.default.createElement(_Badge2.default, {
	        className: _GroupOrgListGroupItem2.default.badge,
	        count: this.state.unreadCount,
	        color: 'brand',
	        size: 'large',
	        shape: 'square'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var group = this.props.group;
	
	
	      return _react2.default.createElement(
	        'li',
	        { className: _GroupOrgListGroupItem2.default.this },
	        _react2.default.createElement(
	          _GroupLink2.default,
	          {
	            className: (0, _classnames2.default)('GroupOrgList-item-link', _UX2.default.highlightLink, _defineProperty({}, _GroupOrgListGroupItem2.default.withUnreads, this.hasUnreads())),
	            group: group,
	            color: 'inherit',
	            placement: 'right',
	            alignment: 'top' },
	          _react2.default.createElement(
	            'div',
	            { className: _GroupOrgListGroupItem2.default.container },
	            _react2.default.createElement(_Image2.default, { src: group.getAvatarUrl(), width: 24, className: _GroupOrgListGroupItem2.default.avatar }),
	            _react2.default.createElement(
	              'div',
	              { className: _GroupOrgListGroupItem2.default.name },
	              group.getName()
	            ),
	            this.renderBadge()
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_UnreadStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(state, props) {
	      var group = props.group;
	
	      return {
	        unreadCount: _UnreadStore2.default.getUnreadCount(group.getUuid())
	      };
	    }
	  }]);
	
	  return GroupItem;
	}(_react2.default.Component);
	
	GroupItem.displayName = 'GroupItem';
	exports.default = _utils.Container.create(GroupItem, { withProps: true, pure: false });

/***/ },
/* 2437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pickInputElementProps = __webpack_require__(1106);
	
	var _pickInputElementProps2 = _interopRequireDefault(_pickInputElementProps);
	
	__webpack_require__(2438);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Component used for indicating unreads/unseen state in the form of a pill.
	 *
	 * ```example
	 * <Badge count={5} color="brand" />
	 * ```
	 */
	var Badge = function (_React$Component) {
	  _inherits(Badge, _React$Component);
	
	  function Badge() {
	    _classCallCheck(this, Badge);
	
	    return _possibleConstructorReturn(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
	  }
	
	  _createClass(Badge, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          count = _props.count,
	          others = _objectWithoutProperties(_props, ['className', 'count']);
	
	      var divProps = (0, _pickInputElementProps2.default)(others);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, divProps, {
	          className: (0, _classnames2.default)('Badge', (0, _getPropClasses.getPropClassesFromInstance)(this), className) }),
	        count
	      );
	    }
	  }]);
	
	  return Badge;
	}(_react2.default.Component);
	
	Badge.propClasses = {
	  color: {
	    violet: null,
	    brand: 'Badge-brand',
	    white: 'Badge-white',
	    lava: 'Badge-lava'
	  },
	  size: {
	    small: null,
	    xsmall: 'Badge-xSmall',
	    large: 'Badge-large'
	  },
	  shape: {
	    square: 'Badge-square'
	  }
	};
	Badge.defaultProps = {
	  color: 'violet',
	  shape: 'pill'
	};
	Badge.displayName = 'Badge';
	exports.default = Badge;

/***/ },
/* 2438 */
1136,
/* 2439 */,
/* 2440 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pitch":"#282c31","brand":"#2f75c1","highlightLink":"UX__highlightLink___gVfb1","active":"UX__active___2P27D"};

/***/ },
/* 2441 */,
/* 2442 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"GroupOrgList-GroupItem__this___15SpF","withUnreads":"GroupOrgList-GroupItem__withUnreads___3QRu1","container":"GroupOrgList-GroupItem__container___1r4s9","avatar":"GroupOrgList-GroupItem__avatar___3-w7K","name":"GroupOrgList-GroupItem__name___1Yuam","badge":"GroupOrgList-GroupItem__badge___FPgwJ"};

/***/ },
/* 2443 */,
/* 2444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _OrganizationLink = __webpack_require__(2445);
	
	var _OrganizationLink2 = _interopRequireDefault(_OrganizationLink);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UX = __webpack_require__(2440);
	
	var _UX2 = _interopRequireDefault(_UX);
	
	var _GroupOrgListOrganizationItem = __webpack_require__(2446);
	
	var _GroupOrgListOrganizationItem2 = _interopRequireDefault(_GroupOrgListOrganizationItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationItem = function (_React$Component) {
	  _inherits(OrganizationItem, _React$Component);
	
	  function OrganizationItem() {
	    _classCallCheck(this, OrganizationItem);
	
	    return _possibleConstructorReturn(this, (OrganizationItem.__proto__ || Object.getPrototypeOf(OrganizationItem)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationItem, [{
	    key: 'render',
	    value: function render() {
	      var organization = this.props.organization;
	
	      return _react2.default.createElement(
	        'li',
	        { className: _GroupOrgListOrganizationItem2.default.this },
	        _react2.default.createElement(
	          _OrganizationLink2.default,
	          {
	            className: (0, _classnames2.default)('GroupOrgList-item-link', _UX2.default.highlightLink),
	            organization: organization,
	            color: 'inherit',
	            placement: 'right',
	            alignment: 'top' },
	          _react2.default.createElement(
	            'div',
	            { className: _GroupOrgListOrganizationItem2.default.container },
	            _react2.default.createElement(_Image2.default, { src: organization.getAvatarUrl(), width: 24, className: _GroupOrgListOrganizationItem2.default.avatar }),
	            _react2.default.createElement(
	              'div',
	              { className: _GroupOrgListOrganizationItem2.default.name },
	              organization.getName()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrganizationItem;
	}(_react2.default.Component);
	
	OrganizationItem.displayName = 'OrganizationItem';
	exports.default = OrganizationItem;

/***/ },
/* 2445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationLink = function (_React$Component) {
	  _inherits(OrganizationLink, _React$Component);
	
	  function OrganizationLink() {
	    _classCallCheck(this, OrganizationLink);
	
	    return _possibleConstructorReturn(this, (OrganizationLink.__proto__ || Object.getPrototypeOf(OrganizationLink)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          organization = _props.organization,
	          children = _props.children,
	          other = _objectWithoutProperties(_props, ['organization', 'children']);
	
	      return _react2.default.createElement(
	        _Link2.default,
	        _extends({
	          to: '/organizations/' + this.props.organization.id,
	          activeClassName: 'active'
	        }, other),
	        children || organization.getName()
	      );
	    }
	  }]);
	
	  return OrganizationLink;
	}(_react2.default.Component);
	
	OrganizationLink.defaultProps = {
	  placement: 'right',
	  alignment: 'middle'
	};
	OrganizationLink.displayName = 'OrganizationLink';
	exports.default = OrganizationLink;

/***/ },
/* 2446 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"GroupOrgList-OrganizationItem__this___3F3H2","container":"GroupOrgList-OrganizationItem__container___BYfxO","avatar":"GroupOrgList-OrganizationItem__avatar___3aqqQ","name":"GroupOrgList-OrganizationItem__name___1AzlB","badge":"GroupOrgList-OrganizationItem__badge___2cY1x"};

/***/ },
/* 2447 */,
/* 2448 */
1136,
/* 2449 */,
/* 2450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(555);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _BirthdayInterruptModal = __webpack_require__(2451);
	
	var _BirthdayInterruptModal2 = _interopRequireDefault(_BirthdayInterruptModal);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _ErrorActions = __webpack_require__(1427);
	
	var _ErrorActions2 = _interopRequireDefault(_ErrorActions);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormSingle = __webpack_require__(1716);
	
	var _FormSingle2 = _interopRequireDefault(_FormSingle);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _HelpIcon = __webpack_require__(2452);
	
	var _HelpIcon2 = _interopRequireDefault(_HelpIcon);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _JoinInfoModal = __webpack_require__(2455);
	
	var _JoinInfoModal2 = _interopRequireDefault(_JoinInfoModal);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _LeadActions = __webpack_require__(1021);
	
	var _LeadActions2 = _interopRequireDefault(_LeadActions);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _NameAndSignatureQuery = __webpack_require__(2036);
	
	var _NameAndSignatureQuery2 = _interopRequireDefault(_NameAndSignatureQuery);
	
	var _Organizations = __webpack_require__(1002);
	
	var _Organizations2 = _interopRequireDefault(_Organizations);
	
	var _PrependedTextInput = __webpack_require__(1384);
	
	var _PrependedTextInput2 = _interopRequireDefault(_PrependedTextInput);
	
	var _ReportTeacherSelectModal = __webpack_require__(2479);
	
	var _ReportTeacherSelectModal2 = _interopRequireDefault(_ReportTeacherSelectModal);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _StatusLabel = __webpack_require__(1571);
	
	var _StatusLabel2 = _interopRequireDefault(_StatusLabel);
	
	var _Teachers = __webpack_require__(2481);
	
	var _Teachers2 = _interopRequireDefault(_Teachers);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _modal = __webpack_require__(1188);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	__webpack_require__(2482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DEBOUNCE_DELAY = 300;
	var ORGANIZATIONS_PAGE_SIZE = 20;
	
	var STATUS = (0, _enumerate2.default)(['JOIN_CLASS', 'FIND_SCHOOL', 'FIND_TEACHER', 'SELECT_CLASS']);
	
	// XXX too big, break apart
	var JoinGroupModal = _react2.default.createClass({
	  displayName: 'JoinGroupModal',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      modal: true,
	      footer: null
	    };
	  },
	  getInitialState: function getInitialState() {
	    this._blockResultMouseOverWhileScrolling = false;
	
	    return {
	      status: STATUS.JOIN_CLASS,
	      joinEnabled: false,
	      groupCode: '',
	      errorMessage: null,
	      highlight: -1,
	      organizationQuery: '',
	      loadingOrganizations: false,
	      allOrganizationsLoaded: false,
	      organizations: null,
	      organization: null,
	      teacherQuery: '',
	      loadingTeachers: false,
	      teachers: null,
	      teacher: null,
	      loadingGroups: false,
	      groups: null,
	      searching: false
	    };
	  },
	
	
	  _blockResultMouseOverWhileScrolling: Boolean,
	
	  findGroupWithCode: (0, _lodash.debounce)(function (code) {
	    var _this = this;
	
	    var showError = function showError() {
	      _this.setState({ searching: false });
	      if (code === _this.state.groupCode) {
	        _reactDom2.default.findDOMNode(_this.refs.groupCode).blur();
	        _this.setState({ errorMessage: 'Uh oh! We couldn\'t find a class matching this code.\n          Please contact your teacher for your class code.' });
	      }
	    };
	
	    _Group2.default.fetchByCode(code).then(function (group) {
	      _this.setState({ searching: false });
	      if (code === _this.state.groupCode) {
	        if (group.canJoin()) {
	          _this.setState({
	            joinEnabled: true,
	            groupCode: group.getCode()
	          });
	        } else {
	          _this.setState({ joinEnabled: false });
	          showError();
	        }
	      }
	    }, showError);
	  }, DEBOUNCE_DELAY),
	
	  handleClickTeacher: function handleClickTeacher(teacher) {
	    var _this2 = this;
	
	    if (teacher.isInvited()) {
	      return;
	    } else if (teacher.isInvitable()) {
	      var subtext = void 0;
	      if (teacher.isUser()) {
	        subtext = 'Invite them to start using Remind.';
	      } else if (teacher.isLead()) {
	        subtext = 'Invite them to join Remind.';
	      }
	
	      var modal = _react2.default.createElement(_AlertDialog2.default, {
	        title: teacher.getName() + ' doesn\'t have any classes on Remind.',
	        subtext: subtext,
	        image: __webpack_require__(2484),
	        buttonText: 'Invite',
	        onOkay: function onOkay() {
	          return _this2.inviteTeacher(teacher);
	        }
	      });
	
	      (0, _modal.mountModal)(modal, this);
	    }
	
	    this.setState({ teacher: teacher }, this.handleToSelectClass);
	  },
	  handleFindSchoolInputChange: function handleFindSchoolInputChange() {
	    this.setState({
	      organizationQuery: _reactDom2.default.findDOMNode(this.refs.findSchoolSearch).value,
	      loadingOrganizations: true,
	      allOrganizationsLoaded: false
	    }, this.loadOrganizations);
	  },
	  handleFindTeacherInputChange: function handleFindTeacherInputChange() {
	    this.setState({
	      teacherQuery: _reactDom2.default.findDOMNode(this.refs.findTeacherSearch).value,
	      loadingTeachers: true
	    }, this.loadTeachers);
	  },
	  handleInputKeyDown: function handleInputKeyDown(event) {
	    var results = void 0;
	    var type = void 0;
	    if (this.state.status === STATUS.FIND_SCHOOL) {
	      results = this.state.organizations;
	      type = 'organization';
	    } else if (this.state.status === STATUS.FIND_TEACHER) {
	      results = this.state.teachers;
	      type = 'teacher';
	    }
	
	    var code = event.keyCode;
	    switch (code) {
	      case _KeyConstants2.default.ENTER:
	        {
	          var searchItemNode = _reactDom2.default.findDOMNode(this.refs[type + '-searchItem-' + this.state.highlight]);
	
	          if (searchItemNode) {
	            searchItemNode.click();
	          }
	          break;
	        }
	      case _KeyConstants2.default.UP:
	      case _KeyConstants2.default.DOWN:
	        {
	          var highlight = this.state.highlight;
	
	          if (code === _KeyConstants2.default.UP) {
	            highlight = highlight >= 0 ? highlight - 1 : results.length - 1;
	          } else {
	            highlight = highlight < results.length ? highlight + 1 : 0;
	          }
	          this.setState({ highlight: highlight });
	
	          if (highlight >= 0 && highlight < results.length) {
	            var _searchItemNode = _reactDom2.default.findDOMNode(this.refs[type + '-searchItem-' + highlight]);
	            if (this.state.status === STATUS.FIND_SCHOOL) {
	              this.refs.scrollAreaOrganizations.scrollIntoView(_searchItemNode);
	            } else if (this.state.status === STATUS.FIND_TEACHER) {
	              this.refs.scrollAreaTeachers.scrollIntoView(_searchItemNode);
	            }
	
	            this._blockResultMouseOverWhileScrolling = true;
	          }
	          break;
	        }
	      default:
	        return;
	    }
	    event.preventDefault();
	  },
	  handleInvalidForm: function handleInvalidForm() {
	    this.setState({ joinEnabled: false, errorMessage: null });
	  },
	  handleResultMouseOver: function handleResultMouseOver(index) {
	    if (this._blockResultMouseOverWhileScrolling) {
	      this._blockResultMouseOverWhileScrolling = false;
	      return;
	    }
	
	    if (this.state.highlight !== index) {
	      this.setState({ highlight: index });
	    }
	  },
	
	
	  handleScroll: (0, _lodash.throttle)(function () {
	    var _this3 = this;
	
	    if (!this.state.loadingOrganizations && this.isScrolledToBottom() && !this.state.allOrganizationsLoaded) {
	      this.setState({ loadingOrganizations: true });
	      this.loadMoreOrganizations().then(function (organizations) {
	        _this3.state.organizations.add(organizations.models);
	        _this3.setState({
	          loadingOrganizations: false,
	          allOrganizationsLoaded: organizations.length < ORGANIZATIONS_PAGE_SIZE,
	          organizations: _this3.state.organizations
	        });
	      });
	    }
	  }, 100),
	
	  handleSelectClass: function handleSelectClass() {
	    this.setState({ loadingGroups: true }, this.loadGroups);
	  },
	  handleToFindSchoolBackward: function handleToFindSchoolBackward() {
	    this.setState({
	      status: STATUS.FIND_SCHOOL,
	      organization: null
	    });
	  },
	  handleToFindSchoolForward: function handleToFindSchoolForward() {
	    var _this4 = this;
	
	    var switchToSearch = function switchToSearch() {
	      _this4.setState({
	        status: STATUS.FIND_SCHOOL,
	        highlight: -1,
	        organizationQuery: '',
	        loadingOrganizations: false,
	        organizations: null,
	        organization: null
	      }, _this4.handleFindSchoolInputChange);
	    };
	
	    var user = _CurrentUser2.default.getUser();
	    if (user.getRole() === 'student' && user.getBirthdate() === null) {
	      var onComplete = function onComplete() {
	        user = _CurrentUser2.default.getUser();
	        if (user.isUnderage()) {
	          _ToastActions2.default.showErrorToast('Search isn’t available for students under 13');
	          _this4.setState({ searching: false });
	        } else if (user.getBirthdate() !== null) {
	          switchToSearch();
	        }
	      };
	      (0, _modal.mountModal)(_react2.default.createElement(_BirthdayInterruptModal2.default, { onRequestHide: onComplete }), this);
	    } else {
	      switchToSearch();
	    }
	  },
	  handleToFindTeacherBackward: function handleToFindTeacherBackward() {
	    this.setState({
	      status: STATUS.FIND_TEACHER,
	      teacher: null
	    });
	  },
	  handleToFindTeacherForward: function handleToFindTeacherForward() {
	    this.setState({
	      status: STATUS.FIND_TEACHER,
	      highlight: -1,
	      teacherQuery: '',
	      loadingTeachers: false,
	      teachers: null,
	      teacher: null
	    }, this.handleFindTeacherInputChange);
	  },
	  handleToJoinClassBackward: function handleToJoinClassBackward() {
	    this.setState({ status: STATUS.JOIN_CLASS, groupCode: '', errorMessage: null });
	  },
	  handleToSelectClass: function handleToSelectClass() {
	    this.setState({
	      status: STATUS.SELECT_CLASS,
	      loadingGroups: false,
	      groups: null
	    }, this.handleSelectClass);
	  },
	  handleValidForm: function handleValidForm() {
	    this.setState({ joinEnabled: false, errorMessage: null });
	
	    if (this.isAlreadySubscribed(this.state.groupCode)) {
	      this.setState({ errorMessage: 'You’ve already joined this class!' });
	      return;
	    }
	
	    var group = _GroupStore2.default.getGroupForCode(this.state.groupCode);
	    if (group && group.isOwnedByUser(_CurrentUser2.default.getUserId())) {
	      this.setState({
	        errorMessage: 'You currently own this class. ' + 'To receive copies of your messages, change your preferences in Notifications.'
	      });
	      return;
	    }
	
	    if (!this.state.groupCode) {
	      return;
	    }
	    this.setState({ searching: true });
	    this.findGroupWithCode(this.state.groupCode);
	  },
	  inviteTeacher: function inviteTeacher(teacher) {
	    var _this5 = this;
	
	    var onInvited = function onInvited() {
	      teacher.setState('invited');
	      _this5.forceUpdate(); // better than what was here
	    };
	
	    if (teacher.isUser()) {
	      _UserActions2.default.requestForPublicGroups(teacher.id).then(onInvited);
	    } else if (teacher.isLead()) {
	      _LeadActions2.default.sendInvitations([teacher.id]).then(onInvited);
	    }
	  },
	  isAlreadySubscribed: function isAlreadySubscribed(code) {
	    var group = _GroupStore2.default.getGroupForCode(code);
	    return group && !group.isOwnedByUser(_CurrentUser2.default.getUserId());
	  },
	  isScrolledToBottom: function isScrolledToBottom() {
	    return this.refs.scrollAreaOrganizations.isScrolledToBottom(100);
	  },
	  joinGroup: function joinGroup(data) {
	    var _this6 = this;
	
	    var groupCode = data.groupCode;
	
	
	    _GroupActions2.default.subscribeToGroupWithCode(groupCode).then(function (group) {
	      _ToastActions2.default.showSuccessToast('You\u2019ve joined ' + group.getName());
	      _this6.props.onRequestHide();
	      _this6.props.onJoin(group);
	    }, function (error) {
	      if (error.code === 'information_required') {
	        // TODO model this via Flux so this component doesn't manage the route
	        _this6.context.router.push('/information_required/' + groupCode);
	      } else {
	        _ErrorActions2.default.serverError(error);
	        console.warn('Join group modal failed to subscribe', error);
	      }
	    });
	  },
	  loadGroups: function loadGroups() {
	    var _this7 = this;
	
	    _Groups2.default.find(this.state.teacher.id).then(function (groups) {
	      _this7.setState({ loadingGroups: false, groups: groups });
	    }).catch(function () {
	      var modal = _react2.default.createElement(_AlertDialog2.default, {
	        glyph: 'caution',
	        glyphColor: 'lava',
	        title: 'Sorry, you can\'t view any more teachers right now.',
	        onRequestHide: _this7.handleToFindTeacherBackward
	      });
	
	      (0, _modal.mountModal)(modal, _this7);
	    });
	  },
	  loadMoreOrganizations: function loadMoreOrganizations() {
	    var query = this.state.organizationQuery;
	    var numOrganizations = this.state.organizations.length;
	    var page = Math.floor(numOrganizations / ORGANIZATIONS_PAGE_SIZE) + 1;
	    return _Organizations2.default.search(_OrganizationConstants.OrganizationTypes.SCHOOL, query, page, ORGANIZATIONS_PAGE_SIZE);
	  },
	
	
	  loadOrganizations: (0, _lodash.debounce)(function () {
	    var _this8 = this;
	
	    var query = this.state.organizationQuery;
	    _Organizations2.default.search(_OrganizationConstants.OrganizationTypes.SCHOOL, query).then(function (organizations) {
	      // Don't update if the query changed
	      if (query !== _this8.state.organizationQuery) {
	        return;
	      }
	
	      _this8.setState({ loadingOrganizations: false, organizations: organizations });
	    });
	  }, DEBOUNCE_DELAY),
	
	  loadTeachers: (0, _lodash.debounce)(function () {
	    var _this9 = this;
	
	    var query = this.state.teacherQuery;
	    _Teachers2.default.getTeachersForOrganizationId(this.state.organization.id, query).then(function (teachers) {
	      // Don't update if the query changed
	      if (query !== _this9.state.teacherQuery) {
	        return;
	      }
	
	      _this9.setState({ loadingTeachers: false, teachers: teachers });
	    }).catch(function () {
	      var modal = _react2.default.createElement(
	        _AlertDialog2.default,
	        {
	          glyph: 'caution',
	          glyphColor: 'lava',
	          title: 'Sorry, you can\'t view any more schools right now.',
	          onRequestHide: _this9.handleToFindSchoolBackward },
	        _react2.default.createElement(
	          _Link2.default,
	          { className: 'JoinGroupModal-learnMore', eventElementName: 'JoinGroupModal-learnMore', href: _LinkConstants2.default.SELECTING_SCHOOL },
	          'Learn more'
	        )
	      );
	
	      (0, _modal.mountModal)(modal, _this9);
	    });
	  }, DEBOUNCE_DELAY),
	
	  reportTeacher: function reportTeacher() {
	    var modal = _react2.default.createElement(_ReportTeacherSelectModal2.default, { teacher: this.state.teacher });
	    (0, _modal.mountModal)(modal, this);
	  },
	  subscribeToGroup: function subscribeToGroup(group) {
	    var _this10 = this;
	
	    var markAsSubscribed = function markAsSubscribed() {
	      _ToastActions2.default.showSuccessToast('You\u2019ve joined ' + group.getName());
	      group.setState('subscribed');
	      _this10.forceUpdate(); // better than what was here
	    };
	
	    _GroupActions2.default.subscribeToGroup(group).then(markAsSubscribed, function (error) {
	      if (error.code === 'information_required') {
	        var modal = _react2.default.createElement(_JoinInfoModal2.default, { code: group.getCode(), onDone: markAsSubscribed });
	        (0, _modal.mountModal)(modal, _this10);
	        return;
	      }
	
	      _ToastActions2.default.showDefaultErrorToast();
	      console.warn('Join group modal failed to subscribe', error);
	    });
	  },
	  unsubscribeFromGroup: function unsubscribeFromGroup(group) {
	    var _this11 = this;
	
	    var onLeave = function onLeave() {
	      _GroupActions2.default.unsubscribeFromGroup(group).then(function () {
	        group.setState('available');
	        _this11.forceUpdate(); // better than what was here
	        _ToastActions2.default.showSuccessToast('You\u2019ve left ' + group.getName());
	      });
	    };
	    var modal = _react2.default.createElement(_ConfirmDialog2.default, {
	      title: 'Leave this class?',
	      subtext: 'Once you leave, you will no longer receive messages from ' + group.getName(),
	      actionButtonText: 'Leave',
	      cancelButtonText: 'Cancel',
	      onConfirm: onLeave
	    });
	
	    (0, _modal.mountModal)(modal, this);
	  },
	  renderFindSchool: function renderFindSchool() {
	    var Wrapper = this.props.modal ? _Dialog2.default : _DialogContent2.default;
	
	    return _react2.default.createElement(
	      Wrapper,
	      _extends({
	        key: 'find-school'
	      }, this.props, {
	        size: 'small',
	        className: 'JoinGroupModal',
	        title: 'Select your school',
	        subtext: 'First, find the school you attend.',
	        hidePreviousButton: false,
	        onRequestPrevious: this.handleToJoinClassBackward }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true, full: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'JoinGroupModal-inputWrapper' },
	          _react2.default.createElement(_Input2.default, {
	            className: 'JoinGroupModal-input',
	            ref: 'findSchoolSearch',
	            key: 'findSchoolSearch',
	            type: 'text',
	            size: 'large',
	            placeholder: 'Search for a school',
	            autofocus: true,
	            value: this.state.organizationQuery,
	            onChange: this.handleFindSchoolInputChange,
	            onKeyDown: this.handleInputKeyDown
	          }),
	          _react2.default.createElement(_Glyph2.default, { className: 'JoinGroupModal-inputGlyph', name: 'search', size: 'medium' })
	        ),
	        _react2.default.createElement(
	          _ScrollableArea2.default,
	          {
	            className: 'JoinGroupModal-list',
	            ref: 'scrollAreaOrganizations',
	            onScroll: this.handleScroll,
	            useBodyChildrenHeight: true },
	          this.renderOrganizations(),
	          this.state.loadingOrganizations && this.renderLoadingIndicator()
	        )
	      )
	    );
	  },
	  renderFindTeacher: function renderFindTeacher() {
	    var Wrapper = this.props.modal ? _Dialog2.default : _DialogContent2.default;
	
	    return _react2.default.createElement(
	      Wrapper,
	      _extends({
	        key: 'find-teacher',
	        full: true
	      }, this.props, {
	        size: 'small',
	        className: 'JoinGroupModal JoinGroupModal-noPadding',
	        title: 'Find your teacher',
	        subtext: this.state.organization.getName(),
	        hidePreviousButton: false,
	        onRequestPrevious: this.handleToFindSchoolBackward }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'JoinGroupModal-inputWrapper' },
	          _react2.default.createElement(_Input2.default, {
	            className: 'JoinGroupModal-input',
	            ref: 'findTeacherSearch',
	            type: 'text',
	            size: 'large',
	            placeholder: 'Search for a teacher',
	            autofocus: true,
	            value: this.state.teacherQuery,
	            onChange: this.handleFindTeacherInputChange,
	            onKeyDown: this.handleInputKeyDown
	          }),
	          _react2.default.createElement(_Glyph2.default, { className: 'JoinGroupModal-inputGlyph', name: 'search', size: 'medium' })
	        ),
	        _react2.default.createElement(
	          _ScrollableArea2.default,
	          {
	            className: 'JoinGroupModal-list',
	            ref: 'scrollAreaTeachers',
	            useBodyChildrenHeight: true },
	          this.renderTeachers(),
	          this.state.loadingTeachers && this.renderLoadingIndicator()
	        )
	      )
	    );
	  },
	  renderGroup: function renderGroup(group) {
	    var _this12 = this;
	
	    var join = void 0;
	    if (group.isAvailable()) {
	      join = _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'JoinGroupModal-join',
	          eventElementName: 'JoinGroupModal-join',
	          level: 'secondary',
	          size: 'xsmall',
	          weight: 'semibold',
	          onClick: function onClick() {
	            return _this12.subscribeToGroup(group);
	          } },
	        'Join'
	      );
	    } else if (group.isSubscribed()) {
	      (function () {
	        var enabled = group.canLeave();
	        join = _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'JoinGroupModal-joined',
	            eventElementName: 'JoinGroupModal-joined',
	            size: 'xsmall',
	            weight: 'normal',
	            disabled: !enabled,
	            onClick: function onClick() {
	              return enabled && _this12.unsubscribeFromGroup(group);
	            } },
	          _react2.default.createElement(_Glyph2.default, { name: 'stamp-check' }),
	          'Joined'
	        );
	      })();
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'JoinGroupModal-group', key: group.id },
	      _react2.default.createElement(
	        _FlexibleBlock2.default,
	        { className: 'JoinGroupModal-group-body', flex: 'right' },
	        _react2.default.createElement(_GroupAvatar2.default, {
	          className: 'JoinGroupModal-avatar',
	          group: group
	        }),
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'left' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Text2.default,
	              { className: 'JoinGroupModal-group-title', truncate: true },
	              _react2.default.createElement(_GroupName2.default, { group: group })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'JoinGroupModal-group-subtext' },
	              '@',
	              group.getCode()
	            )
	          ),
	          join
	        )
	      )
	    );
	  },
	  renderGroups: function renderGroups() {
	    if (!this.state.groups) {
	      return null;
	    }
	
	    return this.state.groups.map(this.renderGroup);
	  },
	  renderJoinClass: function renderJoinClass() {
	    var _this13 = this;
	
	    // TODO: Manually implemented FlexibleBlock
	    // (waiting for fix: https://github.com/christianalfoni/formsy-react/issues/151)
	    var Wrapper = this.props.modal ? _Dialog2.default : _DialogContent2.default;
	    var user = _CurrentUser2.default.getUser();
	
	    return _react2.default.createElement(
	      Wrapper,
	      _extends({
	        key: 'join-class',
	        full: true
	      }, this.props, {
	        className: 'JoinGroupModal',
	        title: 'Join a class',
	        size: 'small' }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(
	          _Form2.default,
	          {
	            onSubmit: this.joinGroup,
	            onValid: this.handleValidForm,
	            onInvalid: this.handleInvalidForm },
	          _react2.default.createElement(
	            _Label2.default,
	            { htmlFor: 'groupCode' },
	            'Enter class code',
	            _react2.default.createElement(_HelpIcon2.default, {
	              tooltipText: 'This is the unique code you can use to join and receive messages\n                  from your class.'
	            })
	          ),
	          _react2.default.createElement(
	            _FormSingle2.default,
	            null,
	            _react2.default.createElement(_FormInput2.default, {
	              loading: this.state.searching,
	              component: _PrependedTextInput2.default,
	              errorMessage: this.state.errorMessage,
	              prepend: '@',
	              autofocus: true,
	              ref: 'groupCode',
	              name: 'groupCode',
	              value: this.state.groupCode,
	              onChange: function onChange(event) {
	                return _this13.setState({ groupCode: event.target.value });
	              },
	              validations: { minLength: 3, maxLength: 10 },
	              validationErrors: {
	                minLength: 'The code must be at least 3 characters long.',
	                maxLength: 'The code cannot be over 10 characters long.'
	              }
	            }),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                type: 'submit',
	                id: 'JoinGroupModal-joinButton',
	                size: 'small',
	                disabled: !this.state.joinEnabled },
	              'Join'
	            )
	          )
	        ),
	        user.getCountryCode() === 'US' && !user.isUnderage() && _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'JoinGroupModal-search',
	            eventElementName: 'JoinGroupModal-search',
	            level: 'text',
	            weight: 'semibold',
	            color: 'brand',
	            onClick: this.handleToFindSchoolForward },
	          _react2.default.createElement(_Glyph2.default, { name: 'search' }),
	          'Search for your class instead'
	        )
	      ),
	      this.props.footer
	    );
	  },
	  renderLoadingIndicator: function renderLoadingIndicator() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'JoinGroupModal-loading' },
	      _react2.default.createElement(_LoadingIndicator2.default, { size: 'small' })
	    );
	  },
	  renderNotFound: function renderNotFound(message) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'JoinGroupModal-notFound' },
	      _react2.default.createElement(
	        'div',
	        { className: 'JoinGroupModal-notFound-title' },
	        message
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'JoinGroupModal-notFound-subtext' },
	        'Please try again or join using the class code from your teacher.'
	      )
	    );
	  },
	  renderOrganization: function renderOrganization(organization, index) {
	    var _this14 = this;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)({
	          'JoinGroupModal-result': true,
	          'JoinGroupModal-highlight': this.state.highlight === index
	        }),
	        ref: 'organization-searchItem-' + index,
	        onClick: function onClick() {
	          return _this14.setState({ organization: organization }, _this14.handleToFindTeacherForward);
	        },
	        onMouseOver: function onMouseOver() {
	          return _this14.handleResultMouseOver(index);
	        },
	        key: organization.id },
	      _react2.default.createElement(
	        'div',
	        { className: 'JoinGroupModal-result-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'JoinGroupModal-result-title' },
	          organization.getName()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'JoinGroupModal-result-subtext' },
	          organization.getFormattedAddress()
	        )
	      )
	    );
	  },
	  renderOrganizations: function renderOrganizations() {
	    if (!this.state.organizations) {
	      return null;
	    }
	
	    if (this.state.organizations.length === 0 && !this.state.loadingOrganizations) {
	      if (this.state.organizationQuery.length === 0) {
	        return null;
	      }
	
	      return this.renderNotFound('School not found');
	    }
	
	    return this.state.organizations.map(this.renderOrganization);
	  },
	  renderSelectClass: function renderSelectClass() {
	    var Wrapper = this.props.modal ? _Dialog2.default : _DialogContent2.default;
	
	    return _react2.default.createElement(
	      Wrapper,
	      _extends({
	        key: 'select-class'
	      }, this.props, {
	        size: 'small',
	        full: true,
	        className: 'JoinGroupModal JoinGroupModal-noPadding',
	        title: 'Select a class',
	        subtext: 'Select one or more of ' + this.state.teacher.getName() + '\'s classes below.',
	        hidePreviousButton: false,
	        onRequestPrevious: this.handleToFindTeacherBackward }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(
	          _ScrollableArea2.default,
	          {
	            className: 'JoinGroupModal-list',
	            ref: 'scrollAreaGroups',
	            showShadows: true,
	            useBodyChildrenHeight: true },
	          this.renderGroups(),
	          this.state.loadingGroups && this.renderLoadingIndicator()
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { className: 'JoinGroupModal-done', eventElementName: 'JoinGroupModal-done', onClick: this.props.onRequestHide },
	          'Done'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'JoinGroupModal-report' },
	          _react2.default.createElement(
	            _Link2.default,
	            { color: 'thunder', onClick: this.reportTeacher },
	            _react2.default.createElement(_Glyph2.default, { name: 'flag', size: 'medium' }),
	            'Report this person'
	          )
	        )
	      )
	    );
	  },
	  renderTeacher: function renderTeacher(teacher, index) {
	    var _this15 = this;
	
	    var invite = void 0;
	    if (teacher.isInvitable()) {
	      invite = _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'JoinGroupModal-invitable',
	          level: 'secondary',
	          size: 'xsmall',
	          weight: 'normal',
	          onClick: function onClick(event) {
	            event.stopPropagation();_this15.inviteTeacher(teacher);
	          } },
	        'Invite'
	      );
	    } else if (teacher.isInvited()) {
	      invite = _react2.default.createElement(
	        _StatusLabel2.default,
	        { className: 'JoinGroupModal-invited' },
	        'Invited'
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)({
	          'JoinGroupModal-result': true,
	          'JoinGroupModal-highlight': this.state.highlight === index,
	          'JoinGroupModal-disabled': teacher.isInvited()
	        }),
	        ref: 'teacher-searchItem-' + index,
	        onClick: function onClick() {
	          return _this15.handleClickTeacher(teacher);
	        },
	        onMouseOver: function onMouseOver() {
	          return _this15.handleResultMouseOver(index);
	        },
	        key: teacher.id },
	      _react2.default.createElement(
	        'div',
	        { className: 'JoinGroupModal-result-body' },
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'left' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Text2.default,
	              { className: 'JoinGroupModal-result-title', truncate: true },
	              _react2.default.createElement(_NameAndSignatureQuery2.default, {
	                displayName: teacher.getName(),
	                fullName: teacher.getFullName(),
	                query: this.state.teacherQuery
	              })
	            ),
	            _react2.default.createElement(
	              _Text2.default,
	              { className: 'JoinGroupModal-result-subtext', truncate: true },
	              teacher.getPreview()
	            )
	          ),
	          invite
	        )
	      )
	    );
	  },
	  renderTeachers: function renderTeachers() {
	    if (!this.state.teachers) {
	      return null;
	    }
	
	    if (this.state.teachers.length === 0 && !this.state.loadingTeachers) {
	      return this.renderNotFound('Teacher not found');
	    }
	
	    return this.state.teachers.map(this.renderTeacher);
	  },
	  render: function render() {
	    var _STATUS$JOIN_CLASS$ST;
	
	    // XXX antipattern. these should each be separate components
	    var body = (_STATUS$JOIN_CLASS$ST = {}, _defineProperty(_STATUS$JOIN_CLASS$ST, STATUS.JOIN_CLASS, this.renderJoinClass), _defineProperty(_STATUS$JOIN_CLASS$ST, STATUS.FIND_SCHOOL, this.renderFindSchool), _defineProperty(_STATUS$JOIN_CLASS$ST, STATUS.FIND_TEACHER, this.renderFindTeacher), _defineProperty(_STATUS$JOIN_CLASS$ST, STATUS.SELECT_CLASS, this.renderSelectClass), _STATUS$JOIN_CLASS$ST)[this.state.status]();
	
	    return body;
	  }
	});
	
	exports.default = JoinGroupModal;

/***/ },
/* 2451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BirthdateSelector = __webpack_require__(1943);
	
	var _BirthdateSelector2 = _interopRequireDefault(_BirthdateSelector);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BirthdayInterruptModal = function (_React$Component) {
	  _inherits(BirthdayInterruptModal, _React$Component);
	
	  function BirthdayInterruptModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BirthdayInterruptModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BirthdayInterruptModal.__proto__ || Object.getPrototypeOf(BirthdayInterruptModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      birthdate: _this.props.birthdate || null
	    }, _this.onChange = function (birthdate) {
	      _this.setState({ birthdate: birthdate });
	    }, _this.onSave = function () {
	      var birthdate = _this.state.birthdate;
	
	      if (!birthdate) {
	        console.error('skipping attempt to save falsy birthdate');
	        return;
	      }
	      _UserActions2.default.setBirthdate(birthdate).then(function () {
	        if (_this.props.onRequestHide) {
	          _this.props.onRequestHide();
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BirthdayInterruptModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          eventScreenName: 'BirthdayInterruptModal',
	          allowOverflow: true,
	          className: 'BirthdayInterruptModal',
	          title: 'When is your birthday?',
	          size: 'small',
	          onRequestHide: this.props.onRequestHide },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(_BirthdateSelector2.default, { onChange: this.onChange }),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              disabled: this.state.birthdate === null,
	              onClick: this.onSave },
	            'Save'
	          )
	        )
	      );
	    }
	  }]);
	
	  return BirthdayInterruptModal;
	}(_react2.default.Component);
	
	BirthdayInterruptModal.displayName = 'BirthdayInterruptModal';
	exports.default = BirthdayInterruptModal;

/***/ },
/* 2452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	__webpack_require__(2453);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Note that this used to work by a TooltipTriggger instead of CSS. That used
	// our layer system which avoided clipping in boxes but it also made it so we
	// couldn't use HelpIcon in server-rendered pages. Going with a pure CSS
	// solution gives us more flexibility and when it's not sufficient a
	// TooltipTrigger can be used.
	function HelpIcon(props) {
	  return _react2.default.createElement(
	    'span',
	    { className: 'HelpIcon-helpGlyph', 'data-tooltip-text': props.tooltipText },
	    _react2.default.createElement(_Glyph2.default, { color: 'eclipse', size: 'small', name: 'help', solo: true })
	  );
	}
	exports.default = HelpIcon;

/***/ },
/* 2453 */
1136,
/* 2454 */,
/* 2455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _JoinInfoPage = __webpack_require__(2456);
	
	var _JoinInfoPage2 = _interopRequireDefault(_JoinInfoPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinInfoModal = _react2.default.createClass({
	  displayName: 'JoinInfoModal',
	  onDone: function onDone() {
	    this.props.onRequestHide();
	    this.props.onDone();
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _Modal2.default,
	      _extends({ size: 'small' }, this.props),
	      _react2.default.createElement(_JoinInfoPage2.default, { code: this.props.code, onDone: this.onDone })
	    );
	  }
	});
	
	exports.default = JoinInfoModal;

/***/ },
/* 2456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _JoinInfoPageBirthdate = __webpack_require__(2457);
	
	var _JoinInfoPageBirthdate2 = _interopRequireDefault(_JoinInfoPageBirthdate);
	
	var _JoinInfoPageCreateFullAccount = __webpack_require__(2460);
	
	var _JoinInfoPageCreateFullAccount2 = _interopRequireDefault(_JoinInfoPageCreateFullAccount);
	
	var _JoinInfoPageParentEmail = __webpack_require__(2464);
	
	var _JoinInfoPageParentEmail2 = _interopRequireDefault(_JoinInfoPageParentEmail);
	
	var _JoinInfoPageRolePicker = __webpack_require__(2465);
	
	var _JoinInfoPageRolePicker2 = _interopRequireDefault(_JoinInfoPageRolePicker);
	
	var _JoinPageLoadingIndicator = __webpack_require__(2476);
	
	var _JoinPageLoadingIndicator2 = _interopRequireDefault(_JoinPageLoadingIndicator);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinInfoPage = function (_React$Component) {
	  _inherits(JoinInfoPage, _React$Component);
	
	  function JoinInfoPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JoinInfoPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinInfoPage.__proto__ || Object.getPrototypeOf(JoinInfoPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      status: 'loading',
	      user: null
	    }, _this.onGatheredEverythingNeeded = function () {
	      var groupCode = _this.getGroupCode();
	
	      // if there isn't a group code then we just bail out and
	      // dont try to subscribe to a class.
	      if (!groupCode) {
	        // if callback in props parent will handle transition for us.
	        if (_this.props.onDone) {
	          _this.props.onDone();
	          return;
	        }
	
	        _this.context.router.push('/classes?origin=subscribed');
	        return;
	      }
	
	      var onSuccess = function onSuccess() {
	        // bypass setup/subscription setup step.
	        if (_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION)) {
	          _UserActions2.default.loadCurrentUser();
	        } else {
	          _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION).then(function () {
	            _UserActions2.default.loadCurrentUser();
	          });
	        }
	
	        // if callback in props parent will handle transition for us.
	        if (_this.props.onDone) {
	          _this.props.onDone();
	          return;
	        }
	
	        _this.context.router.push('/classes/' + groupCode + '?origin=subscribed');
	      };
	
	      var onError = function onError(error) {
	        _this.onError(error);
	        _this.context.router.push('/classes');
	      };
	
	      _GroupActions2.default.subscribeToGroupWithCode(groupCode).then(onSuccess, onError);
	    }, _this.getGroupCode = function () {
	      // XXX this component does too much
	      return _this.props.params.groupCode || _this.props.code || null;
	    }, _this.getNextNeed = function () {
	      var user = _this.state.user;
	
	
	      var needs = user ? user.getNeeds() : {};
	
	      /* All those components must accept a onDone props
	       * that return the updated user object as well as an onError prop
	       * that takes in an error response object. Order matters here.
	       */
	      var infos = [{ when: needs.role, Component: _JoinInfoPageRolePicker2.default }, { when: needs.birthdate, Component: _JoinInfoPageBirthdate2.default }, { when: needs.parent_email, Component: _JoinInfoPageParentEmail2.default }, { when: needs.password, Component: _JoinInfoPageCreateFullAccount2.default }];
	
	      return infos.find(function (info) {
	        return info.when === true;
	      });
	    }, _this.updateUser = function (user) {
	      _this.setState({ user: user }, function () {
	        if (!_this.getNextNeed()) {
	          _this.onGatheredEverythingNeeded();
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JoinInfoPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      _AuthActions2.default.checkLoggedIn().then(function (user) {
	        _this2.setState({ status: 'gather_info', user: user }, function () {
	          if (!_this2.getNextNeed()) {
	            _this2.onGatheredEverythingNeeded();
	          }
	        });
	      }, function () {
	        return _this2.context.router.push('/log_in');
	      });
	    }
	  }, {
	    key: 'onError',
	    value: function onError(response) {
	      _ToastActions2.default.showAPIError(response);
	    }
	  }, {
	    key: 'renderInformationGathering',
	    value: function renderInformationGathering() {
	      var need = this.getNextNeed();
	
	      if (!need) {
	        return _react2.default.createElement(_JoinPageLoadingIndicator2.default, null);
	      }
	
	      return _react2.default.createElement(need.Component, { onDone: this.updateUser, onError: this.onError });
	    }
	  }, {
	    key: 'renderLoading',
	    value: function renderLoading() {
	      return _react2.default.createElement(_JoinPageLoadingIndicator2.default, null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.status === 'loading') {
	        return this.renderLoading();
	      } else if (this.state.status === 'gather_info') {
	        return this.renderInformationGathering();
	      }
	      return null;
	    }
	  }]);
	
	  return JoinInfoPage;
	}(_react2.default.Component);
	
	JoinInfoPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	JoinInfoPage.displayName = 'JoinInfoPage';
	exports.default = JoinInfoPage;

/***/ },
/* 2457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _BirthdateSelector = __webpack_require__(1943);
	
	var _BirthdateSelector2 = _interopRequireDefault(_BirthdateSelector);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(2458);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinInfoPageBirthdate = function (_React$Component) {
	  _inherits(JoinInfoPageBirthdate, _React$Component);
	
	  function JoinInfoPageBirthdate() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JoinInfoPageBirthdate);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinInfoPageBirthdate.__proto__ || Object.getPrototypeOf(JoinInfoPageBirthdate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      birthdate: null,
	      errors: null
	    }, _this.onBirthdateChange = function (birthdate) {
	      // $FlowFixMe
	      _this.setState({ birthdate: birthdate });
	    }, _this.canSubmit = function () {
	      return !!_this.state.birthdate;
	    }, _this.submit = function () {
	      var onError = function onError(response) {
	        _this.props.onError(response);
	
	        var errors = {};
	
	        if (response && response.code === 'validation_error') {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = response['field_errors'][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var field = _step.value;
	
	              errors[field['field_name']] = field.messages.join(', ');
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	
	        // $FlowFixMe
	        _this.setState({ errors: errors });
	      };
	
	      _UserActions2.default.update({ birthdate: _this.state.birthdate }).then(_this.props.onDone, onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JoinInfoPageBirthdate, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          size: 'small',
	          full: true,
	          className: 'JoinInfoPageBirthdate',
	          title: 'What is your birthday?',
	          subtext: 'No one else will see this information.' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(_BirthdateSelector2.default, {
	            initialDate: this.state.birthdate,
	            onChange: this.onBirthdateChange
	          }),
	          this.state.errors && 'birthdate' in this.state.errors ? _react2.default.createElement(
	            'span',
	            { className: 'JoinInfoPageBirthdate-Error' },
	            this.state.errors['birthdate']
	          ) : null,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              disabled: !this.canSubmit(),
	              onClick: this.submit },
	            'Save'
	          )
	        )
	      );
	    }
	  }]);
	
	  return JoinInfoPageBirthdate;
	}(_react2.default.Component);
	
	JoinInfoPageBirthdate.displayName = 'JoinInfoPageBirthdate';
	exports.default = JoinInfoPageBirthdate;

/***/ },
/* 2458 */
1136,
/* 2459 */,
/* 2460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinInfoPageCreateFullAccount = function (_React$Component) {
	  _inherits(JoinInfoPageCreateFullAccount, _React$Component);
	
	  function JoinInfoPageCreateFullAccount() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JoinInfoPageCreateFullAccount);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinInfoPageCreateFullAccount.__proto__ || Object.getPrototypeOf(JoinInfoPageCreateFullAccount)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      canSubmit: false
	    }, _this.onPreexistingAccount = function () {
	      _AuthActions2.default.signOut('/log_in');
	    }, _this.onSubmit = function (attrs, _, invalidateForm) {
	      var onSuccess = function onSuccess(user) {
	        _AuthActions2.default.signIn(attrs.email, attrs.password).then(function () {
	          _this.props.onDone(user);
	        });
	      };
	
	      var onFailure = function onFailure(error) {
	        if (!error || error.code !== 'validation_error') {
	          _ToastActions2.default.showDefaultErrorToast();
	          return;
	        }
	
	        _this.props.onError(error);
	
	        var errors = {};
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = error.field_errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var field = _step.value;
	
	            errors[field['field_name']] = field.messages.join(', ');
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        invalidateForm(errors);
	      };
	
	      _UserActions2.default.update({ email: attrs.email, password: attrs.password }).then(onSuccess, onFailure);
	    }, _this.disableButton = function () {
	      _this.setState({ canSubmit: false });
	    }, _this.enableButton = function () {
	      _this.setState({ canSubmit: true });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JoinInfoPageCreateFullAccount, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          size: 'small',
	          full: true,
	          className: 'JoinInfoPageCreateFullAccount',
	          title: 'Enter account details' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            _Form2.default,
	            {
	              onValid: this.enableButton,
	              onInvalid: this.disableButton,
	              onValidSubmit: this.onSubmit },
	            _react2.default.createElement(_FormInput2.default, {
	              label: 'Email address',
	              type: 'email',
	              name: 'email'
	              // even though this is an email, let the browser know to use this as username in the future
	              , autoComplete: 'username',
	              placeholder: 'Email address',
	              validations: 'isEmail',
	              showErrorAfterBlur: true,
	              className: 'JoinInfoPageCreateFullAccount-Email',
	              validationError: 'Invalid email address. Please try again.'
	            }),
	            _react2.default.createElement(_FormInput2.default, {
	              label: 'Choose a password',
	              name: 'password',
	              placeholder: 'Password',
	              type: 'password',
	              autoComplete: 'new-password',
	              validOnPristine: true,
	              validations: 'minLength:6',
	              className: 'JoinInfoPageCreateFullAccount-Password',
	              validationError: 'Passwords should be at least 6 characters long.'
	            }),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: 'JoinInfoPageCreateFullAccount-Submit',
	                disabled: !this.state.canSubmit,
	                type: 'submit',
	                eventElementName: 'JoinInfoPageCreateFullAccount-Submit' },
	              'Done'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _BoxFooter2.default,
	          { className: 'JoinInfoPageCreateFullAccount-footer' },
	          'Already have an account?',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: this.onPreexistingAccount },
	            'Log in'
	          ),
	          '.'
	        )
	      );
	    }
	  }]);
	
	  return JoinInfoPageCreateFullAccount;
	}(_react2.default.Component);
	
	JoinInfoPageCreateFullAccount.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	JoinInfoPageCreateFullAccount.displayName = 'JoinInfoPageCreateFullAccount';
	exports.default = JoinInfoPageCreateFullAccount;

/***/ },
/* 2461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BoxFooter = function (_React$Component) {
	  _inherits(BoxFooter, _React$Component);
	
	  function BoxFooter() {
	    _classCallCheck(this, BoxFooter);
	
	    return _possibleConstructorReturn(this, (BoxFooter.__proto__ || Object.getPrototypeOf(BoxFooter)).apply(this, arguments));
	  }
	
	  _createClass(BoxFooter, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'footer',
	        { className: (0, _classnames2.default)('BoxFooter', this.props.className) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return BoxFooter;
	}(_react2.default.Component);
	
	BoxFooter.displayName = 'BoxFooter';
	exports.default = BoxFooter;

/***/ },
/* 2462 */
1136,
/* 2463 */,
/* 2464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _RecipientParser = __webpack_require__(1457);
	
	var _RecipientParser2 = _interopRequireDefault(_RecipientParser);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinInfoPageParentEmail = function (_React$Component) {
	  _inherits(JoinInfoPageParentEmail, _React$Component);
	
	  function JoinInfoPageParentEmail() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JoinInfoPageParentEmail);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinInfoPageParentEmail.__proto__ || Object.getPrototypeOf(JoinInfoPageParentEmail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      canSubmit: false
	    }, _this.disableButton = function () {
	      _this.setState({ canSubmit: false });
	    }, _this.enableButton = function () {
	      _this.setState({ canSubmit: true });
	    }, _this.submit = function (attrs) {
	      if (_this.shouldDirectAdd()) {
	        var token = _RecipientParser2.default.newToken(attrs.address);
	        _UserActions2.default.addParent(attrs.full_name, token.address).then(_this.props.onDone, _this.props.onError);
	      } else {
	        _UserActions2.default.update({ parent_email: attrs.email }).then(_this.props.onDone, _this.props.onError);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JoinInfoPageParentEmail, [{
	    key: 'shouldDirectAdd',
	    value: function shouldDirectAdd() {
	      return _CurrentUser2.default.inExpVariant('COPPA_DIRECT_ADD', 'parent_coppa');
	    }
	  }, {
	    key: 'renderParentAddressInput',
	    value: function renderParentAddressInput() {
	      return _react2.default.createElement(_FormInput2.default, {
	        label: 'Contact information',
	        type: 'text',
	        name: 'address',
	        placeholder: 'Phone number or email address',
	        validations: 'isEmailOrPhone',
	        validationError: 'Invalid phone or email',
	        showErrorAfterBlur: true
	      });
	    }
	  }, {
	    key: 'renderParentEmailInput',
	    value: function renderParentEmailInput() {
	      return _react2.default.createElement(_FormInput2.default, {
	        label: 'Parent\u2019s email address',
	        type: 'email',
	        name: 'email',
	        placeholder: 'Parent\u2019s email address',
	        validations: 'isEmail',
	        validationError: 'Invalid email',
	        showErrorAfterBlur: true
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var shouldDirectAdd = this.shouldDirectAdd();
	      var title = void 0;
	      var subtext = void 0;
	
	      if (shouldDirectAdd) {
	        title = 'Enter your parent’s name and contact information';
	        subtext = 'They’ll be added to Remind and get the same messages you do.';
	      } else {
	        title = 'Enter your parent’s email';
	        subtext = 'Looks like you’re under 13. We’ll send an email to your parent to keep everyone in the loop.';
	      }
	
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          size: 'small',
	          full: true,
	          className: 'JoinInfoPageParentEmail',
	          title: title,
	          subtext: subtext },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            _Form2.default,
	            {
	              onValid: this.enableButton,
	              onInvalid: this.disableButton,
	              onValidSubmit: this.submit },
	            shouldDirectAdd && _react2.default.createElement(_FormInput2.default, {
	              label: 'Parent\u2019s full name',
	              required: true,
	              name: 'full_name',
	              showErrorOnPristine: false,
	              placeholder: 'First and last name',
	              validations: { maxLength: 255 },
	              validationErrors: {
	                maxLength: 'Name should be shorter than 255 characters.'
	              }
	            }),
	            shouldDirectAdd ? this.renderParentAddressInput() : this.renderParentEmailInput(),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                disabled: !this.state.canSubmit,
	                type: 'submit' },
	              'Done'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return JoinInfoPageParentEmail;
	}(_react2.default.Component);
	
	JoinInfoPageParentEmail.displayName = 'JoinInfoPageParentEmail';
	exports.default = JoinInfoPageParentEmail;

/***/ },
/* 2465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RolePicker = __webpack_require__(2466);
	
	var _RolePicker2 = _interopRequireDefault(_RolePicker);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _CenteredContainer = __webpack_require__(2240);
	
	var _CenteredContainer2 = _interopRequireDefault(_CenteredContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinInfoPageRolePicker = function (_React$Component) {
	  _inherits(JoinInfoPageRolePicker, _React$Component);
	
	  function JoinInfoPageRolePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JoinInfoPageRolePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinInfoPageRolePicker.__proto__ || Object.getPrototypeOf(JoinInfoPageRolePicker)).call.apply(_ref, [this].concat(args))), _this), _this.saveRole = function (role) {
	      _UserActions2.default.update({ role: role }).then(_this.props.onDone, _this.props.onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JoinInfoPageRolePicker, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _CenteredContainer2.default,
	        { size: 'large', className: 'JoinInfoPageRolePicker' },
	        _react2.default.createElement(_RolePicker2.default, { onSelect: this.saveRole })
	      );
	    }
	  }]);
	
	  return JoinInfoPageRolePicker;
	}(_react2.default.Component);
	
	JoinInfoPageRolePicker.displayName = 'JoinInfoPageRolePicker';
	exports.default = JoinInfoPageRolePicker;

/***/ },
/* 2466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apple = __webpack_require__(1587);
	
	var _apple2 = _interopRequireDefault(_apple);
	
	var _bell = __webpack_require__(1098);
	
	var _bell2 = _interopRequireDefault(_bell);
	
	var _BoxSelect = __webpack_require__(2467);
	
	var _BoxSelect2 = _interopRequireDefault(_BoxSelect);
	
	var _BoxSelectItem = __webpack_require__(2470);
	
	var _BoxSelectItem2 = _interopRequireDefault(_BoxSelectItem);
	
	var _heart = __webpack_require__(1588);
	
	var _heart2 = _interopRequireDefault(_heart);
	
	var _pencil = __webpack_require__(1589);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _SettingsActions = __webpack_require__(1025);
	
	var _SettingsActions2 = _interopRequireDefault(_SettingsActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RolePicker = function (_React$Component) {
	  _inherits(RolePicker, _React$Component);
	
	  function RolePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RolePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RolePicker.__proto__ || Object.getPrototypeOf(RolePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: null,
	      showAdminOption: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RolePicker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var onGeoReceived = function onGeoReceived(geo) {
	        if (!geo.country_code || geo.country_code === 'US') {
	          _this2.setState({ showAdminOption: true });
	        }
	      };
	
	      _SettingsActions2.default.getGeo().then(onGeoReceived);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _BoxSelect2.default,
	        { title: 'Tell us about yourself' },
	        _react2.default.createElement(
	          _BoxSelectItem2.default,
	          {
	            label: 'I\u2019m a teacher',
	            className: 'RolePicker-button--teacher',
	            eventElementName: 'RolePicker-button--teacher',
	            icon: _apple2.default,
	            action: function action() {
	              return _this3.props.onSelect(_UserConstants.Roles.teacher);
	            } },
	          'Teacher, coach, club adviser, organizer, etc.'
	        ),
	        _react2.default.createElement(
	          _BoxSelectItem2.default,
	          {
	            label: 'I\u2019m a student',
	            className: 'RolePicker-button--student',
	            eventElementName: 'RolePicker-button--student',
	            icon: _pencil2.default,
	            action: function action() {
	              return _this3.props.onSelect(_UserConstants.Roles.student);
	            } },
	          'Student in a class, member of a sports team, club participant, etc.'
	        ),
	        _react2.default.createElement(
	          _BoxSelectItem2.default,
	          {
	            label: 'I\u2019m a parent',
	            className: 'RolePicker-button--parent',
	            eventElementName: 'RolePicker-button--parent',
	            icon: _heart2.default,
	            action: function action() {
	              return _this3.props.onSelect(_UserConstants.Roles.parent);
	            } },
	          'Parent or guardian'
	        ),
	        this.state.showAdminOption && _react2.default.createElement(
	          _BoxSelectItem2.default,
	          {
	            label: 'I\u2019m an administrator',
	            className: 'RolePicker-button--admin',
	            eventElementName: 'RolePicker-button--admin',
	            icon: _bell2.default,
	            action: function action() {
	              return _this3.context.router.push('/setup/admin_role');
	            } },
	          'Superintendent, principal, tech coordinator, etc.'
	        )
	      );
	    }
	  }]);
	
	  return RolePicker;
	}(_react2.default.Component);
	
	RolePicker.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	RolePicker.displayName = 'RolePicker';
	exports.default = RolePicker;

/***/ },
/* 2467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2468);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	/*
	 * Used in conjunction with a Box to add a button.
	 */
	var BoxSelect = function (_React$Component) {
	  _inherits(BoxSelect, _React$Component);
	
	  function BoxSelect() {
	    _classCallCheck(this, BoxSelect);
	
	    return _possibleConstructorReturn(this, (BoxSelect.__proto__ || Object.getPrototypeOf(BoxSelect)).apply(this, arguments));
	  }
	
	  _createClass(BoxSelect, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'BoxSelect' },
	        this.props.title && _react2.default.createElement(
	          'h3',
	          { className: 'BoxSelect-title' },
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'BoxSelect-items' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return BoxSelect;
	}(_react2.default.Component);
	
	BoxSelect.displayName = 'BoxSelect';
	exports.default = BoxSelect;

/***/ },
/* 2468 */
1136,
/* 2469 */,
/* 2470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ImageWrapper = __webpack_require__(2471);
	
	var _ImageWrapper2 = _interopRequireDefault(_ImageWrapper);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _ClickEventTrigger = __webpack_require__(1181);
	
	var _ClickEventTrigger2 = _interopRequireDefault(_ClickEventTrigger);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(2474);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoxSelectItem = _react2.default.createClass({
	  displayName: 'BoxSelectItem',
	
	
	  statics: {
	    propClasses: {
	      size: {
	        xsmall: 'BoxSelectItem--xsmall'
	      }
	    }
	  },
	
	  renderChildren: function renderChildren() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      _Text2.default,
	      { color: 'thunder', element: 'div', className: 'BoxSelectItem-text' },
	      children
	    );
	  },
	  render: function render() {
	    var classes = (0, _classnames2.default)('BoxSelectItem', this.props.className, (0, _getPropClasses.getPropClassesFromInstance)(this), {
	      'BoxSelectItem--border': this.props.border
	    });
	
	    return _react2.default.createElement(
	      _ClickEventTrigger2.default,
	      { eventElementName: this.props.eventElementName },
	      _react2.default.createElement(
	        _Link2.default,
	        { className: classes, onClick: this.props.action, to: this.props.to },
	        _react2.default.createElement(
	          _ImageWrapper2.default,
	          { size: 'xsmall', className: 'BoxSelectItem-icon' },
	          this.props.icon ? _react2.default.createElement(_Image2.default, { src: this.props.icon })
	          // $FlowIssue
	          : _react2.default.createElement(_Glyph2.default, { color: 'brand', name: this.props.glyph, size: 'xxxlarge', className: 'BoxSelectItem-glyph' })
	        ),
	        this.props.label && _react2.default.createElement(
	          'h3',
	          { className: 'BoxSelectItem-label' },
	          this.props.label
	        ),
	        this.props.children && this.renderChildren()
	      )
	    );
	  }
	});
	
	exports.default = BoxSelectItem;

/***/ },
/* 2471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _getPropClasses = __webpack_require__(1135);
	
	__webpack_require__(2472);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageWrapper = function (_React$Component) {
	  _inherits(ImageWrapper, _React$Component);
	
	  function ImageWrapper() {
	    _classCallCheck(this, ImageWrapper);
	
	    return _possibleConstructorReturn(this, (ImageWrapper.__proto__ || Object.getPrototypeOf(ImageWrapper)).apply(this, arguments));
	  }
	
	  _createClass(ImageWrapper, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ImageWrapper', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return ImageWrapper;
	}(_react2.default.Component);
	
	ImageWrapper.propClasses = {
	  shape: {
	    circle: 'ImageWrapper--circle'
	  },
	  size: {
	    small: 'ImageWrapper--small',
	    xsmall: 'ImageWrapper--xsmall'
	  }
	};
	ImageWrapper.displayName = 'ImageWrapper';
	exports.default = ImageWrapper;

/***/ },
/* 2472 */
1136,
/* 2473 */,
/* 2474 */
1136,
/* 2475 */,
/* 2476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	__webpack_require__(2477);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinPageLoadingIndicator = _react2.default.createClass({
	  displayName: 'JoinPageLoadingIndicator',
	  render: function render() {
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        className: 'JoinPageLoadingIndicator',
	        onRequestHide: function onRequestHide() {} },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: false },
	        _react2.default.createElement(_LoadingIndicator2.default, null)
	      )
	    );
	  }
	});
	exports.default = JoinPageLoadingIndicator;

/***/ },
/* 2477 */
1136,
/* 2478 */,
/* 2479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReportToRemindSelectModal = __webpack_require__(1608);
	
	var _ReportToRemindSelectModal2 = _interopRequireDefault(_ReportToRemindSelectModal);
	
	var _Teacher = __webpack_require__(2480);
	
	var _Teacher2 = _interopRequireDefault(_Teacher);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportTeacherSelectModal = function (_React$Component) {
	  _inherits(ReportTeacherSelectModal, _React$Component);
	
	  function ReportTeacherSelectModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReportTeacherSelectModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReportTeacherSelectModal.__proto__ || Object.getPrototypeOf(ReportTeacherSelectModal)).call.apply(_ref, [this].concat(args))), _this), _this.reportTeacher = function (reason, notes) {
	      _UserActions2.default.reportUser(_this.props.teacher.id, reason, notes);
	      if (_this.props.onRequestHide) {
	        _this.props.onRequestHide();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReportTeacherSelectModal, [{
	    key: 'render',
	    value: function render() {
	      var options = ['This person doesn’t teach at this school', 'Inappropriate behavior'];
	
	      return _react2.default.createElement(_ReportToRemindSelectModal2.default, _extends({}, this.props, {
	        options: options,
	        reportee: this.props.teacher.getName(),
	        notesPlaceholder: 'Why are you reporting this Teacher?',
	        onReport: this.reportTeacher
	      }));
	    }
	  }]);
	
	  return ReportTeacherSelectModal;
	}(_react2.default.Component);
	
	ReportTeacherSelectModal.displayName = 'ReportTeacherSelectModal';
	exports.default = ReportTeacherSelectModal;

/***/ },
/* 2480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Teacher = function (_Entity) {
	  _inherits(Teacher, _Entity);
	
	  function Teacher() {
	    _classCallCheck(this, Teacher);
	
	    return _possibleConstructorReturn(this, (Teacher.__proto__ || Object.getPrototypeOf(Teacher)).apply(this, arguments));
	  }
	
	  _createClass(Teacher, [{
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getFirstName',
	    value: function getFirstName() {
	      return this.get('first_name') || '';
	    }
	  }, {
	    key: 'getLastName',
	    value: function getLastName() {
	      return this.get('last_name') || '';
	    }
	  }, {
	    key: 'getFullName',
	    value: function getFullName() {
	      return this.getFirstName() + ' ' + this.getLastName();
	    }
	  }, {
	    key: 'getPreview',
	    value: function getPreview() {
	      return this.get('preview');
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.get('state');
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'setState',
	    value: function setState(state) {
	      return this.set({ state: state });
	    }
	  }, {
	    key: 'isAvailable',
	    value: function isAvailable() {
	      return this.getState() === 'available';
	    }
	  }, {
	    key: 'isUnavailable',
	    value: function isUnavailable() {
	      return this.getState() === 'unavailable';
	    }
	  }, {
	    key: 'isInvitable',
	    value: function isInvitable() {
	      return this.getState() === 'invitable';
	    }
	  }, {
	    key: 'isInvited',
	    value: function isInvited() {
	      return this.getState() === 'invited';
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }, {
	    key: 'isUser',
	    value: function isUser() {
	      return this.getType() === 'user';
	    }
	  }, {
	    key: 'isLead',
	    value: function isLead() {
	      return this.getType() === 'lead';
	    }
	  }]);
	
	  return Teacher;
	}(_Entity3.default);
	
	Teacher.displayName = 'Teacher';
	exports.default = Teacher;

/***/ },
/* 2481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _Teacher = __webpack_require__(2480);
	
	var _Teacher2 = _interopRequireDefault(_Teacher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Teachers = function (_Collection) {
	  _inherits(Teachers, _Collection);
	
	  function Teachers() {
	    _classCallCheck(this, Teachers);
	
	    return _possibleConstructorReturn(this, (Teachers.__proto__ || Object.getPrototypeOf(Teachers)).apply(this, arguments));
	  }
	
	  _createClass(Teachers, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _Teacher2.default;
	    }
	  }], [{
	    key: 'getTeachersForOrganizationId',
	    value: function getTeachersForOrganizationId(organizationId) {
	      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      return (0, _apiRequest2.default)('/organizations/' + organizationId + '/teachers', 'GET', {
	        query: query
	      }).then(function (response) {
	        return Teachers.fromJSON(response);
	      });
	    }
	  }]);
	
	  return Teachers;
	}(_Collection3.default);
	
	Teachers.displayName = 'Teachers';
	exports.default = Teachers;

/***/ },
/* 2482 */
1136,
/* 2483 */,
/* 2484 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TopicsSectionTitle = __webpack_require__(2486);
	
	var _TopicsSectionTitle2 = _interopRequireDefault(_TopicsSectionTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var Section = function Section(props) {
	  return _react2.default.createElement(
	    'section',
	    { className: 'GroupsNav-section' },
	    props.title && _react2.default.createElement(
	      _TopicsSectionTitle2.default,
	      { className: 'GroupsNav-section-title' },
	      props.title
	    ),
	    props.children
	  );
	};
	
	exports.default = Section;

/***/ },
/* 2486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TopicsSectionTitle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TopicsSectionTitle = __webpack_require__(2487);
	
	var _TopicsSectionTitle2 = _interopRequireDefault(_TopicsSectionTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TopicsSectionTitle = exports.TopicsSectionTitle = function (_Component) {
	  _inherits(TopicsSectionTitle, _Component);
	
	  function TopicsSectionTitle() {
	    _classCallCheck(this, TopicsSectionTitle);
	
	    return _possibleConstructorReturn(this, (TopicsSectionTitle.__proto__ || Object.getPrototypeOf(TopicsSectionTitle)).apply(this, arguments));
	  }
	
	  _createClass(TopicsSectionTitle, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'h3',
	        { className: (0, _classnames2.default)(this.props.className, _TopicsSectionTitle2.default.this) },
	        this.props.children
	      );
	    }
	  }]);
	
	  return TopicsSectionTitle;
	}(_react.Component);
	
	TopicsSectionTitle.displayName = 'TopicsSectionTitle';
	exports.default = TopicsSectionTitle;

/***/ },
/* 2487 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"pitch":"#282c31","spacing-small":"4px","spacing-medium":"8px","spacing-large":"16px","this":"TopicsSectionTitle__this___1507e"};

/***/ },
/* 2488 */,
/* 2489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SectionShape = exports.GroupOrOrgType = exports.getRootInfo = exports.getSubscribedClasses = exports.getOwnedClasses = exports.getDistrictsInfo = exports.getSchoolsInfo = exports.getDistrictsOrganizationInfo = exports.isPossibleAdminOf = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// typecheck: ignore file
	
	
	exports.getOrderedSectionInfo = getOrderedSectionInfo;
	exports.defaultItemOf = defaultItemOf;
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _Organizations = __webpack_require__(1002);
	
	var _Organizations2 = _interopRequireDefault(_Organizations);
	
	var _react = __webpack_require__(299);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _RootGroup = __webpack_require__(943);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scopeRank = {
	  class: 1,
	  school: 2,
	  district: 3,
	  district_organization: 4,
	  root: 5
	};
	
	var adminScopeRank = {
	  district: 1,
	  district_organization: 2,
	  school: 3,
	  class: 4,
	  root: 5
	};
	
	// 1. If there exists a district, rank the district first, followed by schools, owned groups,
	// joined groups, all classes
	
	// 2. If there is no district, and there exist any schools for which my relationship to that school
	// is 'pending admin' or 'admin', then  schools -> owned classes -> joined classes -> all classes
	
	// 3. Otherwise, owned classes - joined classes -> schools -> all classes
	var sectionOrdering = function sectionOrdering(a, b) {
	  return scopeRank[a.scope] - scopeRank[b.scope];
	};
	
	var adminComparator = function adminComparator(a, b) {
	  return adminScopeRank[a.scope] - adminScopeRank[b.scope];
	};
	
	/**
	 * The organization model pulled from an endpoint that included
	 * 'user_affiliation' to indicate the requesting users's affiliation with the
	 * org.
	 * @param  {Organization} organization from the v2/organizations endpoint
	 * @return {Boolean}    whether current user is or could be an admin of the org
	 */
	var isPossibleAdminOf = exports.isPossibleAdminOf = function isPossibleAdminOf(organization) {
	  var affiliation = organization && organization.get('user_affiliation');
	
	  return affiliation && ((0, _Affiliation.isAdmin)(affiliation) || (0, _Affiliation.isPendingAdmin)(affiliation));
	};
	
	var possibleAdminsOfType = function possibleAdminsOfType(organizations, type) {
	  var typeAdminFilter = function typeAdminFilter(org) {
	    return org.get('type') === type && isPossibleAdminOf(org);
	  };
	
	  return organizations.filter(typeAdminFilter);
	};
	
	var getDistrictsOrganizationInfo = exports.getDistrictsOrganizationInfo = function getDistrictsOrganizationInfo(organizations) {
	  var items = possibleAdminsOfType(organizations, 'District');
	  var hasPossibleAdmins = items.length > 0;
	
	  return {
	    shouldRender: hasPossibleAdmins,
	    scope: 'district_organization',
	    key: 'district_organizations',
	    items: items
	  };
	};
	
	/**
	 * If the user is an admin or teacher in the org, they are a member
	 * of the org's staff class.
	 *
	 * If the user is a pending admin, there may not be a staff class.
	 * In that case we need to render an item from the organization model.
	 */
	var getSchoolsInfo = exports.getSchoolsInfo = function getSchoolsInfo(organizations, schoolGroups) {
	  var schoolsPossiblyAdmined = possibleAdminsOfType(organizations, 'School');
	
	  var couldAdminCount = schoolsPossiblyAdmined.length + schoolGroups.filter(function (g) {
	    return g.isOwnedByUser(_CurrentUser2.default.getUserId());
	  }).length;
	
	  var orgIdsOfStaffClasses = schoolGroups.map(function (g) {
	    return g.getStaffClassOrgId();
	  });
	  var schoolsWithoutStaffClasses = schoolsPossiblyAdmined.filter(function (s) {
	    return !orgIdsOfStaffClasses.includes(s.id);
	  });
	
	  var items = schoolGroups.models.concat(schoolsWithoutStaffClasses);
	
	  return {
	    shouldRender: items.length > 0,
	    containsAdminSchools: couldAdminCount > 0,
	    scope: 'school',
	    key: 'schools',
	    items: items
	  };
	};
	
	var getDistrictsInfo = exports.getDistrictsInfo = function getDistrictsInfo(districtGroups) {
	  var couldAdminCount = districtGroups.filter(function (g) {
	    return isPossibleAdminOf(g);
	  }).length;
	
	  return {
	    shouldRender: districtGroups.length > 0,
	    scope: 'district',
	    key: 'districts',
	    items: districtGroups.models,
	    containsAdminDistricts: couldAdminCount > 0
	  };
	};
	
	var getOwnedClasses = exports.getOwnedClasses = function getOwnedClasses(ownedGroups, userCanOwnGroups) {
	  return {
	    shouldRender: userCanOwnGroups,
	    scope: 'class',
	    key: 'classes-owned',
	    items: ownedGroups.models
	  };
	};
	
	var getSubscribedClasses = exports.getSubscribedClasses = function getSubscribedClasses(subscribedGroups) {
	  return {
	    shouldRender: true,
	    scope: 'class',
	    key: 'classes-subscribed',
	    items: subscribedGroups.models
	  };
	};
	
	var getRootInfo = exports.getRootInfo = function getRootInfo() {
	  return {
	    shouldRender: true,
	    scope: 'root',
	    key: 'root',
	    items: [_RootGroup.rootGroup]
	  };
	};
	
	/**
	 * Eventually this should come from backend so that it's consistent across
	 * clients.
	 */
	// $FlowFixMe
	function getOrderedSectionInfo(_ref) {
	  var _ref$organizations = _ref.organizations,
	      organizations = _ref$organizations === undefined ? new _Organizations2.default() : _ref$organizations,
	      _ref$districtGroups = _ref.districtGroups,
	      districtGroups = _ref$districtGroups === undefined ? new _Groups2.default() : _ref$districtGroups,
	      _ref$schoolGroups = _ref.schoolGroups,
	      schoolGroups = _ref$schoolGroups === undefined ? new _Groups2.default() : _ref$schoolGroups,
	      _ref$subscribedGroups = _ref.subscribedGroups,
	      subscribedGroups = _ref$subscribedGroups === undefined ? new _Groups2.default() : _ref$subscribedGroups,
	      _ref$ownedGroups = _ref.ownedGroups,
	      ownedGroups = _ref$ownedGroups === undefined ? new _Groups2.default() : _ref$ownedGroups,
	      _ref$userCanOwnGroups = _ref.userCanOwnGroups,
	      userCanOwnGroups = _ref$userCanOwnGroups === undefined ? false : _ref$userCanOwnGroups,
	      _ref$options = _ref.options,
	      options = _ref$options === undefined ? {} : _ref$options;
	
	  var opts = _extends({
	    ignoreDistrictSection: false,
	    ignoreDistrictOrganizationSection: false
	  }, options);
	
	  var possibleSections = _lodash2.default.compact([getRootInfo(), opts.ignoreDistrictSection ? undefined : getDistrictsInfo(districtGroups), opts.ignoreDistrictOrganizationSection ? undefined : getDistrictsOrganizationInfo(organizations), getSchoolsInfo(organizations, schoolGroups), getOwnedClasses(ownedGroups, userCanOwnGroups), getSubscribedClasses(subscribedGroups)]);
	
	  var sectionsToRender = possibleSections.filter(function (s) {
	    return s.shouldRender;
	  });
	
	  var useAdminSortOrder = _lodash2.default.some(sectionsToRender, function (section) {
	    return section.shouldRender && (section.scope === 'district_organization' || section.containsAdminDistricts || section.containsAdminSchools);
	  });
	
	  if (useAdminSortOrder) {
	    return sectionsToRender.sort(adminComparator);
	  }
	
	  return sectionsToRender.sort(sectionOrdering);
	}
	
	// XXX transitioning to a shared interface for org groups and class groups
	var GroupOrOrgType = exports.GroupOrOrgType = _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(_Group2.default), _react.PropTypes.instanceOf(_Organization2.default)]);
	
	var SectionShape = exports.SectionShape = _react.PropTypes.shape({
	  shouldRender: _react.PropTypes.bool.isRequired,
	  scope: _react.PropTypes.string.isRequired,
	  key: _react.PropTypes.string.isRequired,
	  items: _react.PropTypes.arrayOf(GroupOrOrgType).isRequired
	});
	
	/**
	 * @param  {Section[]} sections returned by getOrderedSectionInfo()
	 * @return {Group|Organization} the default item to show if there is no selection
	 */
	function defaultItemOf(sections) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var section = _step.value;
	
	      var firstItem = section.items[0];
	      if (firstItem) {
	        return firstItem;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return null;
	}

/***/ },
/* 2490 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getRedirectLocationAfterGroupJoin;
	/*  weak */
	function getRedirectLocationAfterGroupJoin(group) {
	  return '/classes/' + group.getCode() + '/messages' + (group.canAddPeople() ? '?invite=true' : '');
	}

/***/ },
/* 2491 */
1136,
/* 2492 */,
/* 2493 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"polarBear":"#f2f3f5","this":"ClassNavigation__this___2_aJN","divider":"ClassNavigation__divider___Xswf-","classList":"ClassNavigation__classList___d-cLN"};

/***/ },
/* 2494 */,
/* 2495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _QuickPromotion = __webpack_require__(1042);
	
	var _QuickPromotion2 = _interopRequireDefault(_QuickPromotion);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _QuickPromotionModal = __webpack_require__(2496);
	
	var _QuickPromotionModal2 = _interopRequireDefault(_QuickPromotionModal);
	
	var _QuickPromotionActionHandler = __webpack_require__(2396);
	
	var _QuickPromotionConstants = __webpack_require__(1043);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuickPromotionAppOpenedModals = function (_React$Component) {
	  _inherits(QuickPromotionAppOpenedModals, _React$Component);
	
	  function QuickPromotionAppOpenedModals() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, QuickPromotionAppOpenedModals);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuickPromotionAppOpenedModals.__proto__ || Object.getPrototypeOf(QuickPromotionAppOpenedModals)).call.apply(_ref, [this].concat(args))), _this), _this.shown = false, _this.onConfirm = function (promotion) {
	      (0, _QuickPromotionActionHandler.handleResponse)(_this.context.router, promotion, _QuickPromotionConstants.ResponseTypes.PRIMARY_ACTION);
	    }, _this.onCancel = function (promotion) {
	      (0, _QuickPromotionActionHandler.handleResponse)(_this.context.router, promotion, _QuickPromotionConstants.ResponseTypes.SECONDARY_ACTION);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(QuickPromotionAppOpenedModals, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkForPrompts();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.checkForPrompts();
	    }
	  }, {
	    key: 'checkForPrompts',
	    value: function checkForPrompts() {
	      var promotions = this.state.promotions;
	
	
	      if (!this.shown) {
	        var promotion = promotions.find(function (p) {
	          return p.isShowable();
	        });
	        if (promotion) {
	          this.shown = true;
	          (0, _modal.mountModal)(_react2.default.createElement(_QuickPromotionModal2.default, {
	            onConfirm: this.onConfirm,
	            onCancel: this.onCancel,
	            promotion: promotion,
	            triggeredContext: 'quick_promotion:' + promotion.getPromotion(),
	            onRequestHide: function onRequestHide() {} /* Flow can't deal with injected props */
	          }), this);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        promotions: _CurrentUser2.default.getQuickPromotionsForTrigger(_QuickPromotionConstants.TriggerTypes.APP_OPENED)
	      };
	    }
	  }]);
	
	  return QuickPromotionAppOpenedModals;
	}(_react2.default.Component);
	
	QuickPromotionAppOpenedModals.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	QuickPromotionAppOpenedModals.displayName = 'QuickPromotionAppOpenedModals';
	exports.default = _utils.Container.create(QuickPromotionAppOpenedModals, { pure: false });

/***/ },
/* 2496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _QuickPromotion = __webpack_require__(1042);
	
	var _QuickPromotion2 = _interopRequireDefault(_QuickPromotion);
	
	var _QuickPromotionConstants = __webpack_require__(1043);
	
	__webpack_require__(2497);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var QuickPromotionModal = function (_Component) {
	  _inherits(QuickPromotionModal, _Component);
	
	  function QuickPromotionModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, QuickPromotionModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = QuickPromotionModal.__proto__ || Object.getPrototypeOf(QuickPromotionModal)).call.apply(_ref, [this].concat(args))), _this), _this.onConfirm = function () {
	      _this.props.onConfirm(_this.props.promotion);
	    }, _this.onCancel = function () {
	      _this.props.onCancel(_this.props.promotion);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(QuickPromotionModal, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventScreenName: 'QuickPromotionModal',
	        eventProperties: { ui_context: this.props.triggeredContext }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var secondaryButton = false;
	      var secondaryButtonText = '';
	      var secondaryAction = this.props.promotion.getSecondaryAction();
	
	      if (secondaryAction) {
	        secondaryButton = true;
	        secondaryButtonText = secondaryAction.getLabel();
	      }
	
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'QuickPromotionModal',
	        className: (0, _classnames2.default)('QuickPromotionModal', {
	          'with-banner': this.props.promotion.getImageType() === _QuickPromotionConstants.ImageTypes.BANNER
	        }),
	        size: 'xsmall',
	        hideCloseButton: true,
	        hideOnTransition: false,
	        hideOnBlur: false,
	        title: this.props.promotion.getHeader(),
	        subtext: this.props.promotion.getBody(),
	        image: this.props.promotion.getImageUrl(),
	        actionButtonText: this.props.promotion.getPrimaryAction().getLabel(),
	        hideCancel: !secondaryButton,
	        cancelButtonText: secondaryButtonText,
	        imageSize: 'large',
	        onConfirm: this.onConfirm,
	        onCancel: this.onCancel,
	        onRequestHide: this.props.onRequestHide
	      });
	    }
	  }]);
	
	  return QuickPromotionModal;
	}(_react.Component);
	
	QuickPromotionModal.childContextTypes = {
	  eventScreenName: _react2.default.PropTypes.string,
	  eventProperties: _react2.default.PropTypes.object
	};
	QuickPromotionModal.displayName = 'QuickPromotionModal';
	exports.default = QuickPromotionModal;

/***/ },
/* 2497 */
1136,
/* 2498 */,
/* 2499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BannersContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _banners = __webpack_require__(2500);
	
	var _redux = __webpack_require__(476);
	
	var _banners2 = __webpack_require__(2506);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* The banner containers is there to manage banners.
	 * We only want to show one banner at a time, to orchestrate this
	 * the banner container uses a prioritize queue in a form of a redux store.
	 *
	 * Here's an example of a banner that would display for 5 seconds:
	 *
	 * class SomeBanner extends React.Component {
	 *   props = {
	 *     authorized: boolean,
	 *     requestAuthorization: Function,
	 *     releaseAuthorization: Function,
	 *   }
	 *
	 *   componentDidMount() {
	 *     this.props.requestAuthorization();
	 *     setTimeout(this.props.releaseAuthorization, 5000);
	 *   }
	 *
	 *   render() {
	 *     if (!this.props.authorized) {
	 *       return null;
	 *     }
	 *
	 *     return <Banner>some banner</Banner>;
	 *   }
	 * }
	 *
	 * Banner can listen to whatever store(s) they wish to. If so,
	 * you usually want to call the authorization functions from the
	 * componentDidUpdate hooks, looking at the new values from the stores.
	 */
	
	var HIGH_PRIORITY = 0;
	var NORMAL_PRIORITY = 1; // eslint-disable-line
	
	var BannersContainer = function (_React$Component) {
	  _inherits(BannersContainer, _React$Component);
	
	  function BannersContainer() {
	    _classCallCheck(this, BannersContainer);
	
	    return _possibleConstructorReturn(this, (BannersContainer.__proto__ || Object.getPrototypeOf(BannersContainer)).apply(this, arguments));
	  }
	
	  _createClass(BannersContainer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { 'data-test': 'banners-container' },
	        _react2.default.createElement(_banners.ConnectionStateBanner, {
	          authorized: this.props.queueHead === 'connection_state_banner',
	          requestAuthorization: function requestAuthorization() {
	            return _this2.props.enqueue('connection_state_banner', HIGH_PRIORITY);
	          },
	          releaseAuthorization: function releaseAuthorization() {
	            return _this2.props.dequeue('connection_state_banner');
	          }
	        })
	      );
	    }
	  }]);
	
	  return BannersContainer;
	}(_react2.default.Component);
	
	BannersContainer.displayName = 'BannersContainer';
	
	
	function mapStateToProps(state) {
	  return {
	    queueHead: state.banners.queueHead
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ enqueue: _banners2.enqueue, dequeue: _banners2.dequeue }, dispatch);
	}
	
	exports.BannersContainer = BannersContainer;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BannersContainer);

/***/ },
/* 2500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ConnectionStateBanner = undefined;
	
	var _ConnectionStateBanner = __webpack_require__(2501);
	
	var _ConnectionStateBanner2 = _interopRequireDefault(_ConnectionStateBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ConnectionStateBanner = _ConnectionStateBanner2.default;

/***/ },
/* 2501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _redux = __webpack_require__(476);
	
	var _connectionStateBanner = __webpack_require__(2502);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Banner = __webpack_require__(2503);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ConnectionState = __webpack_require__(2251);
	
	var _ConnectionState2 = _interopRequireDefault(_ConnectionState);
	
	var _PusherActions = __webpack_require__(953);
	
	var _PusherActions2 = _interopRequireDefault(_PusherActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SNOOZE_MS = 5 * 60 * 1000;
	
	var ConnectionStateBanner = function (_React$Component) {
	  _inherits(ConnectionStateBanner, _React$Component);
	
	  function ConnectionStateBanner() {
	    _classCallCheck(this, ConnectionStateBanner);
	
	    return _possibleConstructorReturn(this, (ConnectionStateBanner.__proto__ || Object.getPrototypeOf(ConnectionStateBanner)).apply(this, arguments));
	  }
	
	  _createClass(ConnectionStateBanner, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var gotSnoozed = !prevProps.snoozedAt && this.props.snoozedAt;
	      var gotDisconnected = prevState.isConnected && !this.state.isConnected;
	      var gotReconnected = !prevState.isConnected && this.state.isConnected;
	
	      var isSnoozed = this.props.snoozedAt && this.props.snoozedAt.getTime() + SNOOZE_MS > new Date().getTime();
	
	      if (gotSnoozed || gotReconnected) {
	        this.props.releaseAuthorization();
	        return;
	      }
	
	      if (gotDisconnected && !isSnoozed) {
	        this.props.wakeup();
	        this.props.requestAuthorization();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.authorized) {
	        return null;
	      }
	
	      var message = void 0;
	
	      if (this.state.hasRetriedConnection) {
	        message = _react2.default.createElement(
	          'span',
	          null,
	          'Please test your internet connection and',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: _PusherActions2.default.retryConnection },
	            'try again'
	          ),
	          '!'
	        );
	      } else if (this.state.isConnecting) {
	        message = _react2.default.createElement(
	          'span',
	          null,
	          'One second while we try to reconnect\u2026'
	        );
	      } else {
	        message = _react2.default.createElement(
	          'span',
	          null,
	          'Uh-oh, we\u2019re unable to connect.',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: _PusherActions2.default.retryConnection },
	            'Retry'
	          ),
	          '.'
	        );
	      }
	
	      return _react2.default.createElement(
	        _Banner2.default,
	        { type: 'warning', size: 'normal', onClose: this.props.snooze },
	        _react2.default.createElement(_Glyph2.default, { name: 'caution', size: 'large' }),
	        message
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ConnectionState2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        isConnected: _ConnectionState2.default.isConnected(),
	        isConnecting: _ConnectionState2.default.isConnecting(),
	        hasRetriedConnection: _ConnectionState2.default.hasRetriedConnection()
	      };
	    }
	  }]);
	
	  return ConnectionStateBanner;
	}(_react2.default.Component);
	
	ConnectionStateBanner.displayName = 'ConnectionStateBanner';
	
	
	function mapStateToProps(state) {
	  return {
	    snoozedAt: state.connectionStateBanner.snoozedAt
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ snooze: _connectionStateBanner.snooze, wakeup: _connectionStateBanner.wakeup }, dispatch);
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_utils.Container.create(ConnectionStateBanner, { withProps: true }));

/***/ },
/* 2502 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.snooze = snooze;
	exports.wakeup = wakeup;
	var initialState = exports.initialState = {
	  snoozedAt: null
	};
	
	// typecheck: ignore statement
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'connectionStateBanner/SNOOZE':
	      return _extends({}, state, { snoozedAt: action.snoozedAt });
	    case 'connectionStateBanner/WAKEUP':
	      return _extends({}, state, { snoozedAt: null });
	    default:
	      return state;
	  }
	}
	
	function snooze() {
	  return {
	    type: 'connectionStateBanner/SNOOZE',
	    snoozedAt: new Date()
	  };
	}
	
	function wakeup() {
	  return {
	    type: 'connectionStateBanner/WAKEUP'
	  };
	}

/***/ },
/* 2503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(2504);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Banner = function (_React$Component) {
	  _inherits(Banner, _React$Component);
	
	  function Banner() {
	    _classCallCheck(this, Banner);
	
	    return _possibleConstructorReturn(this, (Banner.__proto__ || Object.getPrototypeOf(Banner)).apply(this, arguments));
	  }
	
	  _createClass(Banner, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _FlexibleBlock2.default,
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('Banner', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className),
	          flex: 'left' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'Banner-content' },
	          this.props.children
	        ),
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'Banner-closeButton',
	            color: 'white',
	            onClick: this.props.onClose,
	            eventElementName: 'Banner-closeButton' },
	          _react2.default.createElement(_Glyph2.default, { name: 'close', size: 'medium', solo: true })
	        )
	      );
	    }
	  }]);
	
	  return Banner;
	}(_react2.default.Component);
	
	Banner.propClasses = {
	  type: {
	    warning: 'Banner-typeWarning',
	    nux: 'Banner-typeNux'
	  },
	  size: {
	    small: 'Banner-sizeSmall'
	  }
	};
	Banner.displayName = 'Banner';
	exports.default = Banner;

/***/ },
/* 2504 */
1136,
/* 2505 */,
/* 2506 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.enqueue = enqueue;
	exports.dequeue = dequeue;
	var initialState = exports.initialState = {
	  queue: new Map(),
	  queueHead: null
	};
	
	function computeQueueHead(queue) {
	  if (queue.size === 0) {
	    return null;
	  }
	
	  if (queue.size === 1) {
	    return queue.keys().next().value;
	  }
	
	  // $FlowIssue
	  return Array.from(queue).sort(function (a, b) {
	    return a[1] > b[1];
	  })[0][0];
	}
	
	// typecheck: ignore statement
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'banners/ENQUEUE':
	      state.queue.set(action.bannerName, action.priority);
	      return _extends({}, state, { queue: state.queue, queueHead: computeQueueHead(state.queue) });
	    case 'banners/DEQUEUE':
	      state.queue.delete(action.bannerName);
	      return _extends({}, state, { queue: state.queue, queueHead: computeQueueHead(state.queue) });
	    default:
	      return state;
	  }
	}
	
	function enqueue(bannerName, priority) {
	  return {
	    type: 'banners/ENQUEUE',
	    bannerName: bannerName,
	    priority: priority
	  };
	}
	
	function dequeue(bannerName) {
	  return {
	    type: 'banners/DEQUEUE',
	    bannerName: bannerName
	  };
	}

/***/ },
/* 2507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Leads = __webpack_require__(1023);
	
	var _Leads2 = _interopRequireDefault(_Leads);
	
	var _LeadStore = __webpack_require__(1024);
	
	var _LeadStore2 = _interopRequireDefault(_LeadStore);
	
	var _mountTymkPrompt = __webpack_require__(1464);
	
	var _mountTymkPrompt2 = _interopRequireDefault(_mountTymkPrompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TymkRegistrationModals = function (_React$Component) {
	  _inherits(TymkRegistrationModals, _React$Component);
	
	  function TymkRegistrationModals() {
	    _classCallCheck(this, TymkRegistrationModals);
	
	    return _possibleConstructorReturn(this, (TymkRegistrationModals.__proto__ || Object.getPrototypeOf(TymkRegistrationModals)).apply(this, arguments));
	  }
	
	  _createClass(TymkRegistrationModals, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkForPrompts();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.checkForPrompts();
	    }
	  }, {
	    key: 'checkForPrompts',
	    value: function checkForPrompts() {
	      var leads = this.state.leads;
	
	
	      if (leads.length > 0 && _CurrentUser2.default.didSetupAndJoinClassThisSession()) {
	        (0, _mountTymkPrompt2.default)(this, 'onboarding', true);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_LeadStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        leads: _LeadStore2.default.getLeads()
	      };
	    }
	  }]);
	
	  return TymkRegistrationModals;
	}(_react2.default.Component);
	
	TymkRegistrationModals.displayName = 'TymkRegistrationModals';
	exports.default = _utils.Container.create(TymkRegistrationModals, { pure: false });

/***/ },
/* 2508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _TeacherInfoCollection = __webpack_require__(2509);
	
	var _TeacherInfoCollection2 = _interopRequireDefault(_TeacherInfoCollection);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileCompletenessModals = function (_React$Component) {
	  _inherits(ProfileCompletenessModals, _React$Component);
	
	  function ProfileCompletenessModals() {
	    _classCallCheck(this, ProfileCompletenessModals);
	
	    return _possibleConstructorReturn(this, (ProfileCompletenessModals.__proto__ || Object.getPrototypeOf(ProfileCompletenessModals)).apply(this, arguments));
	  }
	
	  _createClass(ProfileCompletenessModals, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.checkForPrompts();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.checkForPrompts();
	    }
	  }, {
	    key: 'checkForPrompts',
	    value: function checkForPrompts() {
	      var modalBody = void 0;
	      if (_PromptStore2.default.getAvailable(_PromptConstants.PromptNames.TEACHER_INFO_COLLECTION)) {
	        modalBody = _react2.default.createElement(_TeacherInfoCollection2.default, null);
	      }
	
	      if (modalBody) {
	        var modal = _react2.default.createElement(
	          _Dialog2.default,
	          { size: 'xlarge' },
	          modalBody
	        );
	        (0, _modal.mountModal)(modal, this);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ProfileCompletenessModals;
	}(_react2.default.Component);
	
	ProfileCompletenessModals.displayName = 'ProfileCompletenessModals';
	exports.default = ProfileCompletenessModals;

/***/ },
/* 2509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _SchoolPicker = __webpack_require__(2510);
	
	var _SchoolPicker2 = _interopRequireDefault(_SchoolPicker);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	__webpack_require__(2524);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SCREEN_NAME = 'teacher_info_collection';
	
	var TeacherInfoCollection = function (_React$Component) {
	  _inherits(TeacherInfoCollection, _React$Component);
	
	  function TeacherInfoCollection() {
	    _classCallCheck(this, TeacherInfoCollection);
	
	    return _possibleConstructorReturn(this, (TeacherInfoCollection.__proto__ || Object.getPrototypeOf(TeacherInfoCollection)).apply(this, arguments));
	  }
	
	  _createClass(TeacherInfoCollection, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventScreenName: SCREEN_NAME
	      };
	    }
	  }, {
	    key: 'selectSchool',
	    value: function selectSchool(group, organizationId) {
	      _GroupActions2.default.patch(group, { organization_id: organizationId });
	    }
	  }, {
	    key: 'renderTableHeader',
	    value: function renderTableHeader() {
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          'Class'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Class is at'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Grade(s)'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Subject'
	        )
	      );
	    }
	  }, {
	    key: 'renderTableRow',
	    value: function renderTableRow(group) {
	      var schoolSuggestions = _AffiliationStore2.default.getMemberOrganizations();
	      if (!group.hasChildren()) {
	        schoolSuggestions.push(_OrganizationConstants.UNAFFILIATED);
	      }
	      return _react2.default.createElement(
	        'tr',
	        { key: group.id },
	        _react2.default.createElement(
	          'th',
	          null,
	          _react2.default.createElement(_GroupAvatar2.default, { group: group, size: 'small' }),
	          _react2.default.createElement(
	            _Text2.default,
	            { className: 'TeacherInfoCollection-groupName', truncate: true },
	            _react2.default.createElement(_GroupName2.default, { group: group })
	          )
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          _react2.default.createElement(_SchoolPicker2.default, {
	            onSelect: this.selectSchool.bind(this, group),
	            onClear: function onClear() {},
	            suggestions: schoolSuggestions,
	            selectedSchool: group.getOrganization() || _OrganizationConstants.UNAFFILIATED
	          })
	        ),
	        _react2.default.createElement('th', null),
	        _react2.default.createElement('th', null)
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      var groups = _GroupStore2.default.getOwnedGroups().map(function (group) {
	        return _this2.renderTableRow(group);
	      });
	      return _react2.default.createElement(
	        'table',
	        { className: 'TeacherInfoCollection-table' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          this.renderTableHeader()
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          groups
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(_TitleHeader2.default, {
	          title: 'Update your class information',
	          subtext: 'Make sure you have the correct school, grade and subject for each class'
	        }),
	        this.renderTable()
	      );
	    }
	  }]);
	
	  return TeacherInfoCollection;
	}(_react2.default.Component);
	
	TeacherInfoCollection.childContextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	TeacherInfoCollection.displayName = 'TeacherInfoCollection';
	exports.default = TeacherInfoCollection;

/***/ },
/* 2510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _i18n = __webpack_require__(1018);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	var _AsyncSelect = __webpack_require__(2374);
	
	var _AsyncSelect2 = _interopRequireDefault(_AsyncSelect);
	
	var _AsyncSelectItem = __webpack_require__(2377);
	
	var _AsyncSelectItem2 = _interopRequireDefault(_AsyncSelectItem);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _OrganizationCreateModal = __webpack_require__(2511);
	
	var _OrganizationCreateModal2 = _interopRequireDefault(_OrganizationCreateModal);
	
	var _OrganizationProfiles = __webpack_require__(2515);
	
	var _OrganizationProfiles2 = _interopRequireDefault(_OrganizationProfiles);
	
	var _Organizations = __webpack_require__(1002);
	
	var _Organizations2 = _interopRequireDefault(_Organizations);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _SchoolColleaguesRow = __webpack_require__(2521);
	
	var _SchoolColleaguesRow2 = _interopRequireDefault(_SchoolColleaguesRow);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	var _modal = __webpack_require__(1188);
	
	__webpack_require__(2522);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ORGANIZATIONS_PAGE_SIZE = 20;
	
	var CREATE_SCHOOL_ITEM = -1;
	var DEBOUNCE_DELAY = 300;
	
	// TODO rename to OrganizationPicker
	var SchoolPicker = _react2.default.createClass({
	  displayName: 'SchoolPicker',
	
	
	  contextTypes: {
	    eventScreenName: _react2.default.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      organizationType: _OrganizationConstants.OrganizationTypes.SCHOOL
	    };
	  },
	  getInitialState: function getInitialState() {
	    var user = _CurrentUser2.default.getUser();
	    // why do we need to test `user.worksAtASchool()` when `this.props.schoolId` says NO_SCHOOL?
	    var noSchool = user && user.worksAtASchool() === false && this.props.schoolId === _OrganizationConstants.NO_SCHOOL.id;
	    return {
	      defaultSchool: noSchool ? _OrganizationConstants.NO_SCHOOL : null,
	      allPotentialSchoolsLoaded: false,
	      loadedSchools: [],
	      query: ''
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.selectedSchool) {
	      this.setState({ defaultSchool: this.props.selectedSchool });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    if (this.props.schoolId && !this.state.defaultSchool) {
	      _OrganizationActions2.default.getOrLoadOrganization(this.props.schoolId).then(function (school) {
	        _this.setState({ defaultSchool: school });
	      });
	    }
	  },
	  onClear: function onClear() {
	    this.setState(this.getInitialState(), this.props.onClear);
	  },
	  onCreateOrganization: function onCreateOrganization(organization) {
	    var _this2 = this;
	
	    _OrganizationActions2.default.addOrganization(organization);
	    if (this.isMounted()) {
	      this.setState({ defaultSchool: organization }, function () {
	        _this2.props.onCreateOrganization(organization);
	      });
	    } else {
	      this.props.onCreateOrganization(organization);
	    }
	    _EventTracking2.default.tap(this.context.eventScreenName, 'SchoolPicker-createSchool', '', { query: this.state.query });
	  },
	  onNoSchool: function onNoSchool() {
	    var _this3 = this;
	
	    _EventTracking2.default.tap(this.context.eventScreenName, 'dontWorkButton', '', { query: this.state.query });
	    this.setState({ defaultSchool: _OrganizationConstants.NO_SCHOOL }, function () {
	      if (typeof _this3.props.onNoSchool !== 'undefined') {
	        _this3.props.onNoSchool();
	      }
	    });
	  },
	
	
	  onSearchCallback: (0, _lodash.debounce)(function (query, callback) {
	    if (!query) {
	      return callback(new Promise(function (resolve) {
	        return resolve([]);
	      }));
	    }
	    _EventTracking2.default.tap(this.context.eventScreenName, 'SchoolPicker-search');
	    while (this.state.allPotentialSchoolsLoaded !== true) {
	      return this.performSearch(query, callback);
	    }
	  }, DEBOUNCE_DELAY),
	
	  onSelect: function onSelect(item) {
	    if (!item.props) {
	      return;
	    }
	    var key = item.props.id;
	    this.setState({ defaultSchool: null });
	
	    if (key === CREATE_SCHOOL_ITEM) {
	      (0, _modal.mountModal)(this.getOrganizationCreateModal(), this);
	    } else {
	      if (key === _OrganizationConstants.NO_SCHOOL.id && this.props.onNoSchool) {
	        this.onNoSchool();
	      }
	      this.props.onSelect(key, item.props.title);
	    }
	    _EventTracking2.default.tap(this.context.eventScreenName, 'SchoolPicker-select', { key: key });
	  },
	  getOrganizationCreateModal: function getOrganizationCreateModal() {
	    return _react2.default.createElement(_OrganizationCreateModal2.default, {
	      onCreate: this.onCreateOrganization,
	      defaultOrganization: this.refs.schools.getSearchString(),
	      organizationType: this.props.organizationType
	    });
	  },
	  getSearchRequest: function getSearchRequest(query) {
	    var source = _CurrentUser2.default.isSignedIn() ? _Organizations2.default : _OrganizationProfiles2.default;
	
	    var numLoaded = this.state.loadedSchools.length;
	    var page = Math.floor(numLoaded / ORGANIZATIONS_PAGE_SIZE) + 1;
	
	    return source.search(this.props.organizationType, query, page);
	  },
	  focus: function focus() {
	    this.refs.schools.focus();
	  },
	  performSearch: function performSearch(query, callback) {
	    var _this4 = this;
	
	    callback(this.getSearchRequest(query).then(function (organizations) {
	      var filteredOrgs = _this4.props.filterSearchResults ? _this4.props.filterSearchResults(organizations.toArray()) : organizations;
	
	      var schools = _this4.state.loadedSchools;
	
	      if (filteredOrgs.length < ORGANIZATIONS_PAGE_SIZE) {
	        _this4.setState({ allPotentialSchoolsLoaded: true });
	      }
	
	      filteredOrgs.forEach(function (organization) {
	        schools.push(organization);
	        _OrganizationActions2.default.addOrganization(organization);
	      });
	      _this4.setState({ query: query, loadedSchools: schools });
	
	      return schools.map(_this4.renderItemFromSchool);
	    }));
	  },
	  initialItems: function initialItems() {
	    return this.props.suggestions && this.props.suggestions.map(this.renderItemFromSchool);
	  },
	  permanentItems: function permanentItems() {
	    var permanentItems = [];
	
	    // If there's no callback to the create school
	    // then we don't show the last permanent result.
	    if (this.props.onCreateOrganization) {
	      permanentItems.push(_react2.default.createElement(
	        _AsyncSelectItem2.default,
	        { id: CREATE_SCHOOL_ITEM, title: '' },
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolPicker-item SchoolPicker-item--perma SchoolPicker-new' },
	          'Can\u2019t find your ',
	          this.props.organizationType.toLowerCase(),
	          '?',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { weight: 'semibold' },
	            'Add it now'
	          )
	        )
	      ));
	    }
	
	    if (this.props.onNoSchool) {
	      permanentItems.push(_react2.default.createElement(
	        _AsyncSelectItem2.default,
	        { id: _OrganizationConstants.NO_SCHOOL.id, title: _OrganizationConstants.NO_SCHOOL.getName() },
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolPicker-item SchoolPicker-item--perma SchoolPicker-none' },
	          _react2.default.createElement(
	            _Link2.default,
	            { weight: 'semibold' },
	            'I don\u2019t work at a school'
	          )
	        )
	      ));
	    }
	
	    return permanentItems;
	  },
	  renderItemFromSchool: function renderItemFromSchool(organization) {
	    if (organization === _OrganizationConstants.NO_SCHOOL) {
	      return this.renderNoSchool();
	    }
	
	    var address = organization.getFormattedAddress();
	
	    var body = _react2.default.createElement(
	      'div',
	      { className: 'SchoolPicker-item' },
	      _react2.default.createElement(
	        'div',
	        { className: 'SchoolPicker-item-title' },
	        organization.getName()
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'SchoolPicker-item-body' },
	        _react2.default.createElement(
	          'address',
	          null,
	          address
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.showNCESId ? organization.getNCESId() && 'NCES ID: ' + organization.getNCESId() : _react2.default.createElement(_SchoolColleaguesRow2.default, { school: organization })
	        )
	      )
	    );
	
	    return _react2.default.createElement(
	      _AsyncSelectItem2.default,
	      { id: organization.id, title: organization.getName() },
	      body
	    );
	  },
	  renderNoSchool: function renderNoSchool() {
	    var body = _react2.default.createElement(
	      'div',
	      { className: 'SchoolPicker-item' },
	      _react2.default.createElement(
	        'div',
	        { className: 'SchoolPicker-item-title' },
	        _OrganizationConstants.NO_SCHOOL.getName()
	      )
	    );
	
	    return _react2.default.createElement(
	      _AsyncSelectItem2.default,
	      { id: _OrganizationConstants.NO_SCHOOL.id, title: _OrganizationConstants.NO_SCHOOL.getName() },
	      body
	    );
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        others = _objectWithoutProperties(_props, ['className']);
	
	    var minQuery = _SettingsStore2.default.getMinimumOrgQueryLength();
	
	    var schoolItem = void 0;
	    if (this.state.defaultSchool) {
	      schoolItem = this.renderItemFromSchool(this.state.defaultSchool);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('SchoolPicker', className) },
	      _react2.default.createElement(
	        'div',
	        { className: 'SchoolPicker-AsyncWrapper' },
	        _react2.default.createElement(_AsyncSelect2.default, _extends({}, others, {
	          ref: 'schools',
	          clearOnInputChange: true,
	          infiniteLoad: true,
	          inputDelay: 500,
	          defaultItem: schoolItem,
	          initialItems: this.initialItems(),
	          searchCallback: this.onSearchCallback,
	          onSelect: this.onSelect,
	          onClear: this.onClear,
	          permanentItems: this.permanentItems(),
	          queryMinSize: minQuery,
	          noQuery: this.props.noQuery,
	          queryTooShort: _i18n2.default.getText('Enter a minimum of {minQuery, plural, one {# character} other {# characters}}' + ' to search for your school', { minQuery: minQuery })
	        }))
	      )
	    );
	  }
	});
	
	exports.default = SchoolPicker;

/***/ },
/* 2511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormSelect = __webpack_require__(1365);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _USState = __webpack_require__(2512);
	
	var _USState2 = _interopRequireDefault(_USState);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	__webpack_require__(2513);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var OrganizationCreateModal = function (_React$Component) {
	  _inherits(OrganizationCreateModal, _React$Component);
	
	  function OrganizationCreateModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OrganizationCreateModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrganizationCreateModal.__proto__ || Object.getPrototypeOf(OrganizationCreateModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      canSubmit: false
	    }, _this.disableButton = function () {
	      _this.setState({ canSubmit: false });
	    }, _this.enableButton = function () {
	      _this.setState({ canSubmit: true });
	    }, _this.submit = function (values) {
	      values.type = (0, _lodash.capitalize)(_this.props.organizationType.toLowerCase());
	      _OrganizationActions2.default.createOrganization(values).then(function (organization) {
	        _this.props.onRequestHide();
	        _this.props.onCreate(organization);
	      }, _ToastActions2.default.showAPIError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OrganizationCreateModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'OrganizationCreateModal'
	        }, this.props, {
	          title: 'Add your ' + this.props.organizationType.toLowerCase(),
	          size: 'small',
	          className: 'OrganizationCreateModal' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            _Form2.default,
	            {
	              onValidSubmit: this.submit,
	              onValid: this.enableButton,
	              onInvalid: this.disableButton },
	            _react2.default.createElement(
	              'div',
	              { className: 'OrganizationCreateModal-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'OrganizationCreateModal-item full' },
	                _react2.default.createElement(_FormInput2.default, {
	                  label: (0, _lodash.capitalize)(this.props.organizationType.toLowerCase()) + ' name',
	                  value: this.props.defaultOrganization,
	                  name: 'name',
	                  required: true,
	                  validationErrors: {
	                    isDefaultRequiredValue: 'Your school name is required.'
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'OrganizationCreateModal-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'OrganizationCreateModal-item full' },
	                _react2.default.createElement(_FormInput2.default, {
	                  label: 'City',
	                  name: 'city',
	                  required: true,
	                  validationErrors: {
	                    isDefaultRequiredValue: 'Your city is required.'
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'OrganizationCreateModal-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'OrganizationCreateModal-item full' },
	                _react2.default.createElement(_FormSelect2.default, {
	                  label: 'State',
	                  name: 'state',
	                  required: true,
	                  validationErrors: {
	                    isDefaultRequiredValue: 'Please select a state'
	                  },
	                  options: _USState2.default
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: 'OrganizationCreateModal-submit',
	                disabled: !this.state.canSubmit,
	                eventElementName: 'OrganizationCreateModal-submit' },
	              'Save'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrganizationCreateModal;
	}(_react2.default.Component);
	
	OrganizationCreateModal.defaultProps = {
	  organizationType: _OrganizationConstants.OrganizationTypes.SCHOOL
	};
	OrganizationCreateModal.displayName = 'OrganizationCreateModal';
	exports.default = OrganizationCreateModal;

/***/ },
/* 2512 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	exports.default = [{ value: 'AL', label: 'Alabama' }, { value: 'AK', label: 'Alaska' }, { value: 'AZ', label: 'Arizona' }, { value: 'AR', label: 'Arkansas' }, { value: 'CA', label: 'California' }, { value: 'CO', label: 'Colorado' }, { value: 'CT', label: 'Connecticut' }, { value: 'DE', label: 'Delaware' }, { value: 'DC', label: 'District Of Columbia' }, { value: 'FL', label: 'Florida' }, { value: 'GA', label: 'Georgia' }, { value: 'HI', label: 'Hawaii' }, { value: 'ID', label: 'Idaho' }, { value: 'IL', label: 'Illinois' }, { value: 'IN', label: 'Indiana' }, { value: 'IA', label: 'Iowa' }, { value: 'KS', label: 'Kansas' }, { value: 'KY', label: 'Kentucky' }, { value: 'LA', label: 'Louisiana' }, { value: 'ME', label: 'Maine' }, { value: 'MD', label: 'Maryland' }, { value: 'MA', label: 'Massachusetts' }, { value: 'MI', label: 'Michigan' }, { value: 'MN', label: 'Minnesota' }, { value: 'MS', label: 'Mississippi' }, { value: 'MO', label: 'Missouri' }, { value: 'MT', label: 'Montana' }, { value: 'NE', label: 'Nebraska' }, { value: 'NV', label: 'Nevada' }, { value: 'NH', label: 'New Hampshire' }, { value: 'NJ', label: 'New Jersey' }, { value: 'NM', label: 'New Mexico' }, { value: 'NY', label: 'New York' }, { value: 'NC', label: 'North Carolina' }, { value: 'ND', label: 'North Dakota' }, { value: 'OH', label: 'Ohio' }, { value: 'OK', label: 'Oklahoma' }, { value: 'OR', label: 'Oregon' }, { value: 'PA', label: 'Pennsylvania' }, { value: 'RI', label: 'Rhode Island' }, { value: 'SC', label: 'South Carolina' }, { value: 'SD', label: 'South Dakota' }, { value: 'TN', label: 'Tennessee' }, { value: 'TX', label: 'Texas' }, { value: 'UT', label: 'Utah' }, { value: 'VT', label: 'Vermont' }, { value: 'VA', label: 'Virginia' }, { value: 'WA', label: 'Washington' }, { value: 'WV', label: 'West Virginia' }, { value: 'WI', label: 'Wisconsin' }, { value: 'WY', label: 'Wyoming' }];

/***/ },
/* 2513 */
1136,
/* 2514 */,
/* 2515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _OrganizationProfile = __webpack_require__(2516);
	
	var _OrganizationProfile2 = _interopRequireDefault(_OrganizationProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationProfiles = function (_Collection) {
	  _inherits(OrganizationProfiles, _Collection);
	
	  function OrganizationProfiles() {
	    _classCallCheck(this, OrganizationProfiles);
	
	    return _possibleConstructorReturn(this, (OrganizationProfiles.__proto__ || Object.getPrototypeOf(OrganizationProfiles)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationProfiles, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _OrganizationProfile2.default;
	    }
	  }], [{
	    key: 'search',
	    value: function search(queryType, query, page, perPage) {
	      var options = {
	        query: query,
	        page: page || 1,
	        per_page: perPage || 20
	      };
	
	      return (0, _apiRequest2.default)('/organization_profiles', 'GET', options).then(function (response) {
	        return OrganizationProfiles.fromJSON(response);
	      });
	    }
	  }]);
	
	  return OrganizationProfiles;
	}(_Collection3.default);
	
	OrganizationProfiles.displayName = 'OrganizationProfiles';
	exports.default = OrganizationProfiles;

/***/ },
/* 2516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _OrganizationProfileTeachers = __webpack_require__(2517);
	
	var _OrganizationProfileTeachers2 = _interopRequireDefault(_OrganizationProfileTeachers);
	
	var _capitalize = __webpack_require__(1617);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _lodash = __webpack_require__(555);
	
	var _Organization2 = __webpack_require__(999);
	
	var _Organization3 = _interopRequireDefault(_Organization2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A subset of properties of Organization, from an unauthenticated data source
	 */
	var OrganizationProfile = function (_Organization) {
	  _inherits(OrganizationProfile, _Organization);
	
	  function OrganizationProfile() {
	    _classCallCheck(this, OrganizationProfile);
	
	    return _possibleConstructorReturn(this, (OrganizationProfile.__proto__ || Object.getPrototypeOf(OrganizationProfile)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationProfile, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.urlRoot = '/organization_profiles';
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var organizationProfile = (0, _lodash.cloneDeep)(response);
	      organizationProfile['teachers'] = _OrganizationProfileTeachers2.default.fromJSON(organizationProfile['teachers']);
	      return organizationProfile;
	    }
	  }, {
	    key: 'getStreet',
	    value: function getStreet() {
	      return this.get('street');
	    }
	  }, {
	    key: 'getCity',
	    value: function getCity() {
	      return this.get('city');
	    }
	  }, {
	    key: 'getState',
	    value: function getState() {
	      return this.get('state');
	    }
	  }, {
	    key: 'getZip',
	    value: function getZip() {
	      return this.get('zip');
	    }
	  }, {
	    key: 'getFormattedAddress',
	    value: function getFormattedAddress() {
	      return [this.getCity(), this.getState()].filter(function (value) {
	        return value;
	      }).join(', ');
	    }
	  }, {
	    key: 'getAddressObject',
	    value: function getAddressObject() {
	      return {
	        line1: this.getStreet(),
	        line2: [this.getCity(), this.getState(), this.getZip()].filter(function (value) {
	          return value;
	        }).join(', ')
	      };
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('type');
	    }
	  }, {
	    key: 'getSubType',
	    value: function getSubType() {
	      return this.get('subtype');
	    }
	  }, {
	    key: 'getSubSubType',
	    value: function getSubSubType() {
	      return this.get('subsubtype');
	    }
	  }, {
	    key: 'getFormattedType',
	    value: function getFormattedType() {
	      return (0, _capitalize2.default)(this.getSubType()) + ' ' + (this.getSubSubType() || '');
	    }
	  }, {
	    key: 'getGradeLevel',
	    value: function getGradeLevel() {
	      return this.get('grade_level');
	    }
	  }, {
	    key: 'getDistrictName',
	    value: function getDistrictName() {
	      return this.get('district_name');
	    }
	  }, {
	    key: 'getLatitude',
	    value: function getLatitude() {
	      return this.get('latitude');
	    }
	  }, {
	    key: 'getLongitude',
	    value: function getLongitude() {
	      return this.get('longitude');
	    }
	  }, {
	    key: 'getTeachers',
	    value: function getTeachers() {
	      return this.get('teachers');
	    }
	
	    // quack like an Organization
	
	  }, {
	    key: 'getMemberSampleString',
	    value: function getMemberSampleString() {
	      return '';
	    }
	  }, {
	    key: 'getMemberCount',
	    value: function getMemberCount() {
	      return 0;
	    }
	  }, {
	    key: 'getAdmins',
	    value: function getAdmins() {
	      return [];
	    }
	  }]);
	
	  return OrganizationProfile;
	}(_Organization3.default);
	
	OrganizationProfile.displayName = 'OrganizationProfile';
	exports.default = OrganizationProfile;

/***/ },
/* 2517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _OrganizationProfileTeacher = __webpack_require__(2518);
	
	var _OrganizationProfileTeacher2 = _interopRequireDefault(_OrganizationProfileTeacher);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationProfileTeachers = function (_Collection) {
	  _inherits(OrganizationProfileTeachers, _Collection);
	
	  function OrganizationProfileTeachers() {
	    _classCallCheck(this, OrganizationProfileTeachers);
	
	    return _possibleConstructorReturn(this, (OrganizationProfileTeachers.__proto__ || Object.getPrototypeOf(OrganizationProfileTeachers)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationProfileTeachers, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _OrganizationProfileTeacher2.default;
	    }
	  }]);
	
	  return OrganizationProfileTeachers;
	}(_Collection3.default);
	
	OrganizationProfileTeachers.displayName = 'OrganizationProfileTeachers';
	exports.default = OrganizationProfileTeachers;

/***/ },
/* 2518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _GroupClusterItems = __webpack_require__(2519);
	
	var _GroupClusterItems2 = _interopRequireDefault(_GroupClusterItems);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrganizationProfileTeacher = function (_Entity) {
	  _inherits(OrganizationProfileTeacher, _Entity);
	
	  function OrganizationProfileTeacher() {
	    _classCallCheck(this, OrganizationProfileTeacher);
	
	    return _possibleConstructorReturn(this, (OrganizationProfileTeacher.__proto__ || Object.getPrototypeOf(OrganizationProfileTeacher)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationProfileTeacher, [{
	    key: 'parse',
	    value: function parse(response) {
	      var teacher = (0, _lodash.cloneDeep)(response);
	      teacher['owned_groups'] = _GroupClusterItems2.default.fromJSON(teacher['owned_groups']);
	      return teacher;
	    }
	  }, {
	    key: 'getSignature',
	    value: function getSignature() {
	      return this.get('signature');
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'groupClusterItems',
	    get: function get() {
	      return this.get('owned_groups');
	    }
	  }]);
	
	  return OrganizationProfileTeacher;
	}(_Entity3.default);
	
	OrganizationProfileTeacher.displayName = 'OrganizationProfileTeacher';
	exports.default = OrganizationProfileTeacher;

/***/ },
/* 2519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _GroupClusterItem = __webpack_require__(2520);
	
	var _GroupClusterItem2 = _interopRequireDefault(_GroupClusterItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupClusterItems = function (_Collection) {
	  _inherits(GroupClusterItems, _Collection);
	
	  function GroupClusterItems() {
	    _classCallCheck(this, GroupClusterItems);
	
	    return _possibleConstructorReturn(this, (GroupClusterItems.__proto__ || Object.getPrototypeOf(GroupClusterItems)).apply(this, arguments));
	  }
	
	  _createClass(GroupClusterItems, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _GroupClusterItem2.default;
	    }
	  }]);
	
	  return GroupClusterItems;
	}(_Collection3.default);
	
	GroupClusterItems.displayName = 'GroupClusterItems';
	exports.default = GroupClusterItems;

/***/ },
/* 2520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Avatar = __webpack_require__(933);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupClusterItem = function (_Entity) {
	  _inherits(GroupClusterItem, _Entity);
	
	  function GroupClusterItem() {
	    _classCallCheck(this, GroupClusterItem);
	
	    return _possibleConstructorReturn(this, (GroupClusterItem.__proto__ || Object.getPrototypeOf(GroupClusterItem)).apply(this, arguments));
	  }
	
	  _createClass(GroupClusterItem, [{
	    key: 'defaults',
	    value: function defaults() {
	      return {
	        group_avatar: null
	      };
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      if (response['group_avatar']) {
	        response['group_avatar'] = _Avatar2.default.fromJSON(response['group_avatar']);
	      }
	      return response;
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'avatarSvgUrl',
	    get: function get() {
	      var avatar = this.get('group_avatar');
	      return avatar ? avatar.get('svg_url') : null;
	    }
	  }]);
	
	  return GroupClusterItem;
	}(_Entity3.default);
	
	GroupClusterItem.displayName = 'GroupClusterItem';
	exports.default = GroupClusterItem;

/***/ },
/* 2521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchoolColleaguesRow = function (_Component) {
	  _inherits(SchoolColleaguesRow, _Component);
	
	  function SchoolColleaguesRow() {
	    _classCallCheck(this, SchoolColleaguesRow);
	
	    return _possibleConstructorReturn(this, (SchoolColleaguesRow.__proto__ || Object.getPrototypeOf(SchoolColleaguesRow)).apply(this, arguments));
	  }
	
	  _createClass(SchoolColleaguesRow, [{
	    key: 'render',
	    value: function render() {
	      var school = this.props.school;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'SchoolColleaguesRow' },
	        _react2.default.createElement(
	          _Text2.default,
	          { truncate: true },
	          school.getMemberSampleString()
	        )
	      );
	    }
	  }]);
	
	  return SchoolColleaguesRow;
	}(_react.Component);
	
	SchoolColleaguesRow.displayName = 'SchoolColleaguesRow';
	exports.default = SchoolColleaguesRow;

/***/ },
/* 2522 */
1136,
/* 2523 */,
/* 2524 */
1136,
/* 2525 */,
/* 2526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.markSeenClasses = exports.markAccountCreationStart = undefined;
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inProgress = false;
	var markAccountCreationStart = exports.markAccountCreationStart = function markAccountCreationStart(user) {
	  if (!inProgress) {
	    inProgress = true;
	    var role = user ? user.getUserSelectedRole() : null;
	    _EventTracking2.default.track('account.creation.start', { role: role });
	  }
	};
	
	var markSeenClasses = exports.markSeenClasses = function markSeenClasses(user) {
	  if (inProgress) {
	    var role = user.getUserSelectedRole();
	    _EventTracking2.default.track('account.creation.finish', { role: role });
	    inProgress = false;
	  }
	};

/***/ },
/* 2527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.serviceUnavailableInterceptor = serviceUnavailableInterceptor;
	exports.unauthorizedInterceptor = unauthorizedInterceptor;
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function serviceUnavailableInterceptor(response) {
	  if (response.statusCode === 503) {
	    _ToastActions2.default.showErrorToast('We are currently experiencing some technical issues. Try again later.');
	    return true;
	  }
	  return false;
	}
	
	function unauthorizedInterceptor(response) {
	  if (response.statusCode === 401) {
	    _AuthActions2.default.expireSession();
	    return true;
	  }
	  return false;
	}

/***/ },
/* 2528 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wolf":"#dcdee2","minWidth":"1000px","minHeight":"500px","sidebarWidth":"242px","this":"AppLayout__this___1edwK","bodyPadding":"AppLayout__bodyPadding___iF1ro","heightSetter":"AppLayout__heightSetter___2Ivas","banner":"AppLayout__banner___3DSsy","contentWrap":"AppLayout__contentWrap___1I-G_","sidebar":"AppLayout__sidebar___2X7rF","content":"AppLayout__content___28FgI"};

/***/ },
/* 2529 */,
/* 2530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _AppUpsellPage = __webpack_require__(2531);
	
	var _AppUpsellPage2 = _interopRequireDefault(_AppUpsellPage);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _JoinConfirmSubscriptionModal = __webpack_require__(2536);
	
	var _JoinConfirmSubscriptionModal2 = _interopRequireDefault(_JoinConfirmSubscriptionModal);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _modal = __webpack_require__(1188);
	
	var _accountCompletionTracker = __webpack_require__(2526);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppUpsellPageContainer = function (_React$Component) {
	  _inherits(AppUpsellPageContainer, _React$Component);
	
	  function AppUpsellPageContainer() {
	    _classCallCheck(this, AppUpsellPageContainer);
	
	    return _possibleConstructorReturn(this, (AppUpsellPageContainer.__proto__ || Object.getPrototypeOf(AppUpsellPageContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppUpsellPageContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (_CurrentUser2.default.isSignedIn()) {
	        var join = this.props.location.query.join;
	
	        if (join) {
	          (0, _modal.mountModal)(_react2.default.createElement(_JoinConfirmSubscriptionModal2.default, { code: join }), this);
	        }
	
	        _AuthActions2.default.setAuthTokenCookie();
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!_CurrentUser2.default.isSignedIn()) {
	        return;
	      }
	
	      if (this.context.router.location.query.path === '/classes') {
	        (0, _accountCompletionTracker.markSeenClasses)(_CurrentUser2.default.getUser());
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_AppUpsellPage2.default, {
	        group: this.state.group,
	        origin: this.context.router.location.query.origin || 'direct',
	        haveAppUrl: this.context.router.location.query.path
	      });
	    }
	  }], [{
	    key: 'onEnter',
	
	
	    // This has to be here in order to get a CurrentUser
	    value: function onEnter(nextState, replaceWith, callback) {
	      _AuthActions2.default.checkLoggedIn().then(function () {
	        return callback();
	      }, function () {
	        return callback();
	      });
	    }
	  }, {
	    key: 'getStores',
	    value: function getStores() {
	      return [_GroupStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        group: _GroupStore2.default.getGroupCreatedDuringSetup()
	      };
	    }
	  }]);
	
	  return AppUpsellPageContainer;
	}(_react2.default.Component);
	
	AppUpsellPageContainer.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	AppUpsellPageContainer.displayName = 'AppUpsellPageContainer';
	exports.default = _utils.Container.create(AppUpsellPageContainer);

/***/ },
/* 2531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppUpsellPage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  query {\n    me {\n      id\n      featureFlags {\n        web_admin_console\n      }\n      admin_organizations: organizations(affiliation_status: [admin]) {\n        id\n      }\n    }\n  }'], ['\n  query {\n    me {\n      id\n      featureFlags {\n        web_admin_console\n      }\n      admin_organizations: organizations(affiliation_status: [admin]) {\n        id\n      }\n    }\n  }']);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _BoxButton = __webpack_require__(2364);
	
	var _BoxButton2 = _interopRequireDefault(_BoxButton);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _openApp = __webpack_require__(2532);
	
	var _openApp2 = _interopRequireDefault(_openApp);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _UserAgent = __webpack_require__(1161);
	
	var _UserAgent2 = _interopRequireDefault(_UserAgent);
	
	var _View = __webpack_require__(2356);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _reactApollo = __webpack_require__(467);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	__webpack_require__(2533);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var RatingGlyph = function RatingGlyph() {
	  return _react2.default.createElement(_Glyph2.default, { name: 'star', color: 'tuscan', size: 'xxsmall', className: 'AppUpsellPage-appStore-ratingGlyphs-item' });
	};
	
	var AppUpsellPage = function (_React$Component) {
	  _inherits(AppUpsellPage, _React$Component);
	
	  function AppUpsellPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AppUpsellPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppUpsellPage.__proto__ || Object.getPrototypeOf(AppUpsellPage)).call.apply(_ref, [this].concat(args))), _this), _this.alreadyHaveApplication = function () {
	      (0, _openApp2.default)(_this.props.haveAppUrl);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AppUpsellPage, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          origin = _props.origin,
	          group = _props.group,
	          isAdmin = _props.isAdmin,
	          hasAdminConsoleAccess = _props.hasAdminConsoleAccess;
	
	      var userAgent = new _UserAgent2.default(window.navigator.userAgent);
	      var title = 'Get the Remind app';
	      var storeLink = _LinkConstants2.default.APP_DOWNLOAD;
	
	      if (origin === 'group_created' && group) {
	        title = group.getName() + ' is ready!';
	      } else if (origin === 'subscribed' && group) {
	        title = 'Go to ' + group.getName() + '!';
	      }
	
	      if (userAgent.ios()) {
	        storeLink = _LinkConstants2.default.APP_STORE;
	      } else if (userAgent.android()) {
	        storeLink = _LinkConstants2.default.GOOGLE_PLAY;
	      }
	
	      return _react2.default.createElement(
	        _View2.default,
	        { className: 'AppUpsellPage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'AppUpsellPage-inner' },
	          _react2.default.createElement(
	            _Container2.default,
	            { size: 'xsmall' },
	            _react2.default.createElement(
	              'header',
	              { className: 'AppUpsellPage-header' },
	              _react2.default.createElement(
	                _Container2.default,
	                null,
	                _react2.default.createElement(_TitleHeader2.default, {
	                  title: title,
	                  subtext: 'Send and receive messages instantly on your phone.',
	                  size: 'xlarge'
	                }),
	                _react2.default.createElement(
	                  _Box2.default,
	                  { className: 'AppUpsellPage-box', full: true },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'AppUpsellPage-box-body' },
	                    _react2.default.createElement(
	                      'a',
	                      { href: storeLink },
	                      _react2.default.createElement(
	                        _MediaObject2.default,
	                        { gutter: 'small' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'AppUpsellPage-box-body-icon AppUpsellPage-box-body-icon--brand' },
	                          _react2.default.createElement(_Glyph2.default, { name: 'remind-icon', color: 'white', size: 'xxlarge' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'h3',
	                            { className: 'AppUpsellPage-box-body-title' },
	                            'Remind'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'AppUpsellPage-box-body-ratingGlyphs' },
	                            _react2.default.createElement(RatingGlyph, null),
	                            _react2.default.createElement(RatingGlyph, null),
	                            _react2.default.createElement(RatingGlyph, null),
	                            _react2.default.createElement(RatingGlyph, null),
	                            _react2.default.createElement(RatingGlyph, null)
	                          ),
	                          _react2.default.createElement(
	                            _Text2.default,
	                            {
	                              color: 'eclipse',
	                              element: 'div',
	                              size: 'xxxsmall',
	                              className: 'AppUpsellPage-box-body-info' },
	                            '30,000+ 5-star reviews'
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(_BoxButton2.default, { href: storeLink, text: 'Download Remind app' })
	                )
	              ),
	              isAdmin && hasAdminConsoleAccess && _react2.default.createElement(
	                _Container2.default,
	                null,
	                _react2.default.createElement(
	                  _Box2.default,
	                  { className: 'AppUpsellPage-box', full: true },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'AppUpsellPage-box-body' },
	                    _react2.default.createElement(
	                      _MediaObject2.default,
	                      { gutter: 'small' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'AppUpsellPage-box-body-icon AppUpsellPage-box-body-icon--admin' },
	                        _react2.default.createElement(_Image2.default, { src: __webpack_require__(2535) })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                          'h3',
	                          { className: 'AppUpsellPage-box-body-title' },
	                          'Admin Console'
	                        ),
	                        _react2.default.createElement(
	                          _Text2.default,
	                          {
	                            color: 'eclipse',
	                            element: 'div',
	                            size: 'xxxsmall',
	                            className: 'AppUpsellPage-box-body-info' },
	                          'View school and teacher statistics, browse classes, manage people and much more from Remind\u2018s administrator console.'
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(_BoxButton2.default, { disabled: true, color: 'thunder', text: 'Log in from your computer' })
	                )
	              )
	            ),
	            this.props.haveAppUrl && origin === 'direct' && _react2.default.createElement(
	              _Button2.default,
	              {
	                color: 'brand',
	                level: 'text',
	                weight: 'semibold',
	                eventElementName: 'openAppButton',
	                onClick: this.alreadyHaveApplication,
	                full: true },
	              'I already have the app'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AppUpsellPage;
	}(_react2.default.Component);
	
	AppUpsellPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	AppUpsellPage.displayName = 'AppUpsellPage';
	
	
	var withAdminOrganizations = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  props: function props(_ref2) {
	    var data = _ref2.data;
	    return {
	      isAdmin: data.me ? data.me.admin_organizations.length > 0 : false,
	      hasAdminConsoleAccess: data.me ? data.me.featureFlags['web_admin_console'] : false
	    };
	  }
	});
	
	exports.AppUpsellPage = AppUpsellPage;
	exports.default = withAdminOrganizations(AppUpsellPage);

/***/ },
/* 2532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = openApp;
	
	var _currentUserAgent = __webpack_require__(1160);
	
	var _currentUserAgent2 = _interopRequireDefault(_currentUserAgent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function openApp(path) {
	  var location = 'rmd:/' + (path || '/a');
	  if (_currentUserAgent2.default.android()) {
	    location = 'intent:/' + (path || '/a') + '#Intent;scheme=rmd;package=com.remind101;' + ('S.browser_fallback_url=' + encodeURI(window.location.href) + ';end');
	  }
	  window.location = location;
	}

/***/ },
/* 2533 */
1136,
/* 2534 */,
/* 2535 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _JoinGroupAvatarPanel = __webpack_require__(2537);
	
	var _JoinGroupAvatarPanel2 = _interopRequireDefault(_JoinGroupAvatarPanel);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(2541);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinConfirmSubscriptionModal = _react2.default.createClass({
	  displayName: 'JoinConfirmSubscriptionModal',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      group: null
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.loadGroup(this.props.code);
	  },
	  bypass: function bypass() {
	    this.context.router.push('/classes');
	  },
	  loadGroup: function loadGroup(code) {
	    var _this = this;
	
	    var onNotFound = function onNotFound() {
	      _ToastActions2.default.showErrorToast('Group not found.');
	      _this.props.onRequestHide();
	    };
	
	    var onSuccess = function onSuccess(group) {
	      if (_GroupStore2.default.isConnectedToGroup(group)) {
	        _ToastActions2.default.showErrorToast('You have already joined this class.');
	        _this.props.onRequestHide();
	      } else if (!group.canJoin()) {
	        _ToastActions2.default.showErrorToast('Can’t join this class');
	        _this.props.onRequestHide();
	      } else {
	        _this.setState({ group: group });
	      }
	    };
	
	    _GroupActions2.default.searchGroupByCode(code).then(onSuccess, onNotFound);
	  },
	  signOutRequest: function signOutRequest() {
	    _AuthActions2.default.signOut('/join/' + this.props.code);
	  },
	  subscribe: function subscribe() {
	    var _this2 = this;
	
	    var onSuccess = function onSuccess(group) {
	      _ToastActions2.default.showSuccessToast('You\u2019ve joined ' + group.getName());
	      _this2.props.onRequestHide();
	      _this2.context.router.push('/classes/' + group.getCode());
	    };
	
	    var onError = function onError(error) {
	      _ToastActions2.default.showErrorToast(error.message);
	      _this2.props.onRequestHide();
	    };
	
	    _GroupActions2.default.subscribeToGroupWithCode(this.props.code).then(onSuccess, onError);
	  },
	  render: function render() {
	    if (!this.state.group) {
	      return _react2.default.createElement(
	        _Modal2.default,
	        null,
	        _react2.default.createElement(_CenteredLoadingIndicator2.default, null)
	      );
	    }
	    return _react2.default.createElement(
	      _Dialog2.default,
	      _extends({}, this.props, { eventScreenName: 'JoinConfirmSubscriptionModal', size: 'xsmall' }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { className: 'JoinConfirmSubscriptionModal' },
	        _react2.default.createElement(_JoinGroupAvatarPanel2.default, { group: this.state.group }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            full: true,
	            onClick: this.subscribe,
	            className: 'JoinConfirmSubscriptionModal-Button' },
	          'Join class'
	        )
	      ),
	      _react2.default.createElement(
	        _BoxFooter2.default,
	        null,
	        'Logged in as ' + _CurrentUser2.default.getUser().getSignature(),
	        _react2.default.createElement('br', null),
	        'Not you? ',
	        _react2.default.createElement(
	          _Link2.default,
	          { onClick: this.signOutRequest },
	          'Log out'
	        )
	      )
	    );
	  }
	});
	
	exports.default = JoinConfirmSubscriptionModal;

/***/ },
/* 2537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2538);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinGroupAvatarPanel = _react2.default.createClass({
	  displayName: 'JoinGroupAvatarPanel',
	  render: function render() {
	    var group = this.props.group;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('JoinAvatarPanel', this.props.className) },
	      _react2.default.createElement(
	        'div',
	        { className: 'JoinAvatarPanel-Image' },
	        _react2.default.createElement(_GroupAvatar2.default, { group: this.props.group })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'JoinAvatarPanel-Header' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          _react2.default.createElement(
	            'p',
	            null,
	            this.props.group.getPossessiveSignature()
	          ),
	          _react2.default.createElement(
	            'strong',
	            null,
	            _react2.default.createElement(_GroupName2.default, { group: group })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'JoinAvatarPanel-Footer' },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.group.getOrganization() && this.props.group.getOrganization().getName()
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          '@',
	          this.props.group.getCode()
	        )
	      )
	    );
	  }
	});
	
	exports.default = JoinGroupAvatarPanel;

/***/ },
/* 2538 */
1136,
/* 2539 */,
/* 2540 */,
/* 2541 */
1136,
/* 2542 */,
/* 2543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AuthenticationView = __webpack_require__(1690);
	
	var _AuthenticationView2 = _interopRequireDefault(_AuthenticationView);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	__webpack_require__(2544);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var STATUS = (0, _enumerate2.default)(['pending', 'failure']);
	
	var expiredMessage = 'Your link has expired.';
	
	var ConfirmEmailPage = function (_React$Component) {
	  _inherits(ConfirmEmailPage, _React$Component);
	
	  function ConfirmEmailPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConfirmEmailPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConfirmEmailPage.__proto__ || Object.getPrototypeOf(ConfirmEmailPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      status: STATUS.pending,
	      source: _this.props.location.query.source
	    }, _this.onSuccess = function () {
	      _ToastActions2.default.showSuccessToast('Your email has been confirmed');
	      _this.context.router.push('/landing');
	    }, _this.confirmUser = function (token) {
	      _UserActions2.default.confirm(token, _this.state.source).then(_this.onSuccess, function (error) {
	        var errorMessage = 'An error has occurred.';
	        if (error.statusCode === 403) {
	          errorMessage = expiredMessage;
	        } else if (error.statusCode === 422) {
	          try {
	            errorMessage = error.field_errors[0].messages[0] + '.';
	          } catch (e) {
	            // Do nothing.
	          }
	        }
	
	        _this.setState({
	          status: STATUS.failure,
	          errorMessage: errorMessage
	        });
	      });
	    }, _this.confirmDevice = function (token) {
	      _Device2.default.confirmEmailDevice(token).then(_this.onSuccess, function () {
	        _this.setState({
	          status: STATUS.failure,
	          errorMessage: expiredMessage
	        });
	      });
	    }, _this.renderFailure = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ConfirmEmailPage-Failure' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'ConfirmEmailPage-Title' },
	          _this.state.errorMessage
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Please',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { href: _LinkConstants2.default.CONTACT_FORM, target: '_blank' },
	            'contact us'
	          ),
	          '.'
	        )
	      );
	    }, _this.renderPending = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ConfirmEmailPage-Pending' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'ConfirmEmailPage-Title' },
	          'Confirming your new email address...'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ConfirmEmailPage-Loading' },
	          _react2.default.createElement(_LoadingIndicator2.default, { size: 'small' })
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ConfirmEmailPage, [{
	    key: 'componentDidMount',
	
	
	    /* We have 2 ways of confirming email addresses. (I know).
	     * Confirming a User confirms the user's primary email address (and corresponding device).
	     * Confirming a device confirms just that one device. They are different endpoints and
	     * different types of tokens. User tokens are stateless meanwhile device tokens are stored
	     * in the database. The stateless tokens are much larger. Here we determine the type of
	     * token (and which endpoint to request) based on the length of the token. Thanks for
	     * reading.
	     * */
	    value: function componentDidMount() {
	      var token = this.props.params.token;
	      if (token.length > 36) {
	        this.confirmUser(token);
	      } else {
	        this.confirmDevice(token);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _STATUS$pending$STATU;
	
	      var body = (_STATUS$pending$STATU = {}, _defineProperty(_STATUS$pending$STATU, STATUS.pending, this.renderPending), _defineProperty(_STATUS$pending$STATU, STATUS.failure, this.renderFailure), _STATUS$pending$STATU)[this.state.status]();
	
	      return _react2.default.createElement(
	        _AuthenticationView2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'ConfirmEmailPage' },
	          body
	        )
	      );
	    }
	  }]);
	
	  return ConfirmEmailPage;
	}(_react2.default.Component);
	
	ConfirmEmailPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ConfirmEmailPage.displayName = 'ConfirmEmailPage';
	exports.default = ConfirmEmailPage;

/***/ },
/* 2544 */
1136,
/* 2545 */,
/* 2546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _currentUserAgent = __webpack_require__(1160);
	
	var _currentUserAgent2 = _interopRequireDefault(_currentUserAgent);
	
	__webpack_require__(2547);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DebugInfoView = function (_React$Component) {
	  _inherits(DebugInfoView, _React$Component);
	
	  function DebugInfoView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DebugInfoView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DebugInfoView.__proto__ || Object.getPrototypeOf(DebugInfoView)).call.apply(_ref, [this].concat(args))), _this), _this.state = _currentUserAgent2.default.result, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DebugInfoView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'table',
	        { className: 'DebugInfoView' },
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              'UserAgent'
	            ),
	            _react2.default.createElement(
	              'td',
	              { colSpan: '2' },
	              this.state.ua
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              'Browser'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              this.state.browser.name || 'N/A'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              this.state.browser.version || 'N/A'
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              'Engine'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              this.state.engine.name || 'N/A'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              this.state.engine.version || 'N/A'
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              'OS'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              this.state.os.name || 'N/A'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              this.state.os.version || 'N/A'
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              'Device'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              this.state.device.type || 'N/A'
	            ),
	            _react2.default.createElement(
	              'td',
	              null,
	              this.state.device.vendor || 'N/A'
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              null,
	              'CPU'
	            ),
	            _react2.default.createElement(
	              'td',
	              { colSpan: '2' },
	              this.state.cpu.architecture || 'N/A'
	            )
	          ),
	          _react2.default.createElement(
	            'tr',
	            { style: { verticalAlign: 'top' } },
	            _react2.default.createElement(
	              'td',
	              null,
	              'Cookie'
	            ),
	            _react2.default.createElement(
	              'td',
	              { colSpan: '2' },
	              document.cookie
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DebugInfoView;
	}(_react2.default.Component);
	
	DebugInfoView.displayName = 'DebugInfoView';
	exports.default = DebugInfoView;

/***/ },
/* 2547 */
1136,
/* 2548 */,
/* 2549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var DeleteAccountPage = function (_React$Component) {
	  _inherits(DeleteAccountPage, _React$Component);
	
	  function DeleteAccountPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DeleteAccountPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeleteAccountPage.__proto__ || Object.getPrototypeOf(DeleteAccountPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      disabled: true,
	      error: false,
	      concluded: false
	    }, _this.handleCancelClick = function () {
	      _this.context.router.push('/landing');
	    }, _this.handleDeleteClick = function () {
	      _this.setState({
	        disabled: true
	      });
	
	      var token = _this.props.params.token;
	      _UserActions2.default.delete(token).then(function () {
	        _this.setState({
	          concluded: true
	        });
	      }, function (response) {
	        _this.setState({
	          concluded: true,
	          deletionError: response.error
	        });
	      });
	    }, _this.renderConclusion = function () {
	      var dialogProps = {
	        title: 'Your account was deleted.',
	        glyph: 'check',
	        color: 'shamrock'
	      };
	
	      if (_this.state.deletionError) {
	        dialogProps = {
	          title: _this.state.deletionError,
	          glyph: 'caution',
	          color: 'lava'
	        };
	      }
	      return _react2.default.createElement(_DialogContent2.default, _extends({ size: 'xsmall' }, dialogProps));
	    }, _this.renderConfirmation = function () {
	      var title = void 0;
	      var subtext = void 0;
	      if (_this.state.deletionPreview) {
	        // Maybe in the future put another message for when the account is already deleted
	        title = 'Are you sure you want to delete the account at ' + _this.state.deletionPreview.email + '?';
	        subtext = "You will no longer have access to your classes. This action can't be undone.";
	      } else {
	        title = _this.state.error;
	        subtext = null;
	      }
	
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          size: 'xsmall',
	          title: title,
	          subtext: subtext,
	          glyph: 'caution',
	          glyphColor: 'lava' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              onClick: _this.handleDeleteClick,
	              disabled: _this.state.disabled,
	              level: 'primary' },
	            'Delete'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              onClick: _this.handleCancelClick,
	              inline: true,
	              level: 'secondary' },
	            'Cancel'
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DeleteAccountPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var onSuccess = function onSuccess(deletionPreview) {
	        _this2.setState({
	          disabled: false,
	          deletionPreview: deletionPreview
	        });
	      };
	
	      var onError = function onError(_ref2) {
	        var error = _ref2.error;
	        return _this2.setState({ error: error });
	      };
	
	      _UserActions2.default.verifyDeleteToken(this.props.params.token).then(onSuccess, onError);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.concluded) {
	        return this.renderConclusion();
	      } else {
	        return this.renderConfirmation();
	      }
	    }
	  }]);
	
	  return DeleteAccountPage;
	}(_react2.default.Component);
	
	DeleteAccountPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	DeleteAccountPage.displayName = 'DeleteAccountPage';
	exports.default = DeleteAccountPage;

/***/ },
/* 2550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CopyConstants = __webpack_require__(1733);
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _AddBankAccountFormContainer = __webpack_require__(2551);
	
	var _AddBankAccountFormContainer2 = _interopRequireDefault(_AddBankAccountFormContainer);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Carousel = __webpack_require__(2577);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _CarouselPage = __webpack_require__(2584);
	
	var _CarouselPage2 = _interopRequireDefault(_CarouselPage);
	
	var _chainOnEnter = __webpack_require__(2585);
	
	var _chainOnEnter2 = _interopRequireDefault(_chainOnEnter);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DepositConfirmation = __webpack_require__(2587);
	
	var _DepositConfirmation2 = _interopRequireDefault(_DepositConfirmation);
	
	var _DepositSetupReceipt = __webpack_require__(2589);
	
	var _DepositSetupReceipt2 = _interopRequireDefault(_DepositSetupReceipt);
	
	var _DepositSetupViewHeader = __webpack_require__(2597);
	
	var _DepositSetupViewHeader2 = _interopRequireDefault(_DepositSetupViewHeader);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _IdentityVerificationView = __webpack_require__(2600);
	
	var _IdentityVerificationView2 = _interopRequireDefault(_IdentityVerificationView);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _PaymentAccountStore = __webpack_require__(2604);
	
	var _PaymentAccountStore2 = _interopRequireDefault(_PaymentAccountStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RequirePaymentAccount = __webpack_require__(2606);
	
	var _RequirePaymentAccount2 = _interopRequireDefault(_RequirePaymentAccount);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _trackView = __webpack_require__(1950);
	
	var _trackView2 = _interopRequireDefault(_trackView);
	
	__webpack_require__(2607);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequireVerification = {
	  statics: {
	    onEnter: function onEnter(nextState, replaceWith, callback) {
	      var account = _PaymentAccountStore2.default.getPaymentAccount();
	
	      var needVerification = account.needBasicVerification() || account.needBankAccountVerification();
	
	      if (!needVerification) {
	        replaceWith('/campaigns');
	      }
	
	      callback();
	    }
	  }
	};
	
	/* Check the store for the payment request id in the query
	 * param, if not there than try to load it.
	 */
	// typecheck: ignore file
	var RequireActivity = {
	  statics: {
	    onEnter: function onEnter(nextState, replaceWith, callback) {
	      var query = nextState.location.query;
	
	      if (!query.req) {
	        _ToastActions2.default.showDefaultErrorToast();
	        replaceWith('/campaigns');
	        callback();
	        return;
	      }
	
	      var activity = _ActivityStore2.default.getActivityById(query.req);
	      if (activity) {
	        callback();
	        return;
	      }
	
	      _ActivityActions2.default.loadByUuid(query.req).then(function () {
	        return callback();
	      }, function () {
	        _ToastActions2.default.showDefaultErrorToast();
	        replaceWith('/campaigns');
	        callback();
	      });
	    }
	  }
	};
	
	var DepositSetupViewCarouselPage = function DepositSetupViewCarouselPage(props) {
	  return _react2.default.createElement(
	    _CarouselPage2.default,
	    { eventScreenName: props.eventScreenName },
	    _react2.default.createElement(
	      _Container2.default,
	      { size: 'medium' },
	      props.children
	    )
	  );
	};
	
	var DepositSetupView = _react2.default.createClass({
	  displayName: 'DepositSetupView',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [(0, _chainOnEnter2.default)([_RequireUser2.default, _RequirePaymentAccount2.default, RequireVerification, RequireActivity])],
	
	  getInitialState: function getInitialState() {
	    var account = _PaymentAccountStore2.default.getPaymentAccount();
	    var activity = void 0;
	    var initialIndex = void 0;
	    var req = this.props.location.query.req;
	
	    if (req) {
	      activity = _ActivityStore2.default.getActivityById(req);
	    }
	
	    if (account.needBasicVerification()) {
	      initialIndex = 0;
	    } else if (account.needBankAccountVerification()) {
	      initialIndex = 1;
	    }
	
	    return { initialIndex: initialIndex, account: account, activity: activity };
	  },
	  onClose: function onClose() {
	    if (!this.context.router.goBack()) {
	      this.context.router.push('/campaigns');
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var needBankAccount = this.state.account.needBankAccountVerification();
	    var progressLabels = needBankAccount ? ['verify identify', 'add bank account', 'review & confirm'] : ['verify identify', 'review & confirm'];
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('DepositSetupView', this.props.className) },
	      _react2.default.createElement(
	        _Link2.default,
	        {
	          color: 'thunder',
	          className: 'DepositSetupView-closeButton',
	          onClick: this.onClose,
	          eventElementName: 'DepositSetupView-closeButton' },
	        _react2.default.createElement(_Glyph2.default, { name: 'close', size: 'xlarge', solo: true })
	      ),
	      _react2.default.createElement(
	        _Container2.default,
	        null,
	        _react2.default.createElement(
	          _Carousel2.default,
	          {
	            ref: function ref(_ref) {
	              return _this._carousel = _ref;
	            },
	            initialIndex: this.state.initialIndex,
	            clickablePageControls: false,
	            progressLabels: progressLabels },
	          _react2.default.createElement(
	            DepositSetupViewCarouselPage,
	            {
	              key: _EventTrackingConstants2.default.CREATE_DEPOSIT_ADDRESS,
	              eventScreenName: _EventTrackingConstants2.default.CREATE_DEPOSIT_ADDRESS },
	            _react2.default.createElement(_DepositSetupViewHeader2.default, {
	              title: _CopyConstants.IdentityVerification.title,
	              subtext: _CopyConstants.IdentityVerification.subtext
	            }),
	            _react2.default.createElement(_IdentityVerificationView2.default, { onVerified: function onVerified() {
	                return _this._carousel.next();
	              } })
	          ),
	          needBankAccount && _react2.default.createElement(
	            DepositSetupViewCarouselPage,
	            {
	              key: _EventTrackingConstants2.default.CREATE_DEPOSIT_ACCOUNT,
	              eventScreenName: _EventTrackingConstants2.default.CREATE_DEPOSIT_ACCOUNT },
	            this.state.requestedSchoolAccount && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_TitleHeader2.default, {
	                title: _CopyConstants.RequestBankAccountConfirmation.title,
	                subtext: _CopyConstants.RequestBankAccountConfirmation.subtext,
	                image: __webpack_require__(2609),
	                size: 'large',
	                subtle: true
	              }),
	              _react2.default.createElement(
	                _Button2.default,
	                { onClick: function onClick() {
	                    return _this.context.router.push('/settings/transactions/');
	                  } },
	                'Got it'
	              )
	            ),
	            !this.state.requestedSchoolAccount && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_DepositSetupViewHeader2.default, {
	                title: _CopyConstants.BankAccount.title,
	                subtext: _CopyConstants.BankAccount.subtext
	              }),
	              _react2.default.createElement(_AddBankAccountFormContainer2.default, {
	                onSchoolBankAccountAdded: function onSchoolBankAccountAdded() {
	                  return _this.setState({ requestedSchoolAccount: true });
	                },
	                onBankAccountAdded: function onBankAccountAdded() {
	                  return _this._carousel.next();
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            DepositSetupViewCarouselPage,
	            {
	              key: _EventTrackingConstants2.default.CONFIRM_DEPOSIT,
	              eventScreenName: _EventTrackingConstants2.default.CONFIRM_DEPOSIT },
	            _react2.default.createElement(_DepositSetupReceipt2.default, {
	              activity: this.state.activity,
	              onDepositCompleted: function onDepositCompleted() {
	                return _this._carousel.next();
	              }
	            })
	          ),
	          _react2.default.createElement(
	            DepositSetupViewCarouselPage,
	            {
	              key: _EventTrackingConstants2.default.DEPOSIT_RECEIPT,
	              eventScreenName: _EventTrackingConstants2.default.DEPOSIT_RECEIPT },
	            _react2.default.createElement(_DepositConfirmation2.default, {
	              onCompleteText: 'Return to your wallet',
	              onComplete: function onComplete() {
	                return _this.context.router.push('/campaigns');
	              }
	            })
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = (0, _trackView2.default)(DepositSetupView);

/***/ },
/* 2551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AddBankAccountForm = __webpack_require__(2552);
	
	var _AddBankAccountForm2 = _interopRequireDefault(_AddBankAccountForm);
	
	var _AddSchoolAccountForm = __webpack_require__(2571);
	
	var _AddSchoolAccountForm2 = _interopRequireDefault(_AddSchoolAccountForm);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	var _Tabs = __webpack_require__(1539);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	__webpack_require__(2575);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddBankAccountFormContainer = function (_Component) {
	  _inherits(AddBankAccountFormContainer, _Component);
	
	  function AddBankAccountFormContainer() {
	    _classCallCheck(this, AddBankAccountFormContainer);
	
	    return _possibleConstructorReturn(this, (AddBankAccountFormContainer.__proto__ || Object.getPrototypeOf(AddBankAccountFormContainer)).apply(this, arguments));
	  }
	
	  _createClass(AddBankAccountFormContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onSchoolBankAccountAdded = _props.onSchoolBankAccountAdded,
	          onBankAccountAdded = _props.onBankAccountAdded,
	          rest = _objectWithoutProperties(_props, ['onSchoolBankAccountAdded', 'onBankAccountAdded']);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AddBankAccountFormContainer' },
	        _react2.default.createElement(
	          _Tabs2.default,
	          { className: 'AddBankAccountFormContainer-tabs', type: 'button' },
	          _react2.default.createElement(
	            _TabPanel2.default,
	            { title: _react2.default.createElement(
	                'span',
	                null,
	                'Individual account'
	              ) },
	            _react2.default.createElement(_AddBankAccountForm2.default, _extends({}, rest, { onBankAccountAdded: onBankAccountAdded }))
	          ),
	          _react2.default.createElement(
	            _TabPanel2.default,
	            { title: _react2.default.createElement(
	                'span',
	                null,
	                'School bank account'
	              ) },
	            _react2.default.createElement(_AddSchoolAccountForm2.default, _extends({}, rest, { onSchoolBankAccountAdded: onSchoolBankAccountAdded }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddBankAccountFormContainer;
	}(_react.Component);
	
	AddBankAccountFormContainer.displayName = 'AddBankAccountFormContainer';
	exports.default = AddBankAccountFormContainer;

/***/ },
/* 2552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExternalAccountResourceActions = __webpack_require__(2553);
	
	var _ExternalAccountResourceActions2 = _interopRequireDefault(_ExternalAccountResourceActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _ConnectedBankAccountActions = __webpack_require__(2559);
	
	var _ConnectedBankAccountActions2 = _interopRequireDefault(_ConnectedBankAccountActions);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _EncryptionNotice = __webpack_require__(1970);
	
	var _EncryptionNotice2 = _interopRequireDefault(_EncryptionNotice);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _FocusEventTrigger = __webpack_require__(1746);
	
	var _FocusEventTrigger2 = _interopRequireDefault(_FocusEventTrigger);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _StripeAPI = __webpack_require__(1979);
	
	var _StripeAPI2 = _interopRequireDefault(_StripeAPI);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _PaymentAccount = __webpack_require__(2562);
	
	var _ChequeImageView = __webpack_require__(2563);
	
	__webpack_require__(2569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddBankAccountForm = _react2.default.createClass({
	  displayName: 'AddBankAccountForm',
	
	
	  contextTypes: {
	    eventContextName: _react.PropTypes.string,
	    eventScreenName: _react.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hideChequeImage: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      disabled: true,
	      highlighted: null,
	      loading: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    _StripeAPI2.default.setPublishableKey(_SettingsStore2.default.getStripeKey()).then(function () {}, this.handleScriptError);
	  },
	  handleFormSubmit: function handleFormSubmit(value) {
	    var _this = this;
	
	    this.setState({ loading: true });
	    var onDone = function onDone() {
	      if (_this.isMounted()) {
	        _this.setState({ loading: false });
	      }
	    };
	
	    _StripeAPI2.default.createBankAccountToken({
	      country: _PaymentAccount.STRIPE_COUNTRY,
	      currency: _PaymentAccount.USD_CURRENCY,
	      routing_number: value.routing_number,
	      account_number: value.account_number,
	      account_holder_type: _PaymentAccount.STRIPE_ACCOUNT_TYPE_INDIVIDUAL
	    }, function (status, response) {
	      if (response.error) {
	        onDone();
	        if (response.error.message) {
	          _ToastActions2.default.showErrorToast(response.error.message);
	        } else {
	          _ToastActions2.default.showDefaultErrorToast();
	        }
	        return;
	      }
	
	      if (_this.props.connectedBankAccount) {
	        _ConnectedBankAccountActions2.default.approve(response.id, value.bank_account_name, null, _this.props.connectedBankAccount.id).then(_this.props.onAdminBankAccountAdd, _ToastActions2.default.showDefaultErrorToast).then(onDone, onDone);
	      } else if (_this.props.onAdminBankAccountAdd) {
	        _ConnectedBankAccountActions2.default.approve(response.id, value.bank_account_name, _this.props.accessToken).then(_this.props.onAdminBankAccountAdd, _ToastActions2.default.showDefaultErrorToast).then(onDone, onDone);
	      } else {
	        _ExternalAccountResourceActions2.default.create(response.id).then(_this.props.onBankAccountAdded, _ToastActions2.default.showDefaultErrorToast).then(onDone, onDone);
	      }
	    });
	  },
	  handleScriptError: function handleScriptError() {
	    _ToastActions2.default.showDefaultErrorToast();
	  },
	  renderChequeImage: function renderChequeImage() {
	    if (!this.props.hideChequeImage) {
	      return _react2.default.createElement(_ChequeImageView.ChequeImageView, { highlighted: this.state.highlighted });
	    }
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _context = this.context,
	        eventContextName = _context.eventContextName,
	        eventScreenName = _context.eventScreenName;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'AddBankAccountForm' },
	      _react2.default.createElement(
	        _Container2.default,
	        { size: 'medium' },
	        _react2.default.createElement(
	          _Form2.default,
	          {
	            className: 'AddBankAccountForm-form',
	            onValid: function onValid() {
	              return _this2.setState({ disabled: false });
	            },
	            onInvalid: function onInvalid() {
	              return _this2.setState({ disabled: true });
	            },
	            onValidSubmit: this.handleFormSubmit },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _FocusEventTrigger2.default,
	              {
	                eventScreenName: eventScreenName,
	                eventContextName: eventContextName,
	                eventElementName: 'routing_number',
	                trackChildComponents: true },
	              _react2.default.createElement(_FormInput2.default, {
	                label: 'Routing number',
	                type: 'tel',
	                name: 'routing_number',
	                maxLength: '9',
	                autofocus: true,
	                autoComplete: 'off',
	                validations: { isValidRoutingNumber: _PaymentAccount.STRIPE_COUNTRY },
	                validationErrors: {
	                  isDefaultRequiredValue: 'Routing number is required',
	                  isValidRoutingNumber: 'Routing number is invalid'
	                },
	                onBlur: function onBlur() {
	                  return _this2.setState({ highlighted: null });
	                },
	                onFocus: function onFocus() {
	                  return _this2.setState({ highlighted: _ChequeImageView.ROUTING_NUMBER });
	                },
	                showErrorAfterBlur: true,
	                required: true
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _FocusEventTrigger2.default,
	              {
	                eventScreenName: eventScreenName,
	                eventContextName: eventContextName,
	                eventElementName: 'account_number',
	                trackChildComponents: true },
	              _react2.default.createElement(_FormInput2.default, {
	                label: 'Account number',
	                type: 'tel',
	                name: 'account_number',
	                autoComplete: 'off',
	                validations: { isValidAccountNumber: _PaymentAccount.STRIPE_COUNTRY },
	                validationErrors: {
	                  isDefaultRequiredValue: 'Account number is required',
	                  isValidAccountNumber: 'Account number is invalid'
	                },
	                onBlur: function onBlur() {
	                  return _this2.setState({ highlighted: null });
	                },
	                onFocus: function onFocus() {
	                  return _this2.setState({ highlighted: _ChequeImageView.ACCOUNT_NUMBER });
	                },
	                showErrorAfterBlur: true,
	                required: true
	              })
	            )
	          ),
	          this.renderChequeImage(),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              loading: this.state.loading,
	              className: 'AddBankAccountForm-submit',
	              disabled: this.state.disabled,
	              eventScreenName: _EventTrackingConstants2.default.CREATE_DEPOSIT_ACCOUNT,
	              eventContextName: eventContextName,
	              eventElementName: 'continue' },
	            'Continue'
	          )
	        ),
	        _react2.default.createElement(_EncryptionNotice2.default, null)
	      )
	    );
	  }
	}); /*  weak */
	exports.default = AddBankAccountForm;

/***/ },
/* 2553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExternalAccountResourceConstants = __webpack_require__(2554);
	
	var _ExternalAccountResources = __webpack_require__(2555);
	
	var _ExternalAccountResources2 = _interopRequireDefault(_ExternalAccountResources);
	
	var _ExternalAccountResource = __webpack_require__(2556);
	
	var _ExternalAccountResource2 = _interopRequireDefault(_ExternalAccountResource);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExternalAccountResourceActions = {
	  create: function create() {
	    return _ExternalAccountResource2.default.create.apply(_ExternalAccountResource2.default, arguments).then(function (externalAccountResource) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ExternalAccountResourceConstants.ActionTypes.CREATE_BANK_ACCOUNT,
	        externalAccountResource: externalAccountResource
	      });
	
	      return externalAccountResource;
	    });
	  },
	  makePrimary: function makePrimary(account) {
	    return account.makePrimary().then(function (externalAccountResource) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ExternalAccountResourceConstants.ActionTypes.UPDATE_PRIMARY_BANK_ACCOUNT,
	        bankAccount: externalAccountResource.getBankAccount()
	      });
	    });
	  },
	  delete: function _delete(externalAccountResource) {
	    return externalAccountResource.delete().then(function () {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ExternalAccountResourceConstants.ActionTypes.DELETE_BANK_ACCOUNT,
	        bankAccount: externalAccountResource.getBankAccount()
	      });
	    });
	  },
	  load: function load() {
	    return _ExternalAccountResources2.default.load().then(function (externalAccountResources) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ExternalAccountResourceConstants.ActionTypes.LOAD_BANK_ACCOUNTS,
	        externalAccountResources: externalAccountResources
	      });
	
	      return externalAccountResources;
	    });
	  }
	};
	
	exports.default = ExternalAccountResourceActions;

/***/ },
/* 2554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['LOAD_BANK_ACCOUNTS', 'DELETE_BANK_ACCOUNT', 'CREATE_BANK_ACCOUNT', 'UPDATE_PRIMARY_BANK_ACCOUNT']); /*  weak */

/***/ },
/* 2555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _ExternalAccountResource = __webpack_require__(2556);
	
	var _ExternalAccountResource2 = _interopRequireDefault(_ExternalAccountResource);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExternalAccountResources = function (_Collection) {
	  _inherits(ExternalAccountResources, _Collection);
	
	  function ExternalAccountResources() {
	    _classCallCheck(this, ExternalAccountResources);
	
	    return _possibleConstructorReturn(this, (ExternalAccountResources.__proto__ || Object.getPrototypeOf(ExternalAccountResources)).apply(this, arguments));
	  }
	
	  _createClass(ExternalAccountResources, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _ExternalAccountResource2.default;
	    }
	  }], [{
	    key: 'load',
	    value: function load() {
	      return (0, _apiRequest2.default)('/payments/payment_destinations', 'GET').then(function (accounts) {
	        return ExternalAccountResources.fromJSON(accounts);
	      });
	    }
	  }]);
	
	  return ExternalAccountResources;
	}(_Collection3.default);
	
	ExternalAccountResources.displayName = 'ExternalAccountResources';
	exports.default = ExternalAccountResources;

/***/ },
/* 2556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.INDIVIDUAL_BANK_ACCOUNT_TYPE = exports.CONNECTED_BANK_ACCOUNT_TYPE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _StripeBankAccount = __webpack_require__(2558);
	
	var _StripeBankAccount2 = _interopRequireDefault(_StripeBankAccount);
	
	var _PaymentSource = __webpack_require__(1976);
	
	var _PaymentSource2 = _interopRequireDefault(_PaymentSource);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONNECTED_BANK_ACCOUNT_TYPE = exports.CONNECTED_BANK_ACCOUNT_TYPE = 'connected_bank_account';
	var INDIVIDUAL_BANK_ACCOUNT_TYPE = exports.INDIVIDUAL_BANK_ACCOUNT_TYPE = 'individual_bank_account';
	
	var ExternalAccountResource = function (_Entity) {
	  _inherits(ExternalAccountResource, _Entity);
	
	  function ExternalAccountResource() {
	    _classCallCheck(this, ExternalAccountResource);
	
	    return _possibleConstructorReturn(this, (ExternalAccountResource.__proto__ || Object.getPrototypeOf(ExternalAccountResource)).apply(this, arguments));
	  }
	
	  _createClass(ExternalAccountResource, [{
	    key: 'parse',
	    value: function parse(response) {
	      var request = (0, _lodash.cloneDeep)(response);
	      if (response['card']) {
	        request['card'] = new _PaymentSource2.default(response['card']);
	      }
	
	      if (response['connected_account']) {
	        request['connected_account'] = new _ConnectedBankAccount2.default(response['connected_account']);
	      }
	
	      if (response['bank_account']) {
	        request['bank_account'] = new _StripeBankAccount2.default(response['bank_account']);
	      }
	      return request;
	    }
	  }, {
	    key: 'getDisplayName',
	    value: function getDisplayName() {
	      return this.get('display_name');
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      var account = this.getBankAccount();
	      return this.getDisplayName() || account.getAccountHolderName() || account.getBankName();
	    }
	  }, {
	    key: 'getConnectedAccount',
	    value: function getConnectedAccount() {
	      return this.get('connected_account');
	    }
	  }, {
	    key: 'getBankAccount',
	    value: function getBankAccount() {
	      return this.get('bank_account');
	    }
	  }, {
	    key: 'setBankAccount',
	    value: function setBankAccount(account) {
	      return this.set('bank_account', account);
	    }
	  }, {
	    key: 'getType',
	    value: function getType() {
	      return this.get('account_type');
	    }
	  }, {
	    key: 'delete',
	    value: function _delete() {
	      return (0, _apiRequest2.default)('/payments/payment_destinations/' + this.getBankAccount().id, 'DELETE');
	    }
	  }, {
	    key: 'makePrimary',
	    value: function makePrimary() {
	      return (0, _apiRequest2.default)('/payments/payment_destinations/' + this.getBankAccount().id, 'PATCH', {
	        payment_destination: {
	          default_for_currency: true
	        }
	      }).then(function (account) {
	        return ExternalAccountResource.fromJSON(account);
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(token) {
	      return (0, _apiRequest2.default)('/payments/payment_destinations', 'POST', { token: token }).then(function (account) {
	        return ExternalAccountResource.fromJSON(account);
	      });
	    }
	  }]);
	
	  return ExternalAccountResource;
	}(_Entity3.default);
	
	ExternalAccountResource.displayName = 'ExternalAccountResource';
	exports.default = ExternalAccountResource;

/***/ },
/* 2557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STATUS_APPROVED = exports.STATUS_REVOKED = exports.STATUS_PENDING = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _lodash = __webpack_require__(555);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _ExternalAccountResource = __webpack_require__(2556);
	
	var _ExternalAccountResource2 = _interopRequireDefault(_ExternalAccountResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS_PENDING = exports.STATUS_PENDING = 'pending';
	var STATUS_REVOKED = exports.STATUS_REVOKED = 'revoked';
	var STATUS_APPROVED = exports.STATUS_APPROVED = 'approved';
	
	var ConnectedBankAccount = function (_Entity) {
	  _inherits(ConnectedBankAccount, _Entity);
	
	  function ConnectedBankAccount() {
	    _classCallCheck(this, ConnectedBankAccount);
	
	    return _possibleConstructorReturn(this, (ConnectedBankAccount.__proto__ || Object.getPrototypeOf(ConnectedBankAccount)).apply(this, arguments));
	  }
	
	  _createClass(ConnectedBankAccount, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.idAttribute = 'uuid';
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      var request = (0, _lodash.cloneDeep)(response);
	      if (request['revoked_at']) {
	        request['revoked_at'] = new Date(request['revoked_at']);
	      }
	
	      if (request['approved_at']) {
	        request['approved_at'] = new Date(request['approved_at']);
	      }
	
	      if (request['requested_at']) {
	        request['requested_at'] = new Date(request['requested_at']);
	      }
	
	      if (request['external_account']) {
	        request['external_account'] = _ExternalAccountResource2.default.fromJSON(request['external_account']);
	      }
	
	      return request;
	    }
	  }, {
	    key: 'getBankId',
	    value: function getBankId() {
	      return this.get('bank_id');
	    }
	  }, {
	    key: 'getConnectedUserUUID',
	    value: function getConnectedUserUUID() {
	      return this.get('connected_user_uuid');
	    }
	  }, {
	    key: 'getConnectedUserName',
	    value: function getConnectedUserName() {
	      return this.get('connected_user_name');
	    }
	  }, {
	    key: 'getNote',
	    value: function getNote() {
	      return this.get('note');
	    }
	  }, {
	    key: 'getOrganizationName',
	    value: function getOrganizationName() {
	      return this.get('organization_name');
	    }
	  }, {
	    key: 'getOwnerName',
	    value: function getOwnerName() {
	      return this.get('owner_name');
	    }
	  }, {
	    key: 'getOwnerAddress',
	    value: function getOwnerAddress() {
	      return this.get('owner_address');
	    }
	  }, {
	    key: 'getOwnerUUID',
	    value: function getOwnerUUID() {
	      return this.get('owner_uuid');
	    }
	  }, {
	    key: 'getRevokedAt',
	    value: function getRevokedAt() {
	      return this.get('revoked_at');
	    }
	  }, {
	    key: 'getApprovedAt',
	    value: function getApprovedAt() {
	      return this.get('approved_at');
	    }
	  }, {
	    key: 'getRequestedAt',
	    value: function getRequestedAt() {
	      return this.get('requested_at');
	    }
	  }, {
	    key: 'isApproved',
	    value: function isApproved() {
	      return this.getStatus() === STATUS_APPROVED;
	    }
	  }, {
	    key: 'getStatus',
	    value: function getStatus() {
	      return this.get('status');
	    }
	  }, {
	    key: 'isPending',
	    value: function isPending() {
	      return this.get('status') === STATUS_PENDING;
	    }
	  }, {
	    key: 'getExternalAccount',
	    value: function getExternalAccount() {
	      return this.get('external_account');
	    }
	  }, {
	    key: 'getCanManage',
	    value: function getCanManage() {
	      return this.get('can_manage');
	    }
	  }, {
	    key: 'revokeAccess',
	    value: function revokeAccess() {
	      return (0, _apiRequest2.default)('/payments/connected_bank_accounts/' + this.id + '/revoke', 'POST').then(function (response) {
	        return ConnectedBankAccount.fromJSON(response);
	      });
	    }
	  }], [{
	    key: 'getConnectedBankAccount',
	    value: function getConnectedBankAccount(accessToken) {
	      return (0, _apiRequest2.default)('/payments/connected_bank_account/', 'GET', {
	        access_token: accessToken
	      }).then(function (response) {
	        return ConnectedBankAccount.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'requestAccess',
	    value: function requestAccess(ownerName, ownerEmail, note, schoolId) {
	      return (0, _apiRequest2.default)('/payments/connected_bank_accounts', 'POST', {
	        owner_name: ownerName,
	        owner_email: ownerEmail,
	        reason: note,
	        organization_id: schoolId
	      }).then(function (account) {
	        return ConnectedBankAccount.fromJSON(account);
	      });
	    }
	  }, {
	    key: 'approve',
	    value: function approve(token, bankAccountName, accessToken, connectedBankAccountId) {
	      return (0, _apiRequest2.default)('/payments/connected_bank_accounts/approve', 'POST', {
	        token: token,
	        display_name: bankAccountName,
	        access_token: accessToken,
	        uuid: connectedBankAccountId
	      }).then(function (response) {
	        return ConnectedBankAccount.fromJSON(response);
	      });
	    }
	  }]);
	
	  return ConnectedBankAccount;
	}(_Entity3.default);
	
	ConnectedBankAccount.displayName = 'ConnectedBankAccount';
	exports.default = ConnectedBankAccount;

/***/ },
/* 2558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StripeBankAccount = function (_Entity) {
	  _inherits(StripeBankAccount, _Entity);
	
	  function StripeBankAccount() {
	    _classCallCheck(this, StripeBankAccount);
	
	    return _possibleConstructorReturn(this, (StripeBankAccount.__proto__ || Object.getPrototypeOf(StripeBankAccount)).apply(this, arguments));
	  }
	
	  _createClass(StripeBankAccount, [{
	    key: 'getBankName',
	    value: function getBankName() {
	      return this.get('bank_name');
	    }
	  }, {
	    key: 'isDefaultForCurrency',
	    value: function isDefaultForCurrency() {
	      return this.get('default_for_currency');
	    }
	  }, {
	    key: 'setDefaultForCurrency',
	    value: function setDefaultForCurrency(value) {
	      return this.set('default_for_currency', value);
	    }
	  }, {
	    key: 'getAccountNumberLastFourDigits',
	    value: function getAccountNumberLastFourDigits() {
	      return this.get('last4');
	    }
	  }, {
	    key: 'getFingerprint',
	    value: function getFingerprint() {
	      return this.get('fingerprint');
	    }
	  }, {
	    key: 'getAccountHolderName',
	    value: function getAccountHolderName() {
	      return this.get('account_holder_name');
	    }
	  }, {
	    key: 'getStatus',
	    value: function getStatus() {
	      return this.get('status');
	    }
	  }, {
	    key: 'getRoutingNumber',
	    value: function getRoutingNumber() {
	      return this.get('routing_number');
	    }
	  }, {
	    key: 'getIsDeleted',
	    value: function getIsDeleted() {
	      return this.get('deleted');
	    }
	  }]);
	
	  return StripeBankAccount;
	}(_Entity3.default);
	
	StripeBankAccount.displayName = 'StripeBankAccount';
	exports.default = StripeBankAccount;

/***/ },
/* 2559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ConnectedBankAccountConstants = __webpack_require__(2560);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _ConnectedBankAccounts = __webpack_require__(2561);
	
	var _ConnectedBankAccounts2 = _interopRequireDefault(_ConnectedBankAccounts);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConnectedBankAccountActions = {
	  requestAccess: function requestAccess() {
	    return _ConnectedBankAccount2.default.requestAccess.apply(_ConnectedBankAccount2.default, arguments).then(function (account) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ConnectedBankAccountConstants.ActionTypes.CREATE_CONNECTED_BANK_ACCOUNT,
	        connectedBankAccount: account
	      });
	      return account;
	    });
	  },
	  load: function load() {
	    return _ConnectedBankAccounts2.default.load().then(function (connectedBankAccounts) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ConnectedBankAccountConstants.ActionTypes.LOAD_CONNECTED_BANK_ACCOUNTS,
	        connectedBankAccounts: connectedBankAccounts
	      });
	
	      return connectedBankAccounts;
	    });
	  },
	  getConnectedBankAccount: function getConnectedBankAccount(accessToken) {
	    return _ConnectedBankAccount2.default.getConnectedBankAccount(accessToken).then(function (connectedBankAccount) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ConnectedBankAccountConstants.ActionTypes.GET_CONNECTED_BANK_ACCOUNT,
	        connectedBankAccount: connectedBankAccount
	      });
	      return connectedBankAccount;
	    });
	  },
	  reject: function reject(connectedBankAccountUUID) {
	    _RemindAPI2.default.request('/payments/connected_bank_accounts/' + connectedBankAccountUUID + '/reject', 'POST').then(function () {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ConnectedBankAccountConstants.ActionTypes.REJECT,
	        connectedBankAccountUUID: connectedBankAccountUUID
	      });
	    });
	  },
	
	
	  // $FlowFixMe TODO
	  approve: function approve(token, bankAccountName, accessToken, connectedBankAccountId) {
	    return _ConnectedBankAccount2.default.approve(token, bankAccountName, accessToken, connectedBankAccountId).then(function (connectedBankAccount) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ConnectedBankAccountConstants.ActionTypes.APPROVE,
	        connectedBankAccount: connectedBankAccount
	      });
	      return connectedBankAccount;
	    });
	  },
	  revokeAccess: function revokeAccess(account) {
	    return account.revokeAccess().then(function (connectedBankAccount) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ConnectedBankAccountConstants.ActionTypes.REVOKE_ACCESS,
	        connectedBankAccount: connectedBankAccount
	      });
	      return connectedBankAccount;
	    });
	  }
	};
	exports.default = ConnectedBankAccountActions;

/***/ },
/* 2560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Status = exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['CREATE_CONNECTED_BANK_ACCOUNT', 'LOAD_CONNECTED_BANK_ACCOUNTS', 'REVOKE_ACCESS', 'APPROVE', 'REJECT', 'GET_CONNECTED_BANK_ACCOUNT']); /*  weak */
	var Status = exports.Status = (0, _enumerate2.default)(['PENDING', 'APPROVED', 'REVOKED']);

/***/ },
/* 2561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConnectedBankAccounts = function (_Collection) {
	  _inherits(ConnectedBankAccounts, _Collection);
	
	  function ConnectedBankAccounts() {
	    _classCallCheck(this, ConnectedBankAccounts);
	
	    return _possibleConstructorReturn(this, (ConnectedBankAccounts.__proto__ || Object.getPrototypeOf(ConnectedBankAccounts)).apply(this, arguments));
	  }
	
	  _createClass(ConnectedBankAccounts, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _ConnectedBankAccount2.default;
	    }
	  }], [{
	    key: 'load',
	    value: function load() {
	      return (0, _apiRequest2.default)('/payments/connected_bank_accounts', 'GET').then(function (connectedbankAccounts) {
	        return ConnectedBankAccounts.fromJSON(connectedbankAccounts);
	      });
	    }
	  }]);
	
	  return ConnectedBankAccounts;
	}(_Collection3.default);
	
	ConnectedBankAccounts.displayName = 'ConnectedBankAccounts';
	exports.default = ConnectedBankAccounts;

/***/ },
/* 2562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.USD_CURRENCY = exports.STRIPE_CURRENCY = exports.STRIPE_COUNTRY = exports.STRIPE_ACCOUNT_TYPE_INDIVIDUAL = exports.PENDING_WALLET = exports.AVAILABLE_WALLET = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AVAILABLE_WALLET = exports.AVAILABLE_WALLET = 'available';
	var PENDING_WALLET = exports.PENDING_WALLET = 'pending';
	var STRIPE_ACCOUNT_TYPE_INDIVIDUAL = exports.STRIPE_ACCOUNT_TYPE_INDIVIDUAL = 'individual';
	var STRIPE_COUNTRY = exports.STRIPE_COUNTRY = 'US';
	var STRIPE_CURRENCY = exports.STRIPE_CURRENCY = 'USD';
	var USD_CURRENCY = exports.USD_CURRENCY = 'usd';
	
	var STRIPE_BASIC_VERIFICATIONS = ['legal_entity.dob.day', 'legal_entity.dob.month', 'legal_entity.dob.year', 'legal_entity.first_name', 'legal_entity.last_name'];
	
	var STRIPE_ADDITIONAL_VERIFICATIONS = ['legal_entity.personal_id_number'];
	
	var STRIPE_BANK_ACCOUNT_VERIFICATION = 'external_account';
	
	var PaymentAccount = function (_Entity) {
	  _inherits(PaymentAccount, _Entity);
	
	  function PaymentAccount() {
	    _classCallCheck(this, PaymentAccount);
	
	    return _possibleConstructorReturn(this, (PaymentAccount.__proto__ || Object.getPrototypeOf(PaymentAccount)).apply(this, arguments));
	  }
	
	  _createClass(PaymentAccount, [{
	    key: 'isTransferEnabled',
	    value: function isTransferEnabled() {
	      return this.get('transfers_enabled');
	    }
	  }, {
	    key: 'getBalance',
	    value: function getBalance() {
	      return this.get('balance');
	    }
	  }, {
	    key: 'needAdditionalVerification',
	    value: function needAdditionalVerification() {
	      return this.needVerifications(STRIPE_ADDITIONAL_VERIFICATIONS);
	    }
	  }, {
	    key: 'needBasicVerification',
	    value: function needBasicVerification() {
	      return this.needVerifications(STRIPE_BASIC_VERIFICATIONS);
	    }
	  }, {
	    key: 'needBankAccountVerification',
	    value: function needBankAccountVerification() {
	      return this.needVerifications([STRIPE_BANK_ACCOUNT_VERIFICATION]);
	    }
	
	    // $FlowFixMe
	
	  }, {
	    key: 'needVerifications',
	    value: function needVerifications(verifications) {
	      return !!this.get('verification')['fields_needed'].find(function (field) {
	        return verifications.includes(field);
	      });
	    }
	  }, {
	    key: 'getBalanceAmount',
	    value: function getBalanceAmount(wallet) {
	      var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : USD_CURRENCY;
	
	      var balance = this.getBalance();
	
	      if (balance && balance[wallet]) {
	        var currencyBalance = balance[wallet].find(function (w) {
	          return w.currency === currency;
	        });
	
	        if (currencyBalance) {
	          return currencyBalance.amount;
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'hasProvidedPersonalIdNumber',
	    value: function hasProvidedPersonalIdNumber() {
	      return !!this.get('personal_id_number_provided');
	    }
	  }, {
	    key: 'getAvailableBalanceAmount',
	    value: function getAvailableBalanceAmount() {
	      var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : USD_CURRENCY;
	
	      return this.getBalanceAmount(AVAILABLE_WALLET, currency);
	    }
	  }, {
	    key: 'getPendingBalanceAmount',
	    value: function getPendingBalanceAmount() {
	      var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : USD_CURRENCY;
	
	      return this.getBalanceAmount(PENDING_WALLET, currency);
	    }
	  }], [{
	    key: 'load',
	    value: function load() {
	      return (0, _apiRequest2.default)('/payments/account', 'GET').then(function (response) {
	        return PaymentAccount.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'patch',
	    value: function patch(account) {
	      return (0, _apiRequest2.default)('/payments/account', 'PATCH', { account: account }).then(function (response) {
	        return PaymentAccount.fromJSON(response);
	      });
	    }
	
	    // pii = personally identifiable information
	
	  }, {
	    key: 'patchPII',
	    value: function patchPII(piis) {
	      return (0, _apiRequest2.default)('/payments/account/pii', 'PATCH', { account: piis }).then(function (response) {
	        return PaymentAccount.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'addBankAccount',
	    value: function addBankAccount(token) {
	      return (0, _apiRequest2.default)('/payments/payment_destinations', 'POST', { token: token }).then(function (response) {
	        return PaymentAccount.fromJSON(response);
	      });
	    }
	  }, {
	    key: 'requestVerificationHelp',
	    value: function requestVerificationHelp() {
	      return (0, _apiRequest2.default)('/payments/account/need_manual_verification', 'POST');
	    }
	  }]);
	
	  return PaymentAccount;
	}(_Entity3.default);
	
	PaymentAccount.displayName = 'PaymentAccount';
	exports.default = PaymentAccount;

/***/ },
/* 2563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChequeImageView = exports.ACCOUNT_NUMBER = exports.ROUTING_NUMBER = undefined;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	__webpack_require__(2564);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var ROUTING_NUMBER = exports.ROUTING_NUMBER = 'routing_number';
	var ACCOUNT_NUMBER = exports.ACCOUNT_NUMBER = 'account_number';
	
	var ChequeImageView = exports.ChequeImageView = function ChequeImageView(_ref) {
	  var highlighted = _ref.highlighted;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ChequeImageView' },
	    _react2.default.createElement(_Image2.default, {
	      className: 'ChequeImageView-background',
	      src: __webpack_require__(2566)
	    }),
	    _react2.default.createElement(_Image2.default, {
	      className: (0, _classnames2.default)('ChequeImageView-routingNumber', {
	        'ChequeImageView-routingNumber-highlighted': highlighted === ROUTING_NUMBER
	      }),
	      src: __webpack_require__(2567)
	    }),
	    _react2.default.createElement(_Image2.default, {
	      className: (0, _classnames2.default)('ChequeImageView-accountNumber', {
	        'ChequeImageView-accountNumber-highlighted': highlighted === ACCOUNT_NUMBER
	      }),
	      src: __webpack_require__(2568)
	    })
	  );
	};

/***/ },
/* 2564 */
1136,
/* 2565 */,
/* 2566 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b1d83112218c4331e3868b2737fe34f9.png";

/***/ },
/* 2567 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "98b4f351860d4b6447b9917165e54a12.svg";

/***/ },
/* 2568 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a5269cb76e53cb66d02ca43ddadc0af9.svg";

/***/ },
/* 2569 */
1136,
/* 2570 */,
/* 2571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConnectedBankAccountActions = __webpack_require__(2559);
	
	var _ConnectedBankAccountActions2 = _interopRequireDefault(_ConnectedBankAccountActions);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Textarea = __webpack_require__(1598);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _FormSchoolPicker = __webpack_require__(2572);
	
	var _FormSchoolPicker2 = _interopRequireDefault(_FormSchoolPicker);
	
	var _CopyConstants = __webpack_require__(1733);
	
	__webpack_require__(2573);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'AddSchoolAccountForm',
	  getInitialState: function getInitialState() {
	    return {
	      loading: false
	    };
	  },
	  onInvalidSubmit: function onInvalidSubmit() {
	    _ToastActions2.default.showErrorToast('Enter all required fields to continue.');
	  },
	  onSubmit: function onSubmit(form) {
	    var _this = this;
	
	    this.setState({ loading: true });
	    var onDone = function onDone() {
	      if (_this.isMounted()) {
	        _this.setState({ loading: false });
	      }
	    };
	    var adminEmail = form.adminEmail,
	        adminName = form.adminName,
	        adminNote = form.adminNote,
	        adminSchool = form.adminSchool;
	
	
	    _ConnectedBankAccountActions2.default.requestAccess(adminName, adminEmail, adminNote, adminSchool).then(function (account) {
	      if (_this.props.onSchoolBankAccountAdded) {
	        _this.props.onSchoolBankAccountAdded(account);
	      }
	    }).then(onDone, function () {
	      _ToastActions2.default.showDefaultErrorToast();
	      onDone();
	    });
	  },
	  render: function render() {
	    var noteDefault = _CopyConstants.AddSchoolAccount.defaultNote1 + ' ' + _CopyConstants.AddSchoolAccount.defaultNote2 + ' ' + _CopyConstants.AddSchoolAccount.defaultNote3 + ' ' + _CopyConstants.AddSchoolAccount.defaultNote4 + ' ' + _CopyConstants.AddSchoolAccount.defaultNote5;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'AddSchoolAccountForm' },
	      _react2.default.createElement(
	        _Form2.default,
	        {
	          className: 'AddSchoolAccountForm-form',
	          onValidSubmit: this.onSubmit,
	          onInvalidSubmit: this.onInvalidSubmit },
	        _react2.default.createElement(
	          'div',
	          { className: 'AddSchoolAccountForm-fields' },
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Account administrator\u2019s name',
	            autofocus: true,
	            autoComplete: 'off',
	            name: 'adminName',
	            required: 'isRequired',
	            showErrorAfterBlur: true,
	            validationErrors: {
	              isRequired: 'A full name is required'
	            }
	          }),
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Account administrator\u2019s email',
	            name: 'adminEmail',
	            autoComplete: 'off',
	            required: 'isRequired',
	            validations: 'isEmail',
	            showErrorAfterBlur: true,
	            validationErrors: {
	              isEmail: 'A valid email address is required',
	              isRequired: 'An email address is required'
	            }
	          }),
	          _react2.default.createElement(
	            _Field2.default,
	            null,
	            _react2.default.createElement(_Label2.default, { text: 'School name' }),
	            _react2.default.createElement(_FormSchoolPicker2.default, {
	              className: 'AddSchoolAccountForm-schoolPicker',
	              name: 'adminSchool',
	              ref: 'schoolPicker',
	              onNoSchool: function onNoSchool() {}
	            })
	          ),
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Note to account administrator',
	            name: 'adminNote',
	            autoComplete: 'off',
	            component: _Textarea2.default,
	            className: 'AddSchoolAccountForm-textarea',
	            value: noteDefault,
	            required: 'isRequired',
	            placeholder: 'Why do you need access to deposit?',
	            showErrorAfterBlur: true,
	            validationErrors: {
	              isRequired: 'Must provide a reason for the deposit request'
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'AddSchoolAccountForm-footer' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'AddSchoolAccountForm-submit',
	              loading: this.state.loading,
	              eventElementName: 'AddSchoolAccountForm-submit' },
	            _react2.default.createElement(
	              _Text2.default,
	              { size: 'xsmall' },
	              'Continue'
	            )
	          )
	        )
	      )
	    );
	  }
	}); /*  weak */

/***/ },
/* 2572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainedFunction = __webpack_require__(1175);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Formsy = __webpack_require__(1345);
	
	var _Formsy2 = _interopRequireDefault(_Formsy);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _SchoolPicker = __webpack_require__(2510);
	
	var _SchoolPicker2 = _interopRequireDefault(_SchoolPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* A simple wrapped of SchoolPicker into a formzy mixin
	 * So that the component can be used like any other formzy
	 * component.
	 */
	var FormSchoolPicker = _react2.default.createClass({
	  displayName: 'FormSchoolPicker',
	
	
	  mixins: [_Formsy2.default.Mixin],
	
	  onChange: function onChange(value) {
	    this.setValue(value);
	  },
	  onCreateOrganization: function onCreateOrganization(org) {
	    this.onChange(org.id);
	    if (this.props.onCreateOrganization) {
	      this.props.onCreateOrganization(org);
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    return _react2.default.createElement(_SchoolPicker2.default, _extends({}, this.props, {
	      onSelect: (0, _createChainedFunction2.default)(function (value) {
	        return _this.onChange(value);
	      }, this.props.onSelect),
	      onClear: function onClear() {
	        return _this.onChange(null);
	      },
	      onCreateOrganization: this.onCreateOrganization
	    }));
	  }
	});
	
	exports.default = FormSchoolPicker;

/***/ },
/* 2573 */
1136,
/* 2574 */,
/* 2575 */
1136,
/* 2576 */,
/* 2577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CarouselPropTypes = __webpack_require__(2578);
	
	var _CarouselPropTypes2 = _interopRequireDefault(_CarouselPropTypes);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ProgressSteps = __webpack_require__(2579);
	
	var _ProgressSteps2 = _interopRequireDefault(_ProgressSteps);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2582);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var Carousel = function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  function Carousel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Carousel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      index: _this.props.initialIndex || 0
	    }, _this.getChildren = function () {
	      return (0, _lodash.compact)(_this.props.children);
	    }, _this.displayPage = function (index) {
	      _this.setState({ index: index });
	    }, _this.next = function () {
	      _this.displayPage(_this.state.index + 1);
	    }, _this.previous = function () {
	      _this.displayPage(_this.state.index - 1);
	    }, _this.isFirstPage = function () {
	      return _this.state.index === 0;
	    }, _this.renderPageControls = function () {
	      var onClick = _this.props.clickablePageControls ? _this.displayPage : null;
	      return _react2.default.createElement(_ProgressSteps2.default, {
	        labels: _this.props.progressLabels,
	        steps: _this.props.progressLabels && _this.props.progressLabels.length || _this.getChildren().length,
	        current: _this.state.index + 1,
	        onClick: onClick
	      });
	    }, _this.renderBackControllers = function () {
	      var button = void 0;
	      if (_this.isFirstPage() || _this.props.showBackControlsIndices === null) {
	        return button;
	      }
	
	      if (_this.state.index >= _this.props.showBackControlsIndices[0] && _this.state.index <= _this.props.showBackControlsIndices[1]) {
	        button = _react2.default.createElement(
	          _Button2.default,
	          { color: 'thunder', level: 'icon', onClick: _this.previous },
	          _react2.default.createElement(_Glyph2.default, { name: 'arrow-left', size: 'large', solo: true })
	        );
	      }
	      return button;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Carousel, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Carousel' },
	        _react2.default.createElement(
	          'div',
	          { className: 'Carousel-controls Carousel-control-back' },
	          this.props.showBackControlsIndices && this.renderBackControllers()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Carousel-controls Carousel-controls-pages' },
	          this.props.showPageControls && this.renderPageControls()
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _classnames2.default)('Carousel-page', {
	              'Carousel-page-withControls': this.props.showPageControls
	            }) },
	          this.getChildren()[this.state.index]
	        )
	      );
	    }
	  }]);
	
	  return Carousel;
	}(_react2.default.Component);
	
	Carousel.defaultProps = {
	  showPageControls: true,
	  showBackControlsIndices: null,
	  clickablePageControls: true
	};
	Carousel.displayName = 'Carousel';
	exports.default = Carousel;

/***/ },
/* 2578 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	var CarouselPropTypes = {
	  showBackControlsIndices: function showBackControlsIndices(props, propName) {
	    var indices = props[propName];
	    if (indices) {
	      if (indices.length !== 2 && Array.isArray(props[propName])) {
	        return new Error('ShowBackControlsIndices must be array of length 2');
	      }
	
	      if (!Number.isInteger(indices[0])) {
	        return new Error('ShowBackControlsIndices first index must be an integer');
	      }
	
	      if (!Number.isInteger(indices[1])) {
	        return new Error('ShowBackControlsIndices second index must be an integer');
	      }
	
	      if (indices[0] < 0 || indices[1] < 0) {
	        return new Error('ShowBackControlsIndices must be positive');
	      }
	
	      if (indices[0] > indices[1]) {
	        return new Error('ShowBackControlsIndices first index must be lower than second index');
	      }
	
	      if (indices[1] > props.children.length - 1) {
	        return new Error('ShowBackControlsIndices second index must be less than or equal to number of children');
	      }
	    }
	  }
	};
	
	exports.default = CarouselPropTypes;

/***/ },
/* 2579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2580);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Dot = function Dot(_ref) {
	  var _ref$label = _ref.label,
	      label = _ref$label === undefined ? null : _ref$label,
	      _ref$active = _ref.active,
	      active = _ref$active === undefined ? false : _ref$active,
	      _ref$current = _ref.current,
	      current = _ref$current === undefined ? false : _ref$current,
	      onClick = _ref.onClick;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'ProgressSteps-Step' },
	    label && _react2.default.createElement(
	      'div',
	      {
	        onClick: onClick,
	        className: (0, _classnames2.default)('ProgressSteps-Step-Label', {
	          'ProgressSteps-Step-Label-activated': active,
	          'ProgressSteps-Step-Label-current': current,
	          'ProgressSteps-Step-Label-link': !!onClick
	        }) },
	      label
	    ),
	    _react2.default.createElement('div', {
	      onClick: onClick,
	      className: (0, _classnames2.default)('ProgressSteps-Step-Dot', {
	        'ProgressSteps-Step-Dot-deactivated': !active && !current,
	        'ProgressSteps-Step-Dot-activated': active,
	        'ProgressSteps-Step-Dot-current': current,
	        'ProgressSteps-Step-Dot-link': !!onClick
	      })
	    })
	  );
	}; /*  weak */
	
	
	var Line = function Line(_ref2) {
	  var _ref2$active = _ref2.active,
	      active = _ref2$active === undefined ? false : _ref2$active;
	  return _react2.default.createElement('div', {
	    className: (0, _classnames2.default)('ProgressSteps-Line', {
	      'ProgressSteps-Line-deactivated': !active,
	      'ProgressSteps-Line-activated': active
	    })
	  });
	};
	
	
	var ProgressSteps = function ProgressSteps(_ref3) {
	  var _ref3$labels = _ref3.labels,
	      labels = _ref3$labels === undefined ? [] : _ref3$labels,
	      steps = _ref3.steps,
	      current = _ref3.current,
	      className = _ref3.className,
	      onClick = _ref3.onClick;
	
	  var progress = [];
	  var makeClickHandler = function makeClickHandler(index) {
	    if (index + 1 > current) {
	      // if clicking on a dot greater than the current
	      // do nothing.
	      return null;
	    } else {
	      return onClick ? function () {
	        return onClick(index);
	      } : null;
	    }
	  };
	
	  for (var i = 0; i < steps - 1; i++) {
	    progress.push(_react2.default.createElement(
	      'div',
	      { key: i },
	      _react2.default.createElement(Dot, {
	        label: labels[i],
	        current: i === current - 1,
	        active: i < current - 1,
	        onClick: makeClickHandler(i)
	      }),
	      _react2.default.createElement(Line, {
	        current: true,
	        active: i < current - 1
	      })
	    ));
	  }
	
	  progress.push(_react2.default.createElement(
	    'div',
	    { key: 'end' },
	    _react2.default.createElement(Dot, {
	      label: labels[steps - 1],
	      current: current === steps,
	      onClick: makeClickHandler(steps - 1)
	    })
	  ));
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('ProgressSteps', className) },
	    progress
	  );
	};
	
	exports.default = ProgressSteps;

/***/ },
/* 2580 */
1136,
/* 2581 */,
/* 2582 */
1136,
/* 2583 */,
/* 2584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CarouselPage = _react2.default.createClass({
	  displayName: 'CarouselPage',
	  render: function render() {
	    return _react2.default.createElement('div', _extends({}, this.props, {
	      className: (0, _classnames2.default)('CarouselPage', this.props.className)
	    }));
	  }
	});
	
	exports.default = CarouselPage;

/***/ },
/* 2585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _chainOnEnter = __webpack_require__(2586);
	
	var _chainOnEnter2 = _interopRequireDefault(_chainOnEnter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var chainOnEnterMixin = function chainOnEnterMixin(mixins) {
	  return {
	    statics: {
	      onEnter: (0, _chainOnEnter2.default)(mixins)
	    }
	  };
	}; /*  weak */
	/**
	 *
	 * DEPRECATED! Use 'components/lib/chainOnEnter' instead of using a mixin.
	 *
	 * This enables the use of multiple mixins that provide static `onEnter` methods to be
	 * used with `react-router` views.
	 *
	 * This is used by providing an array of mixins like so:
	 *
	 *   mixins: [
	 *     chainOnEnter([RequireUser, RequireDesktop])
	 *   ]
	 *
	 * The order matters. chainOnEnter will skip any remaining onEnters once replaceWith is called.
	 *
	 * You must specify the onEnter method in the route definition, or it will never get called:
	 *
	 *   <Route
	 *     path="/chat/leave/:token"
	 *     component={LeaveChatView}
	 *     onEnter={LeaveChatView.onEnter}
	 *    />
	 */
	
	exports.default = chainOnEnterMixin;

/***/ },
/* 2586 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = chainOnEnter;
	
	
	var ASYNC_ARITY = 3;
	
	// returns a fn for react-route onEnter static prop.
	
	
	/**
	 * This enables the use of multiple mixins that provide static `onEnter` methods to be
	 * used with `react-router` views.
	 *
	 * This is used by providing an array of mixins like so:
	 *
	 *   static onEnter = requireOnEnter([RequireUser])
	 *
	 * The order matters. chainOnEnter will skip any remaining onEnters once replaceWith is called.
	 *
	 * You must specify the onEnter method in the route definition, or it will never get called:
	 *
	 *   <Route
	 *     path="/chat/leave/:token"
	 *     component={LeaveChatView}
	 *     onEnter={LeaveChatView.onEnter}
	 *    />
	 */
	
	function chainOnEnter(mixins) {
	  return function (nextState, replaceWith, routerCallback) {
	    var i = 0;
	    var replaceCalled = false;
	    var replaceOnce = function replaceOnce(loc) {
	      replaceCalled = true;
	      replaceWith(loc);
	    };
	    var recursiveCb = function recursiveCb() {
	      if (i < mixins.length && !replaceCalled) {
	        var nextOnEnter = mixins[i++].statics.onEnter;
	        if (nextOnEnter.length < ASYNC_ARITY) {
	          nextOnEnter(nextState, replaceOnce);
	          recursiveCb();
	        } else {
	          nextOnEnter(nextState, replaceOnce, recursiveCb);
	        }
	      } else {
	        routerCallback();
	      }
	    };
	    recursiveCb();
	  };
	}

/***/ },
/* 2587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _Timestamp = __webpack_require__(1683);
	
	var _Timestamp2 = _interopRequireDefault(_Timestamp);
	
	var _Transaction = __webpack_require__(982);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var DepositConfirmation = function (_React$Component) {
	  _inherits(DepositConfirmation, _React$Component);
	
	  function DepositConfirmation() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DepositConfirmation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DepositConfirmation.__proto__ || Object.getPrototypeOf(DepositConfirmation)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
	      var subtext = _this.props.transaction ? _react2.default.createElement(
	        'span',
	        null,
	        'The funds should arrive in your account: ',
	        _react2.default.createElement(_Timestamp2.default, { date: _this.props.transaction.getAvailableAt() })
	      ) : _react2.default.createElement(
	        'span',
	        null,
	        'The funds should arrive in your account in 1-2 business days'
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'DepositConfirmation' },
	        _react2.default.createElement(
	          _Container2.default,
	          { size: 'medium' },
	          _react2.default.createElement(_TitleHeader2.default, {
	            image: __webpack_require__(2588),
	            title: 'Deposit complete',
	            subtext: subtext,
	            size: 'xlarge'
	          }),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              onClick: _this.props.onComplete,
	              eventScreenName: _EventTrackingConstants2.default.DEPOSIT_RECEIPT,
	              eventElementName: 'return_to_campaigns' },
	            _this.props.onCompleteText
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return DepositConfirmation;
	}(_react2.default.Component);
	
	DepositConfirmation.defaultProps = {
	  onCompleteText: 'Got it'
	};
	DepositConfirmation.displayName = 'DepositConfirmation';
	exports.default = DepositConfirmation;

/***/ },
/* 2588 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "32b5f9598203b58447a7f11129cee262.svg";

/***/ },
/* 2589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ExternalAccountResourceStore = __webpack_require__(2590);
	
	var _ExternalAccountResourceStore2 = _interopRequireDefault(_ExternalAccountResourceStore);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _DepositButton = __webpack_require__(2592);
	
	var _DepositButton2 = _interopRequireDefault(_DepositButton);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(2595);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var DepositSetupReceipt = function DepositSetupReceipt(_ref) {
	  var onDepositCompleted = _ref.onDepositCompleted,
	      activity = _ref.activity;
	
	  var externalAccountResource = _ExternalAccountResourceStore2.default.getExternalAccountResources().first();
	  var bankAccount = externalAccountResource.getBankAccount();
	  return _react2.default.createElement(
	    'div',
	    { className: 'DepositSetupReceipt' },
	    _react2.default.createElement(
	      _Container2.default,
	      { size: 'medium' },
	      _react2.default.createElement(
	        'div',
	        { className: 'DepositSetupReceipt-header' },
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            size: 'xxlarge',
	            weight: 'semibold' },
	          'Review and confirm your deposit information.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'DepositSetupReceipt-accountInfoContainer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'DepositSetupReceipt-accountName' },
	          _react2.default.createElement(
	            _Text2.default,
	            {
	              className: 'DepositSetupReceipt-accountInfoLabel',
	              weight: 'light',
	              color: 'pitch' },
	            'Account Name:'
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            {
	              truncate: true,
	              className: 'DepositSetupReceipt-accountInfo',
	              weight: 'light',
	              color: 'pitch' },
	            bankAccount.getBankName()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'DepositSetupReceipt-routingNumber' },
	          _react2.default.createElement(
	            _Text2.default,
	            {
	              className: 'DepositSetupReceipt-accountInfoLabel',
	              weight: 'light',
	              color: 'pitch' },
	            'Routing Number:'
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            {
	              className: 'DepositSetupReceipt-accountInfo',
	              weight: 'light',
	              color: 'pitch' },
	            bankAccount.getRoutingNumber()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'DepositSetupReceipt-accountNumber' },
	          _react2.default.createElement(
	            _Text2.default,
	            {
	              className: 'DepositSetupReceipt-accountInfoLabel',
	              weight: 'light',
	              color: 'pitch' },
	            'Account Number:'
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            {
	              className: 'DepositSetupReceipt-accountInfo',
	              weight: 'light',
	              color: 'pitch' },
	            '******',
	            bankAccount.getAccountNumberLastFourDigits()
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'DepositSetupReceipt-total' },
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            weight: 'semibold' },
	          'Total Deposit'
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            className: 'DepositSetupReceipt-accountInfo',
	            weight: 'semibold' },
	          _react2.default.createElement(_Money2.default, { cents: activity.getCurrentBalance() })
	        )
	      ),
	      _react2.default.createElement(_DepositButton2.default, {
	        className: 'DepositSetupReceipt-submit',
	        activity: activity,
	        amount: activity.getCurrentBalance(),
	        account: bankAccount,
	        onSuccess: onDepositCompleted
	      })
	    )
	  );
	};
	
	exports.default = DepositSetupReceipt;

/***/ },
/* 2590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ExternalAccountResource = __webpack_require__(2591);
	
	var _utils = __webpack_require__(956);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExternalAccountResourceStore = function (_ReduceStore) {
	  _inherits(ExternalAccountResourceStore, _ReduceStore);
	
	  function ExternalAccountResourceStore() {
	    _classCallCheck(this, ExternalAccountResourceStore);
	
	    return _possibleConstructorReturn(this, (ExternalAccountResourceStore.__proto__ || Object.getPrototypeOf(ExternalAccountResourceStore)).apply(this, arguments));
	  }
	
	  _createClass(ExternalAccountResourceStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return _ExternalAccountResource.initialState;
	    }
	  }, {
	    key: 'getExternalAccountResources',
	    value: function getExternalAccountResources() {
	      return this.getState().externalAccountResources;
	    }
	  }, {
	    key: 'getBankAccounts',
	    value: function getBankAccounts() {
	      return this.getState().externalAccountResources.map(function (ea) {
	        return ea.getBankAccount();
	      });
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      return (0, _ExternalAccountResource.reducer)(state, action);
	    }
	  }]);
	
	  return ExternalAccountResourceStore;
	}(_utils.ReduceStore);
	
	ExternalAccountResourceStore.displayName = 'ExternalAccountResourceStore';
	exports.default = new ExternalAccountResourceStore(_Dispatcher.dispatcher);

/***/ },
/* 2591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	exports.reducer = reducer;
	
	var _ExternalAccountResourceConstants = __webpack_require__(2554);
	
	var _ExternalAccountResources = __webpack_require__(2555);
	
	var _ExternalAccountResources2 = _interopRequireDefault(_ExternalAccountResources);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  externalAccountResources: new _ExternalAccountResources2.default()
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var externalAccountResources = void 0;
	  var resourceToRemove = void 0;
	
	  switch (action.type) {
	    case _ExternalAccountResourceConstants.ActionTypes.DELETE_BANK_ACCOUNT:
	      externalAccountResources = state.externalAccountResources.clone();
	      resourceToRemove = externalAccountResources.find(function (ea) {
	        return ea.getBankAccount().id === action.bankAccount.id;
	      });
	      externalAccountResources.remove(resourceToRemove);
	      return _extends({}, state, { externalAccountResources: externalAccountResources });
	
	    case _ExternalAccountResourceConstants.ActionTypes.UPDATE_PRIMARY_BANK_ACCOUNT:
	      externalAccountResources = state.externalAccountResources.clone();
	      externalAccountResources.forEach(function (ea) {
	        var bankAccount = ea.getBankAccount();
	        if (bankAccount.id === action.bankAccount.id) {
	          bankAccount.setDefaultForCurrency(true);
	        } else {
	          bankAccount.setDefaultForCurrency(false);
	        }
	      });
	      return _extends({}, state, { externalAccountResources: externalAccountResources });
	
	    case _ExternalAccountResourceConstants.ActionTypes.CREATE_BANK_ACCOUNT:
	      externalAccountResources = state.externalAccountResources.clone();
	      externalAccountResources.add(action.externalAccountResource);
	      return _extends({}, state, { externalAccountResources: externalAccountResources });
	
	    case _ExternalAccountResourceConstants.ActionTypes.LOAD_BANK_ACCOUNTS:
	      externalAccountResources = action.externalAccountResources;
	      return _extends({}, state, { externalAccountResources: externalAccountResources });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _StripeBankAccount = __webpack_require__(2558);
	
	var _StripeBankAccount2 = _interopRequireDefault(_StripeBankAccount);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _PaymentAccountActions = __webpack_require__(2593);
	
	var _PaymentAccountActions2 = _interopRequireDefault(_PaymentAccountActions);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _TransactionActions = __webpack_require__(1997);
	
	var _TransactionActions2 = _interopRequireDefault(_TransactionActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DepositButton = _react2.default.createClass({
	  displayName: 'DepositButton',
	  getInitialState: function getInitialState() {
	    return {
	      loading: false
	    };
	  },
	  render: function render() {
	    var _this = this;
	
	    var onClick = function onClick() {
	      _this.setState({ loading: true });
	
	      var onDone = function onDone() {
	        if (_this.isMounted()) {
	          _this.setState({ loading: false });
	        }
	      };
	
	      var onError = function onError() {
	        return _ToastActions2.default.showDefaultErrorToast();
	      };
	      var reloadAccount = function reloadAccount() {
	        return _PaymentAccountActions2.default.load();
	      };
	      var reloadActivity = function reloadActivity() {
	        return _ActivityActions2.default.loadByUuid(_this.props.activity.id);
	      };
	
	      _TransactionActions2.default.createWithdrawTransaction(_this.props.activity.id, _this.props.account.id, _this.props.amount).then(reloadAccount).then(reloadActivity).then(_this.props.onSuccess, onError).then(onDone, onDone);
	    };
	
	    return _react2.default.createElement(
	      _Button2.default,
	      _extends({}, this.props, {
	        loading: this.state.loading,
	        onClick: onClick,
	        eventScreenName: _EventTrackingConstants2.default.CONFIRM_DEPOSIT,
	        eventElementName: 'deposit' }),
	      'Deposit ',
	      _react2.default.createElement(_Money2.default, { cents: this.props.amount })
	    );
	  }
	});
	
	exports.default = DepositButton;

/***/ },
/* 2593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PaymentAccountConstants = __webpack_require__(2594);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _PaymentAccount = __webpack_require__(2562);
	
	var _PaymentAccount2 = _interopRequireDefault(_PaymentAccount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentAccountActions = {
	  load: function load() {
	    return _PaymentAccount2.default.load().then(function (paymentAccount) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _PaymentAccountConstants.ActionTypes.LOAD_PAYMENT_ACCOUNT,
	        paymentAccount: paymentAccount
	      });
	
	      return paymentAccount;
	    });
	  },
	  requestVerificationHelp: function requestVerificationHelp() {
	    return _PaymentAccount2.default.requestVerificationHelp.apply(_PaymentAccount2.default, arguments);
	  },
	  patchPII: function patchPII() {
	    return _PaymentAccount2.default.patchPII.apply(_PaymentAccount2.default, arguments).then(function (paymentAccount) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _PaymentAccountConstants.ActionTypes.PATCH_PAYMENT_ACCOUNT,
	        paymentAccount: paymentAccount
	      });
	    });
	  },
	  patch: function patch() {
	    return _PaymentAccount2.default.patch.apply(_PaymentAccount2.default, arguments).then(function (paymentAccount) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _PaymentAccountConstants.ActionTypes.PATCH_PAYMENT_ACCOUNT,
	        paymentAccount: paymentAccount
	      });
	
	      return paymentAccount;
	    });
	  }
	};
	exports.default = PaymentAccountActions;

/***/ },
/* 2594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['LOAD_PAYMENT_ACCOUNT', 'PATCH_PAYMENT_ACCOUNT', 'WITHDRAW_MONEY']); /*  weak */

/***/ },
/* 2595 */
1136,
/* 2596 */,
/* 2597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	__webpack_require__(2598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DepositSetupViewHeader = _react2.default.createClass({
	  displayName: 'DepositSetupViewHeader',
	  render: function render() {
	    return _react2.default.createElement(_TitleHeader2.default, {
	      title: this.props.title,
	      subtext: this.props.subtext,
	      className: 'DepositSetupViewHeader'
	    });
	  }
	});
	exports.default = DepositSetupViewHeader;

/***/ },
/* 2598 */
1136,
/* 2599 */,
/* 2600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FormDateInputs = __webpack_require__(2601);
	
	var _PaymentAccount = __webpack_require__(2562);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _EncryptionNotice = __webpack_require__(1970);
	
	var _EncryptionNotice2 = _interopRequireDefault(_EncryptionNotice);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormSelect = __webpack_require__(1365);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _PaymentAccountActions = __webpack_require__(2593);
	
	var _PaymentAccountActions2 = _interopRequireDefault(_PaymentAccountActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _USState = __webpack_require__(2512);
	
	var _USState2 = _interopRequireDefault(_USState);
	
	__webpack_require__(2602);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COUNTRY_CODE = 'US'; /*  weak */
	
	
	var IdentityVerificationView = _react2.default.createClass({
	  displayName: 'IdentityVerificationView',
	  getInitialState: function getInitialState() {
	    return {
	      disabled: true,
	      loading: false
	    };
	  },
	  handleFormSubmit: function handleFormSubmit(value, resetForm, invalidateForm) {
	    var _this = this;
	
	    var onFailure = function onFailure(error) {
	      _ToastActions2.default.showAPIError(error);
	
	      var errors = {};
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = error.field_errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var field = _step.value;
	
	          errors[field['field_name']] = field.messages.join(', ');
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      invalidateForm(errors);
	    };
	
	    value.type = _PaymentAccount.STRIPE_ACCOUNT_TYPE_INDIVIDUAL;
	    value['address'] = value['address'] || {};
	    value['address'].country = COUNTRY_CODE;
	
	    this.setState({ loading: true });
	    var onDone = function onDone() {
	      if (_this.isMounted()) {
	        _this.setState({ loading: false });
	      }
	    };
	
	    return _PaymentAccountActions2.default.patch(value).then(this.props.onVerified, onFailure).then(onDone, onDone);
	  },
	  render: function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'IdentityVerificationView' },
	      _react2.default.createElement(
	        _Container2.default,
	        { size: 'medium' },
	        _react2.default.createElement(
	          _Form2.default,
	          {
	            className: 'IdentityVerificationView-form',
	            onValid: function onValid() {
	              return _this2.setState({ disabled: false });
	            },
	            onInvalid: function onInvalid() {
	              return _this2.setState({ disabled: true });
	            },
	            onValidSubmit: this.handleFormSubmit },
	          _react2.default.createElement(
	            'div',
	            { className: 'IdentityVerificationView-inputs' },
	            _react2.default.createElement(
	              'div',
	              { className: 'IdentityVerificationView-columns IdentityVerificationView-columns2' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_FormInput2.default, {
	                  label: 'First name',
	                  required: true,
	                  name: 'first_name',
	                  validations: { maxLength: 60 },
	                  validationErrors: {
	                    maxLength: 'First Name can’t be longer than 60 characters',
	                    isDefaultRequiredValue: 'First name is required'
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_FormInput2.default, {
	                  label: 'Last name',
	                  required: true,
	                  name: 'last_name',
	                  validations: { maxLength: 60 },
	                  validationErrors: {
	                    maxLength: 'Last Name can’t be longer than 60 characters',
	                    isDefaultRequiredValue: 'Last name is required'
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'IdentityVerificationView-columns' },
	              _react2.default.createElement(_FormInput2.default, {
	                label: 'Address',
	                required: true,
	                name: 'address[line1]',
	                validationErrors: {
	                  isDefaultRequiredValue: 'Address is required'
	                }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'IdentityVerificationView-columns IdentityVerificationView-columns3' },
	              _react2.default.createElement(
	                'div',
	                { className: 'IdentityVerificationView-columns3-city' },
	                _react2.default.createElement(_FormInput2.default, {
	                  label: 'City',
	                  required: true,
	                  name: 'address[city]',
	                  validations: { maxLength: 60 },
	                  validationErrors: {
	                    maxLength: 'City can’t be longer than 60 characters',
	                    isDefaultRequiredValue: 'City is required'
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'IdentityVerificationView-columns3-state' },
	                _react2.default.createElement(_FormSelect2.default, {
	                  label: 'State',
	                  required: true,
	                  name: 'address[state]',
	                  placeholder: '',
	                  options: _USState2.default,
	                  inputProps: { maxLength: 12 },
	                  validationErrors: {
	                    isDefaultRequiredValue: 'Please select a state'
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'IdentityVerificationView-columns3-zipcode' },
	                _react2.default.createElement(_FormInput2.default, {
	                  label: 'ZIP code',
	                  required: true,
	                  name: 'address[postal_code]',
	                  autoComplete: 'postal-code',
	                  className: 'postal-code',
	                  validations: { maxLength: 60 },
	                  validationErrors: {
	                    maxLength: 'ZIP code can’t be longer than 60 characters',
	                    isDefaultRequiredValue: 'ZIP code is required'
	                  }
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'IdentityVerificationView-dateandssn' },
	              _react2.default.createElement(
	                'div',
	                { className: 'IdentityVerificationView-dateandssn-date' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _Label2.default,
	                    null,
	                    'Date of birth'
	                  ),
	                  _react2.default.createElement(_Label2.default, { hidden: true, 'aria-label': 'Month' }),
	                  _react2.default.createElement(_FormDateInputs.FormMonthSelect, {
	                    required: true,
	                    name: 'dob[month]',
	                    autoComplete: 'bday-month',
	                    placeholder: 'Month',
	                    className: 'bday-month',
	                    inputProps: { maxLength: 2 },
	                    validationErrors: {
	                      isDefaultRequiredValue: 'Please select a month'
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_Label2.default, { 'aria-label': 'Day' }),
	                  _react2.default.createElement(_FormDateInputs.FormDaySelect, {
	                    required: true,
	                    name: 'dob[day]',
	                    autoComplete: 'bday-day',
	                    placeholder: 'Day',
	                    className: 'bday-day',
	                    inputProps: { maxLength: 2 },
	                    validationErrors: {
	                      isDefaultRequiredValue: 'Please select a day'
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_Label2.default, { 'aria-label': 'Year' }),
	                  _react2.default.createElement(_FormDateInputs.FormYearSelect, {
	                    required: true,
	                    name: 'dob[year]',
	                    autoComplete: 'bday-year',
	                    inputProps: { maxLength: 4 },
	                    placeholder: 'Year',
	                    className: 'bday-year',
	                    validationErrors: {
	                      isDefaultRequiredValue: 'Please select a year'
	                    }
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'IdentityVerificationView-dateandssn-ssn' },
	                _react2.default.createElement(_FormInput2.default, {
	                  label: 'Last 4 digits of SSN',
	                  required: true,
	                  name: 'ssn',
	                  showErrorAfterBlur: true,
	                  maxLength: 4,
	                  validations: { isLength: 4 },
	                  validationErrors: {
	                    isLength: 'SSN must be 4 characters',
	                    isDefaultRequiredValue: 'Last 4 digits of SSN is required'
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              loading: this.state.loading,
	              className: 'IdentityVerificationView-submit',
	              disabled: this.state.disabled,
	              eventScreenName: _EventTrackingConstants2.default.CREATE_DEPOSIT_ADDRESS,
	              eventElementName: 'continue' },
	            'Continue'
	          )
	        ),
	        _react2.default.createElement(_EncryptionNotice2.default, null)
	      )
	    );
	  }
	});
	
	exports.default = IdentityVerificationView;

/***/ },
/* 2601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FormYearSelect = exports.FormMonthSelect = exports.FormDaySelect = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	var _lodash = __webpack_require__(555);
	
	var _FormSelect = __webpack_require__(1365);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentYear = new Date().getFullYear();
	var computeRange = function computeRange(from, to) {
	  return (0, _lodash.range)(from, to + 1).map(function (number) {
	    return { value: number, label: number.toString() };
	  });
	};
	
	var dayRange = computeRange(1, 31);
	var monthRange = computeRange(1, 12);
	var yearRange = computeRange(currentYear - 100, currentYear).reverse();
	
	var FormDaySelect = function FormDaySelect(props) {
	  return _react2.default.createElement(_FormSelect2.default, _extends({}, props, { options: dayRange }));
	};
	var FormMonthSelect = function FormMonthSelect(props) {
	  return _react2.default.createElement(_FormSelect2.default, _extends({}, props, { options: monthRange }));
	};
	var FormYearSelect = function FormYearSelect(props) {
	  return _react2.default.createElement(_FormSelect2.default, _extends({}, props, { options: yearRange }));
	};
	
	exports.FormDaySelect = FormDaySelect;
	exports.FormMonthSelect = FormMonthSelect;
	exports.FormYearSelect = FormYearSelect;

/***/ },
/* 2602 */
1136,
/* 2603 */,
/* 2604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _PaymentAccount = __webpack_require__(2605);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PaymentAccountStore = function (_ReduceStore) {
	  _inherits(PaymentAccountStore, _ReduceStore);
	
	  function PaymentAccountStore() {
	    _classCallCheck(this, PaymentAccountStore);
	
	    return _possibleConstructorReturn(this, (PaymentAccountStore.__proto__ || Object.getPrototypeOf(PaymentAccountStore)).apply(this, arguments));
	  }
	
	  _createClass(PaymentAccountStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return _PaymentAccount.initialState;
	    }
	  }, {
	    key: 'getPaymentAccount',
	    value: function getPaymentAccount() {
	      return this.getState().paymentAccount;
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      return (0, _PaymentAccount.reducer)(state, action);
	    }
	  }]);
	
	  return PaymentAccountStore;
	}(_utils.ReduceStore);
	
	PaymentAccountStore.displayName = 'PaymentAccountStore';
	exports.default = new PaymentAccountStore(_Dispatcher.dispatcher);

/***/ },
/* 2605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	exports.reducer = reducer;
	
	var _PaymentAccountConstants = __webpack_require__(2594);
	
	var initialState = exports.initialState = {
	  paymentAccount: null
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _PaymentAccountConstants.ActionTypes.LOAD_PAYMENT_ACCOUNT:
	    case _PaymentAccountConstants.ActionTypes.PATCH_PAYMENT_ACCOUNT:
	      return _extends({}, state, { paymentAccount: action.paymentAccount });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PaymentAccountActions = __webpack_require__(2593);
	
	var _PaymentAccountActions2 = _interopRequireDefault(_PaymentAccountActions);
	
	var _PaymentAccountStore = __webpack_require__(2604);
	
	var _PaymentAccountStore2 = _interopRequireDefault(_PaymentAccountStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequirePaymentAccount = {
	  statics: {
	    onEnter: function onEnter(nextState, replaceWith, callback) {
	      if (_PaymentAccountStore2.default.getPaymentAccount()) {
	        callback();
	      } else {
	        _PaymentAccountActions2.default.load().then(function () {
	          return callback();
	        });
	      }
	    }
	  }
	};
	
	exports.default = RequirePaymentAccount;

/***/ },
/* 2607 */
1136,
/* 2608 */,
/* 2609 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNDBweCIgaGVpZ2h0PSIxNDBweCIgdmlld0JveD0iMTUgMCAxNDAgMTQwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDE1IDAgMTQwIDE0MCI+PGNpcmNsZSBmaWxsPSIjZjJmM2Y1IiBjeD0iNzkuMSIgY3k9IjcwIiByPSI2Mi44Ii8+PHBhdGggZmlsbD0iI2Q2OWYyNyIgZD0iTTgzLDMwLjFjLTEuNC0xLjEtMy40LTEuMS00LjgsMEwzNy43LDYyLjN2MTkuOWg4NS43VjYyLjNMODMsMzAuMXoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJtMTE2LjMgMzMuNmgtOC44LTUzLjktOC44Yy0uOSAwLTEuNi43LTEuNiAxLjZ2OS40IDM3LjloNzQuOHYtMzcuOS05LjRjLS4xLS45LS44LTEuNi0xLjctMS42Ii8+PGcgZmlsbD0iI2RjZGVlMiI+PHBhdGggZD0ibTQ4LjkgNjguNGg2Mi4zdjQuMmgtNjIuM3YtNC4yIi8+PHBhdGggZD0ibTQ4LjkgNTguM2g2Mi4zdjQuMmgtNjIuM3YtNC4yIi8+PHBhdGggZD0ibTQ2LjYgNzguNWg2OC4xdjQuMmgtNjguMXYtNC4yIi8+PC9nPjxwYXRoIGZpbGw9IiNlYWIzMjgiIGQ9Im04MC42IDgxLjlsLTQyLjktMTkuNnY0NC44YzAgMS4yLjkgMiAyIDJoODEuN2MxLjIgMCAyLS45IDItMnYtNS41LTM5LjNsLTQyLjggMTkuNiIvPjxwYXRoIGZpbGw9IiNmZmMzMmMiIGQ9Ik0zOS44LDEwOS4xaDgxLjdMODIuNiw4M2MtMS4zLTAuNi0yLjctMC42LTQsMEwzOS44LDEwOS4xIi8+PGcgZmlsbD0iIzkwOTE5MyI+PHBhdGggZD0ibTU2IDM5Yy00IDAtNy4xIDMuMy03LjEgNy4xIDAgNCAzLjMgNy4xIDcuMSA3LjEgNCAwIDcuMS0zLjMgNy4xLTcuMS4xLTQtMy4xLTcuMS03LjEtNy4xbTAgMTMuMmMtMy40IDAtNi4xLTIuNy02LjEtNi4xczIuNy02LjEgNi4xLTYuMSA2LjEgMi43IDYuMSA2LjEtMi43IDYuMS02LjEgNi4xIi8+PHBhdGggZD0ibTU2LjcgNDUuN2MtLjUtLjEtMS41LjEtMS42LS43IDAtLjQuNC0uNy45LS43cy45LjIuOS43aDEuMWMwIDAgMCAwIDAtLjEgMC0uOC0uNi0xLjQtMS40LTEuNnYtLjFjMC0uNC0uMi0uNi0uNi0uNi0uNCAwLS42LjItLjYuNnYuMmMtLjguMi0xLjUuOC0xLjUgMS42IDAgMCAwIDAgMCAuMSAwIC41LjIuOS42IDEuMi4yLjIuNy40IDEuMS41LjUgMCAxLjIgMCAxLjQuNnYuMWMwIC40LS40LjctLjkuN3MtLjktLjItLjktLjd2LS4xaC0xLjJ2LjFjMCAuOC42IDEuNCAxLjQgMS42di4yYzAgLjQuMi42LjYuNnMuNi0uMi42LS42di0uNGMuOC0uMiAxLjUtLjggMS41LTEuNnYtLjFjLS4xLS43LS43LTEuMy0xLjQtMS41Ii8+PC9nPjxjaXJjbGUgZmlsbD0iI2ZmZiIgY3g9IjEzMC42IiBjeT0iMTA5LjEiIHI9IjE2LjEiLz48cGF0aCBmaWxsPSIjMTdhNjg3IiBkPSJtMTMwLjMgODUuN2MtMTIuOSAwLTIzLjQgMTAuNS0yMy40IDIzLjRzMTAuNSAyMy40IDIzLjQgMjMuNCAyMy40LTEwLjUgMjMuNC0yMy40LTEwLjUtMjMuNC0yMy40LTIzLjRtOS41IDE2LjRsLTExLjQgMTUuMy03LjMtNy42LjItLjJjLjYtLjYgMS40LS44IDIuMi0uOC45IDAgMS45LjQgMi41IDEuMWwxLjkgMS45Yy44LS45IDQuNy02LjEgNy4xLTkuNS42LS43IDEuMy0xLjIgMi4yLTEuMy44LS4xIDEuOC4xIDIuMy43bC4yLjIuMS4yIi8+PC9zdmc+"

/***/ },
/* 2610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EmailUnsubscribeView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _i18n = __webpack_require__(1018);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _jsonwebtoken = __webpack_require__(2611);
	
	var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _DialogButton = __webpack_require__(1327);
	
	var _DialogButton2 = _interopRequireDefault(_DialogButton);
	
	var _Copy = __webpack_require__(1461);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _DeviceStore = __webpack_require__(1019);
	
	var _DeviceStore2 = _interopRequireDefault(_DeviceStore);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _ErrorActions = __webpack_require__(1427);
	
	var _ErrorActions2 = _interopRequireDefault(_ErrorActions);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailUnsubscribeView = exports.EmailUnsubscribeView = function (_Component) {
	  _inherits(EmailUnsubscribeView, _Component);
	
	  _createClass(EmailUnsubscribeView, null, [{
	    key: 'onEnter',
	    value: function onEnter(nextState, replaceWith, callback) {
	      _AuthActions2.default.jwtTokenSignIn(nextState.params.token);
	
	      // Load the device
	      _UserActions2.default.loadCurrentUser(nextState.params.token).then(function () {
	        return _DeviceActions2.default.loadDevices();
	      }, function () {
	        _ErrorActions2.default.expiredToken('EMAIL_UNSUBSCRIBE');
	        replaceWith('/error');
	        callback();
	      }).then(function () {
	        var payload = _jsonwebtoken2.default.decode(_CurrentUser2.default.getToken());
	        var device = _DeviceStore2.default.getDevice(payload.device_id);
	
	        if (!device) {
	          replaceWith('/error');
	        }
	
	        callback();
	      }, function () {
	        replaceWith('/error');
	        callback();
	      });
	    }
	  }, {
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default, _DeviceStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var payload = _CurrentUser2.default.getToken() && _jsonwebtoken2.default.decode(_CurrentUser2.default.getToken());
	      var device = payload.device_id && _DeviceStore2.default.getDevice(payload.device_id);
	
	      if (!device) {
	        return {};
	      }
	
	      return { device: device, enabled: device.isEnabled() };
	    }
	  }]);
	
	  function EmailUnsubscribeView(props) {
	    _classCallCheck(this, EmailUnsubscribeView);
	
	    var _this = _possibleConstructorReturn(this, (EmailUnsubscribeView.__proto__ || Object.getPrototypeOf(EmailUnsubscribeView)).call(this, props));
	
	    _this.handleDisableButtonClick = function () {
	      _DeviceActions2.default.disable(_this.state.device);
	    };
	
	    var payload = _CurrentUser2.default.getToken() && _jsonwebtoken2.default.decode(_CurrentUser2.default.getToken());
	    var device = payload.device_id && _DeviceStore2.default.getDevice(payload.device_id);
	
	    if (!device) {
	      var _ret;
	
	      return _ret = {}, _possibleConstructorReturn(_this, _ret);
	    }
	
	    _this.state = { device: device, enabled: device.isEnabled() };
	    return _this;
	  }
	
	  _createClass(EmailUnsubscribeView, [{
	    key: 'renderConfirmation',
	    value: function renderConfirmation() {
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          size: 'small',
	          title: _react2.default.createElement(
	            'span',
	            null,
	            'Are you sure you want to stop receiving messages from ',
	            _react2.default.createElement(
	              'b',
	              null,
	              'all'
	            ),
	            ' your classes via email?'
	          ),
	          glyph: 'caution',
	          glyphColor: 'lava' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            _Copy2.default,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Click on the button below to stop receiving messages from all of your classes via email at ',
	              this.state.device.getLabel(),
	              '. If you\u2019d like to edit your contact information, change your notification preferences, or download the Remind app,',
	              ' ',
	              _react2.default.createElement(
	                _Link2.default,
	                { to: '/settings/notifications' },
	                'visit your account'
	              ),
	              ' instead.'
	            )
	          ),
	          _react2.default.createElement(
	            _DialogButton2.default,
	            {
	              onClick: this.handleDisableButtonClick },
	            _i18n2.default.getText('Unsubscribe')
	          )
	        ),
	        _react2.default.createElement(
	          _BoxFooter2.default,
	          null,
	          'Click',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/settings/notifications' },
	            'here'
	          ),
	          ' ',
	          'to edit message preferences'
	        )
	      );
	    }
	  }, {
	    key: 'renderDisabledMessage',
	    value: function renderDisabledMessage() {
	      var title = _i18n2.default.getText('Your email ({address}) is disabled from receiving Remind messages.', {
	        address: this.state.device.getLabel()
	      });
	      var subtext = _i18n2.default.getText('You can now close this browser.');
	
	      return _react2.default.createElement(_DialogContent2.default, {
	        size: 'small',
	        title: title,
	        subtext: subtext
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.device) {
	        return null;
	      } else if (this.state.enabled) {
	        return this.renderConfirmation();
	      } else {
	        return this.renderDisabledMessage();
	      }
	    }
	  }]);
	
	  return EmailUnsubscribeView;
	}(_react.Component);
	
	EmailUnsubscribeView.displayName = 'EmailUnsubscribeView';
	exports.default = _utils.Container.create(EmailUnsubscribeView);

/***/ },
/* 2611 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function decode(token) {
	  var contents = token.split('.')[1];
	  return contents ? JSON.parse(window.atob(contents)) : {};
	}
	
	exports.default = {
	  decode: decode
	};

/***/ },
/* 2612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ErrorStore = __webpack_require__(2613);
	
	var _ErrorStore2 = _interopRequireDefault(_ErrorStore);
	
	__webpack_require__(2614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorView = function (_React$Component) {
	  _inherits(ErrorView, _React$Component);
	
	  function ErrorView() {
	    _classCallCheck(this, ErrorView);
	
	    return _possibleConstructorReturn(this, (ErrorView.__proto__ || Object.getPrototypeOf(ErrorView)).apply(this, arguments));
	  }
	
	  _createClass(ErrorView, [{
	    key: 'render',
	    value: function render() {
	      var title = _ErrorStore2.default.getTitle() || 'Unknown error';
	      var body = _ErrorStore2.default.getBody() || 'An unknown error has occurred';
	      return _react2.default.createElement(
	        'div',
	        { className: 'ErrorView' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ErrorView-wrap' },
	          _react2.default.createElement(_Glyph2.default, { className: 'ErrorView-flag', name: 'flag', size: 'xxlarge' }),
	          _react2.default.createElement(
	            'div',
	            { className: 'ErrorView-title' },
	            title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ErrorView-body' },
	            body
	          )
	        )
	      );
	    }
	  }]);
	
	  return ErrorView;
	}(_react2.default.Component);
	
	ErrorView.displayName = 'ErrorView';
	exports.default = ErrorView;

/***/ },
/* 2613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Dispatcher = __webpack_require__(590);
	
	var _ErrorConstants = __webpack_require__(1428);
	
	var _utils = __webpack_require__(956);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorStore = function (_ReduceStore) {
	  _inherits(ErrorStore, _ReduceStore);
	
	  function ErrorStore() {
	    _classCallCheck(this, ErrorStore);
	
	    return _possibleConstructorReturn(this, (ErrorStore.__proto__ || Object.getPrototypeOf(ErrorStore)).apply(this, arguments));
	  }
	
	  _createClass(ErrorStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        title: null,
	        body: null
	      };
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      return this.getState().title;
	    }
	  }, {
	    key: 'getBody',
	    value: function getBody() {
	      return this.getState().body;
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      var error = _ErrorConstants.ErrorMessages[action.type];
	
	      if (error) {
	        var _error = error[action.context || 'DEFAULT'],
	            title = _error.title,
	            body = _error.body;
	
	        return Object.assign({}, state, { title: title, body: body });
	      } else {
	        return state;
	      }
	    }
	  }]);
	
	  return ErrorStore;
	}(_utils.ReduceStore);
	
	ErrorStore.displayName = 'ErrorStore';
	exports.default = new ErrorStore(_Dispatcher.dispatcher);

/***/ },
/* 2614 */
1136,
/* 2615 */,
/* 2616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _AuthenticationView = __webpack_require__(1690);
	
	var _AuthenticationView2 = _interopRequireDefault(_AuthenticationView);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Buttons = __webpack_require__(1315);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Copy = __webpack_require__(1461);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _LinkSmsVerificationCodeBox = __webpack_require__(2617);
	
	var _LinkSmsVerificationCodeBox2 = _interopRequireDefault(_LinkSmsVerificationCodeBox);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(2620);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ForgotPasswordPage = function (_React$Component) {
	  _inherits(ForgotPasswordPage, _React$Component);
	
	  function ForgotPasswordPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ForgotPasswordPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ForgotPasswordPage.__proto__ || Object.getPrototypeOf(ForgotPasswordPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      medium: '',
	      phoneNumber: '',
	      verificationToken: '',
	      requestSubmitted: false
	    }, _this.onUidChange = function (event) {
	      var value = event.target.value;
	      var medium = value.includes('@') ? 'email' : 'sms';
	      _this.setState({ medium: medium });
	    }, _this.onSmsCodeConfirmed = function (response) {
	      _AuthActions2.default.accessTokenSignIn(response.token).then(function () {
	        _this.props.router.push('/reset_password/');
	      });
	    }, _this.onResend = function () {
	      _this.handleSubmit({ uid: _this.state.phoneNumber });
	    }, _this.handleSubmit = function (data) {
	      var uid = data.uid;
	
	      var onSuccess = function onSuccess(response) {
	        _this.setState({
	          phoneNumber: uid,
	          verificationToken: response.token,
	          requestSubmitted: true
	        });
	      };
	
	      var onError = function onError(error) {
	        return _ToastActions2.default.showAPIError(error);
	      };
	
	      _AuthActions2.default.requestPasswordReset(uid).then(onSuccess).catch(onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ForgotPasswordPage, [{
	    key: 'renderVerificationToken',
	    value: function renderVerificationToken() {
	      return _react2.default.createElement(_LinkSmsVerificationCodeBox2.default, {
	        token: this.state.verificationToken,
	        phoneNumber: this.state.phoneNumber,
	        onDone: this.onSmsCodeConfirmed,
	        onResend: this.onResend,
	        successMessage: 'Correct!'
	      });
	    }
	  }, {
	    key: 'renderSent',
	    value: function renderSent() {
	      var subtext = this.state.verificationToken ? 'Please check your phone for your reset code.' : null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TitleHeader2.default, {
	          image: __webpack_require__(2622),
	          imageClassName: 'ForgotPasswordPage-title-image',
	          title: 'Email sent',
	          subtext: subtext
	        }),
	        !this.state.verificationToken && _react2.default.createElement(
	          _Copy2.default,
	          { center: true },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Please check your email for instructions on how to reset your password! If you do not receive anything, please check your spam folder for an email from remind.com.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              { href: _LinkConstants2.default.FORGOT_PASSWORD, target: '_blank' },
	              'Click here'
	            ),
	            ' ',
	            'if you need further assistance.'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderForm',
	    value: function renderForm() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Form2.default,
	          { onSubmit: this.handleSubmit },
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Email address or phone number',
	            name: 'uid',
	            autoComplete: 'username',
	            placeholder: 'Email address or phone number',
	            onChange: this.onUidChange,
	            size: 'large',
	            value: this.props.location.query.email || '',
	            showErrorAfterBlur: true,
	            required: true,
	            validations: this.state.medium === 'email' ? { isEmail: true } : { couldPlausiblyBeANorthAmericanPhoneNumber: true },
	            validationErrors: {
	              isEmail: 'Invalid email. Please try again.',
	              couldPlausiblyBeANorthAmericanPhoneNumber: 'Invalid phone number or email address. Please try again.'
	            }
	          }),
	          _react2.default.createElement(
	            _Buttons2.default,
	            { axis: 'y' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                type: 'submit',
	                className: 'ForgotPassword-submit',
	                level: 'primary',
	                full: true,
	                eventElementName: 'ForgotPassword-submit' },
	              'Send reset instructions'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                href: _LinkConstants2.default.FORGOT_PASSWORD,
	                target: '_blank',
	                color: 'brand',
	                level: 'text',
	                'data-test': 'help-button' },
	              'Help'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.verificationToken) {
	        return this.renderVerificationToken();
	      }
	
	      return _react2.default.createElement(
	        _AuthenticationView2.default,
	        _extends({}, this.props, { title: 'Forgot password?' }),
	        this.state.requestSubmitted ? this.renderSent() : this.renderForm()
	      );
	    }
	  }]);
	
	  return ForgotPasswordPage;
	}(_react2.default.Component);
	
	ForgotPasswordPage.displayName = 'ForgotPasswordPage';
	exports.default = ForgotPasswordPage;

/***/ },
/* 2617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	__webpack_require__(2618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var LinkSmsVerificationCodeBox = function (_React$Component) {
	  _inherits(LinkSmsVerificationCodeBox, _React$Component);
	
	  function LinkSmsVerificationCodeBox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LinkSmsVerificationCodeBox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkSmsVerificationCodeBox.__proto__ || Object.getPrototypeOf(LinkSmsVerificationCodeBox)).call.apply(_ref, [this].concat(args))), _this), _this.onResend = function () {
	      // FIXME: children because FormInput are wrapped by doWhileMounted
	      _this.refs.code.refs.children.changeValue('');
	      _this.props.onResend();
	    }, _this.submit = function (form) {
	      var onSuccess = function onSuccess(device) {
	        _this.props.onDone(device);
	        _ToastActions2.default.showSuccessToast(_this.props.successMessage || 'Mobile phone linked to Remind');
	      };
	
	      var onError = function onError() {
	        _ToastActions2.default.showErrorToast('Please enter a valid code.');
	      };
	
	      _DeviceActions2.default.createOutboundDevice(_this.props.token, form.code).then(onSuccess, onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LinkSmsVerificationCodeBox, [{
	    key: 'render',
	    value: function render() {
	      var subtext = this.props.phoneNumber ? 'Please enter the 4-digit code sent to ' + this.props.phoneNumber + '.' : 'Please enter the 4-digit code sent to your phone.';
	
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        _extends({
	          size: 'small',
	          full: true,
	          title: 'Enter your code',
	          subtext: subtext
	        }, this.props),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            'div',
	            { className: 'LinkSmsVerificationCodeBox' },
	            _react2.default.createElement(
	              _Form2.default,
	              { onValidSubmit: this.submit },
	              _react2.default.createElement(_FormInput2.default, {
	                autofocus: true,
	                ref: 'code',
	                className: 'LinkSmsVerificationCodeBox-Input',
	                name: 'code',
	                size: 'large',
	                type: 'text'
	              }),
	              _react2.default.createElement(
	                _Button2.default,
	                {
	                  className: 'LinkSmsVerificationCodeBox-Submit',
	                  type: 'submit',
	                  eventElementName: 'LinkSmsVerificationCodeBox-Submit' },
	                'Submit'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _BoxFooter2.default,
	          null,
	          'Didn\u2019t receive a code? ',
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: this.onResend },
	            'Resend'
	          ),
	          this.props.footer ? ' ' : null,
	          this.props.footer
	        )
	      );
	    }
	  }]);
	
	  return LinkSmsVerificationCodeBox;
	}(_react2.default.Component);
	
	LinkSmsVerificationCodeBox.displayName = 'LinkSmsVerificationCodeBox';
	exports.default = LinkSmsVerificationCodeBox;

/***/ },
/* 2618 */
1136,
/* 2619 */,
/* 2620 */
1136,
/* 2621 */,
/* 2622 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _BirthdateModal = __webpack_require__(2624);
	
	var _BirthdateModal2 = _interopRequireDefault(_BirthdateModal);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _jsonwebtoken = __webpack_require__(2611);
	
	var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _waitForPromises = __webpack_require__(2632);
	
	var _waitForPromises2 = _interopRequireDefault(_waitForPromises);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GetBirthdateForChat = _react2.default.createClass({
	  displayName: 'GetBirthdateForChat',
	
	  mixins: [(0, _linkStateWithStores2.default)([_CurrentUser2.default])],
	
	  statics: {
	    routePrefetch: [function (params) {
	      _AuthActions2.default.jwtTokenSignIn(params.token);
	      return _UserActions2.default.loadCurrentUser(params.token);
	    }]
	  },
	
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  getStateFromStores: function getStateFromStores() {
	    var token = _CurrentUser2.default.getToken();
	    if (!token) {
	      throw new Error('missing user token');
	    }
	    var payload = _jsonwebtoken2.default.decode(token);
	    var receiver = _CurrentUser2.default.getUser();
	    return {
	      receiver: receiver,
	      // $FlowFixMe
	      senderSignature: payload.sender.signature
	    };
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'ReportChatView' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ReportChatView-wrap' },
	        _react2.default.createElement(_BirthdateModal2.default, {
	          user: this.state.receiver,
	          senderSignature: this.state.senderSignature
	        })
	      )
	    );
	  }
	});
	
	exports.default = (0, _waitForPromises2.default)(GetBirthdateForChat);

/***/ },
/* 2624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AskForBirthdate = __webpack_require__(2625);
	
	var _AskForBirthdate2 = _interopRequireDefault(_AskForBirthdate);
	
	var _AskForParentEmail = __webpack_require__(2627);
	
	var _AskForParentEmail2 = _interopRequireDefault(_AskForParentEmail);
	
	var _AskForRole = __webpack_require__(2628);
	
	var _AskForRole2 = _interopRequireDefault(_AskForRole);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _UserConstants = __webpack_require__(1015);
	
	__webpack_require__(2630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BirthdateModal = function (_React$Component) {
	  _inherits(BirthdateModal, _React$Component);
	
	  function BirthdateModal() {
	    _classCallCheck(this, BirthdateModal);
	
	    return _possibleConstructorReturn(this, (BirthdateModal.__proto__ || Object.getPrototypeOf(BirthdateModal)).apply(this, arguments));
	  }
	
	  _createClass(BirthdateModal, [{
	    key: 'renderDoneCanChat',
	    value: function renderDoneCanChat() {
	      return this.renderHeader('Thanks!', _react2.default.createElement(
	        'span',
	        null,
	        'You\u2019re now all set to use Remind. We\u2019ve notified everyone that they can now send you messages.'
	      ));
	    }
	  }, {
	    key: 'renderDoneCannotChat',
	    value: function renderDoneCannotChat() {
	      return this.renderHeader('Thanks!', _react2.default.createElement(
	        'span',
	        null,
	        'Two-way messaging is only available for students 13 and older. We\u2019ve notified your teacher. Don\u2019t worry\u2014you will still receive announcements.'
	      ));
	    }
	
	    // =======================
	    // = Sequence Components =
	    // =======================
	
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader(title, subtext) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'BirthdateModal-boxHeader' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'BirthdateModal-boxTitle' },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'BirthdateModal-boxSubtext' },
	          subtext
	        )
	      );
	    }
	  }, {
	    key: 'renderPage',
	    value: function renderPage() {
	      var user = this.props.user;
	
	      var role = user.getRole();
	      if (!role) {
	        return _react2.default.createElement(_AskForRole2.default, null);
	      }
	
	      if (role === _UserConstants.Roles.student) {
	        var birthdate = user.getBirthdate();
	        if (!birthdate) {
	          return _react2.default.createElement(_AskForBirthdate2.default, null);
	        }
	
	        var thirteenYearsAgo = new Date();
	        thirteenYearsAgo.setFullYear(thirteenYearsAgo.getFullYear() - 13);
	        if (birthdate > thirteenYearsAgo) {
	          var parentEmail = user.getParentEmail();
	          if (!parentEmail) {
	            return _react2.default.createElement(_AskForParentEmail2.default, null);
	          }
	          return this.renderDoneCannotChat();
	        }
	      }
	
	      return this.renderDoneCanChat();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Box2.default,
	        _extends({}, this.props, { className: 'BirthdateModal-box' }),
	        this.renderPage()
	      );
	    }
	  }]);
	
	  return BirthdateModal;
	}(_react2.default.Component);
	
	BirthdateModal.displayName = 'BirthdateModal';
	exports.default = BirthdateModal;

/***/ },
/* 2625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BirthdateModalSectionMixin = __webpack_require__(2626);
	
	var _BirthdateModalSectionMixin2 = _interopRequireDefault(_BirthdateModalSectionMixin);
	
	var _BirthdateSelector = __webpack_require__(1943);
	
	var _BirthdateSelector2 = _interopRequireDefault(_BirthdateSelector);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The actual render is in BirthdateModalSectionMixin
	 */
	/* eslint-disable react/require-render-return */
	var AskForBirthdate = _react2.default.createClass({
	  displayName: 'AskForBirthdate',
	
	  mixins: [_BirthdateModalSectionMixin2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      birthdate: undefined
	    };
	  },
	  onSubmit: function onSubmit() {
	    if (!this.state.birthdate) {
	      console.error('ignoring birthdate form submission with null birthdate');
	      return;
	    }
	
	    var onError = function onError(response) {
	      var errors = {};
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = response['field_errors'][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var field = _step.value;
	
	          errors[field['field_name']] = field.messages.join(', ');
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if ('birthdate' in errors) {
	        _ToastActions2.default.showErrorToast(errors['birthdate']);
	      }
	    };
	
	    _UserActions2.default.setBirthdate(this.state.birthdate).then(function () {}, onError);
	  },
	  birthdateChanged: function birthdateChanged(birthdate) {
	    this.setState({ birthdate: birthdate });
	  },
	  buttonDisabled: function buttonDisabled() {
	    return !this.state.birthdate;
	  },
	  title: function title() {
	    return 'What is your date of birth?';
	  },
	  renderCollector: function renderCollector() {
	    return _react2.default.createElement(_BirthdateSelector2.default, { onChange: this.birthdateChanged });
	  }
	});
	exports.default = AskForBirthdate;

/***/ },
/* 2626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var BirthdateModalSectionMixin = {
	  getInitialState: function getInitialState() {
	    return {
	      submitted: false
	    };
	  },
	  submit: function submit() {
	    this.setState({ submitted: true });
	    this.onSubmit();
	  },
	  renderHeader: function renderHeader(title, subtext) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'BirthdateModal-boxHeader' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'BirthdateModal-boxTitle' },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'BirthdateModal-boxSubtext' },
	        subtext
	      )
	    );
	  },
	  renderSubmitButton: function renderSubmitButton() {
	    return _react2.default.createElement(
	      _Button2.default,
	      {
	        level: 'primary',
	        onClick: this.submit,
	        disabled: this.state.submitted || this.buttonDisabled() },
	      'Submit'
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.renderHeader(this.title(), this.getSubtext ? this.getSubtext() : null),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'BirthdateModal-boxArea' },
	          this.renderCollector()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'BirthdateModal-boxArea' },
	          this.renderSubmitButton()
	        )
	      )
	    );
	  }
	};
	
	exports.default = BirthdateModalSectionMixin;

/***/ },
/* 2627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BirthdateModalSectionMixin = __webpack_require__(2626);
	
	var _BirthdateModalSectionMixin2 = _interopRequireDefault(_BirthdateModalSectionMixin);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _reactAddonsLinkedStateMixin = __webpack_require__(2288);
	
	var _reactAddonsLinkedStateMixin2 = _interopRequireDefault(_reactAddonsLinkedStateMixin);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The actual render is in BirthdateModalSectionMixin
	 */
	/* eslint-disable react/require-render-return */
	var AskForParentEmail = _react2.default.createClass({
	  displayName: 'AskForParentEmail',
	
	  mixins: [_BirthdateModalSectionMixin2.default, _reactAddonsLinkedStateMixin2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      parentEmail: '',
	      error: null
	    };
	  },
	  onSubmit: function onSubmit() {
	    var _this = this;
	
	    _UserActions2.default.setParentEmail(this.state.parentEmail).catch(function (error) {
	      // TODO: FIX THIS. This doesn't belong here.
	      _this.setState({ error: error.field_errors[0].messages[0] });
	    });
	  },
	  getSubtext: function getSubtext() {
	    return 'In order to keep using Remind, we’ll need to notify a parent.';
	  },
	  buttonDisabled: function buttonDisabled() {
	    return false;
	  },
	  title: function title() {
	    return 'Please enter your parent’s email';
	  },
	  renderCollector: function renderCollector() {
	    var error = this.state.error;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Label2.default,
	        { htmlFor: '' },
	        'Parent’s email'
	      ),
	      _react2.default.createElement(_Input2.default, { type: 'text', valueLink: this.linkState('parentEmail') }),
	      error && _react2.default.createElement(
	        'span',
	        { className: 'BirthDateModal-error' },
	        error
	      )
	    );
	  }
	});
	
	exports.default = AskForParentEmail;

/***/ },
/* 2628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BirthdateModalSectionMixin = __webpack_require__(2626);
	
	var _BirthdateModalSectionMixin2 = _interopRequireDefault(_BirthdateModalSectionMixin);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _RoleSelector = __webpack_require__(2629);
	
	var _RoleSelector2 = _interopRequireDefault(_RoleSelector);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The actual render is in BirthdateModalSectionMixin
	 */
	/* eslint-disable react/require-render-return */
	/*  weak */
	var AskForRole = _react2.default.createClass({
	  displayName: 'AskForRole',
	
	  mixins: [_BirthdateModalSectionMixin2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      role: ''
	    };
	  },
	  onSubmit: function onSubmit() {
	    _UserActions2.default.setRole(this.state.role);
	  },
	  getSubtext: function getSubtext() {
	    return _react2.default.createElement(
	      _Link2.default,
	      { href: _LinkConstants2.default.CHAT_RESTRICTIONS },
	      'Learn more'
	    );
	  },
	  buttonDisabled: function buttonDisabled() {
	    return false;
	  },
	  roleChanged: function roleChanged(role) {
	    this.setState({ role: role });
	  },
	  title: function title() {
	    return 'To use Chat, please let us know your role.';
	  },
	  renderCollector: function renderCollector() {
	    return _react2.default.createElement(_RoleSelector2.default, { onChange: this.roleChanged, value: this.state.role });
	  }
	});
	
	exports.default = AskForRole;

/***/ },
/* 2629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(1366);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _UserConstants = __webpack_require__(1015);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var RoleSelector = function (_React$Component) {
	  _inherits(RoleSelector, _React$Component);
	
	  function RoleSelector() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RoleSelector);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RoleSelector.__proto__ || Object.getPrototypeOf(RoleSelector)).call.apply(_ref, [this].concat(args))), _this), _this.roleChanged = function (value) {
	      _this.props.onChange(value);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RoleSelector, [{
	    key: 'render',
	    value: function render() {
	      var options = [{
	        label: 'Parent',
	        value: _UserConstants.Roles.parent
	      }, {
	        label: 'Student',
	        value: _UserConstants.Roles.student
	      }, {
	        label: 'Teacher',
	        value: _UserConstants.Roles.teacher
	      }];
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Label2.default,
	          { htmlFor: '', hidden: true },
	          'Role'
	        ),
	        _react2.default.createElement(_Select2.default, {
	          options: options,
	          placeholder: 'Select role',
	          value: this.props.value || '',
	          onChange: this.roleChanged
	        })
	      );
	    }
	  }]);
	
	  return RoleSelector;
	}(_react2.default.Component);
	
	RoleSelector.displayName = 'RoleSelector';
	exports.default = RoleSelector;

/***/ },
/* 2630 */
1136,
/* 2631 */,
/* 2632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*  weak */
	
	
	exports.default = function (Component) {
	  var blockingPromiseMakers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Component.routePrefetch;
	  var Loading = arguments[2];
	
	  // In karma tests, return the original component
	  // so that we don't block on promises that won’t resolve.
	  if (false) {
	    return Component;
	  }
	
	  if (!blockingPromiseMakers) {
	    console.error('waitForPromises requires an array of blocking promise makers\n      or routePrefetch on the Component');
	  }
	
	  var _$partition = _lodash2.default.partition(blockingPromiseMakers, function (f) {
	    return f.length === 0;
	  }),
	      _$partition2 = _slicedToArray(_$partition, 2),
	      simplePromiseMakers = _$partition2[0],
	      routeDependentPromiseMakers = _$partition2[1];
	
	  var WrappedComponent = function (_React$Component) {
	    _inherits(WrappedComponent, _React$Component);
	
	    function WrappedComponent(props) {
	      _classCallCheck(this, WrappedComponent);
	
	      // wait until mounting to make these because some maker functions depend
	      // on some data being loaded, such as the CurrentUser
	      var _this = _possibleConstructorReturn(this, (WrappedComponent.__proto__ || Object.getPrototypeOf(WrappedComponent)).call(this, props));
	
	      _this.displayName = 'WaitForPromises(' + Component.displayName + ')';
	      _this.simplePromises = simplePromiseMakers.map(function (f) {
	        return f();
	      }).filter(function (p) {
	        return !!p;
	      }) // filter when no promise made at all
	      .map(_makePromiseQueryable2.default);
	
	      // a promise can start as resolved, e.g. `Promise.resolve(foo)`
	      var simplePromisesSettled = _this.simplePromises.every(function (p) {
	        return p.isSettled();
	      });
	
	      // XXX bug in Babel if you inline this
	      // `BabelLoaderError: SyntaxError: Invalid assignment value for "this.state".`
	      var state = {
	        loaded: simplePromisesSettled && routeDependentPromiseMakers.length === 0
	      };
	      _this.state = state;
	      return _this;
	    }
	
	    _createClass(WrappedComponent, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.route = window.location.pathname + window.location.search;
	
	        this.fetchData();
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this._isMounted = true;
	      }
	    }, {
	      key: 'componentWillUpdate',
	      value: function componentWillUpdate() {
	        this._isMounted = false;
	
	        // Matching the original behavior of routePrefetch, which only blocks on the routePrefetch
	        // promises when the route changes.
	        if (this.route !== window.location.pathname + window.location.search) {
	          this.route = window.location.pathname + window.location.search;
	          this.fetchData();
	        }
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps, prevState) {
	        if (firstRoute && this.state.loaded && !prevState.loaded) {
	          firstRoute = false;
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this._isMounted = false;
	      }
	
	      // distateful hack for isMounted but this component will be going away
	
	    }, {
	      key: 'fetchData',
	      value: function fetchData() {
	        var _this2 = this;
	
	        var _context = this.context,
	            location = _context.location,
	            params = _context.params;
	        var query = location.query;
	
	        var routeDependentPromises = routeDependentPromiseMakers.map(function (f) {
	          return f(params, query);
	        }) // make promise using args
	        .filter(function (p) {
	          return !!p;
	        }); // filter when no promise made
	
	        var simplePromises = this.simplePromises.filter(function (p) {
	          return !p.isSettled();
	        });
	
	        var promises = routeDependentPromises.concat(simplePromises);
	
	        // If there are no promises to resolve, we don't need to show Loading
	        if (promises.length === 0) {
	          if (!this.state.loaded) {
	            this.setState({ loaded: true });
	          }
	        } else {
	          this.setState({ loaded: false });
	          Promise.all(promises).then(function () {
	            if (_this2._isMounted) {
	              _this2.setState({ loaded: true });
	            }
	          }).catch(function (error) {
	            // TODO: Figure out a better way to handle errors
	            if (error.code === 'not_found') {
	              _this2.context.router.replace('/not_found');
	            }
	            var badInitialRoute = firstRoute && error.statusCode === 404;
	            if (badInitialRoute) {
	              console.warn('Bad initial route', error);
	            } else {
	              console.error('Transition error:', error.stack ? error.stack : error);
	            }
	            throw new Error(error);
	          });
	        }
	      }
	    }, {
	      key: 'renderLoading',
	      value: function renderLoading() {
	        if (Loading) {
	          return _react2.default.createElement(Loading, this.props);
	        } else if (false) {
	          return _react2.default.createElement(
	            'div',
	            { style: { height: '100%', width: '100%', backgroundColor: '#fdd' } },
	            'DEV: ',
	            Component.displayName,
	            ' waiting for promises'
	          );
	        } else {
	          return _react2.default.createElement('div', { style: { height: '100%', width: '100%', backgroundColor: '#f9f9f9' } });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        if (this.state.loaded) {
	          return _react2.default.createElement(Component, this.props);
	        } else {
	          return this.renderLoading();
	        }
	      }
	    }]);
	
	    return WrappedComponent;
	  }(_react2.default.Component);
	
	  WrappedComponent.contextTypes = {
	    location: _react2.default.PropTypes.object.isRequired,
	    params: _react2.default.PropTypes.object.isRequired,
	    router: _react2.default.PropTypes.object.isRequired
	  };
	  WrappedComponent.displayName = 'WrappedComponent';
	
	
	  return (0, _hoistNonReactStatics2.default)(WrappedComponent, Component);
	};
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(474);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _makePromiseQueryable = __webpack_require__(2633);
	
	var _makePromiseQueryable2 = _interopRequireDefault(_makePromiseQueryable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var firstRoute = true;
	
	/**
	 * @param Component The React Component to wrap. Rendering the component will block on the promises
	                    in statics.routePrefetch to resolve.
	 * @param Loading [optional] A React component to render while waiting for the promises to resolve.
	 * @return React Component
	 */

/***/ },
/* 2633 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = makePromiseQueryable;
	/*  weak */
	// credit to http://stackoverflow.com/a/21489870/46040
	function makePromiseQueryable(promise) {
	  // Don't create a wrapper for promises that can already be queried.
	  if (promise.isResolved) {
	    return promise;
	  }
	
	  var isResolved = false;
	  var isRejected = false;
	
	  // Observe the promise, saving the fulfillment in a closure scope.
	  var result = promise.then(function (v) {
	    isResolved = true;return v;
	  }, function (e) {
	    isRejected = true;throw e;
	  });
	  result.isSettled = function () {
	    return isResolved || isRejected;
	  };
	  result.isResolved = function () {
	    return isResolved;
	  };
	  result.isRejected = function () {
	    return isRejected;
	  };
	  return result;
	}

/***/ },
/* 2634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(497);
	
	var _ActivitiesClassView = __webpack_require__(2635);
	
	var _ActivitiesClassView2 = _interopRequireDefault(_ActivitiesClassView);
	
	var _ActivitiesCreateView = __webpack_require__(2699);
	
	var _ActivitiesCreateView2 = _interopRequireDefault(_ActivitiesCreateView);
	
	var _AdminVerificationPage = __webpack_require__(2700);
	
	var _AdminVerificationPage2 = _interopRequireDefault(_AdminVerificationPage);
	
	var _AnnouncementsConversationView = __webpack_require__(2705);
	
	var _AnnouncementsConversationView2 = _interopRequireDefault(_AnnouncementsConversationView);
	
	var _ChatDefaultView = __webpack_require__(2708);
	
	var _ChatDefaultView2 = _interopRequireDefault(_ChatDefaultView);
	
	var _ConversationView = __webpack_require__(2228);
	
	var _ConversationView2 = _interopRequireDefault(_ConversationView);
	
	var _GroupContainer = __webpack_require__(2713);
	
	var _GroupContainer2 = _interopRequireDefault(_GroupContainer);
	
	var _GroupMembersTabListView = __webpack_require__(2718);
	
	var _GroupMembersTabListView2 = _interopRequireDefault(_GroupMembersTabListView);
	
	var _GroupMessagesContainer = __webpack_require__(2728);
	
	var _GroupMessagesContainer2 = _interopRequireDefault(_GroupMessagesContainer);
	
	var _GroupsIndexHandler = __webpack_require__(2732);
	
	var _GroupsIndexHandler2 = _interopRequireDefault(_GroupsIndexHandler);
	
	var _GroupsView = __webpack_require__(2736);
	
	var _GroupsView2 = _interopRequireDefault(_GroupsView);
	
	var _SchoolStatsTab = __webpack_require__(2758);
	
	var _SchoolStatsTab2 = _interopRequireDefault(_SchoolStatsTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { path: '/classes(/)', component: _GroupsView2.default, onEnter: _GroupsView2.default.onEnter },
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { path: ':groupCode', component: _GroupContainer2.default, onEnter: _GroupContainer2.default.onEnter },
	    _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'messages' }),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      {
	        path: 'messages',
	        component: _GroupMessagesContainer2.default,
	        onEnter: _GroupMessagesContainer2.default.onEnter },
	      _react2.default.createElement(_reactRouter.Route, {
	        path: 'new(/:memberId)',
	        component: _ConversationView2.default,
	        onEnter: _ConversationView2.default.onEnter,
	        onLeave: _ConversationView2.default.onLeaveNewChat
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: 'announcements/:role',
	        component: _AnnouncementsConversationView2.default
	      }),
	      _react2.default.createElement(_reactRouter.Route, {
	        path: ':chatId',
	        component: _ConversationView2.default,
	        onEnter: _ConversationView2.default.onEnter
	      }),
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: _ChatDefaultView2.default, onEnter: _ChatDefaultView2.default.onEnter })
	    ),
	    _react2.default.createElement(_reactRouter.Route, { path: 'settings' }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'invite' }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'people', component: _GroupMembersTabListView2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'activities', component: _ActivitiesClassView2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'activities/new', component: _ActivitiesCreateView2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'verify', component: _AdminVerificationPage2.default }),
	    _react2.default.createElement(_reactRouter.Route, { path: 'statistics', component: _SchoolStatsTab2.default })
	  ),
	  _react2.default.createElement(_reactRouter.IndexRoute, { component: _GroupsIndexHandler2.default })
	);

/***/ },
/* 2635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActivitiesClassContainer = __webpack_require__(2636);
	
	var _ActivitiesClassContainer2 = _interopRequireDefault(_ActivitiesClassContainer);
	
	var _ActivitiesClassViewHeader = __webpack_require__(2690);
	
	var _ActivitiesClassViewHeader2 = _interopRequireDefault(_ActivitiesClassViewHeader);
	
	var _ActivitiesClassView = __webpack_require__(2697);
	
	var _ActivitiesClassView2 = _interopRequireDefault(_ActivitiesClassView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivitiesClassView = function (_React$Component) {
	  _inherits(ActivitiesClassView, _React$Component);
	
	  function ActivitiesClassView() {
	    _classCallCheck(this, ActivitiesClassView);
	
	    return _possibleConstructorReturn(this, (ActivitiesClassView.__proto__ || Object.getPrototypeOf(ActivitiesClassView)).apply(this, arguments));
	  }
	
	  _createClass(ActivitiesClassView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: _ActivitiesClassView2.default.this },
	        _react2.default.createElement(_ActivitiesClassViewHeader2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: _ActivitiesClassView2.default.content },
	          _react2.default.createElement(_ActivitiesClassContainer2.default, {
	            'data-test': 'activities-class-container',
	            group: this.context.group
	          })
	        )
	      );
	    }
	  }]);
	
	  return ActivitiesClassView;
	}(_react2.default.Component);
	
	ActivitiesClassView.contextTypes = {
	  group: _react2.default.PropTypes.object.isRequired
	};
	ActivitiesClassView.displayName = 'ActivitiesClassView';
	exports.default = ActivitiesClassView;

/***/ },
/* 2636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActivitiesClassContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _promise = __webpack_require__(1041);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _ActivitiesClass = __webpack_require__(2637);
	
	var _ActivitiesClass2 = _interopRequireDefault(_ActivitiesClass);
	
	var _ActivitiesTabNux = __webpack_require__(2652);
	
	var _ActivitiesTabNux2 = _interopRequireDefault(_ActivitiesTabNux);
	
	var _WalletTabLoader = __webpack_require__(2687);
	
	var _WalletTabLoader2 = _interopRequireDefault(_WalletTabLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// eslint-disable-line
	
	/* Cannot manage activities when
	 * the context group is defined and the
	 * current user is not owner of said group.
	 */
	function canManageActivitiesForGroup(group) {
	  var isRootGroup = group.isRoot();
	  var isOwnedByUser = group.isOwnedByUser(_CurrentUser2.default.getUserId());
	
	  return _CurrentUser2.default.getUser().canCreateActivity() && (isRootGroup || isOwnedByUser);
	}
	
	var ActivitiesClassContainer = function (_React$Component) {
	  _inherits(ActivitiesClassContainer, _React$Component);
	
	  function ActivitiesClassContainer() {
	    _classCallCheck(this, ActivitiesClassContainer);
	
	    return _possibleConstructorReturn(this, (ActivitiesClassContainer.__proto__ || Object.getPrototypeOf(ActivitiesClassContainer)).apply(this, arguments));
	  }
	
	  _createClass(ActivitiesClassContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var onError = function onError(reason) {
	        if (reason && reason.isCanceled) {
	          return;
	        }
	
	        _this2.setState({ errored: true });
	        throw reason;
	      };
	
	      this.cancelable = (0, _promise.makeCancelable)(_ActivityActions2.default.load());
	      this.cancelable.promise.then(function () {
	        return _this2.setState({ loading: false });
	      }).catch(onError);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelable.cancel();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var activities = this.state.activities;
	      var group = this.props.group;
	
	
	      if (this.state.errored) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          'An error happened'
	        );
	      }
	
	      var canManage = canManageActivitiesForGroup(group);
	
	      if (activities.length > 0) {
	        return _react2.default.createElement(_ActivitiesClass2.default, { activities: activities, canManage: canManage });
	      }
	
	      if (this.state.loading) {
	        return _react2.default.createElement(_WalletTabLoader2.default, null);
	      }
	
	      return _react2.default.createElement(_ActivitiesTabNux2.default, { group: group, canManage: canManage });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ActivityStore2.default, _CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(state, props) {
	      return {
	        errored: state ? state.errored : false,
	        loading: state ? state.loading : true,
	        activities: _ActivityStore2.default.getActivityForGroup(props.group)
	      };
	    }
	  }]);
	
	  return ActivitiesClassContainer;
	}(_react2.default.Component);
	
	ActivitiesClassContainer.displayName = 'ActivitiesClassContainer';
	exports.ActivitiesClassContainer = ActivitiesClassContainer;
	exports.default = _utils.Container.create(ActivitiesClassContainer, { withProps: true });

/***/ },
/* 2637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tabs = __webpack_require__(1539);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivitiesSplitView = __webpack_require__(2638);
	
	var _ActivitiesSplitView2 = _interopRequireDefault(_ActivitiesSplitView);
	
	__webpack_require__(2685);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// typecheck: ignore statement
	function split(activities) {
	  var all = activities;
	  var owned = [];
	  var invited = [];
	
	  all.forEach(function (activity) {
	    activity.isSender() ? owned.push(activity) : invited.push(activity); // eslint-disable-line
	  });
	
	  return { owned: owned, invited: invited, all: all };
	}
	
	var ActivitiesClass = function (_React$Component) {
	  _inherits(ActivitiesClass, _React$Component);
	
	  function ActivitiesClass() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivitiesClass);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivitiesClass.__proto__ || Object.getPrototypeOf(ActivitiesClass)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      tab: 0
	    }, _this.tabChangeListener = function (tab) {
	      if (tab !== _this.state.tab) {
	        _this.setState({ tab: tab });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivitiesClass, [{
	    key: 'render',
	    value: function render() {
	      var _split = split(this.props.activities),
	          all = _split.all,
	          owned = _split.owned,
	          invited = _split.invited;
	
	      var activities = [all, owned, invited][this.state.tab];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivitiesClass' },
	        this.props.canManage && _react2.default.createElement(
	          _Tabs2.default,
	          { onTabChange: this.tabChangeListener },
	          _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	              'span',
	              null,
	              'All'
	            ) }),
	          _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	              'span',
	              null,
	              'Hosting'
	            ) }),
	          _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	              'span',
	              null,
	              'Invites'
	            ) })
	        ),
	        !this.props.canManage && _react2.default.createElement('hr', { className: 'ActivitiesClass-hr' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesClass-content' },
	          _react2.default.createElement(_ActivitiesSplitView2.default, {
	            activities: activities,
	            nuxCanManage: this.state.tab === 2 ? false : this.props.canManage
	            /* if looking at the "Invites" tab we want to show non manager nux */
	          })
	        )
	      );
	    }
	  }]);
	
	  return ActivitiesClass;
	}(_react2.default.Component);
	
	ActivitiesClass.defaultProps = {
	  activities: []
	};
	ActivitiesClass.displayName = 'ActivitiesClass';
	exports.default = ActivitiesClass;

/***/ },
/* 2638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityList = __webpack_require__(2639);
	
	var _ActivityList2 = _interopRequireDefault(_ActivityList);
	
	var _ActivityListCard = __webpack_require__(2646);
	
	var _ActivityListCard2 = _interopRequireDefault(_ActivityListCard);
	
	var _ActivitiesTabNux = __webpack_require__(2652);
	
	var _ActivitiesTabNux2 = _interopRequireDefault(_ActivitiesTabNux);
	
	var _ActivitiesNotificationsContainer = __webpack_require__(2655);
	
	var _ActivitiesNotificationsContainer2 = _interopRequireDefault(_ActivitiesNotificationsContainer);
	
	__webpack_require__(2683);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NUMBER_OF_PAST_ACTIVITIES = 5;
	
	// typecheck: ignore statement
	function split(activities) {
	  var upcoming = [];
	  var past = [];
	  var today = new Date();
	
	  activities.forEach(function (activity) {
	    var startAt = activity.getStartAt();
	    startAt && startAt > today && !activity.isClosed() ? // eslint-disable-line
	    upcoming.push(activity) : past.push(activity);
	  });
	
	  return { upcoming: upcoming, past: past };
	}
	
	var ActivitiesSplitView = function (_React$Component) {
	  _inherits(ActivitiesSplitView, _React$Component);
	
	  function ActivitiesSplitView() {
	    _classCallCheck(this, ActivitiesSplitView);
	
	    return _possibleConstructorReturn(this, (ActivitiesSplitView.__proto__ || Object.getPrototypeOf(ActivitiesSplitView)).apply(this, arguments));
	  }
	
	  _createClass(ActivitiesSplitView, [{
	    key: 'render',
	    value: function render() {
	      var _split = split(this.props.activities),
	          upcoming = _split.upcoming,
	          past = _split.past;
	
	      var pastToShow = past.slice(0, NUMBER_OF_PAST_ACTIVITIES);
	
	      // Forgive me,
	      // the activity list is a list containing activity card,
	      // the activity list card is a card containing an activity list.
	      // Q.
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivitiesSplitView' },
	        upcoming.length > 0 && _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesSplitView-list' },
	          _react2.default.createElement(_ActivityList2.default, { activities: upcoming })
	        ),
	        upcoming.length === 0 && _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesSplitView-list' },
	          _react2.default.createElement(_ActivitiesTabNux2.default, { hideImage: true, canManage: this.props.nuxCanManage })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesSplitView-side' },
	          _react2.default.createElement(_ActivitiesNotificationsContainer2.default, { 'data-test': 'activities-notifications-container' }),
	          pastToShow.length > 0 && _react2.default.createElement(_ActivityListCard2.default, { title: 'Past activities', activities: pastToShow })
	        )
	      );
	    }
	  }]);
	
	  return ActivitiesSplitView;
	}(_react2.default.Component);
	
	ActivitiesSplitView.displayName = 'ActivitiesSplitView';
	exports.default = ActivitiesSplitView;

/***/ },
/* 2639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityListCardItem = __webpack_require__(2640);
	
	var _ActivityListCardItem2 = _interopRequireDefault(_ActivityListCardItem);
	
	__webpack_require__(2644);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityList = function (_React$Component) {
	  _inherits(ActivityList, _React$Component);
	
	  function ActivityList() {
	    _classCallCheck(this, ActivityList);
	
	    return _possibleConstructorReturn(this, (ActivityList.__proto__ || Object.getPrototypeOf(ActivityList)).apply(this, arguments));
	  }
	
	  _createClass(ActivityList, [{
	    key: 'render',
	    value: function render() {
	      var activities = this.props.activities;
	
	      // next upcoming activity on top of list
	      // $FlowFixMe
	
	      activities.sort(function (a, b) {
	        return a.getStartAt() - b.getStartAt();
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityList' },
	        activities.map(function (activity) {
	          return _react2.default.createElement(
	            'div',
	            { key: activity.id, className: 'ActivityList-item' },
	            _react2.default.createElement(_ActivityListCardItem2.default, { activity: activity })
	          );
	        })
	      );
	    }
	  }]);
	
	  return ActivityList;
	}(_react2.default.Component);
	
	ActivityList.displayName = 'ActivityList';
	exports.default = ActivityList;

/***/ },
/* 2640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityActionMenuTrigger = __webpack_require__(2641);
	
	var _ActivityActionMenuTrigger2 = _interopRequireDefault(_ActivityActionMenuTrigger);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _RSVPDialogContainer = __webpack_require__(2234);
	
	var _RSVPDialogContainer2 = _interopRequireDefault(_RSVPDialogContainer);
	
	var _RSVPDropdownContainer = __webpack_require__(2245);
	
	var _RSVPDropdownContainer2 = _interopRequireDefault(_RSVPDropdownContainer);
	
	var _SimpleDateIcon = __webpack_require__(2230);
	
	var _SimpleDateIcon2 = _interopRequireDefault(_SimpleDateIcon);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TimeRange = __webpack_require__(1937);
	
	var _TimeRange2 = _interopRequireDefault(_TimeRange);
	
	var _modal = __webpack_require__(1188);
	
	__webpack_require__(2642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line
	
	
	var ActivityListCardItem = function (_React$Component) {
	  _inherits(ActivityListCardItem, _React$Component);
	
	  function ActivityListCardItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityListCardItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityListCardItem.__proto__ || Object.getPrototypeOf(ActivityListCardItem)).call.apply(_ref, [this].concat(args))), _this), _this.getResponseURL = function (sort) {
	      return 'activities/' + _this.props.activity.id + '?sort=' + sort;
	    }, _this.mountRSVPModal = function (rsvp) {
	      (0, _modal.mountModal)(_react2.default.createElement(_RSVPDialogContainer2.default, {
	        initialRSVP: rsvp,
	        activityId: _this.props.activity.id
	      }), _this);
	    }, _this.onTitleClick = function () {
	      var activity = _this.props.activity;
	
	
	      if (activity.isSender()) {
	        _this.context.router.push('/activities/' + activity.id);
	      } else {
	        _this.mountRSVPModal();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityListCardItem, [{
	    key: 'renderLastInfoRow',
	
	
	    // return the activity price for the recipient
	    // returns ammount collected for owner.
	    value: function renderLastInfoRow() {
	      var activity = this.props.activity;
	
	
	      if (activity.isSender()) {
	        var summary = activity.getRecipientSummary();
	
	        return _react2.default.createElement(
	          _Text2.default,
	          { color: 'jungle', weight: 'semibold' },
	          _react2.default.createElement(
	            _Link2.default,
	            { to: this.getResponseURL('yes'), color: 'inherit' },
	            _react2.default.createElement(
	              'span',
	              null,
	              summary.getAttendingCount(),
	              ' Yes'
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'ActivityListCardItem-separator' },
	            '|'
	          ),
	          _react2.default.createElement(
	            _Link2.default,
	            { to: this.getResponseURL('maybe'), color: 'inherit' },
	            _react2.default.createElement(
	              'span',
	              null,
	              summary.getMaybeCount(),
	              ' Maybe'
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'ActivityListCardItem-separator' },
	            '|'
	          ),
	          _react2.default.createElement(
	            _Link2.default,
	            { to: this.getResponseURL('no'), color: 'inherit' },
	            _react2.default.createElement(
	              'span',
	              null,
	              summary.getNotAttendingCount(),
	              ' No'
	            )
	          ),
	          !activity.isClosed() && activity.isOrHasCollectedMoneyOnline() && _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'span',
	              { className: 'ActivityListCardItem-separator' },
	              '|'
	            ),
	            _react2.default.createElement(_Money2.default, { cents: activity.getTotalCollected() }),
	            ' Collected'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _Text2.default,
	        { color: 'jungle', weight: 'semibold' },
	        function () {
	          if (activity.isFree()) {
	            return 'Free';
	          } else {
	            return _react2.default.createElement(_Money2.default, { cents: activity.getAmountPerPerson() });
	          }
	        }()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var activity = this.props.activity;
	
	      var startAt = this.props.activity.getStartAt();
	      var endAt = this.props.activity.getEndAt();
	      var cover = activity.getThumbnail();
	
	      var style = {
	        backgroundImage: 'url(' + cover.image + ')',
	        backgroundSize: '190px 112px'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityListCardItem' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityListCardItem-cover' },
	          _react2.default.createElement('div', {
	            style: style,
	            className: 'ActivityListCardItem-cover-img'
	          }),
	          startAt && _react2.default.createElement(
	            'div',
	            { className: 'ActivityListCardItem-cover-date' },
	            _react2.default.createElement(_SimpleDateIcon2.default, {
	              date: startAt,
	              monthTextProps: { color: 'lava' },
	              dayTextProps: { color: 'pitch' }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityListCardItem-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ActivityListCardItem-info-title' },
	            _react2.default.createElement(
	              _Link2.default,
	              { onClick: this.onTitleClick },
	              activity.getTitle()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ActivityListCardItem-info-sub' },
	            'Organized by ',
	            activity.getRequester().getDisplayName()
	          ),
	          startAt && _react2.default.createElement(
	            'div',
	            { className: 'ActivityListCardItem-info-sub' },
	            _react2.default.createElement(_TimeRange2.default, {
	              start: startAt,
	              end: endAt,
	              month: 'long',
	              year: 'numeric',
	              day: 'numeric',
	              hour: 'numeric',
	              minute: 'numeric'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ActivityListCardItem-info-sub' },
	            this.renderLastInfoRow()
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityListCardItem-action' },
	          _react2.default.createElement(
	            _ActivityActionMenuTrigger2.default,
	            { activity: activity },
	            _react2.default.createElement(_Glyph2.default, { name: 'ellipses', size: 'large', color: 'koala' })
	          )
	        ),
	        !activity.isSender() && _react2.default.createElement(
	          'div',
	          { className: 'ActivityListCardItem-rsvp' },
	          _react2.default.createElement(_RSVPDropdownContainer2.default, {
	            'data-test': 'rsvp-dropdown',
	            activity: activity,
	            onRSVPChange: this.mountRSVPModal,
	            level: 'secondary'
	          })
	        )
	      );
	    }
	  }]);
	
	  return ActivityListCardItem;
	}(_react2.default.Component);
	
	ActivityListCardItem.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ActivityListCardItem.displayName = 'ActivityListCardItem';
	exports.default = ActivityListCardItem;

/***/ },
/* 2641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _ActivityShareModal = __webpack_require__(2261);
	
	var _ActivityShareModal2 = _interopRequireDefault(_ActivityShareModal);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _modal = __webpack_require__(1188);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityActionMenuTrigger = function (_React$Component) {
	  _inherits(ActivityActionMenuTrigger, _React$Component);
	
	  function ActivityActionMenuTrigger() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityActionMenuTrigger);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityActionMenuTrigger.__proto__ || Object.getPrototypeOf(ActivityActionMenuTrigger)).call.apply(_ref, [this].concat(args))), _this), _this.renderShareModal = function () {
	      (0, _modal.mountModal)(_react2.default.createElement(_ActivityShareModal2.default, { activity: _this.props.activity }), _this);
	    }, _this.viewConversationClicked = function () {
	      _this.context.router.push('/classes/r/messages/' + (_this.props.activity.getChatUuid() || ''));
	    }, _this.closeActivityClicked = function () {
	      (0, _modal.mountModal)(_react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'ActivityActionMenuTrigger',
	        size: 'xsmall',
	        title: 'Close this activity?',
	        subtext: 'Once your activity is closed, participants won\u2019t\n        be able to send you money. You can still\n        deposit funds to your bank account.',
	        actionButtonText: 'Close',
	        cancelButtonText: 'Cancel',
	        onConfirm: function onConfirm() {
	          _ActivityActions2.default.close(_this.props.activity).then(function () {
	            return _ToastActions2.default.showSuccessToast('Activity is now closed');
	          }, function () {
	            return _ToastActions2.default.showDefaultErrorToast();
	          });
	        }
	      }), _this);
	    }, _this.viewDetailsClicked = function () {
	      _this.context.router.push('/activities/' + _this.props.activity.id);
	    }, _this.printActivity = function () {
	      _Activity2.default.export(_this.props.activity.id).then(function () {
	        return _ToastActions2.default.showSuccessToast(_Activity.ACTIVITY_PRINTED_MSG);
	      }, function () {
	        return _ToastActions2.default.showDefaultErrorToast();
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityActionMenuTrigger, [{
	    key: 'render',
	    value: function render() {
	      var activity = this.props.activity;
	
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        null,
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: this.renderShareModal },
	          'Share'
	        ),
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: this.viewConversationClicked },
	          'View conversation'
	        ),
	        activity.isSender() && !activity.isClosed() && _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: this.closeActivityClicked },
	          'Close activity'
	        ),
	        activity.isSender() && _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: this.viewDetailsClicked },
	          'View details'
	        ),
	        activity.isSender() && _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: this.printActivity },
	          'Print Activity'
	        )
	      );
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          layer: menu,
	          trigger: 'click',
	          alignment: 'right',
	          placement: 'bottom' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return ActivityActionMenuTrigger;
	}(_react2.default.Component);
	
	ActivityActionMenuTrigger.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ActivityActionMenuTrigger.displayName = 'ActivityActionMenuTrigger';
	exports.default = ActivityActionMenuTrigger;

/***/ },
/* 2642 */
1136,
/* 2643 */,
/* 2644 */
1136,
/* 2645 */,
/* 2646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityListMiniItem = __webpack_require__(2647);
	
	var _ActivityListMiniItem2 = _interopRequireDefault(_ActivityListMiniItem);
	
	__webpack_require__(2650);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityListCard = function (_React$Component) {
	  _inherits(ActivityListCard, _React$Component);
	
	  function ActivityListCard() {
	    _classCallCheck(this, ActivityListCard);
	
	    return _possibleConstructorReturn(this, (ActivityListCard.__proto__ || Object.getPrototypeOf(ActivityListCard)).apply(this, arguments));
	  }
	
	  _createClass(ActivityListCard, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityListCard' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityListCard-title' },
	          this.props.title
	        ),
	        this.props.activities.map(function (activity) {
	          return _react2.default.createElement(
	            'div',
	            { key: activity.id, className: 'ActivityListCard-item' },
	            _react2.default.createElement(_ActivityListMiniItem2.default, { activity: activity })
	          );
	        })
	      );
	    }
	  }]);
	
	  return ActivityListCard;
	}(_react2.default.Component);
	
	ActivityListCard.displayName = 'ActivityListCard';
	exports.default = ActivityListCard;

/***/ },
/* 2647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _TimeRange = __webpack_require__(1937);
	
	var _TimeRange2 = _interopRequireDefault(_TimeRange);
	
	__webpack_require__(2648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityListMiniItem = function (_React$Component) {
	  _inherits(ActivityListMiniItem, _React$Component);
	
	  function ActivityListMiniItem() {
	    _classCallCheck(this, ActivityListMiniItem);
	
	    return _possibleConstructorReturn(this, (ActivityListMiniItem.__proto__ || Object.getPrototypeOf(ActivityListMiniItem)).apply(this, arguments));
	  }
	
	  _createClass(ActivityListMiniItem, [{
	    key: 'renderLastInfoRow',
	    value: function renderLastInfoRow() {
	      var activity = this.props.activity;
	
	
	      return _react2.default.createElement(
	        _Text2.default,
	        { color: 'jungle', weight: 'semibold' },
	        function () {
	          if (activity.isFree()) {
	            return 'Free';
	          } else if (activity.isSender()) {
	            return _react2.default.createElement(_Money2.default, { cents: activity.getTotalCollected() });
	          } else {
	            return _react2.default.createElement(_Money2.default, { cents: activity.getAmountPerPerson() });
	          }
	        }()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var activity = this.props.activity;
	
	      var startAt = activity.getStartAt();
	      var endAt = activity.getEndAt();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityListMiniItem' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityListMiniItem-info' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ActivityListMiniItem-info-title' },
	            _react2.default.createElement(
	              _Text2.default,
	              { truncate: true },
	              function () {
	                if (activity.isSender()) {
	                  return _react2.default.createElement(
	                    _Link2.default,
	                    { to: '/activities/' + activity.id },
	                    activity.getTitle()
	                  );
	                } else {
	                  return activity.getTitle();
	                }
	              }()
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ActivityListMiniItem-info-item' },
	            _react2.default.createElement(
	              _Text2.default,
	              { color: 'thunder' },
	              'Organized by ',
	              activity.getRequester().getDisplayName()
	            )
	          ),
	          startAt && _react2.default.createElement(
	            'div',
	            { className: 'ActivityListMiniItem-info-item' },
	            _react2.default.createElement(
	              _Text2.default,
	              { color: 'thunder' },
	              _react2.default.createElement(_TimeRange2.default, {
	                start: startAt,
	                end: endAt,
	                month: 'long',
	                year: 'numeric',
	                day: 'numeric',
	                hour: 'numeric',
	                minute: 'numeric'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ActivityListMiniItem-info-item' },
	            this.renderLastInfoRow()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ActivityListMiniItem;
	}(_react2.default.Component);
	
	ActivityListMiniItem.displayName = 'ActivityListMiniItem';
	exports.default = ActivityListMiniItem;

/***/ },
/* 2648 */
1136,
/* 2649 */,
/* 2650 */
1136,
/* 2651 */,
/* 2652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ActivityCreateDialogContainer = __webpack_require__(1726);
	
	var _ActivityCreateDialogContainer2 = _interopRequireDefault(_ActivityCreateDialogContainer);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _JoinGroupModal = __webpack_require__(2450);
	
	var _JoinGroupModal2 = _interopRequireDefault(_JoinGroupModal);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _getRedirectLocationAfterGroupJoin = __webpack_require__(2490);
	
	var _getRedirectLocationAfterGroupJoin2 = _interopRequireDefault(_getRedirectLocationAfterGroupJoin);
	
	__webpack_require__(2653);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivitiesTabNux = function (_React$Component) {
	  _inherits(ActivitiesTabNux, _React$Component);
	
	  function ActivitiesTabNux() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivitiesTabNux);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivitiesTabNux.__proto__ || Object.getPrototypeOf(ActivitiesTabNux)).call.apply(_ref, [this].concat(args))), _this), _this.handleGroupJoined = function (group) {
	      _this.context.router.push((0, _getRedirectLocationAfterGroupJoin2.default)(group));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivitiesTabNux, [{
	    key: 'renderNonManager',
	    value: function renderNonManager() {
	      var button = null;
	      var text = 'No activities yet';
	      var subtext = 'Activities shared to you will appear here.';
	      var joinedAGroup = _GroupStore2.default.getSubscribedGroups().length > 0;
	
	      if (this.props.group && this.props.group.isRoot()) {
	        text = 'Ready for action?';
	        subtext = 'Keep track of field trips, fundraisers, and other activities.';
	
	        if (!joinedAGroup) {
	          button = _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_JoinGroupModal2.default, { onJoin: this.handleGroupJoined }) },
	            _react2.default.createElement(
	              _Button2.default,
	              { level: 'secondary' },
	              'Join a class'
	            )
	          );
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivitiesTabNux' },
	        _react2.default.createElement(
	          _Container2.default,
	          { size: 'xsmall' },
	          _react2.default.createElement(_TitleHeader2.default, {
	            size: 'medium',
	            imageClassName: 'ActivitiesTabNux-img',
	            image: this.props.hideImage ? undefined : __webpack_require__(1926),
	            title: text,
	            subtext: subtext
	          }),
	          button
	        )
	      );
	    }
	  }, {
	    key: 'renderManager',
	    value: function renderManager() {
	      var canCollectMoney = _CurrentUser2.default.isSignedIn() && _CurrentUser2.default.getUser().canCollectMoney();
	
	      var text = 'Take the hassle out of organizing field trips and fundraisers';
	      var subtext = canCollectMoney ? 'Track participation, coordinate volunteers, and collect funds—all in one place.You can also send real-time updates and photos!' : 'Track participation and coordinate volunteers. You can also send real-time updates and photos!';
	
	      if (this.props.group && this.props.group.isRoot()) {
	        text = 'An easier way to coordinate activities';
	        subtext = canCollectMoney ? 'Send important details, track who‘s participating, and collect funds online.' : 'Send important details and track who‘s participating.';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivitiesTabNux' },
	        _react2.default.createElement(
	          _Container2.default,
	          { size: 'medium' },
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_ActivityCreateDialogContainer2.default, null) },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_TitleHeader2.default, {
	                size: 'medium',
	                imageClassName: 'ActivitiesTabNux-img',
	                image: this.props.hideImage ? undefined : __webpack_require__(1926),
	                title: text,
	                subtext: subtext
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_ActivityCreateDialogContainer2.default, null) },
	            _react2.default.createElement(
	              _Button2.default,
	              null,
	              'Create an activity'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var canManage = this.props.canManage;
	
	      var hasGroupToSentTo = _GroupStore2.default.getOwnedGroups().length > 0;
	
	      return canManage && hasGroupToSentTo ? this.renderManager() : this.renderNonManager();
	    }
	  }]);
	
	  return ActivitiesTabNux;
	}(_react2.default.Component);
	
	ActivitiesTabNux.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ActivitiesTabNux.defaultProps = {
	  hideImage: false
	};
	ActivitiesTabNux.displayName = 'ActivitiesTabNux';
	exports.default = ActivitiesTabNux;

/***/ },
/* 2653 */
1136,
/* 2654 */,
/* 2655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _PaymentAccountStore = __webpack_require__(2604);
	
	var _PaymentAccountStore2 = _interopRequireDefault(_PaymentAccountStore);
	
	var _PaymentAccountActions = __webpack_require__(2593);
	
	var _PaymentAccountActions2 = _interopRequireDefault(_PaymentAccountActions);
	
	var _ConnectedBankAccountActions = __webpack_require__(2559);
	
	var _ConnectedBankAccountActions2 = _interopRequireDefault(_ConnectedBankAccountActions);
	
	var _ConnectedBankAccountStore = __webpack_require__(2656);
	
	var _ConnectedBankAccountStore2 = _interopRequireDefault(_ConnectedBankAccountStore);
	
	var _ActivitiesNotifications = __webpack_require__(2658);
	
	var _ActivitiesNotifications2 = _interopRequireDefault(_ActivitiesNotifications);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivitiesNotificationsContainer = function (_React$Component) {
	  _inherits(ActivitiesNotificationsContainer, _React$Component);
	
	  function ActivitiesNotificationsContainer() {
	    _classCallCheck(this, ActivitiesNotificationsContainer);
	
	    return _possibleConstructorReturn(this, (ActivitiesNotificationsContainer.__proto__ || Object.getPrototypeOf(ActivitiesNotificationsContainer)).apply(this, arguments));
	  }
	
	  _createClass(ActivitiesNotificationsContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!_PaymentAccountStore2.default.getPaymentAccount()) {
	        _PaymentAccountActions2.default.load();
	      }
	
	      _ConnectedBankAccountActions2.default.load();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ActivitiesNotifications2.default, {
	        refreshPaymentAccount: _PaymentAccountActions2.default.load,
	        needToAddBankAccount: this.state.canCollectMoney && this.state.needToAddBankAccount,
	        needAccountVerification: this.state.canCollectMoney && this.state.needAccountVerification,
	        needAdditionalVerification: this.state.canCollectMoney && this.state.needAdditionalVerification,
	        pendingBankAccountRequestsNumber: this.state.pendingBankAccountRequestsNumber
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default, _ActivityStore2.default, _PaymentAccountStore2.default, _ConnectedBankAccountStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var paymentAccount = _PaymentAccountStore2.default.getPaymentAccount();
	      var pendingBankAccountRequests = _ConnectedBankAccountStore2.default.getConnectedBankAccounts().filter(function (account) {
	        return account.getCanManage() && account.isPending();
	      });
	
	      var isCollectingMoney = _ActivityStore2.default.getActivities().some(function (activity) {
	        return activity.isSender() && !activity.isFree();
	      });
	
	      return {
	        canCollectMoney: _CurrentUser2.default.getUser().canCollectMoney(),
	        canCreateActivity: _CurrentUser2.default.getUser().canCreateActivity(),
	        needAccountVerification: paymentAccount ? paymentAccount.needBasicVerification() && isCollectingMoney : false,
	        needAdditionalVerification: paymentAccount ? paymentAccount.needAdditionalVerification() && isCollectingMoney : false,
	        needToAddBankAccount: paymentAccount ? paymentAccount.needBankAccountVerification() : false,
	        pendingBankAccountRequestsNumber: pendingBankAccountRequests.length
	      };
	    }
	  }]);
	
	  return ActivitiesNotificationsContainer;
	}(_react2.default.Component);
	
	ActivitiesNotificationsContainer.displayName = 'ActivitiesNotificationsContainer';
	exports.default = _utils.Container.create(ActivitiesNotificationsContainer);

/***/ },
/* 2656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConnectedBankAccounts = __webpack_require__(2657);
	
	var _utils = __webpack_require__(956);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConnectedBankAccountStore = function (_ReduceStore) {
	  _inherits(ConnectedBankAccountStore, _ReduceStore);
	
	  function ConnectedBankAccountStore() {
	    _classCallCheck(this, ConnectedBankAccountStore);
	
	    return _possibleConstructorReturn(this, (ConnectedBankAccountStore.__proto__ || Object.getPrototypeOf(ConnectedBankAccountStore)).apply(this, arguments));
	  }
	
	  _createClass(ConnectedBankAccountStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return _ConnectedBankAccounts.initialState;
	    }
	  }, {
	    key: 'getConnectedBankAccounts',
	    value: function getConnectedBankAccounts() {
	      return this.getState().connectedBankAccounts;
	    }
	  }, {
	    key: 'isAdmin',
	    value: function isAdmin() {
	      // An admin is defined by someone for whom at least one of the connected bank accounts
	      // can be managed by the current user.
	      return this.getState().connectedBankAccounts.some(function (account) {
	        return account.getCanManage();
	      });
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      return (0, _ConnectedBankAccounts.reducer)(state, action);
	    }
	  }]);
	
	  return ConnectedBankAccountStore;
	}(_utils.ReduceStore);
	
	ConnectedBankAccountStore.displayName = 'ConnectedBankAccountStore';
	exports.default = new ConnectedBankAccountStore(_Dispatcher.dispatcher);

/***/ },
/* 2657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	exports.reducer = reducer;
	
	var _ConnectedBankAccounts = __webpack_require__(2561);
	
	var _ConnectedBankAccounts2 = _interopRequireDefault(_ConnectedBankAccounts);
	
	var _ConnectedBankAccountConstants = __webpack_require__(2560);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  connectedBankAccounts: new _ConnectedBankAccounts2.default()
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  var connectedBankAccounts = void 0;
	
	  switch (action.type) {
	    case _ConnectedBankAccountConstants.ActionTypes.REJECT:
	      connectedBankAccounts = state.connectedBankAccounts.clone();
	      connectedBankAccounts.remove(action.connectedBankAccountUUID);
	      return _extends({}, state, { connectedBankAccounts: connectedBankAccounts });
	
	    case _ConnectedBankAccountConstants.ActionTypes.LOAD_CONNECTED_BANK_ACCOUNTS:
	      connectedBankAccounts = state.connectedBankAccounts.clone();
	      connectedBankAccounts.add(action.connectedBankAccounts.models);
	      return _extends({}, state, { connectedBankAccounts: connectedBankAccounts });
	
	    case _ConnectedBankAccountConstants.ActionTypes.REVOKE_ACCESS:
	    case _ConnectedBankAccountConstants.ActionTypes.APPROVE:
	    case _ConnectedBankAccountConstants.ActionTypes.GET_CONNECTED_BANK_ACCOUNT:
	    case _ConnectedBankAccountConstants.ActionTypes.CREATE_CONNECTED_BANK_ACCOUNT:
	      {
	        var updatedConnectedBankAccounts = state.connectedBankAccounts.clone();
	        updatedConnectedBankAccounts.add(action.connectedBankAccount);
	        return _extends({}, state, { connectedBankAccounts: updatedConnectedBankAccounts });
	      }
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActivitiesNotification = __webpack_require__(2659);
	
	__webpack_require__(2681);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivitiesNotifications = function (_React$Component) {
	  _inherits(ActivitiesNotifications, _React$Component);
	
	  function ActivitiesNotifications() {
	    _classCallCheck(this, ActivitiesNotifications);
	
	    return _possibleConstructorReturn(this, (ActivitiesNotifications.__proto__ || Object.getPrototypeOf(ActivitiesNotifications)).apply(this, arguments));
	  }
	
	  _createClass(ActivitiesNotifications, [{
	    key: 'render',
	    value: function render() {
	      var shouldRender = this.props.needAccountVerification || this.props.needToAddBankAccount || this.props.needAdditionalVerification || this.props.pendingBankAccountRequestsNumber > 0;
	
	      if (!shouldRender) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivitiesNotifications' },
	        this.props.needAccountVerification && _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesNotifications-item' },
	          _react2.default.createElement(_ActivitiesNotification.PaymentAccountVerificationNotification, null)
	        ),
	        this.props.needAdditionalVerification && _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesNotifications-item' },
	          _react2.default.createElement(_ActivitiesNotification.PaymentAccountAdditionalVerificationNotification, null)
	        ),
	        this.props.needToAddBankAccount && _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesNotifications-item' },
	          _react2.default.createElement(_ActivitiesNotification.AddBankAccountNotification, { onBankAccountAdded: this.props.refreshPaymentAccount })
	        ),
	        this.props.pendingBankAccountRequestsNumber > 0 && _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesNotifications-item' },
	          _react2.default.createElement(_ActivitiesNotification.PendingBankAccountRequestNotification, { number: this.props.pendingBankAccountRequestsNumber })
	        )
	      );
	    }
	  }]);
	
	  return ActivitiesNotifications;
	}(_react2.default.Component);
	
	ActivitiesNotifications.displayName = 'ActivitiesNotifications';
	exports.default = ActivitiesNotifications;

/***/ },
/* 2659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AddBankAccountNotification = exports.PendingBankAccountRequestNotification = exports.PaymentAccountVerificationNotification = exports.PaymentAccountAdditionalVerificationNotification = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _LinkBankAccountModal = __webpack_require__(2660);
	
	var _LinkBankAccountModal2 = _interopRequireDefault(_LinkBankAccountModal);
	
	var _IdentityVerificationModal = __webpack_require__(2663);
	
	var _IdentityVerificationModal2 = _interopRequireDefault(_IdentityVerificationModal);
	
	var _PendingConnectedBankAccountRequestsModalContainer = __webpack_require__(2666);
	
	var _PendingConnectedBankAccountRequestsModalContainer2 = _interopRequireDefault(_PendingConnectedBankAccountRequestsModalContainer);
	
	var _IdentityAdditionalVerificationModalContainer = __webpack_require__(2674);
	
	var _IdentityAdditionalVerificationModalContainer2 = _interopRequireDefault(_IdentityAdditionalVerificationModalContainer);
	
	__webpack_require__(2679);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivitiesNotification = function (_React$Component) {
	  _inherits(ActivitiesNotification, _React$Component);
	
	  function ActivitiesNotification() {
	    _classCallCheck(this, ActivitiesNotification);
	
	    return _possibleConstructorReturn(this, (ActivitiesNotification.__proto__ || Object.getPrototypeOf(ActivitiesNotification)).apply(this, arguments));
	  }
	
	  _createClass(ActivitiesNotification, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          text = _props.text,
	          rest = _objectWithoutProperties(_props, ['text']);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, rest, { className: 'ActivitiesNotification' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesNotification-info' },
	          _react2.default.createElement(_Glyph2.default, { name: 'explanation-circle', size: 'large' }),
	          text
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesNotification-action' },
	          _react2.default.createElement(_Glyph2.default, { name: 'chevron-right', size: 'xsmall' })
	        )
	      );
	    }
	  }]);
	
	  return ActivitiesNotification;
	}(_react2.default.Component);
	
	ActivitiesNotification.displayName = 'ActivitiesNotification';
	
	var PaymentAccountVerificationNotification = function (_React$Component2) {
	  _inherits(PaymentAccountVerificationNotification, _React$Component2);
	
	  function PaymentAccountVerificationNotification() {
	    _classCallCheck(this, PaymentAccountVerificationNotification);
	
	    return _possibleConstructorReturn(this, (PaymentAccountVerificationNotification.__proto__ || Object.getPrototypeOf(PaymentAccountVerificationNotification)).apply(this, arguments));
	  }
	
	  _createClass(PaymentAccountVerificationNotification, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: _react2.default.createElement(_IdentityVerificationModal2.default, null) },
	        _react2.default.createElement(ActivitiesNotification, { text: 'Verify your information' })
	      );
	    }
	  }]);
	
	  return PaymentAccountVerificationNotification;
	}(_react2.default.Component);
	
	PaymentAccountVerificationNotification.displayName = 'PaymentAccountVerificationNotification';
	
	var PendingBankAccountRequestNotification = function (_React$Component3) {
	  _inherits(PendingBankAccountRequestNotification, _React$Component3);
	
	  function PendingBankAccountRequestNotification() {
	    _classCallCheck(this, PendingBankAccountRequestNotification);
	
	    return _possibleConstructorReturn(this, (PendingBankAccountRequestNotification.__proto__ || Object.getPrototypeOf(PendingBankAccountRequestNotification)).apply(this, arguments));
	  }
	
	  _createClass(PendingBankAccountRequestNotification, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: _react2.default.createElement(_PendingConnectedBankAccountRequestsModalContainer2.default, null) },
	        _react2.default.createElement(ActivitiesNotification, { text: this.props.number + ' deposit requests' })
	      );
	    }
	  }]);
	
	  return PendingBankAccountRequestNotification;
	}(_react2.default.Component);
	
	PendingBankAccountRequestNotification.displayName = 'PendingBankAccountRequestNotification';
	
	var PaymentAccountAdditionalVerificationNotification = function (_React$Component4) {
	  _inherits(PaymentAccountAdditionalVerificationNotification, _React$Component4);
	
	  function PaymentAccountAdditionalVerificationNotification() {
	    _classCallCheck(this, PaymentAccountAdditionalVerificationNotification);
	
	    return _possibleConstructorReturn(this, (PaymentAccountAdditionalVerificationNotification.__proto__ || Object.getPrototypeOf(PaymentAccountAdditionalVerificationNotification)).apply(this, arguments));
	  }
	
	  _createClass(PaymentAccountAdditionalVerificationNotification, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: _react2.default.createElement(_IdentityAdditionalVerificationModalContainer2.default, null) },
	        _react2.default.createElement(ActivitiesNotification, { text: 'Additional identity verification' })
	      );
	    }
	  }]);
	
	  return PaymentAccountAdditionalVerificationNotification;
	}(_react2.default.Component);
	
	PaymentAccountAdditionalVerificationNotification.displayName = 'PaymentAccountAdditionalVerificationNotification';
	
	var AddBankAccountNotification = function (_React$Component5) {
	  _inherits(AddBankAccountNotification, _React$Component5);
	
	  function AddBankAccountNotification() {
	    _classCallCheck(this, AddBankAccountNotification);
	
	    return _possibleConstructorReturn(this, (AddBankAccountNotification.__proto__ || Object.getPrototypeOf(AddBankAccountNotification)).apply(this, arguments));
	  }
	
	  _createClass(AddBankAccountNotification, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: _react2.default.createElement(_LinkBankAccountModal2.default, { onBankAccountAdded: this.props.onBankAccountAdded }) },
	        _react2.default.createElement(ActivitiesNotification, { text: 'Add a bank account' })
	      );
	    }
	  }]);
	
	  return AddBankAccountNotification;
	}(_react2.default.Component);
	
	AddBankAccountNotification.displayName = 'AddBankAccountNotification';
	exports.PaymentAccountAdditionalVerificationNotification = PaymentAccountAdditionalVerificationNotification;
	exports.PaymentAccountVerificationNotification = PaymentAccountVerificationNotification;
	exports.PendingBankAccountRequestNotification = PendingBankAccountRequestNotification;
	exports.AddBankAccountNotification = AddBankAccountNotification;

/***/ },
/* 2660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _AddBankAccountFormContainer = __webpack_require__(2551);
	
	var _AddBankAccountFormContainer2 = _interopRequireDefault(_AddBankAccountFormContainer);
	
	var _CopyConstants = __webpack_require__(1733);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _WindowDialog = __webpack_require__(1931);
	
	var _WindowDialog2 = _interopRequireDefault(_WindowDialog);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(2661);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PAGE = (0, _enumerate2.default)(['addSchoolAccountForm', 'addSchoolAccountConfirmation']);
	
	exports.default = _react2.default.createClass({
	  displayName: 'LinkBankAccountModal',
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onBankAccountAdded: function onBankAccountAdded() {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      page: PAGE.addSchoolAccountForm
	    };
	  },
	  onBankAccountAdded: function onBankAccountAdded() {
	    this.props.onRequestHide();
	    _ToastActions2.default.showSuccessToast('Your bank account was added.');
	    this.props.onBankAccountAdded();
	  },
	  onSchoolBankAccountAdded: function onSchoolBankAccountAdded() {
	    this.setState({ page: PAGE.addSchoolAccountConfirmation });
	  },
	  renderConfirmation: function renderConfirmation() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'LinkBankAccountModal-confirmation' },
	      _react2.default.createElement(_TitleHeader2.default, {
	        title: _CopyConstants.RequestBankAccountConfirmation.title,
	        subtext: _CopyConstants.RequestBankAccountConfirmation.subtext,
	        image: __webpack_require__(2609),
	        size: 'large',
	        subtle: true
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        { onClick: this.props.onRequestHide },
	        'Got it'
	      )
	    );
	  },
	  renderSchoolAccountForm: function renderSchoolAccountForm() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'LinkBankAccountModal-addSchool' },
	      _react2.default.createElement(_TitleHeader2.default, {
	        className: 'LinkBankAccountModal-title',
	        title: _CopyConstants.BankAccount.title,
	        subtext: _CopyConstants.BankAccount.subtext
	      }),
	      _react2.default.createElement(_AddBankAccountFormContainer2.default, {
	        className: 'LinkBankAccountModal-form',
	        onSchoolBankAccountAdded: this.onSchoolBankAccountAdded,
	        onBankAccountAdded: this.onBankAccountAdded
	      })
	    );
	  },
	  render: function render() {
	    var _pages;
	
	    var _props = this.props,
	        className = _props.className,
	        rest = _objectWithoutProperties(_props, ['className']);
	
	    var pages = (_pages = {}, _defineProperty(_pages, PAGE.addSchoolAccountForm, this.renderSchoolAccountForm), _defineProperty(_pages, PAGE.addSchoolAccountConfirmation, this.renderConfirmation), _pages);
	
	    return _react2.default.createElement(
	      _WindowDialog2.default,
	      _extends({}, rest, { className: (0, _classnames2.default)('LinkBankAccountModal', className) }),
	      _react2.default.createElement(
	        _WindowDialog2.default.Content,
	        null,
	        _react2.default.createElement(
	          _Container2.default,
	          { size: 'small', className: 'LinkBankAccountModal-container' },
	          pages[this.state.page]()
	        )
	      )
	    );
	  }
	});

/***/ },
/* 2661 */
1136,
/* 2662 */,
/* 2663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _CopyConstants = __webpack_require__(1733);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _IdentityVerificationView = __webpack_require__(2600);
	
	var _IdentityVerificationView2 = _interopRequireDefault(_IdentityVerificationView);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(2664);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IdentityVerificationModal = _react2.default.createClass({
	  displayName: 'IdentityVerificationModal',
	  onVerified: function onVerified() {
	    _ToastActions2.default.showSuccessToast('Your account is now verified.');
	    this.props.onRequestHide();
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        rest = _objectWithoutProperties(_props, ['className']);
	
	    return _react2.default.createElement(
	      _Dialog2.default,
	      _extends({
	        eventScreenName: 'IdentityVerificationModal'
	      }, rest, {
	        size: 'large',
	        className: (0, _classnames2.default)('IdentityVerificationModal', className) }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(_TitleHeader2.default, { title: _CopyConstants.IdentityVerification.title, subtext: _CopyConstants.IdentityVerification.subtext }),
	        _react2.default.createElement(_IdentityVerificationView2.default, { onVerified: this.onVerified })
	      )
	    );
	  }
	});
	
	exports.default = IdentityVerificationModal;

/***/ },
/* 2664 */
1136,
/* 2665 */,
/* 2666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _PendingConnectedBankAccountRequestsModal = __webpack_require__(2667);
	
	var _PendingConnectedBankAccountRequestsModal2 = _interopRequireDefault(_PendingConnectedBankAccountRequestsModal);
	
	var _ConnectedBankAccountActions = __webpack_require__(2559);
	
	var _ConnectedBankAccountActions2 = _interopRequireDefault(_ConnectedBankAccountActions);
	
	var _ConnectedBankAccountStore = __webpack_require__(2656);
	
	var _ConnectedBankAccountStore2 = _interopRequireDefault(_ConnectedBankAccountStore);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PendingConnectedBankAccountRequestsModalContainer = function (_React$Component) {
	  _inherits(PendingConnectedBankAccountRequestsModalContainer, _React$Component);
	
	  function PendingConnectedBankAccountRequestsModalContainer() {
	    _classCallCheck(this, PendingConnectedBankAccountRequestsModalContainer);
	
	    return _possibleConstructorReturn(this, (PendingConnectedBankAccountRequestsModalContainer.__proto__ || Object.getPrototypeOf(PendingConnectedBankAccountRequestsModalContainer)).apply(this, arguments));
	  }
	
	  _createClass(PendingConnectedBankAccountRequestsModalContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _ConnectedBankAccountActions2.default.load();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_PendingConnectedBankAccountRequestsModal2.default, _extends({}, this.props, { /* all the inject modal props */
	        refreshPendingBankAccountRequests: _ConnectedBankAccountActions2.default.load,
	        pendingBankAccountRequests: this.state.pendingBankAccountRequests
	      }));
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ConnectedBankAccountStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var pendingBankAccountRequests = _ConnectedBankAccountStore2.default.getConnectedBankAccounts().filter(function (account) {
	        return account.getCanManage() && account.isPending();
	      });
	
	      return { pendingBankAccountRequests: pendingBankAccountRequests };
	    }
	  }]);
	
	  return PendingConnectedBankAccountRequestsModalContainer;
	}(_react2.default.Component);
	
	PendingConnectedBankAccountRequestsModalContainer.displayName = 'PendingConnectedBankAccountRequestsModalContainer';
	exports.default = _utils.Container.create(PendingConnectedBankAccountRequestsModalContainer, { withProps: true });

/***/ },
/* 2667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _DialogBody = __webpack_require__(1669);
	
	var _DialogBody2 = _interopRequireDefault(_DialogBody);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _TreasurerAddBankAccountModal = __webpack_require__(2668);
	
	var _TreasurerAddBankAccountModal2 = _interopRequireDefault(_TreasurerAddBankAccountModal);
	
	var _ConnectedBankAccountActions = __webpack_require__(2559);
	
	var _ConnectedBankAccountActions2 = _interopRequireDefault(_ConnectedBankAccountActions);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _modal = __webpack_require__(1188);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	__webpack_require__(2672);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PendingConnectedBankAccountRequestsModal = function (_React$Component) {
	  _inherits(PendingConnectedBankAccountRequestsModal, _React$Component);
	
	  function PendingConnectedBankAccountRequestsModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PendingConnectedBankAccountRequestsModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PendingConnectedBankAccountRequestsModal.__proto__ || Object.getPrototypeOf(PendingConnectedBankAccountRequestsModal)).call.apply(_ref, [this].concat(args))), _this), _this.onBankAccountAdded = function () {
	      _ToastActions2.default.showSuccessToast('The account was approved.');
	      _this.props.refreshPendingBankAccountRequests();
	    }, _this.decline = function (connectedBankAccountUUID) {
	      var modal = _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'PendingConnectedBankAccountRequestsModal',
	        title: 'Are you sure you want to decline this deposit request?',
	        subtitle: 'This action cannot be undone',
	        onConfirm: function onConfirm() {
	          return _ConnectedBankAccountActions2.default.reject(connectedBankAccountUUID);
	        }
	      });
	
	      (0, _modal.mountModal)(modal, _this);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PendingConnectedBankAccountRequestsModal, [{
	    key: 'renderPendingBankAccountRequest',
	    value: function renderPendingBankAccountRequest(connectedBankAccount) {
	      var _this2 = this;
	
	      var modal = _react2.default.createElement(_TreasurerAddBankAccountModal2.default, {
	        onBankAccountAdded: this.onBankAccountAdded,
	        connectedBankAccount: connectedBankAccount
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'PendingConnectedBankAccountRequestsModal-table-item' },
	        connectedBankAccount.getConnectedUserName(),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              color: 'lava',
	              weight: 'semibold',
	              onClick: function onClick() {
	                return _this2.decline(connectedBankAccount.id);
	              },
	              className: 'PendingConnectedBankAccountRequestsModal-reject',
	              eventElementName: 'PendingConnectedBankAccountRequestsModal-reject' },
	            'Decline'
	          ),
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: modal },
	            _react2.default.createElement(
	              _Link2.default,
	              { weight: 'semibold' },
	              'Approve'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this3 = this;
	
	      var pendingBankAccountRequests = this.props.pendingBankAccountRequests;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'table',
	          { className: 'PendingConnectedBankAccountRequestsModal-table' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'Name'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            pendingBankAccountRequests.map(function (pendingBankAccountRequest) {
	              return _react2.default.createElement(
	                'tr',
	                { key: pendingBankAccountRequest.id },
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  _this3.renderPendingBankAccountRequest(pendingBankAccountRequest)
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'footer',
	          null,
	          _react2.default.createElement(
	            _Text2.default,
	            { color: 'thunder', size: 'xxsmall' },
	            'Once approved you will will be able to manage all the deposit access from',
	            ' ',
	            _react2.default.createElement(
	              _Link2.default,
	              { to: '/settings/transactions' },
	              'your settings'
	            ),
	            '.'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderNoResults',
	    value: function renderNoResults() {
	      var subtext = _react2.default.createElement(
	        'span',
	        null,
	        'You can manage all the deposit access from',
	        ' ',
	        _react2.default.createElement(
	          _Link2.default,
	          { to: '/settings/transactions' },
	          'your settings'
	        ),
	        '.'
	      );
	
	      return _react2.default.createElement(_TitleHeader2.default, {
	        title: 'You have no pending deposit requests.',
	        subtext: subtext,
	        action: _react2.default.createElement(
	          _Button2.default,
	          { onClick: this.props.onRequestHide },
	          'Close'
	        ),
	        bottomMargin: 'none'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var pendingBankAccountRequests = this.props.pendingBankAccountRequests;
	
	      var subtext = pendingBankAccountRequests.length > 0 ? pendingBankAccountRequests.length + ' people would like to deposit funds directly to your account' : null;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({}, this.props, { className: 'PendingConnectedBankAccountRequestsModal' }),
	        _react2.default.createElement(_BoxHeader2.default, {
	          title: 'Deposit requests',
	          subtext: subtext
	        }),
	        _react2.default.createElement(
	          _DialogBody2.default,
	          null,
	          pendingBankAccountRequests.length > 0 && this.renderResults(),
	          pendingBankAccountRequests.length === 0 && this.renderNoResults()
	        )
	      );
	    }
	  }]);
	
	  return PendingConnectedBankAccountRequestsModal;
	}(_react2.default.Component);
	
	PendingConnectedBankAccountRequestsModal.displayName = 'PendingConnectedBankAccountRequestsModal';
	exports.default = PendingConnectedBankAccountRequestsModal;

/***/ },
/* 2668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TreasurerAddBankAccount = __webpack_require__(2669);
	
	var _TreasurerAddBankAccount2 = _interopRequireDefault(_TreasurerAddBankAccount);
	
	var _WindowDialog = __webpack_require__(1931);
	
	var _WindowDialog2 = _interopRequireDefault(_WindowDialog);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreasurerAddBankAccountModal = function (_React$Component) {
	  _inherits(TreasurerAddBankAccountModal, _React$Component);
	
	  function TreasurerAddBankAccountModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TreasurerAddBankAccountModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TreasurerAddBankAccountModal.__proto__ || Object.getPrototypeOf(TreasurerAddBankAccountModal)).call.apply(_ref, [this].concat(args))), _this), _this.onBankAccountAdded = function () {
	      _this.props.onRequestHide();
	      _this.props.onBankAccountAdded();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TreasurerAddBankAccountModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          connectedBankAccount = _props.connectedBankAccount,
	          rest = _objectWithoutProperties(_props, ['className', 'connectedBankAccount']);
	
	      return _react2.default.createElement(
	        _WindowDialog2.default,
	        _extends({}, rest, {
	          size: 'medium',
	          className: (0, _classnames2.default)('TreasurerAddBankAccountModal', className) }),
	        _react2.default.createElement(_TreasurerAddBankAccount2.default, _extends({}, rest, {
	          onBankAccountAdded: this.onBankAccountAdded,
	          connectedBankAccount: connectedBankAccount
	        }))
	      );
	    }
	  }]);
	
	  return TreasurerAddBankAccountModal;
	}(_react2.default.Component);
	
	TreasurerAddBankAccountModal.displayName = 'TreasurerAddBankAccountModal';
	exports.default = TreasurerAddBankAccountModal;

/***/ },
/* 2669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AddBankAccountForm = __webpack_require__(2552);
	
	var _AddBankAccountForm2 = _interopRequireDefault(_AddBankAccountForm);
	
	var _CenteredContainer = __webpack_require__(2240);
	
	var _CenteredContainer2 = _interopRequireDefault(_CenteredContainer);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _DepositSetupViewHeader = __webpack_require__(2597);
	
	var _DepositSetupViewHeader2 = _interopRequireDefault(_DepositSetupViewHeader);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _trackView = __webpack_require__(1950);
	
	var _trackView2 = _interopRequireDefault(_trackView);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CopyConstants = __webpack_require__(1733);
	
	__webpack_require__(2670);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UI_CONTEXT = 'treasurer_add_account_flow';
	
	var TreasurerAddBankAccount = _react2.default.createClass({
	  displayName: 'TreasurerAddBankAccount',
	
	
	  childContextTypes: {
	    eventContextName: _react.PropTypes.string,
	    eventScreenName: _react.PropTypes.string
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      eventContextName: UI_CONTEXT
	    };
	  },
	  onBankAccountAdded: function onBankAccountAdded() {
	    if (this.props.onBankAccountAdded) {
	      this.props.onBankAccountAdded();
	    }
	  },
	  render: function render() {
	    var _this = this;
	
	    var subtext = 'Your account and routing numbers will be kept private. You can revoke access\n      at any time. By approving this request, you are only enabling ' + this.props.connectedBankAccount.getConnectedUserName() + ' to deposit funds into\n      this account.';
	    return _react2.default.createElement(
	      _CenteredContainer2.default,
	      { size: 'small', className: 'TreasurerAddBankAccount' },
	      _react2.default.createElement(_DepositSetupViewHeader2.default, {
	        title: _CopyConstants.TreasurerAddBankAccount.title,
	        subtext: subtext
	      }),
	      _react2.default.createElement(_AddBankAccountForm2.default, {
	        className: 'TreasurerAddBankAccount',
	        onAdminBankAccountAdd: function onAdminBankAccountAdd() {
	          return _this.onBankAccountAdded();
	        },
	        connectedBankAccount: this.props.connectedBankAccount
	      })
	    );
	  }
	});
	
	exports.default = (0, _trackView2.default)(TreasurerAddBankAccount, _EventTrackingConstants2.default.TREASURER_ADD_BANK_ACCOUNT);

/***/ },
/* 2670 */
1136,
/* 2671 */,
/* 2672 */
1136,
/* 2673 */,
/* 2674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PaymentAccountStore = __webpack_require__(2604);
	
	var _PaymentAccountStore2 = _interopRequireDefault(_PaymentAccountStore);
	
	var _IdentityAdditionalVerificationModal = __webpack_require__(2675);
	
	var _IdentityAdditionalVerificationModal2 = _interopRequireDefault(_IdentityAdditionalVerificationModal);
	
	var _PaymentAccountActions = __webpack_require__(2593);
	
	var _PaymentAccountActions2 = _interopRequireDefault(_PaymentAccountActions);
	
	var _PaymentAccount = __webpack_require__(2562);
	
	var _PaymentAccount2 = _interopRequireDefault(_PaymentAccount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IdentityAdditionalVerificationModalContainer = function (_React$Component) {
	  _inherits(IdentityAdditionalVerificationModalContainer, _React$Component);
	
	  function IdentityAdditionalVerificationModalContainer() {
	    _classCallCheck(this, IdentityAdditionalVerificationModalContainer);
	
	    return _possibleConstructorReturn(this, (IdentityAdditionalVerificationModalContainer.__proto__ || Object.getPrototypeOf(IdentityAdditionalVerificationModalContainer)).apply(this, arguments));
	  }
	
	  _createClass(IdentityAdditionalVerificationModalContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_IdentityAdditionalVerificationModal2.default, _extends({}, this.props, {
	        account: this.state.account,
	        patchPII: _PaymentAccountActions2.default.patchPII
	      }));
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_PaymentAccountStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        account: _PaymentAccountStore2.default.getPaymentAccount()
	      };
	    }
	  }]);
	
	  return IdentityAdditionalVerificationModalContainer;
	}(_react2.default.Component);
	
	IdentityAdditionalVerificationModalContainer.displayName = 'IdentityAdditionalVerificationModalContainer';
	exports.default = _utils.Container.create(IdentityAdditionalVerificationModalContainer, { withProps: true, pure: false });

/***/ },
/* 2675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _PaymentAccount = __webpack_require__(2562);
	
	var _PaymentAccount2 = _interopRequireDefault(_PaymentAccount);
	
	var _StripePersonalNumberForm = __webpack_require__(2676);
	
	var _StripePersonalNumberForm2 = _interopRequireDefault(_StripePersonalNumberForm);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _EncryptionNotice = __webpack_require__(1970);
	
	var _EncryptionNotice2 = _interopRequireDefault(_EncryptionNotice);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dialogSubtext = _react2.default.createElement(
	  'span',
	  null,
	  _react2.default.createElement(
	    _Link2.default,
	    { target: '_blank', href: 'http://www.stripe.com' },
	    'Stripe'
	  ),
	  ', our payment processor, needs your full Social Security number to complete this transaction. We don\u2019t store this information on Remind\u2019s servers.'
	);
	
	var IdentityAdditionalVerificationModal = function (_React$Component) {
	  _inherits(IdentityAdditionalVerificationModal, _React$Component);
	
	  function IdentityAdditionalVerificationModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IdentityAdditionalVerificationModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IdentityAdditionalVerificationModal.__proto__ || Object.getPrototypeOf(IdentityAdditionalVerificationModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      proccessing: false
	    }, _this.onValidSubmit = function (token) {
	      function onSuccess() {
	        _ToastActions2.default.showSuccessToast('Account saved.');
	        this.props.onRequestHide();
	      }
	
	      function onError(error) {
	        _ToastActions2.default.showAPIError(error);
	      }
	
	      _this.setState({ proccessing: true });
	
	      _this.props.patchPII({ personal_id_number: token }).then(onSuccess, onError).then(function () {
	        return _this.setState({ proccessing: false });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(IdentityAdditionalVerificationModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'IdentityAdditionalVerificationModal'
	        }, this.props, {
	          size: 'small',
	          subtext: dialogSubtext,
	          title: 'Looks like we need a little more information',
	          className: 'IdentityAdditionalVerificationModal' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(_StripePersonalNumberForm2.default, {
	            disabled: this.state.proccessing,
	            onValidSubmit: this.onValidSubmit
	          }),
	          _react2.default.createElement(_EncryptionNotice2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return IdentityAdditionalVerificationModal;
	}(_react2.default.Component);
	
	IdentityAdditionalVerificationModal.displayName = 'IdentityAdditionalVerificationModal';
	exports.default = IdentityAdditionalVerificationModal;

/***/ },
/* 2676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _StripeAPI = __webpack_require__(1979);
	
	var _StripeAPI2 = _interopRequireDefault(_StripeAPI);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	__webpack_require__(2677);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	function isSSN(value) {
	  return (/^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/.test(value)
	  );
	}
	
	var StripePersonalNumberForm = function (_React$Component) {
	  _inherits(StripePersonalNumberForm, _React$Component);
	
	  function StripePersonalNumberForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StripePersonalNumberForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StripePersonalNumberForm.__proto__ || Object.getPrototypeOf(StripePersonalNumberForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      personalIdNumber: null,
	      proccessing: false
	    }, _this.onKeyUp = function () {
	      if (_this.state.error) {
	        if (isSSN(_this.state.personalIdNumber || '')) {
	          _this.setState({ error: undefined });
	        }
	      }
	    }, _this.submit = function () {
	      if (!isSSN(_this.state.personalIdNumber || '')) {
	        _this.setState({ error: 'Invalid ssn format' });
	        return;
	      }
	
	      if (_this.state.error) {
	        _this.setState({ error: undefined });
	      }
	
	      _this.setState({ proccessing: true });
	
	      _StripeAPI2.default.createPIIToken({ personal_id_number: _this.state.personalIdNumber }, function (status, response) {
	        if (response.error) {
	          _this.setState({ error: response.error.message });
	        } else {
	          _this.props.onValidSubmit(response.id);
	        }
	
	        _this.setState({ proccessing: false });
	      });
	    }, _this.onChange = function (event) {
	      if (event.target) {
	        _this.setState({ personalIdNumber: event.target.value });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StripePersonalNumberForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _StripeAPI2.default.setPublishableKey(_SettingsStore2.default.getStripeKey());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'StripePersonalNumberForm' },
	        _react2.default.createElement(
	          _Field2.default,
	          { error: this.state.error, className: 'StripePersonalNumberForm-field' },
	          _react2.default.createElement(_Input2.default, {
	            placeholder: '000-00-0000',
	            name: 'personal_id_number',
	            onChange: this.onChange,
	            onKeyUp: this.onKeyUp
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              disabled: this.state.proccessing || this.props.disabled,
	              type: 'submit',
	              size: 'small',
	              onClick: this.submit },
	            'Save'
	          )
	        )
	      );
	    }
	  }]);
	
	  return StripePersonalNumberForm;
	}(_react2.default.Component);
	
	StripePersonalNumberForm.displayName = 'StripePersonalNumberForm';
	exports.default = StripePersonalNumberForm;

/***/ },
/* 2677 */
1136,
/* 2678 */,
/* 2679 */
1136,
/* 2680 */,
/* 2681 */
1136,
/* 2682 */,
/* 2683 */
1136,
/* 2684 */,
/* 2685 */
1136,
/* 2686 */,
/* 2687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2688);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'WalletTabLoader',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('WalletTabLoader', this.props.className) },
	      _react2.default.createElement(_LoadingIndicator2.default, null)
	    );
	  }
	});

/***/ },
/* 2688 */
1136,
/* 2689 */,
/* 2690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActivitiesClassViewHeaderActionsContainer = __webpack_require__(2691);
	
	var _ActivitiesClassViewHeaderActionsContainer2 = _interopRequireDefault(_ActivitiesClassViewHeaderActionsContainer);
	
	__webpack_require__(2695);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivitiesClassViewHeader = function (_React$Component) {
	  _inherits(ActivitiesClassViewHeader, _React$Component);
	
	  function ActivitiesClassViewHeader() {
	    _classCallCheck(this, ActivitiesClassViewHeader);
	
	    return _possibleConstructorReturn(this, (ActivitiesClassViewHeader.__proto__ || Object.getPrototypeOf(ActivitiesClassViewHeader)).apply(this, arguments));
	  }
	
	  _createClass(ActivitiesClassViewHeader, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivitiesClassViewHeader' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesClassViewHeader-title' },
	          'Activities'
	        ),
	        _react2.default.createElement(_ActivitiesClassViewHeaderActionsContainer2.default, null)
	      );
	    }
	  }]);
	
	  return ActivitiesClassViewHeader;
	}(_react2.default.Component);
	
	ActivitiesClassViewHeader.displayName = 'ActivitiesClassViewHeader';
	exports.default = ActivitiesClassViewHeader;

/***/ },
/* 2691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ActivitiesClassViewHeaderActions = __webpack_require__(2692);
	
	var _ActivitiesClassViewHeaderActions2 = _interopRequireDefault(_ActivitiesClassViewHeaderActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivitiesClassViewHeaderActionsContainer = function (_React$Component) {
	  _inherits(ActivitiesClassViewHeaderActionsContainer, _React$Component);
	
	  function ActivitiesClassViewHeaderActionsContainer() {
	    _classCallCheck(this, ActivitiesClassViewHeaderActionsContainer);
	
	    return _possibleConstructorReturn(this, (ActivitiesClassViewHeaderActionsContainer.__proto__ || Object.getPrototypeOf(ActivitiesClassViewHeaderActionsContainer)).apply(this, arguments));
	  }
	
	  _createClass(ActivitiesClassViewHeaderActionsContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ActivitiesClassViewHeaderActions2.default, {
	        canCreateActivity: this.state.canCreateActivity,
	        canGoToTransactionSettings: this.state.canGoToTransactionSettings
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var canCollectMoney = _CurrentUser2.default.getUser().canCollectMoney();
	      var canSendMoney = _CurrentUser2.default.getUser().canSendMoney();
	
	      return {
	        canGoToTransactionSettings: canCollectMoney || canSendMoney,
	        canCreateActivity: _CurrentUser2.default.getUser().canCreateActivity()
	      };
	    }
	  }]);
	
	  return ActivitiesClassViewHeaderActionsContainer;
	}(_react2.default.Component);
	
	ActivitiesClassViewHeaderActionsContainer.displayName = 'ActivitiesClassViewHeaderActionsContainer';
	exports.default = _utils.Container.create(ActivitiesClassViewHeaderActionsContainer);

/***/ },
/* 2692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ActivityCreateDialogContainer = __webpack_require__(1726);
	
	var _ActivityCreateDialogContainer2 = _interopRequireDefault(_ActivityCreateDialogContainer);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	__webpack_require__(2693);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UI_CONTEXT = 'activities_page';
	
	var ActivitiesClassViewHeaderActions = function (_React$Component) {
	  _inherits(ActivitiesClassViewHeaderActions, _React$Component);
	
	  function ActivitiesClassViewHeaderActions() {
	    _classCallCheck(this, ActivitiesClassViewHeaderActions);
	
	    return _possibleConstructorReturn(this, (ActivitiesClassViewHeaderActions.__proto__ || Object.getPrototypeOf(ActivitiesClassViewHeaderActions)).apply(this, arguments));
	  }
	
	  _createClass(ActivitiesClassViewHeaderActions, [{
	    key: 'render',
	    value: function render() {
	      var shouldRender = this.props.canCreateActivity || this.props.canGoToTransactionSettings;
	
	      if (!shouldRender) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivitiesClassViewHeaderActions' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivitiesClassViewHeaderActions-row' },
	          this.props.canGoToTransactionSettings && _react2.default.createElement(
	            _Button2.default,
	            { to: '/settings/transactions', level: 'secondary', size: 'xsmall' },
	            _react2.default.createElement(_Glyph2.default, { name: 'gear', size: 'small' })
	          ),
	          this.props.canCreateActivity && _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_ActivityCreateDialogContainer2.default, null) },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                size: 'xsmall',
	                eventScreenName: _EventTrackingConstants2.default.YOUR_CAMPAIGN_PAYMENTS,
	                eventElementName: 'create_activity',
	                eventContextName: UI_CONTEXT },
	              'Create an activity'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ActivitiesClassViewHeaderActions;
	}(_react2.default.Component);
	
	ActivitiesClassViewHeaderActions.displayName = 'ActivitiesClassViewHeaderActions';
	exports.default = ActivitiesClassViewHeaderActions;

/***/ },
/* 2693 */
1136,
/* 2694 */,
/* 2695 */
1136,
/* 2696 */,
/* 2697 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wolf":"#dcdee2","this":"ActivitiesClassView__this___2N7U3","content":"ActivitiesClassView__content___ovOq5"};

/***/ },
/* 2698 */,
/* 2699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActivitiesClassView = __webpack_require__(2635);
	
	var _ActivitiesClassView2 = _interopRequireDefault(_ActivitiesClassView);
	
	var _ActivityCreateDialogContainer = __webpack_require__(1726);
	
	var _ActivityCreateDialogContainer2 = _interopRequireDefault(_ActivityCreateDialogContainer);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivitiesCreateView = function (_React$Component) {
	  _inherits(ActivitiesCreateView, _React$Component);
	
	  function ActivitiesCreateView() {
	    _classCallCheck(this, ActivitiesCreateView);
	
	    return _possibleConstructorReturn(this, (ActivitiesCreateView.__proto__ || Object.getPrototypeOf(ActivitiesCreateView)).apply(this, arguments));
	  }
	
	  _createClass(ActivitiesCreateView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _modal.mountModal)(_react2.default.createElement(_ActivityCreateDialogContainer2.default, { createParams: this.getCreateParams() }), this);
	    }
	  }, {
	    key: 'getCreateParams',
	    value: function getCreateParams() {
	      var query = this.context.router.location.query;
	      return {
	        title: query.title,
	        location: query.location,
	        date: query.start_at && new Date(query.start_at),
	        amount: query.amount_per_person && parseInt(query.amount_per_person, 10),
	        type: query.event_type,
	        hasChildren: query.has_children ? query.has_children === 'true' : null,
	        disableReplies: query.disable_replies ? query.disable_replies === 'true' : null,
	        message: query.welcome_msg_body
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ActivitiesClassView2.default, null);
	    }
	  }]);
	
	  return ActivitiesCreateView;
	}(_react2.default.Component);
	
	ActivitiesCreateView.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ActivitiesCreateView.displayName = 'ActivitiesCreateView';
	exports.default = ActivitiesCreateView;

/***/ },
/* 2700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SchoolAdminPending = __webpack_require__(2701);
	
	var _SchoolAdminPending2 = _interopRequireDefault(_SchoolAdminPending);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminVerificationPage = function (_Component) {
	  _inherits(AdminVerificationPage, _Component);
	
	  function AdminVerificationPage() {
	    _classCallCheck(this, AdminVerificationPage);
	
	    return _possibleConstructorReturn(this, (AdminVerificationPage.__proto__ || Object.getPrototypeOf(AdminVerificationPage)).apply(this, arguments));
	  }
	
	  _createClass(AdminVerificationPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!_OrganizationStore2.default.isLoaded()) {
	        _OrganizationActions2.default.loadUserOrganizations();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.affiliation) {
	        return _react2.default.createElement(_SchoolAdminPending2.default, { affiliation: this.state.affiliation });
	      } else {
	        return null;
	      }
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_AffiliationStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(_, props) {
	      var orgId = _GroupStore2.default.getGroupForCode(props.params.groupCode).getOrganization().id;
	      return {
	        affiliation: _AffiliationStore2.default.getAffiliation(orgId)
	      };
	    }
	  }]);
	
	  return AdminVerificationPage;
	}(_react.Component);
	
	AdminVerificationPage.displayName = 'AdminVerificationPage';
	exports.default = _utils.Container.create(AdminVerificationPage, { withProps: true });

/***/ },
/* 2701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SchoolAffiliationPending = __webpack_require__(2702);
	
	var _SchoolAffiliationPending2 = _interopRequireDefault(_SchoolAffiliationPending);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _SupportDialog = __webpack_require__(2363);
	
	var _SupportDialog2 = _interopRequireDefault(_SupportDialog);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _YouTubeEmbed = __webpack_require__(2147);
	
	var _YouTubeEmbed2 = _interopRequireDefault(_YouTubeEmbed);
	
	var _AdminRoles = __webpack_require__(2148);
	
	__webpack_require__(1099);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ADMIN_RESOURCES = 'https://www.remind.com/resources/administrators';
	
	
	var SchoolAdminPending = _react2.default.createClass({
	  displayName: 'SchoolAdminPending',
	  renderBox: function renderBox() {
	    return _react2.default.createElement(
	      _Box2.default,
	      {
	        size: 'small',
	        full: true,
	        className: 'SchoolAdminPending-Box' },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: false, size: 'small' },
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolAdminPending-TopText' },
	          'Meanwhile, watch an overview of Remind for Schools.'
	        ),
	        _react2.default.createElement(_YouTubeEmbed2.default, {
	          className: 'SchoolAdminPending-Video',
	          width: 544,
	          height: 306,
	          src: _AdminRoles.VIDEO_URL
	        })
	      ),
	      _react2.default.createElement(
	        _BoxFooter2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolAdminPending-BottomText' },
	          'You can also ',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { href: ADMIN_RESOURCES, target: '_blank' },
	            'check out'
	          ),
	          ' ',
	          'our administrator resources or ',
	          ' ',
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_SupportDialog2.default, null) },
	            _react2.default.createElement(
	              _Link2.default,
	              null,
	              'contact us'
	            )
	          ),
	          ' ',
	          ' with questions.'
	        )
	      )
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'SchoolAdminPending' },
	      _react2.default.createElement(
	        _SchoolAffiliationPending2.default,
	        { affiliation: this.props.affiliation },
	        this.renderBox()
	      )
	    );
	  }
	});
	
	exports.default = SchoolAdminPending;

/***/ },
/* 2702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _OrgRoleActions = __webpack_require__(1583);
	
	var OrgRoleActions = _interopRequireWildcard(_OrgRoleActions);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _Affiliation2 = _interopRequireDefault(_Affiliation);
	
	var _AffiliationStatus = __webpack_require__(1088);
	
	var _AffiliationStatus2 = _interopRequireDefault(_AffiliationStatus);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _MailTo = __webpack_require__(1429);
	
	var _MailTo2 = _interopRequireDefault(_MailTo);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2703);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var SchoolAffiliationPending = _react2.default.createClass({
	  displayName: 'SchoolAffiliationPending',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_OrganizationStore2.default])],
	
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  getStateFromStores: function getStateFromStores() {
	    var org = _OrganizationStore2.default.getOrganization(this.props.affiliation.organization_id);
	    return {
	      orgName: org ? org.getName() : ''
	    };
	  },
	  getMessages: function getMessages(aff) {
	    var subtext = void 0;
	    var title = void 0;
	    if ((0, _Affiliation.needsOptIn)(aff)) {
	      title = 'Introducing Remind for Schools';
	      subtext = _react2.default.createElement(
	        'p',
	        null,
	        'Reach your school instantly with direct, reliable messaging.\n Get started and we\'ll notify the teachers who use Remind that ' + this.state.orgName + '\n has a verified administrator.'
	      );
	    } else if ((0, _Affiliation.needsEmailConf)(aff)) {
	      title = 'Get the new Remind for Schools';
	      subtext = _react2.default.createElement(
	        'p',
	        null,
	        'Confirm your email address so we can verify you as an administrator and give\nyou access to features that support better communication at ' + this.state.orgName + '.'
	      );
	    } else {
	      title = 'We’re verifying your status';
	      subtext = _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Verifying administrators usually takes 1 to 3 business days. You\'ll get an email as\n            soon as we\'re done!'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We currently verify principals and assistant principals at US K-12 schools.\n            If you\u2019re an administrator in a different role, please send an email to ',
	          _react2.default.createElement(_MailTo2.default, { to: 'schooladmin@remindhq.com' }),
	          ' and cc your principal for access to school features.'
	        )
	      );
	    }
	    return { title: title, subtext: subtext };
	  },
	  resendConf: function resendConf() {
	    var email = (0, _Affiliation.getNeedsEmailConf)(this.props.affiliation).official_email;
	    _DeviceActions2.default.resendConfirmationEmail(email).then(function () {
	      return _ToastActions2.default.showSuccessToast('Sent! Please check your email in a few minutes');
	    }, function (error) {
	      return _ToastActions2.default.showAPIError(error);
	    });
	  },
	  acceptAdminship: function acceptAdminship() {
	    var org = _OrganizationStore2.default.getOrganization(this.props.affiliation.organization_id);
	    OrgRoleActions.adminOptIn(org.id, org.getName(), this.props.affiliation);
	    this.context.router.push('/classes');
	  },
	  rejectAdminship: function rejectAdminship() {
	    var org = _OrganizationStore2.default.getOrganization(this.props.affiliation.organization_id);
	    OrgRoleActions.adminOptOut(org.id, org.getName(), this.props.affiliation);
	    this.context.router.push('/classes');
	  },
	  renderCTA: function renderCTA(aff) {
	    if ((0, _Affiliation.needsOptIn)(aff)) {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'SchoolAffiliationPending-CTAButton',
	          eventElementName: 'SchoolAffiliationPending-CTAButton',
	          onClick: this.acceptAdminship },
	        'Get Remind for Schools'
	      );
	    } else if ((0, _Affiliation.needsEmailConf)(aff)) {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'SchoolAffiliationPending-CTAButton',
	          eventElementName: 'SchoolAffiliationPending-CTAButton',
	          onClick: this.resendConf },
	        'Resend confirmation email'
	      );
	    }
	  },
	  render: function render() {
	    var aff = this.props.affiliation;
	
	    var _getMessages = this.getMessages(aff),
	        title = _getMessages.title,
	        subtext = _getMessages.subtext;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _AffiliationStatus2.default,
	        {
	          className: 'SchoolAffiliationPending',
	          avatarSrc: __webpack_require__(1000),
	          title: title,
	          subtext: subtext },
	        this.props.extraSubtext,
	        this.renderCTA(aff),
	        this.props.children,
	        (0, _Affiliation.needsOptIn)(aff) && _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'SchoolAffiliationPending-RejectButton',
	            eventElementName: 'SchoolAffiliationPending-RejectButton',
	            onClick: this.rejectAdminship,
	            level: 'text' },
	          'Don\u2019t want Remind for Schools?'
	        )
	      )
	    );
	  }
	});
	
	exports.default = SchoolAffiliationPending;

/***/ },
/* 2703 */
1136,
/* 2704 */,
/* 2705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	var _utils = __webpack_require__(956);
	
	var _prefillMessageWithGroupName = __webpack_require__(935);
	
	var _AnnouncementComposer = __webpack_require__(2044);
	
	var _AnnouncementComposer2 = _interopRequireDefault(_AnnouncementComposer);
	
	var _ConversationHeader = __webpack_require__(2252);
	
	var _ConversationHeader2 = _interopRequireDefault(_ConversationHeader);
	
	var _MessageList = __webpack_require__(2303);
	
	var _MessageList2 = _interopRequireDefault(_MessageList);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _ChatConstants2 = _interopRequireDefault(_ChatConstants);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Message = __webpack_require__(930);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _groupDisplay = __webpack_require__(1322);
	
	var _MessageActions = __webpack_require__(1228);
	
	var _MessageActions2 = _interopRequireDefault(_MessageActions);
	
	var _MessageStore = __webpack_require__(1232);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _mountTymkPrompt = __webpack_require__(1464);
	
	var _mountTymkPrompt2 = _interopRequireDefault(_mountTymkPrompt);
	
	__webpack_require__(2706);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var AnnouncementsConversationView = function (_React$Component) {
	  _inherits(AnnouncementsConversationView, _React$Component);
	
	  function AnnouncementsConversationView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnnouncementsConversationView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnnouncementsConversationView.__proto__ || Object.getPrototypeOf(AnnouncementsConversationView)).call.apply(_ref, [this].concat(args))), _this), _this.getInitialAnnouncement = function () {
	      var group = _this.props.group;
	
	      var groupKey = (0, _roleHelpers.getGroupKey)(group.id, _this.props.params.role);
	      var onEveryoneThread = _this.props.params.role === _roleHelpers.EVERYONE;
	      if (onEveryoneThread && _MessageStore2.default.getMessages(groupKey).isEmpty()) {
	        var groupName = group.getName();
	        var initialText = (0, _prefillMessageWithGroupName.prefillMessageWithGroupName)(groupName);
	        return _Message.Message.createMessage(null, initialText);
	      } else {
	        return new _Message.Message();
	      }
	    }, _this.loadMessages = function (group) {
	      if (group.isRoot()) {
	        return;
	      }
	
	      var role = _this.props.params.role;
	
	      var thread = group.getThread(role);
	
	      if (thread) {
	        var threadUuid = thread.uuid;
	        _MessageActions2.default.loadThreadMessages(group.id, threadUuid, role);
	        if (group.getPostableRoles().length) {
	          _MessageActions2.default.loadScheduledThreadMessages(group.id, threadUuid, role);
	        }
	      }
	    }, _this.loadMoreMessages = function () {
	      var _this$props = _this.props,
	          group = _this$props.group,
	          params = _this$props.params;
	      var role = params.role;
	
	
	      if (_this.state.gap) {
	        var gapParams = _this.state.gap.getGapParams();
	        _MessageActions2.default.loadThreadMessages(group.id, group.getThread(role).uuid, role, {
	          max_seq: gapParams['max_seq'],
	          since_seq: gapParams['since_seq']
	        });
	      }
	    }, _this.focusComposer = function () {
	      if (_ChatStore2.default.getFocusView() === _ChatConstants2.default.FocusableViews.COMPOSER && _this.refs.composer) {
	        _this.refs.composer.focus();
	      }
	    }, _this.onMessageSent = function () {
	      if (_this.refs.messageList) {
	        _this.refs.messageList.scrollToBottom();
	      }
	      (0, _mountTymkPrompt2.default)(_this, 'send_announcement');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AnnouncementsConversationView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var group = this.props.group;
	
	      this.loadMessages(group);
	      this.focusComposer();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      // shallow state
	      var shallowKeys = ['loading'];
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = shallowKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var key = _step.value;
	
	          if (this.state[key] !== nextState[key]) {
	            return true;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (!(0, _lodash.isEqual)(this.props.params, nextProps.params)) {
	        return true;
	      }
	
	      if (this.state.messages.length !== nextState.messages.length) {
	        return true;
	      }
	
	      var gapPresenceChanged = this.state.gap !== nextState.gap;
	      var gapValueChanged = this.state.gap && nextState.gap && this.state.gap.id !== nextState.gap.id;
	
	      if (gapPresenceChanged || gapValueChanged) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var currentGroup = this.props.group;
	      var roleChanged = prevProps.params.role !== this.props.params.role;
	      var groupChanged = currentGroup !== prevProps.group;
	
	      if (roleChanged || groupChanged) {
	        this.loadMessages(currentGroup);
	      }
	      this.focusComposer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          group = _props.group,
	          params = _props.params;
	      var role = params.role;
	      var messages = this.state.messages;
	
	
	      var loadingIndicator = _react2.default.createElement(
	        'div',
	        { className: 'AnnouncementsConversationView-loadingContainer' },
	        _react2.default.createElement(_LoadingIndicator2.default, { className: 'AnnouncementsConversationView-loading', size: 'large' })
	      );
	
	      var target = {
	        name: group.getName(),
	        type: _Message.TARGET_TYPES.GROUP_TARGET,
	        role: role,
	        group_id: group.id
	      };
	
	      var title = (0, _roleHelpers.getGroupDescription)(group, role);
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('AnnouncementsConversationView', this.props.className) },
	        _react2.default.createElement(_ConversationHeader2.default, {
	          ref: 'header',
	          title: title,
	          subtitle: 'Announcements to ' + (0, _groupDisplay.membershipDescriptionFor)(group, role)
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'AnnouncementsConversationView-body' },
	          this.state.loading ? loadingIndicator : _react2.default.createElement(
	            'div',
	            { className: 'AnnouncementsConversationView-body-wrap' },
	            _react2.default.createElement(_MessageList2.default, {
	              ref: 'messageList',
	              className: 'AnnouncementsConversationView-body-messageList',
	              unreadCount: 0,
	              group: group,
	              messages: messages,
	              loadMoreMessages: this.loadMoreMessages,
	              subgroupRole: this.props.params.role
	            }),
	            _react2.default.createElement(_AnnouncementComposer2.default, {
	              ref: 'composer',
	              initialMessage: this.getInitialAnnouncement(),
	              className: 'AnnouncementsConversationView-body-composer',
	              targets: [target],
	              hideOldInput: true,
	              inAnnouncementsThread: true,
	              charLimit: _CurrentUser2.default.getUser().getAnnouncementCharactersLimit(),
	              charLimitWithFiles: _CurrentUser2.default.getUser().getAnnouncementCharactersLimitWithFiles(),
	              onMessageSent: this.onMessageSent
	            })
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_MessageStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var params = props.params,
	          group = props.group;
	      var role = params.role;
	
	
	      var groupKey = (0, _roleHelpers.getGroupKey)(group.id, role);
	      var messages = _MessageStore2.default.getMessages(groupKey).models.slice(0).reverse();
	
	      var gap = _MessageStore2.default.getGap(groupKey);
	      if (gap) {
	        messages.unshift(new _Message.GapMessage());
	      }
	      var thread = group.getThread(role);
	      return {
	        gap: gap,
	        messages: messages,
	        // May be a fake promo thread, in which case we have nothing to load
	        loading: !!thread && !_MessageStore2.default.isDoneLoadingForGroup(groupKey)
	      };
	    }
	  }]);
	
	  return AnnouncementsConversationView;
	}(_react2.default.Component);
	
	AnnouncementsConversationView.displayName = 'AnnouncementsConversationView';
	exports.default = _utils.Container.create(AnnouncementsConversationView, {
	  withProps: true,
	  pure: false
	});

/***/ },
/* 2706 */
1136,
/* 2707 */,
/* 2708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChatLearnMore = __webpack_require__(2709);
	
	var _ChatLearnMore2 = _interopRequireDefault(_ChatLearnMore);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ChatPromises = __webpack_require__(1569);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _roleHelpers = __webpack_require__(1230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatDefaultView = function (_React$Component) {
	  _inherits(ChatDefaultView, _React$Component);
	
	  function ChatDefaultView() {
	    _classCallCheck(this, ChatDefaultView);
	
	    return _possibleConstructorReturn(this, (ChatDefaultView.__proto__ || Object.getPrototypeOf(ChatDefaultView)).apply(this, arguments));
	  }
	
	  _createClass(ChatDefaultView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ChatLearnMore2.default, { groupCode: this.props.params.groupCode });
	    }
	  }], [{
	    key: 'onEnter',
	
	    // This code controls which chat thread is focused upon entering the /messages or /inbox routes
	    value: function onEnter(nextState, replaceWith, callback) {
	      var groupCode = nextState.params.groupCode;
	
	      var group = _GroupStore2.default.getGroupForCode(groupCode);
	      var user = _CurrentUser2.default.getUser();
	      if (!group || !user) {
	        callback();
	        return;
	      }
	
	      (0, _ChatPromises.promiseGroupOrRootChats)(groupCode).then(function () {
	        var query = nextState.location.query;
	
	        // If the user can send announcements to this group, redirect to the appropriate announcements thread
	
	        var postableRoles = group.getPostableRoles();
	        if (postableRoles.length) {
	          var target = postableRoles.includes(_roleHelpers.EVERYONE) ? _roleHelpers.EVERYONE : postableRoles[0];
	          replaceWith({
	            pathname: '/classes/' + groupCode + '/messages/announcements/' + target,
	            query: query
	          });
	        } else {
	          // Otherwise, focus the first chat, if any
	          var chats = _ChatStore2.default.getChats(group);
	          var firstChat = chats.find(function (chat) {
	            return !chat.isNew();
	          });
	          if (firstChat) {
	            replaceWith({ pathname: '/classes/' + groupCode + '/messages/' + firstChat.id, query: query });
	          }
	        }
	
	        callback();
	      }).catch(function (err) {
	        _ToastActions2.default.showErrorToast('Messages could not be loaded. Please wait and try again later.');
	        console.warn(err);
	        callback();
	      });
	    }
	  }]);
	
	  return ChatDefaultView;
	}(_react2.default.Component);
	
	ChatDefaultView.displayName = 'ChatDefaultView';
	exports.default = ChatDefaultView;

/***/ },
/* 2709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UniversalComposeButtonContainer = __webpack_require__(1723);
	
	var _UniversalComposeButtonContainer2 = _interopRequireDefault(_UniversalComposeButtonContainer);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2710);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatLearnMore = function (_React$Component) {
	  _inherits(ChatLearnMore, _React$Component);
	
	  function ChatLearnMore() {
	    _classCallCheck(this, ChatLearnMore);
	
	    return _possibleConstructorReturn(this, (ChatLearnMore.__proto__ || Object.getPrototypeOf(ChatLearnMore)).apply(this, arguments));
	  }
	
	  _createClass(ChatLearnMore, [{
	    key: 'isGroupOwner',
	    value: function isGroupOwner() {
	      var group = _GroupStore2.default.getGroupForCode(this.props.groupCode);
	      return !!group && group.isOwnedByUser(_CurrentUser2.default.getUserId());
	    }
	  }, {
	    key: 'renderSubtext',
	    value: function renderSubtext() {
	      if (this.isGroupOwner()) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          'Reach individuals and groups by text, app, web, and email.'
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _CurrentUser2.default.getUser().isUnderage() ? 'Never miss a class announcement. Once you turn 13, you can reply to ' + 'messages you receive.' : 'Reach your teachers to stay in the loop.'
	        );
	      }
	    }
	  }, {
	    key: 'renderButton',
	    value: function renderButton() {
	      var isGroupOwner = this.isGroupOwner();
	      return _react2.default.createElement(_UniversalComposeButtonContainer2.default, {
	        className: 'LearnMore-newChat',
	        label: 'Get started',
	        level: 'secondary',
	        size: 'xsmall',
	        hideAnnouncements: !isGroupOwner,
	        hideActivities: !isGroupOwner
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('LearnMore') },
	        _react2.default.createElement(
	          'div',
	          { className: 'LearnMore-container' },
	          _react2.default.createElement(_Image2.default, { src: __webpack_require__(2712) }),
	          _react2.default.createElement(
	            'div',
	            { className: 'LearnMore-heading' },
	            'Direct, reliable messaging. Built for education.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'LearnMore-body' },
	            this.renderSubtext()
	          ),
	          _CurrentUser2.default.getUser().canChat() && this.renderButton()
	        )
	      );
	    }
	  }]);
	
	  return ChatLearnMore;
	}(_react2.default.Component);
	
	ChatLearnMore.displayName = 'ChatLearnMore';
	exports.default = ChatLearnMore;

/***/ },
/* 2710 */
1136,
/* 2711 */,
/* 2712 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2251a3823683f3729a355cd548cbfa27.png";

/***/ },
/* 2713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _getModalToDisplayForQuery = __webpack_require__(2714);
	
	var _getModalToDisplayForQuery2 = _interopRequireDefault(_getModalToDisplayForQuery);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _GroupView = __webpack_require__(2715);
	
	var _GroupView2 = _interopRequireDefault(_GroupView);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupContainer = function (_React$Component) {
	  _inherits(GroupContainer, _React$Component);
	
	  function GroupContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupContainer.__proto__ || Object.getPrototypeOf(GroupContainer)).call.apply(_ref, [this].concat(args))), _this), _this.closeModal = null, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupContainer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        group: this.state.group
	      };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var groupCode = this.props.params.groupCode;
	
	      var group = _GroupStore2.default.getGroupForCode(groupCode);
	
	      if (group) {
	        this.checkLoadOrg({});
	        this.showModal(this.props.location, group);
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this.setState({ modal: null });
	      this.showModal(nextProps.location, nextState.group);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      this.checkLoadOrg(prevState);
	
	      if (this.state.modal) {
	        if (this.closeModal) {
	          this.closeModal();
	        }
	        this.closeModal = (0, _modal.mountModal)(this.state.modal, this);
	      }
	    }
	  }, {
	    key: 'showModal',
	    value: function showModal(location, group) {
	      var router = this.context.router;
	
	      var modal = (0, _getModalToDisplayForQuery2.default)(router, group, location);
	
	      if (modal) {
	        this.setState({ modal: modal });
	        router.replace(location.pathname); // clear the query params
	      }
	    }
	  }, {
	    key: 'getAffiliation',
	    value: function getAffiliation() {
	      var staffClassOrganization = this.state.staffClassOrganization;
	
	      return staffClassOrganization ? _AffiliationStore2.default.getAffiliation(staffClassOrganization.id) : null;
	    }
	  }, {
	    key: 'checkLoadOrg',
	    value: function checkLoadOrg(prevState) {
	      var prevGroup = prevState.group;
	      var group = this.state.group;
	
	      var prevGroupId = prevGroup && prevGroup.id;
	      var groupId = group && group.id;
	      if (prevGroupId !== groupId && groupId) {
	        if (group.isStaffClass()) {
	          _OrganizationActions2.default.getOrLoadOrganization(group.getStaffClassOrgId());
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          group = _state.group,
	          userIsAdmin = _state.userIsAdmin,
	          accentColor = _state.accentColor;
	      var children = this.props.children;
	
	
	      return _react2.default.createElement(
	        _GroupView2.default,
	        {
	          accentColor: accentColor || _Group.DEFAULT_COLOR,
	          group: group,
	          userIsAdmin: userIsAdmin },
	        children
	      );
	    }
	  }], [{
	    key: 'onEnter',
	
	    /*
	     Handles redirecting from /classes/:groupCode to:
	       classes?join=groupCode
	       classes/:groupCode/messages
	       classes/:groupCode/people
	       classes/:groupCode/verify
	      And from:
	       classes/:groupCode/settings to /classes/:groupCode/messages/?settings=true
	       classes/:groupCode/invite   to /classes/:groupCode/messages/?invite=true
	     */
	    value: function onEnter(nextState, replaceWith) {
	      var location = nextState.location.pathname.replace(/\/$/, '');
	      var query = nextState.location.query;
	      var groupCode = nextState.params.groupCode;
	
	      var group = _GroupStore2.default.getGroupForCode(groupCode);
	
	      if (groupCode === 'new') {
	        replaceWith('/classes?action=new-class');
	        return;
	      }
	
	      /* If the group doesn't exist show them to the join group modal */
	      if (!group) {
	        if (location.endsWith('/' + groupCode)) {
	          replaceWith('/classes?join=' + groupCode);
	        } else {
	          replaceWith('/classes');
	        }
	        return;
	      }
	
	      var ownedByMe = group.isOwnedByUser(_CurrentUser2.default.getUserId());
	
	      var doRedirect = false;
	      if (location.endsWith('/' + groupCode + '/settings')) {
	        query.settings = true;
	        doRedirect = true;
	      } else if (ownedByMe && location.endsWith('/' + groupCode + '/invite')) {
	        query.invite = true;
	        doRedirect = true;
	      } else if (location.endsWith('/' + groupCode)) {
	        doRedirect = true;
	      }
	
	      var preventVerify = _CurrentUser2.default.getUser().hasFeature('web_admin_console') && (group.getType() === 'district' || group.isStaffClass());
	
	      if (doRedirect) {
	        var org = group.getOrganization();
	        if (!group.isRoot() && ownedByMe && group.getMembershipsCount() < 3) {
	          replaceWith({ pathname: '/classes/' + groupCode + '/people', query: query });
	        } else if (org) {
	          var affiliation = _AffiliationStore2.default.getAffiliation(org.id);
	          if (!preventVerify && affiliation && ((0, _Affiliation.needsOptIn)(affiliation) || (0, _Affiliation.needsEmailConf)(affiliation))) {
	            replaceWith({ pathname: '/classes/' + groupCode + '/verify', query: query });
	          } else {
	            replaceWith({ pathname: '/classes/' + groupCode + '/messages', query: query });
	          }
	        } else {
	          replaceWith({ pathname: '/classes/' + groupCode + '/messages', query: query });
	        }
	      }
	    }
	  }, {
	    key: 'getStores',
	    value: function getStores() {
	      return [_AffiliationStore2.default, _GroupStore2.default, _OrganizationStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var groupCode = props.params.groupCode;
	
	      var group = _GroupStore2.default.getGroupForCode(groupCode);
	
	      // Warning!
	      // The group identified by groupCode may have been removed from GroupStore,
	      // because the user has unsubscribed from the group.
	      if (!group) {
	        // Do not update with a null group!
	        return prevState;
	      }
	
	      var userIsAdmin = false;
	      var org = null;
	      if (group && group.isStaffClass()) {
	        var orgId = group.getStaffClassOrgId();
	        org = _OrganizationStore2.default.getOrganization(orgId);
	        userIsAdmin = !!org && org.isAdminBy(_CurrentUser2.default.getUser());
	      }
	
	      var accentColor = group.getAccentColor();
	
	      return {
	        accentColor: accentColor,
	        userIsAdmin: userIsAdmin,
	        group: group,
	        joinCode: group ? null : groupCode,
	        staffClassOrganization: org
	      };
	    }
	  }]);
	
	  return GroupContainer;
	}(_react2.default.Component);
	
	GroupContainer.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	GroupContainer.childContextTypes = {
	  group: _react2.default.PropTypes.instanceOf(_Group2.default).isRequired
	};
	GroupContainer.displayName = 'GroupContainer';
	exports.default = _utils.Container.create(GroupContainer, { withProps: true });

/***/ },
/* 2714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getModalToDisplayForQuery;
	
	var _qs = __webpack_require__(557);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupCreateModal = __webpack_require__(1326);
	
	var _GroupCreateModal2 = _interopRequireDefault(_GroupCreateModal);
	
	var _GroupInviteModal = __webpack_require__(1435);
	
	var _GroupInviteModal2 = _interopRequireDefault(_GroupInviteModal);
	
	var _GroupSettingsModal = __webpack_require__(2400);
	
	var _GroupSettingsModal2 = _interopRequireDefault(_GroupSettingsModal);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _GroupSubscribedSettingModal = __webpack_require__(2415);
	
	var _GroupSubscribedSettingModal2 = _interopRequireDefault(_GroupSubscribedSettingModal);
	
	var _JoinConfirmSubscriptionModal = __webpack_require__(2536);
	
	var _JoinConfirmSubscriptionModal2 = _interopRequireDefault(_JoinConfirmSubscriptionModal);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _MessageActions = __webpack_require__(1228);
	
	var _MessageActions2 = _interopRequireDefault(_MessageActions);
	
	var _getRedirectLocationAfterGroupCreation = __webpack_require__(2153);
	
	var _getRedirectLocationAfterGroupCreation2 = _interopRequireDefault(_getRedirectLocationAfterGroupCreation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleGroupCreated(router) {
	  return function (group) {
	    router.push((0, _getRedirectLocationAfterGroupCreation2.default)(group));
	  };
	}
	
	/* eslint-disable consistent-return */
	
	// typecheck: ignore file
	function getModalToDisplayForQuery(router, group, location) {
	  var queryData = _qs2.default.parse(location.query);
	  var queryActionData = queryData.actionData;
	
	  if ('join' in queryData) {
	    var joinCode = queryData.join;
	    var groupToJoin = _GroupStore2.default.getGroupForCode(joinCode);
	    if (groupToJoin) {
	      // already joined
	      return null;
	    } else {
	      return _react2.default.createElement(_JoinConfirmSubscriptionModal2.default, { code: joinCode });
	    }
	  }
	
	  if ('action' in queryData) {
	    if (queryActionData) {
	      _MessageActions2.default.saveAndShowDraftFromQuery(queryActionData);
	      router.replace(location.pathname); // messy side effects
	      return null;
	    } else if (queryData.action === 'new-message') {
	      _MessageActions2.default.saveAndShowDraftAnnouncement(new _Message2.default());
	      router.replace(location.pathname);
	      return null;
	    } else if (queryData.action === 'new-class') {
	      return _react2.default.createElement(_GroupCreateModal2.default, { onCreate: handleGroupCreated(router) });
	    }
	  }
	
	  if (!group) {
	    return null;
	  }
	
	  if ('settings' in queryData) {
	    if (group.canEdit()) {
	      return _react2.default.createElement(_GroupSettingsModal2.default, {
	        group: group,
	        onCodeChange: function onCodeChange(groupCode) {
	          return router.push('/classes/' + groupCode);
	        },
	        userIsTeacher: _CurrentUser2.default.getUser().isTeacher()
	      });
	    } else {
	      return _react2.default.createElement(_GroupSubscribedSettingModal2.default, { group: group });
	    }
	  }
	
	  // Show GroupInviteModal for the class created during setup
	  if (_GroupStore2.default.getGroupCreatedDuringSetup() === group) {
	    _GroupStore2.default.clearGroupCreatedDuringSetup();
	    return _react2.default.createElement(_GroupInviteModal2.default, { group: group });
	  }
	
	  if ('invite' in queryData) {
	    // $FlowIssue can't see initialTab?
	    return _react2.default.createElement(_GroupInviteModal2.default, { group: group, initialTab: _GroupInviteModal2.default.TABS.INVITE });
	  }
	}

/***/ },
/* 2715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GroupView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _View = __webpack_require__(2356);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _GroupView = __webpack_require__(2716);
	
	var _GroupView2 = _interopRequireDefault(_GroupView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupView = exports.GroupView = function (_Component) {
	  _inherits(GroupView, _Component);
	
	  function GroupView() {
	    _classCallCheck(this, GroupView);
	
	    return _possibleConstructorReturn(this, (GroupView.__proto__ || Object.getPrototypeOf(GroupView)).apply(this, arguments));
	  }
	
	  _createClass(GroupView, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        group: this.props.group
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          group = _props.group,
	          accentColor = _props.accentColor;
	
	      var content = group ? _react2.default.cloneElement(children, { group: group }) : _react2.default.createElement(_LoadingIndicator2.default, { className: _GroupView2.default.loading });
	
	      return _react2.default.createElement(
	        'div',
	        { className: _GroupView2.default.wrapper },
	        _react2.default.createElement('div', { className: _GroupView2.default.topBorder, style: { backgroundColor: accentColor } }),
	        _react2.default.createElement(
	          _View2.default,
	          {
	            full: true,
	            className: (0, _classnames2.default)(_GroupView2.default.this, this.props.className) },
	          content
	        )
	      );
	    }
	  }]);
	
	  return GroupView;
	}(_react.Component);
	
	GroupView.childContextTypes = {
	  // Can be an org at this point. If it's an org no one will use this context anyway, but we
	  // have to allow for it here to prevent PropTypes errors.
	  group: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.instanceOf(_Group2.default), _react2.default.PropTypes.instanceOf(_Organization2.default)])
	};
	GroupView.displayName = 'GroupView';
	exports.default = GroupView;

/***/ },
/* 2716 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wolf":"#dcdee2","polarBear":"#f2f3f5","this":"GroupView__this___1ti-r","loading":"GroupView__loading___2-2bQ","wrapper":"GroupView__wrapper___3JCio","topBorder":"GroupView__topBorder___Gz-Nz","nuxTopBorder":"GroupView__nuxTopBorder___2sFlu"};

/***/ },
/* 2717 */,
/* 2718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(956);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupMembersTabList = __webpack_require__(2719);
	
	var _GroupMembersTabList2 = _interopRequireDefault(_GroupMembersTabList);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _GroupMembershipStore = __webpack_require__(1900);
	
	var _GroupMembershipStore2 = _interopRequireDefault(_GroupMembershipStore);
	
	var _GroupMembersTabListView = __webpack_require__(2726);
	
	var _GroupMembersTabListView2 = _interopRequireDefault(_GroupMembersTabListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupMembersTabListView = function (_React$Component) {
	  _inherits(GroupMembersTabListView, _React$Component);
	
	  function GroupMembersTabListView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupMembersTabListView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupMembersTabListView.__proto__ || Object.getPrototypeOf(GroupMembersTabListView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupMembersTabListView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var group = _GroupStore2.default.getGroupForCode(this.props.params.groupCode);
	      if (this.state.loading) {
	        _GroupActions2.default.loadGroupMemberships(group);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.groupCode !== this.props.params.groupCode) {
	        var group = _GroupStore2.default.getGroupForCode(nextProps.params.groupCode);
	        (0, _invariant2.default)(group, 'group unavailable in GroupMembersTabListView');
	        if (!_GroupMembershipStore2.default.isLoadedForGroup(group.getUuid())) {
	          _GroupActions2.default.loadGroupMemberships(group);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          group = _state.group,
	          members = _state.members;
	
	      return loading ? _react2.default.createElement(
	        'div',
	        { className: _GroupMembersTabListView2.default.loading },
	        _react2.default.createElement(_LoadingIndicator2.default, { size: 'large' })
	      ) : _react2.default.createElement(_GroupMembersTabList2.default, { group: group, members: members });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_GroupStore2.default, _GroupMembershipStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState, props) {
	      var group = _GroupStore2.default.getGroupForCode(props.params.groupCode);
	
	      if (!group) {
	        return {
	          loading: true
	        };
	      }
	      var uuid = group.getUuid() || 'r';
	
	      var members = _GroupMembershipStore2.default.getGroupMembershipsForGroup(group.id);
	      var loading = !_GroupMembershipStore2.default.isLoadedForGroup(uuid);
	
	      return {
	        group: group,
	        loading: loading,
	        members: members
	      };
	    }
	  }]);
	
	  return GroupMembersTabListView;
	}(_react2.default.Component);
	
	// Need to access props.params for route groupCode information
	
	
	GroupMembersTabListView.displayName = 'GroupMembersTabListView';
	exports.default = _utils.Container.create(GroupMembersTabListView, { withProps: true });

/***/ },
/* 2719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _lodash = __webpack_require__(555);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _groupDisplay = __webpack_require__(1322);
	
	var _AddGroupOwnerModal = __webpack_require__(2407);
	
	var _AddGroupOwnerModal2 = _interopRequireDefault(_AddGroupOwnerModal);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Cookies = __webpack_require__(573);
	
	var _Cookies2 = _interopRequireDefault(_Cookies);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _FeatureStore = __webpack_require__(588);
	
	var _FeatureStore2 = _interopRequireDefault(_FeatureStore);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _GroupMemberships = __webpack_require__(996);
	
	var _GroupMemberships2 = _interopRequireDefault(_GroupMemberships);
	
	var _GroupMembershipStore = __webpack_require__(1900);
	
	var _GroupMembershipStore2 = _interopRequireDefault(_GroupMembershipStore);
	
	var _GroupMembersTabListItem = __webpack_require__(2720);
	
	var _GroupMembersTabListItem2 = _interopRequireDefault(_GroupMembersTabListItem);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _InviteButton = __webpack_require__(2426);
	
	var _InviteButton2 = _interopRequireDefault(_InviteButton);
	
	var _JoinGroupModal = __webpack_require__(2450);
	
	var _JoinGroupModal2 = _interopRequireDefault(_JoinGroupModal);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ScrollWatch = __webpack_require__(1238);
	
	var _ScrollWatch2 = _interopRequireDefault(_ScrollWatch);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _focusNode = __webpack_require__(1210);
	
	var _focusNode2 = _interopRequireDefault(_focusNode);
	
	var _getMatcher = __webpack_require__(1890);
	
	var _getMatcher2 = _interopRequireDefault(_getMatcher);
	
	var _getRedirectLocationAfterGroupJoin = __webpack_require__(2490);
	
	var _getRedirectLocationAfterGroupJoin2 = _interopRequireDefault(_getRedirectLocationAfterGroupJoin);
	
	__webpack_require__(2723);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SORTS = ['firstName', 'lastName', 'subscribedAt'];
	var DEFAULT_SORT = 'firstName';
	
	var SortKeyCookie = {
	  get: function get() {
	    var sort = _Cookies2.default.get('GROUP_SORT_KEY');
	    if (SORTS.indexOf(sort) > -1) {
	      return sort;
	    }
	
	    // if undefined or unknown
	    return DEFAULT_SORT;
	  },
	
	  set: function set(value) {
	    return _Cookies2.default.set('GROUP_SORT_KEY', value);
	  }
	};
	
	var GroupMembersTabList = _react2.default.createClass({
	  displayName: 'GroupMembersTabList',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      results: this.getResults(this.props.members, ''),
	      query: '',
	      sortKey: SortKeyCookie.get(),
	      pendingQueries: 0
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    (0, _focusNode2.default)(_reactDom2.default.findDOMNode(this.refs.searchInput));
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    // if props changed we recompute the search results.
	    this.setState({
	      results: this.getResults(nextProps.members, this.state.query)
	    });
	  },
	  getResults: function getResults(members) {
	    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    if (query === '') {
	      return members;
	    }
	
	    var isMatch = (0, _getMatcher2.default)(query);
	    return new _GroupMemberships2.default(members.filter(function (member) {
	      var user = member.getUser();
	      return isMatch([user.getFullName()]) || isMatch([user.getSignature()]) || isMatch([user.getNote()]);
	    }));
	  },
	  getSortedSubscribers: function getSortedSubscribers(key, members) {
	    var sortedSubscribers = members;
	    switch (key) {
	      case 'lastName':
	        sortedSubscribers = members.sortByLastName();
	        break;
	      case 'subscribedAt':
	        sortedSubscribers = members.sortByCreatedAt();
	        break;
	      case 'role':
	        sortedSubscribers = members.sortByOrganizationRole();
	        break;
	      default:
	        break;
	    }
	
	    return sortedSubscribers;
	  },
	  allMembersLoaded: function allMembersLoaded() {
	    var uuid = this.props.group.getUuid() || 'r';
	    return _GroupMembershipStore2.default.allMembersLoadedForGroup(uuid, this.state.query);
	  },
	  handleFilterSelect: function handleFilterSelect(key) {
	    SortKeyCookie.set(key);
	    this.setState({ sortKey: key });
	  },
	
	
	  // $FlowFixMe
	  handleSearchInput: function handleSearchInput(event) {
	    var value = event.target.value;
	    if (!value) {
	      this.reset();
	      return;
	    }
	    this.updateResults(value);
	  },
	
	
	  // $FlowFixMe
	  updateResults: (0, _lodash.debounce)(function (query) {
	    var _this = this;
	
	    this.setState({
	      results: this.getResults(this.props.members, query),
	      query: query
	    }, function () {
	      if (!_this.allMembersLoaded()) {
	        _this.loadMoreSubscribers();
	      }
	    });
	  }, 300),
	
	  // $FlowFixMe
	  handleSearchKeyDown: function handleSearchKeyDown(event) {
	    var code = event.keyCode;
	    switch (code) {
	      case _KeyConstants2.default.ESCAPE:
	        this.reset();
	        break;
	      default:
	        return;
	    }
	    event.preventDefault();
	  },
	  shouldShowNullState: function shouldShowNullState() {
	    return this.props.members.length < 2;
	  },
	  shouldShowAdminLink: function shouldShowAdminLink() {
	    var group = this.props.group;
	
	
	    if (!_FeatureStore2.default.hasFeature('web_admin_console')) {
	      return false;
	    }
	
	    if (!group.isStaffClass()) {
	      return false;
	    }
	
	    var organization = this.props.group.getOrganization();
	
	    if (!organization) {
	      console.error('error - staff class should always have an oganization.');
	      return false;
	    }
	
	    var affiliation = _AffiliationStore2.default.getAffiliation(organization.id);
	
	    if (!affiliation) {
	      console.error('error - staff class without an affiliation.');
	      return false;
	    }
	
	    return (0, _Affiliation.isAdmin)(affiliation);
	  },
	  hasPendingQueries: function hasPendingQueries() {
	    return this.state.pendingQueries > 0;
	  },
	  loadMoreSubscribers: function loadMoreSubscribers() {
	    var _this2 = this;
	
	    this.setState({
	      pendingQueries: this.state.pendingQueries + 1
	    });
	    var numResults = this.state.results.length;
	    var page = Math.floor(numResults / _Group.GROUP_MEMBER_PAGE_SIZE) + 1;
	    var group = this.props.group;
	
	    var loadPromise = group.isRoot() ? _GroupActions2.default.loadRootGroupMemberships({
	      page: page,
	      perPage: _Group.GROUP_MEMBER_PAGE_SIZE,
	      query: this.state.query
	    }) : _GroupActions2.default.loadGroupMemberships(this.props.group, {
	      page: page,
	      perPage: _Group.GROUP_MEMBER_PAGE_SIZE,
	      query: this.state.query
	    });
	
	    loadPromise.then(function () {
	      return _this2.setState({
	        pendingQueries: _this2.state.pendingQueries - 1
	      });
	    });
	  },
	  loadingIndicatorEnter: function loadingIndicatorEnter() {
	    if (!this.hasPendingQueries() && !this.allMembersLoaded()) {
	      this.loadMoreSubscribers();
	    }
	  },
	  reset: function reset() {
	    this.setState({
	      results: this.props.members,
	      query: ''
	    });
	  },
	  waitingOnQueries: function waitingOnQueries() {
	    return this.hasPendingQueries() && !this.allMembersLoaded();
	  },
	  handleGroupJoined: function handleGroupJoined(group) {
	    this.context.router.push((0, _getRedirectLocationAfterGroupJoin2.default)(group));
	  },
	  renderSearchBar: function renderSearchBar() {
	    var group = this.props.group;
	
	    var placeholder = 'Search ' + (0, _groupDisplay.memberTypeFor)(group);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'GroupMembersTabList-top' },
	      _react2.default.createElement(
	        'div',
	        { className: 'GroupMembersTabList-actions' },
	        _react2.default.createElement(
	          'div',
	          { className: 'GroupMembersTabList-actions-search' },
	          _react2.default.createElement(
	            'div',
	            { className: 'GroupMembersTabList-actions-search-inputWrap' },
	            _react2.default.createElement(_Input2.default, {
	              ref: 'searchInput',
	              className: 'GroupMembersTabList-actions-search-input',
	              type: 'text',
	              size: 'medium',
	              placeholder: placeholder,
	              onInput: this.handleSearchInput,
	              onKeyDown: this.handleSearchKeyDown
	            }),
	            _react2.default.createElement(_Glyph2.default, {
	              className: 'GroupMembersTabList-actions-search-inputGlyph',
	              name: 'search',
	              size: 'medium'
	            })
	          )
	        ),
	        this.renderSortButton()
	      )
	    );
	  },
	  renderColumnHeaders: function renderColumnHeaders() {
	    var group = this.props.group;
	
	    var showRoles = group.getOrganization();
	
	    return _react2.default.createElement(
	      'tr',
	      null,
	      _react2.default.createElement(
	        'th',
	        { className: 'GroupMembersTabList-name' },
	        _react2.default.createElement(
	          'div',
	          { className: 'GroupMembersTabList-nameHeader' },
	          'Name'
	        )
	      ),
	      showRoles && _react2.default.createElement(
	        'th',
	        { className: 'GroupMembersTabList-role' },
	        'Roles'
	      ),
	      !group.isRoot() && !group.isStaffClass() /* createdAt is inaccurate for staff classes */ && _react2.default.createElement(
	        'th',
	        { className: 'GroupMembersTabList-date' },
	        'Date joined'
	      ),
	      _react2.default.createElement('th', { className: 'GroupMembersTabList-actionsHeader' })
	    );
	  },
	  renderSortButton: function renderSortButton() {
	    var group = this.props.group;
	
	    var menu = _react2.default.createElement(
	      _Menu2.default,
	      { selectedKey: this.state.sortKey, onSelect: this.handleFilterSelect },
	      _react2.default.createElement(
	        _MenuItem2.default,
	        { key: 'firstName' },
	        'By first name'
	      ),
	      _react2.default.createElement(
	        _MenuItem2.default,
	        { key: 'lastName' },
	        'By last name'
	      ),
	      !group.isRoot() && _react2.default.createElement(
	        _MenuItem2.default,
	        { key: 'subscribedAt' },
	        'By most recently joined'
	      ),
	      group.getOrganization() && _react2.default.createElement(
	        _MenuItem2.default,
	        { key: 'role' },
	        'By role'
	      )
	    );
	
	    var tooltip = 'Sort ' + (0, _groupDisplay.memberTypeFor)(this.props.group);
	
	    return _react2.default.createElement(
	      _LayerTrigger2.default,
	      {
	        layer: menu,
	        trigger: 'click',
	        placement: 'bottom',
	        alignment: 'right' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'GroupMembersTabList-filterButton',
	          level: 'text',
	          size: 'small',
	          tooltip: tooltip,
	          tooltipPlacement: 'bottom',
	          eventElementName: 'GroupMembersTabList-filterButton' },
	        _react2.default.createElement(_Glyph2.default, { name: 'sort', size: 'large', solo: true })
	      )
	    );
	  },
	  renderLoadingIndicator: function renderLoadingIndicator() {
	    return _react2.default.createElement(
	      _ScrollWatch2.default,
	      { onEnter: this.loadingIndicatorEnter, threshold: 0.25 },
	      _react2.default.createElement(
	        'div',
	        { className: 'ChatList-loading' },
	        _react2.default.createElement(_LoadingIndicator2.default, { size: 'small' })
	      )
	    );
	  },
	  renderNullState: function renderNullState() {
	    var group = this.props.group;
	
	    var search = !this.waitingOnQueries() && this.state.results.length === 0;
	
	    var title = null;
	    var subtitle = null;
	    var button = _react2.default.createElement(_InviteButton2.default, { level: 'secondary', group: group, forceType: 'button' });
	
	    if (group.isRoot()) {
	      if (_GroupStore2.default.getGroups().length === 0) {
	        title = 'Remind is better with other people';
	        subtitle = 'Connect with others at your school.';
	        button = _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: _react2.default.createElement(_JoinGroupModal2.default, { onJoin: this.handleGroupJoined }) },
	          _react2.default.createElement(
	            _Button2.default,
	            { level: 'secondary' },
	            'Join a class'
	          )
	        );
	      } else {
	        title = 'Remind is better with other people';
	        subtitle = 'It’s a little lonely around here. Why not add some participants?';
	      }
	    } else {
	      title = 'Remind is better with other people';
	      subtitle = group.getName() + ' feels a little lonely. Why not add some participants?';
	    }
	
	    if (search && this.state.query.length > 0) {
	      title = 'No participants matched your search.';
	      subtitle = '';
	      button = null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'GroupMembersTabList-empty' },
	      _react2.default.createElement(_TitleHeader2.default, {
	        image: __webpack_require__(2725),
	        title: title,
	        subtext: subtitle,
	        action: button
	      })
	    );
	  },
	  renderResults: function renderResults() {
	    var searchReturnedNoResults = !this.waitingOnQueries() && this.state.results.length === 0;
	    var results = this.getSortedSubscribers(this.state.sortKey, this.state.results);
	
	    var noResultsNull = _react2.default.createElement(
	      'div',
	      { className: 'GroupMembersTabList-noSearchResultsWrap' },
	      this.renderNullState()
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'GroupMembersTabList-table-wrap' },
	      _react2.default.createElement(
	        'table',
	        { className: 'GroupMembersTabList-table' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          this.renderColumnHeaders()
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'td',
	              { colSpan: '4' },
	              this.renderSearchBar()
	            )
	          ),
	          results.map(this.renderSubscriber)
	        )
	      ),
	      searchReturnedNoResults && noResultsNull,
	      !this.allMembersLoaded() && this.renderLoadingIndicator()
	    );
	  },
	  renderSubscriber: function renderSubscriber(member, index) {
	    var id = member.getUser().id;
	
	    return _react2.default.createElement(_GroupMembersTabListItem2.default, {
	      ref: 'searchItem-' + index,
	      className: 'GroupMembersTabList-tableItem',
	      key: id,
	      member: member,
	      isLinkedToOrg: !!this.props.group.getOrganization(),
	      query: this.state.query,
	      displayBy: this.state.sortKey,
	      group: this.props.group
	    });
	  },
	  renderHeader: function renderHeader(group) {
	    var showInviteButton = group.canAddPeople() || group.isRoot();
	    var membersCount = group.getMembershipsCount();
	    var showMemberCount = !group.isRoot() && // not viewing 'all classes'
	    membersCount > 2 && ( // more than one subscriber (yourself)
	    group.isOwnedByUser(_CurrentUser2.default.getUserId()) || group.isSearchable()); // group is searchable, or you own it
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'GroupMembersTabList-header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'GroupMembersTabList-header-wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'GroupMembersTabList-header-title' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            _react2.default.createElement(
	              _Text2.default,
	              { size: 'large' },
	              'People ',
	              showMemberCount && _react2.default.createElement(
	                _Text2.default,
	                { color: 'thunder' },
	                '(',
	                membersCount,
	                ')'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'GroupMembersTabList-header-actions' },
	          group.canAddOwner() && _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_AddGroupOwnerModal2.default, { group: group }) },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                level: 'secondary',
	                size: 'small',
	                className: 'GroupMembersTabList-header-actions-addOwner',
	                eventElementName: 'GroupMembersTabList-header-actions-addOwner' },
	              'Add owner'
	            )
	          ),
	          showInviteButton && _react2.default.createElement(_InviteButton2.default, {
	            group: group,
	            forceType: 'button'
	          })
	        )
	      )
	    );
	  },
	  renderAdminLink: function renderAdminLink() {
	    var org = this.props.group.getOrganization();
	    (0, _invariant2.default)(org, 'must have an org to render the admin link');
	    return _react2.default.createElement(
	      'div',
	      { className: 'GroupMembersTabList-admin-link' },
	      _react2.default.createElement(_Image2.default, {
	        height: 32,
	        width: 27,
	        className: 'GroupMembersTabList-admin-link-image',
	        src: __webpack_require__(2535)
	      }),
	      'Manage your school more easily by trying the',
	      ' ',
	      _react2.default.createElement(
	        _Link2.default,
	        { href: '/admin/schools/' + org.id + '/information/people', target: '_blank' },
	        'Admin Console'
	      ),
	      '.'
	    );
	  },
	  render: function render() {
	    var group = this.props.group;
	
	    var showNullState = this.shouldShowNullState();
	    var showHeader = !showNullState; // hide header in null state
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)('GroupMembersTabList', this.props.className) },
	      showHeader && this.renderHeader(group),
	      _react2.default.createElement(
	        'div',
	        { className: 'GroupMembersTabList-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'GroupMembersTabList-content-body' },
	          this.shouldShowAdminLink() && this.renderAdminLink(),
	          showNullState ? this.renderNullState() : this.renderResults()
	        )
	      )
	    );
	  }
	});
	
	exports.default = GroupMembersTabList;

/***/ },
/* 2720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GroupMembersTabListItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Coin = __webpack_require__(1671);
	
	var _Coin2 = _interopRequireDefault(_Coin);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Buttons = __webpack_require__(1315);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _OrgRoleDropdown = __webpack_require__(1578);
	
	var _OrgRoleDropdown2 = _interopRequireDefault(_OrgRoleDropdown);
	
	var _RelationshipModal = __webpack_require__(1309);
	
	var _RelationshipModal2 = _interopRequireDefault(_RelationshipModal);
	
	var _StartChatButton = __webpack_require__(1567);
	
	var _StartChatButton2 = _interopRequireDefault(_StartChatButton);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _GroupMembersTabUserActions = __webpack_require__(1574);
	
	var _GroupMembersTabUserActions2 = _interopRequireDefault(_GroupMembersTabUserActions);
	
	var _ChatRouteHelper = __webpack_require__(1568);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _recentMessagesModal = __webpack_require__(1570);
	
	var _AddGroupOwnerModalConfirm = __webpack_require__(1576);
	
	var _AddGroupOwnerModalConfirm2 = _interopRequireDefault(_AddGroupOwnerModalConfirm);
	
	__webpack_require__(2721);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var GroupMembersTabListItem = exports.GroupMembersTabListItem = function (_React$Component) {
	  _inherits(GroupMembersTabListItem, _React$Component);
	
	  function GroupMembersTabListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupMembersTabListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupMembersTabListItem.__proto__ || Object.getPrototypeOf(GroupMembersTabListItem)).call.apply(_ref, [this].concat(args))), _this), _this.isCurrentUser = function () {
	      return _this.props.member.getUser().id === _CurrentUser2.default.getUser().id;
	    }, _this.startChatWithMember = function () {
	      var _this$props = _this.props,
	          group = _this$props.group,
	          member = _this$props.member;
	
	
	      (0, _ChatRouteHelper.pushRouterToChatWithMember)(_this.context.router, _this.props.showRecent, _this.props.hideRecent, member.getUser(), group);
	    }, _this.renderActions = function () {
	      var member = _this.props.member;
	      var group = _this.props.group;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'GroupMembersTabListItem-actions' },
	        _react2.default.createElement(
	          _Buttons2.default,
	          { align: 'right' },
	          member.getCanChat() && _react2.default.createElement(_StartChatButton2.default, {
	            className: 'GroupMembersTabListItem-chatButton',
	            useGlyph: true,
	            subscriber: _this.props.member.getUser()
	          }),
	          _react2.default.createElement(_GroupMembersTabUserActions2.default, {
	            className: 'GroupMembersTabListItem-actionButton',
	            tooltip: 'More Actions',
	            tooltipPlacement: 'top',
	            level: 'text',
	            groupToAdmin: group,
	            groupMembership: member,
	            showViewProfile: true
	          })
	        )
	      );
	    }, _this.renderInfo = function () {
	      if (_this.isCurrentUser()) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'GroupMembersTabListItem-actions' },
	          _this.renderUnder13Label()
	        );
	      } else {
	        return _this.renderActions();
	      }
	    }, _this.renderMakeOwnerDialog = function () {
	      return _react2.default.createElement(_AddGroupOwnerModalConfirm2.default, {
	        group: _this.props.group,
	        checkedIds: [_this.props.member.getUser().id],
	        userName: _this.props.member.getUser().getName()
	      });
	    }, _this.renderName = function () {
	      var _this$props2 = _this.props,
	          member = _this$props2.member,
	          query = _this$props2.query;
	
	      var subscriber = member.getUser();
	
	      var actionClass = function () {
	        if (member.getCanChat() || _this.isCurrentUser()) {
	          return 'GroupMembersTabListItem--actionable';
	        } else {
	          return null;
	        }
	      }();
	
	      var name = subscriber.getFirstName() + ' ' + subscriber.getLastName();
	
	      // U13 children have a "name" provided by the server, but no first/last name.
	      if (name === ' ') {
	        name = subscriber.getName();
	      }
	      var signature = ' (' + subscriber.getSignature() + ')';
	      var note = _this.isCurrentUser() ? 'You' : subscriber.getNote();
	      var crownBadge = _react2.default.createElement(
	        _Coin2.default,
	        { className: 'GroupMembersTabListItem-badge', color: 'midnight', size: 'small' },
	        _react2.default.createElement(_Glyph2.default, { name: 'crown', color: 'white', size: 'xxsmall', solo: true })
	      );
	
	      if (query && query !== '') {
	        var parser = _TextEntities2.default.createTextMatchingParser(query);
	
	        if (subscriber.getSignature() && parser(signature).length > parser(name).length) {
	          signature = _react2.default.createElement(_TextWithEntities2.default, { text: signature, entities: parser(signature) });
	        } else {
	          signature = '';
	        }
	        if (note) {
	          note = _react2.default.createElement(_TextWithEntities2.default, { text: note, entities: parser(note) });
	        }
	        name = _react2.default.createElement(_TextWithEntities2.default, { text: name, entities: parser(name) });
	      }
	
	      var nameView = _this.isCurrentUser() ? _react2.default.createElement(
	        _MediaObject2.default,
	        { gutter: 'small', center: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'GroupMembersTabListItem-avatarBadgeWrap' },
	          _react2.default.createElement(_Avatar2.default, {
	            color: 'grey',
	            text: subscriber.getInitials(),
	            size: 'medium'
	          }),
	          member.isOwner() && crownBadge
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            className: (0, _classnames2.default)('GroupMembersTabListItem-userName', actionClass),
	            truncate: true },
	          name,
	          query && signature
	        )
	      ) : _react2.default.createElement(
	        _MediaObject2.default,
	        { gutter: 'small', center: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'GroupMembersTabListItem-avatarBadgeWrap' },
	          _react2.default.createElement(_Avatar2.default, {
	            colorHex: subscriber.getColor(),
	            text: subscriber.getInitials(),
	            size: 'medium'
	          }),
	          member.isOwner() && crownBadge
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            className: (0, _classnames2.default)('GroupMembersTabListItem-userName', actionClass),
	            truncate: true },
	          name,
	          query && signature,
	          _react2.default.createElement(
	            _Text2.default,
	            {
	              color: 'eclipse',
	              size: 'xxsmall',
	              truncate: true },
	            note
	          )
	        )
	      );
	
	      // wrap in an appropriate click handler
	      var clickHandler = null;
	      if (_this.isCurrentUser()) {
	        clickHandler = function clickHandler() {
	          return _this.context.router.push('/settings');
	        };
	      } else if (member.getCanChat()) {
	        clickHandler = _this.startChatWithMember;
	      }
	      return _react2.default.createElement(
	        'div',
	        { onClick: clickHandler },
	        nameView
	      );
	    }, _this.renderRoles = function () {
	      var _this$props3 = _this.props,
	          group = _this$props3.group,
	          member = _this$props3.member;
	
	      var orgAffView = member.getOrgAffiliationView();
	
	      if (!orgAffView) {
	        return null;
	      }
	
	      // remove admin from potential roles, this is an admin console feature.
	      var potentialRoles = orgAffView.potential_roles.filter(function (potentialRole) {
	        return potentialRole.role !== 'admin';
	      });
	
	      // if user can change role inside the admin console
	      // then we disable changing role in the core app.
	      // roles can still be initialized here (like non admin teachers can).
	      var canChangeRoleInAdminConsole = !!(_CurrentUser2.default.getUser().hasFeature('web_admin_console') && _this.props.group.isStaffClass() && _this.props.group.getOrganization() && _this.props.group.getOrganization().get('paid'));
	
	      var canHaveRoleChanged = !canChangeRoleInAdminConsole && orgAffView.can_have_role_changed;
	      var user = member.getUser();
	
	      return _react2.default.createElement(_OrgRoleDropdown2.default, {
	        roles: orgAffView.roles,
	        potentialRoles: potentialRoles,
	        canHaveRoleInitialized: orgAffView.can_have_role_initialized,
	        canHaveRoleChanged: canHaveRoleChanged,
	        name: user.getFullName(),
	        group: group,
	        userId: user.id
	      });
	    }, _this.renderRelationshipDialog = function () {
	      return _react2.default.createElement(_RelationshipModal2.default, {
	        groupToAdmin: _this.props.group,
	        groupMember: _this.props.member,
	        userId: _this.props.member.getUser().id
	      });
	    }, _this.renderUnder13Label = function () {
	      // return <StatusLabel>Under 13</StatusLabel>;
	      return null; // FIXME: alter API to send this data
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupMembersTabListItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          member = _props.member,
	          isLinkedToOrg = _props.isLinkedToOrg,
	          className = _props.className,
	          group = _props.group;
	
	
	      return _react2.default.createElement(
	        'tr',
	        {
	          className: (0, _classnames2.default)('GroupMembersTabListItem', className, (0, _getPropClasses.getPropClassesFromInstance)(this)) },
	        _react2.default.createElement(
	          'td',
	          { className: 'GroupMembersTabListItem-name' },
	          this.renderName()
	        ),
	        isLinkedToOrg && _react2.default.createElement(
	          'td',
	          null,
	          this.renderRoles()
	        ),
	        !group.isRoot() && !group.isStaffClass() /* createdAt is inaccurate for staff classes */ && _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_Time2.default, { date: member.getCreatedAt(), month: 'short', day: 'numeric', year: 'numeric' })
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'GroupMembersTabListItem-info' },
	          this.renderInfo()
	        )
	      );
	    }
	  }]);
	
	  return GroupMembersTabListItem;
	}(_react2.default.Component);
	
	GroupMembersTabListItem.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	GroupMembersTabListItem.propClasses = {
	  selected: 'GroupMembersTabListItem-selected',
	  highlight: 'GroupMembersTabListItem-highlight'
	};
	GroupMembersTabListItem.defaultProps = {
	  selected: false,
	  highlight: false
	};
	GroupMembersTabListItem.displayName = 'GroupMembersTabListItem';
	
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    showRecent: _recentMessagesModal.showRecent,
	    hideRecent: _recentMessagesModal.hideRecent
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps, undefined, { pure: false })(GroupMembersTabListItem);

/***/ },
/* 2721 */
1136,
/* 2722 */,
/* 2723 */
1136,
/* 2724 */,
/* 2725 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "73d52d2450300f856212b45d6775cd9c.svg";

/***/ },
/* 2726 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loading":"GroupMembersTabListView__loading___1F-9U","list":"GroupMembersTabListView__list___3CK6j"};

/***/ },
/* 2727 */,
/* 2728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(555);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupMessages = __webpack_require__(2729);
	
	var _GroupMessages2 = _interopRequireDefault(_GroupMessages);
	
	var _Timer = __webpack_require__(1239);
	
	var _ChatPromises = __webpack_require__(1569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupMessagesContainer = function (_React$Component) {
	  _inherits(GroupMessagesContainer, _React$Component);
	
	  function GroupMessagesContainer() {
	    _classCallCheck(this, GroupMessagesContainer);
	
	    return _possibleConstructorReturn(this, (GroupMessagesContainer.__proto__ || Object.getPrototypeOf(GroupMessagesContainer)).apply(this, arguments));
	  }
	
	  _createClass(GroupMessagesContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _Timer.markChange)('to_chats', 'mounted');
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var groupChanged = !(0, _lodash.isEqual)(this.props.group.attributes, nextProps.group.attributes);
	      var routeChanged = !(0, _lodash.isEqual)(this.props.params, nextProps.params);
	      return routeChanged || groupChanged;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          group = _props.group,
	          children = _props.children,
	          params = _props.params;
	
	
	      return _react2.default.createElement(
	        _GroupMessages2.default,
	        { group: group, selectedChatId: params.chatId },
	        _react2.default.cloneElement(children, { group: group })
	      );
	    }
	  }], [{
	    key: 'onEnter',
	    value: function onEnter(nextState, replaceWith, callback) {
	      var groupCode = nextState.params.groupCode;
	
	      (0, _ChatPromises.promiseGroupOrRootChats)(groupCode).then(function () {
	        return callback();
	      });
	    }
	  }]);
	
	  return GroupMessagesContainer;
	}(_react2.default.Component);
	
	GroupMessagesContainer.displayName = 'GroupMessagesContainer';
	exports.default = GroupMessagesContainer;

/***/ },
/* 2729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatConstants = __webpack_require__(941);
	
	var _ChatConstants2 = _interopRequireDefault(_ChatConstants);
	
	var _ChatList = __webpack_require__(2184);
	
	var _ChatList2 = _interopRequireDefault(_ChatList);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _ConnectionState = __webpack_require__(2251);
	
	var _ConnectionState2 = _interopRequireDefault(_ConnectionState);
	
	var _GroupMessages = __webpack_require__(2730);
	
	var _GroupMessages2 = _interopRequireDefault(_GroupMessages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupMessages = function (_React$Component) {
	  _inherits(GroupMessages, _React$Component);
	
	  function GroupMessages() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupMessages);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupMessages.__proto__ || Object.getPrototypeOf(GroupMessages)).call.apply(_ref, [this].concat(args))), _this), _this.reloadChats = function () {
	      var group = _this.props.group;
	
	      _ChatActions2.default.loadChats(group);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupMessages, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventScreenName: 'chat_view'
	      };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _ChatActions2.default.setFocusView(_ChatConstants2.default.FocusableViews.COMPOSER);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _ConnectionState2.default.on('reconnect', this.reloadChats);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (_ChatStore2.default.shouldReloadChats()) {
	        this.reloadChats();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _ConnectionState2.default.removeListener('reconnect', this.reloadChats);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          selectedChatId = _props.selectedChatId,
	          group = _props.group;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: _GroupMessages2.default.this },
	        _react2.default.createElement(_ChatList2.default, {
	          className: _GroupMessages2.default.sidebar,
	          selectedChatId: selectedChatId,
	          group: group
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _GroupMessages2.default.wrap },
	          _react2.default.createElement(
	            'div',
	            { className: _GroupMessages2.default.content },
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return GroupMessages;
	}(_react2.default.Component);
	
	GroupMessages.childContextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	GroupMessages.displayName = 'GroupMessages';
	exports.default = GroupMessages;

/***/ },
/* 2730 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"GroupMessages__this___2g2bh","sidebar":"GroupMessages__sidebar___2NdX-","wrap":"GroupMessages__wrap___3cDpx","content":"GroupMessages__content___2qfvz"};

/***/ },
/* 2731 */,
/* 2732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _qs = __webpack_require__(557);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _groupNavigation = __webpack_require__(2489);
	
	var _NoGroupsView = __webpack_require__(2733);
	
	var _NoGroupsView2 = _interopRequireDefault(_NoGroupsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupsIndexHandler = function (_React$Component) {
	  _inherits(GroupsIndexHandler, _React$Component);
	
	  function GroupsIndexHandler() {
	    _classCallCheck(this, GroupsIndexHandler);
	
	    return _possibleConstructorReturn(this, (GroupsIndexHandler.__proto__ || Object.getPrototypeOf(GroupsIndexHandler)).apply(this, arguments));
	  }
	
	  _createClass(GroupsIndexHandler, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var router = this.context.router;
	      var defaultGroupOrOrg = this.props.defaultGroupOrOrg;
	
	      // XXX this should be an else condition, but that creates an infinite loop with the redirect in
	      // groups view when joining a group. Fix by creating an empty state for GroupView so there is no
	      // need to redirect to /classes when joining a group
	
	      var _props$location$query = this.props.location.query,
	          join = _props$location$query.join,
	          admin = _props$location$query.admin,
	          action = _props$location$query.action;
	
	      // Pull out actionData and stringify it in order to pass it through as a query param
	      // Yes, this looks silly.  Necessary because query.queryParams doesn't exist
	      // Also, qs interprets undefined as an empty string, so need to expressly declare
	
	      var actionData = _qs2.default.stringify(_qs2.default.parse(this.props.location.query).queryParams) || undefined;
	
	      if (defaultGroupOrOrg instanceof _Group2.default) {
	        router.replace({
	          pathname: '/classes/' + defaultGroupOrOrg.getCode(),
	          query: { join: join, admin: admin, action: action, actionData: actionData }
	        });
	      } else if (defaultGroupOrOrg instanceof _Organization2.default) {
	        router.replace({
	          pathname: '/organizations/' + defaultGroupOrOrg.id,
	          query: { join: join, admin: admin, action: action, actionData: actionData }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_NoGroupsView2.default, null);
	    }
	  }]);
	
	  return GroupsIndexHandler;
	}(_react2.default.Component);
	
	GroupsIndexHandler.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	GroupsIndexHandler.displayName = 'GroupsIndexHandler';
	exports.default = GroupsIndexHandler;

/***/ },
/* 2733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _GroupCreateModal = __webpack_require__(1326);
	
	var _GroupCreateModal2 = _interopRequireDefault(_GroupCreateModal);
	
	var _JoinGroupModal = __webpack_require__(2450);
	
	var _JoinGroupModal2 = _interopRequireDefault(_JoinGroupModal);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getRedirectLocationAfterGroupCreation = __webpack_require__(2153);
	
	var _getRedirectLocationAfterGroupCreation2 = _interopRequireDefault(_getRedirectLocationAfterGroupCreation);
	
	var _getRedirectLocationAfterGroupJoin = __webpack_require__(2490);
	
	var _getRedirectLocationAfterGroupJoin2 = _interopRequireDefault(_getRedirectLocationAfterGroupJoin);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2734);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var NoGroupsView = function (_React$Component) {
	  _inherits(NoGroupsView, _React$Component);
	
	  function NoGroupsView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NoGroupsView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NoGroupsView.__proto__ || Object.getPrototypeOf(NoGroupsView)).call.apply(_ref, [this].concat(args))), _this), _this.handleGroupCreated = function (group) {
	      _this.context.router.push((0, _getRedirectLocationAfterGroupCreation2.default)(group));
	    }, _this.handleGroupJoined = function (group) {
	      _this.context.router.push((0, _getRedirectLocationAfterGroupJoin2.default)(group));
	    }, _this.renderSubtext = function () {
	      var groupCreateModal = _react2.default.createElement(_GroupCreateModal2.default, { onCreate: _this.handleGroupCreated });
	      var joinGroupModal = _react2.default.createElement(_JoinGroupModal2.default, { onJoin: _this.handleGroupJoined });
	
	      var user = _CurrentUser2.default.getUser();
	
	      if (user.canCreateGroups()) {
	        if (user.isTeacher()) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _ModalTrigger2.default,
	              { modal: groupCreateModal },
	              _react2.default.createElement(
	                _Link2.default,
	                null,
	                'Create a class'
	              )
	            ),
	            ' ',
	            'or',
	            ' ',
	            _react2.default.createElement(
	              _ModalTrigger2.default,
	              { modal: joinGroupModal },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _Link2.default,
	                  null,
	                  'join a class'
	                ),
	                ' ',
	                'to start using Remind.'
	              )
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _ModalTrigger2.default,
	              { modal: groupCreateModal },
	              _react2.default.createElement(
	                _Link2.default,
	                null,
	                'Create a class'
	              )
	            ),
	            ' ',
	            'to stay connected with your clubs, teams, organizations, and more!'
	          );
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: joinGroupModal },
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              null,
	              'Join a class'
	            ),
	            ' ',
	            'to start using Remind.'
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NoGroupsView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('NoGroupsView', this.props.className) },
	        _react2.default.createElement(
	          _Container2.default,
	          { size: 'small' },
	          _react2.default.createElement(_TitleHeader2.default, {
	            glyph: 'remind-icon',
	            title: 'Get started!',
	            subtext: this.renderSubtext(),
	            size: 'xxlarge'
	          })
	        )
	      );
	    }
	  }]);
	
	  return NoGroupsView;
	}(_react2.default.Component);
	
	NoGroupsView.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	NoGroupsView.displayName = 'NoGroupsView';
	exports.default = NoGroupsView;

/***/ },
/* 2734 */
1136,
/* 2735 */,
/* 2736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _AppLayoutContentView = __webpack_require__(2737);
	
	var _AppLayoutContentView2 = _interopRequireDefault(_AppLayoutContentView);
	
	var _AppLayoutContentViewHeader = __webpack_require__(2740);
	
	var _AppLayoutContentViewHeader2 = _interopRequireDefault(_AppLayoutContentViewHeader);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _EventTrackingConstants = __webpack_require__(2743);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupKeyboardListener = __webpack_require__(2744);
	
	var _GroupKeyboardListener2 = _interopRequireDefault(_GroupKeyboardListener);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _JoinMergeAccountsModal = __webpack_require__(2750);
	
	var _JoinMergeAccountsModal2 = _interopRequireDefault(_JoinMergeAccountsModal);
	
	var _MessageActions = __webpack_require__(1228);
	
	var _MessageActions2 = _interopRequireDefault(_MessageActions);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _RequireDesktop = __webpack_require__(2755);
	
	var _RequireDesktop2 = _interopRequireDefault(_RequireDesktop);
	
	var _RequireSetup = __webpack_require__(2756);
	
	var _RequireSetup2 = _interopRequireDefault(_RequireSetup);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	var _UniversalComposeButtonContainer = __webpack_require__(1723);
	
	var _UniversalComposeButtonContainer2 = _interopRequireDefault(_UniversalComposeButtonContainer);
	
	var _UniversalComposer = __webpack_require__(2032);
	
	var _UniversalComposer2 = _interopRequireDefault(_UniversalComposer);
	
	var _modal = __webpack_require__(1188);
	
	var _chainOnEnter = __webpack_require__(2586);
	
	var _chainOnEnter2 = _interopRequireDefault(_chainOnEnter);
	
	var _groupNavigation = __webpack_require__(2489);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var checkInformationRequired = {
	  statics: {
	    onEnter: function onEnter(nextState, replaceWith, callback) {
	      if (_GroupStore2.default.isLoaded()) {
	        callback();
	      } else {
	        _GroupActions2.default.loadGroups().then(callback, function (err) {
	          if (err.code === 'information_required') {
	            replaceWith('/information_required');
	          }
	          callback();
	        });
	      }
	    }
	  }
	};
	
	var GroupsView = function (_Component) {
	  _inherits(GroupsView, _Component);
	
	  function GroupsView() {
	    _classCallCheck(this, GroupsView);
	
	    return _possibleConstructorReturn(this, (GroupsView.__proto__ || Object.getPrototypeOf(GroupsView)).apply(this, arguments));
	  }
	
	  _createClass(GroupsView, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventContextName: _EventTrackingConstants.EventTrackingConstants.UNIVERSAL_COMPOSER_CLASSES
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var query = this.props.location.query;
	
	      // XXX Does this work?
	      if ('token' in query) {
	        (0, _modal.mountModal)(_react2.default.createElement(_JoinMergeAccountsModal2.default, {
	          token: query.token,
	          onRequestHide: function onRequestHide(code) {
	            return code && _this2.context.router.replace('/classes/' + code);
	          }
	        }), this);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.state.showDraft) {
	        var canAnnounce = _CurrentUser2.default.getUser().canCreateGroups();
	        (0, _modal.mountModal)(_react2.default.createElement(_UniversalComposer2.default, {
	          canAnnounce: canAnnounce,
	          panel: _UniversalComposer.PANELS.CLASS_ANNOUCEMENT
	        }), this);
	        // hack, clean up when we have a non-imperative modal
	        _MessageActions2.default.finishShowingDraft();
	      }
	    }
	  }, {
	    key: 'displayUnsavedChangesDialog',
	    value: function displayUnsavedChangesDialog() {
	      var _this3 = this;
	
	      return new Promise(function (resolve) {
	        (0, _modal.mountModal)(_react2.default.createElement(_ConfirmDialog2.default, {
	          eventScreenName: 'GroupsView',
	          actionButtonText: 'Discard',
	          cancelButtonText: 'Cancel',
	          size: 'small',
	          title: 'Are you sure you want to discard this announcement?',
	          onConfirm: resolve
	        }), _this3);
	      });
	    }
	  }, {
	    key: 'renderComposeButton',
	    value: function renderComposeButton() {
	      if (!_CurrentUser2.default.getUser().canChat()) {
	        return null;
	      }
	      return _react2.default.createElement(_UniversalComposeButtonContainer2.default, {
	        full: true,
	        eventScreenName: 'groups_view',
	        eventElementName: 'new_message_button'
	      });
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var title = 'Classes';
	
	      return _react2.default.createElement(
	        _AppLayoutContentViewHeader2.default,
	        { title: title },
	        this.renderComposeButton()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var navSections = this.state.navSections;
	
	      // XXX until we merge org and group interfaces
	
	      var defaultGroupOrOrg = (0, _groupNavigation.defaultItemOf)(navSections);
	      var children = this.props.children;
	
	
	      return _react2.default.createElement(
	        _AppLayoutContentView2.default,
	        { header: this.renderHeader() },
	
	        // $FlowIssue Flow incorrectly thinks children is undefined
	        _react2.default.cloneElement(children, { defaultGroupOrOrg: defaultGroupOrOrg }),
	        _react2.default.createElement(_GroupKeyboardListener2.default, null)
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_GroupStore2.default, _AffiliationStore2.default, _OrganizationStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      // XXX transitioning to a shared interface for org groups and class groups
	      var ownedGroups = _GroupStore2.default.getOwnedGroups();
	      var subscribedGroups = _GroupStore2.default.getSubscribedGroups();
	      var districtGroups = _GroupStore2.default.getDistrictGroups();
	      var schoolGroups = _GroupStore2.default.getSchoolGroups();
	      var organizations = _AffiliationStore2.default.getAffiliatedOrganizations();
	      var userCanOwnGroups = _CurrentUser2.default.getUser().canOwnGroups();
	      var hasAdminConsole = _CurrentUser2.default.getUser().hasFeature('web_admin_console');
	
	      var navSections = (0, _groupNavigation.getOrderedSectionInfo)({
	        organizations: organizations,
	        districtGroups: districtGroups,
	        schoolGroups: schoolGroups,
	        ownedGroups: ownedGroups,
	        subscribedGroups: subscribedGroups,
	        userCanOwnGroups: userCanOwnGroups,
	        options: {
	          ignoreDistrictSection: !hasAdminConsole,
	          ignoreDistrictOrganizationSection: hasAdminConsole
	        }
	      });
	
	      return {
	        showDraft: _GroupStore2.default.getShowDraft(),
	        navSections: navSections
	      };
	    }
	  }]);
	
	  return GroupsView;
	}(_react.Component);
	
	GroupsView.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	GroupsView.childContextTypes = {
	  eventContextName: _react2.default.PropTypes.string
	};
	GroupsView.onEnter = (0, _chainOnEnter2.default)([_RequireUser2.default, _RequireSetup2.default, _RequireDesktop2.default, checkInformationRequired]);
	GroupsView.displayName = 'GroupsView';
	exports.default = _utils.Container.create(GroupsView, { pure: false });

/***/ },
/* 2737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AppLayoutContentView = __webpack_require__(2738);
	
	var _AppLayoutContentView2 = _interopRequireDefault(_AppLayoutContentView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppLayoutContentView = function (_React$Component) {
	  _inherits(AppLayoutContentView, _React$Component);
	
	  function AppLayoutContentView() {
	    _classCallCheck(this, AppLayoutContentView);
	
	    return _possibleConstructorReturn(this, (AppLayoutContentView.__proto__ || Object.getPrototypeOf(AppLayoutContentView)).apply(this, arguments));
	  }
	
	  _createClass(AppLayoutContentView, [{
	    key: 'renderSidebarBlock',
	    value: function renderSidebarBlock() {
	      var _props = this.props,
	          header = _props.header,
	          sidebar = _props.sidebar;
	
	
	      return sidebar ? _react2.default.createElement(
	        'div',
	        { className: _AppLayoutContentView2.default.sidebar },
	        header,
	        sidebar
	      ) : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_AppLayoutContentView2.default.this, this.props.className) },
	        this.renderSidebarBlock(),
	        this.props.children
	      );
	    }
	  }]);
	
	  return AppLayoutContentView;
	}(_react2.default.Component);
	
	AppLayoutContentView.displayName = 'AppLayoutContentView';
	exports.default = AppLayoutContentView;

/***/ },
/* 2738 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"sidebarWidth":"242px","wolf":"#dcdee2","this":"AppLayoutContentView__this___2p8wz","sidebar":"AppLayoutContentView__sidebar___1fygg","sidebarScrollableArea":"AppLayoutContentView__sidebarScrollableArea___1nBfI"};

/***/ },
/* 2739 */,
/* 2740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AppLayoutContentViewHeader = __webpack_require__(2741);
	
	var _AppLayoutContentViewHeader2 = _interopRequireDefault(_AppLayoutContentViewHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var AppLayoutContentViewHeader = function (_React$Component) {
	  _inherits(AppLayoutContentViewHeader, _React$Component);
	
	  function AppLayoutContentViewHeader() {
	    _classCallCheck(this, AppLayoutContentViewHeader);
	
	    return _possibleConstructorReturn(this, (AppLayoutContentViewHeader.__proto__ || Object.getPrototypeOf(AppLayoutContentViewHeader)).apply(this, arguments));
	  }
	
	  _createClass(AppLayoutContentViewHeader, [{
	    key: 'renderTitleWithPreviousButton',
	    value: function renderTitleWithPreviousButton(title) {
	      return _react2.default.createElement(
	        _Link2.default,
	        {
	          color: 'pitch',
	          className: _AppLayoutContentViewHeader2.default.previousButton,
	          onClick: this.props.onRequestPrevious },
	        _react2.default.createElement(_Glyph2.default, { name: 'arrow-left', color: 'brand', size: 'large' }),
	        title
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          children = _props.children,
	          className = _props.className;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(_AppLayoutContentViewHeader2.default.this, className) },
	        _react2.default.createElement(
	          _Text2.default,
	          { className: _AppLayoutContentViewHeader2.default.title, size: 'medium', truncate: true },
	          this.props.renderPreviousButton ? this.renderTitleWithPreviousButton(title) : title
	        ),
	        children && _react2.default.createElement(
	          'div',
	          { className: _AppLayoutContentViewHeader2.default.children },
	          children
	        )
	      );
	    }
	  }]);
	
	  return AppLayoutContentViewHeader;
	}(_react2.default.Component);
	
	AppLayoutContentViewHeader.displayName = 'AppLayoutContentViewHeader';
	exports.default = AppLayoutContentViewHeader;

/***/ },
/* 2741 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"wolf":"#dcdee2","headerHeight":"60px","this":"AppLayoutContentViewHeader__this___3ynwu","header":"AppLayoutContentViewHeader__header___2MbgI","title":"AppLayoutContentViewHeader__title___Suwnv","previousButton":"AppLayoutContentViewHeader__previousButton___1qyYa","children":"AppLayoutContentViewHeader__children___2yEOg"};

/***/ },
/* 2742 */,
/* 2743 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	var EventTrackingConstants = exports.EventTrackingConstants = {
	  UNIVERSAL_COMPOSER_CLASSES: 'universal_composer_classes'
	};

/***/ },
/* 2744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRedux = __webpack_require__(1113);
	
	var _modal = __webpack_require__(1188);
	
	var _GroupQuickSwitcher = __webpack_require__(2745);
	
	var _GroupQuickSwitcher2 = _interopRequireDefault(_GroupQuickSwitcher);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _KeyboardShortcuts = __webpack_require__(2749);
	
	var _KeyboardShortcuts2 = _interopRequireDefault(_KeyboardShortcuts);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupKeyboardListener = function (_React$Component) {
	  _inherits(GroupKeyboardListener, _React$Component);
	
	  function GroupKeyboardListener() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupKeyboardListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupKeyboardListener.__proto__ || Object.getPrototypeOf(GroupKeyboardListener)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyPress = function (event) {
	      if (_KeyboardShortcuts2.default.isQuickSwitch(event)) {
	        if (_this.props.groupQuickSwitcherStatus !== 'open') {
	          _this.displayQuickSwitcher();
	        }
	        event.preventDefault();
	      } else if (_KeyboardShortcuts2.default.isNextUnread(event)) {
	        _this.routeToNextUnreadGroup();
	        event.preventDefault();
	      }
	    }, _this.displayQuickSwitcher = function () {
	      (0, _modal.mountModal)(_react2.default.createElement(_GroupQuickSwitcher2.default, null), _this);
	    }, _this.routeToNextUnreadGroup = function () {
	      var groups = _GroupStore2.default.getSubscribedGroups().models;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = groups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var group = _step.value;
	
	          if (group.get('unread_messages') > 0) {
	            _this.context.router.push('/classes/' + group.getCode());
	            return;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupKeyboardListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('keydown', this.onKeyPress);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.onKeyPress);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return GroupKeyboardListener;
	}(_react2.default.Component);
	
	GroupKeyboardListener.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	GroupKeyboardListener.displayName = 'GroupKeyboardListener';
	
	
	function mapStateToProps(state) {
	  return {
	    groupQuickSwitcherStatus: state.groupQuickSwitcher.status
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(GroupKeyboardListener);

/***/ },
/* 2745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _redux = __webpack_require__(476);
	
	var _groupQuickSwitcher = __webpack_require__(2746);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _TextEntities = __webpack_require__(1145);
	
	var _TextEntities2 = _interopRequireDefault(_TextEntities);
	
	var _TextWithEntities = __webpack_require__(1142);
	
	var _TextWithEntities2 = _interopRequireDefault(_TextWithEntities);
	
	__webpack_require__(2747);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line
	
	var GroupQuickSwitcher = function (_React$Component) {
	  _inherits(GroupQuickSwitcher, _React$Component);
	
	  function GroupQuickSwitcher(props) {
	    _classCallCheck(this, GroupQuickSwitcher);
	
	    var _this = _possibleConstructorReturn(this, (GroupQuickSwitcher.__proto__ || Object.getPrototypeOf(GroupQuickSwitcher)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var groups = new _Groups2.default([].concat(_GroupStore2.default.getOwnedGroups().models, _GroupStore2.default.getSubscribedGroups().models, _GroupStore2.default.getSchoolGroups().models));
	
	    _this.state = {
	      groups: groups,
	      query: '',
	      results: groups,
	      selected: 0
	    };
	    return _this;
	  }
	
	  _createClass(GroupQuickSwitcher, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.changeStatus('open');
	      setTimeout(this.refs.input.focus, 0);
	      document.addEventListener('keydown', this.onKeyPressed);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.changeStatus('closed');
	      document.removeEventListener('keydown', this.onKeyPressed);
	    }
	  }, {
	    key: 'renderEmptyResults',
	    value: function renderEmptyResults() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'GroupQuickSwitcher-emptyResults' },
	        _react2.default.createElement(
	          'div',
	          { className: 'GroupQuickSwitcher-emptyResults-text' },
	          _react2.default.createElement(
	            'div',
	            null,
	            'No matches found for ',
	            this.state.query,
	            '.'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            'Have you spelled it correctly? '
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      return this.state.results.map(function (group, index) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: group.id,
	            className: (0, _classnames2.default)('GroupQuickSwitcher-class', {
	              'GroupQuickSwitcher-class-selected': index === _this2.state.selected
	            }),
	            onMouseOver: function onMouseOver() {
	              return _this2.onResultsHover(index);
	            },
	            onClick: function onClick() {
	              return _this2.gotoIndexResult(index);
	            },
	            ref: 'result-' + index },
	          _react2.default.createElement(_GroupAvatar2.default, {
	            className: 'GroupQuickSwitcher-class-avatar',
	            group: group
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: 'GroupQuickSwitcher-class-name', truncate: true },
	            _react2.default.createElement(_TextWithEntities2.default, {
	              text: group.getName(),
	              entities: _TextEntities2.default.parseEmoji(group.getName())
	            })
	          ),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'GroupQuickSwitcher-class-code' },
	            '@',
	            group.getCode()
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({ eventScreenName: 'GroupQuickSwitcher' }, this.props, { size: 'small' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'GroupQuickSwitcher' },
	          _react2.default.createElement(
	            'div',
	            { className: 'GroupQuickSwitcher-header' },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Jump to a class'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'tab or \u2191\u2193 to navigate'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              '\u21B5 to select'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              'esc to dismiss'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'GroupQuickSwitcher-search' },
	            _react2.default.createElement(_Input2.default, { ref: 'input', onChange: this.onQueryChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'GroupQuickSwitcher-results' },
	            this.state.results.length > 0 ? _react2.default.createElement(
	              _ScrollableArea2.default,
	              { key: this.state.results.length, ref: 'scrollArea' },
	              this.renderResults()
	            ) : this.renderEmptyResults()
	          )
	        )
	      );
	    }
	  }]);
	
	  return GroupQuickSwitcher;
	}(_react2.default.Component);
	
	GroupQuickSwitcher.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	GroupQuickSwitcher.displayName = 'GroupQuickSwitcher';
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onKeyPressed = function (event) {
	    var selected = _this3.state.selected || 0;
	
	    switch (event.keyCode) {
	      case _KeyConstants2.default.ENTER:
	        event.preventDefault();
	        _this3.gotoIndexResult(_this3.state.selected || 0);
	        break;
	      case _KeyConstants2.default.DOWN:
	      case _KeyConstants2.default.TAB:
	        event.preventDefault();
	        if (selected === _this3.state.results.length - 1) {
	          selected = 0;
	        } else {
	          selected = selected === null ? 0 : selected + 1;
	        }
	        break;
	      case _KeyConstants2.default.UP:
	        event.preventDefault();
	        if (selected === 0) {
	          selected = _this3.state.results.length - 1;
	        } else {
	          selected = selected > 0 ? selected - 1 : selected;
	        }
	        break;
	      default:
	        break;
	    }
	
	    if (selected !== _this3.state.selected) {
	      _this3.setState({ selected: selected });
	      var node = _reactDom2.default.findDOMNode(_this3.refs['result-' + selected]);
	      _this3.refs.scrollArea.scrollIntoView(node);
	    }
	  };
	
	  this.onQueryChange = function (event) {
	    var query = event.target.value.replace('@', '');
	    var groups = query.length > 0 ? new _Groups2.default(_this3.state.groups.filter(function (group) {
	      return group.getName().toLowerCase().indexOf(query.toLowerCase()) > -1 || group.getCode().toLowerCase().indexOf(query.toLowerCase()) > -1;
	    })) : _this3.state.groups;
	
	    _this3.setState({
	      query: query,
	      results: groups,
	      selected: query.length > 0 ? 0 : null
	    });
	  };
	
	  this.onResultsHover = function (index) {
	    _this3.setState({ selected: index });
	  };
	
	  this.gotoIndexResult = function (index) {
	    var group = _this3.state.results.at(index);
	    _this3.context.router.push('/classes/' + group.getCode());
	  };
	};
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    changeStatus: _groupQuickSwitcher.changeStatus
	  }, dispatch);
	}
	
	// $FlowIssue
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(GroupQuickSwitcher);

/***/ },
/* 2746 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.changeStatus = changeStatus;
	var initialState = exports.initialState = {
	  status: 'closed'
	};
	
	// typecheck: ignore statement
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'groupQuickSwitcher/CHANGE_STATUS':
	      return _extends({}, state, { status: action.status });
	    default:
	      return state;
	  }
	}
	
	function changeStatus(status) {
	  return {
	    type: 'groupQuickSwitcher/CHANGE_STATUS',
	    status: status
	  };
	}

/***/ },
/* 2747 */
1136,
/* 2748 */,
/* 2749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isNextUnread(e) {
	  return e.altKey && e.shiftKey && e.keyCode === _KeyConstants2.default.DOWN;
	} /*  weak */
	
	
	function isQuickSwitch(e) {
	  return e.metaKey && e.keyCode === _KeyConstants2.default.K;
	}
	
	exports.default = {
	  isNextUnread: isNextUnread,
	  isQuickSwitch: isQuickSwitch
	};

/***/ },
/* 2750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OrganizationAccountActions = __webpack_require__(2751);
	
	var _OrganizationAccountActions2 = _interopRequireDefault(_OrganizationAccountActions);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _JoinMergeAccountsView = __webpack_require__(2752);
	
	var _JoinMergeAccountsView2 = _interopRequireDefault(_JoinMergeAccountsView);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var EVENT_SCREEN_NAME = 'JoinMergeAccountsModal';
	
	var JoinMergeAccountsModal = function (_React$Component) {
	  _inherits(JoinMergeAccountsModal, _React$Component);
	
	  function JoinMergeAccountsModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JoinMergeAccountsModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinMergeAccountsModal.__proto__ || Object.getPrototypeOf(JoinMergeAccountsModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      account: null,
	      submitting: false
	    }, _this.onError = function (error) {
	      _this.setState({ submitting: false });
	      _ToastActions2.default.showErrorToast(error.message);
	      _this.props.onRequestHide();
	    }, _this.mergeAccount = function () {
	      _this.setState({ submitting: true });
	      _OrganizationAccountActions2.default.mergeAccount(_this.props.token).then(function () {
	        var account = _this.state.account;
	
	        _this.setState({ submitting: false });
	        var successMessage = account.user_email + ' added to your account';
	        _ToastActions2.default.showSuccessToast(successMessage);
	        _this.props.onRequestHide(account.organization_group_code);
	        _EventTracking2.default.view('join_merge_account_success');
	      }, _this.onError);
	    }, _this.rejectAccount = function () {
	      _this.setState({ submitting: true });
	      _OrganizationAccountActions2.default.rejectAccount(_this.props.token).then(function () {
	        _this.setState({ submitting: false });
	        _this.props.onRequestHide();
	      }, _this.onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JoinMergeAccountsModal, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventScreenName: EVENT_SCREEN_NAME
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _OrganizationAccountActions2.default.getOrLoadAccount(this.props.token).then(function (account) {
	        return _this2.setState({ account: account });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          account = _state.account,
	          submitting = _state.submitting;
	
	      if (!account || submitting) {
	        return _react2.default.createElement(
	          _Modal2.default,
	          null,
	          _react2.default.createElement(_CenteredLoadingIndicator2.default, null)
	        );
	      }
	
	      return _react2.default.createElement(_JoinMergeAccountsView2.default, {
	        onRequestHide: this.props.onRequestHide,
	        account: account,
	        mergeAccount: this.mergeAccount,
	        rejectAccount: this.rejectAccount
	      });
	    }
	  }]);
	
	  return JoinMergeAccountsModal;
	}(_react2.default.Component);
	
	JoinMergeAccountsModal.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	JoinMergeAccountsModal.childContextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	JoinMergeAccountsModal.displayName = 'JoinMergeAccountsModal';
	exports.default = JoinMergeAccountsModal;

/***/ },
/* 2751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _lodash = __webpack_require__(555);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * These accounts are user accounts that were created as part of direct adding
	 * users to an organization. They can be claimed, rejected or merged into an
	 * existing user account
	 */
	
	var loadAccount = function loadAccount(token) {
	  return (0, _apiRequest2.default)('/organizations/accounts', 'GET', { token: token });
	};
	
	
	var OrganizationAccountActions = {
	  loadAccount: loadAccount,
	  getOrLoadAccount: (0, _lodash.memoize)(loadAccount),
	
	  claimAccount: function claimAccount(token, password) {
	    return (0, _apiRequest2.default)('/organizations/accounts/claim', 'POST', { token: token, password: password }).then(function (user) {
	      return _AuthActions2.default.signIn(user.email, password);
	    });
	  },
	  mergeAccount: function mergeAccount(token) {
	    return (0, _apiRequest2.default)('/organizations/accounts/merge', 'POST', { token: token }).then(function (user) {
	      _GroupActions2.default.loadGroups();
	      _Dispatcher.dispatcher.dispatch({
	        type: _UserConstants.ActionTypes.USER_UPDATED,
	        user: _User2.default.fromJSON(user)
	      });
	    });
	  },
	  rejectAccount: function rejectAccount(token) {
	    return (0, _apiRequest2.default)('/organizations/accounts/reject', 'POST', { token: token });
	  }
	};
	
	exports.default = OrganizationAccountActions;

/***/ },
/* 2752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _JoinMergeAccountsModal = __webpack_require__(2753);
	
	var _JoinMergeAccountsModal2 = _interopRequireDefault(_JoinMergeAccountsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// TODO: referencing non-component stylesheet
	
	
	var JoinMergeAccountsView = function (_React$Component) {
	  _inherits(JoinMergeAccountsView, _React$Component);
	
	  function JoinMergeAccountsView() {
	    _classCallCheck(this, JoinMergeAccountsView);
	
	    return _possibleConstructorReturn(this, (JoinMergeAccountsView.__proto__ || Object.getPrototypeOf(JoinMergeAccountsView)).apply(this, arguments));
	  }
	
	  _createClass(JoinMergeAccountsView, [{
	    key: 'render',
	    value: function render() {
	      var account = this.props.account;
	
	
	      var headerImage = _react2.default.createElement(_Glyph2.default, {
	        className: (0, _classnames2.default)(_JoinMergeAccountsModal2.default.headerImage),
	        name: 'mail',
	        size: 'xxxlarge',
	        color: 'brand'
	      });
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          eventScreenName: 'JoinMergeAccountsView',
	          title: 'Join ' + account.organization_name + ' on Remind',
	          headerImageComponent: headerImage,
	          size: 'xsmall',
	          hideOnBlur: false,
	          hideCloseButton: true,
	          onRequestHide: this.props.onRequestHide,
	          subtext: account.from_admin_name + ' invited ' + account.user_email + ' to join ' + (account.organization_name + ' on Remind. We\'ll add this email ') + 'address to your account.' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              full: true,
	              onClick: this.props.mergeAccount,
	              className: 'submit JoinMergeAccountsModal-Button',
	              eventElementName: 'submit JoinMergeAccountsModal-Button' },
	            'Got it'
	          ),
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              className: (0, _classnames2.default)('wrong_email', _JoinMergeAccountsModal2.default.rejectLink),
	              onClick: this.props.rejectAccount,
	              color: 'thunder' },
	            'Not your email address?'
	          )
	        )
	      );
	    }
	  }]);
	
	  return JoinMergeAccountsView;
	}(_react2.default.Component);
	
	JoinMergeAccountsView.displayName = 'JoinMergeAccountsView';
	exports.default = JoinMergeAccountsView;

/***/ },
/* 2753 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"spacing-large":"16px","headerImage":"JoinMergeAccountsModal__headerImage___CVtST","rejectLink":"JoinMergeAccountsModal__rejectLink___2O07U"};

/***/ },
/* 2754 */,
/* 2755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _currentUserAgent = __webpack_require__(1160);
	
	var _currentUserAgent2 = _interopRequireDefault(_currentUserAgent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequireDesktop = {
	  statics: {
	    onEnter: function onEnter(nextState, replaceWith) {
	      var _nextState$location = nextState.location,
	          query = _nextState$location.query,
	          pathname = _nextState$location.pathname;
	
	
	      var deviceOkay = _currentUserAgent2.default.isDesktop() || _currentUserAgent2.default.tablet() && _currentUserAgent2.default.ie();
	
	      if (!deviceOkay) {
	        if (query && query.admin) {
	          replaceWith({ pathname: '/schools_desktop', query: query });
	        } else {
	          query.path = pathname;
	          replaceWith({ pathname: '/get_the_app', query: query });
	        }
	      }
	    }
	  }
	};
	// typecheck: ignore file
	exports.default = RequireDesktop;

/***/ },
/* 2756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _DeviceStore = __webpack_require__(1019);
	
	var _DeviceStore2 = _interopRequireDefault(_DeviceStore);
	
	var _setupCriteria = __webpack_require__(2757);
	
	var _setupCriteria2 = _interopRequireDefault(_setupCriteria);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RequireSetup = {
	  statics: {
	    onEnter: function onEnter(nextState, replaceWith, callback) {
	      var requireSetup = function requireSetup(user) {
	        // XXX This comment implies that it was looking at the previous route, but this was never
	        // the case. It was always looking at the route that is being transitioned to, not from.
	        /* If we come from the SetupDefaultView or any other setup step
	         * Then set the default redirection to the Groups route.
	         * This is to ensure that nobody will be stuck and a blank page.
	         */
	        if (nextState.location.pathname.startsWith('/setup')) {
	          replaceWith('/classes');
	          callback();
	          return;
	        }
	
	        if (!user.getRole()) {
	          replaceWith('/information_required');
	          callback();
	          return;
	        }
	
	        /* Fetch all the possible routes from setupCriteria and
	         * transition to the first eligible route for the current role.
	         *
	         * When a setup step is finished it can to transition either to:
	         *
	         * - this.context.router.push('/')
	         *   - to show the next setup screen (if any) or transition to Groups.
	         *
	         * - this.context.router.push('SomeRoute')
	         *   - to exit the setup flow and transition to SomeRoute.
	         */
	        var transitionToNextSetupStep = function transitionToNextSetupStep() {
	          var eligibleStep = _setupCriteria2.default.getNextEligibleStep(user.getRole());
	          if (eligibleStep) {
	            replaceWith(eligibleStep);
	          }
	          callback();
	        };
	
	        if (_DeviceStore2.default.isLoaded()) {
	          transitionToNextSetupStep();
	        } else {
	          _DeviceActions2.default.loadDevices().then(transitionToNextSetupStep, transitionToNextSetupStep);
	        }
	      };
	
	      if (_CurrentUser2.default.isSignedIn()) {
	        requireSetup(_CurrentUser2.default.getUser());
	      } else {
	        _AuthActions2.default.checkLoggedIn().then(function (user) {
	          if (user) {
	            requireSetup(user);
	          } else {
	            callback();
	          }
	        }, callback);
	      }
	    }
	  }
	};
	exports.default = RequireSetup;

/***/ },
/* 2757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _DeviceStore = __webpack_require__(1019);
	
	var _DeviceStore2 = _interopRequireDefault(_DeviceStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function needsSchool() {
	  return _CurrentUser2.default.getUser().getNeeds().organization;
	}
	
	
	function needsGroup() {
	  var user = _CurrentUser2.default.getUser();
	
	  return !_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.NUX_SETUP_CLASS) && user.needsGroups() // User object isn't updated when a group is created
	  && _GroupStore2.default.getOwnedGroups().length === 0;
	}
	
	function needsSignature() {
	  var user = _CurrentUser2.default.getUser();
	  return user.getSignInCount() < 3 && !_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.NUX_SETUP_SIGNATURE);
	}
	
	function needsSmsDevice() {
	  var user = _CurrentUser2.default.getUser();
	
	  return user.getSignInCount() <= 2 && user.hasSmsSupported() && _DeviceStore2.default.getDevices().type('sms').length < 1 && !_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.NUX_SETUP_SMS_DEVICE);
	}
	
	function needsSubscription() {
	  var user = _CurrentUser2.default.getUser();
	
	  return user.getSignInCount() <= 2 && user.getNeeds().subscriptions && !_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION);
	}
	
	function needsFullName() {
	  return _CurrentUser2.default.getUser().getNeeds().full_name;
	}
	
	function needsEmail() {
	  return !_CurrentUser2.default.hasEmail();
	}
	
	function needsPassword() {
	  return _CurrentUser2.default.getUser().getNeeds().password;
	}
	
	var steps = {
	  teacher: [{ eligible: needsPassword, transitionTo: '/setup/password' }, { eligible: needsFullName, transitionTo: '/setup/name' }, { eligible: needsSignature, transitionTo: '/setup/signature' }, { eligible: needsEmail, transitionTo: '/setup/email' }, { eligible: needsGroup, transitionTo: '/setup/class' }, { eligible: needsSchool, transitionTo: '/setup/school' }],
	  student: [{ eligible: needsPassword, transitionTo: '/setup/password' }, { eligible: needsSmsDevice, transitionTo: '/setup/device/sms' }, { eligible: needsSubscription, transitionTo: '/setup/subscriptions' }, { eligible: needsFullName, transitionTo: '/setup/name' }],
	  parent: [{ eligible: needsPassword, transitionTo: '/setup/password' }, { eligible: needsFullName, transitionTo: '/setup/name' }, { eligible: needsSmsDevice, transitionTo: '/setup/device/sms' }, { eligible: needsSubscription, transitionTo: '/setup/subscriptions' }]
	};
	
	exports.default = {
	  getNextEligibleStep: function getNextEligibleStep(role) {
	    var stepsForRole = steps[role];
	    var eligibleStep = (stepsForRole || []).find(function (step) {
	      return step.eligible();
	    });
	    return eligibleStep && eligibleStep.transitionTo;
	  }
	};

/***/ },
/* 2758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Columns = __webpack_require__(1532);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _OrganizationDetails = __webpack_require__(2759);
	
	var _OrganizationDetails2 = _interopRequireDefault(_OrganizationDetails);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(2760);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var SchoolStatsTab = function (_React$Component) {
	  _inherits(SchoolStatsTab, _React$Component);
	
	  function SchoolStatsTab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SchoolStatsTab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SchoolStatsTab.__proto__ || Object.getPrototypeOf(SchoolStatsTab)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      orgDetails: null
	    }, _this.announcementsPerTeacher = function () {
	      var messages = _this.state.orgDetails.getMessageCount();
	      var teachers = _this.state.orgDetails.getTeacherCount();
	      // avoid NaN and Infinity
	      if (messages > 0 && teachers > 0) {
	        return (messages / teachers).toFixed(1);
	      }
	      return 0;
	    }, _this.renderStat = function (value, label) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'SchoolStatsTab-stat' },
	        _react2.default.createElement(
	          _Text2.default,
	          { size: 'xxxxlarge' },
	          value.toLocaleString(_CurrentUser2.default.getUser().getLocale())
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          _Text2.default,
	          { size: 'xsmall', color: 'thunder' },
	          label
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SchoolStatsTab, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // XXX get rid of promise, use Flux
	      var orgId = this.context.group.getStaffClassOrgId();
	      _OrganizationDetails2.default.getByOrganizationId(orgId).then(function (orgDetails) {
	        return _this2.setState({ orgDetails: orgDetails });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state || !this.state.orgDetails) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'ChatList-loading' },
	          _react2.default.createElement(_LoadingIndicator2.default, { size: 'small' })
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'SchoolStatsTab' },
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolStatsTab-pageTitle' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            _react2.default.createElement(
	              _Text2.default,
	              { size: 'large' },
	              'Statistics'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Box2.default,
	          { className: 'SchoolStatsTab-statBox' },
	          _react2.default.createElement(
	            'div',
	            { className: 'SchoolStatsTab-statTitle' },
	            'School statistics'
	          ),
	          _react2.default.createElement(
	            _Columns2.default,
	            null,
	            this.renderStat(this.state.orgDetails.getTeacherCount(), 'Teachers'),
	            this.renderStat(this.state.orgDetails.getSubscriberCount(), 'Participants'),
	            this.renderStat(this.state.orgDetails.getClassCount(), 'Classes')
	          )
	        ),
	        _react2.default.createElement(
	          _Box2.default,
	          { className: 'SchoolStatsTab-statBox' },
	          _react2.default.createElement(
	            'div',
	            { className: 'SchoolStatsTab-statTitle' },
	            'Activity in the last 30 days'
	          ),
	          _react2.default.createElement(
	            _Columns2.default,
	            null,
	            this.renderStat(this.state.orgDetails.getMessageCount(), 'Announcements sent'),
	            this.renderStat(this.announcementsPerTeacher(), 'Announcements sent per teacher')
	          )
	        )
	      );
	    }
	  }]);
	
	  return SchoolStatsTab;
	}(_react2.default.Component);
	
	SchoolStatsTab.contextTypes = {
	  group: _react2.default.PropTypes.instanceOf(_Group2.default).isRequired
	};
	SchoolStatsTab.displayName = 'SchoolStatsTab';
	exports.default = SchoolStatsTab;

/***/ },
/* 2759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var OrganizationDetails = function (_Entity) {
	  _inherits(OrganizationDetails, _Entity);
	
	  function OrganizationDetails() {
	    _classCallCheck(this, OrganizationDetails);
	
	    return _possibleConstructorReturn(this, (OrganizationDetails.__proto__ || Object.getPrototypeOf(OrganizationDetails)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationDetails, [{
	    key: 'getCreatedAt',
	    value: function getCreatedAt() {
	      return this.get('created_at');
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }, {
	    key: 'getTeacherCount',
	    value: function getTeacherCount() {
	      return this.get('teacher_count');
	    }
	  }, {
	    key: 'getClassCount',
	    value: function getClassCount() {
	      return this.get('class_count');
	    }
	  }, {
	    key: 'getSubscriberCount',
	    value: function getSubscriberCount() {
	      return this.get('subscriber_count');
	    }
	  }, {
	    key: 'getMessageCount',
	    value: function getMessageCount() {
	      return this.get('message_count');
	    }
	  }, {
	    key: 'parse',
	    value: function parse(response) {
	      return (0, _lodash.cloneDeep)(response);
	    }
	  }], [{
	    key: 'getByOrganizationId',
	    value: function getByOrganizationId(organizationId) {
	      return (0, _apiRequest2.default)('/organizations/' + organizationId + '/statistics', 'GET').then(function (orgDetails) {
	        return OrganizationDetails.fromJSON(orgDetails);
	      });
	    }
	  }]);
	
	  return OrganizationDetails;
	}(_Entity3.default);
	
	OrganizationDetails.displayName = 'OrganizationDetails';
	exports.default = OrganizationDetails;

/***/ },
/* 2760 */
1136,
/* 2761 */,
/* 2762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _LeadActions = __webpack_require__(1021);
	
	var _LeadActions2 = _interopRequireDefault(_LeadActions);
	
	var _Tymk = __webpack_require__(1466);
	
	var _Tymk2 = _interopRequireDefault(_Tymk);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UnauthenticatedView = __webpack_require__(1691);
	
	var _UnauthenticatedView2 = _interopRequireDefault(_UnauthenticatedView);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _ShareRemind = __webpack_require__(1715);
	
	var _ShareRemind2 = _interopRequireDefault(_ShareRemind);
	
	var _AppDownloadImageLinks = __webpack_require__(2170);
	
	var _AppDownloadImageLinks2 = _interopRequireDefault(_AppDownloadImageLinks);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _jsonwebtoken = __webpack_require__(2611);
	
	var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);
	
	__webpack_require__(2763);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinPageTymkView = function (_React$Component) {
	  _inherits(JoinPageTymkView, _React$Component);
	
	  function JoinPageTymkView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JoinPageTymkView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinPageTymkView.__proto__ || Object.getPrototypeOf(JoinPageTymkView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      organization: null,
	      leads: null,
	      showShareRemind: false
	    }, _this.showThanksScreen = function () {
	      _this.context.router.push('/invite/thanks');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JoinPageTymkView, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventScreenName: 'invite_teacher_leads_screen',
	        eventProperties: {
	          total: this.state.leads.length,
	          previous_screen_name: 'sms_join'
	        }
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // XXX decoding auth data within a view
	      // TODO get these data from the stores
	      var payload = _jsonwebtoken2.default.decode(_CurrentUser2.default.getToken());
	
	      if (Object.keys(payload).length > 0) {
	        (function () {
	          var organizationId = payload.organizationId;
	
	          _LeadActions2.default.loadLeads().then(function (leads) {
	            _this2.setState({ leads: leads });
	          }, function () {
	            _this2.setState({ showShareRemind: true });
	          });
	
	          _OrganizationActions2.default.loadOrganization(organizationId).then(function () {
	            var organization = _OrganizationStore2.default.getOrganization(organizationId);
	            _this2.setState({ organization: organization });
	          }, function () {
	            _this2.setState({ showShareRemind: true });
	          });
	        })();
	      } else {
	        this.setState({ showShareRemind: true }); // eslint-disable-line react/no-did-mount-set-state
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var inviteView = void 0;
	
	      if (this.state.showShareRemind) {
	        inviteView = _react2.default.createElement(_ShareRemind2.default, null);
	      } else {
	        if (!this.state.leads || !this.state.organization) {
	          inviteView = _react2.default.createElement(_LoadingIndicator2.default, null);
	        } else {
	          inviteView = _react2.default.createElement(_Tymk2.default, {
	            triggeredContext: 'sms_join',
	            organizations: [this.state.organization],
	            leads: this.state.leads,
	            user: _CurrentUser2.default.getUser(),
	            afterSendInvitations: this.showThanksScreen
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        _UnauthenticatedView2.default,
	        this.props,
	        _react2.default.createElement(
	          _Container2.default,
	          { size: 'small', className: 'JoinPageTymkView' },
	          _react2.default.createElement(
	            _Box2.default,
	            { className: 'JoinPageTymkView-wrap' },
	            _react2.default.createElement(
	              _BoxBody2.default,
	              null,
	              inviteView
	            )
	          ),
	          _react2.default.createElement(_AppDownloadImageLinks2.default, { showText: true })
	        )
	      );
	    }
	  }], [{
	    key: 'onEnter',
	    value: function onEnter(nextState, replaceWith, callback) {
	      var token = nextState.location.query.token;
	
	      if (token) {
	        _AuthActions2.default.jwtTokenSignIn(token);
	        _UserActions2.default.loadCurrentUser(token).then(function () {
	          callback();
	        });
	      }
	      callback();
	    }
	  }]);
	
	  return JoinPageTymkView;
	}(_react2.default.Component);
	
	JoinPageTymkView.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	JoinPageTymkView.childContextTypes = {
	  eventScreenName: _react2.default.PropTypes.string,
	  eventProperties: _react2.default.PropTypes.object
	};
	JoinPageTymkView.displayName = 'JoinPageTymkView';
	exports.default = JoinPageTymkView;

/***/ },
/* 2763 */
1136,
/* 2764 */,
/* 2765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(497);
	
	var _JoinGroupPage = __webpack_require__(2766);
	
	var _JoinGroupPage2 = _interopRequireDefault(_JoinGroupPage);
	
	var _JoinView = __webpack_require__(2779);
	
	var _JoinView2 = _interopRequireDefault(_JoinView);
	
	var _JoinInfoPage = __webpack_require__(2456);
	
	var _JoinInfoPage2 = _interopRequireDefault(_JoinInfoPage);
	
	var _JoinRolePicker = __webpack_require__(2780);
	
	var _JoinRolePicker2 = _interopRequireDefault(_JoinRolePicker);
	
	var _JoinSearchPage = __webpack_require__(2782);
	
	var _JoinSearchPage2 = _interopRequireDefault(_JoinSearchPage);
	
	var _JoinConfirmEmailDevicePage = __webpack_require__(2785);
	
	var _JoinConfirmEmailDevicePage2 = _interopRequireDefault(_JoinConfirmEmailDevicePage);
	
	var _JoinConfirmSmsDevicePage = __webpack_require__(2787);
	
	var _JoinConfirmSmsDevicePage2 = _interopRequireDefault(_JoinConfirmSmsDevicePage);
	
	var _JoinOrganizationPage = __webpack_require__(2790);
	
	var _JoinOrganizationPage2 = _interopRequireDefault(_JoinOrganizationPage);
	
	var _JoinSignUpPage = __webpack_require__(2800);
	
	var _JoinSignUpPage2 = _interopRequireDefault(_JoinSignUpPage);
	
	var _JoinClaimDirectAddAccount = __webpack_require__(2805);
	
	var _JoinClaimDirectAddAccount2 = _interopRequireDefault(_JoinClaimDirectAddAccount);
	
	var _ConfirmOrganizationPage = __webpack_require__(2808);
	
	var _ConfirmOrganizationPage2 = _interopRequireDefault(_ConfirmOrganizationPage);
	
	var _RouteLogic = __webpack_require__(1033);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { component: _JoinView2.default },
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/information_required',
	    component: _JoinInfoPage2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/information_required/:groupCode',
	    component: _JoinInfoPage2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/join/role_picker',
	    component: _JoinRolePicker2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/join/role_picker/:groupCode',
	    component: _JoinRolePicker2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/join(/)',
	    component: _JoinSearchPage2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/join/claim_account',
	    component: _JoinClaimDirectAddAccount2.default
	  }),
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/subscribe(/)', to: '/join' }),
	  _react2.default.createElement(_reactRouter.Redirect, { from: '/subscribe/:groupCode', to: '/join/:groupCode' }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/join/:groupCode',
	    component: _JoinGroupPage2.default,
	    onEnter: _RouteLogic.goToClassCodeIfAuthed
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/join/:groupCode/info',
	    component: _JoinConfirmEmailDevicePage2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/join/:groupCode/sms',
	    component: _JoinConfirmSmsDevicePage2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/sign_up',
	    component: _JoinSignUpPage2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/school/join/:id',
	    component: _JoinOrganizationPage2.default,
	    onEnter: _JoinOrganizationPage2.default.onEnter
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/school/confirm/:id',
	    component: _ConfirmOrganizationPage2.default,
	    onEnter: _ConfirmOrganizationPage2.default.onEnter
	  })
	);

/***/ },
/* 2766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _CenteredContainer = __webpack_require__(2240);
	
	var _CenteredContainer2 = _interopRequireDefault(_CenteredContainer);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _DialogTitle = __webpack_require__(2767);
	
	var _DialogTitle2 = _interopRequireDefault(_DialogTitle);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _JoinGroupFormPanel = __webpack_require__(2770);
	
	var _JoinGroupFormPanel2 = _interopRequireDefault(_JoinGroupFormPanel);
	
	var _JoinGroupAvatarPanel = __webpack_require__(2537);
	
	var _JoinGroupAvatarPanel2 = _interopRequireDefault(_JoinGroupAvatarPanel);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(2777);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinGroupPage = _react2.default.createClass({
	  displayName: 'JoinGroupPage',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  statics: {
	    loadProps: function loadProps(renderProps, cb) {
	      var groupCode = renderProps.params.groupCode;
	      var router = renderProps.loadContext.router;
	
	
	      var cleanGroupCode = _Group2.default.parseAcceptableGroupCode(groupCode);
	
	      if (cleanGroupCode) {
	        _Group2.default.fetchByCode(cleanGroupCode).then(function (group) {
	          if (group.canJoin()) {
	            // convert to JSON because that's how it will be serialized
	            cb(null, { groupJson: group.toJSON() });
	          } else {
	            console.error('DEBUG loadProps cannot join');
	            router.replace('/error');
	            cb(new Error('Cannot join group'));
	          }
	        }, function (err) {
	          console.error('DEBUG loadProps', err);
	          router.replace('/join?notFound=' + groupCode);
	          cb(err);
	        });
	      } else {
	        router.replace('/join?notFound=' + groupCode);
	        cb('invalid group code', groupCode);
	      }
	    }
	  },
	
	  render: function render() {
	    var groupJson = this.props.groupJson;
	
	    // reconstructing on render isn't ideal, but this shouldn't rerender and
	    // we need to think through a good solution for serializing models
	
	    var group = _Group2.default.fromJSON(groupJson);
	
	    // XXX - This is to fix https://my.trackjs.com/details/9a7be15d01bd4ae98c41d04c4148a8aa.
	    // Somehow we're ending up with an empty groupJson here sometimes
	    if (!group.id) {
	      console.warn('Trying to render an empty group');
	      return null;
	    }
	
	    return _react2.default.createElement(
	      _CenteredContainer2.default,
	      { size: 'large' },
	      _react2.default.createElement(
	        _Box2.default,
	        null,
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            _Columns2.default,
	            { reset: 'tablet', flex: true },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_JoinGroupAvatarPanel2.default, { group: group, className: 'JoinGroupPage-header' }),
	              _react2.default.createElement(
	                _DialogTitle2.default,
	                { className: 'JoinGroupPage-title' },
	                'Join',
	                ' ',
	                group.getPossessiveSignature(),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  _react2.default.createElement(_GroupName2.default, { group: group })
	                ),
	                _react2.default.createElement(
	                  _Text2.default,
	                  { element: 'div', color: 'thunder', size: 'large' },
	                  group.getOrganization() && group.getOrganization().getName()
	                )
	              )
	            ),
	            _react2.default.createElement(_JoinGroupFormPanel2.default, { group: group })
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = JoinGroupPage;

/***/ },
/* 2767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2768);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DialogTitle = function (_React$Component) {
	  _inherits(DialogTitle, _React$Component);
	
	  function DialogTitle() {
	    _classCallCheck(this, DialogTitle);
	
	    return _possibleConstructorReturn(this, (DialogTitle.__proto__ || Object.getPrototypeOf(DialogTitle)).apply(this, arguments));
	  }
	
	  _createClass(DialogTitle, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'h2',
	        _extends({}, this.props, { className: (0, _classnames2.default)('DialogTitle', this.props.className) }),
	        this.props.text,
	        this.props.children
	      );
	    }
	  }]);
	
	  return DialogTitle;
	}(_react2.default.Component);
	
	DialogTitle.displayName = 'DialogTitle';
	exports.default = DialogTitle;

/***/ },
/* 2768 */
1136,
/* 2769 */,
/* 2770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _DividerText = __webpack_require__(1234);
	
	var _DividerText2 = _interopRequireDefault(_DividerText);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _GoogleSignIn = __webpack_require__(1706);
	
	var _GoogleSignIn2 = _interopRequireDefault(_GoogleSignIn);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _HelpIcon = __webpack_require__(2452);
	
	var _HelpIcon2 = _interopRequireDefault(_HelpIcon);
	
	var _JoinDeviceBlockModal = __webpack_require__(2771);
	
	var _JoinDeviceBlockModal2 = _interopRequireDefault(_JoinDeviceBlockModal);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Subscription = __webpack_require__(1008);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _TosText = __webpack_require__(2774);
	
	var _TosText2 = _interopRequireDefault(_TosText);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _humanparser = __webpack_require__(2003);
	
	var _humanparser2 = _interopRequireDefault(_humanparser);
	
	var _modal = __webpack_require__(1188);
	
	__webpack_require__(2775);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinGroupFormPanel = _react2.default.createClass({
	  displayName: 'JoinGroupFormPanel',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  childContextTypes: {
	    eventProperties: _react2.default.PropTypes.object
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      i18n: !this.props.group.isSMSEnabled(),
	      medium: this.props.group.isSMSEnabled() ? null : 'email',
	      uidValue: '',
	      canSubmit: false
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      eventProperties: {
	        join_method: this.state.medium,
	        join_device: this.state.uidValue
	      }
	    };
	  },
	  onGoogleSuccess: function onGoogleSuccess(user) {
	    var _this = this;
	
	    if (user.getNeeds().role) {
	      return this.context.router.push('/join/role_picker/' + this.props.group.getCode());
	    }
	
	    var onSubscribeSuccess = function onSubscribeSuccess() {
	      _ToastActions2.default.showSuccessToast('Class joined');
	      return _this.context.router.push('/classes/' + _this.props.group.getCode() + '?origin=subscribed');
	    };
	
	    var onSubscribeFailure = function onSubscribeFailure(error) {
	      if (error.code === 'duplicate_membership') {
	        _ToastActions2.default.showErrorToast(error.message);
	        return _this.context.router.push('/classes/' + _this.props.group.getCode() + '?origin=subscribed');
	      }
	
	      if (error.code === 'information_required') {
	        return _this.context.router.push('/information_required/' + _this.props.group.getCode());
	      }
	
	      _ToastActions2.default.showDefaultErrorToast();
	    };
	
	    _GroupActions2.default.subscribeToGroup(this.props.group).then(onSubscribeSuccess, onSubscribeFailure);
	  },
	  onUidChange: function onUidChange(event) {
	    var value = event.target.value;
	    var medium = this.state.i18n || value.includes('@') ? 'email' : 'sms';
	    this.setState({
	      uidValue: value,
	      medium: medium
	    });
	  },
	  continueEmailFlow: function continueEmailFlow(attr, invalidateForm) {
	    var _this2 = this;
	
	    var onFailure = function onFailure(error) {
	      var errors = {};
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = error.field_errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var field = _step.value;
	
	          var fieldName = field['field_name'];
	          if (fieldName === 'email') {
	            fieldName = 'uid';
	          }
	
	          errors[fieldName] = field.messages.join(', ');
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      invalidateForm(errors);
	      _ToastActions2.default.showDefaultErrorToast();
	    };
	
	    var human = _humanparser2.default.parseName(attr['full_name']);
	    var data = {
	      prefix: human.salutation,
	      first_name: human.firstName,
	      last_name: human.lastName,
	      password: attr.password,
	      email: attr.uid,
	      role: '' };
	
	    var onSuccess = function onSuccess() {
	      _GroupActions2.default.subscribeToGroup(_this2.props.group).then(function () {
	        _this2.context.router.push('/join/role_picker');
	      }, function () {
	        _this2.context.router.push('/join/role_picker/' + _this2.props.group.getCode());
	      });
	    };
	
	    _UserActions2.default.create(data).then(onSuccess, onFailure);
	  },
	  continueSmsFlow: function continueSmsFlow(attr, invalidateForm) {
	    var _this3 = this;
	
	    var address = this.state.medium + '://' + attr.uid;
	    var onSuccess = function onSuccess(response) {
	      _this3.context.router.push({
	        pathname: '/join/' + _this3.props.group.getCode() + '/sms',
	        query: {
	          address: address,
	          token: response.token,
	          name: attr['full_name']
	        }
	      });
	    };
	
	    var onError = function onError(error) {
	      if (error && error.code === 'blocked') {
	        (0, _modal.mountModal)(_react2.default.createElement(_JoinDeviceBlockModal2.default, { group: _this3.props.group }), _this3);
	        return;
	      }
	
	      if (error && error.code === 'validation_error') {
	        _ToastActions2.default.showDefaultErrorToast();
	
	        var errors = {};
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = error.field_errors[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var field = _step2.value;
	
	            var fieldName = field['field_name'];
	            if (fieldName === 'uid') {
	              errors[fieldName] = 'Invalid email or phone number.';
	            } else {
	              errors[fieldName] = field.messages.join(', ');
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        invalidateForm(errors);
	        return;
	      }
	
	      _ToastActions2.default.showDefaultErrorToast();
	    };
	
	    _Subscription2.default.initiateDeviceSubscription(this.props.group.getCode(), address).then(onSuccess, onError);
	  },
	  gatherUserInformation: function gatherUserInformation() {
	    this.context.router.push('/join/role_picker/' + this.props.group.getCode());
	  },
	  handleSubmit: function handleSubmit(attr, _, invalidateForm) {
	    var _this4 = this;
	
	    var address = this.state.medium + '://' + attr.uid;
	
	    var goToSignIn = function goToSignIn(query) {
	      _this4.context.router.push({ pathname: '/log_in', query: query });
	      _ToastActions2.default.showSuccessToast('Looks like you already have an account. Log in below.');
	    };
	
	    var canSignIn = function canSignIn() {
	      // if sms, there's no password provided in form
	      // we can only transition to signin page.
	      if (_this4.state.medium === 'sms') {
	        goToSignIn({ join: _this4.props.group.getCode() });
	        return;
	      }
	
	      var onSignInFailure = function onSignInFailure() {
	        goToSignIn({
	          email: attr.uid,
	          join: _this4.props.group.getCode()
	        });
	      };
	
	      var onSignInSuccess = function onSignInSuccess() {
	        var onSubscribeSuccess = function onSubscribeSuccess() {
	          _this4.context.router.push('/classes?origin=subscribed');
	          _ToastActions2.default.showSuccessToast('Class joined');
	        };
	
	        var onSubscribeFailure = function onSubscribeFailure(error) {
	          if (error && error.code === 'duplicate_membership') {
	            _ToastActions2.default.showErrorToast(error.message);
	            _this4.context.router.push('/classes/' + _this4.props.group.getCode() + '?origin=subscribed');
	          } else {
	            _ToastActions2.default.showDefaultErrorToast();
	          }
	        };
	
	        _GroupActions2.default.subscribeToGroup(_this4.props.group).then(onSubscribeSuccess, onSubscribeFailure);
	      };
	
	      // if the medium is email
	      // than we try to signin the user with the
	      // provided password, if it works then we try
	      // to subscribe the user to the group directly
	      // otherwise we transition to the sign in page.
	      _AuthActions2.default.signIn(attr.uid, attr.password).then(onSignInSuccess, onSignInFailure);
	    };
	
	    var cannotSignIn = function cannotSignIn() {
	      if (_this4.state.medium === 'sms') {
	        _this4.continueSmsFlow(attr, invalidateForm);
	      } else {
	        _this4.continueEmailFlow(attr, invalidateForm);
	      }
	    };
	
	    _Device2.default.belongsToFullAccount(address).then(canSignIn, cannotSignIn);
	  },
	  render: function render() {
	    var _this5 = this;
	
	    var uidPlaceholder = this.state.i18n ? 'email@school.edu' : '(555) 555-5555';
	    var uidLabel = 'Email';
	
	    if (!this.state.i18n) {
	      uidLabel = _react2.default.createElement(
	        'span',
	        null,
	        'Phone number or email address',
	        _react2.default.createElement(_HelpIcon2.default, {
	          tooltipText: 'Enter your phone number to receive messages by text or your email address to receive\n              messages by email. You can always change this later.'
	        })
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'JoinGroupFormPanel' },
	      _react2.default.createElement(
	        _Form2.default,
	        {
	          onSubmit: this.handleSubmit,
	          onValid: function onValid() {
	            return _this5.setState({ canSubmit: true });
	          },
	          onInvalid: function onInvalid() {
	            return _this5.setState({ canSubmit: false });
	          } },
	        _react2.default.createElement(_FormInput2.default, {
	          label: 'Full name',
	          required: true,
	          type: 'text',
	          size: 'large',
	          name: 'full_name',
	          placeholder: 'First and last name',
	          showErrorAfterBlur: true
	        }),
	        _react2.default.createElement(_FormInput2.default, {
	          label: uidLabel,
	          required: true,
	          type: 'text',
	          name: 'uid',
	          autoComplete: 'username',
	          size: 'large',
	          placeholder: uidPlaceholder,
	          onChange: this.onUidChange,
	          showErrorAfterBlur: true,
	          validations: this.state.medium === 'email' ? { isEmail: true } : { couldPlausiblyBeANorthAmericanPhoneNumber: true },
	          validationErrors: {
	            isEmail: 'Invalid email address.',
	            couldPlausiblyBeANorthAmericanPhoneNumber: 'Invalid phone number or email address.'
	          }
	        }),
	        this.state.medium === 'email' && _react2.default.createElement(_FormInput2.default, {
	          label: 'Choose a password',
	          required: true,
	          key: this.state.medium,
	          type: 'password',
	          autoComplete: 'new-password',
	          name: 'password',
	          size: 'large',
	          placeholder: 'Password',
	          showErrorAfterBlur: true,
	          validations: 'minLength:6',
	          validationErrors: {
	            minLength: 'Passwords should be at least 6 characters long.'
	          }
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            type: 'submit',
	            level: 'primary',
	            full: true,
	            disabled: !this.state.canSubmit },
	          'Sign up'
	        )
	      ),
	      _react2.default.createElement(_DividerText2.default, { text: 'or', uppercase: true }),
	      _react2.default.createElement(_GoogleSignIn2.default, { body: 'Sign up with Google', onSuccess: this.onGoogleSuccess }),
	      _react2.default.createElement(_TosText2.default, { className: 'JoinGroupFormPanel-tos' })
	    );
	  }
	}); /*  weak */
	exports.default = JoinGroupFormPanel;

/***/ },
/* 2771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _SmsInstruction = __webpack_require__(1443);
	
	var _SmsInstruction2 = _interopRequireDefault(_SmsInstruction);
	
	__webpack_require__(2772);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinDeviceBlockModal = _react2.default.createClass({
	  displayName: 'JoinDeviceBlockModal',
	  render: function render() {
	    return _react2.default.createElement(
	      _Modal2.default,
	      null,
	      _react2.default.createElement(
	        _DialogContent2.default,
	        _extends({
	          title: 'We cannot send you a code',
	          subtext: 'Sign up via text below'
	        }, this.props),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(_SmsInstruction2.default, {
	            group: this.props.group
	          })
	        )
	      )
	    );
	  }
	});
	
	exports.default = JoinDeviceBlockModal;

/***/ },
/* 2772 */
1136,
/* 2773 */,
/* 2774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TosText = function (_React$Component) {
	  _inherits(TosText, _React$Component);
	
	  function TosText() {
	    _classCallCheck(this, TosText);
	
	    return _possibleConstructorReturn(this, (TosText.__proto__ || Object.getPrototypeOf(TosText)).apply(this, arguments));
	  }
	
	  _createClass(TosText, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Text2.default,
	        { color: 'thunder', size: 'xxsmall', className: (0, _classnames2.default)('TosText', this.props.className) },
	        'By signing up, you agree to our',
	        ' ',
	        _react2.default.createElement(
	          _Link2.default,
	          { href: _LinkConstants2.default.TERMS_OF_SERVICE, target: '_blank', color: 'thunder', weight: 'semibold', noWrap: true },
	          'Terms of Service'
	        ),
	        ' ',
	        'and',
	        ' ',
	        _react2.default.createElement(
	          _Link2.default,
	          { href: _LinkConstants2.default.PRIVACY_POLICY, target: '_blank', color: 'thunder', weight: 'semibold', noWrap: true },
	          'Privacy Policy'
	        ),
	        '.'
	      );
	    }
	  }]);
	
	  return TosText;
	}(_react2.default.Component);
	
	TosText.displayName = 'TosText';
	exports.default = TosText;

/***/ },
/* 2775 */
1136,
/* 2776 */,
/* 2777 */
1136,
/* 2778 */,
/* 2779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _accountCompletionTracker = __webpack_require__(2526);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinView = function (_React$Component) {
	  _inherits(JoinView, _React$Component);
	
	  function JoinView() {
	    _classCallCheck(this, JoinView);
	
	    return _possibleConstructorReturn(this, (JoinView.__proto__ || Object.getPrototypeOf(JoinView)).apply(this, arguments));
	  }
	
	  _createClass(JoinView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _accountCompletionTracker.markAccountCreationStart)();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return JoinView;
	}(_react2.default.Component);
	
	JoinView.displayName = 'JoinView';
	exports.default = JoinView;

/***/ },
/* 2780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _CenteredContainer = __webpack_require__(2240);
	
	var _CenteredContainer2 = _interopRequireDefault(_CenteredContainer);
	
	var _GoogleConversionConstants = __webpack_require__(2781);
	
	var _GoogleConversionConstants2 = _interopRequireDefault(_GoogleConversionConstants);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RolePicker = __webpack_require__(2466);
	
	var _RolePicker2 = _interopRequireDefault(_RolePicker);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JoinRolePicker = function (_React$Component) {
	  _inherits(JoinRolePicker, _React$Component);
	
	  function JoinRolePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JoinRolePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinRolePicker.__proto__ || Object.getPrototypeOf(JoinRolePicker)).call.apply(_ref, [this].concat(args))), _this), _this.onSelect = function (role) {
	      var _this$props = _this.props,
	          params = _this$props.params,
	          router = _this$props.router;
	
	
	      var onUserUpdateError = function onUserUpdateError() {
	        _ToastActions2.default.showDefaultErrorToast();
	      };
	
	      var onUserUpdateSuccess = function onUserUpdateSuccess() {
	        var transitionOut = function transitionOut() {
	          if (params.groupCode) {
	            router.push('/information_required/' + params.groupCode);
	          } else {
	            router.push('/classes?origin=subscribed');
	          }
	        };
	
	        if (!params.groupCode) {
	          transitionOut();
	          return;
	        }
	
	        var onSubscriptionError = function onSubscriptionError(error) {
	          var expected = ['duplicate_membership', 'information_required', 'archived'].includes(error.code);
	          if (expected) {
	            transitionOut();
	          } else {
	            _ToastActions2.default.showDefaultErrorToast();
	            console.warn('Join Role Picker: failed to join group', error);
	          }
	        };
	
	        _GroupActions2.default.subscribeToGroupWithCode(params.groupCode).then(transitionOut, onSubscriptionError);
	      };
	
	      _UserActions2.default.update({ role: role }).then(onUserUpdateSuccess, onUserUpdateError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JoinRolePicker, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (window.google_trackConversion) {
	        window.google_trackConversion(_GoogleConversionConstants2.default.SIGN_UP);
	      }
	
	      if (window.fbq) {
	        window.fbq('track', 'PageView');
	        window.fbq('track', 'CompleteRegistration');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _CenteredContainer2.default,
	        { full: true },
	        _react2.default.createElement(_RolePicker2.default, { onSelect: this.onSelect })
	      );
	    }
	  }]);
	
	  return JoinRolePicker;
	}(_react2.default.Component);
	
	JoinRolePicker.displayName = 'JoinRolePicker';
	exports.default = JoinRolePicker;

/***/ },
/* 2781 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	exports.default = {
	  SIGN_UP: {
	    google_conversion_id: 995958353,
	    google_conversion_language: 'en',
	    google_conversion_format: '3',
	    google_conversion_color: 'ffffff',
	    google_conversion_label: 'yGxACJyoyWgQ0bz02gM',
	    google_remarketing_only: false
	  }
	};

/***/ },
/* 2782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _lodash = __webpack_require__(555);
	
	var _MailTo = __webpack_require__(1429);
	
	var _MailTo2 = _interopRequireDefault(_MailTo);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _CenteredContainer = __webpack_require__(2240);
	
	var _CenteredContainer2 = _interopRequireDefault(_CenteredContainer);
	
	var _PrependedTextInput = __webpack_require__(1384);
	
	var _PrependedTextInput2 = _interopRequireDefault(_PrependedTextInput);
	
	var _SettingsActions = __webpack_require__(1025);
	
	var _SettingsActions2 = _interopRequireDefault(_SettingsActions);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	__webpack_require__(2783);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var JoinSearchPage = function (_React$Component) {
	  _inherits(JoinSearchPage, _React$Component);
	
	  function JoinSearchPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JoinSearchPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = JoinSearchPage.__proto__ || Object.getPrototypeOf(JoinSearchPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      group: null,
	      error: null,
	      disabled: true,
	      showLegalFooter: false,
	      searching: false,
	      value: ''
	    }, _this.onInputChange = function (e) {
	      _this.setState({ group: null, error: null, disabled: true });
	
	      // TODO - cannot use regex from settings because JS does not support \A
	      var code = '';
	      if (e.target instanceof window.HTMLInputElement) {
	        code = e.target.value.replace(/[^a-z0-9-]/gi, '');
	        _this.setState({ value: code });
	      }
	
	      if (code.length < 3) {
	        return;
	      }
	
	      _this.setState({ searching: true });
	      _this.searchGroupByCode(_this, code);
	    }, _this.onSubmit = function () {
	      if (_this.state.group) {
	        _this.context.router.push('/join/' + _this.state.group.getCode());
	      }
	    }, _this.onNotFound = function () {
	      var error = '\n      Uh oh! We couldn\u2019t find a class matching this code.\n      Every class has a unique code. Please contact your\n      teacher to double check instructions for your class.';
	
	      _this.setState({ group: null, disabled: true, error: error, searching: false });
	    }, _this.searchGroupByCode = (0, _lodash.debounce)(function (component, code) {
	      var onFound = function onFound(group) {
	        component.setState({ group: group, disabled: false, searching: false });
	      };
	
	      _GroupActions2.default.searchGroupByCode(code).then(onFound, _this.onNotFound);
	    }, 1000), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(JoinSearchPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var notFoundCode = this.context.router.location.query.notFound || '';
	      if (notFoundCode) {
	        this.onNotFound();
	        this.setState({ value: notFoundCode });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var onGeoReceived = function onGeoReceived(geo) {
	        if (geo.country_code === 'US') {
	          _this2.setState({ showLegalFooter: true });
	        }
	      };
	
	      _SettingsActions2.default.getGeo().then(onGeoReceived, function () {});
	    }
	  }, {
	    key: 'renderLegalFooter',
	    value: function renderLegalFooter() {
	      if (!this.state.showLegalFooter) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _BoxFooter2.default,
	        { className: 'JoinSearchPage-Footer' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Remind uses the short code, 81010, to send alerts from teachers to students and parents. You may opt-in by using this Join page or by texting the class code directly to 81010. You may opt-out at any time by texting STOP to 81010.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Message frequency may vary by class. Standard message & data rates may apply.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Text HELP to 81010 for additional information.',
	          ' ',
	          _react2.default.createElement(_MailTo2.default, { to: _LinkConstants2.default.CONTACT_EMAIL })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _CenteredContainer2.default,
	        { size: 'small' },
	        _react2.default.createElement(
	          _Box2.default,
	          { className: 'JoinSearchPage' },
	          _react2.default.createElement(_BoxHeader2.default, { title: 'Find your class' }),
	          _react2.default.createElement(
	            _BoxBody2.default,
	            null,
	            _react2.default.createElement(
	              _Field2.default,
	              { error: this.state.error, loading: this.state.searching },
	              _react2.default.createElement(_PrependedTextInput2.default, {
	                'data-test-selector': 'join_search_input',
	                value: this.state.value,
	                onChange: this.onInputChange,
	                placeholder: 'Class code',
	                autofocus: true,
	                prepend: '@',
	                type: 'text'
	              })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                onClick: this.onSubmit,
	                'data-test-selector': 'join_search_submit',
	                disabled: this.state.disabled },
	              this.state.group ? 'Join ' + this.state.group.getPossessiveName() : 'Enter'
	            )
	          ),
	          this.renderLegalFooter()
	        )
	      );
	    }
	  }]);
	
	  return JoinSearchPage;
	}(_react2.default.Component);
	
	JoinSearchPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	JoinSearchPage.displayName = 'JoinSearchPage';
	exports.default = JoinSearchPage;

/***/ },
/* 2783 */
1136,
/* 2784 */,
/* 2785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _JoinEmailAccountUpgradeForm = __webpack_require__(2786);
	
	var _JoinEmailAccountUpgradeForm2 = _interopRequireDefault(_JoinEmailAccountUpgradeForm);
	
	var _JoinPageLoadingIndicator = __webpack_require__(2476);
	
	var _JoinPageLoadingIndicator2 = _interopRequireDefault(_JoinPageLoadingIndicator);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var STATUS = (0, _enumerate2.default)(['confirming', 'form']);
	
	var JoinConfirmEmailDevicePage = _react2.default.createClass({
	  displayName: 'JoinConfirmEmailDevicePage',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var query = this.props.location.query;
	
	    return {
	      token: query['token'],
	      verificationToken: query['verification_token'],
	      status: STATUS.confirming,
	      error: ''
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var onSessionExchangeError = function onSessionExchangeError() {
	      _this.setState({
	        error: 'Link might have expired.'
	      });
	    };
	
	    var confirmEmailDevice = function confirmEmailDevice(user) {
	      var onSuccess = function onSuccess() {
	        if (user.hasPassword()) {
	          _this.context.router.push('/join/' + _this.props.params.groupCode);
	        } else {
	          _this.setState({ status: STATUS.form });
	        }
	      };
	
	      var onError = function onError() {
	        _this.setState({ error: 'Cannot confirm email.' });
	      };
	
	      _Device2.default.confirmEmailDevice(_this.state.verificationToken).then(onSuccess, onError);
	    };
	
	    _AuthActions2.default.accessTokenSignIn(this.state.token).then(confirmEmailDevice, onSessionExchangeError);
	  },
	  redirectToInfoPage: function redirectToInfoPage() {
	    var groupCode = this.props.params.groupCode;
	    this.context.router.push('/information_required/' + groupCode);
	  },
	  renderAccountForm: function renderAccountForm() {
	    return _react2.default.createElement(_JoinEmailAccountUpgradeForm2.default, { onDone: this.redirectToInfoPage });
	  },
	  renderConfirming: function renderConfirming() {
	    if (this.state.error) {
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          size: 'small',
	          title: 'An error occured',
	          subtext: this.state.text },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          this.state.error
	        )
	      );
	    }
	
	    return _react2.default.createElement(_JoinPageLoadingIndicator2.default, null);
	  },
	  render: function render() {
	    var _STATUS$confirming$ST;
	
	    return (_STATUS$confirming$ST = {}, _defineProperty(_STATUS$confirming$ST, STATUS.confirming, this.renderConfirming), _defineProperty(_STATUS$confirming$ST, STATUS.form, this.renderAccountForm), _STATUS$confirming$ST)[this.state.status]();
	  }
	});
	
	exports.default = JoinConfirmEmailDevicePage;

/***/ },
/* 2786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _humanparser = __webpack_require__(2003);
	
	var _humanparser2 = _interopRequireDefault(_humanparser);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinEmailAccountUpgradeForm = _react2.default.createClass({
	  displayName: 'JoinEmailAccountUpgradeForm',
	  getInitialState: function getInitialState() {
	    return {
	      enabled: false
	    };
	  },
	  handleSubmit: function handleSubmit(attrs) {
	    var _this = this;
	
	    var onFailure = function onFailure() {
	      _ToastActions2.default.showDefaultErrorToast();
	    };
	
	    var onUpdateSuccess = function onUpdateSuccess() {
	      _AuthActions2.default.signIn(_CurrentUser2.default.getUser().getEmail(), attrs.password).then(_this.props.onDone, onFailure);
	    };
	
	    var human = _humanparser2.default.parseName(attrs.full_name);
	
	    _UserActions2.default.update({
	      prefix: human.salutation,
	      first_name: human.firstName,
	      last_name: human.lastName,
	      password: attrs.password
	    }).then(onUpdateSuccess, onFailure);
	  },
	  render: function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        size: 'small',
	        title: 'Complete your account' },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(
	          _Form2.default,
	          {
	            onSubmit: this.handleSubmit,
	            onValid: function onValid() {
	              return _this2.setState({ enabled: true });
	            },
	            onInvalid: function onInvalid() {
	              return _this2.setState({ enabled: false });
	            } },
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Full name',
	            type: 'text',
	            size: 'large',
	            name: 'full_name',
	            placeholder: 'First and last name',
	            validations: 'minLength:3',
	            showErrorAfterBlur: true,
	            validationErrors: {
	              minLength: 'Names should be at least 3 characters long.'
	            }
	          }),
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Choose a password',
	            type: 'password',
	            autoComplete: 'new-password',
	            className: 'UserPasswordForm-password',
	            name: 'password',
	            validations: 'minLength:6',
	            validOnPristine: true,
	            validationError: 'Password must be at least 6 characters long.'
	          }),
	          _react2.default.createElement(
	            _Button2.default,
	            { disabled: !this.state.enabled },
	            'Submit'
	          )
	        )
	      )
	    );
	  }
	}); /*  weak */
	exports.default = JoinEmailAccountUpgradeForm;

/***/ },
/* 2787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _humanparser = __webpack_require__(2003);
	
	var _humanparser2 = _interopRequireDefault(_humanparser);
	
	var _Session = __webpack_require__(1032);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _LinkSmsDevicePage = __webpack_require__(2788);
	
	var _LinkSmsDevicePage2 = _interopRequireDefault(_LinkSmsDevicePage);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinConfirmSmsDevicePage = _react2.default.createClass({
	  displayName: 'JoinConfirmSmsDevicePage',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      groupCode: this.props.params.groupCode,
	      address: this.props.location.query.address,
	      token: this.props.location.query.token,
	      name: this.props.location.query.name
	    };
	  },
	  onDone: function onDone(device) {
	    var _this = this;
	
	    var onUserUpdateSuccess = function onUserUpdateSuccess(user) {
	      _GroupActions2.default.subscribeToGroupWithCode(_this.state.groupCode).then(function () {
	        _this.context.router.push(user.getRole() ? '/classes?origin=subscribed' : '/join/role_picker');
	      }, function () {
	        _this.context.router.push('/join/role_picker/' + _this.state.groupCode);
	      });
	    };
	
	    var onUserUpdateFailure = function onUserUpdateFailure() {
	      _ToastActions2.default.showErrorToast('An error occured');
	      _this.context.router.push('/join/' + _this.state.groupCode);
	    };
	
	    var onSessionExchanged = function onSessionExchanged() {
	      // bypass the setup sms device setup step.
	      _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.NUX_SETUP_SMS_DEVICE);
	      var human = _humanparser2.default.parseName(_this.state.name);
	
	      _UserActions2.default.update({
	        prefix: human.salutation,
	        last_name: human.lastName,
	        first_name: human.firstName
	      }).then(onUserUpdateSuccess, onUserUpdateFailure);
	    };
	
	    _Session2.default.createWithToken(device.token).then(onSessionExchanged);
	  },
	  render: function render() {
	    return _react2.default.createElement(_LinkSmsDevicePage2.default, _extends({}, this.state, {
	      onDone: this.onDone,
	      instantResend: true
	    }));
	  }
	});
	
	exports.default = JoinConfirmSmsDevicePage;

/***/ },
/* 2788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkSmsPhoneInputBox = __webpack_require__(2789);
	
	var _LinkSmsPhoneInputBox2 = _interopRequireDefault(_LinkSmsPhoneInputBox);
	
	var _LinkSmsVerificationCodeBox = __webpack_require__(2617);
	
	var _LinkSmsVerificationCodeBox2 = _interopRequireDefault(_LinkSmsVerificationCodeBox);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Subscription = __webpack_require__(1008);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*  weak */
	
	
	var STATUS = (0, _enumerate2.default)(['ASK_PHONE', 'ASK_CODE']);
	
	var LinkSmsDevicePage = _react2.default.createClass({
	  displayName: 'LinkSmsDevicePage',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      status: this.props.token ? STATUS.ASK_CODE : STATUS.ASK_PHONE,
	      token: this.props.token || null
	    };
	  },
	  onDeviceLinked: function onDeviceLinked() {
	    var _props;
	
	    (_props = this.props).onDone.apply(_props, arguments);
	  },
	  onPhoneNumberSubmit: function onPhoneNumberSubmit(result) {
	    this.setState({
	      status: STATUS.ASK_CODE,
	      token: result.token,
	      phoneNumber: result.phoneNumber
	    });
	  },
	  onResend: function onResend() {
	    if (this.props.instantResend) {
	      this.resendSms();
	    } else {
	      this.setState(this.getInitialState());
	    }
	  },
	  resendSms: function resendSms() {
	    var _this = this;
	
	    var onSuccess = function onSuccess(response) {
	      _ToastActions2.default.showSuccessToast('Code resent');
	      _this.setState({ token: response.token });
	    };
	
	    var onError = function onError() {
	      _ToastActions2.default.showDefaultErrorToast();
	    };
	
	    _Subscription2.default.initiateDeviceSubscription(this.props.groupCode, this.props.address).then(onSuccess, onError);
	  },
	  renderAskConfirmationCode: function renderAskConfirmationCode() {
	    var footer = null;
	    if (this.props.onSkip) {
	      footer = _react2.default.createElement(
	        'span',
	        null,
	        'or ',
	        _react2.default.createElement(
	          _Link2.default,
	          { onClick: this.props.onSkip },
	          'skip this step'
	        )
	      );
	    }
	
	    return _react2.default.createElement(_LinkSmsVerificationCodeBox2.default, {
	      closable: this.props.closable,
	      onDone: this.onDeviceLinked,
	      token: this.state.token,
	      phoneNumber: this.state.phoneNumber,
	      onResend: this.onResend,
	      footer: footer
	    });
	  },
	  renderAskPhoneNumber: function renderAskPhoneNumber() {
	    var footer = null;
	    if (this.props.onSkip) {
	      footer = _react2.default.createElement(
	        'span',
	        null,
	        'Don\u2019t want to connect a phone? ',
	        _react2.default.createElement(
	          _Link2.default,
	          { onClick: this.props.onSkip },
	          'Skip this step'
	        )
	      );
	    }
	
	    return _react2.default.createElement(_LinkSmsPhoneInputBox2.default, {
	      onRequestHide: this.props.onRequestHide,
	      closable: this.props.closable,
	      footer: footer,
	      onDone: this.onPhoneNumberSubmit
	    });
	  },
	  render: function render() {
	    var _STATUS$ASK_PHONE$STA;
	
	    return (_STATUS$ASK_PHONE$STA = {}, _defineProperty(_STATUS$ASK_PHONE$STA, STATUS.ASK_PHONE, this.renderAskPhoneNumber), _defineProperty(_STATUS$ASK_PHONE$STA, STATUS.ASK_CODE, this.renderAskConfirmationCode), _STATUS$ASK_PHONE$STA)[this.state.status]();
	  }
	});
	
	exports.default = LinkSmsDevicePage;

/***/ },
/* 2789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var LinkSmsPhoneInputBox = function (_React$Component) {
	  _inherits(LinkSmsPhoneInputBox, _React$Component);
	
	  function LinkSmsPhoneInputBox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LinkSmsPhoneInputBox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkSmsPhoneInputBox.__proto__ || Object.getPrototypeOf(LinkSmsPhoneInputBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      submitting: false
	    }, _this.submitPhoneNumber = function (form) {
	      var phoneNumber = form['phone_number'];
	
	      var onSuccess = function onSuccess(response) {
	        _this.setState({ submitting: false });
	
	        _this.props.onDone({
	          token: response.token,
	          phoneNumber: phoneNumber
	        });
	      };
	
	      var onError = function onError(response) {
	        _this.setState({ submitting: false });
	
	        if (response && response.code === 'duplicate_device') {
	          _ToastActions2.default.showErrorToast('This device is already linked to your account.');
	          return;
	        }
	
	        if (response && response.code === 'underage_account_conflict') {
	          _ToastActions2.default.showErrorToast('Please contact support for assistance linking this device.');
	          return;
	        }
	
	        if (response && response.code === 'validation_error') {
	          var message = response.error.endpoint && response.error.endpoint[0] || 'Please enter a valid phone number.';
	          _ToastActions2.default.showErrorToast(message);
	          return;
	        }
	
	        _ToastActions2.default.showDefaultErrorToast();
	      };
	
	      _this.setState({ submitting: true });
	
	      _DeviceActions2.default.outboundVerify(phoneNumber).then(onSuccess, onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LinkSmsPhoneInputBox, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          size: 'small',
	          full: true,
	          title: 'What is your mobile number?',
	          onRequestHide: this.props.onRequestHide,
	          hideCloseButton: !this.props.closable,
	          subtext: 'We’ll send you a code to connect your phone.' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            _Form2.default,
	            { onValidSubmit: this.submitPhoneNumber },
	            _react2.default.createElement(_FormInput2.default, {
	              name: 'phone_number',
	              className: 'LinkSmsPhoneInputBox-Input',
	              autofocus: true,
	              placeholder: '(555) 555-5555',
	              size: 'large',
	              type: 'text',
	              validations: { couldPlausiblyBeANorthAmericanPhoneNumber: true },
	              validationErrors: {
	                couldPlausiblyBeANorthAmericanPhoneNumber: 'Invalid phone number'
	              },
	              showErrorAfterBlur: true
	            }),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: 'LinkSmsPhoneInputBox-Submit',
	                disabled: this.state.submitting,
	                type: 'submit',
	                eventElementName: 'LinkSmsPhoneInputBox-Submit' },
	              'Send code'
	            )
	          )
	        ),
	        this.props.footer ? _react2.default.createElement(
	          _BoxFooter2.default,
	          null,
	          this.props.footer
	        ) : null
	      );
	    }
	  }]);
	
	  return LinkSmsPhoneInputBox;
	}(_react2.default.Component);
	
	LinkSmsPhoneInputBox.displayName = 'LinkSmsPhoneInputBox';
	exports.default = LinkSmsPhoneInputBox;

/***/ },
/* 2790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _CenteredContainer = __webpack_require__(2240);
	
	var _CenteredContainer2 = _interopRequireDefault(_CenteredContainer);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _JoinOrganizationAvatarPanel = __webpack_require__(2791);
	
	var _JoinOrganizationAvatarPanel2 = _interopRequireDefault(_JoinOrganizationAvatarPanel);
	
	var _JoinOrganizationFormPanel = __webpack_require__(2792);
	
	var _JoinOrganizationFormPanel2 = _interopRequireDefault(_JoinOrganizationFormPanel);
	
	var _JoinPageLoadingIndicator = __webpack_require__(2476);
	
	var _JoinPageLoadingIndicator2 = _interopRequireDefault(_JoinPageLoadingIndicator);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _OrganizationProfile = __webpack_require__(2516);
	
	var _OrganizationProfile2 = _interopRequireDefault(_OrganizationProfile);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponsiveMixin = __webpack_require__(1260);
	
	var _ResponsiveMixin2 = _interopRequireDefault(_ResponsiveMixin);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _SchoolPickerModal = __webpack_require__(2796);
	
	var _SchoolPickerModal2 = _interopRequireDefault(_SchoolPickerModal);
	
	var _modal = __webpack_require__(1188);
	
	__webpack_require__(2797);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var STATUS = (0, _enumerate2.default)(['loading', 'success', 'failure']);
	
	var JoinOrganizationPage = _react2.default.createClass({
	  displayName: 'JoinOrganizationPage',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [_ResponsiveMixin2.default],
	
	  statics: {
	    SMALL: 700,
	    onEnter: function onEnter(nextState, replaceWith, callback) {
	      var onSuccess = function onSuccess() {
	        replaceWith('/school/confirm/' + nextState.params.id);
	        callback();
	      };
	
	      _AuthActions2.default.checkLoggedIn().then(onSuccess, function () {
	        return callback();
	      });
	    }
	  },
	
	  // typecheck: ignore statement
	  getInitialState: function getInitialState() {
	    return {
	      status: STATUS.loading,
	      organization: null,
	      query: this.props.location.query,
	      light: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.fetchOrganization();
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.params.id !== nextProps.params.id) {
	      this.fetchOrganization();
	    }
	  },
	  onChange: function onChange() {
	    var _this = this;
	
	    var onSchoolSelect = function onSchoolSelect(schoolId) {
	      _this.context.router.push('/school/join/' + schoolId);
	    };
	
	    var onNotTeacher = function onNotTeacher() {
	      _this.context.router.push('/sign_up');
	    };
	
	    (0, _modal.mountModal)(_react2.default.createElement(_SchoolPickerModal2.default, {
	      onSchoolSelect: onSchoolSelect,
	      onNotTeacher: onNotTeacher
	    }), this);
	  },
	  fetchOrganization: function fetchOrganization() {
	    var _this2 = this;
	
	    var onSuccess = function onSuccess(organization) {
	      _this2.setState({
	        status: STATUS.success,
	        organization: organization
	      });
	    };
	
	    var onFailure = function onFailure() {
	      _this2.setState({ status: STATUS.failure });
	    };
	
	    var organizationId = this.props.params.id;
	
	    _OrganizationProfile2.default.fetch({ id: organizationId }).then(onSuccess, onFailure);
	  },
	  renderFailure: function renderFailure() {
	    return _react2.default.createElement(
	      _CenteredContainer2.default,
	      { className: 'JoinOrganizationPage-ErrorPane' },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(_Image2.default, {
	          className: 'NotFoundPage-image',
	          src: __webpack_require__(2799),
	          alt: 'This is embarrassing'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'NotFoundPage-title' },
	          'Uh oh! Something went wrong.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'We could not find this school.'
	        )
	      )
	    );
	  },
	  renderLoading: function renderLoading() {
	    return _react2.default.createElement(_JoinPageLoadingIndicator2.default, null);
	  },
	  renderSuccess: function renderSuccess() {
	    if (this.isComponentSize(JoinOrganizationPage.SMALL)) {
	      var subText = _react2.default.createElement(
	        'span',
	        null,
	        'Not your school?',
	        ' ',
	        _react2.default.createElement(
	          _Link2.default,
	          { color: 'thunder', onClick: this.onChange },
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Change'
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          title:
	          // $FlowFixMe
	          'Signup for Remind at ' + this.state.organization.getName(),
	          subtext: subText,
	          full: true,
	          size: 'large',
	          onRequestHide: function onRequestHide() {},
	          className: 'JoinOrganizationPage' },
	        _react2.default.createElement(
	          _Box2.default,
	          { className: 'AuthenticationView-box' },
	          _react2.default.createElement(
	            _BoxBody2.default,
	            null,
	            _react2.default.createElement(_JoinOrganizationFormPanel2.default, {
	              role: this.state.query.role || _UserConstants.Roles.teacher,
	              defaultValues: this.state.query,
	              organization: this.state.organization
	            })
	          )
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        size: 'large',
	        full: true,
	        onRequestHide: function onRequestHide() {},
	        className: 'JoinOrganizationPage' },
	      _react2.default.createElement(
	        _Box2.default,
	        { className: 'AuthenticationView-box' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            _Columns2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'JoinOrganizationPage-LeftPanel' },
	              _react2.default.createElement(_JoinOrganizationAvatarPanel2.default, { organization: this.state.organization }),
	              _react2.default.createElement(
	                'span',
	                { className: 'JoinOrganizationPage-LeftPanel-Footer' },
	                'Not your school?',
	                ' ',
	                _react2.default.createElement(
	                  _Link2.default,
	                  { color: 'thunder', onClick: this.onChange },
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Change'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_JoinOrganizationFormPanel2.default, {
	              role: this.state.query.role || _UserConstants.Roles.teacher,
	              defaultValues: this.state.query,
	              organization: this.state.organization
	            })
	          )
	        )
	      )
	    );
	  },
	  render: function render() {
	    var _STATUS$loading$STATU;
	
	    return (_STATUS$loading$STATU = {}, _defineProperty(_STATUS$loading$STATU, STATUS.loading, this.renderLoading), _defineProperty(_STATUS$loading$STATU, STATUS.success, this.renderSuccess), _defineProperty(_STATUS$loading$STATU, STATUS.failure, this.renderFailure), _STATUS$loading$STATU)[this.state.status]();
	  }
	});
	
	exports.default = JoinOrganizationPage;

/***/ },
/* 2791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _OrganizationProfile = __webpack_require__(2516);
	
	var _OrganizationProfile2 = _interopRequireDefault(_OrganizationProfile);
	
	__webpack_require__(2538);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinOrganizationAvatarPanel = _react2.default.createClass({
	  displayName: 'JoinOrganizationAvatarPanel',
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showSchoolNameAboveAvatar: true,
	      showSchoolNameAboveAddress: false
	    };
	  },
	  getSchoolImage: function getSchoolImage() {
	    // TODO return school image (not in entity ATM).
	    return __webpack_require__(1000);
	  },
	  render: function render() {
	    var title = this.props.title ? this.props.title : 'Sign up for Remind at';
	    var name = null;
	
	    if (this.props.showSchoolNameAboveAvatar) {
	      name = _react2.default.createElement(
	        'h4',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          this.props.organization.getName()
	        )
	      );
	    }
	
	    var schoolName = null;
	    if (this.props.showSchoolNameAboveAddress) {
	      schoolName = _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          this.props.organization.getName()
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)('JoinAvatarPanel', this.props.className, {
	          'JoinAvatarPanel-Faded': this.props.faded
	        }) },
	      _react2.default.createElement(
	        'div',
	        { className: 'JoinAvatarPanel-Header' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          title
	        ),
	        name
	      ),
	      _react2.default.createElement(_Image2.default, { className: 'JoinAvatarPanel-Image', src: this.getSchoolImage() }),
	      _react2.default.createElement(
	        'div',
	        { className: 'JoinAvatarPanel-Footer' },
	        schoolName,
	        _react2.default.createElement('br', null),
	        this.props.organization.getStreet() ? _react2.default.createElement(
	          'span',
	          null,
	          this.props.organization.getStreet(),
	          _react2.default.createElement('br', null)
	        ) : null,
	        _react2.default.createElement(
	          'span',
	          null,
	          this.props.organization.getCity(),
	          ', ',
	          this.props.organization.getState(),
	          ' ',
	          this.props.organization.getZip()
	        )
	      )
	    );
	  }
	}); /*  weak */
	exports.default = JoinOrganizationAvatarPanel;

/***/ },
/* 2792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _JoinSignUpForm = __webpack_require__(2793);
	
	var _JoinSignUpForm2 = _interopRequireDefault(_JoinSignUpForm);
	
	var _OrganizationProfile = __webpack_require__(2516);
	
	var _OrganizationProfile2 = _interopRequireDefault(_OrganizationProfile);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserConstants = __webpack_require__(1015);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	__webpack_require__(2794);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinOrganizationFormPanel = _react2.default.createClass({
	  displayName: 'JoinOrganizationFormPanel',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  transitionToGroups: function transitionToGroups() {
	    this.context.router.push('/classes?origin=subscribed');
	  },
	  updateUserOrganization: function updateUserOrganization() {
	    var _this = this;
	
	    var onUserUpdateSuccess = function onUserUpdateSuccess() {
	      _ToastActions2.default.showSuccessToast('School joined');
	      _this.context.router.push('/landing');
	    };
	
	    var updateData = {
	      organization_id: this.props.organization.id,
	      role: _CurrentUser2.default.getUser().getRole() || this.props.role
	    };
	
	    _UserActions2.default.update(updateData).then(onUserUpdateSuccess);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'JoinOrganizationFormPanel' },
	      _react2.default.createElement(_JoinSignUpForm2.default, {
	        defaultValues: this.props.defaultValues,
	        onUserCreate: this.updateUserOrganization
	      })
	    );
	  }
	});
	
	exports.default = JoinOrganizationFormPanel;

/***/ },
/* 2793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _humanparser = __webpack_require__(2003);
	
	var _humanparser2 = _interopRequireDefault(_humanparser);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _DividerText = __webpack_require__(1234);
	
	var _DividerText2 = _interopRequireDefault(_DividerText);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _GoogleSignIn = __webpack_require__(1706);
	
	var _GoogleSignIn2 = _interopRequireDefault(_GoogleSignIn);
	
	var _TosText = __webpack_require__(2774);
	
	var _TosText2 = _interopRequireDefault(_TosText);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinSignUpForm = _react2.default.createClass({
	  displayName: 'JoinSignUpForm',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultValues: {},
	      role: ''
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      canSubmit: false
	    };
	  },
	  onSubmit: function onSubmit(attrs, _, invalidateForm) {
	    var _this = this;
	
	    var doLogin = function doLogin() {
	      var onSignInSuccess = function onSignInSuccess() {
	        _this.props.onUserCreate();
	      };
	
	      var onSignInFailure = function onSignInFailure() {
	        invalidateForm({ email: 'Email has already been taken' });
	      };
	
	      _AuthActions2.default.signIn(attrs.email, attrs.password).then(onSignInSuccess, onSignInFailure);
	    };
	
	    var doSignup = function doSignup() {
	      var human = _humanparser2.default.parseName(attrs['full_name']);
	      var role = _this.props.role ? _this.props.role : '';
	      var userData = {
	        email: attrs.email,
	        prefix: human.salutation,
	        password: attrs.password,
	        last_name: human.lastName,
	        first_name: human.firstName,
	        role: role };
	
	      var onError = function onError(error) {
	        var errors = {};
	
	        if (error.code === 'email_used_by_google_sign_in') {
	          invalidateForm({ email: error.error });
	          return;
	        }
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = error.field_errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var field = _step.value;
	
	            errors[field['field_name']] = field.messages.join(', ');
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        invalidateForm(errors);
	      };
	
	      _UserActions2.default.create(userData).then(_this.props.onUserCreate, onError);
	    };
	
	    _Device2.default.belongsToFullAccount('email://' + attrs.email).then(doLogin, doSignup);
	  },
	  render: function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Form2.default,
	        {
	          onSubmit: this.onSubmit,
	          onValid: function onValid() {
	            return _this2.setState({ canSubmit: true });
	          },
	          onInvalid: function onInvalid() {
	            return _this2.setState({ canSubmit: false });
	          } },
	        _react2.default.createElement(_FormInput2.default, {
	          label: 'Full name',
	          type: 'text',
	          size: 'large',
	          name: 'full_name',
	          autoComplete: 'name',
	          placeholder: 'First and last name',
	          validations: 'minLength:3'
	          // $FlowIssue
	          , value: this.props.defaultValues['full_name'],
	          showErrorAfterBlur: true,
	          className: 'JoinSignUpForm-Name',
	          validationErrors: {
	            minLength: 'Names should be at least 3 characters long.'
	          }
	        }),
	        _react2.default.createElement(_FormInput2.default, {
	          label: 'Email',
	          type: 'email',
	          name: 'email'
	          // even though this is an email, let the browser know to use this as username in the future
	          , autoComplete: 'username',
	          size: 'large'
	          // $FlowIssue
	          , value: this.props.defaultValues['email'],
	          placeholder: 'name@example.com',
	          showErrorAfterBlur: true,
	          validations: 'minLength:1',
	          className: 'JoinSignUpForm-Email',
	          validationErrors: {
	            minLength: 'Invalid, must not be empty'
	          }
	        }),
	        _react2.default.createElement(_FormInput2.default, {
	          label: 'Password',
	          type: 'password',
	          name: 'password',
	          autoComplete: 'new-password',
	          size: 'large',
	          placeholder: 'New password',
	          showErrorAfterBlur: true,
	          validations: 'minLength:6',
	          className: 'JoinSignUpForm-Password',
	          validationErrors: {
	            minLength: 'Passwords should be at least 6 characters long.'
	          }
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            type: 'submit',
	            level: 'primary',
	            full: true,
	            className: 'JoinSignUpForm-Submit',
	            disabled: !this.state.canSubmit,
	            eventElementName: 'JoinSignUpForm-Submit' },
	          'Sign up'
	        )
	      ),
	      _react2.default.createElement(_DividerText2.default, { text: 'or', uppercase: true }),
	      _react2.default.createElement(_GoogleSignIn2.default, { body: 'Sign up with Google', onSuccess: this.props.onUserCreate }),
	      _react2.default.createElement(_TosText2.default, { className: 'JoinSignUpForm-tos' })
	    );
	  }
	});
	exports.default = JoinSignUpForm;

/***/ },
/* 2794 */
1136,
/* 2795 */,
/* 2796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _SchoolPicker = __webpack_require__(2510);
	
	var _SchoolPicker2 = _interopRequireDefault(_SchoolPicker);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchoolPickerModal = function (_React$Component) {
	  _inherits(SchoolPickerModal, _React$Component);
	
	  function SchoolPickerModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SchoolPickerModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SchoolPickerModal.__proto__ || Object.getPrototypeOf(SchoolPickerModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      schoolId: null
	    }, _this.onNotTeacher = function () {
	      _this.props.onRequestHide();
	      _this.props.onNotTeacher();
	    }, _this.onSchoolSelect = function () {
	      _this.props.onRequestHide();
	      _this.props.onSchoolSelect(_this.state.schoolId);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SchoolPickerModal, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'SchoolPickerModal'
	        }, this.props, {
	          className: 'SetupSchool',
	          hideCloseButton: false,
	          full: true,
	          title: 'Select your school',
	          size: 'small' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            _Field2.default,
	            { className: 'SetupGroup-field' },
	            _react2.default.createElement(
	              _Label2.default,
	              null,
	              'My school'
	            ),
	            _react2.default.createElement(_SchoolPicker2.default, {
	              schoolId: this.state.schoolId,
	              organizationType: _OrganizationConstants.OrganizationTypes.SCHOOL,
	              placeholder: 'Search for a school',
	              onSelect: function onSelect(value) {
	                return _this2.setState({ schoolId: value });
	              },
	              onClear: function onClear() {
	                return _this2.setState({ schoolId: null });
	              },
	              onNoSchool: this.handleDontWorkClick,
	              autofocus: true
	            })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { disabled: !this.state.schoolId, onClick: this.onSchoolSelect },
	            'Select'
	          )
	        ),
	        _react2.default.createElement(
	          _BoxFooter2.default,
	          { className: 'SetupSchool-footer' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'SetupSchool-dontWorkButton',
	              level: 'text',
	              size: 'small',
	              onClick: this.onNotTeacher,
	              eventElementName: 'SetupSchool-dontWorkButton' },
	            'I don\u2019t teach at a school'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SchoolPickerModal;
	}(_react2.default.Component);
	
	SchoolPickerModal.displayName = 'SchoolPickerModal';
	exports.default = SchoolPickerModal;

/***/ },
/* 2797 */
1136,
/* 2798 */,
/* 2799 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _JoinSignUpForm = __webpack_require__(2793);
	
	var _JoinSignUpForm2 = _interopRequireDefault(_JoinSignUpForm);
	
	var _ResponsiveMixin = __webpack_require__(1260);
	
	var _ResponsiveMixin2 = _interopRequireDefault(_ResponsiveMixin);
	
	var _JoinSignUpPageLeftPanel = __webpack_require__(2801);
	
	var _JoinSignUpPageLeftPanel2 = _interopRequireDefault(_JoinSignUpPageLeftPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinSignUpPage = _react2.default.createClass({
	  displayName: 'JoinSignUpPage',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [_ResponsiveMixin2.default],
	
	  statics: {
	    SMALL: 700
	  },
	
	  onUserCreate: function onUserCreate() {
	    this.context.router.push('/landing');
	  },
	  render: function render() {
	    if (this.isComponentSize(JoinSignUpPage.SMALL)) {
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        { size: 'large', full: true },
	        _react2.default.createElement(
	          _Box2.default,
	          { className: 'AuthenticationView-box' },
	          _react2.default.createElement(
	            _BoxBody2.default,
	            null,
	            _react2.default.createElement(_JoinSignUpForm2.default, { onUserCreate: this.onUserCreate })
	          )
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      { size: 'large', full: true },
	      _react2.default.createElement(
	        _Box2.default,
	        { className: 'AuthenticationView-box' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            _Columns2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'JoinSignUpPage-LeftPanel' },
	              _react2.default.createElement(_JoinSignUpPageLeftPanel2.default, null)
	            ),
	            _react2.default.createElement(_JoinSignUpForm2.default, { onUserCreate: this.onUserCreate })
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = JoinSignUpPage;

/***/ },
/* 2801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	__webpack_require__(2802);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JoinSignUpPageLeftPanel = _react2.default.createClass({
	  displayName: 'JoinSignUpPageLeftPanel',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'JoinSignUpPageLeftPanel' },
	      _react2.default.createElement(_TitleHeader2.default, {
	        image: __webpack_require__(2804),
	        title: 'Sign up for Remind',
	        subtext: 'Reach students and parents where they are. Send quick, simple messages to any\n            device\u2014for free.',
	        size: 'xlarge',
	        className: 'JoinSignUpPageLeftPanel-title'
	      })
	    );
	  }
	});
	exports.default = JoinSignUpPageLeftPanel;

/***/ },
/* 2802 */
1136,
/* 2803 */,
/* 2804 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _OrganizationAccountActions = __webpack_require__(2751);
	
	var _OrganizationAccountActions2 = _interopRequireDefault(_OrganizationAccountActions);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _TosText = __webpack_require__(2774);
	
	var _TosText2 = _interopRequireDefault(_TosText);
	
	var _SignInPage = __webpack_require__(1689);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _JoinPageLoadingIndicator = __webpack_require__(2476);
	
	var _JoinPageLoadingIndicator2 = _interopRequireDefault(_JoinPageLoadingIndicator);
	
	__webpack_require__(2806);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EVENT_SCREEN_NAME = 'JoinClaimDirectAddAccount';
	
	var JoinClaimDirectAddAccount = _react2.default.createClass({
	  displayName: 'JoinClaimDirectAddAccount',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  childContextTypes: {
	    eventScreenName: _react2.default.PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    var query = this.props.location.query;
	
	
	    (0, _invariant2.default)(query.token, 'missing token');
	
	    return {
	      token: query.token,
	      isValid: false,
	      account: null
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      eventScreenName: EVENT_SCREEN_NAME
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.loadAccount();
	  },
	  onSubmit: function onSubmit(attrs) {
	    var _this = this;
	
	    _OrganizationAccountActions2.default.claimAccount(this.state.token, attrs.password).then(function () {
	      return _this.context.router.push('/classes?origin=subscribed');
	    }, function () {
	      return _ToastActions2.default.showDefaultErrorToast();
	    });
	  },
	  loadAccount: function loadAccount() {
	    var _this2 = this;
	
	    var onSuccess = function onSuccess(_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          account = _ref2[0],
	          isLoggedIn = _ref2[1];
	
	      if (isLoggedIn) {
	        _this2.context.router.push({
	          pathname: '/classes?origin=subscribed',
	          query: _this2.props.location.query
	        });
	      } else {
	        _this2.setState({ account: account });
	        _this2.refs.password.refs.children.focus();
	      }
	    };
	    var onError = function onError() {
	      return _ToastActions2.default.showDefaultErrorToast();
	    };
	
	    var isLoggedIn = new Promise(function (resolve) {
	      _AuthActions2.default.checkLoggedIn().then(function () {
	        return resolve(true);
	      }, function () {
	        return resolve(false);
	      });
	    });
	    var accountPromise = _OrganizationAccountActions2.default.getOrLoadAccount(this.state.token);
	    Promise.all([accountPromise, isLoggedIn]).then(onSuccess, onError);
	  },
	  goToSignIn: function goToSignIn() {
	    // XXX
	    _SignInPage.redirector.onSignInRedirectTo = {
	      pathname: '/classes?origin=subscribed',
	      query: this.props.location.query
	    };
	    this.context.router.push('/log_in');
	  },
	  rejectAccount: function rejectAccount() {
	    _OrganizationAccountActions2.default.rejectAccount(this.state.token);
	    this.context.router.push('/sign_up');
	  },
	  render: function render() {
	    var _this3 = this;
	
	    if (!this.state.account) {
	      return _react2.default.createElement(_JoinPageLoadingIndicator2.default, null);
	    }
	
	    var account = this.state.account;
	
	    var headerImage = _react2.default.createElement(_Image2.default, {
	      className: 'JoinClaimDirectAddAccount-headerImage',
	      src: __webpack_require__(1000)
	    });
	
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        className: 'JoinClaimDirectAddAccount',
	        title: 'Hi ' + account.user_name + '!',
	        headerImageComponent: headerImage,
	        size: 'small',
	        subtext: account.from_admin_name + ' has invited you to join ' + (account.organization_name + ' on Remind with the email address ') + (account.user_email + '.') },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(
	          _Text2.default,
	          { size: 'xsmall' },
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              className: 'wrong_email',
	              onClick: this.rejectAccount,
	              eventElementName: 'wrong_email' },
	            _react2.default.createElement(
	              _Text2.default,
	              { weight: 'semibold' },
	              'Not you'
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            _Text2.default,
	            { color: 'thunder' },
	            'or'
	          ),
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              className: 'already_have_account',
	              onClick: this.goToSignIn,
	              eventElementName: 'already_have_account' },
	            _react2.default.createElement(
	              _Text2.default,
	              { weight: 'semibold' },
	              'already have an account?'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Form2.default,
	          {
	            onSubmit: this.onSubmit,
	            onValid: function onValid() {
	              return _this3.setState({ isValid: true });
	            },
	            onInvalid: function onInvalid() {
	              return _this3.setState({ isValid: false });
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'JoinClaimDirectAddAccount-password' },
	            _react2.default.createElement(_FormInput2.default, {
	              label: 'Create a password',
	              autoComplete: 'new-password',
	              className: 'JoinClaimDirectAddAccount-passwordInput',
	              ref: 'password',
	              name: 'password',
	              type: 'password',
	              size: 'large',
	              placeholder: 'Password',
	              showErrorAfterBlur: true,
	              validations: 'minLength:6',
	              validationErrors: {
	                minLength: 'Passwords should be at least 6 characters long.'
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'submit_password JoinClaimDirectAddAccount-submitButton',
	              disabled: !this.state.isValid,
	              type: 'submit',
	              level: 'primary',
	              eventElementName: 'submit_password JoinClaimDirectAddAccount-submitButton' },
	            'Continue'
	          )
	        ),
	        _react2.default.createElement(_TosText2.default, null)
	      )
	    );
	  }
	});
	
	exports.default = JoinClaimDirectAddAccount;

/***/ },
/* 2806 */
1136,
/* 2807 */,
/* 2808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _OrganizationProfile = __webpack_require__(2516);
	
	var _OrganizationProfile2 = _interopRequireDefault(_OrganizationProfile);
	
	var _JoinPageLoadingIndicator = __webpack_require__(2476);
	
	var _JoinPageLoadingIndicator2 = _interopRequireDefault(_JoinPageLoadingIndicator);
	
	var _JoinOrganizationAvatarPanel = __webpack_require__(2791);
	
	var _JoinOrganizationAvatarPanel2 = _interopRequireDefault(_JoinOrganizationAvatarPanel);
	
	var _ResponsiveMixin = __webpack_require__(1260);
	
	var _ResponsiveMixin2 = _interopRequireDefault(_ResponsiveMixin);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(2809);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); } /*  weak */
	
	
	var STATUS = (0, _enumerate2.default)(['loading', 'success']);
	
	var ConfirmOrganizationPage = _react2.default.createClass({
	  displayName: 'ConfirmOrganizationPage',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [_ResponsiveMixin2.default],
	
	  statics: {
	    SMALL: 700,
	    onEnter: function onEnter(nextState, replaceWith, callback) {
	      if (_CurrentUser2.default.isSignedIn()) {
	        callback();
	      }
	
	      var onError = function onError() {
	        replaceWith('/school/join/' + nextState.params.id);
	        callback();
	      };
	
	      _AuthActions2.default.checkLoggedIn().then(function () {
	        return callback();
	      }, onError);
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      status: STATUS.loading,
	      targetOrganization: null,
	      currentOrganizations: []
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var organizationId = this.props.params.id;
	    var orgPromise = _OrganizationProfile2.default.fetch({ id: organizationId });
	
	    var organizationIds = _CurrentUser2.default.getUser().getOrganizationIds();
	
	    var organizationEntitiesPromise = organizationIds.map(function (id) {
	      return _OrganizationProfile2.default.fetch({ id: id });
	    });
	
	    var arrayOfPromises = [orgPromise].concat(organizationEntitiesPromise);
	
	    Promise.all(arrayOfPromises).then(function (_ref) {
	      var _ref2 = _toArray(_ref),
	          targetOrganization = _ref2[0],
	          currentOrganizations = _ref2.slice(1);
	
	      _this.setState({
	        targetOrganization: targetOrganization,
	        currentOrganizations: currentOrganizations,
	        status: STATUS.success
	      });
	    });
	  },
	  confirmTargetOrganization: function confirmTargetOrganization() {
	    var organizationIds = _CurrentUser2.default.getUser().getOrganizationIds();
	    organizationIds.push(this.state.targetOrganization.id);
	    var updateData = { organization_ids: organizationIds };
	
	    _UserActions2.default.update(updateData).then(this.continueToRemind);
	  },
	  continueToRemind: function continueToRemind() {
	    this.context.router.push('/landing');
	  },
	  logout: function logout() {
	    _AuthActions2.default.signOut('/school/join/' + this.props.params.id);
	  },
	  renderAlreadyMember: function renderAlreadyMember() {
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        size: 'small',
	        full: true },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(_JoinOrganizationAvatarPanel2.default, {
	          title: 'You are currently linked to',
	          organization: this.state.targetOrganization
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            full: true,
	            onClick: this.continueToRemind,
	            className: 'ConfirmOrganizationPage-Submit',
	            eventElementName: 'ConfirmOrganizationPage-Submit' },
	          'Continue to Remind'
	        ),
	        this.renderLogoutOption()
	      )
	    );
	  },
	  renderConfirmation: function renderConfirmation() {
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        size: 'small',
	        full: true },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(_JoinOrganizationAvatarPanel2.default, {
	          title: 'Link to',
	          organization: this.state.targetOrganization
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            full: true,
	            onClick: this.confirmTargetOrganization,
	            className: 'ConfirmOrganizationPage-Submit',
	            eventElementName: 'ConfirmOrganizationPage-Submit' },
	          'Link to ',
	          this.state.targetOrganization.getName()
	        ),
	        this.renderLogoutOption()
	      )
	    );
	  },
	  renderLoading: function renderLoading() {
	    return _react2.default.createElement(_JoinPageLoadingIndicator2.default, null);
	  },
	  renderLogoutOption: function renderLogoutOption() {
	    return _react2.default.createElement(
	      'p',
	      { className: 'ConfirmOrganizationPage-Footer' },
	      'Logged in as ',
	      _CurrentUser2.default.getUser().getSignature(),
	      _react2.default.createElement('br', null),
	      'Not you? ',
	      _react2.default.createElement(
	        _Link2.default,
	        { onClick: this.logout },
	        'Log out'
	      )
	    );
	  },
	  renderSuccess: function renderSuccess() {
	    var isMemberOfTarget = this.state.currentOrganizations.map(function (organization) {
	      return organization.id;
	    }).includes(this.state.targetOrganization.id);
	
	    return isMemberOfTarget ? this.renderAlreadyMember() : this.renderConfirmation();
	  },
	  render: function render() {
	    var _STATUS$loading$STATU;
	
	    return (_STATUS$loading$STATU = {}, _defineProperty(_STATUS$loading$STATU, STATUS.loading, this.renderLoading), _defineProperty(_STATUS$loading$STATU, STATUS.success, this.renderSuccess), _STATUS$loading$STATU)[this.state.status]();
	  }
	});
	
	exports.default = ConfirmOrganizationPage;

/***/ },
/* 2809 */
1136,
/* 2810 */,
/* 2811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _ErrorActions = __webpack_require__(1427);
	
	var _ErrorActions2 = _interopRequireDefault(_ErrorActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _jsonwebtoken = __webpack_require__(2611);
	
	var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeaveChatView = _react2.default.createClass({
	  displayName: 'LeaveChatView',
	
	  mixins: [(0, _linkStateWithStores2.default)([_ChatStore2.default])],
	
	  statics: {
	    onEnter: function onEnter(nextState, replaceWith, callback) {
	      _AuthActions2.default.jwtTokenSignIn(nextState.params.token);
	      _UserActions2.default.loadCurrentUser(nextState.params.token).then(function () {
	        var payload = _jsonwebtoken2.default.decode(_CurrentUser2.default.getToken());
	        return _ChatActions2.default.loadChat(payload.chat_uuid);
	      }, function () {
	        _ErrorActions2.default.expiredToken();
	        replaceWith('/error');
	        callback();
	      }).then(function () {
	        callback();
	      }, function () {
	        replaceWith('/error');
	        callback();
	      });
	    }
	  },
	
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  getStateFromStores: function getStateFromStores() {
	    var payload = _CurrentUser2.default.getToken() && _jsonwebtoken2.default.decode(_CurrentUser2.default.getToken());
	    var chat = payload && _ChatStore2.default.getChat(payload.chat_uuid);
	
	    if (!chat) {
	      return {};
	    }
	
	    return { chat: chat };
	  },
	  handleLeaveButtonClick: function handleLeaveButtonClick() {
	    _ChatActions2.default.leaveChat(this.state.chat);
	  },
	  renderConfirmation: function renderConfirmation() {
	    var title = 'Leave this conversation?';
	
	    var subtext = 'You won’t receive new messages in this conversation.';
	
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        size: 'xsmall',
	        title: title,
	        subtext: subtext,
	        glyph: 'caution',
	        glyphColor: 'lava' },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            onClick: this.handleLeaveButtonClick,
	            level: 'primary' },
	          'Yes, leave this conversation'
	        )
	      )
	    );
	  },
	  renderLeftMessage: function renderLeftMessage() {
	    var title = 'You left this conversation. If you’d like to re-join, please ask your teacher to add you ' + 'back.';
	    var subtext = 'You can now close this browser.';
	
	    return _react2.default.createElement(_DialogContent2.default, {
	      size: 'small',
	      title: title,
	      subtext: subtext
	    });
	  },
	  render: function render() {
	    if (!this.state.chat) {
	      return null;
	    } else if (this.state.chat.canLeave()) {
	      return this.renderConfirmation();
	    } else {
	      return this.renderLeftMessage();
	    }
	  }
	});
	
	exports.default = LeaveChatView;

/***/ },
/* 2812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18n = __webpack_require__(1018);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _Copy = __webpack_require__(1461);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _DialogButton = __webpack_require__(1327);
	
	var _DialogButton2 = _interopRequireDefault(_DialogButton);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _UnsubscribeActions = __webpack_require__(2813);
	
	var _UnsubscribeActions2 = _interopRequireDefault(_UnsubscribeActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketingEmailUnsubscribeView = function (_React$Component) {
	  _inherits(MarketingEmailUnsubscribeView, _React$Component);
	
	  function MarketingEmailUnsubscribeView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MarketingEmailUnsubscribeView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MarketingEmailUnsubscribeView.__proto__ || Object.getPrototypeOf(MarketingEmailUnsubscribeView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      disabled: true,
	      error: false,
	      // $FlowFixMe
	      unsubscribe: null,
	      unsubscribeError: null,
	      concluded: false
	    }, _this.handleUnsubscribeButtonClick = function () {
	      _this.setState({
	        disabled: true
	      });
	
	      if (!_this.state.unsubscribe) {
	        console.error('missing unsubscribe entity');
	        return;
	      }
	
	      _UnsubscribeActions2.default.unsubscribe(_this.state.unsubscribe).then(function () {
	        _this.setState({
	          concluded: true
	        });
	      }, function (response) {
	        _this.setState({
	          concluded: true,
	          unsubscribeError: response.error
	        });
	      });
	    }, _this.renderConclusion = function () {
	      var title = _i18n2.default.getText('You are now unsubscribed.');
	      var glyph = 'check';
	      var color = 'shamrock';
	      if (_this.state.unsubscribeError) {
	        title = _this.state.unsubscribeError;
	        glyph = 'caution';
	        color = 'lava';
	      }
	      return _react2.default.createElement(_DialogContent2.default, {
	        size: 'small',
	        title: title,
	        glyph: glyph,
	        glyphColor: color
	      });
	    }, _this.renderConfirmation = function () {
	      var title = void 0;
	      if (_this.state.unsubscribe) {
	        // Maybe in the future put another message for when a person is already unsubscribed
	        title = _i18n2.default.getText('Are you sure you want to unsubscribe from Remind marketing emails?');
	      } else {
	        title = _this.state.error;
	      }
	
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          size: 'small',
	          title: title,
	          glyph: 'caution',
	          glyphColor: 'lava' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _this.state.unsubscribe && _react2.default.createElement(
	            _Copy2.default,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'We understand\u2014your inbox can get busy. Click on the button below to stop receiving marketing emails from Remind at ',
	              _this.state.unsubscribe.getEmail(),
	              '. You\u2019ll still receive messages from any classes you belong to.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'If you\u2019d like to edit your contact information, change your notification preferences, or download the Remind app,',
	              ' ',
	              _react2.default.createElement(
	                _Link2.default,
	                { to: '/settings/notifications' },
	                'visit your account'
	              ),
	              ' ',
	              'instead.'
	            )
	          ),
	          _react2.default.createElement(
	            _DialogButton2.default,
	            {
	              onClick: _this.handleUnsubscribeButtonClick,
	              disabled: _this.state.disabled,
	              level: 'primary' },
	            _i18n2.default.getText('Unsubscribe')
	          )
	        ),
	        _react2.default.createElement(
	          _BoxFooter2.default,
	          null,
	          'Click ',
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/settings/notifications' },
	            'here'
	          ),
	          ' to edit message preferences'
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MarketingEmailUnsubscribeView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var onSuccess = function onSuccess(unsubscribe) {
	        _this2.setState({
	          disabled: false,
	          unsubscribe: unsubscribe
	        });
	      };
	      var onError = function onError(response) {
	        _this2.setState({
	          error: response.error
	        });
	      };
	      _UnsubscribeActions2.default.confirm(this.props.params.token).then(onSuccess, onError);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.concluded) {
	        return this.renderConclusion();
	      } else {
	        return this.renderConfirmation();
	      }
	    }
	  }]);
	
	  return MarketingEmailUnsubscribeView;
	}(_react2.default.Component);
	
	MarketingEmailUnsubscribeView.displayName = 'MarketingEmailUnsubscribeView';
	exports.default = MarketingEmailUnsubscribeView;

/***/ },
/* 2813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Unsubscribe = __webpack_require__(2814);
	
	var _Unsubscribe2 = _interopRequireDefault(_Unsubscribe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnsubscribeActions = {
	  confirm: function confirm(token) {
	    return new _Unsubscribe2.default({ token: token }).fetch({ data: { token: token } });
	  },
	  unsubscribe: function unsubscribe(emailSubscription) {
	    return emailSubscription.unsubscribe();
	  }
	};
	exports.default = UnsubscribeActions;

/***/ },
/* 2814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Unsubscribe = function (_Entity) {
	  _inherits(Unsubscribe, _Entity);
	
	  function Unsubscribe() {
	    _classCallCheck(this, Unsubscribe);
	
	    return _possibleConstructorReturn(this, (Unsubscribe.__proto__ || Object.getPrototypeOf(Unsubscribe)).apply(this, arguments));
	  }
	
	  _createClass(Unsubscribe, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.url = '/email_unsubscribe';
	    }
	  }, {
	    key: 'getEmail',
	    value: function getEmail() {
	      return this.get('email');
	    }
	  }, {
	    key: 'getToken',
	    value: function getToken() {
	      return this.get('token');
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      return this.get('options');
	    }
	  }, {
	    key: 'unsubscribe',
	    value: function unsubscribe() {
	      return this.sync('POST', this, { data: { token: this.getToken() } });
	    }
	  }]);
	
	  return Unsubscribe;
	}(_Entity3.default);
	
	Unsubscribe.displayName = 'Unsubscribe';
	exports.default = Unsubscribe;

/***/ },
/* 2815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(2816);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _HeaderLight = __webpack_require__(2827);
	
	var _HeaderLight2 = _interopRequireDefault(_HeaderLight);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _MarketingLayout = __webpack_require__(2832);
	
	var _MarketingLayout2 = _interopRequireDefault(_MarketingLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	// typecheck: ignore file
	
	
	function MarketingLayout(props) {
	  var headerStyles = (0, _classnames2.default)(_MarketingLayout2.default.header, _defineProperty({}, _MarketingLayout2.default.headerBorder, !props.borderless));
	
	  return _react2.default.createElement(
	    'div',
	    { className: _MarketingLayout2.default.this },
	    _react2.default.createElement(
	      'div',
	      { className: _MarketingLayout2.default.headerContainer },
	      _react2.default.createElement(
	        'div',
	        { className: headerStyles },
	        props.light ? _react2.default.createElement(_HeaderLight2.default, { 'data-test': 'header-light', location: props.location }) : _react2.default.createElement(_Header2.default, { 'data-test': 'header', location: props.location })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _MarketingLayout2.default.content },
	      _react2.default.createElement(
	        'div',
	        { className: _MarketingLayout2.default.container },
	        props.children
	      )
	    )
	  );
	}
	
	exports.default = MarketingLayout;

/***/ },
/* 2816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(956);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DriveBy = __webpack_require__(2817);
	
	var _DriveBy2 = _interopRequireDefault(_DriveBy);
	
	var _Electron = __webpack_require__(1104);
	
	var _Electron2 = _interopRequireDefault(_Electron);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _getPropClasses = __webpack_require__(1135);
	
	var _getGooglePlayLink = __webpack_require__(2171);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _List = __webpack_require__(1281);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _SupportDialog = __webpack_require__(2363);
	
	var _SupportDialog2 = _interopRequireDefault(_SupportDialog);
	
	var _currentUserAgent = __webpack_require__(1160);
	
	var _currentUserAgent2 = _interopRequireDefault(_currentUserAgent);
	
	__webpack_require__(2824);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Header);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.handleDriveBy = function () {
	      return new _DriveBy2.default(_reactDom2.default.findDOMNode(_this));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Header, [{
	    key: 'renderAuthenticatedNavigation',
	    value: function renderAuthenticatedNavigation() {
	      return _react2.default.createElement(
	        'nav',
	        { className: 'Header-navigation' },
	        this.renderHelpButton()
	      );
	    }
	  }, {
	    key: 'renderHelpButton',
	    value: function renderHelpButton() {
	      return _react2.default.createElement(
	        _List2.default,
	        { className: 'Header-secondaryNav', horizontal: true },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_SupportDialog2.default, null) },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                level: 'text',
	                tooltip: 'Help',
	                tooltipPlacement: 'bottom' },
	              _react2.default.createElement(_Glyph2.default, { name: 'help', solo: true })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderBrand',
	    value: function renderBrand() {
	      var props = {
	        className: 'Header-brandLink',
	        onDragEnd: this.handleDriveBy
	      };
	
	      var router = this.context.router;
	
	      if (router.isActive('/setup')) {
	        return _react2.default.createElement(
	          'div',
	          props,
	          'Remind'
	        );
	      }
	
	      if (this.state.user) {
	        return _react2.default.createElement(
	          _Link2.default,
	          _extends({}, props, { to: '/classes' }),
	          'Remind'
	        );
	      } else {
	        return _react2.default.createElement(
	          _Link2.default,
	          _extends({}, props, {
	            href: _LinkConstants2.default.MARKETING,
	            target: _Electron2.default.isAvailable() ? '_blank' : null }),
	          'Remind'
	        );
	      }
	    }
	  }, {
	    key: 'renderMobileNavigation',
	    value: function renderMobileNavigation() {
	      var link = _currentUserAgent2.default.android() ? (0, _getGooglePlayLink.getGooglePlayShortLink)() : _LinkConstants2.default.APP_DOWNLOAD;
	
	      return _react2.default.createElement(
	        'nav',
	        { className: 'Header-navigation' },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'Header-button',
	            href: link,
	            size: 'small',
	            eventElementName: 'Header-button' },
	          'Get the app'
	        )
	      );
	    }
	  }, {
	    key: 'renderNavigation',
	    value: function renderNavigation() {
	      if (this.state.user) {
	        if (_currentUserAgent2.default.phone()) {
	          return this.renderMobileNavigation();
	        } else {
	          return this.renderAuthenticatedNavigation();
	        }
	      } else {
	        return this.renderUnauthenticatedNavigation();
	      }
	    }
	  }, {
	    key: 'renderUnauthenticatedNavigation',
	    value: function renderUnauthenticatedNavigation() {
	      var router = this.context.router;
	
	      // redirect here on authentication, unless here is the "Sign Out" page
	
	      var skipRedirect = router.isActive('/log_in') || router.isActive('/log_out') || router.isActive('/forgot_password') || router.isActive('/reset_password') || router.isActive('/confirm_email') || router.isActive('/send_the_app') || router.isActive('/share_remind');
	
	      var query = skipRedirect ? null : Object.assign({ locationOnAuth: this.props.location.pathname }, this.props.location.query);
	
	      var signupTarget = _Electron2.default.isAvailable() ? '_blank' : null;
	
	      // FIXME observe locationOnAuth query in "Sign up" case too.
	      // Right now it requires `href` because it's in MARKETING, which has no locationOnAuth.
	      var conditionalProps = router.isActive('/log_in') ? { children: 'Sign up', href: _LinkConstants2.default.SIGN_UP, target: signupTarget } : { children: 'Log in', to: { pathname: '/log_in', query: query } };
	
	      return _react2.default.createElement(
	        'nav',
	        { className: 'Header-navigation' },
	        router.isActive('/log_in') && this.renderHelpButton(),
	        _react2.default.createElement(_Button2.default, _extends({
	          className: 'Header-button',
	          size: 'small'
	        }, conditionalProps, {
	          eventElementName: 'Header-button'
	        }))
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'header',
	        {
	          className: (0, _classnames2.default)('Header', (0, _getPropClasses.getPropClassesFromInstance)(this), this.props.className) },
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'right' },
	          this.renderBrand(),
	          this.props.showNavigation ? this.renderNavigation() : null
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        user: _CurrentUser2.default.isSignedIn() ? _CurrentUser2.default.getUser() : null
	      };
	    }
	  }]);
	
	  return Header;
	}(_react2.default.Component);
	
	Header.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	Header.defaultProps = {
	  showNavigation: true
	};
	Header.displayName = 'Header';
	exports.default = _utils.Container.create(Header);

/***/ },
/* 2817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _currentUserAgent = __webpack_require__(1160);
	
	var _currentUserAgent2 = _interopRequireDefault(_currentUserAgent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CanvasImage = function () {
	  function CanvasImage(ctx, src) {
	    var _this = this;
	
	    _classCallCheck(this, CanvasImage);
	
	    this.ctx = ctx;
	
	    this.img = document.createElement('img');
	    this.img.onload = function () {
	      _this.loaded = true;
	    };
	    this.img.src = src;
	  }
	
	  _createClass(CanvasImage, [{
	    key: 'update',
	    value: function update() {
	      this.x += this.vx;
	      this.y += this.vy;
	    }
	  }, {
	    key: 'draw',
	    value: function draw() {
	      this.ctx.save();
	      this.ctx.translate(this.x, this.y);
	      if (this.a) {
	        // Rotate about the origin of the object
	        this.ctx.translate(this.w / 2, this.h / 2);
	        this.ctx.rotate(Math.PI / 180 * this.a);
	        this.ctx.translate(-this.w / 2, -this.h / 2);
	      }
	      if (this.loaded) {
	        this.ctx.drawImage(this.img, 0, 0, this.w, this.h);
	      }
	      this.ctx.restore();
	    }
	  }], [{
	    key: 'createTiles',
	    value: function createTiles(tiles, ctx) {
	      var _this2 = this;
	
	      var objs = [];
	
	      tiles.forEach(function (tile) {
	        var obj = new _this2(ctx);
	        obj.x += tile.left * obj.w - tile.left;
	        obj.y += tile.top * obj.h - tile.top;
	        objs.push(obj);
	      });
	
	      return objs;
	    }
	  }]);
	
	  return CanvasImage;
	}();
	
	CanvasImage.displayName = 'CanvasImage';
	
	var SmallClouds = function (_CanvasImage) {
	  _inherits(SmallClouds, _CanvasImage);
	
	  function SmallClouds(ctx) {
	    _classCallCheck(this, SmallClouds);
	
	    var _this3 = _possibleConstructorReturn(this, (SmallClouds.__proto__ || Object.getPrototypeOf(SmallClouds)).call(this, ctx, __webpack_require__(2818)));
	
	    _this3.x = 0;
	    _this3.y = 0;
	    _this3.w = 916;
	    _this3.h = ctx.canvas.height;
	    _this3.vx = -0.25;
	    _this3.vy = 0;
	    return _this3;
	  }
	
	  return SmallClouds;
	}(CanvasImage);
	
	SmallClouds.displayName = 'SmallClouds';
	
	var BigClouds = function (_CanvasImage2) {
	  _inherits(BigClouds, _CanvasImage2);
	
	  function BigClouds(ctx) {
	    _classCallCheck(this, BigClouds);
	
	    var _this4 = _possibleConstructorReturn(this, (BigClouds.__proto__ || Object.getPrototypeOf(BigClouds)).call(this, ctx, __webpack_require__(2819)));
	
	    _this4.x = 0;
	    _this4.y = 0;
	    _this4.w = 916;
	    _this4.h = ctx.canvas.height;
	    _this4.vx = -0.5;
	    _this4.vy = 0;
	    return _this4;
	  }
	
	  return BigClouds;
	}(CanvasImage);
	
	BigClouds.displayName = 'BigClouds';
	
	var SmallTrees = function (_CanvasImage3) {
	  _inherits(SmallTrees, _CanvasImage3);
	
	  function SmallTrees(ctx) {
	    _classCallCheck(this, SmallTrees);
	
	    var _this5 = _possibleConstructorReturn(this, (SmallTrees.__proto__ || Object.getPrototypeOf(SmallTrees)).call(this, ctx, __webpack_require__(2820)));
	
	    _this5.x = 0;
	    _this5.y = 0;
	    _this5.w = 916;
	    _this5.h = ctx.canvas.height;
	    _this5.vx = -1;
	    _this5.vy = 0;
	    return _this5;
	  }
	
	  return SmallTrees;
	}(CanvasImage);
	
	SmallTrees.displayName = 'SmallTrees';
	
	var BigTrees = function (_CanvasImage4) {
	  _inherits(BigTrees, _CanvasImage4);
	
	  function BigTrees(ctx) {
	    _classCallCheck(this, BigTrees);
	
	    var _this6 = _possibleConstructorReturn(this, (BigTrees.__proto__ || Object.getPrototypeOf(BigTrees)).call(this, ctx, __webpack_require__(2821)));
	
	    _this6.x = 0;
	    _this6.y = 0;
	    _this6.w = 916;
	    _this6.h = ctx.canvas.height;
	    _this6.vx = -2;
	    _this6.vy = 0;
	    return _this6;
	  }
	
	  return BigTrees;
	}(CanvasImage);
	
	BigTrees.displayName = 'BigTrees';
	
	var Bus = function (_CanvasImage5) {
	  _inherits(Bus, _CanvasImage5);
	
	  function Bus(ctx) {
	    _classCallCheck(this, Bus);
	
	    var _this7 = _possibleConstructorReturn(this, (Bus.__proto__ || Object.getPrototypeOf(Bus)).call(this, ctx, __webpack_require__(2822)));
	
	    _this7.x = -106;
	    _this7.y = 15;
	    _this7.w = 106;
	    _this7.h = 35;
	    _this7.vx = 4;
	    _this7.vy = 0;
	    return _this7;
	  }
	
	  _createClass(Bus, [{
	    key: 'update',
	    value: function update() {
	      this.vx += Math.log(Math.abs((this.x + this.w / 2) / this.ctx.canvas.width) + 1) / 4;
	      this.a = Math.sin(this.x / 20);
	
	      _get(Bus.prototype.__proto__ || Object.getPrototypeOf(Bus.prototype), 'update', this).call(this);
	    }
	  }]);
	
	  return Bus;
	}(CanvasImage);
	
	Bus.displayName = 'Bus';
	
	var Wheels = function (_CanvasImage6) {
	  _inherits(Wheels, _CanvasImage6);
	
	  function Wheels(ctx) {
	    _classCallCheck(this, Wheels);
	
	    var _this8 = _possibleConstructorReturn(this, (Wheels.__proto__ || Object.getPrototypeOf(Wheels)).call(this, ctx, __webpack_require__(2823)));
	
	    _this8.x = -92;
	    _this8.y = 44;
	    _this8.w = 82;
	    _this8.h = 12;
	    _this8.vx = 4;
	    _this8.vy = 0;
	    return _this8;
	  }
	
	  _createClass(Wheels, [{
	    key: 'update',
	    value: function update() {
	      this.vx += Math.log(Math.abs((this.x + this.w / 2) / this.ctx.canvas.width) + 1) / 4;
	
	      _get(Wheels.prototype.__proto__ || Object.getPrototypeOf(Wheels.prototype), 'update', this).call(this);
	    }
	  }]);
	
	  return Wheels;
	}(CanvasImage);
	
	Wheels.displayName = 'Wheels';
	
	var DriveBy = function () {
	  function DriveBy(parent) {
	    _classCallCheck(this, DriveBy);
	
	    this.canvas = document.createElement('canvas');
	    if (!this.canvas.getContext || _currentUserAgent2.default.ie() || _currentUserAgent2.default.firefox()) {
	      return;
	    }
	
	    this.ctx = this.canvas.getContext('2d');
	    this.parent = parent;
	
	    this.canvas.style.position = 'absolute';
	    this.canvas.style.left = '0';
	    this.canvas.style.top = '0';
	    this.canvas.width = this.parent.offsetWidth;
	    this.canvas.height = this.parent.offsetHeight;
	    this.canvas.style.background = '#e5edee';
	    this.canvas.style.webkitAnimation = 'driveby 5s ease infinite';
	    this.canvas.style.animation = 'driveby 5s ease infinite';
	    this.canvas.style.zIndex = '102';
	
	    _EventTracking2.default.view('DriveBy');
	    this._start();
	  }
	
	  _createClass(DriveBy, [{
	    key: '_start',
	    value: function _start() {
	      var _drawings,
	          _drawings2,
	          _drawings3,
	          _drawings4,
	          _this9 = this;
	
	      this.parent.appendChild(this.canvas);
	
	      this.drawings = [];
	      var tiles = [{ left: 0, top: 0 }, { left: 1, top: 0 }, { left: 2, top: 0 }, { left: 3, top: 0 }];
	
	      (_drawings = this.drawings).push.apply(_drawings, _toConsumableArray(SmallClouds.createTiles(tiles, this.ctx)));
	      (_drawings2 = this.drawings).push.apply(_drawings2, _toConsumableArray(BigClouds.createTiles(tiles, this.ctx)));
	      (_drawings3 = this.drawings).push.apply(_drawings3, _toConsumableArray(SmallTrees.createTiles(tiles, this.ctx)));
	      (_drawings4 = this.drawings).push.apply(_drawings4, _toConsumableArray(BigTrees.createTiles(tiles, this.ctx)));
	      this.drawings.push(this.bus = new Bus(this.ctx));
	      this.drawings.push(new Wheels(this.ctx));
	
	      this._loop();
	
	      // Incase the bus doesn't make it to the other side...
	      setTimeout(function () {
	        return _this9._stop();
	      }, 10000);
	    }
	  }, {
	    key: '_update',
	    value: function _update() {
	      this.canvas.width = this.parent.offsetWidth;
	
	      this.drawings.forEach(function (drawing) {
	        return drawing.update();
	      });
	    }
	  }, {
	    key: '_draw',
	    value: function _draw() {
	      this.drawings.forEach(function (drawing) {
	        return drawing.draw();
	      });
	    }
	  }, {
	    key: '_loop',
	    value: function _loop() {
	      var _this10 = this;
	
	      if (!this.canvas || this.bus.x > this.canvas.width) {
	        return this._stop();
	      }
	
	      this._update();
	      this._draw();
	
	      window.requestAnimationFrame(function () {
	        return _this10._loop();
	      }, 1000 / 60);
	    }
	  }, {
	    key: '_stop',
	    value: function _stop() {
	      if (this.canvas) {
	        this.parent.removeChild(this.canvas);
	      }
	
	      this.canvas = null;
	    }
	  }]);
	
	  return DriveBy;
	}();
	
	DriveBy.displayName = 'DriveBy';
	exports.default = DriveBy;

/***/ },
/* 2818 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2819 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2820 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2821 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2822 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2823 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xNDQgMTIxIDE2NSAyMyIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAtMTQ0IDEyMSAxNjUgMjMiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDEpIj48cGF0aCBmaWxsPSIjMWExOTE4IiBkPSJtLTEyMS45IDEzMS45YzAgNi4xLTUgMTEuMS0xMS4xIDExLjEtNi4xIDAtMTEuMS01LTExLjEtMTEuMSAwLTYuMSA1LTExLjEgMTEuMS0xMS4xIDYuMS0uMSAxMS4xIDQuOSAxMS4xIDExLjEiIGlkPSIwIi8+PHBhdGggZmlsbD0iIzRkNGQ0YyIgZD0ibS0xMjguNyAxMzEuOWMwIDIuNC0xLjkgNC4zLTQuMyA0LjMtMi40IDAtNC4zLTEuOS00LjMtNC4zIDAtMi40IDEuOS00LjMgNC4zLTQuMyAyLjMtLjEgNC4zIDEuOSA0LjMgNC4zIiBpZD0iMSIvPjwvZz48Zz48dXNlIHhsaW5rOmhyZWY9IiMwIi8+PHVzZSB4bGluazpocmVmPSIjMSIvPjwvZz48L2c+PC9zdmc+"

/***/ },
/* 2824 */
1136,
/* 2825 */,
/* 2826 */,
/* 2827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _SignInModal = __webpack_require__(2828);
	
	var _SignInModal2 = _interopRequireDefault(_SignInModal);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _modal = __webpack_require__(1188);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	__webpack_require__(2829);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var HeaderLight = function (_React$Component) {
	  _inherits(HeaderLight, _React$Component);
	
	  function HeaderLight() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HeaderLight);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderLight.__proto__ || Object.getPrototypeOf(HeaderLight)).call.apply(_ref, [this].concat(args))), _this), _this.onLogin = function () {
	      if (_this.props.onLogin) {
	        _this.props.onLogin();
	      } else {
	        (0, _modal.mountModal)(_react2.default.createElement(_SignInModal2.default, null), _this);
	      }
	    }, _this.onLogout = function () {
	      if (_this.props.onLogout) {
	        _this.props.onLogout();
	      } else {
	        _AuthActions2.default.signOut();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(HeaderLight, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hideLogout = _props.hideLogout,
	          hideLogin = _props.hideLogin;
	      var user = this.state.user;
	
	
	      var logoutGlyphMenu = _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          layer: _react2.default.createElement(
	            _Menu2.default,
	            null,
	            _react2.default.createElement(
	              _MenuItem2.default,
	              { onClick: this.onLogout },
	              _react2.default.createElement(_Glyph2.default, { name: 'sign-out' }),
	              ' Log Out'
	            )
	          ),
	          placement: 'bottom',
	          trigger: 'click' },
	        _react2.default.createElement(_Glyph2.default, { className: 'HeaderLight-info-glyph', name: 'chevron-down', color: 'thunder' })
	      );
	
	      return _react2.default.createElement(
	        'header',
	        { className: 'HeaderLight' },
	        _react2.default.createElement(
	          'div',
	          { className: 'HeaderLight-brand' },
	          'Remind'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'HeaderLight-info' },
	          _react2.default.createElement(
	            _Text2.default,
	            { color: 'thunder' },
	            this.state.user && this.state.user.getEmail()
	          ),
	          user && !hideLogout && logoutGlyphMenu,
	          !user && !hideLogin && _react2.default.createElement(
	            _Button2.default,
	            { level: 'secondary', color: 'thunder', size: 'xsmall', onClick: this.onLogin },
	            'Log in'
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        user: _CurrentUser2.default.isSignedIn() ? _CurrentUser2.default.getUser() : undefined
	      };
	    }
	  }]);
	
	  return HeaderLight;
	}(_react2.default.Component);
	
	HeaderLight.displayName = 'HeaderLight';
	exports.default = _utils.Container.create(HeaderLight);

/***/ },
/* 2828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _SignInForm = __webpack_require__(1702);
	
	var _SignInForm2 = _interopRequireDefault(_SignInForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignInModal = _react2.default.createClass({
	  displayName: 'SignInModal',
	  getDefaultProps: function getDefaultProps() {
	    return {
	      email: '',
	      onSignedIn: function onSignedIn() {},
	      onRequestHide: function onRequestHide() {}
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    _CurrentUser2.default.addSignInListener(this.onSignedIn);
	    _CurrentUser2.default.addSignInNoRoleListener(this.onSignedIn);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    _CurrentUser2.default.removeSignInListener(this.onSignedIn);
	    _CurrentUser2.default.removeSignInNoRoleListener(this.onSignedIn);
	  },
	  onSignedIn: function onSignedIn() {
	    // $FlowIssue
	    this.props.onSignedIn();
	    // $FlowIssue
	    this.props.onRequestHide();
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _Dialog2.default,
	      _extends({
	        eventScreenName: 'SignInModal'
	      }, this.props, {
	        size: 'small',
	        className: 'SignInModal' }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(_SignInForm2.default, { uid: this.props.email })
	      )
	    );
	  }
	});
	
	exports.default = SignInModal;

/***/ },
/* 2829 */
1136,
/* 2830 */,
/* 2831 */,
/* 2832 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"this":"MarketingLayout__this___10puQ","headerContainer":"MarketingLayout__headerContainer___3P382","content":"MarketingLayout__content___1xFew","header":"MarketingLayout__header___33upT","headerBorder":"MarketingLayout__headerBorder___3JO1C","container":"MarketingLayout__container___glpqw"};

/***/ },
/* 2833 */,
/* 2834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MessageView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _GroupMessageBase = __webpack_require__(1253);
	
	var _GroupMessageBase2 = _interopRequireDefault(_GroupMessageBase);
	
	var _GroupMessageHeader = __webpack_require__(1305);
	
	var _GroupMessageHeader2 = _interopRequireDefault(_GroupMessageHeader);
	
	var _GroupMessageContent = __webpack_require__(1256);
	
	var _GroupMessageContent2 = _interopRequireDefault(_GroupMessageContent);
	
	var _GroupMessageInformation = __webpack_require__(1646);
	
	var _GroupMessageInformation2 = _interopRequireDefault(_GroupMessageInformation);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Message = __webpack_require__(930);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2835);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// GroupMessageHeader has to precede GroupMessageContent
	// https://remind.slack.com/archives/frontend/p1461709761000230
	
	
	var DownloadLink = function DownloadLink(_ref) {
	  var file = _ref.file;
	  return _react2.default.createElement(
	    _Link2.default,
	    {
	      className: 'MessageView-downloadLink',
	      href: file.getUrls().cdn,
	      download: true,
	      eventElementName: 'MessageView-downloadLink' },
	    _react2.default.createElement(
	      _Button2.default,
	      {
	        type: 'submit',
	        level: 'primary',
	        full: true },
	      'Download'
	    )
	  );
	};
	
	var MessageView = exports.MessageView = function (_React$Component) {
	  _inherits(MessageView, _React$Component);
	
	  function MessageView() {
	    _classCallCheck(this, MessageView);
	
	    return _possibleConstructorReturn(this, (MessageView.__proto__ || Object.getPrototypeOf(MessageView)).apply(this, arguments));
	  }
	
	  _createClass(MessageView, [{
	    key: 'render',
	    value: function render() {
	      var message = this.props.message;
	
	      var file = message.getFile();
	      var sender = message.getSender();
	
	      return _react2.default.createElement(
	        _GroupMessageBase2.default,
	        { message: message },
	        _react2.default.createElement(_GroupMessageHeader2.default, {
	          author: sender.getName(),
	          initials: sender.getInitials(),
	          color: sender.getColor(),
	          senderId: sender.id
	        }),
	        _react2.default.createElement(_GroupMessageContent2.default, null),
	        _react2.default.createElement(_GroupMessageInformation2.default, null),
	        file && _react2.default.createElement(DownloadLink, { file: file })
	      );
	    }
	  }]);
	
	  return MessageView;
	}(_react2.default.Component);
	
	MessageView.displayName = 'MessageView';
	exports.default = MessageView;

/***/ },
/* 2835 */
1136,
/* 2836 */,
/* 2837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _SupportDialog = __webpack_require__(2363);
	
	var _SupportDialog2 = _interopRequireDefault(_SupportDialog);
	
	var _documentTitle = __webpack_require__(1713);
	
	__webpack_require__(2838);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotFoundPage = function (_React$Component) {
	  _inherits(NotFoundPage, _React$Component);
	
	  function NotFoundPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NotFoundPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotFoundPage.__proto__ || Object.getPrototypeOf(NotFoundPage)).call.apply(_ref, [this].concat(args))), _this), _this.goBack = function () {
	      if (!_this.context.router) {
	        // We aren't in a Route Handler, so use browser API to relocate
	        window.location.replace('/classes');
	        return;
	      }
	
	      if (window.history.length > 1) {
	        _this.context.router.goBack();
	      } else {
	        _this.context.router.replace('/');
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NotFoundPage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'NotFoundPage' },
	        _react2.default.createElement(
	          'div',
	          { className: 'NotFoundPage-content' },
	          _react2.default.createElement(_Image2.default, {
	            className: 'NotFoundPage-image',
	            src: __webpack_require__(2799),
	            alt: 'This is embarrassing'
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'NotFoundPage-title' },
	            'Uh oh! Something went wrong.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'NotFoundPage-subtext' },
	            _react2.default.createElement(
	              _Link2.default,
	              {
	                onClick: this.goBack,
	                className: 'NotFoundPage-link',
	                eventElementName: 'NotFoundPage-link' },
	              'Go back'
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ' or '
	            ),
	            _react2.default.createElement(
	              _ModalTrigger2.default,
	              { modal: _react2.default.createElement(_SupportDialog2.default, null) },
	              _react2.default.createElement(
	                _Link2.default,
	                { className: 'NotFoundPage-link', eventElementName: 'NotFoundPage-link' },
	                'get help'
	              )
	            ),
	            '.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return NotFoundPage;
	}(_react2.default.Component);
	
	NotFoundPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	NotFoundPage.displayName = 'NotFoundPage';
	exports.default = (0, _documentTitle.withDocumentTitle)('Not found', NotFoundPage);

/***/ },
/* 2838 */
1136,
/* 2839 */,
/* 2840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(497);
	
	var _GroupsView = __webpack_require__(2736);
	
	var _GroupsView2 = _interopRequireDefault(_GroupsView);
	
	var _OrganizationContainer = __webpack_require__(2841);
	
	var _OrganizationContainer2 = _interopRequireDefault(_OrganizationContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { path: '/organizations(/)', component: _GroupsView2.default, onEnter: _GroupsView2.default.onEnter },
	  _react2.default.createElement(_reactRouter.Route, { path: ':organizationId', component: _OrganizationContainer2.default })
	);

/***/ },
/* 2841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  query {\n    user: me {\n      id\n      featureFlags {\n        web_admin_console\n      }\n    }\n  }'], ['\n  query {\n    user: me {\n      id\n      featureFlags {\n        web_admin_console\n      }\n    }\n  }']);
	
	var _Group = __webpack_require__(606);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _DistrictAdminPending = __webpack_require__(2842);
	
	var _DistrictAdminPending2 = _interopRequireDefault(_DistrictAdminPending);
	
	var _GroupView = __webpack_require__(2715);
	
	var _GroupView2 = _interopRequireDefault(_GroupView);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _JoinConfirmSubscriptionModal = __webpack_require__(2536);
	
	var _JoinConfirmSubscriptionModal2 = _interopRequireDefault(_JoinConfirmSubscriptionModal);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _modal = __webpack_require__(1188);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SchoolAdminPending = __webpack_require__(2701);
	
	var _SchoolAdminPending2 = _interopRequireDefault(_SchoolAdminPending);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _reactApollo = __webpack_require__(467);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var viewForOrganization = function viewForOrganization(organization) {
	  var type = organization.get('type');
	
	  if (type === 'School') {
	    return _SchoolAdminPending2.default;
	  } else if (type === 'District') {
	    return _DistrictAdminPending2.default;
	  }
	
	  throw new Error('Unsupported organization type ' + type);
	};
	
	var OrganizationContainer = _react2.default.createClass({
	  displayName: 'OrganizationContainer',
	
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_AffiliationStore2.default, _OrganizationStore2.default, _GroupStore2.default])],
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	  componentWillMount: function componentWillMount() {
	    this.checkForStaffClass();
	  },
	  componentDidMount: function componentDidMount() {
	    var query = this.props.location.query;
	
	    if (query && 'join' in query) {
	      (0, _modal.mountModal)(_react2.default.createElement(_JoinConfirmSubscriptionModal2.default, { code: query.join }), this);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.checkForStaffClass();
	  },
	  checkForStaffClass: function checkForStaffClass() {
	    var organizationId = parseInt(this.props.params.organizationId, 10);
	    var organization = _OrganizationStore2.default.getOrganization(organizationId);
	    var staffClass = _GroupStore2.default.getStaffClassForOrg(organizationId);
	
	    if (this.props.loading) {
	      return;
	    }
	
	    // don't redirect to staff class if it's a district
	    // because we want to preserve the current behaviour for
	    // user without the admin console ATM.
	    var preventStaffClassRedirection = !this.props.canAccessAdminConsole && (organization.getType() === 'District' || organization.getType() === 'School');
	
	    if (!staffClass || preventStaffClassRedirection) {
	      return;
	    }
	
	    var affiliation = _AffiliationStore2.default.getAffiliation(organizationId);
	    if (staffClass.getType() !== 'district' && affiliation && (0, _Affiliation.needsEmailConf)(affiliation)) {
	      this.context.router.replace('/classes/' + staffClass.getCode() + '/verify');
	    }
	
	    this.context.router.replace('/classes/' + staffClass.getCode() + '/messages');
	  },
	  render: function render() {
	    var organizationId = parseInt(this.props.params.organizationId, 10);
	    var organization = _OrganizationStore2.default.getOrganization(organizationId);
	    var affiliation = _AffiliationStore2.default.getAffiliation(organizationId);
	
	    var OrgView = viewForOrganization(organization);
	
	    return _react2.default.createElement(
	      _GroupView2.default,
	      {
	        accentColor: organization.getAccentColor() || _Group.DEFAULT_COLOR,
	        group: organization },
	      _react2.default.createElement(OrgView, { affiliation: affiliation, organization: organization })
	    );
	  }
	});
	
	var withAdminConsoleFeature = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  props: function props(_ref) {
	    var data = _ref.data;
	    return {
	      canAccessAdminConsole: data.user ? data.user.featureFlags['web_admin_console'] : undefined,
	      loading: data.loading
	    };
	  }
	});
	
	exports.default = withAdminConsoleFeature(OrganizationContainer);

/***/ },
/* 2842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _SupportDialog = __webpack_require__(2363);
	
	var _SupportDialog2 = _interopRequireDefault(_SupportDialog);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AffiliationStatus = __webpack_require__(1088);
	
	var _AffiliationStatus2 = _interopRequireDefault(_AffiliationStatus);
	
	__webpack_require__(2843);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var perks = [['Direct, reliable messaging when you need it', __webpack_require__(2845)], ['District communication in one place', __webpack_require__(2846)], ['Flexible features built for education', __webpack_require__(2847)]];
	
	var DistrictAdminPending = _react2.default.createClass({
	  displayName: 'DistrictAdminPending',
	  renderBox: function renderBox() {
	    return _react2.default.createElement(
	      _Box2.default,
	      {
	        size: 'small',
	        full: true,
	        className: 'DistrictAdminPending-Box' },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: false, size: 'small' },
	        _react2.default.createElement(
	          'ul',
	          null,
	          perks.map(function (_ref) {
	            var _ref2 = _slicedToArray(_ref, 2),
	                message = _ref2[0],
	                src = _ref2[1];
	
	            return _react2.default.createElement(
	              'li',
	              { key: src },
	              _react2.default.createElement(_Image2.default, {
	                src: src,
	                className: 'DistrictAdminPending-Box-perkImage'
	              }),
	              message
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'DistrictAdminPending-BottomText' },
	          'Questions?',
	          ' ',
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_SupportDialog2.default, null) },
	            _react2.default.createElement(
	              _Link2.default,
	              null,
	              'Contact us'
	            )
	          )
	        )
	      )
	    );
	  },
	  render: function render() {
	    var orgName = this.props.organization.getName();
	    return _react2.default.createElement(
	      'div',
	      { className: 'DistrictAdminPending' },
	      _react2.default.createElement(_AffiliationStatus2.default, {
	        title: orgName + ' is coming soon!',
	        subtext: 'We\'re working on building district support for Remind. We\'ll send you an email as soon as it\'s ready!'
	      }),
	      this.renderBox()
	    );
	  }
	});
	
	exports.default = DistrictAdminPending;

/***/ },
/* 2843 */
1136,
/* 2844 */,
/* 2845 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2846 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2847 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _CenteredContainer = __webpack_require__(2240);
	
	var _CenteredContainer2 = _interopRequireDefault(_CenteredContainer);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _DeviceStore = __webpack_require__(1019);
	
	var _DeviceStore2 = _interopRequireDefault(_DeviceStore);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _ParentalConsentOptionView = __webpack_require__(2849);
	
	var _ParentalConsentOptionView2 = _interopRequireDefault(_ParentalConsentOptionView);
	
	var _ParentalConsentOptionsView = __webpack_require__(2858);
	
	var _ParentalConsentOptionsView2 = _interopRequireDefault(_ParentalConsentOptionsView);
	
	var _View = __webpack_require__(2356);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var EVENT_SCREEN_NAME = 'vpc_flow';
	
	var ParentalConsentPage = function (_React$Component) {
	  _inherits(ParentalConsentPage, _React$Component);
	
	  _createClass(ParentalConsentPage, null, [{
	    key: 'onEnter',
	
	
	    // This has to be here in order to get a CurrentUser
	    value: function onEnter(nextState, replaceWith, callback) {
	      _AuthActions2.default.accessTokenSignIn(nextState.location.query.token).then(_DeviceActions2.default.loadDevices).then(callback).catch(callback);
	    }
	  }]);
	
	  function ParentalConsentPage(props) {
	    _classCallCheck(this, ParentalConsentPage);
	
	    var _this = _possibleConstructorReturn(this, (ParentalConsentPage.__proto__ || Object.getPrototypeOf(ParentalConsentPage)).call(this, props));
	
	    _this.setOption = function (option) {
	      _this.setState({ option: option });
	    };
	
	    _this.proceed = function () {
	      _this.context.router.push('/setup');
	    };
	
	    _this.renderBody = function () {
	      var _this$state = _this.state,
	          childId = _this$state.childId,
	          childName = _this$state.childName,
	          option = _this$state.option;
	
	
	      if (option) {
	        return _react2.default.createElement(_ParentalConsentOptionView2.default, {
	          childId: childId,
	          option: option,
	          setOption: _this.setOption,
	          onProceed: _this.proceed
	        });
	      } else {
	        return _react2.default.createElement(_ParentalConsentOptionsView2.default, {
	          childName: childName,
	          setOption: _this.setOption,
	          onProceed: _this.proceed
	        });
	      }
	    };
	
	    var query = props.location.query;
	
	
	    _this.state = {
	      childId: parseInt(query['child_id'], 10),
	      childName: query['child_name'],
	      option: _this.chooseViewOption()
	    };
	    return _this;
	  }
	
	  _createClass(ParentalConsentPage, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var referrer = this.props.location.query.referrer;
	
	
	      return {
	        eventContextName: referrer,
	        eventScreenName: EVENT_SCREEN_NAME
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _EventTracking2.default.view(EVENT_SCREEN_NAME, { uiContext: this.props.location.query.referrer });
	    }
	
	    // If there's no email associated with the current user, only show card option
	
	  }, {
	    key: 'chooseViewOption',
	    value: function chooseViewOption() {
	      var devices = _DeviceStore2.default.getDevices();
	      var option = devices.type('email').length === 0 ? 'card' : '';
	      return option;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ParentalConsentPage' },
	        _react2.default.createElement(
	          _CenteredContainer2.default,
	          null,
	          _react2.default.createElement(
	            _View2.default,
	            null,
	            this.renderBody()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ParentalConsentPage;
	}(_react2.default.Component);
	
	ParentalConsentPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ParentalConsentPage.childContextTypes = {
	  eventContextName: _react2.default.PropTypes.string,
	  eventScreenName: _react2.default.PropTypes.string
	};
	ParentalConsentPage.displayName = 'ParentalConsentPage';
	exports.default = ParentalConsentPage;

/***/ },
/* 2849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _ParentalConsentCardView = __webpack_require__(2850);
	
	var _ParentalConsentCardView2 = _interopRequireDefault(_ParentalConsentCardView);
	
	var _ParentalConsentSignatureView = __webpack_require__(2854);
	
	var _ParentalConsentSignatureView2 = _interopRequireDefault(_ParentalConsentSignatureView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ParentalConsentOptionView = function (_React$Component) {
	  _inherits(ParentalConsentOptionView, _React$Component);
	
	  function ParentalConsentOptionView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ParentalConsentOptionView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParentalConsentOptionView.__proto__ || Object.getPrototypeOf(ParentalConsentOptionView)).call.apply(_ref, [this].concat(args))), _this), _this.handleChooseDifferentOption = function () {
	      _this.props.setOption('');
	    }, _this.renderView = function () {
	      var _this$props = _this.props,
	          childId = _this$props.childId,
	          onProceed = _this$props.onProceed,
	          option = _this$props.option;
	
	
	      if (option === 'card') {
	        return _react2.default.createElement(_ParentalConsentCardView2.default, {
	          childId: childId,
	          onProceed: onProceed
	        });
	      } else {
	        return _react2.default.createElement(_ParentalConsentSignatureView2.default, {
	          childId: childId,
	          onProceed: onProceed
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ParentalConsentOptionView, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var option = this.props.option;
	
	      var differentOptionText = void 0;
	
	      if (option === 'card') {
	        differentOptionText = 'Prefer to print and sign a permission form?';
	      } else if (option === 'signature-file') {
	        differentOptionText = 'Prefer to charge a card?';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ParentalConsentOptionView' },
	        _react2.default.createElement(
	          _Container2.default,
	          { size: 'small' },
	          _react2.default.createElement(
	            _Box2.default,
	            null,
	            this.renderView(),
	            _react2.default.createElement(
	              _BoxFooter2.default,
	              null,
	              _react2.default.createElement(
	                _Button2.default,
	                { full: true, level: 'text', onClick: function onClick() {
	                    return _this2.handleChooseDifferentOption();
	                  } },
	                differentOptionText,
	                ' ',
	                'Go back'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ParentalConsentOptionView;
	}(_react2.default.Component);
	
	ParentalConsentOptionView.displayName = 'ParentalConsentOptionView';
	exports.default = ParentalConsentOptionView;

/***/ },
/* 2850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _DecoratedInput = __webpack_require__(1961);
	
	var _ParentalConsentConstants = __webpack_require__(2851);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CardInput = __webpack_require__(1964);
	
	var _CardInput2 = _interopRequireDefault(_CardInput);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _EncryptionNotice = __webpack_require__(1970);
	
	var _EncryptionNotice2 = _interopRequireDefault(_EncryptionNotice);
	
	var _FamilyActions = __webpack_require__(2852);
	
	var _FamilyActions2 = _interopRequireDefault(_FamilyActions);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ParentalConsentPersonalInfoModal = __webpack_require__(2853);
	
	var _ParentalConsentPersonalInfoModal2 = _interopRequireDefault(_ParentalConsentPersonalInfoModal);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _StripeAPI = __webpack_require__(1979);
	
	var _StripeAPI2 = _interopRequireDefault(_StripeAPI);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ParentalConsentCardView = function (_React$Component) {
	  _inherits(ParentalConsentCardView, _React$Component);
	
	  function ParentalConsentCardView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ParentalConsentCardView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParentalConsentCardView.__proto__ || Object.getPrototypeOf(ParentalConsentCardView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      card: null,
	      loadingStripeScript: true,
	      name: '',
	      nameError: false,
	      nameId: '',
	      option: '',
	      parentName: '',
	      safetyPolicy: true,
	      safetyPolicyError: false,
	      submitting: false
	    }, _this.setUserName = function () {
	      _this.setState({ name: _CurrentUser2.default.getUser().getFullName() });
	    }, _this.handleStripeScriptError = function () {
	      _ToastActions2.default.showErrorToast('\n      There was an error. Please try a different method, or email\n      ' + _LinkConstants2.default.SUPPORT_EMAIL + '\n      for help.\n    ');
	    }, _this.handleStripeScriptLoaded = function () {
	      _this.setState({ loadingStripeScript: false });
	    }, _this.handleNameBlur = function (event) {
	      // $FlowFixMe
	      var nameValid = event.target.checkValidity();
	
	      if (nameValid) {
	        _this.setState({ nameError: false });
	      } else {
	        _this.setState({ nameError: 'Card owner’s name is required' });
	      }
	    }, _this.handleNameChange = function (event) {
	      _this.setState({
	        // $FlowFixMe
	        name: event.target.value
	      });
	    }, _this.handleNameFocus = function () {
	      _this.setState({ nameError: false });
	    }, _this.handleCardInvalid = function () {
	      _this.setState({ card: null });
	    }, _this.handleCardValid = function (card) {
	      _this.setState({ card: card });
	    }, _this.handleSafetyPolicyChange = function () {
	      var value = !_this.state.safetyPolicy;
	
	      _this.setState({ safetyPolicy: value });
	
	      if (value) {
	        _this.setState({ safetyPolicyError: false });
	      } else {
	        _this.setState({ safetyPolicyError: 'Permission is required' });
	      }
	    }, _this.checkValidity = function () {
	      return _this.state.name !== '' && _this.state.card !== null && _this.state.safetyPolicy;
	    }, _this.handlePayment = function (event) {
	      event.preventDefault();
	
	      var onSuccess = function onSuccess() {
	        _ToastActions2.default.showSuccessToast('Transaction successful');
	        _this.setState({ submitting: false });
	        _this.props.onProceed();
	      };
	
	      var onError = function onError() {
	        _ToastActions2.default.showErrorToast('\n        There was an error with your transaction. Please try again or email\n        ' + _LinkConstants2.default.SUPPORT_EMAIL + '\n        for help.\n      ');
	        _this.setState({ submitting: false });
	      };
	
	      _this.setState({ submitting: true });
	
	      (0, _invariant2.default)(_this.state.card, 'ParentalConsentCardView tried to do some shit with a card but it was null!');
	
	      _StripeAPI2.default.createCardToken({
	        number: _this.state.card.number.value,
	        cvc: _this.state.card.cvc.value,
	        exp: _this.state.card.expiry.value,
	        address_zip: _this.state.card.zip.value
	      }, function (status, response) {
	        if (response.error) {
	          _ToastActions2.default.showErrorToast(response.error.message);
	        } else {
	          _FamilyActions2.default.sendConsentPayment(_this.props.childId, response.id, _this.state.name).then(onSuccess, onError);
	        }
	      });
	    }, _this.renderCardInput = function () {
	      var label = 'Debit or credit card';
	
	      if (_this.state.loadingStripeScript) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Label2.default,
	            null,
	            label
	          ),
	          _react2.default.createElement(_DecoratedInput.LoadingInput, null)
	        );
	      }
	
	      return _react2.default.createElement(_CardInput2.default, {
	        label: label,
	        placeholder: 'Enter your debit or credit card',
	        onInvalid: function onInvalid() {
	          return _this.handleCardInvalid();
	        },
	        onValid: function onValid(card) {
	          return _this.handleCardValid(card);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ParentalConsentCardView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ nameId: (0, _lodash.uniqueId)('id-') });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setUserName();
	
	      _StripeAPI2.default.setPublishableKey(_SettingsStore2.default.getStripeKey()).then(this.handleStripeScriptLoaded, this.handleStripeScriptError);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          name = _state.name,
	          nameError = _state.nameError,
	          nameId = _state.nameId,
	          safetyPolicy = _state.safetyPolicy,
	          safetyPolicyError = _state.safetyPolicyError,
	          submitting = _state.submitting;
	
	      var safetyPolicyLabel = _react2.default.createElement(
	        'span',
	        null,
	        'I\u2019ve read and understand how',
	        ' ',
	        _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: _react2.default.createElement(_ParentalConsentPersonalInfoModal2.default, null) },
	          _react2.default.createElement(
	            _Link2.default,
	            null,
	            'Remind uses personal information'
	          )
	        ),
	        '.',
	        ' ',
	        'I give my child permission to use Remind.'
	      );
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'ParentalConsentCardView' },
	        _react2.default.createElement(_BoxHeader2.default, {
	          title: 'Verify your identity with a card',
	          subtext: _ParentalConsentConstants.CONSENT_CHARGE_AMOUNT + ' will be charged to your card. We\u2019ll refund it soon!'
	        }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(
	            'form',
	            { onSubmit: function onSubmit(event) {
	                return _this2.handlePayment(event);
	              } },
	            _react2.default.createElement(
	              _Field2.default,
	              { error: nameError },
	              _react2.default.createElement(
	                _Label2.default,
	                { htmlFor: nameId },
	                'Name'
	              ),
	              _react2.default.createElement(_Input2.default, {
	                id: nameId,
	                placeholder: 'Enter your name as it appears on your card',
	                required: true,
	                value: name,
	                onBlur: function onBlur(event) {
	                  return _this2.handleNameBlur(event);
	                },
	                onChange: function onChange(event) {
	                  return _this2.handleNameChange(event);
	                },
	                onFocus: function onFocus(event) {
	                  return _this2.handleNameFocus(event);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _Field2.default,
	              null,
	              this.renderCardInput()
	            ),
	            _react2.default.createElement(
	              _Field2.default,
	              { error: safetyPolicyError },
	              _react2.default.createElement(_Checkbox2.default, {
	                label: safetyPolicyLabel,
	                defaultChecked: safetyPolicy,
	                required: true,
	                onChange: function onChange(event) {
	                  return _this2.handleSafetyPolicyChange(event);
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                type: 'submit',
	                disabled: !this.checkValidity(),
	                full: true,
	                loading: submitting },
	              'Submit'
	            ),
	            _react2.default.createElement(_EncryptionNotice2.default, null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return ParentalConsentCardView;
	}(_react2.default.Component);
	
	ParentalConsentCardView.displayName = 'ParentalConsentCardView';
	exports.default = ParentalConsentCardView;

/***/ },
/* 2851 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONSENT_CHARGE_AMOUNT = exports.CONSENT_CHARGE_AMOUNT = '$0.50';

/***/ },
/* 2852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FamilyActions = {
	  sendConsentForm: function sendConsentForm(childId) {
	    return (0, _apiRequest2.default)('/family/send_vpc_form', 'POST', {
	      child_id: childId
	    });
	  },
	  sendConsentFile: function sendConsentFile(childId, consentFileUuid) {
	    return (0, _apiRequest2.default)('/family/verify', 'POST', {
	      child_id: childId,
	      signature_file_uuid: consentFileUuid
	    });
	  },
	  sendConsentPayment: function sendConsentPayment(childId, token, cardOwnerName) {
	    return (0, _apiRequest2.default)('/family/verify', 'POST', {
	      child_id: childId,
	      charge: {
	        token: token,
	        cardowner_name: cardOwnerName
	      }
	    });
	  }
	};
	exports.default = FamilyActions;

/***/ },
/* 2853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxTitle = __webpack_require__(1508);
	
	var _BoxTitle2 = _interopRequireDefault(_BoxTitle);
	
	var _Copy = __webpack_require__(1461);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ParentalConsentSafetyModal = function (_React$Component) {
	  _inherits(ParentalConsentSafetyModal, _React$Component);
	
	  function ParentalConsentSafetyModal() {
	    _classCallCheck(this, ParentalConsentSafetyModal);
	
	    return _possibleConstructorReturn(this, (ParentalConsentSafetyModal.__proto__ || Object.getPrototypeOf(ParentalConsentSafetyModal)).apply(this, arguments));
	  }
	
	  _createClass(ParentalConsentSafetyModal, [{
	    key: 'render',
	    value: function render() {
	      var onRequestHide = this.props.onRequestHide;
	
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          eventScreenName: 'ParentalConsentSafetyModal',
	          size: 'small',
	          className: 'ParentalConsentSafetyModal',
	          onRequestHide: onRequestHide },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(_BoxTitle2.default, { title: 'Safety policy' }),
	          _react2.default.createElement(
	            _Copy2.default,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Your child\u2019s teacher is using Remind to share important school updates and announcements.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'As part of the Children\u2019s Online Privacy and Protection Act (\u201CCOPPA\u201D), your child entered your contact information because they need your permission to use Remind.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'To provide their communication service, Remind will collect your child\u2019s name, date of birth, photograph, email address, and telephone number.'
	            ),
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Remind',
	                  ' ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'will not'
	                  ),
	                  ' ',
	                  'rent or sell this information to anyone.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Other users will',
	                  ' ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'only'
	                  ),
	                  ' ',
	                  'see the name and the photograph.'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'For more information about how Remind uses personal information, please see the',
	                  ' ',
	                  _react2.default.createElement(
	                    _Link2.default,
	                    { href: _LinkConstants2.default.PRIVACY_POLICY, target: '_blank' },
	                    'Remind Privacy Policy'
	                  ),
	                  '.'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ParentalConsentSafetyModal;
	}(_react2.default.Component);
	
	ParentalConsentSafetyModal.displayName = 'ParentalConsentSafetyModal';
	exports.default = ParentalConsentSafetyModal;

/***/ },
/* 2854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxTitle = __webpack_require__(1508);
	
	var _BoxTitle2 = _interopRequireDefault(_BoxTitle);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Copy = __webpack_require__(1461);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _DropZoneModal = __webpack_require__(1501);
	
	var _DropZoneModal2 = _interopRequireDefault(_DropZoneModal);
	
	var _FamilyActions = __webpack_require__(2852);
	
	var _FamilyActions2 = _interopRequireDefault(_FamilyActions);
	
	var _File = __webpack_require__(929);
	
	var _File2 = _interopRequireDefault(_File);
	
	var _FileUploaderMixin = __webpack_require__(2082);
	
	var _FileUploaderMixin2 = _interopRequireDefault(_FileUploaderMixin);
	
	var _Heading = __webpack_require__(1436);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _Progress = __webpack_require__(1520);
	
	var _Progress2 = _interopRequireDefault(_Progress);
	
	var _Row = __webpack_require__(1482);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(2855);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// typecheck: ignore file
	var ParentalConsentSignatureView = _react2.default.createClass({
	  displayName: 'ParentalConsentSignatureView',
	
	
	  mixins: [_FileUploaderMixin2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      card: null,
	      fileUploading: false,
	      loading: true,
	      option: ''
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    _FamilyActions2.default.sendConsentForm(this.props.childId);
	  },
	  getDropzoneId: function getDropzoneId() {
	    return 'parental_consent';
	  },
	  handleResendForm: function handleResendForm() {
	    var onSuccess = function onSuccess() {
	      _ToastActions2.default.showSuccessToast('Form resent');
	    };
	
	    var onError = function onError() {
	      _ToastActions2.default.showErrorToast('\n        There was an error resending the form. Please try again or email\n        ' + _LinkConstants2.default.SUPPORT_EMAIL + '\n        for help.\n      ');
	    };
	
	    _FamilyActions2.default.sendConsentForm(this.props.childId).then(onSuccess, onError);
	  },
	  onUploadSuccess: function onUploadSuccess(file) {
	    var _this = this;
	
	    var onSuccess = function onSuccess() {
	      _ToastActions2.default.showSuccessToast('Photo upload successful');
	      _this.setState({ fileUploading: false });
	      _this.props.onProceed();
	    };
	
	    var onError = function onError() {
	      _ToastActions2.default.showErrorToast('\n        There was an error uploading your photo. Please try again or email\n        ' + _LinkConstants2.default.SUPPORT_EMAIL + '\n        for help.\n      ');
	      _this.setState({ fileUploading: false });
	    };
	
	    this.setState({ fileUploading: true });
	
	    _FamilyActions2.default.sendConsentFile(this.props.childId, file.id).then(onSuccess, onError);
	  },
	  renderDropzoneModal: function renderDropzoneModal() {
	    if (this.state.isDraggingFile) {
	      return _react2.default.createElement(_DropZoneModal2.default, {
	        title: 'Drag and drop form to upload',
	        titleDrop: 'Drop form!',
	        isFileUploaded: this.getFiles().length > 0,
	        isHovering: this.state.isDraggingFileInner
	      });
	    } else {
	      return null;
	    }
	  },
	  renderBody: function renderBody() {
	    var _this2 = this;
	
	    if (this.state.fileUploading) {
	      var percent = this.getFileData(this.getFiles()[0]).progress;
	
	      return _react2.default.createElement(
	        _Container2.default,
	        { size: 'xxsmall' },
	        _react2.default.createElement(_Progress2.default, { percent: percent, label: 'Uploading consent file' })
	      );
	    } else {
	      return _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          _BoxTitle2.default,
	          null,
	          'Print and sign a form'
	        ),
	        _react2.default.createElement(
	          _Row2.default,
	          { size: 'small' },
	          _react2.default.createElement(_Image2.default, { src: __webpack_require__(2857) })
	        ),
	        _react2.default.createElement(
	          _Row2.default,
	          { size: 'medium' },
	          _react2.default.createElement(
	            _Copy2.default,
	            null,
	            _react2.default.createElement(
	              _Heading2.default,
	              { level: '3' },
	              'Step 1: Print, read, and sign the permission form'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We sent the form to',
	              ' ',
	              _react2.default.createElement(
	                'b',
	                null,
	                _CurrentUser2.default.getUser().getEmail()
	              ),
	              '.',
	              ' ',
	              'Didn\u2019t get the email?',
	              ' ',
	              _react2.default.createElement(
	                _Link2.default,
	                { onClick: function onClick() {
	                    return _this2.handleResendForm();
	                  } },
	                'Resend'
	              )
	            ),
	            _react2.default.createElement(_Divider2.default, { size: 'medium' }),
	            _react2.default.createElement(
	              _Heading2.default,
	              { level: '3' },
	              'Step 2: Upload a photo of the signed permission form'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'The photo should include the entire form with the signature clearly visible.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { full: true, ref: 'dropzone_attach', className: 'addFileButton_' + this.getDropzoneId() },
	          'Upload'
	        ),
	        this.renderDropzoneModal()
	      );
	    }
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _BoxBody2.default,
	      { ref: 'dropzone', className: 'ParentalConsentSignatureView' },
	      this.renderBody()
	    );
	  }
	});
	
	exports.default = ParentalConsentSignatureView;

/***/ },
/* 2855 */
1136,
/* 2856 */,
/* 2857 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "8018a41151bdfd6db1803a5636cb8120.svg";

/***/ },
/* 2858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ParentalConsentConstants = __webpack_require__(2851);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxSelect = __webpack_require__(2467);
	
	var _BoxSelect2 = _interopRequireDefault(_BoxSelect);
	
	var _BoxSelectItem = __webpack_require__(2470);
	
	var _BoxSelectItem2 = _interopRequireDefault(_BoxSelectItem);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Row = __webpack_require__(1482);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ParentalConsentOptionsView = function (_React$Component) {
	  _inherits(ParentalConsentOptionsView, _React$Component);
	
	  function ParentalConsentOptionsView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ParentalConsentOptionsView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParentalConsentOptionsView.__proto__ || Object.getPrototypeOf(ParentalConsentOptionsView)).call.apply(_ref, [this].concat(args))), _this), _this.handleOptionSelect = function (option) {
	      _this.props.setOption(option);
	    }, _this.handleSkip = function () {
	      _this.props.onProceed();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ParentalConsentOptionsView, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var childName = this.props.childName;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ParentalConsentOptionsView' },
	        _react2.default.createElement(
	          _Container2.default,
	          { size: 'medium' },
	          _react2.default.createElement(_TitleHeader2.default, {
	            title: (childName || 'Your child') + ' signed up for Remind.',
	            subtext: '\n              As part of federal law, we need to confirm that\n              ' + (childName || 'your child') + '\n              has your permission to use Remind. If\n              ' + (childName || 'your child') + '\n              doesn\u2019t have permission from a parent or guardian to use Remind, their account will be deleted.\n            '
	          }),
	          _react2.default.createElement(
	            _Row2.default,
	            { size: 'small' },
	            _react2.default.createElement(
	              _BoxSelect2.default,
	              null,
	              _react2.default.createElement(
	                _BoxSelectItem2.default,
	                {
	                  glyph: 'credit-card',
	                  label: 'Use a card',
	                  className: 'ParentalConsentOptionsView-option--card',
	                  eventElementName: 'ParentalConsentOptionsView-option--card',
	                  action: function action() {
	                    return _this2.handleOptionSelect('card');
	                  } },
	                'Verify your identity with a temporary charge of',
	                ' ',
	                _ParentalConsentConstants.CONSENT_CHARGE_AMOUNT,
	                ' ',
	                'to your card.'
	              ),
	              _react2.default.createElement(
	                _BoxSelectItem2.default,
	                {
	                  glyph: 'printer',
	                  label: 'Sign a permission form',
	                  className: 'ParentalConsentOptionsView-option--signature-file',
	                  eventElementName: 'ParentalConsentOptionsView-option--signature-file',
	                  action: function action() {
	                    return _this2.handleOptionSelect('signature-file');
	                  } },
	                'Print and sign a permission form, then upload it to Remind.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            { align: 'center', element: 'div' },
	            _react2.default.createElement(
	              _Button2.default,
	              { color: 'eclipse', level: 'text', 'data-test': 'parental-consent-options-view-skip', onClick: function onClick() {
	                  return _this2.handleSkip();
	                } },
	              _react2.default.createElement(
	                _Text2.default,
	                { size: 'xsmall' },
	                'Skip for now'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ParentalConsentOptionsView;
	}(_react2.default.Component);
	
	ParentalConsentOptionsView.displayName = 'ParentalConsentOptionsView';
	exports.default = ParentalConsentOptionsView;

/***/ },
/* 2859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.libs = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _react = __webpack_require__(299);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// for mocking in tests
	var libs = exports.libs = {
	  apiRequest: _apiRequest2.default
	};
	
	var QuickLinkView = function (_Component) {
	  _inherits(QuickLinkView, _Component);
	
	  function QuickLinkView() {
	    _classCallCheck(this, QuickLinkView);
	
	    return _possibleConstructorReturn(this, (QuickLinkView.__proto__ || Object.getPrototypeOf(QuickLinkView)).apply(this, arguments));
	  }
	
	  _createClass(QuickLinkView, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'onEnter',
	    value: function onEnter(nextState, replaceWith, callback) {
	      if (!nextState.params.token) {
	        replaceWith('/not_found');
	        callback();
	      } else {
	        libs.apiRequest('/quicklink', 'POST', { token: nextState.params.token }).then(function (res) {
	          _ToastActions2.default.showSuccessToast(res.message);
	          replaceWith('/landing');
	          callback();
	        }, function (res) {
	          var message = res.message || 'Oops. That link didn’t work.';
	          _ToastActions2.default.showErrorToast(message);
	          replaceWith('/landing');
	          callback();
	        });
	      }
	    }
	  }]);
	
	  return QuickLinkView;
	}(_react.Component);
	
	QuickLinkView.displayName = 'QuickLinkView';
	exports.default = QuickLinkView;

/***/ },
/* 2860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatStore = __webpack_require__(984);
	
	var _ChatStore2 = _interopRequireDefault(_ChatStore);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ErrorActions = __webpack_require__(1427);
	
	var _ErrorActions2 = _interopRequireDefault(_ErrorActions);
	
	var _jsonwebtoken = __webpack_require__(2611);
	
	var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _ReportChatModal = __webpack_require__(2861);
	
	var _ReportChatModal2 = _interopRequireDefault(_ReportChatModal);
	
	__webpack_require__(2865);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportChatView = function (_React$Component) {
	  _inherits(ReportChatView, _React$Component);
	
	  _createClass(ReportChatView, null, [{
	    key: 'onEnter',
	    value: function onEnter(nextState, replaceWith, callback) {
	      _AuthActions2.default.jwtTokenSignIn(nextState.params.token);
	      var payload = _jsonwebtoken2.default.decode(_CurrentUser2.default.getToken());
	      if (Object.keys(payload).length > 0) {
	        _UserActions2.default.loadCurrentUser(nextState.params.token).then(function () {
	          _ChatActions2.default.loadChat(payload.chat_uuid).then(function () {
	            callback();
	          }, function () {
	            replaceWith('/error');
	            callback();
	          });
	        }, function () {
	          _ErrorActions2.default.expiredToken('REPORT_CHAT');
	          replaceWith('/error');
	          callback();
	        });
	      } else {
	        _ErrorActions2.default.unknownToken('REPORT_CHAT');
	        replaceWith('/error');
	        callback();
	      }
	    }
	
	    // $FlowFixMe
	
	  }]);
	
	  function ReportChatView(props) {
	    _classCallCheck(this, ReportChatView);
	
	    var _this = _possibleConstructorReturn(this, (ReportChatView.__proto__ || Object.getPrototypeOf(ReportChatView)).call(this, props));
	
	    var payload = _jsonwebtoken2.default.decode(_CurrentUser2.default.getToken());
	    var chat = _ChatStore2.default.getChat(payload.chat_uuid);
	    var partner = chat.getMemberships().filter(function (membership) {
	      return membership.getMember().getUuid() === payload.sender.id;
	    })[0].getMember();
	
	    _this.state = {
	      chat: chat,
	      partner: partner
	    };
	    return _this;
	  }
	
	  _createClass(ReportChatView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ReportChatView' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ReportChatView-wrap' },
	          _react2.default.createElement(_ReportChatModal2.default, {
	            className: 'ReportChatView-modal',
	            chat: this.state.chat,
	            partner: this.state.partner
	          })
	        )
	      );
	    }
	  }]);
	
	  return ReportChatView;
	}(_react2.default.Component);
	
	ReportChatView.displayName = 'ReportChatView';
	exports.default = ReportChatView;

/***/ },
/* 2861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Chat = __webpack_require__(906);
	
	var _Chat2 = _interopRequireDefault(_Chat);
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatMember = __webpack_require__(921);
	
	var _ChatMember2 = _interopRequireDefault(_ChatMember);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ReportChatModalOption = __webpack_require__(2862);
	
	var _ReportChatModalOption2 = _interopRequireDefault(_ReportChatModalOption);
	
	var _ReportChatSelectModal = __webpack_require__(2279);
	
	var _ReportChatSelectModal2 = _interopRequireDefault(_ReportChatSelectModal);
	
	__webpack_require__(2863);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportChatModal = function (_React$Component) {
	  _inherits(ReportChatModal, _React$Component);
	
	  function ReportChatModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReportChatModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReportChatModal.__proto__ || Object.getPrototypeOf(ReportChatModal)).call.apply(_ref, [this].concat(args))), _this), _this.emailTranscript = function () {
	      _ChatActions2.default.emailTranscript(_this.props.chat.id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReportChatModal, [{
	    key: 'renderEmailTranscriptOption',
	    value: function renderEmailTranscriptOption() {
	      return _react2.default.createElement(
	        _ReportChatModalOption2.default,
	        {
	          className: 'ReportChatModal-emailTranscript',
	          onClick: this.emailTranscript },
	        _react2.default.createElement(_Glyph2.default, {
	          className: 'ReportChatModal-glyph',
	          name: 'email-transcript'
	        }),
	        'Email message history'
	      );
	    }
	  }, {
	    key: 'renderReportOption',
	    value: function renderReportOption() {
	      var modal = _react2.default.createElement(_ReportChatSelectModal2.default, {
	        chat: this.props.chat,
	        partner: this.props.partner
	      });
	
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: modal },
	        _react2.default.createElement(
	          _ReportChatModalOption2.default,
	          { className: 'ReportChatModal-report' },
	          _react2.default.createElement(_Glyph2.default, { className: 'ReportChatModal-glyph', name: 'remind-icon' }),
	          'Report to Remind'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var title = _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(_Glyph2.default, { name: 'flag', size: 'medium', color: 'lava' }),
	        'Report'
	      );
	
	      var subtext = _react2.default.createElement(
	        'span',
	        null,
	        'Safety is a top priority.',
	        _react2.default.createElement('br', null),
	        'If someone is not following our ',
	        _react2.default.createElement(
	          _Link2.default,
	          { href: _LinkConstants2.default.COMMUNITY_GUIDELINES, target: '_blank' },
	          'Community Guidelines'
	        ),
	        ', you can take the following steps:'
	      );
	
	      var body = _react2.default.createElement(
	        'div',
	        { className: 'ReportChatModal-options' },
	        this.renderEmailTranscriptOption(),
	        this.renderReportOption()
	      );
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'ReportChatModal'
	        }, this.props, {
	          hideCloseButton: true,
	          className: (0, _classnames2.default)('ReportChatModal', this.props.className),
	          title: title,
	          subtext: subtext }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { full: true },
	          body
	        )
	      );
	    }
	  }]);
	
	  return ReportChatModal;
	}(_react2.default.Component);
	
	ReportChatModal.displayName = 'ReportChatModal';
	exports.default = ReportChatModal;

/***/ },
/* 2862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReportChatModalOption = function (_React$Component) {
	  _inherits(ReportChatModalOption, _React$Component);
	
	  function ReportChatModalOption() {
	    _classCallCheck(this, ReportChatModalOption);
	
	    return _possibleConstructorReturn(this, (ReportChatModalOption.__proto__ || Object.getPrototypeOf(ReportChatModalOption)).apply(this, arguments));
	  }
	
	  _createClass(ReportChatModalOption, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Link2.default,
	        _extends({}, this.props, {
	          bar: true,
	          color: 'pitch',
	          className: (0, _classnames2.default)({
	            'ReportChatModal-button': true,
	            'ReportChatModal-button-disabled': this.props.disabled
	          }, this.props.className) }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ReportChatModalOption;
	}(_react2.default.Component);
	
	ReportChatModalOption.defaultProps = {
	  disabled: false
	};
	ReportChatModalOption.displayName = 'ReportChatModalOption';
	exports.default = ReportChatModalOption;

/***/ },
/* 2863 */
1136,
/* 2864 */,
/* 2865 */
1136,
/* 2866 */,
/* 2867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _AuthenticationView = __webpack_require__(1690);
	
	var _AuthenticationView2 = _interopRequireDefault(_AuthenticationView);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(2868);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STATUS = (0, _enumerate2.default)(['pending', 'failure']);
	
	var ResetPasswordPage = function (_React$Component) {
	  _inherits(ResetPasswordPage, _React$Component);
	
	  function ResetPasswordPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResetPasswordPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResetPasswordPage.__proto__ || Object.getPrototypeOf(ResetPasswordPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      status: STATUS.pending,
	      canSubmit: false
	    }, _this.disableButton = function () {
	      if (_this.state.canSubmit) {
	        _this.setState({ canSubmit: false });
	      }
	    }, _this.enableButton = function () {
	      if (!_this.state.canSubmit) {
	        _this.setState({ canSubmit: true });
	      }
	    }, _this.submit = function (value) {
	      var onSuccess = function onSuccess() {
	        _ToastActions2.default.showSuccessToast('Your password has been changed');
	        _this.context.router.push('/classes');
	      };
	
	      var onFailure = function onFailure() {
	        _this.setState({ status: STATUS.failure });
	      };
	
	      _UserActions2.default.resetPassword(value.password).then(onSuccess, onFailure);
	    }, _this.renderFailure = function () {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ResetPasswordPage-Failure' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'ResetPasswordPage-Title' },
	          'Your link has expired.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'For security reason the reset link sent via email is only valid for a few hours.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'You can request a new link ',
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/forgot_password' },
	            'here'
	          ),
	          '.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If the problem persist, please',
	          ' ',
	          _react2.default.createElement(
	            _Link2.default,
	            { href: _LinkConstants2.default.CONTACT_FORM, target: '_blank' },
	            'contact us'
	          ),
	          '.'
	        )
	      );
	    }, _this.renderPending = function () {
	      return _react2.default.createElement(
	        _Form2.default,
	        {
	          onValid: _this.enableButton,
	          onValidSubmit: _this.submit,
	          onInvalid: _this.disableButton },
	        _react2.default.createElement(
	          _Fieldset2.default,
	          { className: 'ResetPasswordPage-fieldset', legend: 'Change your password' },
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'New password',
	            required: true,
	            type: 'password',
	            autoComplete: 'new-password',
	            className: 'ResetPasswordPage-Password',
	            name: 'password',
	            validations: 'minLength:6',
	            validOnPristine: false,
	            validationError: 'Password must be at least 6 characters long.'
	          }),
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'New password confirmation',
	            required: true,
	            type: 'password',
	            autoComplete: 'new-password',
	            className: 'ResetPasswordPage-PasswordConfirmation',
	            name: 'password_confirmation',
	            validations: 'equalsField:password',
	            validationError: 'Must be same as password',
	            validOnPristine: false
	          }),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              size: 'small',
	              type: 'submit',
	              className: 'ResetPasswordPage-Submit',
	              disabled: !_this.state.canSubmit,
	              eventElementName: 'ResetPasswordPage-Submit' },
	            'Change my password'
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ResetPasswordPage, [{
	    key: 'render',
	    value: function render() {
	      var body = this.state.status === STATUS.pending ? this.renderPending() : this.renderFailure();
	
	      return _react2.default.createElement(
	        _AuthenticationView2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'ResetPasswordPage' },
	          body
	        )
	      );
	    }
	  }]);
	
	  return ResetPasswordPage;
	}(_react2.default.Component);
	
	ResetPasswordPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ResetPasswordPage.displayName = 'ResetPasswordPage';
	exports.default = ResetPasswordPage;

/***/ },
/* 2868 */
1136,
/* 2869 */,
/* 2870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _MarketingContent = __webpack_require__(2871);
	
	var _MarketingContent2 = _interopRequireDefault(_MarketingContent);
	
	var _NotFoundPage = __webpack_require__(2837);
	
	var _NotFoundPage2 = _interopRequireDefault(_NotFoundPage);
	
	var _OrganizationProfile = __webpack_require__(2516);
	
	var _OrganizationProfile2 = _interopRequireDefault(_OrganizationProfile);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SchoolDetailView = __webpack_require__(2875);
	
	var _SchoolDetailView2 = _interopRequireDefault(_SchoolDetailView);
	
	var _SchoolTeacherList = __webpack_require__(2879);
	
	var _SchoolTeacherList2 = _interopRequireDefault(_SchoolTeacherList);
	
	var _UnauthenticatedView = __webpack_require__(1691);
	
	var _UnauthenticatedView2 = _interopRequireDefault(_UnauthenticatedView);
	
	__webpack_require__(2891);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchoolView = function (_React$Component) {
	  _inherits(SchoolView, _React$Component);
	
	  function SchoolView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SchoolView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SchoolView.__proto__ || Object.getPrototypeOf(SchoolView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      organizationProfile: null,
	      error: false
	    }, _this.getJoinTransition = function (school) {
	      if (!school) {
	        return function () {};
	      }
	      return _this.transitionToJoinSchool.bind(_this, school.id);
	    }, _this.getSchoolImage = function () {
	      // TODO return school image (not in entity ATM).
	      return __webpack_require__(1000);
	    }, _this.loadOrganization = function (organizationId) {
	      _OrganizationProfile2.default.fetch({ id: organizationId }).then(function (organizationProfile) {
	        _this.setState({ organizationProfile: organizationProfile });
	      }, function () {
	        _this.setState({ error: true });
	      });
	    }, _this.transitionToJoinSchool = function (organizationId) {
	      _this.context.router.push('/school/join/' + organizationId);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SchoolView, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var params = this.props.params;
	      this.loadOrganization(parseInt(params.organizationId, 10));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.error) {
	        return _react2.default.createElement(_NotFoundPage2.default, null);
	      }
	
	      var school = this.state.organizationProfile;
	
	      return _react2.default.createElement(
	        _UnauthenticatedView2.default,
	        _extends({}, this.props, { className: 'SchoolView' }),
	        school ? _react2.default.createElement(
	          'div',
	          { className: 'SchoolView-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'SchoolView-header' },
	            _react2.default.createElement(_Image2.default, { className: 'SchoolView-header-logo', src: this.getSchoolImage() }),
	            _react2.default.createElement(
	              'h1',
	              { className: 'SchoolView-header-title' },
	              school.getName()
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                onClick: this.getJoinTransition(school),
	                level: 'secondary',
	                className: 'SchoolView-header-joinButton',
	                eventElementName: 'SchoolView-header-joinButton' },
	              'Join a class on Remind'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'SchoolView-body' },
	            _react2.default.createElement(
	              'div',
	              { className: 'SchoolView-body-teacherList' },
	              _react2.default.createElement(_SchoolTeacherList2.default, {
	                location: this.props.location,
	                redirect: this.getJoinTransition(school),
	                organizationId: school.id,
	                schoolName: school.getName(),
	                teachers: school.getTeachers()
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'SchoolView-body-details' },
	              _react2.default.createElement(_SchoolDetailView2.default, { organizationProfile: school })
	            )
	          )
	        ) : _react2.default.createElement(_LoadingIndicator2.default, { className: 'SchoolView-loading' }),
	        _react2.default.createElement(_MarketingContent2.default, { onSignupButtonClick: this.getJoinTransition(school) })
	      );
	    }
	  }], [{
	    key: 'onEnter',
	    value: function onEnter(nextState, replaceWith, callback) {
	      _AuthActions2.default.checkLoggedIn().then(function () {
	        return callback();
	      }, function () {
	        return callback();
	      });
	    }
	  }]);
	
	  return SchoolView;
	}(_react2.default.Component);
	
	SchoolView.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	SchoolView.displayName = 'SchoolView';
	exports.default = SchoolView;

/***/ },
/* 2871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Columns = __webpack_require__(1532);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2872);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MarketingContent = function (_React$Component) {
	  _inherits(MarketingContent, _React$Component);
	
	  function MarketingContent() {
	    _classCallCheck(this, MarketingContent);
	
	    return _possibleConstructorReturn(this, (MarketingContent.__proto__ || Object.getPrototypeOf(MarketingContent)).apply(this, arguments));
	  }
	
	  _createClass(MarketingContent, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'MarketingContent' },
	        _react2.default.createElement(
	          'div',
	          { className: 'MarketingContent-lead' },
	          _react2.default.createElement(
	            'div',
	            { className: 'MarketingContent-lead-quote' },
	            _react2.default.createElement(
	              'div',
	              { className: 'MarketingContent-lead-quote-open' },
	              '\u201C'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'MarketingContent-lead-quote-content' },
	              'Remind gives me a sense of ease because I know what\u2019s going on with my child on a daily basis.',
	              _react2.default.createElement(
	                'div',
	                { className: 'MarketingContent-lead-quote-attribution' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'MarketingContent-lead-quote-attribution-photo' },
	                  _react2.default.createElement(_Image2.default, { src: __webpack_require__(2874) })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'MarketingContent-lead-quote-attribution-content' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'MarketingContent-lead-quote-attribution-content-name' },
	                    'Kamelia Reilly'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'MarketingContent-lead-quote-attribution-content-role' },
	                    'Kindergarten Parent'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'MarketingContent-lead-video' },
	            _react2.default.createElement('iframe', {
	              className: 'MarketingContent-lead-video-frame',
	              src: 'https://www.youtube.com/embed/Nav0GpNqorU',
	              frameBorder: '0',
	              allowFullScreen: true
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'h3',
	          { className: 'MarketingContent-subText' },
	          'What is Remind?'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'MarketingContent-copy' },
	          'Remind is a free, safe, and easy-to-use communication tool that helps teachers reach students and parents where they are.'
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'MarketingContent-signUpButton',
	            onClick: this.props.onSignupButtonClick,
	            eventElementName: 'MarketingContent-signUpButton' },
	          'Sign up'
	        ),
	        _react2.default.createElement(
	          _Columns2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h4',
	              { className: 'MarketingContent-columnHeader' },
	              '15 seconds',
	              _react2.default.createElement(
	                'div',
	                { className: 'MarketingContent-columnBody' },
	                'to sign up'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h4',
	              { className: 'MarketingContent-columnHeader' },
	              '29 million',
	              _react2.default.createElement(
	                'div',
	                { className: 'MarketingContent-columnBody' },
	                'students and parents use Remind'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h4',
	              { className: 'MarketingContent-columnHeader' },
	              '3 out of 4 school districts',
	              _react2.default.createElement(
	                'div',
	                { className: 'MarketingContent-columnBody' },
	                'in the U.S. use Remind'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MarketingContent;
	}(_react2.default.Component);
	
	MarketingContent.displayName = 'MarketingContent';
	exports.default = MarketingContent;

/***/ },
/* 2872 */
1136,
/* 2873 */,
/* 2874 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 2875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _OrganizationProfile = __webpack_require__(2516);
	
	var _OrganizationProfile2 = _interopRequireDefault(_OrganizationProfile);
	
	__webpack_require__(2876);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchoolDetailView = function (_React$Component) {
	  _inherits(SchoolDetailView, _React$Component);
	
	  function SchoolDetailView(props) {
	    _classCallCheck(this, SchoolDetailView);
	
	    var _this = _possibleConstructorReturn(this, (SchoolDetailView.__proto__ || Object.getPrototypeOf(SchoolDetailView)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var school = props.organizationProfile;
	
	    var hasLatLong = school.getLatitude() && school.getLongitude();
	
	    _this.state = {
	      showMap: hasLatLong
	    };
	    return _this;
	  }
	
	  _createClass(SchoolDetailView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var school = this.props.organizationProfile;
	      var latitude = school.getLatitude();
	      var longitude = school.getLongitude();
	
	      var GoogleMapsLoader = __webpack_require__(2878);
	
	      if (this.state.showMap) {
	        GoogleMapsLoader.load(function (google) {
	          var latlng = new google.maps.LatLng(latitude, longitude);
	          var mapOptions = {
	            zoom: 15,
	            center: latlng,
	            mapTypeControl: false,
	            scrollWheel: false,
	            navigationControl: false,
	            streetViewControl: false,
	            zoomControl: false,
	            draggable: false,
	            mapTypeId: google.maps.MapTypeId.ROADMAP
	          };
	
	          var map = new google.maps.Map(_reactDom2.default.findDOMNode(_this2.refs.googleMap), mapOptions);
	
	          var marker = new google.maps.Marker({
	            position: latlng,
	            title: school.getName()
	          });
	          marker.setMap(map);
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var school = this.props.organizationProfile;
	      var address = school.getAddressObject();
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('SchoolDetailView', this.props.className) },
	        _react2.default.createElement(
	          'h3',
	          { className: 'SchoolDetailView-title' },
	          school.getName()
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolDetailView-label' },
	          'Address:'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolDetailView-field address' },
	          _react2.default.createElement(
	            'div',
	            null,
	            address.line1
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            address.line2
	          ),
	          this.state.showMap && _react2.default.createElement('div', { ref: 'googleMap', className: 'SchoolDetailView-map' })
	        ),
	        this.renderDistrict(school),
	        this.renderGradeLevels(school),
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolDetailView-label' },
	          'Type:'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolDetailView-field schoolType' },
	          school.getFormattedType(),
	          ' school'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolDetailView-claim' },
	          _react2.default.createElement(
	            _Link2.default,
	            { onClick: this.redirectToAdminSignUp },
	            _react2.default.createElement(_Glyph2.default, { name: 'school', size: 'large' }),
	            'Administrator of this school? Claim school'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SchoolDetailView;
	}(_react2.default.Component);
	
	SchoolDetailView.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	SchoolDetailView.displayName = 'SchoolDetailView';
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.redirectToAdminSignUp = function () {
	    _this3.context.router.push('/school/sign_up');
	  };
	
	  this.renderDistrict = function (school) {
	    if (!school.getDistrictName()) {
	      return null;
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'SchoolDetailView-label' },
	        'District:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'SchoolDetailView-field district' },
	        school.getDistrictName()
	      )
	    );
	  };
	
	  this.renderGradeLevels = function (school) {
	    if (!school.getGradeLevel()) {
	      return null;
	    }
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'SchoolDetailView-label' },
	        'Grade levels:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'SchoolDetailView-field gradeLevel' },
	        school.getGradeLevel()
	      )
	    );
	  };
	};
	
	exports.default = SchoolDetailView;

/***/ },
/* 2876 */
1136,
/* 2877 */,
/* 2878 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	
		if (root === null) {
			throw new Error('Google-maps package can be used only in browser');
		}
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === 'object') {
			module.exports = factory();
		} else {
			root.GoogleMapsLoader = factory();
		}
	
	})(typeof window !== 'undefined' ? window : null, function() {
	
	
		'use strict';
	
	
		var googleVersion = '3.18';
	
		var script = null;
	
		var google = null;
	
		var loading = false;
	
		var callbacks = [];
	
		var onLoadEvents = [];
	
		var originalCreateLoaderMethod = null;
	
	
		var GoogleMapsLoader = {};
	
	
		GoogleMapsLoader.URL = 'https://maps.googleapis.com/maps/api/js';
	
		GoogleMapsLoader.KEY = null;
	
		GoogleMapsLoader.LIBRARIES = [];
	
		GoogleMapsLoader.CLIENT = null;
	
		GoogleMapsLoader.CHANNEL = null;
	
		GoogleMapsLoader.SENSOR = null;
	
		GoogleMapsLoader.LANGUAGE = null;
	
		GoogleMapsLoader.VERSION = googleVersion;
	
		GoogleMapsLoader.WINDOW_CALLBACK_NAME = '__google_maps_api_provider_initializator__';
	
	
		GoogleMapsLoader._googleMockApiObject = {};
	
	
		GoogleMapsLoader.load = function(fn) {
			if (google === null) {
				if (loading === true) {
					if (fn) {
						callbacks.push(fn);
					}
				} else {
					loading = true;
	
					window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] = function() {
						ready(fn);
					};
	
					GoogleMapsLoader.createLoader();
				}
			} else if (fn) {
				fn(google);
			}
	
			var promiseError = function() {
				throw new Error('Using promises is not supported anymore. Please take a look in new documentation and use callback instead.');
			};
	
			return {
				then: promiseError,
				'catch': promiseError,
				fail: promiseError
			};
		};
	
	
		GoogleMapsLoader.createLoader = function() {
			script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = GoogleMapsLoader.createUrl();
	
			document.body.appendChild(script);
		};
	
	
		GoogleMapsLoader.isLoaded = function() {
			return google !== null;
		};
	
	
		GoogleMapsLoader.createUrl = function() {
			var url = GoogleMapsLoader.URL;
	
			url += '?callback=' + GoogleMapsLoader.WINDOW_CALLBACK_NAME;
	
			url += '&sensor=' + ((GoogleMapsLoader.SENSOR === true || GoogleMapsLoader.SENSOR === 'true') ? 'true' : 'false');
	
			if (GoogleMapsLoader.KEY) {
				url += '&key=' + GoogleMapsLoader.KEY;
			}
	
			if (GoogleMapsLoader.LIBRARIES.length > 0) {
				url += '&libraries=' + GoogleMapsLoader.LIBRARIES.join(',');
			}
	
			if (GoogleMapsLoader.CLIENT) {
				url += '&client=' + GoogleMapsLoader.CLIENT + '&v=' + GoogleMapsLoader.VERSION;
			}
	
			if (GoogleMapsLoader.CHANNEL) {
				url += '&channel=' + GoogleMapsLoader.CHANNEL;
			}
	
			if (GoogleMapsLoader.LANGUAGE) {
				url += '&language=' + GoogleMapsLoader.LANGUAGE;
			}
	
			return url;
		};
	
	
		GoogleMapsLoader.release = function(fn) {
			var release = function() {
				GoogleMapsLoader.KEY = null;
				GoogleMapsLoader.LIBRARIES = [];
				GoogleMapsLoader.CLIENT = null;
				GoogleMapsLoader.CHANNEL = null;
				GoogleMapsLoader.LANGUAGE = null;
				GoogleMapsLoader.SENSOR = false;
				GoogleMapsLoader.VERSION = googleVersion;
	
				google = null;
				loading = false;
				callbacks = [];
				onLoadEvents = [];
	
				if (typeof window.google !== 'undefined') {
					delete window.google;
				}
	
				if (typeof window[GoogleMapsLoader.WINDOW_CALLBACK_NAME] !== 'undefined') {
					delete window[GoogleMapsLoader.WINDOW_CALLBACK_NAME];
				}
	
				if (originalCreateLoaderMethod !== null) {
					GoogleMapsLoader.createLoader = originalCreateLoaderMethod;
					originalCreateLoaderMethod = null;
				}
	
				if (script !== null) {
					script.parentElement.removeChild(script);
					script = null;
				}
	
				fn();
			};
	
			if (loading) {
				GoogleMapsLoader.load(function() {
					release();
				});
			} else {
				release();
			}
		};
	
	
		GoogleMapsLoader.onLoad = function(fn) {
			onLoadEvents.push(fn);
		};
	
	
		GoogleMapsLoader.makeMock = function() {
			originalCreateLoaderMethod = GoogleMapsLoader.createLoader;
	
			GoogleMapsLoader.createLoader = function() {
				window.google = GoogleMapsLoader._googleMockApiObject;
				window[GoogleMapsLoader.WINDOW_CALLBACK_NAME]();
			};
		};
	
	
		var ready = function(fn) {
			var i;
	
			loading = false;
	
			if (google === null) {
				google = window.google;
			}
	
			for (i = 0; i < onLoadEvents.length; i++) {
				onLoadEvents[i](google);
			}
	
			if (fn) {
				fn(google);
			}
	
			for (i = 0; i < callbacks.length; i++) {
				callbacks[i](google);
			}
	
			callbacks = [];
		};
	
	
		return GoogleMapsLoader;
	
	});


/***/ },
/* 2879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _OrganizationProfileTeachers = __webpack_require__(2517);
	
	var _OrganizationProfileTeachers2 = _interopRequireDefault(_OrganizationProfileTeachers);
	
	var _SignInPage = __webpack_require__(1689);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _modal = __webpack_require__(1188);
	
	var _SchoolReportModal = __webpack_require__(2880);
	
	var _SchoolReportModal2 = _interopRequireDefault(_SchoolReportModal);
	
	var _SchoolTeacherListItem = __webpack_require__(2883);
	
	var _SchoolTeacherListItem2 = _interopRequireDefault(_SchoolTeacherListItem);
	
	__webpack_require__(2889);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchoolTeacherList = function (_React$Component) {
	  _inherits(SchoolTeacherList, _React$Component);
	
	  function SchoolTeacherList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SchoolTeacherList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SchoolTeacherList.__proto__ || Object.getPrototypeOf(SchoolTeacherList)).call.apply(_ref, [this].concat(args))), _this), _this.displayReportModal = function () {
	      (0, _modal.mountModal)(_react2.default.createElement(_SchoolReportModal2.default, { schoolName: _this.props.schoolName, teachers: _this.props.teachers }), _this);
	    }, _this.redirectToSignIn = function () {
	      // XXX
	      _SignInPage.redirector.onSignInRedirectTo = {
	        pathname: '/school/' + _this.props.organizationId,
	        query: { report: true }
	      };
	      _ToastActions2.default.showSuccessToast('You must sign in to report.');
	      _this.context.router.push('/log_in');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SchoolTeacherList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.location.query.report) {
	        this.displayReportModal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var teachers = this.props.teachers;
	
	
	      if (!teachers || teachers.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'SchoolTeacherList-empty' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Are you a member of the ',
	            this.props.schoolName,
	            ' community?'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'SchoolTeacherList-empty-signUpButton',
	              onClick: this.props.redirect,
	              eventElementName: 'SchoolTeacherList-empty-signUpButton' },
	            'Sign up for Remind'
	          )
	        );
	      }
	
	      var teacherList = teachers.map(function (teacher) {
	        return _react2.default.createElement(_SchoolTeacherListItem2.default, {
	          key: teacher.id,
	          teacher: teacher,
	          onGroupAvatarClick: _this2.props.redirect
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          { className: 'SchoolTeacherList-title' },
	          'Teachers on Remind at ',
	          this.props.schoolName
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolTeacherList' },
	          teacherList
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'SchoolTeacherList-report' },
	          _react2.default.createElement(
	            _Link2.default,
	            {
	              onClick: _CurrentUser2.default.isSignedIn() ? this.displayReportModal : this.redirectToSignIn },
	            _react2.default.createElement(_Glyph2.default, { name: 'flag', size: 'small' }),
	            'See an error in the list? Report to Remind'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SchoolTeacherList;
	}(_react2.default.Component);
	
	SchoolTeacherList.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	SchoolTeacherList.displayName = 'SchoolTeacherList';
	exports.default = SchoolTeacherList;

/***/ },
/* 2880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(326);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _getMatcher = __webpack_require__(1890);
	
	var _getMatcher2 = _interopRequireDefault(_getMatcher);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _OrganizationProfileTeachers = __webpack_require__(2517);
	
	var _OrganizationProfileTeachers2 = _interopRequireDefault(_OrganizationProfileTeachers);
	
	var _ReportToRemindSelectModal = __webpack_require__(1608);
	
	var _ReportToRemindSelectModal2 = _interopRequireDefault(_ReportToRemindSelectModal);
	
	var _ScrollableArea = __webpack_require__(1412);
	
	var _ScrollableArea2 = _interopRequireDefault(_ScrollableArea);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _modal = __webpack_require__(1188);
	
	__webpack_require__(2881);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchoolReportModal = function (_React$Component) {
	  _inherits(SchoolReportModal, _React$Component);
	
	  function SchoolReportModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SchoolReportModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SchoolReportModal.__proto__ || Object.getPrototypeOf(SchoolReportModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      results: _this.props.teachers
	    }, _this.filterTeachers = function () {
	      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      var isMatch = (0, _getMatcher2.default)(query);
	      return _this.props.teachers.filter(function (teacher) {
	        return isMatch([teacher.signature]);
	      });
	    }, _this.handleClickTeacher = function (teacher) {
	      var modal = _react2.default.createElement(_ReportToRemindSelectModal2.default, {
	        options: ['This person doesn’t teach at this school'],
	        reportee: teacher.getSignature(),
	        notesPlaceholder: 'Why are you reporting this Teacher?',
	        onReport: _this.reportTeacher.bind(_this, teacher)
	      });
	      (0, _modal.mountModal)(modal, _this);
	    }, _this.performSearch = function () {
	      var input = _reactDom2.default.findDOMNode(_this.refs.teacherSearch);
	      var value = input.value;
	
	      _this.setState({
	        results: _this.filterTeachers(value),
	        query: value
	      });
	    }, _this.reportTeacher = function (teacher, reason, notes) {
	      _UserActions2.default.reportUser(teacher.id, reason, notes);
	      _this.props.onRequestHide();
	    }, _this.renderTeacher = function (teacher) {
	      return _react2.default.createElement(
	        'div',
	        {
	          key: teacher.id,
	          className: 'SchoolReportModal-result',
	          onClick: function onClick() {
	            return _this.handleClickTeacher(teacher);
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolReportModal-result-body' },
	          _react2.default.createElement(
	            _Text2.default,
	            { className: 'SchoolReportModal-result-title', truncate: true },
	            teacher.getSignature()
	          )
	        )
	      );
	    }, _this.renderTeachers = function () {
	      return _this.state.results.map(_this.renderTeacher);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SchoolReportModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'SchoolReportModal'
	        }, this.props, {
	          size: 'small',
	          className: 'SchoolReportModal SchoolReportModal-noPadding',
	          title: 'Who are you reporting to Remind?',
	          hidePreviousButton: true }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            'div',
	            { className: 'SchoolReportModal-inputWrapper' },
	            _react2.default.createElement(_Input2.default, {
	              className: 'SchoolReportModal-input',
	              ref: 'teacherSearch',
	              type: 'text',
	              size: 'large',
	              placeholder: 'Search for a teacher at ' + this.props.schoolName,
	              autofocus: true,
	              value: this.state.query,
	              onChange: this.performSearch
	            }),
	            _react2.default.createElement(_Glyph2.default, { className: 'SchoolReportModal-inputGlyph', name: 'search', size: 'medium' })
	          ),
	          _react2.default.createElement(
	            _ScrollableArea2.default,
	            {
	              className: 'SchoolReportModal-list',
	              ref: 'scrollAreaTeachers',
	              useBodyChildrenHeight: true },
	            this.renderTeachers()
	          )
	        )
	      );
	    }
	  }]);
	
	  return SchoolReportModal;
	}(_react2.default.Component);
	
	SchoolReportModal.displayName = 'SchoolReportModal';
	exports.default = SchoolReportModal;

/***/ },
/* 2881 */
1136,
/* 2882 */,
/* 2883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Columns = __webpack_require__(1532);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _GroupAvatarCluster = __webpack_require__(2884);
	
	var _GroupAvatarCluster2 = _interopRequireDefault(_GroupAvatarCluster);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _OrganizationProfileTeacher = __webpack_require__(2518);
	
	var _OrganizationProfileTeacher2 = _interopRequireDefault(_OrganizationProfileTeacher);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2887);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchoolTeacherListItem = function (_React$Component) {
	  _inherits(SchoolTeacherListItem, _React$Component);
	
	  function SchoolTeacherListItem() {
	    _classCallCheck(this, SchoolTeacherListItem);
	
	    return _possibleConstructorReturn(this, (SchoolTeacherListItem.__proto__ || Object.getPrototypeOf(SchoolTeacherListItem)).apply(this, arguments));
	  }
	
	  _createClass(SchoolTeacherListItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'SchoolTeacherListItem' },
	        _react2.default.createElement(
	          _Columns2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'SchoolTeacherListItem-signature' },
	            this.props.teacher.getSignature()
	          ),
	          _react2.default.createElement(_GroupAvatarCluster2.default, {
	            groups: this.props.teacher.groupClusterItems,
	            maxSize: 3,
	            moreButtonHref: _LinkConstants2.default.SIGN_UP,
	            onGroupAvatarClick: this.props.onGroupAvatarClick
	          })
	        )
	      );
	    }
	  }]);
	
	  return SchoolTeacherListItem;
	}(_react2.default.Component);
	
	SchoolTeacherListItem.displayName = 'SchoolTeacherListItem';
	exports.default = SchoolTeacherListItem;

/***/ },
/* 2884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _GroupClusterItem = __webpack_require__(2520);
	
	var _GroupClusterItem2 = _interopRequireDefault(_GroupClusterItem);
	
	var _GroupClusterItems = __webpack_require__(2519);
	
	var _GroupClusterItems2 = _interopRequireDefault(_GroupClusterItems);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2885);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function renderAvatarImage(group) {
	  return _react2.default.createElement(_Image2.default, {
	    src: group.avatarSvgUrl,
	    className: 'GroupAvatarCluster-avatar'
	  });
	}
	
	var GroupAvatarCluster = function (_React$Component) {
	  _inherits(GroupAvatarCluster, _React$Component);
	
	  function GroupAvatarCluster() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, GroupAvatarCluster);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GroupAvatarCluster.__proto__ || Object.getPrototypeOf(GroupAvatarCluster)).call.apply(_ref, [this].concat(args))), _this), _this.renderAvatar = function (group, index) {
	      if (_this.props.onGroupAvatarClick) {
	        return _react2.default.createElement(
	          _Link2.default,
	          {
	            key: index,
	            onClick: _this.props.onGroupAvatarClick,
	            className: 'GroupAvatarCluster-link',
	            eventElementName: 'GroupAvatarCluster-link' },
	          renderAvatarImage(group)
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { key: index },
	          renderAvatarImage(group)
	        );
	      }
	    }, _this.renderMoreButton = function (countNotShown) {
	      var bareButton = _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'GroupAvatarCluster-more',
	          level: 'secondary',
	          shape: 'circle',
	          eventElementName: 'GroupAvatarCluster-more' },
	        '+',
	        countNotShown
	      );
	
	      if (_this.props.moreButtonHref) {
	        return _react2.default.createElement(
	          _Link2.default,
	          {
	            href: _this.props.moreButtonHref,
	            className: 'GroupAvatarCluster-link',
	            eventElementName: 'GroupAvatarCluster-link' },
	          bareButton
	        );
	      } else {
	        return bareButton;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(GroupAvatarCluster, [{
	    key: 'render',
	    value: function render() {
	      var allFit = this.props.groups.length === this.props.maxSize;
	      var countToShow = allFit ? this.props.maxSize : this.props.maxSize - 1;
	      var groupsToShow = this.props.groups.slice(0, countToShow);
	      var countNotShown = this.props.groups.length - countToShow;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'GroupAvatarCluster' },
	        groupsToShow.map(this.renderAvatar),
	        countNotShown > 0 && this.renderMoreButton(countNotShown)
	      );
	    }
	  }]);
	
	  return GroupAvatarCluster;
	}(_react2.default.Component);
	
	GroupAvatarCluster.displayName = 'GroupAvatarCluster';
	exports.default = GroupAvatarCluster;

/***/ },
/* 2885 */
1136,
/* 2886 */,
/* 2887 */
1136,
/* 2888 */,
/* 2889 */
1136,
/* 2890 */,
/* 2891 */
1136,
/* 2892 */,
/* 2893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SessionExpiredPage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AuthenticationView = __webpack_require__(1690);
	
	var _AuthenticationView2 = _interopRequireDefault(_AuthenticationView);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1638);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SessionExpiredPage = exports.SessionExpiredPage = function (_React$Component) {
	  _inherits(SessionExpiredPage, _React$Component);
	
	  function SessionExpiredPage() {
	    _classCallCheck(this, SessionExpiredPage);
	
	    return _possibleConstructorReturn(this, (SessionExpiredPage.__proto__ || Object.getPrototypeOf(SessionExpiredPage)).apply(this, arguments));
	  }
	
	  _createClass(SessionExpiredPage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _AuthenticationView2.default,
	        { title: 'Session expired' },
	        _react2.default.createElement(
	          'p',
	          { className: 'block' },
	          'For your security, you have been logged out of your Remind session.'
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { to: '/log_in' },
	          'Log back in'
	        )
	      );
	    }
	  }]);
	
	  return SessionExpiredPage;
	}(_react2.default.Component);
	
	SessionExpiredPage.displayName = 'SessionExpiredPage';
	exports.default = SessionExpiredPage;

/***/ },
/* 2894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _AuthenticationView = __webpack_require__(1690);
	
	var _AuthenticationView2 = _interopRequireDefault(_AuthenticationView);
	
	__webpack_require__(2895);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var STATUS = (0, _enumerate2.default)(['loading', 'finished']);
	
	var SessionSyncPage = function (_React$Component) {
	  _inherits(SessionSyncPage, _React$Component);
	
	  function SessionSyncPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SessionSyncPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SessionSyncPage.__proto__ || Object.getPrototypeOf(SessionSyncPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      user: null,
	      status: STATUS.loading
	    }, _this.confirmNewSession = function () {
	      window.location = '/classes';
	    }, _this.resetSession = function () {
	      _AuthActions2.default.signOut('/log_in');
	    }, _this.renderFinished = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _this.renderHeader(),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            full: true,
	            className: 'SessionSyncPage-Button',
	            onClick: _this.confirmNewSession,
	            eventElementName: 'SessionSyncPage-Button' },
	          'Log in with ',
	          _this.state.user.getEmail()
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            full: true,
	            className: 'SessionSyncPage-Button',
	            onClick: _this.resetSession,
	            eventElementName: 'SessionSyncPage-Button' },
	          'Log in with another email address'
	        )
	      );
	    }, _this.renderHeader = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          { className: 'SessionSyncPage-Title' },
	          'It looks like you\u2019re already logged in to Remind'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Which account do you want to use?'
	        )
	      );
	    }, _this.renderLoading = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _this.renderHeader(),
	        _react2.default.createElement(_LoadingIndicator2.default, { size: 'medium' })
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SessionSyncPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _AuthActions2.default.checkLoggedIn().then(function (user) {
	        _this2.setState({
	          status: STATUS.finished,
	          user: user
	        });
	      }).catch(function () {
	        _ToastActions2.default.showErrorToast('Oops, you need to log in again.');
	        _this2.context.router.push('/log_in');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _STATUS$loading$STATU;
	
	      var body = (_STATUS$loading$STATU = {}, _defineProperty(_STATUS$loading$STATU, STATUS.loading, this.renderLoading), _defineProperty(_STATUS$loading$STATU, STATUS.finished, this.renderFinished), _STATUS$loading$STATU)[this.state.status]();
	
	      return _react2.default.createElement(
	        _AuthenticationView2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'SessionSyncPage' },
	          body
	        )
	      );
	    }
	  }]);
	
	  return SessionSyncPage;
	}(_react2.default.Component);
	
	SessionSyncPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	SessionSyncPage.displayName = 'SessionSyncPage';
	exports.default = SessionSyncPage;

/***/ },
/* 2895 */
1136,
/* 2896 */,
/* 2897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(497);
	
	var _TransactionSettingsView = __webpack_require__(2898);
	
	var _TransactionSettingsView2 = _interopRequireDefault(_TransactionSettingsView);
	
	var _ChatSettingsView = __webpack_require__(2964);
	
	var _ChatSettingsView2 = _interopRequireDefault(_ChatSettingsView);
	
	var _WidgetSettingsView = __webpack_require__(2975);
	
	var _WidgetSettingsView2 = _interopRequireDefault(_WidgetSettingsView);
	
	var _PrintSettingsView = __webpack_require__(2986);
	
	var _PrintSettingsView2 = _interopRequireDefault(_PrintSettingsView);
	
	var _SettingsViewRouteHandler = __webpack_require__(2993);
	
	var _SettingsViewRouteHandler2 = _interopRequireDefault(_SettingsViewRouteHandler);
	
	var _UserSettingsView = __webpack_require__(3004);
	
	var _UserSettingsView2 = _interopRequireDefault(_UserSettingsView);
	
	var _PrivacySettingsView = __webpack_require__(3028);
	
	var _PrivacySettingsView2 = _interopRequireDefault(_PrivacySettingsView);
	
	var _NotificationSettingsContainer = __webpack_require__(3038);
	
	var _NotificationSettingsContainer2 = _interopRequireDefault(_NotificationSettingsContainer);
	
	var _ArchivedClassesView = __webpack_require__(3045);
	
	var _ArchivedClassesView2 = _interopRequireDefault(_ArchivedClassesView);
	
	var _UserProfileView = __webpack_require__(3053);
	
	var _UserProfileView2 = _interopRequireDefault(_UserProfileView);
	
	var _AccountSettingsView = __webpack_require__(3075);
	
	var _AccountSettingsView2 = _interopRequireDefault(_AccountSettingsView);
	
	var _chainOnEnter = __webpack_require__(2586);
	
	var _chainOnEnter2 = _interopRequireDefault(_chainOnEnter);
	
	var _RequireOwner = __webpack_require__(3076);
	
	var _RequireOwner2 = _interopRequireDefault(_RequireOwner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requireOwner = (0, _chainOnEnter2.default)([_RequireOwner2.default]);
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  {
	    path: '/settings(/)',
	    component: _SettingsViewRouteHandler2.default,
	    onEnter: _SettingsViewRouteHandler2.default.onEnter },
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/settings/chat',
	    component: _ChatSettingsView2.default,
	    onEnter: requireOwner
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/settings/notifications',
	    component: _NotificationSettingsContainer2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/settings/widget',
	    component: _WidgetSettingsView2.default,
	    onEnter: requireOwner
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/settings/export',
	    component: _PrintSettingsView2.default,
	    onEnter: requireOwner
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/settings/transactions',
	    component: _TransactionSettingsView2.default
	    // $FlowIssue - those statics are hoisted by connect() HOC.
	    , onEnter: _TransactionSettingsView2.default.onEnter
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/settings/privacy',
	    component: _PrivacySettingsView2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/settings/archived',
	    component: _ArchivedClassesView2.default
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/settings/profile',
	    component: _UserProfileView2.default,
	    onEnter: _UserProfileView2.default.onEnter
	  }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/settings/account',
	    component: _AccountSettingsView2.default,
	    onEnter: _AccountSettingsView2.default.onEnter
	  }),
	  _react2.default.createElement(_reactRouter.IndexRoute, { component: _UserSettingsView2.default })
	);

/***/ },
/* 2898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TransactionSettingsView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _AccountTransferDisabledModal = __webpack_require__(2899);
	
	var _AccountTransferDisabledModal2 = _interopRequireDefault(_AccountTransferDisabledModal);
	
	var _AddBankAccountModal = __webpack_require__(2903);
	
	var _AddBankAccountModal2 = _interopRequireDefault(_AddBankAccountModal);
	
	var _IdentityVerificationModal = __webpack_require__(2663);
	
	var _IdentityVerificationModal2 = _interopRequireDefault(_IdentityVerificationModal);
	
	var _TransactionSettingsContainer = __webpack_require__(2904);
	
	var _TransactionSettingsContainer2 = _interopRequireDefault(_TransactionSettingsContainer);
	
	var _IdentityAdditionalVerificationModalContainer = __webpack_require__(2674);
	
	var _IdentityAdditionalVerificationModalContainer2 = _interopRequireDefault(_IdentityAdditionalVerificationModalContainer);
	
	var _modal = __webpack_require__(1188);
	
	var _PaymentAccountActions = __webpack_require__(2593);
	
	var _PaymentAccountActions2 = _interopRequireDefault(_PaymentAccountActions);
	
	var _PaymentAccountStore = __webpack_require__(2604);
	
	var _PaymentAccountStore2 = _interopRequireDefault(_PaymentAccountStore);
	
	var _ConnectedBankAccountActions = __webpack_require__(2559);
	
	var _ConnectedBankAccountActions2 = _interopRequireDefault(_ConnectedBankAccountActions);
	
	var _toasts = __webpack_require__(948);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var OPEN_INFORMATION = 'identity_modal';
	var OPEN_BANKACCOUNT = 'bank_account_modal';
	
	function RequirePaymentData(nextState, replaceWith, callback) {
	  var onError = function onError() {
	    replaceWith('/classes');
	    callback();
	  };
	
	  var promises = [];
	
	  if (_CurrentUser2.default.getUser().canCreateActivity()) {
	    promises.push(_ConnectedBankAccountActions2.default.load());
	  }
	
	  if (_PaymentAccountStore2.default.getPaymentAccount()) {
	    _PaymentAccountActions2.default.load(); // non-blocking refresh.
	  } else {
	    promises.push(_PaymentAccountActions2.default.load());
	  }
	
	  Promise.all(promises).then(function () {
	    return callback();
	  }, function () {
	    return onError();
	  });
	}
	
	var TransactionSettingsView = function (_React$Component) {
	  _inherits(TransactionSettingsView, _React$Component);
	
	  function TransactionSettingsView() {
	    _classCallCheck(this, TransactionSettingsView);
	
	    return _possibleConstructorReturn(this, (TransactionSettingsView.__proto__ || Object.getPrototypeOf(TransactionSettingsView)).apply(this, arguments));
	  }
	
	  _createClass(TransactionSettingsView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var account = _PaymentAccountStore2.default.getPaymentAccount();
	      var show = this.props.location.query.show;
	
	      if (show === OPEN_INFORMATION) {
	        if (account.isTransferEnabled()) {
	          this.props.showToast('Identify already verified.', 'success');
	          return;
	        }
	
	        if (account.needBasicVerification()) {
	          (0, _modal.mountModal)(_react2.default.createElement(_IdentityVerificationModal2.default, null), this);
	        } else if (account.needAdditionalVerification()) {
	          (0, _modal.mountModal)(_react2.default.createElement(_IdentityAdditionalVerificationModalContainer2.default, null), this);
	        } else {
	          (0, _modal.mountModal)(_react2.default.createElement(_AccountTransferDisabledModal2.default, null), this);
	        }
	      }
	
	      if (show === OPEN_BANKACCOUNT) {
	        if (account.needBankAccountVerification()) {
	          (0, _modal.mountModal)(_react2.default.createElement(_AddBankAccountModal2.default, null), this);
	        } else {
	          this.props.showToast('Bank account already verified.', 'success');
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('TransactionSettingsView', this.props.className) },
	        _react2.default.createElement(_TransactionSettingsContainer2.default, null)
	      );
	    }
	  }]);
	
	  return TransactionSettingsView;
	}(_react2.default.Component);
	
	TransactionSettingsView.onEnter = RequirePaymentData;
	TransactionSettingsView.displayName = 'TransactionSettingsView';
	
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ showToast: _toasts.showToast }, dispatch);
	}
	
	exports.TransactionSettingsView = TransactionSettingsView;
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(TransactionSettingsView);

/***/ },
/* 2899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _MailTo = __webpack_require__(1429);
	
	var _MailTo2 = _interopRequireDefault(_MailTo);
	
	var _PaymentAccountActions = __webpack_require__(2593);
	
	var _PaymentAccountActions2 = _interopRequireDefault(_PaymentAccountActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _AccountTransferDisabledModal = __webpack_require__(2900);
	
	var _AccountTransferDisabledModal2 = _interopRequireDefault(_AccountTransferDisabledModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupportMailTo = function SupportMailTo() {
	  return _react2.default.createElement(
	    _MailTo2.default,
	    { to: _LinkConstants2.default.SUPPORT_EMAIL },
	    _LinkConstants2.default.SUPPORT_EMAIL
	  );
	};
	
	var AccountTransferDisabledModal = function (_Component) {
	  _inherits(AccountTransferDisabledModal, _Component);
	
	  function AccountTransferDisabledModal() {
	    _classCallCheck(this, AccountTransferDisabledModal);
	
	    return _possibleConstructorReturn(this, (AccountTransferDisabledModal.__proto__ || Object.getPrototypeOf(AccountTransferDisabledModal)).apply(this, arguments));
	  }
	
	  _createClass(AccountTransferDisabledModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // noop, http error is normal here as this endpoint is ratelimited.
	      _PaymentAccountActions2.default.requestVerificationHelp().then(function () {}, function () {});
	    }
	  }, {
	    key: 'getSubtext',
	    value: function getSubtext() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        'The Support team will follow up with you shortly! If you have any questions, please contact',
	        ' ',
	        _react2.default.createElement(SupportMailTo, null)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'AccountTransferDisabledModal'
	        }, this.props, {
	          size: 'small' }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(_TitleHeader2.default, {
	            image: __webpack_require__(2902),
	            imageClassName: _AccountTransferDisabledModal2.default.image,
	            title: 'We need more information to verify your identity',
	            subtext: this.getSubtext()
	          }),
	          _react2.default.createElement(
	            _Button2.default,
	            { onClick: this.props.onRequestHide },
	            'Done'
	          )
	        )
	      );
	    }
	  }]);
	
	  return AccountTransferDisabledModal;
	}(_react.Component);
	
	AccountTransferDisabledModal.displayName = 'AccountTransferDisabledModal';
	exports.default = AccountTransferDisabledModal;

/***/ },
/* 2900 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"AccountTransferDisabledModal__image___2Yw-L"};

/***/ },
/* 2901 */,
/* 2902 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _CopyConstants = __webpack_require__(1733);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _AddBankAccountForm = __webpack_require__(2552);
	
	var _AddBankAccountForm2 = _interopRequireDefault(_AddBankAccountForm);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /*  weak */
	
	
	var AddBankAccountModal = _react2.default.createClass({
	  displayName: 'AddBankAccountModal',
	  onBankAccountAdded: function onBankAccountAdded(bankAccount) {
	    this.props.onRequestHide();
	    _ToastActions2.default.showSuccessToast('Your bank account was added.');
	    if (this.props.onBankAccountAdded) {
	      this.props.onBankAccountAdded(bankAccount);
	    }
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        style = _props.style,
	        rest = _objectWithoutProperties(_props, ['className', 'style']);
	
	    return _react2.default.createElement(
	      _Dialog2.default,
	      _extends({
	        eventScreenName: 'AddBankAccountModal'
	      }, rest, {
	        size: 'medium',
	        style: style,
	        className: (0, _classnames2.default)('AddBankAccountModal', className) }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(_TitleHeader2.default, { title: _CopyConstants.BankAccount.title, subtext: _CopyConstants.BankAccount.subtext }),
	        _react2.default.createElement(_AddBankAccountForm2.default, {
	          hideChequeImage: false,
	          onBankAccountAdded: this.onBankAccountAdded
	        })
	      )
	    );
	  }
	});
	
	exports.default = AddBankAccountModal;

/***/ },
/* 2904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _ConnectedBankAccountStore = __webpack_require__(2656);
	
	var _ConnectedBankAccountStore2 = _interopRequireDefault(_ConnectedBankAccountStore);
	
	var _TransactionSettings = __webpack_require__(2905);
	
	var _TransactionSettings2 = _interopRequireDefault(_TransactionSettings);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransactionSettingsContainer = function (_React$Component) {
	  _inherits(TransactionSettingsContainer, _React$Component);
	
	  function TransactionSettingsContainer() {
	    _classCallCheck(this, TransactionSettingsContainer);
	
	    return _possibleConstructorReturn(this, (TransactionSettingsContainer.__proto__ || Object.getPrototypeOf(TransactionSettingsContainer)).apply(this, arguments));
	  }
	
	  _createClass(TransactionSettingsContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _apiRequest2.default)('/payments/connected_bank_accounts/exists', 'GET').then(function (response) {
	        return _this2.setState({ requestsForUnconfirmedEmail: !!response && response.exists });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_TransactionSettings2.default, {
	        canCreateActivity: this.state.canCreateActivity,
	        connectedBankAccounts: this.state.connectedBankAccounts,
	        requestsForUnconfirmedEmail: this.state.requestsForUnconfirmedEmail
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default, _ConnectedBankAccountStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState) {
	      return {
	        canCreateActivity: _CurrentUser2.default.getUser().canCreateActivity(),
	        connectedBankAccounts: _ConnectedBankAccountStore2.default.getConnectedBankAccounts().models,
	        requestsForUnconfirmedEmail: !!prevState && prevState.requestsForUnconfirmedEmail
	      };
	    }
	  }]);
	
	  return TransactionSettingsContainer;
	}(_react2.default.Component);
	
	TransactionSettingsContainer.displayName = 'TransactionSettingsContainer';
	exports.default = _utils.Container.create(TransactionSettingsContainer);

/***/ },
/* 2905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _BankAccountsManager = __webpack_require__(2906);
	
	var _BankAccountsManager2 = _interopRequireDefault(_BankAccountsManager);
	
	var _LinkedAccountsTable = __webpack_require__(2921);
	
	var _LinkedAccountsTable2 = _interopRequireDefault(_LinkedAccountsTable);
	
	var _PaymentCardsManager = __webpack_require__(2927);
	
	var _PaymentCardsManager2 = _interopRequireDefault(_PaymentCardsManager);
	
	var _WalletTabSection = __webpack_require__(2941);
	
	var _WalletTabSection2 = _interopRequireDefault(_WalletTabSection);
	
	var _TransactionsListContainer = __webpack_require__(2942);
	
	var _TransactionsListContainer2 = _interopRequireDefault(_TransactionsListContainer);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _ActivitiesNotification = __webpack_require__(2659);
	
	__webpack_require__(2962);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TransactionSettings(props) {
	  var linkedAccounts = props.connectedBankAccounts.filter(function (account) {
	    return account.getCanManage() && account.isApproved();
	  });
	
	  var pendingAccounts = props.connectedBankAccounts.filter(function (account) {
	    return account.getCanManage() && account.isPending();
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'TransactionSettings' },
	    props.canCreateActivity && (pendingAccounts.length > 0 || props.requestsForUnconfirmedEmail) && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _WalletTabSection2.default,
	        { title: 'Pending deposit approval' },
	        pendingAccounts.length > 0 && _react2.default.createElement(_ActivitiesNotification.PendingBankAccountRequestNotification, { number: pendingAccounts.length }),
	        props.requestsForUnconfirmedEmail && _react2.default.createElement(
	          'div',
	          { className: 'TransactionSettings-message' },
	          'There are pending deposit requests for your email. Please ',
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/settings/notifications' },
	            'confirm your email'
	          ),
	          ' to manage them.'
	        )
	      ),
	      _react2.default.createElement(_Divider2.default, null)
	    ),
	    props.canCreateActivity && linkedAccounts.length > 0 && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _WalletTabSection2.default,
	        { title: 'Deposit approval' },
	        _react2.default.createElement(_LinkedAccountsTable2.default, { bankAccounts: linkedAccounts })
	      ),
	      _react2.default.createElement(_Divider2.default, null)
	    ),
	    props.canCreateActivity && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _WalletTabSection2.default,
	        { title: 'Bank account' },
	        _react2.default.createElement(_BankAccountsManager2.default, null)
	      ),
	      _react2.default.createElement(_Divider2.default, null)
	    ),
	    _react2.default.createElement(
	      _WalletTabSection2.default,
	      { title: 'Credit & debit cards' },
	      _react2.default.createElement(_PaymentCardsManager2.default, null)
	    ),
	    _react2.default.createElement(_Divider2.default, null),
	    _react2.default.createElement(
	      _WalletTabSection2.default,
	      { title: 'Transaction history' },
	      _react2.default.createElement(_TransactionsListContainer2.default, null)
	    )
	  );
	}
	exports.default = TransactionSettings;

/***/ },
/* 2906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(956);
	
	var _AddButton = __webpack_require__(1894);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _ManagerItemCard = __webpack_require__(2907);
	
	var _BankAccountsManagerItem = __webpack_require__(2910);
	
	var _BankAccountsManagerItem2 = _interopRequireDefault(_BankAccountsManagerItem);
	
	var _ExternalAccountResourceActions = __webpack_require__(2553);
	
	var _ExternalAccountResourceActions2 = _interopRequireDefault(_ExternalAccountResourceActions);
	
	var _ExternalAccountResourceStore = __webpack_require__(2590);
	
	var _ExternalAccountResourceStore2 = _interopRequireDefault(_ExternalAccountResourceStore);
	
	var _LinkBankAccountModal = __webpack_require__(2660);
	
	var _LinkBankAccountModal2 = _interopRequireDefault(_LinkBankAccountModal);
	
	var _SchoolBankAccountsManagerItem = __webpack_require__(2914);
	
	var _SchoolBankAccountsManagerItem2 = _interopRequireDefault(_SchoolBankAccountsManagerItem);
	
	var _SchoolBankAccountsPendingItem = __webpack_require__(2918);
	
	var _SchoolBankAccountsPendingItem2 = _interopRequireDefault(_SchoolBankAccountsPendingItem);
	
	var _ExternalAccountResources = __webpack_require__(2555);
	
	var _ExternalAccountResources2 = _interopRequireDefault(_ExternalAccountResources);
	
	var _ConnectedBankAccounts = __webpack_require__(2561);
	
	var _ConnectedBankAccounts2 = _interopRequireDefault(_ConnectedBankAccounts);
	
	var _ConnectedBankAccountStore = __webpack_require__(2656);
	
	var _ConnectedBankAccountStore2 = _interopRequireDefault(_ConnectedBankAccountStore);
	
	var _ExternalAccountResource = __webpack_require__(2556);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BankAccountsManager = function (_React$Component) {
	  _inherits(BankAccountsManager, _React$Component);
	
	  function BankAccountsManager() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BankAccountsManager);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BankAccountsManager.__proto__ || Object.getPrototypeOf(BankAccountsManager)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
	      Promise.all([_ExternalAccountResourceActions2.default.load()]).then(function () {
	        return _this.mounted && _this.setState({ loading: false });
	      }, function () {
	        return _this.mounted && _this.setState({ loading: false });
	      });
	    }, _this.componentDidMount = function () {
	      _this.mounted = true;
	    }, _this.componentWillUnmount = function () {
	      _this.mounted = false;
	    }, _this.shouldDisplayLoadingIndicator = function () {
	      return _this.state.loading && _this.state.externalAccountResources.length <= 0 && _this.state.connectedBankAccounts.length <= 0;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BankAccountsManager, [{
	    key: 'renderConnectedBankAccounts',
	    value: function renderConnectedBankAccounts() {
	      return this.state.connectedBankAccounts.map(function (connectedBankAccount) {
	        if (connectedBankAccount.isPending() && !connectedBankAccount.getCanManage()) {
	          return _react2.default.createElement(_SchoolBankAccountsPendingItem2.default, {
	            key: connectedBankAccount.id,
	            connectedBankAccount: connectedBankAccount
	          });
	        }
	        return null;
	      });
	    }
	  }, {
	    key: 'renderBankAccounts',
	    value: function renderBankAccounts() {
	      return this.state.externalAccountResources.map(function (externalAccountResource) {
	        if (externalAccountResource.getType() === _ExternalAccountResource.INDIVIDUAL_BANK_ACCOUNT_TYPE) {
	          return _react2.default.createElement(_BankAccountsManagerItem2.default, {
	            key: externalAccountResource.getBankAccount().id,
	            bankAccount: externalAccountResource
	          });
	        } else if (externalAccountResource.getType() === _ExternalAccountResource.CONNECTED_BANK_ACCOUNT_TYPE) {
	          var connectedBankAccount = externalAccountResource.getConnectedAccount();
	          return connectedBankAccount && _react2.default.createElement(_SchoolBankAccountsManagerItem2.default, {
	            key: connectedBankAccount.id,
	            externalAccount: externalAccountResource
	          });
	        }
	        return null;
	      });
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      var _this2 = this;
	
	      if (this.shouldDisplayLoadingIndicator()) {
	        return _react2.default.createElement(_ManagerItemCard.ManagerItemPlaceholderCard, null);
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.state.connectedBankAccounts.length > 0 && this.renderConnectedBankAccounts(),
	        this.state.externalAccountResources.length > 0 && this.renderBankAccounts(),
	        _react2.default.createElement(
	          _AddButton2.default,
	          {
	            size: 'large',
	            onClick: function onClick() {
	              return (0, _modal.mountModal)(_react2.default.createElement(_LinkBankAccountModal2.default, null), _this2);
	            } },
	          'Add a bank account'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('BankAccountsManager', this.props.className) },
	        this.renderBody()
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ExternalAccountResourceStore2.default, _ConnectedBankAccountStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState) {
	      return {
	        externalAccountResources: _ExternalAccountResourceStore2.default.getExternalAccountResources(),
	        connectedBankAccounts: _ConnectedBankAccountStore2.default.getConnectedBankAccounts(),
	        loading: prevState ? prevState.loading : true
	      };
	    }
	  }]);
	
	  return BankAccountsManager;
	}(_react2.default.Component);
	
	BankAccountsManager.displayName = 'BankAccountsManager';
	exports.default = _utils.Container.create(BankAccountsManager);

/***/ },
/* 2907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ManagerItemPlaceholderCard = undefined;
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2908);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var ManagerItemCard = function ManagerItemCard(_ref) {
	  var className = _ref.className,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('ManagerItemCard', className) },
	    children
	  );
	};
	
	var ManagerItemPlaceholderCard = exports.ManagerItemPlaceholderCard = function ManagerItemPlaceholderCard(_ref2) {
	  var className = _ref2.className;
	  return _react2.default.createElement(
	    ManagerItemCard,
	    { className: (0, _classnames2.default)('ManagerItemPlaceholderCard', className) },
	    _react2.default.createElement(_LoadingIndicator2.default, null)
	  );
	};
	
	exports.default = ManagerItemCard;

/***/ },
/* 2908 */
1136,
/* 2909 */,
/* 2910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _ManagerItemCard = __webpack_require__(2907);
	
	var _ManagerItemCard2 = _interopRequireDefault(_ManagerItemCard);
	
	var _BankAccountsMenuButton = __webpack_require__(2911);
	
	var _BankAccountsMenuButton2 = _interopRequireDefault(_BankAccountsMenuButton);
	
	var _ExternalAccountResource = __webpack_require__(2556);
	
	var _ExternalAccountResource2 = _interopRequireDefault(_ExternalAccountResource);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2912);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'BankAccountsManagerItem',
	  renderPrimary: function renderPrimary() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'BankAccountsManagerItem-primary' },
	      'Primary account'
	    );
	  },
	  render: function render() {
	    var externalBankAccount = this.props.bankAccount.getBankAccount();
	    return _react2.default.createElement(
	      _ManagerItemCard2.default,
	      { className: (0, _classnames2.default)('BankAccountsManagerItem', this.props.className) },
	      _react2.default.createElement(
	        _FlexibleBlock2.default,
	        { flex: 'left' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'BankAccountsManagerItem-title' },
	            externalBankAccount.getBankName()
	          ),
	          _react2.default.createElement(
	            'table',
	            { className: 'BankAccountsManagerItem-table' },
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Routing Number:'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  externalBankAccount.getRoutingNumber()
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Account Number:'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Last four digits',
	                  ' ',
	                  externalBankAccount.getAccountNumberLastFourDigits()
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          externalBankAccount.isDefaultForCurrency() && this.renderPrimary(),
	          !externalBankAccount.isDefaultForCurrency() && _react2.default.createElement(_BankAccountsMenuButton2.default, { bankAccount: this.props.bankAccount })
	        )
	      )
	    );
	  }
	});

/***/ },
/* 2911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExternalAccountResource = __webpack_require__(2556);
	
	var _ExternalAccountResource2 = _interopRequireDefault(_ExternalAccountResource);
	
	var _ExternalAccountResourceActions = __webpack_require__(2553);
	
	var _ExternalAccountResourceActions2 = _interopRequireDefault(_ExternalAccountResourceActions);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuButton = __webpack_require__(1604);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _ModalMenuItem = __webpack_require__(1595);
	
	var _ModalMenuItem2 = _interopRequireDefault(_ModalMenuItem);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BankAccountMenuButton = function (_React$Component) {
	  _inherits(BankAccountMenuButton, _React$Component);
	
	  function BankAccountMenuButton() {
	    _classCallCheck(this, BankAccountMenuButton);
	
	    return _possibleConstructorReturn(this, (BankAccountMenuButton.__proto__ || Object.getPrototypeOf(BankAccountMenuButton)).apply(this, arguments));
	  }
	
	  _createClass(BankAccountMenuButton, [{
	    key: 'setBankAccountPrimary',
	    value: function setBankAccountPrimary() {
	      _ExternalAccountResourceActions2.default.makePrimary(this.props.bankAccount).then(function () {
	        return _ToastActions2.default.showSuccessToast('Primary bank account updated');
	      }, function () {
	        return _ToastActions2.default.showDefaultErrorToast();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var confirmDialog = _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'BankAccountMenuButton',
	        title: 'Are you sure you want to delete this bank account?',
	        actionButtonText: 'Yes',
	        cancelButtonText: 'No',
	        onConfirm: function onConfirm() {
	          _ExternalAccountResourceActions2.default.delete(_this2.props.bankAccount).then(function () {
	            return _ToastActions2.default.showSuccessToast('Bank account removed');
	          }, function () {
	            return _ToastActions2.default.showDefaultErrorToast();
	          });
	        }
	      });
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        null,
	        _react2.default.createElement(
	          _ModalMenuItem2.default,
	          { modal: confirmDialog },
	          'Remove bank account'
	        ),
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: function onClick() {
	              return _this2.setBankAccountPrimary();
	            } },
	          'Set as primary'
	        )
	      );
	
	      return _react2.default.createElement(
	        _MenuButton2.default,
	        {
	          alignment: 'right',
	          placement: 'bottom',
	          menu: menu,
	          size: 'small',
	          level: 'icon' },
	        _react2.default.createElement(_Glyph2.default, { name: 'ellipses', solo: true })
	      );
	    }
	  }]);
	
	  return BankAccountMenuButton;
	}(_react2.default.Component);
	
	BankAccountMenuButton.displayName = 'BankAccountMenuButton';
	exports.default = BankAccountMenuButton;

/***/ },
/* 2912 */
1136,
/* 2913 */,
/* 2914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ManagerItemCard = __webpack_require__(2907);
	
	var _ManagerItemCard2 = _interopRequireDefault(_ManagerItemCard);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _BankAccountsMenuButton = __webpack_require__(2911);
	
	var _BankAccountsMenuButton2 = _interopRequireDefault(_BankAccountsMenuButton);
	
	var _ExternalAccountResource = __webpack_require__(2556);
	
	var _ExternalAccountResource2 = _interopRequireDefault(_ExternalAccountResource);
	
	__webpack_require__(2915);
	
	__webpack_require__(2912);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchoolBankAccountsManagerItem = function (_React$Component) {
	  _inherits(SchoolBankAccountsManagerItem, _React$Component);
	
	  function SchoolBankAccountsManagerItem() {
	    _classCallCheck(this, SchoolBankAccountsManagerItem);
	
	    return _possibleConstructorReturn(this, (SchoolBankAccountsManagerItem.__proto__ || Object.getPrototypeOf(SchoolBankAccountsManagerItem)).apply(this, arguments));
	  }
	
	  _createClass(SchoolBankAccountsManagerItem, [{
	    key: 'renderPrimary',
	    value: function renderPrimary() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'BankAccountsManagerItem-primary' },
	        'Primary account'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var externalAccount = this.props.externalAccount;
	
	      var externalBankAccount = externalAccount.getBankAccount();
	      var connectedBankAccount = externalAccount.getConnectedAccount();
	      var organizationName = connectedBankAccount.getOrganizationName();
	
	      var displayName = organizationName ? organizationName + ' account' : connectedBankAccount.getOwnerName();
	
	      return _react2.default.createElement(
	        _ManagerItemCard2.default,
	        { className: (0, _classnames2.default)('SchoolBankAccountsManagerItem', this.props.className) },
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'left' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Image2.default, {
	              className: 'SchoolBankAccountsManagerItem-image',
	              src: __webpack_require__(2917)
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'SchoolBankAccountsManagerItem-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'SchoolBankAccountsManagerItem-title' },
	                _react2.default.createElement(
	                  _Text2.default,
	                  { size: 'large' },
	                  displayName
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _Text2.default,
	                    {
	                      size: 'xsmall',
	                      className: 'SchoolBankAccountsManagerItem-label',
	                      color: 'thunder' },
	                    'Account admin name:'
	                  ),
	                  _react2.default.createElement(
	                    _Text2.default,
	                    { size: 'xsmall', color: 'thunder' },
	                    connectedBankAccount.getOwnerName()
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _Text2.default,
	                    {
	                      size: 'xsmall',
	                      className: 'SchoolBankAccountsManagerItem-label',
	                      color: 'thunder' },
	                    'Account admin email:'
	                  ),
	                  _react2.default.createElement(
	                    _Text2.default,
	                    { size: 'xsmall', color: 'thunder' },
	                    connectedBankAccount.getOwnerAddress()
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            externalBankAccount.isDefaultForCurrency() && this.renderPrimary(),
	            !externalBankAccount.isDefaultForCurrency() && _react2.default.createElement(_BankAccountsMenuButton2.default, { bankAccount: externalAccount })
	          )
	        )
	      );
	    }
	  }]);
	
	  return SchoolBankAccountsManagerItem;
	}(_react2.default.Component);
	
	SchoolBankAccountsManagerItem.displayName = 'SchoolBankAccountsManagerItem';
	exports.default = SchoolBankAccountsManagerItem;

/***/ },
/* 2915 */
1136,
/* 2916 */,
/* 2917 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzYgMzAiPjxwYXRoIGQ9Im0zNC4zIDE3LjZoLTYuNnYtMmMwLS41LS4yLS45LS42LTEuMmwtMi43LTJ2LTUuN2wxLjkgMS40LjYtLjgtOC45LTYuNS04LjkgNi42LjYuOCAxLjktMS40djUuN2wtMi43IDJjLS40LjMtLjYuNy0uNiAxLjJ2MmgtNi42Yy0uOCAwLTEuNC43LTEuNCAxLjV2MTAuMWgxNy43IDEuNCAxNi4zdi0xMC4yYy4xLS44LS42LTEuNS0xLjQtMS41bS0yNC44LTIuNGwzLjEtMi4zdi02LjlsNS40LTQgNS40IDR2Ni45bDMuMSAyLjNjLjEuMS4yLjIuMi40djEyLjZoLTQuOHYtOS4xYzAtLjgtLjYtMS41LTEuNC0xLjVoLTEuOC0uNy0yLjVjLS44IDAtMS40LjctMS40IDEuNXY5LjFoLTQuOHYtMTIuNmMwLS4yLjEtLjMuMi0uNG0tOC4zIDMuOWMwLS4zLjItLjUuNC0uNWg2LjZ2OS42aC03di05LjFtMTYuOCA5LjFoLTIuOXYtOS4xYzAtLjMuMi0uNS40LS41aDIuNS43IDEuOGMuMiAwIC40LjIuNC41djkuMWgtMS41LTEuNG0xNi44IDBoLTcuMXYtOS42aDYuNmMuMiAwIC40LjIuNC41djkuMXoiLz48ZWxsaXBzZSBjeD0iMTgiIGN5PSI5LjkiIHJ4PSIyIiByeT0iMiIvPjwvc3ZnPg=="

/***/ },
/* 2918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _ManagerItemCard = __webpack_require__(2907);
	
	var _ManagerItemCard2 = _interopRequireDefault(_ManagerItemCard);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	__webpack_require__(2919);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SchoolBankAccountsPendingItem = function (_React$Component) {
	  _inherits(SchoolBankAccountsPendingItem, _React$Component);
	
	  function SchoolBankAccountsPendingItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SchoolBankAccountsPendingItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SchoolBankAccountsPendingItem.__proto__ || Object.getPrototypeOf(SchoolBankAccountsPendingItem)).call.apply(_ref, [this].concat(args))), _this), _this.invite = function () {
	      var id = _this.props.connectedBankAccount.id;
	
	      _RemindAPI2.default.request('/payments/connected_bank_accounts/' + id + '/resend_request', 'POST').then(function () {
	        _ToastActions2.default.showSuccessToast('Invitation sent');
	      }, function (error) {
	        if (error && error.code === 'throttling_error') {
	          _ToastActions2.default.showErrorToast('Oops, you can only reinvite once per day.');
	        } else {
	          _ToastActions2.default.showErrorToast('Oops, an unknow error happened.');
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SchoolBankAccountsPendingItem, [{
	    key: 'render',
	    value: function render() {
	      var connectedBankAccount = this.props.connectedBankAccount;
	
	      var organizationName = connectedBankAccount.getOrganizationName();
	
	      return _react2.default.createElement(
	        _ManagerItemCard2.default,
	        { className: (0, _classnames2.default)('SchoolBankAccountsPendingItem', this.props.className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'SchoolBankAccountsPendingItem-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'SchoolBankAccountsPendingItem-info' },
	            _react2.default.createElement(_Image2.default, {
	              className: 'SchoolBankAccountsPendingItem-image',
	              src: __webpack_require__(2917)
	            }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'SchoolBankAccountsPendingItem-title' },
	                _react2.default.createElement(
	                  _Text2.default,
	                  { size: 'large' },
	                  organizationName || connectedBankAccount.getOwnerName()
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _Text2.default,
	                  { color: 'sunrise' },
	                  'Pending deposit approval'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _Text2.default,
	                    {
	                      size: 'xsmall',
	                      className: 'SchoolBankAccountsPendingItem-label',
	                      color: 'thunder' },
	                    'Account admin name:'
	                  ),
	                  _react2.default.createElement(
	                    _Text2.default,
	                    { size: 'xsmall', color: 'thunder' },
	                    connectedBankAccount.getOwnerName()
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _Text2.default,
	                    {
	                      size: 'xsmall',
	                      className: 'SchoolBankAccountsPendingItem-label',
	                      color: 'thunder' },
	                    'Account admin email:'
	                  ),
	                  _react2.default.createElement(
	                    _Text2.default,
	                    { size: 'xsmall', color: 'thunder' },
	                    connectedBankAccount.getOwnerAddress()
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Button2.default,
	              { color: 'sunrise', onClick: this.invite, level: 'secondary', size: 'small' },
	              'Reinvite'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SchoolBankAccountsPendingItem;
	}(_react2.default.Component);
	
	SchoolBankAccountsPendingItem.displayName = 'SchoolBankAccountsPendingItem';
	exports.default = SchoolBankAccountsPendingItem;

/***/ },
/* 2919 */
1136,
/* 2920 */,
/* 2921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LinkedAccountsTableRow = __webpack_require__(2922);
	
	var _LinkedAccountsTableRow2 = _interopRequireDefault(_LinkedAccountsTableRow);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	__webpack_require__(2925);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	function LinkedAccountsTable(props) {
	  return _react2.default.createElement(
	    'table',
	    { className: 'LinkedAccountsTable' },
	    _react2.default.createElement(
	      'thead',
	      null,
	      _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          'Name'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Bank account'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'tbody',
	      null,
	      props.bankAccounts.map(function (bankAccount) {
	        if (!bankAccount.isApproved()) {
	          return null;
	        }
	
	        return _react2.default.createElement(_LinkedAccountsTableRow2.default, { key: bankAccount.id, bankAccount: bankAccount });
	      })
	    )
	  );
	}
	
	exports.default = LinkedAccountsTable;

/***/ },
/* 2922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ConnectedBankAccountActions = __webpack_require__(2559);
	
	var _ConnectedBankAccountActions2 = _interopRequireDefault(_ConnectedBankAccountActions);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _MenuButton = __webpack_require__(1604);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(2923);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkedAccountsTableRow = function (_React$Component) {
	  _inherits(LinkedAccountsTableRow, _React$Component);
	
	  function LinkedAccountsTableRow() {
	    _classCallCheck(this, LinkedAccountsTableRow);
	
	    return _possibleConstructorReturn(this, (LinkedAccountsTableRow.__proto__ || Object.getPrototypeOf(LinkedAccountsTableRow)).apply(this, arguments));
	  }
	
	  _createClass(LinkedAccountsTableRow, [{
	    key: 'revokeAccess',
	    value: function revokeAccess() {
	      _ConnectedBankAccountActions2.default.revokeAccess(this.props.bankAccount).then(function () {
	        return _ToastActions2.default.showSuccessToast('Bank account revoked');
	      }, function () {
	        return _ToastActions2.default.showErrorToast('Bank account revoke failed');
	      }).then(function () {
	        return _ConnectedBankAccountActions2.default.load();
	      });
	    }
	  }, {
	    key: 'renderMenuButton',
	    value: function renderMenuButton() {
	      var _this2 = this;
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        null,
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: function onClick() {
	              return _this2.revokeAccess();
	            } },
	          _react2.default.createElement(_Glyph2.default, { color: 'lava', name: 'trash' }),
	          _react2.default.createElement(
	            _Text2.default,
	            { color: 'lava' },
	            'Revoke approval'
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        _MenuButton2.default,
	        {
	          alignment: 'right',
	          placement: 'bottom',
	          menu: menu,
	          size: 'xsmall',
	          level: 'secondary' },
	        _react2.default.createElement(_Glyph2.default, { name: 'ellipses', solo: true })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var bankAccount = this.props.bankAccount;
	
	      var externalAccount = bankAccount.getExternalAccount();
	
	      return _react2.default.createElement(
	        'tr',
	        { className: 'LinkedAccountsTableRow' },
	        _react2.default.createElement(
	          'td',
	          null,
	          bankAccount.getConnectedUserName()
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'LinkedAccountsTableRow-actions' },
	            _react2.default.createElement(
	              'div',
	              null,
	              externalAccount ? externalAccount.getName() : 'No bank name given'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              this.renderMenuButton()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LinkedAccountsTableRow;
	}(_react2.default.Component);
	
	LinkedAccountsTableRow.displayName = 'LinkedAccountsTableRow';
	exports.default = LinkedAccountsTableRow;

/***/ },
/* 2923 */
1136,
/* 2924 */,
/* 2925 */
1136,
/* 2926 */,
/* 2927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AddButton = __webpack_require__(1894);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _PaymentSourceActions = __webpack_require__(1973);
	
	var _PaymentSourceActions2 = _interopRequireDefault(_PaymentSourceActions);
	
	var _PaymentSourceStore = __webpack_require__(1977);
	
	var _PaymentSourceStore2 = _interopRequireDefault(_PaymentSourceStore);
	
	var _AddPaymentSourceModal = __webpack_require__(2928);
	
	var _AddPaymentSourceModal2 = _interopRequireDefault(_AddPaymentSourceModal);
	
	var _PaymentCardsManagerItem = __webpack_require__(2932);
	
	var _PaymentCardsManagerItem2 = _interopRequireDefault(_PaymentCardsManagerItem);
	
	var _ManagerItemCard = __webpack_require__(2907);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	exports.default = _react2.default.createClass({
	  displayName: 'PaymentCardsManager',
	
	  mixins: [(0, _linkStateWithStores2.default)([_PaymentSourceStore2.default])],
	
	  getInitialState: function getInitialState() {
	    return Object.assign({ loading: true }, this.getStateFromStores());
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    _PaymentSourceActions2.default.load().then(function () {
	      return _this.setState({ loading: false });
	    }, function () {
	      return _this.setState({ loading: false });
	    });
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      paymentSources: _PaymentSourceStore2.default.getPaymentSources()
	    };
	  },
	  shouldDisplayLoadingIndicator: function shouldDisplayLoadingIndicator() {
	    return this.state.loading && this.state.paymentSources.length <= 0;
	  },
	  renderCards: function renderCards() {
	    return this.state.paymentSources.map(function (paymentSource) {
	      return _react2.default.createElement(_PaymentCardsManagerItem2.default, {
	        key: paymentSource.id,
	        paymentSource: paymentSource
	      });
	    });
	  },
	  renderBody: function renderBody() {
	    var _this2 = this;
	
	    if (this.shouldDisplayLoadingIndicator()) {
	      return _react2.default.createElement(_ManagerItemCard.ManagerItemPlaceholderCard, null);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.state.paymentSources.length > 0 && this.renderCards(),
	      _react2.default.createElement(
	        _AddButton2.default,
	        {
	          size: 'large',
	          onClick: function onClick() {
	            return (0, _modal.mountModal)(_react2.default.createElement(_AddPaymentSourceModal2.default, null), _this2);
	          } },
	        'Add a credit or debit card'
	      )
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('PaymentCardsManager', this.props.className) },
	      this.renderBody()
	    );
	  }
	});

/***/ },
/* 2928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _PaymentSourceForm = __webpack_require__(2929);
	
	var _PaymentSourceForm2 = _interopRequireDefault(_PaymentSourceForm);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /*  weak */
	
	
	var AddPaymentSourceModal = _react2.default.createClass({
	  displayName: 'AddPaymentSourceModal',
	  onPaymentSourceAdded: function onPaymentSourceAdded(paymentSource) {
	    this.props.onRequestHide();
	    _ToastActions2.default.showSuccessToast('Card created');
	    if (this.props.onPaymentSourceAdded) {
	      this.props.onPaymentSourceAdded(paymentSource);
	    }
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        rest = _objectWithoutProperties(_props, ['className']);
	
	    return _react2.default.createElement(
	      _Dialog2.default,
	      _extends({
	        eventScreenName: 'AddPaymentSourceModal'
	      }, rest, {
	        size: 'medium',
	        className: (0, _classnames2.default)('AddPaymentSourceModal', className) }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(_TitleHeader2.default, { title: 'Add a credit or debit card' }),
	        _react2.default.createElement(_PaymentSourceForm2.default, { onCreated: this.onPaymentSourceAdded })
	      )
	    );
	  }
	});
	
	exports.default = AddPaymentSourceModal;

/***/ },
/* 2929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DecoratedInput = __webpack_require__(1961);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CardInput = __webpack_require__(1964);
	
	var _CardInput2 = _interopRequireDefault(_CardInput);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PaymentSourceActions = __webpack_require__(1973);
	
	var _PaymentSourceActions2 = _interopRequireDefault(_PaymentSourceActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _StripeAPI = __webpack_require__(1979);
	
	var _StripeAPI2 = _interopRequireDefault(_StripeAPI);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _EncryptionNotice = __webpack_require__(1970);
	
	var _EncryptionNotice2 = _interopRequireDefault(_EncryptionNotice);
	
	__webpack_require__(2930);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentSourceForm = _react2.default.createClass({
	  displayName: 'PaymentSourceForm',
	  getInitialState: function getInitialState() {
	    return {
	      card: null,
	      loadingScript: true
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    _StripeAPI2.default.setPublishableKey(_SettingsStore2.default.getStripeKey()).then(this.handleScriptLoaded, this.handleScriptError);
	  },
	  onSubmit: function onSubmit() {
	    var _this = this;
	
	    _StripeAPI2.default.createCardToken({
	      number: this.state.card.number.value,
	      cvc: this.state.card.cvc.value,
	      exp: this.state.card.expiry.value,
	      address_zip: this.state.card.zip.value
	    }, function (status, response) {
	      if (response.error) {
	        _ToastActions2.default.showErrorToast(response.error.message);
	      } else {
	        _this.createdPaymentSourceFromToken(response.id);
	      }
	    });
	  },
	  createdPaymentSourceFromToken: function createdPaymentSourceFromToken(token) {
	    _PaymentSourceActions2.default.create(token).then(this.props.onCreated, _ToastActions2.default.showAPIError);
	  },
	  handleScriptError: function handleScriptError() {
	    // TODO
	  },
	  handleScriptLoaded: function handleScriptLoaded() {
	    this.setState({ loadingScript: false });
	  },
	  renderCardInput: function renderCardInput() {
	    var _this2 = this;
	
	    if (this.state.loadingScript) {
	      return _react2.default.createElement(_DecoratedInput.LoadingInput, null);
	    }
	
	    return _react2.default.createElement(_CardInput2.default, {
	      placeholder: 'Enter your debit or credit card',
	      onValid: function onValid(card) {
	        return _this2.setState({ card: card });
	      },
	      onInvalid: function onInvalid() {
	        return _this2.setState({ card: null });
	      }
	    });
	  },
	  render: function render() {
	    var className = this.props.className;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('PaymentSourceForm', className) },
	      this.renderCardInput(),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'PaymentSourceForm-submit',
	          onClick: this.onSubmit,
	          disabled: !this.state.card,
	          eventElementName: 'PaymentSourceForm-submit' },
	        'Add card'
	      ),
	      _react2.default.createElement(_EncryptionNotice2.default, { className: 'PaymentSourceForm-notice' })
	    );
	  }
	}); /*  weak */
	exports.default = PaymentSourceForm;

/***/ },
/* 2930 */
1136,
/* 2931 */,
/* 2932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CardLogo = __webpack_require__(2933);
	
	var _CardLogo2 = _interopRequireDefault(_CardLogo);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ManagerItemCard = __webpack_require__(2907);
	
	var _ManagerItemCard2 = _interopRequireDefault(_ManagerItemCard);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuButton = __webpack_require__(1604);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _ModalMenuItem = __webpack_require__(1595);
	
	var _ModalMenuItem2 = _interopRequireDefault(_ModalMenuItem);
	
	var _PaymentSource = __webpack_require__(1976);
	
	var _PaymentSource2 = _interopRequireDefault(_PaymentSource);
	
	var _PaymentSourceActions = __webpack_require__(1973);
	
	var _PaymentSourceActions2 = _interopRequireDefault(_PaymentSourceActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(2939);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'PaymentCardsManagerItem',
	  renderMenuButton: function renderMenuButton() {
	    var _this = this;
	
	    var confirmDialog = _react2.default.createElement(_ConfirmDialog2.default, {
	      title: 'Are you sure you want to delete this payment card?',
	      actionButtonText: 'Yes',
	      cancelButtonText: 'No',
	      onConfirm: function onConfirm() {
	        _PaymentSourceActions2.default.delete(_this.props.paymentSource).then(function () {
	          return _ToastActions2.default.showSuccessToast('Payment card removed');
	        }, function () {
	          return _ToastActions2.default.showDefaultErrorToast();
	        });
	      }
	    });
	
	    var menu = _react2.default.createElement(
	      _Menu2.default,
	      null,
	      _react2.default.createElement(
	        _ModalMenuItem2.default,
	        { modal: confirmDialog },
	        'Remove Card'
	      )
	    );
	
	    return _react2.default.createElement(
	      _MenuButton2.default,
	      {
	        alignment: 'right',
	        placement: 'bottom',
	        menu: menu,
	        size: 'medium',
	        level: 'icon' },
	      _react2.default.createElement(_Glyph2.default, { name: 'ellipses', solo: true })
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _ManagerItemCard2.default,
	      { className: (0, _classnames2.default)('PaymentCardsManagerItem', this.props.className) },
	      _react2.default.createElement(
	        _FlexibleBlock2.default,
	        { flex: 'left' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _FlexibleBlock2.default,
	            { flex: 'right' },
	            _react2.default.createElement(
	              'div',
	              { className: 'PaymentCardsManagerItem-logo' },
	              _react2.default.createElement(_CardLogo2.default, { paymentSource: this.props.paymentSource })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'PaymentCardsManagerItem-title' },
	                this.props.paymentSource.getBrand(),
	                ' ending in ',
	                ' ',
	                this.props.paymentSource.getLastFourDigit()
	              ),
	              _react2.default.createElement(
	                'table',
	                { className: 'PaymentCardsManagerItem-table' },
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      'Expiration Date:'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      this.props.paymentSource.getExpirationDate()
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'PaymentCardsManagerItem-actions' },
	          this.renderMenuButton()
	        )
	      )
	    );
	  }
	});

/***/ },
/* 2933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _PaymentSource = __webpack_require__(1976);
	
	var _PaymentSource2 = _interopRequireDefault(_PaymentSource);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cc_other = __webpack_require__(2934);
	
	var _cc_other2 = _interopRequireDefault(_cc_other);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IMAGES = {
	  'american express': __webpack_require__(2935),
	  discover: __webpack_require__(2936),
	  mastercard: __webpack_require__(2937),
	  visa: __webpack_require__(2938)
	};
	
	exports.default = _react2.default.createClass({
	  displayName: 'CardLogo',
	  render: function render() {
	    var _props = this.props,
	        paymentSource = _props.paymentSource,
	        rest = _objectWithoutProperties(_props, ['paymentSource']);
	
	    var match = IMAGES[paymentSource.getBrand().toLowerCase()];
	    var source = match || _cc_other2.default;
	
	    return _react2.default.createElement(_Image2.default, _extends({ src: source }, rest));
	  }
	});

/***/ },
/* 2934 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2935 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2936 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2937 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2938 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 2939 */
1136,
/* 2940 */,
/* 2941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WalletTabSection = function WalletTabSection(_ref) {
	  var className = _ref.className,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? '' : _ref$title,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('WalletTabSection', className) },
	    _react2.default.createElement(_Legend2.default, { text: title }),
	    children
	  );
	}; /*  weak */
	exports.default = WalletTabSection;

/***/ },
/* 2942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ActivityTransactionsTable = __webpack_require__(2943);
	
	var _ActivityTransactionsTable2 = _interopRequireDefault(_ActivityTransactionsTable);
	
	var _utils = __webpack_require__(956);
	
	var _promise = __webpack_require__(1041);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TransactionActions = __webpack_require__(1997);
	
	var _TransactionActions2 = _interopRequireDefault(_TransactionActions);
	
	var _TransactionsListNuxSection = __webpack_require__(2956);
	
	var _TransactionsListNuxSection2 = _interopRequireDefault(_TransactionsListNuxSection);
	
	var _TransactionStore = __webpack_require__(2960);
	
	var _TransactionStore2 = _interopRequireDefault(_TransactionStore);
	
	var _WalletTabLoader = __webpack_require__(2687);
	
	var _WalletTabLoader2 = _interopRequireDefault(_WalletTabLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransactionsListContainer = function (_Component) {
	  _inherits(TransactionsListContainer, _Component);
	
	  function TransactionsListContainer() {
	    _classCallCheck(this, TransactionsListContainer);
	
	    return _possibleConstructorReturn(this, (TransactionsListContainer.__proto__ || Object.getPrototypeOf(TransactionsListContainer)).apply(this, arguments));
	  }
	
	  _createClass(TransactionsListContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var onError = function onError(reason) {
	        if (reason && reason.isCanceled) {
	          return;
	        }
	
	        _this2.setState({ errored: true });
	        throw reason;
	      };
	
	      var promise = _TransactionActions2.default.loadTransactions();
	      this.cancelable = (0, _promise.makeCancelable)(promise);
	      this.cancelable.promise.then(function () {
	        return _this2.setState({ loading: false });
	      }).catch(onError);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.cancelable.cancel();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.errored) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          'An error happened'
	        );
	      }
	
	      if (this.state.loading && this.state.transactions.length === 0) {
	        return _react2.default.createElement(_WalletTabLoader2.default, null);
	      }
	
	      if (this.state.transactions.length === 0) {
	        return _react2.default.createElement(_TransactionsListNuxSection2.default, null);
	      }
	
	      return _react2.default.createElement(_ActivityTransactionsTable2.default, { transactions: this.state.transactions });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_TransactionStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(state) {
	      return {
	        errored: state ? state.errored : false,
	        loading: state ? state.loading : true,
	        transactions: _TransactionStore2.default.getTransactions()
	      };
	    }
	  }]);
	
	  return TransactionsListContainer;
	}(_react.Component);
	
	TransactionsListContainer.displayName = 'TransactionsListContainer';
	exports.default = _utils.Container.create(TransactionsListContainer);

/***/ },
/* 2943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Transactions = __webpack_require__(981);
	
	var _Transactions2 = _interopRequireDefault(_Transactions);
	
	var _TransactionsTableRow = __webpack_require__(2944);
	
	var _TransactionsTableRow2 = _interopRequireDefault(_TransactionsTableRow);
	
	var _TransactionsTableDepositRow = __webpack_require__(2952);
	
	var _TransactionsTableDepositRow2 = _interopRequireDefault(_TransactionsTableDepositRow);
	
	var _Transaction = __webpack_require__(982);
	
	__webpack_require__(2950);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var ActivityTransactionsTable = function (_Component) {
	  _inherits(ActivityTransactionsTable, _Component);
	
	  function ActivityTransactionsTable() {
	    _classCallCheck(this, ActivityTransactionsTable);
	
	    return _possibleConstructorReturn(this, (ActivityTransactionsTable.__proto__ || Object.getPrototypeOf(ActivityTransactionsTable)).apply(this, arguments));
	  }
	
	  _createClass(ActivityTransactionsTable, [{
	    key: 'renderTransaction',
	    value: function renderTransaction(transaction) {
	      switch (transaction.getType()) {
	        case _Transaction.TYPE_WITHDRAWAL:
	          return _react2.default.createElement(_TransactionsTableDepositRow2.default, {
	            key: transaction.getUuid(),
	            transaction: transaction
	          });
	        case _Transaction.TYPE_PAYMENT_RECEIVED:
	        case _Transaction.TYPE_PAYMENT_SENT:
	        case _Transaction.TYPE_REFUND_SENT:
	          return _react2.default.createElement(_TransactionsTableRow2.default, { key: transaction.getUuid(), transaction: transaction });
	        default:
	          console.error('Unknown Transaction Status: ' + transaction.getType());
	          return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ActivityTable', this.props.className) },
	        _react2.default.createElement(
	          'table',
	          { className: 'EventDetailsTables' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'Name'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Note'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Date'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Amount'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            this.props.transactions.map(this.renderTransaction)
	          )
	        )
	      );
	    }
	  }]);
	
	  return ActivityTransactionsTable;
	}(_react.Component);
	
	ActivityTransactionsTable.displayName = 'ActivityTransactionsTable';
	exports.default = ActivityTransactionsTable;

/***/ },
/* 2944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableRowUserName = __webpack_require__(2945);
	
	var _TableRowUserName2 = _interopRequireDefault(_TableRowUserName);
	
	var _TransactionAmount = __webpack_require__(2948);
	
	var _TransactionAmount2 = _interopRequireDefault(_TransactionAmount);
	
	var _Refund = __webpack_require__(2949);
	
	var _Refund2 = _interopRequireDefault(_Refund);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _Transaction = __webpack_require__(982);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(2950);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TransactionsTableRow(props) {
	  var transaction = props.transaction;
	
	
	  var sent = transaction.isRefundSent();
	  var user = sent ? transaction.getPaidTo() : transaction.getPayer();
	
	  return _react2.default.createElement(
	    'tr',
	    { className: 'ActivityTable-row' },
	    _react2.default.createElement(
	      'td',
	      null,
	      _react2.default.createElement(_TableRowUserName2.default, { user: user })
	    ),
	    _react2.default.createElement(
	      'td',
	      { className: 'ActivityTable-row-note' },
	      transaction.getPaymentMadeFor()
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      _react2.default.createElement(_Time2.default, {
	        date: transaction.getCreatedAt(),
	        day: 'numeric',
	        month: 'short'
	      })
	    ),
	    _react2.default.createElement(
	      'td',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'ActivityTable-row-amount' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_TransactionAmount2.default, { transaction: transaction })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          transaction.isRefundable() && _react2.default.createElement(
	            _Refund2.default,
	            { transaction: transaction },
	            function (refund, proccessing) {
	              return proccessing ? _react2.default.createElement(_LoadingIndicator2.default, { size: 'xsmall', color: 'lava' }) : _react2.default.createElement(
	                _Button2.default,
	                {
	                  color: 'lava',
	                  size: 'xsmall',
	                  level: 'text',
	                  onClick: refund,
	                  disabled: proccessing },
	                'Refund'
	              );
	            }
	          )
	        )
	      )
	    )
	  );
	}
	exports.default = TransactionsTableRow;

/***/ },
/* 2945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _RelatedUserSummary = __webpack_require__(909);
	
	var _RelatedUserSummary2 = _interopRequireDefault(_RelatedUserSummary);
	
	__webpack_require__(2946);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var TableRowUserName = function (_Component) {
	  _inherits(TableRowUserName, _Component);
	
	  function TableRowUserName() {
	    _classCallCheck(this, TableRowUserName);
	
	    return _possibleConstructorReturn(this, (TableRowUserName.__proto__ || Object.getPrototypeOf(TableRowUserName)).apply(this, arguments));
	  }
	
	  _createClass(TableRowUserName, [{
	    key: 'render',
	    value: function render() {
	      var user = this.props.user;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'TableRowUserName' },
	        _react2.default.createElement(_Avatar2.default, {
	          className: 'TableRowUserName-droplet',
	          text: user ? user.getInitials() : '?',
	          colorHex: user ? user.getColor() : 'ffffff',
	          color: !user || !user.getColor() ? 'fullGrey' : null,
	          size: 'small'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'TableRowUserName-name' },
	          _react2.default.createElement(
	            _Text2.default,
	            { className: 'TableRowUserName-text', color: 'pitch' },
	            user ? user.getDisplayName() : '-'
	          )
	        )
	      );
	    }
	  }]);
	
	  return TableRowUserName;
	}(_react.Component);
	
	TableRowUserName.defaultProps = {
	  user: null
	};
	TableRowUserName.displayName = 'TableRowUserName';
	exports.default = TableRowUserName;

/***/ },
/* 2946 */
1136,
/* 2947 */,
/* 2948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Transaction = __webpack_require__(982);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Timestamp = __webpack_require__(1683);
	
	var _Timestamp2 = _interopRequireDefault(_Timestamp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransactionAmount = function TransactionAmount(props) {
	  var transaction = props.transaction;
	
	
	  var prefix = null;
	  var sufix = null;
	  var color = null;
	
	  if (transaction.isWithdrawal()) {
	    prefix = 'Deposited';
	  }
	
	  if (transaction.isRefundSent()) {
	    prefix = 'Refunded';
	    color = 'lava';
	  }
	
	  if (transaction.isPaymentSent()) {
	    prefix = 'Paid';
	    color = 'lava';
	  }
	
	  if (transaction.isPaymentReceived()) {
	    prefix = 'Received';
	    color = 'jungle';
	
	    if (transaction.getRefundedTransactionUUID()) {
	      sufix = '(refunded)';
	    }
	  }
	
	  if (transaction.isPending()) {
	    sufix = '(pending)';
	    color = 'koala';
	  }
	
	  var amount = _react2.default.createElement(
	    _Text2.default,
	    _extends({}, props, { color: color }),
	    prefix,
	    ' ',
	    _react2.default.createElement(_Money2.default, { cents: transaction.getAmount() }),
	    ' ',
	    sufix
	  );
	
	  if (transaction.isPending() && transaction.getAvailableAt()) {
	    var tooltipText = new Date().toDateString() === transaction.getAvailableAt().toDateString() ? 'Transaction will be completed' : 'Transaction will be completed on';
	
	    var tooltip = _react2.default.createElement(
	      _Tooltip2.default,
	      null,
	      _react2.default.createElement(
	        _Text2.default,
	        { weight: 'light' },
	        tooltipText,
	        ' ',
	        _react2.default.createElement(_Timestamp2.default, { date: transaction.getAvailableAt() })
	      )
	    );
	
	    return _react2.default.createElement(
	      _LayerTrigger2.default,
	      { layer: tooltip, trigger: 'hover', placement: 'bottom' },
	      _react2.default.createElement(
	        'span',
	        null,
	        ' ',
	        amount
	      )
	    );
	  }
	
	  return amount;
	};
	
	exports.default = TransactionAmount;

/***/ },
/* 2949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Refund = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transaction = __webpack_require__(982);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _modal = __webpack_require__(1188);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _TransactionActions = __webpack_require__(1997);
	
	var _TransactionActions2 = _interopRequireDefault(_TransactionActions);
	
	var _toasts = __webpack_require__(948);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function RefundConfirmDialog(props) {
	  var transaction = props.transaction,
	      onConfirm = props.onConfirm,
	      rest = _objectWithoutProperties(props, ['transaction', 'onConfirm']);
	
	  var title = _react2.default.createElement(
	    'span',
	    null,
	    'Are you sure you want to refund ',
	    _react2.default.createElement(_Money2.default, { cents: transaction.getAmount() }),
	    'to ',
	    transaction.getPayer().getDisplayName(),
	    '?'
	  );
	
	  return _react2.default.createElement(_ConfirmDialog2.default, _extends({
	    eventScreenName: 'Refund'
	  }, rest, {
	    title: title,
	    onConfirm: onConfirm,
	    subtext: 'This operation cannot be undone'
	  }));
	}
	
	var Refund = function (_React$Component) {
	  _inherits(Refund, _React$Component);
	
	  function Refund() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Refund);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Refund.__proto__ || Object.getPrototypeOf(Refund)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      proccessing: false
	    }, _this.onConfirm = function () {
	      var activityId = _this.props.transaction.getActivity().id;
	      var transactionId = _this.props.transaction.id;
	
	      _this.setState({ proccessing: true });
	
	      _TransactionActions2.default.refund(activityId, transactionId).then(function () {
	        return _this.props.showToast('Refund sent', 'success');
	      }, function () {
	        return _this.props.showToast('Oops, an unknow error happened.', 'error');
	      }).then(function () {
	        return _this.setState({ proccessing: false });
	      });
	    }, _this.refund = function () {
	      var modal = _react2.default.createElement(RefundConfirmDialog, {
	        transaction: _this.props.transaction,
	        onConfirm: _this.onConfirm
	      });
	
	      (0, _modal.mountModal)(modal, _this);
	    }, _this.noop = function () {}, _this.render = function () {
	      return (_this.props.children || _this.noop)(_this.refund, _this.state.proccessing);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return Refund;
	}(_react2.default.Component);
	
	Refund.displayName = 'Refund';
	
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ showToast: _toasts.showToast }, dispatch);
	}
	
	exports.Refund = Refund;
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(Refund);

/***/ },
/* 2950 */
1136,
/* 2951 */,
/* 2952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transaction = __webpack_require__(982);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _TransactionAmount = __webpack_require__(2948);
	
	var _TransactionAmount2 = _interopRequireDefault(_TransactionAmount);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	__webpack_require__(2953);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransactionsTableDepositRow = function (_React$Component) {
	  _inherits(TransactionsTableDepositRow, _React$Component);
	
	  function TransactionsTableDepositRow() {
	    _classCallCheck(this, TransactionsTableDepositRow);
	
	    return _possibleConstructorReturn(this, (TransactionsTableDepositRow.__proto__ || Object.getPrototypeOf(TransactionsTableDepositRow)).apply(this, arguments));
	  }
	
	  _createClass(TransactionsTableDepositRow, [{
	    key: 'render',
	    value: function render() {
	      var transaction = this.props.transaction;
	
	
	      return _react2.default.createElement(
	        'tr',
	        { className: 'TransactionsTableDepositRow' },
	        _react2.default.createElement(
	          'td',
	          { colSpan: 2 },
	          _react2.default.createElement(_Avatar2.default, {
	            className: 'TransactionsTableDepositRow-droplet',
	            color: 'grey',
	            image: __webpack_require__(2955),
	            size: 'small'
	          }),
	          _react2.default.createElement(
	            'span',
	            { className: 'TransactionsTableDepositRow-depositTitle' },
	            'You deposited',
	            ' ',
	            _react2.default.createElement(_Money2.default, { cents: transaction.getAmount() })
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_Time2.default, {
	            date: transaction.getCreatedAt(),
	            day: 'numeric',
	            month: 'short'
	          })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_TransactionAmount2.default, { transaction: transaction })
	        )
	      );
	    }
	  }]);
	
	  return TransactionsTableDepositRow;
	}(_react2.default.Component);
	
	TransactionsTableDepositRow.displayName = 'TransactionsTableDepositRow';
	exports.default = TransactionsTableDepositRow;

/***/ },
/* 2953 */
1136,
/* 2954 */,
/* 2955 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxOCAxNSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTggMTUiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZmlsbD0iI0ZGRkZGRiIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIGQ9Ik0xNi40LDE0SDEuNnYtMmgxNC44VjE0eiBNMTcuNCw2TDkuNSwxDQoJTDAuNiw2SDE3LjR6IE0xMCw2SDh2NkgxMFY2eiBNMTUsNkgxM3Y2SDE1VjZ6IE01LDZIM3Y2SDVWNnoiLz4NCjwvc3ZnPg0K"

/***/ },
/* 2956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	__webpack_require__(2957);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'TransactionsListNuxSection',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'TransactionsListNuxSection TransactionsListNuxSection-nux' },
	      _react2.default.createElement(
	        _Container2.default,
	        { size: 'medium' },
	        _react2.default.createElement(_TitleHeader2.default, {
	          image: __webpack_require__(2959),
	          imageClassName: 'TransactionsListNuxSection-image',
	          title: 'No transactions yet',
	          subtext: 'Your transaction history will appear here. Send money, see the activities\n              shared with you, and more.'
	        })
	      )
	    );
	  }
	});

/***/ },
/* 2957 */
1136,
/* 2958 */,
/* 2959 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "85bd577ffc6bfacc06d5eb61f2095874.svg";

/***/ },
/* 2960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Transactions = __webpack_require__(2961);
	
	var _utils = __webpack_require__(956);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _Transactions2 = __webpack_require__(981);
	
	var _Transactions3 = _interopRequireDefault(_Transactions2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransactionStore = function (_ReduceStore) {
	  _inherits(TransactionStore, _ReduceStore);
	
	  function TransactionStore() {
	    _classCallCheck(this, TransactionStore);
	
	    return _possibleConstructorReturn(this, (TransactionStore.__proto__ || Object.getPrototypeOf(TransactionStore)).apply(this, arguments));
	  }
	
	  _createClass(TransactionStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return _Transactions.initialState;
	    }
	  }, {
	    key: 'getSentPayments',
	    value: function getSentPayments() {
	      return new _Transactions3.default(this.getState().transactions.models.filter(function (tr) {
	        return tr.isPaymentSent();
	      }));
	    }
	  }, {
	    key: 'getTransactions',
	    value: function getTransactions() {
	      return this.getState().transactions;
	    }
	  }, {
	    key: 'getTransactionById',
	    value: function getTransactionById(id) {
	      return this.getState().transactions.get(id);
	    }
	  }, {
	    key: 'reduce',
	    value: function reduce(state, action) {
	      return (0, _Transactions.reducer)(state, action);
	    }
	  }]);
	
	  return TransactionStore;
	}(_utils.ReduceStore);
	
	TransactionStore.displayName = 'TransactionStore';
	exports.default = new TransactionStore(_Dispatcher.dispatcher);

/***/ },
/* 2961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	exports.reducer = reducer;
	
	var _TransactionConstants = __webpack_require__(979);
	
	var _Transactions = __webpack_require__(981);
	
	var _Transactions2 = _interopRequireDefault(_Transactions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  transactions: new _Transactions2.default()
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _TransactionConstants.ActionTypes.LOAD_TRANSACTIONS:
	      var transactions = state.transactions.clone();
	      transactions.add(action.transactions.models);
	      return _extends({}, state, { transactions: transactions });
	
	    case _TransactionConstants.ActionTypes.CREATE_TRANSACTION:
	    case _TransactionConstants.ActionTypes.CLAIM_TRANSACTION:
	      var updatedTransactions = state.transactions.clone();
	      updatedTransactions.add(action.transaction);
	      return _extends({}, state, { transactions: updatedTransactions });
	
	    default:
	      return state;
	  }
	}

/***/ },
/* 2962 */
1136,
/* 2963 */,
/* 2964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ChatActions = __webpack_require__(838);
	
	var _ChatActions2 = _interopRequireDefault(_ChatActions);
	
	var _ChatSettingsActions = __webpack_require__(2965);
	
	var _ChatSettingsActions2 = _interopRequireDefault(_ChatSettingsActions);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormSelect = __webpack_require__(1365);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _OfficeHoursPicker = __webpack_require__(2966);
	
	var _OfficeHoursPicker2 = _interopRequireDefault(_OfficeHoursPicker);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingsContainer = __webpack_require__(2970);
	
	var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _waitForPromises = __webpack_require__(2632);
	
	var _waitForPromises2 = _interopRequireDefault(_waitForPromises);
	
	var _utils = __webpack_require__(956);
	
	var _modal = __webpack_require__(1188);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2973);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatSettingsView = function (_React$Component) {
	  _inherits(ChatSettingsView, _React$Component);
	
	  function ChatSettingsView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChatSettingsView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatSettingsView.__proto__ || Object.getPrototypeOf(ChatSettingsView)).call.apply(_ref, [this].concat(args))), _this), _this.handleTwoWayMessagingChange = function (value) {
	      var twoWayMessaging = value === 'conversations';
	      var savePreference = function savePreference(updateExistingConversations) {
	        var saveOptions = [_UserActions2.default.savePreference('two_way_messaging', twoWayMessaging)];
	
	        if (updateExistingConversations) {
	          saveOptions.push(twoWayMessaging ? _ChatActions2.default.enableRepliesForAllChats() : _ChatActions2.default.disableRepliesForAllChats());
	        }
	
	        Promise.all(saveOptions).then(function () {
	          return _ToastActions2.default.showSuccessToast('Message options have been saved!');
	        }).catch(_ToastActions2.default.showDefaultErrorToast);
	      };
	
	      var modal = _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'ChatSettingsView',
	        title: twoWayMessaging ? '2-way conversations are now turned on!' : '1-way announcements are now turned on!',
	        subtext: twoWayMessaging ? 'You can now receive messages from class participants. Tap \u201CUpdate all\u201D to turn on\n            replies in your existing conversations.' : 'This update only applies to new announcements. Tap \u201CUpdate all\u201D to turn off replies in\n            your existing conversations.',
	        actionButtonText: 'Update all',
	        cancelButtonText: 'Not now',
	        size: 'small',
	        onConfirm: function onConfirm() {
	          return savePreference(true);
	        },
	        onCancel: function onCancel() {
	          return savePreference(false);
	        }
	      });
	
	      (0, _modal.mountModal)(modal, _this);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChatSettingsView, [{
	    key: 'renderMessageOptions',
	    value: function renderMessageOptions() {
	      return _react2.default.createElement(
	        _Form2.default,
	        null,
	        _react2.default.createElement(
	          _Fieldset2.default,
	          null,
	          _react2.default.createElement(
	            _Legend2.default,
	            null,
	            'Message options',
	            _react2.default.createElement(
	              'p',
	              null,
	              'Choose how you would like to communicate with your students and parents.'
	            )
	          ),
	          _react2.default.createElement(
	            _SettingsContainer2.default,
	            null,
	            _react2.default.createElement(
	              _Columns2.default,
	              { gutter: 'small' },
	              _react2.default.createElement(_FormSelect2.default, {
	                name: 'two_way_messaging',
	                value: this.state.twoWayMessaging ? 'conversations' : 'announcements',
	                options: [{
	                  value: 'announcements',
	                  label: '1-way announcements'
	                }, {
	                  value: 'conversations',
	                  label: '2-way conversations'
	                }],
	                onChange: this.handleTwoWayMessagingChange,
	                searchable: false
	              })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderOfficeHours',
	    value: function renderOfficeHours() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_Divider2.default, null),
	        _react2.default.createElement(_OfficeHoursPicker2.default, { showToggleButton: true, showToastMessages: true, showIntroText: true })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ChatSettingsView', this.props.className) },
	        this.renderMessageOptions(),
	        this.renderOfficeHours()
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }]);
	
	  return ChatSettingsView;
	}(_react2.default.Component);
	
	ChatSettingsView.routePrefetch = [function () {
	  return _ChatSettingsActions2.default.loadOfficeHours();
	}];
	
	ChatSettingsView.calculateState = function () {
	  var twoWayMessaging = _CurrentUser2.default.getUser().hasTwoWayMessaging();
	
	  return {
	    twoWayMessaging: twoWayMessaging
	  };
	};
	
	ChatSettingsView.displayName = 'ChatSettingsView';
	exports.default = (0, _waitForPromises2.default)(_utils.Container.create(ChatSettingsView));

/***/ },
/* 2965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _OfficeHours = __webpack_require__(922);
	
	var _OfficeHours2 = _interopRequireDefault(_OfficeHours);
	
	var _OfficeHoursDay = __webpack_require__(925);
	
	var _OfficeHoursDay2 = _interopRequireDefault(_OfficeHoursDay);
	
	var _ChatSettingsConstants = __webpack_require__(923);
	
	var _GroupConstants = __webpack_require__(991);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChatSettingsActions = {
	  loadOfficeHours: function loadOfficeHours() {
	    return _OfficeHours2.default.yieldForCurrentUser().then(function (hours) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_LOADED,
	        hours: hours
	      });
	    });
	  },
	  enableOfficeHours: function enableOfficeHours() {
	    var hours = new _OfficeHours2.default();
	
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_ENABLED,
	      hours: hours
	    });
	
	    return ChatSettingsActions.setOfficeHours(hours.getAvailability());
	  },
	  disableOfficeHours: function disableOfficeHours() {
	    var hours = new _OfficeHours2.default({
	      available: []
	    });
	
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_DISABLED,
	      hours: hours
	    });
	
	    return ChatSettingsActions.setOfficeHours(hours.getAvailability());
	  },
	  setOfficeHours: function setOfficeHours(available) {
	    var hours = new _OfficeHours2.default({
	      available: available
	    });
	
	    _Dispatcher.dispatcher.dispatch({
	      type: _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_UPDATED,
	      hours: hours
	    });
	
	    return _OfficeHours2.default.setForCurrentUser(available);
	  },
	  updateAllowGroupsToStartChat: function updateAllowGroupsToStartChat(groups) {
	    for (var _id in groups) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _GroupConstants.ActionTypes.CAN_START_CHAT_CHANGED,
	        groupId: _id,
	        canStartChat: groups[_id]
	      });
	    }
	
	    return _Groups2.default.setGroupsAllowedToStartChat(groups).then(function (updatedGroups) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _GroupConstants.ActionTypes.GROUPS_UPDATED,
	        groups: updatedGroups
	      });
	    });
	  }
	};
	exports.default = ChatSettingsActions;

/***/ },
/* 2966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ChatSettingsActions = __webpack_require__(2965);
	
	var _ChatSettingsActions2 = _interopRequireDefault(_ChatSettingsActions);
	
	var _CheckboxList = __webpack_require__(1467);
	
	var _CheckboxList2 = _interopRequireDefault(_CheckboxList);
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ChatSettingsStore = __webpack_require__(2967);
	
	var _ChatSettingsStore2 = _interopRequireDefault(_ChatSettingsStore);
	
	var _DateConstants = __webpack_require__(1751);
	
	var _DateConstants2 = _interopRequireDefault(_DateConstants);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _OfficeHours = __webpack_require__(922);
	
	var _OfficeHours2 = _interopRequireDefault(_OfficeHours);
	
	var _OfficeHoursDay = __webpack_require__(925);
	
	var _OfficeHoursDay2 = _interopRequireDefault(_OfficeHoursDay);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TimePickerInput = __webpack_require__(1854);
	
	var _TimePickerInput2 = _interopRequireDefault(_TimePickerInput);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2968);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OFFICE_HOUR_DAYS = new Map();
	var OFFICE_HOUR_DAYS_COMPACT = new Map();
	[0, 1, 2, 3, 4, 5, 6].forEach(function (index) {
	  OFFICE_HOUR_DAYS.set(index, _DateConstants2.default.WEEKDAYS[index]);
	  OFFICE_HOUR_DAYS_COMPACT.set(index, _DateConstants2.default.WEEKDAYS_COMPACT[index]);
	});
	
	var OfficeHoursPicker = function (_Component) {
	  _inherits(OfficeHoursPicker, _Component);
	
	  function OfficeHoursPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OfficeHoursPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OfficeHoursPicker.__proto__ || Object.getPrototypeOf(OfficeHoursPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      officeHours: null,
	      startTime: null,
	      endTime: null,
	      twoWayMessaging: null,
	      availabilityChanges: {
	        startTime: null,
	        endTime: null
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OfficeHoursPicker, [{
	    key: 'getSecondsFromTime',
	    value: function getSecondsFromTime(time) {
	      if (!time) {
	        return 0;
	      }
	      // this converts Date object from DateTimePicker into seconds for API
	
	      var SECONDS_IN_HOUR = 60 * 60;
	      var SECONDS_IN_MIN = 60;
	
	      var date = new Date(time);
	      return date.getHours() * SECONDS_IN_HOUR + date.getMinutes() * SECONDS_IN_MIN;
	    }
	  }, {
	    key: 'commitAvailabilityChanges',
	    value: function commitAvailabilityChanges(newTimes) {
	      var showToastMessages = this.props.showToastMessages;
	
	      var days = this.refs.days.getValue();
	      var newStartTime = newTimes.startTime ? this.getSecondsFromTime(newTimes.startTime) : this.getSecondsFromTime(this.state.startTime);
	      var newEndTime = newTimes.endTime ? this.getSecondsFromTime(newTimes.endTime) : this.getSecondsFromTime(this.state.endTime);
	      var available = days.map(function (day) {
	        return _OfficeHoursDay2.default.create(day, newStartTime, newEndTime);
	      });
	
	      _ChatSettingsActions2.default.setOfficeHours(available).then(function () {
	        return showToastMessages && _ToastActions2.default.showSuccessToast('Office hours updated');
	      }).catch(showToastMessages ? _ToastActions2.default.showDefaultErrorToast : function () {});
	
	      if (this.props.showSubmitButton && this.props.onSubmit) {
	        this.props.onSubmit();
	      }
	    }
	  }, {
	    key: 'handleAvailabilityChange',
	    value: function handleAvailabilityChange(newTimes) {
	      if (this.props.showSubmitButton) {
	        if (newTimes.startTime) {
	          this.setState({ startTime: newTimes.startTime });
	        }
	        if (newTimes.endTime) {
	          this.setState({ endTime: newTimes.endTime });
	        }
	        this.setState({
	          availabilityChanges: Object.assign(this.state.availabilityChanges, newTimes)
	        });
	      } else {
	        this.commitAvailabilityChanges(newTimes);
	      }
	    }
	  }, {
	    key: 'handleEndChange',
	    value: function handleEndChange(newEndTime) {
	      if (newEndTime) {
	        this.handleAvailabilityChange({ startTime: null, endTime: newEndTime });
	      }
	    }
	  }, {
	    key: 'handleStartChange',
	    value: function handleStartChange(newStartTime) {
	      if (newStartTime) {
	        this.handleAvailabilityChange({ startTime: newStartTime, endTime: null });
	      }
	    }
	  }, {
	    key: 'toggleOfficeHours',
	    value: function toggleOfficeHours() {
	      var showToastMessages = this.props.showToastMessages;
	      var officeHours = this.state.officeHours;
	
	
	      if (officeHours && officeHours.hasAvailability()) {
	        _ChatSettingsActions2.default.disableOfficeHours().then(function () {
	          return showToastMessages && _ToastActions2.default.showSuccessToast('Office hours have been canceled');
	        }).catch(showToastMessages ? _ToastActions2.default.showDefaultErrorToast : function () {});
	      } else {
	        _ChatSettingsActions2.default.enableOfficeHours().then(function () {
	          return showToastMessages && _ToastActions2.default.showSuccessToast('Office hours have been set');
	        }).catch(showToastMessages ? _ToastActions2.default.showDefaultErrorToast : function () {});
	      }
	    }
	  }, {
	    key: 'renderOptions',
	    value: function renderOptions() {
	      var _this2 = this;
	
	      var officeHours = this.state.officeHours;
	      if (!officeHours) {
	        return null;
	      }
	      var availability = officeHours.getAvailability();
	
	      var times = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_TimePickerInput2.default, {
	          ref: 'startTime',
	          value: this.state.startTime,
	          max: this.state.endTime,
	          onChange: function onChange(newStartTime) {
	            return _this2.handleStartChange(newStartTime);
	          }
	        }),
	        _react2.default.createElement(
	          _Text2.default,
	          { color: 'thunder', size: 'large' },
	          ' - '
	        ),
	        _react2.default.createElement(_TimePickerInput2.default, {
	          ref: 'endTime',
	          value: this.state.endTime,
	          min: this.state.startTime,
	          onChange: function onChange(newEndTime) {
	            return _this2.handleEndChange(newEndTime);
	          }
	        })
	      );
	
	      var days = _react2.default.createElement(_CheckboxList2.default, {
	        ref: 'days',
	        className: 'OfficeHoursPicker-officeHoursDays',
	        options: this.props.compact ? OFFICE_HOUR_DAYS_COMPACT : OFFICE_HOUR_DAYS,
	        defaultChecked: availability.map(function (day) {
	          return day.getDay();
	        }),
	        onChange: function onChange(newTimes) {
	          return _this2.handleAvailabilityChange(newTimes);
	        },
	        direction: this.props.compact ? 'horizontal' : 'vertical'
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)({ 'OfficeHoursPicker-compactDateTime': this.props.compact }) },
	        _react2.default.createElement(
	          'div',
	          { className: 'OfficeHoursPicker-timePicker' },
	          _react2.default.createElement(
	            _Label2.default,
	            null,
	            'Time'
	          ),
	          times
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'OfficeHoursPicker-datePicker' },
	          _react2.default.createElement(
	            _Label2.default,
	            null,
	            'Day(s)'
	          ),
	          days
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var options = void 0;
	      var toggleButton = void 0;
	
	      var _state = this.state,
	          officeHours = _state.officeHours,
	          twoWayMessaging = _state.twoWayMessaging;
	
	      var officeHoursAreOn = twoWayMessaging && officeHours && officeHours.hasAvailability();
	      if (officeHoursAreOn && officeHours) {
	        options = this.renderOptions();
	
	        toggleButton = _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'thunder',
	            level: 'text',
	            size: 'xsmall',
	            key: 'enabled',
	            onClick: function onClick() {
	              return _this3.toggleOfficeHours();
	            } },
	          'Turn off office hours'
	        );
	      } else {
	        toggleButton = _react2.default.createElement(
	          _Button2.default,
	          {
	            key: 'disabled',
	            level: 'secondary',
	            size: 'xsmall',
	            disabled: !twoWayMessaging,
	            onClick: function onClick() {
	              return _this3.toggleOfficeHours();
	            } },
	          'Turn on office hours'
	        );
	      }
	
	      var submitButton = _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'OfficeHoursPicker-submit',
	          level: 'primary',
	          size: 'xsmall',
	          onClick: function onClick() {
	            return _this3.commitAvailabilityChanges(_this3.state.availabilityChanges);
	          },
	          eventElementName: 'OfficeHoursPicker-submit' },
	        'Set office hours'
	      );
	
	      var introText = _react2.default.createElement(
	        'div',
	        null,
	        'Office hours',
	        _react2.default.createElement(
	          'p',
	          null,
	          'Let people know the best times to reach you.'
	        )
	      );
	
	      return _react2.default.createElement(
	        _Fieldset2.default,
	        null,
	        _react2.default.createElement(
	          _Legend2.default,
	          null,
	          this.props.showIntroText && introText,
	          !twoWayMessaging && _react2.default.createElement(
	            'p',
	            null,
	            'To enable Office hours, set Message options to 2-way conversations.'
	          )
	        ),
	        options,
	        this.props.showToggleButton && toggleButton,
	        this.props.showSubmitButton && officeHoursAreOn && submitButton
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ChatSettingsStore2.default, _CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState) {
	      var officeHours = _ChatSettingsStore2.default.getOfficeHours();
	      var startTime = void 0;
	      var endTime = void 0;
	      var twoWayMessaging = void 0;
	      if (officeHours) {
	        var availability = officeHours.getAvailability();
	        startTime = officeHours.hasAvailability() ? OfficeHoursPicker.getDateObject(availability[0].getStartTime()) : null;
	        endTime = officeHours.hasAvailability() ? OfficeHoursPicker.getDateObject(availability[0].getEndTime()) : null;
	        twoWayMessaging = _CurrentUser2.default.getUser().hasTwoWayMessaging();
	      }
	
	      return {
	        officeHours: officeHours,
	        startTime: startTime,
	        endTime: endTime,
	        twoWayMessaging: twoWayMessaging,
	        availabilityChanges: prevState && prevState.availabilityChanges || {
	          startTime: null,
	          endTime: null
	        }
	      };
	    }
	  }, {
	    key: 'getDateObject',
	    value: function getDateObject(seconds) {
	      // start and end time from API are stored as seconds
	      // DateTimePicker expects Date object
	      // this converts API seconds to Date object for the DateTimePicker
	      return new Date(2015, 0, 0, 0, 0, seconds);
	    }
	  }]);
	
	  return OfficeHoursPicker;
	}(_react.Component);
	
	OfficeHoursPicker.displayName = 'OfficeHoursPicker';
	exports.default = _utils.Container.create(OfficeHoursPicker);

/***/ },
/* 2967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ChatSettingsConstants = __webpack_require__(923);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChatSettingsStore = function (_Store) {
	  _inherits(ChatSettingsStore, _Store);
	
	  function ChatSettingsStore() {
	    _classCallCheck(this, ChatSettingsStore);
	
	    return _possibleConstructorReturn(this, (ChatSettingsStore.__proto__ || Object.getPrototypeOf(ChatSettingsStore)).apply(this, arguments));
	  }
	
	  _createClass(ChatSettingsStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        officeHours: null
	      };
	    }
	  }, {
	    key: 'getOfficeHours',
	    value: function getOfficeHours() {
	      return this.state.officeHours;
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_LOADED:
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_ENABLED:
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_DISABLED:
	        case _ChatSettingsConstants.ActionTypes.OFFICE_HOURS_UPDATED:
	          this.state.officeHours = action.hours;
	          this.emitChange();
	          break;
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return ChatSettingsStore;
	}(_Store3.default);
	
	ChatSettingsStore.displayName = 'ChatSettingsStore';
	exports.default = new ChatSettingsStore();

/***/ },
/* 2968 */
1136,
/* 2969 */,
/* 2970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2971);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsContainer = function (_React$Component) {
	  _inherits(SettingsContainer, _React$Component);
	
	  function SettingsContainer() {
	    _classCallCheck(this, SettingsContainer);
	
	    return _possibleConstructorReturn(this, (SettingsContainer.__proto__ || Object.getPrototypeOf(SettingsContainer)).apply(this, arguments));
	  }
	
	  _createClass(SettingsContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        _extends({}, this.props, {
	          className: (0, _classnames2.default)('SettingsContainer', this.props.className) }),
	        this.props.children
	      );
	    }
	  }]);
	
	  return SettingsContainer;
	}(_react2.default.Component);
	
	SettingsContainer.displayName = 'SettingsContainer';
	exports.default = SettingsContainer;

/***/ },
/* 2971 */
1136,
/* 2972 */,
/* 2973 */
1136,
/* 2974 */,
/* 2975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _GroupCreateModal = __webpack_require__(1326);
	
	var _GroupCreateModal2 = _interopRequireDefault(_GroupCreateModal);
	
	var _Heading = __webpack_require__(1436);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _Row = __webpack_require__(1482);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Select = __webpack_require__(1366);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Widgets = __webpack_require__(2976);
	
	var _Widgets2 = _interopRequireDefault(_Widgets);
	
	var _SettingsContainer = __webpack_require__(2970);
	
	var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _WidgetActions = __webpack_require__(2978);
	
	var _WidgetActions2 = _interopRequireDefault(_WidgetActions);
	
	var _ClipboardTrigger = __webpack_require__(1492);
	
	var _ClipboardTrigger2 = _interopRequireDefault(_ClipboardTrigger);
	
	var _WidgetStore = __webpack_require__(2980);
	
	var _WidgetStore2 = _interopRequireDefault(_WidgetStore);
	
	var _waitForPromises = __webpack_require__(2632);
	
	var _waitForPromises2 = _interopRequireDefault(_waitForPromises);
	
	var _getRedirectLocationAfterGroupCreation = __webpack_require__(2153);
	
	var _getRedirectLocationAfterGroupCreation2 = _interopRequireDefault(_getRedirectLocationAfterGroupCreation);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _IframePreview = __webpack_require__(2981);
	
	var _IframePreview2 = _interopRequireDefault(_IframePreview);
	
	var _Radio = __webpack_require__(1609);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _queryString = __webpack_require__(528);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	__webpack_require__(2984);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetSettingsView = function (_React$Component) {
	  _inherits(WidgetSettingsView, _React$Component);
	
	  function WidgetSettingsView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, WidgetSettingsView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WidgetSettingsView.__proto__ || Object.getPrototypeOf(WidgetSettingsView)).call.apply(_ref, [this].concat(args))), _this), _this.handlerCodeCopy = function () {
	      _ToastActions2.default.showSuccessToast('Code copied to your clipboard.');
	    }, _this.handlerJoinButtonToggle = function () {
	      _this.setState({ withJoinButton: !_this.state.withJoinButton });
	    }, _this.handlerWidgetChange = function (id) {
	      _this.setState({ selected: id });
	    }, _this.handlerTypeChange = function (type) {
	      _this.setState({ type: type });
	    }, _this.handleGroupCreated = function (group) {
	      _this.context.router.push((0, _getRedirectLocationAfterGroupCreation2.default)(group));
	    }, _this.handleToggleAdvancedSettings = function () {
	      _this.setState({ advancedSettingsVisible: !_this.state.advancedSettingsVisible });
	    }, _this.handleWidgetHeightChange = function (event) {
	      _this.setState({ widgetHeight: Number(event.target.value) });
	    }, _this.onRegularTypeSelect = function () {
	      return _this.setState({ type: 'regular' });
	    }, _this.onGoogleTypeSelect = function () {
	      return _this.setState({ type: 'google' });
	    }, _this.onWixTypeSelect = function () {
	      return _this.setState({ type: 'wix' });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(WidgetSettingsView, [{
	    key: 'renderBuilder',
	    value: function renderBuilder() {
	      var widgetOptions = this.state.widgets.map(function (widget) {
	        return {
	          label: widget.getClassName(),
	          value: widget.id
	        };
	      });
	
	      var widget = this.state.widgets.get(this.state.selected);
	      var withJoinButton = this.state.withJoinButton && !!widget.getGroup();
	
	      var builderParams = {
	        height: this.state.widgetHeight,
	        join: withJoinButton
	      };
	
	      var iframeSource = widget.getWidgetUrl() + '&' + _queryString2.default.stringify(builderParams);
	      var scriptSource = widget.getScriptUrl() + '&' + _queryString2.default.stringify(builderParams);
	      var googleSource = widget.getGadgetUrl() + '?' + _queryString2.default.stringify(builderParams);
	
	      var code = void 0;
	
	      if (this.state.type === 'google') {
	        code = googleSource;
	      } else if (this.state.type === 'wix') {
	        code = '<div><script src="' + scriptSource + '"></script></div>';
	      } else {
	        code = '<script src="' + scriptSource + '"></script>';
	      }
	
	      return _react2.default.createElement(
	        _Columns2.default,
	        { gutter: 'xlarge' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Row2.default,
	            { size: 'small' },
	            _react2.default.createElement(
	              _Field2.default,
	              null,
	              _react2.default.createElement(_Label2.default, { text: 'Step 1: Choose a class' }),
	              _react2.default.createElement(_Select2.default, {
	                onChange: this.handlerWidgetChange,
	                value: this.state.selected,
	                options: widgetOptions
	              })
	            ),
	            this.state.advancedSettingsVisible && _react2.default.createElement(
	              'div',
	              null,
	              widget.getGroup() && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _Heading2.default,
	                  { level: '4' },
	                  'Can users join your class?'
	                ),
	                _react2.default.createElement(
	                  _Field2.default,
	                  null,
	                  _react2.default.createElement(_Checkbox2.default, {
	                    onChange: this.handlerJoinButtonToggle,
	                    checked: withJoinButton,
	                    label: 'Enable subscribers to join my class'
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _Field2.default,
	                null,
	                _react2.default.createElement(
	                  _Label2.default,
	                  null,
	                  'Widget height'
	                ),
	                _react2.default.createElement(_Input2.default, {
	                  type: 'number',
	                  pattern: '\\d*',
	                  width: 'auto',
	                  step: '5',
	                  value: this.state.widgetHeight,
	                  className: 'WidgetSettingsView-widgetHeightInput',
	                  onChange: this.handleWidgetHeightChange
	                })
	              ),
	              _react2.default.createElement(
	                _Field2.default,
	                null,
	                _react2.default.createElement(
	                  _Heading2.default,
	                  { level: '4' },
	                  'Type'
	                ),
	                _react2.default.createElement(
	                  _Radio2.default,
	                  {
	                    onChange: this.onRegularTypeSelect,
	                    name: 'widget-type',
	                    defaultChecked: true,
	                    inline: true },
	                  'Regular'
	                ),
	                _react2.default.createElement(
	                  _Radio2.default,
	                  {
	                    onChange: this.onGoogleTypeSelect,
	                    name: 'widget-type',
	                    inline: true },
	                  'Google site'
	                ),
	                _react2.default.createElement(
	                  _Radio2.default,
	                  {
	                    onChange: this.onWixTypeSelect,
	                    name: 'widget-type',
	                    inline: true },
	                  'Wix'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                color: 'brand',
	                level: 'text',
	                size: 'small',
	                weight: 'semibold',
	                className: 'WidgetSettingsView-advancedSettingsButton',
	                onClick: this.handleToggleAdvancedSettings,
	                eventElementName: 'WidgetSettingsView-advancedSettingsButton' },
	              this.state.advancedSettingsVisible ? 'Hide advanced settings' : 'Show advanced settings'
	            ),
	            _react2.default.createElement(_Divider2.default, null),
	            _react2.default.createElement(
	              _Field2.default,
	              null,
	              _react2.default.createElement(_Label2.default, { text: 'Step 2: Copy the code to your website' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'WidgetSettingsView-code' },
	                _react2.default.createElement(
	                  'code',
	                  null,
	                  code
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _ClipboardTrigger2.default,
	              { text: code, onCopy: this.handlerCodeCopy },
	              _react2.default.createElement(
	                _Button2.default,
	                { full: true },
	                'Copy widget code'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _Link2.default,
	              { href: _LinkConstants2.default.ZENDESK + '/articles/204876696', target: '_blank' },
	              'Click here'
	            ),
	            ' ',
	            'for instructions on how to add the widget.'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Heading2.default,
	            { level: '4' },
	            'Live preview'
	          ),
	          _react2.default.createElement(_IframePreview2.default, { src: iframeSource, height: this.state.widgetHeight })
	        )
	      );
	    }
	  }, {
	    key: 'renderGroupCreateLink',
	    value: function renderGroupCreateLink() {
	      if (!this.state.canCreateGroups) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: _react2.default.createElement(_GroupCreateModal2.default, { onCreate: this.handleGroupCreated }) },
	        _react2.default.createElement(
	          _Link2.default,
	          null,
	          'Create your first class.'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var headerText = 'Embed any Remind widget into the HTML of your class website or blog to display your recently sent messages.';
	
	      if (this.state.widgets.length === 0) {
	        headerText = _react2.default.createElement(
	          _Text2.default,
	          { color: 'eclipse' },
	          'Widgets will appear here once you create your first class.',
	          ' ',
	          this.renderGroupCreateLink()
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('WidgetSettingsView', this.props.className) },
	        _react2.default.createElement(
	          _SettingsContainer2.default,
	          null,
	          _react2.default.createElement(
	            _Legend2.default,
	            null,
	            'Class widgets',
	            _react2.default.createElement(
	              'p',
	              null,
	              headerText
	            )
	          ),
	          this.state.widgets.length > 0 && this.renderBuilder()
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_WidgetStore2.default, _CurrentUser2.default];
	    }
	  }]);
	
	  return WidgetSettingsView;
	}(_react2.default.Component);
	
	WidgetSettingsView.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	WidgetSettingsView.routePrefetch = [function () {
	  return _WidgetActions2.default.loadWidgets();
	}];
	
	WidgetSettingsView.calculateState = function () {
	  var widgets = _WidgetStore2.default.getAll();
	  var currentUser = _CurrentUser2.default.getUser();
	
	  return {
	    widgets: widgets,
	    type: 'regular',
	    widgetHeight: 500,
	    withJoinButton: true,
	    selected: widgets.first() ? widgets.first().id : undefined,
	    advancedSettingsVisible: false,
	    canCreateGroups: currentUser.canCreateGroups()
	  };
	};
	
	WidgetSettingsView.displayName = 'WidgetSettingsView';
	exports.default = (0, _waitForPromises2.default)(_utils.Container.create(WidgetSettingsView));

/***/ },
/* 2976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _javascriptNaturalSort = __webpack_require__(993);
	
	var _javascriptNaturalSort2 = _interopRequireDefault(_javascriptNaturalSort);
	
	var _Widget = __webpack_require__(2977);
	
	var _Widget2 = _interopRequireDefault(_Widget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Widgets = function (_Collection) {
	  _inherits(Widgets, _Collection);
	
	  function Widgets() {
	    _classCallCheck(this, Widgets);
	
	    return _possibleConstructorReturn(this, (Widgets.__proto__ || Object.getPrototypeOf(Widgets)).apply(this, arguments));
	  }
	
	  _createClass(Widgets, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _Widget2.default;
	      this.url = '/widgets';
	    }
	  }, {
	    key: 'comparator',
	    value: function comparator(a, b) {
	      if (a.isAllClassesWidget()) {
	        return -1;
	      }
	
	      if (b.isAllClassesWidget()) {
	        return 1;
	      }
	
	      return (0, _javascriptNaturalSort2.default)(a.getClassName().toLowerCase(), b.getClassName().toLowerCase());
	    }
	  }]);
	
	  return Widgets;
	}(_Collection3.default);
	
	Widgets.displayName = 'Widgets';
	exports.default = Widgets;

/***/ },
/* 2977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(555);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Widget = function (_Entity) {
	  _inherits(Widget, _Entity);
	
	  function Widget() {
	    _classCallCheck(this, Widget);
	
	    return _possibleConstructorReturn(this, (Widget.__proto__ || Object.getPrototypeOf(Widget)).apply(this, arguments));
	  }
	
	  _createClass(Widget, [{
	    key: 'parse',
	    value: function parse(response) {
	      var widget = _lodash2.default.clone(response);
	
	      if (widget['group']) {
	        widget['group'] = _Group2.default.fromJSON(widget['group']);
	      }
	
	      return widget;
	    }
	  }, {
	    key: 'getGroup',
	    value: function getGroup() {
	      return this.get('group');
	    }
	  }, {
	    key: 'getClassName',
	    value: function getClassName() {
	      var group = this.getGroup();
	      return group ? group.getName() : 'All classes';
	    }
	  }, {
	    key: 'getScriptUrl',
	    value: function getScriptUrl() {
	      return this.get('script_url');
	    }
	  }, {
	    key: 'getGadgetUrl',
	    value: function getGadgetUrl() {
	      return this.get('gadget_url');
	    }
	  }, {
	    key: 'getWidgetUrl',
	    value: function getWidgetUrl() {
	      return this.get('widget_url');
	    }
	  }, {
	    key: 'isAllClassesWidget',
	    value: function isAllClassesWidget() {
	      return !!this.getGroup() === false;
	    }
	  }]);
	
	  return Widget;
	}(_Entity3.default);
	
	Widget.displayName = 'Widget';
	exports.default = Widget;

/***/ },
/* 2978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _WidgetConstants = __webpack_require__(2979);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _Widgets = __webpack_require__(2976);
	
	var _Widgets2 = _interopRequireDefault(_Widgets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WidgetActions = {
	  loadWidgets: function loadWidgets() {
	    return _Widgets2.default.fetch().then(function (widgets) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _WidgetConstants.ActionTypes.WIDGETS_LOADED,
	        widgets: widgets
	      });
	    });
	  }
	};
	exports.default = WidgetActions;

/***/ },
/* 2979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['WIDGETS_LOADED']); /*  weak */

/***/ },
/* 2980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _WidgetConstants = __webpack_require__(2979);
	
	var _Widgets = __webpack_require__(2976);
	
	var _Widgets2 = _interopRequireDefault(_Widgets);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WidgetStore = function (_Store) {
	  _inherits(WidgetStore, _Store);
	
	  function WidgetStore() {
	    _classCallCheck(this, WidgetStore);
	
	    return _possibleConstructorReturn(this, (WidgetStore.__proto__ || Object.getPrototypeOf(WidgetStore)).apply(this, arguments));
	  }
	
	  _createClass(WidgetStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        widgets: new _Widgets2.default()
	      };
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      return this.state.widgets;
	    }
	  }, {
	    key: 'addNewWidget',
	    value: function addNewWidget(widget) {
	      this.state.widgets.add(widget);
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      var _this2 = this;
	
	      switch (action.type) {
	        case _WidgetConstants.ActionTypes.WIDGETS_LOADED:
	          action.widgets.map(function (widget) {
	            return _this2.addNewWidget(widget);
	          });
	          this.emitChange();
	          break;
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return WidgetStore;
	}(_Store3.default);
	
	WidgetStore.displayName = 'WidgetStore';
	exports.default = new WidgetStore();

/***/ },
/* 2981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OverlayLoading = __webpack_require__(2022);
	
	var _OverlayLoading2 = _interopRequireDefault(_OverlayLoading);
	
	__webpack_require__(2982);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IframePreview = function (_React$Component) {
	  _inherits(IframePreview, _React$Component);
	
	  function IframePreview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IframePreview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = IframePreview.__proto__ || Object.getPrototypeOf(IframePreview)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loading: true
	    }, _this.componentWillReceiveProps = function (nextProps) {
	      if (_this.props.src !== nextProps.src) {
	        _this.setState({ loading: true });
	      }
	    }, _this.onLoad = function () {
	      return _this.setState({ loading: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(IframePreview, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'IframePreview', style: { height: this.props.height + 5 } },
	        this.state.loading && _react2.default.createElement(_OverlayLoading2.default, null),
	        _react2.default.createElement('iframe', {
	          onLoad: this.onLoad,
	          src: this.props.src,
	          style: { width: '100%', height: this.props.height }
	        })
	      );
	    }
	  }]);
	
	  return IframePreview;
	}(_react2.default.Component);
	
	IframePreview.displayName = 'IframePreview';
	exports.default = IframePreview;

/***/ },
/* 2982 */
1136,
/* 2983 */,
/* 2984 */
1136,
/* 2985 */,
/* 2986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(956);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _Activities = __webpack_require__(980);
	
	var _Activities2 = _interopRequireDefault(_Activities);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _PrintAnnouncements = __webpack_require__(2987);
	
	var _PrintAnnouncements2 = _interopRequireDefault(_PrintAnnouncements);
	
	var _PrintActivity = __webpack_require__(2990);
	
	var _PrintActivity2 = _interopRequireDefault(_PrintActivity);
	
	var _PrintSubscribers = __webpack_require__(2991);
	
	var _PrintSubscribers2 = _interopRequireDefault(_PrintSubscribers);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrintSettingsView = function (_React$Component) {
	  _inherits(PrintSettingsView, _React$Component);
	
	  function PrintSettingsView() {
	    _classCallCheck(this, PrintSettingsView);
	
	    return _possibleConstructorReturn(this, (PrintSettingsView.__proto__ || Object.getPrototypeOf(PrintSettingsView)).apply(this, arguments));
	  }
	
	  _createClass(PrintSettingsView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('PrintSettingsView', this.props.className) },
	        _react2.default.createElement(_PrintAnnouncements2.default, { groups: this.state.groups }),
	        _react2.default.createElement(_Divider2.default, null),
	        _react2.default.createElement(_PrintSubscribers2.default, { groups: this.state.groups }),
	        _react2.default.createElement(_Divider2.default, null),
	        _react2.default.createElement(_PrintActivity2.default, { activities: this.state.activities })
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_GroupStore2.default, _ActivityStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        groups: _GroupStore2.default.getOwnedGroups(),
	        activities: _ActivityStore2.default.getOwnedActivities()
	      };
	    }
	  }]);
	
	  return PrintSettingsView;
	}(_react2.default.Component);
	
	PrintSettingsView.displayName = 'PrintSettingsView';
	exports.default = _utils.Container.create(PrintSettingsView);

/***/ },
/* 2987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DatePickerInput = __webpack_require__(1749);
	
	var _DatePickerInput2 = _interopRequireDefault(_DatePickerInput);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _MessageActions = __webpack_require__(1228);
	
	var _MessageActions2 = _interopRequireDefault(_MessageActions);
	
	var _Select = __webpack_require__(1366);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _SetUserEmailModal = __webpack_require__(1402);
	
	var _SetUserEmailModal2 = _interopRequireDefault(_SetUserEmailModal);
	
	var _modal = __webpack_require__(1188);
	
	var _SettingsContainer = __webpack_require__(2970);
	
	var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
	
	__webpack_require__(2988);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALL_CLASSES_OPTION = { label: 'All classes', value: '_all' }; /*  weak */
	
	
	var PrintAnnouncements = _react2.default.createClass({
	  displayName: 'PrintAnnouncements',
	  getInitialState: function getInitialState() {
	    var startDate = this.sixMonthsAgo();
	    var endDate = new Date();
	
	    return {
	      group: ALL_CLASSES_OPTION,
	      startDate: startDate,
	      endDate: endDate,
	      groupOptions: this.getFormattedGroupSelectOptions()
	    };
	  },
	  getFormattedGroupSelectOptions: function getFormattedGroupSelectOptions() {
	    return [ALL_CLASSES_OPTION].concat(this.props.groups.map(function (group) {
	      return { label: group.getName(), value: group.id };
	    }));
	  },
	  setSelectedGroup: function setSelectedGroup(value) {
	    var group = this.state.groupOptions.find(function (option) {
	      return option.value === value;
	    });
	    this.setState({ group: group });
	  },
	  canSubmit: function canSubmit() {
	    return this.state.group !== null && this.state.startDate !== null && this.state.endDate !== null && this.state.startDate < this.state.endDate;
	  },
	  handleEndDateChange: function handleEndDateChange(date) {
	    this.setState({ endDate: date });
	  },
	  handleStartDateChange: function handleStartDateChange(date) {
	    this.setState({ startDate: date });
	  },
	  printAnnouncements: function printAnnouncements() {
	    if (!_CurrentUser2.default.hasEmail()) {
	      return (0, _modal.mountModal)(_react2.default.createElement(_SetUserEmailModal2.default, { onSave: this.printAnnouncements }), this);
	    }
	
	    var groupIds = void 0;
	
	    // if selected group is all class pass an empty array.
	    var allGroups = ALL_CLASSES_OPTION.value;
	    if (this.state.group.value === allGroups) {
	      groupIds = [];
	    } else {
	      groupIds = [this.state.group.value];
	    }
	
	    _MessageActions2.default.export(groupIds, this.state.startDate, this.state.endDate);
	  },
	  sixMonthsAgo: function sixMonthsAgo() {
	    var sixMonthsAgo = new Date();
	    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
	    return sixMonthsAgo;
	  },
	  render: function render() {
	    var today = new Date();
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'PrintAnnouncements PrintSettingSection' },
	      _react2.default.createElement(
	        _Fieldset2.default,
	        null,
	        _react2.default.createElement(
	          _Legend2.default,
	          null,
	          'Announcements',
	          _react2.default.createElement(
	            'p',
	            null,
	            'Export a PDF of all the announcements you\u2019ve sent to participants in a class.'
	          )
	        ),
	        _react2.default.createElement(
	          _SettingsContainer2.default,
	          null,
	          _react2.default.createElement(
	            _Field2.default,
	            null,
	            _react2.default.createElement(
	              _Columns2.default,
	              { gutter: 'small' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _Label2.default,
	                  null,
	                  'Class'
	                ),
	                _react2.default.createElement(_Select2.default, {
	                  className: 'PrintSettingSection-groupSelector',
	                  options: this.state.groupOptions,
	                  value: this.state.group.value,
	                  onChange: this.setSelectedGroup
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _Columns2.default,
	                  { gutter: 'small' },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      _Label2.default,
	                      null,
	                      'Start date'
	                    ),
	                    _react2.default.createElement(_DatePickerInput2.default, {
	                      className: (0, _classnames2.default)('PrintSettingSection-dateSelector control input', {
	                        error: this.state.startDate > today
	                      }),
	                      ref: 'startdate',
	                      value: this.state.startDate,
	                      max: today,
	                      onChange: this.handleStartDateChange
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      _Label2.default,
	                      null,
	                      'End date'
	                    ),
	                    _react2.default.createElement(_DatePickerInput2.default, {
	                      className: (0, _classnames2.default)('PrintSettingSection-dateSelector control input', {
	                        error: this.state.startDate >= this.state.endDate
	                      }),
	                      ref: 'endDate',
	                      value: this.state.endDate,
	                      min: this.state.startDate,
	                      max: today,
	                      onChange: this.handleEndDateChange
	                    })
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { size: 'small', disabled: !this.canSubmit(), onClick: this.printAnnouncements },
	          'Export'
	        )
	      )
	    );
	  }
	});
	
	exports.default = PrintAnnouncements;

/***/ },
/* 2988 */
1136,
/* 2989 */,
/* 2990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Activities = __webpack_require__(980);
	
	var _Activities2 = _interopRequireDefault(_Activities);
	
	var _Select = __webpack_require__(1366);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _SettingsContainer = __webpack_require__(2970);
	
	var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrintActivity = function (_React$Component) {
	  _inherits(PrintActivity, _React$Component);
	
	  function PrintActivity() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PrintActivity);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PrintActivity.__proto__ || Object.getPrototypeOf(PrintActivity)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedActivityId: _this.props.activities.first() && _this.props.activities.first().id
	    }, _this.setSelectedActivity = function (value) {
	      _this.setState({ selectedActivityId: value });
	    }, _this.printActivity = function () {
	      if (_this.state.selectedActivityId) {
	        _Activity2.default.export(_this.state.selectedActivityId).then(function () {
	          return _ToastActions2.default.showSuccessToast(_Activity.ACTIVITY_PRINTED_MSG);
	        }, function () {
	          return _ToastActions2.default.showDefaultErrorToast();
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PrintActivity, [{
	    key: 'getFormattedActivitySelectOptions',
	    value: function getFormattedActivitySelectOptions() {
	      return this.props.activities.map(function (activity) {
	        return { label: activity.getTitle(), value: activity.id };
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var options = this.getFormattedActivitySelectOptions();
	      return _react2.default.createElement(
	        'div',
	        { className: 'PrintActivity PrintSettingSection' },
	        _react2.default.createElement(
	          _Fieldset2.default,
	          null,
	          _react2.default.createElement(
	            _Legend2.default,
	            null,
	            'Activity',
	            _react2.default.createElement(
	              'p',
	              null,
	              'Export a PDF of your activity.'
	            )
	          ),
	          _react2.default.createElement(
	            _SettingsContainer2.default,
	            null,
	            _react2.default.createElement(
	              _Field2.default,
	              null,
	              _react2.default.createElement(
	                _Label2.default,
	                null,
	                'Activity'
	              ),
	              _react2.default.createElement(_Select2.default, {
	                options: options,
	                value: this.state.selectedActivityId,
	                onChange: this.setSelectedActivity
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { size: 'small', disabled: !this.state.selectedActivityId, onClick: this.printActivity },
	            'Export'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PrintActivity;
	}(_react2.default.Component);
	
	PrintActivity.displayName = 'PrintActivity';
	exports.default = PrintActivity;

/***/ },
/* 2991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(1366);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _SubscriberActions = __webpack_require__(2992);
	
	var _SubscriberActions2 = _interopRequireDefault(_SubscriberActions);
	
	var _SetUserEmailModal = __webpack_require__(1402);
	
	var _SetUserEmailModal2 = _interopRequireDefault(_SetUserEmailModal);
	
	var _SettingsContainer = __webpack_require__(2970);
	
	var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _modal = __webpack_require__(1188);
	
	__webpack_require__(2988);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALL_CLASSES_OPTION = { label: 'All classes', value: '_all' }; /*  weak */
	
	
	var PrintSubscribers = _react2.default.createClass({
	  displayName: 'PrintSubscribers',
	  getInitialState: function getInitialState() {
	    return {
	      group: ALL_CLASSES_OPTION,
	      groupOptions: this.getFormattedGroupSelectOptions()
	    };
	  },
	  getFormattedGroupSelectOptions: function getFormattedGroupSelectOptions() {
	    return [ALL_CLASSES_OPTION].concat(this.props.groups.map(function (group) {
	      return { label: group.getName(), value: group.id };
	    }));
	  },
	  setSelectedGroup: function setSelectedGroup(value) {
	    var group = this.state.groupOptions.find(function (option) {
	      return option.value === value;
	    });
	    this.setState({ group: group });
	  },
	  hasSelectedGroup: function hasSelectedGroup() {
	    return this.state.group !== null;
	  },
	  printSubscribers: function printSubscribers() {
	    if (!_CurrentUser2.default.hasEmail()) {
	      return (0, _modal.mountModal)(_react2.default.createElement(_SetUserEmailModal2.default, { onSave: this.printSubscribers }), this);
	    }
	
	    var groupIds = void 0;
	
	    // if selected group is all class pass an empty array.
	    var allGroups = ALL_CLASSES_OPTION.value;
	    if (this.state.group.value === allGroups) {
	      groupIds = [];
	    } else {
	      groupIds = [this.state.group.value];
	    }
	
	    _SubscriberActions2.default.export(groupIds);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'PrintSubscribers PrintSettingSection' },
	      _react2.default.createElement(
	        _Fieldset2.default,
	        null,
	        _react2.default.createElement(
	          _Legend2.default,
	          null,
	          'Participants',
	          _react2.default.createElement(
	            'p',
	            null,
	            'Export PDFs of all the participants in your classes.'
	          )
	        ),
	        _react2.default.createElement(
	          _SettingsContainer2.default,
	          null,
	          _react2.default.createElement(
	            _Columns2.default,
	            { gutter: 'small' },
	            _react2.default.createElement(
	              _Field2.default,
	              null,
	              _react2.default.createElement(
	                _Label2.default,
	                null,
	                'Class'
	              ),
	              _react2.default.createElement(_Select2.default, {
	                ref: 'select',
	                options: this.state.groupOptions,
	                value: this.state.group.value,
	                onChange: this.setSelectedGroup
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { size: 'small', disabled: !this.hasSelectedGroup(), onClick: this.printSubscribers },
	          'Export'
	        )
	      )
	    );
	  }
	});
	
	exports.default = PrintSubscribers;

/***/ },
/* 2992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Subscribers = __webpack_require__(997);
	
	var _Subscribers2 = _interopRequireDefault(_Subscribers);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SubscriberActions = {
	  export: function _export(groupIds) {
	    _Subscribers2.default.export(groupIds).then(function () {
	      _ToastActions2.default.showSuccessToast('We’ve emailed you a list of your participants.');
	    }).catch(function (error) {
	      _ToastActions2.default.showAPIError(error);
	      throw error;
	    });
	  }
	};
	
	exports.default = SubscriberActions;

/***/ },
/* 2993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingsView = __webpack_require__(2994);
	
	var _SettingsView2 = _interopRequireDefault(_SettingsView);
	
	var _RequireDesktop = __webpack_require__(2755);
	
	var _RequireDesktop2 = _interopRequireDefault(_RequireDesktop);
	
	var _RequireSetup = __webpack_require__(2756);
	
	var _RequireSetup2 = _interopRequireDefault(_RequireSetup);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	var _chainOnEnter = __webpack_require__(2585);
	
	var _chainOnEnter2 = _interopRequireDefault(_chainOnEnter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var previousLocation = void 0;
	
	var getPreviousLocation = {
	  statics: {
	    onEnter: function onEnter() {
	      previousLocation = window.prevLocation;
	    }
	  }
	};
	
	var SettingsViewRouteHandler = _react2.default.createClass({
	  displayName: 'SettingsViewRouteHandler',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [(0, _chainOnEnter2.default)([_RequireSetup2.default, _RequireDesktop2.default, _RequireUser2.default, getPreviousLocation])],
	
	  goBack: function goBack() {
	    if (previousLocation) {
	      this.context.router.push(previousLocation);
	    } else {
	      this.context.router.push('/classes');
	    }
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _SettingsView2.default,
	      { goBack: this.goBack },
	      this.props.children
	    );
	  }
	});
	
	exports.default = SettingsViewRouteHandler;

/***/ },
/* 2994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppLayoutContentView = __webpack_require__(2737);
	
	var _AppLayoutContentView2 = _interopRequireDefault(_AppLayoutContentView);
	
	var _AppLayoutContentViewHeader = __webpack_require__(2740);
	
	var _AppLayoutContentViewHeader2 = _interopRequireDefault(_AppLayoutContentViewHeader);
	
	var _SettingsNavContainer = __webpack_require__(2995);
	
	var _SettingsNavContainer2 = _interopRequireDefault(_SettingsNavContainer);
	
	var _View = __webpack_require__(2356);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _documentTitle = __webpack_require__(1713);
	
	__webpack_require__(3002);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var SettingsView = function (_React$Component) {
	  _inherits(SettingsView, _React$Component);
	
	  function SettingsView() {
	    _classCallCheck(this, SettingsView);
	
	    return _possibleConstructorReturn(this, (SettingsView.__proto__ || Object.getPrototypeOf(SettingsView)).apply(this, arguments));
	  }
	
	  _createClass(SettingsView, [{
	    key: 'renderHeader',
	    value: function renderHeader() {
	      return _react2.default.createElement(_AppLayoutContentViewHeader2.default, {
	        title: 'Back',
	        onRequestPrevious: this.props.goBack,
	        renderPreviousButton: true
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _AppLayoutContentView2.default,
	        {
	          className: (0, _classnames2.default)('SettingsView', this.props.className),
	          header: this.renderHeader(),
	          sidebar: _react2.default.createElement(_SettingsNavContainer2.default, null) },
	        _react2.default.createElement(
	          _View2.default,
	          { className: 'SettingsView-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'SettingsView-content-view' },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return SettingsView;
	}(_react2.default.Component);
	
	SettingsView.displayName = 'SettingsView';
	exports.default = (0, _documentTitle.withDocumentTitle)('Settings', SettingsView);

/***/ },
/* 2995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _SettingsNav = __webpack_require__(2996);
	
	var _SettingsNav2 = _interopRequireDefault(_SettingsNav);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _FeatureStore = __webpack_require__(588);
	
	var _FeatureStore2 = _interopRequireDefault(_FeatureStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsNavContainer = function (_React$Component) {
	  _inherits(SettingsNavContainer, _React$Component);
	
	  function SettingsNavContainer() {
	    _classCallCheck(this, SettingsNavContainer);
	
	    return _possibleConstructorReturn(this, (SettingsNavContainer.__proto__ || Object.getPrototypeOf(SettingsNavContainer)).apply(this, arguments));
	  }
	
	  _createClass(SettingsNavContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_SettingsNav2.default, this.state);
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var user = _CurrentUser2.default.getUser();
	      var canCollectMoney = user.canCollectMoney();
	      var canSendMoney = user.canSendMoney();
	      var isTeacher = user.isTeacher();
	      var canOwnGroups = user.canOwnGroups();
	      var showNewAccount = _FeatureStore2.default.hasFeature('web.new_account');
	
	      return {
	        canGoToTransactionSettings: canCollectMoney || canSendMoney,
	        showMessageSettings: isTeacher,
	        canOwnGroups: canOwnGroups,
	        showNewAccount: showNewAccount
	      };
	    }
	  }]);
	
	  return SettingsNavContainer;
	}(_react2.default.Component);
	
	SettingsNavContainer.displayName = 'SettingsNavContainer';
	exports.default = _utils.Container.create(SettingsNavContainer);

/***/ },
/* 2996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _NavItem = __webpack_require__(2997);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	__webpack_require__(3000);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SettingsNav = function (_React$Component) {
	  _inherits(SettingsNav, _React$Component);
	
	  function SettingsNav() {
	    _classCallCheck(this, SettingsNav);
	
	    return _possibleConstructorReturn(this, (SettingsNav.__proto__ || Object.getPrototypeOf(SettingsNav)).apply(this, arguments));
	  }
	
	  _createClass(SettingsNav, [{
	    key: 'renderTransactionsNavItem',
	    value: function renderTransactionsNavItem() {
	      return _react2.default.createElement(
	        _NavItem2.default,
	        { key: 'Transactions', to: '/settings/transactions' },
	        'Transactions'
	      );
	    }
	  }, {
	    key: 'renderMessageSettingsNavItem',
	    value: function renderMessageSettingsNavItem() {
	      return _react2.default.createElement(
	        _NavItem2.default,
	        { key: 'ChatSettings', to: '/settings/chat' },
	        'Message settings'
	      );
	    }
	  }, {
	    key: 'renderNotificationNavItem',
	    value: function renderNotificationNavItem() {
	      return _react2.default.createElement(
	        _NavItem2.default,
	        {
	          key: 'NotificationSettings',
	          to: '/settings/notifications' },
	        'Notifications'
	      );
	    }
	  }, {
	    key: 'renderPrivacyNavItem',
	    value: function renderPrivacyNavItem() {
	      return _react2.default.createElement(
	        _NavItem2.default,
	        { key: 'PrivacySettings', to: '/settings/privacy' },
	        'Blocked users'
	      );
	    }
	  }, {
	    key: 'renderPrintNavItem',
	    value: function renderPrintNavItem() {
	      return _react2.default.createElement(
	        _NavItem2.default,
	        { key: 'PrintSettings', to: '/settings/export' },
	        'Print'
	      );
	    }
	  }, {
	    key: 'renderUserProfileNavItem',
	    value: function renderUserProfileNavItem() {
	      var to = this.props.showNewAccount ? '/settings/profile' : '/settings';
	      return _react2.default.createElement(
	        _NavItem2.default,
	        { key: 'UserProfile', to: to },
	        'Profile'
	      );
	    }
	  }, {
	    key: 'renderUserSettingsNavItem',
	    value: function renderUserSettingsNavItem() {
	      return _react2.default.createElement(
	        _NavItem2.default,
	        { key: 'UserSettings', to: '/settings/account' },
	        'Account Settings'
	      );
	    }
	  }, {
	    key: 'renderWidgetNavItem',
	    value: function renderWidgetNavItem() {
	      return _react2.default.createElement(
	        _NavItem2.default,
	        { key: 'WidgetSettings', to: '/settings/widget' },
	        'Widgets'
	      );
	    }
	  }, {
	    key: 'renderArchivedClassesNavItem',
	    value: function renderArchivedClassesNavItem() {
	      return _react2.default.createElement(
	        _NavItem2.default,
	        { key: 'ArchivedClassesSettings', to: '/settings/archived' },
	        'Archived classes'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('SettingsNav', this.props.className) },
	        _react2.default.createElement(
	          'ul',
	          null,
	          this.renderUserProfileNavItem(),
	          this.props.showNewAccount && this.renderUserSettingsNavItem(),
	          this.renderNotificationNavItem(),
	          this.props.showMessageSettings && this.renderMessageSettingsNavItem(),
	          this.props.canOwnGroups && this.renderWidgetNavItem(),
	          this.props.canOwnGroups && this.renderPrintNavItem(),
	          this.props.canGoToTransactionSettings && this.renderTransactionsNavItem(),
	          this.renderPrivacyNavItem(),
	          this.props.canOwnGroups && this.renderArchivedClassesNavItem()
	        )
	      );
	    }
	  }]);
	
	  return SettingsNav;
	}(_react2.default.Component);
	
	SettingsNav.displayName = 'SettingsNav';
	exports.default = SettingsNav;

/***/ },
/* 2997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(2998);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavItem = function (_React$Component) {
	  _inherits(NavItem, _React$Component);
	
	  function NavItem() {
	    _classCallCheck(this, NavItem);
	
	    return _possibleConstructorReturn(this, (NavItem.__proto__ || Object.getPrototypeOf(NavItem)).apply(this, arguments));
	  }
	
	  _createClass(NavItem, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'li',
	        { className: 'NavItem' },
	        _react2.default.createElement(
	          _Link2.default,
	          _extends({}, this.props, {
	            onlyActiveOnIndex: true,
	            className: 'NavItem-link',
	            activeClassName: 'NavItem-link-active',
	            eventElementName: 'NavItem-link' }),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return NavItem;
	}(_react2.default.Component);
	
	NavItem.displayName = 'NavItem';
	exports.default = NavItem;

/***/ },
/* 2998 */
1136,
/* 2999 */,
/* 3000 */
1136,
/* 3001 */,
/* 3002 */
1136,
/* 3003 */,
/* 3004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FeatureStore = __webpack_require__(588);
	
	var _FeatureStore2 = _interopRequireDefault(_FeatureStore);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserEmailsForm = __webpack_require__(3005);
	
	var _UserEmailsForm2 = _interopRequireDefault(_UserEmailsForm);
	
	var _UserPasswordForm = __webpack_require__(3015);
	
	var _UserPasswordForm2 = _interopRequireDefault(_UserPasswordForm);
	
	var _UserPersonalInfoForm = __webpack_require__(3016);
	
	var _UserPersonalInfoForm2 = _interopRequireDefault(_UserPersonalInfoForm);
	
	var _UserSchoolsForm = __webpack_require__(3017);
	
	var _UserSchoolsForm2 = _interopRequireDefault(_UserSchoolsForm);
	
	var _UserSignatureForm = __webpack_require__(3024);
	
	var _UserSignatureForm2 = _interopRequireDefault(_UserSignatureForm);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	__webpack_require__(3026);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserSettingsView = _react2.default.createClass({
	  displayName: 'UserSettingsView',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  componentWillMount: function componentWillMount() {
	    if (_FeatureStore2.default.hasFeature('web.new_account')) {
	      this.context.router.replace('/settings/profile');
	    }
	  },
	  deleteAccount: function deleteAccount() {
	    window.location = _LinkConstants2.default.MARKETING;
	  },
	  renderAdditionalForms: function renderAdditionalForms() {
	    return {
	      teacher: function teacher() {
	        return [_react2.default.createElement(_UserSignatureForm2.default, { key: 'UserSignatureForm' }), _react2.default.createElement(_Divider2.default, { key: 'Divider-UserSignatureForm' })];
	      },
	      student: function student() {
	        return [];
	      },
	      parent: function parent() {
	        return [];
	      }
	    }[_CurrentUser2.default.getUser().getRole()]();
	  },
	  renderConfirmModal: function renderConfirmModal() {
	    var subtext = _CurrentUser2.default.getUser().canCreateGroups() ? 'You will no longer have access to your classes or participants. ' + 'This action can’t be undone.' : 'You will no longer have access to your classes. This action can’t be undone.';
	
	    return _react2.default.createElement(_ConfirmDialog2.default, {
	      eventScreenName: 'UserSettingsView',
	      actionButtonText: 'Delete',
	      cancelButtonText: 'Cancel',
	      size: 'xsmall',
	      glyph: 'trash',
	      glyphColor: 'lava',
	      onConfirm: this.deleteAccount,
	      preConfirmPromise: _UserActions2.default.delete,
	      title: 'Are you sure you want to delete your account?',
	      subtext: subtext
	    });
	  },
	  renderDeleteAccountForm: function renderDeleteAccountForm() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: this.renderConfirmModal() },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'UserSettingsView-deleteAccountBtn',
	            size: 'xsmall',
	            level: 'secondary',
	            color: 'lava',
	            eventElementName: 'UserSettingsView-deleteAccountBtn' },
	          'Delete account'
	        )
	      )
	    );
	  },
	  renderSchoolsSection: function renderSchoolsSection() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_UserSchoolsForm2.default, null),
	      _react2.default.createElement(_Divider2.default, null)
	    );
	  },
	  renderTermsAndPrivacyLink: function renderTermsAndPrivacyLink() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Link2.default,
	        {
	          href: _LinkConstants2.default.TERMS_OF_SERVICE,
	          target: '_blank',
	          color: 'thunder' },
	        'Terms & Privacy'
	      )
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('UserSettingsView', this.props.className) },
	      this.renderAdditionalForms(),
	      _react2.default.createElement(_UserPersonalInfoForm2.default, null),
	      _react2.default.createElement(_Divider2.default, null),
	      _react2.default.createElement(_UserEmailsForm2.default, null),
	      _react2.default.createElement(_Divider2.default, null),
	      _CurrentUser2.default.getUser().isOrganizationPickerEligible() && this.renderSchoolsSection(),
	      _react2.default.createElement(_UserPasswordForm2.default, null),
	      _react2.default.createElement(_Divider2.default, null),
	      this.renderDeleteAccountForm(),
	      this.renderTermsAndPrivacyLink()
	    );
	  }
	}); /*  weak */
	exports.default = UserSettingsView;

/***/ },
/* 3005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _DeviceStore = __webpack_require__(1019);
	
	var _DeviceStore2 = _interopRequireDefault(_DeviceStore);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingsContainer = __webpack_require__(2970);
	
	var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
	
	var _UserEmailDevice = __webpack_require__(3006);
	
	var _UserEmailDevice2 = _interopRequireDefault(_UserEmailDevice);
	
	var _NewEmailDeviceForm = __webpack_require__(3010);
	
	var _NewEmailDeviceForm2 = _interopRequireDefault(_NewEmailDeviceForm);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	__webpack_require__(3013);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserEmailsForm = _react2.default.createClass({
	  displayName: 'UserEmailsForm',
	
	  mixins: [(0, _linkStateWithStores2.default)([_DeviceStore2.default])],
	
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  componentWillMount: function componentWillMount() {
	    _DeviceActions2.default.loadDevices();
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      devices: _DeviceStore2.default.getDevices()
	    };
	  },
	  getDevices: function getDevices() {
	    return this.state.devices.type('email').sort(function (a, b) {
	      var verified = b.isVerified() - a.isVerified();
	      if (verified !== 0) {
	        return verified;
	      } else {
	        return a.id > b.id;
	      }
	    });
	  },
	  canRemoveEmail: function canRemoveEmail() {
	    if (this.state.devices.type('email').length < 2) {
	      // Cannot remove if it's the only one
	      return false;
	    }
	    return true;
	  },
	  render: function render() {
	    var _this = this;
	
	    return _react2.default.createElement(
	      _SettingsContainer2.default,
	      { className: 'UserEmailsForm' },
	      _react2.default.createElement(
	        _Fieldset2.default,
	        null,
	        _react2.default.createElement(
	          _Legend2.default,
	          null,
	          'Email',
	          _react2.default.createElement(
	            'p',
	            null,
	            'Choose where you\u2019d like to receive account and message notifications.'
	          )
	        ),
	        this.getDevices().map(function (d) {
	          return _react2.default.createElement(_UserEmailDevice2.default, {
	            key: d.id,
	            device: d,
	            btnDisabled: !_this.canRemoveEmail()
	          });
	        }),
	        _react2.default.createElement(
	          _Columns2.default,
	          null,
	          _react2.default.createElement(_NewEmailDeviceForm2.default, null)
	        )
	      )
	    );
	  }
	});
	exports.default = UserEmailsForm;

/***/ },
/* 3006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Coin = __webpack_require__(1671);
	
	var _Coin2 = _interopRequireDefault(_Coin);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResentConfirmationEmail = __webpack_require__(3007);
	
	var _ResentConfirmationEmail2 = _interopRequireDefault(_ResentConfirmationEmail);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(3008);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserEmailDevice = _react2.default.createClass({
	  displayName: 'UserEmailDevice',
	  getInitialState: function getInitialState() {
	    return {
	      isHovering: false
	    };
	  },
	  onRemoveSuccess: function onRemoveSuccess(device) {
	    _ToastActions2.default.showSuccessToast(device.getLabel() + ' removed');
	  },
	  onRemoveError: function onRemoveError() {
	    _ToastActions2.default.showDefaultErrorToast();
	  },
	  removeEmail: function removeEmail() {
	    return _DeviceActions2.default.deleteEmailDevice(this.props.device).then(this.onRemoveSuccess, this.onRemoveError);
	  },
	  renderConfirmDialog: function renderConfirmDialog() {
	    return _react2.default.createElement(_ConfirmDialog2.default, {
	      eventScreenName: 'UserEmailDevice',
	      actionButtonText: 'Remove',
	      cancelButtonText: 'Cancel',
	      size: 'xsmall',
	      glyph: 'caution',
	      glyphColor: 'lava',
	      title: 'Remove ' + this.props.device.getLabel() + '?',
	      subtext: 'This email address will no longer be associated with your account. You can always\n          add it again!',
	      preConfirmPromise: this.removeEmail
	    });
	  },
	  renderHoverContent: function renderHoverContent() {
	    return _react2.default.createElement(
	      _ModalTrigger2.default,
	      { modal: this.renderConfirmDialog() },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'UserEmailDevice-Row-removeBtn',
	          level: 'secondary',
	          size: 'xsmall',
	          color: 'lava',
	          tooltip: this.props.btnDisabled ? 'Want to stay in touch? Add another email address\n            before removing your primary email address' : '',
	          tooltipAlignment: 'right',
	          tooltipPlacement: 'bottom',
	          disabled: this.props.btnDisabled,
	          eventElementName: 'UserEmailDevice-Row-removeBtn' },
	        'Remove'
	      )
	    );
	  },
	  renderVerified: function renderVerified() {
	    return _react2.default.createElement(
	      _Coin2.default,
	      { color: 'shamrock', size: 'xxsmall' },
	      _react2.default.createElement(_Glyph2.default, { name: 'check', color: 'white', solo: true })
	    );
	  },
	  renderNotVerified: function renderNotVerified() {
	    return _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        _Coin2.default,
	        { border: 'flame', size: 'xxsmall' },
	        _react2.default.createElement(_Glyph2.default, { name: 'explanation', color: 'flame', solo: true })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'UserEmailDevice-VerificationText' },
	        'Pending confirmation. ',
	        ' ',
	        _react2.default.createElement(
	          _ResentConfirmationEmail2.default,
	          {
	            className: 'UserEmailDevice-ResendConfirmation',
	            email: this.props.device },
	          'Resend email'
	        )
	      )
	    );
	  },
	  render: function render() {
	    var _this = this;
	
	    var device = this.props.device;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        key: device.id,
	        className: 'UserEmailDevice',
	        onMouseEnter: function onMouseEnter() {
	          return _this.setState({ isHovering: true });
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this.setState({ isHovering: false });
	        } },
	      _react2.default.createElement(
	        _FlexibleBlock2.default,
	        { flex: 'left' },
	        _react2.default.createElement(
	          'div',
	          { className: 'UserEmailDevice-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            {
	              color: device.isVerified() ? 'pitch' : 'thunder',
	              weight: 'semibold' },
	            device.getLabel(),
	            ' ',
	            device.isVerified() ? this.renderVerified() : this.renderNotVerified()
	          )
	        ),
	        this.state.isHovering && this.renderHoverContent()
	      )
	    );
	  }
	});
	exports.default = UserEmailDevice;

/***/ },
/* 3007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* Component to resend a confirmation email:
	 *
	 * if (user.getUnconfirmedEmail()) {
	 *  var resent = <ResentConfirmationEmail>Click me!</ResentConfirmationEmail>;
	 * }
	 *
	 */
	var ResentConfirmationEmail = function (_React$Component) {
	  _inherits(ResentConfirmationEmail, _React$Component);
	
	  function ResentConfirmationEmail() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ResentConfirmationEmail);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResentConfirmationEmail.__proto__ || Object.getPrototypeOf(ResentConfirmationEmail)).call.apply(_ref, [this].concat(args))), _this), _this.resendConfirmation = function () {
	      var success = function success() {
	        var email = _this.props.email && _this.props.email.getEndpoint() || _CurrentUser2.default.getUser().getUnconfirmedEmail();
	
	        if (!_this.props.silent) {
	          _ToastActions2.default.showSuccessToast('Sent confirmation link to ' + email);
	        }
	
	        if (_this.props.onSuccess) {
	          _this.props.onSuccess();
	        }
	      };
	
	      var onFailure = function onFailure() {
	        if (!_this.props.silent) {
	          _ToastActions2.default.showDefaultErrorToast();
	        }
	
	        if (_this.props.onError) {
	          _this.props.onError();
	        }
	      };
	
	      if (_this.props.email) {
	        _this.props.email.resendConfirmationEmail().then(success, onFailure);
	      } else {
	        _UserActions2.default.requestConfirmation().then(success, onFailure);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ResentConfirmationEmail, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Link2.default,
	        _extends({
	          onClick: this.resendConfirmation
	        }, this.props),
	        this.props.children
	      );
	    }
	  }]);
	
	  return ResentConfirmationEmail;
	}(_react2.default.Component);
	
	ResentConfirmationEmail.defaultProps = {
	  silent: false
	};
	ResentConfirmationEmail.displayName = 'ResentConfirmationEmail';
	exports.default = ResentConfirmationEmail;

/***/ },
/* 3008 */
1136,
/* 3009 */,
/* 3010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _SettingsContainer = __webpack_require__(2970);
	
	var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _AddButton = __webpack_require__(1894);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _User = __webpack_require__(554);
	
	var _User2 = _interopRequireDefault(_User);
	
	var _EmailMergeConfirmation = __webpack_require__(1404);
	
	var _EmailMergeConfirmation2 = _interopRequireDefault(_EmailMergeConfirmation);
	
	var _modal = __webpack_require__(1188);
	
	__webpack_require__(3011);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EXISTING_EMAIL_ERROR = 'email_exists';
	
	var EVENT_SCREEN_NAME = 'settings_page';
	
	var NewEmailDeviceForm = _react2.default.createClass({
	  displayName: 'NewEmailDeviceForm',
	  getInitialState: function getInitialState() {
	    return {
	      user: _CurrentUser2.default.getUser(),
	      isEnteringEmail: false,
	      hasChanged: false,
	      canSubmit: false,
	      errorMessage: '',
	      code: '',
	      enteredEmail: ''
	    };
	  },
	  renderEmailMergeConfirmation: function renderEmailMergeConfirmation() {
	    return _react2.default.createElement(_EmailMergeConfirmation2.default, {
	      oldUserEmail: this.state.enteredEmail,
	      errorMessage: this.state.errorMessage,
	      eventScreenName: EVENT_SCREEN_NAME,
	      onDone: _DeviceActions2.default.loadDevices
	    });
	  },
	  onAddSuccess: function onAddSuccess(response) {
	    var label = response.getLabel ? response.getLabel() : response.getEmail();
	    this.setState({ isEnteringEmail: false, errorMessage: '' });
	    _ToastActions2.default.showSuccessToast(label + ' added');
	  },
	  onAddError: function onAddError(error) {
	    var errorMessage = void 0;
	
	    if (error.field_errors) {
	      errorMessage = error.field_errors.map(function (fieldError) {
	        return fieldError.messages.join(', ');
	      }).join(', ');
	    } else {
	      // DeviceActions.newEmailDevice return deprecated validation
	      errorMessage = error.message;
	    }
	
	    this.setState({ errorMessage: errorMessage });
	
	    if (error.code === EXISTING_EMAIL_ERROR) {
	      (0, _modal.mountModal)(this.renderEmailMergeConfirmation(), this);
	      this.setState({ isEnteringEmail: false, errorMessage: '', enteredEmail: '' });
	    }
	  },
	  handleAddButtonClick: function handleAddButtonClick() {
	    this.setState({ isEnteringEmail: true });
	  },
	  handleCancelButtonClick: function handleCancelButtonClick() {
	    this.setState({ isEnteringEmail: false, errorMessage: '', enteredEmail: '' });
	  },
	  handleSaveButtonClick: function handleSaveButtonClick(_ref) {
	    var email = _ref.email;
	
	    this.setState({ isEnteringEmail: false, errorMessage: '', enteredEmail: email });
	    _DeviceActions2.default.newEmailDevice(email).then(this.onAddSuccess, this.onAddError);
	  },
	  enableChanged: function enableChanged() {
	    this.setState({ hasChanged: true, errorMessage: '' });
	  },
	  disableButton: function disableButton() {
	    this.setState({ canSubmit: false });
	  },
	  enableButton: function enableButton() {
	    if (this.state.hasChanged) {
	      this.setState({ canSubmit: true });
	    }
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _Form2.default,
	      {
	        key: this.state.user.cid,
	        onChange: this.enableChanged,
	        onValid: this.enableButton,
	        onValidSubmit: this.handleSaveButtonClick,
	        onInvalid: this.disableButton },
	      _react2.default.createElement(
	        _SettingsContainer2.default,
	        {
	          className: 'NewEmailDeviceForm' },
	        this.state.isEnteringEmail ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'NewEmailDeviceForm-addEmail' },
	            _react2.default.createElement(_FormInput2.default, {
	              className: 'NewEmailDeviceForm-addEmailInput',
	              name: 'email',
	              type: 'email',
	              validations: 'isEmail',
	              placeholder: 'Enter an email address',
	              autofocus: true
	            })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'NewEmailDeviceForm-save',
	              size: 'small',
	              type: 'submit',
	              disabled: !this.state.canSubmit,
	              eventElementName: 'NewEmailDeviceForm-save' },
	            'Save'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'NewEmailDeviceForm-cancel',
	              size: 'small',
	              onClick: this.handleCancelButtonClick,
	              level: 'secondary',
	              eventElementName: 'NewEmailDeviceForm-cancel' },
	            'Cancel'
	          )
	        ) : _react2.default.createElement(
	          _AddButton2.default,
	          {
	            size: 'large',
	            className: 'NewEmailDeviceForm-addEmail',
	            onClick: this.handleAddButtonClick },
	          'Add an email address'
	        )
	      )
	    );
	  }
	});
	
	exports.default = NewEmailDeviceForm;

/***/ },
/* 3011 */
1136,
/* 3012 */,
/* 3013 */
1136,
/* 3014 */,
/* 3015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingsContainer = __webpack_require__(2970);
	
	var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var UserPasswordForm = _react2.default.createClass({
	  displayName: 'UserPasswordForm',
	  getInitialState: function getInitialState() {
	    return {
	      user: _CurrentUser2.default.isSignedIn() ? _CurrentUser2.default.getUser() : null,
	      canSubmit: false
	    };
	  },
	  disableButton: function disableButton() {
	    this.setState({ canSubmit: false });
	  },
	  enableButton: function enableButton() {
	    this.setState({ canSubmit: true });
	  },
	  submit: function submit(values) {
	    _UserActions2.default.changePassword(values.current_password, values.password).then(function () {
	      return _ToastActions2.default.showSuccessToast('Password has been changed!');
	    }).catch(_ToastActions2.default.showDefaultErrorToast);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _Form2.default,
	      {
	        onValid: this.enableButton,
	        onValidSubmit: this.submit,
	        onInvalid: this.disableButton },
	      _react2.default.createElement(
	        _Fieldset2.default,
	        { legend: 'Password' },
	        _react2.default.createElement(
	          _SettingsContainer2.default,
	          null,
	          _react2.default.createElement(
	            _Columns2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_FormInput2.default, {
	                label: 'Current password',
	                type: 'password',
	                className: 'UserPasswordForm-password',
	                name: 'current_password',
	                validations: 'minLength:6',
	                validOnPristine: true,
	                validationError: 'Password must be at least 6 characters long.'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Columns2.default,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_FormInput2.default, {
	                label: 'New password',
	                type: 'password',
	                autoComplete: 'new-password',
	                className: 'UserPasswordForm-password',
	                name: 'password',
	                required: true,
	                validations: 'minLength:6',
	                validOnPristine: true,
	                validationError: 'Password must be at least 6 characters long.'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_FormInput2.default, {
	                label: 'Retype password',
	                type: 'password',
	                autoComplete: 'new-password',
	                className: 'UserPasswordForm-password',
	                name: 'password_confirmation',
	                validations: 'equalsField:password',
	                validationError: 'Must be same as password',
	                validOnPristine: true
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            size: 'small',
	            type: 'submit',
	            disabled: !this.state.canSubmit },
	          'Save'
	        )
	      )
	    );
	  }
	});
	
	exports.default = UserPasswordForm;

/***/ },
/* 3016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormSelect = __webpack_require__(1365);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SettingsContainer = __webpack_require__(2970);
	
	var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var UserPersonalInfoForm = _react2.default.createClass({
	  displayName: 'UserPersonalInfoForm',
	
	  mixins: [(0, _linkStateWithStores2.default)([_CurrentUser2.default, _SettingsStore2.default])],
	
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      user: _CurrentUser2.default.isSignedIn() ? _CurrentUser2.default.getUser() : null,
	      canSubmit: false,
	      hasChanged: false,
	      countries: _SettingsStore2.default.getSetting('countries')
	    };
	  },
	  disableButton: function disableButton() {
	    this.setState({ canSubmit: false });
	  },
	  enableButton: function enableButton() {
	    if (this.state.hasChanged) {
	      this.setState({ canSubmit: true });
	    }
	  },
	  enableChanged: function enableChanged() {
	    this.setState({ hasChanged: true });
	  },
	  submit: function submit(attrs, resetForm, invalidateForm) {
	    var _this = this;
	
	    // When the user changes country we reload all the user classes.
	    // This is because the class subscription info changes depending on the user country.
	    if (attrs['country_code'] !== _CurrentUser2.default.getUser().getCountryCode()) {
	      _GroupActions2.default.loadGroups();
	    }
	
	    var emailChanged = attrs.email && attrs.email !== _CurrentUser2.default.getUser().getEmail();
	
	    var reset = function reset() {
	      _this.disableButton();
	      _this.setState({ hasChanged: false });
	    };
	
	    var onSuccess = function onSuccess() {
	      _ToastActions2.default.showSuccessToast(emailChanged ? 'Changes saved. Please verify your new email address.' : 'Changes saved');
	    };
	
	    var onFailure = function onFailure(error) {
	      _ToastActions2.default.showAPIError(error);
	
	      var errors = {};
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = error.field_errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var field = _step.value;
	
	          errors[field['field_name']] = field.messages.join(', ');
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      invalidateForm(errors);
	    };
	
	    _UserActions2.default.update(attrs).then(reset).then(onSuccess, onFailure);
	  },
	  render: function render() {
	    var language = this.state.user.getLocale();
	
	    // API accepts both en and en_US, but en-US is correct format
	    if (language === 'en') {
	      language = 'en-US';
	    }
	
	    return _react2.default.createElement(
	      _Form2.default,
	      {
	        key: this.state.user.cid,
	        onChange: this.enableChanged,
	        onValid: this.enableButton,
	        onValidSubmit: this.submit,
	        onInvalid: this.disableButton },
	      _react2.default.createElement(
	        _Fieldset2.default,
	        { legend: 'Personal information' },
	        _react2.default.createElement(
	          _SettingsContainer2.default,
	          null,
	          _react2.default.createElement(
	            _Columns2.default,
	            { gutter: 'small' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_FormInput2.default, {
	                label: 'First name',
	                name: 'first_name',
	                value: this.state.user.getFirstName(),
	                validations: 'minLength: 1',
	                validationError: 'First name is required'
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_FormInput2.default, {
	                label: 'Last name',
	                name: 'last_name',
	                value: this.state.user.getLastName(),
	                validations: 'minLength:1',
	                validationError: 'Last name is required'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Columns2.default,
	            { gutter: 'small' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_FormSelect2.default, {
	                label: 'Country',
	                name: 'country_code',
	                options: this.state.countries.map(function (country) {
	                  return { value: country.code, label: country.name };
	                }),
	                value: this.state.user.getCountryCode(),
	                validations: 'minLength: 1',
	                validationError: 'Country is required.'
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            size: 'small',
	            type: 'submit',
	            disabled: !this.state.canSubmit },
	          'Save'
	        )
	      )
	    );
	  }
	});
	
	exports.default = UserPersonalInfoForm;

/***/ },
/* 3017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(555);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AddButton = __webpack_require__(1894);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _AffiliationStore = __webpack_require__(1038);
	
	var _AffiliationStore2 = _interopRequireDefault(_AffiliationStore);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Groups = __webpack_require__(992);
	
	var _Groups2 = _interopRequireDefault(_Groups);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _SchoolPicker = __webpack_require__(2510);
	
	var _SchoolPicker2 = _interopRequireDefault(_SchoolPicker);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	var _SettingsContainer = __webpack_require__(2970);
	
	var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
	
	var _SettingsSchoolsListItem = __webpack_require__(3018);
	
	var _SettingsSchoolsListItem2 = _interopRequireDefault(_SettingsSchoolsListItem);
	
	__webpack_require__(3022);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserSchoolsForm = _react2.default.createClass({
	  displayName: 'UserSchoolsForm',
	
	  childContextTypes: {
	    eventScreenName: _react2.default.PropTypes.string
	  },
	
	  mixins: [(0, _linkStateWithStores2.default)([_OrganizationStore2.default, _AffiliationStore2.default, _GroupStore2.default])],
	
	  getInitialState: function getInitialState() {
	    return {
	      isEditing: false,
	      addingId: null,
	      schools: _AffiliationStore2.default.getMemberOrganizations(),
	      groups: _GroupStore2.default.getGroups()
	    };
	  },
	  getChildContext: function getChildContext() {
	    return {
	      eventScreenName: 'SettingsSchool'
	    };
	  },
	
	
	  // OrganizationStores fire lots of emitChange during search
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    var same = nextState.schools.length === this.state.schools.length && nextState.groups.length === this.state.groups.length && (0, _lodash.isEqual)(nextState.addingId, this.state.addingId) && (0, _lodash.isEqual)(nextState.isEditing, this.state.isEditing);
	    return !this.state.isEditing || !same;
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (this.state.isEditing && !prevState.isEditing) {
	      this.refs.schoolPicker.focus();
	    }
	  },
	  onSelectSchool: function onSelectSchool(schoolId) {
	    this.setState({ isEditing: false, addingId: schoolId });
	    var schoolIds = this.state.schools.map(function (s) {
	      return s.id;
	    });
	    schoolIds.push(schoolId);
	    _UserActions2.default.update({ organization_ids: schoolIds }).then(this.onAddSuccess, this.onAddError);
	  },
	  onAddSuccess: function onAddSuccess() {
	    _OrganizationActions2.default.loadUserOrganizations();
	    // $FlowFixMe
	    _OrganizationActions2.default.getOrLoadOrganization(this.state.addingId).then(function (school) {
	      _ToastActions2.default.showSuccessToast('You joined ' + school.getName());
	    });
	    this.setState({ addingId: null });
	  },
	  onAddError: function onAddError() {
	    _ToastActions2.default.showDefaultErrorToast();
	    this.setState({ addingId: null });
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      schools: _AffiliationStore2.default.getMemberOrganizations(),
	      groups: _GroupStore2.default.getGroups()
	    };
	  },
	  filterSearchResults: function filterSearchResults(orgs) {
	    var _this = this;
	
	    return orgs.filter(function (org) {
	      return !_this.state.schools.some(function (s) {
	        return s.id === org.id;
	      });
	    });
	  },
	  renderAddSchool: function renderAddSchool() {
	    var _this2 = this;
	
	    var addSchool = this.state.isEditing ? _react2.default.createElement(_SchoolPicker2.default, {
	      className: 'UserSchoolsForm-schoolPicker',
	      organizationType: _OrganizationConstants.OrganizationTypes.SCHOOL,
	      filterSearchResults: this.filterSearchResults,
	      onSelect: this.onSelectSchool,
	      onClear: function onClear() {},
	      onCreateOrganization: function onCreateOrganization(school) {
	        return _this2.onSelectSchool(school.id);
	      },
	      onBlur: function onBlur() {
	        _this2.setState({ isEditing: false });
	      },
	      noQuery: 'Search for a school',
	      ref: 'schoolPicker'
	    }) : _react2.default.createElement(
	      _AddButton2.default,
	      {
	        size: 'large',
	        onClick: function onClick() {
	          _this2.setState({ isEditing: true });
	        } },
	      'Join a school'
	    );
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'UserSchoolsForm-addSchool' },
	      addSchool
	    );
	  },
	  renderSchoolRow: function renderSchoolRow(submitting, school) {
	    return _react2.default.createElement(_SettingsSchoolsListItem2.default, {
	      key: school.id,
	      school: school,
	      affiliation: _AffiliationStore2.default.getAffiliation(school.id),
	      groups: this.state.groups.filter(function (g) {
	        return g.getOrganization() && g.getOrganization().id === school.id && !g.isStaffClass();
	      }),
	      submitting: submitting
	    });
	  },
	
	
	  // quick fix for `.bind` in render
	  renderSchoolRowNotSubmitting: function renderSchoolRowNotSubmitting(school) {
	    return this.renderSchoolRow(false, school);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'UserSchoolsForm' },
	      _react2.default.createElement(
	        _Fieldset2.default,
	        null,
	        _react2.default.createElement(
	          _Legend2.default,
	          null,
	          this.state.schools.length > 1 ? 'Schools' : 'School'
	        ),
	        _react2.default.createElement(
	          _SettingsContainer2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'UserSchoolsForm-schoolList' },
	            this.state.schools.map(this.renderSchoolRowNotSubmitting),
	            this.state.addingId && this.renderSchoolRow(true, _OrganizationStore2.default.getOrganization(this.state.addingId))
	          ),
	          _react2.default.createElement(
	            _Columns2.default,
	            null,
	            !this.state.addingId && this.renderAddSchool(),
	            this.state.isEditing && _react2.default.createElement(_Glyph2.default, { className: 'UserSchoolsForm-closeButton', name: 'close', size: 'large' })
	          )
	        )
	      )
	    );
	  }
	});
	exports.default = UserSchoolsForm;

/***/ },
/* 3018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Affiliation = __webpack_require__(1039);
	
	var _Affiliation2 = _interopRequireDefault(_Affiliation);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Coin = __webpack_require__(1671);
	
	var _Coin2 = _interopRequireDefault(_Coin);
	
	var _CircleSpinner = __webpack_require__(1579);
	
	var _CircleSpinner2 = _interopRequireDefault(_CircleSpinner);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _OrgRoleDropdownMenu = __webpack_require__(1582);
	
	var _OrgRoleDropdownMenu2 = _interopRequireDefault(_OrgRoleDropdownMenu);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdminResignModal = __webpack_require__(3019);
	
	var _AdminResignModal2 = _interopRequireDefault(_AdminResignModal);
	
	var _SettingsRemoveSchoolModal = __webpack_require__(2420);
	
	var _SettingsRemoveSchoolModal2 = _interopRequireDefault(_SettingsRemoveSchoolModal);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _lodash = __webpack_require__(555);
	
	var _roleHelpers = __webpack_require__(1230);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(3020);
	
	var _schoolCircle = __webpack_require__(1000);
	
	var _schoolCircle2 = _interopRequireDefault(_schoolCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AVATAR_NUMBER = 3;
	
	var SettingsSchoolsListItem = function (_React$Component) {
	  _inherits(SettingsSchoolsListItem, _React$Component);
	
	  function SettingsSchoolsListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SettingsSchoolsListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SettingsSchoolsListItem.__proto__ || Object.getPrototypeOf(SettingsSchoolsListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false,
	      hovered: false,
	      savingRole: false,
	      roles: _this.props.affiliation && _this.props.affiliation.roles
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SettingsSchoolsListItem, [{
	    key: 'renderHoverContent',
	    value: function renderHoverContent() {
	      var _props = this.props,
	          groups = _props.groups,
	          affiliation = _props.affiliation,
	          school = _props.school;
	
	
	      var groupsByOwned = (0, _lodash.partition)(groups, function (group) {
	        return group.isOwnedByUser(_CurrentUser2.default.getUserId());
	      });
	
	      var removeSchoolModal = _react2.default.createElement(_SettingsRemoveSchoolModal2.default, {
	        affiliation: affiliation,
	        ownedGroups: groupsByOwned[0],
	        subscribedGroups: groupsByOwned[1],
	        school: school
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'SettingsSchoolsListItem-actionButtons' },
	        affiliation && (0, _Affiliation.isAdmin)(affiliation) && _react2.default.createElement(
	          _ModalTrigger2.default,
	          {
	            className: 'SettingsSchoolsListItem-removeAdminButton',
	            modal: _react2.default.createElement(_AdminResignModal2.default, { affiliation: affiliation, school: school }) },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              color: 'lava',
	              disabled: this.props.submitting,
	              level: 'secondary',
	              size: 'xsmall' },
	            'Remove me as admin'
	          )
	        ),
	        _react2.default.createElement(
	          _ModalTrigger2.default,
	          {
	            className: 'SettingsSchoolsListItem-leaveButton',
	            modal: removeSchoolModal },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              color: 'lava',
	              disabled: this.props.submitting,
	              level: 'secondary',
	              size: 'xsmall' },
	            'Leave'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderGroupAvatars',
	    value: function renderGroupAvatars() {
	      var groups = this.props.groups;
	
	      var avatars = groups.slice(0, AVATAR_NUMBER).map(function (g) {
	        return _react2.default.createElement(_Image2.default, {
	          className: 'SettingsSchoolsListItem-group',
	          key: g.id,
	          src: g.getAvatarUrl()
	        });
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        avatars,
	        groups.length > AVATAR_NUMBER && _react2.default.createElement(
	          _Coin2.default,
	          {
	            className: 'SettingsSchoolsListItem-group',
	            color: 'white',
	            border: 'brand',
	            size: 'xlarge' },
	          '+',
	          groups.length - AVATAR_NUMBER
	        )
	      );
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon(school) {
	      var affiliation = this.props.affiliation;
	
	      var userIsAdmin = affiliation && (0, _Affiliation.isAdmin)(affiliation);
	      var image = _react2.default.createElement(_Image2.default, { height: 32, width: 32, src: _schoolCircle2.default });
	      var badge = _react2.default.createElement(
	        _Coin2.default,
	        {
	          className: 'SettingsSchoolsListItem-icon-badge',
	          color: userIsAdmin ? 'midnight' : 'shamrock',
	          size: 'small' },
	        _react2.default.createElement(_Glyph2.default, { name: userIsAdmin ? 'crown' : 'check', color: 'white', solo: true })
	      );
	
	      if (!school.hasAdmins()) {
	        return image;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        image,
	        badge
	      );
	    }
	  }, {
	    key: 'renderByline',
	    value: function renderByline() {
	      var _this2 = this;
	
	      if (!this.props.affiliation) {
	        return;
	      }
	
	      var roleString = this.state.roles.map(function (e) {
	        return _roleHelpers.roleNameSingular[e];
	      }).join(', ');
	
	      if (!this.props.affiliation.can_have_role_changed || this.state.roles.length === 0 || this.state.savingRole) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'SettingsSchoolsListItem-roleString' },
	            roleString
	          ),
	          this.state.savingRole && _react2.default.createElement(_CircleSpinner2.default, { className: 'SettingsSchoolsListItem-spinner', color: 'shamrock', size: 'small' })
	        );
	      }
	
	      var onClose = function onClose(roles) {
	        if ((0, _lodash.xor)(roles, _this2.state.roles).length > 0) {
	          _this2.setState({ savingRole: true, roles: roles });
	        }
	        _this2.setState({ open: false });
	      };
	
	      var roleDropdown = _react2.default.createElement(_OrgRoleDropdownMenu2.default, {
	        isCurrentUser: true,
	        organization: this.props.school,
	        roles: this.state.roles,
	        potentialRoles: this.props.affiliation.potential_roles,
	        userId: _CurrentUser2.default.getUserId(),
	        onClose: onClose,
	        onSave: function onSave() {
	          return _this2.setState({ savingRole: false });
	        }
	      });
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        {
	          layer: roleDropdown,
	          trigger: 'click',
	          placement: 'bottom',
	          alignment: 'left' },
	        _react2.default.createElement(
	          'span',
	          {
	            className: 'SettingsSchoolsListItem-editableRole',
	            onClick: function onClick() {
	              return _this2.setState({ open: !_this2.state.open });
	            } },
	          _react2.default.createElement(
	            'span',
	            { className: 'SettingsSchoolsListItem-editableRole-text' },
	            roleString
	          ),
	          _react2.default.createElement(_Glyph2.default, {
	            name: 'chevron-down',
	            color: 'thunder',
	            size: 'xxsmall',
	            className: (0, _classnames2.default)({
	              'SettingsSchoolsListItem-editableRole-chevron': true,
	              'SettingsSchoolsListItem-editableRole-chevronClosed': !this.state.open,
	              'SettingsSchoolsListItem-editableRole-chevronOpen': this.state.open
	            })
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          school = _props2.school,
	          submitting = _props2.submitting;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'SettingsSchoolsListItem',
	          onMouseEnter: function onMouseEnter() {
	            return _this3.setState({ hovered: true });
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this3.setState({ hovered: false });
	          } },
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'left' },
	          _react2.default.createElement(
	            _FlexibleBlock2.default,
	            { flex: 'right', className: 'SettingsSchoolsListItem-school' },
	            _react2.default.createElement(
	              'div',
	              { className: 'SettingsSchoolsListItem-icon' },
	              this.renderIcon(school)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'SettingsSchoolsListItem-content' },
	              _react2.default.createElement(
	                'div',
	                { className: 'SettingsSchoolsListItem-name' },
	                _react2.default.createElement(
	                  _Text2.default,
	                  { size: 'small', color: submitting ? 'eclipse' : 'pitch' },
	                  school.getName()
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'SettingsSchoolsListItem-byline' },
	                _react2.default.createElement(
	                  _Text2.default,
	                  { size: 'small', color: 'thunder' },
	                  this.renderByline()
	                )
	              )
	            )
	          ),
	          this.state.hovered ? this.renderHoverContent() : this.renderGroupAvatars()
	        )
	      );
	    }
	  }]);
	
	  return SettingsSchoolsListItem;
	}(_react2.default.Component);
	
	SettingsSchoolsListItem.defaultProps = {
	  submitting: false,
	  groups: []
	};
	SettingsSchoolsListItem.displayName = 'SettingsSchoolsListItem';
	exports.default = SettingsSchoolsListItem;

/***/ },
/* 3019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _OrgRoleActions = __webpack_require__(1583);
	
	var _Affiliation = __webpack_require__(1039);
	
	var _Affiliation2 = _interopRequireDefault(_Affiliation);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminResignModal = function (_React$Component) {
	  _inherits(AdminResignModal, _React$Component);
	
	  function AdminResignModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AdminResignModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminResignModal.__proto__ || Object.getPrototypeOf(AdminResignModal)).call.apply(_ref, [this].concat(args))), _this), _this.resignAsAdmin = function () {
	      return (0, _OrgRoleActions.resignAdminship)(_this.props.school.id, _CurrentUser2.default.getUserId()).then(function () {
	        return _ToastActions2.default.showSuccessToast('You have been remove as administrator of ' + _this.props.school.getName());
	      }, _ToastActions2.default.showDefaultErrorToast);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AdminResignModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'AdminResignModal',
	        title: 'Remove yourself as administrator of ' + this.props.school.getName() + '?',
	        subtext: 'Once you do, you won\u2019t have access to your school\u2019s staff list, staff messaging, and other features for verified administrators.',
	        actionButtonText: 'Remove myself as administrator',
	        cancelButtonText: 'Cancel',
	        className: 'AdminResignModal',
	        preConfirmPromise: this.resignAsAdmin,
	        actionButtonColor: 'lava',
	        onRequestHide: this.props.onRequestHide
	      });
	    }
	  }]);
	
	  return AdminResignModal;
	}(_react2.default.Component);
	
	AdminResignModal.displayName = 'AdminResignModal';
	exports.default = AdminResignModal;

/***/ },
/* 3020 */
1136,
/* 3021 */,
/* 3022 */
1136,
/* 3023 */,
/* 3024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserSignatureForm = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  mutation updateSignature($input: UpdateUserInput!) {\n    updateUser(input: $input) {\n      user {\n        id\n        signature\n      }\n      error {\n        message\n      }\n    }\n  }\n  '], ['\n  mutation updateSignature($input: UpdateUserInput!) {\n    updateUser(input: $input) {\n      user {\n        id\n        signature\n      }\n      error {\n        message\n      }\n    }\n  }\n  ']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  query {\n    user: me {\n      id\n      signature\n    }\n  }\n  '], ['\n  query {\n    user: me {\n      id\n      signature\n    }\n  }\n  ']);
	
	var _CopyConstants = __webpack_require__(3025);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _reactApollo = __webpack_require__(467);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _SettingsContainer = __webpack_require__(2970);
	
	var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserSignatureForm = exports.UserSignatureForm = function (_React$Component) {
	  _inherits(UserSignatureForm, _React$Component);
	
	  function UserSignatureForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserSignatureForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserSignatureForm.__proto__ || Object.getPrototypeOf(UserSignatureForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      canSubmit: false,
	      hasChanged: false
	    }, _this.disableButton = function () {
	      _this.setState({ canSubmit: false });
	    }, _this.enableButton = function () {
	      if (_this.state.hasChanged) {
	        _this.setState({ canSubmit: true });
	      }
	    }, _this.enableChanged = function () {
	      _this.setState({ hasChanged: true });
	    }, _this.reset = function () {
	      _this.disableButton();
	      _this.setState({ hasChanged: false });
	    }, _this.submit = function (values) {
	      _this.reset();
	
	      var saveSignature = _this.props.saveSignature;
	
	
	      saveSignature(values.signature).then(function () {
	        return _ToastActions2.default.showSuccessToast('Signature saved');
	      }).catch(_ToastActions2.default.showDefaultErrorToast);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserSignatureForm, [{
	    key: 'componentWillReceiveProps',
	
	
	    // XXX until we have a good mechanism for GraphQL errors (e.g. re-auth)
	    // https://apollographql.slack.com/archives/general/p1478732615013498
	    // FIXME(turadg)
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.error && nextProps.error) {
	        _ToastActions2.default.showDefaultErrorToast();
	        console.warn(nextProps);
	        console.error('GraphQL error');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.user) {
	        return _react2.default.createElement(_LoadingIndicator2.default, null);
	      }
	
	      return _react2.default.createElement(
	        _Form2.default,
	        {
	          onValidSubmit: this.submit,
	          onValid: this.enableButton,
	          onInvalid: this.disableButton,
	          onChange: this.enableChanged },
	        _react2.default.createElement(
	          _Fieldset2.default,
	          null,
	          _react2.default.createElement(
	            _Legend2.default,
	            null,
	            'Signature',
	            _react2.default.createElement(
	              'p',
	              null,
	              _CopyConstants.Signature.explanation
	            )
	          ),
	          _react2.default.createElement(
	            _SettingsContainer2.default,
	            null,
	            _react2.default.createElement(
	              _Columns2.default,
	              { gutter: 'small' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_FormInput2.default, {
	                  required: true,
	                  name: 'signature',
	                  showErrorOnPristine: true,
	                  className: 'UserSignatureForm-signature',
	                  value: this.props.user.signature,
	                  validations: { maxLength: 18 },
	                  validationErrors: {
	                    maxLength: 'Signature can’t be longer than 18 characters.'
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              size: 'small',
	              type: 'submit',
	              className: 'UserSignatureForm-signature-submit',
	              disabled: !this.state.canSubmit,
	              eventElementName: 'UserSignatureForm-signature-submit' },
	            'Save'
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserSignatureForm;
	}(_react2.default.Component);
	
	UserSignatureForm.displayName = 'UserSignatureForm';
	
	
	var withMutations = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  props: function props(_ref2) {
	    var mutate = _ref2.mutate;
	
	    return {
	      saveSignature: function saveSignature(signature) {
	        var input = { signature: signature };
	        return mutate({ variables: { input: input } }).then(function (_ref3) {
	          var updateUser = _ref3.data.updateUser;
	
	          if (updateUser.error) {
	            throw new Error(updateUser.error.message);
	          }
	          // while we support the CurrentUser store
	          _UserActions2.default.updateLocal({ signature: signature });
	        });
	      }
	    };
	  }
	});
	
	var withUser = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject2), {
	  // TODO decide whether to make this the default `props` function
	  props: function props(_ref4) {
	    var data = _ref4.data;
	    return data;
	  }
	});
	
	exports.default = withMutations(withUser(UserSignatureForm));

/***/ },
/* 3025 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Signature = exports.Signature = {
	  explanation: 'Only class participants see your signature on Remind.'
	};

/***/ },
/* 3026 */
1136,
/* 3027 */,
/* 3028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _BlockedUserActions = __webpack_require__(3029);
	
	var _BlockedUserActions2 = _interopRequireDefault(_BlockedUserActions);
	
	var _BlockedUserStore = __webpack_require__(3033);
	
	var _BlockedUserStore2 = _interopRequireDefault(_BlockedUserStore);
	
	var _BlockedUsersList = __webpack_require__(3034);
	
	var _BlockedUsersList2 = _interopRequireDefault(_BlockedUsersList);
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrivacySettingsView = function (_Component) {
	  _inherits(PrivacySettingsView, _Component);
	
	  function PrivacySettingsView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PrivacySettingsView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PrivacySettingsView.__proto__ || Object.getPrototypeOf(PrivacySettingsView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PrivacySettingsView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!_BlockedUserStore2.default.isLoaded()) {
	        _BlockedUserActions2.default.load();
	      }
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList() {
	      return _react2.default.createElement(_BlockedUsersList2.default, { blockedUsers: this.state.blockedUsers });
	    }
	  }, {
	    key: 'renderLoadingIndicator',
	    value: function renderLoadingIndicator() {
	      return _react2.default.createElement(_CenteredLoadingIndicator2.default, null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Fieldset2.default,
	          null,
	          _react2.default.createElement(
	            _Legend2.default,
	            null,
	            'Blocked Users',
	            _react2.default.createElement(
	              'p',
	              null,
	              'Users you have blocked will not be able to send you individual messages or add you to their classes.'
	            )
	          ),
	          this.state.loaded ? this.renderList() : this.renderLoadingIndicator()
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_BlockedUserStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var blockedUsers = _BlockedUserStore2.default.getBlockedUsers();
	      var loaded = _BlockedUserStore2.default.isLoaded();
	
	      return {
	        blockedUsers: blockedUsers,
	        loaded: loaded
	      };
	    }
	  }]);
	
	  return PrivacySettingsView;
	}(_react.Component);
	
	PrivacySettingsView.displayName = 'PrivacySettingsView';
	exports.default = _utils.Container.create(PrivacySettingsView, { pure: false });

/***/ },
/* 3029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BlockedUsers = __webpack_require__(3030);
	
	var _BlockedUsers2 = _interopRequireDefault(_BlockedUsers);
	
	var _BlockedUserConstants = __webpack_require__(3032);
	
	var _Dispatcher = __webpack_require__(590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockedUserActions = {
	  load: function load() {
	    _BlockedUsers2.default.load().then(function (blockedUsers) {
	      _Dispatcher.dispatcher.dispatch({
	        type: _BlockedUserConstants.ActionTypes.LOAD_BLOCKED_USERS,
	        blockedUsers: blockedUsers
	      });
	    }).catch(function (e) {
	      return console.error('BlockedUsers load failed', e);
	    });
	  }
	};
	exports.default = BlockedUserActions;

/***/ },
/* 3030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _Collection2 = __webpack_require__(599);
	
	var _Collection3 = _interopRequireDefault(_Collection2);
	
	var _BlockedUser = __webpack_require__(3031);
	
	var _BlockedUser2 = _interopRequireDefault(_BlockedUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockedUsers = function (_Collection) {
	  _inherits(BlockedUsers, _Collection);
	
	  function BlockedUsers() {
	    _classCallCheck(this, BlockedUsers);
	
	    return _possibleConstructorReturn(this, (BlockedUsers.__proto__ || Object.getPrototypeOf(BlockedUsers)).apply(this, arguments));
	  }
	
	  _createClass(BlockedUsers, [{
	    key: 'initialize',
	    value: function initialize() {
	      this.model = _BlockedUser2.default;
	    }
	  }], [{
	    key: 'load',
	    value: function load() {
	      return (0, _apiRequest2.default)('/related_users/blocked', 'GET').then(function (blockedUsers) {
	        return BlockedUsers.fromJSON(blockedUsers);
	      });
	    }
	  }]);
	
	  return BlockedUsers;
	}(_Collection3.default);
	
	BlockedUsers.displayName = 'BlockedUsers';
	exports.default = BlockedUsers;

/***/ },
/* 3031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockedUser = function (_Entity) {
	  _inherits(BlockedUser, _Entity);
	
	  function BlockedUser() {
	    _classCallCheck(this, BlockedUser);
	
	    return _possibleConstructorReturn(this, (BlockedUser.__proto__ || Object.getPrototypeOf(BlockedUser)).apply(this, arguments));
	  }
	
	  _createClass(BlockedUser, [{
	    key: 'parse',
	    value: function parse(response) {
	      var blockedUser = (0, _lodash.cloneDeep)(response);
	      blockedUser['blocked_at'] = new Date(blockedUser['blocked_at']);
	      return blockedUser;
	    }
	  }, {
	    key: 'getBlockedAt',
	    value: function getBlockedAt() {
	      return this.get('blocked_at');
	    }
	  }, {
	    key: 'getColor',
	    value: function getColor() {
	      return this.get('color');
	    }
	  }, {
	    key: 'getInitials',
	    value: function getInitials() {
	      return this.get('initials');
	    }
	  }, {
	    key: 'getName',
	    value: function getName() {
	      return this.get('name');
	    }
	  }]);
	
	  return BlockedUser;
	}(_Entity3.default);
	
	BlockedUser.displayName = 'BlockedUser';
	exports.default = BlockedUser;

/***/ },
/* 3032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['LOAD_BLOCKED_USERS']); /*  weak */

/***/ },
/* 3033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	var _BlockedUserConstants = __webpack_require__(3032);
	
	var _BlockedUsers = __webpack_require__(3030);
	
	var _BlockedUsers2 = _interopRequireDefault(_BlockedUsers);
	
	var _RelationshipConstants = __webpack_require__(986);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockedUserStore = function (_Store) {
	  _inherits(BlockedUserStore, _Store);
	
	  function BlockedUserStore() {
	    _classCallCheck(this, BlockedUserStore);
	
	    return _possibleConstructorReturn(this, (BlockedUserStore.__proto__ || Object.getPrototypeOf(BlockedUserStore)).apply(this, arguments));
	  }
	
	  _createClass(BlockedUserStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        blockedUsers: new _BlockedUsers2.default(),
	        loaded: false
	      };
	    }
	  }, {
	    key: 'isLoaded',
	    value: function isLoaded() {
	      return this.state.loaded;
	    }
	  }, {
	    key: 'getBlockedUsers',
	    value: function getBlockedUsers() {
	      return this.state.blockedUsers;
	    }
	  }, {
	    key: 'removeBlockedUser',
	    value: function removeBlockedUser(blockedUser) {
	      this.state.blockedUsers.remove(blockedUser);
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _BlockedUserConstants.ActionTypes.LOAD_BLOCKED_USERS:
	          this.handleLoad(action.blockedUsers);
	          break;
	        case _RelationshipConstants.ActionTypes.UPDATE_RELATIONSHIP:
	          this.handleRelationshipUpdate(action.relationship);
	          break;
	        default:
	          break;
	      }
	    }
	  }, {
	    key: 'handleRelationshipUpdate',
	    value: function handleRelationshipUpdate(relationship) {
	      var relatedUser = relationship.getRelatedUser();
	      if (relatedUser.isBlocked()) {
	        this.state.loaded = false;
	      } else {
	        this.removeBlockedUser(relatedUser);
	      }
	      this.emitChange();
	    }
	  }, {
	    key: 'handleLoad',
	    value: function handleLoad(blockedUsers) {
	      this.state.blockedUsers.reset(blockedUsers.models);
	      this.state.loaded = true;
	      this.emitChange();
	    }
	  }]);
	
	  return BlockedUserStore;
	}(_Store3.default);
	
	BlockedUserStore.displayName = 'BlockedUserStore';
	exports.default = new BlockedUserStore();

/***/ },
/* 3034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BlockedUser = __webpack_require__(3031);
	
	var _BlockedUser2 = _interopRequireDefault(_BlockedUser);
	
	var _BlockedUsers = __webpack_require__(3030);
	
	var _BlockedUsers2 = _interopRequireDefault(_BlockedUsers);
	
	var _BlockedUsersListItem = __webpack_require__(3035);
	
	var _BlockedUsersListItem2 = _interopRequireDefault(_BlockedUsersListItem);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(3036);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockedUsersList = function (_React$Component) {
	  _inherits(BlockedUsersList, _React$Component);
	
	  function BlockedUsersList() {
	    _classCallCheck(this, BlockedUsersList);
	
	    return _possibleConstructorReturn(this, (BlockedUsersList.__proto__ || Object.getPrototypeOf(BlockedUsersList)).apply(this, arguments));
	  }
	
	  _createClass(BlockedUsersList, [{
	    key: 'renderColumnHeaders',
	    value: function renderColumnHeaders() {
	      return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	          'th',
	          null,
	          'Name'
	        ),
	        _react2.default.createElement(
	          'th',
	          null,
	          'Date blocked'
	        ),
	        _react2.default.createElement('th', null)
	      );
	    }
	  }, {
	    key: 'renderBlockedUser',
	    value: function renderBlockedUser(blockedUser) {
	      return _react2.default.createElement(_BlockedUsersListItem2.default, {
	        blockedUser: blockedUser,
	        key: blockedUser.id
	      });
	    }
	  }, {
	    key: 'renderBlockedUserList',
	    value: function renderBlockedUserList() {
	      if (this.props.blockedUsers.length > 0) {
	        return this.props.blockedUsers.map(this.renderBlockedUser);
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.blockedUsers.length <= 0) {
	        return _react2.default.createElement(
	          'p',
	          { className: 'BlockedUsersList-empty' },
	          'You have no blocked users.'
	        );
	      }
	
	      return _react2.default.createElement(
	        'table',
	        { className: 'BlockedUsersList' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          this.renderColumnHeaders()
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          this.renderBlockedUserList()
	        )
	      );
	    }
	  }]);
	
	  return BlockedUsersList;
	}(_react2.default.Component);
	
	BlockedUsersList.displayName = 'BlockedUsersList';
	exports.default = BlockedUsersList;

/***/ },
/* 3035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BlockedUser = __webpack_require__(3031);
	
	var _BlockedUser2 = _interopRequireDefault(_BlockedUser);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Avatar = __webpack_require__(1306);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RelationshipActions = __webpack_require__(1006);
	
	var _RelationshipActions2 = _interopRequireDefault(_RelationshipActions);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockedUsersListItem = function (_React$Component) {
	  _inherits(BlockedUsersListItem, _React$Component);
	
	  function BlockedUsersListItem() {
	    _classCallCheck(this, BlockedUsersListItem);
	
	    return _possibleConstructorReturn(this, (BlockedUsersListItem.__proto__ || Object.getPrototypeOf(BlockedUsersListItem)).apply(this, arguments));
	  }
	
	  _createClass(BlockedUsersListItem, [{
	    key: 'unblockUser',
	    value: function unblockUser() {
	      var blockedUser = this.props.blockedUser;
	
	      var id = blockedUser.id;
	      var name = blockedUser.getName();
	      _RelationshipActions2.default.unblock(id, name);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var blockedUser = this.props.blockedUser;
	
	
	      return _react2.default.createElement(
	        'tr',
	        { className: 'BlockedUsersListItem' },
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _Text2.default,
	            {
	              className: 'BlockedUsersListItem-userName',
	              truncate: true },
	            _react2.default.createElement(
	              _MediaObject2.default,
	              { center: true },
	              _react2.default.createElement(_Avatar2.default, {
	                colorHex: blockedUser.getColor(),
	                text: blockedUser.getInitials(),
	                size: 'medium'
	              }),
	              blockedUser.getName()
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_Time2.default, {
	            date: blockedUser.getBlockedAt(),
	            month: 'short',
	            day: 'numeric'
	          })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              level: 'secondary',
	              size: 'small',
	              onClick: function onClick() {
	                return _this2.unblockUser();
	              } },
	            'Unblock'
	          )
	        )
	      );
	    }
	  }]);
	
	  return BlockedUsersListItem;
	}(_react2.default.Component);
	
	BlockedUsersListItem.displayName = 'BlockedUsersListItem';
	exports.default = BlockedUsersListItem;

/***/ },
/* 3036 */
1136,
/* 3037 */,
/* 3038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _Devices = __webpack_require__(1020);
	
	var _Devices2 = _interopRequireDefault(_Devices);
	
	var _DeviceStore = __webpack_require__(1019);
	
	var _DeviceStore2 = _interopRequireDefault(_DeviceStore);
	
	var _waitForPromises = __webpack_require__(2632);
	
	var _waitForPromises2 = _interopRequireDefault(_waitForPromises);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _NotificationSettingsView = __webpack_require__(3039);
	
	var _NotificationSettingsView2 = _interopRequireDefault(_NotificationSettingsView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var NotificationSettingsContainer = function (_React$Component) {
	  _inherits(NotificationSettingsContainer, _React$Component);
	
	  function NotificationSettingsContainer() {
	    _classCallCheck(this, NotificationSettingsContainer);
	
	    return _possibleConstructorReturn(this, (NotificationSettingsContainer.__proto__ || Object.getPrototypeOf(NotificationSettingsContainer)).apply(this, arguments));
	  }
	
	  _createClass(NotificationSettingsContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_NotificationSettingsView2.default, {
	        devices: this.state.devices,
	        showSmsDevices: this.state.showSmsDevices,
	        showNotificationPreferences: this.state.showNotificationPreferences
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_DeviceStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        devices: _DeviceStore2.default.getDevices(),
	        showSmsDevices: _CurrentUser2.default.getUser().hasSmsSupported(),
	        showNotificationPreferences: _CurrentUser2.default.getUser().canCreateGroups()
	      };
	    }
	  }]);
	
	  return NotificationSettingsContainer;
	}(_react2.default.Component);
	
	NotificationSettingsContainer.routePrefetch = [function () {
	  if (!_DeviceStore2.default.isLoaded()) {
	    _DeviceActions2.default.localDeleteAll().then(_DeviceActions2.default.loadDevices);
	  }
	}];
	NotificationSettingsContainer.displayName = 'NotificationSettingsContainer';
	exports.default = (0, _waitForPromises2.default)(_utils.Container.create(NotificationSettingsContainer));

/***/ },
/* 3039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AlertDialog = __webpack_require__(1190);
	
	var _AlertDialog2 = _interopRequireDefault(_AlertDialog);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Coin = __webpack_require__(1671);
	
	var _Coin2 = _interopRequireDefault(_Coin);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _Devices = __webpack_require__(1020);
	
	var _Devices2 = _interopRequireDefault(_Devices);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkSmsDeviceModal = __webpack_require__(3040);
	
	var _LinkSmsDeviceModal2 = _interopRequireDefault(_LinkSmsDeviceModal);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ResentConfirmationEmail = __webpack_require__(3007);
	
	var _ResentConfirmationEmail2 = _interopRequireDefault(_ResentConfirmationEmail);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TextAppLinkForm = __webpack_require__(2168);
	
	var _TextAppLinkForm2 = _interopRequireDefault(_TextAppLinkForm);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _WebNotificationStore = __webpack_require__(2096);
	
	var _WebNotificationStore2 = _interopRequireDefault(_WebNotificationStore);
	
	var _modal = __webpack_require__(1188);
	
	var _NewEmailDeviceForm = __webpack_require__(3010);
	
	var _NewEmailDeviceForm2 = _interopRequireDefault(_NewEmailDeviceForm);
	
	var _NotificationSettingsViewDesktop = __webpack_require__(3041);
	
	var _NotificationSettingsViewDesktop2 = _interopRequireDefault(_NotificationSettingsViewDesktop);
	
	var _NotificationSettingsViewPreferences = __webpack_require__(3042);
	
	var _NotificationSettingsViewPreferences2 = _interopRequireDefault(_NotificationSettingsViewPreferences);
	
	__webpack_require__(3043);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var NotificationSettingsView = function (_React$Component) {
	  _inherits(NotificationSettingsView, _React$Component);
	
	  function NotificationSettingsView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NotificationSettingsView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationSettingsView.__proto__ || Object.getPrototypeOf(NotificationSettingsView)).call.apply(_ref, [this].concat(args))), _this), _this.onDeviceStatusChange = function (device) {
	      // if we are disabling a device and there's only 1 left.
	      if (device.isEnabled() && _this.props.devices.enabled().length <= 1) {
	        (0, _modal.mountModal)(_react2.default.createElement(_AlertDialog2.default, {
	          title: 'Stay in touch',
	          subtext: 'To receive messages from Remind, turn on at least one type of notification.'
	        }), _this);
	
	        return;
	      }
	
	      var savedState = device.isEnabled();
	
	      var onConfirm = function onConfirm() {
	        device.setEnabled(!device.isEnabled());
	
	        var promise = device.isEnabled() ? _DeviceActions2.default.enable(device) : _DeviceActions2.default.disable(device);
	
	        var onSucces = function onSucces() {
	          _ToastActions2.default.showSuccessToast(device.isEnabled() ? 'Notifications turned on for ' + device.getLabel() : 'Notifications turned off for ' + device.getLabel());
	        };
	
	        var onError = function onError() {
	          device.setEnabled(savedState);
	          _ToastActions2.default.showDefaultErrorToast();
	        };
	
	        promise.then(onSucces, onError);
	        _this.forceUpdate();
	      };
	
	      if (savedState === false) {
	        onConfirm();
	        return;
	      }
	
	      (0, _modal.mountModal)(_react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'NotificationSettingsView',
	        title: _react2.default.createElement(
	          'div',
	          null,
	          'Turn off ',
	          device.getNotificationType(),
	          ' for',
	          _react2.default.createElement('br', null),
	          device.getLabel(),
	          '?'
	        ),
	        actionButtonText: 'Turn off',
	        cancelButtonText: 'Cancel',
	        onConfirm: onConfirm,
	        subtext: 'You will no longer get ' + device.getMessageType() + ' when you receive messages on Remind.'
	      }), _this);
	    }, _this.renderUnconfirmedEmailSubtext = function (device) {
	      var text = null;
	      if (device.cannotBeEnabled()) {
	        text = _react2.default.createElement(
	          'div',
	          null,
	          'Please',
	          ' ',
	          _react2.default.createElement(
	            _ResentConfirmationEmail2.default,
	            { email: device },
	            'confirm this email'
	          ),
	          ' ',
	          'to receive notifications.'
	        );
	      } else {
	        text = _react2.default.createElement(
	          'div',
	          null,
	          'Pending confirmation.',
	          ' ',
	          _react2.default.createElement(
	            _ResentConfirmationEmail2.default,
	            { email: device },
	            'Resend email'
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _Coin2.default,
	          { border: 'flame', size: 'xxsmall' },
	          _react2.default.createElement(_Glyph2.default, { name: 'explanation', color: 'flame', solo: true })
	        ),
	        text
	      );
	    }, _this.renderDevice = function (device) {
	      var action = null;
	      if (device.getType() === 'sms') {
	        action = _react2.default.createElement(
	          'span',
	          null,
	          ' ',
	          '\u2022',
	          ' ',
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: _react2.default.createElement(_LinkSmsDeviceModal2.default, { replaceDevice: device }) },
	            _react2.default.createElement(
	              _Link2.default,
	              null,
	              'Edit'
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          key: device.id,
	          className: 'NotificationSettingsView-device' },
	        _react2.default.createElement(
	          _Checkbox2.default,
	          {
	            onChange: function onChange() {
	              return _this.onDeviceStatusChange(device);
	            },
	            disabled: device.cannotBeEnabled(),
	            checked: device.isEnabled() },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Glyph2.default, {
	              name: device.getGlyphName(),
	              size: 'medium',
	              className: 'NotificationSettingsView-device-glyph'
	            }),
	            _react2.default.createElement(
	              _Text2.default,
	              {
	                color: device.isVerified() ? 'pitch' : 'thunder',
	                weight: 'semibold' },
	              device.getLabel(),
	              ' ',
	              device.getType() === 'email' && !device.isVerified() && _this.renderUnconfirmedEmailSubtext(device)
	            ),
	            action
	          )
	        )
	      );
	    }, _this.renderEmailDevices = function () {
	      var devices = _this.props.devices.type('email');
	      if (devices.length === 0) {
	        return _react2.default.createElement(_NewEmailDeviceForm2.default, null);
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        devices.map(_this.renderDevice)
	      );
	    }, _this.renderPushNotificationSettings = function () {
	      var devices = new _Devices2.default([].concat(_this.props.devices.type('apns'), // apple
	      _this.props.devices.type('amd'), // amazon
	      _this.props.devices.type('gcm') // google
	      ));
	
	      if (devices.length <= 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Legend2.default,
	            null,
	            'Push',
	            _react2.default.createElement(
	              'p',
	              null,
	              'Send and receive messages instantly on your phone.'
	            )
	          ),
	          _react2.default.createElement(_TextAppLinkForm2.default, null)
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Legend2.default,
	          null,
	          'Push'
	        ),
	        devices.map(_this.renderDevice)
	      );
	    }, _this.renderSmsDevices = function () {
	      var devices = _this.props.devices.type('sms');
	      if (devices.length <= 0) {
	        return _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: _react2.default.createElement(_LinkSmsDeviceModal2.default, null) },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              size: 'xsmall',
	              className: 'NotificationSettingsView-addSmsDeviceBtn',
	              level: 'secondary',
	              eventElementName: 'NotificationSettingsView-addSmsDeviceBtn' },
	            'Add a mobile device'
	          )
	        );
	      }
	
	      return devices.map(_this.renderDevice);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NotificationSettingsView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'NotificationSettingsView' },
	        this.renderPushNotificationSettings(),
	        this.props.showSmsDevices && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Divider2.default, null),
	          _react2.default.createElement(
	            _Legend2.default,
	            null,
	            'Text message'
	          ),
	          this.renderSmsDevices()
	        ),
	        _react2.default.createElement(_Divider2.default, null),
	        _react2.default.createElement(
	          _Legend2.default,
	          null,
	          'Email'
	        ),
	        this.renderEmailDevices(),
	        _WebNotificationStore2.default.areNotificationsCompatible() && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Divider2.default, null),
	          _react2.default.createElement(_NotificationSettingsViewDesktop2.default, null)
	        ),
	        this.props.showNotificationPreferences && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Divider2.default, null),
	          _react2.default.createElement(_NotificationSettingsViewPreferences2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return NotificationSettingsView;
	}(_react2.default.Component);
	
	NotificationSettingsView.displayName = 'NotificationSettingsView';
	exports.default = NotificationSettingsView;

/***/ },
/* 3040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Device = __webpack_require__(1016);
	
	var _Device2 = _interopRequireDefault(_Device);
	
	var _DeviceActions = __webpack_require__(1013);
	
	var _DeviceActions2 = _interopRequireDefault(_DeviceActions);
	
	var _LinkSmsDevicePage = __webpack_require__(2788);
	
	var _LinkSmsDevicePage2 = _interopRequireDefault(_LinkSmsDevicePage);
	
	var _Modal = __webpack_require__(1207);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LinkSmsDeviceModal = function (_React$Component) {
	  _inherits(LinkSmsDeviceModal, _React$Component);
	
	  function LinkSmsDeviceModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LinkSmsDeviceModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkSmsDeviceModal.__proto__ || Object.getPrototypeOf(LinkSmsDeviceModal)).call.apply(_ref, [this].concat(args))), _this), _this.onDone = function () {
	      // The API delete the old sms device when we verify a new one,
	      // hence we only have to do a local delete to remove from the store.
	      if (_this.props.replaceDevice) {
	        _DeviceActions2.default.localDelete(_this.props.replaceDevice);
	      }
	
	      // we might have new subscriptions!
	      _GroupStore2.default.invalidate();
	      _this.props.onRequestHide();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(LinkSmsDeviceModal, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Modal2.default,
	        this.props,
	        _react2.default.createElement(_LinkSmsDevicePage2.default, {
	          closable: true,
	          onDone: this.onDone,
	          onRequestHide: this.props.onRequestHide
	        })
	      );
	    }
	  }]);
	
	  return LinkSmsDeviceModal;
	}(_react2.default.Component);
	
	LinkSmsDeviceModal.displayName = 'LinkSmsDeviceModal';
	exports.default = LinkSmsDeviceModal;

/***/ },
/* 3041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotificationSettingsViewDesktop = undefined;
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _PusherConstants = __webpack_require__(954);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _WebNotificationStore = __webpack_require__(2096);
	
	var _WebNotificationStore2 = _interopRequireDefault(_WebNotificationStore);
	
	var _WebNotificationTutorialModal = __webpack_require__(2089);
	
	var _WebNotificationTutorialModal2 = _interopRequireDefault(_WebNotificationTutorialModal);
	
	var _WebNotificationActions = __webpack_require__(2090);
	
	var _WebNotificationActions2 = _interopRequireDefault(_WebNotificationActions);
	
	var _trackView = __webpack_require__(1950);
	
	var _trackView2 = _interopRequireDefault(_trackView);
	
	var _modal = __webpack_require__(1188);
	
	__webpack_require__(1638);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSettingsViewDesktop = _react2.default.createClass({
	  displayName: 'NotificationSettingsViewDesktop',
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  getStateFromStores: function getStateFromStores() {
	    return {
	      areNotificationsUserEnabled: _WebNotificationStore2.default.areNotificationsUserEnabled()
	    };
	  },
	  sendTestWebNotification: function sendTestWebNotification() {
	    _Dispatcher.dispatcher.dispatch({
	      type: _PusherConstants.PushEvents.TEST_MESSAGE
	    });
	  },
	  updatePermissionState: function updatePermissionState() {
	    var areNotificationsUserEnabled = _WebNotificationStore2.default.areNotificationsUserEnabled();
	    this.setState({ areNotificationsUserEnabled: areNotificationsUserEnabled });
	  },
	  renderButton: function renderButton() {
	    var _this = this;
	
	    var browserPermission = _WebNotificationStore2.default.getBrowserPermission();
	
	    if (browserPermission === 'default') {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          size: 'xsmall',
	          level: 'secondary',
	          onClick: function onClick() {
	            return (0, _modal.mountModal)(_react2.default.createElement(_WebNotificationTutorialModal2.default, { onRequestHide: _this.updatePermissionState }), _this);
	          },
	          eventScreenName: 'desktop_notification',
	          eventElementName: 'desktop_notification_enable' },
	        'Turn on'
	      );
	    } else if (browserPermission === 'granted') {
	      var handleChange = function handleChange(e) {
	        var enabled = e.target.checked;
	        _WebNotificationActions2.default.updateLocalUserEnabled(enabled);
	        _this.updatePermissionState();
	      };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'NotificationSettingsView-device' },
	        _react2.default.createElement(_Checkbox2.default, {
	          label: 'Turn on desktop notifications',
	          defaultChecked: this.state.areNotificationsUserEnabled,
	          className: 'block',
	          onChange: handleChange
	        }),
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            disabled: !this.state.areNotificationsUserEnabled,
	            onClick: this.sendTestWebNotification,
	            level: 'secondary',
	            size: 'xsmall' },
	          'Send test notification'
	        )
	      );
	    } else if (browserPermission === 'denied') {
	      return _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Re-enable desktop notifications for remind.com in your browser\u2019s settings.'
	        )
	      );
	    }
	
	    throw new Error('unknown permission value', browserPermission);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Legend2.default,
	        null,
	        'Desktop'
	      ),
	      this.renderButton()
	    );
	  }
	});
	
	exports.NotificationSettingsViewDesktop = NotificationSettingsViewDesktop;
	exports.default = (0, _trackView2.default)(NotificationSettingsViewDesktop, 'desktop_notification', function () {
	  return {
	    enabled: _WebNotificationStore2.default.getBrowserPermission() === 'granted'
	  };
	});

/***/ },
/* 3042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INCLUDE_IN_OWN_BROADCASTS_PREF = 'include_in_own_broadcasts';
	
	
	var NotificationSettingsViewPreferences = _react2.default.createClass({
	  displayName: 'NotificationSettingsViewPreferences',
	  getInitialState: function getInitialState() {
	    return {
	      includeInOwnBroadcasts: _CurrentUser2.default.getUser().getPreference(INCLUDE_IN_OWN_BROADCASTS_PREF)
	    };
	  },
	
	
	  // typecheck: ignore statement
	  handleChange: function handleChange(e) {
	    var _this = this;
	
	    var includeInOwnBroadcasts = e.target.checked;
	
	    var onSuccess = function onSuccess() {
	      _this.setState({ includeInOwnBroadcasts: includeInOwnBroadcasts });
	      var message = includeInOwnBroadcasts ? 'You will receive copies of your class announcements' : 'You will no longer receive copies of your class announcements';
	      _ToastActions2.default.showSuccessToast(message);
	    };
	
	    var onError = function onError() {
	      _ToastActions2.default.showErrorToast('Failed to save preference');
	    };
	
	    _CurrentUser2.default.getUser().savePreference(INCLUDE_IN_OWN_BROADCASTS_PREF, includeInOwnBroadcasts).then(onSuccess, onError);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Legend2.default,
	        null,
	        'Preferences'
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'NotificationSettingsView-device' },
	        _react2.default.createElement(_Checkbox2.default, {
	          label: 'Receive copies of your class announcements',
	          onChange: this.handleChange,
	          defaultChecked: this.state.includeInOwnBroadcasts
	        })
	      )
	    );
	  }
	});
	
	exports.default = NotificationSettingsViewPreferences;

/***/ },
/* 3043 */
1136,
/* 3044 */,
/* 3045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _ArchivedClassesList = __webpack_require__(3046);
	
	var _ArchivedClassesList2 = _interopRequireDefault(_ArchivedClassesList);
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArchivedClassesView = function (_React$Component) {
	  _inherits(ArchivedClassesView, _React$Component);
	
	  function ArchivedClassesView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ArchivedClassesView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ArchivedClassesView.__proto__ || Object.getPrototypeOf(ArchivedClassesView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ArchivedClassesView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!_GroupStore2.default.isArchivedLoaded()) {
	        _GroupActions2.default.loadArchivedGroups();
	      }
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList() {
	      return _react2.default.createElement(_ArchivedClassesList2.default, {
	        archivedClasses: this.state.archivedClasses,
	        canCreateGroups: this.state.canCreateGroups
	      });
	    }
	  }, {
	    key: 'renderLoadingIndicator',
	    value: function renderLoadingIndicator() {
	      return _react2.default.createElement(_CenteredLoadingIndicator2.default, null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Fieldset2.default,
	          null,
	          _react2.default.createElement(
	            _Legend2.default,
	            null,
	            'Archived Classes',
	            _react2.default.createElement(
	              'p',
	              null,
	              'Restore or reuse classes you\u2019ve archived.'
	            )
	          ),
	          this.state.loaded ? this.renderList() : this.renderLoadingIndicator()
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_GroupStore2.default, _CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      var archivedClasses = _GroupStore2.default.getArchivedGroups();
	      var loaded = _GroupStore2.default.isArchivedLoaded();
	      var canCreateGroups = _CurrentUser2.default.getUser().canCreateGroups();
	
	      return {
	        archivedClasses: archivedClasses,
	        loaded: loaded,
	        canCreateGroups: canCreateGroups
	      };
	    }
	  }]);
	
	  return ArchivedClassesView;
	}(_react2.default.Component);
	
	ArchivedClassesView.displayName = 'ArchivedClassesView';
	exports.default = _utils.Container.create(ArchivedClassesView, { pure: false });

/***/ },
/* 3046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _ArchivedClassesListItem = __webpack_require__(3047);
	
	var _ArchivedClassesListItem2 = _interopRequireDefault(_ArchivedClassesListItem);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(3051);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArchivedClassesList = function (_React$Component) {
	  _inherits(ArchivedClassesList, _React$Component);
	
	  function ArchivedClassesList() {
	    _classCallCheck(this, ArchivedClassesList);
	
	    return _possibleConstructorReturn(this, (ArchivedClassesList.__proto__ || Object.getPrototypeOf(ArchivedClassesList)).apply(this, arguments));
	  }
	
	  _createClass(ArchivedClassesList, [{
	    key: 'renderArchivedClassesList',
	    value: function renderArchivedClassesList() {
	      var canCreateGroups = this.props.canCreateGroups;
	
	
	      if (this.props.archivedClasses.length > 0) {
	        return this.props.archivedClasses.map(function (archivedClass) {
	          return _react2.default.createElement(_ArchivedClassesListItem2.default, {
	            archivedClass: archivedClass,
	            key: archivedClass.id,
	            canCreateGroups: canCreateGroups
	          });
	        });
	      } else {
	        return this.renderNoArchivedClasses();
	      }
	    }
	  }, {
	    key: 'renderNoArchivedClasses',
	    value: function renderNoArchivedClasses() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ArchivedClassesList-noClasses' },
	        'No archived classes.'
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ArchivedClassesList-table' },
	        this.renderArchivedClassesList()
	      );
	    }
	  }]);
	
	  return ArchivedClassesList;
	}(_react2.default.Component);
	
	ArchivedClassesList.displayName = 'ArchivedClassesList';
	exports.default = ArchivedClassesList;

/***/ },
/* 3047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ArchivedClassesListItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouter = __webpack_require__(497);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FlexibleBlock = __webpack_require__(1272);
	
	var _FlexibleBlock2 = _interopRequireDefault(_FlexibleBlock);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _GroupName = __webpack_require__(1320);
	
	var _GroupName2 = _interopRequireDefault(_GroupName);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Time = __webpack_require__(1563);
	
	var _Time2 = _interopRequireDefault(_Time);
	
	var _ReuseClassConfirmDialog = __webpack_require__(2402);
	
	var _ReuseClassConfirmDialog2 = _interopRequireDefault(_ReuseClassConfirmDialog);
	
	var _RestoreClassConfirmDialog = __webpack_require__(3048);
	
	var _RestoreClassConfirmDialog2 = _interopRequireDefault(_RestoreClassConfirmDialog);
	
	__webpack_require__(3049);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArchivedClassesListItem = exports.ArchivedClassesListItem = function (_React$Component) {
	  _inherits(ArchivedClassesListItem, _React$Component);
	
	  function ArchivedClassesListItem() {
	    _classCallCheck(this, ArchivedClassesListItem);
	
	    return _possibleConstructorReturn(this, (ArchivedClassesListItem.__proto__ || Object.getPrototypeOf(ArchivedClassesListItem)).apply(this, arguments));
	  }
	
	  _createClass(ArchivedClassesListItem, [{
	    key: 'handleReuseCompletion',
	    value: function handleReuseCompletion(newGroup) {
	      this.props.router.push('/classes/' + newGroup.getCode());
	    }
	  }, {
	    key: 'renderReuseDialog',
	    value: function renderReuseDialog() {
	      var _this2 = this;
	
	      var subText = 'A new class will be created with the code @' + this.props.archivedClass.getCode() + ', and this class will be archived with an automatically generated code.';
	      return _react2.default.createElement(_ReuseClassConfirmDialog2.default, {
	        group: this.props.archivedClass,
	        onActionCompletion: function onActionCompletion(newGroup) {
	          return _this2.handleReuseCompletion(newGroup);
	        },
	        subText: subText
	      });
	    }
	  }, {
	    key: 'handleRestoreCompletion',
	    value: function handleRestoreCompletion(newGroup) {
	      this.props.router.push('/classes/' + newGroup.getCode());
	    }
	  }, {
	    key: 'renderRestoreDialog',
	    value: function renderRestoreDialog() {
	      var _this3 = this;
	
	      return _react2.default.createElement(_RestoreClassConfirmDialog2.default, {
	        group: this.props.archivedClass,
	        onActionCompletion: function onActionCompletion(newGroup) {
	          return _this3.handleRestoreCompletion(newGroup);
	        }
	      });
	    }
	  }, {
	    key: 'renderAvatar',
	    value: function renderAvatar() {
	      return _react2.default.createElement(_GroupAvatar2.default, {
	        className: 'ArchivedClassesListItem-avatar',
	        group: this.props.archivedClass
	      });
	    }
	  }, {
	    key: 'renderClassName',
	    value: function renderClassName() {
	      return _react2.default.createElement(
	        _Text2.default,
	        { size: 'xsmall', weight: 'semibold', color: 'pitch' },
	        _react2.default.createElement(_GroupName2.default, { group: this.props.archivedClass })
	      );
	    }
	  }, {
	    key: 'renderSubtext',
	    value: function renderSubtext() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ArchivedClassesListItem-subtext' },
	        '@',
	        this.props.archivedClass.getCode(),
	        '\xA0\u2022\xA0',
	        _react2.default.createElement(_Time2.default, {
	          className: 'ArchivedClassesListItem-date',
	          date: this.props.archivedClass.getArchivedDate(),
	          month: 'numeric',
	          day: 'numeric',
	          year: 'numeric'
	        })
	      );
	    }
	  }, {
	    key: 'renderRestoreButton',
	    value: function renderRestoreButton() {
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: this.renderRestoreDialog() },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'brand',
	            level: 'secondary',
	            size: 'small' },
	          'Restore'
	        )
	      );
	    }
	  }, {
	    key: 'renderReuseButton',
	    value: function renderReuseButton() {
	      return _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: this.renderReuseDialog() },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            color: 'brand',
	            level: 'secondary',
	            size: 'small' },
	          'Reuse class code'
	        )
	      );
	    }
	  }, {
	    key: 'renderButtons',
	    value: function renderButtons() {
	      if (!this.props.canCreateGroups) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'ArchivedClassesListItem-buttons' },
	        this.renderRestoreButton(),
	        this.renderReuseButton()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _FlexibleBlock2.default,
	        { className: 'ArchivedClassesListItem', flex: 'left' },
	        _react2.default.createElement(
	          _FlexibleBlock2.default,
	          { flex: 'right' },
	          this.renderAvatar(),
	          _react2.default.createElement(
	            'div',
	            { className: 'ArchivedClassesListItem-info' },
	            this.renderClassName(),
	            this.renderSubtext()
	          )
	        ),
	        this.renderButtons()
	      );
	    }
	  }]);
	
	  return ArchivedClassesListItem;
	}(_react2.default.Component);
	
	ArchivedClassesListItem.displayName = 'ArchivedClassesListItem';
	exports.default = (0, _reactRouter.withRouter)(ArchivedClassesListItem);

/***/ },
/* 3048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var RestoreClassConfirmDialog = function (_React$Component) {
	  _inherits(RestoreClassConfirmDialog, _React$Component);
	
	  function RestoreClassConfirmDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RestoreClassConfirmDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RestoreClassConfirmDialog.__proto__ || Object.getPrototypeOf(RestoreClassConfirmDialog)).call.apply(_ref, [this].concat(args))), _this), _this.onSuccess = function (group) {
	      _ToastActions2.default.showSuccessToast('Class restored');
	      _this.props.onActionCompletion(group);
	    }, _this.onError = function (error) {
	      _ToastActions2.default.showErrorToast(error.message);
	    }, _this.handleRestore = function () {
	      var group = _this.props.group;
	
	      var orgId = group.getOriginalOrganizationId() || null;
	
	      return _GroupActions2.default.restoreGroup(group, orgId).then(_this.onSuccess, _this.onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RestoreClassConfirmDialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'RestoreClassConfirmDialog',
	        group: this.props.group,
	        title: 'Restore this class?',
	        subtext: this.props.group.getName() + ' will reappear in your class list. You\u2019ll also be able to send class announcements again.',
	        actionButtonText: 'Restore',
	        cancelButtonText: 'Cancel',
	        preConfirmPromise: this.handleRestore,
	        onRequestHide: this.props.onRequestHide
	      });
	    }
	  }]);
	
	  return RestoreClassConfirmDialog;
	}(_react2.default.Component);
	
	RestoreClassConfirmDialog.displayName = 'RestoreClassConfirmDialog';
	exports.default = RestoreClassConfirmDialog;

/***/ },
/* 3049 */
1136,
/* 3050 */,
/* 3051 */
1136,
/* 3052 */,
/* 3053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  query {\n    me {\n      id\n      # TODO https://app.asana.com/0/52068106376728/221203365474362\n      organization_picker_eligible\n      permissions {\n        can_add_parent\n        can_add_child\n        can_create_group\n        can_own_groups\n      }\n      role\n      ownedClasses: classes(classType: "owned") {\n        ...classesDefaults\n      }\n      subscribedClasses: classes(classType: "subscribed") {\n        ...classesDefaults\n      }\n      family {\n        children {\n          ...minimalRelatedUser\n        }\n        pending_children {\n          ...minimalRelatedUser\n        }\n        parents {\n          ...minimalRelatedUser\n        }\n        pending_parents {\n          ...minimalRelatedUser\n        }\n      }\n    }\n  }\n  ', '\n  ', '\n  '], ['\n  query {\n    me {\n      id\n      # TODO https://app.asana.com/0/52068106376728/221203365474362\n      organization_picker_eligible\n      permissions {\n        can_add_parent\n        can_add_child\n        can_create_group\n        can_own_groups\n      }\n      role\n      ownedClasses: classes(classType: "owned") {\n        ...classesDefaults\n      }\n      subscribedClasses: classes(classType: "subscribed") {\n        ...classesDefaults\n      }\n      family {\n        children {\n          ...minimalRelatedUser\n        }\n        pending_children {\n          ...minimalRelatedUser\n        }\n        parents {\n          ...minimalRelatedUser\n        }\n        pending_parents {\n          ...minimalRelatedUser\n        }\n      }\n    }\n  }\n  ', '\n  ', '\n  ']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChatSettingsActions = __webpack_require__(2965);
	
	var _ChatSettingsActions2 = _interopRequireDefault(_ChatSettingsActions);
	
	var _ClassCardSection = __webpack_require__(3054);
	
	var _ClassCardSection2 = _interopRequireDefault(_ClassCardSection);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _FeatureStore = __webpack_require__(588);
	
	var _FeatureStore2 = _interopRequireDefault(_FeatureStore);
	
	var _classesDefaultsFragment = __webpack_require__(995);
	
	var _classesDefaultsFragment2 = _interopRequireDefault(_classesDefaultsFragment);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupCreateModal = __webpack_require__(1326);
	
	var _GroupCreateModal2 = _interopRequireDefault(_GroupCreateModal);
	
	var _JoinGroupModal = __webpack_require__(2450);
	
	var _JoinGroupModal2 = _interopRequireDefault(_JoinGroupModal);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _minimalRelatedUserFragment = __webpack_require__(3060);
	
	var _minimalRelatedUserFragment2 = _interopRequireDefault(_minimalRelatedUserFragment);
	
	var _OfficeHoursPicker = __webpack_require__(2966);
	
	var _OfficeHoursPicker2 = _interopRequireDefault(_OfficeHoursPicker);
	
	var _ProfileHeaderView = __webpack_require__(3061);
	
	var _ProfileHeaderView2 = _interopRequireDefault(_ProfileHeaderView);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserParentChildSection = __webpack_require__(3064);
	
	var _UserParentChildSection2 = _interopRequireDefault(_UserParentChildSection);
	
	var _UserSchoolsForm = __webpack_require__(3017);
	
	var _UserSchoolsForm2 = _interopRequireDefault(_UserSchoolsForm);
	
	var _reactApollo = __webpack_require__(467);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	__webpack_require__(3073);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserProfileView = function (_React$Component) {
	  _inherits(UserProfileView, _React$Component);
	
	  function UserProfileView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserProfileView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserProfileView.__proto__ || Object.getPrototypeOf(UserProfileView)).call.apply(_ref, [this].concat(args))), _this), _this.onCompleteGroup = function (group) {
	      _this.props.router.push(group.webUrl());
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserProfileView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _ChatSettingsActions2.default.loadOfficeHours();
	    }
	
	    // XXX until we have a good mechanism for GraphQL errors (e.g. re-auth)
	    // https://apollographql.slack.com/archives/general/p1478732615013498
	    // FIXME(turadg)
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.error && nextProps.error) {
	        _ToastActions2.default.showDefaultErrorToast();
	        console.warn(nextProps);
	        console.error('GraphQL error');
	      }
	    }
	  }, {
	    key: 'renderParentsSection',
	    value: function renderParentsSection() {
	      if (this.props.family.parents.length || this.props.family.pending_parents.length || this.props.permissions.can_add_parent) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'UserProfileView-section' },
	          _react2.default.createElement(_UserParentChildSection2.default, { relation: 'parent' }),
	          _react2.default.createElement(_Divider2.default, { size: 'large' })
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderChildrenSection',
	    value: function renderChildrenSection() {
	      if (this.props.family.children.length || this.props.family.pending_children.length || this.props.permissions.can_add_child) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'UserProfileView-section' },
	          _react2.default.createElement(_UserParentChildSection2.default, { relation: 'child' }),
	          _react2.default.createElement(_Divider2.default, { size: 'large' })
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'renderSchoolsSection',
	    value: function renderSchoolsSection() {
	      if (!this.props.organizationPickerEligible) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'UserProfileView-section' },
	        _react2.default.createElement(_UserSchoolsForm2.default, null),
	        _react2.default.createElement(_Divider2.default, { size: 'large' })
	      );
	    }
	  }, {
	    key: 'renderOfficeHoursSection',
	    value: function renderOfficeHoursSection() {
	      if (this.props.role !== 'teacher') {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'UserProfileView-section' },
	        _react2.default.createElement(_OfficeHoursPicker2.default, { showToastMessages: true, showToggleButton: true, showIntroText: true, compact: true }),
	        _react2.default.createElement(_Divider2.default, { size: 'large' })
	      );
	    }
	  }, {
	    key: 'renderOwnedClassSection',
	    value: function renderOwnedClassSection() {
	      var _props = this.props,
	          ownedClasses = _props.ownedClasses,
	          permissions = _props.permissions;
	
	      if (!permissions.can_own_groups || ownedClasses.length === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'UserProfileView-section' },
	        _react2.default.createElement(_ClassCardSection2.default, {
	          label: 'Classes owned',
	          items: ownedClasses,
	          addModal: _react2.default.createElement(_GroupCreateModal2.default, { onCreate: this.onCompleteGroup }),
	          addText: 'Create a class',
	          addEnabled: permissions.can_create_group
	        }),
	        _react2.default.createElement(_Divider2.default, { size: 'large' })
	      );
	    }
	  }, {
	    key: 'renderJoinedClassSection',
	    value: function renderJoinedClassSection() {
	      var subscribedClasses = this.props.subscribedClasses;
	
	      if (subscribedClasses.length === 0) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'UserProfileView-section' },
	        _react2.default.createElement(_ClassCardSection2.default, {
	          label: 'Classes joined',
	          items: subscribedClasses,
	          addModal: _react2.default.createElement(_JoinGroupModal2.default, { onJoin: this.onCompleteGroup }),
	          addText: 'Join a class'
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.loading || this.props.error) {
	        return _react2.default.createElement(_LoadingIndicator2.default, null);
	      }
	
	      var showFamily = _FeatureStore2.default.hasFeature('web.profile.family');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'UserProfileView' },
	        _react2.default.createElement(_ProfileHeaderView2.default, null),
	        showFamily && this.renderParentsSection(),
	        showFamily && this.renderChildrenSection(),
	        this.renderSchoolsSection(),
	        this.renderOfficeHoursSection(),
	        this.renderOwnedClassSection(),
	        this.renderJoinedClassSection()
	      );
	    }
	  }], [{
	    key: 'onEnter',
	    value: function onEnter(nextState, replaceWith) {
	      if (!_FeatureStore2.default.hasFeature('web.new_account')) {
	        replaceWith('/settings');
	      }
	    }
	  }]);
	
	  return UserProfileView;
	}(_react2.default.Component);
	
	UserProfileView.displayName = 'UserProfileView';
	
	
	var withData = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject, _minimalRelatedUserFragment2.default, _classesDefaultsFragment2.default), {
	  // TODO decide whether to make this the default `props` function
	  props: function props(_ref2) {
	    var data = _ref2.data;
	
	    var defaultMe = {
	      ownedClasses: [],
	      subscribedClasses: [],
	      family: {},
	      permissions: {},
	      organization_picker_eligible: false,
	      role: null
	    };
	
	    var me = data.me || defaultMe;
	
	    var ownedClasses = me.ownedClasses.map(function (c) {
	      return _Group2.default.fromJSON(c);
	    });
	    var subscribedClasses = me.subscribedClasses.map(function (c) {
	      return _Group2.default.fromJSON(c);
	    });
	    var organizationPickerEligible = me.organization_picker_eligible;
	    var family = me.family,
	        permissions = me.permissions,
	        role = me.role;
	
	
	    return Object.assign({}, data, {
	      ownedClasses: ownedClasses,
	      subscribedClasses: subscribedClasses,
	      family: family,
	      permissions: permissions,
	      organizationPickerEligible: organizationPickerEligible,
	      role: role
	    });
	  }
	});
	
	exports.default = withData(UserProfileView);

/***/ },
/* 3054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AddButton = __webpack_require__(1894);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _ClassCardView = __webpack_require__(3055);
	
	var _ClassCardView2 = _interopRequireDefault(_ClassCardView);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	__webpack_require__(3058);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassCardSection = function (_React$Component) {
	  _inherits(ClassCardSection, _React$Component);
	
	  function ClassCardSection() {
	    _classCallCheck(this, ClassCardSection);
	
	    return _possibleConstructorReturn(this, (ClassCardSection.__proto__ || Object.getPrototypeOf(ClassCardSection)).apply(this, arguments));
	  }
	
	  _createClass(ClassCardSection, [{
	    key: 'renderAddButton',
	    value: function renderAddButton() {
	      return this.props.addEnabled ? _react2.default.createElement(
	        _ModalTrigger2.default,
	        { modal: this.props.addModal },
	        _react2.default.createElement(
	          'div',
	          { className: 'ClassCardSection-addButton' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ClassCardSection-addButtonContainer' },
	            _react2.default.createElement(_AddButton2.default, { className: 'UserProfileView-addClassButton' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'ClassCardSection-addButtonTitle' },
	              this.props.addText
	            )
	          )
	        )
	      ) : null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cards = this.props.items.map(function (item) {
	        return _react2.default.createElement(_ClassCardView2.default, { key: item.id, group: item });
	      });
	      return _react2.default.createElement(
	        _Fieldset2.default,
	        null,
	        _react2.default.createElement(
	          _Legend2.default,
	          null,
	          this.props.label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ClassCardSection' },
	          cards,
	          this.renderAddButton()
	        )
	      );
	    }
	  }]);
	
	  return ClassCardSection;
	}(_react2.default.Component);
	
	ClassCardSection.defaultProps = {
	  addEnabled: true,
	  addText: 'Add class'
	};
	ClassCardSection.displayName = 'ClassCardSection';
	exports.default = ClassCardSection;

/***/ },
/* 3055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClassCardView = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupAvatar = __webpack_require__(1323);
	
	var _GroupAvatar2 = _interopRequireDefault(_GroupAvatar);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	__webpack_require__(3056);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ClassCardView = exports.ClassCardView = function (_React$Component) {
	  _inherits(ClassCardView, _React$Component);
	
	  function ClassCardView() {
	    _classCallCheck(this, ClassCardView);
	
	    return _possibleConstructorReturn(this, (ClassCardView.__proto__ || Object.getPrototypeOf(ClassCardView)).apply(this, arguments));
	  }
	
	  _createClass(ClassCardView, [{
	    key: 'render',
	    value: function render() {
	      var group = this.props.group;
	
	      return _react2.default.createElement(
	        _Link2.default,
	        {
	          className: 'ClassCardView',
	          to: group.webUrl(),
	          eventElementName: 'ClassCardView' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'ClassCardView-header',
	            style: { background: group.getAccentColor(), boxShadow: '0px 0px 0px 1px ' + group.getAccentColor() } },
	          _react2.default.createElement(_GroupAvatar2.default, {
	            className: 'ClassCardView-header-avatar',
	            group: group,
	            size: 'medium'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ClassCardView-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ClassCardView-body-title' },
	            group.getName()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ClassCardView-body-memberCount' },
	            group.getMembershipCountText()
	          )
	        )
	      );
	    }
	  }]);
	
	  return ClassCardView;
	}(_react2.default.Component);
	
	ClassCardView.displayName = 'ClassCardView';
	exports.default = ClassCardView;

/***/ },
/* 3056 */
1136,
/* 3057 */,
/* 3058 */
1136,
/* 3059 */,
/* 3060 */
/***/ function(module, exports) {

	module.exports = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"minimalRelatedUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RelatedUser"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"name"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"initials"},"arguments":[],"directives":[],"selectionSet":null}]}}],"loc":{"start":0,"end":70,"source":{"body":"fragment minimalRelatedUser on RelatedUser {\n  id\n  name\n  initials\n}\n","name":"GraphQL"}}};

/***/ },
/* 3061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _humanparser = __webpack_require__(2003);
	
	var _humanparser2 = _interopRequireDefault(_humanparser);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _ProfilePicture = __webpack_require__(1618);
	
	var _ProfilePicture2 = _interopRequireDefault(_ProfilePicture);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _SettingsStore = __webpack_require__(955);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	__webpack_require__(3062);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProfileHeaderView = function (_React$Component) {
	  _inherits(ProfileHeaderView, _React$Component);
	
	  function ProfileHeaderView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProfileHeaderView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProfileHeaderView.__proto__ || Object.getPrototypeOf(ProfileHeaderView)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      displayName: _CurrentUser2.default.getUser().getDisplayName(),
	      gradeLevel: _CurrentUser2.default.getUser().getGradeLevel()
	    }, _this.onChange = function (event) {
	      _this.setState({ displayName: event.target.value });
	    }, _this.onError = function (err) {
	      _ToastActions2.default.showAPIError(err);
	      _this.setState({
	        displayName: _CurrentUser2.default.getUser().getDisplayName(),
	        gradeLevel: _CurrentUser2.default.getUser().getGradeLevel()
	      });
	    }, _this.saveSignature = function () {
	      var displayName = _this.state.displayName;
	
	      if (displayName === _CurrentUser2.default.getUser().getDisplayName()) {
	        return;
	      }
	
	      _UserActions2.default.update({ signature: displayName }).then(function () {
	        return _ToastActions2.default.showSuccessToast('Signature saved');
	      }, _this.onError);
	    }, _this.saveName = function () {
	      var displayName = _this.state.displayName;
	
	      if (displayName === _CurrentUser2.default.getUser().getDisplayName()) {
	        return;
	      }
	
	      var human = _humanparser2.default.parseName(displayName);
	      var data = {
	        first_name: human.firstName,
	        last_name: human.lastName || ''
	      };
	      _UserActions2.default.update(data).then(function () {
	        return _ToastActions2.default.showSuccessToast('Name saved');
	      }, _this.onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ProfileHeaderView, [{
	    key: 'renderEditableDisplayName',
	    value: function renderEditableDisplayName() {
	      var _this2 = this;
	
	      var onKeyDown = function onKeyDown(event) {
	        if (event.keyCode === _KeyConstants2.default.ENTER) {
	          _this2.refs.displayNameInput.getInputNode().blur();
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProfileHeaderView-inputContainer' },
	        _react2.default.createElement(_Glyph2.default, { name: 'pencil-stroke', color: 'eclipse', size: 'large' }),
	        _react2.default.createElement(_Input2.default, {
	          ref: 'displayNameInput',
	          className: 'ProfileHeaderView-displayName',
	          value: this.state.displayName,
	          onBlur: _CurrentUser2.default.getUser().isTeacher() ? this.saveSignature : this.saveName,
	          onKeyDown: onKeyDown,
	          onChange: this.onChange
	        })
	      );
	    }
	  }, {
	    key: 'renderGradeByline',
	    value: function renderGradeByline() {
	      var _this3 = this;
	
	      var gradeLevel = this.state.gradeLevel;
	
	      var gradeText = gradeLevel ? gradeLevel.name : 'Set your grade level';
	      var setGrade = function setGrade(grade) {
	        var gradeObject = _SettingsStore2.default.getSetting('grades').find(function (g) {
	          return g.code === grade;
	        });
	        _this3.setState({ gradeLevel: gradeObject });
	        _UserActions2.default.update({ grade_level: grade }).then(function () {
	          return _ToastActions2.default.showSuccessToast('Grade level saved');
	        }, _this3.onError);
	      };
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        { className: 'ProfileHeaderView-gradeMenu' },
	        _SettingsStore2.default.getSetting('grades').map(function (grade) {
	          return _react2.default.createElement(
	            _MenuItem2.default,
	            { key: grade.code, onSelect: setGrade },
	            grade.name
	          );
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProfileHeaderView-byline' },
	        _react2.default.createElement(
	          _LayerTrigger2.default,
	          {
	            layer: menu,
	            trigger: 'click',
	            placement: 'bottom',
	            alignment: 'middle' },
	          _react2.default.createElement(
	            _Link2.default,
	            { href: '#' },
	            _react2.default.createElement(
	              'span',
	              { className: 'ProfileHeaderView-gradeLabel' },
	              _react2.default.createElement(
	                _Text2.default,
	                { color: gradeLevel ? 'thunder' : 'flame', size: 'medium' },
	                gradeText
	              ),
	              _react2.default.createElement(_Glyph2.default, { name: 'chevron-down', color: 'thunder', size: 'xsmall' })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderSignatureByline',
	    value: function renderSignatureByline() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProfileHeaderView-byline' },
	        _react2.default.createElement(
	          _Text2.default,
	          { italic: true, color: 'thunder', size: 'xsmall' },
	          'Your signature is what others will see when you send a message.'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var user = _CurrentUser2.default.getUser();
	      return _react2.default.createElement(
	        'div',
	        { className: 'ProfileHeaderView' },
	        _react2.default.createElement(_ProfilePicture2.default, { user: user }),
	        this.renderEditableDisplayName(),
	        user.isStudent() && this.renderGradeByline(),
	        user.isTeacher() && this.renderSignatureByline()
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        displayName: _CurrentUser2.default.getUser().getDisplayName(),
	        gradeLevel: _CurrentUser2.default.getUser().getGradeLevel()
	      };
	    }
	  }]);
	
	  return ProfileHeaderView;
	}(_react2.default.Component);
	
	ProfileHeaderView.displayName = 'ProfileHeaderView';
	exports.default = _utils.Container.create(ProfileHeaderView);

/***/ },
/* 3062 */
1136,
/* 3063 */,
/* 3064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserParentChildSection = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  query {\n    me {\n      permissions {\n        can_add_parent\n        can_add_child\n      }\n      family {\n        children {\n          ...minimalRelatedUser\n        }\n        pending_children {\n          ...minimalRelatedUser\n        }\n        parents {\n          ...minimalRelatedUser\n        }\n        pending_parents {\n          ...minimalRelatedUser\n        }\n      }\n    }\n  }\n  ', '\n  '], ['\n  query {\n    me {\n      permissions {\n        can_add_parent\n        can_add_child\n      }\n      family {\n        children {\n          ...minimalRelatedUser\n        }\n        pending_children {\n          ...minimalRelatedUser\n        }\n        parents {\n          ...minimalRelatedUser\n        }\n        pending_parents {\n          ...minimalRelatedUser\n        }\n      }\n    }\n  }\n  ', '\n  ']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AddButton = __webpack_require__(1894);
	
	var _AddButton2 = _interopRequireDefault(_AddButton);
	
	var _AddParentChildModal = __webpack_require__(3065);
	
	var _AddParentChildModal2 = _interopRequireDefault(_AddParentChildModal);
	
	var _Fieldset = __webpack_require__(1419);
	
	var _Fieldset2 = _interopRequireDefault(_Fieldset);
	
	var _reactApollo = __webpack_require__(467);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _Legend = __webpack_require__(1420);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _minimalRelatedUserFragment = __webpack_require__(3060);
	
	var _minimalRelatedUserFragment2 = _interopRequireDefault(_minimalRelatedUserFragment);
	
	var _modal = __webpack_require__(1188);
	
	var _UserParentChildRow = __webpack_require__(3068);
	
	var _UserParentChildRow2 = _interopRequireDefault(_UserParentChildRow);
	
	__webpack_require__(3071);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserParentChildSection = function (_React$Component) {
	  _inherits(UserParentChildSection, _React$Component);
	
	  function UserParentChildSection() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserParentChildSection);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserParentChildSection.__proto__ || Object.getPrototypeOf(UserParentChildSection)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.addParentChild = function () {
	      (0, _modal.mountModal)(_react2.default.createElement(_AddParentChildModal2.default, {
	        relation: _this.props.relation,
	        title: _this.getAddText(),
	        onRequestHide: function onRequestHide() {}
	      }), _this);
	    }, _this.render = function () {
	      var titleText = _this.props.relation === 'parent' ? 'Parents' : 'Children';
	      return _react2.default.createElement(
	        _Fieldset2.default,
	        null,
	        _react2.default.createElement(
	          _Legend2.default,
	          null,
	          titleText
	        ),
	        _react2.default.createElement(
	          'table',
	          { className: 'UserParentChildSection-table' },
	          _react2.default.createElement(
	            'tbody',
	            null,
	            _this.props.related_users.map(function (u) {
	              return _react2.default.createElement(_UserParentChildRow2.default, {
	                key: u.id,
	                relation: _this.props.relation,
	                related_user: u
	              });
	            }),
	            _this.props.pending_related_users.map(function (u) {
	              return _react2.default.createElement(_UserParentChildRow2.default, {
	                key: u.id,
	                relation: _this.props.relation,
	                related_user: u,
	                pending: true
	              });
	            })
	          )
	        ),
	        _this.renderAddButton()
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserParentChildSection, [{
	    key: 'getAddText',
	    value: function getAddText() {
	      return this.props.relation === 'parent' ? 'Add your parent' : 'Add your child';
	    }
	  }, {
	    key: 'renderAddButton',
	    value: function renderAddButton() {
	      var _props = this.props,
	          relation = _props.relation,
	          permissions = _props.permissions;
	
	      if (relation === 'parent' && permissions.can_add_parent || relation === 'child' && permissions.can_add_child) {
	        return _react2.default.createElement(
	          _AddButton2.default,
	          {
	            className: 'UserParentChildSection-add-button',
	            onClick: this.addParentChild,
	            size: 'large' },
	          this.getAddText()
	        );
	      }
	      return null;
	    }
	  }]);
	
	  return UserParentChildSection;
	}(_react2.default.Component);
	
	UserParentChildSection.displayName = 'UserParentChildSection';
	
	
	var withPermissions = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject, _minimalRelatedUserFragment2.default), {
	  props: function props(_ref2) {
	    var data = _ref2.data,
	        ownProps = _ref2.ownProps;
	
	    var familyKey = ownProps.relation === 'parent' ? 'parents' : 'children';
	    var pendingFamilyKey = ownProps.relation === 'parent' ? 'pending_parents' : 'pending_children';
	
	    return {
	      permissions: data.me ? data.me.permissions : {},
	      related_users: data.me ? data.me.family[familyKey] : [],
	      pending_related_users: data.me ? data.me.family[pendingFamilyKey] : []
	    };
	  }
	});
	
	exports.UserParentChildSection = UserParentChildSection;
	exports.default = withPermissions(UserParentChildSection);

/***/ },
/* 3065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _ProfilePicture = __webpack_require__(1618);
	
	var _ProfilePicture2 = _interopRequireDefault(_ProfilePicture);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(3066);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var AddParentChildModal = function (_React$Component) {
	  _inherits(AddParentChildModal, _React$Component);
	
	  function AddParentChildModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AddParentChildModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddParentChildModal.__proto__ || Object.getPrototypeOf(AddParentChildModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      query: ''
	    }, _this.addNewParentOrChild = function () {
	      // TODO add the person
	      _this.props.onRequestHide();
	    }, _this.addExistingParentOrChild = function () {
	      // TODO
	      _this.props.onRequestHide();
	    }, _this.performSearch = function (event) {
	      _this.setState({
	        // $FlowFixMe
	        query: event.target.value
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AddParentChildModal, [{
	    key: 'renderEmptyQuery',
	    value: function renderEmptyQuery() {
	      var text = this.props.relation === 'parent' ? 'Search for your parent by first or last name' : 'Search for your child by first or last name';
	
	      return _react2.default.createElement(
	        _Text2.default,
	        {
	          className: 'AddParentChildModal-empty-query',
	          element: 'div',
	          color: 'koala',
	          size: 'large' },
	        text
	      );
	    }
	  }, {
	    key: 'renderResultList',
	    value: function renderResultList() {
	      // TODO: foreach render this with real results
	      return _react2.default.createElement(
	        _Link2.default,
	        {
	          className: 'AddParentChildModal-result-item',
	          block: true,
	          onClick: this.addExistingParentOrChild },
	        _react2.default.createElement(
	          _MediaObject2.default,
	          {
	            className: 'AddParentChildModal-result-item-inner',
	            gutter: 'small' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_ProfilePicture2.default, {
	              size: 'medium',
	              user: { initials: 'AZ' }
	            })
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            { element: 'div' },
	            'Abba Zabba'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderAddPerson',
	    value: function renderAddPerson() {
	      var isParent = this.props.relation === 'parent';
	      var buttonText = isParent ? 'Add parent' : 'Add child';
	      var h1Text = isParent ? 'Don’t see your parent?' : 'Don’t see your child?';
	      var h2Text = isParent ? 'Your parent must be first added to a class so that you can connect them' : 'Your child must be first added to a class so that you can connect them';
	
	      return _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            size: 'large',
	            element: 'p' },
	          h1Text
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            color: 'thunder',
	            element: 'p' },
	          h2Text
	        ),
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            block: true,
	            weight: 'semibold',
	            onClick: this.addNewParentOrChild },
	          buttonText
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var placeholderText = this.props.relation === 'parent' ? 'Search for a parent' : 'Search for a child';
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        {
	          eventScreenName: this.props.relation === 'parent' ? 'AddParentModal' : 'AddChildModal',
	          className: 'AddParentChildModal',
	          size: 'small',
	          onRequestHide: this.props.onRequestHide,
	          title: this.props.title },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { full: true },
	          _react2.default.createElement(
	            'div',
	            { className: 'AddParentChildModal-input' },
	            _react2.default.createElement(_Input2.default, {
	              autofocus: true,
	              glyph: 'search',
	              placeholder: placeholderText,
	              onChange: this.performSearch
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'AddParentChildModal-content' },
	          !this.state.query && this.renderEmptyQuery(),
	          this.state.query && this.renderResultList(),
	          this.state.query && this.renderAddPerson()
	        )
	      );
	    }
	  }]);
	
	  return AddParentChildModal;
	}(_react2.default.Component);
	
	AddParentChildModal.displayName = 'AddParentChildModal';
	exports.default = AddParentChildModal;

/***/ },
/* 3066 */
1136,
/* 3067 */,
/* 3068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _MediaObject = __webpack_require__(1396);
	
	var _MediaObject2 = _interopRequireDefault(_MediaObject);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuButton = __webpack_require__(1604);
	
	var _MenuButton2 = _interopRequireDefault(_MenuButton);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _modal = __webpack_require__(1188);
	
	var _ProfilePicture = __webpack_require__(1618);
	
	var _ProfilePicture2 = _interopRequireDefault(_ProfilePicture);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RelationshipModal = __webpack_require__(1309);
	
	var _RelationshipModal2 = _interopRequireDefault(_RelationshipModal);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(3069);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserParentChildRow = function (_React$Component) {
	  _inherits(UserParentChildRow, _React$Component);
	
	  function UserParentChildRow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UserParentChildRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserParentChildRow.__proto__ || Object.getPrototypeOf(UserParentChildRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.confirmRemoveRelation = function () {
	      var modal = _react2.default.createElement(_ConfirmDialog2.default, {
	        title: 'Are you sure you want to remove ' + _this.props.related_user.name + ' as your ' + _this.props.relation + '?'
	      });
	      (0, _modal.mountModal)(modal, _this);
	    }, _this.goToProfile = function () {
	      var modal = _react2.default.createElement(_RelationshipModal2.default, { userId: _this.props.related_user.id });
	      (0, _modal.mountModal)(modal, _this);
	    }, _this.render = function () {
	      var textColor = _this.props.pending ? 'koala' : undefined;
	
	      return _react2.default.createElement(
	        'tr',
	        { className: 'UserParentChildRow' },
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _MediaObject2.default,
	            { gutter: 'small', className: 'UserParentChildRow-name' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_ProfilePicture2.default, {
	                size: 'medium',
	                user: _this.props.related_user
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'UserParentChildRow-name-text' },
	              _react2.default.createElement(
	                _Text2.default,
	                { element: 'div', color: textColor },
	                _this.props.related_user.name
	              ),
	              _this.props.pending && _react2.default.createElement(
	                _Text2.default,
	                { element: 'div', color: textColor },
	                'Pending'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _MenuButton2.default,
	            {
	              alignment: 'right',
	              placement: 'bottom',
	              menu: _this.renderMenu(),
	              size: 'small',
	              level: 'icon' },
	            _react2.default.createElement(_Glyph2.default, { name: 'ellipses', solo: true })
	          )
	        )
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UserParentChildRow, [{
	    key: 'renderMenu',
	    value: function renderMenu() {
	      var removeText = this.props.relation === 'parent' ? 'Remove parent' : 'Remove child';
	      return _react2.default.createElement(
	        _Menu2.default,
	        null,
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: this.goToProfile },
	          _react2.default.createElement(_Glyph2.default, { name: 'avatar' }),
	          'View profile'
	        ),
	        _react2.default.createElement(
	          _MenuItem2.default,
	          { onClick: this.confirmRemoveRelation },
	          _react2.default.createElement(_Glyph2.default, { name: 'close' }),
	          removeText
	        )
	      );
	    }
	  }]);
	
	  return UserParentChildRow;
	}(_react2.default.Component);
	
	UserParentChildRow.displayName = 'UserParentChildRow';
	exports.default = UserParentChildRow;

/***/ },
/* 3069 */
1136,
/* 3070 */,
/* 3071 */
1136,
/* 3072 */,
/* 3073 */
1136,
/* 3074 */,
/* 3075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _FeatureStore = __webpack_require__(588);
	
	var _FeatureStore2 = _interopRequireDefault(_FeatureStore);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LinkConstants = __webpack_require__(1102);
	
	var _LinkConstants2 = _interopRequireDefault(_LinkConstants);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _UserEmailsForm = __webpack_require__(3005);
	
	var _UserEmailsForm2 = _interopRequireDefault(_UserEmailsForm);
	
	var _UserPasswordForm = __webpack_require__(3015);
	
	var _UserPasswordForm2 = _interopRequireDefault(_UserPasswordForm);
	
	var _UserPersonalInfoForm = __webpack_require__(3016);
	
	var _UserPersonalInfoForm2 = _interopRequireDefault(_UserPersonalInfoForm);
	
	var _UserSignatureForm = __webpack_require__(3024);
	
	var _UserSignatureForm2 = _interopRequireDefault(_UserSignatureForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AccountSettingsView = function (_React$Component) {
	  _inherits(AccountSettingsView, _React$Component);
	
	  function AccountSettingsView() {
	    _classCallCheck(this, AccountSettingsView);
	
	    return _possibleConstructorReturn(this, (AccountSettingsView.__proto__ || Object.getPrototypeOf(AccountSettingsView)).apply(this, arguments));
	  }
	
	  _createClass(AccountSettingsView, [{
	    key: 'deleteAccount',
	    value: function deleteAccount() {
	      window.location = _LinkConstants2.default.MARKETING;
	    }
	  }, {
	    key: 'renderConfirmModal',
	    value: function renderConfirmModal() {
	      var subtext = _CurrentUser2.default.getUser().canCreateGroups() ? 'You will no longer have access to your classes or participants. ' + 'This action can’t be undone.' : 'You will no longer have access to your classes. This action can’t be undone.';
	
	      return _react2.default.createElement(_ConfirmDialog2.default, {
	        eventScreenName: 'AccountSettingsView',
	        actionButtonText: 'Delete',
	        cancelButtonText: 'Cancel',
	        size: 'xsmall',
	        glyph: 'trash',
	        glyphColor: 'lava',
	        onConfirm: this.deleteAccount,
	        preConfirmPromise: _UserActions2.default.delete,
	        title: 'Are you sure you want to delete your account?',
	        subtext: subtext
	      });
	    }
	  }, {
	    key: 'renderDeleteAccountForm',
	    value: function renderDeleteAccountForm() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: this.renderConfirmModal() },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'UserSettingsView-deleteAccountBtn',
	              size: 'xsmall',
	              level: 'secondary',
	              color: 'lava',
	              eventElementName: 'UserSettingsView-deleteAccountBtn' },
	            'Delete account'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTermsAndPrivacyLink',
	    value: function renderTermsAndPrivacyLink() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            href: _LinkConstants2.default.TERMS_OF_SERVICE,
	            target: '_blank',
	            color: 'thunder' },
	          'Terms & Privacy'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _CurrentUser2.default.getUser().isTeacher() && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_UserSignatureForm2.default, null),
	          _react2.default.createElement(_Divider2.default, null)
	        ),
	        _react2.default.createElement(_UserPersonalInfoForm2.default, null),
	        _react2.default.createElement(_Divider2.default, null),
	        _react2.default.createElement(_UserEmailsForm2.default, null),
	        _react2.default.createElement(_Divider2.default, null),
	        _react2.default.createElement(_UserPasswordForm2.default, null),
	        _react2.default.createElement(_Divider2.default, null),
	        this.renderDeleteAccountForm(),
	        this.renderTermsAndPrivacyLink()
	      );
	    }
	  }], [{
	    key: 'onEnter',
	    value: function onEnter(nextState, replaceWith) {
	      if (!_FeatureStore2.default.hasFeature('web.new_account')) {
	        replaceWith('/settings');
	      }
	    }
	  }]);
	
	  return AccountSettingsView;
	}(_react2.default.Component);
	
	AccountSettingsView.displayName = 'AccountSettingsView';
	exports.default = AccountSettingsView;

/***/ },
/* 3076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Returns an onEnter function that will require that a user can be a group owner.
	 *
	 * static onEnter = RequireOwner
	 * static onEnter = chainOnEnter([RequireUser, RequireOwner])
	 *
	 */
	var RequireOwner = {
	  statics: {
	    onEnter: function onEnter(nextState, replaceWith) {
	      var user = _CurrentUser2.default.isSignedIn() ? _CurrentUser2.default.getUser() : null;
	      if (!(user && user.canOwnGroups())) {
	        replaceWith('/error');
	      }
	    }
	  }
	};
	// typecheck: ignore file
	exports.default = RequireOwner;

/***/ },
/* 3077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(497);
	
	var _SetupAdminRole = __webpack_require__(3078);
	
	var _SetupAdminRole2 = _interopRequireDefault(_SetupAdminRole);
	
	var _SetupDefaultView = __webpack_require__(3084);
	
	var _SetupDefaultView2 = _interopRequireDefault(_SetupDefaultView);
	
	var _SetupFullName = __webpack_require__(3085);
	
	var _SetupFullName2 = _interopRequireDefault(_SetupFullName);
	
	var _SetupGroup = __webpack_require__(3086);
	
	var _SetupGroup2 = _interopRequireDefault(_SetupGroup);
	
	var _SetupSchool = __webpack_require__(3089);
	
	var _SetupSchool2 = _interopRequireDefault(_SetupSchool);
	
	var _SetupView = __webpack_require__(3093);
	
	var _SetupView2 = _interopRequireDefault(_SetupView);
	
	var _SetupSmsDevice = __webpack_require__(3096);
	
	var _SetupSmsDevice2 = _interopRequireDefault(_SetupSmsDevice);
	
	var _SetupSignature = __webpack_require__(3102);
	
	var _SetupSignature2 = _interopRequireDefault(_SetupSignature);
	
	var _SetupEmail = __webpack_require__(3106);
	
	var _SetupEmail2 = _interopRequireDefault(_SetupEmail);
	
	var _SetupPassword = __webpack_require__(3107);
	
	var _SetupPassword2 = _interopRequireDefault(_SetupPassword);
	
	var _SetupSubscription = __webpack_require__(3109);
	
	var _SetupSubscription2 = _interopRequireDefault(_SetupSubscription);
	
	var _SetupSchoolEmail = __webpack_require__(3110);
	
	var _SetupSchoolEmail2 = _interopRequireDefault(_SetupSchoolEmail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { path: '/setup(/)', component: _SetupView2.default, onEnter: _SetupView2.default.onEnter },
	  _react2.default.createElement(_reactRouter.Route, { path: '/setup/class', component: _SetupGroup2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/setup/school', component: _SetupSchool2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/setup/signature', component: _SetupSignature2.default, onEnter: _SetupSignature2.default.onEnter }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/setup/name', component: _SetupFullName2.default, onEnter: _SetupFullName2.default.onEnter }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/setup/device/sms', component: _SetupSmsDevice2.default, onEnter: _SetupSmsDevice2.default.onEnter }),
	  _react2.default.createElement(_reactRouter.Route, {
	    path: '/setup/subscriptions',
	    component: _SetupSubscription2.default,
	    onEnter: _SetupSubscription2.default.onEnter
	  }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/setup/password', component: _SetupPassword2.default }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/setup/email', component: _SetupEmail2.default, onEnter: _SetupEmail2.default.onEnter }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/setup/admin_role', component: _SetupAdminRole2.default, onEnter: _SetupAdminRole2.default.onEnter }),
	  _react2.default.createElement(_reactRouter.Route, { path: '/setup/school_email', component: _SetupSchoolEmail2.default }),
	  _react2.default.createElement(_reactRouter.IndexRoute, { component: _SetupDefaultView2.default, onEnter: _SetupDefaultView2.default.onEnter })
	);

/***/ },
/* 3078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AdminRoles = __webpack_require__(2148);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _lodash = __webpack_require__(555);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormSelect = __webpack_require__(1365);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Radio = __webpack_require__(1609);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	var _RoleVerificationActions = __webpack_require__(3079);
	
	var _RoleVerificationActions2 = _interopRequireDefault(_RoleVerificationActions);
	
	var _RoleVerificationStore = __webpack_require__(3081);
	
	var _RoleVerificationStore2 = _interopRequireDefault(_RoleVerificationStore);
	
	var _SchoolPicker = __webpack_require__(2510);
	
	var _SchoolPicker2 = _interopRequireDefault(_SchoolPicker);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	__webpack_require__(3082);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EVENT_SCREEN_NAME = 'SetupAdminRoles';
	
	var SetupAdmin = _react2.default.createClass({
	  displayName: 'SetupAdmin',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  childContextTypes: {
	    eventScreenName: _react2.default.PropTypes.string
	  },
	
	  mixins: [_RequireUser2.default],
	
	  getInitialState: function getInitialState() {
	    var existingVerificationState = {};
	    var roleVerification = _RoleVerificationStore2.default.getRoleVerification();
	    if (roleVerification) {
	      existingVerificationState.isSchool = roleVerification.is_school;
	      existingVerificationState.organizationId = roleVerification.organization_id;
	
	      var currentRole = roleVerification.role;
	      if (currentRole in _AdminRoles.AdminRoles) {
	        existingVerificationState.role = currentRole;
	      } else {
	        existingVerificationState.role = 'other';
	        existingVerificationState.otherRole = currentRole;
	      }
	    }
	    return Object.assign({
	      enabled: false,
	      isSchool: true
	    }, existingVerificationState);
	  },
	  getChildContext: function getChildContext() {
	    return {
	      eventScreenName: EVENT_SCREEN_NAME
	    };
	  },
	  onSelectOrg: function onSelectOrg(organizationId) {
	    this.setState({ enabled: true, organizationId: organizationId });
	  },
	  submit: function submit(attrs) {
	    var roleVerification = {
	      organization_id: this.state.organizationId,
	      is_school: this.state.isSchool
	    };
	
	    roleVerification.role = this.state.role === 'other' ? attrs.other_role : attrs.role;
	
	    _RoleVerificationActions2.default.addRoleVerification(roleVerification);
	    this.context.router.push('/setup/school_email');
	  },
	  roleSelected: function roleSelected() {
	    if (this.state.role) {
	      if (this.state.role === 'other') {
	        return !!this.state.otherRole;
	      } else {
	        return true;
	      }
	    } else {
	      return false;
	    }
	  },
	  renderOtherRole: function renderOtherRole() {
	    var _this = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'SetupAdmin-section' },
	      _react2.default.createElement(_FormInput2.default, {
	        label: 'Description',
	        name: 'other_role',
	        onChange: function onChange(event) {
	          return _this.setState({ otherRole: event.target.value });
	        },
	        value: this.state.otherRole,
	        placeholder: 'Describe your role'
	      })
	    );
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        isSchool = _state.isSchool,
	        organizationId = _state.organizationId;
	
	    var organizationType = isSchool ? _OrganizationConstants.OrganizationTypes.SCHOOL : _OrganizationConstants.OrganizationTypes.DISTRICT;
	    var organizationLabel = (0, _lodash.capitalize)(organizationType.toLowerCase());
	
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        size: 'small',
	        full: true,
	        className: 'SetupAdmin',
	        title: 'Where do you work?',
	        subtext: 'We currently verify principals and assistant principals at US K-12 schools. If you\u2019re an administrator in a different role, please send an email to schooladmin@remindhq.com and cc your principal for access to school features.' },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Form2.default,
	            { onValidSubmit: this.submit },
	            _react2.default.createElement(
	              'div',
	              { className: 'SetupAdmin-section' },
	              _react2.default.createElement(
	                _Label2.default,
	                null,
	                'Primary affiliation'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'SetupAdmin-affiliation' },
	                _react2.default.createElement(_Radio2.default, {
	                  className: 'SetupAdmin-affiliation-radio',
	                  label: 'School',
	                  onChange: function onChange() {
	                    return _this2.setState({ isSchool: true });
	                  },
	                  checked: isSchool
	                }),
	                _react2.default.createElement(_Radio2.default, {
	                  className: 'SetupAdmin-affiliation-radio',
	                  label: 'District',
	                  onChange: function onChange() {
	                    return _this2.setState({ isSchool: false });
	                  },
	                  checked: !isSchool
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'SetupAdmin-section' },
	              _react2.default.createElement(
	                _Label2.default,
	                null,
	                organizationLabel
	              ),
	              _react2.default.createElement(_SchoolPicker2.default, {
	                organizationType: organizationType,
	                onSelect: this.onSelectOrg,
	                onClear: function onClear() {},
	                onCreateOrganization: function onCreateOrganization(org) {
	                  return _this2.onSelectOrg(org.id);
	                },
	                schoolId: organizationId,
	                placeholder: 'Search for your ' + organizationLabel.toLowerCase(),
	                showNCESId: true
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'SetupAdmin-section' },
	              _react2.default.createElement(_FormSelect2.default, {
	                label: 'Role at ' + organizationLabel.toLowerCase(),
	                name: 'role',
	                searchable: false,
	                options: _AdminRoles.AdminRoleOptions,
	                onChange: function onChange(role) {
	                  return _this2.setState({ role: role });
	                },
	                value: this.state.role
	              })
	            ),
	            this.state.role === 'other' && this.renderOtherRole(),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                disabled: !this.state.organizationId || !this.roleSelected(),
	                className: 'SetupAdmin-Submit',
	                type: 'submit',
	                eventProperties: {
	                  is_school: isSchool
	                },
	                eventElementName: 'SetupAdmin-Submit' },
	              'Next'
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = SetupAdmin;

/***/ },
/* 3079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RoleVerificationConstants = __webpack_require__(3080);
	
	var _Dispatcher = __webpack_require__(590);
	
	var RoleVerificationActions = {
	  addRoleVerification: function addRoleVerification(roleVerification) {
	    _Dispatcher.dispatcher.dispatch({
	      type: _RoleVerificationConstants.ActionTypes.ROLE_VERIFICATION_LOADED,
	      roleVerification: roleVerification
	    });
	  }
	};
	
	exports.default = RoleVerificationActions;

/***/ },
/* 3080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActionTypes = undefined;
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = (0, _enumerate2.default)(['ROLE_VERIFICATION_LOADED']); /*  weak */

/***/ },
/* 3081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RoleVerificationConstants = __webpack_require__(3080);
	
	var _Store2 = __webpack_require__(589);
	
	var _Store3 = _interopRequireDefault(_Store2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RoleVerificationStore = function (_Store) {
	  _inherits(RoleVerificationStore, _Store);
	
	  function RoleVerificationStore() {
	    _classCallCheck(this, RoleVerificationStore);
	
	    return _possibleConstructorReturn(this, (RoleVerificationStore.__proto__ || Object.getPrototypeOf(RoleVerificationStore)).apply(this, arguments));
	  }
	
	  _createClass(RoleVerificationStore, [{
	    key: 'getInitialState',
	    value: function getInitialState() {
	      return {
	        roleVerification: null
	      };
	    }
	  }, {
	    key: 'getRoleVerification',
	    value: function getRoleVerification() {
	      return this.state.roleVerification;
	    }
	  }, {
	    key: 'handleDispatch',
	    value: function handleDispatch(action) {
	      switch (action.type) {
	        case _RoleVerificationConstants.ActionTypes.ROLE_VERIFICATION_LOADED:
	          this.setState({ roleVerification: action.roleVerification });
	          this.emitChange();
	          break;
	        default:
	          break;
	      }
	    }
	  }]);
	
	  return RoleVerificationStore;
	}(_Store3.default);
	
	RoleVerificationStore.displayName = 'RoleVerificationStore';
	exports.default = new RoleVerificationStore();

/***/ },
/* 3082 */
1136,
/* 3083 */,
/* 3084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RequireSetup = __webpack_require__(2756);
	
	var _RequireSetup2 = _interopRequireDefault(_RequireSetup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SetupDefaultView = _react2.default.createClass({
	  displayName: 'SetupDefaultView',
	
	  mixins: [_RequireSetup2.default],
	
	  // This component will always redirect, hence nothing to render
	  render: function render() {
	    return null;
	  }
	});
	
	exports.default = SetupDefaultView;

/***/ },
/* 3085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _humanparser = __webpack_require__(2003);
	
	var _humanparser2 = _interopRequireDefault(_humanparser);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SetupFullName = _react2.default.createClass({
	  displayName: 'SetupFullName',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [_RequireUser2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      enable: false
	    };
	  },
	  submit: function submit(attrs) {
	    var _this = this;
	
	    var human = _humanparser2.default.parseName(attrs['full_name']);
	    var data = {
	      first_name: human.firstName,
	      last_name: human.lastName
	    };
	
	    var onSuccess = function onSuccess() {
	      _ToastActions2.default.showSuccessToast('Saved!');
	      _this.context.router.push('/');
	    };
	
	    var onFailure = function onFailure(error) {
	      return _ToastActions2.default.showAPIError(error);
	    };
	
	    _UserActions2.default.update(data).then(onSuccess, onFailure);
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var user = _CurrentUser2.default.getUser();
	    var fullName = '';
	
	    if (user.getFirstName() && user.getLastName()) {
	      fullName = user.getFirstName() + ' ' + user.getLastName();
	    } else {
	      fullName = user.getFirstName() || user.getLastName() || '';
	    }
	
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        size: 'small',
	        full: true,
	        className: 'SetupFullName',
	        title: 'What’s your name?' },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(
	          _Form2.default,
	          {
	            onValidSubmit: this.submit,
	            onValid: function onValid() {
	              return _this2.setState({ enabled: true });
	            },
	            onInvalid: function onInvalid() {
	              return _this2.setState({ enabled: false });
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'SetupFullName-First' },
	            _react2.default.createElement(_FormInput2.default, {
	              label: 'Full name',
	              required: true,
	              name: 'full_name',
	              showErrorOnPristine: false,
	              value: fullName,
	              placeholder: 'First and last name',
	              validations: { maxLength: 255 },
	              validationErrors: {
	                maxLength: 'Name should be shorter than 255 characters.'
	              }
	            })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              disabled: !this.state.enabled,
	              className: 'SetupFullName-Submit',
	              type: 'submit',
	              eventElementName: 'SetupFullName-Submit' },
	            'Next'
	          )
	        )
	      )
	    );
	  }
	}); /*  weak */
	exports.default = SetupFullName;

/***/ },
/* 3086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*  weak */
	
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _FeatureStore = __webpack_require__(588);
	
	var _FeatureStore2 = _interopRequireDefault(_FeatureStore);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormCheckBox = __webpack_require__(1705);
	
	var _FormCheckBox2 = _interopRequireDefault(_FormCheckBox);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	__webpack_require__(3087);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FACEBOOK_TRACKING_PIXEL = 'https://www.facebook.com/offsite_event.php?id=6008327779772&value=0.01&currency=USD';
	
	var SetupGroup = _react2.default.createClass({
	  displayName: 'SetupGroup',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      submitEnabled: false
	    };
	  },
	  handleSubmit: function handleSubmit(data) {
	    var _this = this;
	
	    this.setState({ submitEnabled: false });
	
	    var groupName = data.groupName,
	        overThirteen = data.overThirteen;
	
	
	    var groupToCreate = new _Group2.default();
	    groupToCreate.setName(groupName);
	    groupToCreate.setHasChildren(!overThirteen);
	    groupToCreate.setCanSubscribersInititateChats(_FeatureStore2.default.hasFeature('subscriber_initiated_chats_default'));
	
	    var onError = function onError(error) {
	      _this.setState({ submitEnabled: true });
	      _ToastActions2.default.showAPIError(error);
	    };
	
	    _GroupActions2.default.create(groupToCreate).then(function (group) {
	      // Controls visibility of group invite modal when landing in app
	      _GroupStore2.default.setGroupCreatedDuringSetup(group);
	
	      if (!_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.NUX_SETUP_CLASS)) {
	        _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.NUX_SETUP_CLASS).then(function () {
	          _UserActions2.default.loadCurrentUser();
	        });
	      }
	      _this.context.router.push('/classes/?origin=created_group');
	    }, onError);
	  },
	  onInputBlur: function onInputBlur(event) {
	    // Hack to redirect before firing validation if the thing that was clicked on the
	    // cause the blur was a link to somewhere else
	    if (event.relatedTarget && event.relatedTarget.href && event.relatedTarget.href.endsWith('/setup/subscriptions')) {
	      this.context.router.push('/setup/subscriptions');
	    }
	  },
	  validateClassName: function validateClassName(e) {
	    var value = e.target.value;
	
	    var warning = null;
	
	    if (value === '81010' || value.startsWith('@') || value.startsWith('rmd.me')) {
	      warning = _react2.default.createElement(
	        'div',
	        null,
	        'It looks like you’re trying to ',
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'SetupGroup-warning',
	            to: '/setup/subscriptions',
	            eventElementName: 'SetupGroup-warning' },
	          'join a class'
	        ),
	        '.'
	      );
	    }
	
	    this.setState({ warning: warning });
	  },
	  renderFBTrackingPixel: function renderFBTrackingPixel() {
	    // Don't render the tracking pixel for subsequent logins
	    if (_CurrentUser2.default.getUser().getSignInCount() > 1) {
	      return null;
	    }
	
	    return _react2.default.createElement(_Image2.default, {
	      className: 'SetupGroup-fbPixel',
	      src: FACEBOOK_TRACKING_PIXEL,
	      width: '1',
	      height: '1'
	    });
	  },
	  renderUnder13Checkbox: function renderUnder13Checkbox() {
	    return _react2.default.createElement(
	      _FormCheckBox2.default,
	      { name: 'overThirteen', defaultChecked: true },
	      _react2.default.createElement(
	        'div',
	        null,
	        'I will only message people 13 and older'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'SetupGroup-labelSubtext' },
	        'It\u2019s okay if students are under 13. We\u2019ll ask for a parent\u2019s email address to keep everyone in the loop.'
	      )
	    );
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var props = {
	      title: 'Create a class',
	      subtext: 'Once you create a class, you can invite students and parents,\n         send announcements, and start conversations.',
	      size: 'small'
	    };
	
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      _extends({}, props, { full: true, className: 'SetupGroup' }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(
	          _Form2.default,
	          {
	            onValidSubmit: this.handleSubmit,
	            onValid: function onValid() {
	              return _this2.setState({ submitEnabled: true });
	            },
	            onInvalid: function onInvalid() {
	              return _this2.setState({ submitEnabled: false });
	            } },
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Class name',
	            onBlur: this.onInputBlur,
	            onChange: this.validateClassName,
	            required: true,
	            className: 'SetupGroup-GroupName',
	            type: 'text',
	            name: 'groupName',
	            placeholder: 'e.g. Math 101, Soccer Team, Chess Club',
	            autofocus: true,
	            showErrorAfterBlur: true,
	            warning: this.state.warning,
	            validations: { minLength: 3, maxLength: 60 },
	            validationError: 'The class name must be between 3 and 60 characters long.'
	          }),
	          _CurrentUser2.default.getUser().isTeacher() ? this.renderUnder13Checkbox() : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_FormInput2.default, { type: 'hidden', name: 'overThirteen', value: true }),
	            _react2.default.createElement(
	              'p',
	              { className: 'SetupGroup-overThirteenText' },
	              'This class can only include people who are 13 or older.'
	            )
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'SetupGroup-button-submit',
	              disabled: !this.state.submitEnabled,
	              type: 'submit',
	              level: 'primary',
	              eventElementName: 'SetupGroup-button-submit' },
	            'Add'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _BoxFooter2.default,
	        null,
	        'Looking for a class? ',
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'SetupGroup-JoinClass',
	            onClick: function onClick() {
	              return _this2.context.router.push('/setup/subscriptions');
	            },
	            eventElementName: 'SetupGroup-JoinClass' },
	          'Join a class'
	        )
	      ),
	      this.renderFBTrackingPixel()
	    );
	  }
	});
	
	exports.default = SetupGroup;

/***/ },
/* 3087 */
1136,
/* 3088 */,
/* 3089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _EventTracking = __webpack_require__(577);
	
	var _EventTracking2 = _interopRequireDefault(_EventTracking);
	
	var _Field = __webpack_require__(1355);
	
	var _Field2 = _interopRequireDefault(_Field);
	
	var _GroupActions = __webpack_require__(994);
	
	var _GroupActions2 = _interopRequireDefault(_GroupActions);
	
	var _GroupStore = __webpack_require__(990);
	
	var _GroupStore2 = _interopRequireDefault(_GroupStore);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Label = __webpack_require__(1361);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Lead = __webpack_require__(1022);
	
	var _Lead2 = _interopRequireDefault(_Lead);
	
	var _LeadActions = __webpack_require__(1021);
	
	var _LeadActions2 = _interopRequireDefault(_LeadActions);
	
	var _LeadStore = __webpack_require__(1024);
	
	var _LeadStore2 = _interopRequireDefault(_LeadStore);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _OrganizationConstants = __webpack_require__(1004);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _OrganizationStore = __webpack_require__(1003);
	
	var _OrganizationStore2 = _interopRequireDefault(_OrganizationStore);
	
	var _Organizations = __webpack_require__(1002);
	
	var _Organizations2 = _interopRequireDefault(_Organizations);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SchoolPicker = __webpack_require__(2510);
	
	var _SchoolPicker2 = _interopRequireDefault(_SchoolPicker);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	__webpack_require__(3090);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EVENT_SCREEN_NAME = 'SetupSchool';
	
	var SetupSchool = function (_React$Component) {
	  _inherits(SetupSchool, _React$Component);
	
	  function SetupSchool() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SetupSchool);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SetupSchool.__proto__ || Object.getPrototypeOf(SetupSchool)).call.apply(_ref, [this].concat(args))), _this), _this.onSchoolCreate = function (organization) {
	      _this.setState({ schoolId: organization.id });
	    }, _this.didCreateChildClass = function () {
	      return _this.getFirstOwnedClass() && _this.getFirstOwnedClass().hasChildren();
	    }, _this.handleDontWorkClick = function () {
	      _UserActions2.default.savePreference('works_at_a_school', false).then(_LeadActions2.default.deleteLead).then(function () {
	        return _this.updateUserOrganization(_OrganizationConstants.NO_SCHOOL.id);
	      }).catch(_ToastActions2.default.showDefaultErrorToast);
	    }, _this.handleNoButtonClick = function () {
	      _this.setState({ suggesting: false });
	    }, _this.handleSaveSchoolButtonClick = function () {
	      if (_this.state.schoolId === _OrganizationConstants.NO_SCHOOL.id) {
	        _this.handleDontWorkClick();
	      } else {
	        _this.updateUserOrganization(_this.state.schoolId);
	      }
	    }, _this.handleYesButtonClick = function () {
	      _this.updateUserOrganization(_this.state.lead ? _this.state.lead.getOrganizationId() : null);
	    }, _this.redirectToApp = function () {
	      _this.context.router.push('/');
	    }, _this.updateUserOrganization = function (organizationId) {
	      var onFailure = function onFailure(error) {
	        _this.setState({ submitting: false });
	        _ToastActions2.default.showAPIError(error);
	      };
	
	      var onSuccess = function onSuccess() {
	        _LeadActions2.default.loadLeads(true);
	        _OrganizationActions2.default.loadUserOrganizations();
	        _ToastActions2.default.showSuccessToast('Saved!');
	        _this.redirectToApp();
	      };
	
	      var updateUserOrganization = function updateUserOrganization() {
	        _UserActions2.default.update({ organization_id: organizationId }).then(onSuccess, onFailure);
	      };
	
	      var defaultFirstClass = function defaultFirstClass() {
	        var attrs = { organization_id: organizationId };
	        _GroupActions2.default.patch(_this.getFirstOwnedClass(), attrs).then(updateUserOrganization, onFailure);
	      };
	
	      _this.setState({ submitting: true });
	      if (_this.getFirstOwnedClass()) {
	        defaultFirstClass();
	      } else {
	        updateUserOrganization();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SetupSchool, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        eventScreenName: EVENT_SCREEN_NAME
	      };
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      _Organizations2.default.suggest().then(function (orgs) {
	        if (orgs && orgs.length) {
	          _this2.setState({ suggestedSchools: orgs });
	        }
	      });
	
	      _LeadActions2.default.loadLead(_CurrentUser2.default.getUser().id).then(function () {
	        var lead = _LeadStore2.default.getLeadForUser(_CurrentUser2.default.getUser().id);
	        _this2.setState({ lead: lead });
	        _OrganizationActions2.default.getOrLoadOrganization(lead.getOrganizationId()).then(function (orgForLead) {
	          _this2.setState({ orgForLead: orgForLead });
	        }, function () {
	          _this2.setState({ suggesting: false });
	        });
	      }, function () {
	        _this2.setState({ suggesting: false });
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _EventTracking2.default.view(EVENT_SCREEN_NAME, { user_id: _CurrentUser2.default.getUserId() });
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      if (this.state.suggesting && nextState.lead && nextState.lead.length === 0) {
	        this.setState({ suggesting: false });
	      }
	    }
	  }, {
	    key: 'getFirstOwnedClass',
	    value: function getFirstOwnedClass() {
	      return _GroupStore2.default.getOwnedGroups().first();
	    }
	  }, {
	    key: 'renderDontWorkInASchoolButton',
	    value: function renderDontWorkInASchoolButton() {
	      return _react2.default.createElement(
	        _BoxFooter2.default,
	        { className: 'SetupSchool-footer' },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            eventElementName: 'dontWorkButton',
	            className: 'SetupSchool-dontWorkButton',
	            level: 'text',
	            size: 'small',
	            onClick: this.handleDontWorkClick },
	          'I don\u2019t work at a school'
	        )
	      );
	    }
	  }, {
	    key: 'renderSchoolSelector',
	    value: function renderSchoolSelector() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          className: 'SetupSchool',
	          title: 'Add your school',
	          full: true,
	          subtext: 'Connect with colleagues and help students ' + 'and parents find your classes.',
	          size: 'small' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          { divided: true },
	          _react2.default.createElement(
	            _Field2.default,
	            { className: 'SetupGroup-field' },
	            _react2.default.createElement(
	              _Label2.default,
	              null,
	              'School'
	            ),
	            _react2.default.createElement(_SchoolPicker2.default, {
	              schoolId: this.state.schoolId,
	              suggestions: this.state.suggestedSchools,
	              placeholder: 'Search for a school',
	              onSelect: function onSelect(value) {
	                return _this3.setState({ schoolId: value });
	              },
	              onClear: function onClear() {
	                return _this3.setState({ schoolId: null });
	              },
	              onCreateOrganization: this.onSchoolCreate,
	              onNoSchool: this.handleDontWorkClick,
	              noQuery: 'Suggested schools for you',
	              autofocus: true
	            })
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'SetupSchool-saveSchoolButton',
	              eventElementName: 'saveSchoolButton',
	              disabled: !this.state.schoolId || this.state.submitting,
	              onClick: this.handleSaveSchoolButtonClick },
	            this.state.submitting ? _react2.default.createElement(_LoadingIndicator2.default, { className: 'SetupSchool-saveSchoolButton-loader' }) : 'Save'
	          )
	        ),
	        !this.didCreateChildClass() && this.renderDontWorkInASchoolButton()
	      );
	    }
	  }, {
	    key: 'renderSchoolSuggestor',
	    value: function renderSchoolSuggestor() {
	      var _state = this.state,
	          lead = _state.lead,
	          orgForLead = _state.orgForLead;
	
	      if (!lead || !orgForLead) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'SetupSchool-loading' },
	          _react2.default.createElement(_LoadingIndicator2.default, null)
	        );
	      }
	
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        { className: 'SetupSchool', size: 'small' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          {
	            className: 'SetupSchool-content',
	            divided: true,
	            dividerPlacement: 'bottom' },
	          _react2.default.createElement(_Image2.default, {
	            className: 'SetupSchool-image',
	            src: __webpack_require__(3092),
	            alt: 'School'
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'SetupSchool-title' },
	            'Do you teach at',
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'SetupSchool-school' },
	              orgForLead.getName(),
	              '?'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'SetupSchool-buttons' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                onClick: this.handleNoButtonClick,
	                eventElementName: 'declineSuggestedSchoolButton' },
	              'No'
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                onClick: this.handleYesButtonClick,
	                eventElementName: 'acceptSuggestedSchoolButton' },
	              'Yes'
	            )
	          )
	        ),
	        !this.didCreateChildClass() && this.renderDontWorkInASchoolButton()
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.state.suggesting ? this.renderSchoolSuggestor() : this.renderSchoolSelector();
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_LeadStore2.default, _OrganizationStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(prevState) {
	      var lead = _LeadStore2.default.getLeadForUser(_CurrentUser2.default.getUser().id);
	      return {
	        lead: lead,
	        orgForLead: lead && _OrganizationStore2.default.getOrganization(lead.getOrganizationId()),
	        suggesting: prevState ? prevState.suggesting : true,
	        schoolId: prevState && prevState.schoolId,
	        submitting: prevState ? prevState.submitting : false,
	        suggestedSchools: prevState && prevState.suggestedSchools
	      };
	    }
	  }]);
	
	  return SetupSchool;
	}(_react2.default.Component);
	
	SetupSchool.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	SetupSchool.childContextTypes = {
	  eventScreenName: _react2.default.PropTypes.string
	};
	SetupSchool.displayName = 'SetupSchool';
	exports.default = _utils.Container.create(SetupSchool, {
	  pure: false
	});

/***/ },
/* 3090 */
1136,
/* 3091 */,
/* 3092 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 3093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	var _accountCompletionTracker = __webpack_require__(2526);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	__webpack_require__(3094);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SetupView = _react2.default.createClass({
	  displayName: 'SetupView',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [_RequireUser2.default],
	
	  componentDidMount: function componentDidMount() {
	    (0, _accountCompletionTracker.markAccountCreationStart)(_CurrentUser2.default.getUser());
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'SetupView' },
	      this.props.children
	    );
	  }
	});
	exports.default = SetupView;

/***/ },
/* 3094 */
1136,
/* 3095 */,
/* 3096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _enumerate = __webpack_require__(924);
	
	var _enumerate2 = _interopRequireDefault(_enumerate);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _LinkSmsDevicePage = __webpack_require__(2788);
	
	var _LinkSmsDevicePage2 = _interopRequireDefault(_LinkSmsDevicePage);
	
	var _ShouldLinkSmsDeviceView = __webpack_require__(3097);
	
	var _ShouldLinkSmsDeviceView2 = _interopRequireDefault(_ShouldLinkSmsDeviceView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*  weak */
	
	
	var STATUS = (0, _enumerate2.default)(['question', 'device_verify']);
	
	var SetupSignature = _react2.default.createClass({
	  displayName: 'SetupSignature',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [_RequireUser2.default],
	
	  getInitialState: function getInitialState() {
	    var forcePhone = _CurrentUser2.default.inExpVariant('FORCE_PHONE') || _CurrentUser2.default.inExpVariant('FORCE_PHONE', 'allow_skip');
	    return {
	      status: forcePhone ? STATUS.device_verify : STATUS.question
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (!_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.NUX_SETUP_SMS_DEVICE)) {
	      _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.NUX_SETUP_SMS_DEVICE);
	    }
	  },
	  onDone: function onDone() {
	    this.context.router.push('/');
	  },
	  onSelect: function onSelect(response) {
	    if (response === false) {
	      this.context.router.push('/');
	    } else {
	      this.setState({ status: STATUS.device_verify });
	    }
	  },
	  renderDeviceVerification: function renderDeviceVerification() {
	    return _react2.default.createElement(_LinkSmsDevicePage2.default, {
	      onDone: this.onDone,
	      onSkip: _CurrentUser2.default.inExpVariant('FORCE_PHONE') ? undefined : this.onDone
	    });
	  },
	  renderQuestion: function renderQuestion() {
	    return _react2.default.createElement(_ShouldLinkSmsDeviceView2.default, { onSelect: this.onSelect });
	  },
	  render: function render() {
	    var _STATUS$question$STAT;
	
	    return (_STATUS$question$STAT = {}, _defineProperty(_STATUS$question$STAT, STATUS.question, this.renderQuestion), _defineProperty(_STATUS$question$STAT, STATUS.device_verify, this.renderDeviceVerification), _STATUS$question$STAT)[this.state.status]();
	  }
	});
	
	exports.default = SetupSignature;

/***/ },
/* 3097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxSelect = __webpack_require__(2467);
	
	var _BoxSelect2 = _interopRequireDefault(_BoxSelect);
	
	var _CenteredContainer = __webpack_require__(2240);
	
	var _CenteredContainer2 = _interopRequireDefault(_CenteredContainer);
	
	var _BoxSelectItem = __webpack_require__(2470);
	
	var _BoxSelectItem2 = _interopRequireDefault(_BoxSelectItem);
	
	__webpack_require__(3098);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShouldLinkSmsDeviceView = function (_React$Component) {
	  _inherits(ShouldLinkSmsDeviceView, _React$Component);
	
	  function ShouldLinkSmsDeviceView() {
	    _classCallCheck(this, ShouldLinkSmsDeviceView);
	
	    return _possibleConstructorReturn(this, (ShouldLinkSmsDeviceView.__proto__ || Object.getPrototypeOf(ShouldLinkSmsDeviceView)).apply(this, arguments));
	  }
	
	  _createClass(ShouldLinkSmsDeviceView, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _CenteredContainer2.default,
	        { size: 'small' },
	        _react2.default.createElement(
	          _BoxSelect2.default,
	          { title: 'Did you sign up for Remind via text?' },
	          _react2.default.createElement(_BoxSelectItem2.default, {
	            label: 'Yes',
	            size: 'xsmall',
	            className: 'ShouldLinkSmsDeviceView-Yes',
	            eventElementName: 'ShouldLinkSmsDeviceView-Yes',
	            icon: __webpack_require__(3100),
	            action: function action() {
	              return _this2.props.onSelect(true);
	            }
	          }),
	          _react2.default.createElement(_BoxSelectItem2.default, {
	            label: 'No',
	            size: 'xsmall',
	            className: 'ShouldLinkSmsDeviceView-No',
	            eventElementName: 'ShouldLinkSmsDeviceView-No',
	            icon: __webpack_require__(3101),
	            action: function action() {
	              return _this2.props.onSelect(false);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return ShouldLinkSmsDeviceView;
	}(_react2.default.Component);
	
	ShouldLinkSmsDeviceView.displayName = 'ShouldLinkSmsDeviceView';
	exports.default = ShouldLinkSmsDeviceView;

/***/ },
/* 3098 */
1136,
/* 3099 */,
/* 3100 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 3101 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ },
/* 3102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CopyConstants = __webpack_require__(3025);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _FormSelect = __webpack_require__(1365);
	
	var _FormSelect2 = _interopRequireDefault(_FormSelect);
	
	var _Prefixes = __webpack_require__(3103);
	
	var _Prefixes2 = _interopRequireDefault(_Prefixes);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _PromptConstants = __webpack_require__(1045);
	
	__webpack_require__(3104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SetupSignature = _react2.default.createClass({
	  displayName: 'SetupSignature',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [_RequireUser2.default],
	
	  getInitialState: function getInitialState() {
	    return {
	      enable: false,
	      prefix: _CurrentUser2.default.getUser().getPrefix() || ''
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (!_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.NUX_SETUP_SIGNATURE)) {
	      _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.NUX_SETUP_SIGNATURE);
	    }
	  },
	  onPrefixChange: function onPrefixChange(prefix) {
	    this.setState({ prefix: prefix });
	  },
	  submit: function submit(attrs) {
	    var _this = this;
	
	    var onSuccess = function onSuccess() {
	      _ToastActions2.default.showSuccessToast('Saved!');
	      _this.context.router.push('/');
	    };
	
	    var onFailure = function onFailure(error) {
	      return _ToastActions2.default.showAPIError(error);
	    };
	
	    if (attrs.prefix) {
	      attrs.signature = attrs.prefix + ' ' + attrs.signature;
	    }
	
	    _UserActions2.default.update(attrs).then(onSuccess, onFailure);
	  },
	  render: function render() {
	    var _this2 = this;
	
	    // if there's a prefix we concat the signature and the prefix
	    // so the max length of the signature is not 18 but (18 - 'Mr. '.length)
	    var maxLength = this.state.prefix.length > 0 ? 18 - (this.state.prefix.length + 1) : 18;
	
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        size: 'small',
	        full: true,
	        className: 'SetupSignature',
	        title: 'What do students and parents call you?',
	        subtext: _CopyConstants.Signature.explanation },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'SetupSignature' },
	          _react2.default.createElement(
	            _Form2.default,
	            {
	              onValidSubmit: this.submit,
	              onValid: function onValid() {
	                return _this2.setState({ enabled: true });
	              },
	              onInvalid: function onInvalid() {
	                return _this2.setState({ enabled: false });
	              } },
	            _react2.default.createElement(
	              'div',
	              { className: 'SetupSignature-Title' },
	              _react2.default.createElement(_FormSelect2.default, {
	                label: 'Title',
	                name: 'prefix',
	                value: _CurrentUser2.default.getUser().getPrefix(),
	                onChange: this.onPrefixChange,
	                options: _Prefixes2.default,
	                placeholder: '[No title]',
	                searchable: false
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'SetupSignature-Name' },
	              _react2.default.createElement(_FormInput2.default, {
	                label: 'Name',
	                required: true,
	                name: 'signature',
	                showErrorOnPristine: true,
	                value: _CurrentUser2.default.getUser().getSignature(),
	                validations: { maxLength: maxLength },
	                validationErrors: {
	                  maxLength: 'Signature should be shorter than ' + (maxLength + 1) + ' characters.'
	                }
	              })
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                disabled: !this.state.enabled,
	                className: 'SetupSignature-Submit',
	                type: 'submit',
	                eventElementName: 'SetupSignature-Submit' },
	              'Next'
	            )
	          )
	        )
	      )
	    );
	  }
	}); /*  weak */
	exports.default = SetupSignature;

/***/ },
/* 3103 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/*  weak */
	exports.default = [{ value: '', label: '[No title]' }, { value: 'Mr.', label: 'Mr.' }, { value: 'Mrs.', label: 'Mrs.' }, { value: 'Ms.', label: 'Ms.' }, { value: 'Miss', label: 'Miss' }, { value: 'Dr.', label: 'Dr.' }, { value: 'Coach', label: 'Coach' }, { value: 'Prof.', label: 'Prof.' }];

/***/ },
/* 3104 */
1136,
/* 3105 */,
/* 3106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _EmailForm = __webpack_require__(1403);
	
	var _EmailForm2 = _interopRequireDefault(_EmailForm);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SetupEmail = _react2.default.createClass({
	  displayName: 'SetupEmail',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [_RequireUser2.default],
	
	  onSave: function onSave() {
	    this.context.router.push('/');
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        size: 'small',
	        full: true,
	        title: 'What is your email address?',
	        subtext: 'This will be your primary email address for Remind.' },
	      _react2.default.createElement(
	        _BoxBody2.default,
	        { divided: true },
	        _react2.default.createElement(_EmailForm2.default, { onSave: this.onSave })
	      )
	    );
	  }
	});
	exports.default = SetupEmail;

/***/ },
/* 3107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _chainOnEnter = __webpack_require__(2586);
	
	var _chainOnEnter2 = _interopRequireDefault(_chainOnEnter);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _PasswordForm = __webpack_require__(3108);
	
	var _PasswordForm2 = _interopRequireDefault(_PasswordForm);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SetupPassword = function (_React$Component) {
	  _inherits(SetupPassword, _React$Component);
	
	  function SetupPassword() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SetupPassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SetupPassword.__proto__ || Object.getPrototypeOf(SetupPassword)).call.apply(_ref, [this].concat(args))), _this), _this.onSave = function () {
	      _this.context.router.push('/classes');
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SetupPassword, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          size: 'small',
	          full: true,
	          title: 'Create a password',
	          subtext: 'Your password must consist of at least six characters.' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(_PasswordForm2.default, { onSave: this.onSave })
	        )
	      );
	    }
	  }]);
	
	  return SetupPassword;
	}(_react2.default.Component);
	
	SetupPassword.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	SetupPassword.onEnter = (0, _chainOnEnter2.default)([_RequireUser2.default]);
	SetupPassword.displayName = 'SetupPassword';
	exports.default = SetupPassword;

/***/ },
/* 3108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PasswordForm = function (_React$Component) {
	  _inherits(PasswordForm, _React$Component);
	
	  function PasswordForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PasswordForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PasswordForm.__proto__ || Object.getPrototypeOf(PasswordForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      enabled: false
	    }, _this.submit = function (attrs) {
	      var onSuccess = function onSuccess() {
	        _ToastActions2.default.showSuccessToast('Saved!');
	        _this.props.onSave();
	      };
	
	      var onFailure = function onFailure(error) {
	        return _ToastActions2.default.showAPIError(error);
	      };
	
	      _UserActions2.default.createPassword(attrs.password).then(onSuccess, onFailure);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PasswordForm, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'PasswordForm' },
	        _react2.default.createElement(
	          _Form2.default,
	          {
	            onValidSubmit: this.submit,
	            onValid: function onValid() {
	              return _this2.setState({ enabled: true });
	            },
	            onInvalid: function onInvalid() {
	              return _this2.setState({ enabled: false });
	            } },
	          _react2.default.createElement(_FormInput2.default, {
	            type: 'password',
	            autoComplete: 'new-password',
	            className: 'PasswordForm-password',
	            name: 'password',
	            placeholder: 'Password',
	            required: true,
	            validations: 'minLength:6',
	            validOnPristine: true,
	            validationError: 'Password must be at least 6 characters long.'
	          }),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              disabled: !this.state.enabled,
	              className: 'PasswordForm-Submit',
	              type: 'submit',
	              eventElementName: 'PasswordForm-Submit' },
	            'Save'
	          )
	        )
	      );
	    }
	  }]);
	
	  return PasswordForm;
	}(_react2.default.Component);
	
	PasswordForm.displayName = 'PasswordForm';
	exports.default = PasswordForm;

/***/ },
/* 3109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PromptStore = __webpack_require__(1401);
	
	var _PromptStore2 = _interopRequireDefault(_PromptStore);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	var _PromptActions = __webpack_require__(1400);
	
	var _PromptActions2 = _interopRequireDefault(_PromptActions);
	
	var _PromptConstants = __webpack_require__(1045);
	
	var _JoinGroupModal = __webpack_require__(2450);
	
	var _JoinGroupModal2 = _interopRequireDefault(_JoinGroupModal);
	
	var _BoxFooter = __webpack_require__(2461);
	
	var _BoxFooter2 = _interopRequireDefault(_BoxFooter);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _LeadActions = __webpack_require__(1021);
	
	var _LeadActions2 = _interopRequireDefault(_LeadActions);
	
	var _SetupActions = __webpack_require__(1473);
	
	var _SetupActions2 = _interopRequireDefault(_SetupActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SetupSubscription = _react2.default.createClass({
	  displayName: 'SetupSubscription',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  mixins: [_RequireUser2.default],
	
	  componentDidMount: function componentDidMount() {
	    if (!_PromptStore2.default.hasDismissed(_PromptConstants.PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION)) {
	      _PromptActions2.default.recordDismissal(_PromptConstants.PromptNames.NUX_SETUP_FIRST_SUBSCRIPTION);
	    }
	  },
	  onJoinGroup: function onJoinGroup() {
	    _SetupActions2.default.joinGroupDuringSetup();
	    _LeadActions2.default.loadLeads(true);
	
	    this.context.router.push('/information_required');
	  },
	  onSkip: function onSkip() {
	    this.context.router.push('/information_required');
	  },
	  renderCreateClass: function renderCreateClass() {
	    var _this = this;
	
	    if (_CurrentUser2.default.getUser().canCreateGroups()) {
	      return _react2.default.createElement(
	        _BoxFooter2.default,
	        null,
	        'Or ',
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            className: 'SetupSubscription-CreateClass',
	            onClick: function onClick() {
	              return _this.context.router.push('/setup/class');
	            },
	            eventElementName: 'SetupSubscription-CreateClass' },
	          'create a class'
	        )
	      );
	    } else {
	      return null;
	    }
	  },
	  render: function render() {
	    return _react2.default.createElement(_JoinGroupModal2.default, {
	      modal: false,
	      footer: this.renderCreateClass(),
	      onRequestHide: this.onSkip,
	      onJoin: this.onJoinGroup
	    });
	  }
	});
	exports.default = SetupSubscription;

/***/ },
/* 3110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.libs = undefined;
	
	var _AdminRoles = __webpack_require__(2148);
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _Form = __webpack_require__(1344);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormInput = __webpack_require__(1353);
	
	var _FormInput2 = _interopRequireDefault(_FormInput);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RoleVerificationStore = __webpack_require__(3081);
	
	var _RoleVerificationStore2 = _interopRequireDefault(_RoleVerificationStore);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _UserActions = __webpack_require__(1037);
	
	var _UserActions2 = _interopRequireDefault(_UserActions);
	
	var _OrganizationActions = __webpack_require__(998);
	
	var _OrganizationActions2 = _interopRequireDefault(_OrganizationActions);
	
	__webpack_require__(3111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var libs = exports.libs = {
	  apiRequest: _apiRequest2.default
	};
	
	var SetupSchoolEmail = _react2.default.createClass({
	  displayName: 'SetupSchoolEmail',
	
	  contextTypes: {
	    router: _react2.default.PropTypes.object.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var initialEmail = _CurrentUser2.default.getUser().getEmail();
	    return {
	      email: initialEmail,
	      showEmailInput: !initialEmail,
	      enabled: false,
	      submitting: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (window.fbq) {
	      window.fbq('track', 'PageView');
	      window.fbq('track', 'Lead');
	    }
	  },
	  onSuccess: function onSuccess() {
	    var _this = this;
	
	    _OrganizationActions2.default.loadUserOrganizations();
	    _UserActions2.default.loadCurrentUser().then(function () {
	      return _this.context.router.push({ pathname: '/classes', query: { admin: true } });
	    });
	  },
	  onError: function onError(error) {
	    this.setState({ submitting: false });
	    _ToastActions2.default.showErrorToast(error.message);
	  },
	  onSubmit: function onSubmit() {
	    var roleVerification = _RoleVerificationStore2.default.getRoleVerification();
	    var orgId = roleVerification.organization_id;
	    var officialTitle = roleVerification.role in _AdminRoles.AdminRoles ? _AdminRoles.AdminRoles[roleVerification.role] : roleVerification.role;
	
	    var data = {
	      official_email: this.state.email,
	      official_title: officialTitle
	    };
	    this.setState({ submitting: true });
	    libs.apiRequest('/organizations/' + orgId + '/users/' + _CurrentUser2.default.getUser().id + '/roles/admin', 'POST', data).then(this.onSuccess, this.onError);
	  },
	  renderEmailConfirm: function renderEmailConfirm() {
	    var _this2 = this;
	
	    if (this.state.submitting) {
	      return _react2.default.createElement(_LoadingIndicator2.default, { className: 'SetupSchoolEmail-loader' });
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'SetupSchoolEmail-emailConfirm' },
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'SetupSchoolEmail-emailConfirm-no',
	          disabled: this.state.submitting,
	          onClick: function onClick() {
	            return _this2.setState({ showEmailInput: true });
	          },
	          eventElementName: 'SetupSchoolEmail-emailConfirm-no' },
	        'No'
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'SetupSchoolEmail-emailConfirm-yes',
	          disabled: this.state.submitting,
	          onClick: this.onSubmit,
	          eventElementName: 'SetupSchoolEmail-emailConfirm-yes' },
	        'Yes'
	      )
	    );
	  },
	  renderEmailInput: function renderEmailInput() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      _BoxBody2.default,
	      { divided: true },
	      _react2.default.createElement(
	        _Form2.default,
	        {
	          onValid: function onValid() {
	            return _this3.setState({ enabled: true });
	          },
	          onInvalid: function onInvalid() {
	            return _this3.setState({ enabled: false });
	          },
	          onValidSubmit: this.onSubmit },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_FormInput2.default, {
	            label: 'Email address',
	            name: 'email',
	            type: 'email',
	            validations: 'isEmail',
	            value: this.state.email,
	            onChange: function onChange(event) {
	              return _this3.setState({ email: event.target.value });
	            }
	          })
	        ),
	        this.state.submitting ? _react2.default.createElement(_LoadingIndicator2.default, { className: 'SetupSchoolEmail-loader' }) : _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'SetupSchoolEmail-emailConfirm-next',
	            disabled: !this.state.enabled,
	            type: 'submit',
	            level: 'primary',
	            eventElementName: 'SetupSchoolEmail-emailConfirm-next' },
	          'Next'
	        )
	      )
	    );
	  },
	  render: function render() {
	    var roleVerification = _RoleVerificationStore2.default.getRoleVerification();
	    if (!roleVerification) {
	      this.context.router.push('/setup/admin_role');
	    }
	
	    var orgType = roleVerification.is_school ? 'school' : 'district';
	    var dialogTitle = this.state.showEmailInput ? 'What is your official ' + orgType + ' email address?' : 'Is ' + this.state.email + ' your official ' + orgType + ' email address?';
	
	    return _react2.default.createElement(
	      _DialogContent2.default,
	      {
	        size: 'small',
	        className: 'SetupSchoolEmail',
	        title: dialogTitle,
	        subtext: 'Remind verifies the status of every administrator. ' + ('Your email address must match the one listed in your ' + orgType + ' directory.') },
	      this.state.showEmailInput ? this.renderEmailInput() : this.renderEmailConfirm()
	    );
	  }
	});
	
	exports.default = SetupSchoolEmail;

/***/ },
/* 3111 */
1136,
/* 3112 */,
/* 3113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _AuthenticationView = __webpack_require__(1690);
	
	var _AuthenticationView2 = _interopRequireDefault(_AuthenticationView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignOutPage = function (_React$Component) {
	  _inherits(SignOutPage, _React$Component);
	
	  function SignOutPage() {
	    _classCallCheck(this, SignOutPage);
	
	    return _possibleConstructorReturn(this, (SignOutPage.__proto__ || Object.getPrototypeOf(SignOutPage)).apply(this, arguments));
	  }
	
	  _createClass(SignOutPage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _AuthenticationView2.default,
	        _extends({}, this.props, { className: 'SignOutPage' }),
	        _react2.default.createElement(_LoadingIndicator2.default, null)
	      );
	    }
	  }]);
	
	  return SignOutPage;
	}(_react2.default.Component);
	
	SignOutPage.onEnter = function () {
	  _AuthActions2.default.signOut(); // This will redirect after sign out is complete
	};
	
	SignOutPage.displayName = 'SignOutPage';
	exports.default = SignOutPage;

/***/ },
/* 3114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthenticationView = __webpack_require__(1690);
	
	var _AuthenticationView2 = _interopRequireDefault(_AuthenticationView);
	
	var _ShareRemind = __webpack_require__(1715);
	
	var _ShareRemind2 = _interopRequireDefault(_ShareRemind);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShareRemindPage = function (_React$Component) {
	  _inherits(ShareRemindPage, _React$Component);
	
	  function ShareRemindPage() {
	    _classCallCheck(this, ShareRemindPage);
	
	    return _possibleConstructorReturn(this, (ShareRemindPage.__proto__ || Object.getPrototypeOf(ShareRemindPage)).apply(this, arguments));
	  }
	
	  _createClass(ShareRemindPage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _ToastActions2.default.showSuccessToast('Log out successful');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _AuthenticationView2.default,
	        _extends({}, this.props, { className: 'ShareRemindPage' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ShareRemindPage-share' },
	          _react2.default.createElement(_ShareRemind2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return ShareRemindPage;
	}(_react2.default.Component);
	
	ShareRemindPage.displayName = 'ShareRemindPage';
	exports.default = ShareRemindPage;

/***/ },
/* 3115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AuthenticationView = __webpack_require__(1690);
	
	var _AuthenticationView2 = _interopRequireDefault(_AuthenticationView);
	
	var _TextAppLink = __webpack_require__(2164);
	
	var _TextAppLink2 = _interopRequireDefault(_TextAppLink);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextAppLinkPage = function (_React$Component) {
	  _inherits(TextAppLinkPage, _React$Component);
	
	  function TextAppLinkPage() {
	    _classCallCheck(this, TextAppLinkPage);
	
	    return _possibleConstructorReturn(this, (TextAppLinkPage.__proto__ || Object.getPrototypeOf(TextAppLinkPage)).apply(this, arguments));
	  }
	
	  _createClass(TextAppLinkPage, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _AuthenticationView2.default,
	        _extends({}, this.props, { size: 'large', className: 'TextAppLinkPage' }),
	        _react2.default.createElement(_TextAppLink2.default, null)
	      );
	    }
	  }]);
	
	  return TextAppLinkPage;
	}(_react2.default.Component);
	
	TextAppLinkPage.displayName = 'TextAppLinkPage';
	exports.default = TextAppLinkPage;

/***/ },
/* 3116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	var _DialogContent = __webpack_require__(1201);
	
	var _DialogContent2 = _interopRequireDefault(_DialogContent);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TranscriptRequestActions = __webpack_require__(3117);
	
	var _TranscriptRequestActions2 = _interopRequireDefault(_TranscriptRequestActions);
	
	var _i18n = __webpack_require__(1018);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var TranscriptRequestApproveView = function (_React$Component) {
	  _inherits(TranscriptRequestApproveView, _React$Component);
	
	  function TranscriptRequestApproveView() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TranscriptRequestApproveView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TranscriptRequestApproveView.__proto__ || Object.getPrototypeOf(TranscriptRequestApproveView)).call.apply(_ref, [this].concat(args))), _this), _this.state = { transcriptRequest: null, error: null }, _this.token = function () {
	      return _this.props.params.token;
	    }, _this.renderContinueButton = function () {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          className: 'TranscriptRequestApproveView-continue_button',
	          to: '/landing',
	          eventElementName: 'TranscriptRequestApproveView-continue_button' },
	        _i18n2.default.getText('Log in to Remind')
	      );
	    }, _this.renderError = function () {
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          size: 'xsmall',
	          title: _i18n2.default.getText('Message history request'),
	          subtext: _i18n2.default.getText('Message history already shared.'),
	          glyph: 'disabled',
	          glyphColor: 'lava' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _this.renderContinueButton()
	        )
	      );
	    }, _this.renderIncludeAnnouncementHistory = function () {
	      if (!_this.state.transcriptRequest.getInclAnnouncements()) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'li',
	        null,
	        'Announcements for all classes'
	      );
	    }, _this.renderIncludeChats = function () {
	      if (!_this.state.transcriptRequest.getInclChat()) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'li',
	        null,
	        'Chat messages with students'
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TranscriptRequestApproveView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _TranscriptRequestActions2.default.confirm(this.token()).then(function (transcriptRequest) {
	        _this2.setState({ transcriptRequest: transcriptRequest });
	      }).catch(function (error) {
	        _this2.setState({ error: error.message });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.error) {
	        return this.renderError();
	      }
	
	      var transcriptRequest = this.state.transcriptRequest;
	
	      if (!transcriptRequest) {
	        return _react2.default.createElement(_CenteredLoadingIndicator2.default, null);
	      }
	
	      var adminName = transcriptRequest.getRequestorName();
	      return _react2.default.createElement(
	        _DialogContent2.default,
	        {
	          size: 'xsmall',
	          title: _i18n2.default.getText('Message history request'),
	          subtext: _i18n2.default.getText('Your message history has been shared with ' + adminName + '.'),
	          glyph: 'check',
	          glyphColor: 'shamrock' },
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          this.renderContinueButton()
	        )
	      );
	    }
	  }]);
	
	  return TranscriptRequestApproveView;
	}(_react2.default.Component);
	
	TranscriptRequestApproveView.displayName = 'TranscriptRequestApproveView';
	exports.default = TranscriptRequestApproveView;

/***/ },
/* 3117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _apiRequest = __webpack_require__(556);
	
	var _apiRequest2 = _interopRequireDefault(_apiRequest);
	
	var _TranscriptRequest = __webpack_require__(3118);
	
	var _TranscriptRequest2 = _interopRequireDefault(_TranscriptRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TranscriptRequestActions = {
	  confirm: function confirm(token) {
	    return (0, _apiRequest2.default)('/transcript_requests', 'POST', { token: token }).then(function (transcriptRequest) {
	      return _TranscriptRequest2.default.fromJSON(transcriptRequest);
	    });
	  }
	};
	
	exports.default = TranscriptRequestActions;

/***/ },
/* 3118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Entity2 = __webpack_require__(595);
	
	var _Entity3 = _interopRequireDefault(_Entity2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TranscriptRequest = function (_Entity) {
	  _inherits(TranscriptRequest, _Entity);
	
	  function TranscriptRequest() {
	    _classCallCheck(this, TranscriptRequest);
	
	    return _possibleConstructorReturn(this, (TranscriptRequest.__proto__ || Object.getPrototypeOf(TranscriptRequest)).apply(this, arguments));
	  }
	
	  _createClass(TranscriptRequest, [{
	    key: 'getInclAnnouncements',
	    value: function getInclAnnouncements() {
	      return this.get('incl_announcements');
	    }
	  }, {
	    key: 'getInclChat',
	    value: function getInclChat() {
	      return this.get('incl_chat');
	    }
	  }, {
	    key: 'getRequestorName',
	    value: function getRequestorName() {
	      return this.get('requestor_name');
	    }
	  }, {
	    key: 'getNote',
	    value: function getNote() {
	      return this.get('note');
	    }
	  }]);
	
	  return TranscriptRequest;
	}(_Entity3.default);
	
	TranscriptRequest.displayName = 'TranscriptRequest';
	exports.default = TranscriptRequest;

/***/ },
/* 3119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _JoinSignUpForm = __webpack_require__(2793);
	
	var _JoinSignUpForm2 = _interopRequireDefault(_JoinSignUpForm);
	
	var _Heading = __webpack_require__(1436);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _CopyConstants = __webpack_require__(1733);
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Copy = __webpack_require__(1461);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _AuthenticationView = __webpack_require__(1690);
	
	var _AuthenticationView2 = _interopRequireDefault(_AuthenticationView);
	
	var _Columns = __webpack_require__(2165);
	
	var _Columns2 = _interopRequireDefault(_Columns);
	
	var _UserConstants = __webpack_require__(1015);
	
	__webpack_require__(3120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreasurerSignUp = function (_React$Component) {
	  _inherits(TreasurerSignUp, _React$Component);
	
	  function TreasurerSignUp() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TreasurerSignUp);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TreasurerSignUp.__proto__ || Object.getPrototypeOf(TreasurerSignUp)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loading: true
	    }, _this.onUserCreate = function () {
	      _this.context.router.push({
	        pathname: '/activities/treasurer/add_bank_account',
	        query: _this.props.location.query
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TreasurerSignUp, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      // This handle the case where the user clicks the "sign in"
	      // button in the header and is redirected back here.
	      _AuthActions2.default.checkLoggedIn().then(function () {
	        _this2.context.router.push({
	          pathname: '/activities/treasurer/add_bank_account',
	          query: _this2.props.location.query
	        });
	      }, function () {
	        return _this2.setState({ loading: false });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.loading) {
	        return _react2.default.createElement(_CenteredLoadingIndicator2.default, null);
	      }
	
	      return _react2.default.createElement(
	        _AuthenticationView2.default,
	        { size: 'large', className: 'TreasurerSignUp' },
	        _react2.default.createElement(
	          _Columns2.default,
	          { reset: 'tablet' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Container2.default,
	              { size: 'xsmall' },
	              _react2.default.createElement(_Image2.default, {
	                src: __webpack_require__(3122),
	                className: 'TreasurerSignUp-image'
	              }),
	              _react2.default.createElement(
	                _Heading2.default,
	                { align: 'left', level: '2' },
	                _CopyConstants.TreasurerSignUp.title
	              ),
	              _react2.default.createElement(
	                _Copy2.default,
	                { color: 'thunder' },
	                _react2.default.createElement(
	                  'ul',
	                  null,
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _CopyConstants.TreasurerSignUp.h1
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _CopyConstants.TreasurerSignUp.h2
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _CopyConstants.TreasurerSignUp.h3
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Container2.default,
	              { size: 'xsmall' },
	              _react2.default.createElement(_JoinSignUpForm2.default, {
	                onUserCreate: this.onUserCreate,
	                role: _UserConstants.Roles.TEACHER
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TreasurerSignUp;
	}(_react2.default.Component);
	
	TreasurerSignUp.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	TreasurerSignUp.displayName = 'TreasurerSignUp';
	exports.default = TreasurerSignUp;

/***/ },
/* 3120 */
1136,
/* 3121 */,
/* 3122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9df78497d52e24a0297b4247bc101a14.svg";

/***/ },
/* 3123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TreasurerAddBankAccountPage = __webpack_require__(3124);
	
	var _TreasurerAddBankAccountPage2 = _interopRequireDefault(_TreasurerAddBankAccountPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreasurerAddBankAccountRouteHandler = function (_React$Component) {
	  _inherits(TreasurerAddBankAccountRouteHandler, _React$Component);
	
	  function TreasurerAddBankAccountRouteHandler() {
	    _classCallCheck(this, TreasurerAddBankAccountRouteHandler);
	
	    return _possibleConstructorReturn(this, (TreasurerAddBankAccountRouteHandler.__proto__ || Object.getPrototypeOf(TreasurerAddBankAccountRouteHandler)).apply(this, arguments));
	  }
	
	  _createClass(TreasurerAddBankAccountRouteHandler, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_TreasurerAddBankAccountPage2.default, { token: this.context.location.query.access_token });
	    }
	  }]);
	
	  return TreasurerAddBankAccountRouteHandler;
	}(_react2.default.Component);
	
	TreasurerAddBankAccountRouteHandler.contextTypes = {
	  location: _react2.default.PropTypes.object.isRequired
	};
	TreasurerAddBankAccountRouteHandler.displayName = 'TreasurerAddBankAccountRouteHandler';
	exports.default = TreasurerAddBankAccountRouteHandler;

/***/ },
/* 3124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TreasurerAddBankAccountPage = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _TreasurerAddBankAccount = __webpack_require__(2669);
	
	var _TreasurerAddBankAccount2 = _interopRequireDefault(_TreasurerAddBankAccount);
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	var _TreasurerAddBankAccountInterstitial = __webpack_require__(3125);
	
	var _TreasurerAddBankAccountInterstitial2 = _interopRequireDefault(_TreasurerAddBankAccountInterstitial);
	
	var _CenteredContainer = __webpack_require__(2240);
	
	var _CenteredContainer2 = _interopRequireDefault(_CenteredContainer);
	
	var _connectedBankAccountRequest = __webpack_require__(3129);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var TreasurerAddBankAccountPage = function (_React$Component) {
	  _inherits(TreasurerAddBankAccountPage, _React$Component);
	
	  function TreasurerAddBankAccountPage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TreasurerAddBankAccountPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TreasurerAddBankAccountPage.__proto__ || Object.getPrototypeOf(TreasurerAddBankAccountPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      interstitial: true
	    }, _this.onBankAccountAdded = function () {
	      _this.context.router.push('/settings/transactions');
	    }, _this.closeInterstitial = function () {
	      _this.setState({ interstitial: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TreasurerAddBankAccountPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var onAuthenticated = function onAuthenticated() {
	        return _this2.props.load(_this2.props.token);
	      };
	      var onUnauthenticated = function onUnauthenticated() {
	        _this2.context.router.push({
	          pathname: '/activities/treasurer/sign_up',
	          query: _this2.context.location.query
	        });
	      };
	
	      _AuthActions2.default.checkLoggedIn().then(onAuthenticated, onUnauthenticated);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.connectedBankAccountRequest) {
	        return null;
	      }
	
	      var _props$connectedBankA = this.props.connectedBankAccountRequest,
	          error = _props$connectedBankA.error,
	          isLoading = _props$connectedBankA.isLoading,
	          connectedBankAccount = _props$connectedBankA.connectedBankAccount;
	
	
	      if (isLoading) {
	        return _react2.default.createElement(_CenteredLoadingIndicator2.default, null);
	      }
	
	      if (error) {
	        return _react2.default.createElement(
	          _CenteredContainer2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center' } },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _Text2.default,
	                { size: 'large' },
	                'An error happened, the link might have expired.'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { marginTop: 10 } },
	              _react2.default.createElement(
	                _Text2.default,
	                { color: 'lava' },
	                'Error: ',
	                error
	              )
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { to: '/settings/transactions', size: 'xsmall', style: { marginTop: 15 } },
	              'Go to my account'
	            )
	          )
	        );
	      }
	
	      if (this.state.interstitial) {
	        return _react2.default.createElement(_TreasurerAddBankAccountInterstitial2.default, {
	          connectedBankAccount: connectedBankAccount,
	          onAddBankAccount: this.closeInterstitial
	        });
	      }
	
	      return _react2.default.createElement(_TreasurerAddBankAccount2.default, {
	        connectedBankAccount: connectedBankAccount,
	        onBankAccountAdded: this.onBankAccountAdded
	      });
	    }
	  }]);
	
	  return TreasurerAddBankAccountPage;
	}(_react2.default.Component);
	
	TreasurerAddBankAccountPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired,
	  location: _react2.default.PropTypes.object.isRequired
	};
	TreasurerAddBankAccountPage.displayName = 'TreasurerAddBankAccountPage';
	
	
	function mapStateToProps(state, props) {
	  return {
	    connectedBankAccountRequest: state.connectedBankAccountRequest.get(props.token)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  // $FlowIssue
	  return (0, _redux.bindActionCreators)({ load: _connectedBankAccountRequest.load }, dispatch);
	}
	
	exports.TreasurerAddBankAccountPage = TreasurerAddBankAccountPage;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TreasurerAddBankAccountPage);

/***/ },
/* 3125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CenteredContainer = __webpack_require__(2240);
	
	var _CenteredContainer2 = _interopRequireDefault(_CenteredContainer);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _Copy = __webpack_require__(1461);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _Divider = __webpack_require__(1330);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _EducationMediaObject = __webpack_require__(1734);
	
	var _EducationMediaObject2 = _interopRequireDefault(_EducationMediaObject);
	
	var _EventTrackingConstants = __webpack_require__(1745);
	
	var _EventTrackingConstants2 = _interopRequireDefault(_EventTrackingConstants);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(3126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreasurerAddBankAccountInterstitial = function (_React$Component) {
	  _inherits(TreasurerAddBankAccountInterstitial, _React$Component);
	
	  function TreasurerAddBankAccountInterstitial() {
	    _classCallCheck(this, TreasurerAddBankAccountInterstitial);
	
	    return _possibleConstructorReturn(this, (TreasurerAddBankAccountInterstitial.__proto__ || Object.getPrototypeOf(TreasurerAddBankAccountInterstitial)).apply(this, arguments));
	  }
	
	  _createClass(TreasurerAddBankAccountInterstitial, [{
	    key: 'renderCopy',
	    value: function renderCopy() {
	      var connectedBankAccount = this.props.connectedBankAccount;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Text2.default,
	          { element: 'h2', size: 'xlarge', className: 'TreasurerSignInInterstitial-title' },
	          'A safe, simple way to collect and manage funds for your school.'
	        ),
	        _react2.default.createElement(_EducationMediaObject2.default, {
	          className: 'TreasurerSignInInterstitial-media',
	          image: __webpack_require__(1739),
	          title: 'No more cash or checks',
	          text: 'Parents and students can send money directly to your school so teachers don\u2019t\n            need to manage funds.'
	        }),
	        _react2.default.createElement(_EducationMediaObject2.default, {
	          className: 'TreasurerSignInInterstitial-media',
	          image: __webpack_require__(1740),
	          title: 'Effortless deposits',
	          text: 'Authorize ' + connectedBankAccount.getConnectedUserName() + ' to deposit money to your\n            school\'s bank account\u2014without sharing any account information.'
	        }),
	        _react2.default.createElement(_EducationMediaObject2.default, {
	          className: 'TreasurerSignInInterstitial-media',
	          image: __webpack_require__(3128),
	          title: 'Safety and security',
	          text: 'Remind partners with bank-level payment solutions to ensure that everyone\u2019s\n            information is secure and protected.'
	        })
	      );
	    }
	  }, {
	    key: 'renderNote',
	    value: function renderNote() {
	      var connectedBankAccount = this.props.connectedBankAccount;
	
	      var note = connectedBankAccount && connectedBankAccount.getNote() ? connectedBankAccount.getNote() : '"I\'m using Remind to organize my class activities. I\'d love for you to see my event details\n      and monitor all funds collected. With your approval, I can also deposit directly\n      into any bank account you chose. Thanks!"';
	      return _react2.default.createElement(
	        'blockquote',
	        { className: 'TreasurerSignInInterstitial-note' },
	        _react2.default.createElement(
	          _Copy2.default,
	          { center: true },
	          _react2.default.createElement(
	            _Text2.default,
	            { element: 'p', lineHeight: 'large', size: 'small' },
	            '\u201C',
	            note,
	            '\u201D'
	          ),
	          _react2.default.createElement(
	            'cite',
	            null,
	            _react2.default.createElement(
	              _Text2.default,
	              { weight: 'semibold', element: 'div' },
	              connectedBankAccount.getConnectedUserName()
	            ),
	            _react2.default.createElement(
	              _Text2.default,
	              { italic: true, element: 'div' },
	              connectedBankAccount.getOrganizationName()
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var continueEventName = 'continue';
	      var skipEventName = 'skip';
	      var eventContextName = this.context.eventContextName;
	
	
	      return _react2.default.createElement(
	        _CenteredContainer2.default,
	        { className: 'TreasurerSignInInterstitial', size: 'small' },
	        this.renderNote(),
	        _react2.default.createElement(
	          'div',
	          { className: 'TreasurerSignInInterstitial-action' },
	          _react2.default.createElement(
	            'div',
	            { className: 'TreasurerSignInInterstitial-action-button' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                eventScreenName: this.props.eventScreenName,
	                eventElementName: continueEventName,
	                eventContextName: eventContextName,
	                onClick: this.props.onAddBankAccount },
	              'Continue'
	            )
	          )
	        ),
	        _react2.default.createElement(_Divider2.default, { size: 'small' }),
	        this.renderCopy(),
	        _react2.default.createElement(_Divider2.default, { size: 'small' }),
	        _react2.default.createElement(
	          'footer',
	          { className: 'TreasurerSignInInterstitial-action' },
	          _react2.default.createElement(
	            'div',
	            { className: 'TreasurerSignInInterstitial-action-button' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                element: 'div',
	                color: 'brand',
	                weight: 'semibold',
	                level: 'text',
	                eventScreenName: this.props.eventScreenName,
	                eventElementName: continueEventName,
	                eventContextName: eventContextName,
	                onClick: this.props.onAddBankAccount },
	              'Continue'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _Link2.default,
	                {
	                  eventScreenName: this.props.eventScreenName,
	                  eventElementName: skipEventName,
	                  eventContextName: eventContextName,
	                  href: '/settings/transactions',
	                  weight: 'semibold' },
	                'Skip for now'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TreasurerAddBankAccountInterstitial;
	}(_react2.default.Component);
	
	TreasurerAddBankAccountInterstitial.contextTypes = {
	  eventContextName: _react.PropTypes.string
	};
	TreasurerAddBankAccountInterstitial.defaultProps = {
	  eventScreenName: _EventTrackingConstants2.default.TREASURER_INTERSTITIAL
	};
	TreasurerAddBankAccountInterstitial.displayName = 'TreasurerAddBankAccountInterstitial';
	exports.default = TreasurerAddBankAccountInterstitial;

/***/ },
/* 3126 */
1136,
/* 3127 */,
/* 3128 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNCAzNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMzQgMzQiPjxwYXRoIGZpbGw9IiMzOGI4OGQiIGQ9Im0yOC4xIDEyLjFoLTMuOHYtNC4zYzAtNC0zLjQtNy4yLTcuNi03LjItNC4yIDAtNy42IDMuMi03LjYgNy4ydjQuM2gtMy44Yy0uOSAwLTEuNi42LTEuNiAxLjR2MTcuM2MwIDEuMyA1LjggMi40IDEzIDIuNCA3LjIgMCAxMy0xLjEgMTMtMi40di0xNy4yYy4xLS44LS43LTEuNS0xLjYtMS41bS0xOC00LjNjMC0zLjQgMy02LjIgNi42LTYuMnM2LjYgMi44IDYuNiA2LjJ2NC4zaC0xMy4ydi00LjNtMTguNyAyMi45Yy0uOC42LTQuOSAxLjYtMTIgMS42LTcuMSAwLTExLjMtMS0xMi0xLjZ2LTE3LjFjMC0uMi4zLS40LjYtLjRoMjIuOGMuNCAwIC42LjIuNi40djE3LjEiLz48cGF0aCBmaWxsPSIjMzhiODhkIiBkPSJtMTguMyAyMC4xYzAtLjktLjctMS42LTEuNi0xLjYtLjkgMC0xLjYuNy0xLjYgMS42IDAgLjYuMyAxIC43IDEuM2wtLjQgMy45YzAgLjMuMi42LjYuNmgxLjJjLjQgMCAuNi0uMy42LS42bC0uNC0zLjljLjYtLjMuOS0uOC45LTEuMyIvPjwvc3ZnPg=="

/***/ },
/* 3129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = reducer;
	exports.load = load;
	exports.loadSuccess = loadSuccess;
	exports.loadError = loadError;
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	var _immutable = __webpack_require__(949);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = new _immutable.Map();
	
	// typecheck: ignore statement
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'connectedBankAccountRequest/LOAD_REQUEST':
	      return state.set(action.token, { isLoading: true });
	    case 'connectedBankAccountRequest/LOAD_SUCCESS':
	      return state.set(action.token, { connectedBankAccount: action.connectedBankAccount });
	    case 'connectedBankAccountRequest/LOAD_ERROR':
	      return state.set(action.token, { error: action.error });
	    default:
	      return state;
	  }
	}
	
	function load(token) {
	  return {
	    type: 'connectedBankAccountRequest/LOAD_REQUEST',
	    token: token
	  };
	}
	
	function loadSuccess(token, connectedBankAccount) {
	  return {
	    type: 'connectedBankAccountRequest/LOAD_SUCCESS',
	    connectedBankAccount: connectedBankAccount,
	    token: token
	  };
	}
	
	function loadError(token, error) {
	  return {
	    type: 'connectedBankAccountRequest/LOAD_ERROR',
	    error: error,
	    token: token
	  };
	}

/***/ },
/* 3130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AuthActions = __webpack_require__(837);
	
	var _AuthActions2 = _interopRequireDefault(_AuthActions);
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreasurerLandingPage = function (_React$Component) {
	  _inherits(TreasurerLandingPage, _React$Component);
	
	  function TreasurerLandingPage() {
	    _classCallCheck(this, TreasurerLandingPage);
	
	    return _possibleConstructorReturn(this, (TreasurerLandingPage.__proto__ || Object.getPrototypeOf(TreasurerLandingPage)).apply(this, arguments));
	  }
	
	  _createClass(TreasurerLandingPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      _AuthActions2.default.checkLoggedIn().then(function () {
	        _this2.context.router.push({
	          pathname: '/activities/treasurer/add_bank_account',
	          query: _this2.props.location.query
	        });
	      }, function () {
	        _this2.context.router.push({
	          pathname: '/activities/treasurer/sign_up',
	          query: _this2.props.location.query
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_CenteredLoadingIndicator2.default, null);
	    }
	  }]);
	
	  return TreasurerLandingPage;
	}(_react2.default.Component);
	
	TreasurerLandingPage.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	TreasurerLandingPage.displayName = 'TreasurerLandingPage';
	exports.default = TreasurerLandingPage;

/***/ },
/* 3131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UnauthenticatedView = __webpack_require__(1691);
	
	var _UnauthenticatedView2 = _interopRequireDefault(_UnauthenticatedView);
	
	var _Box = __webpack_require__(1202);
	
	var _Box2 = _interopRequireDefault(_Box);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _AppDownloadImageLinks = __webpack_require__(2170);
	
	var _AppDownloadImageLinks2 = _interopRequireDefault(_AppDownloadImageLinks);
	
	var _Image = __webpack_require__(1090);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(3132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TymkThanksView = function (_React$Component) {
	  _inherits(TymkThanksView, _React$Component);
	
	  function TymkThanksView() {
	    _classCallCheck(this, TymkThanksView);
	
	    return _possibleConstructorReturn(this, (TymkThanksView.__proto__ || Object.getPrototypeOf(TymkThanksView)).apply(this, arguments));
	  }
	
	  _createClass(TymkThanksView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _UnauthenticatedView2.default,
	        this.props,
	        _react2.default.createElement(
	          _Container2.default,
	          { size: 'small', className: 'TymkThanksView' },
	          _react2.default.createElement(
	            _Box2.default,
	            null,
	            _react2.default.createElement(
	              _BoxHeader2.default,
	              {
	                className: 'TymkThanksView-header',
	                title: 'Want to get even more out of Remind?' },
	              _react2.default.createElement(
	                _Text2.default,
	                { className: 'TymkThanksView-subtext', color: 'thunder' },
	                'Download the app on your phone or tablet!'
	              )
	            ),
	            _react2.default.createElement(
	              _BoxBody2.default,
	              null,
	              _react2.default.createElement(_AppDownloadImageLinks2.default, { className: 'TymkThanksView-downloadImages' }),
	              _react2.default.createElement(_Image2.default, { src: __webpack_require__(3134) })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TymkThanksView;
	}(_react2.default.Component);
	
	TymkThanksView.displayName = 'TymkThanksView';
	exports.default = TymkThanksView;

/***/ },
/* 3132 */
1136,
/* 3133 */,
/* 3134 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b7b6f688344e63a647c4e588e7c140fe.jpg";

/***/ },
/* 3135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ActivityDetailContainer = __webpack_require__(3136);
	
	var _ActivityDetailContainer2 = _interopRequireDefault(_ActivityDetailContainer);
	
	var _chainOnEnter = __webpack_require__(2585);
	
	var _chainOnEnter2 = _interopRequireDefault(_chainOnEnter);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	__webpack_require__(3184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActivityDetailView = _react2.default.createClass({
	  displayName: 'ActivityDetailView',
	
	
	  mixins: [(0, _chainOnEnter2.default)([_RequireUser2.default])],
	
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'ActivityDetailView' },
	      _react2.default.createElement(_ActivityDetailContainer2.default, { activityId: this.props.params.id })
	    );
	  }
	});
	exports.default = ActivityDetailView;

/***/ },
/* 3136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _ActivityDetail = __webpack_require__(3137);
	
	var _ActivityDetail2 = _interopRequireDefault(_ActivityDetail);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityDetailContainer = function (_Component) {
	  _inherits(ActivityDetailContainer, _Component);
	
	  function ActivityDetailContainer() {
	    _classCallCheck(this, ActivityDetailContainer);
	
	    return _possibleConstructorReturn(this, (ActivityDetailContainer.__proto__ || Object.getPrototypeOf(ActivityDetailContainer)).apply(this, arguments));
	  }
	
	  _createClass(ActivityDetailContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // always refresh activities, cause we dont have any push event.
	      _ActivityActions2.default.loadByUuid(this.props.activityId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.state.activity) {
	        return null;
	      }
	
	      return _react2.default.createElement(_ActivityDetail2.default, { activity: this.state.activity });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ActivityStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(_, props) {
	      return {
	        activity: _ActivityStore2.default.getActivityById(props.activityId)
	      };
	    }
	  }]);
	
	  return ActivityDetailContainer;
	}(_react.Component);
	
	ActivityDetailContainer.displayName = 'ActivityDetailContainer';
	exports.default = _utils.Container.create(ActivityDetailContainer, { withProps: true });

/***/ },
/* 3137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityDetailHeader = __webpack_require__(3138);
	
	var _ActivityDetailHeader2 = _interopRequireDefault(_ActivityDetailHeader);
	
	var _ActivityResponsesTableContainer = __webpack_require__(3141);
	
	var _ActivityResponsesTableContainer2 = _interopRequireDefault(_ActivityResponsesTableContainer);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ActivitiesActionsLayer = __webpack_require__(3156);
	
	var _ActivitiesActionsLayer2 = _interopRequireDefault(_ActivitiesActionsLayer);
	
	var _ActivityShareModal = __webpack_require__(2261);
	
	var _ActivityShareModal2 = _interopRequireDefault(_ActivityShareModal);
	
	var _ActivityEditModal = __webpack_require__(3157);
	
	var _ActivityEditModal2 = _interopRequireDefault(_ActivityEditModal);
	
	var _ActivityTransactionsModalContainer = __webpack_require__(3161);
	
	var _ActivityTransactionsModalContainer2 = _interopRequireDefault(_ActivityTransactionsModalContainer);
	
	var _ActivityAddParticipantContainer = __webpack_require__(3181);
	
	var _ActivityAddParticipantContainer2 = _interopRequireDefault(_ActivityAddParticipantContainer);
	
	__webpack_require__(3182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityDetail = function (_React$Component) {
	  _inherits(ActivityDetail, _React$Component);
	
	  function ActivityDetail() {
	    _classCallCheck(this, ActivityDetail);
	
	    return _possibleConstructorReturn(this, (ActivityDetail.__proto__ || Object.getPrototypeOf(ActivityDetail)).apply(this, arguments));
	  }
	
	  _createClass(ActivityDetail, [{
	    key: 'renderSubHeader',
	    value: function renderSubHeader() {
	      var shareModal = _react2.default.createElement(_ActivityShareModal2.default, { activity: this.props.activity });
	      var editModal = _react2.default.createElement(_ActivityEditModal2.default, { activity: this.props.activity });
	      var transactionsModal = _react2.default.createElement(_ActivityTransactionsModalContainer2.default, { activityID: this.props.activity.id });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityDetail-subheader' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityDetail-subheader-info' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'ActivityDetail-subheader-title' },
	              this.props.activity.getTitle()
	            ),
	            this.props.activity.isClosed() && _react2.default.createElement(
	              'span',
	              { className: 'ActivityDetail-closed' },
	              'Activity is closed'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityDetail-subheader-actions' },
	          !this.props.activity.isClosed() && _react2.default.createElement(
	            _ActivityAddParticipantContainer2.default,
	            { activity: this.props.activity },
	            function (disabled) {
	              return _react2.default.createElement(
	                _Button2.default,
	                {
	                  level: 'secondary',
	                  disabled: disabled,
	                  size: 'xsmall' },
	                'Add people'
	              );
	            }
	          ),
	          !this.props.activity.isClosed() && _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: shareModal },
	            _react2.default.createElement(
	              _Button2.default,
	              { level: 'secondary', size: 'xsmall' },
	              'Share'
	            )
	          ),
	          !this.props.activity.isClosed() && _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: editModal },
	            _react2.default.createElement(
	              _Button2.default,
	              { level: 'secondary', size: 'xsmall' },
	              'Details'
	            )
	          ),
	          this.props.activity.isOrHasCollectedMoneyOnline() && _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: transactionsModal },
	            _react2.default.createElement(
	              _Button2.default,
	              { level: 'secondary', size: 'xsmall' },
	              'Transactions'
	            )
	          ),
	          !this.props.activity.isClosed() && _react2.default.createElement(
	            _ActivitiesActionsLayer2.default,
	            { activity: this.props.activity },
	            _react2.default.createElement(
	              _Button2.default,
	              { level: 'secondary', size: 'xsmall' },
	              _react2.default.createElement(_Glyph2.default, { name: 'ellipses', solo: true })
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activity = _props.activity,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ActivityDetail', className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityDetail-header' },
	          _react2.default.createElement(_ActivityDetailHeader2.default, { activity: activity })
	        ),
	        this.renderSubHeader(),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityDetail-body' },
	          _react2.default.createElement(_ActivityResponsesTableContainer2.default, { activity: activity })
	        )
	      );
	    }
	  }]);
	
	  return ActivityDetail;
	}(_react2.default.Component);
	
	ActivityDetail.displayName = 'ActivityDetail';
	exports.default = ActivityDetail;

/***/ },
/* 3138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	__webpack_require__(3139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityDetailHeader = function (_Component) {
	  _inherits(ActivityDetailHeader, _Component);
	
	  function ActivityDetailHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityDetailHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityDetailHeader.__proto__ || Object.getPrototypeOf(ActivityDetailHeader)).call.apply(_ref, [this].concat(args))), _this), _this.onClose = function () {
	      if (window.history && window.history.length > 1) {
	        window.history.back();
	      } else {
	        _this.context.router.push('/campaigns');
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityDetailHeader, [{
	    key: 'renderBack',
	    value: function renderBack() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityDetailHeader-back', onClick: this.onClose },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            { level: 'icon' },
	            _react2.default.createElement(_Glyph2.default, { name: 'close-btn', size: 'large', solo: true })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityDetailHeader-back-text' },
	          'close'
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cover = this.props.activity.getCover();
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ActivityDetailHeader', this.props.className), style: { backgroundColor: cover.color } },
	        _react2.default.createElement('div', { className: 'ActivityDetailHeader-img', style: { backgroundImage: 'url(' + cover.image + ')' } }),
	        this.renderBack()
	      );
	    }
	  }]);
	
	  return ActivityDetailHeader;
	}(_react.Component);
	
	ActivityDetailHeader.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ActivityDetailHeader.displayName = 'ActivityDetailHeader';
	exports.default = ActivityDetailHeader;

/***/ },
/* 3139 */
1136,
/* 3140 */,
/* 3141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _activityRecipients = __webpack_require__(2238);
	
	var actions = _interopRequireWildcard(_activityRecipients);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityResponsesTable = __webpack_require__(3142);
	
	var _ActivityResponsesTable2 = _interopRequireDefault(_ActivityResponsesTable);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RecipientsNux = __webpack_require__(3152);
	
	var _RecipientsNux2 = _interopRequireDefault(_RecipientsNux);
	
	var _WalletTabLoader = __webpack_require__(2687);
	
	var _WalletTabLoader2 = _interopRequireDefault(_WalletTabLoader);
	
	var _ActivityRecipients = __webpack_require__(910);
	
	var _ActivityRecipients2 = _interopRequireDefault(_ActivityRecipients);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityResponsesTableContainer = function (_Component) {
	  _inherits(ActivityResponsesTableContainer, _Component);
	
	  function ActivityResponsesTableContainer() {
	    _classCallCheck(this, ActivityResponsesTableContainer);
	
	    return _possibleConstructorReturn(this, (ActivityResponsesTableContainer.__proto__ || Object.getPrototypeOf(ActivityResponsesTableContainer)).apply(this, arguments));
	  }
	
	  _createClass(ActivityResponsesTableContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // force update on each mount.
	      if (this.props.loadActivityRecipients) {
	        this.props.loadActivityRecipients(this.props.activity.id);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var alreadyLoaded = !!this.props.recipients;
	      if (this.props.loading && !alreadyLoaded || !this.props.recipients) {
	        return _react2.default.createElement(_WalletTabLoader2.default, null);
	      }
	
	      if (this.props.recipients.length === 0) {
	        return _react2.default.createElement(_RecipientsNux2.default, { activity: this.props.activity });
	      }
	
	      var sort = this.context.router.location.query.sort;
	
	      return _react2.default.createElement(_ActivityResponsesTable2.default, {
	        activity: this.props.activity,
	        recipients: this.props.recipients,
	        initialSort: sort
	      });
	    }
	  }]);
	
	  return ActivityResponsesTableContainer;
	}(_react.Component);
	
	ActivityResponsesTableContainer.contextTypes = {
	  router: _react.PropTypes.object.isRequired
	};
	ActivityResponsesTableContainer.defaultProps = {
	  loading: false
	};
	ActivityResponsesTableContainer.displayName = 'ActivityResponsesTableContainer';
	
	
	function mapStateToProps(state, props) {
	  var activity = state.activityRecipients.activities[props.activity.id] || {};
	  return {
	    loading: activity.loadingRecipients,
	    recipients: activity.recipients
	  };
	}
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch
	// $FlowIssue
	) {
	  return (0, _redux.bindActionCreators)({
	    loadActivityRecipients: actions.loadActivityRecipients
	  }, dispatch);
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ActivityResponsesTableContainer);

/***/ },
/* 3142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ActivityResponsesTable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _activityRecipients = __webpack_require__(2238);
	
	var actions = _interopRequireWildcard(_activityRecipients);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _ActivityRecipients = __webpack_require__(910);
	
	var _ActivityRecipients2 = _interopRequireDefault(_ActivityRecipients);
	
	var _ActivityResponsesTableRow = __webpack_require__(3143);
	
	var _ActivityResponsesTableRow2 = _interopRequireDefault(_ActivityResponsesTableRow);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _ActivityShareModal = __webpack_require__(2261);
	
	var _ActivityShareModal2 = _interopRequireDefault(_ActivityShareModal);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	var _Tabs = __webpack_require__(1539);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	__webpack_require__(3150);
	
	__webpack_require__(2950);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line
	// eslint-disable-line
	
	
	// eslint-disable-line
	
	var attendanceToTabLabel = {
	  default: 'Invited',
	  yes: 'Attending',
	  maybe: 'Maybe',
	  no: 'Declined',
	  pending: 'Pending'
	};
	
	var selectedSortToTabNumber = {
	  default: 0,
	  yes: 1,
	  maybe: 2,
	  no: 3,
	  pending: 4
	};
	
	var ActivityResponsesTable = exports.ActivityResponsesTable = function (_Component) {
	  _inherits(ActivityResponsesTable, _Component);
	
	  function ActivityResponsesTable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityResponsesTable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityResponsesTable.__proto__ || Object.getPrototypeOf(ActivityResponsesTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedSort: _this.props.initialSort || 'default'
	    }, _this.onTabChange = function (index) {
	      var tabNumberToSelectedSort = ['default', 'yes', 'maybe', 'no', 'pending'];
	      _this.setState({ selectedSort: tabNumberToSelectedSort[index] });
	    }, _this.handleNoteEdit = function (recipient, note) {
	      return _this.props.patchActivityRecipient(_this.props.activity.id, recipient.id, {
	        note: note
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityResponsesTable, [{
	    key: 'renderRecipient',
	    value: function renderRecipient(recipient) {
	      var displayPaidRow = this.props.activity.isOrHasCollectedMoneyOnline();
	
	      return _react2.default.createElement(_ActivityResponsesTableRow2.default, {
	        recipient: recipient,
	        key: recipient.id,
	        displayPaidRow: displayPaidRow,
	        onNoteEdit: this.handleNoteEdit
	      });
	    }
	  }, {
	    key: 'renderTableNux',
	    value: function renderTableNux() {
	      var title = 'No ' + attendanceToTabLabel[this.state.selectedSort] + ' Participants';
	      var subheader = 'Make sure everyone knows about your activity';
	      var shareModal = _react2.default.createElement(_ActivityShareModal2.default, { activity: this.props.activity });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityResponsesTable-nux' },
	        _react2.default.createElement(
	          'table',
	          { className: 'ActivityTable' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                null,
	                'Guest'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Note'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Response'
	              ),
	              _react2.default.createElement(
	                'th',
	                null,
	                'Paid'
	              ),
	              _react2.default.createElement('th', null)
	            )
	          ),
	          _react2.default.createElement('tbody', null)
	        ),
	        _react2.default.createElement(
	          _TitleHeader2.default,
	          {
	            className: 'ActivityResponsesTable-nux-text',
	            title: title,
	            subtext: subheader },
	          _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: shareModal },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                className: 'ActivityResponsesTable-nux-button',
	                eventElementName: 'ActivityResponsesTable-nux-button' },
	              'Invite People'
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderTable',
	    value: function renderTable() {
	      var _this2 = this;
	
	      var recipients = this.props.recipients;
	
	      if (this.state.selectedSort !== 'default') {
	        recipients = this.props.recipients.filter(function (recipient) {
	          return recipient.getAttendance() === _this2.state.selectedSort;
	        });
	      }
	
	      if (recipients.length === 0) {
	        return this.renderTableNux();
	      }
	
	      return _react2.default.createElement(
	        'table',
	        { className: 'ActivityTable' },
	        _react2.default.createElement(
	          'thead',
	          null,
	          _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	              'th',
	              null,
	              'Name'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Note'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              'Response'
	            ),
	            _react2.default.createElement(
	              'th',
	              null,
	              this.props.activity.isOrHasCollectedMoneyOnline() && 'Paid'
	            ),
	            _react2.default.createElement('th', null)
	          )
	        ),
	        _react2.default.createElement(
	          'tbody',
	          null,
	          recipients.map(function (recipient) {
	            return _this2.renderRecipient(recipient);
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var summary = this.props.activity.getRecipientSummary();
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ActivityResponsesTable', this.props.className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityResponsesTable-tabs' },
	          _react2.default.createElement(
	            _Tabs2.default,
	            {
	              tabActive: selectedSortToTabNumber[this.state.selectedSort],
	              orientation: 'vertical',
	              size: 'xsmall',
	              type: 'bar',
	              onTabChange: this.onTabChange },
	            _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	                'span',
	                null,
	                'Invited (',
	                summary.getInvitedCount(),
	                ')'
	              ) }),
	            _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	                'span',
	                null,
	                'Yes (',
	                summary.getAttendingCount(),
	                ')'
	              ) }),
	            _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	                'span',
	                null,
	                'Maybe (',
	                summary.getMaybeCount(),
	                ') '
	              ) }),
	            _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	                'span',
	                null,
	                'No (',
	                summary.getNotAttendingCount(),
	                ')'
	              ) }),
	            _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	                'span',
	                null,
	                'Not Responded (',
	                summary.getNotRespondingCount(),
	                ')'
	              ) })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'ActivityResponsesTable-tabsPanels' },
	          this.renderTable()
	        )
	      );
	    }
	  }]);
	
	  return ActivityResponsesTable;
	}(_react.Component);
	
	ActivityResponsesTable.displayName = 'ActivityResponsesTable';
	
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({
	    patchActivityRecipient: actions.patchActivityRecipient
	  }, dispatch);
	}
	
	// $FlowIssue
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(ActivityResponsesTable);

/***/ },
/* 3143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActivityNotesFieldColumn = __webpack_require__(3144);
	
	var _ActivityNotesFieldColumn2 = _interopRequireDefault(_ActivityNotesFieldColumn);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _TableRowUserName = __webpack_require__(2945);
	
	var _TableRowUserName2 = _interopRequireDefault(_TableRowUserName);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(2950);
	
	__webpack_require__(3147);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _ConversationStarter = __webpack_require__(3149);
	
	var _ConversationStarter2 = _interopRequireDefault(_ConversationStarter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getAttendanceText(value) {
	  var _RECIPIENT_ATTENDING$;
	
	  return (_RECIPIENT_ATTENDING$ = {}, _defineProperty(_RECIPIENT_ATTENDING$, _ActivityRecipient.RECIPIENT_ATTENDING, 'Yes'), _defineProperty(_RECIPIENT_ATTENDING$, _ActivityRecipient.RECIPIENT_DECLINED, 'No'), _defineProperty(_RECIPIENT_ATTENDING$, _ActivityRecipient.RECIPIENT_PENDING, ''), _defineProperty(_RECIPIENT_ATTENDING$, _ActivityRecipient.RECIPIENT_MAYBE, 'Maybe'), _RECIPIENT_ATTENDING$)[value];
	}
	
	var ActivityResponsesTableRow = function (_React$Component) {
	  _inherits(ActivityResponsesTableRow, _React$Component);
	
	  function ActivityResponsesTableRow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityResponsesTableRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityResponsesTableRow.__proto__ || Object.getPrototypeOf(ActivityResponsesTableRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      note: _this.props.recipient.getNote(),
	      editNote: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityResponsesTableRow, [{
	    key: 'handleNoteChange',
	    value: function handleNoteChange(value) {
	      this.setState({ note: value });
	    }
	  }, {
	    key: 'handleEditNoteClick',
	    value: function handleEditNoteClick() {
	      this.setState({ editNote: true });
	    }
	  }, {
	    key: 'handleNoteSave',
	    value: function handleNoteSave(value) {
	      this.handleNoteChange(value);
	      this.setState({ editNote: false });
	      this.props.onNoteEdit(this.props.recipient, value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var recipient = this.props.recipient;
	
	      var user = recipient.getUser();
	
	      return _react2.default.createElement(
	        'tr',
	        { className: 'ActivityTable-row ActivityResponsesTableRow', key: recipient.id },
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_TableRowUserName2.default, { user: recipient.getUser() })
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'ActivityTable-row-noteColumn' },
	          _react2.default.createElement(_ActivityNotesFieldColumn2.default, {
	            onClick: function onClick() {
	              return _this2.handleEditNoteClick();
	            },
	            onInputSave: function onInputSave(value) {
	              return _this2.handleNoteSave(value);
	            },
	            onChange: function onChange(value) {
	              return _this2.handleNoteChange(value);
	            },
	            initialValue: this.state.note,
	            editMode: this.state.editNote
	          })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(
	            _Text2.default,
	            { color: recipient.getAttendance() === _ActivityRecipient.RECIPIENT_PENDING ? 'thunder' : undefined },
	            getAttendanceText(recipient.getAttendance()) || _react2.default.createElement(
	              'span',
	              null,
	              '-'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          this.props.displayPaidRow && _react2.default.createElement(
	            'span',
	            null,
	            this.props.recipient.hasPaid() ? _react2.default.createElement(_Glyph2.default, { name: 'check', size: 'medium' }) : _react2.default.createElement(
	              'span',
	              null,
	              '-'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'ActivityResponsesTableRow-action-column' },
	          user && _react2.default.createElement(_ConversationStarter2.default, { user: user })
	        )
	      );
	    }
	  }]);
	
	  return ActivityResponsesTableRow;
	}(_react2.default.Component);
	
	ActivityResponsesTableRow.displayName = 'ActivityResponsesTableRow';
	exports.default = ActivityResponsesTableRow;

/***/ },
/* 3144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Textarea = __webpack_require__(1598);
	
	var _Textarea2 = _interopRequireDefault(_Textarea);
	
	var _KeyConstants = __webpack_require__(1164);
	
	var _KeyConstants2 = _interopRequireDefault(_KeyConstants);
	
	__webpack_require__(3145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  weak */
	
	
	var ActivityNotesFieldColumn = function (_React$Component) {
	  _inherits(ActivityNotesFieldColumn, _React$Component);
	
	  function ActivityNotesFieldColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityNotesFieldColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityNotesFieldColumn.__proto__ || Object.getPrototypeOf(ActivityNotesFieldColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleKeyPress = function (event) {
	      if (event.keyCode === _KeyConstants2.default.ENTER) {
	        _this.props.onInputSave(event.currentTarget.value);
	        _this.setState({ hover: false });
	      }
	    }, _this.handleMouseOver = function () {
	      _this.setState({ hover: true });
	    }, _this.handleMouseOut = function () {
	      _this.setState({ hover: false });
	    }, _this.onChange = function (event) {
	      _this.props.onChange(event.currentTarget.value);
	    }, _this.onBlur = function (event) {
	      _this.props.onInputSave(event.currentTarget.value);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityNotesFieldColumn, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'ActivityNotesFieldColumn',
	          onClick: this.props.onClick,
	          onMouseEnter: this.handleMouseOver,
	          onMouseLeave: this.handleMouseOut },
	        _react2.default.createElement(_Textarea2.default, {
	          autogrow: true,
	          rows: 1,
	          className: 'ActivityNotesFieldColumn-input',
	          placeholder: 'Add a note',
	          value: this.props.initialValue,
	          onChange: this.onChange,
	          onBlur: this.onBlur,
	          onKeyDown: this.handleKeyPress
	        })
	      );
	    }
	  }]);
	
	  return ActivityNotesFieldColumn;
	}(_react2.default.Component);
	
	ActivityNotesFieldColumn.defaultProps = {
	  onClick: function onClick() {},
	  onInputBlur: function onInputBlur() {},
	  onChange: function onChange() {},
	  initialValue: '',
	  editMode: false
	};
	ActivityNotesFieldColumn.displayName = 'ActivityNotesFieldColumn';
	exports.default = ActivityNotesFieldColumn;

/***/ },
/* 3145 */
1136,
/* 3146 */,
/* 3147 */
1136,
/* 3148 */,
/* 3149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ChatPromises = __webpack_require__(1569);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RelatedUserSummary = __webpack_require__(909);
	
	var _RelatedUserSummary2 = _interopRequireDefault(_RelatedUserSummary);
	
	var _Relationship = __webpack_require__(1007);
	
	var _Relationship2 = _interopRequireDefault(_Relationship);
	
	var _Tooltip = __webpack_require__(1157);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConversationStarter = function (_React$Component) {
	  _inherits(ConversationStarter, _React$Component);
	
	  function ConversationStarter() {
	    _classCallCheck(this, ConversationStarter);
	
	    return _possibleConstructorReturn(this, (ConversationStarter.__proto__ || Object.getPrototypeOf(ConversationStarter)).apply(this, arguments));
	  }
	
	  _createClass(ConversationStarter, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var user = this.props.user;
	
	      var newConversationPath = '/classes/r/messages/new';
	
	      var tooltip = _react2.default.createElement(
	        _Tooltip2.default,
	        null,
	        'Message attendee'
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ConversationStarter' },
	        _react2.default.createElement(
	          _Button2.default,
	          {
	            onClick: function onClick() {
	              (0, _ChatPromises.promiseRelationship)(user).then(function (relationship) {
	                _this2.context.router.push({
	                  pathname: newConversationPath + '/' + relationship.id
	                });
	              });
	            },
	            level: 'icon' },
	          _react2.default.createElement(
	            _LayerTrigger2.default,
	            { placement: 'bottom', layer: tooltip },
	            _react2.default.createElement(_Glyph2.default, { name: 'chat-add-bubble', color: 'brand', size: 'large', solo: true })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ConversationStarter;
	}(_react2.default.Component);
	
	ConversationStarter.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ConversationStarter.displayName = 'ConversationStarter';
	exports.default = ConversationStarter;

/***/ },
/* 3150 */
1136,
/* 3151 */,
/* 3152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ActivityShareModal = __webpack_require__(2261);
	
	var _ActivityShareModal2 = _interopRequireDefault(_ActivityShareModal);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	__webpack_require__(3153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RecipientsNux = function (_React$Component) {
	  _inherits(RecipientsNux, _React$Component);
	
	  function RecipientsNux() {
	    _classCallCheck(this, RecipientsNux);
	
	    return _possibleConstructorReturn(this, (RecipientsNux.__proto__ || Object.getPrototypeOf(RecipientsNux)).apply(this, arguments));
	  }
	
	  _createClass(RecipientsNux, [{
	    key: 'render',
	    value: function render() {
	      var activity = this.props.activity;
	
	      var shareModal = _react2.default.createElement(_ActivityShareModal2.default, { activity: activity });
	      var image = __webpack_require__(3155);
	      var title = 'Let people know about your activity';
	      var subtext = 'Share a link to your activity on Remind, ' + 'or send it to people via Facebook, Twitter, or email. 🎉';
	
	      if (activity.isClosed()) {
	        return _react2.default.createElement(_TitleHeader2.default, {
	          className: 'RecipientsNux',
	          image: image,
	          title: 'This activity is closed',
	          subtext: 'You have received no responses.'
	        });
	      }
	
	      return _react2.default.createElement(
	        _TitleHeader2.default,
	        {
	          className: 'RecipientsNux',
	          image: image,
	          title: title,
	          subtext: subtext },
	        _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: shareModal },
	          _react2.default.createElement(
	            _Button2.default,
	            { className: 'RecipientsNux-cta', eventElementName: 'RecipientsNux-cta' },
	            'Share your activity'
	          )
	        )
	      );
	    }
	  }]);
	
	  return RecipientsNux;
	}(_react2.default.Component);
	
	RecipientsNux.displayName = 'RecipientsNux';
	exports.default = RecipientsNux;

/***/ },
/* 3153 */
1136,
/* 3154 */,
/* 3155 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "db90e9a1a12b7d60e97c7fa4618fa2ca.svg";

/***/ },
/* 3156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ConfirmDialog = __webpack_require__(1314);
	
	var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Menu = __webpack_require__(1244);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ModalMenuItem = __webpack_require__(1595);
	
	var _ModalMenuItem2 = _interopRequireDefault(_ModalMenuItem);
	
	var _MenuItem = __webpack_require__(1249);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'ActivitiesActionsLayer',
	  getCloseConfirmDialog: function getCloseConfirmDialog() {
	    var _this = this;
	
	    return _react2.default.createElement(_ConfirmDialog2.default, {
	      size: 'xsmall',
	      title: 'Close this activity?',
	      subtext: 'Once your activity is closed, participants won\u2019t\n        be able to send you money. You can still\n        deposit funds to your bank account.',
	      actionButtonText: 'Close',
	      cancelButtonText: 'Cancel',
	      onConfirm: function onConfirm() {
	        _ActivityActions2.default.close(_this.props.activity).then(function () {
	          return _ToastActions2.default.showSuccessToast('Activity is now closed');
	        }, function () {
	          return _ToastActions2.default.showDefaultErrorToast();
	        });
	      }
	    });
	  },
	  printActivity: function printActivity() {
	    _Activity2.default.export(this.props.activity.id).then(function () {
	      return _ToastActions2.default.showSuccessToast(_Activity.ACTIVITY_PRINTED_MSG);
	    }, function () {
	      return _ToastActions2.default.showDefaultErrorToast();
	    });
	  },
	  renderMenu: function renderMenu() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      _Menu2.default,
	      null,
	      !this.props.activity.isClosed() && _react2.default.createElement(
	        _ModalMenuItem2.default,
	        { modal: this.getCloseConfirmDialog() },
	        'Close activity'
	      ),
	      _react2.default.createElement(
	        _MenuItem2.default,
	        { onClick: function onClick() {
	            return _this2.printActivity();
	          } },
	        'Print Activity'
	      )
	    );
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      _LayerTrigger2.default,
	      {
	        layer: this.renderMenu(),
	        trigger: 'click',
	        alignment: 'right',
	        placement: 'bottom' },
	      this.props.children
	    );
	  }
	});

/***/ },
/* 3157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityFormEditHandler = __webpack_require__(3158);
	
	var _ActivityFormEditHandler2 = _interopRequireDefault(_ActivityFormEditHandler);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	__webpack_require__(3159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ActivityEditModal = function (_React$Component) {
	  _inherits(ActivityEditModal, _React$Component);
	
	  function ActivityEditModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityEditModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityEditModal.__proto__ || Object.getPrototypeOf(ActivityEditModal)).call.apply(_ref, [this].concat(args))), _this), _this.onEdited = function () {
	      _ToastActions2.default.showSuccessToast('Changes saved');
	      if (_this.props.onRequestHide) {
	        _this.props.onRequestHide();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityEditModal, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activity = _props.activity,
	          onRequestHide = _props.onRequestHide,
	          rest = _objectWithoutProperties(_props, ['activity', 'onRequestHide']);
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'ActivityEditModal'
	        }, rest, {
	          className: 'ActivityEditModal',
	          onRequestHide: onRequestHide }),
	        _react2.default.createElement(
	          _BoxBody2.default,
	          null,
	          _react2.default.createElement(_ActivityFormEditHandler2.default, {
	            canCollectMoney: this.state.canCollectMoney,
	            initialActivity: activity,
	            onEdited: this.onEdited
	          })
	        )
	      );
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_CurrentUser2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState() {
	      return {
	        canCollectMoney: _CurrentUser2.default.getUser().canCollectMoney()
	      };
	    }
	  }]);
	
	  return ActivityEditModal;
	}(_react2.default.Component);
	
	ActivityEditModal.displayName = 'ActivityEditModal';
	exports.default = _utils.Container.create(ActivityEditModal, { withProps: true });

/***/ },
/* 3158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActivityForm = __webpack_require__(1730);
	
	var _ActivityForm2 = _interopRequireDefault(_ActivityForm);
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _lodash = __webpack_require__(555);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var ActivityFormEditHandler = function (_Component) {
	  _inherits(ActivityFormEditHandler, _Component);
	
	  function ActivityFormEditHandler() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityFormEditHandler);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityFormEditHandler.__proto__ || Object.getPrototypeOf(ActivityFormEditHandler)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loading: false
	    }, _this.onValidSubmit = function (values) {
	      _this.setState({ loading: true });
	
	      var onEdited = function onEdited(activity) {
	        _this.setState({ loading: false });
	        if (_this.props.onEdited) {
	          _this.props.onEdited(activity);
	        }
	      };
	
	      var onError = function onError(error) {
	        _this.setState({ loading: false });
	        _ToastActions2.default.showAPIError(error);
	        throw error;
	      };
	
	      var original = _this.props.initialActivity.toJSON();
	      var params = (0, _lodash.pickBy)({
	        welcomeMsgBody: _this.difference(values.welcome_msg_body, original.welcome_msg_body),
	        activity: _this.props.initialActivity,
	        amountPerPerson: _this.difference(values.amount || values.amount === 0 ? values.amount * 100 : undefined, original.amount_per_person),
	        collectOnline: _this.difference(values.collect_online, original.collect_online),
	        hasChildren: _this.difference(values.has_children, original.has_children),
	        location: _this.difference(values.location, original.location),
	        endDate: _this.dateDifference(values.end_date, original.end_at),
	        title: _this.difference(values.title, original.title),
	        date: _this.dateDifference(values.date, original.start_at)
	      }, function (v) {
	        return v !== undefined && v !== null;
	      });
	
	      if (Object.keys(params).length === 1) {
	        onEdited(_this.props.initialActivity);
	        return;
	      }
	
	      return _ActivityActions2.default.edit(params).then(onEdited).catch(onError);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityFormEditHandler, [{
	    key: 'difference',
	    value: function difference(updated, original) {
	      return updated === original ? undefined : updated;
	    }
	  }, {
	    key: 'dateDifference',
	    value: function dateDifference(updated, original) {
	      if (!updated) {
	        return undefined;
	      }
	      if (!original) {
	        return updated;
	      }
	      return updated.getTime() === original.getTime() ? undefined : updated;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var initialActivity = this.props.initialActivity;
	
	
	      return _react2.default.createElement(_ActivityForm2.default, {
	        showLabels: true,
	        submitText: 'Update',
	        initialActivity: this.props.initialActivity,
	        loading: this.state.loading,
	        onValidSubmit: this.onValidSubmit,
	        canCollectMoney: this.props.canCollectMoney,
	        disabled: initialActivity.getStartAt() < new Date()
	      });
	    }
	  }]);
	
	  return ActivityFormEditHandler;
	}(_react.Component);
	
	ActivityFormEditHandler.displayName = 'ActivityFormEditHandler';
	exports.default = ActivityFormEditHandler;

/***/ },
/* 3159 */
1136,
/* 3160 */,
/* 3161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _ActivityTransactionsModal = __webpack_require__(3162);
	
	var _ActivityTransactionsModal2 = _interopRequireDefault(_ActivityTransactionsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityTransactionsModalContainer = function (_React$Component) {
	  _inherits(ActivityTransactionsModalContainer, _React$Component);
	
	  function ActivityTransactionsModalContainer() {
	    _classCallCheck(this, ActivityTransactionsModalContainer);
	
	    return _possibleConstructorReturn(this, (ActivityTransactionsModalContainer.__proto__ || Object.getPrototypeOf(ActivityTransactionsModalContainer)).apply(this, arguments));
	  }
	
	  _createClass(ActivityTransactionsModalContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_ActivityTransactionsModal2.default, _extends({}, this.props, { activity: this.state.activity }));
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ActivityStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(_prevState, props) {
	      return {
	        activity: _ActivityStore2.default.getActivityById(props.activityID)
	      };
	    }
	  }]);
	
	  return ActivityTransactionsModalContainer;
	}(_react2.default.Component);
	
	ActivityTransactionsModalContainer.displayName = 'ActivityTransactionsModalContainer';
	exports.default = _utils.Container.create(ActivityTransactionsModalContainer, { withProps: true });

/***/ },
/* 3162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ActivityTransactionsModal;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _ActivityTransactionsTableContainer = __webpack_require__(3163);
	
	var _ActivityTransactionsTableContainer2 = _interopRequireDefault(_ActivityTransactionsTableContainer);
	
	var _ActivityDepositStarter = __webpack_require__(3167);
	
	var _ActivityDepositStarter2 = _interopRequireDefault(_ActivityDepositStarter);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	__webpack_require__(3179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	// typecheck: ignore file
	
	
	function ActivityTransactionsModal(props) {
	  var activity = props.activity,
	      onRequestHide = props.onRequestHide,
	      rest = _objectWithoutProperties(props, ['activity', 'onRequestHide']);
	
	  var balance = activity.getCurrentBalance();
	
	  return _react2.default.createElement(
	    _Dialog2.default,
	    _extends({}, rest, {
	      size: 'xlarge',
	      onRequestHide: onRequestHide }),
	    _react2.default.createElement(
	      _BoxBody2.default,
	      { className: 'ActivityTransactionsModal-body' },
	      _react2.default.createElement(
	        'div',
	        { className: 'ActivityTransactionsModal-header' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Transactions'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            'You currently have',
	            ' ',
	            _react2.default.createElement(_Money2.default, { cents: activity.getCurrentBalance() }),
	            ' ',
	            'to deposit'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _ActivityDepositStarter2.default,
	            { activity: activity },
	            function (_ref) {
	              var start = _ref.start,
	                  loading = _ref.loading;
	              return _react2.default.createElement(
	                _Button2.default,
	                {
	                  onClick: start,
	                  loading: loading,
	                  disabled: !balance || balance <= 0 },
	                'Deposit ',
	                _react2.default.createElement(_Money2.default, { cents: balance })
	              );
	            }
	          )
	        )
	      ),
	      _react2.default.createElement(_ActivityTransactionsTableContainer2.default, { activity: activity })
	    )
	  );
	}

/***/ },
/* 3163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _utils = __webpack_require__(956);
	
	var _ActivityActions = __webpack_require__(976);
	
	var _ActivityActions2 = _interopRequireDefault(_ActivityActions);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _ActivityTransactionsTable = __webpack_require__(2943);
	
	var _ActivityTransactionsTable2 = _interopRequireDefault(_ActivityTransactionsTable);
	
	var _ActivityTransactionsTableNux = __webpack_require__(3164);
	
	var _ActivityTransactionsTableNux2 = _interopRequireDefault(_ActivityTransactionsTableNux);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityTransactionsTableContainer = function (_Component) {
	  _inherits(ActivityTransactionsTableContainer, _Component);
	
	  function ActivityTransactionsTableContainer() {
	    _classCallCheck(this, ActivityTransactionsTableContainer);
	
	    return _possibleConstructorReturn(this, (ActivityTransactionsTableContainer.__proto__ || Object.getPrototypeOf(ActivityTransactionsTableContainer)).apply(this, arguments));
	  }
	
	  _createClass(ActivityTransactionsTableContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      _ActivityActions2.default.getTransactions(this.props.activity.id).then(function () {
	        return _this2.setState({ loading: false });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.state.loading && this.state.transactions.length === 0) {
	        return _react2.default.createElement(_CenteredLoadingIndicator2.default, null);
	      }
	
	      if (!this.state.loading && this.state.transactions.length === 0) {
	        return _react2.default.createElement(_ActivityTransactionsTableNux2.default, {
	          isFree: this.state.activity.isFree(),
	          isClosed: this.state.activity.isClosed(),
	          activityURL: this.state.activity.getPayUrl()
	        });
	      }
	
	      return _react2.default.createElement(_ActivityTransactionsTable2.default, { transactions: this.state.transactions });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ActivityStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(state, props) {
	      return {
	        loading: state ? state.loading : true,
	        activity: _ActivityStore2.default.getActivityById(props.activity.id),
	        transactions: _ActivityStore2.default.getTransactionsForActivityUUID(props.activity.id)
	      };
	    }
	  }]);
	
	  return ActivityTransactionsTableContainer;
	}(_react.Component);
	
	ActivityTransactionsTableContainer.displayName = 'ActivityTransactionsTableContainer';
	exports.default = _utils.Container.create(ActivityTransactionsTableContainer, { withProps: true });

/***/ },
/* 3164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ClipboardTrigger = __webpack_require__(1492);
	
	var _ClipboardTrigger2 = _interopRequireDefault(_ClipboardTrigger);
	
	var _Container = __webpack_require__(1493);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TitleHeader = __webpack_require__(1511);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	var _ToastActions = __webpack_require__(947);
	
	var _ToastActions2 = _interopRequireDefault(_ToastActions);
	
	__webpack_require__(3165);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityTransactionsTableNux = function (_Component) {
	  _inherits(ActivityTransactionsTableNux, _Component);
	
	  function ActivityTransactionsTableNux() {
	    _classCallCheck(this, ActivityTransactionsTableNux);
	
	    return _possibleConstructorReturn(this, (ActivityTransactionsTableNux.__proto__ || Object.getPrototypeOf(ActivityTransactionsTableNux)).apply(this, arguments));
	  }
	
	  _createClass(ActivityTransactionsTableNux, [{
	    key: 'showCopyToast',
	    value: function showCopyToast() {
	      _ToastActions2.default.showSuccessToast('The URL has been copied to your clipboard');
	    }
	  }, {
	    key: 'renderOpenNux',
	    value: function renderOpenNux() {
	      var subText = this.props.isFree ? 'This activity is free, transactions do not apply to free activities.' : 'Collected funds, deposits, and refunds will appear here.\n      In the meantime, you can share this activity with your class.';
	
	      var title = this.props.isFree ? 'No transactions' : 'No transactions yet';
	
	      return _react2.default.createElement(
	        _Container2.default,
	        { size: 'xsmall' },
	        _react2.default.createElement(_TitleHeader2.default, { title: title, subtext: subText }),
	        !this.props.isFree && _react2.default.createElement(
	          _ClipboardTrigger2.default,
	          {
	            text: this.props.activityURL,
	            onCopy: this.showCopyToast },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              className: 'ActivityTransactionsTableNux-cta',
	              eventElementName: 'ActivityTransactionsTableNux-cta' },
	            'Get the link'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderCloseNux',
	    value: function renderCloseNux() {
	      return _react2.default.createElement(
	        _Container2.default,
	        { size: 'xsmall' },
	        _react2.default.createElement(_TitleHeader2.default, {
	          title: 'Activity closed',
	          subtext: 'This activity is no longer available. To create a new activity, compose a new announcement.'
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'ActivityTransactionsTableNux' },
	        this.props.isClosed ? this.renderCloseNux() : this.renderOpenNux()
	      );
	    }
	  }]);
	
	  return ActivityTransactionsTableNux;
	}(_react.Component);
	
	ActivityTransactionsTableNux.displayName = 'ActivityTransactionsTableNux';
	exports.default = ActivityTransactionsTableNux;

/***/ },
/* 3165 */
1136,
/* 3166 */,
/* 3167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AccountTransferDisabledModal = __webpack_require__(2899);
	
	var _AccountTransferDisabledModal2 = _interopRequireDefault(_AccountTransferDisabledModal);
	
	var _DepositModal = __webpack_require__(3168);
	
	var _DepositModal2 = _interopRequireDefault(_DepositModal);
	
	var _PaymentAccountActions = __webpack_require__(2593);
	
	var _PaymentAccountActions2 = _interopRequireDefault(_PaymentAccountActions);
	
	var _IdentityAdditionalVerificationModalContainer = __webpack_require__(2674);
	
	var _IdentityAdditionalVerificationModalContainer2 = _interopRequireDefault(_IdentityAdditionalVerificationModalContainer);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityDepositStarter = function (_React$Component) {
	  _inherits(ActivityDepositStarter, _React$Component);
	
	  function ActivityDepositStarter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityDepositStarter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityDepositStarter.__proto__ || Object.getPrototypeOf(ActivityDepositStarter)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loading: false
	    }, _this.onClick = function () {
	      _this.setState({ loading: true });
	      var onDone = function onDone() {
	        return _this.setState({ loading: false });
	      };
	
	      // Refresh the payment account, we really don't
	      // want to get this wrong here and really want
	      // the latest state of the account.
	      _PaymentAccountActions2.default.load().then(function (account) {
	        var needBasicVerifications = account.needBasicVerification() || account.needBankAccountVerification();
	
	        if (needBasicVerifications) {
	          _this.context.router.push({
	            pathname: '/transactions/deposit/setup',
	            query: { req: _this.props.activity.id }
	          });
	          return;
	        }
	
	        // if the account transfers is disabled this means the user
	        // need a verifications step that we do not support in V1.
	        if (account.isTransferEnabled()) {
	          (0, _modal.mountModal)(_react2.default.createElement(_DepositModal2.default, { activity: _this.props.activity }), _this);
	        } else if (account.needAdditionalVerification()) {
	          (0, _modal.mountModal)(_react2.default.createElement(_IdentityAdditionalVerificationModalContainer2.default, null), _this);
	        } else {
	          (0, _modal.mountModal)(_react2.default.createElement(_AccountTransferDisabledModal2.default, null), _this);
	        }
	      }).then(onDone, onDone);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityDepositStarter, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        start: this.onClick,
	        loading: this.state.loading
	      });
	    }
	  }]);
	
	  return ActivityDepositStarter;
	}(_react2.default.Component);
	
	ActivityDepositStarter.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	ActivityDepositStarter.displayName = 'ActivityDepositStarter';
	exports.default = ActivityDepositStarter;

/***/ },
/* 3168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _DepositConfirmationContainer = __webpack_require__(3169);
	
	var _DepositConfirmationContainer2 = _interopRequireDefault(_DepositConfirmationContainer);
	
	var _DepositModalDepositView = __webpack_require__(3170);
	
	var _DepositModalDepositView2 = _interopRequireDefault(_DepositModalDepositView);
	
	var _Dialog = __webpack_require__(1200);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	__webpack_require__(3177);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var DepositModal = function (_React$Component) {
	  _inherits(DepositModal, _React$Component);
	
	  function DepositModal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DepositModal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DepositModal.__proto__ || Object.getPrototypeOf(DepositModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      view: 'deposit'
	    }, _this.onDeposited = function () {
	      _this.setState({ view: 'success' });
	    }, _this.renderContent = function () {
	      switch (_this.state.view) {
	        case 'deposit':
	          return _react2.default.createElement(_DepositModalDepositView2.default, {
	            activity: _this.props.activity,
	            onDeposited: _this.onDeposited
	          });
	        case 'success':
	          return _react2.default.createElement(
	            _BoxBody2.default,
	            null,
	            _react2.default.createElement(_DepositConfirmationContainer2.default, {
	              activityUUID: _this.props.activity.id,
	              onComplete: _this.props.onRequestHide
	            })
	          );
	        default:
	          throw new Error('unknow view in deposit modal');
	      }
	    }, _this.render = function () {
	      var _this$props = _this.props,
	          className = _this$props.className,
	          onRequestHide = _this$props.onRequestHide,
	          rest = _objectWithoutProperties(_this$props, ['className', 'onRequestHide']);
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        _extends({
	          eventScreenName: 'DepositModal'
	        }, rest, {
	          size: 'small',
	          onRequestHide: onRequestHide,
	          className: (0, _classnames2.default)('DepositModal', className) }),
	        _this.renderContent()
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return DepositModal;
	}(_react2.default.Component);
	
	DepositModal.displayName = 'DepositModal';
	exports.default = DepositModal;

/***/ },
/* 3169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(956);
	
	var _Transaction = __webpack_require__(982);
	
	var _Transaction2 = _interopRequireDefault(_Transaction);
	
	var _ActivityStore = __webpack_require__(983);
	
	var _ActivityStore2 = _interopRequireDefault(_ActivityStore);
	
	var _DepositConfirmation = __webpack_require__(2587);
	
	var _DepositConfirmation2 = _interopRequireDefault(_DepositConfirmation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	/* DepositConfirmationContainer -
	 * Passes the last deposit transactions of the activity
	 * to the DepositConfirmation child.
	 */
	var DepositConfirmationContainer = function (_React$Component) {
	  _inherits(DepositConfirmationContainer, _React$Component);
	
	  function DepositConfirmationContainer() {
	    _classCallCheck(this, DepositConfirmationContainer);
	
	    return _possibleConstructorReturn(this, (DepositConfirmationContainer.__proto__ || Object.getPrototypeOf(DepositConfirmationContainer)).apply(this, arguments));
	  }
	
	  _createClass(DepositConfirmationContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_DepositConfirmation2.default, {
	        onComplete: this.props.onComplete,
	        onCompleteText: this.props.onCompleteText,
	        transaction: this.state.transaction
	      });
	    }
	  }], [{
	    key: 'getStores',
	    value: function getStores() {
	      return [_ActivityStore2.default];
	    }
	  }, {
	    key: 'calculateState',
	    value: function calculateState(_prevState, props) {
	      var transactions = _ActivityStore2.default.getTransactionsForActivityUUID(props.activityUUID).models;
	      var withdrawals = transactions.filter(function (tx) {
	        return tx.isWithdrawal();
	      });
	      var transaction = withdrawals[0];
	
	      return {
	        transaction: transaction
	      };
	    }
	  }]);
	
	  return DepositConfirmationContainer;
	}(_react2.default.Component);
	
	DepositConfirmationContainer.displayName = 'DepositConfirmationContainer';
	exports.default = _utils.Container.create(DepositConfirmationContainer, { withProps: true });

/***/ },
/* 3170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BankAccountSelector = __webpack_require__(3171);
	
	var _BankAccountSelector2 = _interopRequireDefault(_BankAccountSelector);
	
	var _BoxBody = __webpack_require__(1191);
	
	var _BoxBody2 = _interopRequireDefault(_BoxBody);
	
	var _BoxHeader = __webpack_require__(1440);
	
	var _BoxHeader2 = _interopRequireDefault(_BoxHeader);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DepositButton = __webpack_require__(2592);
	
	var _DepositButton2 = _interopRequireDefault(_DepositButton);
	
	var _Money = __webpack_require__(1651);
	
	var _Money2 = _interopRequireDefault(_Money);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Receipt = __webpack_require__(1987);
	
	var _Receipt2 = _interopRequireDefault(_Receipt);
	
	var _ReceiptBody = __webpack_require__(1990);
	
	var _ReceiptBody2 = _interopRequireDefault(_ReceiptBody);
	
	var _ReceiptRow = __webpack_require__(1996);
	
	var _ReceiptRow2 = _interopRequireDefault(_ReceiptRow);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(3175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var DepositModalDepositView = _react2.default.createClass({
	  displayName: 'DepositModalDepositView',
	  getInitialState: function getInitialState() {
	    return {
	      externalAccountResource: null
	    };
	  },
	  onBankAccountSelected: function onBankAccountSelected(externalAccountResource) {
	    this.setState({ externalAccountResource: externalAccountResource });
	  },
	  render: function render() {
	    var balance = this.props.activity.getCurrentBalance();
	    var bankAccount = this.state.externalAccountResource && this.state.externalAccountResource.getBankAccount();
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)('DepositModalDepositView', this.props.className) },
	      _react2.default.createElement(_BoxHeader2.default, { title: 'Review and deposit your funds' }),
	      _react2.default.createElement(
	        _BoxBody2.default,
	        null,
	        _react2.default.createElement(_BankAccountSelector2.default, { onSelect: this.onBankAccountSelected }),
	        _react2.default.createElement(
	          _Receipt2.default,
	          { className: 'DepositModalDepositView-table' },
	          _react2.default.createElement(
	            _ReceiptBody2.default,
	            null,
	            _react2.default.createElement(
	              _ReceiptRow2.default,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Account name'
	              ),
	              _react2.default.createElement(
	                _Text2.default,
	                { truncate: true },
	                bankAccount && this.state.externalAccountResource.getName()
	              )
	            ),
	            _react2.default.createElement(
	              _ReceiptRow2.default,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Rounting number'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                bankAccount && bankAccount.getRoutingNumber()
	              )
	            ),
	            _react2.default.createElement(
	              _ReceiptRow2.default,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                'Account number (last 4 digits)'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                bankAccount && bankAccount.getAccountNumberLastFourDigits()
	              )
	            )
	          )
	        ),
	        !bankAccount ? _react2.default.createElement(
	          _Button2.default,
	          {
	            className: 'DepositModalDepositView-submit',
	            disabled: true,
	            eventElementName: 'DepositModalDepositView-submit' },
	          'Deposit ',
	          _react2.default.createElement(_Money2.default, { cents: balance })
	        ) : _react2.default.createElement(_DepositButton2.default, {
	          className: 'DepositModalDepositView-submit',
	          disabled: !bankAccount,
	          activity: this.props.activity,
	          amount: balance,
	          account: bankAccount,
	          onSuccess: this.props.onDeposited
	        })
	      )
	    );
	  }
	});
	
	exports.default = DepositModalDepositView;

/***/ },
/* 3171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BankAccountSelectorItem = __webpack_require__(3172);
	
	var _ExternalAccountResourceActions = __webpack_require__(2553);
	
	var _ExternalAccountResourceActions2 = _interopRequireDefault(_ExternalAccountResourceActions);
	
	var _ExternalAccountResourceStore = __webpack_require__(2590);
	
	var _ExternalAccountResourceStore2 = _interopRequireDefault(_ExternalAccountResourceStore);
	
	var _LinkBankAccountModal = __webpack_require__(2660);
	
	var _LinkBankAccountModal2 = _interopRequireDefault(_LinkBankAccountModal);
	
	var _linkStateWithStores = __webpack_require__(1237);
	
	var _linkStateWithStores2 = _interopRequireDefault(_linkStateWithStores);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(1366);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _modal = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  weak */
	var ADD_BANK_ACCOUNT_OPTION = 'add_bank_account';
	
	exports.default = _react2.default.createClass({
	  displayName: 'BankAccountSelector',
	
	
	  mixins: [(0, _linkStateWithStores2.default)([_ExternalAccountResourceStore2.default])],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoSelect: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    return this.getStateFromStores();
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    if (this.state.value) {
	      var externalAccountResource = this.state.externalAccountResources.find(function (ea) {
	        return ea.getBankAccount().id === _this.state.value;
	      });
	      this.props.onSelect(externalAccountResource);
	    }
	
	    if (_ExternalAccountResourceStore2.default.getExternalAccountResources().length === 0) {
	      _ExternalAccountResourceActions2.default.load();
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    var _this2 = this;
	
	    if (this.state.value !== prevState.value) {
	      var externalAccountResource = this.state.externalAccountResources.find(function (ea) {
	        return ea.getBankAccount().id === _this2.state.value;
	      });
	      this.props.onSelect(externalAccountResource);
	    }
	  },
	  onBankAccountAdded: function onBankAccountAdded(externalAccountResource) {
	    var externalAccountResources = this.state.externalAccountResources.clone();
	    externalAccountResources.add(externalAccountResource);
	    this.setState({ externalAccountResources: externalAccountResources, value: externalAccountResource.getBankAccount().id });
	  },
	  onChange: function onChange(value) {
	    if (value === ADD_BANK_ACCOUNT_OPTION) {
	      var modal = _react2.default.createElement(_LinkBankAccountModal2.default, { onBankAccountAdded: this.onBankAccountAdded });
	      (0, _modal.mountModal)(modal, this);
	    }
	
	    this.setState({ value: value });
	  },
	  getStateFromStores: function getStateFromStores() {
	    var externalAccountResources = _ExternalAccountResourceStore2.default.getExternalAccountResources();
	    var value = this.state ? this.state.value : null;
	
	    if (externalAccountResources.length > 0) {
	      if (value === null && this.props.autoSelect) {
	        value = externalAccountResources.first().getBankAccount().id;
	      }
	    }
	
	    return { externalAccountResources: externalAccountResources, value: value };
	  },
	  getOptions: function getOptions() {
	    var options = this.state.externalAccountResources.map(function (externalAccountResource) {
	      return {
	        label: externalAccountResource.getName(),
	        value: externalAccountResource.getBankAccount().id,
	        node: _react2.default.createElement(
	          _BankAccountSelectorItem.BankAccountSelectorItem,
	          null,
	          externalAccountResource.getName()
	        )
	      };
	    });
	
	    options.push({
	      value: ADD_BANK_ACCOUNT_OPTION,
	      label: 'Add Bank Account',
	      node: _react2.default.createElement(_BankAccountSelectorItem.BankAccountSelectorAddItem, null)
	    });
	
	    return options;
	  },
	  render: function render() {
	    return _react2.default.createElement(_Select2.default, {
	      searchable: false,
	      value: this.state.value,
	      onChange: this.onChange,
	      options: this.getOptions()
	    });
	  }
	});

/***/ },
/* 3172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BankAccountSelectorAddItem = exports.BankAccountSelectorItem = undefined;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	__webpack_require__(3173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BankAccountSelectorItem = exports.BankAccountSelectorItem = function BankAccountSelectorItem(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'BankAccountSelectorItem' },
	    props.children
	  );
	};
	var BankAccountSelectorAddItem = exports.BankAccountSelectorAddItem = function BankAccountSelectorAddItem() {
	  return _react2.default.createElement(
	    BankAccountSelectorItem,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'BankAccountSelectorItem BankAccountSelectorItem-add' },
	      _react2.default.createElement(_Glyph2.default, { color: 'brand', name: 'plus-circle-fill', size: 'large' }),
	      'Add another bank account'
	    )
	  );
	};

/***/ },
/* 3173 */
1136,
/* 3174 */,
/* 3175 */
1136,
/* 3176 */,
/* 3177 */
1136,
/* 3178 */,
/* 3179 */
1136,
/* 3180 */,
/* 3181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRedux = __webpack_require__(1113);
	
	var _redux = __webpack_require__(476);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _activityRecipients = __webpack_require__(2238);
	
	var _ChatAddParticipantContainer = __webpack_require__(2273);
	
	var _ChatAddParticipantContainer2 = _interopRequireDefault(_ChatAddParticipantContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ActivityAddParticipantContainer = function (_React$Component) {
	  _inherits(ActivityAddParticipantContainer, _React$Component);
	
	  function ActivityAddParticipantContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ActivityAddParticipantContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActivityAddParticipantContainer.__proto__ || Object.getPrototypeOf(ActivityAddParticipantContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onAddParticipants = function () {
	      _this.props.loadActivityRecipients(_this.props.activity.id);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ActivityAddParticipantContainer, [{
	    key: 'render',
	    value: function render() {
	      var chatUuid = this.props.activity.getChatUuid();
	
	      if (!chatUuid) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _ChatAddParticipantContainer2.default,
	        {
	          chatUuid: chatUuid,
	          onAddParticipants: this.onAddParticipants },
	        this.props.children
	      );
	    }
	  }]);
	
	  return ActivityAddParticipantContainer;
	}(_react2.default.Component);
	
	ActivityAddParticipantContainer.displayName = 'ActivityAddParticipantContainer';
	
	
	function mapDispatchToProps(dispatch) {
	  // $FlowIssue
	  return (0, _redux.bindActionCreators)({ loadActivityRecipients: _activityRecipients.loadActivityRecipients }, dispatch);
	}
	
	exports.default = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(ActivityAddParticipantContainer);

/***/ },
/* 3182 */
1136,
/* 3183 */,
/* 3184 */
1136,
/* 3185 */,
/* 3186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// typecheck: ignore file
	
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(497);
	
	var _chainOnEnter = __webpack_require__(2586);
	
	var _chainOnEnter2 = _interopRequireDefault(_chainOnEnter);
	
	var _RequireUser = __webpack_require__(1688);
	
	var _RequireUser2 = _interopRequireDefault(_RequireUser);
	
	var _RequireFeatures = __webpack_require__(3187);
	
	var _RequireFeatures2 = _interopRequireDefault(_RequireFeatures);
	
	var _AdminLayout = __webpack_require__(3188);
	
	var _AdminLayout2 = _interopRequireDefault(_AdminLayout);
	
	var _AdminLanding = __webpack_require__(3195);
	
	var _AdminLanding2 = _interopRequireDefault(_AdminLanding);
	
	var _AdminPeopleTable = __webpack_require__(3202);
	
	var _AdminPeopleTable2 = _interopRequireDefault(_AdminPeopleTable);
	
	var _AdminClassesTable = __webpack_require__(3233);
	
	var _AdminClassesTable2 = _interopRequireDefault(_AdminClassesTable);
	
	var _MarketingLayout = __webpack_require__(2815);
	
	var _MarketingLayout2 = _interopRequireDefault(_MarketingLayout);
	
	var _SchoolLayout = __webpack_require__(3239);
	
	var _SchoolLayout2 = _interopRequireDefault(_SchoolLayout);
	
	var _DistrictLayout = __webpack_require__(3242);
	
	var _DistrictLayout2 = _interopRequireDefault(_DistrictLayout);
	
	var _AdminIndex = __webpack_require__(3245);
	
	var _AdminIndex2 = _interopRequireDefault(_AdminIndex);
	
	var _AdminSchools = __webpack_require__(3246);
	
	var _AdminSchools2 = _interopRequireDefault(_AdminSchools);
	
	var _SchoolInfomationLayout = __webpack_require__(3261);
	
	var _SchoolInfomationLayout2 = _interopRequireDefault(_SchoolInfomationLayout);
	
	var _AdminBillingOverview = __webpack_require__(3273);
	
	var _AdminBillingOverview2 = _interopRequireDefault(_AdminBillingOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var requireAdminWithFeature = (0, _chainOnEnter2.default)([_RequireUser2.default, (0, _RequireFeatures2.default)(['web_admin_console'])]);
	
	var LandingLayout = function LandingLayout(props) {
	  return _react2.default.createElement(_MarketingLayout2.default, _extends({ light: true, borderless: true }, props));
	};
	
	// Fetch organizations (if not cached) and redirect to a school or district.
	var SchoolIndex = function SchoolIndex(props) {
	  return _react2.default.createElement(_AdminIndex2.default, _extends({ schoolRedirect: true }, props));
	};
	var DistrictIndex = function DistrictIndex(props) {
	  return _react2.default.createElement(_AdminIndex2.default, _extends({ districtRedirect: true }, props));
	};
	
	exports.default = _react2.default.createElement(
	  _reactRouter.Route,
	  { path: '/admin', onEnter: requireAdminWithFeature },
	  _react2.default.createElement(_reactRouter.IndexRoute, { component: _AdminIndex2.default }),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { component: LandingLayout },
	    _react2.default.createElement(_reactRouter.Route, { path: 'landing', component: _AdminLanding2.default })
	  ),
	  _react2.default.createElement(
	    _reactRouter.Route,
	    { component: _AdminLayout2.default },
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'districts' },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: DistrictIndex }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: ':districtId' },
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { component: _DistrictLayout2.default },
	          _react2.default.createElement(_reactRouter.Route, { path: 'schools', component: _AdminSchools2.default }),
	          _react2.default.createElement(_reactRouter.Route, { path: 'billing', component: _AdminBillingOverview2.default }),
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'schools' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactRouter.Route,
	      { path: 'schools' },
	      _react2.default.createElement(_reactRouter.IndexRoute, { component: SchoolIndex }),
	      _react2.default.createElement(
	        _reactRouter.Route,
	        { path: ':schoolId' },
	        _react2.default.createElement(
	          _reactRouter.Route,
	          { component: _SchoolLayout2.default },
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'information', component: _SchoolInfomationLayout2.default },
	            _react2.default.createElement(_reactRouter.Route, { path: 'classes', component: _AdminClassesTable2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'people', component: _AdminPeopleTable2.default }),
	            _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'people' })
	          ),
	          _react2.default.createElement(_reactRouter.Route, { path: 'billing', component: _AdminBillingOverview2.default }),
	          _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'information' })
	        )
	      )
	    )
	  )
	);

/***/ },
/* 3187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requireFeatures = requireFeatures;
	
	var _CurrentUser = __webpack_require__(576);
	
	var _CurrentUser2 = _interopRequireDefault(_CurrentUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requireFeatures(permissions) {
	  return {
	    statics: {
	      onEnter: function onEnter(nextState, replaceWith) {
	        var user = _CurrentUser2.default.isSignedIn() ? _CurrentUser2.default.getUser() : null;
	        if (!user) {
	          replaceWith('/error');
	          return;
	        }
	
	        permissions.forEach(function (permission) {
	          if (!user.getFeatures()[permission]) {
	            replaceWith('/error');
	          }
	        });
	      }
	    }
	  };
	}
	// typecheck: ignore file
	exports.default = requireFeatures;

/***/ },
/* 3188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdminLayoutHeader = __webpack_require__(3189);
	
	var _AdminLayoutHeader2 = _interopRequireDefault(_AdminLayoutHeader);
	
	__webpack_require__(3193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AdminLayout(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'AdminLayout' },
	    _react2.default.createElement(_AdminLayoutHeader2.default, null),
	    props.children
	  );
	}
	exports.default = AdminLayout;

/***/ },
/* 3189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ZopimLink = __webpack_require__(2381);
	
	var _ZopimLink2 = _interopRequireDefault(_ZopimLink);
	
	var _ZopimChevronBox = __webpack_require__(2382);
	
	var _ZopimChevronBox2 = _interopRequireDefault(_ZopimChevronBox);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _SupportDialog = __webpack_require__(2363);
	
	var _SupportDialog2 = _interopRequireDefault(_SupportDialog);
	
	var _UserNavigationMenu = __webpack_require__(2159);
	
	var _UserNavigationMenu2 = _interopRequireDefault(_UserNavigationMenu);
	
	var _AdminLayoutHeaderOrganizationName = __webpack_require__(3190);
	
	var _AdminLayoutHeaderOrganizationName2 = _interopRequireDefault(_AdminLayoutHeaderOrganizationName);
	
	__webpack_require__(3191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// typecheck: ignore file
	function AdminLayoutHeader(_props, context) {
	  var router = context.router;
	  var _router$params = router.params,
	      schoolId = _router$params.schoolId,
	      districtId = _router$params.districtId;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'AdminLayoutHeader' },
	    _react2.default.createElement(
	      'div',
	      { className: 'AdminLayoutHeader-tile' },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Admin Console'
	      ),
	      _react2.default.createElement(
	        _AdminLayoutHeaderOrganizationName2.default,
	        { organizationId: schoolId || districtId },
	        function (name) {
	          return _react2.default.createElement(
	            _Text2.default,
	            { weight: 'light', className: 'AdminLayoutHeader-organizationName' },
	            name
	          );
	        }
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'AdminLayoutHeader-nav' },
	      _react2.default.createElement(
	        'div',
	        { className: 'AdminLayoutHeader-nav-help' },
	        _react2.default.createElement(
	          _ZopimLink2.default,
	          null,
	          _react2.default.createElement(_ZopimChevronBox2.default, null)
	        ),
	        _react2.default.createElement(
	          _ModalTrigger2.default,
	          { modal: _react2.default.createElement(_SupportDialog2.default, null) },
	          _react2.default.createElement(
	            _Link2.default,
	            { color: 'white' },
	            _react2.default.createElement(_Glyph2.default, { name: 'help', size: 'xlarge', solo: true })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _UserNavigationMenu2.default,
	        { showSettings: true, showLogout: true },
	        _react2.default.createElement(
	          _Link2.default,
	          { color: 'white' },
	          _react2.default.createElement(_Glyph2.default, { name: 'avatar-circle', size: 'xlarge', solo: true })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'AdminLayoutHeader-nav-remind' },
	        _react2.default.createElement(
	          _Button2.default,
	          { size: 'xxsmall', level: 'secondary', color: 'white', target: '_blank', to: '/classes' },
	          _react2.default.createElement(_Glyph2.default, { name: 'remind-icon', size: 'large' }),
	          _react2.default.createElement(
	            'span',
	            null,
	            'Launch Remind'
	          )
	        )
	      )
	    )
	  );
	}
	
	AdminLayoutHeader.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	exports.default = AdminLayoutHeader;

/***/ },
/* 3190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdminLayoutHeaderOrganizationName = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      name\n      district_name\n    }\n  }'], ['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      name\n      district_name\n    }\n  }']);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _reactApollo = __webpack_require__(467);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// typecheck: ignore file
	
	
	function AdminLayoutHeaderOrganizationName(props) {
	  var organization = props.organization;
	
	
	  if (!organization) {
	    return null;
	  }
	
	  return props.children(organization.district_name || organization.name);
	}
	
	var withOrganization = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  options: function options(_ref) {
	    var organizationId = _ref.organizationId;
	    return { variables: { organizationId: [organizationId] } };
	  },
	  props: function props(_ref2) {
	    var data = _ref2.data;
	    return { organization: data.organizations ? data.organizations[0] : null };
	  }
	});
	
	exports.AdminLayoutHeaderOrganizationName = AdminLayoutHeaderOrganizationName;
	exports.default = withOrganization(AdminLayoutHeaderOrganizationName);

/***/ },
/* 3191 */
1136,
/* 3192 */,
/* 3193 */
1136,
/* 3194 */,
/* 3195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdminLanding = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  query {\n    user: me {\n      id\n      first_name\n      districts: organizations(first: 1, type: "district", affiliation_status: [admin]) {\n        id\n      }\n      schools: organizations(first: 1, type: "school", affiliation_status: [admin]) {\n        id\n      }\n      pending_organizations: organizations(first: 1, affiliation_status: [pending_admin]) {\n        id\n        type\n      }\n    }\n  }'], ['\n  query {\n    user: me {\n      id\n      first_name\n      districts: organizations(first: 1, type: "district", affiliation_status: [admin]) {\n        id\n      }\n      schools: organizations(first: 1, type: "school", affiliation_status: [admin]) {\n        id\n      }\n      pending_organizations: organizations(first: 1, affiliation_status: [pending_admin]) {\n        id\n        type\n      }\n    }\n  }']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BoxSelect = __webpack_require__(2467);
	
	var _BoxSelect2 = _interopRequireDefault(_BoxSelect);
	
	var _BadgedBox = __webpack_require__(3196);
	
	var _BadgedBox2 = _interopRequireDefault(_BadgedBox);
	
	var _BoxSelectItem = __webpack_require__(2470);
	
	var _BoxSelectItem2 = _interopRequireDefault(_BoxSelectItem);
	
	var _Notice = __webpack_require__(1132);
	
	var _Notice2 = _interopRequireDefault(_Notice);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _reactApollo = __webpack_require__(467);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	__webpack_require__(3199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// typecheck: ignore file
	
	
	function AdminLanding(props) {
	  var title = props.user ? _react2.default.createElement(
	    'span',
	    null,
	    'Hello ',
	    props.user.first_name,
	    ', where do you want to go?'
	  ) : _react2.default.createElement(
	    'span',
	    null,
	    'Hello _ _ _ _ , where do you want to go?'
	  );
	
	  var pending = props.user ? props.user.pending_organizations.length > 0 : false;
	
	  var type = '_ _ _';
	
	  if (props.user) {
	    if (props.user.pending_organizations.length > 0) {
	      type = props.user.pending_organizations[0].type.toLowerCase();
	    }
	
	    if (props.user.schools.length > 0) {
	      type = 'school';
	    }
	
	    if (props.user.districts.length > 0) {
	      type = 'district';
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'AdminLanding' },
	    _react2.default.createElement(
	      'div',
	      { className: 'AdminLanding-content' },
	      pending && _react2.default.createElement(
	        'div',
	        { className: 'AdminLanding-notice' },
	        _react2.default.createElement(
	          _Notice2.default,
	          { glyph: 'bell-stroke', color: 'flame' },
	          'We are currently verifying your account.'
	        )
	      ),
	      _react2.default.createElement(
	        _BoxSelect2.default,
	        { key: 'one', title: title },
	        _react2.default.createElement(
	          _BoxSelectItem2.default,
	          {
	            eventElementName: 'AdminLanding-Core-Link',
	            to: '/classes',
	            border: true,
	            size: 'large',
	            icon: __webpack_require__(3201) },
	          _react2.default.createElement(
	            _Text2.default,
	            { element: 'div', size: 'xlarge', weight: 'semibold', color: 'brand' },
	            'Remind'
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            { element: 'div', size: 'small', weight: 'semibold', color: 'brand' },
	            'See what your teachers see'
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            { className: 'AdminLanding-info' },
	            'Remind is the tool your teachers use to connect with their students and parents. You can use it to message your district schools, too.'
	          )
	        ),
	        _react2.default.createElement(
	          _BadgedBox2.default,
	          { text: 'New' },
	          _react2.default.createElement(
	            _BoxSelectItem2.default,
	            {
	              eventElementName: 'AdminLanding-Dashboard-Link',
	              to: '/admin',
	              border: true,
	              size: 'large',
	              icon: __webpack_require__(2535) },
	            _react2.default.createElement(
	              _Text2.default,
	              { element: 'div', size: 'xlarge', weight: 'semibold', color: 'brand' },
	              'Admin Console'
	            ),
	            _react2.default.createElement(
	              _Text2.default,
	              { element: 'div', size: 'small', weight: 'semibold', color: 'brand' },
	              'Manage your ',
	              type
	            ),
	            _react2.default.createElement(
	              _Text2.default,
	              { className: 'AdminLanding-info' },
	              'The Admin Console is used for managing all the people in your district and schools. Only verified administrators have access to this tool.'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	var withUser = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  props: function props(_ref) {
	    var data = _ref.data;
	    return { user: data.user };
	  }
	});
	
	exports.AdminLanding = AdminLanding;
	exports.default = withUser(AdminLanding);

/***/ },
/* 3196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BadgedBox;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(3197);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// / typecheck: ignore file
	function BadgedBox(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'BadgedBox' },
	    _react2.default.createElement(
	      'div',
	      { className: 'BadgedBox-badge' },
	      props.text
	    ),
	    props.children
	  );
	}

/***/ },
/* 3197 */
1136,
/* 3198 */,
/* 3199 */
1136,
/* 3200 */,
/* 3201 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "59967f42a8d934f786e5014c6187b847.svg";

/***/ },
/* 3202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  ', '\n\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      paid\n      class {\n        ...classesDefaults\n      }\n    }\n  }\n  '], ['\n  ', '\n\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      paid\n      class {\n        ...classesDefaults\n      }\n    }\n  }\n  ']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PeopleTable = __webpack_require__(3203);
	
	var _PeopleTable2 = _interopRequireDefault(_PeopleTable);
	
	var _classesDefaultsFragment = __webpack_require__(995);
	
	var _classesDefaultsFragment2 = _interopRequireDefault(_classesDefaultsFragment);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _reactApollo = __webpack_require__(467);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	__webpack_require__(3231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// typecheck: ignore file
	
	
	function AdminPeopleTable(props) {
	  var organization = props.organization;
	
	
	  if (!organization) {
	    return null;
	  }
	
	  var paid = organization.paid;
	
	  var groupEntity = organization && organization.class && _Group2.default.fromJSON(organization.class);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'AdminPeopleTable' },
	    _react2.default.createElement(_PeopleTable2.default, { disabled: !paid, group: groupEntity, namespace: String(props.params.schoolId) })
	  );
	}
	
	var withOrganizationAndClass = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject, _classesDefaultsFragment2.default), {
	  options: function options(_ref) {
	    var params = _ref.params;
	    return {
	      variables: { organizationId: [params.schoolId] }
	    };
	  },
	  props: function props(_ref2) {
	    var data = _ref2.data;
	    return {
	      organization: data.organizations ? data.organizations[0] : null
	    };
	  }
	});
	
	exports.default = withOrganizationAndClass(AdminPeopleTable);

/***/ },
/* 3203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PeopleTableBodyContainer = __webpack_require__(3204);
	
	var _PeopleTableBodyContainer2 = _interopRequireDefault(_PeopleTableBodyContainer);
	
	var _PeopleTableSuperActions = __webpack_require__(3212);
	
	var _PeopleTableSuperActions2 = _interopRequireDefault(_PeopleTableSuperActions);
	
	var _SmartTable = __webpack_require__(3215);
	
	var _SmartTable2 = _interopRequireDefault(_SmartTable);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var FILTERS = [{
	  name: 'roles',
	  options: [{ key: 'admin', name: 'Admins' }, { key: 'teacher', name: 'Teachers' }, { key: 'parent', name: 'Parents' }, { key: 'student', name: 'Students' }, { key: 'unknown', name: 'No role' }]
	}];
	
	var nameSorts = [{ key: 'first_name_asc', name: 'First name ascending' }, { key: 'first_name_desc', name: 'First name descending', lastInSection: true }, { key: 'last_name_asc', name: 'Last name ascending' }, { key: 'last_name_desc', name: 'Last name descending' }];
	
	var dateJoinedSorts = [{ key: 'join_date_desc', name: 'Descending' }, { key: 'join_date_asc', name: 'Ascending' }];
	
	var roleSorts = [{ key: 'role_desc', name: 'Descending' }, { key: 'role_asc', name: 'Ascending' }];
	
	var COLUMNS = [{ key: 'avatar', name: '' }, { key: 'name', name: 'Name', sorts: nameSorts }, { key: 'role', name: 'Role', sorts: roleSorts }, { key: 'date_joined', name: 'Date joined', sorts: dateJoinedSorts }, { key: 'actions', name: 'Actions' }];
	
	var INITIAL_SORT = 'first_name_asc';
	
	var PeopleTable = function (_React$Component) {
	  _inherits(PeopleTable, _React$Component);
	
	  function PeopleTable() {
	    _classCallCheck(this, PeopleTable);
	
	    return _possibleConstructorReturn(this, (PeopleTable.__proto__ || Object.getPrototypeOf(PeopleTable)).apply(this, arguments));
	  }
	
	  _createClass(PeopleTable, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var namespace = 'people-list-' + this.props.namespace;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.group && _react2.default.createElement(_PeopleTableSuperActions2.default, { group: this.props.group }),
	        _react2.default.createElement(
	          _SmartTable2.default,
	          { 'data-test': 'smart-table', withSearch: true, hasActions: true, namespace: namespace, filters: FILTERS, columns: COLUMNS, initialSort: INITIAL_SORT },
	          function (_ref) {
	            var query = _ref.query,
	                sort = _ref.sort,
	                filters = _ref.filters;
	            return _this2.props.group && _react2.default.createElement(_PeopleTableBodyContainer2.default, {
	              sort: sort,
	              query: query,
	              filters: filters,
	              group: _this2.props.group,
	              disabled: _this2.props.disabled
	            });
	          }
	        )
	      );
	    }
	  }]);
	
	  return PeopleTable;
	}(_react2.default.Component);
	
	PeopleTable.displayName = 'PeopleTable';
	exports.default = PeopleTable;

/***/ },
/* 3204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PeopleTableBodyContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _peopleTables = __webpack_require__(3205);
	
	var _PeopleTableBody = __webpack_require__(3206);
	
	var _PeopleTableBody2 = _interopRequireDefault(_PeopleTableBody);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _redux = __webpack_require__(476);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var PER_PAGE = 20;
	
	var PeopleTableBodyContainer = function (_React$Component) {
	  _inherits(PeopleTableBodyContainer, _React$Component);
	
	  function PeopleTableBodyContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PeopleTableBodyContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PeopleTableBodyContainer.__proto__ || Object.getPrototypeOf(PeopleTableBodyContainer)).call.apply(_ref, [this].concat(args))), _this), _this.loadNextPage = function () {
	      return _this.loadPage(_this.props.page + 1);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PeopleTableBodyContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.initialized) {
	        this.props.initializeTable(this.props.group.id);
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var initialized = !this.props.initialized && nextProps.initialized;
	      var newFilters = this.props.filters !== nextProps.filters;
	      var newQuery = this.props.query !== nextProps.query;
	      var newSort = this.props.sort !== nextProps.sort;
	
	      if (initialized || newSort || newQuery || newFilters) {
	        this.loadPage(1, nextProps);
	      }
	    }
	  }, {
	    key: 'loadPage',
	    value: function loadPage(page, nextProps) {
	      var props = nextProps || this.props;
	
	      var sortOptions = {};
	
	      if (props.sort) {
	        switch (props.sort) {
	          case 'first_name_asc':
	            sortOptions = { sort: 'first_name', direction: 'asc' };
	            break;
	          case 'first_name_desc':
	            sortOptions = { sort: 'first_name', direction: 'desc' };
	            break;
	          case 'last_name_asc':
	            sortOptions = { sort: 'last_name', direction: 'asc' };
	            break;
	          case 'last_name_desc':
	            sortOptions = { sort: 'last_name', direction: 'desc' };
	            break;
	          case 'join_date_asc':
	            sortOptions = { sort: 'join_date', direction: 'asc' };
	            break;
	          case 'join_date_desc':
	            sortOptions = { sort: 'join_date', direction: 'desc' };
	            break;
	          case 'role_asc':
	            sortOptions = { sort: 'role', direction: 'asc' };
	            break;
	          case 'role_desc':
	            sortOptions = { sort: 'role', direction: 'desc' };
	            break;
	          default:
	        }
	      }
	
	      var filterKeys = props.filters.toArray().map(function (filter) {
	        return filter.key;
	      });
	
	      this.props.loadMemberships(this.props.group.id, {
	        page: page,
	        perPage: PER_PAGE,
	        query: props.query,
	        roles: filterKeys,
	        sort: sortOptions.sort,
	        sortDirection: sortOptions.direction
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.initialized) {
	        return _react2.default.createElement('tbody', null);
	      }
	
	      return _react2.default.createElement(_PeopleTableBody2.default, {
	        group: this.props.group,
	        loadNextPage: this.loadNextPage,
	        allLoaded: this.props.allLoaded,
	        memberships: this.props.memberships,
	        disabled: this.props.disabled
	      });
	    }
	  }]);
	
	  return PeopleTableBodyContainer;
	}(_react2.default.Component);
	
	PeopleTableBodyContainer.displayName = 'PeopleTableBodyContainer';
	
	
	function mapStateToProps(state, props) {
	  var table = state.peopleTables.get(props.group.id);
	
	  if (!table) {
	    return { initialized: false };
	  }
	
	  return {
	    initialized: true,
	    page: table.page,
	    loading: table.loading,
	    allLoaded: table.allLoaded,
	    memberships: table.memberships
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ initializeTable: _peopleTables.initializeTable, loadMemberships: _peopleTables.loadMemberships }, dispatch);
	}
	
	exports.PeopleTableBodyContainer = PeopleTableBodyContainer;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PeopleTableBodyContainer);

/***/ },
/* 3205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// typecheck: ignore file
	
	
	exports.default = reducer;
	exports.initializeTable = initializeTable;
	exports.selectMembership = selectMembership;
	exports.unselectMembership = unselectMembership;
	exports.unselectAllMembership = unselectAllMembership;
	exports.loadMemberships = loadMemberships;
	exports.loadMembershipsSuccess = loadMembershipsSuccess;
	exports.removeMembers = removeMembers;
	exports.loadMembership = loadMembership;
	exports.loadMembershipSuccess = loadMembershipSuccess;
	
	var _immutable = __webpack_require__(949);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = new _immutable.Map();
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'peopleTables/INITIALIZE_TABLE':
	      {
	        return state.set(action.groupId, {
	          page: 1,
	          loading: false,
	          allLoaded: false,
	          memberships: [],
	          selectedMemberships: new _immutable.Map()
	        });
	      }
	
	    case 'peopleTables/LOAD_MEMBERSHIPS_REQUEST':
	      {
	        var table = state.get(action.groupId);
	        return state.set(action.groupId, _extends({}, table, {
	          loading: true
	        }));
	      }
	
	    case 'peopleTables/LOAD_MEMBERSHIPS_SUCCESS':
	      {
	        var _table = state.get(action.groupId);
	        return state.set(action.groupId, _extends({}, _table, {
	          loading: false,
	          page: action.options.page,
	          allLoaded: action.memberships.length < action.options.perPage,
	          memberships: action.options.page === 1 ? action.memberships : [].concat(_table.memberships, action.memberships)
	        }));
	      }
	
	    case 'peopleTables/LOAD_MEMBERSHIP_SUCCESS':
	      {
	        var _ret = function () {
	          var groupId = action.groupId,
	              membership = action.membership,
	              options = action.options;
	
	
	          var table = state.get(groupId);
	          var update = options && options.update;
	
	          var updated = false;
	
	          var memberships = table.memberships.map(function (m) {
	            if (m.id !== membership.id) {
	              return m;
	            }
	
	            updated = true;
	            return membership;
	          });
	
	          if (!update && !updated) {
	            memberships.push(membership);
	          }
	
	          return {
	            v: state.set(action.groupId, _extends({}, table, { memberships: memberships }))
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      }
	
	    case 'peopleTables/SELECT_MEMBERSHIP':
	      {
	        var _table2 = state.get(action.groupId);
	        return state.set(action.groupId, _extends({}, _table2, {
	          selectedMemberships: _table2.selectedMemberships.set(action.membership.id, action.membership)
	        }));
	      }
	
	    case 'peopleTables/UNSELECT_MEMBERSHIP':
	      {
	        var _table3 = state.get(action.groupId);
	        return state.set(action.groupId, _extends({}, _table3, {
	          selectedMemberships: _table3.selectedMemberships.delete(action.membership.id)
	        }));
	      }
	
	    case 'peopleTables/UNSELECT_ALL_MEMBERSHIP':
	      {
	        var _table4 = state.get(action.groupId);
	        return state.set(action.groupId, _extends({}, _table4, {
	          selectedMemberships: _table4.selectedMemberships.clear()
	        }));
	      }
	
	    case 'peopleTables/REMOVE_MEMBERS':
	      {
	        var _ret2 = function () {
	          var ids = action.userIds;
	          var table = state.get(action.groupId);
	          var memberships = table.memberships.filter(function (m) {
	            return !ids.includes(m.getUserId());
	          });
	          var selectedMemberships = table.selectedMemberships.filter(function (m) {
	            return !ids.includes(m.getUserId());
	          });
	
	          return {
	            v: state.set(action.groupId, _extends({}, table, {
	              memberships: memberships,
	              selectedMemberships: selectedMemberships
	            }))
	          };
	        }();
	
	        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	}
	
	function initializeTable(groupId) {
	  return {
	    type: 'peopleTables/INITIALIZE_TABLE',
	    groupId: groupId
	  };
	}
	
	function selectMembership(groupId, membership) {
	  return {
	    type: 'peopleTables/SELECT_MEMBERSHIP',
	    membership: membership,
	    groupId: groupId
	  };
	}
	
	function unselectMembership(groupId, membership) {
	  return {
	    type: 'peopleTables/UNSELECT_MEMBERSHIP',
	    membership: membership,
	    groupId: groupId
	  };
	}
	
	function unselectAllMembership(groupId) {
	  return {
	    type: 'peopleTables/UNSELECT_ALL_MEMBERSHIP',
	    groupId: groupId
	  };
	}
	
	function loadMemberships(groupId, options) {
	  return {
	    type: 'peopleTables/LOAD_MEMBERSHIPS_REQUEST',
	    groupId: groupId,
	    options: options
	  };
	}
	
	function loadMembershipsSuccess(groupId, memberships, options) {
	  return {
	    type: 'peopleTables/LOAD_MEMBERSHIPS_SUCCESS',
	    memberships: memberships,
	    groupId: groupId,
	    options: options
	  };
	}
	
	function removeMembers(groupId, userIds) {
	  return {
	    type: 'peopleTables/REMOVE_MEMBERS',
	    userIds: userIds,
	    groupId: groupId
	  };
	}
	
	function loadMembership(groupId, userId, options) {
	  return {
	    type: 'peopleTables/LOAD_MEMBERSHIP_REQUEST',
	    groupId: groupId,
	    userId: userId,
	    options: options
	  };
	}
	
	function loadMembershipSuccess(groupId, membership, options) {
	  return {
	    type: 'peopleTables/LOAD_MEMBERSHIP_SUCCESS',
	    membership: membership,
	    options: options,
	    groupId: groupId
	  };
	}

/***/ },
/* 3206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _PeopleTableRow = __webpack_require__(3207);
	
	var _PeopleTableRow2 = _interopRequireDefault(_PeopleTableRow);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _ScrollWatch = __webpack_require__(1238);
	
	var _ScrollWatch2 = _interopRequireDefault(_ScrollWatch);
	
	var _reactRedux = __webpack_require__(1113);
	
	__webpack_require__(3210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var PeopleTableBody = function (_React$Component) {
	  _inherits(PeopleTableBody, _React$Component);
	
	  function PeopleTableBody() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PeopleTableBody);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PeopleTableBody.__proto__ || Object.getPrototypeOf(PeopleTableBody)).call.apply(_ref, [this].concat(args))), _this), _this.onBottomReached = function () {
	      return _this.props.loadNextPage();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PeopleTableBody, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          allLoaded = _props.allLoaded,
	          memberships = _props.memberships,
	          disabled = _props.disabled;
	
	
	      var rows = memberships.map(function (m) {
	        return _react2.default.createElement(_PeopleTableRow2.default, { key: m.id, membership: m, disabled: disabled, group: _this2.props.group });
	      });
	
	      return _react2.default.createElement(
	        'tbody',
	        null,
	        rows,
	        !allLoaded && _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            { colSpan: 99, className: 'PeopleTableBody-loading' },
	            _react2.default.createElement(
	              _ScrollWatch2.default,
	              { onEnter: this.onBottomReached, threshold: 0.2 },
	              _react2.default.createElement(_LoadingIndicator2.default, { size: 'large' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PeopleTableBody;
	}(_react2.default.Component);
	
	PeopleTableBody.displayName = 'PeopleTableBody';
	
	
	function mapStateToProps(state, props) {
	  return {
	    hasSelection: state.peopleTables.get(props.group.id).selectedMemberships.size > 0
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, undefined)(PeopleTableBody);

/***/ },
/* 3207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PeopleTableRow = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(555);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _redux = __webpack_require__(476);
	
	var _peopleTables = __webpack_require__(3205);
	
	var _Buttons = __webpack_require__(1315);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Timestamp = __webpack_require__(1683);
	
	var _Timestamp2 = _interopRequireDefault(_Timestamp);
	
	var _UserActionsMenuButton = __webpack_require__(1575);
	
	var _UserActionsMenuButton2 = _interopRequireDefault(_UserActionsMenuButton);
	
	__webpack_require__(3208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var PeopleTableRow = function (_React$Component) {
	  _inherits(PeopleTableRow, _React$Component);
	
	  function PeopleTableRow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PeopleTableRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PeopleTableRow.__proto__ || Object.getPrototypeOf(PeopleTableRow)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
	      var fn = _this.props.isSelected ? _this.props.unselectMembership : _this.props.selectMembership;
	
	      fn(_this.props.group.id, _this.props.membership);
	    }, _this.stopPropagation = function (e) {
	      return e.stopPropagation();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PeopleTableRow, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          membership = _props.membership,
	          group = _props.group;
	
	
	      var classes = (0, _classnames2.default)('PeopleTableRow', {
	        'PeopleTableRow--enabled': !this.props.disabled,
	        'PeopleTableRow--selected': this.props.isSelected,
	        'PeopleTableRow--hasSelection': this.props.hasSelection
	      });
	
	      var organizationAffiliation = membership.getOrgAffiliationView();
	      var roles = organizationAffiliation ? organizationAffiliation.roles.map(_lodash.capitalize).join(', ') || 'No role' : undefined;
	
	      var onClick = this.props.disabled ? undefined : this.onClick;
	
	      return _react2.default.createElement(
	        'tr',
	        { className: classes, onClick: onClick },
	        _react2.default.createElement(
	          'td',
	          { className: 'PeopleTableRow-avatarCheckbox' },
	          _react2.default.createElement(_Checkbox2.default, {
	            checked: this.props.isSelected,
	            className: 'PeopleTableRow-checkbox'
	          })
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          membership.getName()
	        ),
	        roles && _react2.default.createElement(
	          'td',
	          null,
	          roles
	        ),
	        _react2.default.createElement(
	          'td',
	          null,
	          _react2.default.createElement(_Timestamp2.default, { date: membership.getCreatedAt(), format: 'long' })
	        ),
	        _react2.default.createElement(
	          'td',
	          { className: 'PeopleTableRow-actions' },
	          _react2.default.createElement(
	            _Text2.default,
	            { color: this.props.hasSelection ? 'koala' : 'inherit' },
	            _react2.default.createElement(
	              _Buttons2.default,
	              { align: 'right' },
	              _react2.default.createElement(_UserActionsMenuButton2.default, {
	                className: 'GroupMembersTabListItem-actionButton',
	                tooltip: this.props.disabled ? undefined : 'More Actions',
	                tooltipPlacement: 'top',
	                level: 'text',
	                isAdminView: true,
	                disabled: this.props.disabled,
	                groupToAdmin: group,
	                groupMembership: membership,
	                showChangeRole: membership.hasPermission('can_change_role'),
	                showRemoveFromSchool: membership.hasPermission('can_remove_from_org'),
	                showGetTranscript: membership.hasPermission('can_request_message_history'),
	                handleClick: this.stopPropagation,
	                subscriber: membership.getSubscriber()
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PeopleTableRow;
	}(_react2.default.Component);
	
	PeopleTableRow.displayName = 'PeopleTableRow';
	
	
	function mapStateToProps(state, props) {
	  var table = state.peopleTables.get(props.group.id);
	
	  return {
	    hasSelection: table.selectedMemberships.size > 0,
	    isSelected: table.selectedMemberships.has(props.membership.id)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ selectMembership: _peopleTables.selectMembership, unselectMembership: _peopleTables.unselectMembership }, dispatch);
	}
	
	exports.PeopleTableRow = PeopleTableRow;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PeopleTableRow);

/***/ },
/* 3208 */
1136,
/* 3209 */,
/* 3210 */
1136,
/* 3211 */,
/* 3212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PeopleTableSuperActions = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _immutable = __webpack_require__(949);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _peopleTables = __webpack_require__(3205);
	
	var _BatchRoleCorrectionModal = __webpack_require__(1577);
	
	var _BatchRoleCorrectionModal2 = _interopRequireDefault(_BatchRoleCorrectionModal);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _ModalTrigger = __webpack_require__(1187);
	
	var _ModalTrigger2 = _interopRequireDefault(_ModalTrigger);
	
	var _RemoveFromOrgModal = __webpack_require__(1605);
	
	var _RemoveFromOrgModal2 = _interopRequireDefault(_RemoveFromOrgModal);
	
	var _RequestTranscriptModal = __webpack_require__(1597);
	
	var _RequestTranscriptModal2 = _interopRequireDefault(_RequestTranscriptModal);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(2126);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	__webpack_require__(3213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var PeopleTableSuperActions = function (_React$Component) {
	  _inherits(PeopleTableSuperActions, _React$Component);
	
	  function PeopleTableSuperActions() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PeopleTableSuperActions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PeopleTableSuperActions.__proto__ || Object.getPrototypeOf(PeopleTableSuperActions)).call.apply(_ref, [this].concat(args))), _this), _this.shouldRenderAction = function (permission) {
	      return _this.props.selectedMemberships.every(function (groupMembership) {
	        return groupMembership.hasPermission(permission);
	      });
	    }, _this.renderRequestTranscriptModal = function () {
	      var _this$props = _this.props,
	          selectedMemberships = _this$props.selectedMemberships,
	          group = _this$props.group;
	
	      var organizations = group.getOrganization();
	
	      var users = selectedMemberships.toArray().map(function (m) {
	        return {
	          id: m.getUserId(),
	          fullName: m.getUser().getFullName(),
	          firstName: m.getUser().getFirstName(),
	          canGetMessageHistory: m.hasPermission('can_get_message_history'),
	          canRequestMessageHistory: m.hasPermission('can_request_message_history')
	        };
	      });
	
	      return _react2.default.createElement(_RequestTranscriptModal2.default, {
	        users: users,
	        organizationId: organizations.id,
	        organizationName: organizations.getName()
	      });
	    }, _this.unselectAllMembership = function () {
	      _this.props.unselectAllMembership(_this.props.group.id);
	    }, _this.onUserRoleSave = function (userId) {
	      _this.props.loadMembership(_this.props.group.id, userId, { update: true });
	    }, _this.removeAllSelected = function () {
	      var ids = _this.props.selectedMemberships.toArray().map(function (m) {
	        return m.getUserId();
	      });
	      _this.props.removeMembers(_this.props.group.id, ids);
	    }, _this.renderRemoveFromOrgModal = function () {
	      var _this$props2 = _this.props,
	          selectedMemberships = _this$props2.selectedMemberships,
	          group = _this$props2.group;
	
	      var userIds = selectedMemberships.toArray().map(function (m) {
	        return m.getUserId();
	      });
	      var organizations = group.getOrganization();
	
	      return _react2.default.createElement(_RemoveFromOrgModal2.default, {
	        isAdminView: true,
	        group: group,
	        userIds: userIds,
	        orgId: organizations.id,
	        onRemoved: _this.removeAllSelected,
	        orgName: organizations.getName()
	      });
	    }, _this.renderChangeRolesModal = function () {
	      var _this$props3 = _this.props,
	          selectedMemberships = _this$props3.selectedMemberships,
	          group = _this$props3.group;
	
	      return _react2.default.createElement(_BatchRoleCorrectionModal2.default, {
	        group: group,
	        groupMemberships: selectedMemberships.toArray(),
	        onUserRoleSave: _this.onUserRoleSave
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PeopleTableSuperActions, [{
	    key: 'renderItem',
	    value: function renderItem(glyph, text) {
	      return _react2.default.createElement(
	        _Button2.default,
	        {
	          size: 'xsmall',
	          color: 'white',
	          level: 'secondary',
	          className: 'PeopleTableSuperActions-item',
	          eventElementName: 'PeopleTableSuperActions-item' },
	        _react2.default.createElement(_Glyph2.default, { name: glyph, size: 'large' }),
	        _react2.default.createElement(
	          _Text2.default,
	          { size: 'xsmall' },
	          text
	        )
	      );
	    }
	  }, {
	    key: 'renderActions',
	    value: function renderActions() {
	      var selectedMemberships = this.props.selectedMemberships;
	
	      var selectedCount = selectedMemberships.size;
	
	      if (selectedCount === 0) {
	        return null;
	      }
	
	      var moreThanOneSelected = selectedCount > 1;
	
	      return _react2.default.createElement(
	        'div',
	        { key: 'actions', className: (0, _classnames2.default)('PeopleTableSuperActions', this.props.className) },
	        _react2.default.createElement(
	          'div',
	          null,
	          this.shouldRenderAction('can_change_role') && _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: this.renderChangeRolesModal() },
	            this.renderItem('avatar', moreThanOneSelected ? 'Change roles' : 'Change role')
	          ),
	          this.shouldRenderAction('can_request_message_history') && _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: this.renderRequestTranscriptModal() },
	            this.renderItem('email-transcript', 'Get message history')
	          ),
	          this.shouldRenderAction('can_remove_from_org') && _react2.default.createElement(
	            _ModalTrigger2.default,
	            { modal: this.renderRemoveFromOrgModal() },
	            this.renderItem('close', 'Remove from school')
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Text2.default,
	            { color: 'wolf', className: 'PeopleTableSuperActions-numberInfo' },
	            moreThanOneSelected ? selectedCount + ' people selected' : selectedCount + ' person selected'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              size: 'xsmall',
	              color: 'white',
	              level: 'secondary',
	              onClick: this.unselectAllMembership },
	            'Deselect all'
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactAddonsCssTransitionGroup2.default,
	        {
	          transitionName: 'PeopleTableSuperActions-transition',
	          transitionEnterTimeout: 300,
	          transitionLeaveTimeout: 300 },
	        this.renderActions()
	      );
	    }
	  }]);
	
	  return PeopleTableSuperActions;
	}(_react2.default.Component);
	
	PeopleTableSuperActions.displayName = 'PeopleTableSuperActions';
	
	
	function mapStateToProps(state, props) {
	  var table = state.peopleTables.get(props.group.id);
	
	  return {
	    selectedMemberships: table ? table.selectedMemberships : new _immutable.Map()
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ removeMembers: _peopleTables.removeMembers, unselectAllMembership: _peopleTables.unselectAllMembership, loadMembership: _peopleTables.loadMembership }, dispatch);
	}
	
	exports.PeopleTableSuperActions = PeopleTableSuperActions;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PeopleTableSuperActions);

/***/ },
/* 3213 */
1136,
/* 3214 */,
/* 3215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SmartTable = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.sortDirection = sortDirection;
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SmartTableHeaderColumn = __webpack_require__(3216);
	
	var _SmartTableHeaderColumn2 = _interopRequireDefault(_SmartTableHeaderColumn);
	
	var _SmartTableSearchInput = __webpack_require__(3221);
	
	var _SmartTableSearchInput2 = _interopRequireDefault(_SmartTableSearchInput);
	
	var _SmartTableFilterTokens = __webpack_require__(3224);
	
	var _SmartTableFilterTokens2 = _interopRequireDefault(_SmartTableFilterTokens);
	
	var _SmartTableFilterIcon = __webpack_require__(3227);
	
	var _SmartTableFilterIcon2 = _interopRequireDefault(_SmartTableFilterIcon);
	
	var _redux = __webpack_require__(476);
	
	var _tables = __webpack_require__(3218);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodash = __webpack_require__(555);
	
	__webpack_require__(3229);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	function sortDirection(key) {
	  if ((0, _lodash.endsWith)(key, 'asc')) {
	    return 'asc';
	  }
	  if ((0, _lodash.endsWith)(key, 'desc')) {
	    return 'desc';
	  }
	  return null;
	}
	
	var SmartTable = function (_React$Component) {
	  _inherits(SmartTable, _React$Component);
	
	  function SmartTable() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SmartTable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmartTable.__proto__ || Object.getPrototypeOf(SmartTable)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
	      if (!_this.props.initialized) {
	        _this.props.initTable(_this.props.namespace, { sort: _this.props.initialSort });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SmartTable, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        namespace: this.props.namespace
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.props.initialized) {
	        return _react2.default.createElement('div', null);
	      }
	
	      var _props = this.props,
	          children = _props.children,
	          currentQuery = _props.currentQuery,
	          currentSort = _props.currentSort,
	          currentFilters = _props.currentFilters;
	
	
	      (0, _invariant2.default)(children, 'table header children is required');
	      (0, _invariant2.default)(this.props.withSearch || !this.props.filters || this.props.filters.length === 0, 'cant filter without search input');
	      (0, _invariant2.default)(typeof currentQuery === 'string', 'SmartTable should not try to render without query (not initialized?)');
	      (0, _invariant2.default)(currentFilters, 'SmartTable should not try to render without filters (not initialized?)');
	
	      var tableClasses = (0, _classnames2.default)('SmartTable-table', {
	        'SmartTable-table--hasActions': this.props.hasActions
	      });
	
	      var columns = this.props.columns.map(function (column) {
	        return _react2.default.createElement(_SmartTableHeaderColumn2.default, {
	          key: column.key,
	          column: column,
	          sortKey: _this2.props.currentSort
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'SmartTable-filterSearch' },
	          this.props.filters && this.props.filters.length > 0 && _react2.default.createElement(_SmartTableFilterIcon2.default, { filters: this.props.filters }),
	          this.props.withSearch && _react2.default.createElement(_SmartTableSearchInput2.default, null)
	        ),
	        this.props.filters && _react2.default.createElement(_SmartTableFilterTokens2.default, { namespace: this.props.namespace }),
	        _react2.default.createElement(
	          'table',
	          { className: tableClasses },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              columns
	            )
	          ),
	          children({ query: currentQuery, sort: currentSort, filters: currentFilters })
	        )
	      );
	    }
	  }]);
	
	  return SmartTable;
	}(_react2.default.Component);
	
	SmartTable.childContextTypes = {
	  namespace: _react2.default.PropTypes.string.isRequired
	};
	SmartTable.defaultProps = {
	  withSearch: false
	};
	SmartTable.displayName = 'SmartTable';
	
	
	function mapStateToProps(state, props) {
	  var table = state.tables.get(props.namespace);
	
	  if (!table) {
	    return {
	      initialized: false
	    };
	  }
	
	  return {
	    initialized: true,
	    currentSort: table.sort,
	    currentQuery: table.query,
	    currentFilters: table.filters
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  // $FlowFixMe
	  return (0, _redux.bindActionCreators)({ initTable: _tables.initTable }, dispatch);
	}
	
	exports.SmartTable = SmartTable;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SmartTable);

/***/ },
/* 3216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SmartTableHeaderColumn = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SmartTable = __webpack_require__(3215);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _SmartTableHeaderSorts = __webpack_require__(3217);
	
	var _SmartTableHeaderSorts2 = _interopRequireDefault(_SmartTableHeaderSorts);
	
	var _HovercardBody = __webpack_require__(1554);
	
	var _HovercardBody2 = _interopRequireDefault(_HovercardBody);
	
	var _Hovercard = __webpack_require__(1548);
	
	var _Hovercard2 = _interopRequireDefault(_Hovercard);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _tables = __webpack_require__(3218);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _lodash = __webpack_require__(555);
	
	__webpack_require__(3219);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var SmartTableHeaderColumn = function (_React$Component) {
	  _inherits(SmartTableHeaderColumn, _React$Component);
	
	  function SmartTableHeaderColumn(props) {
	    _classCallCheck(this, SmartTableHeaderColumn);
	
	    var _this = _possibleConstructorReturn(this, (SmartTableHeaderColumn.__proto__ || Object.getPrototypeOf(SmartTableHeaderColumn)).call(this, props));
	
	    _this.columnSortKeys = new Set();
	
	    _this.toggleSort = function () {
	      var _this$props = _this.props,
	          column = _this$props.column,
	          sortKey = _this$props.sortKey;
	
	      var sorts = column.sorts;
	      if (!sorts || sorts.length === 0) {
	        return;
	      }
	
	      if (_this.isPrimarySort()) {
	        var currentIndex = (0, _lodash.findIndex)(sorts, function (sort) {
	          return sort.key === sortKey;
	        });
	        var nextIndex = (currentIndex + 1) % sorts.length;
	        _this.props.setSort(_this.context.namespace, sorts[nextIndex].key);
	      } else {
	        _this.props.setSort(_this.context.namespace, sorts[0].key);
	      }
	    };
	
	    _this.updateSortKeys(props.column);
	    return _this;
	  }
	
	  _createClass(SmartTableHeaderColumn, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.column !== this.props.column) {
	        this.updateSortKeys(nextProps.column);
	      }
	    }
	  }, {
	    key: 'updateSortKeys',
	    value: function updateSortKeys(column) {
	      if (!column.sorts) {
	        this.columnSortKeys = new Set();
	      } else {
	        var sortKeys = column.sorts.map(function (sort) {
	          return sort.key;
	        });
	        this.columnSortKeys = new Set(sortKeys);
	      }
	    }
	  }, {
	    key: 'isPrimarySort',
	    value: function isPrimarySort() {
	      return this.columnSortKeys.has(this.props.sortKey);
	    }
	  }, {
	    key: 'directionIcon',
	    value: function directionIcon() {
	      if (!this.isPrimarySort()) {
	        return 'chevron-down';
	      }
	      var direction = (0, _SmartTable.sortDirection)(this.props.sortKey);
	      if (direction === 'asc') {
	        return 'chevron-up';
	      } else {
	        return 'chevron-down';
	      }
	    }
	  }, {
	    key: 'renderSorts',
	    value: function renderSorts() {
	      var sorts = this.props.column.sorts;
	
	      // Show collapsed sort menu when just an asc/desc toggle
	      if (sorts && sorts.length === 2) {
	        return _react2.default.createElement(
	          _Button2.default,
	          { size: 'small', level: 'icon', onClick: this.toggleSort },
	          this.props.column.name,
	          _react2.default.createElement(_Glyph2.default, { name: this.directionIcon(), solo: true })
	        );
	      } else {
	        var layer = _react2.default.createElement(
	          _Hovercard2.default,
	          { className: 'TableHeaderColumn-card' },
	          _react2.default.createElement(
	            _HovercardBody2.default,
	            null,
	            _react2.default.createElement(_SmartTableHeaderSorts2.default, { 'data-test': 'table-header-sorts', namespace: this.context.namespace, column: this.props.column })
	          )
	        );
	
	        return _react2.default.createElement(
	          _LayerTrigger2.default,
	          { ref: 'trigger', layer: layer, trigger: 'click', alignment: 'left', placement: 'bottom' },
	          _react2.default.createElement(
	            _Button2.default,
	            { level: 'icon', size: 'small' },
	            this.props.column.name,
	            _react2.default.createElement(_Glyph2.default, { name: this.directionIcon(), solo: true })
	          )
	        );
	      }
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle() {
	      if (this.props.column.sorts) {
	        return this.renderSorts();
	      } else {
	        return _react2.default.createElement(
	          _Button2.default,
	          { className: 'SmartTableHeaderColumn-noSort', level: 'icon', size: 'small' },
	          this.props.column.name
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'th',
	        {
	          className: (0, _classnames2.default)('SmartTableHeaderColumn', { 'SmartTableHeaderColumn-primary': this.isPrimarySort() }) },
	        this.renderTitle()
	      );
	    }
	  }]);
	
	  return SmartTableHeaderColumn;
	}(_react2.default.Component);
	
	SmartTableHeaderColumn.contextTypes = {
	  namespace: _react2.default.PropTypes.string.isRequired
	};
	SmartTableHeaderColumn.displayName = 'SmartTableHeaderColumn';
	
	
	function mapDispatchToProps(dispatch) {
	  // $FlowFixMe
	  return (0, _redux.bindActionCreators)({ setSort: _tables.setSort }, dispatch);
	}
	exports.SmartTableHeaderColumn = SmartTableHeaderColumn;
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(SmartTableHeaderColumn);

/***/ },
/* 3217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SmartTableHeaderSorts = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Radio = __webpack_require__(1609);
	
	var _Radio2 = _interopRequireDefault(_Radio);
	
	var _tables = __webpack_require__(3218);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Spacing = __webpack_require__(2037);
	
	var _Spacing2 = _interopRequireDefault(_Spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var SmartTableHeaderSorts = function (_React$Component) {
	  _inherits(SmartTableHeaderSorts, _React$Component);
	
	  function SmartTableHeaderSorts() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SmartTableHeaderSorts);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmartTableHeaderSorts.__proto__ || Object.getPrototypeOf(SmartTableHeaderSorts)).call.apply(_ref, [this].concat(args))), _this), _this.setColumnSort = function (sortKey) {
	      _this.props.setSort(_this.props.namespace, sortKey);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SmartTableHeaderSorts, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      (0, _invariant2.default)(this.props.column.sorts, 'column must have sorts');
	
	      var radios = this.props.column.sorts.map(function (sort) {
	        var radio = _react2.default.createElement(_Radio2.default, {
	          name: 'sort',
	          key: sort.key,
	          label: sort.name,
	          onChange: function onChange() {
	            return _this2.setColumnSort(sort.key);
	          },
	          checked: _this2.props.selectedSort === sort.key
	        });
	        if (sort.lastInSection) {
	          return _react2.default.createElement(
	            'div',
	            { className: _Spacing2.default.marginBottomLarge },
	            radio
	          );
	        } else {
	          return radio;
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: _Spacing2.default.marginBottomLarge },
	          'Sort by'
	        ),
	        radios
	      );
	    }
	  }]);
	
	  return SmartTableHeaderSorts;
	}(_react2.default.Component);
	
	// $FlowFixMe
	
	
	SmartTableHeaderSorts.displayName = 'SmartTableHeaderSorts';
	function mapStateToProps(state, props) {
	  return {
	    selectedSort: state.tables.get(props.namespace).sort
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  // $FlowFixMe
	  return (0, _redux.bindActionCreators)({ setSort: _tables.setSort }, dispatch);
	}
	
	exports.SmartTableHeaderSorts = SmartTableHeaderSorts;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SmartTableHeaderSorts);

/***/ },
/* 3218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	exports.initTable = initTable;
	exports.setQuery = setQuery;
	exports.addFilter = addFilter;
	exports.removeFilter = removeFilter;
	exports.flushFilters = flushFilters;
	exports.setSort = setSort;
	
	var _immutable = __webpack_require__(949);
	
	var initialState = exports.initialState = new _immutable.Map();
	
	// typecheck: ignore statement
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'tables/INIT_TABLE':
	      {
	        return state.set(action.namespace, _extends({ query: '', filters: new _immutable.Map() }, action.options));
	      }
	
	    case 'tables/SET_COLUMN_SORT':
	      {
	        var table = void 0;
	
	        table = state.get(action.namespace);
	        table = _extends({}, table, { sort: action.sort });
	
	        return state.set(action.namespace, table);
	      }
	
	    case 'tables/ADD_FILTER':
	      {
	        var _table = void 0;
	
	        _table = state.get(action.namespace);
	        _table = _extends({}, _table, { filters: _table.filters.set(action.filter.key, action.filter) });
	
	        return state.set(action.namespace, _table);
	      }
	
	    case 'tables/REMOVE_FILTER':
	      {
	        var _table2 = void 0;
	
	        _table2 = state.get(action.namespace);
	        _table2 = _extends({}, _table2, { filters: _table2.filters.delete(action.filter.key) });
	
	        return state.set(action.namespace, _table2);
	      }
	
	    case 'tables/FLUSH_FILTERS':
	      {
	        var _table3 = void 0;
	
	        _table3 = state.get(action.namespace);
	        _table3 = _extends({}, _table3, { filters: new _immutable.Map() });
	
	        return state.set(action.namespace, _table3);
	      }
	
	    case 'tables/SET_QUERY':
	      {
	        var _table4 = void 0;
	
	        _table4 = state.get(action.namespace);
	        _table4 = _extends({}, _table4, { query: action.query });
	
	        return state.set(action.namespace, _table4);
	      }
	
	    default:
	      return state;
	  }
	}
	
	function initTable(namespace, options) {
	  return {
	    type: 'tables/INIT_TABLE',
	    namespace: namespace,
	    options: options
	  };
	}
	
	function setQuery(namespace, query) {
	  return {
	    type: 'tables/SET_QUERY',
	    namespace: namespace,
	    query: query
	  };
	}
	
	function addFilter(namespace, filter) {
	  return {
	    type: 'tables/ADD_FILTER',
	    namespace: namespace,
	    filter: filter
	  };
	}
	
	function removeFilter(namespace, filter) {
	  return {
	    type: 'tables/REMOVE_FILTER',
	    namespace: namespace,
	    filter: filter
	  };
	}
	
	function flushFilters(namespace) {
	  return {
	    type: 'tables/FLUSH_FILTERS',
	    namespace: namespace
	  };
	}
	
	function setSort(namespace, sort) {
	  return {
	    type: 'tables/SET_COLUMN_SORT',
	    namespace: namespace,
	    sort: sort
	  };
	}

/***/ },
/* 3219 */
1136,
/* 3220 */,
/* 3221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Input = __webpack_require__(1358);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _redux = __webpack_require__(476);
	
	var _tables = __webpack_require__(3218);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _lodash = __webpack_require__(555);
	
	__webpack_require__(3222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var SmartTableSearchInput = function (_React$Component) {
	  _inherits(SmartTableSearchInput, _React$Component);
	
	  function SmartTableSearchInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SmartTableSearchInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmartTableSearchInput.__proto__ || Object.getPrototypeOf(SmartTableSearchInput)).call.apply(_ref, [this].concat(args))), _this), _this.debouncedChangeQuery = (0, _lodash.debounce)(function (query) {
	      return _this.props.setQuery(_this.context.namespace, query);
	    }, 400), _this.onChange = function (e) {
	      _this.debouncedChangeQuery(e.target.value);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SmartTableSearchInput, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'SmartTableSearchInput' },
	        _react2.default.createElement(_Input2.default, {
	          size: 'large',
	          placeholder: 'Search',
	          onChange: this.onChange,
	          className: 'SmartTableSearchInput-input'
	        })
	      );
	    }
	  }]);
	
	  return SmartTableSearchInput;
	}(_react2.default.Component);
	
	SmartTableSearchInput.contextTypes = {
	  namespace: _react2.default.PropTypes.string.isRequired
	};
	SmartTableSearchInput.displayName = 'SmartTableSearchInput';
	
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ setQuery: _tables.setQuery }, dispatch);
	}
	
	exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(SmartTableSearchInput);

/***/ },
/* 3222 */
1136,
/* 3223 */,
/* 3224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SmartTableFilterTokens = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tables = __webpack_require__(3218);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	__webpack_require__(3225);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	function Token(props) {
	  return _react2.default.createElement(
	    _Link2.default,
	    {
	      className: 'SmartTableFilterTokens-item',
	      eventElementName: 'SmartTableFilterTokens-item' },
	    props.text && _react2.default.createElement(
	      'span',
	      { className: 'SmartTableFilterTokens-item-text' },
	      props.text
	    ),
	    _react2.default.createElement(_Glyph2.default, { name: 'close', size: 'xxsmall', onClick: props.onClose })
	  );
	}
	
	var SmartTableFilterTokens = function (_React$Component) {
	  _inherits(SmartTableFilterTokens, _React$Component);
	
	  function SmartTableFilterTokens() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SmartTableFilterTokens);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmartTableFilterTokens.__proto__ || Object.getPrototypeOf(SmartTableFilterTokens)).call.apply(_ref, [this].concat(args))), _this), _this.flush = function () {
	      _this.props.flushFilters(_this.props.namespace);
	    }, _this.removeFilter = function (filter) {
	      _this.props.removeFilter(_this.props.namespace, filter);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SmartTableFilterTokens, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var filters = this.props.filters;
	
	
	      if (filters.size === 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'SmartTableFilterTokens' },
	        _react2.default.createElement(Token, { onClose: this.flush }),
	        this.props.filters.toArray().map(function (filter) {
	          return _react2.default.createElement(Token, {
	            key: filter.key,
	            text: filter.name,
	            onClose: function onClose() {
	              return _this2.removeFilter(filter);
	            }
	          });
	        })
	      );
	    }
	  }]);
	
	  return SmartTableFilterTokens;
	}(_react2.default.Component);
	
	SmartTableFilterTokens.displayName = 'SmartTableFilterTokens';
	
	
	function mapStateToProps(state, props) {
	  return {
	    filters: state.tables.get(props.namespace).filters
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  // $FlowFixMe
	  return (0, _redux.bindActionCreators)({ removeFilter: _tables.removeFilter, flushFilters: _tables.flushFilters }, dispatch);
	}
	
	exports.SmartTableFilterTokens = SmartTableFilterTokens;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SmartTableFilterTokens);

/***/ },
/* 3225 */
1136,
/* 3226 */,
/* 3227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _LayerTrigger = __webpack_require__(1172);
	
	var _LayerTrigger2 = _interopRequireDefault(_LayerTrigger);
	
	var _Hovercard = __webpack_require__(1548);
	
	var _Hovercard2 = _interopRequireDefault(_Hovercard);
	
	var _HovercardBody = __webpack_require__(1554);
	
	var _HovercardBody2 = _interopRequireDefault(_HovercardBody);
	
	var _SmartTableFilters = __webpack_require__(3228);
	
	var _SmartTableFilters2 = _interopRequireDefault(_SmartTableFilters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var SmartTableFilterIcon = function (_React$Component) {
	  _inherits(SmartTableFilterIcon, _React$Component);
	
	  function SmartTableFilterIcon() {
	    _classCallCheck(this, SmartTableFilterIcon);
	
	    return _possibleConstructorReturn(this, (SmartTableFilterIcon.__proto__ || Object.getPrototypeOf(SmartTableFilterIcon)).apply(this, arguments));
	  }
	
	  _createClass(SmartTableFilterIcon, [{
	    key: 'render',
	    value: function render() {
	      var layer = _react2.default.createElement(
	        _Hovercard2.default,
	        null,
	        _react2.default.createElement(
	          _HovercardBody2.default,
	          null,
	          _react2.default.createElement(_SmartTableFilters2.default, { 'data-test': 'table-filters', namespace: this.context.namespace, filters: this.props.filters })
	        )
	      );
	
	      return _react2.default.createElement(
	        _LayerTrigger2.default,
	        { ref: 'trigger', layer: layer, trigger: 'click', alignment: 'left', placement: 'bottom' },
	        _react2.default.createElement(
	          _Button2.default,
	          { level: 'icon', color: 'thunder' },
	          _react2.default.createElement(_Glyph2.default, { name: 'sort', color: 'thunder', size: 'xlarge' })
	        )
	      );
	    }
	  }]);
	
	  return SmartTableFilterIcon;
	}(_react2.default.Component);
	
	SmartTableFilterIcon.contextTypes = {
	  namespace: _react2.default.PropTypes.string.isRequired
	};
	SmartTableFilterIcon.displayName = 'SmartTableFilterIcon';
	exports.default = SmartTableFilterIcon;

/***/ },
/* 3228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SmartTableFilters = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tables = __webpack_require__(3218);
	
	var _Heading = __webpack_require__(1436);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Checkbox = __webpack_require__(1388);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _immutable = __webpack_require__(949);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var SmartTableFilters = function (_React$Component) {
	  _inherits(SmartTableFilters, _React$Component);
	
	  function SmartTableFilters() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SmartTableFilters);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SmartTableFilters.__proto__ || Object.getPrototypeOf(SmartTableFilters)).call.apply(_ref, [this].concat(args))), _this), _this.renderFilter = function (filter) {
	      var checkboxes = filter.options.map(function (option) {
	        return _react2.default.createElement(_Checkbox2.default, {
	          name: 'filter',
	          key: option.key,
	          label: option.name.toUpperCase(),
	          onChange: function onChange() {
	            return _this.toggleFilter(option);
	          },
	          checked: _this.props.selectedFilters.has(option.key)
	        });
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { key: filter.name },
	        _react2.default.createElement(
	          _Heading2.default,
	          { level: '2' },
	          _react2.default.createElement(
	            _Text2.default,
	            { size: 'small' },
	            filter.name
	          )
	        ),
	        checkboxes
	      );
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SmartTableFilters, [{
	    key: 'toggleFilter',
	    value: function toggleFilter(filterOption) {
	      var fn = this.props.selectedFilters.get(filterOption.key) ? this.props.removeFilter : this.props.addFilter;
	
	      fn(this.props.namespace, filterOption);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Heading2.default,
	          { level: '1' },
	          'Filter by'
	        ),
	        this.props.filters.map(this.renderFilter)
	      );
	    }
	  }]);
	
	  return SmartTableFilters;
	}(_react2.default.Component);
	
	// $FlowFixMe
	
	
	SmartTableFilters.displayName = 'SmartTableFilters';
	function mapStateToProps(state, props) {
	  return {
	    selectedFilters: state.tables.get(props.namespace).filters
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  // $FlowFixMe
	  return (0, _redux.bindActionCreators)({ removeFilter: _tables.removeFilter, addFilter: _tables.addFilter }, dispatch);
	}
	
	exports.SmartTableFilters = SmartTableFilters;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SmartTableFilters);

/***/ },
/* 3229 */
1136,
/* 3230 */,
/* 3231 */
1136,
/* 3232 */,
/* 3233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _SmartTable = __webpack_require__(3215);
	
	var _SmartTable2 = _interopRequireDefault(_SmartTable);
	
	var _OrganizationClassesTableContainer = __webpack_require__(3234);
	
	var _OrganizationClassesTableContainer2 = _interopRequireDefault(_OrganizationClassesTableContainer);
	
	__webpack_require__(3237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nameSorts = [{ key: 'name_asc', name: 'Ascending' }, { key: 'name_desc', name: 'Descending' }];
	// typecheck: ignore file
	
	
	var createdAtSorts = [{ key: 'created_at_asc', name: 'Ascending' }, { key: 'created_at_desc', name: 'Descending' }];
	
	var COLUMNS = [{ key: 'name', name: 'Name', sorts: nameSorts }, { key: 'teacher_count', name: 'Teacher' }, { key: 'message_count', name: 'Announcements' }, { key: 'parent_count', name: 'Parents' }, { key: 'created_at', name: 'Date created', sorts: createdAtSorts }];
	
	var INITIAL_SORT = 'name_asc';
	
	function AdminClassesTable(props) {
	  var schoolId = props.params.schoolId;
	
	  (0, _invariant2.default)(schoolId, 'school id missing in router param');
	  var namespace = 'admin-class-list-' + props.params.schoolId;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'AdminClassesTable' },
	    _react2.default.createElement(
	      _SmartTable2.default,
	      { 'data-test': 'smart-table', withSearch: true, namespace: namespace, columns: COLUMNS, initialSort: INITIAL_SORT },
	      function (_ref) {
	        var query = _ref.query,
	            sort = _ref.sort;
	        return _react2.default.createElement(_OrganizationClassesTableContainer2.default, {
	          organizationId: Number(schoolId),
	          query: query,
	          sort: sort
	        });
	      }
	    )
	  );
	}
	
	exports.default = AdminClassesTable;

/***/ },
/* 3234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrganizationClassesTableContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OrganizationClassesTable = __webpack_require__(3235);
	
	var _OrganizationClassesTable2 = _interopRequireDefault(_OrganizationClassesTable);
	
	var _organizationClassesTables = __webpack_require__(3236);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _redux = __webpack_require__(476);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var PER_PAGE = 20;
	
	var OrganizationClassesTableContainer = function (_React$Component) {
	  _inherits(OrganizationClassesTableContainer, _React$Component);
	
	  function OrganizationClassesTableContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, OrganizationClassesTableContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OrganizationClassesTableContainer.__proto__ || Object.getPrototypeOf(OrganizationClassesTableContainer)).call.apply(_ref, [this].concat(args))), _this), _this.loadNextPage = function () {
	      return _this.loadPage(_this.props.page + 1);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(OrganizationClassesTableContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.initialized) {
	        this.props.initializeTable(this.props.organizationId);
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var initialized = !this.props.initialized && nextProps.initialized;
	      var newQuery = this.props.query !== nextProps.query;
	      var newSort = this.props.sort !== nextProps.sort;
	
	      if (initialized || newSort || newQuery) {
	        this.loadPage(1, nextProps);
	      }
	    }
	  }, {
	    key: 'loadPage',
	    value: function loadPage(page, nextProps) {
	      var props = nextProps || this.props;
	
	      var sortOptions = {};
	
	      if (props.sort) {
	        switch (props.sort) {
	          case 'name_asc':
	            sortOptions = { sort: 'name', direction: 'asc' };
	            break;
	          case 'name_desc':
	            sortOptions = { sort: 'name', direction: 'desc' };
	            break;
	          case 'created_at_asc':
	            sortOptions = { sort: 'created', direction: 'asc' };
	            break;
	          case 'created_at_desc':
	            sortOptions = { sort: 'created', direction: 'desc' };
	            break;
	          default:
	        }
	      }
	
	      this.props.loadOrganizationClasses(this.props.organizationId, {
	        sortDirection: sortOptions.direction,
	        sort: sortOptions.sort,
	        query: props.query,
	        perPage: PER_PAGE,
	        page: page
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.initialized) {
	        return _react2.default.createElement('tbody', null);
	      }
	
	      return _react2.default.createElement(_OrganizationClassesTable2.default, {
	        groups: this.props.groups,
	        allLoaded: this.props.allLoaded,
	        loadNextPage: this.loadNextPage
	      });
	    }
	  }]);
	
	  return OrganizationClassesTableContainer;
	}(_react2.default.Component);
	
	OrganizationClassesTableContainer.displayName = 'OrganizationClassesTableContainer';
	
	
	function mapStateToProps(state, props) {
	  var table = state.organizationClassesTables.get(props.organizationId);
	
	  if (!table) {
	    return { initialized: false };
	  }
	
	  return {
	    initialized: true,
	    page: table.page,
	    groups: table.groups,
	    loading: table.loading,
	    allLoaded: table.allLoaded
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  // $FlowFixMe
	  return (0, _redux.bindActionCreators)({ initializeTable: _organizationClassesTables.initializeTable, loadOrganizationClasses: _organizationClassesTables.loadOrganizationClasses }, dispatch);
	}
	
	exports.OrganizationClassesTableContainer = OrganizationClassesTableContainer;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OrganizationClassesTableContainer);

/***/ },
/* 3235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Timestamp = __webpack_require__(1683);
	
	var _Timestamp2 = _interopRequireDefault(_Timestamp);
	
	var _ScrollWatch = __webpack_require__(1238);
	
	var _ScrollWatch2 = _interopRequireDefault(_ScrollWatch);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var OrganizationClassesTable = function (_React$Component) {
	  _inherits(OrganizationClassesTable, _React$Component);
	
	  function OrganizationClassesTable() {
	    _classCallCheck(this, OrganizationClassesTable);
	
	    return _possibleConstructorReturn(this, (OrganizationClassesTable.__proto__ || Object.getPrototypeOf(OrganizationClassesTable)).apply(this, arguments));
	  }
	
	  _createClass(OrganizationClassesTable, [{
	    key: 'render',
	    value: function render() {
	      var rows = this.props.groups.map(function (group) {
	        var parents = group.roles.find(function (role) {
	          return role.role === 'parent';
	        });
	
	        return _react2.default.createElement(
	          'tr',
	          { key: group.id },
	          _react2.default.createElement(
	            'td',
	            null,
	            group.class_name
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            group.user && group.user.signature ? group.user.signature : 'no name'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            group.statistics ? group.statistics.message_count : 0
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            parents ? parents.count : 0
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            group.created_at ? _react2.default.createElement(_Timestamp2.default, { date: new Date(group.created_at), format: 'long' }) : _react2.default.createElement(
	              'span',
	              null,
	              'error'
	            )
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        'tbody',
	        null,
	        rows,
	        !this.props.allLoaded && _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            { colSpan: 99, className: 'PeopleTableBody-loading' },
	            _react2.default.createElement(
	              _ScrollWatch2.default,
	              { onEnter: this.props.loadNextPage, threshold: 0.2 },
	              _react2.default.createElement(_LoadingIndicator2.default, { size: 'large' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrganizationClassesTable;
	}(_react2.default.Component);
	
	OrganizationClassesTable.displayName = 'OrganizationClassesTable';
	exports.default = OrganizationClassesTable;

/***/ },
/* 3236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	exports.default = reducer;
	exports.loadOrganizationClasses = loadOrganizationClasses;
	exports.loadOrganizationClassesSuccess = loadOrganizationClassesSuccess;
	exports.initializeTable = initializeTable;
	
	var _immutable = __webpack_require__(949);
	
	// typecheck: ignore file
	var initialState = exports.initialState = new _immutable.Map();
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'organizationClassTables/INITIALIZE_TABLE':
	      {
	        return state.set(action.organizationId, {
	          page: 1,
	          groups: [],
	          loading: false,
	          allLoaded: false
	        });
	      }
	
	    case 'organizationClassTables/LOAD_ORGANIZATION_CLASSES_SUCCESS':
	      {
	        var table = state.get(action.organizationId);
	
	        return state.set(action.organizationId, {
	          loading: false,
	          page: action.options.page,
	          allLoaded: action.groups.length < action.options.perPage,
	          groups: action.options.page === 1 ? action.groups : [].concat(table.groups, action.groups)
	        });
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	}
	
	function loadOrganizationClasses(organizationId, options) {
	  return {
	    type: 'organizationClassTables/LOAD_ORGANIZATION_CLASSES_REQUEST',
	    organizationId: organizationId,
	    options: options
	  };
	}
	
	function loadOrganizationClassesSuccess(organizationId, groups, options) {
	  return {
	    type: 'organizationClassTables/LOAD_ORGANIZATION_CLASSES_SUCCESS',
	    organizationId: organizationId,
	    options: options,
	    groups: groups
	  };
	}
	
	function initializeTable(organizationId) {
	  return {
	    type: 'organizationClassTables/INITIALIZE_TABLE',
	    organizationId: organizationId
	  };
	}

/***/ },
/* 3237 */
1136,
/* 3238 */,
/* 3239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SchoolLayout = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      paid\n      parent_id\n      is_parent_org_admin\n    }\n  }'], ['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      paid\n      parent_id\n      is_parent_org_admin\n    }\n  }']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _reactApollo = __webpack_require__(467);
	
	var _Tabs = __webpack_require__(1539);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Glyph = __webpack_require__(1133);
	
	var _Glyph2 = _interopRequireDefault(_Glyph);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(3240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var SchoolLayout = function (_React$Component) {
	  _inherits(SchoolLayout, _React$Component);
	
	  function SchoolLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SchoolLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SchoolLayout.__proto__ || Object.getPrototypeOf(SchoolLayout)).call.apply(_ref, [this].concat(args))), _this), _this.goPeoples = function () {
	      _this.context.router.push('/admin/schools/' + _this.props.params.schoolId + '/information');
	    }, _this.goBilling = function () {
	      _this.context.router.push('/admin/schools/' + _this.props.params.schoolId + '/billing');
	    }, _this.onTabChange = function (index) {
	      [_this.goPeoples, _this.goBilling][index]();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SchoolLayout, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          loading = _props.loading,
	          paid = _props.paid,
	          isParentAdmin = _props.isParentAdmin,
	          parentId = _props.parentId;
	
	      var informations = !!this.context.router.location.pathname.match(/schools\/[0-9]+\/information/);
	
	      // district admin cant access billing at school level, we show "go back" instead
	      var shouldSeeGoBack = !loading && isParentAdmin && parentId;
	      var shouldSeeTabs = paid && !shouldSeeGoBack;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'SchoolLayout' },
	        shouldSeeGoBack && _react2.default.createElement(
	          _Text2.default,
	          { size: 'xxxsmall', className: 'SchoolLayout-goBack' },
	          _react2.default.createElement(
	            _Link2.default,
	            { to: '/admin/districts/' + (parentId || '') },
	            _react2.default.createElement(_Glyph2.default, { name: 'arrow-left' }),
	            ' Back to schools'
	          )
	        ),
	        shouldSeeTabs && _react2.default.createElement(
	          'div',
	          { className: 'SchoolLayout-tabs' },
	          _react2.default.createElement(
	            _Tabs2.default,
	            { tabActive: informations ? 0 : 1, onTabChange: this.onTabChange },
	            _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	                'span',
	                null,
	                'Your school'
	              ) }),
	            _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	                'span',
	                null,
	                'Billing'
	              ) })
	          )
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return SchoolLayout;
	}(_react2.default.Component);
	
	SchoolLayout.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	SchoolLayout.displayName = 'SchoolLayout';
	
	
	var withOrganization = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  options: function options(_ref2) {
	    var params = _ref2.params;
	    return {
	      variables: { organizationId: [params.schoolId] }
	    };
	  },
	  props: function props(_ref3) {
	    var data = _ref3.data;
	    return {
	      paid: data.organizations ? data.organizations[0].paid : null,
	      isParentAdmin: data.organizations ? data.organizations[0].is_parent_org_admin : null,
	      parentId: data.organizations ? data.organizations[0].parent_id : null,
	      loading: data.loading
	    };
	  }
	});
	
	exports.SchoolLayout = SchoolLayout;
	exports.default = withOrganization(SchoolLayout);

/***/ },
/* 3240 */
1136,
/* 3241 */,
/* 3242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DistrictLayout = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      paid\n    }\n  }'], ['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      paid\n    }\n  }']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _reactApollo = __webpack_require__(467);
	
	var _Tabs = __webpack_require__(1539);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabPanel = __webpack_require__(1447);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	__webpack_require__(3243);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var DistrictLayout = function (_React$Component) {
	  _inherits(DistrictLayout, _React$Component);
	
	  function DistrictLayout() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DistrictLayout);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DistrictLayout.__proto__ || Object.getPrototypeOf(DistrictLayout)).call.apply(_ref, [this].concat(args))), _this), _this.goSchools = function () {
	      _this.context.router.push('/admin/districts/' + _this.props.params.districtId + '/schools');
	    }, _this.goBilling = function () {
	      _this.context.router.push('/admin/districts/' + _this.props.params.districtId + '/billing');
	    }, _this.onTabChange = function (index) {
	      [_this.goSchools, _this.goBilling][index]();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DistrictLayout, [{
	    key: 'render',
	    value: function render() {
	      var schools = !!this.context.router.location.pathname.match(/districts\/[0-9]+\/schools/);
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'DistrictLayout' },
	        this.props.paid && _react2.default.createElement(
	          'div',
	          { className: 'DistrictLayout-tabs' },
	          _react2.default.createElement(
	            _Tabs2.default,
	            { tabActive: schools ? 0 : 1, onTabChange: this.onTabChange },
	            _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	                'span',
	                null,
	                'Schools'
	              ) }),
	            _react2.default.createElement(_TabPanel2.default, { title: _react2.default.createElement(
	                'span',
	                null,
	                'Billing'
	              ) })
	          )
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return DistrictLayout;
	}(_react2.default.Component);
	
	DistrictLayout.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	DistrictLayout.displayName = 'DistrictLayout';
	
	
	var withOrganization = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  options: function options(_ref2) {
	    var params = _ref2.params;
	    return {
	      variables: { organizationId: [params.districtId] }
	    };
	  },
	  props: function props(_ref3) {
	    var data = _ref3.data;
	    return {
	      paid: data.organizations ? data.organizations[0].paid : null
	    };
	  }
	});
	
	exports.DistrictLayout = DistrictLayout;
	exports.default = withOrganization(DistrictLayout);

/***/ },
/* 3243 */
1136,
/* 3244 */,
/* 3245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdminIndex = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  query {\n    me {\n      id\n      districts: organizations(first: 1, type: "district", affiliation_status: [admin pending_admin]) {\n        id\n      }\n      schools: organizations(first: 1, type: "school", affiliation_status: [admin pending_admin]) {\n        id\n      }\n    }\n  }\n  '], ['\n  query {\n    me {\n      id\n      districts: organizations(first: 1, type: "district", affiliation_status: [admin pending_admin]) {\n        id\n      }\n      schools: organizations(first: 1, type: "school", affiliation_status: [admin pending_admin]) {\n        id\n      }\n    }\n  }\n  ']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactApollo = __webpack_require__(467);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var AdminIndex = function (_React$Component) {
	  _inherits(AdminIndex, _React$Component);
	
	  function AdminIndex() {
	    _classCallCheck(this, AdminIndex);
	
	    return _possibleConstructorReturn(this, (AdminIndex.__proto__ || Object.getPrototypeOf(AdminIndex)).apply(this, arguments));
	  }
	
	  _createClass(AdminIndex, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.invariants();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      this.invariants();
	
	      var errorChanged = !this.props.error && nextProps.error;
	
	      if (errorChanged) {
	        this.context.router.push({ pathname: 'error' });
	        return;
	      }
	
	      var goToDistrict = function goToDistrict(id) {
	        _this2.context.router.push({ pathname: 'admin/districts/' + id });
	      };
	
	      var goToSchool = function goToSchool(id) {
	        _this2.context.router.push({ pathname: 'admin/schools/' + id });
	      };
	
	      var school = nextProps.school,
	          district = nextProps.district;
	
	
	      if (!school && !district) {
	        console.error('AdminIndex error: School or district not found');
	        this.context.router.push({ pathname: 'error' });
	        return;
	      }
	
	      if (school && this.props.schoolRedirect) {
	        goToSchool(school.id);
	        return;
	      }
	
	      if (district && this.props.districtRedirect) {
	        goToDistrict(district.id);
	        return;
	      }
	
	      if (district) {
	        goToDistrict(district.id);
	      } else if (school) {
	        goToSchool(school.id);
	      } else {
	        this.context.router.push({ pathname: 'error' });
	      }
	    }
	  }, {
	    key: 'invariants',
	    value: function invariants() {
	      (0, _invariant2.default)(!this.props.schoolRedirect || !this.props.districtRedirect, 'error can only be school or district');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_CenteredLoadingIndicator2.default, null);
	    }
	  }]);
	
	  return AdminIndex;
	}(_react2.default.Component);
	
	AdminIndex.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	AdminIndex.displayName = 'AdminIndex';
	
	
	var withAdministratedOrganizations = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  props: function props(_ref) {
	    var data = _ref.data;
	    return _extends({
	      district: data.me ? data.me.districts[0] : null,
	      school: data.me ? data.me.schools[0] : null
	    }, data);
	  }
	});
	
	exports.AdminIndex = AdminIndex;
	exports.default = withAdministratedOrganizations(AdminIndex);

/***/ },
/* 3246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdminSchools = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      paid\n    }\n  }'], ['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      paid\n    }\n  }']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _reactApollo = __webpack_require__(467);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _SmartTable = __webpack_require__(3215);
	
	var _SmartTable2 = _interopRequireDefault(_SmartTable);
	
	var _SchoolTableBodyContainer = __webpack_require__(3247);
	
	var _SchoolTableBodyContainer2 = _interopRequireDefault(_SchoolTableBodyContainer);
	
	var _DistrictStatistics = __webpack_require__(3252);
	
	var _DistrictStatistics2 = _interopRequireDefault(_DistrictStatistics);
	
	var _AdminBillingBanner = __webpack_require__(3258);
	
	var _AdminBillingBanner2 = _interopRequireDefault(_AdminBillingBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// typecheck: ignore file
	
	
	var nameSorts = [{ key: 'name_asc', name: 'Ascending' }, { key: 'name_desc', name: 'Descending' }];
	
	var COLUMNS = [{ key: 'name', name: 'School', sorts: nameSorts }, { key: 'teacher_count', name: 'Teachers' }, { key: 'parent_count', name: 'Parents' }, { key: 'class_count', name: 'Classes' }, { key: 'message_count', name: 'Announcements' }];
	
	function AdminSchools(props) {
	  var districtId = props.params.districtId;
	
	  (0, _invariant2.default)(districtId, 'district id missing in router param');
	  var namespace = 'admin-school-table-' + props.params.districtId;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_DistrictStatistics2.default, { organizationId: districtId }),
	    _react2.default.createElement(
	      _SmartTable2.default,
	      { namespace: namespace, columns: COLUMNS, initialSort: 'name_asc' },
	      function (_ref) {
	        var sort = _ref.sort;
	        return _react2.default.createElement(_SchoolTableBodyContainer2.default, {
	          disabled: !props.organization || !props.organization.paid,
	          districtId: districtId,
	          sort: sort
	        });
	      }
	    ),
	    _react2.default.createElement(_AdminBillingBanner2.default, null)
	  );
	}
	
	var withOrganization = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  options: function options(_ref2) {
	    var params = _ref2.params;
	    return { variables: { organizationId: [params.districtId] } };
	  },
	  props: function props(_ref3) {
	    var data = _ref3.data;
	    return { organization: data.organizations ? data.organizations[0] : null };
	  }
	});
	
	exports.AdminSchools = AdminSchools;
	exports.default = withOrganization(AdminSchools);

/***/ },
/* 3247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SchoolTableBodyContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _redux = __webpack_require__(476);
	
	var _SchoolTableBody = __webpack_require__(3248);
	
	var _SchoolTableBody2 = _interopRequireDefault(_SchoolTableBody);
	
	var _schoolTables = __webpack_require__(3251);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var PER_PAGE = 20;
	
	var SchoolTableBodyContainer = function (_React$Component) {
	  _inherits(SchoolTableBodyContainer, _React$Component);
	
	  function SchoolTableBodyContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SchoolTableBodyContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SchoolTableBodyContainer.__proto__ || Object.getPrototypeOf(SchoolTableBodyContainer)).call.apply(_ref, [this].concat(args))), _this), _this.loadNextPage = function () {
	      return _this.loadPage(_this.props.page + 1);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SchoolTableBodyContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.initialized) {
	        this.props.initializeTable(this.props.districtId);
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var initialized = !this.props.initialized && nextProps.initialized;
	      var newSort = this.props.sort !== nextProps.sort;
	
	      if (initialized || newSort) {
	        this.loadPage(1, nextProps);
	      }
	    }
	  }, {
	    key: 'loadPage',
	    value: function loadPage(page, nextProps) {
	      var props = nextProps || this.props;
	
	      var sortOptions = {};
	
	      if (props.sort) {
	        switch (props.sort) {
	          case 'name_asc':
	            sortOptions = { sort: 'name', direction: 'asc' };
	            break;
	          case 'name_desc':
	            sortOptions = { sort: 'name', direction: 'desc' };
	            break;
	          default:
	        }
	      }
	
	      this.props.loadSchools(this.props.districtId, {
	        sortDirection: sortOptions.direction,
	        sort: sortOptions.sort,
	        perPage: PER_PAGE,
	        page: page
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.props.initialized) {
	        return _react2.default.createElement('tbody', null);
	      }
	
	      return _react2.default.createElement(_SchoolTableBody2.default, {
	        disabled: this.props.disabled,
	        schools: this.props.schools,
	        allLoaded: this.props.allLoaded,
	        loadNextPage: this.loadNextPage
	      });
	    }
	  }]);
	
	  return SchoolTableBodyContainer;
	}(_react2.default.Component);
	
	SchoolTableBodyContainer.displayName = 'SchoolTableBodyContainer';
	
	
	function mapStateToProps(state, props) {
	  var table = state.schoolTables.get(props.districtId);
	
	  if (!table) {
	    return { initialized: false };
	  }
	
	  return {
	    initialized: true,
	    page: table.page,
	    schools: table.schools,
	    loading: table.loading,
	    allLoaded: table.allLoaded
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  // $FlowFixMe
	  return (0, _redux.bindActionCreators)({ initializeTable: _schoolTables.initializeTable, loadSchools: _schoolTables.loadSchools }, dispatch);
	}
	
	exports.SchoolTableBodyContainer = SchoolTableBodyContainer;
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SchoolTableBodyContainer);

/***/ },
/* 3248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(1089);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _ScrollWatch = __webpack_require__(1238);
	
	var _ScrollWatch2 = _interopRequireDefault(_ScrollWatch);
	
	var _LoadingIndicator = __webpack_require__(1195);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	__webpack_require__(3249);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var SchoolTableBody = function (_React$Component) {
	  _inherits(SchoolTableBody, _React$Component);
	
	  function SchoolTableBody() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SchoolTableBody);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SchoolTableBody.__proto__ || Object.getPrototypeOf(SchoolTableBody)).call.apply(_ref, [this].concat(args))), _this), _this.go = function (school) {
	      return _this.context.router.push({ pathname: 'admin/schools/' + school.id });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SchoolTableBody, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var rows = this.props.schools.map(function (school) {
	        var statistics = school.getStatistics();
	        var onClick = _this2.props.disabled ? undefined : function () {
	          return _this2.go(school);
	        };
	        var classes = (0, _classnames2.default)('SchoolTableBody-row', {
	          'SchoolTableBody-row--enabled': !_this2.props.disabled
	        });
	
	        return _react2.default.createElement(
	          'tr',
	          { key: school.id, className: classes, onClick: onClick },
	          _react2.default.createElement(
	            'td',
	            null,
	            school.getName()
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            statistics && statistics.teacher_count
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            statistics && statistics.parent_count
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            statistics && statistics.class_count
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            statistics && statistics.message_count
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        'tbody',
	        null,
	        rows,
	        !this.props.allLoaded && _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'td',
	            { colSpan: 99, className: 'PeopleTableBody-loading' },
	            _react2.default.createElement(
	              _ScrollWatch2.default,
	              { onEnter: this.props.loadNextPage, threshold: 0.2 },
	              _react2.default.createElement(_LoadingIndicator2.default, { size: 'large' })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SchoolTableBody;
	}(_react2.default.Component);
	
	SchoolTableBody.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	SchoolTableBody.displayName = 'SchoolTableBody';
	exports.default = SchoolTableBody;

/***/ },
/* 3249 */
1136,
/* 3250 */,
/* 3251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// typecheck: ignore file
	
	
	exports.default = reducer;
	exports.initializeTable = initializeTable;
	exports.loadSchools = loadSchools;
	exports.loadSchoolsSuccess = loadSchoolsSuccess;
	
	var _immutable = __webpack_require__(949);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = new _immutable.Map();
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'schoolTables/INITIALIZE_TABLE':
	      {
	        return state.set(action.districtId, {
	          page: 1,
	          schools: [],
	          loading: false,
	          allLoaded: false
	        });
	      }
	
	    case 'schoolTables/LOAD_SCHOOLS_REQUEST':
	      {
	        var table = state.get(action.districtId);
	        return state.set(action.districtId, _extends({}, table, {
	          loading: true
	        }));
	      }
	
	    case 'schoolTables/LOAD_SCHOOLS_SUCCESS':
	      {
	        var _table = state.get(action.districtId);
	        return state.set(action.districtId, _extends({}, _table, {
	          loading: false,
	          page: action.options.page,
	          allLoaded: action.schools.length < action.options.perPage,
	          schools: action.options.page === 1 ? action.schools : [].concat(_table.schools, action.schools)
	        }));
	      }
	
	    default:
	      {
	        return state;
	      }
	  }
	}
	
	function initializeTable(districtId) {
	  return {
	    type: 'schoolTables/INITIALIZE_TABLE',
	    districtId: districtId
	  };
	}
	
	function loadSchools(districtId, options) {
	  return {
	    type: 'schoolTables/LOAD_SCHOOLS_REQUEST',
	    districtId: districtId,
	    options: options
	  };
	}
	
	function loadSchoolsSuccess(districtId, schools, options) {
	  return {
	    type: 'schoolTables/LOAD_SCHOOLS_SUCCESS',
	    districtId: districtId,
	    schools: schools,
	    options: options
	  };
	}

/***/ },
/* 3252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DistrictStatistics = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// typecheck: ignore file
	
	
	var _templateObject = _taggedTemplateLiteral(['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      statistics {\n        teacher_count\n        parent_count\n        class_count\n        message_count\n      }\n    }\n  }'], ['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      statistics {\n        teacher_count\n        parent_count\n        class_count\n        message_count\n      }\n    }\n  }']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _reactApollo = __webpack_require__(467);
	
	var _Statistic = __webpack_require__(3253);
	
	var _Statistic2 = _interopRequireDefault(_Statistic);
	
	__webpack_require__(3256);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var DistrictStatistic = function DistrictStatistic(props) {
	  return _react2.default.createElement(_Statistic2.default, _extends({ block: true, nameColor: 'thunder', size: 'xxxxlarge' }, props));
	};
	
	function DistrictStatistics(props) {
	  var organization = props.organization;
	
	
	  if (!organization) {
	    return _react2.default.createElement('div', { className: 'DistrictStatistics' });
	  }
	
	  var statistics = organization.statistics;
	
	
	  var stats = {
	    teacher_count: statistics ? statistics.teacher_count : 0,
	    parent_count: statistics ? statistics.parent_count : 0,
	    class_count: statistics ? statistics.class_count : 0,
	    message_count: statistics ? statistics.message_count : 0
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'DistrictStatistics' },
	    _react2.default.createElement(DistrictStatistic, { name: 'Teachers', value: stats.teacher_count }),
	    _react2.default.createElement(DistrictStatistic, { name: 'Parents', value: stats.parent_count }),
	    _react2.default.createElement(DistrictStatistic, { name: 'Classes', value: stats.class_count }),
	    _react2.default.createElement(DistrictStatistic, { name: 'Announcements', value: stats.message_count })
	  );
	}
	
	var withOrganizationStatistics = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  options: function options(_ref) {
	    var organizationId = _ref.organizationId;
	    return {
	      variables: { organizationId: [organizationId] }
	    };
	  },
	  props: function props(_ref2) {
	    var data = _ref2.data;
	    return _extends({
	      organization: data.organizations ? data.organizations[0] : null
	    }, data);
	  }
	});
	
	exports.DistrictStatistics = DistrictStatistics;
	exports.default = withOrganizationStatistics(DistrictStatistics);

/***/ },
/* 3253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	__webpack_require__(3254);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sizes = ['xxxxxsmall', 'xxxxsmall', 'xxxsmall', 'xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge', 'xxxxlarge'];
	// typecheck: ignore file
	
	
	function Statistic(props) {
	  var valueSize = props.size || 'xlarge';
	  var nameSize = sizes[sizes.indexOf(valueSize) - 3];
	  var element = props.block ? 'div' : 'span';
	
	  return _react2.default.createElement(
	    'span',
	    { className: 'Statistic' },
	    _react2.default.createElement(
	      _Text2.default,
	      { element: element, size: valueSize, className: 'Statistic-value' },
	      props.value
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      { element: element, size: nameSize, color: props.nameColor },
	      props.name
	    )
	  );
	}
	
	exports.default = Statistic;

/***/ },
/* 3254 */
1136,
/* 3255 */,
/* 3256 */
1136,
/* 3257 */,
/* 3258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdminBillingBanner = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      paid\n      type\n    }\n  }'], ['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      paid\n      type\n    }\n  }']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _reactApollo = __webpack_require__(467);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Link = __webpack_require__(1155);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(3259);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// typecheck: ignore file
	
	
	function _AdminBillingBanner(props) {
	  if (!props.organization || props.organization.paid) {
	    return null;
	  }
	
	  var link = props.organization.type === 'School' ? '/admin/schools/' + props.organizationId + '/billing/overview' : '/admin/districts/' + props.organizationId + '/billing/overview';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'AdminBillingBanner' },
	    _react2.default.createElement(
	      'div',
	      { className: 'AdminBillingBanner-content' },
	      _react2.default.createElement(
	        _Text2.default,
	        { element: 'div', size: 'xlarge' },
	        'Manage your community and gain powerful insight.'
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        { element: 'div', size: 'large' },
	        'The Admin Console is a premium feature for connected schools and districts. Click below to learn more.'
	      ),
	      _react2.default.createElement(
	        _Text2.default,
	        null,
	        _react2.default.createElement(
	          _Link2.default,
	          { to: link },
	          _react2.default.createElement(
	            _Button2.default,
	            { inline: true, color: 'white' },
	            'Get the Admin Console'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Link2.default,
	        { to: '/classes', color: 'white' },
	        'Go to Remind'
	      )
	    )
	  );
	}
	
	var AdminBillingBanner = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  options: function options(_ref) {
	    var organizationId = _ref.organizationId;
	    return { variables: { organizationId: [organizationId] } };
	  },
	  props: function props(_ref2) {
	    var data = _ref2.data;
	    return { organization: data.organizations ? data.organizations[0] : null };
	  }
	})(_AdminBillingBanner);
	
	function AdminBillingBannerWrapper(_props, context) {
	  var router = context.router;
	  var _router$params = router.params,
	      schoolId = _router$params.schoolId,
	      districtId = _router$params.districtId;
	
	
	  return _react2.default.createElement(AdminBillingBanner, { organizationId: Number(schoolId || districtId) });
	}
	
	AdminBillingBannerWrapper.contextTypes = {
	  router: _react2.default.PropTypes.object.isRequired
	};
	
	exports.AdminBillingBanner = _AdminBillingBanner;
	exports.default = AdminBillingBannerWrapper;

/***/ },
/* 3259 */
1136,
/* 3260 */,
/* 3261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AdminSchoolHeader = __webpack_require__(3262);
	
	var _AdminSchoolHeader2 = _interopRequireDefault(_AdminSchoolHeader);
	
	var _AdminSchoolNav = __webpack_require__(3268);
	
	var _AdminSchoolNav2 = _interopRequireDefault(_AdminSchoolNav);
	
	var _AdminBillingBanner = __webpack_require__(3258);
	
	var _AdminBillingBanner2 = _interopRequireDefault(_AdminBillingBanner);
	
	__webpack_require__(3271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SchoolInfomationLayout(props) {
	  var params = props.params;
	  var schoolId = params.schoolId;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'SchoolInfomationLayout' },
	    _react2.default.createElement(_AdminSchoolHeader2.default, { 'data-test': 'admin-school-header', schoolId: Number(schoolId) }),
	    _react2.default.createElement(
	      'div',
	      { className: 'SchoolInfomationLayout-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'SchoolInfomationLayout-content-nav' },
	        _react2.default.createElement(_AdminSchoolNav2.default, { schoolId: Number(schoolId) })
	      ),
	      props.children,
	      _react2.default.createElement(_AdminBillingBanner2.default, null)
	    )
	  );
	}
	// typecheck: ignore file
	exports.default = SchoolInfomationLayout;

/***/ },
/* 3262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdminSchoolHeader = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  ', '\n\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      name\n      paid\n      class {\n        ...classesDefaults\n      }\n    }\n  }\n  '], ['\n  ', '\n\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      name\n      paid\n      class {\n        ...classesDefaults\n      }\n    }\n  }\n  ']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _classesDefaultsFragment = __webpack_require__(995);
	
	var _classesDefaultsFragment2 = _interopRequireDefault(_classesDefaultsFragment);
	
	var _Group = __webpack_require__(606);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Heading = __webpack_require__(1436);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _InviteButton = __webpack_require__(2426);
	
	var _InviteButton2 = _interopRequireDefault(_InviteButton);
	
	var _SchoolStatistics = __webpack_require__(3263);
	
	var _SchoolStatistics2 = _interopRequireDefault(_SchoolStatistics);
	
	var _reactApollo = __webpack_require__(467);
	
	__webpack_require__(3266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// typecheck: ignore file
	
	
	function AdminSchoolHeader(props) {
	  var organization = props.organization,
	      schoolId = props.schoolId;
	
	  var groupEntity = organization && organization.class && _Group2.default.fromJSON(organization.class);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'AdminSchoolHeader' },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Heading2.default,
	        { level: '1' },
	        _react2.default.createElement(
	          _Text2.default,
	          { size: 'xlarge', weight: 'semibold' },
	          organization ? organization.name : _react2.default.createElement(
	            'span',
	            null,
	            '\xA0'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'AdminSchoolHeader-stats' },
	        _react2.default.createElement(_SchoolStatistics2.default, { organizationId: schoolId })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'AdminSchoolHeader-action' },
	      organization && organization.paid && groupEntity && _react2.default.createElement(_InviteButton2.default, { group: groupEntity, forceType: 'button' })
	    )
	  );
	}
	
	var withOrganizationAndClass = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject, _classesDefaultsFragment2.default), {
	  options: function options(_ref) {
	    var schoolId = _ref.schoolId;
	    return {
	      variables: { organizationId: [schoolId] }
	    };
	  },
	  props: function props(_ref2) {
	    var data = _ref2.data;
	    return {
	      organization: data.organizations ? data.organizations[0] : null
	    };
	  }
	});
	
	exports.AdminSchoolHeader = AdminSchoolHeader;
	exports.default = withOrganizationAndClass(AdminSchoolHeader);

/***/ },
/* 3263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SchoolStatistics = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      statistics {\n        teacher_count\n        student_count\n        parent_count\n        message_count\n      }\n    }\n  }\n  '], ['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      statistics {\n        teacher_count\n        student_count\n        parent_count\n        message_count\n      }\n    }\n  }\n  ']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _reactApollo = __webpack_require__(467);
	
	var _Statistic = __webpack_require__(3253);
	
	var _Statistic2 = _interopRequireDefault(_Statistic);
	
	__webpack_require__(3264);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	// typecheck: ignore file
	
	
	function SchoolStatistics(props) {
	  var _props$data = props.data,
	      loading = _props$data.loading,
	      organizations = _props$data.organizations;
	
	
	  if (loading || !organizations) {
	    return null;
	  }
	
	  var statistics = organizations[0].statistics;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'SchoolStatistics' },
	    _react2.default.createElement(_Statistic2.default, { name: 'Teachers', value: statistics.teacher_count }),
	    _react2.default.createElement(_Statistic2.default, { name: 'Parents', value: statistics.parent_count }),
	    _react2.default.createElement(_Statistic2.default, { name: 'Students', value: statistics.student_count }),
	    _react2.default.createElement(_Statistic2.default, { name: 'Announcements', value: statistics.message_count })
	  );
	}
	
	var withOrganizationStatistics = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  options: function options(_ref) {
	    var organizationId = _ref.organizationId;
	    return {
	      variables: { organizationId: [organizationId] }
	    };
	  }
	});
	
	exports.SchoolStatistics = SchoolStatistics;
	exports.default = withOrganizationStatistics(SchoolStatistics);

/***/ },
/* 3264 */
1136,
/* 3265 */,
/* 3266 */
1136,
/* 3267 */,
/* 3268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavItem = __webpack_require__(2997);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	__webpack_require__(3269);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AdminSchoolNav(props) {
	  return _react2.default.createElement(
	    'ul',
	    { className: 'AdminSchoolNav' },
	    _react2.default.createElement(
	      _NavItem2.default,
	      { to: '/admin/schools/' + props.schoolId + '/information/people' },
	      'People'
	    ),
	    _react2.default.createElement(
	      _NavItem2.default,
	      { to: '/admin/schools/' + props.schoolId + '/information/classes' },
	      'Classes'
	    )
	  );
	}
	// typecheck: ignore file
	exports.default = AdminSchoolNav;

/***/ },
/* 3269 */
1136,
/* 3270 */,
/* 3271 */
1136,
/* 3272 */,
/* 3273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AdminBillingOverview = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      name\n      paid\n    }\n  }'], ['\n  query($organizationId: Int) {\n    organizations(ids: [$organizationId]) {\n      id\n      name\n      paid\n    }\n  }']);
	
	var _react = __webpack_require__(299);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphqlTag = __webpack_require__(613);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _Text = __webpack_require__(1285);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Button = __webpack_require__(1194);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _reactApollo = __webpack_require__(467);
	
	var _CenteredLoadingIndicator = __webpack_require__(2239);
	
	var _CenteredLoadingIndicator2 = _interopRequireDefault(_CenteredLoadingIndicator);
	
	var _invariant = __webpack_require__(469);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	var _toasts = __webpack_require__(948);
	
	var _redux = __webpack_require__(476);
	
	var _reactRedux = __webpack_require__(1113);
	
	var _MailTo = __webpack_require__(1429);
	
	var _MailTo2 = _interopRequireDefault(_MailTo);
	
	__webpack_require__(3274);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// typecheck: ignore file
	
	
	var AdminBillingOverview = function (_React$Component) {
	  _inherits(AdminBillingOverview, _React$Component);
	
	  function AdminBillingOverview() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AdminBillingOverview);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminBillingOverview.__proto__ || Object.getPrototypeOf(AdminBillingOverview)).call.apply(_ref, [this].concat(args))), _this), _this.requestInformation = function () {
	      var organization = _this.props.organization;
	
	      (0, _invariant2.default)(organization, 'organization cannot be null in click handler');
	
	      return _RemindAPI2.default.request('/organizations/' + organization.id + '/get_admin_console_promo', 'post').then(function () {
	        return _this.props.showToast('Your request has been sent! We‘ll be in touch', 'success');
	      }, function (error) {
	        return error && error.code === 'throttling_error' ? _this.props.showToast('Your request has been sent! We‘ll be in touch', 'success') : _this.props.showAPIErrorToast(error);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AdminBillingOverview, [{
	    key: 'render',
	    value: function render() {
	      var organization = this.props.organization;
	
	
	      if (!organization) {
	        return _react2.default.createElement(_CenteredLoadingIndicator2.default, null);
	      }
	
	      if (!organization.paid) {
	        console.error('admin billing page - paid only account should to here');
	        return _react2.default.createElement(
	          'span',
	          null,
	          'Oh, oh. You should not be here, something weird happened.'
	        );
	      }
	
	      var Mail = function Mail(props) {
	        return _react2.default.createElement(
	          _MailTo2.default,
	          { to: 'districts@remind101.com', subject: organization.name + ' - Billing assistance' },
	          props.children
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AdminBillingOverview' },
	        _react2.default.createElement(
	          'div',
	          { className: 'AdminBillingOverview-info' },
	          _react2.default.createElement(
	            _Text2.default,
	            { element: 'div' },
	            'Your are on the ',
	            _react2.default.createElement(
	              _Text2.default,
	              { weight: 'semibold' },
	              'Remind Plus plan'
	            ),
	            ' which includes access to the admin console.'
	          ),
	          _react2.default.createElement(
	            _Text2.default,
	            { element: 'div' },
	            'Contact our ',
	            _react2.default.createElement(
	              Mail,
	              null,
	              'Operations team'
	            ),
	            ' to dicuss details about your plan.'
	          )
	        ),
	        _react2.default.createElement(
	          Mail,
	          null,
	          _react2.default.createElement(
	            _Button2.default,
	            null,
	            'Contact us'
	          )
	        )
	      );
	    }
	  }]);
	
	  return AdminBillingOverview;
	}(_react2.default.Component);
	
	AdminBillingOverview.displayName = 'AdminBillingOverview';
	
	
	var withOrganization = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(_templateObject), {
	  options: function options(_ref2) {
	    var params = _ref2.params;
	    return {
	      variables: { organizationId: [params.schoolId || params.districtId] }
	    };
	  },
	  props: function props(_ref3) {
	    var data = _ref3.data;
	    return _extends({
	      organization: data.organizations ? data.organizations[0] : null
	    }, data);
	  }
	});
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)({ showToast: _toasts.showToast, showAPIErrorToast: _toasts.showAPIErrorToast }, dispatch);
	}
	
	exports.AdminBillingOverview = AdminBillingOverview;
	exports.default = withOrganization((0, _reactRedux.connect)(undefined, mapDispatchToProps)(AdminBillingOverview));

/***/ },
/* 3274 */
1136,
/* 3275 */,
/* 3276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.apolloClient = undefined;
	
	var _redux = __webpack_require__(476);
	
	var _reduxDevtoolsExtension = __webpack_require__(3277);
	
	var _Dispatcher = __webpack_require__(590);
	
	var _reduxSaga = __webpack_require__(3278);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _reducer = __webpack_require__(3290);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _sagas = __webpack_require__(3292);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	var _graphql = __webpack_require__(615);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// XXX this is all module global state which will prevent SSR
	
	// create the saga middleware
	var sagaMiddleware = (0, _reduxSaga2.default)();
	
	// mount it on the Store
	
	var store = (0, _redux.createStore)((0, _reducer2.default)(_graphql.apolloClient.reducer()), (0, _reduxDevtoolsExtension.composeWithDevTools)((0, _redux.applyMiddleware)(sagaMiddleware, _graphql.apolloClient.middleware())));
	
	_Dispatcher.reduxDispatcher.setDispatch(store.dispatch);
	
	// $FlowFixMe ¯\_(ツ)_/¯
	sagaMiddleware.run(_sagas2.default);
	
	exports.apolloClient = _graphql.apolloClient;
	exports.default = store;

/***/ },
/* 3277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.composeWithDevTools = (
	  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
	    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
	    function() {
	      if (arguments.length === 0) return undefined;
	      var compose = __webpack_require__(476).compose;
	      if (typeof arguments[0] === 'object') return compose;
	      return compose.apply(null, arguments);
	    }
	);


/***/ },
/* 3278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.utils = exports.effects = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;
	
	var _runSaga = __webpack_require__(3279);
	
	Object.defineProperty(exports, 'runSaga', {
	  enumerable: true,
	  get: function get() {
	    return _runSaga.runSaga;
	  }
	});
	
	var _channel = __webpack_require__(3284);
	
	Object.defineProperty(exports, 'END', {
	  enumerable: true,
	  get: function get() {
	    return _channel.END;
	  }
	});
	Object.defineProperty(exports, 'eventChannel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.eventChannel;
	  }
	});
	Object.defineProperty(exports, 'channel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.channel;
	  }
	});
	
	var _buffers = __webpack_require__(3285);
	
	Object.defineProperty(exports, 'buffers', {
	  enumerable: true,
	  get: function get() {
	    return _buffers.buffers;
	  }
	});
	
	var _sagaHelpers = __webpack_require__(3286);
	
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.throttle;
	  }
	});
	
	var _utils = __webpack_require__(3280);
	
	Object.defineProperty(exports, 'delay', {
	  enumerable: true,
	  get: function get() {
	    return _utils.delay;
	  }
	});
	Object.defineProperty(exports, 'CANCEL', {
	  enumerable: true,
	  get: function get() {
	    return _utils.CANCEL;
	  }
	});
	
	var _middleware = __webpack_require__(3287);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	var _effects = __webpack_require__(3288);
	
	var effects = _interopRequireWildcard(_effects);
	
	var _utils2 = __webpack_require__(3289);
	
	var utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _middleware2.default;
	exports.effects = effects;
	exports.utils = utils;

/***/ },
/* 3279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.runSaga = runSaga;
	
	var _utils = __webpack_require__(3280);
	
	var _proc = __webpack_require__(3281);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function runSaga(iterator, _ref) {
	  var subscribe = _ref.subscribe,
	      dispatch = _ref.dispatch,
	      getState = _ref.getState,
	      sagaMonitor = _ref.sagaMonitor,
	      logger = _ref.logger;
	
	
	  (0, _utils.check)(iterator, _utils.is.iterator, "runSaga must be called on an iterator");
	
	  var effectId = (0, _utils.uid)();
	  if (sagaMonitor) {
	    dispatch = (0, _utils.wrapSagaDispatch)(dispatch);
	    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: iterator, args: [] } });
	  }
	  var task = (0, _proc2.default)(iterator, subscribe, dispatch, getState, { sagaMonitor: sagaMonitor, logger: logger }, effectId, iterator.name);
	
	  if (sagaMonitor) {
	    sagaMonitor.effectResolved(effectId, task);
	  }
	
	  return task;
	}

/***/ },
/* 3280 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.check = check;
	exports.remove = remove;
	exports.deferred = deferred;
	exports.arrayOfDeffered = arrayOfDeffered;
	exports.delay = delay;
	exports.createMockTask = createMockTask;
	exports.autoInc = autoInc;
	exports.makeIterator = makeIterator;
	exports.log = log;
	exports.wrapSagaDispatch = wrapSagaDispatch;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var sym = exports.sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	var TASK = exports.TASK = sym('TASK');
	var HELPER = exports.HELPER = sym('HELPER');
	var MATCH = exports.MATCH = sym('MATCH');
	var CANCEL = exports.CANCEL = sym('cancelPromise');
	var SAGA_ACTION = exports.SAGA_ACTION = sym('SAGA_ACTION');
	var konst = exports.konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = exports.kTrue = konst(true);
	var kFalse = exports.kFalse = konst(false);
	var noop = exports.noop = function noop() {};
	var ident = exports.ident = function ident(v) {
	  return v;
	};
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var is = exports.is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  array: Array.isArray,
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (typeof pat === 'string' || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  },
	  channel: function channel(ch) {
	    return ch && is.func(ch.take) && is.func(ch.close);
	  },
	  helper: function helper(it) {
	    return it && it[HELPER];
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	function deferred() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _defineProperty(_ref, TASK, true), _defineProperty(_ref, 'isRunning', function isRunning() {
	    return running;
	  }), _defineProperty(_ref, 'result', function result() {
	    return _result;
	  }), _defineProperty(_ref, 'error', function error() {
	    return _error;
	  }), _defineProperty(_ref, 'setRunning', function setRunning(b) {
	    return running = b;
	  }), _defineProperty(_ref, 'setResult', function setResult(r) {
	    return _result = r;
	  }), _defineProperty(_ref, 'setError', function setError(e) {
	    return _error = e;
	  }), _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = exports.uid = autoInc();
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	var kReturn = function kReturn(value) {
	  return { value: value, done: true };
	};
	function makeIterator(next) {
	  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var isHelper = arguments[3];
	
	  var iterator = { name: name, next: next, throw: thro, return: kReturn };
	
	  if (isHelper) {
	    iterator[HELPER] = true;
	  }
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message, error) {
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level](message, error);
	  }
	}
	
	var internalErr = exports.internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};
	
	function wrapSagaDispatch(dispatch) {
	  return function sagaDispatch(action) {
	    var wrappedAction = Object.defineProperty(action, SAGA_ACTION, { value: true });
	    return dispatch(wrappedAction);
	  };
	}

/***/ },
/* 3281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
	exports.default = proc;
	
	var _utils = __webpack_require__(3280);
	
	var _scheduler = __webpack_require__(3282);
	
	var _io = __webpack_require__(3283);
	
	var _channel = __webpack_require__(3284);
	
	var _buffers = __webpack_require__(3285);
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var isDev = ("production") === 'development';
	
	var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';
	
	var CHANNEL_END = exports.CHANNEL_END = {
	  toString: function toString() {
	    return '@@redux-saga/CHANNEL_END';
	  }
	};
	var TASK_CANCEL = exports.TASK_CANCEL = {
	  toString: function toString() {
	    return '@@redux-saga/TASK_CANCEL';
	  }
	};
	
	var matchers = {
	  wildcard: function wildcard() {
	    return _utils.kTrue;
	  },
	  default: function _default(pattern) {
	    return function (input) {
	      return input.type === pattern;
	    };
	  },
	  array: function array(patterns) {
	    return function (input) {
	      return patterns.some(function (p) {
	        return p === input.type;
	      });
	    };
	  },
	  predicate: function predicate(_predicate) {
	    return function (input) {
	      return _predicate(input);
	    };
	  }
	};
	
	function matcher(pattern) {
	  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
	}
	
	/**
	  Used to track a parent task and its forks
	  In the new fork model, forked tasks are attached by default to their parent
	  We model this using the concept of Parent task && main Task
	  main task is the main flow of the current Generator, the parent tasks is the
	  aggregation of the main tasks + all its forked tasks.
	  Thus the whole model represents an execution tree with multiple branches (vs the
	  linear execution tree in sequential (non parallel) programming)
	
	  A parent tasks has the following semantics
	  - It completes iff all its forks either complete or all cancelled
	  - If it's cancelled, all forks are cancelled as well
	  - It aborts if any uncaught error bubbles up from forks
	  - If it completes, the return value is the one returned by the main task
	**/
	function forkQueue(name, mainTask, cb) {
	  var tasks = [],
	      result = void 0,
	      completed = false;
	  addTask(mainTask);
	
	  function abort(err) {
	    cancelAll();
	    cb(err, true);
	  }
	
	  function addTask(task) {
	    tasks.push(task);
	    task.cont = function (res, isErr) {
	      if (completed) {
	        return;
	      }
	
	      (0, _utils.remove)(tasks, task);
	      task.cont = _utils.noop;
	      if (isErr) {
	        abort(res);
	      } else {
	        if (task === mainTask) {
	          result = res;
	        }
	        if (!tasks.length) {
	          completed = true;
	          cb(result);
	        }
	      }
	    };
	    // task.cont.cancel = task.cancel
	  }
	
	  function cancelAll() {
	    if (completed) {
	      return;
	    }
	    completed = true;
	    tasks.forEach(function (t) {
	      t.cont = _utils.noop;
	      t.cancel();
	    });
	    tasks = [];
	  }
	
	  return {
	    addTask: addTask,
	    cancelAll: cancelAll,
	    abort: abort,
	    getTasks: function getTasks() {
	      return tasks;
	    },
	    taskNames: function taskNames() {
	      return tasks.map(function (t) {
	        return t.name;
	      });
	    }
	  };
	}
	
	function createTaskIterator(_ref) {
	  var context = _ref.context,
	      fn = _ref.fn,
	      args = _ref.args;
	
	  if (_utils.is.iterator(fn)) {
	    return fn;
	  }
	
	  // catch synchronous failures; see #152 and #441
	  var result = void 0,
	      error = void 0;
	  try {
	    result = fn.apply(context, args);
	  } catch (err) {
	    error = err;
	  }
	
	  // i.e. a generator function returns an iterator
	  if (_utils.is.iterator(result)) {
	    return result;
	  }
	
	  // do not bubble up synchronous failures for detached forks
	  // instead create a failed task. See #152 and #441
	  return error ? (0, _utils.makeIterator)(function () {
	    throw error;
	  }) : (0, _utils.makeIterator)(function () {
	    var pc = void 0;
	    var eff = { done: false, value: result };
	    var ret = function ret(value) {
	      return { done: true, value: value };
	    };
	    return function (arg) {
	      if (!pc) {
	        pc = true;
	        return eff;
	      } else {
	        return ret(arg);
	      }
	    };
	  }());
	}
	
	function wrapHelper(helper) {
	  return {
	    fn: helper
	  };
	}
	
	function proc(iterator) {
	  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return _utils.noop;
	  };
	  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;
	  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;
	  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	  var parentEffectId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	  var name = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'anonymous';
	  var cont = arguments[7];
	
	  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	  var log = logger || _utils.log;
	  var stdChannel = (0, _channel.stdChannel)(subscribe);
	  /**
	    Tracks the current effect cancellation
	    Each time the generator progresses. calling runEffect will set a new value
	    on it. It allows propagating cancellation to child effects
	  **/
	  next.cancel = _utils.noop;
	
	  /**
	    Creates a new task descriptor for this generator, We'll also create a main task
	    to track the main flow (besides other forked tasks)
	  **/
	  var task = newTask(parentEffectId, name, iterator, cont);
	  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
	  var taskQueue = forkQueue(name, mainTask, end);
	
	  /**
	    cancellation of the main task. We'll simply resume the Generator with a Cancel
	  **/
	  function cancelMain() {
	    if (mainTask.isRunning && !mainTask.isCancelled) {
	      mainTask.isCancelled = true;
	      next(TASK_CANCEL);
	    }
	  }
	
	  /**
	    This may be called by a parent generator to trigger/propagate cancellation
	    cancel all pending tasks (including the main task), then end the current task.
	      Cancellation propagates down to the whole execution tree holded by this Parent task
	    It's also propagated to all joiners of this task and their execution tree/joiners
	      Cancellation is noop for terminated/Cancelled tasks tasks
	  **/
	  function cancel() {
	    /**
	      We need to check both Running and Cancelled status
	      Tasks can be Cancelled but still Running
	    **/
	    if (iterator._isRunning && !iterator._isCancelled) {
	      iterator._isCancelled = true;
	      taskQueue.cancelAll();
	      /**
	        Ending with a Never result will propagate the Cancellation to all joiners
	      **/
	      end(TASK_CANCEL);
	    }
	  }
	  /**
	    attaches cancellation logic to this task's continuation
	    this will permit cancellation to propagate down the call chain
	  **/
	  cont && (cont.cancel = cancel);
	
	  // tracks the running status
	  iterator._isRunning = true;
	
	  // kicks up the generator
	  next();
	
	  // then return the task descriptor to the caller
	  return task;
	
	  /**
	    This is the generator driver
	    It's a recursive async/continuation function which calls itself
	    until the generator terminates or throws
	  **/
	  function next(arg, isErr) {
	    // Preventive measure. If we end up here, then there is really something wrong
	    if (!mainTask.isRunning) {
	      throw new Error('Trying to resume an already finished generator');
	    }
	
	    try {
	      var result = void 0;
	      if (isErr) {
	        result = iterator.throw(arg);
	      } else if (arg === TASK_CANCEL) {
	        /**
	          getting TASK_CANCEL autoamtically cancels the main task
	          We can get this value here
	            - By cancelling the parent task manually
	          - By joining a Cancelled task
	        **/
	        mainTask.isCancelled = true;
	        /**
	          Cancels the current effect; this will propagate the cancellation down to any called tasks
	        **/
	        next.cancel();
	        /**
	          If this Generator has a `return` method then invokes it
	          Thill will jump to the finally block
	        **/
	        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
	      } else if (arg === CHANNEL_END) {
	        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
	        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
	      } else {
	        result = iterator.next(arg);
	      }
	
	      if (!result.done) {
	        runEffect(result.value, parentEffectId, '', next);
	      } else {
	        /**
	          This Generator has ended, terminate the main task and notify the fork queue
	        **/
	        mainTask.isMainRunning = false;
	        mainTask.cont && mainTask.cont(result.value);
	      }
	    } catch (error) {
	      if (mainTask.isCancelled) {
	        log('error', 'uncaught at ' + name, error.message);
	      }
	      mainTask.isMainRunning = false;
	      mainTask.cont(error, true);
	    }
	  }
	
	  function end(result, isErr) {
	    iterator._isRunning = false;
	    stdChannel.close();
	    if (!isErr) {
	      if (result === TASK_CANCEL && isDev) {
	        log('info', name + ' has been cancelled', '');
	      }
	      iterator._result = result;
	      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
	    } else {
	      if (result instanceof Error) {
	        result.sagaStack = 'at ' + name + ' \n ' + (result.sagaStack || result.stack);
	      }
	      if (!task.cont) {
	        log('error', 'uncaught', result.sagaStack || result.stack);
	        if (result instanceof Error && onError) {
	          onError(result);
	        }
	      }
	      iterator._error = result;
	      iterator._isAborted = true;
	      iterator._deferredEnd && iterator._deferredEnd.reject(result);
	    }
	    task.cont && task.cont(result, isErr);
	    task.joiners.forEach(function (j) {
	      return j.cb(result, isErr);
	    });
	    task.joiners = null;
	  }
	
	  function runEffect(effect, parentEffectId) {
	    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var cb = arguments[3];
	
	    var effectId = (0, _utils.uid)();
	    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });
	
	    /**
	      completion callback and cancel callback are mutually exclusive
	      We can't cancel an already completed effect
	      And We can't complete an already cancelled effectId
	    **/
	    var effectSettled = void 0;
	
	    // Completion callback passed to the appropriate effect runner
	    function currCb(res, isErr) {
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      cb.cancel = _utils.noop; // defensive measure
	      if (sagaMonitor) {
	        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
	      }
	
	      cb(res, isErr);
	    }
	    // tracks down the current cancel
	    currCb.cancel = _utils.noop;
	
	    // setup cancellation logic on the parent cb
	    cb.cancel = function () {
	      // prevents cancelling an already completed effect
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      /**
	        propagates cancel downward
	        catch uncaught cancellations errors; since we can no longer call the completion
	        callback, log errors raised during cancellations into the console
	      **/
	      try {
	        currCb.cancel();
	      } catch (err) {
	        log('error', 'uncaught at ' + name, err.message);
	      }
	      currCb.cancel = _utils.noop; // defensive measure
	
	      sagaMonitor && sagaMonitor.effectCancelled(effectId);
	    };
	
	    /**
	      each effect runner must attach its own logic of cancellation to the provided callback
	      it allows this generator to propagate cancellation downward.
	        ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
	      And the setup must occur before calling the callback
	        This is a sort of inversion of control: called async functions are responsible
	      of completing the flow by calling the provided continuation; while caller functions
	      are responsible for aborting the current flow by calling the attached cancel function
	        Library users can attach their own cancellation logic to promises by defining a
	      promise[CANCEL] method in their returned promises
	      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
	    **/
	    var data = void 0;
	    return (
	      // Non declarative effect
	      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)
	
	      // declarative effects
	      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : _utils.is.notUndef(data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : _utils.is.notUndef(data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : /* anything else returned as is        */currCb(effect)
	    );
	  }
	
	  function resolvePromise(promise, cb) {
	    var cancelPromise = promise[_utils.CANCEL];
	    if (typeof cancelPromise === 'function') {
	      cb.cancel = cancelPromise;
	    }
	    promise.then(cb, function (error) {
	      return cb(error, true);
	    });
	  }
	
	  function resolveIterator(iterator, effectId, name, cb) {
	    proc(iterator, subscribe, dispatch, getState, options, effectId, name, cb);
	  }
	
	  function runTakeEffect(_ref2, cb) {
	    var channel = _ref2.channel,
	        pattern = _ref2.pattern,
	        maybe = _ref2.maybe;
	
	    channel = channel || stdChannel;
	    var takeCb = function takeCb(inp) {
	      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
	    };
	    try {
	      channel.take(takeCb, matcher(pattern));
	    } catch (err) {
	      return cb(err, true);
	    }
	    cb.cancel = takeCb.cancel;
	  }
	
	  function runPutEffect(_ref3, cb) {
	    var channel = _ref3.channel,
	        action = _ref3.action,
	        sync = _ref3.sync;
	
	    /**
	      Schedule the put in case another saga is holding a lock.
	      The put will be executed atomically. ie nested puts will execute after
	      this put has terminated.
	    **/
	    (0, _scheduler.asap)(function () {
	      var result = void 0;
	      try {
	        result = (channel ? channel.put : dispatch)(action);
	      } catch (error) {
	        // If we have a channel or `put.sync` was used then bubble up the error.
	        if (channel || sync) return cb(error, true);
	        log('error', 'uncaught at ' + name, error.stack || error.message || error);
	      }
	
	      if (sync && _utils.is.promise(result)) {
	        resolvePromise(result, cb);
	      } else {
	        return cb(result);
	      }
	    });
	    // Put effects are non cancellables
	  }
	
	  function runCallEffect(_ref4, effectId, cb) {
	    var context = _ref4.context,
	        fn = _ref4.fn,
	        args = _ref4.args;
	
	    var result = void 0;
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (error) {
	      return cb(error, true);
	    }
	    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
	  }
	
	  function runCPSEffect(_ref5, cb) {
	    var context = _ref5.context,
	        fn = _ref5.fn,
	        args = _ref5.args;
	
	    // CPS (ie node style functions) can define their own cancellation logic
	    // by setting cancel field on the cb
	
	    // catch synchronous failures; see #152
	    try {
	      (function () {
	        var cpsCb = function cpsCb(err, res) {
	          return _utils.is.undef(err) ? cb(res) : cb(err, true);
	        };
	        fn.apply(context, args.concat(cpsCb));
	        if (cpsCb.cancel) {
	          cb.cancel = function () {
	            return cpsCb.cancel();
	          };
	        }
	      })();
	    } catch (error) {
	      return cb(error, true);
	    }
	  }
	
	  function runForkEffect(_ref6, effectId, cb) {
	    var context = _ref6.context,
	        fn = _ref6.fn,
	        args = _ref6.args,
	        detached = _ref6.detached;
	
	    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });
	
	    try {
	      (0, _scheduler.suspend)();
	      var _task = proc(taskIterator, subscribe, dispatch, getState, options, effectId, fn.name, detached ? null : _utils.noop);
	
	      if (detached) {
	        cb(_task);
	      } else {
	        if (taskIterator._isRunning) {
	          taskQueue.addTask(_task);
	          cb(_task);
	        } else if (taskIterator._error) {
	          taskQueue.abort(taskIterator._error);
	        } else {
	          cb(_task);
	        }
	      }
	    } finally {
	      (0, _scheduler.flush)();
	    }
	    // Fork effects are non cancellables
	  }
	
	  function runJoinEffect(t, cb) {
	    if (t.isRunning()) {
	      (function () {
	        var joiner = { task: task, cb: cb };
	        cb.cancel = function () {
	          return (0, _utils.remove)(t.joiners, joiner);
	        };
	        t.joiners.push(joiner);
	      })();
	    } else {
	      t.isAborted() ? cb(t.error(), true) : cb(t.result());
	    }
	  }
	
	  function runCancelEffect(task, cb) {
	    if (task.isRunning()) {
	      task.cancel();
	    }
	    cb();
	    // cancel effects are non cancellables
	  }
	
	  function runParallelEffect(effects, effectId, cb) {
	    if (!effects.length) {
	      return cb([]);
	    }
	
	    var completedCount = 0;
	    var completed = void 0;
	    var results = Array(effects.length);
	
	    function checkEffectEnd() {
	      if (completedCount === results.length) {
	        completed = true;
	        cb(results);
	      }
	    }
	
	    var childCbs = effects.map(function (eff, idx) {
	      var chCbAtIdx = function chCbAtIdx(res, isErr) {
	        if (completed) {
	          return;
	        }
	        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
	          cb.cancel();
	          cb(res, isErr);
	        } else {
	          results[idx] = res;
	          completedCount++;
	          checkEffectEnd();
	        }
	      };
	      chCbAtIdx.cancel = _utils.noop;
	      return chCbAtIdx;
	    });
	
	    cb.cancel = function () {
	      if (!completed) {
	        completed = true;
	        childCbs.forEach(function (chCb) {
	          return chCb.cancel();
	        });
	      }
	    };
	
	    effects.forEach(function (eff, idx) {
	      return runEffect(eff, effectId, idx, childCbs[idx]);
	    });
	  }
	
	  function runRaceEffect(effects, effectId, cb) {
	    var completed = void 0;
	    var keys = Object.keys(effects);
	    var childCbs = {};
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	
	        if (isErr) {
	          // Race Auto cancellation
	          cb.cancel();
	          cb(res, true);
	        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
	          cb.cancel();
	          completed = true;
	          cb(_defineProperty({}, key, res));
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      // prevents unnecessary cancellation
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	    keys.forEach(function (key) {
	      if (completed) {
	        return;
	      }
	      runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runSelectEffect(_ref7, cb) {
	    var selector = _ref7.selector,
	        args = _ref7.args;
	
	    try {
	      var state = selector.apply(undefined, [getState()].concat(_toConsumableArray(args)));
	      cb(state);
	    } catch (error) {
	      cb(error, true);
	    }
	  }
	
	  function runChannelEffect(_ref8, cb) {
	    var pattern = _ref8.pattern,
	        buffer = _ref8.buffer;
	
	    var match = matcher(pattern);
	    match.pattern = pattern;
	    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
	  }
	
	  function runCancelledEffect(data, cb) {
	    cb(!!mainTask.isCancelled);
	  }
	
	  function runFlushEffect(channel, cb) {
	    channel.flush(cb);
	  }
	
	  function newTask(id, name, iterator, cont) {
	    var _done, _ref9, _mutatorMap;
	
	    iterator._deferredEnd = null;
	    return _ref9 = {}, _defineProperty(_ref9, _utils.TASK, true), _defineProperty(_ref9, 'id', id), _defineProperty(_ref9, 'name', name), _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
	      if (iterator._deferredEnd) {
	        return iterator._deferredEnd.promise;
	      } else {
	        var def = (0, _utils.deferred)();
	        iterator._deferredEnd = def;
	        if (!iterator._isRunning) {
	          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
	        }
	        return def.promise;
	      }
	    }, _defineProperty(_ref9, 'cont', cont), _defineProperty(_ref9, 'joiners', []), _defineProperty(_ref9, 'cancel', cancel), _defineProperty(_ref9, 'isRunning', function isRunning() {
	      return iterator._isRunning;
	    }), _defineProperty(_ref9, 'isCancelled', function isCancelled() {
	      return iterator._isCancelled;
	    }), _defineProperty(_ref9, 'isAborted', function isAborted() {
	      return iterator._isAborted;
	    }), _defineProperty(_ref9, 'result', function result() {
	      return iterator._result;
	    }), _defineProperty(_ref9, 'error', function error() {
	      return iterator._error;
	    }), _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
	  }
	}

/***/ },
/* 3282 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.asap = asap;
	exports.suspend = suspend;
	exports.flush = flush;
	
	var queue = [];
	/**
	  Variable to hold a counting semaphore
	  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
	    already suspended)
	  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
	    triggers flushing the queued tasks.
	**/
	var semaphore = 0;
	
	/**
	  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
	  and flushed after this task has finished (assuming the scheduler endup in a released
	  state).
	**/
	function exec(task) {
	  try {
	    suspend();
	    task();
	  } finally {
	    flush();
	  }
	}
	
	/**
	  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
	**/
	function asap(task) {
	  if (!semaphore) {
	    exec(task);
	  } else {
	    queue.push(task);
	  }
	}
	
	/**
	  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
	  scheduler is released.
	**/
	function suspend() {
	  semaphore++;
	}
	
	/**
	  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
	**/
	function flush() {
	  semaphore--;
	  if (!semaphore && queue.length) {
	    exec(queue.shift());
	  }
	}

/***/ },
/* 3283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.asEffect = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.take = take;
	exports.takem = takem;
	exports.put = put;
	exports.race = race;
	exports.call = call;
	exports.apply = apply;
	exports.cps = cps;
	exports.fork = fork;
	exports.spawn = spawn;
	exports.join = join;
	exports.cancel = cancel;
	exports.select = select;
	exports.actionChannel = actionChannel;
	exports.cancelled = cancelled;
	exports.flush = flush;
	
	var _utils = __webpack_require__(3280);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IO = (0, _utils.sym)('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	var FLUSH = 'FLUSH';
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _defineProperty(_ref, IO, true), _defineProperty(_ref, type, payload), _ref;
	};
	
	function take() {
	  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
	
	  if (arguments.length) {
	    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
	  }
	  if (_utils.is.pattern(patternOrChannel)) {
	    return effect(TAKE, { pattern: patternOrChannel });
	  }
	  if (_utils.is.channel(patternOrChannel)) {
	    return effect(TAKE, { channel: patternOrChannel });
	  }
	  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
	}
	
	function takem() {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	}
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
	    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
	    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.sync = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].sync = true;
	  return eff;
	};
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils.is.array(fn)) {
	    var _fn = fn;
	
	    var _fn2 = _slicedToArray(_fn, 2);
	
	    context = _fn2[0];
	    fn = _fn2[1];
	  } else if (fn.fn) {
	    var _fn3 = fn;
	    context = _fn3.context;
	    fn = _fn3.fn;
	  }
	  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  var eff = fork.apply(undefined, [fn].concat(args));
	  eff[FORK].detached = true;
	  return eff;
	}
	
	var isForkedTask = function isForkedTask(task) {
	  return task[_utils.TASK];
	};
	
	function join(task) {
	  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
	  if (!isForkedTask(task)) {
	    throw new Error('join(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
	  }
	
	  return effect(JOIN, task);
	}
	
	function cancel(task) {
	  (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
	  if (!isForkedTask(task)) {
	    throw new Error('cancel(task): argument ' + task + ' is not a valid Task object \n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)');
	  }
	
	  return effect(CANCEL, task);
	}
	
	function select(selector) {
	  for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    args[_key5 - 1] = arguments[_key5];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils.ident;
	  } else {
	    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
	    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	function flush(channel) {
	  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
	  return effect(FLUSH, channel);
	}
	
	var asEffect = exports.asEffect = {
	  take: function take(effect) {
	    return effect && effect[IO] && effect[TAKE];
	  },
	  put: function put(effect) {
	    return effect && effect[IO] && effect[PUT];
	  },
	  race: function race(effect) {
	    return effect && effect[IO] && effect[RACE];
	  },
	  call: function call(effect) {
	    return effect && effect[IO] && effect[CALL];
	  },
	  cps: function cps(effect) {
	    return effect && effect[IO] && effect[CPS];
	  },
	  fork: function fork(effect) {
	    return effect && effect[IO] && effect[FORK];
	  },
	  join: function join(effect) {
	    return effect && effect[IO] && effect[JOIN];
	  },
	  cancel: function cancel(effect) {
	    return effect && effect[IO] && effect[CANCEL];
	  },
	  select: function select(effect) {
	    return effect && effect[IO] && effect[SELECT];
	  },
	  actionChannel: function actionChannel(effect) {
	    return effect && effect[IO] && effect[ACTION_CHANNEL];
	  },
	  cancelled: function cancelled(effect) {
	    return effect && effect[IO] && effect[CANCELLED];
	  },
	  flush: function flush(effect) {
	    return effect && effect[IO] && effect[FLUSH];
	  }
	};

/***/ },
/* 3284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.emitter = emitter;
	exports.channel = channel;
	exports.eventChannel = eventChannel;
	exports.stdChannel = stdChannel;
	
	var _utils = __webpack_require__(3280);
	
	var _buffers = __webpack_require__(3285);
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = exports.END = { type: CHANNEL_END_TYPE };
	var isEnd = exports.isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return (0, _utils.remove)(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (false) {
	  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel() {
	  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();
	
	  var closed = false;
	  var takers = [];
	
	  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
	    if (closed) {
	      return;
	    }
	    if (!takers.length) {
	      return buffer.put(input);
	    }
	    for (var i = 0; i < takers.length; i++) {
	      var cb = takers[i];
	      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
	        takers.splice(i, 1);
	        return cb(input);
	      }
	    }
	  }
	
	  function take(cb) {
	    checkForbiddenStates();
	    (0, _utils.check)(cb, _utils.is.func, 'channel.take\'s callback must be a function');
	
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return (0, _utils.remove)(takers, cb);
	      };
	    }
	  }
	
	  function flush(cb) {
	    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
	    (0, _utils.check)(cb, _utils.is.func, 'channel.flush\' callback must be a function');
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	      return;
	    }
	    cb(buffer.flush());
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	      }
	    }
	  }
	
	  return { take: take, put: put, flush: flush, close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      chan.close();
	    } else if (!matcher || matcher(input)) {
	      chan.put(input);
	    }
	  });
	
	  if (!_utils.is.func(unsubscribe)) {
	    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
	  }
	
	  return {
	    take: chan.take,
	    flush: chan.flush,
	    close: function close() {
	      if (!chan.__closed__) {
	        chan.close();
	        unsubscribe();
	      }
	    }
	  };
	}
	
	function stdChannel(subscribe) {
	  var chan = eventChannel(subscribe);
	
	  return _extends({}, chan, {
	    take: function take(cb, matcher) {
	      if (arguments.length > 1) {
	        (0, _utils.check)(matcher, _utils.is.func, 'channel.take\'s matcher argument must be a function');
	        cb[_utils.MATCH] = matcher;
	      }
	      chan.take(cb);
	    }
	  });
	}

/***/ },
/* 3285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buffers = exports.BUFFER_OVERFLOW = undefined;
	
	var _utils = __webpack_require__(3280);
	
	var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = 'Channel\'s Buffer overflow!';
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	var ON_OVERFLOW_EXPAND = 4;
	
	var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };
	
	function ringBuffer() {
	  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	  var overflowAction = arguments[1];
	
	  var arr = new Array(limit);
	  var length = 0;
	  var pushIndex = 0;
	  var popIndex = 0;
	
	  var push = function push(it) {
	    arr[pushIndex] = it;
	    pushIndex = (pushIndex + 1) % limit;
	    length++;
	  };
	
	  var take = function take() {
	    if (length != 0) {
	      var it = arr[popIndex];
	      arr[popIndex] = null;
	      length--;
	      popIndex = (popIndex + 1) % limit;
	      return it;
	    }
	  };
	
	  var flush = function flush() {
	    var items = [];
	    while (length) {
	      items.push(take());
	    }
	    return items;
	  };
	
	  return {
	    isEmpty: function isEmpty() {
	      return length == 0;
	    },
	    put: function put(it) {
	      if (length < limit) {
	        push(it);
	      } else {
	        var doubledLimit = void 0;
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr[pushIndex] = it;
	            pushIndex = (pushIndex + 1) % limit;
	            popIndex = pushIndex;
	            break;
	          case ON_OVERFLOW_EXPAND:
	            doubledLimit = 2 * limit;
	
	            arr = flush();
	
	            length = arr.length;
	            pushIndex = arr.length;
	            popIndex = 0;
	
	            arr.length = doubledLimit;
	            limit = doubledLimit;
	
	            push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: take, flush: flush
	  };
	}
	
	var buffers = exports.buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
	  },
	  expanding: function expanding(initialSize) {
	    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
	  }
	};

/***/ },
/* 3286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	
	var _channel = __webpack_require__(3284);
	
	var _utils = __webpack_require__(3280);
	
	var _io = __webpack_require__(3283);
	
	var _buffers = __webpack_require__(3285);
	
	var done = { done: true, value: undefined };
	var qEnd = {};
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext](),
	          _fsm$qNext2 = _slicedToArray(_fsm$qNext, 3),
	          q = _fsm$qNext2[0],
	          output = _fsm$qNext2[1],
	          _updateState = _fsm$qNext2[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return (0, _utils.makeIterator)(next, function (error) {
	    return next(null, error);
	  }, name, true);
	}
	
	function safeName(pattern) {
	  if (Array.isArray(pattern)) {
	    return String(pattern.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(pattern);
	  }
	}
	
	function takeEvery(pattern, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(pattern) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [qEnd] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + safeName(pattern) + ', ' + worker.name + ')');
	}
	
	function takeLatest(pattern, worker) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    args[_key2 - 2] = arguments[_key2];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(pattern) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: (0, _io.cancel)(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + safeName(pattern) + ', ' + worker.name + ')');
	}
	
	function throttle(delayLength, pattern, worker) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
	    args[_key3 - 3] = arguments[_key3];
	  }
	
	  var action = void 0,
	      channel = void 0;
	
	  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
	  var yTake = function yTake() {
	    return { done: false, value: (0, _io.take)(channel, pattern) };
	  };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return fsmIterator({
	    q1: function q1() {
	      return ['q2', yActionChannel, setChannel];
	    },
	    q2: function q2() {
	      return ['q3', yTake(), setAction];
	    },
	    q3: function q3() {
	      return action === _channel.END ? [qEnd] : ['q4', yFork(action)];
	    },
	    q4: function q4() {
	      return ['q2', yDelay];
	    }
	  }, 'q1', 'throttle(' + safeName(pattern) + ', ' + worker.name + ')');
	}

/***/ },
/* 3287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sagaMiddlewareFactory;
	
	var _utils = __webpack_require__(3280);
	
	var _proc = __webpack_require__(3281);
	
	var _proc2 = _interopRequireDefault(_proc);
	
	var _scheduler = __webpack_require__(3282);
	
	var _channel = __webpack_require__(3284);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function sagaMiddlewareFactory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var runSagaDynamically = void 0;
	  var sagaMonitor = options.sagaMonitor;
	
	
	  if (_utils.is.func(options)) {
	    if (true) {
	      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
	    } else {
	      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
	    }
	  }
	
	  if (options.logger && !_utils.is.func(options.logger)) {
	    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
	  }
	
	  if (options.onerror && !_utils.is.func(options.onerror)) {
	    throw new Error('`options.onerror` passed to the Saga middleware is not a function!');
	  }
	
	  function sagaMiddleware(_ref) {
	    var getState = _ref.getState,
	        dispatch = _ref.dispatch;
	
	    runSagaDynamically = runSaga;
	    var sagaEmitter = (0, _channel.emitter)();
	    var sagaDispatch = (0, _utils.wrapSagaDispatch)(dispatch);
	
	    function runSaga(saga, args, sagaId) {
	      return (0, _proc2.default)(saga.apply(undefined, _toConsumableArray(args)), sagaEmitter.subscribe, sagaDispatch, getState, options, sagaId, saga.name);
	    }
	
	    return function (next) {
	      return function (action) {
	        if (sagaMonitor) {
	          sagaMonitor.actionDispatched(action);
	        }
	        var result = next(action); // hit reducers
	        if (action[_utils.SAGA_ACTION]) {
	          // Saga actions are already scheduled with asap in proc/runPutEffect
	          sagaEmitter.emit(action);
	        } else {
	          (0, _scheduler.asap)(function () {
	            return sagaEmitter.emit(action);
	          });
	        }
	
	        return result;
	      };
	    };
	  }
	
	  sagaMiddleware.run = function (saga) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    (0, _utils.check)(runSagaDynamically, _utils.is.notUndef, 'Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
	    (0, _utils.check)(saga, _utils.is.func, 'sagaMiddleware.run(saga, ...args): saga argument must be a Generator function!');
	
	    var effectId = (0, _utils.uid)();
	    if (sagaMonitor) {
	      sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
	    }
	    var task = runSagaDynamically(saga, args, effectId);
	    if (sagaMonitor) {
	      sagaMonitor.effectResolved(effectId, task);
	    }
	    return task;
	  };
	
	  return sagaMiddleware;
	}

/***/ },
/* 3288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _io = __webpack_require__(3283);
	
	Object.defineProperty(exports, 'take', {
	  enumerable: true,
	  get: function get() {
	    return _io.take;
	  }
	});
	Object.defineProperty(exports, 'takem', {
	  enumerable: true,
	  get: function get() {
	    return _io.takem;
	  }
	});
	Object.defineProperty(exports, 'put', {
	  enumerable: true,
	  get: function get() {
	    return _io.put;
	  }
	});
	Object.defineProperty(exports, 'race', {
	  enumerable: true,
	  get: function get() {
	    return _io.race;
	  }
	});
	Object.defineProperty(exports, 'call', {
	  enumerable: true,
	  get: function get() {
	    return _io.call;
	  }
	});
	Object.defineProperty(exports, 'apply', {
	  enumerable: true,
	  get: function get() {
	    return _io.apply;
	  }
	});
	Object.defineProperty(exports, 'cps', {
	  enumerable: true,
	  get: function get() {
	    return _io.cps;
	  }
	});
	Object.defineProperty(exports, 'fork', {
	  enumerable: true,
	  get: function get() {
	    return _io.fork;
	  }
	});
	Object.defineProperty(exports, 'spawn', {
	  enumerable: true,
	  get: function get() {
	    return _io.spawn;
	  }
	});
	Object.defineProperty(exports, 'join', {
	  enumerable: true,
	  get: function get() {
	    return _io.join;
	  }
	});
	Object.defineProperty(exports, 'cancel', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancel;
	  }
	});
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _io.select;
	  }
	});
	Object.defineProperty(exports, 'actionChannel', {
	  enumerable: true,
	  get: function get() {
	    return _io.actionChannel;
	  }
	});
	Object.defineProperty(exports, 'cancelled', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancelled;
	  }
	});
	Object.defineProperty(exports, 'flush', {
	  enumerable: true,
	  get: function get() {
	    return _io.flush;
	  }
	});

/***/ },
/* 3289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(3280);
	
	Object.defineProperty(exports, 'TASK', {
	  enumerable: true,
	  get: function get() {
	    return _utils.TASK;
	  }
	});
	Object.defineProperty(exports, 'SAGA_ACTION', {
	  enumerable: true,
	  get: function get() {
	    return _utils.SAGA_ACTION;
	  }
	});
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.noop;
	  }
	});
	Object.defineProperty(exports, 'is', {
	  enumerable: true,
	  get: function get() {
	    return _utils.is;
	  }
	});
	Object.defineProperty(exports, 'deferred', {
	  enumerable: true,
	  get: function get() {
	    return _utils.deferred;
	  }
	});
	Object.defineProperty(exports, 'arrayOfDeffered', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayOfDeffered;
	  }
	});
	Object.defineProperty(exports, 'createMockTask', {
	  enumerable: true,
	  get: function get() {
	    return _utils.createMockTask;
	  }
	});
	
	var _io = __webpack_require__(3283);
	
	Object.defineProperty(exports, 'CHANNEL_END', {
	  enumerable: true,
	  get: function get() {
	    return _io.CHANNEL_END;
	  }
	});
	Object.defineProperty(exports, 'asEffect', {
	  enumerable: true,
	  get: function get() {
	    return _io.asEffect;
	  }
	});

/***/ },
/* 3290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	// typecheck: ignore file
	
	
	exports.default = combineRemindReducers;
	
	var _redux = __webpack_require__(476);
	
	var _connectedBankAccountRequest = __webpack_require__(3129);
	
	var _connectedBankAccountRequest2 = _interopRequireDefault(_connectedBankAccountRequest);
	
	var _roleBasedMessagingSearch = __webpack_require__(1901);
	
	var _roleBasedMessagingSearch2 = _interopRequireDefault(_roleBasedMessagingSearch);
	
	var _activityRecipients = __webpack_require__(2238);
	
	var _activityRecipients2 = _interopRequireDefault(_activityRecipients);
	
	var _groupQuickSwitcher = __webpack_require__(2746);
	
	var _groupQuickSwitcher2 = _interopRequireDefault(_groupQuickSwitcher);
	
	var _organizationClassesTables = __webpack_require__(3236);
	
	var _organizationClassesTables2 = _interopRequireDefault(_organizationClassesTables);
	
	var _connectionStateBanner = __webpack_require__(2502);
	
	var _connectionStateBanner2 = _interopRequireDefault(_connectionStateBanner);
	
	var _tables = __webpack_require__(3218);
	
	var _tables2 = _interopRequireDefault(_tables);
	
	var _banners = __webpack_require__(2506);
	
	var _banners2 = _interopRequireDefault(_banners);
	
	var _toasts = __webpack_require__(948);
	
	var _toasts2 = _interopRequireDefault(_toasts);
	
	var _zopim = __webpack_require__(1082);
	
	var _zopim2 = _interopRequireDefault(_zopim);
	
	var _recentMessagesModal = __webpack_require__(1570);
	
	var _recentMessagesModal2 = _interopRequireDefault(_recentMessagesModal);
	
	var _availableReactions = __webpack_require__(3291);
	
	var _availableReactions2 = _interopRequireDefault(_availableReactions);
	
	var _quickActions = __webpack_require__(2209);
	
	var _quickActions2 = _interopRequireDefault(_quickActions);
	
	var _peopleTables = __webpack_require__(3205);
	
	var _peopleTables2 = _interopRequireDefault(_peopleTables);
	
	var _schoolTables = __webpack_require__(3251);
	
	var _schoolTables2 = _interopRequireDefault(_schoolTables);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalReducers = {
	  connectedBankAccountRequest: _connectedBankAccountRequest2.default,
	  roleBasedMessagingSearch: _roleBasedMessagingSearch2.default,
	  connectionStateBanner: _connectionStateBanner2.default,
	  organizationClassesTables: _organizationClassesTables2.default,
	  groupQuickSwitcher: _groupQuickSwitcher2.default,
	  activityRecipients: _activityRecipients2.default,
	  schoolTables: _schoolTables2.default,
	  banners: _banners2.default,
	  toasts: _toasts2.default,
	  zopim: _zopim2.default,
	  tables: _tables2.default,
	  recentMessagesModal: _recentMessagesModal2.default,
	  availableReactions: _availableReactions2.default,
	  quickActions: _quickActions2.default,
	  peopleTables: _peopleTables2.default
	};
	
	function combineRemindReducers(apolloReducer) {
	  return (0, _redux.combineReducers)(_extends({}, globalReducers, {
	    apollo: apolloReducer
	  }));
	}

/***/ },
/* 3291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = reducer;
	
	var _ReactionEmojis = __webpack_require__(2310);
	
	var _ReactionEmojis2 = _interopRequireDefault(_ReactionEmojis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = exports.initialState = {
	  availableReactions: new _ReactionEmojis2.default()
	};
	
	function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'availableReactions/LOAD_REACTIONS_SUCCESS':
	      return _extends({}, state, {
	        availableReactions: action.availableReactions
	      });
	    default:
	      return state;
	  }
	}

/***/ },
/* 3292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rootSaga;
	
	var _activityRecipients = __webpack_require__(3293);
	
	var _activityRecipients2 = _interopRequireDefault(_activityRecipients);
	
	var _connectedBankAccountRequest = __webpack_require__(3295);
	
	var _connectedBankAccountRequest2 = _interopRequireDefault(_connectedBankAccountRequest);
	
	var _roleBasedMessagingSearch = __webpack_require__(3296);
	
	var _roleBasedMessagingSearch2 = _interopRequireDefault(_roleBasedMessagingSearch);
	
	var _organizationClasses = __webpack_require__(3297);
	
	var _organizationClasses2 = _interopRequireDefault(_organizationClasses);
	
	var _availableReactions = __webpack_require__(3298);
	
	var _availableReactions2 = _interopRequireDefault(_availableReactions);
	
	var _quickActions = __webpack_require__(3299);
	
	var _quickActions2 = _interopRequireDefault(_quickActions);
	
	var _peopleTables = __webpack_require__(3300);
	
	var _peopleTables2 = _interopRequireDefault(_peopleTables);
	
	var _schoolTables = __webpack_require__(3301);
	
	var _schoolTables2 = _interopRequireDefault(_schoolTables);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [rootSaga].map(regeneratorRuntime.mark);
	
	function rootSaga() {
	  return regeneratorRuntime.wrap(function rootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return [(0, _activityRecipients2.default)(), (0, _connectedBankAccountRequest2.default)(), (0, _roleBasedMessagingSearch2.default)(), (0, _availableReactions2.default)(), (0, _organizationClasses2.default)(), (0, _quickActions2.default)(), (0, _peopleTables2.default)(), (0, _schoolTables2.default)()];
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}

/***/ },
/* 3293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchLoadActivityRecipients = watchLoadActivityRecipients;
	exports.loadActivityRecipients = loadActivityRecipients;
	exports.watchLoadCurrentUserActivityResponse = watchLoadCurrentUserActivityResponse;
	exports.loadCurrentUserActivityResponse = loadCurrentUserActivityResponse;
	exports.watchPatchActivityRecipient = watchPatchActivityRecipient;
	exports.patchActivityRecipient = patchActivityRecipient;
	exports.default = root;
	
	var _effects = __webpack_require__(3294);
	
	var _reduxSaga = __webpack_require__(3278);
	
	var _activityRecipients = __webpack_require__(2238);
	
	var actions = _interopRequireWildcard(_activityRecipients);
	
	var _Activity = __webpack_require__(907);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityRecipient = __webpack_require__(908);
	
	var _ActivityRecipient2 = _interopRequireDefault(_ActivityRecipient);
	
	var _ActivityRecipients = __webpack_require__(910);
	
	var _ActivityRecipients2 = _interopRequireDefault(_ActivityRecipients);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchLoadActivityRecipients, loadActivityRecipients, watchLoadCurrentUserActivityResponse, loadCurrentUserActivityResponse, watchPatchActivityRecipient, patchActivityRecipient, root].map(regeneratorRuntime.mark); // eslint-disable-line
	
	
	function watchLoadActivityRecipients() {
	  return regeneratorRuntime.wrap(function watchLoadActivityRecipients$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          return _context.delegateYield((0, _reduxSaga.takeLatest)('activityRecipients/ACTIVITY_RECIPIENTS_REQUEST', loadActivityRecipients), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function loadActivityRecipients(action) {
	  var recipients;
	  return regeneratorRuntime.wrap(function loadActivityRecipients$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.call)(_Activity2.default.getRecipients, action.activityId);
	
	        case 3:
	          recipients = _context2.sent;
	
	          if (!recipients) {
	            _context2.next = 7;
	            break;
	          }
	
	          _context2.next = 7;
	          return (0, _effects.put)(actions.loadActivityRecipientsSuccess(action.activityId, recipients));
	
	        case 7:
	          _context2.next = 12;
	          break;
	
	        case 9:
	          _context2.prev = 9;
	          _context2.t0 = _context2['catch'](0);
	
	          console.warn(_context2.t0);
	
	        case 12:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 9]]);
	}
	
	function watchLoadCurrentUserActivityResponse() {
	  return regeneratorRuntime.wrap(function watchLoadCurrentUserActivityResponse$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          return _context3.delegateYield((0, _reduxSaga.takeLatest)('activityRecipients/CURRENT_USER_ACTIVITY_RESPONSE_REQUEST', loadCurrentUserActivityResponse), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function loadCurrentUserActivityResponse(action) {
	  var activityRecipient;
	  return regeneratorRuntime.wrap(function loadCurrentUserActivityResponse$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.prev = 0;
	          _context4.next = 3;
	          return (0, _effects.call)(_Activity2.default.getCurrentUserRecipientResponse, action.activityId);
	
	        case 3:
	          activityRecipient = _context4.sent;
	
	          if (!activityRecipient) {
	            _context4.next = 7;
	            break;
	          }
	
	          _context4.next = 7;
	          return (0, _effects.put)(actions.loadCurrentUserActivityResponseSuccess(activityRecipient, action.activityId));
	
	        case 7:
	          _context4.next = 12;
	          break;
	
	        case 9:
	          _context4.prev = 9;
	          _context4.t0 = _context4['catch'](0);
	
	          console.warn(_context4.t0);
	
	        case 12:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this, [[0, 9]]);
	}
	
	function watchPatchActivityRecipient() {
	  return regeneratorRuntime.wrap(function watchPatchActivityRecipient$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          return _context5.delegateYield((0, _reduxSaga.takeLatest)('activityRecipients/PATCH_ACTIVITY_RECIPIENT_REQUEST', patchActivityRecipient), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}
	
	function patchActivityRecipient(action) {
	  var activityRecipient;
	  return regeneratorRuntime.wrap(function patchActivityRecipient$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.prev = 0;
	          _context6.next = 3;
	          return (0, _effects.call)(_ActivityRecipient2.default.patch, action.activityId, action.recipientId, action.data);
	
	        case 3:
	          activityRecipient = _context6.sent;
	
	          if (!activityRecipient) {
	            _context6.next = 7;
	            break;
	          }
	
	          _context6.next = 7;
	          return (0, _effects.put)(actions.patchActivityRecipientSuccess(action.activityId, activityRecipient));
	
	        case 7:
	          _context6.next = 12;
	          break;
	
	        case 9:
	          _context6.prev = 9;
	          _context6.t0 = _context6['catch'](0);
	
	          console.warn(_context6.t0);
	
	        case 12:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[5], this, [[0, 9]]);
	}
	
	function root() {
	  return regeneratorRuntime.wrap(function root$(_context7) {
	    while (1) {
	      switch (_context7.prev = _context7.next) {
	        case 0:
	          _context7.next = 2;
	          return [(0, _effects.fork)(watchLoadCurrentUserActivityResponse), (0, _effects.fork)(watchLoadActivityRecipients), (0, _effects.fork)(watchPatchActivityRecipient)];
	
	        case 2:
	        case 'end':
	          return _context7.stop();
	      }
	    }
	  }, _marked[6], this);
	}

/***/ },
/* 3294 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3288)

/***/ },
/* 3295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.watchLoadRequest = watchLoadRequest;
	exports.load = load;
	exports.default = root;
	
	var _effects = __webpack_require__(3294);
	
	var _reduxSaga = __webpack_require__(3278);
	
	var _connectedBankAccountRequest = __webpack_require__(3129);
	
	var actions = _interopRequireWildcard(_connectedBankAccountRequest);
	
	var _ConnectedBankAccount = __webpack_require__(2557);
	
	var _ConnectedBankAccount2 = _interopRequireDefault(_ConnectedBankAccount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _marked = [watchLoadRequest, load, root].map(regeneratorRuntime.mark);
	
	function watchLoadRequest() {
	  return regeneratorRuntime.wrap(function watchLoadRequest$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          return _context.delegateYield((0, _reduxSaga.takeLatest)('connectedBankAccountRequest/LOAD_REQUEST', load), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function load(action) {
	  var connectedBankAccount;
	  return regeneratorRuntime.wrap(function load$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.call)(_ConnectedBankAccount2.default.getConnectedBankAccount, action.token);
	
	        case 3:
	          connectedBankAccount = _context2.sent;
	
	          if (!connectedBankAccount) {
	            _context2.next = 7;
	            break;
	          }
	
	          _context2.next = 7;
	          return (0, _effects.put)(actions.loadSuccess(action.token, connectedBankAccount));
	
	        case 7:
	          _context2.next = 13;
	          break;
	
	        case 9:
	          _context2.prev = 9;
	          _context2.t0 = _context2['catch'](0);
	          _context2.next = 13;
	          return (0, _effects.put)(actions.loadError(action.token, _context2.t0.error || _context2.t0.message || 'unknow'));
	
	        case 13:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 9]]);
	}
	
	function root() {
	  return regeneratorRuntime.wrap(function root$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(watchLoadRequest)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 3296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.search = search;
	exports.watchLoadPotentialChatMembers = watchLoadPotentialChatMembers;
	exports.loadPotentialChatMembers = loadPotentialChatMembers;
	exports.default = root;
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	var _effects = __webpack_require__(3294);
	
	var _reduxSaga = __webpack_require__(3278);
	
	var _roleBasedMessagingSearch = __webpack_require__(1901);
	
	var actions = _interopRequireWildcard(_roleBasedMessagingSearch);
	
	var _PotentialChatMembers = __webpack_require__(946);
	
	var _PotentialChatMembers2 = _interopRequireDefault(_PotentialChatMembers);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [watchLoadPotentialChatMembers, loadPotentialChatMembers, root].map(regeneratorRuntime.mark);
	// typecheck: ignore file
	
	
	function search(query) {
	  return _RemindAPI2.default.request('/chats/members/search', 'GET', { q: query }).then(function (members) {
	    return _PotentialChatMembers2.default.fromJSON(members);
	  });
	}
	
	function watchLoadPotentialChatMembers() {
	  return regeneratorRuntime.wrap(function watchLoadPotentialChatMembers$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          return _context.delegateYield((0, _reduxSaga.takeLatest)('rbms/LOAD_POTENTIAL_CHAT_MEMBERS_REQUEST', loadPotentialChatMembers), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function loadPotentialChatMembers(action) {
	  var members;
	  return regeneratorRuntime.wrap(function loadPotentialChatMembers$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.call)(search, action.query);
	
	        case 3:
	          members = _context2.sent;
	
	          if (!members) {
	            _context2.next = 7;
	            break;
	          }
	
	          _context2.next = 7;
	          return (0, _effects.put)(actions.loadPotentialChatMembersSuccess(members));
	
	        case 7:
	          _context2.next = 12;
	          break;
	
	        case 9:
	          _context2.prev = 9;
	          _context2.t0 = _context2['catch'](0);
	
	          console.warn(_context2.t0);
	
	        case 12:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 9]]);
	}
	
	function root() {
	  return regeneratorRuntime.wrap(function root$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          _context3.next = 2;
	          return [(0, _effects.fork)(watchLoadPotentialChatMembers)];
	
	        case 2:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}

/***/ },
/* 3297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = organizationClasses;
	
	var _reduxSaga = __webpack_require__(3278);
	
	var _effects = __webpack_require__(3294);
	
	var _organizationClassesTables = __webpack_require__(3236);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchOrganizationClasses, organizationClasses].map(regeneratorRuntime.mark);
	// typecheck: ignore file
	
	
	function fetch(id, parameters) {
	  var options = {
	    sort_type: parameters.sort,
	    per_page: parameters.perPage,
	    sort_direction: parameters.sortDirection,
	    page: parameters.page,
	    q: parameters.query
	  };
	
	  return _RemindAPI2.default.request('/organizations/' + id + '/classes', 'GET', options).then(function (response) {
	    return response.classes;
	  });
	}
	
	function fetchOrganizationClasses(action) {
	  var classes;
	  return regeneratorRuntime.wrap(function fetchOrganizationClasses$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.call)(fetch, action.organizationId, action.options);
	
	        case 3:
	          classes = _context.sent;
	
	          if (!classes) {
	            _context.next = 7;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)((0, _organizationClassesTables.loadOrganizationClassesSuccess)(action.organizationId, classes, action.options));
	
	        case 7:
	          _context.next = 12;
	          break;
	
	        case 9:
	          _context.prev = 9;
	          _context.t0 = _context['catch'](0);
	
	          console.error(_context.t0);
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 9]]);
	}
	
	function organizationClasses() {
	  return regeneratorRuntime.wrap(function organizationClasses$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          return _context2.delegateYield((0, _reduxSaga.takeLatest)('organizationClassTables/LOAD_ORGANIZATION_CLASSES_REQUEST', fetchOrganizationClasses), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },
/* 3298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = loadAvailableReactions;
	
	var _effects = __webpack_require__(3294);
	
	var _ReactionEmojis = __webpack_require__(2310);
	
	var _ReactionEmojis2 = _interopRequireDefault(_ReactionEmojis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loadAvailableReactions].map(regeneratorRuntime.mark);
	
	function loadAvailableReactions() {
	  var availableReactions;
	  return regeneratorRuntime.wrap(function loadAvailableReactions$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.call)(_ReactionEmojis2.default.fetch);
	
	        case 3:
	          availableReactions = _context.sent;
	
	          if (!availableReactions) {
	            _context.next = 7;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)({
	            type: 'availableReactions/LOAD_REACTIONS_SUCCESS',
	            availableReactions: availableReactions
	          });
	
	        case 7:
	          _context.next = 12;
	          break;
	
	        case 9:
	          _context.prev = 9;
	          _context.t0 = _context['catch'](0);
	
	          console.warn(_context.t0);
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 9]]);
	}

/***/ },
/* 3299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = loadQuickActions;
	
	var _reduxSaga = __webpack_require__(3278);
	
	var _effects = __webpack_require__(3294);
	
	var _QuickActions = __webpack_require__(2203);
	
	var _quickActions = __webpack_require__(2209);
	
	var _marked = [fetchQuickActions, loadQuickActions].map(regeneratorRuntime.mark);
	
	function fetchQuickActions(action) {
	  var quickActions;
	  return regeneratorRuntime.wrap(function fetchQuickActions$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.call)(_QuickActions.loadQuickActionsForGroup, action.groupId);
	
	        case 3:
	          quickActions = _context.sent;
	
	          if (!quickActions) {
	            _context.next = 7;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)((0, _quickActions.loadQuickActionsSuccess)(action.groupId, quickActions));
	
	        case 7:
	          _context.next = 12;
	          break;
	
	        case 9:
	          _context.prev = 9;
	          _context.t0 = _context['catch'](0);
	
	          console.error(_context.t0);
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 9]]);
	}
	
	function loadQuickActions() {
	  return regeneratorRuntime.wrap(function loadQuickActions$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          return _context2.delegateYield((0, _reduxSaga.takeLatest)('quickActions/LOAD_QUICK_ACTIONS', fetchQuickActions), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },
/* 3300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = root;
	
	var _reduxSaga = __webpack_require__(3278);
	
	var _effects = __webpack_require__(3294);
	
	var _peopleTables = __webpack_require__(3205);
	
	var _GroupMembership = __webpack_require__(604);
	
	var _GroupMembership2 = _interopRequireDefault(_GroupMembership);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchClassMembership, fetchClassMemberships, watchFetchMemberships, watchFetchMembership, root].map(regeneratorRuntime.mark);
	// typecheck: ignore file
	
	
	function fetchMembership(groupId, userId) {
	  return _RemindAPI2.default.request('/classes/' + groupId + '/members/' + userId, 'GET').then(function (response) {
	    return _GroupMembership2.default.fromJSON(response);
	  });
	}
	
	function fetchMemberships(groupId, parameters) {
	  var options = {
	    sort_type: parameters.sort,
	    per_page: parameters.perPage,
	    user_ids: parameters.userIds,
	    sort_direction: parameters.sortDirection,
	    roles: parameters.roles,
	    page: parameters.page,
	    q: parameters.query
	  };
	
	  return _RemindAPI2.default.request('/classes/' + groupId + '/members', 'GET', options).then(function (response) {
	    return response.members.map(function (member) {
	      return _GroupMembership2.default.fromJSON(member);
	    });
	  });
	}
	
	function fetchClassMembership(action) {
	  var membership;
	  return regeneratorRuntime.wrap(function fetchClassMembership$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.call)(fetchMembership, action.groupId, action.userId);
	
	        case 3:
	          membership = _context.sent;
	
	          if (!membership) {
	            _context.next = 7;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)((0, _peopleTables.loadMembershipSuccess)(action.groupId, membership, action.options));
	
	        case 7:
	          _context.next = 12;
	          break;
	
	        case 9:
	          _context.prev = 9;
	          _context.t0 = _context['catch'](0);
	
	          console.error(_context.t0);
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 9]]);
	}
	
	function fetchClassMemberships(action) {
	  var memberships;
	  return regeneratorRuntime.wrap(function fetchClassMemberships$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.prev = 0;
	          _context2.next = 3;
	          return (0, _effects.call)(fetchMemberships, action.groupId, action.options);
	
	        case 3:
	          memberships = _context2.sent;
	
	          if (!memberships) {
	            _context2.next = 7;
	            break;
	          }
	
	          _context2.next = 7;
	          return (0, _effects.put)((0, _peopleTables.loadMembershipsSuccess)(action.groupId, memberships, action.options));
	
	        case 7:
	          _context2.next = 12;
	          break;
	
	        case 9:
	          _context2.prev = 9;
	          _context2.t0 = _context2['catch'](0);
	
	          console.error(_context2.t0);
	
	        case 12:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this, [[0, 9]]);
	}
	
	function watchFetchMemberships() {
	  return regeneratorRuntime.wrap(function watchFetchMemberships$(_context3) {
	    while (1) {
	      switch (_context3.prev = _context3.next) {
	        case 0:
	          return _context3.delegateYield((0, _reduxSaga.takeLatest)('peopleTables/LOAD_MEMBERSHIPS_REQUEST', fetchClassMemberships), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context3.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function watchFetchMembership() {
	  return regeneratorRuntime.wrap(function watchFetchMembership$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          return _context4.delegateYield((0, _reduxSaga.takeLatest)('peopleTables/LOAD_MEMBERSHIP_REQUEST', fetchClassMembership), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	
	function root() {
	  return regeneratorRuntime.wrap(function root$(_context5) {
	    while (1) {
	      switch (_context5.prev = _context5.next) {
	        case 0:
	          _context5.next = 2;
	          return [(0, _effects.fork)(watchFetchMemberships), (0, _effects.fork)(watchFetchMembership)];
	
	        case 2:
	        case 'end':
	          return _context5.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 3301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = schoolTables;
	
	var _reduxSaga = __webpack_require__(3278);
	
	var _effects = __webpack_require__(3294);
	
	var _schoolTables = __webpack_require__(3251);
	
	var _Organization = __webpack_require__(999);
	
	var _Organization2 = _interopRequireDefault(_Organization);
	
	var _RemindAPI = __webpack_require__(612);
	
	var _RemindAPI2 = _interopRequireDefault(_RemindAPI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [fetchSchools, schoolTables].map(regeneratorRuntime.mark);
	// typecheck: ignore file
	
	
	function fetch(id, parameters) {
	  var options = {
	    sort_type: parameters.sort,
	    per_page: parameters.perPage,
	    sort_direction: parameters.sortDirection,
	    page: parameters.page
	  };
	
	  return _RemindAPI2.default.request('/organizations/' + id + '/schools', 'GET', options).then(function (response) {
	    return response.schools.map(function (o) {
	      return _Organization2.default.fromJSON(o);
	    });
	  });
	}
	
	function fetchSchools(action) {
	  var schools;
	  return regeneratorRuntime.wrap(function fetchSchools$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.prev = 0;
	          _context.next = 3;
	          return (0, _effects.call)(fetch, action.districtId, action.options);
	
	        case 3:
	          schools = _context.sent;
	
	          if (!schools) {
	            _context.next = 7;
	            break;
	          }
	
	          _context.next = 7;
	          return (0, _effects.put)((0, _schoolTables.loadSchoolsSuccess)(action.districtId, schools, action.options));
	
	        case 7:
	          _context.next = 12;
	          break;
	
	        case 9:
	          _context.prev = 9;
	          _context.t0 = _context['catch'](0);
	
	          console.error(_context.t0);
	
	        case 12:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this, [[0, 9]]);
	}
	
	function schoolTables() {
	  return regeneratorRuntime.wrap(function schoolTables$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          return _context2.delegateYield((0, _reduxSaga.takeLatest)('schoolTables/LOAD_SCHOOLS_REQUEST', fetchSchools), 't0', 1);
	
	        case 1:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[1], this);
	}

/***/ },
/* 3302 */
1136
]);


// WEBPACK FOOTER //
// app.23523cf76eaa5799dec0.js